webpackJsonp([0],{

/***/ 1237:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _stringify = __webpack_require__(486);

var _stringify2 = _interopRequireDefault(_stringify);

var _slicedToArray2 = __webpack_require__(1292);

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Isomorphic CSS style loader for Webpack
 *
 * Copyright © 2015-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

var prefix = 's';
var inserted = {};

// Base64 encoding and decoding - The "Unicode Problem"
// https://developer.mozilla.org/en-US/docs/Web/API/WindowBase64/Base64_encoding_and_decoding#The_Unicode_Problem
function b64EncodeUnicode(str) {
  return btoa(encodeURIComponent(str).replace(/%([0-9A-F]{2})/g, function (match, p1) {
    return String.fromCharCode('0x' + p1);
  }));
}

/**
 * Remove style/link elements for specified node IDs
 * if they are no longer referenced by UI components.
 */
function removeCss(ids) {
  ids.forEach(function (id) {
    if (--inserted[id] <= 0) {
      var elem = document.getElementById(prefix + id);
      if (elem) {
        elem.parentNode.removeChild(elem);
      }
    }
  });
}

/**
 * Example:
 *   // Insert CSS styles object generated by `css-loader` into DOM
 *   var removeCss = insertCss([[1, 'body { color: red; }']]);
 *
 *   // Remove it from the DOM
 *   removeCss();
 */
function insertCss(styles) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$replace = _ref.replace,
      replace = _ref$replace === undefined ? false : _ref$replace,
      _ref$prepend = _ref.prepend,
      prepend = _ref$prepend === undefined ? false : _ref$prepend;

  var ids = [];
  for (var i = 0; i < styles.length; i++) {
    var _styles$i = (0, _slicedToArray3.default)(styles[i], 4),
        moduleId = _styles$i[0],
        css = _styles$i[1],
        media = _styles$i[2],
        sourceMap = _styles$i[3];

    var id = moduleId + '-' + i;

    ids.push(id);

    if (inserted[id]) {
      if (!replace) {
        inserted[id]++;
        continue;
      }
    }

    inserted[id] = 1;

    var elem = document.getElementById(prefix + id);
    var create = false;

    if (!elem) {
      create = true;

      elem = document.createElement('style');
      elem.setAttribute('type', 'text/css');
      elem.id = prefix + id;

      if (media) {
        elem.setAttribute('media', media);
      }
    }

    var cssText = css;
    if (sourceMap && typeof btoa === 'function') {
      // skip IE9 and below, see http://caniuse.com/atob-btoa
      cssText += '\n/*# sourceMappingURL=data:application/json;base64,' + b64EncodeUnicode((0, _stringify2.default)(sourceMap)) + '*/';
      cssText += '\n/*# sourceURL=' + sourceMap.file + '?' + id + '*/';
    }

    if ('textContent' in elem) {
      elem.textContent = cssText;
    } else {
      elem.styleSheet.cssText = cssText;
    }

    if (create) {
      if (prepend) {
        document.head.insertBefore(elem, document.head.childNodes[0]);
      } else {
        document.head.appendChild(elem);
      }
    }
  }

  return removeCss.bind(null, ids);
}

module.exports = insertCss;

/***/ }),

/***/ 1238:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(316);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(311);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(313);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(314);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(315);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(11);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1289);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _hoistNonReactStatics = __webpack_require__(1278);

var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var contextTypes = {
  insertCss: _propTypes2.default.func
}; /**
    * Isomorphic CSS style loader for Webpack
    *
    * Copyright © 2015-present Kriasoft, LLC. All rights reserved.
    *
    * This source code is licensed under the MIT license found in the
    * LICENSE.txt file in the root directory of this source tree.
    */

function withStyles() {
  for (var _len = arguments.length, styles = Array(_len), _key = 0; _key < _len; _key++) {
    styles[_key] = arguments[_key];
  }

  return function wrapWithStyles(ComposedComponent) {
    var WithStyles = function (_Component) {
      (0, _inherits3.default)(WithStyles, _Component);

      function WithStyles() {
        (0, _classCallCheck3.default)(this, WithStyles);
        return (0, _possibleConstructorReturn3.default)(this, (WithStyles.__proto__ || (0, _getPrototypeOf2.default)(WithStyles)).apply(this, arguments));
      }

      (0, _createClass3.default)(WithStyles, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
          var _context;

          this.removeCss = (_context = this.context).insertCss.apply(_context, styles);
        }
      }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
          if (this.removeCss) {
            setTimeout(this.removeCss, 0);
          }
        }
      }, {
        key: 'render',
        value: function render() {
          return _react2.default.createElement(ComposedComponent, this.props);
        }
      }]);
      return WithStyles;
    }(_react.Component);

    var displayName = ComposedComponent.displayName || ComposedComponent.name || 'Component';

    WithStyles.displayName = 'WithStyles(' + displayName + ')';
    WithStyles.contextTypes = contextTypes;
    WithStyles.ComposedComponent = ComposedComponent;

    return (0, _hoistNonReactStatics2.default)(WithStyles, ComposedComponent);
  };
}

exports.default = withStyles;

/***/ }),

/***/ 1239:
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
module.exports = function (useSourceMap) {
	var list = [];

	// return the list of modules as css string
	list.toString = function toString() {
		return this.map(function (item) {
			var content = cssWithMappingToString(item, useSourceMap);
			if (item[2]) {
				return "@media " + item[2] + "{" + content + "}";
			} else {
				return content;
			}
		}).join("");
	};

	// import a list of modules into the list
	list.i = function (modules, mediaQuery) {
		if (typeof modules === "string") modules = [[null, modules, ""]];
		var alreadyImportedModules = {};
		for (var i = 0; i < this.length; i++) {
			var id = this[i][0];
			if (typeof id === "number") alreadyImportedModules[id] = true;
		}
		for (i = 0; i < modules.length; i++) {
			var item = modules[i];
			// skip already imported module
			// this implementation is not 100% perfect for weird media query combinations
			//  when a module is imported multiple times with different media queries.
			//  I hope this will never occur (Hey this way we have smaller bundles)
			if (typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
				if (mediaQuery && !item[2]) {
					item[2] = mediaQuery;
				} else if (mediaQuery) {
					item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
				}
				list.push(item);
			}
		}
	};
	return list;
};

function cssWithMappingToString(item, useSourceMap) {
	var content = item[1] || '';
	var cssMapping = item[3];
	if (!cssMapping) {
		return content;
	}

	if (useSourceMap && typeof btoa === 'function') {
		var sourceMapping = toComment(cssMapping);
		var sourceURLs = cssMapping.sources.map(function (source) {
			return '/*# sourceURL=' + cssMapping.sourceRoot + source + ' */';
		});

		return [content].concat(sourceURLs).concat([sourceMapping]).join('\n');
	}

	return [content].join('\n');
}

// Adapted from convert-source-map (MIT)
function toComment(sourceMap) {
	// eslint-disable-next-line no-undef
	var base64 = btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap))));
	var data = 'sourceMappingURL=data:application/json;charset=utf-8;base64,' + base64;

	return '/*# ' + data + ' */';
}

/***/ }),

/***/ 1240:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/*!
  Copyright (c) 2016 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames() {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg === 'undefined' ? 'undefined' : _typeof(arg);

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg)) {
				classes.push(classNames.apply(null, arg));
			} else if (argType === 'object') {
				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if (typeof module !== 'undefined' && module.exports) {
		module.exports = classNames;
	} else if ("function" === 'function' && _typeof(__webpack_require__(87)) === 'object' && __webpack_require__(87)) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
			return classNames;
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		window.classNames = classNames;
	}
})();

/***/ }),

/***/ 1241:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history_js__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_locale__ = __webpack_require__(102);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







function isLeftClickEvent(event) {
  return event.button === 0;
}

function isModifiedEvent(event) {
  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}

var Link = function (_React$Component) {
  _inherits(Link, _React$Component);

  function Link() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Link);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Link.__proto__ || Object.getPrototypeOf(Link)).call.apply(_ref, [this].concat(args))), _this), _this.handleClick = function (event) {
      var _this$props = _this.props,
          to = _this$props.to,
          locale = _this$props.locale;


      if (_this.props.onClick) {
        _this.props.onClick(event);
      }

      if (isModifiedEvent(event) || !isLeftClickEvent(event)) {
        return;
      }

      if (event.defaultPrevented === true) {
        return;
      }

      event.preventDefault();

      if (to) {
        __WEBPACK_IMPORTED_MODULE_3_history_js__["a" /* default */].push(__WEBPACK_IMPORTED_MODULE_4__helpers_locale__["h" /* toLocalized */](to, locale));
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Link, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          to = _props.to,
          locale = _props.locale,
          children = _props.children,
          elementRef = _props.elementRef,
          shouldSetNoIndex = _props.shouldSetNoIndex,
          dispatch = _props.dispatch,
          props = _objectWithoutProperties(_props, ['to', 'locale', 'children', 'elementRef', 'shouldSetNoIndex', 'dispatch']);

      var title = typeof children === 'string' ? children : '';
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'a',
        _extends({
          title: title,
          href: __WEBPACK_IMPORTED_MODULE_4__helpers_locale__["h" /* toLocalized */](to, locale)
        }, props, {
          ref: elementRef,
          onClick: this.handleClick
        }),
        children
      );
    }
  }]);

  return Link;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Link.defaultProps = {
  shouldSetNoIndex: false,
  onClick: null,
  children: '',
  elementRef: undefined,
  dispatch: undefined,
  to: undefined
};


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */](function (_ref2) {
  var locale = _ref2.globals.locale;
  return { locale: locale };
})(Link));

/***/ }),

/***/ 1242:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return withTranslate; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_intl__ = __webpack_require__(474);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_common__ = __webpack_require__(184);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var withTranslate = function withTranslate(WrappedComponent) {
  var _class, _temp2;

  return __WEBPACK_IMPORTED_MODULE_1_react_intl__["d" /* injectIntl */]((_temp2 = _class = function (_React$Component) {
    _inherits(_class, _React$Component);

    function _class() {
      var _ref;

      var _temp, _this, _ret;

      _classCallCheck(this, _class);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = _class.__proto__ || Object.getPrototypeOf(_class)).call.apply(_ref, [this].concat(args))), _this), _this.t = function (string) {
        var values = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

        if (!string) {
          return '';
        }

        return _this.props.intl.formatMessage({ id: string }, values);
      }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(_class, [{
      key: 'render',
      value: function render() {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(WrappedComponent, _extends({}, this.props, { t: this.t }));
      }
    }]);

    return _class;
  }(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component), _class.displayName = 'withTranslate(' + __WEBPACK_IMPORTED_MODULE_2__helpers_common__["e" /* getDisplayName */](WrappedComponent) + ')', _temp2));
};

/***/ }),

/***/ 1243:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EVENTS; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__payment__ = __webpack_require__(308);
var _business, _advert;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



var ADVERT_CLICK = 'clickAddAdButton_';
// const SERVICE = 'service';
var TARIFF_PLAN = 'tariffplan';
var SERVICE = 'service';
var TARIFF_PLAN_BUSINESS = 'tariffplan_business';
var SERVICE_BUSINESS = 'service_business';
var C2C_SLOT = __WEBPACK_IMPORTED_MODULE_0__payment__["d" /* PACKAGES */].C2C_SLOT,
    C2C_SINGLE = __WEBPACK_IMPORTED_MODULE_0__payment__["d" /* PACKAGES */].C2C_SINGLE,
    C2C_TURBO = __WEBPACK_IMPORTED_MODULE_0__payment__["d" /* PACKAGES */].C2C_TURBO,
    C2C_FAST = __WEBPACK_IMPORTED_MODULE_0__payment__["d" /* PACKAGES */].C2C_FAST;


var EVENTS = {
  MOBILE: {
    sendMessageToOwner: { event: 'sendlOwnerMessage_button' },
    registrationSuccess: { event: 'successRegistration' },
    adSent0: { event: 'clickAddAdButton_Free' },
    adSent1: { event: 'clickAddAdButton_109' },
    adSent2: { event: 'clickAddAdButton_199' },
    adSent3: { event: 'clickAddAdButton_299' },
    // Page types
    pageMain: { pageType: 'mainpage' },
    pageAdCard: { pageType: 'Ad_card' },
    pageDealer: { pageType: 'Dealer_Page' },
    pageSearch: { pageType: 'catalog' },
    pageAddAdvMainInfo: { pageType: 'Step 1' },
    pageAddAdvContactsPhoto: { pageType: 'Step 2' },
    pageAddAdvSellCar: { pageType: 'Step 3' },

    //
    pageDealers: { pageType: 'Dealers_Page' },
    pageProfile: { pageType: 'Profile_Page' },
    pageGeo: { pageType: 'Geo_Page' },
    pageFilters: { pageType: 'Filters_Page' },
    pageFavorites: { pageType: 'Favorites_Page' }
  },
  // Adverts
  AddCarNumberButton: { event: 'Add__NumberButton' },
  AddChooseBrand: { event: 'Add__ChooseBrand' },
  AddPhotoAdded: { event: 'Add__PhotoAdded' },
  AddPhotoDeleted: { event: 'Add__PhotoDeleted' },
  AddPhotoSort: { event: 'Add__PhotoSort' },
  AddSubmit: { event: 'Add__Submit' },
  AddSubmitFinal: { event: 'Add__SubmitFinall' },
  AddClearWarningMessageAndSubmit: { event: 'Add__SubmitAfterError' },
  AddSubmitForm: { event: 'Add__SubmitForm' },
  AddNextButtonCommon: { event: 'Add__NextButtonAll' },
  AddCommonPublishButton: { event: 'Add__PublishButtonAll' },
  // AddNextButton1: { event: 'Add__NextButton-1' },
  // AddNextButton2: { event: 'Add__NextButton-2' },
  // AddNextButton3: { event: 'Add__NextButton-3' },
  // AddNextButton4: { event: 'Add__NextButton-4' },

  AddCarBrandGroup: { event: 'AddCarBrandGroup' },
  freeAdSent: { event: 'freeAdSent' },
  turboAdvert: { event: ADVERT_CLICK + '333_Turbo' },
  fastAdvert: { event: ADVERT_CLICK + '198_Quick' },
  freeAll: { event: ADVERT_CLICK + '555_All' },
  freeUp: { event: ADVERT_CLICK + '105_Autopromotion' },
  freeVip: { event: ADVERT_CLICK + '225_VIP' },
  freeCol: { event: ADVERT_CLICK + '75_Colour' },
  freeTop: { event: ADVERT_CLICK + '150_TOP' },
  freeUpVipCol: { event: ADVERT_CLICK + '405_Auto+VIP+Colour' },
  freeUpVip: { event: ADVERT_CLICK + '330_Auto+VIP' },
  freeUpCol: { event: ADVERT_CLICK + '180_Auto+Colour' },
  freeUpTop: { event: ADVERT_CLICK + '150_Auto+Top' },
  freeUpTopCol: { event: ADVERT_CLICK + '225_Auto+Top+Colour' },
  freeVipVolTop: { event: ADVERT_CLICK + '450_VIP+Colour+Top' },
  freeVipCol: { event: ADVERT_CLICK + '300_Vip+Colour' },
  freeVipTop: { event: ADVERT_CLICK + '375_Vip+Top' },
  freeVipTopUp: { event: ADVERT_CLICK + '480_Vip+Top+Auto' },
  freeColTop: { event: ADVERT_CLICK + '225_Colour+Top' },
  //
  addToFavorites: { event: 'likeCar_button' },
  sellCarButtonClick: { event: 'sellCarr_Button' },
  seeReviews: { event: 'see_review_Button' },
  showPhoneClick: { event: 'showPhone_button' },
  sendTestDriveForm: { event: 'sendTestDrive_Form' },
  dealerSiteRedirect: { event: 'goDealerSite_Button' },
  showAllDealerAdverts: { event: 'showAllDealerCars_Button' },
  successLogin: { event: 'successRegistration' },
  callOwner: { event: 'callOwner_button' },
  searchButtonClick: { event: 'pressSearchButton' },
  paidAdSent: { event: 'paidAdSent' },
  advert: (_advert = {
    'balance-refill': { event: 'balance_refil' }
  }, _defineProperty(_advert, C2C_SLOT, { event: TARIFF_PLAN + '/4/' }), _defineProperty(_advert, 'sp-slot', { event: TARIFF_PLAN + '/25/' }), _defineProperty(_advert, C2C_SINGLE, { event: TARIFF_PLAN + '/31/' }), _defineProperty(_advert, 'update', { event: SERVICE + '/1/' }), _defineProperty(_advert, 'vip', { event: SERVICE + '/2/' }), _defineProperty(_advert, 'top', { event: SERVICE + '/4/' }), _defineProperty(_advert, 'color', { event: SERVICE + '/3/' }), _defineProperty(_advert, C2C_TURBO, { event: TARIFF_PLAN + '/6/' }), _defineProperty(_advert, C2C_FAST, { event: TARIFF_PLAN + '/5/' }), _defineProperty(_advert, 'b2c', { event: TARIFF_PLAN_BUSINESS + '/2/' }), _defineProperty(_advert, 'business', (_business = {}, _defineProperty(_business, C2C_SINGLE, { event: TARIFF_PLAN_BUSINESS + '/31/' }), _defineProperty(_business, 'b2c', { event: TARIFF_PLAN_BUSINESS + '/2/' }), _defineProperty(_business, 'update', { event: SERVICE_BUSINESS + '/1/' }), _defineProperty(_business, 'vip', { event: SERVICE_BUSINESS + '/2/' }), _defineProperty(_business, 'top', { event: SERVICE_BUSINESS + '/4/' }), _defineProperty(_business, 'color', { event: SERVICE_BUSINESS + '/3/' }), _defineProperty(_business, C2C_FAST, { event: TARIFF_PLAN_BUSINESS + '/5/' }), _defineProperty(_business, C2C_TURBO, { event: TARIFF_PLAN_BUSINESS + '/6/' }), _defineProperty(_business, 'spareparts-500', { event: TARIFF_PLAN_BUSINESS + '/7/' }), _defineProperty(_business, 'spareparts-1000', { event: TARIFF_PLAN_BUSINESS + '/8/' }), _defineProperty(_business, 'spareparts-2000', { event: TARIFF_PLAN_BUSINESS + '/9/' }), _defineProperty(_business, 'spareparts-3000', { event: TARIFF_PLAN_BUSINESS + '/10/' }), _defineProperty(_business, 'spareparts-unlim', { event: TARIFF_PLAN_BUSINESS + '/11/' }), _defineProperty(_business, 'spareparts-batch-update-20', { event: TARIFF_PLAN_BUSINESS + '/18/' }), _defineProperty(_business, 'spareparts-batch-update-35', { event: TARIFF_PLAN_BUSINESS + '/19/' }), _defineProperty(_business, 'spareparts-batch-update-70', { event: TARIFF_PLAN_BUSINESS + '/20/' }), _defineProperty(_business, 'spareparts-batch-update-100', { event: TARIFF_PLAN_BUSINESS + '/21/' }), _defineProperty(_business, 'spareparts-batch-update-150', { event: TARIFF_PLAN_BUSINESS + '/22/' }), _defineProperty(_business, 'spareparts-batch-update-200', { event: TARIFF_PLAN_BUSINESS + '/23/' }), _defineProperty(_business, 'spareparts-batch-update-400', { event: TARIFF_PLAN_BUSINESS + '/24/' }), _business)), _defineProperty(_advert, 'dealership', {
    'spareparts-500': { event: TARIFF_PLAN + '/7/' },
    'spareparts-1000': { event: TARIFF_PLAN + '/8/' },
    'spareparts-2000': { event: TARIFF_PLAN + '/9/' },
    'spareparts-3000': { event: TARIFF_PLAN + '/10/' },
    'spareparts-unlim': { event: TARIFF_PLAN + '/11/' },
    'spareparts-batch-update-20': { event: TARIFF_PLAN + '/18/' },
    'spareparts-batch-update-35': { event: TARIFF_PLAN + '/19/' },
    'spareparts-batch-update-70': { event: TARIFF_PLAN + '/20/' },
    'spareparts-batch-update-100': { event: TARIFF_PLAN + '/21/' },
    'spareparts-batch-update-150': { event: TARIFF_PLAN + '/22/' },
    'spareparts-batch-update-200': { event: TARIFF_PLAN + '/23/' },
    'spareparts-batch-update-400': { event: TARIFF_PLAN + '/24/' }
  }), _advert),
  leasing: {
    'data-lens-event': { event: 'leasingRequestClick' },
    'page-view': { event: 'leasingPageView' },

    // Automoney
    'automoney-monthly-calculation-show-form-click': {
      event: 'automoney-LeasingMonthly-Calculation-Show-Form-Click'
    },
    'automoney-monthly-calculation-form-sumbit': {
      event: 'automoney-LeasingMonthly-Calculation-Form-Sumbit'
    },
    'automoney-monthly-consultation-form-sumbit': {
      event: 'automoney-LeasingMonthly-Consultation-Form-Submit'
    },
    'automoney-questions-form-sumbit': { event: 'automoney-leasingMonthly-questions-Form-Submit' },
    'automoney-lead-create-success': { event: 'automoney-lead-created-success' },
    'automoney-lead-create-fail': { event: 'automoney-lead-create-fail' },
    'automoney-monthly-calculation-show-form-click-advertcard': {
      event: 'automoney-leasingMonthly-Calculation-Show-Form-Click-advertCard'
    },
    'automoney-monthly-calculation-form-sumbit-advertcard': {
      event: 'automoney-leasingMonthly-Calculation-Form-Sumbit-advertCard'
    },
    'automoney-monthly-consultation-form-sumbit-advertcard': {
      event: 'automoney-leasingMonthly-Consultation-Form-Submit-advertCard'
    },
    'automoney-lead-create-success-advertcard': {
      event: 'automoney-myauto-lead-create-success-advertCard'
    },
    'automoney-lead-create-fail-advertcard': {
      event: 'automoney-myauto-lead-create-fail-advertCard'
    },

    // Microcredit
    'microcredit-consultation-show-form-click': {
      event: 'microcredit-Consultation-Show-Form-Click'
    },
    'microcredit-consultation-form-sumbit': { event: 'microcredit-Consultation-Form-Submit' },
    'microcredit-lead-create-success': { event: 'microcredit-lead-created-success' },
    'microcredit-lead-create-fail': { event: 'microcredit-lead-create-fail' },

    'microcredit-consultation-show-form-click-advertcard': {
      event: 'microcredit-Consultation-Show-Form-Click-advertCard'
    },
    'microcredit-consultation-form-sumbit-advertcard': {
      event: 'microcredit-Consultation-Form-Submit-advertCard'
    },
    'microcredit-lead-create-success-advertcard': {
      event: 'microcredit-lead-created-success-advertCard'
    },
    'microcredit-lead-create-fail-advertcard': { event: 'microcredit-lead-create-fail-advertCard' },

    // Creditmarket
    'creditmarket-consultation-show-form-click': {
      event: 'creditmarket-Consultation-Show-Form-Click'
    },
    'creditmarket-consultation-form-sumbit': { event: 'creditmarket-Consultation-Form-Submit' },
    'creditmarket-lead-create-success': { event: 'creditmarket-lead-created-success' },
    'creditmarket-lead-create-fail': { event: 'creditmarket-lead-create-fail' },

    'creditmarket-consultation-show-form-click-advertcard': {
      event: 'creditmarket-Consultation-Show-Form-Click-advertCard'
    },
    'creditmarket-consultation-form-sumbit-advertcard': {
      event: 'creditmarket-Consultation-Form-Submit-advertCard'
    },
    'creditmarket-lead-create-success-advertcard': {
      event: 'creditmarket-lead-created-success-advertCard'
    },
    'creditmarket-lead-create-fail-advertcard': {
      event: 'creditmarket-lead-create-fail-advertCard'
    },
    'creditmarket-questions-form-sumbit': {
      event: 'creditmarket-leasingMonthly-questions-Form-Submit'
    },

    // MyAuto
    'monthly-calculation-show-form-click': { event: 'leasingMonthly-Calculation-Show-Form-Click' },
    'monthly-calculation-form-sumbit': { event: 'leasingMonthly-Calculation-Form-Sumbit' },
    'monthly-consultation-form-sumbit': { event: 'leasingMonthly-Consultation-Form-Submit' },
    'questions-form-sumbit': { event: 'leasingMonthly-questions-Form-Submit' },
    'lead-create-success-questions': { event: 'lead-create-success-questions' },
    'lead-create-fail-questions': { event: 'lead-create-fail-questions' },
    'lead-create-success': { event: 'lead-create-success' },
    'lead-create-fail': { event: 'lead-create-fail' },
    'monthly-calculation-show-form-click-advertcard': {
      event: 'leasingMonthly-Calculation-Show-Form-Click-advertCard'
    },
    'monthly-calculation-form-sumbit-advertcard': {
      event: 'leasingMonthly-Calculation-Form-Sumbit-advertCard'
    },
    'monthly-consultation-form-sumbit-advertcard': {
      event: 'leasingMonthly-Consultation-Form-Submit-advertCard'
    },
    // 'questions-form-sumbit-advertcard': { event: `leasingMonthly-questions-Form-Submit-advertCard` },
    'lead-create-success-advertcard': { event: 'lead-create-success-advertCard' },
    'lead-create-fail-advertcard': { event: 'lead-create-fail-advertCard' },
    'lead-create-success-advertcard-sidebar': { event: 'lead-create-success-advertCard-sidebar' },
    'lead-create-fail-advertcard-sidebar': { event: 'lead-create-fail-advertCard-sidebar' },

    // Hapai
    'hapai-monthly-calculation-show-form-click': {
      event: 'hapai-LeasingMonthly-Calculation-Show-Form-Click'
    },
    'hapai-monthly-calculation-form-sumbit': {
      event: 'hapai-LeasingMonthly-Calculation-Form-Sumbit'
    },
    'hapai-monthly-consultation-form-sumbit': {
      event: 'hapai-LeasingMonthly-Consultation-Form-Submit'
    },
    'hapai-questions-form-sumbit': { event: 'hapai-leasingMonthly-questions-Form-Submit' },
    'hapai-lead-create-success': { event: 'hapai-lead-created-success' },
    'hapai-lead-create-success-questions': { event: 'hapai-lead-create-success-questions' },
    'hapai-lead-create-fail-questions': { event: 'hapai-lead-create-fail-questions' },
    'hapai-lead-create-fail': { event: 'hapai-lead-create-fail' },
    'hapai-monthly-calculation-show-form-click-advertcard': {
      event: 'hapai-leasingMonthly-Calculation-Show-Form-Click-advertCard'
    },
    'hapai-monthly-calculation-form-sumbit-advertcard': {
      event: 'hapai-leasingMonthly-Calculation-Form-Sumbit-advertCard'
    },
    'hapai-monthly-consultation-form-sumbit-advertcard': {
      event: 'hapai-leasingMonthly-Consultation-Form-Submit-advertCard'
    },
    // 'hapai-questions-form-sumbit-advertcard': { event: `hapai-leasingMonthly-questions-Form-Submit-advertCard` },
    'hapai-lead-create-success-advertcard': { event: 'hapai-lead-create-success-advertCard' },
    'hapai-lead-create-fail-advertcard': { event: 'hapai-lead-create-fail-advertCard' },
    'hapai-lead-create-success-advertcard-sidebar': {
      event: 'hapai-lead-create-success-advertCard-sidebar'
    },
    'hapai-lead-create-fail-advertcard-sidebar': {
      event: 'hapai-lead-create-fail-advertCard-sidebar'
    },

    // Ulf24
    'ulf24-monthly-calculation-show-form-click': {
      event: 'ulf24-LeasingMonthly-Calculation-Show-Form-Click'
    },
    'ulf24-monthly-calculation-form-sumbit': {
      event: 'ulf24-LeasingMonthly-Calculation-Form-Sumbit'
    },
    'ulf24-monthly-consultation-form-sumbit': {
      event: 'ulf24-LeasingMonthly-Consultation-Form-Submit'
    },
    'ulf24-questions-form-sumbit': { event: 'ulf24-leasingMonthly-questions-Form-Submit' },
    'ulf24-lead-create-success': { event: 'ulf24-lead-created-success' },
    'ulf24-lead-create-fail': { event: 'ulf24-lead-create-fail' },
    'ulf24-monthly-calculation-show-form-click-advertcard': {
      event: 'ulf24-leasingMonthly-Calculation-Show-Form-Click-advertCard'
    },
    'ulf24-monthly-calculation-form-sumbit-advertcard': {
      event: 'ulf24-leasingMonthly-Calculation-Form-Sumbit-advertCard'
    },
    'ulf24-monthly-consultation-form-sumbit-advertcard': {
      event: 'ulf24-leasingMonthly-Consultation-Form-Submit-advertCard'
    },
    // 'ulf24-questions-form-sumbit-advertcard': { event: `ulf24-leasingMonthly-questions-Form-Submit-advertCard` },
    'ulf24-lead-create-success-advertcard': {
      event: 'ulf24-myauto-lead-create-success-advertCard'
    },
    'ulf24-lead-create-fail-advertcard': { event: 'ulf24-myauto-lead-create-fail-advertCard' },

    'ulf24-monthly-consultation-form-sumbit-advertcard-sidebar': {
      event: 'ulf24-leasingMonthly-Consultation-Form-Submit-advertCard-sidebar'
    },
    'ulf24-lead-create-success-advertcard-sidebar': {
      event: 'ulf24-lead-create-success-advertCard-sidebar'
    },
    'ulf24-lead-create-fail-advertcard-sidebar': {
      event: 'ulf24-lead-create-fail-advertCard-sidebar'
    },

    // Other events
    online: {
      'Popup-Used-Click': { event: 'leasingOnline-Popup-Used-Click' },
      'Popup-New-Click': { event: 'leasingOnline-Popup-New-Click' },
      'Sidebar-Used-Click': { event: 'leasingOnline-Sidebar-Used-Click' },
      'Sidebar-New-Click': { event: 'leasingOnline-Sidebar-New-Click' },
      LinkUnderThePrice: { event: 'leasingOnline_LinkUnderThePrice' }
    },
    consultation: {
      'Popup-Used-Click': { event: 'leasingConsultation-Popup-Used-Click' },
      'Popup-New-Click': { event: 'leasingConsultation-Popup-New-Click' },
      'Sidebar-Used-Click': { event: 'leasingConsultation-Sidebar-Used-Click' },
      'Sidebar-New-Click': { event: 'leasingConsultation-Sidebar-New-Click' },
      'Hapai-Popup-Used-Click': { event: 'hapai-leasingConsultation-Popup-Used-Click' },
      'Hapai-Popup-New-Click': { event: 'hapai-leasingConsultation-Popup-New-Click' },
      'Hapai-Sidebar-Used-Click': { event: 'hapai-leasingConsultation-Sidebar-Used-Click' },
      'Hapai-Sidebar-New-Click': { event: 'hapai-leasingConsultation-Sidebar-New-Click' },
      'Ulf24-Popup-Used-Click': { event: 'ulf24-leasingConsultation-Popup-Used-Click' },
      'Ulf24-Popup-New-Click': { event: 'ulf24-leasingConsultation-Popup-New-Click' },
      'Ulf24-Sidebar-Used-Click': { event: 'ulf24-leasingConsultation-Sidebar-Used-Click' },
      'Ulf24-Sidebar-New-Click': { event: 'ulf24-leasingConsultation-Sidebar-New-Click' }
    },

    codeVerification: {
      'Popup-Used-Click': { event: 'leasingOnlineCodeVerification-Popup-Used-Click' },
      'Popup-New-Click': { event: 'leasingOnlineCodeVerification-Popup-New-Click' },
      'Sidebar-Used-Click': { event: 'leasingOnlineCodeVerification-Sidebar-Used-Click' },
      'Sidebar-New-Click': { event: 'leasingOnlineCodeVerification-Sidebar-New-Click' }
    }
  },

  NAVIGATION_LINK: {
    'headerNavigation/avto/avtosalony/': { event: 'avtosalony_nav_legkovye' },
    'headerNavigation/avtosalony/': { event: 'avtosalony_nav_avtosalony' },
    'headerNavigation/avtosalony/avtosalony/avto/': { event: 'avtosalony_nav_avtosalony_avto' },
    'subHeader/avtosalony/': { event: 'avtosalony_sub-nav_avtosalony' }
  },

  DEALERS: {
    showNubmer: { event: 'avtosalony_listing_show-nubmer' },
    testDrive: { event: 'avtosalony_listing_test-drive' },
    tradeIn: { event: 'avtosalony_listing_trade-in' },

    formTestDrive: { event: 'avtosalony_listing_form_test-drive' },
    formTradeIn: { event: 'avtosalony_listing_form_trade-in' }
  },

  DEALER_ADV: {
    showNubmer: { event: 'avtosalony_car_show-number' },
    tradeIn: { event: 'avtosalony_car_trade-in' },
    testDrive: { event: 'avtosalony_car_testDrive' },
    callback: { event: 'avtosalony_car_callback' },

    formTradeIn: { event: 'avtosalony_car_form_trade-in' },
    formTestDrive: { event: 'avtosalony_car_form_testDrive' },
    formCallback: { event: 'avtosalony_car_form_callback' }
  },

  DEALER_CARD: {
    showNubmer: { event: 'avtosalony_card_show-number' },
    goToSite: { event: 'avtosalony_card_site' },

    tradeIn: { event: 'avtosalony_card_trade-in' },
    testDrive: { event: 'avtosalony_card_test-drive' },

    formTradeIn: { event: 'avtosalony_card_form_trade-in' },
    formTestDrive: { event: 'avtosalony_card_form_test-drive' }
  }
};

/***/ }),

/***/ 1244:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return withFetch; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_shared_components_App__ = __webpack_require__(485);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_common__ = __webpack_require__(184);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();





var withFetch = function withFetch(WrappedComponent) {
  var Component = function Component(props) {
    return _jsx(__WEBPACK_IMPORTED_MODULE_1_shared_components_App__["a" /* ContextConsumer */], {}, void 0, function (_ref) {
      var fetch = _ref.fetch;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(WrappedComponent, _extends({}, props, { fetch: fetch }));
    });
  };
  Component.displayName = 'withFetch(' + __WEBPACK_IMPORTED_MODULE_2__helpers_common__["e" /* getDisplayName */](WrappedComponent) + ')';

  return Component;
};

/***/ }),

/***/ 1245:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1309);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./UIStyle.css", function() {
        content = require("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./UIStyle.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 1246:
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var ReactIs = require('react-is');

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(ReactIs.isElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(1356)();
}

/***/ }),

/***/ 1247:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "583766ba.svg";

/***/ }),

/***/ 1248:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_shared_constants_locationTypes__ = __webpack_require__(1261);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



// Helpers

var withInjectLocations = function withInjectLocations() {
  for (var _len = arguments.length, locationTypes = Array(_len), _key = 0; _key < _len; _key++) {
    locationTypes[_key] = arguments[_key];
  }

  return function (item) {
    return _extends({}, item, {
      injectLocations: locationTypes
    });
  };
};

//

var avto = [{
  title: 'Объявления',
  route: '/avto/',
  injectLocations: [__WEBPACK_IMPORTED_MODULE_0_shared_constants_locationTypes__["a" /* default */].COUNTRY, __WEBPACK_IMPORTED_MODULE_0_shared_constants_locationTypes__["a" /* default */].CITY]
},
// {
//   title: 'Каталог',
//   route: '/avto/catalog',
// },
{
  title: 'Автосалоны',
  route: '/avtosalony/',
  slug: '/avtosalony/',
  injectLocations: [__WEBPACK_IMPORTED_MODULE_0_shared_constants_locationTypes__["a" /* default */].CITY]
}];

var moto = [{
  title: 'Мотоциклы',
  route: '/mototsikl/',
  slug: '/mototsikl/',
  injectLocations: [__WEBPACK_IMPORTED_MODULE_0_shared_constants_locationTypes__["a" /* default */].CITY]
}, {
  title: 'Скутеры',
  route: '/skuter/',
  slug: '/skuter/',
  injectLocations: [__WEBPACK_IMPORTED_MODULE_0_shared_constants_locationTypes__["a" /* default */].CITY]
}, {
  title: 'Картинг',
  route: '/karting/',
  slug: '/karting/',
  injectLocations: [__WEBPACK_IMPORTED_MODULE_0_shared_constants_locationTypes__["a" /* default */].CITY]
}, {
  title: 'Квадроциклы',
  route: '/kvadrotsikl/',
  slug: '/kvadrotsikl/',
  injectLocations: [__WEBPACK_IMPORTED_MODULE_0_shared_constants_locationTypes__["a" /* default */].CITY]
}, {
  title: 'Мопеды',
  route: '/moped/',
  slug: '/moped/',
  injectLocations: [__WEBPACK_IMPORTED_MODULE_0_shared_constants_locationTypes__["a" /* default */].CITY]
}, {
  title: 'Багги',
  route: '/baggi/',
  slug: '/baggi/',
  injectLocations: [__WEBPACK_IMPORTED_MODULE_0_shared_constants_locationTypes__["a" /* default */].CITY]
}, {
  title: 'Трициклы',
  route: '/tritsikl/',
  slug: '/tritsikl/',
  injectLocations: [__WEBPACK_IMPORTED_MODULE_0_shared_constants_locationTypes__["a" /* default */].CITY]
}];

var truck = [{
  title: 'Грузовики',
  route: '/gruzovye/',
  slug: '/gruzovye/',
  injectLocations: [__WEBPACK_IMPORTED_MODULE_0_shared_constants_locationTypes__["a" /* default */].CITY]
}, {
  title: 'Автобусы',
  route: '/avtobus/',
  slug: '/avtobus/',
  injectLocations: [__WEBPACK_IMPORTED_MODULE_0_shared_constants_locationTypes__["a" /* default */].CITY]
}, {
  title: 'Прицепы',
  route: '/pritsepy/',
  slug: '/pritsepy/',
  injectLocations: [__WEBPACK_IMPORTED_MODULE_0_shared_constants_locationTypes__["a" /* default */].CITY]
}, {
  title: 'Водный транспорт',
  route: '/vodnyi-transport/',
  slug: '/vodnyi-transport/',
  injectLocations: [__WEBPACK_IMPORTED_MODULE_0_shared_constants_locationTypes__["a" /* default */].CITY]
}, {
  title: 'Спецтехника',
  route: '/spetstehnika/',
  slug: '/spetstehnika/',
  injectLocations: [__WEBPACK_IMPORTED_MODULE_0_shared_constants_locationTypes__["a" /* default */].CITY]
}];

var AVTOSALONS_LINKS = [{
  title: 'Авто',
  route: '/avtosalony/',
  slug: '/avtosalony/avto/'
}, {
  title: 'Мото',
  route: '/avtosalony/mototsikl/',
  slug: '/avtosalony/mototsikl/'
}, {
  title: 'Автобусы',
  route: '/avtosalony/avtobus/',
  slug: '/avtosalony/avtobus/'
}, {
  title: 'Грузовики',
  route: '/avtosalony/gruzovye/',
  slug: '/avtosalony/gruzovye/'
}, {
  title: 'Водный транспорт',
  route: '/avtosalony/vodnyi-transport/',
  slug: '/avtosalony/vodnyi-transport/'
}, {
  title: 'Спецтехника',
  route: '/avtosalony/spetstehnika/',
  slug: '/avtosalony/spetstehnika/'
}, {
  title: 'Прицепы',
  route: '/avtosalony/pritsepy/',
  slug: '/avtosalony/pritsepy/'
}];

var FIRMS_TAGS_LINKS = [{
  title: 'СТО',
  route: '/katalog-kompaniy/sto/',
  slug: '/katalog-kompaniy/sto/'
}, {
  title: 'Авторазборка',
  route: '/katalog-kompaniy/avtorazborka/',
  slug: '/katalog-kompaniy/avtorazborka//'
}, {
  title: 'Автовыкуп',
  route: '/katalog-kompaniy/avtovykup/',
  slug: '/katalog-kompaniy/avtovykup/'
}, {
  title: 'Запчасти',
  route: '/katalog-kompaniy/zapchasti/',
  slug: '/katalog-kompaniy/zapchasti/'
}, {
  title: 'Автотовары',
  route: '/katalog-kompaniy/avtotovary/',
  slug: '/katalog-kompaniy/avtotovary/'
}, {
  title: 'ТСЦ',
  route: '/katalog-kompaniy/teritorialni-servisni-centri/',
  slug: '/katalog-kompaniy/teritorialni-servisni-centri/'
}];

var HEADER = [{
  title: 'Легковые',
  route: '/avto/',
  name: 'avto',
  items: [{
    title: 'C пробегом',
    route: '/avto/',
    injectLocations: [__WEBPACK_IMPORTED_MODULE_0_shared_constants_locationTypes__["a" /* default */].COUNTRY, __WEBPACK_IMPORTED_MODULE_0_shared_constants_locationTypes__["a" /* default */].CITY]
  }, {
    title: 'Новые',
    route: '/avto/novye/',
    injectLocations: [__WEBPACK_IMPORTED_MODULE_0_shared_constants_locationTypes__["a" /* default */].CITY]
  },
  // {
  //   title: 'Каталог',
  //   route: '/avto/catalog',
  // },
  {
    title: 'Автосалоны',
    route: '/avtosalony/',
    injectLocations: [__WEBPACK_IMPORTED_MODULE_0_shared_constants_locationTypes__["a" /* default */].CITY]
  }, {
    title: 'Лизинг авто',
    route: '/leasing/',
    injectLocations: [__WEBPACK_IMPORTED_MODULE_0_shared_constants_locationTypes__["a" /* default */].CITY]
  }],
  injectLocations: [__WEBPACK_IMPORTED_MODULE_0_shared_constants_locationTypes__["a" /* default */].COUNTRY, __WEBPACK_IMPORTED_MODULE_0_shared_constants_locationTypes__["a" /* default */].CITY]
}, {
  title: 'Мото',
  route: '/moto/',
  items: moto.map(withInjectLocations(__WEBPACK_IMPORTED_MODULE_0_shared_constants_locationTypes__["a" /* default */].CITY)),
  injectLocations: [__WEBPACK_IMPORTED_MODULE_0_shared_constants_locationTypes__["a" /* default */].CITY]
}, {
  title: 'Коммерческие',
  route: '/commercial/',
  items: truck.map(withInjectLocations(__WEBPACK_IMPORTED_MODULE_0_shared_constants_locationTypes__["a" /* default */].CITY)),
  injectLocations: [__WEBPACK_IMPORTED_MODULE_0_shared_constants_locationTypes__["a" /* default */].CITY]
  // {
  //   title: 'Спецтехника',
  //   route: '/spetstehnika/',
  //   items: [
  //     {
  //       title: 'Автокран',
  //       route: '/avtokran',
  //     },
  //     {
  //       title: 'Бульдозеры',
  //       route: '/buldozer',
  //     },
  //     {
  //       title: 'Автопогрузчики',
  //       route: '/avtopogruzchik',
  //     },
  //     {
  //       title: 'Эскаваторы',
  //       route: '/ekskavator',
  //     },
  //     {
  //       title: 'Самопогрузчики',
  //       route: '/samopogruzchik',
  //     },
  //     {
  //       title: 'Коммунальная',
  //       route: '/kommunalnaya',
  //     },
  //     {
  //       title: 'Cтроительная техника',
  //       route: '/stroitelnaya',
  //     },
  //   ],
  // },
}, {
  title: 'Запчасти',
  route: '/zapchasti/',
  injectLocations: [__WEBPACK_IMPORTED_MODULE_0_shared_constants_locationTypes__["a" /* default */].CITY],
  items: [
    // {
    //   title: 'Запчасти',
    //   route: '/zapchasti/',
    //   injectLocations: [LOCATION_TYPES.CITY],
    // },
    // {
    //   title: 'Новые',
    //   route: '/zapchasti?isNew=1',
    // },
    // {
    //   title: 'Б/y',
    //   route: '/zapchasti?isUsed=1',
    // },
    // {
    //   title: 'Каталог компаний',
    //   route: '/katalog-kompaniy/',
    //   injectLocations: [LOCATION_TYPES.CITY],
    // },
  ]
}, {
  title: 'Автосалоны',
  route: '/avtosalony/',
  items: AVTOSALONS_LINKS
}, {
  title: 'Каталог',
  route: '/katalog-kompaniy/sto/',
  items: FIRMS_TAGS_LINKS,
  injectLocations: [__WEBPACK_IMPORTED_MODULE_0_shared_constants_locationTypes__["a" /* default */].CITY]
},
// {
//   title: 'Журнал',
//   route: '/zhurnal/',
//   items: [
//     {
//       title: 'Видео',
//       route: '/zhurnal/video/',
//     },
//     {
//       title: 'Новости',
//       route: '/zhurnal/',
//     },
//     {
//       title: 'Акции',
//       route: '/zhurnal/aktsii/',
//     },
//     {
//       title: 'Статьи',
//       route: '/zhurnal/stati/',
//     },
//     {
//       title: 'Тест-драйвы',
//       route: '/zhurnal/test-draiv/',
//     },
//     {
//       title: 'Обзоры',
//       route: '/zhurnal/obzory/',
//     },
//   ],
// },
{
  title: 'Сервисы',
  route: '/service/ocenka-avto/',
  items: [{
    title: 'Оценка стоимости авто',
    route: '/service/ocenka-avto/'
  }, {
    title: 'Пригон авто',
    route: '/service/prygon-avto/'
  }, {
    title: 'Страховка',
    route: '/insurance/orders/'
  }, {
    title: 'Подписки на поиск',
    route: '/service/search-subscriptions/'
  }]
}];

var FOOTER = [
//

{
  title: 'Разместить рекламу',
  route: '/advertising/'
}, {
  title: 'Бизнесу',
  route: '/biznes-paket/'
}, {
  title: 'Автосалонам',
  route: '/for-dealers/'
}, {
  title: 'Запчасти',
  route: '/info-zapchasti/'
}, {
  title: 'Автосервисам',
  route: '/for-services/'
}, {
  title: 'Помощь',
  route: '/help/'
}, {
  title: 'Частным лицам',
  route: '/for-privates/'
}];

var SPARES_LINKS = [{
  title: 'Авто',
  route: '/zapchasti/',
  slug: '/zapchasti/avto/',
  injectLocations: [__WEBPACK_IMPORTED_MODULE_0_shared_constants_locationTypes__["a" /* default */].CITY]
}, {
  title: 'Мото',
  route: '/zapchasti/moto/',
  slug: '/zapchasti/moto/',
  injectLocations: [__WEBPACK_IMPORTED_MODULE_0_shared_constants_locationTypes__["a" /* default */].CITY]
}, {
  title: 'Автобусы',
  route: '/zapchasti/avtobus/',
  slug: '/zapchasti/avtobus/',
  injectLocations: [__WEBPACK_IMPORTED_MODULE_0_shared_constants_locationTypes__["a" /* default */].CITY]
}, {
  title: 'Грузовики',
  route: '/zapchasti/gruzovye/',
  slug: '/zapchasti/gruzovye/',
  injectLocations: [__WEBPACK_IMPORTED_MODULE_0_shared_constants_locationTypes__["a" /* default */].CITY]
}, {
  title: 'Водный транспорт',
  route: '/zapchasti/vodnyi-transport/',
  slug: '/zapchasti/vodnyi-transport/',
  injectLocations: [__WEBPACK_IMPORTED_MODULE_0_shared_constants_locationTypes__["a" /* default */].CITY]
}, {
  title: 'Спецтехника',
  route: '/zapchasti/spetstehnika/',
  slug: '/zapchasti/spetstehnika/',
  injectLocations: [__WEBPACK_IMPORTED_MODULE_0_shared_constants_locationTypes__["a" /* default */].CITY]
}, {
  title: 'Прицепы',
  route: '/zapchasti/pritsepy/',
  slug: '/zapchasti/pritsepy/',
  injectLocations: [__WEBPACK_IMPORTED_MODULE_0_shared_constants_locationTypes__["a" /* default */].CITY]
}];

var PROFILE = [{
  title: 'Мои объявления',
  route: '/my/'
}, {
  title: 'Сообщения',
  route: '/dialogs/'
}, {
  title: 'Баланс',
  route: '/billing/'
}, {
  title: 'Избранное',
  route: '/favorites/'
},
// {
//   title: 'Мои поиски',
//   route: '/my-searches',
// },
{
  title: 'Страховка',
  route: '/insurance/orders/'
}, {
  title: 'Подписки на поиск',
  route: '/service/search-subscriptions/'
}, {
  title: 'Настройки',
  route: '/profile/'
}];

var SEARCH = {
  avto: avto,
  //
  moto: moto.map(withInjectLocations(__WEBPACK_IMPORTED_MODULE_0_shared_constants_locationTypes__["a" /* default */].CITY)),
  mototsikl: moto.map(withInjectLocations(__WEBPACK_IMPORTED_MODULE_0_shared_constants_locationTypes__["a" /* default */].CITY)),
  skuter: moto.map(withInjectLocations(__WEBPACK_IMPORTED_MODULE_0_shared_constants_locationTypes__["a" /* default */].CITY)),
  karting: moto.map(withInjectLocations(__WEBPACK_IMPORTED_MODULE_0_shared_constants_locationTypes__["a" /* default */].CITY)),
  kvadrotsikl: moto.map(withInjectLocations(__WEBPACK_IMPORTED_MODULE_0_shared_constants_locationTypes__["a" /* default */].CITY)),
  tritsikl: moto.map(withInjectLocations(__WEBPACK_IMPORTED_MODULE_0_shared_constants_locationTypes__["a" /* default */].CITY)),
  moped: moto.map(withInjectLocations(__WEBPACK_IMPORTED_MODULE_0_shared_constants_locationTypes__["a" /* default */].CITY)),
  baggi: moto.map(withInjectLocations(__WEBPACK_IMPORTED_MODULE_0_shared_constants_locationTypes__["a" /* default */].CITY)),
  snegohod: moto.map(withInjectLocations(__WEBPACK_IMPORTED_MODULE_0_shared_constants_locationTypes__["a" /* default */].CITY)),
  //
  gruzovye: truck.map(withInjectLocations(__WEBPACK_IMPORTED_MODULE_0_shared_constants_locationTypes__["a" /* default */].CITY)),
  avtobus: truck.map(withInjectLocations(__WEBPACK_IMPORTED_MODULE_0_shared_constants_locationTypes__["a" /* default */].CITY)),
  pritsepy: truck.map(withInjectLocations(__WEBPACK_IMPORTED_MODULE_0_shared_constants_locationTypes__["a" /* default */].CITY)),
  spetstehnika: truck.map(withInjectLocations(__WEBPACK_IMPORTED_MODULE_0_shared_constants_locationTypes__["a" /* default */].CITY)),
  'vodnyi-transport': truck.map(withInjectLocations(__WEBPACK_IMPORTED_MODULE_0_shared_constants_locationTypes__["a" /* default */].CITY))
};

var SPARES = [
  // {
  //   title: 'Запчасти',
  //   route: '/zapchasti/',
  // },
  // {
  //   title: 'Новые',
  //   route: '/zapchasti?isNew=1',
  // },
  // {
  //   title: 'Б/y',
  //   route: '/zapchasti?isUsed=1',
  // },
  // {
  //   title: 'Каталог компаний',
  //   route: '/katalog-kompaniy/',
  // },
];

var LINKS = {
  HEADER: HEADER,
  FOOTER: FOOTER,
  PROFILE: PROFILE,
  SEARCH: SEARCH,
  SPARES: SPARES,
  AVTOSALONS_LINKS: AVTOSALONS_LINKS,
  FIRMS_TAGS_LINKS: FIRMS_TAGS_LINKS,
  SPARES_LINKS: SPARES_LINKS,
  moto: moto
};

/* harmony default export */ __webpack_exports__["a"] = (LINKS);

/***/ }),

/***/ 1249:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(1240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Loader_css__ = __webpack_require__(1307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Loader_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__Loader_css__);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();







var _ref = _jsx('i', {
  className: 'fa fa-2x fa-spinner fa-spin'
});

function Loader(props) {
  var isLoading = props.isLoading,
      children = props.children,
      isHidden = props.isHidden,
      className = props.className,
      loaderElement = props.loaderElement,
      defaultClassName = props.defaultClassName;


  if (isHidden) {
    return null;
  }

  return isLoading ? _jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_3_classnames___default.a(__WEBPACK_IMPORTED_MODULE_4__Loader_css___default.a.root, className)
  }, void 0, loaderElement || _ref) : _jsx('div', {
    className: defaultClassName
  }, void 0, children);
}

Loader.defaultProps = {
  isLoading: false,
  isHidden: false,
  children: '',
  className: '',
  defaultClassName: '',
  loaderElement: null
};


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_4__Loader_css___default.a)(Loader));

/***/ }),

/***/ 1250:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var Modal = function (_React$Component) {
  _inherits(Modal, _React$Component);

  function Modal(props) {
    _classCallCheck(this, Modal);

    // Create a div that we'll render the modal into. Because each
    // Modal component has its own element, we can render multiple
    // modal components into the modal container.
    var _this = _possibleConstructorReturn(this, (Modal.__proto__ || Object.getPrototypeOf(Modal)).call(this, props));

    _this.el = document.createElement('div');
    return _this;
  }

  _createClass(Modal, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      // Append the element into the DOM on mount. We'll render
      // into the modal container element (see the HTML tab).
      var modalRoot = document.getElementById('modal');
      modalRoot.appendChild(this.el);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      // Remove the element from the DOM when we unmount
      var modalRoot = document.getElementById('modal');
      modalRoot.removeChild(this.el);
    }
  }, {
    key: 'render',
    value: function render() {
      // Use a portal to render the children into the element
      return __WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.createPortal(
      // Any valid React child: JSX, strings, arrays, etc.
      this.props.children,
      // A DOM element
      this.el);
    }
  }]);

  return Modal;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (Modal);

/***/ }),

/***/ 1251:
/***/ (function(module, exports) {

function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    "default": e
  };
}
module.exports = _interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 1252:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getCustomParams;
/* harmony export (immutable) */ __webpack_exports__["b"] = paramsToSeoData;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_shared_modules_subjectiveText_allText__ = __webpack_require__(309);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_shared_modules__ = __webpack_require__(103);
/* eslint-disable no-param-reassign */



var avaliableKeyFields = ['make', 'model', 'city', 'generation', 'gearbox', 'engine', 'body', 'drive',
// 'driveSelected',
'isNew', 'year',
// 'makeTranslate',
'country',
// 'location'
'transport', 'transportType', 'transporttype'];

/**
 * Make pathes to compare and find needed function.
 * Like: body_engine_isnew
 * @param {object} inputParams 
 * @param {object} seoData 
 * @returns {object}
 */
function findSeoPath(inputParams, seoData) {
  var inputKeys = avaliableKeyFields.filter(function (k) {
    return inputParams[k] !== null && inputParams[k] !== undefined && inputParams[k] !== '';
  });

  var pathInput = inputKeys.sort().join('_').toLowerCase();

  var seoDataKeys = Object.keys(seoData || {});

  for (var i = 0, l = seoDataKeys.length; i < l; i += 1) {
    var path = seoDataKeys[i].split('_').sort().join('_');
    var pathLc = path.toLowerCase();
    var func = seoData[pathLc] || seoData[path];
    if (path === pathInput && func) {
      return { path: path, func: func };
    }
  }
  return {};
}

function getCustomParams(data, t) {
  var city = data.city,
      country = data.country,
      engine = data.engine,
      gearbox = data.gearbox;


  var locale = t('locale');
  var buy = t('Купить');
  var newTxt = t('Новый');

  var newTxtLCase = newTxt.toLowerCase();
  var buyLCase = buy.toLowerCase();

  var inCity = __WEBPACK_IMPORTED_MODULE_0_shared_modules_subjectiveText_allText__["g" /* sity */][city] ? ' ' + __WEBPACK_IMPORTED_MODULE_1_shared_modules__["c" /* buildInGenitiveCityHeader */](__WEBPACK_IMPORTED_MODULE_0_shared_modules_subjectiveText_allText__["g" /* sity */][city][locale].genitive) : __WEBPACK_IMPORTED_MODULE_1_shared_modules__["c" /* buildInGenitiveCityHeader */](t(city) || city) || '';

  var fromCountry = country && country.is_country ? country.from[locale] : '';
  var countryTitle = country && country.is_country ? t(country.title) : '';

  var customEngineAlt = engine;
  var customEngine = engine;
  var customEngineShort = engine;
  var customGearbox = gearbox;
  var customGearboxLCase = gearbox && gearbox.toLowerCase();

  if (engine in __WEBPACK_IMPORTED_MODULE_0_shared_modules_subjectiveText_allText__["b" /* engines */] && __WEBPACK_IMPORTED_MODULE_0_shared_modules_subjectiveText_allText__["b" /* engines */][engine][locale]) {
    customEngineAlt = __WEBPACK_IMPORTED_MODULE_0_shared_modules_subjectiveText_allText__["b" /* engines */][engine][locale].altTitle;
    customEngine = __WEBPACK_IMPORTED_MODULE_0_shared_modules_subjectiveText_allText__["b" /* engines */][engine][locale].title;
    customEngineShort = __WEBPACK_IMPORTED_MODULE_0_shared_modules_subjectiveText_allText__["b" /* engines */][engine][locale].short;
  }

  if (gearbox in __WEBPACK_IMPORTED_MODULE_0_shared_modules_subjectiveText_allText__["c" /* gearboxes */] && __WEBPACK_IMPORTED_MODULE_0_shared_modules_subjectiveText_allText__["c" /* gearboxes */][gearbox][locale]) {
    customGearbox = __WEBPACK_IMPORTED_MODULE_0_shared_modules_subjectiveText_allText__["c" /* gearboxes */][gearbox][locale].title;
    customGearboxLCase = customGearbox.toLowerCase();
  }
  var makeLocale = 'test'; // make[`${t('locale')}_title`] ? make[`${t('locale')}_title`] : make.title;

  return {
    buy: buy,
    newTxt: newTxt,
    newTxtLCase: newTxtLCase,
    buyLCase: buyLCase,

    customEngineShort: customEngineShort,
    customEngineAlt: customEngineAlt,
    customEngine: customEngine,

    customGearbox: customGearbox,
    customGearboxLCase: customGearboxLCase,

    inCity: (inCity || '').trim(),
    fromCountry: (fromCountry || '').trim(),
    country: countryTitle,
    locale: locale,
    t: t,
    makeLocale: makeLocale
  };
}

/**
 * Parse input params and retrurn Object with 
 * @param {object} data 
 * @param {object} pathes 
 * @param {funciton} t 
 * @returns {object} { head: 'text for H1', title: 'text for eta Title', ... }
 */
function paramsToSeoData(data, pathes, t) {
  try {
    var locale = t('locale');
    var isNew = !!data.isNew;
    if (data.transportCategoryTitleOrigin) {
      var subCategory = data.transportCategoryTitleOrigin;
      var subCategoryObject = __WEBPACK_IMPORTED_MODULE_0_shared_modules_subjectiveText_allText__["a" /* crutch */](isNew)[subCategory] || {};

      if (subCategoryObject[locale]) {
        var obj = subCategoryObject[locale];
        data.subCategory = subCategory || '';
        data.subCategoryHeader = obj.transportHeader || '';
        data.subCategoryPluralGenitive = obj.pluralGenitiveTransport || '';
        data.subCategoryPlural = obj.pluralTransport || '';
      }
    }

    if (data.transportTitleOrigin) {
      var transport = __WEBPACK_IMPORTED_MODULE_0_shared_modules_subjectiveText_allText__["a" /* crutch */](isNew)[data.transportTitleOrigin] || {};

      if (transport[locale]) {
        var _obj = transport[locale];
        data.category = data.transportTitleOrigin || '';
        data.categoryPluralGenitive = _obj.pluralGenitive || '';
        data.categoryPlural = _obj.plural || '';
      }
    }

    data.transportType = data.subCategoryHeader || data.category;
    data.transportTypePlural = data.subCategoryPlural || data.categoryPlural;
    data.transportTypePluralGenitive = data.subCategoryPluralGenitive || data.categoryPluralGenitive;

    var _findSeoPath = findSeoPath(data, pathes),
        path = _findSeoPath.path,
        func = _findSeoPath.func;

    // ...
    // Here can be added some additional SEO searching by API or something else.
    // We have `path` (brand_model_...) and can use it.
    // ...


    if (path) {
      var customParams = getCustomParams(data, t);
      var res = func(data, customParams);
      var lc = customParams.locale;

      return {
        title: res['title_' + lc] || res.title,
        description: res['description_' + lc] || res.description,
        header: res['header_' + lc] || res.header
      };
    }
    return {};
  } catch (err) {}
  return {};
}

/***/ }),

/***/ 1253:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var NOTIFICATION_TYPES = {
  ERROR: 'ERROR',
  SUCCESS: 'SUCCESS',
  WARNING: 'WARNING',
  INFO: 'INFO'
};

/* harmony default export */ __webpack_exports__["a"] = (NOTIFICATION_TYPES);

/***/ }),

/***/ 1254:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// CONCATENATED MODULE: ./src/shared/helpers/seoTextFinder/seoTemplates/search/avto/templates.js
var avtoPathesHead = {
  city: function city(data, p) {
    return {
      header: p.buy + ' \u0430\u0432\u0442\u043E \u0431\u0443 ' + p.inCity,

      title: '\u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440 ' + p.t(data.city) + '. \u041A\u0443\u043F\u0438\u0442\u044C \u0430\u0432\u0442\u043E \u0431\u0443 ' + p.inCity + ' \u0441 \u043F\u0440\u043E\u0431\u0435\u0433\u043E\u043C \u043D\u0430 \u0430\u0432\u0442\u043E\u0440\u044B\u043D\u043A\u0435',
      title_uk: '\u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440 ' + p.t(data.city) + '. \u041A\u0443\u043F\u0438\u0442\u0438 \u0430\u0432\u0442\u043E \u0431\u0443 ' + p.inCity + ' \u0437 \u043F\u0440\u043E\u0431\u0456\u0433\u043E\u043C \u043D\u0430 \u0430\u0432\u0442\u043E\u0440\u0438\u043D\u043A\u0443',

      description: '\u041F\u0440\u043E\u0434\u0430\u0436\u0430 \u0431\u0443 \u0430\u0432\u0442\u043E \uD83D\uDE97 ' + p.inCity + '. \u041A\u0443\u043F\u0438\u0442\u044C \u0430\u0432\u0442\u043E \u0431\u0443 ' + p.inCity + ' \u0441 \u043F\u0440\u043E\u0431\u0435\u0433\u043E\u043C \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0439. \u0412\u044B\u0433\u043E\u0434\u043D\u0430\u044F \u0446\u0435\u043D\u0430. \u041F\u0440\u043E\u0432\u0435\u0440\u0435\u043D\u043D\u044B\u0435 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u044B',
      description_uk: '\u041F\u0440\u043E\u0434\u0430\u0436 \u0431\u0443 \u0430\u0432\u0442\u043E \uD83D\uDE97 ' + p.inCity + '. \u041A\u0443\u043F\u0438\u0442\u0438 \u0430\u0432\u0442\u043E \u0431\u0443 ' + p.inCity + ' \u0437 \u043F\u0440\u043E\u0431\u0456\u0433\u043E\u043C \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u044C. \u0412\u0438\u0433\u0456\u0434\u043D\u0430 \u0446\u0456\u043D\u0430. \u041F\u0435\u0440\u0435\u0432\u0456\u0440\u0435\u043D\u0456 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u0456'
    };
  },

  make: function make(data, p) {
    return {
      title: '\u041A\u0443\u043F\u0438\u0442\u044C ' + data.make + ' \u0431\u0443 \u0432 \u0423\u043A\u0440\u0430\u0438\u043D\u0435. \u041F\u0440\u043E\u0434\u0430\u0436\u0430 ' + data.make + ' \u0441 \u043F\u0440\u043E\u0431\u0435\u0433\u043E\u043C. \u0426\u0435\u043D\u0430 \u0430\u0432\u0442\u043E, \u0444\u043E\u0442\u043E - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',
      title_uk: '\u041A\u0443\u043F\u0438\u0442\u0438 ' + data.make + ' \u0431\u0443 \u0432 \u0423\u043A\u0440\u0430\u0457\u043D\u0456. \u041F\u0440\u043E\u0434\u0430\u0436 ' + data.make + ' \u0437 \u043F\u0440\u043E\u0431\u0456\u0433\u043E\u043C. \u0426\u0456\u043D\u0430 \u0430\u0432\u0442\u043E, \u0444\u043E\u0442\u043E - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',

      description: '\u041A\u0443\u043F\u0438\u0442\u044C ' + data.make + ' \u0431\u0443 \u0432 \u0423\u043A\u0440\u0430\u0438\u043D\u0435. \u041F\u043E\u0434\u0435\u0440\u0436\u0430\u043D\u043D\u044B\u0435 \u043C\u0430\u0448\u0438\u043D\u044B ' + data.make + ' \u0441 \u043F\u0440\u043E\u0431\u0435\u0433\u043E\u043C \u0432 \u043F\u0440\u043E\u0434\u0430\u0436\u0435 \u043D\u0430 \u0430\u0432\u0442\u043E \u0431\u0430\u0437\u0430\u0440\u0435. \u0421\u0440\u0430\u0432\u043D\u0438\u0442\u044C \u0446\u0435\u043D\u044B \u043D\u0430 \u0430\u0432\u0442\u043E\u043C\u043E\u0431\u0438\u043B\u0438, \u043F\u043E\u0441\u043C\u043E\u0442\u0440\u0435\u0442\u044C \u0444\u043E\u0442\u043E, \u0445\u0430\u0440\u0430\u043A\u0442\u0435\u0440\u0438\u0441\u0442\u0438\u043A\u0438, \u043A\u043E\u043C\u043F\u043B\u0435\u043A\u0442\u0430\u0446\u0438\u044E \u043C\u043E\u0434\u0435\u043B\u0438. \u0412\u0435\u0441\u044C \u043C\u043E\u0434\u0435\u043B\u044C\u043D\u044B\u0439 \u0440\u044F\u0434 ' + data.make + ' \u0432 \u043A\u0430\u0442\u0430\u043B\u043E\u0433\u0435 \u043D\u0430 \u0441\u0430\u0439\u0442\u0435 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',
      description_uk: '\u041A\u0443\u043F\u0438\u0442\u0438 ' + data.make + ' \u0431\u0443 \u0432 \u0423\u043A\u0440\u0430\u0457\u043D\u0456. \u0421\u0442\u0430\u0440\u0456 \u043C\u0430\u0448\u0438\u043D\u0438 ' + data.make + ' \u0437 \u043F\u0440\u043E\u0431\u0456\u0433\u043E\u043C \u0432 \u043F\u0440\u043E\u0434\u0430\u0436\u0443 \u043D\u0430 \u0430\u0432\u0442\u043E \u0431\u0430\u0437\u0430\u0440\u0456. \u041F\u043E\u0440\u0456\u0432\u043D\u044F\u0442\u0438 \u0446\u0456\u043D\u0438 \u043D\u0430 \u0430\u0432\u0442\u043E\u043C\u043E\u0431\u0456\u043B\u0456, \u043F\u043E\u0434\u0438\u0432\u0438\u0442\u0438\u0441\u044F \u0444\u043E\u0442\u043E, \u0445\u0430\u0440\u0430\u043A\u0442\u0435\u0440\u0438\u0441\u0442\u0438\u043A\u0438, \u043A\u043E\u043C\u043F\u043B\u0435\u043A\u0442\u0430\u0446\u0456\u044E \u043C\u043E\u0434\u0435\u043B\u0456. \u0412\u0435\u0441\u044C \u043C\u043E\u0434\u0435\u043B\u044C\u043D\u0438\u0439 \u0440\u044F\u0434 ' + data.make + ' \u0432 \u043A\u0430\u0442\u0430\u043B\u043E\u0437\u0456 \u043D\u0430 \u0441\u0430\u0439\u0442\u0456 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440'
    };
  },

  country: function country(data, p) {
    return {
      header: p.buy + ' \u0430\u0432\u0442\u043E \u0431\u0443 ' + p.fromCountry,

      title: '\u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440 ' + p.country + '. \u041A\u0443\u043F\u0438\u0442\u044C \u0430\u0432\u0442\u043E \u0431\u0443 ' + p.fromCountry + ' \u0441 \u043F\u0440\u043E\u0431\u0435\u0433\u043E\u043C \u043D\u0430 \u0430\u0432\u0442\u043E\u0440\u044B\u043D\u043A\u0435',
      title_uk: '\u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440 ' + p.country + '. \u041A\u0443\u043F\u0438\u0442\u0438 \u0430\u0432\u0442\u043E \u0431\u0443 ' + p.fromCountry + ' \u0437 \u043F\u0440\u043E\u0431\u0456\u0433\u043E\u043C \u043D\u0430 \u0430\u0432\u0442\u043E\u0440\u0438\u043D\u043A\u0443',

      description: '\u041F\u0440\u043E\u0434\u0430\u0436\u0430 \u0431\u0443 \u0430\u0432\u0442\u043E \u0432 ' + p.country + '. \u041A\u0443\u043F\u0438\u0442\u044C \u0430\u0432\u0442\u043E \u0431\u0443 \u0432 ' + p.country + ' \u0441 \u043F\u0440\u043E\u0431\u0435\u0433\u043E\u043C \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0439. \u0412\u044B\u0433\u043E\u0434\u043D\u0430\u044F \u0446\u0435\u043D\u0430. \u041F\u0440\u043E\u0432\u0435\u0440\u0435\u043D\u043D\u044B\u0435 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u044B',
      description_uk: '\u041F\u0440\u043E\u0434\u0430\u0436 \u0431\u0443 \u0430\u0432\u0442\u043E \u0432 ' + p.country + '. \u041A\u0443\u043F\u0438\u0442\u0438 \u0430\u0432\u0442\u043E \u0431\u0443 \u0432 ' + p.country + ' \u0437 \u043F\u0440\u043E\u0431\u0456\u0433\u043E\u043C \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u044C. \u0412\u0438\u0433\u0456\u0434\u043D\u0430 \u0446\u0456\u043D\u0430. \u041F\u0435\u0440\u0435\u0432\u0456\u0440\u0435\u043D\u0456 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u0456'
    };
  },

  engine: function engine(data, p) {
    return {
      header: p.buy + ' ' + p.t(data.engine).toLowerCase() + ' ' + p.t('автомобиль') + ' \u0431\u0443'
    };
  },

  body: function body(data, p) {
    return {
      title: p.buy + ' \u0431\u0443 ' + p.t(data.body) + ' ' + p.t('в Украине') + ' \u2013 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',
      header: p.buy + ' ' + p.t(data.body) + ' \u0431\u0443 ' + p.t('в Украине'),

      description: p.buy + ' \u0431\u0443 ' + p.t(data.body) + ' \u0441 \u043F\u0440\u043E\u0431\u0435\u0433\u043E\u043C \u0432 \u0423\u043A\u0440\u0430\u0438\u043D\u0435. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043C\u0430\u0440\u043E\u043A \u0438 \u043C\u043E\u0434\u0435\u043B\u0435\u0439. \u0421\u0440\u0430\u0432\u043D\u0438\u0442\u044C \u0446\u0435\u043D\u044B, \u043F\u043E\u0441\u043C\u043E\u0442\u0440\u0435\u0442\u044C \u0444\u043E\u0442\u043E \u043D\u0430 \u0441\u0430\u0439\u0442\u0435 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',
      description_uk: p.buy + ' \u0431\u0443 ' + p.t(data.body) + ' \u0437 \u043F\u0440\u043E\u0431\u0456\u0433\u043E\u043C \u0432 \u0423\u043A\u0440\u0430\u0457\u043D\u0456. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043C\u0430\u0440\u043E\u043A \u0456 \u043C\u043E\u0434\u0435\u043B\u0435\u0439. \u041F\u043E\u0440\u0456\u0432\u043D\u044F\u0442\u0438 \u0446\u0456\u043D\u0438, \u043F\u043E\u0434\u0438\u0432\u0438\u0442\u0438\u0441\u044F \u0444\u043E\u0442\u043E \u043D\u0430 \u0441\u0430\u0439\u0442\u0456 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440'
    };
  },

  gearbox: function gearbox(data, p) {
    return { header: p.buy + ' \u0430\u0432\u0442\u043E ' + p.customGearbox + ' \u0431\u0443' };
  },

  year: function year(data, p) {
    return {
      title: '\u0410\u0432\u0442\u043E\u043C\u043E\u0431\u0438\u043B\u0438 ' + data.year + ' \u0433\u043E\u0434\u0430 \u043A\u0443\u043F\u0438\u0442\u044C \u0432 \u0423\u043A\u0440\u0430\u0438\u043D\u0435 - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',
      title_uk: '\u0410\u0432\u0442\u043E\u043C\u043E\u0431\u0456\u043B\u0456 ' + data.year + ' \u0440\u043E\u043A\u0443 \u043A\u0443\u043F\u0438\u0442\u0438 \u0432 \u0423\u043A\u0440\u0430\u0457\u043D\u0456 - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',

      description: '\u041F\u0440\u043E\u0434\u0430\u0436\u0430 \u0430\u0432\u0442\u043E ' + data.year + ' \u0433\u043E\u0434\u0430 \u0431\u0443 \u0432 \u0423\u043A\u0440\u0430\u0438\u043D\u0435. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043C\u0430\u0440\u043E\u043A \u0438 \u043C\u043E\u0434\u0435\u043B\u0435\u0439 \u0430\u0432\u0442\u043E\u043C\u043E\u0431\u0438\u043B\u0435\u0439. \u0421\u0440\u0430\u0432\u043D\u0438\u0442\u044C \u0446\u0435\u043D\u044B, \u043F\u043E\u0441\u043C\u043E\u0442\u0440\u0435\u0442\u044C \u0444\u043E\u0442\u043E \u0432 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u044F\u0445 \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',
      description_uk: '\u041F\u0440\u043E\u0434\u0430\u0436 \u0430\u0432\u0442\u043E ' + data.year + ' \u0440\u043E\u043A\u0443 \u0431\u0443 \u0432 \u0423\u043A\u0440\u0430\u0457\u043D\u0456. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043C\u0430\u0440\u043E\u043A \u0456 \u043C\u043E\u0434\u0435\u043B\u0435\u0439 \u0430\u0432\u0442\u043E\u043C\u043E\u0431\u0456\u043B\u0456\u0432. \u041F\u043E\u0440\u0456\u0432\u043D\u044F\u0442\u0438 \u0446\u0456\u043D\u0438, \u043F\u043E\u0434\u0438\u0432\u0438\u0442\u0438\u0441\u044F \u0444\u043E\u0442\u043E \u0432 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u043D\u044F\u0445 \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440'
    };
  },

  // --- //

  gearboxCity: function gearboxCity(data, p) {
    return { header: p.buy + ' \u0430\u0432\u0442\u043E ' + p.customGearbox.toLowerCase() + ' \u0431\u0443 ' + p.t(data.city) };
  },

  cityEngine: function cityEngine(data, p) {
    return { header: p.t(data.engine) + ' \u0430\u0432\u0442\u043E \u0431\u0443 ' + p.buyLCase + ' ' + p.inCity };
  },

  makeModel: function makeModel(data, p) {
    return {
      title: '\u041A\u0443\u043F\u0438\u0442\u044C ' + data.make + ' ' + data.model + ' \u0432 \u0423\u043A\u0440\u0430\u0438\u043D\u0435. \u041F\u0440\u043E\u0434\u0430\u0436\u0430 ' + data.make + ' ' + data.model + ' \u0431\u0443. \u0426\u0435\u043D\u0430 \u0430\u0432\u0442\u043E - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',
      title_uk: '\u041A\u0443\u043F\u0438\u0442\u0438 ' + data.make + ' ' + data.model + ' \u0432 \u0423\u043A\u0440\u0430\u0457\u043D\u0456. \u041F\u0440\u043E\u0434\u0430\u0436 ' + data.make + ' ' + data.model + ' \u0431\u0443. \u0426\u0456\u043D\u0430 \u0430\u0432\u0442\u043E - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',

      description: '\u041A\u0443\u043F\u0438\u0442\u044C ' + data.make + ' ' + data.model + ' \u0431\u0443 \u0432 \u0423\u043A\u0440\u0430\u0438\u043D\u0435. \u0412 \u043F\u0440\u043E\u0434\u0430\u0436\u0435 \u043F\u043E\u0434\u0435\u0440\u0436\u0430\u043D\u043D\u044B\u0435 \u043C\u0430\u0448\u0438\u043D\u044B ' + data.make + ' ' + data.model + ' \u0441 \u043F\u0440\u043E\u0431\u0435\u0433\u043E\u043C \u043D\u0430 \u0430\u0432\u0442\u043E \u0440\u044B\u043D\u043A\u0435. \u0421\u0440\u0430\u0432\u043D\u0438\u0442\u044C \u0446\u0435\u043D\u044B \u043D\u0430 \u0430\u0432\u0442\u043E\u043C\u043E\u0431\u0438\u043B\u0438, \u043F\u043E\u0441\u043C\u043E\u0442\u0440\u0435\u0442\u044C \u0444\u043E\u0442\u043E, \u043E\u0431\u0437\u043E\u0440 \u043A\u043E\u043C\u043F\u043B\u0435\u043A\u0442\u0430\u0446\u0438\u0438 \u0438 \u0445\u0430\u0440\u0430\u043A\u0442\u0435\u0440\u0438\u0441\u0442\u0438\u043A \u0430\u0432\u0442\u043E\u043C\u043E\u0431\u0438\u043B\u0435\u0439 \u043D\u0430 \u0441\u0430\u0439\u0442\u0435 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',
      description_uk: '\u041A\u0443\u043F\u0438\u0442\u0438 ' + data.make + ' ' + data.model + ' \u0431\u0443 \u0432 \u0423\u043A\u0440\u0430\u0457\u043D\u0456. \u0423 \u043F\u0440\u043E\u0434\u0430\u0436\u0443 \u0441\u0442\u0430\u0440\u0456 \u043C\u0430\u0448\u0438\u043D\u0438 ' + data.make + ' ' + data.model + ' \u0437 \u043F\u0440\u043E\u0431\u0456\u0433\u043E\u043C \u043D\u0430 \u0430\u0432\u0442\u043E \u0440\u0438\u043D\u043A\u0443. \u041F\u043E\u0440\u0456\u0432\u043D\u044F\u0442\u0438 \u0446\u0456\u043D\u0438 \u043D\u0430 \u0430\u0432\u0442\u043E\u043C\u043E\u0431\u0456\u043B\u0456, \u043F\u043E\u0434\u0438\u0432\u0438\u0442\u0438\u0441\u044F \u0444\u043E\u0442\u043E, \u043E\u0433\u043B\u044F\u0434 \u043A\u043E\u043C\u043F\u043B\u0435\u043A\u0442\u0430\u0446\u0456\u0457 \u0456 \u0445\u0430\u0440\u0430\u043A\u0442\u0435\u0440\u0438\u0441\u0442\u0438\u043A \u0430\u0432\u0442\u043E\u043C\u043E\u0431\u0456\u043B\u0456\u0432 \u043D\u0430 \u0441\u0430\u0439\u0442\u0456 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440'
    };
  },

  makeCity: function makeCity(data, p) {
    return {
      title: '\u041A\u0443\u043F\u0438\u0442\u044C ' + data.make + ' ' + p.inCity + '. \u041F\u0440\u043E\u0434\u0430\u0436\u0430 ' + data.make + ' \u0431\u0443 ' + p.t(data.city) + '. \u0426\u0435\u043D\u044B \u043D\u0430 \u0430\u0432\u0442\u043E - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',
      title_uk: '\u041A\u0443\u043F\u0438\u0442\u0438 ' + data.make + ' ' + p.inCity + '. \u041F\u0440\u043E\u0434\u0430\u0436 ' + data.make + ' \u0431\u0443 ' + p.t(data.city) + '. \u0426\u0456\u043D\u0438 \u043D\u0430 \u0430\u0432\u0442\u043E - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',

      description: '\u041A\u0443\u043F\u0438\u0442\u044C \u0430\u0432\u0442\u043E\u043C\u043E\u0431\u0438\u043B\u044C ' + data.make + ' \u0431\u0443 ' + p.inCity + '. \u041F\u0440\u043E\u0434\u0430\u0436\u0430 \u0430\u0432\u0442\u043E ' + data.make + ' \u0441 \u043F\u0440\u043E\u0431\u0435\u0433\u043E\u043C ' + p.inCity + '. \u0426\u0435\u043D\u044B \u043D\u0430 \u043F\u043E\u0434\u0435\u0440\u0436\u0430\u043D\u043D\u044B\u0435 \u043D\u0430 \u043C\u0430\u0448\u0438\u043D\u044B, \u0444\u043E\u0442\u043E, \u0445\u0430\u0440\u0430\u043A\u0442\u0435\u0440\u0438\u0441\u0442\u0438\u043A\u0438 \u0438 \u043A\u043E\u043C\u043F\u043B\u0435\u043A\u0442\u0430\u0446\u0438\u044E \u0430\u0432\u0442\u043E\u043C\u043E\u0431\u0438\u043B\u0435\u0439 \u043C\u0430\u0440\u043A\u0438 \u0441\u043C\u043E\u0442\u0440\u0438\u0442\u0435 \u0432 \u043A\u0430\u0442\u0430\u043B\u043E\u0433\u0435 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0439 \u043D\u0430 \u0441\u0430\u0439\u0442\u0435 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',
      description_uk: '\u041A\u0443\u043F\u0438\u0442\u0438 \u0430\u0432\u0442\u043E\u043C\u043E\u0431\u0456\u043B\u044C ' + data.make + ' \u0431\u0443 ' + p.inCity + '. \u041F\u0440\u043E\u0434\u0430\u0436 \u0430\u0432\u0442\u043E ' + data.make + ' \u0437 \u043F\u0440\u043E\u0431\u0456\u0433\u043E\u043C ' + p.inCity + '. \u0426\u0456\u043D\u0438 \u043D\u0430 \u0441\u0442\u0430\u0440\u0456 \u043D\u0430 \u043C\u0430\u0448\u0438\u043D\u0438, \u0444\u043E\u0442\u043E, \u0445\u0430\u0440\u0430\u043A\u0442\u0435\u0440\u0438\u0441\u0442\u0438\u043A\u0438 \u0456 \u043A\u043E\u043C\u043F\u043B\u0435\u043A\u0442\u0430\u0446\u0456\u044E \u0430\u0432\u0442\u043E\u043C\u043E\u0431\u0456\u043B\u0456\u0432 \u043C\u0430\u0440\u043A\u0438 \u0434\u0438\u0432\u0456\u0442\u044C\u0441\u044F \u0432 \u043A\u0430\u0442\u0430\u043B\u043E\u0437\u0456 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u044C \u043D\u0430 \u0441\u0430\u0439\u0442\u0456 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440'
    };
  },

  makeCountry: function makeCountry(data, p) {
    return {
      title: '\u041A\u0443\u043F\u0438\u0442\u044C ' + data.make + ' ' + p.fromCountry + '. \u041F\u0440\u043E\u0434\u0430\u0436\u0430 ' + data.make + ' \u0431\u0443 ' + p.fromCountry + ' \u0432 \u0423\u043A\u0440\u0430\u0438\u043D\u0435. \u0426\u0435\u043D\u0430 \u0430\u0432\u0442\u043E - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',
      title_uk: '\u041A\u0443\u043F\u0438\u0442\u0438 ' + data.make + ' ' + p.fromCountry + '. \u041F\u0440\u043E\u0434\u0430\u0436 ' + data.make + ' \u0431\u0443 ' + p.fromCountry + ' \u0432 \u0423\u043A\u0440\u0430\u0457\u043D\u0456. \u0426\u0456\u043D\u0430 \u0430\u0432\u0442\u043E - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',

      description: '\u041A\u0443\u043F\u0438\u0442\u044C \u0430\u0432\u0442\u043E\u043C\u043E\u0431\u0438\u043B\u044C ' + data.make + ' \u0431\u0443 ' + p.fromCountry + '. \u041F\u0440\u043E\u0434\u0430\u0436\u0430 \u0430\u0432\u0442\u043E ' + data.make + ' \u0441 \u043F\u0440\u043E\u0431\u0435\u0433\u043E\u043C \u043F\u0440\u0438\u0433\u043D\u0430\u043D\u043D\u044B\u0445 ' + p.fromCountry + ' \u0432 \u0423\u043A\u0440\u0430\u0438\u043D\u0443. \u0421\u0440\u0430\u0432\u043D\u0438\u0442\u044C \u0446\u0435\u043D\u044B \u043D\u0430 \u043F\u043E\u0434\u0435\u0440\u0436\u0430\u043D\u043D\u044B\u0435 \u043C\u0430\u0448\u0438\u043D\u044B, \u043F\u043E\u0441\u043C\u043E\u0442\u0440\u0435\u0442\u044C \u0444\u043E\u0442\u043E, \u043E\u0431\u0437\u043E\u0440 \u0445\u0430\u0440\u0430\u043A\u0442\u0435\u0440\u0438\u0441\u0442\u0438\u043A \u0438 \u043A\u043E\u043C\u043F\u043B\u0435\u043A\u0442\u0430\u0446\u0438\u0438 \u0430\u0432\u0442\u043E\u043C\u043E\u0431\u0438\u043B\u0435\u0439 \u043D\u0430 \u0441\u0430\u0439\u0442\u0435 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',
      description_uk: '\u041A\u0443\u043F\u0438\u0442\u0438 \u0430\u0432\u0442\u043E\u043C\u043E\u0431\u0456\u043B\u044C ' + data.make + ' \u0431\u0443 ' + p.fromCountry + '. \u041F\u0440\u043E\u0434\u0430\u0436 \u0430\u0432\u0442\u043E ' + data.make + ' \u0437 \u043F\u0440\u043E\u0431\u0456\u0433\u043E\u043C \u043F\u0440\u0438\u0432\u0435\u0437\u0435\u043D\u0456 ' + p.fromCountry + ' \u0432 \u0423\u043A\u0440\u0430\u0457\u043D\u0456. \u041F\u043E\u0440\u0456\u0432\u043D\u044F\u0442\u0438 \u0446\u0456\u043D\u0438 \u043D\u0430 \u0441\u0442\u0430\u0440\u0456 \u043C\u0430\u0448\u0438\u043D\u0438, \u043F\u043E\u0434\u0438\u0432\u0438\u0442\u0438\u0441\u044F \u0444\u043E\u0442\u043E, \u043E\u0433\u043B\u044F\u0434 \u0445\u0430\u0440\u0430\u043A\u0442\u0435\u0440\u0438\u0441\u0442\u0438\u043A \u0456 \u043A\u043E\u043C\u043F\u043B\u0435\u043A\u0442\u0430\u0446\u0456\u0457 \u0430\u0432\u0442\u043E\u043C\u043E\u0431\u0456\u043B\u0456\u0432 \u043D\u0430 \u0441\u0430\u0439\u0442\u0456 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440'
    };
  },

  cityYear: function cityYear(data, p) {
    return {
      title: '\u0410\u0432\u0442\u043E\u043C\u043E\u0431\u0438\u043B\u0438 ' + data.year + ' \u0433\u043E\u0434\u0430 \u043A\u0443\u043F\u0438\u0442\u044C ' + p.inCity + ' - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',
      title_uk: '\u0410\u0432\u0442\u043E\u043C\u043E\u0431\u0456\u043B\u0456 ' + data.year + ' \u0440\u043E\u043A\u0443 \u043A\u0443\u043F\u0438\u0442\u0438 ' + p.inCity + ' - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',

      description: '\u041F\u0440\u043E\u0434\u0430\u0436\u0430 \u0430\u0432\u0442\u043E ' + data.year + ' \u0433\u043E\u0434\u0430 \u0431\u0443 ' + p.inCity + '. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043C\u0430\u0440\u043E\u043A \u0438 \u043C\u043E\u0434\u0435\u043B\u0435\u0439 \u0430\u0432\u0442\u043E\u043C\u043E\u0431\u0438\u043B\u0435\u0439. \u0421\u0440\u0430\u0432\u043D\u0438\u0442\u044C \u0446\u0435\u043D\u044B, \u043F\u043E\u0441\u043C\u043E\u0442\u0440\u0435\u0442\u044C \u0444\u043E\u0442\u043E \u0432 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u044F\u0445 \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',
      description_uk: '\u041F\u0440\u043E\u0434\u0430\u0436 \u0430\u0432\u0442\u043E ' + data.year + ' \u0440\u043E\u043A\u0443 \u0431\u0443 ' + p.inCity + '. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043C\u0430\u0440\u043E\u043A \u0456 \u043C\u043E\u0434\u0435\u043B\u0435\u0439 \u0430\u0432\u0442\u043E\u043C\u043E\u0431\u0456\u043B\u0456\u0432. \u041F\u043E\u0440\u0456\u0432\u043D\u044F\u0442\u0438 \u0446\u0456\u043D\u0438, \u043F\u043E\u0434\u0438\u0432\u0438\u0442\u0438\u0441\u044F \u0444\u043E\u0442\u043E \u0432 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u043D\u044F\u0445 \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440'
    };
  },

  bodyYear: function bodyYear(data, p) {
    return {
      header: p.buy + ' ' + p.t(data.body) + ' ' + data.year + ' \u0433\u043E\u0434\u0430',
      header_uk: p.buy + ' ' + p.t(data.body) + ' ' + data.year + ' \u0440\u043E\u043A\u0443',

      title: '\u041A\u0443\u043F\u0438\u0442\u044C ' + p.t(data.body) + ' ' + data.year + ' \u0433\u043E\u0434\u0430 \u0432 \u0423\u043A\u0440\u0430\u0438\u043D\u0435 \u2013 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',
      title_uk: '\u041A\u0443\u043F\u0438\u0442\u0438 ' + p.t(data.body) + ' ' + data.year + ' \u0440\u043E\u043A\u0443 \u0432 \u0423\u043A\u0440\u0430\u0457\u043D\u0456 \u2013 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',

      description: '\u041A\u0443\u043F\u0438\u0442\u044C ' + p.t(data.body) + ' ' + data.year + ' \u0433\u043E\u0434\u0430 \u0432 \u0423\u043A\u0440\u0430\u0438\u043D\u0435. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043C\u0430\u0440\u043E\u043A \u0438 \u043C\u043E\u0434\u0435\u043B\u0435\u0439. \u0421\u0440\u0430\u0432\u043D\u0438\u0442\u044C \u0446\u0435\u043D\u044B, \u043F\u043E\u0441\u043C\u043E\u0442\u0440\u0435\u0442\u044C \u0444\u043E\u0442\u043E \u043D\u0430 \u0441\u0430\u0439\u0442\u0435 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',
      description_uk: '\u041A\u0443\u043F\u0438\u0442\u0438 ' + p.t(data.body) + ' ' + data.year + ' \u0440\u043E\u043A\u0443 \u0432 \u0423\u043A\u0440\u0430\u0457\u043D\u0456. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043C\u0430\u0440\u043E\u043A \u0456 \u043C\u043E\u0434\u0435\u043B\u0435\u0439. \u041F\u043E\u0440\u0456\u0432\u043D\u044F\u0442\u0438 \u0446\u0456\u043D\u0438, \u043F\u043E\u0434\u0438\u0432\u0438\u0442\u0438\u0441\u044F \u0444\u043E\u0442\u043E \u043D\u0430 \u0441\u0430\u0439\u0442\u0456 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440'
    };
  },

  bodyIsnew: function bodyIsnew(data, p) {
    return {
      header: p.buy + ' ' + p.newTxtLCase + ' ' + p.t(data.body) + ' ' + p.t('в Украине'),
      title: p.buy + ' ' + p.newTxtLCase + ' ' + p.t(data.body) + ' ' + p.t('в Украине') + ' \u2013 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',

      description: '\u041A\u0443\u043F\u0438\u0442\u044C \u043D\u043E\u0432\u044B\u0439 ' + p.t(data.body) + ' \u0441 \u0441\u0430\u043B\u043E\u043D\u0430 \u0432 \u0423\u043A\u0440\u0430\u0438\u043D\u0435. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043C\u0430\u0440\u043E\u043A \u0438 \u043C\u043E\u0434\u0435\u043B\u0435\u0439. \u0421\u0440\u0430\u0432\u043D\u0438\u0442\u044C \u0446\u0435\u043D\u044B, \u043F\u043E\u0441\u043C\u043E\u0442\u0440\u0435\u0442\u044C \u0444\u043E\u0442\u043E \u043D\u0430 \u0441\u0430\u0439\u0442\u0435 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',
      description_uk: '\u041A\u0443\u043F\u0438\u0442\u0438 \u043D\u043E\u0432\u0438\u0439 ' + p.t(data.body) + ' \u0437 \u0441\u0430\u043B\u043E\u043D\u0443 \u0432 \u0423\u043A\u0440\u0430\u0457\u043D\u0456. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043C\u0430\u0440\u043E\u043A \u0456 \u043C\u043E\u0434\u0435\u043B\u0435\u0439. \u041F\u043E\u0440\u0456\u0432\u043D\u044F\u0442\u0438 \u0446\u0456\u043D\u0438, \u043F\u043E\u0434\u0438\u0432\u0438\u0442\u0438\u0441\u044F \u0444\u043E\u0442\u043E \u043D\u0430 \u0441\u0430\u0439\u0442\u0456 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440'
    };
  },
  // Купить кроссовер в Украине

  bodyCity: function bodyCity(data, p) {
    return {
      header: p.buy + ' ' + p.t(data.body).toLowerCase() + ' \u0431\u0443 ' + p.inCity,
      title: p.buy + ' \u0431\u0443 ' + p.t(data.body) + ' ' + p.inCity + ' \u2013 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',

      description: p.buy + ' \u0431\u0443 ' + p.t(data.body) + ' \u0441 \u043F\u0440\u043E\u0431\u0435\u0433\u043E\u043C ' + p.inCity + '. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043C\u0430\u0440\u043E\u043A \u0438 \u043C\u043E\u0434\u0435\u043B\u0435\u0439. \u0421\u0440\u0430\u0432\u043D\u0438\u0442\u044C \u0446\u0435\u043D\u044B, \u043F\u043E\u0441\u043C\u043E\u0442\u0440\u0435\u0442\u044C \u0444\u043E\u0442\u043E \u043D\u0430 \u0441\u0430\u0439\u0442\u0435 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',
      description_uk: p.buy + ' \u0431\u0443 ' + p.t(data.body) + ' \u0437 \u043F\u0440\u043E\u0431\u0456\u0433\u043E\u043C ' + p.inCity + '. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043C\u0430\u0440\u043E\u043A \u0456 \u043C\u043E\u0434\u0435\u043B\u0435\u0439. \u041F\u043E\u0440\u0456\u0432\u043D\u044F\u0442\u0438 \u0446\u0456\u043D\u0438, \u043F\u043E\u0434\u0438\u0432\u0438\u0442\u0438\u0441\u044F \u0444\u043E\u0442\u043E \u043D\u0430 \u0441\u0430\u0439\u0442\u0456 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440'
    };
  },
  // Купить кроссовер бу в Киеве

  gearboxIsnew: function gearboxIsnew(data, p) {
    return { header: p.buy + ' \u0430\u0432\u0442\u043E ' + p.customGearbox };
  },
  // Купить авто Механика

  makeBody: function makeBody(data, p) {
    return {
      header: data.make + ' ' + p.t(data.body) + ' \u0431\u0443 ' + p.buyLCase + ' ' + p.t('в Украине'),
      title: p.t(data.body) + ' ' + data.make + ' \u0431\u0443 ' + p.buyLCase + ' ' + p.t('в Украине') + ' \u2013 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',

      description: '\u041A\u0443\u043F\u0438\u0442\u044C ' + p.t(data.body) + ' ' + data.make + ' \u0431\u0443 \u0441 \u043F\u0440\u043E\u0431\u0435\u0433\u043E\u043C \u0432 \u0423\u043A\u0440\u0430\u0438\u043D\u0435. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043F\u043E\u0434\u0435\u0440\u0436\u0430\u043D\u043D\u044B\u0445 \u043C\u043E\u0434\u0435\u043B\u0435\u0439. \u0421\u0440\u0430\u0432\u043D\u0438\u0442\u044C \u0446\u0435\u043D\u044B, \u043F\u043E\u0441\u043C\u043E\u0442\u0440\u0435\u0442\u044C \u0444\u043E\u0442\u043E \u043D\u0430 \u0441\u0430\u0439\u0442\u0435 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',
      description_uk: '\u041A\u0443\u043F\u0438\u0442\u0438 ' + p.t(data.body) + ' ' + data.make + ' \u0431\u0443 \u0437 \u043F\u0440\u043E\u0431\u0456\u0433\u043E\u043C \u0432 \u0423\u043A\u0440\u0430\u0457\u043D\u0456. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u0443\u0436\u0438\u0432\u0430\u043D\u0438\u0445 \u043C\u043E\u0434\u0435\u043B\u0435\u0439. \u041F\u043E\u0440\u0456\u0432\u043D\u044F\u0442\u0438 \u0446\u0456\u043D\u0438, \u043F\u043E\u0434\u0438\u0432\u0438\u0442\u0438\u0441\u044F \u0444\u043E\u0442\u043E \u043D\u0430 \u0441\u0430\u0439\u0442\u0456 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440'
    };
  },
  // BMW Кросовер бу купить в Украине

  makeEngine: function makeEngine(data, p) {
    return { header: data.make + ' ' + p.t(data.engine).toLowerCase() + ' \u0431\u0443' };
  },
  // BMW дизель бу

  makeGearbox: function makeGearbox(data, p) {
    return {
      header: data.make + ' ' + p.customGearboxLCase + ' \u0431\u0443 ' + p.buyLCase + ' ' + p.t('в Украине')
    };
  },
  // BMW механика бу купить в Украине

  bodyIsnewMake: function bodyIsnewMake(data, p) {
    return {
      title: p.newTxt + ' ' + p.t(data.body) + ' ' + data.make + ' ' + p.buyLCase + ' ' + p.t('в Украине') + ' \u2013 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',
      header: p.buy + ' ' + p.newTxtLCase + ' ' + p.t(data.body) + ' ' + data.make,

      description: '\u041D\u043E\u0432\u044B\u0439 ' + p.t(data.body) + ' ' + data.make + ' \u043A\u0443\u043F\u0438\u0442\u044C \u0432 \u0423\u043A\u0440\u0430\u0438\u043D\u0435. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043C\u043E\u0434\u0435\u043B\u0435\u0439. \u0421\u0440\u0430\u0432\u043D\u0438\u0442\u044C \u0446\u0435\u043D\u044B, \u043F\u043E\u0441\u043C\u043E\u0442\u0440\u0435\u0442\u044C \u0444\u043E\u0442\u043E \u043D\u0430 \u0441\u0430\u0439\u0442\u0435 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',
      description_uk: '\u041D\u043E\u0432\u0438\u0439 ' + p.t(data.body) + ' ' + data.make + ' \u043A\u0443\u043F\u0438\u0442\u0438 \u0432 \u0423\u043A\u0440\u0430\u0457\u043D\u0456. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043C\u043E\u0434\u0435\u043B\u0435\u0439. \u041F\u043E\u0440\u0456\u0432\u043D\u044F\u0442\u0438 \u0446\u0456\u043D\u0438, \u043F\u043E\u0434\u0438\u0432\u0438\u0442\u0438\u0441\u044F \u0444\u043E\u0442\u043E \u043D\u0430 \u0441\u0430\u0439\u0442\u0456 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440'
    };
  },

  bodyIsnewYear: function bodyIsnewYear(data, p) {
    return {
      header: p.newTxt + ' ' + p.t(data.body) + ' ' + data.year + ' \u0433\u043E\u0434\u0430',
      header_uk: p.newTxt + ' ' + p.t(data.body) + ' ' + data.year + ' \u0440\u043E\u043A\u0443',

      title: '\u041D\u043E\u0432\u044B\u0439 ' + p.t(data.body) + ' ' + data.year + ' \u0433\u043E\u0434\u0430 \u043A\u0443\u043F\u0438\u0442\u044C ' + p.t('в Украине') + ' \u2013 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',
      title_uk: '\u041D\u043E\u0432\u0438\u0439 ' + p.t(data.body) + ' ' + data.year + ' \u0440\u043E\u043A\u0443 \u043A\u0443\u043F\u0438\u0442\u0438 ' + p.t('в Украине') + ' \u2013 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',

      description: '\u041D\u043E\u0432\u044B\u0439 ' + p.t(data.body) + ' ' + data.year + ' \u0433\u043E\u0434\u0430 \u043A\u0443\u043F\u0438\u0442\u044C \u0432 \u0423\u043A\u0440\u0430\u0438\u043D\u0435. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043C\u0430\u0440\u043E\u043A \u0438 \u043C\u043E\u0434\u0435\u043B\u0435\u0439. \u0421\u0440\u0430\u0432\u043D\u0438\u0442\u044C \u0446\u0435\u043D\u044B, \u043F\u043E\u0441\u043C\u043E\u0442\u0440\u0435\u0442\u044C \u0444\u043E\u0442\u043E \u043D\u0430 \u0441\u0430\u0439\u0442\u0435 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',
      description_uk: '\u041D\u043E\u0432\u0438\u0439 ' + p.t(data.body) + ' ' + data.year + ' \u0440\u043E\u043A\u0443 \u043A\u0443\u043F\u0438\u0442\u0438 \u0432 \u0423\u043A\u0440\u0430\u0457\u043D\u0456. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043C\u0430\u0440\u043E\u043A \u0456 \u043C\u043E\u0434\u0435\u043B\u0435\u0439. \u041F\u043E\u0440\u0456\u0432\u043D\u044F\u0442\u0438 \u0446\u0456\u043D\u0438, \u043F\u043E\u0434\u0438\u0432\u0438\u0442\u0438\u0441\u044F \u0444\u043E\u0442\u043E \u043D\u0430 \u0441\u0430\u0439\u0442\u0456 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440'
    };
  },

  makeGearboxIsnew: function makeGearboxIsnew(data, p) {
    return {
      header: data.make + ' ' + p.customGearboxLCase + ' ' + p.buyLCase + ' ' + p.t('в Украине')
    };
  },
  // BMW механика купить в Украине

  gearboxIsnewCity: function gearboxIsnewCity(data, p) {
    return { header: p.buy + ' \u0430\u0432\u0442\u043E ' + p.t(data.gearbox) + ' ' + p.inCity };
  },
  // Купить авто Механика в Киеве

  makeGearboxCity: function makeGearboxCity(data, p) {
    return {
      header: p.buy + ' ' + data.make + ' ' + p.t(data.gearbox).toLowerCase() + ' \u0431\u0443 ' + p.t(data.city)
    };
  },
  // Купить BMW Механика бу в Киеве

  engineMakeModel: function engineMakeModel(data, p) {
    return {
      header: p.buy + ' ' + data.make + ' ' + data.model + ' ' + p.customEngineShort + ' \u0431\u0443',

      title: '\u041A\u0443\u043F\u0438\u0442\u044C ' + data.make + ' ' + data.model + ' ' + p.t(data.engine) + ' \u0432 \u0423\u043A\u0440\u0430\u0438\u043D\u0435 - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',
      title_uk: '\u041A\u0443\u043F\u0438\u0442\u0438 ' + data.make + ' ' + data.model + ' ' + p.t(data.engine) + ' \u0432 \u0423\u043A\u0440\u0430\u0457\u043D\u0456 - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',

      description: '\u041F\u0440\u043E\u0434\u0430\u0436\u0430 ' + data.make + ' ' + data.model + ' ' + p.t(data.engine) + ' \u0432 \u0423\u043A\u0440\u0430\u0438\u043D\u0435. \u041A\u0443\u043F\u0438\u0442\u044C ' + data.make + ' ' + data.model + ' ' + p.t(data.engine) + ' \u0431\u0443 \u0441 \u043F\u0440\u043E\u0431\u0435\u0433\u043E\u043C \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0439. \u0421\u0440\u0430\u0432\u043D\u0438\u0442\u044C \u0446\u0435\u043D\u044B, \u043F\u043E\u0441\u043C\u043E\u0442\u0440\u0435\u0442\u044C \u0444\u043E\u0442\u043E',
      description_uk: '\u041F\u0440\u043E\u0434\u0430\u0436 ' + data.make + ' ' + data.model + ' ' + p.t(data.engine) + ' \u0432 \u0423\u043A\u0440\u0430\u0457\u043D\u0456. \u041A\u0443\u043F\u0438\u0442\u0438 ' + data.make + ' ' + data.model + ' ' + p.t(data.engine) + ' \u0431\u0443 \u0437 \u043F\u0440\u043E\u0431\u0456\u0433\u043E\u043C \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u044C. \u041F\u043E\u0440\u0456\u0432\u043D\u044F\u0442\u0438 \u0446\u0456\u043D\u0438, \u043F\u043E\u0434\u0438\u0432\u0438\u0442\u0438\u0441\u044F \u0444\u043E\u0442\u043E'
    };
  },
  // Купить BMW X6 дизель бу

  makeModelCity: function makeModelCity(data, p) {
    return {
      title: '\u041A\u0443\u043F\u0438\u0442\u044C ' + data.make + ' ' + data.model + ' \u0431\u0443 ' + p.inCity + '. \u041F\u0440\u043E\u0434\u0430\u0436\u0430 ' + data.make + ' ' + data.model + ' \u043D\u0430 \u0430\u0432\u0442\u043E \u0440\u044B\u043D\u043A\u0435 - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',
      title_uk: '\u041A\u0443\u043F\u0438\u0442\u0438 ' + data.make + ' ' + data.model + ' \u0431\u0443 ' + p.inCity + '. \u041F\u0440\u043E\u0434\u0430\u0436 ' + data.make + ' ' + data.model + ' \u043D\u0430 \u0430\u0432\u0442\u043E \u0440\u0438\u043D\u043A\u0443 - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',

      description: data.make + ' ' + data.model + ' \u043A\u0443\u043F\u0438\u0442\u044C \u0431\u0443 ' + p.inCity + '. \u041F\u043E\u0434\u0435\u0440\u0436\u0430\u043D\u043D\u044B\u0435 \u043C\u0430\u0448\u0438\u043D\u044B ' + data.make + ' ' + data.model + ' \u0441 \u043F\u0440\u043E\u0431\u0435\u0433\u043E\u043C \u0432 \u043F\u0440\u043E\u0434\u0430\u0436\u0435 \u043D\u0430 \u0430\u0432\u0442\u043E \u0440\u044B\u043D\u043A\u0435 \u0433. ' + p.t(data.city) + '. \u0421\u0440\u0430\u0432\u043D\u0438\u0442\u044C \u0446\u0435\u043D\u044B \u043D\u0430 \u0430\u0432\u0442\u043E\u043C\u043E\u0431\u0438\u043B\u0438, \u043F\u043E\u0441\u043C\u043E\u0442\u0440\u0435\u0442\u044C \u0444\u043E\u0442\u043E, \u043E\u0431\u0437\u043E\u0440 \u0445\u0430\u0440\u0430\u043A\u0442\u0435\u0440\u0438\u0441\u0442\u0438\u043A \u0438 \u043A\u043E\u043C\u043F\u043B\u0435\u043A\u0442\u0430\u0446\u0438\u0438 \u043C\u043E\u0434\u0435\u043B\u0438 \u043D\u0430 \u0441\u0430\u0439\u0442\u0435 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',
      description_uk: data.make + ' ' + data.model + ' \u043A\u0443\u043F\u0438\u0442\u0438 \u0431\u0443 ' + p.inCity + '. \u0421\u0442\u0430\u0440\u0456 \u043C\u0430\u0448\u0438\u043D\u0438 ' + data.make + ' ' + data.model + ' \u0437 \u043F\u0440\u043E\u0431\u0456\u0433\u043E\u043C \u0432 \u043F\u0440\u043E\u0434\u0430\u0436\u0443 \u043D\u0430 \u0430\u0432\u0442\u043E\u043C\u043E\u0431\u0456\u043B\u044C\u043D\u043E\u043C\u0443 \u0440\u0438\u043D\u043A\u0443 \u043C. ' + p.t(data.city) + '. \u041F\u043E\u0440\u0456\u0432\u043D\u044F\u0442\u0438 \u0446\u0456\u043D\u0438 \u043D\u0430 \u0430\u0432\u0442\u043E\u043C\u043E\u0431\u0456\u043B\u0456, \u043F\u043E\u0434\u0438\u0432\u0438\u0442\u0438\u0441\u044F \u0444\u043E\u0442\u043E, \u043E\u0433\u043B\u044F\u0434 \u0445\u0430\u0440\u0430\u043A\u0442\u0435\u0440\u0438\u0441\u0442\u0438\u043A \u0456 \u043A\u043E\u043C\u043F\u043B\u0435\u043A\u0442\u0430\u0446\u0456\u0457 \u043C\u043E\u0434\u0435\u043B\u0456 \u043D\u0430 \u0441\u0430\u0439\u0442\u0456 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440'
    };
  },

  makeModelYear: function makeModelYear(data, p) {
    return {
      header: '',
      title: '\u041A\u0443\u043F\u0438\u0442\u044C ' + data.make + ' ' + data.model + ' ' + data.year + ' \u0433\u043E\u0434\u0430 \u0432 \u0423\u043A\u0440\u0430\u0438\u043D\u0435 - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',
      title_uk: '\u041A\u0443\u043F\u0438\u0442\u0438 ' + data.make + ' ' + data.model + ' ' + data.year + ' \u0440\u043E\u043A\u0443 \u0432 \u0423\u043A\u0440\u0430\u0457\u043D\u0456 - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',

      description: '\u041F\u0440\u043E\u0434\u0430\u0436\u0430 ' + data.make + ' ' + data.model + ' ' + data.year + ' \u0433\u043E\u0434\u0430 \u0432 \u0423\u043A\u0440\u0430\u0438\u043D\u0435. \u041A\u0443\u043F\u0438\u0442\u044C ' + data.make + ' ' + data.model + ' ' + data.year + ' \u0431\u0443 \u0441 \u043F\u0440\u043E\u0431\u0435\u0433\u043E\u043C \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0439. \u0421\u0440\u0430\u0432\u043D\u0438\u0442\u044C \u0446\u0435\u043D\u044B, \u043F\u043E\u0441\u043C\u043E\u0442\u0440\u0435\u0442\u044C \u0444\u043E\u0442\u043E',
      description_uk: '\u041F\u0440\u043E\u0434\u0430\u0436 ' + data.make + ' ' + data.model + ' ' + data.year + ' \u0440\u043E\u043A\u0443 \u0432 \u0423\u043A\u0440\u0430\u0457\u043D\u0456. \u041A\u0443\u043F\u0438\u0442\u0438 ' + data.make + ' ' + data.model + ' ' + data.year + ' \u0431\u0443 \u0437 \u043F\u0440\u043E\u0431\u0456\u0433\u043E\u043C \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u044C. \u041F\u043E\u0440\u0456\u0432\u043D\u044F\u0442\u0438 \u0446\u0456\u043D\u0438, \u043F\u043E\u0434\u0438\u0432\u0438\u0442\u0438\u0441\u044F \u0444\u043E\u0442\u043E'
    };
  },

  gearboxMakeModel: function gearboxMakeModel(data, p) {
    return {
      // header: '',
      title: '\u041A\u0443\u043F\u0438\u0442\u044C ' + data.make + ' ' + data.model + ' ' + p.customGearbox + ' \u0432 \u0423\u043A\u0440\u0430\u0438\u043D\u0435 - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',
      title_uk: '\u041A\u0443\u043F\u0438\u0442\u0438 ' + data.make + ' ' + data.model + ' ' + p.customGearbox + ' \u0432 \u0423\u043A\u0440\u0430\u0457\u043D\u0456 - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',

      description: '\u041F\u0440\u043E\u0434\u0430\u0436\u0430 ' + data.make + ' ' + data.model + ' ' + p.customGearbox + ' \u0432 \u0423\u043A\u0440\u0430\u0438\u043D\u0435. \u041A\u0443\u043F\u0438\u0442\u044C ' + data.make + ' ' + data.model + ' ' + p.customGearbox + ' \u0431\u0443 \u0441 \u043F\u0440\u043E\u0431\u0435\u0433\u043E\u043C \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0439. \u0421\u0440\u0430\u0432\u043D\u0438\u0442\u044C \u0446\u0435\u043D\u044B, \u043F\u043E\u0441\u043C\u043E\u0442\u0440\u0435\u0442\u044C \u0444\u043E\u0442\u043E',
      description_uk: '\u041F\u0440\u043E\u0434\u0430\u0436 ' + data.make + ' ' + data.model + ' ' + p.customGearbox + ' \u0432 \u0423\u043A\u0440\u0430\u0457\u043D\u0456. \u041A\u0443\u043F\u0438\u0442\u0438 ' + data.make + ' ' + data.model + ' ' + p.customGearbox + ' \u0431\u0443 \u0437 \u043F\u0440\u043E\u0431\u0456\u0433\u043E\u043C \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u044C. \u041F\u043E\u0440\u0456\u0432\u043D\u044F\u0442\u0438 \u0446\u0456\u043D\u0438, \u043F\u043E\u0434\u0438\u0432\u0438\u0442\u0438\u0441\u044F \u0444\u043E\u0442\u043E'
    };
  },

  bodyMakeModel: function bodyMakeModel(data, p) {
    return {
      header: p.buy + ' ' + p.t(data.body) + ' ' + data.make + ' ' + data.model,
      title: p.buy + ' ' + data.make + ' ' + data.model + ' ' + p.t(data.body) + ' ' + p.t('в Украине') + ' \u2013 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',

      description: '\u041F\u0440\u043E\u0434\u0430\u0436\u0430 ' + data.make + ' ' + data.model + ' ' + p.t(data.body) + ' \u0432 \u0423\u043A\u0440\u0430\u0438\u043D\u0435. \u041A\u0443\u043F\u0438\u0442\u044C ' + data.make + ' ' + data.model + ' ' + p.t(data.body) + ' \u0431\u0443 \u0441 \u043F\u0440\u043E\u0431\u0435\u0433\u043E\u043C \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0439. \u0421\u0440\u0430\u0432\u043D\u0438\u0442\u044C \u0446\u0435\u043D\u044B, \u043F\u043E\u0441\u043C\u043E\u0442\u0440\u0435\u0442\u044C \u0444\u043E\u0442\u043E',
      description_uk: '\u041F\u0440\u043E\u0434\u0430\u0436 ' + data.make + ' ' + data.model + ' ' + p.t(data.body) + ' \u0432 \u0423\u043A\u0440\u0430\u0457\u043D\u0456. \u041A\u0443\u043F\u0438\u0442\u0438 ' + data.make + ' ' + data.model + ' ' + p.t(data.body) + ' \u0431\u0443 \u0437 \u043F\u0440\u043E\u0431\u0456\u0433\u043E\u043C \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u044C. \u041F\u043E\u0440\u0456\u0432\u043D\u044F\u0442\u0438 \u0446\u0456\u043D\u0438, \u043F\u043E\u0434\u0438\u0432\u0438\u0442\u0438\u0441\u044F \u0444\u043E\u0442\u043E'
    };
  },
  // Купить Кросовер BMW X6 бу

  bodyCityIsnew: function bodyCityIsnew(data, p) {
    return {
      header: p.newTxt + ' ' + p.t(data.body) + ' ' + p.buyLCase + ' ' + p.inCity,
      title: p.newTxt + ' ' + p.t(data.body) + ' ' + p.buyLCase + ' ' + p.inCity + ' \u2013 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',

      description: '\u041D\u043E\u0432\u044B\u0439 ' + p.t(data.body) + ' \u043A\u0443\u043F\u0438\u0442\u044C ' + p.inCity + '. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043C\u0430\u0440\u043E\u043A \u0438 \u043C\u043E\u0434\u0435\u043B\u0435\u0439. \u0421\u0440\u0430\u0432\u043D\u0438\u0442\u044C \u0446\u0435\u043D\u044B, \u043F\u043E\u0441\u043C\u043E\u0442\u0440\u0435\u0442\u044C \u0444\u043E\u0442\u043E \u043D\u0430 \u0441\u0430\u0439\u0442\u0435 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',
      description_uk: '\u041D\u043E\u0432\u0438\u0439 ' + p.t(data.body) + ' \u043A\u0443\u043F\u0438\u0442\u0438 ' + p.inCity + '. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043C\u0430\u0440\u043E\u043A \u0456 \u043C\u043E\u0434\u0435\u043B\u0435\u0439. \u041F\u043E\u0440\u0456\u0432\u043D\u044F\u0442\u0438 \u0446\u0456\u043D\u0438, \u043F\u043E\u0434\u0438\u0432\u0438\u0442\u0438\u0441\u044F \u0444\u043E\u0442\u043E \u043D\u0430 \u0441\u0430\u0439\u0442\u0456 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440'
    };
  },
  // Купить Кросовер в Киеве

  bodyCityMake: function bodyCityMake(data, p) {
    return {
      header: data.make + ' ' + p.t(data.body).toLowerCase() + ' \u0431\u0443 ' + p.t(data.city),
      title: p.buy + ' \u0431\u0443 ' + p.t(data.body) + ' ' + data.make + ' ' + p.inCity + ' \u2013 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',

      description: '\u041A\u0443\u043F\u0438\u0442\u044C \u0431\u0443 ' + p.t(data.body) + ' ' + data.make + ' \u0441 \u043F\u0440\u043E\u0431\u0435\u0433\u043E\u043C ' + p.inCity + '. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043C\u043E\u0434\u0435\u043B\u0435\u0439. \u0421\u0440\u0430\u0432\u043D\u0438\u0442\u044C \u0446\u0435\u043D\u044B, \u043F\u043E\u0441\u043C\u043E\u0442\u0440\u0435\u0442\u044C \u0444\u043E\u0442\u043E \u043D\u0430 \u0441\u0430\u0439\u0442\u0435 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',
      description_uk: '\u041A\u0443\u043F\u0438\u0442\u0438 \u0431\u0443 ' + p.t(data.body) + ' ' + data.make + ' \u0437 \u043F\u0440\u043E\u0431\u0456\u0433\u043E\u043C ' + p.inCity + '. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043C\u043E\u0434\u0435\u043B\u0435\u0439. \u041F\u043E\u0440\u0456\u0432\u043D\u044F\u0442\u0438 \u0446\u0456\u043D\u0438, \u043F\u043E\u0434\u0438\u0432\u0438\u0442\u0438\u0441\u044F \u0444\u043E\u0442\u043E \u043D\u0430 \u0441\u0430\u0439\u0442\u0456 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440'
    };
  },
  // BMW Кроссовер бу в Киеве

  bodyCityYear: function bodyCityYear(data, p) {
    return {
      title: '\u041A\u0443\u043F\u0438\u0442\u044C ' + p.t(data.body) + ' ' + data.year + ' \u0433\u043E\u0434\u0430 \u0431\u0443 ' + p.inCity + ' \u2013 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',
      title_uk: '\u041A\u0443\u043F\u0438\u0442\u0438 ' + p.t(data.body) + ' ' + data.year + ' \u0440\u043E\u043A\u0443 \u0431\u0443 ' + p.inCity + ' \u2013 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',

      description: '\u041F\u0440\u043E\u0434\u0430\u0436\u0430 \u0430\u0432\u0442\u043E ' + p.t(data.body) + ' ' + data.year + ' \u0433\u043E\u0434\u0430 \u0431\u0443 ' + p.inCity + '. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043C\u0430\u0440\u043E\u043A \u0438 \u043C\u043E\u0434\u0435\u043B\u0435\u0439. \u0421\u0440\u0430\u0432\u043D\u0438\u0442\u044C \u0446\u0435\u043D\u044B, \u043F\u043E\u0441\u043C\u043E\u0442\u0440\u0435\u0442\u044C \u0444\u043E\u0442\u043E \u0432 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u044F\u0445 \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',
      description_uk: '\u041F\u0440\u043E\u0434\u0430\u0436 \u0430\u0432\u0442\u043E ' + p.t(data.body) + ' ' + data.year + ' \u0440\u043E\u043A\u0443 \u0431\u0443 ' + p.inCity + '. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043C\u0430\u0440\u043E\u043A \u0456 \u043C\u043E\u0434\u0435\u043B\u0435\u0439. \u041F\u043E\u0440\u0456\u0432\u043D\u044F\u0442\u0438 \u0446\u0456\u043D\u0438, \u043F\u043E\u0434\u0438\u0432\u0438\u0442\u0438\u0441\u044F \u0444\u043E\u0442\u043E \u0432 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u043D\u044F\u0445 \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440'
    };
  },

  cityEngineYear: function cityEngineYear(data, p) {
    return {
      title: '\u041A\u0443\u043F\u0438\u0442\u044C \u0430\u0432\u0442\u043E ' + p.t(data.engine) + ' ' + data.year + ' \u0433\u043E\u0434\u0430 ' + p.inCity + ' - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',
      title_uk: '\u041A\u0443\u043F\u0438\u0442\u0438 \u0430\u0432\u0442\u043E ' + p.t(data.engine) + ' ' + data.year + ' \u0440\u043E\u043A\u0443 ' + p.inCity + ' - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',

      description: '\u041F\u0440\u043E\u0434\u0430\u0436\u0430 \u0430\u0432\u0442\u043E ' + p.t(data.engine) + ' ' + data.year + ' \u0433\u043E\u0434\u0430 \u0431\u0443 ' + p.inCity + '. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043C\u0430\u0440\u043E\u043A \u0438 \u043C\u043E\u0434\u0435\u043B\u0435\u0439. \u0421\u0440\u0430\u0432\u043D\u0438\u0442\u044C \u0446\u0435\u043D\u044B, \u043F\u043E\u0441\u043C\u043E\u0442\u0440\u0435\u0442\u044C \u0444\u043E\u0442\u043E \u0432 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u044F\u0445 \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',
      description_uk: '\u041F\u0440\u043E\u0434\u0430\u0436 \u0430\u0432\u0442\u043E ' + p.t(data.engine) + ' ' + data.year + ' \u0440\u043E\u043A\u0443 \u0431\u0443 ' + p.inCity + '. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043C\u0430\u0440\u043E\u043A \u0456 \u043C\u043E\u0434\u0435\u043B\u0435\u0439. \u041F\u043E\u0440\u0456\u0432\u043D\u044F\u0442\u0438 \u0446\u0456\u043D\u0438, \u043F\u043E\u0434\u0438\u0432\u0438\u0442\u0438\u0441\u044F \u0444\u043E\u0442\u043E \u0432 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u043D\u044F\u0445 \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440'
    };
  },

  bodyCityIsnewMake: function bodyCityIsnewMake(data, p) {
    return {
      header: p.newTxt + ' ' + data.make + ' ' + p.t(data.body) + ' ' + p.inCity,
      title: p.buy + ' ' + p.newTxtLCase + ' ' + p.t(data.body) + ' ' + data.make + ' ' + p.inCity + ' \u2013 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',

      description: '\u041A\u0443\u043F\u0438\u0442\u044C \u043D\u043E\u0432\u044B\u0439 ' + p.t(data.body) + ' ' + data.make + ' ' + p.inCity + ' \u0441 \u0441\u0430\u043B\u043E\u043D\u0430. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043C\u043E\u0434\u0435\u043B\u0435\u0439. \u0421\u0440\u0430\u0432\u043D\u0438\u0442\u044C \u0446\u0435\u043D\u044B, \u043F\u043E\u0441\u043C\u043E\u0442\u0440\u0435\u0442\u044C \u0444\u043E\u0442\u043E \u043D\u0430 \u0441\u0430\u0439\u0442\u0435 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',
      description_uk: '\u041A\u0443\u043F\u0438\u0442\u0438 \u043D\u043E\u0432\u0438\u0439 ' + p.t(data.body) + ' ' + data.make + ' ' + p.inCity + ' \u0437 \u0441\u0430\u043B\u043E\u043D\u0443. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043C\u043E\u0434\u0435\u043B\u0435\u0439. \u041F\u043E\u0440\u0456\u0432\u043D\u044F\u0442\u0438 \u0446\u0456\u043D\u0438, \u043F\u043E\u0434\u0438\u0432\u0438\u0442\u0438\u0441\u044F \u0444\u043E\u0442\u043E \u043D\u0430 \u0441\u0430\u0439\u0442\u0456 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440'
    };
  },

  bodyCityMakeModel: function bodyCityMakeModel(data, p) {
    return {
      header: p.buy + ' ' + p.t(data.body).toLowerCase() + ' ' + data.make + ' ' + data.model + ' \u0431\u0443 ' + p.t(data.city),

      title: p.buy + ' ' + data.make + ' ' + data.model + ' ' + p.t(data.body) + ' ' + p.inCity + ' \u2013 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',

      description: '\u041F\u0440\u043E\u0434\u0430\u0436\u0430 ' + data.make + ' ' + data.model + ' ' + p.t(data.body) + ' ' + p.inCity + '. \u041A\u0443\u043F\u0438\u0442\u044C ' + data.make + ' ' + data.model + ' ' + p.t(data.body) + ' \u0431\u0443 \u0441 \u043F\u0440\u043E\u0431\u0435\u0433\u043E\u043C \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0439 ' + p.inCity + '. \u0421\u0440\u0430\u0432\u043D\u0438\u0442\u044C \u0446\u0435\u043D\u044B, \u043F\u043E\u0441\u043C\u043E\u0442\u0440\u0435\u0442\u044C \u0444\u043E\u0442\u043E',
      description_uk: '\u041F\u0440\u043E\u0434\u0430\u0436 ' + data.make + ' ' + data.model + ' ' + p.t(data.body) + ' ' + p.inCity + '. \u041A\u0443\u043F\u0438\u0442\u0438 ' + data.make + ' ' + data.model + ' ' + p.t(data.body) + ' \u0431\u0443 \u0437 \u043F\u0440\u043E\u0431\u0456\u0433\u043E\u043C \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u044C ' + p.inCity + '. \u041F\u043E\u0440\u0456\u0432\u043D\u044F\u0442\u0438 \u0446\u0456\u043D\u0438, \u043F\u043E\u0434\u0438\u0432\u0438\u0442\u0438\u0441\u044F \u0444\u043E\u0442\u043E'
    };
  },

  countryMakeModel: function countryMakeModel(data, p) {
    return {
      header: p.buy + ' ' + data.make + ' ' + data.model + ' ' + p.fromCountry + ' \u0431\u0443',

      title: '\u041A\u0443\u043F\u0438\u0442\u044C ' + data.make + ' ' + data.model + ' ' + p.fromCountry + ' - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',
      title_uk: '\u041A\u0443\u043F\u0438\u0442\u0438 ' + data.make + ' ' + data.model + ' ' + p.fromCountry + ' - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',

      description: '\u041A\u0443\u043F\u0438\u0442\u044C ' + data.make + ' ' + data.model + ' \u043F\u0440\u0438\u0433\u043D\u0430\u043D\u043D\u044B\u0439 ' + p.fromCountry + '. \u0412 \u043F\u0440\u043E\u0434\u0430\u0436\u0435 ' + data.make + ' ' + data.model + ' \u0431\u0443 \u0441 \u043F\u0440\u043E\u0431\u0435\u0433\u043E\u043C \u0440\u0430\u0441\u0442\u0430\u043C\u043E\u0436\u0435\u043D\u043D\u044B\u0439 \u0438 \u043D\u0435\u0440\u0430\u0441\u0442\u0430\u043C\u043E\u0436\u0435\u043D\u043D\u044B\u0439. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0439. \u0421\u0440\u0430\u0432\u043D\u0438\u0442\u044C \u0446\u0435\u043D\u044B, \u043F\u043E\u0441\u043C\u043E\u0442\u0440\u0435\u0442\u044C \u0444\u043E\u0442\u043E',
      description_uk: '\u041A\u0443\u043F\u0438\u0442\u0438 ' + data.make + ' ' + data.model + ' \u043F\u0440\u0438\u0433\u043D\u0430\u043D\u0438\u0439 ' + p.fromCountry + '. \u0423 \u043F\u0440\u043E\u0434\u0430\u0436\u0443 ' + data.make + ' ' + data.model + ' \u0431\u0443 \u0437 \u043F\u0440\u043E\u0431\u0456\u0433\u043E\u043C \u0440\u043E\u0437\u043C\u0438\u0442\u043D\u0435\u043D\u0438\u0439 \u0456 \u043D\u0435\u0440\u043E\u0437\u043C\u0438\u0442\u043D\u0435\u043D\u0438\u0439. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u044C. \u041F\u043E\u0440\u0456\u0432\u043D\u044F\u0442\u0438 \u0446\u0456\u043D\u0438, \u043F\u043E\u0434\u0438\u0432\u0438\u0442\u0438\u0441\u044F \u0444\u043E\u0442\u043E'
    };
  },

  makeModelEngineCity: function makeModelEngineCity(data, p) {
    return {
      header: p.buy + ' ' + data.make + ' ' + data.model + ' ' + p.customEngineShort + ' \u0431\u0443 ' + p.inCity,
      title: '\u041A\u0443\u043F\u0438\u0442\u044C ' + data.make + ' ' + data.model + ' ' + p.t(data.engine) + ' ' + p.inCity + ' - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',
      title_uk: '\u041A\u0443\u043F\u0438\u0442\u0438 ' + data.make + ' ' + data.model + ' ' + p.t(data.engine) + ' ' + p.inCity + ' - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',

      description: '\u041F\u0440\u043E\u0434\u0430\u0436\u0430 ' + data.make + ' ' + data.model + ' ' + p.t(data.engine) + ' ' + p.inCity + '. \u041A\u0443\u043F\u0438\u0442\u044C ' + data.make + ' ' + data.model + ' ' + p.t(data.engine) + ' \u0431\u0443 \u0441 \u043F\u0440\u043E\u0431\u0435\u0433\u043E\u043C \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0439 ' + p.inCity + '. \u0421\u0440\u0430\u0432\u043D\u0438\u0442\u044C \u0446\u0435\u043D\u044B, \u043F\u043E\u0441\u043C\u043E\u0442\u0440\u0435\u0442\u044C \u0444\u043E\u0442\u043E',
      description_uk: '\u041F\u0440\u043E\u0434\u0430\u0436 ' + data.make + ' ' + data.model + ' ' + p.t(data.engine) + ' ' + p.inCity + '. \u041A\u0443\u043F\u0438\u0442\u0438 ' + data.make + ' ' + data.model + ' ' + p.t(data.engine) + ' \u0431\u0443 \u0437 \u043F\u0440\u043E\u0431\u0456\u0433\u043E\u043C \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u044C ' + p.inCity + '. \u041F\u043E\u0440\u0456\u0432\u043D\u044F\u0442\u0438 \u0446\u0456\u043D\u0438, \u043F\u043E\u0434\u0438\u0432\u0438\u0442\u0438\u0441\u044F \u0444\u043E\u0442\u043E'
    };
  },
  // Купить BMW X6 дизель бу в Киеве

  cityGearboxMakeModel: function cityGearboxMakeModel(data, p) {
    return {
      header: p.buy + ' ' + data.make + ' ' + data.model + ' ' + p.customGearbox.toLowerCase() + ' \u0431\u0443 ' + p.t(data.city),
      title: '\u041A\u0443\u043F\u0438\u0442\u044C ' + data.make + ' ' + data.model + ' ' + p.customGearbox + ' ' + p.inCity + ' - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',
      title_uk: '\u041A\u0443\u043F\u0438\u0442\u0438 ' + data.make + ' ' + data.model + ' ' + p.customGearbox + ' ' + p.inCity + ' - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',

      description: '\u041F\u0440\u043E\u0434\u0430\u0436\u0430 ' + data.make + ' ' + data.model + ' ' + p.customGearbox + ' ' + p.inCity + '. \u041A\u0443\u043F\u0438\u0442\u044C ' + data.make + ' ' + data.model + ' ' + p.customGearbox + ' \u0431\u0443 \u0441 \u043F\u0440\u043E\u0431\u0435\u0433\u043E\u043C \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0439. \u0421\u0440\u0430\u0432\u043D\u0438\u0442\u044C \u0446\u0435\u043D\u044B ' + p.inCity + ', \u043F\u043E\u0441\u043C\u043E\u0442\u0440\u0435\u0442\u044C \u0444\u043E\u0442\u043E',
      description_uk: '\u041F\u0440\u043E\u0434\u0430\u0436 ' + data.make + ' ' + data.model + ' ' + p.customGearbox + ' ' + p.inCity + '. \u041A\u0443\u043F\u0438\u0442\u0438 ' + data.make + ' ' + data.model + ' ' + p.customGearbox + ' \u0431\u0443 \u0437 \u043F\u0440\u043E\u0431\u0456\u0433\u043E\u043C \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u044C. \u041F\u043E\u0440\u0456\u0432\u043D\u044F\u0442\u0438 \u0446\u0456\u043D\u0438 ' + p.inCity + ', \u043F\u043E\u0434\u0438\u0432\u0438\u0442\u0438\u0441\u044F \u0444\u043E\u0442\u043E'
    };
  },
  // Купить BMW X6 Механика бу в Киеве

  cityGearboxIsnewMake: function cityGearboxIsnewMake(data, p) {
    return {
      header: p.buy + ' ' + data.make + ' ' + p.customGearbox + ' ' + p.inCity
    };
  },
  // Купить BMW Механика в Киеве

  cityMakeModelYear: function cityMakeModelYear(data, p) {
    return {
      header: p.buy + ' ' + data.make + ' ' + data.model + ' ' + data.year + ' \u0431\u0443 ' + p.inCity,

      title: '\u041A\u0443\u043F\u0438\u0442\u044C ' + data.make + ' ' + data.model + ' ' + data.year + ' \u0433\u043E\u0434\u0430 ' + p.inCity + ' - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',
      title_uk: '\u041A\u0443\u043F\u0438\u0442\u0438 ' + data.make + ' ' + data.model + ' ' + data.year + ' \u0440\u043E\u043A\u0443 ' + p.inCity + ' - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',

      description: '\u041F\u0440\u043E\u0434\u0430\u0436\u0430 ' + data.make + ' ' + data.model + ' ' + data.year + ' \u0433\u043E\u0434\u0430 ' + p.inCity + '. \u041A\u0443\u043F\u0438\u0442\u044C ' + data.make + ' ' + data.model + ' ' + data.year + ' \u0431\u0443 \u0441 \u043F\u0440\u043E\u0431\u0435\u0433\u043E\u043C \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0439. \u0421\u0440\u0430\u0432\u043D\u0438\u0442\u044C \u0446\u0435\u043D\u044B ' + p.inCity + ', \u043F\u043E\u0441\u043C\u043E\u0442\u0440\u0435\u0442\u044C \u0444\u043E\u0442\u043E',
      description_uk: '\u041F\u0440\u043E\u0434\u0430\u0436 ' + data.make + ' ' + data.model + ' ' + data.year + ' \u0440\u043E\u043A\u0443 ' + p.inCity + '. \u041A\u0443\u043F\u0438\u0442\u0438 ' + data.make + ' ' + data.model + ' ' + data.year + ' \u0431\u0443 \u0437 \u043F\u0440\u043E\u0431\u0456\u0433\u043E\u043C \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u044C. \u041F\u043E\u0440\u0456\u0432\u043D\u044F\u0442\u0438 \u0446\u0456\u043D\u0438 ' + p.inCity + ', \u043F\u043E\u0434\u0438\u0432\u0438\u0442\u0438\u0441\u044F \u0444\u043E\u0442\u043E'
    };
  },

  makeModelEngineCityYear: function makeModelEngineCityYear(data, p) {
    return {
      header: p.buy + ' ' + data.make + ' ' + data.model + ' ' + data.year + ' \u0431\u0443 ' + p.inCity
    };
  },

  //
  bodyCityIsnewYear: function bodyCityIsnewYear(data, p) {
    return {
      title: '\u041A\u0443\u043F\u0438\u0442\u044C \u043D\u043E\u0432\u044B\u0439 ' + p.t(data.body) + ' ' + data.year + ' \u0433\u043E\u0434\u0430 \u0441 \u0441\u0430\u043B\u043E\u043D\u0430 ' + p.inCity + ' - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',
      description: '\u041F\u0440\u043E\u0434\u0430\u0436\u0430 \u043D\u043E\u0432\u044B\u0445 ' + p.t(data.body) + ' ' + data.year + ' \u0433\u043E\u0434\u0430 \u0441 \u0441\u0430\u043B\u043E\u043D\u0430 ' + p.inCity + '. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043C\u0430\u0440\u043E\u043A \u0438 \u043C\u043E\u0434\u0435\u043B\u0435\u0439. \u0421\u0440\u0430\u0432\u043D\u0438\u0442\u044C \u0446\u0435\u043D\u044B, \u043F\u043E\u0441\u043C\u043E\u0442\u0440\u0435\u0442\u044C \u0444\u043E\u0442\u043E \u0432 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u044F\u0445 \u043E\u0442 \u0430\u0432\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u043E\u0432 \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',
      title_uk: '\u041A\u0443\u043F\u0438\u0442\u0438 \u043D\u043E\u0432\u0438\u0439 ' + p.t(data.body) + ' ' + data.year + ' \u0440\u043E\u043A\u0443 \u0437 \u0441\u0430\u043B\u043E\u043D\u0443 ' + p.inCity + ' - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',
      description_uk: '\u041F\u0440\u043E\u0434\u0430\u0436 \u043D\u043E\u0432\u0438\u0445 ' + p.t(data.body) + ' ' + data.year + ' \u0440\u043E\u043A\u0443 \u0437 \u0441\u0430\u043B\u043E\u043D\u0443 ' + p.inCity + '. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043C\u0430\u0440\u043E\u043A \u0456 \u043C\u043E\u0434\u0435\u043B\u0435\u0439. \u041F\u043E\u0440\u0456\u0432\u043D\u044F\u0442\u0438 \u0446\u0456\u043D\u0438, \u043F\u043E\u0434\u0438\u0432\u0438\u0442\u0438\u0441\u044F \u0444\u043E\u0442\u043E \u0432 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u043D\u044F\u0445 \u0432\u0456\u0434 \u0430\u0432\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0456\u0432 \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440'
    };
  },
  isnewYear: function isnewYear(data, p) {
    return {
      title: '\u041D\u043E\u0432\u044B\u0435 \u0430\u0432\u0442\u043E\u043C\u043E\u0431\u0438\u043B\u0438 ' + data.year + ' \u0433\u043E\u0434\u0430 \u043A\u0443\u043F\u0438\u0442\u044C \u0432 \u0430\u0432\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u0423\u043A\u0440\u0430\u0438\u043D\u044B - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',
      description: '\u041F\u0440\u043E\u0434\u0430\u0436\u0430 \u043D\u043E\u0432\u044B\u0445 \u0430\u0432\u0442\u043E ' + data.year + ' \u0433\u043E\u0434\u0430 \u0432 \u0430\u0432\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u0423\u043A\u0440\u0430\u0438\u043D\u044B. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043C\u0430\u0440\u043E\u043A \u0438 \u043C\u043E\u0434\u0435\u043B\u0435\u0439 \u0430\u0432\u0442\u043E\u043C\u043E\u0431\u0438\u043B\u0435\u0439. \u0421\u0440\u0430\u0432\u043D\u0438\u0442\u044C \u0446\u0435\u043D\u044B, \u043F\u043E\u0441\u043C\u043E\u0442\u0440\u0435\u0442\u044C \u0444\u043E\u0442\u043E \u0441 \u0441\u0430\u043B\u043E\u043D\u0430 \u0432 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u044F\u0445 \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',
      title_uk: '\u041D\u043E\u0432\u0456 \u0430\u0432\u0442\u043E\u043C\u043E\u0431\u0456\u043B\u0456 ' + data.year + ' \u0440\u043E\u043A\u0443 \u043A\u0443\u043F\u0438\u0442\u0438 \u0432 \u0430\u0432\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u0423\u043A\u0440\u0430\u0457\u043D\u0438 - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',
      description_uk: '\u041F\u0440\u043E\u0434\u0430\u0436 \u043D\u043E\u0432\u0438\u0445 \u0430\u0432\u0442\u043E ' + data.year + ' \u0440\u043E\u043A\u0443 \u0432 \u0430\u0432\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u0423\u043A\u0440\u0430\u0457\u043D\u0438. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043C\u0430\u0440\u043E\u043A \u0456 \u043C\u043E\u0434\u0435\u043B\u0435\u0439 \u0430\u0432\u0442\u043E\u043C\u043E\u0431\u0456\u043B\u0456\u0432. \u041F\u043E\u0440\u0456\u0432\u043D\u044F\u0442\u0438 \u0446\u0456\u043D\u0438, \u043F\u043E\u0434\u0438\u0432\u0438\u0442\u0438\u0441\u044F \u0444\u043E\u0442\u043E \u0437 \u0441\u0430\u043B\u043E\u043D\u0443 \u0432 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u043D\u044F\u0445 \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440'
    };
  },
  cityIsnewYear: function cityIsnewYear(data, p) {
    return {
      title: '\u041D\u043E\u0432\u044B\u0435 \u0430\u0432\u0442\u043E\u043C\u043E\u0431\u0438\u043B\u0438 ' + data.year + ' \u0433\u043E\u0434\u0430 \u043A\u0443\u043F\u0438\u0442\u044C \u0432 \u0430\u0432\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u0433\u043E\u0440\u043E\u0434\u0430 ' + p.t(data.city) + ' - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',
      description: '\u041F\u0440\u043E\u0434\u0430\u0436\u0430 \u043D\u043E\u0432\u044B\u0445 \u0430\u0432\u0442\u043E ' + data.year + ' \u0433\u043E\u0434\u0430 \u0432 \u0430\u0432\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u0433\u043E\u0440\u043E\u0434\u0430 ' + p.t(data.city) + '. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043C\u0430\u0440\u043E\u043A \u0438 \u043C\u043E\u0434\u0435\u043B\u0435\u0439. \u0421\u0440\u0430\u0432\u043D\u0438\u0442\u044C \u0446\u0435\u043D\u044B, \u043F\u043E\u0441\u043C\u043E\u0442\u0440\u0435\u0442\u044C \u0444\u043E\u0442\u043E \u0432 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u044F\u0445 \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',
      title_uk: '\u041D\u043E\u0432\u0456 \u0430\u0432\u0442\u043E\u043C\u043E\u0431\u0456\u043B\u0456 ' + data.year + ' \u0440\u043E\u043A\u0443 \u043A\u0443\u043F\u0438\u0442\u0438 \u0432 \u0430\u0432\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u043C\u0456\u0441\u0442\u0430 ' + p.t(data.city) + ' - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',
      description_uk: '\u041F\u0440\u043E\u0434\u0430\u0436 \u043D\u043E\u0432\u0438\u0445 \u0430\u0432\u0442\u043E ' + data.year + ' \u0440\u043E\u043A\u0443 \u0432 \u0430\u0432\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u043C\u0456\u0441\u0442\u0430 ' + p.t(data.city) + '. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043C\u0430\u0440\u043E\u043A \u0456 \u043C\u043E\u0434\u0435\u043B\u0435\u0439. \u041F\u043E\u0440\u0456\u0432\u043D\u044F\u0442\u0438 \u0446\u0456\u043D\u0438, \u043F\u043E\u0434\u0438\u0432\u0438\u0442\u0438\u0441\u044F \u0444\u043E\u0442\u043E \u0432 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u043D\u044F\u0445 \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440'
    };
  },
  cityIsnew: function cityIsnew(data, p) {
    return {
      title: '\u041A\u0443\u043F\u0438\u0442\u044C \u043D\u043E\u0432\u043E\u0435 \u0430\u0432\u0442\u043E \u0441 \u0441\u0430\u043B\u043E\u043D\u0430 ' + p.inCity + ' - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',
      description: '\u041F\u0440\u043E\u0434\u0430\u0436\u0430 \u043D\u043E\u0432\u044B\u0445 \u0430\u0432\u0442\u043E \u0432 \u0430\u0432\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u0433\u043E\u0440\u043E\u0434\u0430 ' + p.t(data.city) + '. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043C\u0430\u0448\u0438\u043D. \u0412\u044B\u0433\u043E\u0434\u043D\u0430\u044F \u0446\u0435\u043D\u0430. \u0415\u0449\u0435 \u0431\u043E\u043B\u044C\u0448\u0435 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0439 \u043E\u0442 \u0441\u0430\u043B\u043E\u043D\u043E\u0432 \u043D\u0430 \u0441\u0430\u0439\u0442\u0435 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',
      title_uk: '\u041A\u0443\u043F\u0438\u0442\u0438 \u043D\u043E\u0432\u0435 \u0430\u0432\u0442\u043E \u0437 \u0441\u0430\u043B\u043E\u043D\u0443 ' + p.inCity + ' - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',
      description_uk: '\u041F\u0440\u043E\u0434\u0430\u0436 \u043D\u043E\u0432\u0438\u0445 \u0430\u0432\u0442\u043E \u0432 \u0430\u0432\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u043C\u0456\u0441\u0442\u0430 ' + p.t(data.city) + '. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043C\u0430\u0448\u0438\u043D. \u0412\u0438\u0433\u0456\u0434\u043D\u0430 \u0446\u0456\u043D\u0430. \u0429\u0435 \u0431\u0456\u043B\u044C\u0448\u0435 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u044C \u0432\u0456\u0434 \u0441\u0430\u043B\u043E\u043D\u0456\u0432 \u043D\u0430 \u0441\u0430\u0439\u0442\u0456 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440'
    };
  },
  isnewMakeModelYear: function isnewMakeModelYear(data, p) {
    return {
      title: '\u041A\u0443\u043F\u0438\u0442\u044C \u043D\u043E\u0432\u044B\u0439 ' + data.make + ' ' + data.model + ' ' + data.year + ' \u0433\u043E\u0434\u0430 \u0441 \u0441\u0430\u043B\u043E\u043D\u0430 \u0432 \u0423\u043A\u0440\u0430\u0438\u043D\u0435 - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',
      description: '\u041F\u0440\u043E\u0434\u0430\u0436\u0430 \u043D\u043E\u0432\u044B\u0445 ' + data.make + ' ' + data.model + ' ' + data.year + ' \u0433\u043E\u0434\u0430 \u0432 \u0430\u0432\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u0423\u043A\u0440\u0430\u0438\u043D\u044B. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0439. \u0421\u0440\u0430\u0432\u043D\u0438\u0442\u044C \u0446\u0435\u043D\u044B, \u0432\u044B\u0431\u0440\u0430\u0442\u044C \u0432\u044B\u0433\u043E\u0434\u043D\u043E\u0435 \u043F\u0440\u0435\u0434\u043B\u043E\u0436\u0435\u043D\u0438\u0435 \u043E\u0442 \u0441\u0430\u043B\u043E\u043D\u0430 \u043D\u0430 \u0441\u0430\u0439\u0442\u0435 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',
      title_uk: '\u041A\u0443\u043F\u0438\u0442\u0438 \u043D\u043E\u0432\u0438\u0439 ' + data.make + ' ' + data.model + ' ' + data.year + ' \u0440\u043E\u043A\u0443 \u0437 \u0441\u0430\u043B\u043E\u043D\u0443 \u0432 \u0423\u043A\u0440\u0430\u0457\u043D\u0456 - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',
      description_uk: '\u041F\u0440\u043E\u0434\u0430\u0436 \u043D\u043E\u0432\u0438\u0445 ' + data.make + ' ' + data.model + ' ' + data.year + ' \u0440\u043E\u043A\u0443 \u0432 \u0430\u0432\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u0423\u043A\u0440\u0430\u0457\u043D\u0438. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u044C. \u041F\u043E\u0440\u0456\u0432\u043D\u044F\u0442\u0438 \u0446\u0456\u043D\u0438, \u0432\u0438\u0431\u0440\u0430\u0442\u0438 \u0432\u0438\u0433\u0456\u0434\u043D\u0443 \u043F\u0440\u043E\u043F\u043E\u0437\u0438\u0446\u0456\u044E \u0432\u0456\u0434 \u0441\u0430\u043B\u043E\u043D\u0443 \u043D\u0430 \u0441\u0430\u0439\u0442\u0456 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440'
    };
  },
  cityIsnewMakeModelYear: function cityIsnewMakeModelYear(data, p) {
    return {
      title: '\u041A\u0443\u043F\u0438\u0442\u044C \u043D\u043E\u0432\u044B\u0439 ' + data.make + ' ' + data.model + ' ' + data.year + ' \u0433\u043E\u0434\u0430 \u0441 \u0441\u0430\u043B\u043E\u043D\u0430 ' + p.inCity + ' - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',
      description: '\u041F\u0440\u043E\u0434\u0430\u0436\u0430 \u043D\u043E\u0432\u044B\u0445 ' + data.make + ' ' + data.model + ' ' + data.year + ' \u0433\u043E\u0434\u0430 \u0432 \u0430\u0432\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u0433\u043E\u0440\u043E\u0434\u0430 ' + p.t(data.city) + '. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0439. \u0421\u0440\u0430\u0432\u043D\u0438\u0442\u044C \u0446\u0435\u043D\u044B ' + p.inCity + ', \u0432\u044B\u0431\u0440\u0430\u0442\u044C \u043B\u0443\u0447\u0448\u0435\u0435 \u043F\u0440\u0435\u0434\u043B\u043E\u0436\u0435\u043D\u0438\u0435 \u043E\u0442 \u0441\u0430\u043B\u043E\u043D\u0430 \u043D\u0430 \u0441\u0430\u0439\u0442\u0435 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',
      title_uk: '\u041A\u0443\u043F\u0438\u0442\u0438 \u043D\u043E\u0432\u0438\u0439 ' + data.make + ' ' + data.model + ' ' + data.year + ' \u0440\u043E\u043A\u0443 \u0437 \u0441\u0430\u043B\u043E\u043D\u0443 ' + p.inCity + ' - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',
      description_uk: '\u041F\u0440\u043E\u0434\u0430\u0436 \u043D\u043E\u0432\u0438\u0445 ' + data.make + ' ' + data.model + ' ' + data.year + ' \u0440\u043E\u043A\u0443 \u0432 \u0430\u0432\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u043C\u0456\u0441\u0442\u0430 ' + p.t(data.city) + '. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u044C. \u041F\u043E\u0440\u0456\u0432\u043D\u044F\u0442\u0438 \u0446\u0456\u043D\u0438 ' + p.inCity + ', \u0432\u0438\u0431\u0440\u0430\u0442\u0438 \u043A\u0440\u0430\u0449\u0443 \u043F\u0440\u043E\u043F\u043E\u0437\u0438\u0446\u0456\u044E \u0432\u0456\u0434 \u0441\u0430\u043B\u043E\u043D\u0443 \u043D\u0430 \u0441\u0430\u0439\u0442\u0456 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440'
    };
  },
  gearboxIsnewMakeModel: function gearboxIsnewMakeModel(data, p) {
    return {
      title: '\u041A\u0443\u043F\u0438\u0442\u044C \u043D\u043E\u0432\u044B\u0439 ' + data.make + ' ' + data.model + ' ' + p.customGearbox + ' \u0441 \u0441\u0430\u043B\u043E\u043D\u0430 \u0432 \u0423\u043A\u0440\u0430\u0438\u043D\u0435 - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',
      description: '\u041F\u0440\u043E\u0434\u0430\u0436\u0430 \u043D\u043E\u0432\u044B\u0445 ' + data.make + ' ' + data.model + ' ' + p.customGearbox + ' \u0432 \u0430\u0432\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u0423\u043A\u0440\u0430\u0438\u043D\u044B. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0439. \u0421\u0440\u0430\u0432\u043D\u0438\u0442\u044C \u0446\u0435\u043D\u044B \u0432 \u0441\u0430\u043B\u043E\u043D\u0430\u0445, \u0432\u044B\u0431\u0440\u0430\u0442\u044C \u043B\u0443\u0447\u0448\u0435\u0435 \u043F\u0440\u0435\u0434\u043B\u043E\u0436\u0435\u043D\u0438\u0435 \u043D\u0430 \u0441\u0430\u0439\u0442\u0435 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',
      title_uk: '\u041A\u0443\u043F\u0438\u0442\u0438 \u043D\u043E\u0432\u0438\u0439 ' + data.make + ' ' + data.model + ' ' + p.customGearbox + ' \u0437 \u0441\u0430\u043B\u043E\u043D\u0443 \u0432 \u0423\u043A\u0440\u0430\u0457\u043D\u0456 - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',
      description_uk: '\u041F\u0440\u043E\u0434\u0430\u0436 \u043D\u043E\u0432\u0438\u0445 ' + data.make + ' ' + data.model + ' ' + p.customGearbox + ' \u0432 \u0430\u0432\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u0423\u043A\u0440\u0430\u0457\u043D\u0438. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u044C. \u041F\u043E\u0440\u0456\u0432\u043D\u044F\u0442\u0438 \u0446\u0456\u043D\u0438 \u0432 \u0441\u0430\u043B\u043E\u043D\u0430\u0445, \u0432\u0438\u0431\u0440\u0430\u0442\u0438 \u043A\u0440\u0430\u0449\u0443 \u043F\u0440\u043E\u043F\u043E\u0437\u0438\u0446\u0456\u044E \u043D\u0430 \u0441\u0430\u0439\u0442\u0456 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440'
    };
  },
  cityGearboxIsnewMakeModel: function cityGearboxIsnewMakeModel(data, p) {
    return {
      title: '\u041A\u0443\u043F\u0438\u0442\u044C \u043D\u043E\u0432\u044B\u0439 ' + data.make + ' ' + data.model + ' ' + p.customGearbox + ' \u0432 \u0430\u0432\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 ' + p.t(data.city) + ' - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',
      description: '\u041F\u0440\u043E\u0434\u0430\u0436\u0430 \u043D\u043E\u0432\u044B\u0445 ' + data.make + ' ' + data.model + ' ' + p.customGearbox + ' \u0432 \u0430\u0432\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u0433\u043E\u0440\u043E\u0434\u0430 ' + p.t(data.city) + '. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0439. \u0421\u0440\u0430\u0432\u043D\u0438\u0442\u044C \u0446\u0435\u043D\u044B \u0432 \u0441\u0430\u043B\u043E\u043D\u0430\u0445 ' + p.t(data.city) + ', \u0432\u044B\u0431\u0440\u0430\u0442\u044C \u043B\u0443\u0447\u0448\u0435\u0435 \u043F\u0440\u0435\u0434\u043B\u043E\u0436\u0435\u043D\u0438\u0435 \u043D\u0430 \u0441\u0430\u0439\u0442\u0435 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',
      title_uk: '\u041A\u0443\u043F\u0438\u0442\u0438 \u043D\u043E\u0432\u0438\u0439 ' + data.make + ' ' + data.model + ' ' + p.customGearbox + ' \u0432 \u0430\u0432\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 ' + p.t(data.city) + ' - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',
      description_uk: '\u041F\u0440\u043E\u0434\u0430\u0436 \u043D\u043E\u0432\u0438\u0445 ' + data.make + ' ' + data.model + ' ' + p.customGearbox + ' \u0432 \u0430\u0432\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u043C\u0456\u0441\u0442\u0430 ' + p.t(data.city) + '. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u044C. \u041F\u043E\u0440\u0456\u0432\u043D\u044F\u0442\u0438 \u0446\u0456\u043D\u0438 \u0432 \u0441\u0430\u043B\u043E\u043D\u0430\u0445 ' + p.t(data.city) + ', \u0432\u0438\u0431\u0440\u0430\u0442\u0438 \u043A\u0440\u0430\u0449\u0443 \u043F\u0440\u043E\u043F\u043E\u0437\u0438\u0446\u0456\u044E \u043D\u0430 \u0441\u0430\u0439\u0442\u0456 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440'
    };
  },
  engineIsnewMakeModel: function engineIsnewMakeModel(data, p) {
    return {
      title: '\u041A\u0443\u043F\u0438\u0442\u044C \u043D\u043E\u0432\u044B\u0439 ' + data.make + ' ' + data.model + ' ' + p.t(data.engine) + ' \u0441 \u0441\u0430\u043B\u043E\u043D\u0430 \u0432 \u0423\u043A\u0440\u0430\u0438\u043D\u0435 - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',
      description: '\u041F\u0440\u043E\u0434\u0430\u0436\u0430 \u043D\u043E\u0432\u044B\u0445 ' + data.make + ' ' + data.model + ' ' + p.t(data.engine) + ' \u0432 \u0430\u0432\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u0423\u043A\u0440\u0430\u0438\u043D\u044B. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0439. \u0421\u0440\u0430\u0432\u043D\u0438\u0442\u044C \u0446\u0435\u043D\u044B, \u0432\u044B\u0431\u0440\u0430\u0442\u044C \u043B\u0443\u0447\u0448\u0435\u0435 \u043F\u0440\u0435\u0434\u043B\u043E\u0436\u0435\u043D\u0438\u0435 \u043D\u0430 \u0441\u0430\u0439\u0442\u0435 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',
      title_uk: '\u041A\u0443\u043F\u0438\u0442\u0438 \u043D\u043E\u0432\u0438\u0439 ' + data.make + ' ' + data.model + ' ' + p.t(data.engine) + ' \u0437 \u0441\u0430\u043B\u043E\u043D\u0443 \u0432 \u0423\u043A\u0440\u0430\u0457\u043D\u0456 - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',
      description_uk: '\u041F\u0440\u043E\u0434\u0430\u0436 \u043D\u043E\u0432\u0438\u0445 ' + data.make + ' ' + data.model + ' ' + p.t(data.engine) + ' \u0432 \u0430\u0432\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u0423\u043A\u0440\u0430\u0457\u043D\u0438. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u044C. \u041F\u043E\u0440\u0456\u0432\u043D\u044F\u0442\u0438 \u0446\u0456\u043D\u0438, \u0432\u0438\u0431\u0440\u0430\u0442\u0438 \u043A\u0440\u0430\u0449\u0443 \u043F\u0440\u043E\u043F\u043E\u0437\u0438\u0446\u0456\u044E \u043D\u0430 \u0441\u0430\u0439\u0442\u0456 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440'
    };
  },
  cityEngineIsnewMakeModel: function cityEngineIsnewMakeModel(data, p) {
    return {
      title: '\u041A\u0443\u043F\u0438\u0442\u044C \u043D\u043E\u0432\u044B\u0439 ' + data.make + ' ' + data.model + ' ' + p.t(data.engine) + ' \u0441 \u0441\u0430\u043B\u043E\u043D\u0430 ' + p.inCity + ' - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',
      description: '\u041F\u0440\u043E\u0434\u0430\u0436\u0430 \u043D\u043E\u0432\u044B\u0445 ' + data.make + ' ' + data.model + ' ' + p.t(data.engine) + ' \u0432 \u0430\u0432\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u0433\u043E\u0440\u043E\u0434\u0430 ' + p.t(data.city) + '. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0439 \u043E\u0442 \u0441\u0430\u043B\u043E\u043D\u043E\u0432. \u0412\u044B\u0431\u0440\u0430\u0442\u044C \u043B\u0443\u0447\u0448\u0435\u0435 \u043F\u0440\u0435\u0434\u043B\u043E\u0436\u0435\u043D\u0438\u0435 \u043D\u0430 \u0441\u0430\u0439\u0442\u0435 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',
      title_uk: '\u041A\u0443\u043F\u0438\u0442\u0438 \u043D\u043E\u0432\u0438\u0439 ' + data.make + ' ' + data.model + ' ' + p.t(data.engine) + ' \u0437 \u0441\u0430\u043B\u043E\u043D\u0443 ' + p.inCity + ' - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',
      description_uk: '\u041F\u0440\u043E\u0434\u0430\u0436 \u043D\u043E\u0432\u0438\u0445 ' + data.make + ' ' + data.model + ' ' + p.t(data.engine) + ' \u0432 \u0430\u0432\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u043C\u0456\u0441\u0442\u0430 ' + p.t(data.city) + '. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u044C \u0432\u0456\u0434 \u0441\u0430\u043B\u043E\u043D\u0456\u0432. \u0412\u0438\u0431\u0440\u0430\u0442\u0438 \u043A\u0440\u0430\u0449\u0443 \u043F\u0440\u043E\u043F\u043E\u0437\u0438\u0446\u0456\u044E \u043D\u0430 \u0441\u0430\u0439\u0442\u0456 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440'
    };
  },
  bodyIsnewMakeModel: function bodyIsnewMakeModel(data, p) {
    return {
      header: p.buy + ' ' + p.newTxtLCase + ' ' + p.t(data.body) + ' ' + data.make + ' ' + data.model,
      title: '\u041A\u0443\u043F\u0438\u0442\u044C \u043D\u043E\u0432\u044B\u0439 ' + data.make + ' ' + data.model + ' ' + p.t(data.body) + ' \u0441 \u0441\u0430\u043B\u043E\u043D\u0430 \u0432 \u0423\u043A\u0440\u0430\u0438\u043D\u0435 - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',
      description: '\u041F\u0440\u043E\u0434\u0430\u0436\u0430 \u043D\u043E\u0432\u044B\u0445 ' + data.make + ' ' + data.model + ' ' + p.t(data.body) + ' \u0432 \u0430\u0432\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u0423\u043A\u0440\u0430\u0438\u043D\u044B. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0439. \u0421\u0440\u0430\u0432\u043D\u0438\u0442\u044C \u0446\u0435\u043D\u044B, \u0432\u044B\u0431\u0440\u0430\u0442\u044C \u043B\u0443\u0447\u0448\u0435\u0435 \u043F\u0440\u0435\u0434\u043B\u043E\u0436\u0435\u043D\u0438\u0435 \u043E\u0442 \u0441\u0430\u043B\u043E\u043D\u0430 \u043D\u0430 \u0441\u0430\u0439\u0442\u0435 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',
      title_uk: '\u041A\u0443\u043F\u0438\u0442\u0438 \u043D\u043E\u0432\u0438\u0439 ' + data.make + ' ' + data.model + ' ' + p.t(data.body) + ' \u0437 \u0441\u0430\u043B\u043E\u043D\u0443 \u0432 \u0423\u043A\u0440\u0430\u0457\u043D\u0456 - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',
      description_uk: '\u041F\u0440\u043E\u0434\u0430\u0436 \u043D\u043E\u0432\u0438\u0445 ' + data.make + ' ' + data.model + ' ' + p.t(data.body) + ' \u0432 \u0430\u0432\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u0423\u043A\u0440\u0430\u0457\u043D\u0438. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u044C. \u041F\u043E\u0440\u0456\u0432\u043D\u044F\u0442\u0438 \u0446\u0456\u043D\u0438, \u0432\u0438\u0431\u0440\u0430\u0442\u0438 \u043A\u0440\u0430\u0449\u0443 \u043F\u0440\u043E\u043F\u043E\u0437\u0438\u0446\u0456\u044E \u0432\u0456\u0434 \u0441\u0430\u043B\u043E\u043D\u0443 \u043D\u0430 \u0441\u0430\u0439\u0442\u0456 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440'
    };
  },
  bodyCityIsnewMakeModel: function bodyCityIsnewMakeModel(data, p) {
    return {
      header: p.newTxt + ' ' + p.t(data.body) + ' ' + data.make + ' ' + data.model + ' ' + p.inCity,
      title: '\u041A\u0443\u043F\u0438\u0442\u044C \u043D\u043E\u0432\u044B\u0439 ' + data.make + ' ' + data.model + ' ' + p.t(data.body) + ' \u0441 \u0441\u0430\u043B\u043E\u043D\u0430 ' + p.inCity + ' - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',
      description: '\u041F\u0440\u043E\u0434\u0430\u0436\u0430 \u043D\u043E\u0432\u044B\u0445 ' + data.make + ' ' + data.model + ' ' + p.t(data.body) + ' \u0432 \u0430\u0432\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u0433\u043E\u0440\u043E\u0434\u0430 ' + p.t(data.city) + '. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0439. \u0421\u0440\u0430\u0432\u043D\u0438\u0442\u044C \u0446\u0435\u043D\u044B, \u0432\u044B\u0431\u0440\u0430\u0442\u044C \u043B\u0443\u0447\u0448\u0435\u0435 \u043F\u0440\u0435\u0434\u043B\u043E\u0436\u0435\u043D\u0438\u0435 \u043E\u0442 \u0441\u0430\u043B\u043E\u043D\u0430 \u043D\u0430 \u0441\u0430\u0439\u0442\u0435 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',
      title_uk: '\u041A\u0443\u043F\u0438\u0442\u0438 \u043D\u043E\u0432\u0438\u0439 ' + data.make + ' ' + data.model + ' ' + p.t(data.body) + ' \u0437 \u0441\u0430\u043B\u043E\u043D\u0443 ' + p.inCity + ' - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',
      description_uk: '\u041F\u0440\u043E\u0434\u0430\u0436 \u043D\u043E\u0432\u0438\u0445 ' + data.make + ' ' + data.model + ' ' + p.t(data.body) + ' \u0432 \u0430\u0432\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u043C\u0456\u0441\u0442\u0430 ' + p.t(data.city) + '. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u044C. \u041F\u043E\u0440\u0456\u0432\u043D\u044F\u0442\u0438 \u0446\u0456\u043D\u0438, \u0432\u0438\u0431\u0440\u0430\u0442\u0438 \u043A\u0440\u0430\u0449\u0443 \u043F\u0440\u043E\u043F\u043E\u0437\u0438\u0446\u0456\u044E \u0432\u0456\u0434 \u0441\u0430\u043B\u043E\u043D\u0443 \u043D\u0430 \u0441\u0430\u0439\u0442\u0456 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440'
    };
  },
  countryIsnewMakeModel: function countryIsnewMakeModel(data, p) {
    return {
      title: '\u041A\u0443\u043F\u0438\u0442\u044C \u043D\u043E\u0432\u044B\u0439 ' + data.make + ' ' + data.model + ' ' + p.fromCountry + ' - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',
      description: '\u041A\u0443\u043F\u0438\u0442\u044C \u043D\u043E\u0432\u044B\u0439 ' + data.make + ' ' + data.model + ' \u043F\u0440\u0438\u0433\u043D\u0430\u043D\u043D\u044B\u0439 ' + p.fromCountry + '. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0439. \u0421\u0440\u0430\u0432\u043D\u0438\u0442\u044C \u0446\u0435\u043D\u044B, \u0432\u044B\u0431\u0440\u0430\u0442\u044C \u043B\u0443\u0447\u0448\u0435\u0435 \u043F\u0440\u0435\u0434\u043B\u043E\u0436\u0435\u043D\u0438\u0435 \u043D\u0430 \u0441\u0430\u0439\u0442\u0435 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',
      title_uk: '\u041A\u0443\u043F\u0438\u0442\u0438 \u043D\u043E\u0432\u0438\u0439 ' + data.make + ' ' + data.model + ' ' + p.fromCountry + ' - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',
      description_uk: '\u041A\u0443\u043F\u0438\u0442\u0438 \u043D\u043E\u0432\u0438\u0439 ' + data.make + ' ' + data.model + ' \u043F\u0440\u0438\u0433\u043D\u0430\u043D\u0438\u0439 ' + p.fromCountry + '. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u044C. \u041F\u043E\u0440\u0456\u0432\u043D\u044F\u0442\u0438 \u0446\u0456\u043D\u0438, \u0432\u0438\u0431\u0440\u0430\u0442\u0438 \u043A\u0440\u0430\u0449\u0443 \u043F\u0440\u043E\u043F\u043E\u0437\u0438\u0446\u0456\u044E \u043D\u0430 \u0441\u0430\u0439\u0442\u0456 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440'
    };
  },
  cityEngineIsnewYear: function cityEngineIsnewYear(data, p) {
    return {
      title: '\u041A\u0443\u043F\u0438\u0442\u044C \u043D\u043E\u0432\u044B\u0439 ' + p.t(data.engine) + ' \u0430\u0432\u0442\u043E ' + data.year + ' \u0433\u043E\u0434\u0430 \u0441 \u0441\u0430\u043B\u043E\u043D\u0430 ' + p.inCity + ' - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',
      description: '\u041F\u0440\u043E\u0434\u0430\u0436\u0430 \u043D\u043E\u0432\u044B\u0445 \u0430\u0432\u0442\u043E ' + p.t(data.engine) + ' ' + data.year + ' \u0433\u043E\u0434\u0430 \u0441 \u0441\u0430\u043B\u043E\u043D\u0430 ' + p.inCity + '. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043C\u0430\u0440\u043E\u043A \u0438 \u043C\u043E\u0434\u0435\u043B\u0435\u0439. \u0421\u0440\u0430\u0432\u043D\u0438\u0442\u044C \u0446\u0435\u043D\u044B, \u043F\u043E\u0441\u043C\u043E\u0442\u0440\u0435\u0442\u044C \u0444\u043E\u0442\u043E \u0432 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u044F\u0445 \u043E\u0442 \u0430\u0432\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u043E\u0432 \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',
      title_uk: '\u041A\u0443\u043F\u0438\u0442\u0438 \u043D\u043E\u0432\u0438\u0439 ' + p.t(data.engine) + ' \u0430\u0432\u0442\u043E ' + data.year + ' \u0440\u043E\u043A\u0443 \u0437 \u0441\u0430\u043B\u043E\u043D\u0443 ' + p.inCity + ' - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',
      description_uk: '\u041F\u0440\u043E\u0434\u0430\u0436 \u043D\u043E\u0432\u0438\u0445 \u0430\u0432\u0442\u043E ' + p.t(data.engine) + ' ' + data.year + ' \u0440\u043E\u043A\u0443 \u0437 \u0441\u0430\u043B\u043E\u043D\u0443 ' + p.inCity + '. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043C\u0430\u0440\u043E\u043A \u0456 \u043C\u043E\u0434\u0435\u043B\u0435\u0439. \u041F\u043E\u0440\u0456\u0432\u043D\u044F\u0442\u0438 \u0446\u0456\u043D\u0438, \u043F\u043E\u0434\u0438\u0432\u0438\u0442\u0438\u0441\u044F \u0444\u043E\u0442\u043E \u0432 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u043D\u044F\u0445 \u0432\u0456\u0434 \u0430\u0432\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0456\u0432 \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440'
    };
  }
};

/* harmony default export */ var templates_defaultExport = (avtoPathesHead);
// CONCATENATED MODULE: ./src/shared/helpers/seoTextFinder/seoTemplates/search/avto/index.js
var _AVTO;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



// To more readable code, try to use keys in alphabet order " { ab_bc_de: abBcDe }"
// body country city drive engine gearbox generation isNew location make makeTranslate model year
var AVTO = (_AVTO = {
  city: templates_defaultExport.city,
  // city: tpl.city,
  make: templates_defaultExport.make,
  country: templates_defaultExport.country,
  body: templates_defaultExport.body,
  engine: templates_defaultExport.engine,
  gearbox: templates_defaultExport.gearbox,
  year: templates_defaultExport.year,

  // 2
  make_model: templates_defaultExport.makeModel,
  country_make: templates_defaultExport.makeCountry,
  city_make: templates_defaultExport.makeCity,
  body_isnew: templates_defaultExport.bodyIsnew,
  body_city: templates_defaultExport.bodyCity,
  gearbox_isnew: templates_defaultExport.gearboxIsnew,
  city_gearbox: templates_defaultExport.gearboxCity,
  city_year: templates_defaultExport.cityYear,
  body_year: templates_defaultExport.bodyYear,

  city_engine: templates_defaultExport.cityEngine,
  body_make: templates_defaultExport.makeBody,
  engine_make: templates_defaultExport.makeEngine,
  gearbox_make: templates_defaultExport.makeGearbox,
  isnew_year: templates_defaultExport.isnewYear,
  city_isnew: templates_defaultExport.cityIsnew,

  // 3
  gearbox_isnew_make: templates_defaultExport.makeGearboxIsnew,
  city_gearbox_isnew: templates_defaultExport.gearboxIsnewCity,
  city_gearbox_make: templates_defaultExport.makeGearboxCity,
  engine_make_model: templates_defaultExport.engineMakeModel,
  body_make_model: templates_defaultExport.bodyMakeModel,
  body_isnew_make: templates_defaultExport.bodyIsnewMake,
  body_isnew_year: templates_defaultExport.bodyIsnewYear,
  country_make_model: templates_defaultExport.countryMakeModel,
  body_city_isnew: templates_defaultExport.bodyCityIsnew,
  body_city_make: templates_defaultExport.bodyCityMake,
  body_city_year: templates_defaultExport.bodyCityYear,
  city_engine_year: templates_defaultExport.cityEngineYear,
  make_model_year: templates_defaultExport.makeModelYear,
  city_make_model: templates_defaultExport.makeModelCity,
  gearbox_make_model: templates_defaultExport.gearboxMakeModel,
  city_isnew_year: templates_defaultExport.cityIsnewYear,

  // 4
  city_gearbox_isnew_make: templates_defaultExport.cityGearboxIsnewMake,
  city_engine_make_model: templates_defaultExport.makeModelEngineCity,
  city_gearbox_make_model: templates_defaultExport.cityGearboxMakeModel,
  body_city_make_model: templates_defaultExport.bodyCityMakeModel,
  body_city_isnew_make: templates_defaultExport.bodyCityIsnewMake,
  city_make_model_year: templates_defaultExport.cityMakeModelYear,
  body_isnew_make_model: templates_defaultExport.bodyIsnewMakeModel,

  // 5
  city_engine_make_model_year: templates_defaultExport.makeModelEngineCityYear,
  body_city_isnew_make_model: templates_defaultExport.bodyCityIsnewMakeModel,

  body_city_isnew_year: templates_defaultExport.bodyCityIsnewYear,
  city_engine_isnew_year: templates_defaultExport.cityEngineIsnewYear
}, _defineProperty(_AVTO, 'isnew_year', templates_defaultExport.isnewYear), _defineProperty(_AVTO, 'city_isnew_year', templates_defaultExport.cityIsnewYear), _defineProperty(_AVTO, 'city_isnew', templates_defaultExport.cityIsnew), _defineProperty(_AVTO, 'isnew_make_model_year', templates_defaultExport.isnewMakeModelYear), _defineProperty(_AVTO, 'city_isnew_make_model_year', templates_defaultExport.cityIsnewMakeModelYear), _defineProperty(_AVTO, 'gearbox_isnew_make_model', templates_defaultExport.gearboxIsnewMakeModel), _defineProperty(_AVTO, 'city_gearbox_isnew_make_model', templates_defaultExport.cityGearboxIsnewMakeModel), _defineProperty(_AVTO, 'engine_isnew_make_model', templates_defaultExport.engineIsnewMakeModel), _defineProperty(_AVTO, 'city_engine_isnew_make_model', templates_defaultExport.cityEngineIsnewMakeModel), _defineProperty(_AVTO, 'country_isnew_make_model', templates_defaultExport.countryIsnewMakeModel), _AVTO);
// CONCATENATED MODULE: ./src/shared/helpers/seoTextFinder/seoTemplates/search/moto/templates.js
var templates_avtoPathesHead = {
  city: function city(data, p) {
    return {
      header: "\u041A\u0443\u043F\u0438\u0442\u044C \u043C\u043E\u0442\u043E\u0442\u0435\u0445\u043D\u0438\u043A\u0443 \u0431\u0443 " + p.inCity,
      header_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043C\u043E\u0442\u043E\u0442\u0435\u0445\u043D\u0456\u043A\u0443 \u0431\u0443 " + p.inCity,

      title: "\u041C\u043E\u0442\u043E\u0442\u0435\u0445\u043D\u0438\u043A\u0430 " + p.t(data.city) + ". \u041F\u0440\u043E\u0434\u0430\u0436\u0430 \u043F\u043E\u0434\u0434\u0435\u0440\u0436\u0430\u043D\u043D\u043E\u0439 \u043C\u043E\u0442\u043E\u0442\u0435\u0445\u043D\u0438\u043A\u0438 - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      title_uk: "\u041C\u043E\u0442\u043E\u0442\u0435\u0445\u043D\u0456\u043A\u0430 " + p.t(data.city) + ". \u041F\u0440\u043E\u0434\u0430\u0436 \u043F\u0456\u0434\u0442\u0440\u0438\u043C\u0430\u043D\u043E\u0457 \u043C\u043E\u0442\u043E\u0442\u0435\u0445\u043D\u0456\u043A\u0456 - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",

      description: "\u041A\u0443\u043F\u0438\u0442\u044C \u043C\u043E\u0442\u043E\u0442\u0435\u0445\u043D\u0438\u043A\u0443 \u0431\u0443 " + p.inCity + ". \u041F\u0440\u043E\u0434\u0430\u0436\u0430 \u043F\u043E\u0434\u0434\u0435\u0440\u0436\u0430\u043D\u043D\u043E\u0439 \u043C\u043E\u0442\u043E\u0442\u0435\u0445\u043D\u0438\u043A\u0438 \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0439. \u0421\u0440\u0430\u0432\u043D\u0438\u0442\u044C \u0446\u0435\u043D\u044B. \u041F\u0440\u043E\u0432\u0435\u0440\u0435\u043D\u043D\u044B\u0435 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u044B",
      description_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043C\u043E\u0442\u043E\u0442\u0435\u0445\u043D\u0456\u043A\u0443 \u0431\u0443 " + p.inCity + ". \u041F\u0440\u043E\u0434\u0430\u0436 \u043F\u0456\u0434\u0442\u0440\u0438\u043C\u0430\u043D\u043E\u0457 \u043C\u043E\u0442\u043E\u0442\u0435\u0445\u043D\u0456\u043A\u0438 \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u044C. \u041F\u043E\u0440\u0456\u0432\u043D\u044F\u0442\u0438 \u0446\u0456\u043D\u0438. \u041F\u0435\u0440\u0435\u0432\u0456\u0440\u0435\u043D\u0456 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u0456"
    };
  }
};

/* harmony default export */ var moto_templates_defaultExport = (templates_avtoPathesHead);
// CONCATENATED MODULE: ./src/shared/helpers/seoTextFinder/seoTemplates/search/moto/index.js


var MOTO = {
  city: moto_templates_defaultExport.city
};
// CONCATENATED MODULE: ./src/shared/helpers/seoTextFinder/seoTemplates/search/mototsikl/templates.js
/* harmony default export */ var mototsikl_templates_defaultExport = ({
  city: function city(data, p) {
    return {
      title: "\u041A\u0443\u043F\u0438\u0442\u044C \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B \u0431\u0443 " + p.inCity + " \u0441 \u043F\u0440\u043E\u0431\u0435\u0433\u043E\u043C \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      title_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B \u0431\u0443 " + p.inCity + " \u0437 \u043F\u0440\u043E\u0431\u0456\u0433\u043E\u043C \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",

      description: "\u041F\u0440\u043E\u0434\u0430\u0436\u0430 \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B\u043E\u0432 \u0431\u0443 " + p.t(data.city) + ". \u041A\u0443\u043F\u0438\u0442\u044C \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B \u0431\u0443 " + p.inCity + " \u0441 \u043F\u0440\u043E\u0431\u0435\u0433\u043E\u043C \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u041F\u043E\u0434\u0435\u0440\u0436\u0430\u043D\u043D\u044B\u0435 \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B\u044B \u043E\u0442 \u043F\u0440\u043E\u0432\u0435\u0440\u0435\u043D\u043D\u044B\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u043E\u0432. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0439. \u0412\u044B\u0433\u043E\u0434\u043D\u0430\u044F \u0446\u0435\u043D\u0430",
      description_uk: "\u041F\u0440\u043E\u0434\u0430\u0436 \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B\u0456\u0432 \u0431\u0443 " + p.t(data.city) + ". \u041A\u0443\u043F\u0438\u0442\u0438 \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B \u0431\u0443 " + p.inCity + " \u0437 \u043F\u0440\u043E\u0431\u0456\u0433\u043E\u043C \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0412\u0436\u0438\u0432\u0430\u043D\u0456 \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B\u0438 \u0432\u0456\u0434 \u043F\u0435\u0440\u0435\u0432\u0456\u0440\u0435\u043D\u0438\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u0456\u0432. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u044C. \u0412\u0438\u0433\u0456\u0434\u043D\u0430 \u0446\u0456\u043D\u0430"
    };
  },

  make: function make(data, p) {
    return {
      header: "\u041C\u043E\u0442\u043E\u0446\u0438\u043A\u043B\u044B " + data.make,
      header_uk: "\u041C\u043E\u0442\u043E\u0446\u0438\u043A\u043B\u0438 " + data.make,

      title: "\u041C\u043E\u0442\u043E\u0446\u0438\u043A\u043B\u044B " + data.makeTranslit + " \u0432 \u0423\u043A\u0440\u0430\u0438\u043D\u0435, \u043A\u0443\u043F\u0438\u0442\u044C \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B " + data.make + " \u0431\u0443 \u0438\u043B\u0438 \u043D\u043E\u0432\u044B\u0439 - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      title_uk: "\u041C\u043E\u0442\u043E\u0446\u0438\u043A\u043B\u0438 " + data.makeTranslit + " \u0432 \u0423\u043A\u0440\u0430\u0457\u043D\u0456, \u043A\u0443\u043F\u0438\u0442\u0438 \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B " + data.make + " \u0431\u0443 \u0430\u0431\u043E \u043D\u043E\u0432\u0438\u0439 - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",

      description: "\u041A\u0443\u043F\u0438\u0442\u044C \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B " + data.make + " \u0441 \u043F\u0440\u043E\u0431\u0435\u0433\u043E\u043C \u0438\u043B\u0438 \u043D\u043E\u0432\u044B\u0439 \u2B50 \u0426\u0435\u043D\u044B \u043D\u0430 \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B\u044B, \u0445\u0430\u0440\u0430\u043A\u0442\u0435\u0440\u0438\u0441\u0442\u0438\u043A\u0438 \u0438 \u0444\u043E\u0442\u043E \u043D\u0430 \u0441\u0430\u0439\u0442\u0435 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      description_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B " + data.make + " \u0437 \u043F\u0440\u043E\u0431\u0456\u0433\u043E\u043C \u0430\u0431\u043E \u043D\u043E\u0432\u0438\u0439 \u2B50 \u0426\u0456\u043D\u0438 \u043D\u0430 \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B\u0438, \u0445\u0430\u0440\u0430\u043A\u0442\u0435\u0440\u0438\u0441\u0442\u0438\u043A\u0438 \u0442\u0430 \u0444\u043E\u0442\u043E \u043D\u0430 \u0441\u0430\u0439\u0442\u0456 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440"
    };
  },

  body: function body(data, p) {
    return {
      header: p.buy + " " + p.t(data.body).toLowerCase() + " \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B \u0431\u0443"
    };
  },

  makeModel: function makeModel(data, p) {
    return {
      header: p.buy + " \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " \u0431\u0443",

      title: "\u041A\u0443\u043F\u0438\u0442\u044C \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " \u0431\u0443 \u0432 \u0423\u043A\u0440\u0430\u0438\u043D\u0435 \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      title_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " \u0431\u0443 \u0432 \u0423\u043A\u0440\u0430\u0457\u043D\u0456 \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",

      description: "\u041F\u0440\u043E\u0434\u0430\u0436\u0430 \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B\u043E\u0432 " + data.make + " " + data.model + " \u0431\u0443 \u0432 \u0423\u043A\u0440\u0430\u0438\u043D\u0435. \u041A\u0443\u043F\u0438\u0442\u044C \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " \u0431\u0443 \u0441 \u043F\u0440\u043E\u0431\u0435\u0433\u043E\u043C \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u041F\u043E\u0434\u0435\u0440\u0436\u0430\u043D\u043D\u044B\u0435 \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B\u044B \u043E\u0442 \u043F\u0440\u043E\u0432\u0435\u0440\u0435\u043D\u043D\u044B\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u043E\u0432. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0439",
      description_uk: "\u041F\u0440\u043E\u0434\u0430\u0436 \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B\u0456\u0432 " + data.make + " " + data.model + " \u0431\u0443 \u0432 \u0423\u043A\u0440\u0430\u0457\u043D\u0456. \u041A\u0443\u043F\u0438\u0442\u0438 \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " \u0431\u0443 \u0437 \u043F\u0440\u043E\u0431\u0456\u0433\u043E\u043C \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0412\u0436\u0438\u0432\u0430\u043D\u0456 \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B\u0438 \u0432\u0456\u0434 \u043F\u0435\u0440\u0435\u0432\u0456\u0440\u0435\u043D\u0438\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u0456\u0432. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u044C"
    };
  },
  cityMake: function cityMake(data, p) {
    return {
      title: "\u041A\u0443\u043F\u0438\u0442\u044C \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B " + data.make + " \u0431\u0443 " + p.inCity + " - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      title_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B " + data.make + " \u0431\u0443 " + p.inCity + " - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",

      description: "\u041F\u0440\u043E\u0434\u0430\u0436\u0430 \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B\u043E\u0432 " + data.make + " \u0431\u0443 " + p.t(data.city) + ". \u041A\u0443\u043F\u0438\u0442\u044C \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B " + data.make + " \u0431\u0443 \u0441 \u043F\u0440\u043E\u0431\u0435\u0433\u043E\u043C \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0439 " + p.inCity + ". \u0421\u0440\u0430\u0432\u043D\u0438\u0442\u044C \u0446\u0435\u043D\u044B, \u043F\u043E\u0441\u043C\u043E\u0442\u0440\u0435\u0442\u044C \u0444\u043E\u0442\u043E",
      description_uk: "\u041F\u0440\u043E\u0434\u0430\u0436 \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B\u0456\u0432 " + data.make + " \u0431\u0443 " + p.t(data.city) + ". \u041A\u0443\u043F\u0438\u0442\u0438 \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B " + data.make + " \u0431\u0443 \u0437 \u043F\u0440\u043E\u0431\u0456\u0433\u043E\u043C \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u044C " + p.inCity + ". \u041F\u043E\u0440\u0456\u0432\u043D\u044F\u0442\u0438 \u0446\u0456\u043D\u0438, \u043F\u043E\u0434\u0438\u0432\u0438\u0442\u0438\u0441\u044F \u0444\u043E\u0442\u043E"
    };
  },
  cityIsnew: function cityIsnew(data, p) {
    return {
      title: "\u041A\u0443\u043F\u0438\u0442\u044C \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B \u043D\u043E\u0432\u044B\u0439 " + p.inCity + " \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      title_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B \u043D\u043E\u0432\u0438\u0439 " + p.inCity + " \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      description: "\u041A\u0443\u043F\u0438\u0442\u044C \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B \u043D\u043E\u0432\u044B\u0439 " + p.inCity + " \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0439. \u0421\u0440\u0430\u0432\u043D\u0438\u0442\u044C \u0446\u0435\u043D\u044B \u0432 \u043C\u043E\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u0438 \u043E\u0442 \u0447\u0430\u0441\u0442\u043D\u044B\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u043E\u0432",
      description_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B \u043D\u043E\u0432\u0438\u0439 " + p.inCity + " \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u044C. \u041F\u043E\u0440\u0456\u0432\u043D\u044F\u0442\u0438 \u0446\u0456\u043D\u0438 \u0432 \u043C\u043E\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u0456 \u0432\u0456\u0434 \u043F\u0440\u0438\u0432\u0430\u0442\u043D\u0438\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u0456\u0432"
    };
  },
  makeIsnew: function makeIsnew(data, p) {
    return {
      title: "\u041A\u0443\u043F\u0438\u0442\u044C \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B " + data.make + " \u043D\u043E\u0432\u044B\u0439 \u0432 \u0423\u043A\u0440\u0430\u0438\u043D\u0435 \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      title_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B " + data.make + " \u043D\u043E\u0432\u0438\u0439 \u0432 \u0423\u043A\u0440\u0430\u0457\u043D\u0456 \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      description: "\u041A\u0443\u043F\u0438\u0442\u044C \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B " + data.make + " \u043D\u043E\u0432\u044B\u0439 \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0439. \u0421\u0440\u0430\u0432\u043D\u0438\u0442\u044C \u0446\u0435\u043D\u044B \u0432 \u043C\u043E\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u0438 \u043E\u0442 \u0447\u0430\u0441\u0442\u043D\u044B\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u043E\u0432",
      description_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B " + data.make + " \u043D\u043E\u0432\u0438\u0439 \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u044C. \u041F\u043E\u0440\u0456\u0432\u043D\u044F\u0442\u0438 \u0446\u0456\u043D\u0438 \u0432 \u043C\u043E\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u0456 \u0432\u0456\u0434 \u043F\u0440\u0438\u0432\u0430\u0442\u043D\u0438\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u0456\u0432"
    };
  },
  makeBody: function makeBody(data, p) {
    return {
      header: p.buy + " " + p.t(data.body).toLowerCase() + " \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B " + data.make + " \u0431\u0443"
    };
  },
  bodyIsnew: function bodyIsnew(data, p) {
    return {
      header: "\u041A\u0443\u043F\u0438\u0442\u044C \u043D\u043E\u0432\u044B\u0439 " + p.t(data.body).toLowerCase() + " \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B",
      header_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043D\u043E\u0432\u0438\u0439 " + p.t(data.body).toLowerCase() + " \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B"
    };
  },
  bodyCity: function bodyCity(data, p) {
    return {
      header: p.buy + " " + p.t(data.body).toLowerCase() + " \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B \u0431\u0443 " + p.inCity
    };
  },

  makeModelCity: function makeModelCity(data, p) {
    return {
      header: p.buy + " \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " \u0431\u0443 " + p.inCity,

      title: "\u041A\u0443\u043F\u0438\u0442\u044C \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " \u0431\u0443 " + p.inCity + " - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      title_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " \u0431\u0443 " + p.inCity + " - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",

      description: "\u041F\u0440\u043E\u0434\u0430\u0436\u0430 \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B\u043E\u0432 " + data.make + " " + data.model + " \u0431\u0443 " + p.t(data.city) + ". \u041A\u0443\u043F\u0438\u0442\u044C \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " \u0431\u0443 \u0441 \u043F\u0440\u043E\u0431\u0435\u0433\u043E\u043C \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0439 " + p.inCity + ". \u0421\u0440\u0430\u0432\u043D\u0438\u0442\u044C \u0446\u0435\u043D\u044B, \u043F\u043E\u0441\u043C\u043E\u0442\u0440\u0435\u0442\u044C \u0444\u043E\u0442\u043E",
      description_uk: "\u041F\u0440\u043E\u0434\u0430\u0436 \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B\u0456\u0432 " + data.make + " " + data.model + " \u0431\u0443 " + p.t(data.city) + ". \u041A\u0443\u043F\u0438\u0442\u0438 \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " \u0431\u0443 \u0437 \u043F\u0440\u043E\u0431\u0456\u0433\u043E\u043C \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u044C " + p.inCity + ". \u041F\u043E\u0440\u0456\u0432\u043D\u044F\u0442\u0438 \u0446\u0456\u043D\u0438, \u043F\u043E\u0434\u0438\u0432\u0438\u0442\u0438\u0441\u044F \u0444\u043E\u0442\u043E"
    };
  },
  makeModelIsnew: function makeModelIsnew(data, p) {
    return {
      header: "\u041A\u0443\u043F\u0438\u0442\u044C \u043D\u043E\u0432\u044B\u0439 \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B " + data.make + " " + data.model,
      header_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043D\u043E\u0432\u0438\u0439 \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B " + data.make + " " + data.model,

      title: "\u041A\u0443\u043F\u0438\u0442\u044C \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " \u043D\u043E\u0432\u044B\u0439 \u0432 \u0423\u043A\u0440\u0430\u0438\u043D\u0435 \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      title_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " \u043D\u043E\u0432\u0438\u0439 \u0432 \u0423\u043A\u0440\u0430\u0457\u043D\u0456 \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",

      description: "\u041A\u0443\u043F\u0438\u0442\u044C \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " \u043D\u043E\u0432\u044B\u0439 \u0432 \u0423\u043A\u0440\u0430\u0438\u043D\u0435 \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0439. \u0421\u0440\u0430\u0432\u043D\u0438\u0442\u044C \u0446\u0435\u043D\u044B \u0432 \u043C\u043E\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u0438 \u043E\u0442 \u0447\u0430\u0441\u0442\u043D\u044B\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u043E\u0432",
      description_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " \u043D\u043E\u0432\u0438\u0439 \u0432 \u0423\u043A\u0440\u0430\u0457\u043D\u0456 \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u044C. \u041F\u043E\u0440\u0456\u0432\u043D\u044F\u0442\u0438 \u0446\u0456\u043D\u0438 \u0432 \u043C\u043E\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u0456 \u0432\u0456\u0434 \u043F\u0440\u0438\u0432\u0430\u0442\u043D\u0438\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u0456\u0432"
    };
  },
  makeCityIsnew: function makeCityIsnew(data, p) {
    return {
      title: "\u041A\u0443\u043F\u0438\u0442\u044C \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B " + data.make + " \u043D\u043E\u0432\u044B\u0439 " + p.inCity + " - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      title_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B " + data.make + " \u043D\u043E\u0432\u0438\u0439 " + p.inCity + " - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      description: "\u041A\u0443\u043F\u0438\u0442\u044C \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B " + data.make + " \u043D\u043E\u0432\u044B\u0439 " + p.inCity + " \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0439. \u0421\u0440\u0430\u0432\u043D\u0438\u0442\u044C \u0446\u0435\u043D\u044B \u0432 \u043C\u043E\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u0438 \u043E\u0442 \u0447\u0430\u0441\u0442\u043D\u044B\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u043E\u0432",
      description_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B " + data.make + " \u043D\u043E\u0432\u0438\u0439 " + p.inCity + " \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u044C. \u041F\u043E\u0440\u0456\u0432\u043D\u044F\u0442\u0438 \u0446\u0456\u043D\u0438 \u0432 \u043C\u043E\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u0456 \u0432\u0456\u0434 \u043F\u0440\u0438\u0432\u0430\u0442\u043D\u0438\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u0456\u0432"
    };
  },
  makeModelBody: function makeModelBody(data, p) {
    return {
      header: "\u041A\u0443\u043F\u0438\u0442\u044C " + p.t(data.body).toLowerCase() + " \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " \u0431\u0443",
      header_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 " + p.t(data.body).toLowerCase() + " \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " \u0431\u0443"
    };
  },
  makeModelYear: function makeModelYear(data, p) {
    return {
      header: "\u041A\u0443\u043F\u0438\u0442\u044C \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " " + data.year + " \u0433\u043E\u0434\u0430 \u0431\u0443",
      header_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " " + data.year + " \u0440\u043E\u043A\u0443 \u0431\u0443"
    };
  },
  isnewMakeBody: function isnewMakeBody(data, p) {
    return {
      header: "\u041A\u0443\u043F\u0438\u0442\u044C \u043D\u043E\u0432\u044B\u0439 " + p.t(data.body).toLowerCase() + " \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B " + data.make,
      header_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043D\u043E\u0432\u0438\u0439 " + p.t(data.body).toLowerCase() + " \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B " + data.make
    };
  },
  makeCityBody: function makeCityBody(data, p) {
    return {
      header: p.buy + " " + p.t(data.body).toLowerCase() + " \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B " + data.make + " \u0431\u0443 " + p.inCity
    };
  },
  isnewBodyCity: function isnewBodyCity(data, p) {
    return {
      header: "\u041A\u0443\u043F\u0438\u0442\u044C \u043D\u043E\u0432\u044B\u0439 " + p.t(data.body).toLowerCase() + " \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B " + p.inCity,
      header_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043D\u043E\u0432\u0438\u0439 " + p.t(data.body).toLowerCase() + " \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B " + p.inCity
    };
  },

  isnewMakeModelYear: function isnewMakeModelYear(data, p) {
    return {
      header: "\u041A\u0443\u043F\u0438\u0442\u044C \u043D\u043E\u0432\u044B\u0439 \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " " + data.year + " \u0433\u043E\u0434\u0430",
      header_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043D\u043E\u0432\u0438\u0439 \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " " + data.year + " \u0440\u043E\u043A\u0443",

      title: "\u041A\u0443\u043F\u0438\u0442\u044C \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " " + data.year + " \u043D\u043E\u0432\u044B\u0439 \u0432 \u0423\u043A\u0440\u0430\u0438\u043D\u0435 - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      title_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " " + data.year + " \u043D\u043E\u0432\u0438\u0439 \u0432 \u0423\u043A\u0440\u0430\u0457\u043D\u0456 - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      description: "\u041A\u0443\u043F\u0438\u0442\u044C \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " " + data.year + " \u043D\u043E\u0432\u044B\u0439 \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0439. \u0421\u0440\u0430\u0432\u043D\u0438\u0442\u044C \u0446\u0435\u043D\u044B \u0432 \u043C\u043E\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u0438 \u043E\u0442 \u0447\u0430\u0441\u0442\u043D\u044B\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u043E\u0432",
      description_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " " + data.year + " \u043D\u043E\u0432\u0438\u0439 \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u044C. \u041F\u043E\u0440\u0456\u0432\u043D\u044F\u0442\u0438 \u0446\u0456\u043D\u0438 \u0432 \u043C\u043E\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u0456 \u0432\u0456\u0434 \u043F\u0440\u0438\u0432\u0430\u0442\u043D\u0438\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u0456\u0432"
    };
  },
  isnewMakeModelCity: function isnewMakeModelCity(data, p) {
    return {
      header: "\u041A\u0443\u043F\u0438\u0442\u044C \u043D\u043E\u0432\u044B\u0439 \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " " + p.inCity,
      header_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043D\u043E\u0432\u0438\u0439 \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " " + p.inCity,

      title: "\u041A\u0443\u043F\u0438\u0442\u044C \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " \u043D\u043E\u0432\u044B\u0439 " + p.inCity + " - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      title_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " \u043D\u043E\u0432\u0438\u0439 " + p.inCity + " - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      description: "\u041A\u0443\u043F\u0438\u0442\u044C \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " \u043D\u043E\u0432\u044B\u0439 " + p.inCity + " \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0439. \u0421\u0440\u0430\u0432\u043D\u0438\u0442\u044C \u0446\u0435\u043D\u044B \u0432 \u043C\u043E\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u0438 \u043E\u0442 \u0447\u0430\u0441\u0442\u043D\u044B\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u043E\u0432",
      description_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " \u043D\u043E\u0432\u0438\u0439 " + p.inCity + " \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u044C. \u041F\u043E\u0440\u0456\u0432\u043D\u044F\u0442\u0438 \u0446\u0456\u043D\u0438 \u0432 \u043C\u043E\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u0456 \u0432\u0456\u0434 \u043F\u0440\u0438\u0432\u0430\u0442\u043D\u0438\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u0456\u0432"
    };
  },
  isnewMakeModelBody: function isnewMakeModelBody(data, p) {
    return {
      header: "\u041A\u0443\u043F\u0438\u0442\u044C \u043D\u043E\u0432\u044B\u0439 " + p.t(data.body).toLowerCase() + " \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B " + data.make + " " + data.model,
      header_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043D\u043E\u0432\u0438\u0439 " + p.t(data.body).toLowerCase() + " \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B " + data.make + " " + data.model
    };
  },
  makeModelCityBody: function makeModelCityBody(data, p) {
    return {
      header: "\u041A\u0443\u043F\u0438\u0442\u044C " + p.t(data.body).toLowerCase() + " \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " \u0431\u0443 " + p.inCity,
      header_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 " + p.t(data.body).toLowerCase() + " \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " \u0431\u0443 " + p.inCity
    };
  },
  isnewMakeCityBody: function isnewMakeCityBody(data, p) {
    return {
      header: "\u041A\u0443\u043F\u0438\u0442\u044C \u043D\u043E\u0432\u044B\u0439 " + p.t(data.body).toLowerCase() + " \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B " + data.make + " " + p.inCity,
      header_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043D\u043E\u0432\u0438\u0439 " + p.t(data.body).toLowerCase() + " \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B " + data.make + " " + p.inCity
    };
  },

  isnewMakeModelCityBody: function isnewMakeModelCityBody(data, p) {
    return {
      header: "\u041A\u0443\u043F\u0438\u0442\u044C \u043D\u043E\u0432\u044B\u0439 " + p.t(data.body).toLowerCase() + " \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " " + p.inCity,
      header_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043D\u043E\u0432\u0438\u0439 " + p.t(data.body).toLowerCase() + " \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " " + p.inCity
    };
  }
});
// CONCATENATED MODULE: ./src/shared/helpers/seoTextFinder/seoTemplates/search/mototsikl/index.js


var MOTOTSIKL = {
  city: mototsikl_templates_defaultExport.city,
  body: mototsikl_templates_defaultExport.body,

  make: mototsikl_templates_defaultExport.make,

  make_model: mototsikl_templates_defaultExport.makeModel,
  city_make: mototsikl_templates_defaultExport.cityMake,
  city_isnew: mototsikl_templates_defaultExport.cityIsnew,
  isnew_make: mototsikl_templates_defaultExport.makeIsnew,
  body_make: mototsikl_templates_defaultExport.makeBody,
  body_isnew: mototsikl_templates_defaultExport.bodyIsnew,
  body_city: mototsikl_templates_defaultExport.bodyCity,

  city_make_model: mototsikl_templates_defaultExport.makeModelCity,
  isnew_make_model: mototsikl_templates_defaultExport.makeModelIsnew,
  city_isnew_make: mototsikl_templates_defaultExport.makeCityIsnew,
  body_make_model: mototsikl_templates_defaultExport.makeModelBody,
  make_model_year: mototsikl_templates_defaultExport.makeModelYear,
  body_isnew_make: mototsikl_templates_defaultExport.isnewMakeBody,
  body_city_make: mototsikl_templates_defaultExport.makeCityBody,
  body_city_isnew: mototsikl_templates_defaultExport.isnewBodyCity,

  isnew_make_model_year: mototsikl_templates_defaultExport.isnewMakeModelYear,
  city_isnew_make_model: mototsikl_templates_defaultExport.isnewMakeModelCity,
  body_isnew_make_model: mototsikl_templates_defaultExport.isnewMakeModelBody,
  body_city_make_model: mototsikl_templates_defaultExport.makeModelCityBody,
  body_city_isnew_make: mototsikl_templates_defaultExport.isnewMakeCityBody,

  body_city_isnew_make_model: mototsikl_templates_defaultExport.isnewMakeModelCityBody
};
// CONCATENATED MODULE: ./src/shared/helpers/seoTextFinder/seoTemplates/search/skuter/templates.js
var skuter_templates_avtoPathesHead = {
  make: function make(data, p) {
    return {
      header: "\u0421\u043A\u0443\u0442\u0435\u0440\u044B " + data.make,
      header_uk: "\u0421\u043A\u0443\u0442\u0435\u0440\u0438 " + data.make,

      title: "\u0421\u043A\u0443\u0442\u0435\u0440\u044B " + data.makeTranslit + " \u0432 \u0423\u043A\u0440\u0430\u0438\u043D\u0435, \u043A\u0443\u043F\u0438\u0442\u044C \u0441\u043A\u0443\u0442\u0435\u0440 " + data.make + " \u0431\u0443 \u0438\u043B\u0438 \u043D\u043E\u0432\u044B\u0439 - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      title_uk: "\u0421\u043A\u0443\u0442\u0435\u0440\u0438 " + data.makeTranslit + " \u0432 \u0423\u043A\u0440\u0430\u0457\u043D\u0456, \u043A\u0443\u043F\u0438\u0442\u0438 \u0441\u043A\u0443\u0442\u0435\u0440 " + data.make + " \u0431\u0443 \u0430\u0431\u043E \u043D\u043E\u0432\u0438\u0439 - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",

      description: "\u041A\u0443\u043F\u0438\u0442\u044C \u0441\u043A\u0443\u0442\u0435\u0440 " + data.make + " \u0441 \u043F\u0440\u043E\u0431\u0435\u0433\u043E\u043C \u0438\u043B\u0438 \u043D\u043E\u0432\u044B\u0439 \u2B50 \u0426\u0435\u043D\u044B \u043D\u0430 \u0441\u043A\u0443\u0442\u0435\u0440\u0438, \u0445\u0430\u0440\u0430\u043A\u0442\u0435\u0440\u0438\u0441\u0442\u0438\u043A\u0438 \u0438 \u0444\u043E\u0442\u043E \u043D\u0430 \u0441\u0430\u0439\u0442\u0435 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      description_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u0441\u043A\u0443\u0442\u0435\u0440 " + data.make + " \u0437 \u043F\u0440\u043E\u0431\u0456\u0433\u043E\u043C \u0430\u0431\u043E \u043D\u043E\u0432\u0438\u0439 \u2B50 \u0426\u0456\u043D\u0438 \u043D\u0430 \u0441\u043A\u0443\u0442\u0435\u0440\u0438, \u0445\u0430\u0440\u0430\u043A\u0442\u0435\u0440\u0438\u0441\u0442\u0438\u043A\u0438 \u0442\u0430 \u0444\u043E\u0442\u043E \u043D\u0430 \u0441\u0430\u0439\u0442\u0456 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440"
    };
  },
  body: function body(data, p) {
    return {
      header: p.buy + " " + p.t(data.body).toLowerCase() + " \u0441\u043A\u0443\u0442\u0435\u0440 \u0431\u0443"
    };
  },

  makeCity: function makeCity(data, p) {
    return {
      title: "\u041A\u0443\u043F\u0438\u0442\u044C \u0441\u043A\u0443\u0442\u0435\u0440 " + data.make + " \u0431\u0443 " + p.inCity + " - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      title_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u0441\u043A\u0443\u0442\u0435\u0440 " + data.make + " \u0431\u0443 " + p.inCity + " - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",

      description: "\u041F\u0440\u043E\u0434\u0430\u0436\u0430 \u0441\u043A\u0443\u0442\u0435\u0440\u043E\u0432 " + data.make + " \u0431\u0443 " + p.t(data.city) + ". \u041A\u0443\u043F\u0438\u0442\u044C \u0441\u043A\u0443\u0442\u0435\u0440 " + data.make + " \u0431\u0443 \u0441 \u043F\u0440\u043E\u0431\u0435\u0433\u043E\u043C \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0439 " + p.inCity + ". \u0421\u0440\u0430\u0432\u043D\u0438\u0442\u044C \u0446\u0435\u043D\u044B, \u043F\u043E\u0441\u043C\u043E\u0442\u0440\u0435\u0442\u044C \u0444\u043E\u0442\u043E",
      description_uk: "\u041F\u0440\u043E\u0434\u0430\u0436 \u0441\u043A\u0443\u0442\u0435\u0440\u0456\u0432 " + data.make + " \u0431\u0443 " + p.t(data.city) + ". \u041A\u0443\u043F\u0438\u0442\u0438 \u0441\u043A\u0443\u0442\u0435\u0440 " + data.make + " \u0431\u0443 \u0437 \u043F\u0440\u043E\u0431\u0456\u0433\u043E\u043C \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u044C " + p.inCity + ". \u041F\u043E\u0440\u0456\u0432\u043D\u044F\u0442\u0438 \u0446\u0456\u043D\u0438, \u043F\u043E\u0434\u0438\u0432\u0438\u0442\u0438\u0441\u044F \u0444\u043E\u0442\u043E"
    };
  },
  makeModel: function makeModel(data, p) {
    return {
      header: p.buy + " \u0441\u043A\u0443\u0442\u0435\u0440 " + data.make + " " + data.model + " \u0431\u0443",

      title: "\u041A\u0443\u043F\u0438\u0442\u044C \u0441\u043A\u0443\u0442\u0435\u0440 " + data.make + " " + data.model + " \u0431\u0443 \u0432 \u0423\u043A\u0440\u0430\u0438\u043D\u0435 \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      title_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u0441\u043A\u0443\u0442\u0435\u0440 " + data.make + " " + data.model + " \u0431\u0443 \u0432 \u0423\u043A\u0440\u0430\u0457\u043D\u0456 \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",

      description: "\u041F\u0440\u043E\u0434\u0430\u0436\u0430 \u0441\u043A\u0443\u0442\u0435\u0440\u043E\u0432 " + data.make + " " + data.model + " \u0431\u0443 \u0432 \u0423\u043A\u0440\u0430\u0438\u043D\u0435. \u041A\u0443\u043F\u0438\u0442\u044C \u0441\u043A\u0443\u0442\u0435\u0440 " + data.make + " " + data.model + " \u0431\u0443 \u0441 \u043F\u0440\u043E\u0431\u0435\u0433\u043E\u043C \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u041F\u043E\u0434\u0435\u0440\u0436\u0430\u043D\u043D\u044B\u0435 \u0441\u043A\u0443\u0442\u0435\u0440\u044B \u043E\u0442 \u043F\u0440\u043E\u0432\u0435\u0440\u0435\u043D\u043D\u044B\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u043E\u0432. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0439",
      description_uk: "\u041F\u0440\u043E\u0434\u0430\u0436 \u0441\u043A\u0443\u0442\u0435\u0440\u0456\u0432 " + data.make + " " + data.model + " \u0431\u0443 \u0432 \u0423\u043A\u0440\u0430\u0457\u043D\u0456. \u041A\u0443\u043F\u0438\u0442\u0438 \u0441\u043A\u0443\u0442\u0435\u0440 " + data.make + " " + data.model + " \u0431\u0443 \u0437 \u043F\u0440\u043E\u0431\u0456\u0433\u043E\u043C \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0412\u0436\u0438\u0432\u0430\u043D\u0456 \u0441\u043A\u0443\u0442\u0435\u0440\u0438 \u0432\u0456\u0434 \u043F\u0435\u0440\u0435\u0432\u0456\u0440\u0435\u043D\u0438\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u0456\u0432. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u044C"
    };
  },
  cityIsnew: function cityIsnew(data, p) {
    return {
      title: "\u041A\u0443\u043F\u0438\u0442\u044C \u0441\u043A\u0443\u0442\u0435\u0440 \u043D\u043E\u0432\u044B\u0439 " + p.inCity + " \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      title_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u0441\u043A\u0443\u0442\u0435\u0440 \u043D\u043E\u0432\u0438\u0439 " + p.inCity + " \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      description: "\u041A\u0443\u043F\u0438\u0442\u044C \u0441\u043A\u0443\u0442\u0435\u0440 \u043D\u043E\u0432\u044B\u0439 " + p.inCity + " \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0439. \u0421\u0440\u0430\u0432\u043D\u0438\u0442\u044C \u0446\u0435\u043D\u044B \u0432 \u043C\u043E\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u0438 \u043E\u0442 \u0447\u0430\u0441\u0442\u043D\u044B\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u043E\u0432",
      description_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u0441\u043A\u0443\u0442\u0435\u0440 \u043D\u043E\u0432\u0438\u0439 " + p.inCity + " \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u044C. \u041F\u043E\u0440\u0456\u0432\u043D\u044F\u0442\u0438 \u0446\u0456\u043D\u0438 \u0432 \u043C\u043E\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u0456 \u0432\u0456\u0434 \u043F\u0440\u0438\u0432\u0430\u0442\u043D\u0438\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u0456\u0432"
    };
  },
  makeIsnew: function makeIsnew(data, p) {
    return {
      title: "\u041A\u0443\u043F\u0438\u0442\u044C \u0441\u043A\u0443\u0442\u0435\u0440 " + data.make + " \u043D\u043E\u0432\u044B\u0439 \u0432 \u0423\u043A\u0440\u0430\u0438\u043D\u0435 \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      title_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u0441\u043A\u0443\u0442\u0435\u0440 " + data.make + " \u043D\u043E\u0432\u0438\u0439 \u0432 \u0423\u043A\u0440\u0430\u0457\u043D\u0456 \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      description: "\u041A\u0443\u043F\u0438\u0442\u044C \u0441\u043A\u0443\u0442\u0435\u0440 " + data.make + " \u043D\u043E\u0432\u044B\u0439 \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0439. \u0421\u0440\u0430\u0432\u043D\u0438\u0442\u044C \u0446\u0435\u043D\u044B \u0432 \u043C\u043E\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u0438 \u043E\u0442 \u0447\u0430\u0441\u0442\u043D\u044B\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u043E\u0432",
      description_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u0441\u043A\u0443\u0442\u0435\u0440 " + data.make + " \u043D\u043E\u0432\u0438\u0439 \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u044C. \u041F\u043E\u0440\u0456\u0432\u043D\u044F\u0442\u0438 \u0446\u0456\u043D\u0438 \u0432 \u043C\u043E\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u0456 \u0432\u0456\u0434 \u043F\u0440\u0438\u0432\u0430\u0442\u043D\u0438\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u0456\u0432"
    };
  },
  makeBody: function makeBody(data, p) {
    return {
      header: p.buy + " " + p.t(data.body).toLowerCase() + " \u0441\u043A\u0443\u0442\u0435\u0440 " + data.make + " \u0431\u0443"
    };
  },
  bodyIsnew: function bodyIsnew(data, p) {
    return {
      header: "\u041A\u0443\u043F\u0438\u0442\u044C \u043D\u043E\u0432\u044B\u0439 " + p.t(data.body).toLowerCase() + " \u0441\u043A\u0443\u0442\u0435\u0440",
      header_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043D\u043E\u0432\u0438\u0439 " + p.t(data.body).toLowerCase() + " \u0441\u043A\u0443\u0442\u0435\u0440"
    };
  },
  cityBody: function cityBody(data, p) {
    return {
      header: p.buy + " " + p.t(data.body).toLowerCase() + " \u0441\u043A\u0443\u0442\u0435\u0440 \u0431\u0443 " + p.inCity
    };
  },

  cityMakeModel: function cityMakeModel(data, p) {
    return {
      header: p.buy + " \u0441\u043A\u0443\u0442\u0435\u0440 " + data.make + " " + data.model + " \u0431\u0443 " + p.inCity,

      title: "\u041A\u0443\u043F\u0438\u0442\u044C \u0441\u043A\u0443\u0442\u0435\u0440 " + data.make + " " + data.model + " \u0431\u0443 " + p.inCity + " - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      title_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u0441\u043A\u0443\u0442\u0435\u0440 " + data.make + " " + data.model + " \u0431\u0443 " + p.inCity + " - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",

      description: "\u041F\u0440\u043E\u0434\u0430\u0436\u0430 \u0441\u043A\u0443\u0442\u0435\u0440\u043E\u0432 " + data.make + " " + data.model + " \u0431\u0443 " + p.t(data.city) + ". \u041A\u0443\u043F\u0438\u0442\u044C \u0441\u043A\u0443\u0442\u0435\u0440 " + data.make + " " + data.model + " \u0431\u0443 \u0441 \u043F\u0440\u043E\u0431\u0435\u0433\u043E\u043C \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0439 " + p.inCity + ". \u0421\u0440\u0430\u0432\u043D\u0438\u0442\u044C \u0446\u0435\u043D\u044B, \u043F\u043E\u0441\u043C\u043E\u0442\u0440\u0435\u0442\u044C \u0444\u043E\u0442\u043E",
      description_uk: "\u041F\u0440\u043E\u0434\u0430\u0436 \u0441\u043A\u0443\u0442\u0435\u0440\u0456\u0432 " + data.make + " " + data.model + " \u0431\u0443 " + p.t(data.city) + ". \u041A\u0443\u043F\u0438\u0442\u0438 \u0441\u043A\u0443\u0442\u0435\u0440 " + data.make + " " + data.model + " \u0431\u0443 \u0437 \u043F\u0440\u043E\u0431\u0456\u0433\u043E\u043C \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u044C " + p.inCity + ". \u041F\u043E\u0440\u0456\u0432\u043D\u044F\u0442\u0438 \u0446\u0456\u043D\u0438, \u043F\u043E\u0434\u0438\u0432\u0438\u0442\u0438\u0441\u044F \u0444\u043E\u0442\u043E"
    };
  },
  makeModelIsnew: function makeModelIsnew(data, p) {
    return {
      header: "\u041A\u0443\u043F\u0438\u0442\u044C \u043D\u043E\u0432\u044B\u0439 \u0441\u043A\u0443\u0442\u0435\u0440 " + data.make + " " + data.model,
      header_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043D\u043E\u0432\u0438\u0439 \u0441\u043A\u0443\u0442\u0435\u0440 " + data.make + " " + data.model,

      title: "\u041A\u0443\u043F\u0438\u0442\u044C \u0441\u043A\u0443\u0442\u0435\u0440 " + data.make + " " + data.model + " \u043D\u043E\u0432\u044B\u0439 \u0432 \u0423\u043A\u0440\u0430\u0438\u043D\u0435 \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      title_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u0441\u043A\u0443\u0442\u0435\u0440 " + data.make + " " + data.model + " \u043D\u043E\u0432\u0438\u0439 \u0432 \u0423\u043A\u0440\u0430\u0457\u043D\u0456 \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",

      description: "\u041A\u0443\u043F\u0438\u0442\u044C \u0441\u043A\u0443\u0442\u0435\u0440 " + data.make + " " + data.model + " \u043D\u043E\u0432\u044B\u0439 \u0432 \u0423\u043A\u0440\u0430\u0438\u043D\u0435 \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0439. \u0421\u0440\u0430\u0432\u043D\u0438\u0442\u044C \u0446\u0435\u043D\u044B \u0432 \u043C\u043E\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u0438 \u043E\u0442 \u0447\u0430\u0441\u0442\u043D\u044B\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u043E\u0432",
      description_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u0441\u043A\u0443\u0442\u0435\u0440 " + data.make + " " + data.model + " \u043D\u043E\u0432\u0438\u0439 \u0432 \u0423\u043A\u0440\u0430\u0457\u043D\u0456 \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u044C. \u041F\u043E\u0440\u0456\u0432\u043D\u044F\u0442\u0438 \u0446\u0456\u043D\u0438 \u0432 \u043C\u043E\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u0456 \u0432\u0456\u0434 \u043F\u0440\u0438\u0432\u0430\u0442\u043D\u0438\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u0456\u0432"
    };
  },
  cityIsnewMake: function cityIsnewMake(data, p) {
    return {
      title: "\u041A\u0443\u043F\u0438\u0442\u044C \u0441\u043A\u0443\u0442\u0435\u0440 " + data.make + " \u043D\u043E\u0432\u044B\u0439 " + p.inCity + " - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      title_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u0441\u043A\u0443\u0442\u0435\u0440 " + data.make + " \u043D\u043E\u0432\u0438\u0439 " + p.inCity + " - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      description: "\u041A\u0443\u043F\u0438\u0442\u044C \u0441\u043A\u0443\u0442\u0435\u0440 " + data.make + " \u043D\u043E\u0432\u044B\u0439 " + p.inCity + " \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0439. \u0421\u0440\u0430\u0432\u043D\u0438\u0442\u044C \u0446\u0435\u043D\u044B \u0432 \u043C\u043E\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u0438 \u043E\u0442 \u0447\u0430\u0441\u0442\u043D\u044B\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u043E\u0432",
      description_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u0441\u043A\u0443\u0442\u0435\u0440 " + data.make + " \u043D\u043E\u0432\u0438\u0439 " + p.inCity + " \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u044C. \u041F\u043E\u0440\u0456\u0432\u043D\u044F\u0442\u0438 \u0446\u0456\u043D\u0438 \u0432 \u043C\u043E\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u0456 \u0432\u0456\u0434 \u043F\u0440\u0438\u0432\u0430\u0442\u043D\u0438\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u0456\u0432"
    };
  },
  makeModelBody: function makeModelBody(data, p) {
    return {
      header: "\u041A\u0443\u043F\u0438\u0442\u044C " + p.t(data.body).toLowerCase() + " \u0441\u043A\u0443\u0442\u0435\u0440 " + data.make + " " + data.model + " \u0431\u0443",
      header_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 " + p.t(data.body).toLowerCase() + " \u0441\u043A\u0443\u0442\u0435\u0440 " + data.make + " " + data.model + " \u0431\u0443"
    };
  },
  makeModelYear: function makeModelYear(data, p) {
    return {
      header: "\u041A\u0443\u043F\u0438\u0442\u044C \u0441\u043A\u0443\u0442\u0435\u0440 " + data.make + " " + data.model + " " + data.year + " \u0433\u043E\u0434\u0430 \u0431\u0443",
      header_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u0441\u043A\u0443\u0442\u0435\u0440 " + data.make + " " + data.model + " " + data.year + " \u0440\u043E\u043A\u0443 \u0431\u0443"
    };
  },
  isnewMakeBody: function isnewMakeBody(data, p) {
    return {
      header: "\u041A\u0443\u043F\u0438\u0442\u044C \u043D\u043E\u0432\u044B\u0439 " + p.t(data.body).toLowerCase() + " \u0441\u043A\u0443\u0442\u0435\u0440 " + data.make,
      header_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043D\u043E\u0432\u0438\u0439 " + p.t(data.body).toLowerCase() + " \u0441\u043A\u0443\u0442\u0435\u0440 " + data.make
    };
  },
  cityMakeBody: function cityMakeBody(data, p) {
    return {
      header: p.buy + " " + p.t(data.body).toLowerCase() + " \u0441\u043A\u0443\u0442\u0435\u0440 " + data.make + " \u0431\u0443 " + p.inCity
    };
  },
  cityIsnewBody: function cityIsnewBody(data, p) {
    return {
      header: "\u041A\u0443\u043F\u0438\u0442\u044C \u043D\u043E\u0432\u044B\u0439 " + p.t(data.body).toLowerCase() + " \u0441\u043A\u0443\u0442\u0435\u0440 " + p.inCity,
      header_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043D\u043E\u0432\u0438\u0439 " + p.t(data.body).toLowerCase() + " \u0441\u043A\u0443\u0442\u0435\u0440 " + p.inCity
    };
  },

  isnewMakeModelYear: function isnewMakeModelYear(data, p) {
    return {
      header: "\u041A\u0443\u043F\u0438\u0442\u044C \u043D\u043E\u0432\u044B\u0439 \u0441\u043A\u0443\u0442\u0435\u0440 " + data.make + " " + data.model + " " + data.year + " \u0433\u043E\u0434\u0430",
      header_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043D\u043E\u0432\u0438\u0439 \u0441\u043A\u0443\u0442\u0435\u0440 " + data.make + " " + data.model + " " + data.year + " \u0440\u043E\u043A\u0443",

      title: "\u041A\u0443\u043F\u0438\u0442\u044C \u0441\u043A\u0443\u0442\u0435\u0440 " + data.make + " " + data.model + " " + data.year + " \u043D\u043E\u0432\u044B\u0439 \u0432 \u0423\u043A\u0440\u0430\u0438\u043D\u0435 - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      title_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u0441\u043A\u0443\u0442\u0435\u0440 " + data.make + " " + data.model + " " + data.year + " \u043D\u043E\u0432\u0438\u0439 \u0432 \u0423\u043A\u0440\u0430\u0457\u043D\u0456 - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      description: "\u041A\u0443\u043F\u0438\u0442\u044C \u0441\u043A\u0443\u0442\u0435\u0440 " + data.make + " " + data.model + " " + data.year + " \u043D\u043E\u0432\u044B\u0439 \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0439. \u0421\u0440\u0430\u0432\u043D\u0438\u0442\u044C \u0446\u0435\u043D\u044B \u0432 \u043C\u043E\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u0438 \u043E\u0442 \u0447\u0430\u0441\u0442\u043D\u044B\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u043E\u0432",
      description_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u0441\u043A\u0443\u0442\u0435\u0440 " + data.make + " " + data.model + " " + data.year + " \u043D\u043E\u0432\u0438\u0439 \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u044C. \u041F\u043E\u0440\u0456\u0432\u043D\u044F\u0442\u0438 \u0446\u0456\u043D\u0438 \u0432 \u043C\u043E\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u0456 \u0432\u0456\u0434 \u043F\u0440\u0438\u0432\u0430\u0442\u043D\u0438\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u0456\u0432"
    };
  },
  isnewMakeModelCity: function isnewMakeModelCity(data, p) {
    return {
      header: "\u041A\u0443\u043F\u0438\u0442\u044C \u043D\u043E\u0432\u044B\u0439 \u0441\u043A\u0443\u0442\u0435\u0440 " + data.make + " " + data.model + " " + p.inCity,
      header_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043D\u043E\u0432\u0438\u0439 \u0441\u043A\u0443\u0442\u0435\u0440 " + data.make + " " + data.model + " " + p.inCity,

      title: "\u041A\u0443\u043F\u0438\u0442\u044C \u0441\u043A\u0443\u0442\u0435\u0440 " + data.make + " " + data.model + " \u043D\u043E\u0432\u044B\u0439 " + p.inCity + " - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      title_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u0441\u043A\u0443\u0442\u0435\u0440 " + data.make + " " + data.model + " \u043D\u043E\u0432\u0438\u0439 " + p.inCity + " - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      description: "\u041A\u0443\u043F\u0438\u0442\u044C \u0441\u043A\u0443\u0442\u0435\u0440 " + data.make + " " + data.model + " \u043D\u043E\u0432\u044B\u0439 " + p.inCity + " \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0439. \u0421\u0440\u0430\u0432\u043D\u0438\u0442\u044C \u0446\u0435\u043D\u044B \u0432 \u043C\u043E\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u0438 \u043E\u0442 \u0447\u0430\u0441\u0442\u043D\u044B\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u043E\u0432",
      description_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u0441\u043A\u0443\u0442\u0435\u0440 " + data.make + " " + data.model + " \u043D\u043E\u0432\u0438\u0439 " + p.inCity + " \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u044C. \u041F\u043E\u0440\u0456\u0432\u043D\u044F\u0442\u0438 \u0446\u0456\u043D\u0438 \u0432 \u043C\u043E\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u0456 \u0432\u0456\u0434 \u043F\u0440\u0438\u0432\u0430\u0442\u043D\u0438\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u0456\u0432"
    };
  },
  isnewMakeModelBody: function isnewMakeModelBody(data, p) {
    return {
      header: "\u041A\u0443\u043F\u0438\u0442\u044C \u043D\u043E\u0432\u044B\u0439 " + p.t(data.body).toLowerCase() + " \u0441\u043A\u0443\u0442\u0435\u0440 " + data.make + " " + data.model,
      header_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043D\u043E\u0432\u0438\u0439 " + p.t(data.body).toLowerCase() + " \u0441\u043A\u0443\u0442\u0435\u0440 " + data.make + " " + data.model
    };
  },
  makeModelCityBody: function makeModelCityBody(data, p) {
    return {
      header: "\u041A\u0443\u043F\u0438\u0442\u044C " + p.t(data.body).toLowerCase() + " \u0441\u043A\u0443\u0442\u0435\u0440 " + data.make + " " + data.model + " \u0431\u0443 " + p.inCity,
      header_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 " + p.t(data.body).toLowerCase() + " \u0441\u043A\u0443\u0442\u0435\u0440 " + data.make + " " + data.model + " \u0431\u0443 " + p.inCity
    };
  },
  isnewMakeCityBody: function isnewMakeCityBody(data, p) {
    return {
      header: "\u041A\u0443\u043F\u0438\u0442\u044C \u043D\u043E\u0432\u044B\u0439 " + p.t(data.body).toLowerCase() + " \u0441\u043A\u0443\u0442\u0435\u0440 " + data.make + " " + p.inCity,
      header_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043D\u043E\u0432\u0438\u0439 " + p.t(data.body).toLowerCase() + " \u0441\u043A\u0443\u0442\u0435\u0440 " + data.make + " " + p.inCity
    };
  },

  isnewMakeModelCityBody: function isnewMakeModelCityBody(data, p) {
    return {
      header: "\u041A\u0443\u043F\u0438\u0442\u044C \u043D\u043E\u0432\u044B\u0439 " + p.t(data.body).toLowerCase() + " \u0441\u043A\u0443\u0442\u0435\u0440 " + data.make + " " + data.model + " " + p.inCity,
      header_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043D\u043E\u0432\u0438\u0439 " + p.t(data.body).toLowerCase() + " \u0441\u043A\u0443\u0442\u0435\u0440 " + data.make + " " + data.model + " " + p.inCity
    };
  }
};

/* harmony default export */ var skuter_templates_defaultExport = (skuter_templates_avtoPathesHead);
// CONCATENATED MODULE: ./src/shared/helpers/seoTextFinder/seoTemplates/search/skuter/index.js


var SKUTER = {
  make: skuter_templates_defaultExport.make,
  body: skuter_templates_defaultExport.body,

  city_make: skuter_templates_defaultExport.makeCity,
  make_model: skuter_templates_defaultExport.makeModel,
  city_isnew: skuter_templates_defaultExport.cityIsnew,
  isnew_make: skuter_templates_defaultExport.makeIsnew,
  body_make: skuter_templates_defaultExport.makeBody,
  body_isnew: skuter_templates_defaultExport.bodyIsnew,
  body_city: skuter_templates_defaultExport.cityBody,

  city_make_model: skuter_templates_defaultExport.cityMakeModel,
  isnew_make_model: skuter_templates_defaultExport.makeModelIsnew,
  city_isnew_make: skuter_templates_defaultExport.cityIsnewMake,
  body_make_model: skuter_templates_defaultExport.makeModelBody,
  make_model_year: skuter_templates_defaultExport.makeModelYear,
  body_isnew_make: skuter_templates_defaultExport.isnewMakeBody,
  body_city_make: skuter_templates_defaultExport.cityMakeBody,
  body_city_isnew: skuter_templates_defaultExport.cityIsnewBody,

  isnew_make_model_year: skuter_templates_defaultExport.isnewMakeModelYear,
  city_isnew_make_model: skuter_templates_defaultExport.isnewMakeModelCity,
  body_isnew_make_model: skuter_templates_defaultExport.isnewMakeModelBody,
  body_city_make_model: skuter_templates_defaultExport.makeModelCityBody,
  body_city_isnew_make: skuter_templates_defaultExport.isnewMakeCityBody,

  body_city_isnew_make_model: skuter_templates_defaultExport.isnewMakeModelCityBody
};
// CONCATENATED MODULE: ./src/shared/helpers/seoTextFinder/seoTemplates/search/moped/templates.js
var moped_templates_avtoPathesHead = {
  city: function city(data, p) {
    return {
      title: "\u041A\u0443\u043F\u0438\u0442\u044C \u043C\u043E\u043F\u0435\u0434 \u0431\u0443 " + p.inCity + " \u0441 \u043F\u0440\u043E\u0431\u0435\u0433\u043E\u043C \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      title_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043C\u043E\u043F\u0435\u0434 \u0431\u0443 " + p.inCity + " \u0437 \u043F\u0440\u043E\u0431\u0456\u0433\u043E\u043C \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",

      description: "\u041F\u0440\u043E\u0434\u0430\u0436\u0430 \u043C\u043E\u043F\u0435\u0434\u043E\u0432 \u0431\u0443 " + p.t(data.city) + ". \u041A\u0443\u043F\u0438\u0442\u044C \u043C\u043E\u043F\u0435\u0434 \u0431\u0443 " + p.inCity + " \u0441 \u043F\u0440\u043E\u0431\u0435\u0433\u043E\u043C \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u041F\u043E\u0434\u0435\u0440\u0436\u0430\u043D\u043D\u044B\u0435 \u043C\u043E\u043F\u0435\u0434\u044B \u043E\u0442 \u043F\u0440\u043E\u0432\u0435\u0440\u0435\u043D\u043D\u044B\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u043E\u0432. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0439. \u0412\u044B\u0433\u043E\u0434\u043D\u0430\u044F \u0446\u0435\u043D\u0430",
      description_uk: "\u041F\u0440\u043E\u0434\u0430\u0436 \u043C\u043E\u043F\u0435\u0434\u0456\u0432 \u0431\u0443 " + p.t(data.city) + ". \u041A\u0443\u043F\u0438\u0442\u0438 \u043C\u043E\u043F\u0435\u0434 \u0431\u0443 " + p.inCity + " \u0437 \u043F\u0440\u043E\u0431\u0456\u0433\u043E\u043C \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0412\u0436\u0438\u0432\u0430\u043D\u0456 \u043C\u043E\u043F\u0435\u0434\u0438 \u0432\u0456\u0434 \u043F\u0435\u0440\u0435\u0432\u0456\u0440\u0435\u043D\u0438\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u0456\u0432. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u044C. \u0412\u0438\u0433\u0456\u0434\u043D\u0430 \u0446\u0456\u043D\u0430"
    };
  },
  make: function make(data, p) {
    return {
      header: "\u041C\u043E\u043F\u0435\u0434\u044B " + data.make,
      header_uk: "\u041C\u043E\u043F\u0435\u0434\u0438 " + data.make,

      title: "\u041C\u043E\u043F\u0435\u0434\u044B " + data.makeTranslit + " \u0432 \u0423\u043A\u0440\u0430\u0438\u043D\u0435, \u043A\u0443\u043F\u0438\u0442\u044C \u043C\u043E\u043F\u0435\u0434 " + data.make + " \u0431\u0443 \u0438\u043B\u0438 \u043D\u043E\u0432\u044B\u0439 - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      title_uk: "\u041C\u043E\u043F\u0435\u0434\u0438 " + data.makeTranslit + " \u0432 \u0423\u043A\u0440\u0430\u0457\u043D\u0456, \u043A\u0443\u043F\u0438\u0442\u0438 \u043C\u043E\u043F\u0435\u0434 " + data.make + " \u0431\u0443 \u0430\u0431\u043E \u043D\u043E\u0432\u0438\u0439 - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",

      description: "\u041A\u0443\u043F\u0438\u0442\u044C \u043C\u043E\u043F\u0435\u0434 " + data.make + " \u0441 \u043F\u0440\u043E\u0431\u0435\u0433\u043E\u043C \u0438\u043B\u0438 \u043D\u043E\u0432\u044B\u0439 \u2B50 \u0426\u0435\u043D\u044B \u043D\u0430 \u043C\u043E\u043F\u0435\u0434\u044B, \u0445\u0430\u0440\u0430\u043A\u0442\u0435\u0440\u0438\u0441\u0442\u0438\u043A\u0438 \u0438 \u0444\u043E\u0442\u043E \u043D\u0430 \u0441\u0430\u0439\u0442\u0435 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      description_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043C\u043E\u043F\u0435\u0434 " + data.make + " \u0437 \u043F\u0440\u043E\u0431\u0456\u0433\u043E\u043C \u0430\u0431\u043E \u043D\u043E\u0432\u0438\u0439 \u2B50 \u0426\u0456\u043D\u0438 \u043D\u0430 \u043C\u043E\u043F\u0435\u0434\u0438, \u0445\u0430\u0440\u0430\u043A\u0442\u0435\u0440\u0438\u0441\u0442\u0438\u043A\u0438 \u0442\u0430 \u0444\u043E\u0442\u043E \u043D\u0430 \u0441\u0430\u0439\u0442\u0456 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440"
    };
  },
  body: function body(data, p) {
    return {
      header: p.buy + " " + p.t(data.body).toLowerCase() + " \u043C\u043E\u043F\u0435\u0434 \u0431\u0443"
    };
  },

  makeModel: function makeModel(data, p) {
    return {
      header: p.buy + " \u043C\u043E\u043F\u0435\u0434 " + data.make + " " + data.model + " \u0431\u0443",

      title: "\u041A\u0443\u043F\u0438\u0442\u044C \u043C\u043E\u043F\u0435\u0434 " + data.make + " " + data.model + " \u0431\u0443 \u0432 \u0423\u043A\u0440\u0430\u0438\u043D\u0435 \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      title_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043C\u043E\u043F\u0435\u0434 " + data.make + " " + data.model + " \u0431\u0443 \u0432 \u0423\u043A\u0440\u0430\u0457\u043D\u0456 \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",

      description: "\u041F\u0440\u043E\u0434\u0430\u0436\u0430 \u043C\u043E\u043F\u0435\u0434\u043E\u0432 " + data.make + " " + data.model + " \u0431\u0443 \u0432 \u0423\u043A\u0440\u0430\u0438\u043D\u0435. \u041A\u0443\u043F\u0438\u0442\u044C \u043C\u043E\u043F\u0435\u0434 " + data.make + " " + data.model + " \u0431\u0443 \u0441 \u043F\u0440\u043E\u0431\u0435\u0433\u043E\u043C \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u041F\u043E\u0434\u0435\u0440\u0436\u0430\u043D\u043D\u044B\u0435 \u043C\u043E\u043F\u0435\u0434\u044B \u043E\u0442 \u043F\u0440\u043E\u0432\u0435\u0440\u0435\u043D\u043D\u044B\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u043E\u0432. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0439",
      description_uk: "\u041F\u0440\u043E\u0434\u0430\u0436 \u043C\u043E\u043F\u0435\u0434\u0456\u0432 " + data.make + " " + data.model + " \u0431\u0443 \u0432 \u0423\u043A\u0440\u0430\u0457\u043D\u0456. \u041A\u0443\u043F\u0438\u0442\u0438 \u043C\u043E\u043F\u0435\u0434 " + data.make + " " + data.model + " \u0431\u0443 \u0437 \u043F\u0440\u043E\u0431\u0456\u0433\u043E\u043C \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0412\u0436\u0438\u0432\u0430\u043D\u0456 \u043C\u043E\u043F\u0435\u0434\u0438 \u0432\u0456\u0434 \u043F\u0435\u0440\u0435\u0432\u0456\u0440\u0435\u043D\u0438\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u0456\u0432. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u044C"
    };
  },
  makeCity: function makeCity(data, p) {
    return {
      title: "\u041A\u0443\u043F\u0438\u0442\u044C \u043C\u043E\u043F\u0435\u0434 " + data.make + " \u0431\u0443 " + p.inCity + " - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      title_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043C\u043E\u043F\u0435\u0434 " + data.make + " \u0431\u0443 " + p.inCity + " - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",

      description: "\u041F\u0440\u043E\u0434\u0430\u0436\u0430 \u043C\u043E\u043F\u0435\u0434\u043E\u0432 " + data.make + " \u0431\u0443 " + p.t(data.city) + ". \u041A\u0443\u043F\u0438\u0442\u044C \u043C\u043E\u043F\u0435\u0434 " + data.make + " \u0431\u0443 \u0441 \u043F\u0440\u043E\u0431\u0435\u0433\u043E\u043C \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0439 " + p.inCity + ". \u0421\u0440\u0430\u0432\u043D\u0438\u0442\u044C \u0446\u0435\u043D\u044B, \u043F\u043E\u0441\u043C\u043E\u0442\u0440\u0435\u0442\u044C \u0444\u043E\u0442\u043E",
      description_uk: "\u041F\u0440\u043E\u0434\u0430\u0436 \u043C\u043E\u043F\u0435\u0434\u0456\u0432 " + data.make + " \u0431\u0443 " + p.t(data.city) + ". \u041A\u0443\u043F\u0438\u0442\u0438 \u043C\u043E\u043F\u0435\u0434 " + data.make + " \u0431\u0443 \u0437 \u043F\u0440\u043E\u0431\u0456\u0433\u043E\u043C \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u044C " + p.inCity + ". \u041F\u043E\u0440\u0456\u0432\u043D\u044F\u0442\u0438 \u0446\u0456\u043D\u0438, \u043F\u043E\u0434\u0438\u0432\u0438\u0442\u0438\u0441\u044F \u0444\u043E\u0442\u043E"
    };
  },
  cityIsnew: function cityIsnew(data, p) {
    return {
      title: "\u041A\u0443\u043F\u0438\u0442\u044C \u043C\u043E\u043F\u0435\u0434 \u043D\u043E\u0432\u044B\u0439 " + p.inCity + " \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      title_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043C\u043E\u043F\u0435\u0434 \u043D\u043E\u0432\u0438\u0439 " + p.inCity + " \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      description: "\u041A\u0443\u043F\u0438\u0442\u044C \u043C\u043E\u043F\u0435\u0434 \u043D\u043E\u0432\u044B\u0439 " + p.inCity + " \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0439. \u0421\u0440\u0430\u0432\u043D\u0438\u0442\u044C \u0446\u0435\u043D\u044B \u0432 \u043C\u043E\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u0438 \u043E\u0442 \u0447\u0430\u0441\u0442\u043D\u044B\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u043E\u0432",
      description_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043C\u043E\u043F\u0435\u0434 \u043D\u043E\u0432\u0438\u0439 " + p.inCity + " \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u044C. \u041F\u043E\u0440\u0456\u0432\u043D\u044F\u0442\u0438 \u0446\u0456\u043D\u0438 \u0432 \u043C\u043E\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u0456 \u0432\u0456\u0434 \u043F\u0440\u0438\u0432\u0430\u0442\u043D\u0438\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u0456\u0432"
    };
  },
  makeIsnew: function makeIsnew(data, p) {
    return {
      title: "\u041A\u0443\u043F\u0438\u0442\u044C \u043C\u043E\u043F\u0435\u0434 " + data.make + " \u043D\u043E\u0432\u044B\u0439 \u0432 \u0423\u043A\u0440\u0430\u0438\u043D\u0435 \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      title_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043C\u043E\u043F\u0435\u0434 " + data.make + " \u043D\u043E\u0432\u0438\u0439 \u0432 \u0423\u043A\u0440\u0430\u0457\u043D\u0456 \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      description: "\u041A\u0443\u043F\u0438\u0442\u044C \u043C\u043E\u043F\u0435\u0434 " + data.make + " \u043D\u043E\u0432\u044B\u0439 \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0439. \u0421\u0440\u0430\u0432\u043D\u0438\u0442\u044C \u0446\u0435\u043D\u044B \u0432 \u043C\u043E\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u0438 \u043E\u0442 \u0447\u0430\u0441\u0442\u043D\u044B\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u043E\u0432",
      description_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043C\u043E\u043F\u0435\u0434 " + data.make + " \u043D\u043E\u0432\u0438\u0439 \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u044C. \u041F\u043E\u0440\u0456\u0432\u043D\u044F\u0442\u0438 \u0446\u0456\u043D\u0438 \u0432 \u043C\u043E\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u0456 \u0432\u0456\u0434 \u043F\u0440\u0438\u0432\u0430\u0442\u043D\u0438\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u0456\u0432"
    };
  },
  makeBody: function makeBody(data, p) {
    return {
      header: p.buy + " " + p.t(data.body).toLowerCase() + " \u043C\u043E\u043F\u0435\u0434 " + data.make + " \u0431\u0443"
    };
  },
  bodyIsnew: function bodyIsnew(data, p) {
    return {
      header: "\u041A\u0443\u043F\u0438\u0442\u044C \u043D\u043E\u0432\u044B\u0439 " + p.t(data.body).toLowerCase() + " \u043C\u043E\u043F\u0435\u0434",
      header_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043D\u043E\u0432\u0438\u0439 " + p.t(data.body).toLowerCase() + " \u043C\u043E\u043F\u0435\u0434"
    };
  },
  bodyCity: function bodyCity(data, p) {
    return {
      header: p.buy + " " + p.t(data.body).toLowerCase() + " \u043C\u043E\u043F\u0435\u0434 \u0431\u0443 " + p.inCity
    };
  },

  makeModelYear: function makeModelYear(data, p) {
    return {
      header: "\u041A\u0443\u043F\u0438\u0442\u044C \u043C\u043E\u043F\u0435\u0434 " + data.make + " " + data.model + " " + data.year + " \u0433\u043E\u0434\u0430 \u0431\u0443",
      header_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043C\u043E\u043F\u0435\u0434 " + data.make + " " + data.model + " " + data.year + " \u0440\u043E\u043A\u0443 \u0431\u0443",

      title: "\u041A\u0443\u043F\u0438\u0442\u044C \u043C\u043E\u043F\u0435\u0434 " + data.make + " " + data.model + " " + data.year + " \u0433\u043E\u0434\u0430 \u0431\u0443 \u0432 \u0423\u043A\u0440\u0430\u0438\u043D\u0435 - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      title_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043C\u043E\u043F\u0435\u0434 " + data.make + " " + data.model + " " + data.year + " \u0440\u043E\u043A\u0443 \u0431\u0443 \u0432 \u0423\u043A\u0440\u0430\u0457\u043D\u0456 - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",

      description: "\u041F\u0440\u043E\u0434\u0430\u0436\u0430 \u043C\u043E\u043F\u0435\u0434\u043E\u0432 " + data.make + " " + data.model + " " + data.year + " \u0433\u043E\u0434\u0430 \u0431\u0443 \u0432 \u0423\u043A\u0440\u0430\u0438\u043D\u0435. \u041A\u0443\u043F\u0438\u0442\u044C \u043C\u043E\u043F\u0435\u0434 " + data.make + " " + data.model + " " + data.year + " \u0431\u0443 \u0441 \u043F\u0440\u043E\u0431\u0435\u0433\u043E\u043C \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0439. \u0421\u0440\u0430\u0432\u043D\u0438\u0442\u044C \u0446\u0435\u043D\u044B, \u043F\u043E\u0441\u043C\u043E\u0442\u0440\u0435\u0442\u044C \u0444\u043E\u0442\u043E",
      description_uk: "\u041F\u0440\u043E\u0434\u0430\u0436 \u043C\u043E\u043F\u0435\u0434\u0456\u0432 " + data.make + " " + data.model + " " + data.year + " \u0440\u043E\u043A\u0443 \u0431\u0443 \u0432 \u0423\u043A\u0440\u0430\u0457\u043D\u0456. \u041A\u0443\u043F\u0438\u0442\u0438 \u043C\u043E\u043F\u0435\u0434 " + data.make + " " + data.model + " " + data.year + " \u0431\u0443 \u0437 \u043F\u0440\u043E\u0431\u0456\u0433\u043E\u043C \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u044C. \u041F\u043E\u0440\u0456\u0432\u043D\u044F\u0442\u0438 \u0446\u0456\u043D\u0438, \u043F\u043E\u0434\u0438\u0432\u0438\u0442\u0438\u0441\u044F \u0444\u043E\u0442\u043E"
    };
  },
  makeModelCity: function makeModelCity(data, p) {
    return {
      header: p.buy + " \u043C\u043E\u043F\u0435\u0434 " + data.make + " " + data.model + " \u0431\u0443 " + p.inCity,

      title: "\u041A\u0443\u043F\u0438\u0442\u044C \u043C\u043E\u043F\u0435\u0434 " + data.make + " " + data.model + " \u0431\u0443 " + p.inCity + " - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      title_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043C\u043E\u043F\u0435\u0434 " + data.make + " " + data.model + " \u0431\u0443 " + p.inCity + " - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",

      description: "\u041F\u0440\u043E\u0434\u0430\u0436\u0430 \u043C\u043E\u043F\u0435\u0434\u043E\u0432 " + data.make + " " + data.model + " \u0431\u0443 " + p.t(data.city) + ". \u041A\u0443\u043F\u0438\u0442\u044C \u043C\u043E\u043F\u0435\u0434 " + data.make + " " + data.model + " \u0431\u0443 \u0441 \u043F\u0440\u043E\u0431\u0435\u0433\u043E\u043C \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0439 " + p.inCity + ". \u0421\u0440\u0430\u0432\u043D\u0438\u0442\u044C \u0446\u0435\u043D\u044B, \u043F\u043E\u0441\u043C\u043E\u0442\u0440\u0435\u0442\u044C \u0444\u043E\u0442\u043E",
      description_uk: "\u041F\u0440\u043E\u0434\u0430\u0436 \u043C\u043E\u043F\u0435\u0434\u0456\u0432 " + data.make + " " + data.model + " \u0431\u0443 " + p.t(data.city) + ". \u041A\u0443\u043F\u0438\u0442\u0438 \u043C\u043E\u043F\u0435\u0434 " + data.make + " " + data.model + " \u0431\u0443 \u0437 \u043F\u0440\u043E\u0431\u0456\u0433\u043E\u043C \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u044C " + p.inCity + ". \u041F\u043E\u0440\u0456\u0432\u043D\u044F\u0442\u0438 \u0446\u0456\u043D\u0438, \u043F\u043E\u0434\u0438\u0432\u0438\u0442\u0438\u0441\u044F \u0444\u043E\u0442\u043E"
    };
  },
  makeModelIsnew: function makeModelIsnew(data, p) {
    return {
      header: "\u041A\u0443\u043F\u0438\u0442\u044C \u043D\u043E\u0432\u044B\u0439 \u043C\u043E\u043F\u0435\u0434 " + data.make + " " + data.model,
      header_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043D\u043E\u0432\u0438\u0439 \u043C\u043E\u043F\u0435\u0434 " + data.make + " " + data.model,

      title: "\u041A\u0443\u043F\u0438\u0442\u044C \u043C\u043E\u043F\u0435\u0434 " + data.make + " " + data.model + " \u043D\u043E\u0432\u044B\u0439 \u0432 \u0423\u043A\u0440\u0430\u0438\u043D\u0435 \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      title_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043C\u043E\u043F\u0435\u0434 " + data.make + " " + data.model + " \u043D\u043E\u0432\u0438\u0439 \u0432 \u0423\u043A\u0440\u0430\u0457\u043D\u0456 \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",

      description: "\u041A\u0443\u043F\u0438\u0442\u044C \u043C\u043E\u043F\u0435\u0434 " + data.make + " " + data.model + " \u043D\u043E\u0432\u044B\u0439 \u0432 \u0423\u043A\u0440\u0430\u0438\u043D\u0435 \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0439. \u0421\u0440\u0430\u0432\u043D\u0438\u0442\u044C \u0446\u0435\u043D\u044B \u0432 \u043C\u043E\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u0438 \u043E\u0442 \u0447\u0430\u0441\u0442\u043D\u044B\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u043E\u0432",
      description_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043C\u043E\u043F\u0435\u0434 " + data.make + " " + data.model + " \u043D\u043E\u0432\u0438\u0439 \u0432 \u0423\u043A\u0440\u0430\u0457\u043D\u0456 \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u044C. \u041F\u043E\u0440\u0456\u0432\u043D\u044F\u0442\u0438 \u0446\u0456\u043D\u0438 \u0432 \u043C\u043E\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u0456 \u0432\u0456\u0434 \u043F\u0440\u0438\u0432\u0430\u0442\u043D\u0438\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u0456\u0432"
    };
  },
  makeCityIsnew: function makeCityIsnew(data, p) {
    return {
      title: "\u041A\u0443\u043F\u0438\u0442\u044C \u043C\u043E\u043F\u0435\u0434 " + data.make + " \u043D\u043E\u0432\u044B\u0439 " + p.inCity + " - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      title_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043C\u043E\u043F\u0435\u0434 " + data.make + " \u043D\u043E\u0432\u0438\u0439 " + p.inCity + " - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      description: "\u041A\u0443\u043F\u0438\u0442\u044C \u043C\u043E\u043F\u0435\u0434 " + data.make + " \u043D\u043E\u0432\u044B\u0439 " + p.inCity + " \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0439. \u0421\u0440\u0430\u0432\u043D\u0438\u0442\u044C \u0446\u0435\u043D\u044B \u0432 \u043C\u043E\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u0438 \u043E\u0442 \u0447\u0430\u0441\u0442\u043D\u044B\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u043E\u0432",
      description_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043C\u043E\u043F\u0435\u0434 " + data.make + " \u043D\u043E\u0432\u0438\u0439 " + p.inCity + " \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u044C. \u041F\u043E\u0440\u0456\u0432\u043D\u044F\u0442\u0438 \u0446\u0456\u043D\u0438 \u0432 \u043C\u043E\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u0456 \u0432\u0456\u0434 \u043F\u0440\u0438\u0432\u0430\u0442\u043D\u0438\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u0456\u0432"
    };
  },
  makeModelBody: function makeModelBody(data, p) {
    return {
      header: "\u041A\u0443\u043F\u0438\u0442\u044C " + p.t(data.body).toLowerCase() + " \u043C\u043E\u043F\u0435\u0434 " + data.make + " " + data.model + " \u0431\u0443",
      header_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 " + p.t(data.body).toLowerCase() + " \u043C\u043E\u043F\u0435\u0434 " + data.make + " " + data.model + " \u0431\u0443"
    };
  },
  isnewMakeBody: function isnewMakeBody(data, p) {
    return {
      header: "\u041A\u0443\u043F\u0438\u0442\u044C \u043D\u043E\u0432\u044B\u0439 " + p.t(data.body).toLowerCase() + " \u043C\u043E\u043F\u0435\u0434 " + data.make,
      header_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043D\u043E\u0432\u0438\u0439 " + p.t(data.body).toLowerCase() + " \u043C\u043E\u043F\u0435\u0434 " + data.make
    };
  },
  makeCityBody: function makeCityBody(data, p) {
    return {
      header: p.buy + " " + p.t(data.body).toLowerCase() + " \u043C\u043E\u043F\u0435\u0434 " + data.make + " \u0431\u0443 " + p.inCity
    };
  },
  isnewBodyCity: function isnewBodyCity(data, p) {
    return {
      header: "\u041A\u0443\u043F\u0438\u0442\u044C \u043D\u043E\u0432\u044B\u0439 " + p.t(data.body).toLowerCase() + " \u043C\u043E\u043F\u0435\u0434 " + p.inCity,
      header_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043D\u043E\u0432\u0438\u0439 " + p.t(data.body).toLowerCase() + " \u043C\u043E\u043F\u0435\u0434 " + p.inCity
    };
  },

  isnewMakeModelYear: function isnewMakeModelYear(data, p) {
    return {
      header: "\u041A\u0443\u043F\u0438\u0442\u044C \u043D\u043E\u0432\u044B\u0439 \u043C\u043E\u043F\u0435\u0434 " + data.make + " " + data.model + " " + data.year + " \u0433\u043E\u0434\u0430",
      header_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043D\u043E\u0432\u0438\u0439 \u043C\u043E\u043F\u0435\u0434 " + data.make + " " + data.model + " " + data.year + " \u0440\u043E\u043A\u0443",

      title: "\u041A\u0443\u043F\u0438\u0442\u044C \u043C\u043E\u043F\u0435\u0434 " + data.make + " " + data.model + " " + data.year + " \u043D\u043E\u0432\u044B\u0439 \u0432 \u0423\u043A\u0440\u0430\u0438\u043D\u0435 - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      title_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043C\u043E\u043F\u0435\u0434 " + data.make + " " + data.model + " " + data.year + " \u043D\u043E\u0432\u0438\u0439 \u0432 \u0423\u043A\u0440\u0430\u0457\u043D\u0456 - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      description: "\u041A\u0443\u043F\u0438\u0442\u044C \u043C\u043E\u043F\u0435\u0434 " + data.make + " " + data.model + " " + data.year + " \u043D\u043E\u0432\u044B\u0439 \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0439. \u0421\u0440\u0430\u0432\u043D\u0438\u0442\u044C \u0446\u0435\u043D\u044B \u0432 \u043C\u043E\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u0438 \u043E\u0442 \u0447\u0430\u0441\u0442\u043D\u044B\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u043E\u0432",
      description_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043C\u043E\u043F\u0435\u0434 " + data.make + " " + data.model + " " + data.year + " \u043D\u043E\u0432\u0438\u0439 \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u044C. \u041F\u043E\u0440\u0456\u0432\u043D\u044F\u0442\u0438 \u0446\u0456\u043D\u0438 \u0432 \u043C\u043E\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u0456 \u0432\u0456\u0434 \u043F\u0440\u0438\u0432\u0430\u0442\u043D\u0438\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u0456\u0432"
    };
  },
  isnewMakeModelCity: function isnewMakeModelCity(data, p) {
    return {
      header: "\u041A\u0443\u043F\u0438\u0442\u044C \u043D\u043E\u0432\u044B\u0439 \u043C\u043E\u043F\u0435\u0434 " + data.make + " " + data.model + " " + p.inCity,
      header_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043D\u043E\u0432\u0438\u0439 \u043C\u043E\u043F\u0435\u0434 " + data.make + " " + data.model + " " + p.inCity,

      title: "\u041A\u0443\u043F\u0438\u0442\u044C \u043C\u043E\u043F\u0435\u0434 " + data.make + " " + data.model + " \u043D\u043E\u0432\u044B\u0439 " + p.inCity + " - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      title_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043C\u043E\u043F\u0435\u0434 " + data.make + " " + data.model + " \u043D\u043E\u0432\u0438\u0439 " + p.inCity + " - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      description: "\u041A\u0443\u043F\u0438\u0442\u044C \u043C\u043E\u043F\u0435\u0434 " + data.make + " " + data.model + " \u043D\u043E\u0432\u044B\u0439 " + p.inCity + " \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0439. \u0421\u0440\u0430\u0432\u043D\u0438\u0442\u044C \u0446\u0435\u043D\u044B \u0432 \u043C\u043E\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u0438 \u043E\u0442 \u0447\u0430\u0441\u0442\u043D\u044B\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u043E\u0432",
      description_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043C\u043E\u043F\u0435\u0434 " + data.make + " " + data.model + " \u043D\u043E\u0432\u0438\u0439 " + p.inCity + " \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u044C. \u041F\u043E\u0440\u0456\u0432\u043D\u044F\u0442\u0438 \u0446\u0456\u043D\u0438 \u0432 \u043C\u043E\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u0456 \u0432\u0456\u0434 \u043F\u0440\u0438\u0432\u0430\u0442\u043D\u0438\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u0456\u0432"
    };
  },
  isnewMakeModelBody: function isnewMakeModelBody(data, p) {
    return {
      header: "\u041A\u0443\u043F\u0438\u0442\u044C \u043D\u043E\u0432\u044B\u0439 " + p.t(data.body).toLowerCase() + " \u043C\u043E\u043F\u0435\u0434 " + data.make + " " + data.model,
      header_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043D\u043E\u0432\u0438\u0439 " + p.t(data.body).toLowerCase() + " \u043C\u043E\u043F\u0435\u0434 " + data.make + " " + data.model
    };
  },
  makeModelCityBody: function makeModelCityBody(data, p) {
    return {
      header: "\u041A\u0443\u043F\u0438\u0442\u044C " + p.t(data.body).toLowerCase() + " \u043C\u043E\u043F\u0435\u0434 " + data.make + " " + data.model + " \u0431\u0443 " + p.inCity,
      header_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 " + p.t(data.body).toLowerCase() + " \u043C\u043E\u043F\u0435\u0434 " + data.make + " " + data.model + " \u0431\u0443 " + p.inCity
    };
  },
  isnewMakeCityBody: function isnewMakeCityBody(data, p) {
    return {
      header: "\u041A\u0443\u043F\u0438\u0442\u044C \u043D\u043E\u0432\u044B\u0439 " + p.t(data.body).toLowerCase() + " \u043C\u043E\u043F\u0435\u0434 " + data.make + " " + p.inCity,
      header_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043D\u043E\u0432\u0438\u0439 " + p.t(data.body).toLowerCase() + " \u043C\u043E\u043F\u0435\u0434 " + data.make + " " + p.inCity
    };
  },

  isnewMakeModelCityBody: function isnewMakeModelCityBody(data, p) {
    return {
      header: "\u041A\u0443\u043F\u0438\u0442\u044C \u043D\u043E\u0432\u044B\u0439 " + p.t(data.body).toLowerCase() + " \u043C\u043E\u043F\u0435\u0434 " + data.make + " " + data.model + " " + p.inCity,
      header_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043D\u043E\u0432\u0438\u0439 " + p.t(data.body).toLowerCase() + " \u043C\u043E\u043F\u0435\u0434 " + data.make + " " + data.model + " " + p.inCity
    };
  }
};

/* harmony default export */ var moped_templates_defaultExport = (moped_templates_avtoPathesHead);
// CONCATENATED MODULE: ./src/shared/helpers/seoTextFinder/seoTemplates/search/moped/index.js


var MOPED = {
    city: moped_templates_defaultExport.city,
    make: moped_templates_defaultExport.make,
    body: moped_templates_defaultExport.body,

    make_model: moped_templates_defaultExport.makeModel,
    city_make: moped_templates_defaultExport.makeCity,
    city_isnew: moped_templates_defaultExport.cityIsnew,
    isnew_make: moped_templates_defaultExport.makeIsnew,
    body_make: moped_templates_defaultExport.makeBody,
    body_isnew: moped_templates_defaultExport.bodyIsnew,
    body_city: moped_templates_defaultExport.bodyCity,

    make_model_year: moped_templates_defaultExport.makeModelYear,
    city_make_model: moped_templates_defaultExport.makeModelCity,
    isnew_make_model: moped_templates_defaultExport.makeModelIsnew,
    city_isnew_make: moped_templates_defaultExport.makeCityIsnew,
    body_make_model: moped_templates_defaultExport.makeModelBody,
    body_isnew_make: moped_templates_defaultExport.isnewMakeBody,
    body_city_make: moped_templates_defaultExport.makeCityBody,
    body_city_isnew: moped_templates_defaultExport.isnewBodyCity,

    isnew_make_model_year: moped_templates_defaultExport.isnewMakeModelYear,
    city_isnew_make_model: moped_templates_defaultExport.isnewMakeModelCity,
    body_isnew_make_model: moped_templates_defaultExport.isnewMakeModelBody,
    body_city_make_model: moped_templates_defaultExport.makeModelCityBody,
    body_city_isnew_make: moped_templates_defaultExport.isnewMakeCityBody,

    body_city_isnew_make_model: moped_templates_defaultExport.isnewMakeModelCityBody
};
// CONCATENATED MODULE: ./src/shared/helpers/seoTextFinder/seoTemplates/search/kvadrotsikl/templates.js
var kvadrotsikl_templates_avtoPathesHead = {
  make: function make(data, p) {
    return {
      header: "\u041A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B\u044B " + data.make,
      header_uk: "\u041A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B\u0438 " + data.make,

      title: "\u041A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B\u044B " + data.makeTranslit + " \u0432 \u0423\u043A\u0440\u0430\u0438\u043D\u0435, \u043A\u0443\u043F\u0438\u0442\u044C \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B " + data.make + " \u0431\u0443 \u0438\u043B\u0438 \u043D\u043E\u0432\u044B\u0439 - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      title_uk: "\u041A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B\u0438 " + data.makeTranslit + " \u0432 \u0423\u043A\u0440\u0430\u0457\u043D\u0456, \u043A\u0443\u043F\u0438\u0442\u0438 \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B " + data.make + " \u0431\u0443 \u0430\u0431\u043E \u043D\u043E\u0432\u0438\u0439 - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",

      description: "\u041A\u0443\u043F\u0438\u0442\u044C \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B " + data.make + " \u0441 \u043F\u0440\u043E\u0431\u0435\u0433\u043E\u043C \u0438\u043B\u0438 \u043D\u043E\u0432\u044B\u0439 \u2B50 \u0426\u0435\u043D\u044B \u043D\u0430 \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B\u044B, \u0445\u0430\u0440\u0430\u043A\u0442\u0435\u0440\u0438\u0441\u0442\u0438\u043A\u0438 \u0438 \u0444\u043E\u0442\u043E \u043D\u0430 \u0441\u0430\u0439\u0442\u0435 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      description_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B " + data.make + " \u0437 \u043F\u0440\u043E\u0431\u0456\u0433\u043E\u043C \u0430\u0431\u043E \u043D\u043E\u0432\u0438\u0439 \u2B50 \u0426\u0456\u043D\u0438 \u043D\u0430 \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B\u0438, \u0445\u0430\u0440\u0430\u043A\u0442\u0435\u0440\u0438\u0441\u0442\u0438\u043A\u0438 \u0442\u0430 \u0444\u043E\u0442\u043E \u043D\u0430 \u0441\u0430\u0439\u0442\u0456 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440"
    };
  },
  city: function city(data, p) {
    return {
      title: "\u041A\u0443\u043F\u0438\u0442\u044C \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B \u0431\u0443 " + p.inCity + " \u0441 \u043F\u0440\u043E\u0431\u0435\u0433\u043E\u043C \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      title_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B \u0431\u0443 " + p.inCity + " \u0437 \u043F\u0440\u043E\u0431\u0456\u0433\u043E\u043C \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",

      description: "\u041F\u0440\u043E\u0434\u0430\u0436\u0430 \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B\u043E\u0432 \u0431\u0443 " + p.t(data.city) + ". \u041A\u0443\u043F\u0438\u0442\u044C \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B \u0431\u0443 " + p.inCity + " \u0441 \u043F\u0440\u043E\u0431\u0435\u0433\u043E\u043C \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u041F\u043E\u0434\u0435\u0440\u0436\u0430\u043D\u043D\u044B\u0435 \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B\u044B \u043E\u0442 \u043F\u0440\u043E\u0432\u0435\u0440\u0435\u043D\u043D\u044B\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u043E\u0432. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0439. \u0412\u044B\u0433\u043E\u0434\u043D\u0430\u044F \u0446\u0435\u043D\u0430",
      description_uk: "\u041F\u0440\u043E\u0434\u0430\u0436 \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B\u0456\u0432 \u0431\u0443 " + p.t(data.city) + ". \u041A\u0443\u043F\u0438\u0442\u0438 \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B \u0431\u0443 " + p.inCity + " \u0437 \u043F\u0440\u043E\u0431\u0456\u0433\u043E\u043C \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0412\u0436\u0438\u0432\u0430\u043D\u0456 \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B\u0438 \u0432\u0456\u0434 \u043F\u0435\u0440\u0435\u0432\u0456\u0440\u0435\u043D\u0438\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u0456\u0432. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u044C. \u0412\u0438\u0433\u0456\u0434\u043D\u0430 \u0446\u0456\u043D\u0430"
    };
  },
  body: function body(data, p) {
    return {
      header: p.buy + " " + p.t(data.body).toLowerCase() + " \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B \u0431\u0443"
    };
  },

  makeModel: function makeModel(data, p) {
    return {
      header: p.buy + " \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " \u0431\u0443",

      title: "\u041A\u0443\u043F\u0438\u0442\u044C \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " \u0431\u0443 \u0432 \u0423\u043A\u0440\u0430\u0438\u043D\u0435 \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      title_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " \u0431\u0443 \u0432 \u0423\u043A\u0440\u0430\u0457\u043D\u0456 \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",

      description: "\u041F\u0440\u043E\u0434\u0430\u0436\u0430 \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B\u043E\u0432 " + data.make + " " + data.model + " \u0431\u0443 \u0432 \u0423\u043A\u0440\u0430\u0438\u043D\u0435. \u041A\u0443\u043F\u0438\u0442\u044C \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " \u0431\u0443 \u0441 \u043F\u0440\u043E\u0431\u0435\u0433\u043E\u043C \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u041F\u043E\u0434\u0435\u0440\u0436\u0430\u043D\u043D\u044B\u0435 \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B\u044B \u043E\u0442 \u043F\u0440\u043E\u0432\u0435\u0440\u0435\u043D\u043D\u044B\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u043E\u0432. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0439",
      description_uk: "\u041F\u0440\u043E\u0434\u0430\u0436 \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B\u0456\u0432 " + data.make + " " + data.model + " \u0431\u0443 \u0432 \u0423\u043A\u0440\u0430\u0457\u043D\u0456. \u041A\u0443\u043F\u0438\u0442\u0438 \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " \u0431\u0443 \u0437 \u043F\u0440\u043E\u0431\u0456\u0433\u043E\u043C \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0412\u0436\u0438\u0432\u0430\u043D\u0456 \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B\u0438 \u0432\u0456\u0434 \u043F\u0435\u0440\u0435\u0432\u0456\u0440\u0435\u043D\u0438\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u0456\u0432. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u044C"
    };
  },
  makeCity: function makeCity(data, p) {
    return {
      title: "\u041A\u0443\u043F\u0438\u0442\u044C \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B " + data.make + " \u0431\u0443 " + p.inCity + " - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      title_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B " + data.make + " \u0431\u0443 " + p.inCity + " - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",

      description: "\u041F\u0440\u043E\u0434\u0430\u0436\u0430 \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B\u043E\u0432 " + data.make + " \u0431\u0443 " + p.t(data.city) + ". \u041A\u0443\u043F\u0438\u0442\u044C \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B " + data.make + " \u0431\u0443 \u0441 \u043F\u0440\u043E\u0431\u0435\u0433\u043E\u043C \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0439 " + p.inCity + ". \u0421\u0440\u0430\u0432\u043D\u0438\u0442\u044C \u0446\u0435\u043D\u044B, \u043F\u043E\u0441\u043C\u043E\u0442\u0440\u0435\u0442\u044C \u0444\u043E\u0442\u043E",
      description_uk: "\u041F\u0440\u043E\u0434\u0430\u0436 \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B\u0456\u0432 " + data.make + " \u0431\u0443 " + p.t(data.city) + ". \u041A\u0443\u043F\u0438\u0442\u0438 \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B " + data.make + " \u0431\u0443 \u0437 \u043F\u0440\u043E\u0431\u0456\u0433\u043E\u043C \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u044C " + p.inCity + ". \u041F\u043E\u0440\u0456\u0432\u043D\u044F\u0442\u0438 \u0446\u0456\u043D\u0438, \u043F\u043E\u0434\u0438\u0432\u0438\u0442\u0438\u0441\u044F \u0444\u043E\u0442\u043E"
    };
  },
  cityIsnew: function cityIsnew(data, p) {
    return {
      title: "\u041A\u0443\u043F\u0438\u0442\u044C \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B \u043D\u043E\u0432\u044B\u0439 " + p.inCity + " \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      title_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B \u043D\u043E\u0432\u0438\u0439 " + p.inCity + " \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      description: "\u041A\u0443\u043F\u0438\u0442\u044C \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B \u043D\u043E\u0432\u044B\u0439 " + p.inCity + " \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0439. \u0421\u0440\u0430\u0432\u043D\u0438\u0442\u044C \u0446\u0435\u043D\u044B \u0432 \u043C\u043E\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u0438 \u043E\u0442 \u0447\u0430\u0441\u0442\u043D\u044B\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u043E\u0432",
      description_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B \u043D\u043E\u0432\u0438\u0439 " + p.inCity + " \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u044C. \u041F\u043E\u0440\u0456\u0432\u043D\u044F\u0442\u0438 \u0446\u0456\u043D\u0438 \u0432 \u043C\u043E\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u0456 \u0432\u0456\u0434 \u043F\u0440\u0438\u0432\u0430\u0442\u043D\u0438\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u0456\u0432"
    };
  },
  makeIsnew: function makeIsnew(data, p) {
    return {
      title: "\u041A\u0443\u043F\u0438\u0442\u044C \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B " + data.make + " \u043D\u043E\u0432\u044B\u0439 \u0432 \u0423\u043A\u0440\u0430\u0438\u043D\u0435 \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      title_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B " + data.make + " \u043D\u043E\u0432\u0438\u0439 \u0432 \u0423\u043A\u0440\u0430\u0457\u043D\u0456 \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      description: "\u041A\u0443\u043F\u0438\u0442\u044C \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B " + data.make + " \u043D\u043E\u0432\u044B\u0439 \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0439. \u0421\u0440\u0430\u0432\u043D\u0438\u0442\u044C \u0446\u0435\u043D\u044B \u0432 \u043C\u043E\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u0438 \u043E\u0442 \u0447\u0430\u0441\u0442\u043D\u044B\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u043E\u0432",
      description_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B " + data.make + " \u043D\u043E\u0432\u0438\u0439 \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u044C. \u041F\u043E\u0440\u0456\u0432\u043D\u044F\u0442\u0438 \u0446\u0456\u043D\u0438 \u0432 \u043C\u043E\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u0456 \u0432\u0456\u0434 \u043F\u0440\u0438\u0432\u0430\u0442\u043D\u0438\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u0456\u0432"
    };
  },
  makeBody: function makeBody(data, p) {
    return {
      header: p.buy + " " + p.t(data.body).toLowerCase() + " \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B " + data.make + " \u0431\u0443"
    };
  },
  bodyIsnew: function bodyIsnew(data, p) {
    return {
      header: "\u041A\u0443\u043F\u0438\u0442\u044C \u043D\u043E\u0432\u044B\u0439 " + p.t(data.body).toLowerCase() + " \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B",
      header_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043D\u043E\u0432\u0438\u0439 " + p.t(data.body).toLowerCase() + " \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B"
    };
  },
  bodyCity: function bodyCity(data, p) {
    return {
      header: p.buy + " " + p.t(data.body).toLowerCase() + " \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B \u0431\u0443 " + p.inCity
    };
  },

  makeModelCity: function makeModelCity(data, p) {
    return {
      header: p.buy + " \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " \u0431\u0443 " + p.inCity,

      title: "\u041A\u0443\u043F\u0438\u0442\u044C \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " \u0431\u0443 " + p.inCity + " - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      title_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " \u0431\u0443 " + p.inCity + " - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",

      description: "\u041F\u0440\u043E\u0434\u0430\u0436\u0430 \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B\u043E\u0432 " + data.make + " " + data.model + " \u0431\u0443 " + p.t(data.city) + ". \u041A\u0443\u043F\u0438\u0442\u044C \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " \u0431\u0443 \u0441 \u043F\u0440\u043E\u0431\u0435\u0433\u043E\u043C \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0439 " + p.inCity + ". \u0421\u0440\u0430\u0432\u043D\u0438\u0442\u044C \u0446\u0435\u043D\u044B, \u043F\u043E\u0441\u043C\u043E\u0442\u0440\u0435\u0442\u044C \u0444\u043E\u0442\u043E",
      description_uk: "\u041F\u0440\u043E\u0434\u0430\u0436 \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B\u0456\u0432 " + data.make + " " + data.model + " \u0431\u0443 " + p.t(data.city) + ". \u041A\u0443\u043F\u0438\u0442\u0438 \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " \u0431\u0443 \u0437 \u043F\u0440\u043E\u0431\u0456\u0433\u043E\u043C \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u044C " + p.inCity + ". \u041F\u043E\u0440\u0456\u0432\u043D\u044F\u0442\u0438 \u0446\u0456\u043D\u0438, \u043F\u043E\u0434\u0438\u0432\u0438\u0442\u0438\u0441\u044F \u0444\u043E\u0442\u043E"
    };
  },
  makeModelIsnew: function makeModelIsnew(data, p) {
    return {
      header: "\u041A\u0443\u043F\u0438\u0442\u044C \u043D\u043E\u0432\u044B\u0439 \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B " + data.make + " " + data.model,
      header_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043D\u043E\u0432\u0438\u0439 \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B " + data.make + " " + data.model,

      title: "\u041A\u0443\u043F\u0438\u0442\u044C \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " \u043D\u043E\u0432\u044B\u0439 \u0432 \u0423\u043A\u0440\u0430\u0438\u043D\u0435 \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      title_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " \u043D\u043E\u0432\u0438\u0439 \u0432 \u0423\u043A\u0440\u0430\u0457\u043D\u0456 \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",

      description: "\u041A\u0443\u043F\u0438\u0442\u044C \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " \u043D\u043E\u0432\u044B\u0439 \u0432 \u0423\u043A\u0440\u0430\u0438\u043D\u0435 \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0439. \u0421\u0440\u0430\u0432\u043D\u0438\u0442\u044C \u0446\u0435\u043D\u044B \u0432 \u043C\u043E\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u0438 \u043E\u0442 \u0447\u0430\u0441\u0442\u043D\u044B\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u043E\u0432",
      description_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " \u043D\u043E\u0432\u0438\u0439 \u0432 \u0423\u043A\u0440\u0430\u0457\u043D\u0456 \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u044C. \u041F\u043E\u0440\u0456\u0432\u043D\u044F\u0442\u0438 \u0446\u0456\u043D\u0438 \u0432 \u043C\u043E\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u0456 \u0432\u0456\u0434 \u043F\u0440\u0438\u0432\u0430\u0442\u043D\u0438\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u0456\u0432"
    };
  },
  makeCityIsnew: function makeCityIsnew(data, p) {
    return {
      title: "\u041A\u0443\u043F\u0438\u0442\u044C \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B " + data.make + " \u043D\u043E\u0432\u044B\u0439 " + p.inCity + " - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      title_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B " + data.make + " \u043D\u043E\u0432\u0438\u0439 " + p.inCity + " - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      description: "\u041A\u0443\u043F\u0438\u0442\u044C \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B " + data.make + " \u043D\u043E\u0432\u044B\u0439 " + p.inCity + " \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0439. \u0421\u0440\u0430\u0432\u043D\u0438\u0442\u044C \u0446\u0435\u043D\u044B \u0432 \u043C\u043E\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u0438 \u043E\u0442 \u0447\u0430\u0441\u0442\u043D\u044B\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u043E\u0432",
      description_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B " + data.make + " \u043D\u043E\u0432\u0438\u0439 " + p.inCity + " \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u044C. \u041F\u043E\u0440\u0456\u0432\u043D\u044F\u0442\u0438 \u0446\u0456\u043D\u0438 \u0432 \u043C\u043E\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u0456 \u0432\u0456\u0434 \u043F\u0440\u0438\u0432\u0430\u0442\u043D\u0438\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u0456\u0432"
    };
  },
  makeModelBody: function makeModelBody(data, p) {
    return {
      header: "\u041A\u0443\u043F\u0438\u0442\u044C " + p.t(data.body).toLowerCase() + " \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " \u0431\u0443",
      header_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 " + p.t(data.body).toLowerCase() + " \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " \u0431\u0443"
    };
  },
  makeModelYear: function makeModelYear(data, p) {
    return {
      header: "\u041A\u0443\u043F\u0438\u0442\u044C \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " " + data.year + " \u0433\u043E\u0434\u0430 \u0431\u0443",
      header_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " " + data.year + " \u0440\u043E\u043A\u0443 \u0431\u0443"
    };
  },
  isnewMakeBody: function isnewMakeBody(data, p) {
    return {
      header: "\u041A\u0443\u043F\u0438\u0442\u044C \u043D\u043E\u0432\u044B\u0439 " + p.t(data.body).toLowerCase() + " \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B " + data.make,
      header_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043D\u043E\u0432\u0438\u0439 " + p.t(data.body).toLowerCase() + " \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B " + data.make
    };
  },
  makeCityBody: function makeCityBody(data, p) {
    return {
      header: p.buy + " " + p.t(data.body).toLowerCase() + " \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B " + data.make + " \u0431\u0443 " + p.inCity
    };
  },
  isnewBodyCity: function isnewBodyCity(data, p) {
    return {
      header: "\u041A\u0443\u043F\u0438\u0442\u044C \u043D\u043E\u0432\u044B\u0439 " + p.t(data.body).toLowerCase() + " \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B " + p.inCity,
      header_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043D\u043E\u0432\u0438\u0439 " + p.t(data.body).toLowerCase() + " \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B " + p.inCity
    };
  },

  isnewMakeModelYear: function isnewMakeModelYear(data, p) {
    return {
      header: "\u041A\u0443\u043F\u0438\u0442\u044C \u043D\u043E\u0432\u044B\u0439 \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " " + data.year + " \u0433\u043E\u0434\u0430",
      header_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043D\u043E\u0432\u0438\u0439 \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " " + data.year + " \u0440\u043E\u043A\u0443",

      title: "\u041A\u0443\u043F\u0438\u0442\u044C \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " " + data.year + " \u043D\u043E\u0432\u044B\u0439 \u0432 \u0423\u043A\u0440\u0430\u0438\u043D\u0435 - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      title_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " " + data.year + " \u043D\u043E\u0432\u0438\u0439 \u0432 \u0423\u043A\u0440\u0430\u0457\u043D\u0456 - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      description: "\u041A\u0443\u043F\u0438\u0442\u044C \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " " + data.year + " \u043D\u043E\u0432\u044B\u0439 \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0439. \u0421\u0440\u0430\u0432\u043D\u0438\u0442\u044C \u0446\u0435\u043D\u044B \u0432 \u043C\u043E\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u0438 \u043E\u0442 \u0447\u0430\u0441\u0442\u043D\u044B\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u043E\u0432",
      description_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " " + data.year + " \u043D\u043E\u0432\u0438\u0439 \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u044C. \u041F\u043E\u0440\u0456\u0432\u043D\u044F\u0442\u0438 \u0446\u0456\u043D\u0438 \u0432 \u043C\u043E\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u0456 \u0432\u0456\u0434 \u043F\u0440\u0438\u0432\u0430\u0442\u043D\u0438\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u0456\u0432"
    };
  },
  isnewMakeModelCity: function isnewMakeModelCity(data, p) {
    return {
      header: "\u041A\u0443\u043F\u0438\u0442\u044C \u043D\u043E\u0432\u044B\u0439 \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " " + p.inCity,
      header_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043D\u043E\u0432\u0438\u0439 \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " " + p.inCity,

      title: "\u041A\u0443\u043F\u0438\u0442\u044C \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " \u043D\u043E\u0432\u044B\u0439 " + p.inCity + " - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      title_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " \u043D\u043E\u0432\u0438\u0439 " + p.inCity + " - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      description: "\u041A\u0443\u043F\u0438\u0442\u044C \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " \u043D\u043E\u0432\u044B\u0439 " + p.inCity + " \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0439. \u0421\u0440\u0430\u0432\u043D\u0438\u0442\u044C \u0446\u0435\u043D\u044B \u0432 \u043C\u043E\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u0438 \u043E\u0442 \u0447\u0430\u0441\u0442\u043D\u044B\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u043E\u0432",
      description_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " \u043D\u043E\u0432\u0438\u0439 " + p.inCity + " \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u044C. \u041F\u043E\u0440\u0456\u0432\u043D\u044F\u0442\u0438 \u0446\u0456\u043D\u0438 \u0432 \u043C\u043E\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u0456 \u0432\u0456\u0434 \u043F\u0440\u0438\u0432\u0430\u0442\u043D\u0438\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u0456\u0432"
    };
  },
  isnewMakeModelBody: function isnewMakeModelBody(data, p) {
    return {
      header: "\u041A\u0443\u043F\u0438\u0442\u044C \u043D\u043E\u0432\u044B\u0439 " + p.t(data.body).toLowerCase() + " \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B " + data.make + " " + data.model,
      header_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043D\u043E\u0432\u0438\u0439 " + p.t(data.body).toLowerCase() + " \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B " + data.make + " " + data.model
    };
  },
  makeModelCityBody: function makeModelCityBody(data, p) {
    return {
      header: "\u041A\u0443\u043F\u0438\u0442\u044C " + p.t(data.body).toLowerCase() + " \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " \u0431\u0443 " + p.inCity,
      header_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 " + p.t(data.body).toLowerCase() + " \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " \u0431\u0443 " + p.inCity
    };
  },
  isnewMakeCityBody: function isnewMakeCityBody(data, p) {
    return {
      header: "\u041A\u0443\u043F\u0438\u0442\u044C \u043D\u043E\u0432\u044B\u0439 " + p.t(data.body).toLowerCase() + " \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B " + data.make + " " + p.inCity,
      header_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043D\u043E\u0432\u0438\u0439 " + p.t(data.body).toLowerCase() + " \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B " + data.make + " " + p.inCity
    };
  },

  isnewMakeModelCityBody: function isnewMakeModelCityBody(data, p) {
    return {
      header: "\u041A\u0443\u043F\u0438\u0442\u044C \u043D\u043E\u0432\u044B\u0439 " + p.t(data.body).toLowerCase() + " \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " " + p.inCity,
      header_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043D\u043E\u0432\u0438\u0439 " + p.t(data.body).toLowerCase() + " \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " " + p.inCity
    };
  }
};

/* harmony default export */ var kvadrotsikl_templates_defaultExport = (kvadrotsikl_templates_avtoPathesHead);
// CONCATENATED MODULE: ./src/shared/helpers/seoTextFinder/seoTemplates/search/kvadrotsikl/index.js


var KVADROTSIKL = {
    make: kvadrotsikl_templates_defaultExport.make,
    city: kvadrotsikl_templates_defaultExport.city,
    body: kvadrotsikl_templates_defaultExport.body,

    city_make: kvadrotsikl_templates_defaultExport.makeCity,
    make_model: kvadrotsikl_templates_defaultExport.makeModel,
    city_isnew: kvadrotsikl_templates_defaultExport.cityIsnew,
    isnew_make: kvadrotsikl_templates_defaultExport.makeIsnew,
    body_make: kvadrotsikl_templates_defaultExport.makeBody,
    body_isnew: kvadrotsikl_templates_defaultExport.bodyIsnew,
    body_city: kvadrotsikl_templates_defaultExport.bodyCity,

    city_make_model: kvadrotsikl_templates_defaultExport.makeModelCity,
    isnew_make_model: kvadrotsikl_templates_defaultExport.makeModelIsnew,
    city_isnew_make: kvadrotsikl_templates_defaultExport.makeCityIsnew,
    body_make_model: kvadrotsikl_templates_defaultExport.makeModelBody,
    make_model_year: kvadrotsikl_templates_defaultExport.makeModelYear,
    body_isnew_make: kvadrotsikl_templates_defaultExport.isnewMakeBody,
    body_city_make: kvadrotsikl_templates_defaultExport.makeCityBody,
    body_city_isnew: kvadrotsikl_templates_defaultExport.isnewBodyCity,

    isnew_make_model_year: kvadrotsikl_templates_defaultExport.isnewMakeModelYear,
    city_isnew_make_model: kvadrotsikl_templates_defaultExport.isnewMakeModelCity,
    body_isnew_make_model: kvadrotsikl_templates_defaultExport.isnewMakeModelBody,
    body_city_make_model: kvadrotsikl_templates_defaultExport.makeModelCityBody,
    body_city_isnew_make: kvadrotsikl_templates_defaultExport.isnewMakeCityBody,

    body_city_isnew_make_model: kvadrotsikl_templates_defaultExport.isnewMakeModelCityBody
};
// CONCATENATED MODULE: ./src/shared/helpers/seoTextFinder/seoTemplates/search/baggi/templates.js
var baggi_templates_avtoPathesHead = {
  city: function city(data, p) {
    return {
      title: "\u041A\u0443\u043F\u0438\u0442\u044C \u0431\u0430\u0433\u0433\u0438 \u0431\u0443 " + p.inCity + " \u0441 \u043F\u0440\u043E\u0431\u0435\u0433\u043E\u043C \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      title_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u0431\u0430\u0433\u0433\u0456 \u0431\u0443 " + p.inCity + " \u0437 \u043F\u0440\u043E\u0431\u0456\u0433\u043E\u043C \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",

      description: "\u041F\u0440\u043E\u0434\u0430\u0436\u0430 \u0431\u0430\u0433\u0433\u0438 \u0431\u0443 " + p.t(data.city) + ". \u041A\u0443\u043F\u0438\u0442\u044C \u0431\u0430\u0433\u0433\u0438 \u0431\u0443 " + p.inCity + " \u0441 \u043F\u0440\u043E\u0431\u0435\u0433\u043E\u043C \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u041F\u043E\u0434\u0435\u0440\u0436\u0430\u043D\u043D\u044B\u0435 \u0431\u0430\u0433\u0433\u0438 \u043E\u0442 \u043F\u0440\u043E\u0432\u0435\u0440\u0435\u043D\u043D\u044B\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u043E\u0432. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0439. \u0412\u044B\u0433\u043E\u0434\u043D\u0430\u044F \u0446\u0435\u043D\u0430",
      description_uk: "\u041F\u0440\u043E\u0434\u0430\u0436 \u0431\u0430\u0433\u0433\u0456 \u0431\u0443 " + p.t(data.city) + ". \u041A\u0443\u043F\u0438\u0442\u0438 \u0431\u0430\u0433\u0433\u0456 \u0431\u0443 " + p.inCity + " \u0437 \u043F\u0440\u043E\u0431\u0456\u0433\u043E\u043C \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0412\u0436\u0438\u0432\u0430\u043D\u0456 \u0431\u0430\u0433\u0433\u0456 \u0432\u0456\u0434 \u043F\u0435\u0440\u0435\u0432\u0456\u0440\u0435\u043D\u0438\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u0456\u0432. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u044C. \u0412\u0438\u0433\u0456\u0434\u043D\u0430 \u0446\u0456\u043D\u0430"
    };
  },
  make: function make(data, p) {
    return {
      header: "\u0411\u0430\u0433\u0433\u0438 " + data.make,
      header_uk: "\u0411\u0430\u0433\u0433\u0456 " + data.make,

      title: "\u0411\u0430\u0433\u0433\u0438 " + data.makeTranslit + " \u0432 \u0423\u043A\u0440\u0430\u0438\u043D\u0435, \u043A\u0443\u043F\u0438\u0442\u044C \u0431\u0430\u0433\u0433\u0438 " + data.make + " \u0431\u0443 \u0438\u043B\u0438 \u043D\u043E\u0432\u044B\u0439 - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      title_uk: "\u0411\u0430\u0433\u0433\u0456 " + data.makeTranslit + " \u0432 \u0423\u043A\u0440\u0430\u0457\u043D\u0456, \u043A\u0443\u043F\u0438\u0442\u0438 \u0431\u0430\u0433\u0433\u0456 " + data.make + " \u0431\u0443 \u0430\u0431\u043E \u043D\u043E\u0432\u0438\u0439 - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",

      description: "\u041A\u0443\u043F\u0438\u0442\u044C \u0431\u0430\u0433\u0433\u0438 " + data.make + " \u0441 \u043F\u0440\u043E\u0431\u0435\u0433\u043E\u043C \u0438\u043B\u0438 \u043D\u043E\u0432\u044B\u0439 \u2B50 \u0426\u0435\u043D\u044B \u043D\u0430 \u0431\u0430\u0433\u0433\u0438, \u0445\u0430\u0440\u0430\u043A\u0442\u0435\u0440\u0438\u0441\u0442\u0438\u043A\u0438 \u0438 \u0444\u043E\u0442\u043E \u043D\u0430 \u0441\u0430\u0439\u0442\u0435 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      description_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u0431\u0430\u0433\u0433\u0456 " + data.make + " \u0437 \u043F\u0440\u043E\u0431\u0456\u0433\u043E\u043C \u0430\u0431\u043E \u043D\u043E\u0432\u0438\u0439 \u2B50 \u0426\u0456\u043D\u0438 \u043D\u0430 \u0431\u0430\u0433\u0433\u0456, \u0445\u0430\u0440\u0430\u043A\u0442\u0435\u0440\u0438\u0441\u0442\u0438\u043A\u0438 \u0442\u0430 \u0444\u043E\u0442\u043E \u043D\u0430 \u0441\u0430\u0439\u0442\u0456 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440"
    };
  },
  body: function body(data, p) {
    return {
      header: "\u041A\u0443\u043F\u0438\u0442\u044C " + p.t(data.body).toLowerCase() + " \u0431\u0430\u0433\u0433\u0438 \u0431\u0443",
      header_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 " + p.t(data.body).toLowerCase() + " \u0431\u0430\u0433\u0433\u0456 \u0431\u0443"
    };
  },

  makeModel: function makeModel(data, p) {
    return {
      header: "\u041A\u0443\u043F\u0438\u0442\u044C \u0431\u0430\u0433\u0433\u0438 " + data.make + " " + data.model + " \u0431\u0443",
      header_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u0431\u0430\u0433\u0433\u0456 " + data.make + " " + data.model + " \u0431\u0443",

      title: "\u041A\u0443\u043F\u0438\u0442\u044C \u0431\u0430\u0433\u0433\u0438 " + data.make + " " + data.model + " \u0431\u0443 \u0432 \u0423\u043A\u0440\u0430\u0438\u043D\u0435 \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      title_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u0431\u0430\u0433\u0433\u0456 " + data.make + " " + data.model + " \u0431\u0443 \u0432 \u0423\u043A\u0440\u0430\u0457\u043D\u0456 \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",

      description: "\u041F\u0440\u043E\u0434\u0430\u0436\u0430 \u0431\u0430\u0433\u0433\u0438 " + data.make + " " + data.model + " \u0431\u0443 \u0432 \u0423\u043A\u0440\u0430\u0438\u043D\u0435. \u041A\u0443\u043F\u0438\u0442\u044C \u0431\u0430\u0433\u0433\u0438 " + data.make + " " + data.model + " \u0431\u0443 \u0441 \u043F\u0440\u043E\u0431\u0435\u0433\u043E\u043C \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u041F\u043E\u0434\u0435\u0440\u0436\u0430\u043D\u043D\u044B\u0435 \u0431\u0430\u0433\u0433\u0438 \u043E\u0442 \u043F\u0440\u043E\u0432\u0435\u0440\u0435\u043D\u043D\u044B\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u043E\u0432. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0439",
      description_uk: "\u041F\u0440\u043E\u0434\u0430\u0436 \u0431\u0430\u0433\u0433\u0456 " + data.make + " " + data.model + " \u0431\u0443 \u0432 \u0423\u043A\u0440\u0430\u0457\u043D\u0456. \u041A\u0443\u043F\u0438\u0442\u0438 \u0431\u0430\u0433\u0433\u0456 " + data.make + " " + data.model + " \u0431\u0443 \u0437 \u043F\u0440\u043E\u0431\u0456\u0433\u043E\u043C \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0412\u0436\u0438\u0432\u0430\u043D\u0456 \u0431\u0430\u0433\u0433\u0456 \u0432\u0456\u0434 \u043F\u0435\u0440\u0435\u0432\u0456\u0440\u0435\u043D\u0438\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u0456\u0432. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u044C"
    };
  },
  makeCity: function makeCity(data, p) {
    return {
      title: "\u041A\u0443\u043F\u0438\u0442\u044C \u0431\u0430\u0433\u0433\u0438 " + data.make + " \u0431\u0443 " + p.inCity + " - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      title_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u0431\u0430\u0433\u0433\u0456 " + data.make + " \u0431\u0443 " + p.inCity + " - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",

      description: "\u041F\u0440\u043E\u0434\u0430\u0436\u0430 \u0431\u0430\u0433\u0433\u0438 " + data.make + " \u0431\u0443 " + p.t(data.city) + ". \u041A\u0443\u043F\u0438\u0442\u044C \u0431\u0430\u0433\u0433\u0438 " + data.make + " \u0431\u0443 \u0441 \u043F\u0440\u043E\u0431\u0435\u0433\u043E\u043C \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0439 " + p.inCity + ". \u0421\u0440\u0430\u0432\u043D\u0438\u0442\u044C \u0446\u0435\u043D\u044B, \u043F\u043E\u0441\u043C\u043E\u0442\u0440\u0435\u0442\u044C \u0444\u043E\u0442\u043E",
      description_uk: "\u041F\u0440\u043E\u0434\u0430\u0436 \u0431\u0430\u0433\u0433\u0456 " + data.make + " \u0431\u0443 " + p.t(data.city) + ". \u041A\u0443\u043F\u0438\u0442\u0438 \u0431\u0430\u0433\u0433\u0456 " + data.make + " \u0431\u0443 \u0437 \u043F\u0440\u043E\u0431\u0456\u0433\u043E\u043C \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u044C " + p.inCity + ". \u041F\u043E\u0440\u0456\u0432\u043D\u044F\u0442\u0438 \u0446\u0456\u043D\u0438, \u043F\u043E\u0434\u0438\u0432\u0438\u0442\u0438\u0441\u044F \u0444\u043E\u0442\u043E"
    };
  },
  cityIsnew: function cityIsnew(data, p) {
    return {
      title: "\u041A\u0443\u043F\u0438\u0442\u044C \u0431\u0430\u0433\u0433\u0438 \u043D\u043E\u0432\u044B\u0439 " + p.inCity + " \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      title_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u0431\u0430\u0433\u0433\u0456 \u043D\u043E\u0432\u0438\u0439 " + p.inCity + " \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      description: "\u041A\u0443\u043F\u0438\u0442\u044C \u0431\u0430\u0433\u0433\u0438 \u043D\u043E\u0432\u044B\u0439 " + p.inCity + " \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0439. \u0421\u0440\u0430\u0432\u043D\u0438\u0442\u044C \u0446\u0435\u043D\u044B \u0432 \u043C\u043E\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u0438 \u043E\u0442 \u0447\u0430\u0441\u0442\u043D\u044B\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u043E\u0432",
      description_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u0431\u0430\u0433\u0433\u0456 \u043D\u043E\u0432\u0438\u0439 " + p.inCity + " \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u044C. \u041F\u043E\u0440\u0456\u0432\u043D\u044F\u0442\u0438 \u0446\u0456\u043D\u0438 \u0432 \u043C\u043E\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u0456 \u0432\u0456\u0434 \u043F\u0440\u0438\u0432\u0430\u0442\u043D\u0438\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u0456\u0432"
    };
  },
  makeIsnew: function makeIsnew(data, p) {
    return {
      title: "\u041A\u0443\u043F\u0438\u0442\u044C \u0431\u0430\u0433\u0433\u0438 " + data.make + " \u043D\u043E\u0432\u044B\u0439 \u0432 \u0423\u043A\u0440\u0430\u0438\u043D\u0435 \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      title_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u0431\u0430\u0433\u0433\u0456 " + data.make + " \u043D\u043E\u0432\u0438\u0439 \u0432 \u0423\u043A\u0440\u0430\u0457\u043D\u0456 \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      description: "\u041A\u0443\u043F\u0438\u0442\u044C \u0431\u0430\u0433\u0433\u0438 " + data.make + " \u043D\u043E\u0432\u044B\u0439 \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0439. \u0421\u0440\u0430\u0432\u043D\u0438\u0442\u044C \u0446\u0435\u043D\u044B \u0432 \u043C\u043E\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u0438 \u043E\u0442 \u0447\u0430\u0441\u0442\u043D\u044B\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u043E\u0432",
      description_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u0431\u0430\u0433\u0433\u0456 " + data.make + " \u043D\u043E\u0432\u0438\u0439 \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u044C. \u041F\u043E\u0440\u0456\u0432\u043D\u044F\u0442\u0438 \u0446\u0456\u043D\u0438 \u0432 \u043C\u043E\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u0456 \u0432\u0456\u0434 \u043F\u0440\u0438\u0432\u0430\u0442\u043D\u0438\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u0456\u0432"
    };
  },
  makeBody: function makeBody(data, p) {
    return {
      header: "\u041A\u0443\u043F\u0438\u0442\u044C " + p.t(data.body).toLowerCase() + " \u0431\u0430\u0433\u0433\u0438 " + data.make + " \u0431\u0443",
      header_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 " + p.t(data.body).toLowerCase() + " \u0431\u0430\u0433\u0433\u0456 " + data.make + " \u0431\u0443"
    };
  },
  bodyIsnew: function bodyIsnew(data, p) {
    return {
      header: "\u041A\u0443\u043F\u0438\u0442\u044C \u043D\u043E\u0432\u044B\u0439 " + p.t(data.body).toLowerCase() + " \u0431\u0430\u0433\u0433\u0438",
      header_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043D\u043E\u0432\u0438\u0439 " + p.t(data.body).toLowerCase() + " \u0431\u0430\u0433\u0433\u0456"
    };
  },
  bodyCity: function bodyCity(data, p) {
    return {
      header: "\u041A\u0443\u043F\u0438\u0442\u044C " + p.t(data.body).toLowerCase() + " \u0431\u0430\u0433\u0433\u0438 \u0431\u0443 " + p.inCity,
      header_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 " + p.t(data.body).toLowerCase() + " \u0431\u0430\u0433\u0433\u0456 \u0431\u0443 " + p.inCity
    };
  },

  makeModelCity: function makeModelCity(data, p) {
    return {
      header: "\u041A\u0443\u043F\u0438\u0442\u044C \u0431\u0430\u0433\u0433\u0438 " + data.make + " " + data.model + " \u0431\u0443 " + p.inCity,
      header_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u0431\u0430\u0433\u0433\u0456 " + data.make + " " + data.model + " \u0431\u0443 " + p.inCity,

      title: "\u041A\u0443\u043F\u0438\u0442\u044C \u0431\u0430\u0433\u0433\u0438 " + data.make + " " + data.model + " \u0431\u0443 " + p.inCity + " - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      title_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u0431\u0430\u0433\u0433\u0456 " + data.make + " " + data.model + " \u0431\u0443 " + p.inCity + " - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",

      description: "\u041F\u0440\u043E\u0434\u0430\u0436\u0430 \u0431\u0430\u0433\u0433\u0438 " + data.make + " " + data.model + " \u0431\u0443 " + p.t(data.city) + ". \u041A\u0443\u043F\u0438\u0442\u044C \u0431\u0430\u0433\u0433\u0438 " + data.make + " " + data.model + " \u0431\u0443 \u0441 \u043F\u0440\u043E\u0431\u0435\u0433\u043E\u043C \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0439 " + p.inCity + ". \u0421\u0440\u0430\u0432\u043D\u0438\u0442\u044C \u0446\u0435\u043D\u044B, \u043F\u043E\u0441\u043C\u043E\u0442\u0440\u0435\u0442\u044C \u0444\u043E\u0442\u043E",
      description_uk: "\u041F\u0440\u043E\u0434\u0430\u0436 \u0431\u0430\u0433\u0433\u0456 " + data.make + " " + data.model + " \u0431\u0443 " + p.t(data.city) + ". \u041A\u0443\u043F\u0438\u0442\u0438 \u0431\u0430\u0433\u0433\u0456 " + data.make + " " + data.model + " \u0431\u0443 \u0437 \u043F\u0440\u043E\u0431\u0456\u0433\u043E\u043C \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u044C " + p.inCity + ". \u041F\u043E\u0440\u0456\u0432\u043D\u044F\u0442\u0438 \u0446\u0456\u043D\u0438, \u043F\u043E\u0434\u0438\u0432\u0438\u0442\u0438\u0441\u044F \u0444\u043E\u0442\u043E"
    };
  },
  makeModelIsnew: function makeModelIsnew(data, p) {
    return {
      header: "\u041A\u0443\u043F\u0438\u0442\u044C \u043D\u043E\u0432\u044B\u0439 \u0431\u0430\u0433\u0433\u0438 " + data.make + " " + data.model,
      header_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043D\u043E\u0432\u0438\u0439 \u0431\u0430\u0433\u0433\u0456 " + data.make + " " + data.model,

      title: "\u041A\u0443\u043F\u0438\u0442\u044C \u0431\u0430\u0433\u0433\u0438 " + data.make + " " + data.model + " \u043D\u043E\u0432\u044B\u0439 \u0432 \u0423\u043A\u0440\u0430\u0438\u043D\u0435 \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      title_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u0431\u0430\u0433\u0433\u0456 " + data.make + " " + data.model + " \u043D\u043E\u0432\u0438\u0439 \u0432 \u0423\u043A\u0440\u0430\u0457\u043D\u0456 \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",

      description: "\u041A\u0443\u043F\u0438\u0442\u044C \u0431\u0430\u0433\u0433\u0438 " + data.make + " " + data.model + " \u043D\u043E\u0432\u044B\u0439 \u0432 \u0423\u043A\u0440\u0430\u0438\u043D\u0435 \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0439. \u0421\u0440\u0430\u0432\u043D\u0438\u0442\u044C \u0446\u0435\u043D\u044B \u0432 \u043C\u043E\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u0438 \u043E\u0442 \u0447\u0430\u0441\u0442\u043D\u044B\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u043E\u0432",
      description_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u0431\u0430\u0433\u0433\u0456 " + data.make + " " + data.model + " \u043D\u043E\u0432\u0438\u0439 \u0432 \u0423\u043A\u0440\u0430\u0457\u043D\u0456 \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u044C. \u041F\u043E\u0440\u0456\u0432\u043D\u044F\u0442\u0438 \u0446\u0456\u043D\u0438 \u0432 \u043C\u043E\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u0456 \u0432\u0456\u0434 \u043F\u0440\u0438\u0432\u0430\u0442\u043D\u0438\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u0456\u0432"
    };
  },
  makeCityIsnew: function makeCityIsnew(data, p) {
    return {
      title: "\u041A\u0443\u043F\u0438\u0442\u044C \u0431\u0430\u0433\u0433\u0438 " + data.make + " \u043D\u043E\u0432\u044B\u0439 " + p.inCity + " - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      title_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u0431\u0430\u0433\u0433\u0456 " + data.make + " \u043D\u043E\u0432\u0438\u0439 " + p.inCity + " - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      description: "\u041A\u0443\u043F\u0438\u0442\u044C \u0431\u0430\u0433\u0433\u0438 " + data.make + " \u043D\u043E\u0432\u044B\u0439 " + p.inCity + " \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0439. \u0421\u0440\u0430\u0432\u043D\u0438\u0442\u044C \u0446\u0435\u043D\u044B \u0432 \u043C\u043E\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u0438 \u043E\u0442 \u0447\u0430\u0441\u0442\u043D\u044B\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u043E\u0432",
      description_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u0431\u0430\u0433\u0433\u0456 " + data.make + " \u043D\u043E\u0432\u0438\u0439 " + p.inCity + " \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u044C. \u041F\u043E\u0440\u0456\u0432\u043D\u044F\u0442\u0438 \u0446\u0456\u043D\u0438 \u0432 \u043C\u043E\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u0456 \u0432\u0456\u0434 \u043F\u0440\u0438\u0432\u0430\u0442\u043D\u0438\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u0456\u0432"
    };
  },
  makeModelBody: function makeModelBody(data, p) {
    return {
      header: "\u041A\u0443\u043F\u0438\u0442\u044C " + p.t(data.body).toLowerCase() + " \u0431\u0430\u0433\u0433\u0438 " + data.make + " " + data.model + " \u0431\u0443",
      header_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 " + p.t(data.body).toLowerCase() + " \u0431\u0430\u0433\u0433\u0456 " + data.make + " " + data.model + " \u0431\u0443"
    };
  },
  makeModelYear: function makeModelYear(data, p) {
    return {
      header: "\u041A\u0443\u043F\u0438\u0442\u044C \u0431\u0430\u0433\u0433\u0438 " + data.make + " " + data.model + " " + data.year + " \u0433\u043E\u0434\u0430 \u0431\u0443",
      header_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u0431\u0430\u0433\u0433\u0456 " + data.make + " " + data.model + " " + data.year + " \u0440\u043E\u043A\u0443 \u0431\u0443"
    };
  },
  isnewMakeBody: function isnewMakeBody(data, p) {
    return {
      header: "\u041A\u0443\u043F\u0438\u0442\u044C \u043D\u043E\u0432\u044B\u0439 " + p.t(data.body).toLowerCase() + " \u0431\u0430\u0433\u0433\u0438 " + data.make,
      header_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043D\u043E\u0432\u0438\u0439 " + p.t(data.body).toLowerCase() + " \u0431\u0430\u0433\u0433\u0456 " + data.make
    };
  },
  makeCityBody: function makeCityBody(data, p) {
    return {
      header: "\u041A\u0443\u043F\u0438\u0442\u044C " + p.t(data.body).toLowerCase() + " \u0431\u0430\u0433\u0433\u0438 " + data.make + " \u0431\u0443 " + p.inCity,
      header_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 " + p.t(data.body).toLowerCase() + " \u0431\u0430\u0433\u0433\u0456 " + data.make + " \u0431\u0443 " + p.inCity
    };
  },
  isnewBodyCity: function isnewBodyCity(data, p) {
    return {
      header: "\u041A\u0443\u043F\u0438\u0442\u044C \u043D\u043E\u0432\u044B\u0439 " + p.t(data.body).toLowerCase() + " \u0431\u0430\u0433\u0433\u0438 " + p.inCity,
      header_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043D\u043E\u0432\u0438\u0439 " + p.t(data.body).toLowerCase() + " \u0431\u0430\u0433\u0433\u0456 " + p.inCity
    };
  },

  isnewMakeModelYear: function isnewMakeModelYear(data, p) {
    return {
      header: "\u041A\u0443\u043F\u0438\u0442\u044C \u043D\u043E\u0432\u044B\u0439 \u0431\u0430\u0433\u0433\u0438 " + data.make + " " + data.model + " " + data.year + " \u0433\u043E\u0434\u0430",
      header_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043D\u043E\u0432\u0438\u0439 \u0431\u0430\u0433\u0433\u0456 " + data.make + " " + data.model + " " + data.year + " \u0440\u043E\u043A\u0443",

      title: "\u041A\u0443\u043F\u0438\u0442\u044C \u0431\u0430\u0433\u0433\u0438 " + data.make + " " + data.model + " " + data.year + " \u043D\u043E\u0432\u044B\u0439 \u0432 \u0423\u043A\u0440\u0430\u0438\u043D\u0435 - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      title_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u0431\u0430\u0433\u0433\u0456 " + data.make + " " + data.model + " " + data.year + " \u043D\u043E\u0432\u0438\u0439 \u0432 \u0423\u043A\u0440\u0430\u0457\u043D\u0456 - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      description: "\u041A\u0443\u043F\u0438\u0442\u044C \u0431\u0430\u0433\u0433\u0438 " + data.make + " " + data.model + " " + data.year + " \u043D\u043E\u0432\u044B\u0439 \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0439. \u0421\u0440\u0430\u0432\u043D\u0438\u0442\u044C \u0446\u0435\u043D\u044B \u0432 \u043C\u043E\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u0438 \u043E\u0442 \u0447\u0430\u0441\u0442\u043D\u044B\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u043E\u0432",
      description_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u0431\u0430\u0433\u0433\u0456 " + data.make + " " + data.model + " " + data.year + " \u043D\u043E\u0432\u0438\u0439 \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u044C. \u041F\u043E\u0440\u0456\u0432\u043D\u044F\u0442\u0438 \u0446\u0456\u043D\u0438 \u0432 \u043C\u043E\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u0456 \u0432\u0456\u0434 \u043F\u0440\u0438\u0432\u0430\u0442\u043D\u0438\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u0456\u0432"
    };
  },
  isnewMakeModelCity: function isnewMakeModelCity(data, p) {
    return {
      header: "\u041A\u0443\u043F\u0438\u0442\u044C \u043D\u043E\u0432\u044B\u0439 \u0431\u0430\u0433\u0433\u0438 " + data.make + " " + data.model + " " + p.inCity,
      header_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043D\u043E\u0432\u0438\u0439 \u0431\u0430\u0433\u0433\u0456 " + data.make + " " + data.model + " " + p.inCity,

      title: "\u041A\u0443\u043F\u0438\u0442\u044C \u0431\u0430\u0433\u0433\u0438 " + data.make + " " + data.model + " \u043D\u043E\u0432\u044B\u0439 " + p.inCity + " - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      title_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u0431\u0430\u0433\u0433\u0456 " + data.make + " " + data.model + " \u043D\u043E\u0432\u0438\u0439 " + p.inCity + " - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      description: "\u041A\u0443\u043F\u0438\u0442\u044C \u0431\u0430\u0433\u0433\u0438 " + data.make + " " + data.model + " \u043D\u043E\u0432\u044B\u0439 " + p.inCity + " \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0439. \u0421\u0440\u0430\u0432\u043D\u0438\u0442\u044C \u0446\u0435\u043D\u044B \u0432 \u043C\u043E\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u0438 \u043E\u0442 \u0447\u0430\u0441\u0442\u043D\u044B\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u043E\u0432",
      description_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u0431\u0430\u0433\u0433\u0456 " + data.make + " " + data.model + " \u043D\u043E\u0432\u0438\u0439 " + p.inCity + " \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u044C. \u041F\u043E\u0440\u0456\u0432\u043D\u044F\u0442\u0438 \u0446\u0456\u043D\u0438 \u0432 \u043C\u043E\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u0456 \u0432\u0456\u0434 \u043F\u0440\u0438\u0432\u0430\u0442\u043D\u0438\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u0456\u0432"
    };
  },
  isnewMakeModelBody: function isnewMakeModelBody(data, p) {
    return {
      header: "\u041A\u0443\u043F\u0438\u0442\u044C \u043D\u043E\u0432\u044B\u0439 " + p.t(data.body).toLowerCase() + " \u0431\u0430\u0433\u0433\u0438 " + data.make + " " + data.model,
      header_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043D\u043E\u0432\u0438\u0439 " + p.t(data.body).toLowerCase() + " \u0431\u0430\u0433\u0433\u0456 " + data.make + " " + data.model
    };
  },
  makeModelCityBody: function makeModelCityBody(data, p) {
    return {
      header: "\u041A\u0443\u043F\u0438\u0442\u044C " + p.t(data.body).toLowerCase() + " \u0431\u0430\u0433\u0433\u0438 " + data.make + " " + data.model + " \u0431\u0443 " + p.inCity,
      header_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 " + p.t(data.body).toLowerCase() + " \u0431\u0430\u0433\u0433\u0456 " + data.make + " " + data.model + " \u0431\u0443 " + p.inCity
    };
  },
  isnewMakeCityBody: function isnewMakeCityBody(data, p) {
    return {
      header: "\u041A\u0443\u043F\u0438\u0442\u044C \u043D\u043E\u0432\u044B\u0439 " + p.t(data.body).toLowerCase() + " \u0431\u0430\u0433\u0433\u0438 " + data.make + " " + p.inCity,
      header_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043D\u043E\u0432\u0438\u0439 " + p.t(data.body).toLowerCase() + " \u0431\u0430\u0433\u0433\u0456 " + data.make + " " + p.inCity
    };
  },

  isnewMakeModelCityBody: function isnewMakeModelCityBody(data, p) {
    return {
      header: "\u041A\u0443\u043F\u0438\u0442\u044C \u043D\u043E\u0432\u044B\u0439 " + p.t(data.body).toLowerCase() + " \u0431\u0430\u0433\u0433\u0438 " + data.make + " " + data.model + " " + p.inCity,
      header_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043D\u043E\u0432\u0438\u0439 " + p.t(data.body).toLowerCase() + " \u0431\u0430\u0433\u0433\u0456 " + data.make + " " + data.model + " " + p.inCity
    };
  }
};

/* harmony default export */ var baggi_templates_defaultExport = (baggi_templates_avtoPathesHead);
// CONCATENATED MODULE: ./src/shared/helpers/seoTextFinder/seoTemplates/search/baggi/index.js


var BAGGI = {
    city: baggi_templates_defaultExport.city,
    make: baggi_templates_defaultExport.make,
    body: baggi_templates_defaultExport.body,

    make_model: baggi_templates_defaultExport.makeModel,
    city_make: baggi_templates_defaultExport.makeCity,
    city_isnew: baggi_templates_defaultExport.cityIsnew,
    isnew_make: baggi_templates_defaultExport.makeIsnew,
    body_make: baggi_templates_defaultExport.makeBody,
    body_isnew: baggi_templates_defaultExport.bodyIsnew,
    body_city: baggi_templates_defaultExport.bodyCity,

    city_make_model: baggi_templates_defaultExport.makeModelCity,
    isnew_make_model: baggi_templates_defaultExport.makeModelIsnew,
    city_isnew_make: baggi_templates_defaultExport.makeCityIsnew,
    body_make_model: baggi_templates_defaultExport.makeModelBody,
    make_model_year: baggi_templates_defaultExport.makeModelYear,
    body_isnew_make: baggi_templates_defaultExport.isnewMakeBody,
    body_city_make: baggi_templates_defaultExport.makeCityBody,
    body_city_isnew: baggi_templates_defaultExport.isnewBodyCity,

    isnew_make_model_year: baggi_templates_defaultExport.isnewMakeModelYear,
    city_isnew_make_model: baggi_templates_defaultExport.isnewMakeModelCity,
    body_isnew_make_model: baggi_templates_defaultExport.isnewMakeModelBody,
    body_city_make_model: baggi_templates_defaultExport.makeModelCityBody,
    body_city_isnew_make: baggi_templates_defaultExport.isnewMakeCityBody,

    body_city_isnew_make_model: baggi_templates_defaultExport.isnewMakeModelCityBody
};
// CONCATENATED MODULE: ./src/shared/helpers/seoTextFinder/seoTemplates/search/tritsikl/templates.js
var tritsikl_templates_avtoPathesHead = {
  city: function city(data, p) {
    return {
      title: "\u041A\u0443\u043F\u0438\u0442\u044C \u0442\u0440\u0438\u0446\u0438\u043A\u043B \u0431\u0443 " + p.inCity + " \u0441 \u043F\u0440\u043E\u0431\u0435\u0433\u043E\u043C \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      title_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u0442\u0440\u0438\u0446\u0438\u043A\u043B \u0431\u0443 " + p.inCity + " \u0437 \u043F\u0440\u043E\u0431\u0456\u0433\u043E\u043C \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",

      description: "\u041F\u0440\u043E\u0434\u0430\u0436\u0430 \u0442\u0440\u0438\u0446\u0438\u043A\u043B\u043E\u0432 \u0431\u0443 " + p.t(data.city) + ". \u041A\u0443\u043F\u0438\u0442\u044C \u0442\u0440\u0438\u0446\u0438\u043A\u043B \u0431\u0443 " + p.inCity + " \u0441 \u043F\u0440\u043E\u0431\u0435\u0433\u043E\u043C \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u041F\u043E\u0434\u0435\u0440\u0436\u0430\u043D\u043D\u044B\u0435 \u0442\u0440\u0438\u0446\u0438\u043A\u043B\u044B \u043E\u0442 \u043F\u0440\u043E\u0432\u0435\u0440\u0435\u043D\u043D\u044B\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u043E\u0432. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0439. \u0412\u044B\u0433\u043E\u0434\u043D\u0430\u044F \u0446\u0435\u043D\u0430",
      description_uk: "\u041F\u0440\u043E\u0434\u0430\u0436 \u0442\u0440\u0438\u0446\u0438\u043A\u043B\u0456\u0432 \u0431\u0443 " + p.t(data.city) + ". \u041A\u0443\u043F\u0438\u0442\u0438 \u0442\u0440\u0438\u0446\u0438\u043A\u043B \u0431\u0443 " + p.inCity + " \u0437 \u043F\u0440\u043E\u0431\u0456\u0433\u043E\u043C \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0412\u0436\u0438\u0432\u0430\u043D\u0456 \u0442\u0440\u0438\u0446\u0438\u043A\u043B\u0438 \u0432\u0456\u0434 \u043F\u0435\u0440\u0435\u0432\u0456\u0440\u0435\u043D\u0438\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u0456\u0432. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u044C. \u0412\u0438\u0433\u0456\u0434\u043D\u0430 \u0446\u0456\u043D\u0430"
    };
  },
  make: function make(data, p) {
    return {
      header: "\u0422\u0440\u0438\u0446\u0438\u043A\u043B\u044B " + data.make,
      header_uk: "\u0422\u0440\u0438\u0446\u0438\u043A\u043B\u0438 " + data.make,

      title: "\u0422\u0440\u0438\u0446\u0438\u043A\u043B\u044B " + data.makeTranslit + " \u0432 \u0423\u043A\u0440\u0430\u0438\u043D\u0435, \u043A\u0443\u043F\u0438\u0442\u044C \u0442\u0440\u0438\u0446\u0438\u043A\u043B " + data.make + " \u0431\u0443 \u0438\u043B\u0438 \u043D\u043E\u0432\u044B\u0439 - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      title_uk: "\u0422\u0440\u0438\u0446\u0438\u043A\u043B\u0438 " + data.makeTranslit + " \u0432 \u0423\u043A\u0440\u0430\u0457\u043D\u0456, \u043A\u0443\u043F\u0438\u0442\u0438 \u0442\u0440\u0438\u0446\u0438\u043A\u043B " + data.make + " \u0431\u0443 \u0430\u0431\u043E \u043D\u043E\u0432\u0438\u0439 - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",

      description: "\u041A\u0443\u043F\u0438\u0442\u044C \u0442\u0440\u0438\u0446\u0438\u043A\u043B " + data.make + " \u0441 \u043F\u0440\u043E\u0431\u0435\u0433\u043E\u043C \u0438\u043B\u0438 \u043D\u043E\u0432\u044B\u0439 \u2B50 \u0426\u0435\u043D\u044B \u043D\u0430 \u0442\u0440\u0438\u0446\u0438\u043A\u043B\u044B, \u0445\u0430\u0440\u0430\u043A\u0442\u0435\u0440\u0438\u0441\u0442\u0438\u043A\u0438 \u0438 \u0444\u043E\u0442\u043E \u043D\u0430 \u0441\u0430\u0439\u0442\u0435 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      description_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u0442\u0440\u0438\u0446\u0438\u043A\u043B " + data.make + " \u0437 \u043F\u0440\u043E\u0431\u0456\u0433\u043E\u043C \u0430\u0431\u043E \u043D\u043E\u0432\u0438\u0439 \u2B50 \u0426\u0456\u043D\u0438 \u043D\u0430 \u0442\u0440\u0438\u0446\u0438\u043A\u043B\u0438, \u0445\u0430\u0440\u0430\u043A\u0442\u0435\u0440\u0438\u0441\u0442\u0438\u043A\u0438 \u0442\u0430 \u0444\u043E\u0442\u043E \u043D\u0430 \u0441\u0430\u0439\u0442\u0456 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440"
    };
  },
  body: function body(data, p) {
    return {
      header: p.buy + " " + p.t(data.body).toLowerCase() + " \u0442\u0440\u0438\u0446\u0438\u043A\u043B \u0431\u0443"
    };
  },

  makeCity: function makeCity(data, p) {
    return {
      title: "\u041A\u0443\u043F\u0438\u0442\u044C \u0442\u0440\u0438\u0446\u0438\u043A\u043B " + data.make + " \u0431\u0443 " + p.inCity + " - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      title_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u0442\u0440\u0438\u0446\u0438\u043A\u043B " + data.make + " \u0431\u0443 " + p.inCity + " - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",

      description: "\u041F\u0440\u043E\u0434\u0430\u0436\u0430 \u0442\u0440\u0438\u0446\u0438\u043A\u043B\u043E\u0432 " + data.make + " \u0431\u0443 " + p.t(data.city) + ". \u041A\u0443\u043F\u0438\u0442\u044C \u0442\u0440\u0438\u0446\u0438\u043A\u043B " + data.make + " \u0431\u0443 \u0441 \u043F\u0440\u043E\u0431\u0435\u0433\u043E\u043C \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0439 " + p.inCity + ". \u0421\u0440\u0430\u0432\u043D\u0438\u0442\u044C \u0446\u0435\u043D\u044B, \u043F\u043E\u0441\u043C\u043E\u0442\u0440\u0435\u0442\u044C \u0444\u043E\u0442\u043E",
      description_uk: "\u041F\u0440\u043E\u0434\u0430\u0436 \u0442\u0440\u0438\u0446\u0438\u043A\u043B\u0456\u0432 " + data.make + " \u0431\u0443 " + p.t(data.city) + ". \u041A\u0443\u043F\u0438\u0442\u0438 \u0442\u0440\u0438\u0446\u0438\u043A\u043B " + data.make + " \u0431\u0443 \u0437 \u043F\u0440\u043E\u0431\u0456\u0433\u043E\u043C \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u044C " + p.inCity + ". \u041F\u043E\u0440\u0456\u0432\u043D\u044F\u0442\u0438 \u0446\u0456\u043D\u0438, \u043F\u043E\u0434\u0438\u0432\u0438\u0442\u0438\u0441\u044F \u0444\u043E\u0442\u043E"
    };
  },
  makeModel: function makeModel(data, p) {
    return {
      header: p.buy + " \u0442\u0440\u0438\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " \u0431\u0443",

      title: "\u041A\u0443\u043F\u0438\u0442\u044C \u0442\u0440\u0438\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " \u0431\u0443 \u0432 \u0423\u043A\u0440\u0430\u0438\u043D\u0435 \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      title_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u0442\u0440\u0438\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " \u0431\u0443 \u0432 \u0423\u043A\u0440\u0430\u0457\u043D\u0456 \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",

      description: "\u041F\u0440\u043E\u0434\u0430\u0436\u0430 \u0442\u0440\u0438\u0446\u0438\u043A\u043B\u043E\u0432 " + data.make + " " + data.model + " \u0431\u0443 \u0432 \u0423\u043A\u0440\u0430\u0438\u043D\u0435. \u041A\u0443\u043F\u0438\u0442\u044C \u0442\u0440\u0438\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " \u0431\u0443 \u0441 \u043F\u0440\u043E\u0431\u0435\u0433\u043E\u043C \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u041F\u043E\u0434\u0435\u0440\u0436\u0430\u043D\u043D\u044B\u0435 \u0442\u0440\u0438\u0446\u0438\u043A\u043B\u044B \u043E\u0442 \u043F\u0440\u043E\u0432\u0435\u0440\u0435\u043D\u043D\u044B\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u043E\u0432. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0439",
      description_uk: "\u041F\u0440\u043E\u0434\u0430\u0436 \u0442\u0440\u0438\u0446\u0438\u043A\u043B\u0456\u0432 " + data.make + " " + data.model + " \u0431\u0443 \u0432 \u0423\u043A\u0440\u0430\u0457\u043D\u0456. \u041A\u0443\u043F\u0438\u0442\u0438 \u0442\u0440\u0438\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " \u0431\u0443 \u0437 \u043F\u0440\u043E\u0431\u0456\u0433\u043E\u043C \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0412\u0436\u0438\u0432\u0430\u043D\u0456 \u0442\u0440\u0438\u0446\u0438\u043A\u043B\u0438 \u0432\u0456\u0434 \u043F\u0435\u0440\u0435\u0432\u0456\u0440\u0435\u043D\u0438\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u0456\u0432. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u044C"
    };
  },
  cityIsnew: function cityIsnew(data, p) {
    return {
      title: "\u041A\u0443\u043F\u0438\u0442\u044C \u0442\u0440\u0438\u0446\u0438\u043A\u043B \u043D\u043E\u0432\u044B\u0439 " + p.inCity + " \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      title_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u0442\u0440\u0438\u0446\u0438\u043A\u043B \u043D\u043E\u0432\u0438\u0439 " + p.inCity + " \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      description: "\u041A\u0443\u043F\u0438\u0442\u044C \u0442\u0440\u0438\u0446\u0438\u043A\u043B \u043D\u043E\u0432\u044B\u0439 " + p.inCity + " \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0439. \u0421\u0440\u0430\u0432\u043D\u0438\u0442\u044C \u0446\u0435\u043D\u044B \u0432 \u043C\u043E\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u0438 \u043E\u0442 \u0447\u0430\u0441\u0442\u043D\u044B\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u043E\u0432",
      description_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u0442\u0440\u0438\u0446\u0438\u043A\u043B \u043D\u043E\u0432\u0438\u0439 " + p.inCity + " \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u044C. \u041F\u043E\u0440\u0456\u0432\u043D\u044F\u0442\u0438 \u0446\u0456\u043D\u0438 \u0432 \u043C\u043E\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u0456 \u0432\u0456\u0434 \u043F\u0440\u0438\u0432\u0430\u0442\u043D\u0438\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u0456\u0432"
    };
  },
  makeIsnew: function makeIsnew(data, p) {
    return {
      title: "\u041A\u0443\u043F\u0438\u0442\u044C \u0442\u0440\u0438\u0446\u0438\u043A\u043B " + data.make + " \u043D\u043E\u0432\u044B\u0439 \u0432 \u0423\u043A\u0440\u0430\u0438\u043D\u0435 \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      title_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u0442\u0440\u0438\u0446\u0438\u043A\u043B " + data.make + " \u043D\u043E\u0432\u0438\u0439 \u0432 \u0423\u043A\u0440\u0430\u0457\u043D\u0456 \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      description: "\u041A\u0443\u043F\u0438\u0442\u044C \u0442\u0440\u0438\u0446\u0438\u043A\u043B " + data.make + " \u043D\u043E\u0432\u044B\u0439 \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0439. \u0421\u0440\u0430\u0432\u043D\u0438\u0442\u044C \u0446\u0435\u043D\u044B \u0432 \u043C\u043E\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u0438 \u043E\u0442 \u0447\u0430\u0441\u0442\u043D\u044B\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u043E\u0432",
      description_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u0442\u0440\u0438\u0446\u0438\u043A\u043B " + data.make + " \u043D\u043E\u0432\u0438\u0439 \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u044C. \u041F\u043E\u0440\u0456\u0432\u043D\u044F\u0442\u0438 \u0446\u0456\u043D\u0438 \u0432 \u043C\u043E\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u0456 \u0432\u0456\u0434 \u043F\u0440\u0438\u0432\u0430\u0442\u043D\u0438\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u0456\u0432"
    };
  },
  makeBody: function makeBody(data, p) {
    return {
      header: p.buy + " " + p.t(data.body).toLowerCase() + " \u0442\u0440\u0438\u0446\u0438\u043A\u043B " + data.make + " \u0431\u0443"
    };
  },
  bodyIsnew: function bodyIsnew(data, p) {
    return {
      header: "\u041A\u0443\u043F\u0438\u0442\u044C \u043D\u043E\u0432\u044B\u0439 " + p.t(data.body).toLowerCase() + " \u0442\u0440\u0438\u0446\u0438\u043A\u043B",
      header_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043D\u043E\u0432\u0438\u0439 " + p.t(data.body).toLowerCase() + " \u0442\u0440\u0438\u0446\u0438\u043A\u043B"
    };
  },
  bodyCity: function bodyCity(data, p) {
    return {
      header: p.buy + " " + p.t(data.body).toLowerCase() + " \u0442\u0440\u0438\u0446\u0438\u043A\u043B \u0431\u0443 " + p.inCity
    };
  },

  makeModelCity: function makeModelCity(data, p) {
    return {
      header: p.buy + " \u0442\u0440\u0438\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " \u0431\u0443 " + p.inCity,

      title: "\u041A\u0443\u043F\u0438\u0442\u044C \u0442\u0440\u0438\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " \u0431\u0443 " + p.inCity + " - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      title_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u0442\u0440\u0438\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " \u0431\u0443 " + p.inCity + " - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",

      description: "\u041F\u0440\u043E\u0434\u0430\u0436\u0430 \u0442\u0440\u0438\u0446\u0438\u043A\u043B\u043E\u0432 " + data.make + " " + data.model + " \u0431\u0443 " + p.t(data.city) + ". \u041A\u0443\u043F\u0438\u0442\u044C \u0442\u0440\u0438\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " \u0431\u0443 \u0441 \u043F\u0440\u043E\u0431\u0435\u0433\u043E\u043C \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0439 " + p.inCity + ". \u0421\u0440\u0430\u0432\u043D\u0438\u0442\u044C \u0446\u0435\u043D\u044B, \u043F\u043E\u0441\u043C\u043E\u0442\u0440\u0435\u0442\u044C \u0444\u043E\u0442\u043E",
      description_uk: "\u041F\u0440\u043E\u0434\u0430\u0436 \u0442\u0440\u0438\u0446\u0438\u043A\u043B\u0456\u0432 " + data.make + " " + data.model + " \u0431\u0443 " + p.t(data.city) + ". \u041A\u0443\u043F\u0438\u0442\u0438 \u0442\u0440\u0438\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " \u0431\u0443 \u0437 \u043F\u0440\u043E\u0431\u0456\u0433\u043E\u043C \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u044C " + p.inCity + ". \u041F\u043E\u0440\u0456\u0432\u043D\u044F\u0442\u0438 \u0446\u0456\u043D\u0438, \u043F\u043E\u0434\u0438\u0432\u0438\u0442\u0438\u0441\u044F \u0444\u043E\u0442\u043E"
    };
  },
  makeModelIsnew: function makeModelIsnew(data, p) {
    return {
      header: "\u041A\u0443\u043F\u0438\u0442\u044C \u043D\u043E\u0432\u044B\u0439 \u0442\u0440\u0438\u0446\u0438\u043A\u043B " + data.make + " " + data.model,
      header_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043D\u043E\u0432\u0438\u0439 \u0442\u0440\u0438\u0446\u0438\u043A\u043B " + data.make + " " + data.model,

      title: "\u041A\u0443\u043F\u0438\u0442\u044C \u0442\u0440\u0438\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " \u043D\u043E\u0432\u044B\u0439 \u0432 \u0423\u043A\u0440\u0430\u0438\u043D\u0435 \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      title_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u0442\u0440\u0438\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " \u043D\u043E\u0432\u0438\u0439 \u0432 \u0423\u043A\u0440\u0430\u0457\u043D\u0456 \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",

      description: "\u041A\u0443\u043F\u0438\u0442\u044C \u0442\u0440\u0438\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " \u043D\u043E\u0432\u044B\u0439 \u0432 \u0423\u043A\u0440\u0430\u0438\u043D\u0435 \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0439. \u0421\u0440\u0430\u0432\u043D\u0438\u0442\u044C \u0446\u0435\u043D\u044B \u0432 \u043C\u043E\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u0438 \u043E\u0442 \u0447\u0430\u0441\u0442\u043D\u044B\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u043E\u0432",
      description_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u0442\u0440\u0438\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " \u043D\u043E\u0432\u0438\u0439 \u0432 \u0423\u043A\u0440\u0430\u0457\u043D\u0456 \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u044C. \u041F\u043E\u0440\u0456\u0432\u043D\u044F\u0442\u0438 \u0446\u0456\u043D\u0438 \u0432 \u043C\u043E\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u0456 \u0432\u0456\u0434 \u043F\u0440\u0438\u0432\u0430\u0442\u043D\u0438\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u0456\u0432"
    };
  },
  makeCityIsnew: function makeCityIsnew(data, p) {
    return {
      title: "\u041A\u0443\u043F\u0438\u0442\u044C \u0442\u0440\u0438\u0446\u0438\u043A\u043B " + data.make + " \u043D\u043E\u0432\u044B\u0439 " + p.inCity + " - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      title_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u0442\u0440\u0438\u0446\u0438\u043A\u043B " + data.make + " \u043D\u043E\u0432\u0438\u0439 " + p.inCity + " - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      description: "\u041A\u0443\u043F\u0438\u0442\u044C \u0442\u0440\u0438\u0446\u0438\u043A\u043B " + data.make + " \u043D\u043E\u0432\u044B\u0439 " + p.inCity + " \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0439. \u0421\u0440\u0430\u0432\u043D\u0438\u0442\u044C \u0446\u0435\u043D\u044B \u0432 \u043C\u043E\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u0438 \u043E\u0442 \u0447\u0430\u0441\u0442\u043D\u044B\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u043E\u0432",
      description_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u0442\u0440\u0438\u0446\u0438\u043A\u043B " + data.make + " \u043D\u043E\u0432\u0438\u0439 " + p.inCity + " \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u044C. \u041F\u043E\u0440\u0456\u0432\u043D\u044F\u0442\u0438 \u0446\u0456\u043D\u0438 \u0432 \u043C\u043E\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u0456 \u0432\u0456\u0434 \u043F\u0440\u0438\u0432\u0430\u0442\u043D\u0438\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u0456\u0432"
    };
  },
  makeModelBody: function makeModelBody(data, p) {
    return {
      header: "\u041A\u0443\u043F\u0438\u0442\u044C " + p.t(data.body).toLowerCase() + " \u0442\u0440\u0438\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " \u0431\u0443",
      header_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 " + p.t(data.body).toLowerCase() + " \u0442\u0440\u0438\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " \u0431\u0443"
    };
  },
  makeModelYear: function makeModelYear(data, p) {
    return {
      header: "\u041A\u0443\u043F\u0438\u0442\u044C \u0442\u0440\u0438\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " " + data.year + " \u0433\u043E\u0434\u0430 \u0431\u0443",
      header_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u0442\u0440\u0438\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " " + data.year + " \u0440\u043E\u043A\u0443 \u0431\u0443"
    };
  },
  isnewMakeBody: function isnewMakeBody(data, p) {
    return {
      header: "\u041A\u0443\u043F\u0438\u0442\u044C \u043D\u043E\u0432\u044B\u0439 " + p.t(data.body).toLowerCase() + " \u0442\u0440\u0438\u0446\u0438\u043A\u043B " + data.make,
      header_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043D\u043E\u0432\u0438\u0439 " + p.t(data.body).toLowerCase() + " \u0442\u0440\u0438\u0446\u0438\u043A\u043B " + data.make
    };
  },
  makeCityBody: function makeCityBody(data, p) {
    return {
      header: p.buy + " " + p.t(data.body).toLowerCase() + " \u0442\u0440\u0438\u0446\u0438\u043A\u043B " + data.make + " \u0431\u0443 " + p.inCity
    };
  },
  isnewBodyCity: function isnewBodyCity(data, p) {
    return {
      header: "\u041A\u0443\u043F\u0438\u0442\u044C \u043D\u043E\u0432\u044B\u0439 " + p.t(data.body).toLowerCase() + " \u0442\u0440\u0438\u0446\u0438\u043A\u043B " + p.inCity,
      header_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043D\u043E\u0432\u0438\u0439 " + p.t(data.body).toLowerCase() + " \u0442\u0440\u0438\u0446\u0438\u043A\u043B " + p.inCity
    };
  },

  isnewMakeModelYear: function isnewMakeModelYear(data, p) {
    return {
      header: "\u041A\u0443\u043F\u0438\u0442\u044C \u043D\u043E\u0432\u044B\u0439 \u0442\u0440\u0438\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " " + data.year + " \u0433\u043E\u0434\u0430",
      header_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043D\u043E\u0432\u0438\u0439 \u0442\u0440\u0438\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " " + data.year + " \u0440\u043E\u043A\u0443",

      title: "\u041A\u0443\u043F\u0438\u0442\u044C \u0442\u0440\u0438\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " " + data.year + " \u043D\u043E\u0432\u044B\u0439 \u0432 \u0423\u043A\u0440\u0430\u0438\u043D\u0435 - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      title_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u0442\u0440\u0438\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " " + data.year + " \u043D\u043E\u0432\u0438\u0439 \u0432 \u0423\u043A\u0440\u0430\u0457\u043D\u0456 - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      description: "\u041A\u0443\u043F\u0438\u0442\u044C \u0442\u0440\u0438\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " " + data.year + " \u043D\u043E\u0432\u044B\u0439 \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0439. \u0421\u0440\u0430\u0432\u043D\u0438\u0442\u044C \u0446\u0435\u043D\u044B \u0432 \u043C\u043E\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u0438 \u043E\u0442 \u0447\u0430\u0441\u0442\u043D\u044B\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u043E\u0432",
      description_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u0442\u0440\u0438\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " " + data.year + " \u043D\u043E\u0432\u0438\u0439 \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u044C. \u041F\u043E\u0440\u0456\u0432\u043D\u044F\u0442\u0438 \u0446\u0456\u043D\u0438 \u0432 \u043C\u043E\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u0456 \u0432\u0456\u0434 \u043F\u0440\u0438\u0432\u0430\u0442\u043D\u0438\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u0456\u0432"
    };
  },
  isnewMakeModelCity: function isnewMakeModelCity(data, p) {
    return {
      header: "\u041A\u0443\u043F\u0438\u0442\u044C \u043D\u043E\u0432\u044B\u0439 \u0442\u0440\u0438\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " " + p.inCity,
      header_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043D\u043E\u0432\u0438\u0439 \u0442\u0440\u0438\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " " + p.inCity,

      title: "\u041A\u0443\u043F\u0438\u0442\u044C \u0442\u0440\u0438\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " \u043D\u043E\u0432\u044B\u0439 " + p.inCity + " - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      title_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u0442\u0440\u0438\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " \u043D\u043E\u0432\u0438\u0439 " + p.inCity + " - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      description: "\u041A\u0443\u043F\u0438\u0442\u044C \u0442\u0440\u0438\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " \u043D\u043E\u0432\u044B\u0439 " + p.inCity + " \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0439. \u0421\u0440\u0430\u0432\u043D\u0438\u0442\u044C \u0446\u0435\u043D\u044B \u0432 \u043C\u043E\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u0438 \u043E\u0442 \u0447\u0430\u0441\u0442\u043D\u044B\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u043E\u0432",
      description_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u0442\u0440\u0438\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " \u043D\u043E\u0432\u0438\u0439 " + p.inCity + " \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u044C. \u041F\u043E\u0440\u0456\u0432\u043D\u044F\u0442\u0438 \u0446\u0456\u043D\u0438 \u0432 \u043C\u043E\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u0456 \u0432\u0456\u0434 \u043F\u0440\u0438\u0432\u0430\u0442\u043D\u0438\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u0456\u0432"
    };
  },
  isnewMakeModelBody: function isnewMakeModelBody(data, p) {
    return {
      header: "\u041A\u0443\u043F\u0438\u0442\u044C \u043D\u043E\u0432\u044B\u0439 " + p.t(data.body).toLowerCase() + " \u0442\u0440\u0438\u0446\u0438\u043A\u043B " + data.make + " " + data.model,
      header_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043D\u043E\u0432\u0438\u0439 " + p.t(data.body).toLowerCase() + " \u0442\u0440\u0438\u0446\u0438\u043A\u043B " + data.make + " " + data.model
    };
  },
  makeModelCityBody: function makeModelCityBody(data, p) {
    return {
      header: "\u041A\u0443\u043F\u0438\u0442\u044C " + p.t(data.body).toLowerCase() + " \u0442\u0440\u0438\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " \u0431\u0443 " + p.inCity,
      header_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 " + p.t(data.body).toLowerCase() + " \u0442\u0440\u0438\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " \u0431\u0443 " + p.inCity
    };
  },
  isnewMakeCityBody: function isnewMakeCityBody(data, p) {
    return {
      header: "\u041A\u0443\u043F\u0438\u0442\u044C \u043D\u043E\u0432\u044B\u0439 " + p.t(data.body).toLowerCase() + " \u0442\u0440\u0438\u0446\u0438\u043A\u043B " + data.make + " " + p.inCity,
      header_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043D\u043E\u0432\u0438\u0439 " + p.t(data.body).toLowerCase() + " \u0442\u0440\u0438\u0446\u0438\u043A\u043B " + data.make + " " + p.inCity
    };
  },

  isnewMakeModelCityBody: function isnewMakeModelCityBody(data, p) {
    return {
      header: "\u041A\u0443\u043F\u0438\u0442\u044C \u043D\u043E\u0432\u044B\u0439 " + p.t(data.body).toLowerCase() + " \u0442\u0440\u0438\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " " + p.inCity,
      header_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043D\u043E\u0432\u0438\u0439 " + p.t(data.body).toLowerCase() + " \u0442\u0440\u0438\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " " + p.inCity
    };
  }
};

/* harmony default export */ var tritsikl_templates_defaultExport = (tritsikl_templates_avtoPathesHead);
// CONCATENATED MODULE: ./src/shared/helpers/seoTextFinder/seoTemplates/search/tritsikl/index.js


var TRITSIKL = {
    city: tritsikl_templates_defaultExport.city,
    make: tritsikl_templates_defaultExport.make,
    body: tritsikl_templates_defaultExport.body,

    city_make: tritsikl_templates_defaultExport.makeCity,
    make_model: tritsikl_templates_defaultExport.makeModel,
    city_isnew: tritsikl_templates_defaultExport.cityIsnew,
    isnew_make: tritsikl_templates_defaultExport.makeIsnew,
    body_make: tritsikl_templates_defaultExport.makeBody,
    body_isnew: tritsikl_templates_defaultExport.bodyIsnew,
    body_city: tritsikl_templates_defaultExport.bodyCity,

    city_make_model: tritsikl_templates_defaultExport.makeModelCity,
    isnew_make_model: tritsikl_templates_defaultExport.makeModelIsnew,
    city_isnew_make: tritsikl_templates_defaultExport.makeCityIsnew,
    body_make_model: tritsikl_templates_defaultExport.makeModelBody,
    make_model_year: tritsikl_templates_defaultExport.makeModelYear,
    body_isnew_make: tritsikl_templates_defaultExport.isnewMakeBody,
    body_city_make: tritsikl_templates_defaultExport.makeCityBody,
    body_city_isnew: tritsikl_templates_defaultExport.isnewBodyCity,

    isnew_make_model_year: tritsikl_templates_defaultExport.isnewMakeModelYear,
    city_isnew_make_model: tritsikl_templates_defaultExport.isnewMakeModelCity,
    body_isnew_make_model: tritsikl_templates_defaultExport.isnewMakeModelBody,
    body_city_make_model: tritsikl_templates_defaultExport.makeModelCityBody,
    body_city_isnew_make: tritsikl_templates_defaultExport.isnewMakeCityBody,

    body_city_isnew_make_model: tritsikl_templates_defaultExport.isnewMakeModelCityBody
};
// CONCATENATED MODULE: ./src/shared/helpers/seoTextFinder/seoTemplates/avtosalony/avto/templates.js
var avto_templates_avtoPathesHead = {
  city: function city(data, p) {
    return {
      title: "\u0410\u0432\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u044B " + p.t(data.city) + ". \u0412\u0441\u0435 \u0430\u0432\u0442\u043E\u0434\u0438\u043B\u0435\u0440\u044B, \u0446\u0435\u043D\u044B, \u0430\u043A\u0446\u0438\u0438 \u043D\u0430 \u0430\u0432\u0442\u043E \u0438\u0437 \u0441\u0430\u043B\u043E\u043D\u0430 - \u0410\u0432\u0442\u043E\u0411\u0430\u0437\u0430\u0440",
      description: "\u0410\u0432\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u044B " + p.t(data.city) + ". \u041B\u0443\u0447\u0448\u0438\u0435 \u043F\u0440\u0435\u0434\u043B\u043E\u0436\u0435\u043D\u0438\u044F \u043E\u0442 \u0430\u0432\u0442\u043E\u0434\u0438\u043B\u0435\u0440\u043E\u0432, \u0441\u043A\u0438\u0434\u043A\u0438 \u043D\u0430 \u043D\u043E\u0432\u044B\u0435 \u0430\u0432\u0442\u043E\u043C\u043E\u0431\u0438\u043B\u0438. \u0417\u0430\u043F\u0438\u0448\u0438\u0442\u0435\u0441\u044C \u043D\u0430 \u0442\u0435\u0441\u0442-\u0434\u0440\u0430\u0439\u0432 \u2705 \u0430\u0434\u0440\u0435\u0441\u0430 \u0438 \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u044B \u0430\u0432\u0442\u043E\u0446\u0435\u043D\u0442\u0440\u0430 \u260E\uFE0F \u043D\u0430 \u0441\u0430\u0439\u0442\u0435 \u0410\u0432\u0442\u043E\u0411\u0430\u0437\u0430\u0440",
      header: "\u0410\u0432\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u044B " + p.t(data.city),
      title_uk: "\u0410\u0432\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0438 " + p.t(data.city) + ". \u0423\u0441\u0456 \u0430\u0432\u0442\u043E\u0434\u0438\u043B\u0435\u0440\u0438, \u0446\u0456\u043D\u0438, \u0430\u043A\u0446\u0456\u0457 \u043D\u0430 \u0430\u0432\u0442\u043E \u0437 \u0441\u0430\u043B\u043E\u043D\u0443 - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      description_uk: "\u0410\u0432\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0438 " + p.t(data.city) + ". \u041A\u0440\u0430\u0449\u0456 \u043F\u0440\u043E\u043F\u043E\u0437\u0438\u0446\u0456\u0457 \u0432\u0456\u0434 \u0430\u0432\u0442\u043E\u0434\u0438\u043B\u0435\u0440\u0456\u0432, \u0437\u043D\u0438\u0436\u043A\u0438 \u043D\u0430 \u043D\u043E\u0432\u0456 \u0430\u0432\u0442\u043E\u043C\u043E\u0431\u0456\u043B\u0456. \u0417\u0430\u043F\u0438\u0448\u0456\u0442\u044C\u0441\u044F \u043D\u0430 \u0442\u0435\u0441\u0442-\u0434\u0440\u0430\u0439\u0432 \u2705 \u0430\u0434\u0440\u0435\u0441\u0438 \u0456 \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u0438 \u0430\u0432\u0442\u043E\u0446\u0435\u043D\u0442\u0440\u0443 \u260E\uFE0F \u043D\u0430 \u0441\u0430\u0439\u0442\u0456 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      header_uk: "\u0410\u0432\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0438 " + p.t(data.city)
    };
  },
  cityMake: function cityMake(data, p) {
    return {
      title: "\u0410\u0432\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u044B " + data.make + " " + p.inCity + ". \u0426\u0435\u043D\u044B, \u0430\u043A\u0446\u0438\u0438 \u043D\u0430 \u0430\u0432\u0442\u043E \u0438\u0437 \u0441\u0430\u043B\u043E\u043D\u0430 - \u0410\u0432\u0442\u043E\u0411\u0430\u0437\u0430\u0440",
      description: "\u0410\u0432\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u044B " + data.make + " " + p.inCity + ". \u041B\u0443\u0447\u0448\u0438\u0435 \u043F\u0440\u0435\u0434\u043B\u043E\u0436\u0435\u043D\u0438\u044F \u043E\u0442 \u0430\u0432\u0442\u043E\u0434\u0438\u043B\u0435\u0440\u043E\u0432 " + data.make + " \u043D\u0430 \u043D\u043E\u0432\u044B\u0435 \u0430\u0432\u0442\u043E\u043C\u043E\u0431\u0438\u043B\u0438. \u0417\u0430\u043F\u0438\u0448\u0438\u0442\u0435\u0441\u044C \u043D\u0430 \u0442\u0435\u0441\u0442-\u0434\u0440\u0430\u0439\u0432 \u2705 \u0430\u0434\u0440\u0435\u0441\u0430 \u0438 \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u044B \u0430\u0432\u0442\u043E\u0446\u0435\u043D\u0442\u0440\u043E\u0432 \u260E\uFE0F \u043D\u0430 \u0441\u0430\u0439\u0442\u0435 \u0410\u0432\u0442\u043E\u0411\u0430\u0437\u0430\u0440",
      header: "\u0410\u0432\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u044B " + data.make + " " + p.inCity,
      title_uk: "\u0410\u0432\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0438 " + data.make + " " + p.inCity + ". \u0426\u0456\u043D\u0438, \u0430\u043A\u0446\u0456\u0457 \u043D\u0430 \u0430\u0432\u0442\u043E \u0437 \u0441\u0430\u043B\u043E\u043D\u0443 - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      description_uk: "\u0410\u0432\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0438 " + data.make + " " + p.inCity + ". \u041A\u0440\u0430\u0449\u0456 \u043F\u0440\u043E\u043F\u043E\u0437\u0438\u0446\u0456\u0457 \u0432\u0456\u0434 \u0430\u0432\u0442\u043E\u0434\u0438\u043B\u0435\u0440\u0456\u0432 " + data.make + " \u043D\u0430 \u043D\u043E\u0432\u0456 \u0430\u0432\u0442\u043E\u043C\u043E\u0431\u0456\u043B\u0456. \u0417\u0430\u043F\u0438\u0448\u0456\u0442\u044C\u0441\u044F \u043D\u0430 \u0442\u0435\u0441\u0442-\u0434\u0440\u0430\u0439\u0432 \u2705 \u0430\u0434\u0440\u0435\u0441\u0438 \u0456 \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u0438 \u0430\u0432\u0442\u043E\u0446\u0435\u043D\u0442\u0440\u0456\u0432 \u260E\uFE0F \u043D\u0430 \u0441\u0430\u0439\u0442\u0456 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      header_uk: "\u0410\u0432\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0438 " + data.make + " " + p.inCity
    };
  }
};

/* harmony default export */ var avto_templates_defaultExport = (avto_templates_avtoPathesHead);
// CONCATENATED MODULE: ./src/shared/helpers/seoTextFinder/seoTemplates/avtosalony/avto/index.js


var avto_AVTO = {
  city: avto_templates_defaultExport.city,
  city_make: avto_templates_defaultExport.cityMake
};
// CONCATENATED MODULE: ./src/shared/helpers/seoTextFinder/seoTemplates/avtosalony/gruzovye/templates.js
var gruzovye_templates_avtoPathesHead = {
  city: function city(data, p) {
    return {
      title: "\u0410\u0432\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u044B \u0433\u0440\u0443\u0437\u043E\u0432\u044B\u0445 \u0430\u0432\u0442\u043E\u043C\u043E\u0431\u0438\u043B\u0435\u0439 " + p.t(data.city) + ". \u0412\u0441\u0435 \u0430\u0432\u0442\u043E\u0434\u0438\u043B\u0435\u0440\u044B \u043F\u043E \u043F\u0440\u043E\u0434\u0430\u0436\u0435 \u0433\u0440\u0443\u0437\u043E\u0432\u0438\u043A\u043E\u0432 - \u0410\u0432\u0442\u043E\u0411\u0430\u0437\u0430\u0440",
      description: "\u0410\u0432\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u044B \u0433\u0440\u0443\u0437\u043E\u0432\u0438\u043A\u043E\u0432 " + p.t(data.city) + ". \u041B\u0443\u0447\u0448\u0438\u0435 \u043F\u0440\u0435\u0434\u043B\u043E\u0436\u0435\u043D\u0438\u044F \u043D\u0430 \u0433\u0440\u0443\u0437\u043E\u0432\u044B\u0435 \u0430\u0432\u0442\u043E\u043C\u043E\u0431\u0438\u043B\u0438 \u043E\u0442 \u0430\u0432\u0442\u043E\u0434\u0438\u043B\u0435\u0440\u043E\u0432. \u0417\u0430\u043F\u0438\u0448\u0438\u0442\u0435\u0441\u044C \u043D\u0430 \u0442\u0435\u0441\u0442-\u0434\u0440\u0430\u0439\u0432 \u0433\u0440\u0443\u0437\u043E\u0432\u0438\u043A\u0430 \u2705 \u0430\u0434\u0440\u0435\u0441\u0430 \u0438 \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u044B \u0430\u0432\u0442\u043E\u0446\u0435\u043D\u0442\u0440\u043E\u0432 \u260E\uFE0F \u043D\u0430 \u0441\u0430\u0439\u0442\u0435 \u0410\u0432\u0442\u043E\u0411\u0430\u0437\u0430\u0440",
      header: "\u0410\u0432\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u044B \u0433\u0440\u0443\u0437\u043E\u0432\u044B\u0445 \u0430\u0432\u0442\u043E\u043C\u043E\u0431\u0438\u043B\u0435\u0439 " + p.t(data.city),
      title_uk: "\u0410\u0432\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0438 \u0432\u0430\u043D\u0442\u0430\u0436\u043D\u0438\u0445 \u0430\u0432\u0442\u043E\u043C\u043E\u0431\u0456\u043B\u0456\u0432 " + p.t(data.city) + ". \u0423\u0441\u0456 \u0430\u0432\u0442\u043E\u0434\u0438\u043B\u0435\u0440\u0438 \u0437 \u043F\u0440\u043E\u0434\u0430\u0436\u0443 \u0432\u0430\u043D\u0442\u0430\u0436\u0456\u0432\u043E\u043A - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      description_uk: "\u0410\u0432\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0438 \u0432\u0430\u043D\u0442\u0430\u0436\u0456\u0432\u043E\u043A " + p.t(data.city) + ". \u041A\u0440\u0430\u0449\u0456 \u043F\u0440\u043E\u043F\u043E\u0437\u0438\u0446\u0456\u0457 \u043D\u0430 \u0432\u0430\u043D\u0442\u0430\u0436\u043D\u0456 \u0430\u0432\u0442\u043E\u043C\u043E\u0431\u0456\u043B\u0456 \u0432\u0456\u0434 \u0430\u0432\u0442\u043E\u0434\u0438\u043B\u0435\u0440\u0456\u0432. \u0417\u0430\u043F\u0438\u0448\u0456\u0442\u044C\u0441\u044F \u043D\u0430 \u0442\u0435\u0441\u0442-\u0434\u0440\u0430\u0439\u0432 \u0432\u0430\u043D\u0442\u0430\u0436\u0456\u0432\u043A\u0438 \u2705 \u0430\u0434\u0440\u0435\u0441\u0430 \u0456 \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u0438 \u0430\u0432\u0442\u043E\u0446\u0435\u043D\u0442\u0440\u0456\u0432 \u260E\uFE0F \u043D\u0430 \u0441\u0430\u0439\u0442\u0456 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      header_uk: "\u0410\u0432\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0438 \u0432\u0430\u043D\u0442\u0430\u0436\u043D\u0438\u0445 \u0430\u0432\u0442\u043E\u043C\u043E\u0431\u0456\u043B\u0456\u0432 " + p.t(data.city)
    };
  }
};

/* harmony default export */ var gruzovye_templates_defaultExport = (gruzovye_templates_avtoPathesHead);
// CONCATENATED MODULE: ./src/shared/helpers/seoTextFinder/seoTemplates/avtosalony/gruzovye/index.js


var GRUZOVYE = {
  city: gruzovye_templates_defaultExport.city
};
// CONCATENATED MODULE: ./src/shared/helpers/seoTextFinder/seoTemplates/avtosalony/avtobus/templates.js
var avtobus_templates_avtoPathesHead = {
  city: function city(data, p) {
    return {
      title: "\u0410\u0432\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u044B \u0430\u0432\u0442\u043E\u0431\u0443\u0441\u043E\u0432 " + p.t(data.city) + ". \u0412\u0441\u0435 \u0430\u0432\u0442\u043E\u0434\u0438\u043B\u0435\u0440\u044B \u043F\u043E \u043F\u0440\u043E\u0434\u0430\u0436\u0435 \u0431\u0443\u0441\u043E\u0432 - \u0410\u0432\u0442\u043E\u0411\u0430\u0437\u0430\u0440",
      description: "\u0414\u0438\u043B\u0435\u0440\u044B \u0430\u0432\u0442\u043E\u0431\u0443\u0441\u043E\u0432 " + p.t(data.city) + ". \u041B\u0443\u0447\u0448\u0438\u0435 \u043F\u0440\u0435\u0434\u043B\u043E\u0436\u0435\u043D\u0438\u044F \u043E\u0442 \u0430\u0432\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u043E\u0432. \u0411\u0443\u0441 \u0441 \u0433\u0430\u0440\u0430\u043D\u0442\u0438\u0435\u0439. \u0417\u0430\u043F\u0438\u0448\u0438\u0442\u0435\u0441\u044C \u043D\u0430 \u0442\u0435\u0441\u0442-\u0434\u0440\u0430\u0439\u0432 \u0431\u0443\u0441\u0430 \u2705 \u0430\u0434\u0440\u0435\u0441\u0430 \u0438 \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u044B \u0430\u0432\u0442\u043E\u0446\u0435\u043D\u0442\u0440\u043E\u0432 \u260E\uFE0F \u043D\u0430 \u0441\u0430\u0439\u0442\u0435 \u0410\u0432\u0442\u043E\u0411\u0430\u0437\u0430\u0440",
      header: "\u0410\u0432\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u044B \u0430\u0432\u0442\u043E\u0431\u0443\u0441\u043E\u0432 " + p.t(data.city),
      title_uk: "\u0410\u0432\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0438 \u0430\u0432\u0442\u043E\u0431\u0443\u0441\u0456\u0432 " + p.t(data.city) + ". \u0423\u0441\u0456 \u0430\u0432\u0442\u043E\u0434\u0438\u043B\u0435\u0440\u0438 \u0437 \u043F\u0440\u043E\u0434\u0430\u0436\u0443 \u0431\u0443\u0441\u0456\u0432 - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      description_uk: "\u0414\u0438\u043B\u0435\u0440\u0438 \u0430\u0432\u0442\u043E\u0431\u0443\u0441\u0456\u0432 " + p.t(data.city) + ". \u041A\u0440\u0430\u0449\u0456 \u043F\u0440\u043E\u043F\u043E\u0437\u0438\u0446\u0456\u0457 \u0432\u0456\u0434 \u0430\u0432\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0456\u0432. \u0411\u0443\u0441 \u0437 \u0433\u0430\u0440\u0430\u043D\u0442\u0456\u0454\u044E. \u0417\u0430\u043F\u0438\u0448\u0456\u0442\u044C\u0441\u044F \u043D\u0430 \u0442\u0435\u0441\u0442-\u0434\u0440\u0430\u0439\u0432 \u0431\u0443\u0441\u0430 \u2705 \u0430\u0434\u0440\u0435\u0441\u0438 \u0456 \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u0438 \u0430\u0432\u0442\u043E\u0446\u0435\u043D\u0442\u0440\u0456\u0432 \u260E\uFE0F \u043D\u0430 \u0441\u0430\u0439\u0442\u0456 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      header_uk: "\u0410\u0432\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0438 \u0430\u0432\u0442\u043E\u0431\u0443\u0441\u0456\u0432 " + p.t(data.city)
    };
  }
};

/* harmony default export */ var avtobus_templates_defaultExport = (avtobus_templates_avtoPathesHead);
// CONCATENATED MODULE: ./src/shared/helpers/seoTextFinder/seoTemplates/avtosalony/avtobus/index.js


var AVTOBUS = {
  city: avtobus_templates_defaultExport.city
};
// CONCATENATED MODULE: ./src/shared/helpers/seoTextFinder/seoTemplates/avtosalony/vodnyi-transport/templates.js
var vodnyi_transport_templates_avtoPathesHead = {
  city: function city(data, p) {
    return {
      title: "\u0414\u0438\u043B\u0435\u0440\u044B \u0432\u043E\u0434\u043D\u043E\u0433\u043E \u0442\u0440\u0430\u043D\u0441\u043F\u043E\u0440\u0442\u0430 " + p.inCity + ". \u041A\u0430\u0442\u0430\u043B\u043E\u0433 \u043A\u043E\u043C\u043F\u0430\u043D\u0438\u0439 - \u0410\u0432\u0442\u043E\u0411\u0430\u0437\u0430\u0440",
      description: "\u0414\u0438\u043B\u0435\u0440\u044B \u0432\u043E\u0434\u043D\u043E\u0433\u043E \u0442\u0440\u0430\u043D\u0441\u043F\u043E\u0440\u0442\u0430 " + p.inCity + ". \u041B\u0443\u0447\u0448\u0438\u0435 \u043F\u0440\u0435\u0434\u043B\u043E\u0436\u0435\u043D\u0438\u044F \u043E\u0442 \u043F\u0440\u043E\u0432\u0435\u0440\u0435\u043D\u043D\u044B\u0445 \u0441\u0430\u043B\u043E\u043D\u043E\u0432 \u2705 \u0430\u0434\u0440\u0435\u0441\u0430 \u0438 \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u044B \u043A\u043E\u043C\u043F\u0430\u043D\u0438\u0439 \u260E\uFE0F \u043D\u0430 \u0441\u0430\u0439\u0442\u0435 \u0410\u0432\u0442\u043E\u0411\u0430\u0437\u0430\u0440",
      header: "\u0414\u0438\u043B\u0435\u0440\u044B \u0432\u043E\u0434\u043D\u043E\u0433\u043E \u0442\u0440\u0430\u043D\u0441\u043F\u043E\u0440\u0442\u0430 " + p.inCity,
      title_uk: "\u0414\u0438\u043B\u0435\u0440\u0438 \u0432\u043E\u0434\u043D\u043E\u0433\u043E \u0442\u0440\u0430\u043D\u0441\u043F\u043E\u0440\u0442\u0443 " + p.inCity + ". \u041A\u0430\u0442\u0430\u043B\u043E\u0433 \u043A\u043E\u043C\u043F\u0430\u043D\u0456\u0439 - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      description_uk: "\u0414\u0438\u043B\u0435\u0440\u0438 \u0432\u043E\u0434\u043D\u043E\u0433\u043E \u0442\u0440\u0430\u043D\u0441\u043F\u043E\u0440\u0442\u0443 " + p.inCity + ". \u041A\u0440\u0430\u0449\u0456 \u043F\u0440\u043E\u043F\u043E\u0437\u0438\u0446\u0456\u0457 \u0432\u0456\u0434 \u043F\u0435\u0440\u0435\u0432\u0456\u0440\u0435\u043D\u0438\u0445 \u0441\u0430\u043B\u043E\u043D\u0456\u0432 \u2705 \u0430\u0434\u0440\u0435\u0441\u0438 \u0456 \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u0438 \u043A\u043E\u043C\u043F\u0430\u043D\u0456\u0439 \u260E\uFE0F \u043D\u0430 \u0441\u0430\u0439\u0442\u0456 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      header_uk: "\u0414\u0438\u043B\u0435\u0440\u0438 \u0432\u043E\u0434\u043D\u043E\u0433\u043E \u0442\u0440\u0430\u043D\u0441\u043F\u043E\u0440\u0442\u0443 " + p.inCity
    };
  },
  cityMake: function cityMake(data, p) {
    return {
      title: "\u0414\u0438\u043B\u0435\u0440\u044B \u0432\u043E\u0434\u043D\u043E\u0433\u043E \u0442\u0440\u0430\u043D\u0441\u043F\u043E\u0440\u0442\u0430 " + data.make + " " + p.inCity + ". \u041A\u0430\u0442\u0430\u043B\u043E\u0433 \u043A\u043E\u043C\u043F\u0430\u043D\u0438\u0439 - \u0410\u0432\u0442\u043E\u0411\u0430\u0437\u0430\u0440",
      description: "\u0414\u0438\u043B\u0435\u0440\u044B \u0432\u043E\u0434\u043D\u043E\u0433\u043E \u0442\u0440\u0430\u043D\u0441\u043F\u043E\u0440\u0442\u0430 " + data.make + " " + p.inCity + ". \u041B\u0443\u0447\u0448\u0438\u0435 \u043F\u0440\u0435\u0434\u043B\u043E\u0436\u0435\u043D\u0438\u044F \u043D\u0430 \u0432\u043E\u0434\u043D\u044B\u0439 \u0442\u0440\u0430\u043D\u0441\u043F\u043E\u0440\u0442 " + data.make + " \u2705 \u0430\u0434\u0440\u0435\u0441\u0430 \u0438 \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u044B \u043A\u043E\u043C\u043F\u0430\u043D\u0438\u0439 \u260E\uFE0F \u043D\u0430 \u0441\u0430\u0439\u0442\u0435 \u0410\u0432\u0442\u043E\u0411\u0430\u0437\u0430\u0440",
      header: "\u0414\u0438\u043B\u0435\u0440\u044B \u0432\u043E\u0434\u043D\u043E\u0433\u043E \u0442\u0440\u0430\u043D\u0441\u043F\u043E\u0440\u0442\u0430 " + data.make + " " + p.inCity,
      title_uk: "\u0414\u0438\u043B\u0435\u0440\u0438 \u0432\u043E\u0434\u043D\u043E\u0433\u043E \u0442\u0440\u0430\u043D\u0441\u043F\u043E\u0440\u0442\u0443 " + data.make + " " + p.inCity + ". \u041A\u0430\u0442\u0430\u043B\u043E\u0433 \u043A\u043E\u043C\u043F\u0430\u043D\u0456\u0439 - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      description_uk: "\u0414\u0438\u043B\u0435\u0440\u0438 \u0432\u043E\u0434\u043D\u043E\u0433\u043E \u0442\u0440\u0430\u043D\u0441\u043F\u043E\u0440\u0442\u0443 " + data.make + " " + p.inCity + ". \u041A\u0440\u0430\u0449\u0456 \u043F\u0440\u043E\u043F\u043E\u0437\u0438\u0446\u0456\u0457 \u043D\u0430 \u0432\u043E\u0434\u043D\u0438\u0439 \u0442\u0440\u0430\u043D\u0441\u043F\u043E\u0440\u0442 " + data.make + " \u2705 \u0430\u0434\u0440\u0435\u0441\u0438 \u0456 \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u0438 \u043A\u043E\u043C\u043F\u0430\u043D\u0456\u0439 \u260E\uFE0F \u043D\u0430 \u0441\u0430\u0439\u0442\u0456 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      header_uk: "\u0414\u0438\u043B\u0435\u0440\u0438 \u0432\u043E\u0434\u043D\u043E\u0433\u043E \u0442\u0440\u0430\u043D\u0441\u043F\u043E\u0440\u0442\u0443 " + data.make + " " + p.inCity
    };
  }
};

/* harmony default export */ var vodnyi_transport_templates_defaultExport = (vodnyi_transport_templates_avtoPathesHead);
// CONCATENATED MODULE: ./src/shared/helpers/seoTextFinder/seoTemplates/avtosalony/vodnyi-transport/index.js


var VODNYI_TRANSPORT = {
  city: vodnyi_transport_templates_defaultExport.city,
  city_make: vodnyi_transport_templates_defaultExport.cityMake
};
// CONCATENATED MODULE: ./src/shared/helpers/seoTextFinder/seoTemplates/avtosalony/mototsikl/templates.js
var mototsikl_templates_avtoPathesHead = {
  city: function city(data, p) {
    return {
      title: "\u041C\u043E\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u044B " + p.t(data.city) + ". \u041C\u0430\u0433\u0430\u0437\u0438\u043D\u044B \u043F\u043E \u043F\u0440\u043E\u0434\u0430\u0436\u0435 \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B\u043E\u0432, \u0441\u043A\u0443\u0442\u0435\u0440\u043E\u0432, \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B\u043E\u0432 - \u0410\u0432\u0442\u043E\u0411\u0430\u0437\u0430\u0440",
      description: "\u041C\u043E\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u044B " + p.t(data.city) + ". \u041B\u0443\u0447\u0448\u0438\u0435 \u0446\u0435\u043D\u044B \u043D\u0430 \u043C\u043E\u0442\u043E\u0442\u0435\u0445\u043D\u0438\u043A\u0443 \u0441 \u0433\u0430\u0440\u0430\u043D\u0442\u0438\u0435\u0439 \u043E\u0442 \u0441\u0430\u043B\u043E\u043D\u0430 \u2705 \u0430\u0434\u0440\u0435\u0441\u0430 \u0438 \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u044B \u043C\u043E\u0442\u043E \u043C\u0430\u0433\u0430\u0437\u0438\u043D\u043E\u0432 \u260E\uFE0F \u043D\u0430 \u0441\u0430\u0439\u0442\u0435 \u0410\u0432\u0442\u043E\u0411\u0430\u0437\u0430\u0440",
      header: "\u041C\u043E\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u044B " + p.t(data.city),
      title_uk: "\u041C\u043E\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0438 " + p.t(data.city) + ". \u041C\u0430\u0433\u0430\u0437\u0438\u043D\u0438 \u0437 \u043F\u0440\u043E\u0434\u0430\u0436\u0443 \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B\u0456\u0432, \u0441\u043A\u0443\u0442\u0435\u0440\u0456\u0432, \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B\u0456\u0432 - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      description_uk: "\u041C\u043E\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0438 " + p.t(data.city) + ". \u041A\u0440\u0430\u0449\u0456 \u0446\u0456\u043D\u0438 \u043D\u0430 \u043C\u043E\u0442\u043E\u0442\u0435\u0445\u043D\u0456\u043A\u0443 \u0437 \u0433\u0430\u0440\u0430\u043D\u0442\u0456\u0454\u044E \u0432\u0456\u0434 \u0441\u0430\u043B\u043E\u043D\u0443 \u2705 \u0430\u0434\u0440\u0435\u0441\u0438 \u0456 \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u0438 \u043C\u043E\u0442\u043E \u043C\u0430\u0433\u0430\u0437\u0438\u043D\u0456\u0432 \u260E\uFE0F \u043D\u0430 \u0441\u0430\u0439\u0442\u0456 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      header_uk: "\u041C\u043E\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0438 " + p.t(data.city)
    };
  }
};

/* harmony default export */ var avtosalony_mototsikl_templates_defaultExport = (mototsikl_templates_avtoPathesHead);
// CONCATENATED MODULE: ./src/shared/helpers/seoTextFinder/seoTemplates/avtosalony/mototsikl/index.js


var mototsikl_MOTOTSIKL = {
  city: avtosalony_mototsikl_templates_defaultExport.city
};
// CONCATENATED MODULE: ./src/shared/helpers/seoTextFinder/seoTemplates/avtosalony/pritsepy/templates.js
var pritsepy_templates_avtoPathesHead = {
  city: function city(data, p) {
    return {
      title: "\u041F\u0440\u043E\u0438\u0437\u0432\u043E\u0434\u0438\u0442\u0435\u043B\u0438 \u043F\u0440\u0438\u0446\u0435\u043F\u043E\u0432 " + p.t(data.city) + ". \u041B\u0443\u0447\u0448\u0438\u0435 \u0434\u0438\u043B\u0435\u0440\u044B \u043F\u0440\u0438\u0446\u0435\u043F\u043E\u0432 - \u0410\u0432\u0442\u043E\u0411\u0430\u0437\u0430\u0440",
      description: "\u041F\u0440\u043E\u0438\u0437\u0432\u043E\u0434\u0438\u0442\u0435\u043B\u0438 \u043F\u0440\u0438\u0446\u0435\u043F\u043E\u0432 " + p.t(data.city) + ". \u041B\u0443\u0447\u0448\u0438\u0435 \u0446\u0435\u043D\u044B \u043D\u0430 \u043F\u0440\u0438\u0446\u0435\u043F\u044B. \u0410\u043A\u0446\u0438\u0438 \u043A\u043E\u043C\u043F\u0430\u043D\u0438\u0439 \u2705 \u0430\u0434\u0440\u0435\u0441\u0430 \u0438 \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u044B \u0434\u0438\u043B\u0435\u0440\u043E\u0432 \u260E\uFE0F \u043D\u0430 \u0441\u0430\u0439\u0442\u0435 \u0410\u0432\u0442\u043E\u0411\u0430\u0437\u0430\u0440",
      header: "\u041F\u0440\u043E\u0438\u0437\u0432\u043E\u0434\u0438\u0442\u0435\u043B\u0438 \u043F\u0440\u0438\u0446\u0435\u043F\u043E\u0432 " + p.t(data.city),
      title_uk: "\u0412\u0438\u0440\u043E\u0431\u043D\u0438\u043A\u0438 \u043F\u0440\u0438\u0447\u0435\u043F\u0456\u0432 " + p.t(data.city) + ". \u041A\u0440\u0430\u0449\u0456 \u0434\u0438\u043B\u0435\u0440\u0438 \u043F\u0440\u0438\u0447\u0435\u043F\u0456\u0432 - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      description_uk: "\u0412\u0438\u0440\u043E\u0431\u043D\u0438\u043A\u0438 \u043F\u0440\u0438\u0447\u0435\u043F\u0456\u0432 " + p.t(data.city) + ". \u041A\u0440\u0430\u0449\u0456 \u0446\u0456\u043D\u0438 \u043D\u0430 \u043F\u0440\u0438\u0447\u0435\u043F\u0438. \u0410\u043A\u0446\u0456\u0457 \u043A\u043E\u043C\u043F\u0430\u043D\u0456\u0439 \u2705 \u0430\u0434\u0440\u0435\u0441\u0438 \u0456 \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u0438 \u0434\u0438\u043B\u0435\u0440\u0456\u0432 \u260E\uFE0F \u043D\u0430 \u0441\u0430\u0439\u0442\u0456 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      header_uk: "\u0412\u0438\u0440\u043E\u0431\u043D\u0438\u043A\u0438 \u043F\u0440\u0438\u0447\u0435\u043F\u0456\u0432 " + p.t(data.city)
    };
  },
  cityMake: function cityMake(data, p) {
    return {
      title: "\u041F\u0440\u043E\u0438\u0437\u0432\u043E\u0434\u0438\u0442\u0435\u043B\u0438 \u043F\u0440\u0438\u0446\u0435\u043F\u043E\u0432 " + data.make + " " + p.inCity + ". \u041B\u0443\u0447\u0448\u0438\u0435 \u043F\u0440\u0435\u0434\u043B\u043E\u0436\u0435\u043D\u0438\u044F \u043E\u0442 \u0434\u0438\u043B\u0435\u0440\u043E\u0432 - \u0410\u0432\u0442\u043E\u0411\u0430\u0437\u0430\u0440",
      description: "\u041F\u0440\u043E\u0438\u0437\u0432\u043E\u0434\u0438\u0442\u0435\u043B\u0438 \u043F\u0440\u0438\u0446\u0435\u043F\u043E\u0432 " + data.make + " " + p.inCity + ". \u041F\u0440\u043E\u0432\u0435\u0440\u0435\u043D\u043D\u044B\u0435 \u0434\u0438\u043B\u0435\u0440\u044B \u043F\u0440\u0438\u0446\u0435\u043F\u043E\u0432 \u2705 \u0430\u0434\u0440\u0435\u0441\u0430 \u0438 \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u044B \u043A\u043E\u043C\u043F\u0430\u043D\u0438\u0439 \u260E\uFE0F \u043D\u0430 \u0441\u0430\u0439\u0442\u0435 \u0410\u0432\u0442\u043E\u0411\u0430\u0437\u0430\u0440",
      header: "\u041F\u0440\u043E\u0438\u0437\u0432\u043E\u0434\u0438\u0442\u0435\u043B\u0438 \u043F\u0440\u0438\u0446\u0435\u043F\u043E\u0432 " + data.make + " " + p.inCity,
      title_uk: "\u0412\u0438\u0440\u043E\u0431\u043D\u0438\u043A\u0438 \u043F\u0440\u0438\u0447\u0435\u043F\u0456\u0432 " + data.make + " " + p.inCity + ". \u041A\u0440\u0430\u0449\u0456 \u043F\u0440\u043E\u043F\u043E\u0437\u0438\u0446\u0456\u0457 \u0432\u0456\u0434 \u0434\u0438\u043B\u0435\u0440\u0456\u0432 - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      description_uk: "\u0412\u0438\u0440\u043E\u0431\u043D\u0438\u043A\u0438 \u043F\u0440\u0438\u0447\u0435\u043F\u0456\u0432 " + data.make + " " + p.inCity + ". \u041F\u0435\u0440\u0435\u0432\u0456\u0440\u0435\u043D\u0456 \u0434\u0438\u043B\u0435\u0440\u0438 \u043F\u0440\u0438\u0447\u0435\u043F\u0456\u0432 \u2705 \u0430\u0434\u0440\u0435\u0441\u0438 \u0456 \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u0438 \u043A\u043E\u043C\u043F\u0430\u043D\u0456\u0439 \u260E\uFE0F \u043D\u0430 \u0441\u0430\u0439\u0442\u0456 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      header_uk: "\u0412\u0438\u0440\u043E\u0431\u043D\u0438\u043A\u0438 \u043F\u0440\u0438\u0447\u0435\u043F\u0456\u0432 " + data.make + " " + p.inCity
    };
  }
};

/* harmony default export */ var pritsepy_templates_defaultExport = (pritsepy_templates_avtoPathesHead);
// CONCATENATED MODULE: ./src/shared/helpers/seoTextFinder/seoTemplates/avtosalony/pritsepy/index.js

// body country city drive engine gearbox generation isNew location make makeTranslate model year

var PRITSEPY = {
  city: pritsepy_templates_defaultExport.city,
  city_make: pritsepy_templates_defaultExport.cityMake
};
// CONCATENATED MODULE: ./src/shared/helpers/seoTextFinder/seoTemplates/avtosalony/spetstehnika/templates.js
var spetstehnika_templates_avtoPathesHead = {
  city: function city(data, p) {
    return {
      title: "\u0414\u0438\u043B\u0435\u0440\u044B \u0441\u043F\u0435\u0446\u0442\u0435\u0445\u043D\u0438\u043A\u0438 \u0434\u043B\u044F \u0430\u0432\u0442\u043E " + p.inCity + ". \u041B\u0443\u0447\u0448\u0438\u0435 \u043F\u0440\u0435\u0434\u043B\u043E\u0436\u0435\u043D\u0438\u044F \u043E\u0442 \u0430\u0432\u0442\u043E\u0434\u0438\u043B\u0435\u0440\u043E\u0432 - \u0410\u0432\u0442\u043E\u0411\u0430\u0437\u0430\u0440",
      description: "\u0414\u0438\u043B\u0435\u0440\u044B \u0441\u043F\u0435\u0446\u0442\u0435\u0445\u043D\u0438\u043A\u0438 " + p.inCity + ". \u041B\u0443\u0447\u0448\u0438\u0435 \u043F\u0440\u0435\u0434\u043B\u043E\u0436\u0435\u043D\u0438\u044F \u043D\u0430 \u0441\u043F\u0435\u0446\u0442\u0435\u0445\u043D\u0438\u043A\u0443 \u043E\u0442 \u043F\u0440\u043E\u0432\u0435\u0440\u0435\u043D\u043D\u044B\u0445 \u0434\u0438\u043B\u0435\u0440\u043E\u0432 \u2705 \u0430\u0434\u0440\u0435\u0441\u0430 \u0438 \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u044B \u043A\u043E\u043C\u043F\u0430\u043D\u0438\u0439 \u260E\uFE0F \u043D\u0430 \u0441\u0430\u0439\u0442\u0435 \u0410\u0432\u0442\u043E\u0411\u0430\u0437\u0430\u0440",
      header: "\u0414\u0438\u043B\u0435\u0440\u044B \u0441\u043F\u0435\u0446\u0442\u0435\u0445\u043D\u0438\u043A\u0438 " + p.t(data.city),
      title_uk: "\u0414\u0438\u043B\u0435\u0440\u0438 \u0441\u043F\u0435\u0446\u0442\u0435\u0445\u043D\u0456\u043A\u0438 \u0434\u043B\u044F \u0430\u0432\u0442\u043E " + p.inCity + ". \u041A\u0440\u0430\u0449\u0456 \u043F\u0440\u043E\u043F\u043E\u0437\u0438\u0446\u0456\u0457 \u0432\u0456\u0434 \u0430\u0432\u0442\u043E\u0434\u0438\u043B\u0435\u0440\u0456\u0432 - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      description_uk: "\u0414\u0438\u043B\u0435\u0440\u0438 \u0441\u043F\u0435\u0446\u0442\u0435\u0445\u043D\u0456\u043A\u0438 " + p.inCity + ". \u041A\u0440\u0430\u0449\u0456 \u043F\u0440\u043E\u043F\u043E\u0437\u0438\u0446\u0456\u0457 \u043D\u0430 \u0441\u043F\u0435\u0446\u0442\u0435\u0445\u043D\u0456\u043A\u0443 \u0432\u0456\u0434 \u043F\u0435\u0440\u0435\u0432\u0456\u0440\u0435\u043D\u0438\u0445 \u0434\u0438\u043B\u0435\u0440\u0456\u0432 \u2705 \u0430\u0434\u0440\u0435\u0441\u0438 \u0456 \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u0438 \u043A\u043E\u043C\u043F\u0430\u043D\u0456\u0439 \u260E\uFE0F \u043D\u0430 \u0441\u0430\u0439\u0442\u0456 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      header_uk: "\u0414\u0438\u043B\u0435\u0440\u0438 \u0441\u043F\u0435\u0446\u0442\u0435\u0445\u043D\u0456\u043A\u0438 " + p.t(data.city)
    };
  },
  cityMake: function cityMake(data, p) {
    return {
      title: "\u0414\u0438\u043B\u0435\u0440\u044B \u0441\u043F\u0435\u0446\u0442\u0435\u0445\u043D\u0438\u043A\u0438 " + data.make + " " + p.inCity + ". \u041B\u0443\u0447\u0448\u0438\u0435 \u043F\u0440\u0435\u0434\u043B\u043E\u0436\u0435\u043D\u0438\u044F \u043E\u0442 \u0430\u0432\u0442\u043E\u0434\u0438\u043B\u0435\u0440\u043E\u0432 - \u0410\u0432\u0442\u043E\u0411\u0430\u0437\u0430\u0440",
      description: "\u0414\u0438\u043B\u0435\u0440\u044B \u0441\u043F\u0435\u0446\u0442\u0435\u0445\u043D\u0438\u043A\u0438 " + data.make + " " + p.inCity + ". \u041B\u0443\u0447\u0448\u0438\u0435 \u043F\u0440\u0435\u0434\u043B\u043E\u0436\u0435\u043D\u0438\u044F \u043D\u0430 \u0441\u043F\u0435\u0446\u0442\u0435\u0445\u043D\u0438\u043A\u0443 " + data.make + " \u043E\u0442 \u043F\u0440\u043E\u0432\u0435\u0440\u0435\u043D\u043D\u044B\u0445 \u0434\u0438\u043B\u0435\u0440\u043E\u0432 \u2705 \u0430\u0434\u0440\u0435\u0441\u0430 \u0438 \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u044B \u043A\u043E\u043C\u043F\u0430\u043D\u0438\u0439 \u260E\uFE0F \u043D\u0430 \u0441\u0430\u0439\u0442\u0435 \u0410\u0432\u0442\u043E\u0411\u0430\u0437\u0430\u0440",
      header: "\u0414\u0438\u043B\u0435\u0440\u044B \u0441\u043F\u0435\u0446\u0442\u0435\u0445\u043D\u0438\u043A\u0438 " + data.make + " " + p.inCity,
      title_uk: "\u0414\u0438\u043B\u0435\u0440\u0438 \u0441\u043F\u0435\u0446\u0442\u0435\u0445\u043D\u0456\u043A\u0438 " + data.make + " " + p.inCity + ". \u041A\u0440\u0430\u0449\u0456 \u043F\u0440\u043E\u043F\u043E\u0437\u0438\u0446\u0456\u0457 \u0432\u0456\u0434 \u0430\u0432\u0442\u043E\u0434\u0438\u043B\u0435\u0440\u0456\u0432 - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      description_uk: "\u0414\u0438\u043B\u0435\u0440\u0438 \u0441\u043F\u0435\u0446\u0442\u0435\u0445\u043D\u0456\u043A\u0438 " + data.make + " " + p.inCity + ". \u041A\u0440\u0430\u0449\u0456 \u043F\u0440\u043E\u043F\u043E\u0437\u0438\u0446\u0456\u0457 \u043D\u0430 \u0441\u043F\u0435\u0446\u0442\u0435\u0445\u043D\u0456\u043A\u0443 " + data.make + " \u0432\u0456\u0434 \u043F\u0435\u0440\u0435\u0432\u0456\u0440\u0435\u043D\u0438\u0445 \u0434\u0438\u043B\u0435\u0440\u0456\u0432 \u2705 \u0430\u0434\u0440\u0435\u0441\u0438 \u0456 \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u0438 \u043A\u043E\u043C\u043F\u0430\u043D\u0456\u0439 \u260E\uFE0F \u043D\u0430 \u0441\u0430\u0439\u0442\u0456 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      header_uk: "\u0414\u0438\u043B\u0435\u0440\u0438 \u0441\u043F\u0435\u0446\u0442\u0435\u0445\u043D\u0456\u043A\u0438 " + data.make + " " + p.inCity
    };
  }
};

/* harmony default export */ var spetstehnika_templates_defaultExport = (spetstehnika_templates_avtoPathesHead);
// CONCATENATED MODULE: ./src/shared/helpers/seoTextFinder/seoTemplates/avtosalony/spetstehnika/index.js


var SPETSTEHNIKA = {
  city: spetstehnika_templates_defaultExport.city,
  city_make: spetstehnika_templates_defaultExport.cityMake
};
// CONCATENATED MODULE: ./src/shared/helpers/seoTextFinder/seoTemplates/zapchasti/avto/templates.js
/* harmony default export */ var zapchasti_avto_templates_defaultExport = ({
  transport: function transport() {
    return {
      title: 'Автозапчасти Украина. Купить запчасти на авто бу и новые. Продажа запчастей для автомобилей иномарок - Автобазар',
      title_uk: 'Автозапчастини Україна. Купити запчастини на авто бу і нові. Продаж запчастин для автомобілів іномарок - Автобазар',

      description: 'Купить автозапчасти в Украине: новые и бу запчасти на авто. Электронный каталог автомобильных запчастей на машины иномарки. Заказ и продажа запчастей на автомобили круглосуточно 24/7 по интернету на сайте Автобазар.',
      description_uk: 'Купити автозапчастини в Україні: нові та бу запчастини на авто. Електронний каталог автомобільних запчастин на іномарки. Заказ та продаж запчастин на автомобілі цілодобово 24/7 по інтернету на сайті Автобазар',

      header: 'Автозапчасти в Украине',
      header_uk: 'Автозапчастини в Україні'
    };
  },

  make: function make(data) {
    return {
      title: '\u0417\u0430\u043F\u0447\u0430\u0441\u0442\u0438 ' + data.makeTranslate + ': \u043A\u0443\u043F\u0438\u0442\u044C \u0430\u0432\u0442\u043E\u0437\u0430\u043F\u0447\u0430\u0441\u0442\u0438 \u0434\u043B\u044F ' + data.make + ' \u0432 \u0423\u043A\u0440\u0430\u0438\u043D\u0435 - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',
      title_uk: '\u0417\u0430\u043F\u0447\u0430\u0441\u0442\u0438\u043D\u0438 ' + data.makeTranslate + ': \u043A\u0443\u043F\u0438\u0442\u0438 \u0430\u0432\u0442\u043E\u0437\u0430\u043F\u0447\u0430\u0441\u0442\u0438\u043D\u0438 \u0434\u043B\u044F ' + data.make + ' \u0432 \u0423\u043A\u0440\u0430\u0457\u043D\u0456 - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',

      description: '\u041A\u0443\u043F\u0438\u0442\u044C \u0437\u0430\u043F\u0447\u0430\u0441\u0442\u0438 \u0434\u043B\u044F \u0430\u0432\u0442\u043E\u043C\u043E\u0431\u0438\u043B\u0435\u0439 ' + data.makeTranslate + ' \u0432 \u0423\u043A\u0440\u0430\u0438\u043D\u0435 \u2B50 \u0412 \u043F\u0440\u043E\u0434\u0430\u0436\u0435 \u043E\u0440\u0438\u0433\u0438\u043D\u0430\u043B\u044C\u043D\u044B\u0435 \u0430\u0432\u0442\u043E\u0437\u0430\u043F\u0447\u0430\u0441\u0442\u0438 \u0434\u043B\u044F ' + data.make + ' \u0431\u0443 \u0438 \u043D\u043E\u0432\u044B\u0435. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u043A\u0430\u0442\u0430\u043B\u043E\u0433 \u0437\u0430\u043F\u0447\u0430\u0441\u0442\u0435\u0439 \u0441 \u0444\u043E\u0442\u043E, \u0446\u0435\u043D\u0430\u043C\u0438 \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440\u0435',
      description_uk: '\u041A\u0443\u043F\u0438\u0442\u0438 \u0437\u0430\u043F\u0447\u0430\u0441\u0442\u0438\u043D\u0438 \u0434\u043B\u044F \u0430\u0432\u0442\u043E\u043C\u043E\u0431\u0456\u043B\u0456\u0432 ' + data.makeTranslate + ' \u0432 \u0423\u043A\u0440\u0430\u0457\u043D\u0456 \u2B50 \u0423 \u043F\u0440\u043E\u0434\u0430\u0436\u0443 \u043E\u0440\u0438\u0433\u0456\u043D\u0430\u043B\u044C\u043D\u0456 \u0430\u0432\u0442\u043E\u0437\u0430\u043F\u0447\u0430\u0441\u0442\u0438\u043D\u0438 \u0434\u043B\u044F ' + data.make + ' \u0431\u0443 \u0456 \u043D\u043E\u0432\u0456. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u043A\u0430\u0442\u0430\u043B\u043E\u0433 \u0437\u0430\u043F\u0447\u0430\u0441\u0442\u0438\u043D \u0437 \u0444\u043E\u0442\u043E, \u0446\u0456\u043D\u0430\u043C\u0438 \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440\u0456',

      header: '\u0417\u0430\u043F\u0447\u0430\u0441\u0442\u0438 \u043D\u0430 ' + data.make + ' \u0432 \u0423\u043A\u0440\u0430\u0438\u043D\u0435',
      header_uk: '\u0417\u0430\u043F\u0447\u0430\u0441\u0442\u0438\u043D\u0438 \u043D\u0430 ' + data.make + ' \u0432 \u0423\u043A\u0440\u0430\u0457\u043D\u0456'
    };
  },

  make_model: function make_model(data) {
    return {
      title: '\u0417\u0430\u043F\u0447\u0430\u0441\u0442\u0438 \u043D\u0430 ' + data.makeTranslate + ' ' + data.modelTranslate + ': \u043A\u0443\u043F\u0438\u0442\u044C \u0430\u0432\u0442\u043E\u0437\u0430\u043F\u0447\u0430\u0441\u0442\u0438 \u0434\u043B\u044F  ' + data.make + ' ' + data.model + ' \u0432 \u0423\u043A\u0440\u0430\u0438\u043D\u0435 - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',
      title_uk: '\u0417\u0430\u043F\u0447\u0430\u0441\u0442\u0438\u043D\u0438 \u043D\u0430 ' + data.makeTranslate + ' ' + data.modelTranslate + ': \u043A\u0443\u043F\u0438\u0442\u0438 \u0430\u0432\u0442\u043E\u0437\u0430\u043F\u0447\u0430\u0441\u0442\u0438\u043D\u0438 \u0434\u043B\u044F ' + data.make + ' ' + data.model + ' \u0432 \u0423\u043A\u0440\u0430\u0457\u043D\u0456 - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',

      description: '\u041A\u0443\u043F\u0438\u0442\u044C \u0437\u0430\u043F\u0447\u0430\u0441\u0442\u0438 \u0434\u043B\u044F ' + data.makeTranslate + ' ' + data.modelTranslate + ' \u0423\u043A\u0440\u0430\u0438\u043D\u0435 \u2B50 \u0412 \u043F\u0440\u043E\u0434\u0430\u0436\u0435 \u043E\u0440\u0438\u0433\u0438\u043D\u0430\u043B\u044C\u043D\u044B\u0435 \u0430\u0432\u0442\u043E\u0437\u0430\u043F\u0447\u0430\u0441\u0442\u0438 \u0434\u043B\u044F ' + data.make + ' ' + data.model + ' \u0431\u0443 \u0438 \u043D\u043E\u0432\u044B\u0435. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u043A\u0430\u0442\u0430\u043B\u043E\u0433 \u0437\u0430\u043F\u0447\u0430\u0441\u0442\u0435\u0439 \u0441 \u0444\u043E\u0442\u043E, \u0446\u0435\u043D\u0430\u043C\u0438 \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440\u0435',
      description_uk: '\u041A\u0443\u043F\u0438\u0442\u0438 \u0437\u0430\u043F\u0447\u0430\u0441\u0442\u0438\u043D\u0438 \u0434\u043B\u044F ' + data.makeTranslate + ' ' + data.modelTranslate + ' \u0423\u043A\u0440\u0430\u0457\u043D\u0456 \u2B50 \u0423 \u043F\u0440\u043E\u0434\u0430\u0436\u0443 \u043E\u0440\u0438\u0433\u0456\u043D\u0430\u043B\u044C\u043D\u0456 \u0430\u0432\u0442\u043E\u0437\u0430\u043F\u0447\u0430\u0441\u0442\u0438\u043D\u0438 \u0434\u043B\u044F ' + data.make + ' ' + data.model + ' \u0431\u0443 \u0456 \u043D\u043E\u0432\u0456. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u043A\u0430\u0442\u0430\u043B\u043E\u0433 \u0437\u0430\u043F\u0447\u0430\u0441\u0442\u0438\u043D \u0437 \u0444\u043E\u0442\u043E, \u0446\u0456\u043D\u0430\u043C\u0438 \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440\u0456',

      header: '\u0417\u0430\u043F\u0447\u0430\u0441\u0442\u0438 \u043D\u0430 ' + data.make + ' ' + data.model + ' \u0432 \u0423\u043A\u0440\u0430\u0438\u043D\u0435',
      header_uk: '\u0417\u0430\u043F\u0447\u0430\u0441\u0442\u0438\u043D\u0438 \u043D\u0430 ' + data.make + ' ' + data.model + ' \u0432 \u0423\u043A\u0440\u0430\u0457\u043D\u0456'
    };
  },

  city: function city(data, p) {
    return {
      title: '\u0417\u0430\u043F\u0447\u0430\u0441\u0442\u0438 \u043D\u0430 \u041B\u0435\u0433\u043A\u043E\u0432\u044B\u0435 \u0430\u0432\u0442\u043E \u043A\u0443\u043F\u0438\u0442\u044C ' + p.inCity + ' - \u0410\u0432\u0442\u043E\u0411\u0430\u0437\u0430\u0440\u2122',
      title_uk: '\u0417\u0430\u043F\u0447\u0430\u0441\u0442\u0438\u043D\u0438 \u043D\u0430 \u041B\u0435\u0433\u043A\u043E\u0432\u0456 \u0430\u0432\u0442\u043E \u043A\u0443\u043F\u0438\u0442\u0438 ' + p.inCity + ' - \u0410\u0432\u0442\u043E\u0411\u0430\u0437\u0430\u0440\u2122',

      description: '\u041A\u0443\u043F\u0438\u0442\u044C \u0430\u0432\u0442\u043E\u0437\u0430\u043F\u0447\u0430\u0441\u0442\u0438 \u043D\u0430 \u041B\u0435\u0433\u043A\u043E\u0432\u044B\u0435 \u0430\u0432\u0442\u043E ' + p.inCity + ' \u043D\u0430 \u0441\u0430\u0439\u0442\u0435 \u0410\u0432\u0442\u043E\u0411\u0430\u0437\u0430\u0440 \u2705 \u0423\u0434\u043E\u0431\u043D\u044B\u0439 \u043F\u043E\u0438\u0441\u043A \u043F\u043E \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u044F\u043C \u043F\u043E\u043C\u043E\u0436\u0435\u0442 \u0412\u0430\u043C \u0431\u044B\u0441\u0442\u0440\u043E \u0438 \u043B\u0435\u0433\u043A\u043E \u043A\u0443\u043F\u0438\u0442\u044C \u0437\u0430\u043F\u0447\u0430\u0441\u0442\u0438 \u043D\u0430 \u041B\u0435\u0433\u043A\u043E\u0432\u044B\u0435 \u0430\u0432\u0442\u043E \u043F\u043E \u0432\u044B\u0433\u043E\u0434\u043D\u043E\u0439 \u0446\u0435\u043D\u0435',
      description_uk: '\u041A\u0443\u043F\u0438\u0442\u0438 \u0430\u0432\u0442\u043E\u0437\u0430\u043F\u0447\u0430\u0441\u0442\u0438\u043D\u0438 \u043D\u0430 \u041B\u0435\u0433\u043A\u043E\u0432\u0456 \u0430\u0432\u0442\u043E ' + p.inCity + ' \u043D\u0430 \u0441\u0430\u0439\u0442\u0456 \u0410\u0432\u0442\u043E\u0411\u0430\u0437\u0430\u0440 \u2705 \u0417\u0440\u0443\u0447\u043D\u0438\u0439 \u043F\u043E\u0448\u0443\u043A \u043F\u043E \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u043D\u044F\u0445 \u0434\u043E\u043F\u043E\u043C\u043E\u0436\u0435 \u0412\u0430\u043C \u0448\u0432\u0438\u0434\u043A\u043E \u0456 \u043B\u0435\u0433\u043A\u043E \u043A\u0443\u043F\u0438\u0442\u0438 \u0437\u0430\u043F\u0447\u0430\u0441\u0442\u0438\u043D\u0438 \u043D\u0430 \u041B\u0435\u0433\u043A\u043E\u0432\u0456 \u0430\u0432\u0442\u043E \u0437\u0430 \u0432\u0438\u0433\u0456\u0434\u043D\u043E\u044E \u0446\u0456\u043D\u043E\u044E',

      header: '\u0417\u0430\u043F\u0447\u0430\u0441\u0442\u0438 \u043D\u0430 \u043B\u0435\u0433\u043A\u043E\u0432\u044B\u0435 \u0430\u0432\u0442\u043E ' + p.inCity,
      header_uk: '\u0417\u0430\u043F\u0447\u0430\u0441\u0442\u0438\u043D\u0438 \u043D\u0430 \u041B\u0435\u0433\u043A\u043E\u0432\u0456 \u0430\u0432\u0442\u043E ' + p.inCity
    };
  },

  city_make: function city_make(data, p) {
    return {
      title: '\u0417\u0430\u043F\u0447\u0430\u0441\u0442\u0438 ' + data.make + ' \u043A\u0443\u043F\u0438\u0442\u044C \u0431\u0443 \u0438 \u043D\u043E\u0432\u044B\u0435 ' + p.inCity + ' - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',
      title_uk: '\u0417\u0430\u043F\u0447\u0430\u0441\u0442\u0438\u043D\u0438 ' + data.make + ' \u043A\u0443\u043F\u0438\u0442\u0438 \u0431\u0443 \u0456 \u043D\u043E\u0432\u0456 ' + p.inCity + ' - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',

      description: '\u041A\u0443\u043F\u0438\u0442\u044C \u0437\u0430\u043F\u0447\u0430\u0441\u0442\u0438 ' + data.make + ' ' + p.inCity + '. \u0412 \u043F\u0440\u043E\u0434\u0430\u0436\u0435 \u0430\u0432\u0442\u043E\u0437\u0430\u043F\u0447\u0430\u0441\u0442\u0438 \u0434\u043B\u044F ' + data.make + ' \u0431\u0443 \u0438 \u043D\u043E\u0432\u044B\u0435. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u043A\u0430\u0442\u0430\u043B\u043E\u0433 \u0434\u0435\u0442\u0430\u043B\u0435\u0439 \u0434\u043B\u044F ' + data.make + ' ' + p.inCity + ' \u0441 \u0444\u043E\u0442\u043E, \u0446\u0435\u043D\u0430\u043C\u0438 \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',
      description_uk: '\u041A\u0443\u043F\u0438\u0442\u0438 \u0437\u0430\u043F\u0447\u0430\u0441\u0442\u0438\u043D\u0438 ' + data.make + ' ' + p.inCity + '. \u0423 \u043F\u0440\u043E\u0434\u0430\u0436\u0443 \u0430\u0432\u0442\u043E\u0437\u0430\u043F\u0447\u0430\u0441\u0442\u0438\u043D\u0438 \u0434\u043B\u044F ' + data.make + ' \u0431\u0443 \u0456 \u043D\u043E\u0432\u0456. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u043A\u0430\u0442\u0430\u043B\u043E\u0433 \u0434\u0435\u0442\u0430\u043B\u0435\u0439 \u0434\u043B\u044F ' + data.make + ' ' + p.inCity + ' \u0437 \u0444\u043E\u0442\u043E, \u0446\u0456\u043D\u0430\u043C\u0438 \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',

      header: '\u0417\u0430\u043F\u0447\u0430\u0441\u0442\u0438 ' + data.make + ' ' + p.inCity,
      header_uk: '\u0417\u0430\u043F\u0447\u0430\u0441\u0442\u0438\u043D\u0438 ' + data.make + ' ' + p.inCity
    };
  },

  city_make_model: function city_make_model(data, p) {
    return {
      title: '\u0417\u0430\u043F\u0447\u0430\u0441\u0442\u0438 ' + data.make + ' ' + data.model + ' \u043A\u0443\u043F\u0438\u0442\u044C \u0431\u0443 \u0438 \u043D\u043E\u0432\u044B\u0435 ' + p.inCity + ' - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',
      title_uk: '\u0417\u0430\u043F\u0447\u0430\u0441\u0442\u0438\u043D\u0438 ' + data.make + ' ' + data.model + ' \u043A\u0443\u043F\u0438\u0442\u0438 \u0431\u0443 \u0456 \u043D\u043E\u0432\u0456 ' + p.inCity + ' - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',

      description: '\u041A\u0443\u043F\u0438\u0442\u044C \u0437\u0430\u043F\u0447\u0430\u0441\u0442\u0438 ' + data.make + ' ' + data.model + ' ' + p.inCity + '. \u0412 \u043F\u0440\u043E\u0434\u0430\u0436\u0435 \u0430\u0432\u0442\u043E\u0437\u0430\u043F\u0447\u0430\u0441\u0442\u0438 \u0434\u043B\u044F ' + data.make + ' ' + data.model + ' \u0431\u0443 \u0438 \u043D\u043E\u0432\u044B\u0435. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u043A\u0430\u0442\u0430\u043B\u043E\u0433 \u0434\u0435\u0442\u0430\u043B\u0435\u0439 \u0441 \u0444\u043E\u0442\u043E, \u0446\u0435\u043D\u0430\u043C\u0438 \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',
      description_uk: '\u041A\u0443\u043F\u0438\u0442\u0438 \u0437\u0430\u043F\u0447\u0430\u0441\u0442\u0438\u043D\u0438 ' + data.make + ' ' + data.model + ' ' + p.inCity + '. \u0423 \u043F\u0440\u043E\u0434\u0430\u0436\u0443 \u0430\u0432\u0442\u043E\u0437\u0430\u043F\u0447\u0430\u0441\u0442\u0438\u043D\u0438 \u0434\u043B\u044F ' + data.make + ' ' + data.model + ' \u0431\u0443 \u0456 \u043D\u043E\u0432\u0456. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u043A\u0430\u0442\u0430\u043B\u043E\u0433 \u0434\u0435\u0442\u0430\u043B\u0435\u0439 \u0437 \u0444\u043E\u0442\u043E, \u0446\u0456\u043D\u0430\u043C\u0438 \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',

      header: '\u0417\u0430\u043F\u0447\u0430\u0441\u0442\u0438 ' + data.make + ' ' + data.model + ' ' + p.inCity,
      header_uk: '\u0417\u0430\u043F\u0447\u0430\u0441\u0442\u0438\u043D\u0438 ' + data.make + ' ' + data.model + ' ' + p.inCity
    };
  }
});
// CONCATENATED MODULE: ./src/shared/helpers/seoTextFinder/seoTemplates/zapchasti/avto/templates_dvigatel_mahovik.js
/* harmony default export */ var templates_dvigatel_mahovik_defaultExport = ({
  make: function make(data) {
    return {
      header: "\u041C\u0430\u0445\u043E\u0432\u0438\u043A " + data.make,
      header_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043C\u0430\u0445\u043E\u0432\u0438\u043A " + data.make
    };
  }
});
// CONCATENATED MODULE: ./src/shared/helpers/seoTextFinder/seoTemplates/zapchasti/avto/templates_dvigatel_patrubki.js
/* harmony default export */ var templates_dvigatel_patrubki_defaultExport = ({
  make: function make(data) {
    return {
      header: "\u041F\u0430\u0442\u0440\u0443\u0431\u043A\u0438 " + data.make,
      header_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043F\u0430\u0442\u0440\u0443\u0431\u043E\u043A \u0434\u043B\u044F " + data.make
    };
  }
});
// CONCATENATED MODULE: ./src/shared/helpers/seoTextFinder/seoTemplates/zapchasti/avto/templates_dvigatel_klapan-egr.js
/* harmony default export */ var templates_dvigatel_klapan_egr_defaultExport = ({
  make: function make(data) {
    return {
      header: "\u041A\u043B\u0430\u043F\u0430\u043D EGR \u0434\u043B\u044F " + data.make,
      header_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043A\u043B\u0430\u043F\u0430\u043D EGR \u0434\u043B\u044F " + data.make
    };
  }
});
// CONCATENATED MODULE: ./src/shared/helpers/seoTextFinder/seoTemplates/zapchasti/avto/templates_elektrika-i-elektronika_datchik-abs.js
/* harmony default export */ var templates_elektrika_i_elektronika_datchik_abs_defaultExport = ({
  make: function make(data) {
    return {
      header: "\u0414\u0430\u0442\u0447\u0438\u043A ABS " + data.make,
      header_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u0434\u0430\u0442\u0447\u0438\u043A ABS " + data.make
    };
  }
});
// CONCATENATED MODULE: ./src/shared/helpers/seoTextFinder/seoTemplates/zapchasti/avto/templates_elektrika-i-elektronika_datchik.js
/* harmony default export */ var templates_elektrika_i_elektronika_datchik_defaultExport = ({
  make: function make(data) {
    return {
      header: "\u0414\u0430\u0442\u0447\u0438\u043A\u0438 \u0434\u043B\u044F " + data.make,
      header_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u0434\u0430\u0442\u0447\u0438\u043A\u0438 \u0434\u043B\u044F " + data.make
    };
  }
});
// CONCATENATED MODULE: ./src/shared/helpers/seoTextFinder/seoTemplates/zapchasti/avto/index.js







var AUTO = {
  transport: zapchasti_avto_templates_defaultExport.transport,
  make: zapchasti_avto_templates_defaultExport.make,
  make_model: zapchasti_avto_templates_defaultExport.make_model,

  city: zapchasti_avto_templates_defaultExport.city,
  city_make: zapchasti_avto_templates_defaultExport.city_make,
  city_make_model: zapchasti_avto_templates_defaultExport.city_make_model
};

var AVTO_DVIGATEL_MAHOVIK = {
  make: templates_dvigatel_mahovik_defaultExport.make
};

var AVTO_DVIGATEL_PATRUBKI = {
  make: templates_dvigatel_patrubki_defaultExport.make
};

var AVTO_DVIGATEL_KLAPANI__EGR = {
  make: templates_dvigatel_klapan_egr_defaultExport.make
};

var AVTO_ELEKTRIKA__I__ELEKTRONIKA_DATCHIKI = {
  make: templates_elektrika_i_elektronika_datchik_defaultExport.make
};

var AVTO_ELEKTRIKA__I__ELEKTRONIKA_DATCHIKI__ABS = {
  make: templates_elektrika_i_elektronika_datchik_abs_defaultExport.make
};
// CONCATENATED MODULE: ./src/shared/helpers/seoTextFinder/seoTemplates/zapchasti/avtobus/templates.js
/* harmony default export */ var zapchasti_avtobus_templates_defaultExport = ({
  city: function city(data, p) {
    return {
      title: "\u0417\u0430\u043F\u0447\u0430\u0441\u0442\u0438 \u043D\u0430 \u0430\u0432\u0442\u043E\u0431\u0443\u0441 \u043A\u0443\u043F\u0438\u0442\u044C " + p.inCity + " - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      title_uk: "\u0417\u0430\u043F\u0447\u0430\u0441\u0442\u0438\u043D\u0438 \u043D\u0430 \u0430\u0432\u0442\u043E\u0431\u0443\u0441 \u043A\u0443\u043F\u0438\u0442\u0438 " + p.inCity + " - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",

      description: "\u041A\u0443\u043F\u0438\u0442\u044C \u0437\u0430\u043F\u0447\u0430\u0441\u0442\u0438 \u043D\u0430 \u0430\u0432\u0442\u043E\u0431\u0443\u0441 " + p.inCity + ". \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u043A\u0430\u0442\u0430\u043B\u043E\u0433 \u0437\u0430\u043F\u0447\u0430\u0441\u0442\u0435\u0439 \u0434\u043B\u044F \u0430\u0432\u0442\u043E\u0431\u0443\u0441\u043E\u0432 " + p.inCity + " \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0412 \u043F\u0440\u043E\u0434\u0430\u0436\u0435 \u0437\u0430\u043F\u0447\u0430\u0441\u0442\u0438 \u043D\u0430 \u0430\u0432\u0442\u043E\u0431\u0443\u0441\u044B \u0431\u0443 \u0438 \u043D\u043E\u0432\u044B\u0435 \u043E\u0442 \u043E\u0444\u0438\u0446\u0438\u0430\u043B\u044C\u043D\u044B\u0445 \u0438\u043D\u0442\u0435\u0440\u043D\u0435\u0442 \u043C\u0430\u0433\u0430\u0437\u0438\u043D\u043E\u0432, \u0430\u0432\u0442\u043E\u0440\u0430\u0437\u0431\u043E\u0440\u043E\u043A \u0438 \u0447\u0430\u0441\u0442\u043D\u044B\u0445 \u043B\u0438\u0446",
      description_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u0437\u0430\u043F\u0447\u0430\u0441\u0442\u0438\u043D\u0438 \u043D\u0430 \u0430\u0432\u0442\u043E\u0431\u0443\u0441 " + p.inCity + ". \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u043A\u0430\u0442\u0430\u043B\u043E\u0433 \u0437\u0430\u043F\u0447\u0430\u0441\u0442\u0438\u043D \u0434\u043B\u044F \u0430\u0432\u0442\u043E\u0431\u0443\u0441\u0456\u0432 " + p.inCity + " \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0423 \u043F\u0440\u043E\u0434\u0430\u0436\u0443 \u0437\u0430\u043F\u0447\u0430\u0441\u0442\u0438\u043D\u0438 \u043D\u0430 \u0430\u0432\u0442\u043E\u0431\u0443\u0441\u0438 \u0431\u0443 \u0456 \u043D\u043E\u0432\u0456 \u0432\u0456\u0434 \u043E\u0444\u0456\u0446\u0456\u0439\u043D\u0438\u0445 \u0456\u043D\u0442\u0435\u0440\u043D\u0435\u0442 \u043C\u0430\u0433\u0430\u0437\u0438\u043D\u0456\u0432, \u0430\u0432\u0442\u043E\u0440\u0430\u0437\u0431\u043E\u0440\u043E\u043A \u0456 \u043F\u0440\u0438\u0432\u0430\u0442\u043D\u0438\u0445 \u043E\u0441\u0456\u0431",

      header: "\u0417\u0430\u043F\u0447\u0430\u0441\u0442\u0438 \u043D\u0430 \u0430\u0432\u0442\u043E\u0431\u0443\u0441 " + p.inCity,
      header_uk: "\u0417\u0430\u043F\u0447\u0430\u0441\u0442\u0438\u043D\u0438 \u043D\u0430 \u0430\u0432\u0442\u043E\u0431\u0443\u0441 " + p.inCity
    };
  },

  make_model: function make_model(data, p) {
    return {
      header: "\u0417\u0430\u043F\u0447\u0430\u0441\u0442\u0438 \u043D\u0430 \u0430\u0432\u0442\u043E\u0431\u0443\u0441\u044B " + data.make + " " + data.model + " \u0432 \u0423\u043A\u0440\u0430\u0438\u043D\u0435",
      header_uk: "\u0417\u0430\u043F\u0447\u0430\u0441\u0442\u0438\u043D\u0438 \u043D\u0430 \u0430\u0432\u0442\u043E\u0431\u0443\u0441\u0438 " + data.make + " " + data.model + " \u0432 \u0423\u043A\u0440\u0430\u0457\u043D\u0456"
    };
  }
});
// CONCATENATED MODULE: ./src/shared/helpers/seoTextFinder/seoTemplates/zapchasti/avtobus/index.js


var avtobus_AVTOBUS = {
  city: zapchasti_avtobus_templates_defaultExport.city,
  make_model: zapchasti_avtobus_templates_defaultExport.make_model
};
// CONCATENATED MODULE: ./src/shared/helpers/seoTextFinder/seoTemplates/zapchasti/gruzovye/templates.js
/* harmony default export */ var zapchasti_gruzovye_templates_defaultExport = ({
  city: function city(data, p) {
    return {
      title: "\u0417\u0430\u043F\u0447\u0430\u0441\u0442\u0438 \u0434\u043B\u044F \u0433\u0440\u0443\u0437\u043E\u0432\u0438\u043A\u043E\u0432 \u043A\u0443\u043F\u0438\u0442\u044C " + p.inCity + " - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      title_uk: "\u0417\u0430\u043F\u0447\u0430\u0441\u0442\u0438\u043D\u0438 \u0434\u043B\u044F \u0432\u0430\u043D\u0442\u0430\u0436\u0456\u0432\u043E\u043A \u043A\u0443\u043F\u0438\u0442\u0438 " + p.inCity + " - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",

      description: "\u041A\u0443\u043F\u0438\u0442\u044C \u0437\u0430\u043F\u0447\u0430\u0441\u0442\u0438 \u043D\u0430 \u0433\u0440\u0443\u0437\u043E\u0432\u0438\u043A " + p.inCity + ". \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u043A\u0430\u0442\u0430\u043B\u043E\u0433 \u0430\u0432\u0442\u043E\u0437\u0430\u043F\u0447\u0430\u0441\u0442\u0435\u0439 \u0434\u043B\u044F \u0433\u0440\u0443\u0437\u043E\u0432\u0438\u043A\u043E\u0432 " + p.inCity + " \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0412 \u043F\u0440\u043E\u0434\u0430\u0436\u0435 \u0437\u0430\u043F\u0447\u0430\u0441\u0442\u0438 \u043A \u0433\u0440\u0443\u0437\u043E\u0432\u0438\u043A\u0430\u043C \u0431\u0443 \u0438 \u043D\u043E\u0432\u044B\u0435 \u043E\u0442 \u043F\u043E \u0432\u044B\u0433\u043E\u0434\u043D\u044B\u043C \u0446\u0435\u043D\u0430\u043C",
      description_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u0437\u0430\u043F\u0447\u0430\u0441\u0442\u0438\u043D\u0438 \u043D\u0430 \u0433\u0440\u0443\u0437\u043E\u0432\u0438\u043A " + p.inCity + ". \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u043A\u0430\u0442\u0430\u043B\u043E\u0433 \u0430\u0432\u0442\u043E\u0437\u0430\u043F\u0447\u0430\u0441\u0442\u0438\u043D \u0434\u043B\u044F \u0432\u0430\u043D\u0442\u0430\u0436\u0456\u0432\u043E\u043A " + p.inCity + " \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0423 \u043F\u0440\u043E\u0434\u0430\u0436\u0443 \u0437\u0430\u043F\u0447\u0430\u0441\u0442\u0438\u043D\u0438 \u0434\u043E \u0432\u0430\u043D\u0442\u0430\u0436\u0456\u0432\u043E\u043A \u0431\u0443 \u0456 \u043D\u043E\u0432\u0456 \u0432\u0456\u0434 \u0437\u0430 \u0432\u0438\u0433\u0456\u0434\u043D\u0438\u043C\u0438 \u0446\u0456\u043D\u0430\u043C\u0438",

      header: "\u0417\u0430\u043F\u0447\u0430\u0441\u0442\u0438 \u0434\u043B\u044F \u0433\u0440\u0443\u0437\u043E\u0432\u0438\u043A\u043E\u0432 " + p.inCity,
      header_uk: "\u0417\u0430\u043F\u0447\u0430\u0441\u0442\u0438\u043D\u0438 \u0434\u043B\u044F \u0432\u0430\u043D\u0442\u0430\u0436\u0456\u0432\u043E\u043A " + p.inCity
    };
  },

  make_model: function make_model(data, p) {
    return {
      header: "\u0417\u0430\u043F\u0447\u0430\u0441\u0442\u0438 \u0434\u043B\u044F \u0433\u0440\u0443\u0437\u043E\u0432\u0438\u043A\u043E\u0432 " + data.make + " " + data.model,
      header_uk: "\u0417\u0430\u043F\u0447\u0430\u0441\u0442\u0438\u043D\u0438 \u0434\u043B\u044F \u0432\u0430\u043D\u0442\u0430\u0436\u0456\u0432\u043E\u043A " + data.make + " " + data.model
    };
  }
});
// CONCATENATED MODULE: ./src/shared/helpers/seoTextFinder/seoTemplates/zapchasti/gruzovye/index.js


var gruzovye_GRUZOVYE = {
  city: zapchasti_gruzovye_templates_defaultExport.city,
  make_model: zapchasti_gruzovye_templates_defaultExport.make_model
};
// CONCATENATED MODULE: ./src/shared/helpers/seoTextFinder/seoTemplates/zapchasti/moto/templates.js
/* harmony default export */ var zapchasti_moto_templates_defaultExport = ({
  city: function city(data, p) {
    return {
      title: "\u0417\u0430\u043F\u0447\u0430\u0441\u0442\u0438 \u043D\u0430 \u043C\u043E\u0442\u043E\u0442\u0435\u0445\u043D\u0438\u043A\u0443 \u043A\u0443\u043F\u0438\u0442\u044C " + p.inCity + " - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      title_uk: "\u0417\u0430\u043F\u0447\u0430\u0441\u0442\u0438\u043D\u0438 \u043D\u0430 \u043C\u043E\u0442\u043E\u0442\u0435\u0445\u043D\u0456\u043A\u0443 \u043A\u0443\u043F\u0438\u0442\u0438 " + p.inCity + " - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",

      description: "\u041A\u0443\u043F\u0438\u0442\u044C \u0437\u0430\u043F\u0447\u0430\u0441\u0442\u0438 \u043D\u0430 \u043C\u043E\u0442\u043E\u0442\u0435\u0445\u043D\u0438\u043A\u0443 " + p.inCity + ". \u0412 \u043F\u0440\u043E\u0434\u0430\u0436\u0435 \u0437\u0430\u043F\u0447\u0430\u0441\u0442\u0438 \u0434\u043B\u044F \u043C\u043E\u0442\u043E\u0442\u0435\u0445\u043D\u0438\u043A\u0438 \u0431\u0443 \u0438 \u043D\u043E\u0432\u044B\u0435. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u043A\u0430\u0442\u0430\u043B\u043E\u0433 \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440 \u0441 \u0446\u0435\u043D\u0430\u043C\u0438 \u0438 \u0444\u043E\u0442\u043E",
      description_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u0437\u0430\u043F\u0447\u0430\u0441\u0442\u0438\u043D\u0438 \u043D\u0430 \u043C\u043E\u0442\u043E\u0442\u0435\u0445\u043D\u0456\u043A\u0443 " + p.inCity + ". \u0423 \u043F\u0440\u043E\u0434\u0430\u0436\u0443 \u0437\u0430\u043F\u0447\u0430\u0441\u0442\u0438\u043D\u0438 \u0434\u043B\u044F \u043C\u043E\u0442\u043E\u0442\u0435\u0445\u043D\u0456\u043A\u0438 \u0431\u0443 \u0456 \u043D\u043E\u0432\u0456. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u043A\u0430\u0442\u0430\u043B\u043E\u0433 \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440 \u0437 \u0446\u0456\u043D\u0430\u043C\u0438 \u0456 \u0444\u043E\u0442\u043E",

      header: "\u041C\u043E\u0442\u043E\u0442\u0435\u0445\u043D\u0438\u043A\u0430 \u0437\u0430\u043F\u0447\u0430\u0441\u0442\u0438 " + p.t(data.city),
      header_uk: "\u041C\u043E\u0442\u043E\u0442\u0435\u0445\u043D\u0456\u043A\u0430 \u0437\u0430\u043F\u0447\u0430\u0441\u0442\u0438\u043D\u0438 " + p.t(data.city)
    };
  }
});
// CONCATENATED MODULE: ./src/shared/helpers/seoTextFinder/seoTemplates/zapchasti/moto/index.js


var moto_MOTO = {
  city: zapchasti_moto_templates_defaultExport.city
};
// CONCATENATED MODULE: ./src/shared/helpers/seoTextFinder/seoTemplates/zapchasti/skuter/templates.js
/* harmony default export */ var zapchasti_skuter_templates_defaultExport = ({
  make: function make(data, p) {
    return {
      header: "\u0417\u0430\u043F\u0447\u0430\u0441\u0442\u0438 \u043D\u0430 \u0441\u043A\u0443\u0442\u0435\u0440 " + data.make,
      header_uk: "\u0417\u0430\u043F\u0447\u0430\u0441\u0442\u0438\u043D\u0438 \u043D\u0430 \u0441\u043A\u0443\u0442\u0435\u0440  " + data.make
    };
  },
  make_model: function make_model(data, p) {
    return {
      header: "\u0417\u0430\u043F\u0447\u0430\u0441\u0442\u0438 \u043D\u0430 \u0441\u043A\u0443\u0442\u0435\u0440 " + data.make + " " + data.model,
      header_uk: "\u0417\u0430\u043F\u0447\u0430\u0441\u0442\u0438\u043D\u0438 \u043D\u0430 \u0441\u043A\u0443\u0442\u0435\u0440 " + data.make + " " + data.model
    };
  }
});
// CONCATENATED MODULE: ./src/shared/helpers/seoTextFinder/seoTemplates/zapchasti/skuter/index.js


var skuter_SKUTER = {
  make: zapchasti_skuter_templates_defaultExport.make,
  make_model: zapchasti_skuter_templates_defaultExport.make_model
};
// CONCATENATED MODULE: ./src/shared/helpers/seoTextFinder/seoTemplates/zapchasti/mototsikl/templates.js
/* harmony default export */ var zapchasti_mototsikl_templates_defaultExport = ({
  make: function make(data, p) {
    return {
      header: "\u0417\u0430\u043F\u0447\u0430\u0441\u0442\u0438 \u043D\u0430 \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B " + data.make,
      header_uk: "\u0417\u0430\u043F\u0447\u0430\u0441\u0442\u0438\u043D\u0438 \u043D\u0430 \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B " + data.make
    };
  },
  make_model: function make_model(data, p) {
    return {
      header: "\u0417\u0430\u043F\u0447\u0430\u0441\u0442\u0438 \u043D\u0430 \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B " + data.make + " " + data.model,
      header_uk: "\u0417\u0430\u043F\u0447\u0430\u0441\u0442\u0438\u043D\u0438 \u043D\u0430 \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B " + data.make + " " + data.model
    };
  }
});
// CONCATENATED MODULE: ./src/shared/helpers/seoTextFinder/seoTemplates/zapchasti/mototsikl/index.js


var zapchasti_mototsikl_MOTOTSIKL = {
  make: zapchasti_mototsikl_templates_defaultExport.make,
  make_model: zapchasti_mototsikl_templates_defaultExport.make_model
};
// CONCATENATED MODULE: ./src/shared/helpers/seoTextFinder/seoTemplates/zapchasti/kvadrotsikl/templates.js
/* harmony default export */ var zapchasti_kvadrotsikl_templates_defaultExport = ({
  city: function city(data, p) {
    return {
      title: "\u0417\u0430\u043F\u0447\u0430\u0441\u0442\u0438 \u043D\u0430 \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B \u043A\u0443\u043F\u0438\u0442\u044C " + p.inCity + " - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      title_uk: "\u0417\u0430\u043F\u0447\u0430\u0441\u0442\u0438\u043D\u0438 \u043D\u0430 \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B \u043A\u0443\u043F\u0438\u0442\u0438 " + p.inCity + " - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",

      description: "\u041A\u0443\u043F\u0438\u0442\u044C \u0437\u0430\u043F\u0447\u0430\u0441\u0442\u0438 \u043D\u0430 \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B " + p.inCity + ". \u0412 \u043F\u0440\u043E\u0434\u0430\u0436\u0435 \u0437\u0430\u043F\u0447\u0430\u0441\u0442\u0438 \u0434\u043B\u044F \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B\u043E\u0432 \u0431\u0443 \u0438 \u043D\u043E\u0432\u044B\u0435. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u043A\u0430\u0442\u0430\u043B\u043E\u0433 \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440 \u0441 \u0446\u0435\u043D\u0430\u043C\u0438 \u0438 \u0444\u043E\u0442\u043E",
      description_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u0437\u0430\u043F\u0447\u0430\u0441\u0442\u0438\u043D\u0438 \u043D\u0430 \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B " + p.inCity + ". \u0423 \u043F\u0440\u043E\u0434\u0430\u0436\u0443 \u0437\u0430\u043F\u0447\u0430\u0441\u0442\u0438\u043D\u0438 \u0434\u043B\u044F \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B\u0456\u0432 \u0431\u0443 \u0456 \u043D\u043E\u0432\u0456. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u043A\u0430\u0442\u0430\u043B\u043E\u0433 \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440 \u0437 \u0446\u0456\u043D\u0430\u043C\u0438 \u0456 \u0444\u043E\u0442\u043E"
    };
  },
  make: function make(data, p) {
    return {
      header: "\u0417\u0430\u043F\u0447\u0430\u0441\u0442\u0438 \u043D\u0430 \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B " + data.make,
      header_uk: "\u0417\u0430\u043F\u0447\u0430\u0441\u0442\u0438\u043D\u0438 \u043D\u0430 \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B " + data.make
    };
  },
  make_model: function make_model(data, p) {
    return {
      header: "\u0417\u0430\u043F\u0447\u0430\u0441\u0442\u0438 \u043D\u0430 \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B " + data.make + " " + data.model,
      header_uk: "\u0417\u0430\u043F\u0447\u0430\u0441\u0442\u0438\u043D\u0438 \u043D\u0430 \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B " + data.make + " " + data.model
    };
  }
});
// CONCATENATED MODULE: ./src/shared/helpers/seoTextFinder/seoTemplates/zapchasti/kvadrotsikl/index.js


var kvadrotsikl_KVADROTSIKL = {
  city: zapchasti_kvadrotsikl_templates_defaultExport.city,
  make: zapchasti_kvadrotsikl_templates_defaultExport.make,
  make_model: zapchasti_kvadrotsikl_templates_defaultExport.make_model
};
// CONCATENATED MODULE: ./src/shared/helpers/seoTextFinder/seoTemplates/zapchasti/moped/templates.js
/* harmony default export */ var zapchasti_moped_templates_defaultExport = ({
  make: function make(data, p) {
    return {
      header: "\u0417\u0430\u043F\u0447\u0430\u0441\u0442\u0438 \u043D\u0430 \u043C\u043E\u043F\u0435\u0434 " + data.make,
      header_uk: "\u0417\u0430\u043F\u0447\u0430\u0441\u0442\u0438\u043D\u0438 \u043D\u0430 \u043C\u043E\u043F\u0435\u0434 " + data.make
    };
  },
  make_model: function make_model(data, p) {
    return {
      header: "\u0417\u0430\u043F\u0447\u0430\u0441\u0442\u0438 \u043D\u0430 \u043C\u043E\u043F\u0435\u0434 " + data.make + " " + data.model,
      header_uk: "\u0417\u0430\u043F\u0447\u0430\u0441\u0442\u0438\u043D\u0438 \u043D\u0430 \u043C\u043E\u043F\u0435\u0434 " + data.make + " " + data.model,

      title: "\u0417\u0430\u043F\u0447\u0430\u0441\u0442\u0438 \u043D\u0430 \u043C\u043E\u043F\u0435\u0434\u044B " + data.make + " " + data.model + " \u043A\u0443\u043F\u0438\u0442\u044C \u0431\u0443 \u0438 \u043D\u043E\u0432\u044B\u0435 \u0432 \u0423\u043A\u0440\u0430\u0438\u043D\u0435 - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      title_uk: "\u0417\u0430\u043F\u0447\u0430\u0441\u0442\u0438\u043D\u0438 \u043D\u0430 \u043C\u043E\u043F\u0435\u0434\u0438 " + data.make + " " + data.model + " \u043A\u0443\u043F\u0438\u0442\u0438 \u0431\u0443 \u0456 \u043D\u043E\u0432\u0456 \u0432 \u0423\u043A\u0440\u0430\u0457\u043D\u0456 - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",

      description: "\u041A\u0443\u043F\u0438\u0442\u044C \u0437\u0430\u043F\u0447\u0430\u0441\u0442\u0438 \u043D\u0430 \u043C\u043E\u043F\u0435\u0434 " + data.make + " " + data.model + " \u0432 \u0423\u043A\u0440\u0430\u0438\u043D\u0435. \u0412 \u043F\u0440\u043E\u0434\u0430\u0436\u0435 \u0437\u0430\u043F\u0447\u0430\u0441\u0442\u0438 \u0434\u043B\u044F \u043C\u043E\u043F\u0435\u0434\u043E\u0432 " + data.make + " " + data.model + " \u0431\u0443 \u0438 \u043D\u043E\u0432\u044B\u0435. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u043A\u0430\u0442\u0430\u043B\u043E\u0433 \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440 \u0441 \u0444\u043E\u0442\u043E, \u0446\u0435\u043D\u0430\u043C\u0438",
      description_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u0437\u0430\u043F\u0447\u0430\u0441\u0442\u0438\u043D\u0438 \u043D\u0430 \u043C\u043E\u043F\u0435\u0434 " + data.make + " " + data.model + " \u0432 \u0423\u043A\u0440\u0430\u0457\u043D\u0456. \u0423 \u043F\u0440\u043E\u0434\u0430\u0436\u0443 \u0437\u0430\u043F\u0447\u0430\u0441\u0442\u0438\u043D\u0438 \u0434\u043B\u044F \u043C\u043E\u043F\u0435\u0434\u0456\u0432 " + data.make + " " + data.model + " \u0431\u0443 \u0456 \u043D\u043E\u0432\u0456. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u043A\u0430\u0442\u0430\u043B\u043E\u0433 \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440 \u0437 \u0444\u043E\u0442\u043E, \u0446\u0456\u043D\u0430\u043C\u0438"
    };
  }
});
// CONCATENATED MODULE: ./src/shared/helpers/seoTextFinder/seoTemplates/zapchasti/moped/index.js


var moped_MOPED = {
  make: zapchasti_moped_templates_defaultExport.make,
  make_model: zapchasti_moped_templates_defaultExport.make_model
};
// CONCATENATED MODULE: ./src/shared/helpers/seoTextFinder/seoTemplates/zapchasti/spetstehnika/templates.js
/* harmony default export */ var zapchasti_spetstehnika_templates_defaultExport = ({
  city: function city(data, p) {
    return {
      header: "\u0417\u0430\u043F\u0447\u0430\u0441\u0442\u0438 \u0441\u043F\u0435\u0446\u0442\u0435\u0445\u043D\u0438\u043A\u0430 " + p.t(data.city),
      header_uk: "\u0417\u0430\u043F\u0447\u0430\u0441\u0442\u0438\u043D\u0438 \u0441\u043F\u0435\u0446\u0442\u0435\u0445\u043D\u0456\u043A\u0430 " + p.t(data.city),

      title: "\u0417\u0430\u043F\u0447\u0430\u0441\u0442\u0438 \u0441\u043F\u0435\u0446\u0442\u0435\u0445\u043D\u0438\u043A\u0430 \u043A\u0443\u043F\u0438\u0442\u044C " + p.inCity + " - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      title_uk: "\u0417\u0430\u043F\u0447\u0430\u0441\u0442\u0438\u043D\u0438 \u0441\u043F\u0435\u0446\u0442\u0435\u0445\u043D\u0456\u043A\u0430 \u043A\u0443\u043F\u0438\u0442\u0438 " + p.inCity + " - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",

      description: "\u041A\u0443\u043F\u0438\u0442\u044C \u0437\u0430\u043F\u0447\u0430\u0441\u0442\u0438 \u0441\u043F\u0435\u0446\u0442\u0435\u0445\u043D\u0438\u043A\u0430 " + p.inCity + ". \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u043A\u0430\u0442\u0430\u043B\u043E\u0433 \u0437\u0430\u043F\u0447\u0430\u0441\u0442\u0435\u0439 \u0441\u043F\u0435\u0446\u0442\u0435\u0445\u043D\u0438\u043A\u0430 \u0431\u0443 \u0438 \u043D\u043E\u0432\u044B\u0445 \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440 \u0441 \u0446\u0435\u043D\u0430\u043C\u0438 \u0438 \u0444\u043E\u0442\u043E",
      description_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u0437\u0430\u043F\u0447\u0430\u0441\u0442\u0438\u043D\u0438 \u0441\u043F\u0435\u0446\u0442\u0435\u0445\u043D\u0456\u043A\u0430 " + p.inCity + ". \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u043A\u0430\u0442\u0430\u043B\u043E\u0433 \u0437\u0430\u043F\u0447\u0430\u0441\u0442\u0438\u043D \u0441\u043F\u0435\u0446\u0442\u0435\u0445\u043D\u0456\u043A\u0430 \u0431\u0443 \u0456 \u043D\u043E\u0432\u0438\u0445 \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440 \u0437 \u0446\u0456\u043D\u0430\u043C\u0438 \u0456 \u0444\u043E\u0442\u043E"
    };
  }
});
// CONCATENATED MODULE: ./src/shared/helpers/seoTextFinder/seoTemplates/zapchasti/spetstehnika/index.js


var spetstehnika_SPETSTEHNIKA = {
  city: zapchasti_spetstehnika_templates_defaultExport.city
};
// CONCATENATED MODULE: ./src/shared/helpers/seoTextFinder/seoTemplates/zapchasti/pritsepy/templates.js
/* harmony default export */ var zapchasti_pritsepy_templates_defaultExport = ({
  city: function city(data, p) {
    return {
      header: "\u0417\u0430\u043F\u0447\u0430\u0441\u0442\u0438 \u0434\u043B\u044F \u043F\u0440\u0438\u0446\u0435\u043F\u043E\u0432 " + p.t(data.city),
      header_uk: "\u0417\u0430\u043F\u0447\u0430\u0441\u0442\u0438\u043D\u0438 \u0434\u043B\u044F \u043F\u0440\u0438\u0447\u0435\u043F\u0456\u0432 " + p.t(data.city),

      title: "\u0417\u0430\u043F\u0447\u0430\u0441\u0442\u0438 \u0434\u043B\u044F \u043F\u0440\u0438\u0446\u0435\u043F\u043E\u0432 \u043A\u0443\u043F\u0438\u0442\u044C " + p.inCity + " - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      title_uk: "\u0417\u0430\u043F\u0447\u0430\u0441\u0442\u0438\u043D\u0438 \u0434\u043B\u044F \u043F\u0440\u0438\u0447\u0435\u043F\u0456\u0432 \u043A\u0443\u043F\u0438\u0442\u0438 " + p.inCity + " - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",

      description: "\u041A\u0443\u043F\u0438\u0442\u044C \u0437\u0430\u043F\u0447\u0430\u0441\u0442\u0438 \u0434\u043B\u044F \u043F\u0440\u0438\u0446\u0435\u043F\u0430 " + p.inCity + ". \u0412 \u043F\u0440\u043E\u0434\u0430\u0436\u0435 \u0437\u0430\u043F\u0447\u0430\u0441\u0442\u0438 \u0434\u043B\u044F \u043B\u0435\u0433\u043A\u043E\u0432\u044B\u0445 \u043F\u0440\u0438\u0446\u0435\u043F\u043E\u0432 \u0431\u0443 \u0438 \u043D\u043E\u0432\u044B\u0435. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u043A\u0430\u0442\u0430\u043B\u043E\u0433 \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440 \u0441 \u0446\u0435\u043D\u0430\u043C\u0438 \u0438 \u0444\u043E\u0442\u043E",
      description_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u0437\u0430\u043F\u0447\u0430\u0441\u0442\u0438\u043D\u0438 \u0434\u043B\u044F \u043F\u0440\u0438\u0447\u0435\u043F\u0430 " + p.inCity + ". \u0423 \u043F\u0440\u043E\u0434\u0430\u0436\u0443 \u0437\u0430\u043F\u0447\u0430\u0441\u0442\u0438\u043D\u0438 \u0434\u043B\u044F \u043B\u0435\u0433\u043A\u043E\u0432\u0438\u0445 \u043F\u0440\u0438\u0447\u0435\u043F\u0456\u0432 \u0431\u0443 \u0456 \u043D\u043E\u0432\u0456. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u043A\u0430\u0442\u0430\u043B\u043E\u0433 \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440 \u0437 \u0446\u0456\u043D\u0430\u043C\u0438 \u0456 \u0444\u043E\u0442\u043E"
    };
  }
});
// CONCATENATED MODULE: ./src/shared/helpers/seoTextFinder/seoTemplates/zapchasti/pritsepy/index.js


var pritsepy_PRITSEPY = {
  city: zapchasti_pritsepy_templates_defaultExport.city
};
// CONCATENATED MODULE: ./src/shared/helpers/seoTextFinder/seoTemplates/zapchasti/tritsikl/templates.js
/* harmony default export */ var zapchasti_tritsikl_templates_defaultExport = ({
    makeModel: function makeModel(data) {
        return {
            header: "\u0417\u0430\u043F\u0447\u0430\u0441\u0442\u0438 \u043D\u0430 \u0442\u0440\u0438\u0446\u0438\u043A\u043B " + data.make + " " + data.model,
            header_uk: "\u0417\u0430\u043F\u0447\u0430\u0441\u0442\u0438\u043D\u0438 \u043D\u0430 \u0442\u0440\u0438\u0446\u0438\u043A\u043B " + data.make + " " + data.model
        };
    }
});
// CONCATENATED MODULE: ./src/shared/helpers/seoTextFinder/seoTemplates/zapchasti/tritsikl/index.js


var tritsikl_TRITSIKL = {
    make_model: zapchasti_tritsikl_templates_defaultExport.makeModel
};
// CONCATENATED MODULE: ./src/shared/helpers/seoTextFinder/seoTemplates/zapchasti/vodnyi-transport/templates.js
/* harmony default export */ var zapchasti_vodnyi_transport_templates_defaultExport = ({
  city: function city(data, p) {
    return {
      header: "\u0417\u0430\u043F\u0447\u0430\u0441\u0442\u0438 \u043D\u0430 \u0432\u043E\u0434\u043D\u044B\u0439 \u0442\u0440\u0430\u043D\u0441\u043F\u043E\u0440\u0442 " + p.t(data.city),
      header_uk: "\u0417\u0430\u043F\u0447\u0430\u0441\u0442\u0438\u043D\u0438 \u043D\u0430 \u0432\u043E\u0434\u043D\u0438\u0439 \u0442\u0440\u0430\u043D\u0441\u043F\u043E\u0440\u0442 " + p.t(data.city),

      title: "\u0417\u0430\u043F\u0447\u0430\u0441\u0442\u0438 \u043D\u0430 \u0432\u043E\u0434\u043D\u044B\u0439 \u0442\u0440\u0430\u043D\u0441\u043F\u043E\u0440\u0442 \u043A\u0443\u043F\u0438\u0442\u044C " + p.inCity + " - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      title_uk: "\u0417\u0430\u043F\u0447\u0430\u0441\u0442\u0438\u043D\u0438 \u043D\u0430 \u0432\u043E\u0434\u043D\u0438\u0439 \u0442\u0440\u0430\u043D\u0441\u043F\u043E\u0440\u0442 \u043A\u0443\u043F\u0438\u0442\u0438 " + p.inCity + " - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",

      description: "\u041A\u0443\u043F\u0438\u0442\u044C \u0437\u0430\u043F\u0447\u0430\u0441\u0442\u0438 \u043D\u0430 \u0432\u043E\u0434\u043D\u044B\u0439 \u0442\u0440\u0430\u043D\u0441\u043F\u043E\u0440\u0442 " + p.inCity + ". \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u043A\u0430\u0442\u0430\u043B\u043E\u0433 \u0441\u0443\u0434\u043E\u0432\u044B\u0445 \u0437\u0430\u043F\u0447\u0430\u0441\u0442\u0435\u0439 \u0431\u0443 \u0438 \u043D\u043E\u0432\u044B\u0445 \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u041E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u044F \u0441 \u0446\u0435\u043D\u0430\u043C\u0438 \u0438 \u0444\u043E\u0442\u043E. \u041F\u0440\u043E\u0434\u0430\u0436\u0430 \u043E\u0442 \u043E\u0444\u0438\u0446\u0438\u0430\u043B\u044C\u043D\u044B\u0445 \u0434\u0438\u043B\u043B\u0435\u0440\u043E\u0432 \u0438 \u0447\u0430\u0441\u0442\u043D\u044B\u0445 \u043B\u0438\u0446",
      description_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u0437\u0430\u043F\u0447\u0430\u0441\u0442\u0438\u043D\u0438 \u043D\u0430 \u0432\u043E\u0434\u043D\u0438\u0439 \u0442\u0440\u0430\u043D\u0441\u043F\u043E\u0440\u0442 " + p.inCity + ". \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u043A\u0430\u0442\u0430\u043B\u043E\u0433 \u0441\u0443\u0434\u043D\u043E\u0432\u0438\u0445 \u0437\u0430\u043F\u0447\u0430\u0441\u0442\u0438\u043D \u0431\u0443 \u0442\u0430 \u043D\u043E\u0432\u0438\u0445 \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u041E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u043D\u044F \u0437 \u0446\u0456\u043D\u0430\u043C\u0438 \u0456 \u0444\u043E\u0442\u043E. \u041F\u0440\u043E\u0434\u0430\u0436 \u0432\u0456\u0434 \u043E\u0444\u0456\u0446\u0456\u0439\u043D\u0438\u0445 \u0434\u0438\u043B\u043B\u0435\u0440\u0456\u0432 \u0456 \u043F\u0440\u0438\u0432\u0430\u0442\u043D\u0438\u0445 \u043E\u0441\u0456\u0431"
    };
  }
});
// CONCATENATED MODULE: ./src/shared/helpers/seoTextFinder/seoTemplates/zapchasti/vodnyi-transport/index.js


var vodnyi_transport_VODNYI_TRANSPORT = {
  city: zapchasti_vodnyi_transport_templates_defaultExport.city
};
// CONCATENATED MODULE: ./src/shared/helpers/seoTextFinder/seoTemplates/commercial/gruzovye/templates.js
var upperCaseFirst = function upperCaseFirst(str) {
  var safeStr = str || '';
  return safeStr.charAt(0).toUpperCase() + safeStr.substr(1);
};

var templates_path = {
  transporttype: function transporttype(data) {
    return {
      header: '\u041F\u0440\u043E\u0434\u0430\u0436\u0430 ' + data.transportTypePluralGenitive + ' \u0432 \u0423\u043A\u0440\u0430\u0438\u043D\u0435',
      header_uk: '\u041F\u0440\u043E\u0434\u0430\u0436 ' + data.transportTypePluralGenitive + ' \u0432 \u0423\u043A\u0440\u0430\u0457\u043D\u0456',

      title: upperCaseFirst(data.transportTypePlural) + ': \u043A\u0443\u043F\u0438\u0442\u044C ' + data.transportTitle + ' \u0432 \u0423\u043A\u0440\u0430\u0438\u043D\u0435 \u0431\u0443 \u0438\u043B\u0438 \u043D\u043E\u0432\u044B\u0439 - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',
      title_uk: upperCaseFirst(data.transportTypePlural) + ': \u043A\u0443\u043F\u0438\u0442\u0438 ' + data.transportTitle + ' \u0432 \u0423\u043A\u0440\u0430\u0457\u043D\u0456 \u0431\u0443 \u0430\u0431\u043E \u043D\u043E\u0432\u0438\u0439 - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',

      description: '\u041A\u0443\u043F\u0438\u0442\u044C ' + data.transportTitle + ' \u0441 \u043F\u0440\u043E\u0431\u0435\u0433\u043E\u043C \u0438\u043B\u0438 \u043D\u043E\u0432\u044B\u0439 \u2B50 \u0426\u0435\u043D\u044B \u043D\u0430 ' + data.transportTypePlural + ', \u0445\u0430\u0440\u0430\u043A\u0442\u0435\u0440\u0438\u0441\u0442\u0438\u043A\u0438, \u0444\u043E\u0442\u043E \u0438 \u0431\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043A\u043E\u043C\u043C\u0435\u0440\u0447\u0435\u0441\u043A\u043E\u0433\u043E \u0442\u0440\u0430\u043D\u0441\u043F\u043E\u0440\u0442\u0430 \u043D\u0430 \u0441\u0430\u0439\u0442\u0435 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',
      description_uk: '\u041A\u0443\u043F\u0438\u0442\u0438 ' + data.transportTitle + ' \u0437 \u043F\u0440\u043E\u0431\u0456\u0433\u043E\u043C \u0430\u0431\u043E \u043D\u043E\u0432\u0438\u0439 \u2B50 \u0426\u0456\u043D\u0438 \u043D\u0430 ' + data.transportTypePlural + ', \u0445\u0430\u0440\u0430\u043A\u0442\u0435\u0440\u0438\u0441\u0442\u0438\u043A\u0438, \u0444\u043E\u0442\u043E \u0442\u0430 \u0432\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043A\u043E\u043C\u0435\u0440\u0446\u0456\u0439\u043D\u043E\u0433\u043E \u0442\u0440\u0430\u043D\u0441\u043F\u043E\u0440\u0442\u0443 \u043D\u0430 \u0441\u0430\u0439\u0442\u0456 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440'
    };
  },

  make_transporttype: function make_transporttype(data) {
    return {
      header: upperCaseFirst(data.transportTypePlural) + ' ' + data.make + ' \u0432 \u0423\u043A\u0440\u0430\u0438\u043D\u0435',
      header_uk: upperCaseFirst(data.transportTypePlural) + ' ' + data.make + ' \u0432 \u0423\u043A\u0440\u0430\u0457\u043D\u0456',

      title: upperCaseFirst(data.transportTitle) + ' ' + data.makeTranslit + ' \u0432 \u0423\u043A\u0440\u0430\u0438\u043D\u0435, \u043A\u0443\u043F\u0438\u0442\u044C ' + data.transportTypePlural + ' ' + data.make + ' \u0431\u0443 \u0438\u043B\u0438 \u043D\u043E\u0432\u044B\u0435 - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',
      title_uk: upperCaseFirst(data.transportTitle) + ' ' + data.makeTranslit + ' \u0432 \u0423\u043A\u0440\u0430\u0457\u043D\u0456, \u043A\u0443\u043F\u0438\u0442\u0438 ' + data.transportTypePlural + ' ' + data.make + ' \u0431\u0443 \u0430\u0431\u043E \u043D\u043E\u0432\u0456 - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',

      description: '\u041A\u0443\u043F\u0438\u0442\u044C ' + data.transportTypePlural + ' ' + data.make + ' \u043D\u043E\u0432\u044B\u0435 \u0438\u043B\u0438 \u0441 \u043F\u0440\u043E\u0431\u0435\u0433\u043E\u043C \u2B50 \u0426\u0435\u043D\u044B \u043D\u0430 ' + data.transportTypePlural + ', \u0445\u0430\u0440\u0430\u043A\u0442\u0435\u0440\u0438\u0441\u0442\u0438\u043A\u0438, \u0444\u043E\u0442\u043E \u0438 \u0431\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043A\u043E\u043C\u043C\u0435\u0440\u0447\u0435\u0441\u043A\u043E\u0433\u043E \u0442\u0440\u0430\u043D\u0441\u043F\u043E\u0440\u0442\u0430 \u043D\u0430 \u0441\u0430\u0439\u0442\u0435 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',
      description_uk: '\u041A\u0443\u043F\u0438\u0442\u0438 ' + data.transportTypePlural + ' ' + data.make + ' \u043D\u043E\u0432\u0456 \u0430\u0431\u043E \u0437 \u043F\u0440\u043E\u0431\u0456\u0433\u043E\u043C \u2B50 \u0426\u0456\u043D\u0438 \u043D\u0430 ' + data.transportTypePlural + ', \u0445\u0430\u0440\u0430\u043A\u0442\u0435\u0440\u0438\u0441\u0442\u0438\u043A\u0438, \u0444\u043E\u0442\u043E \u0442\u0430 \u0432\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043A\u043E\u043C\u0435\u0440\u0446\u0456\u0439\u043D\u043E\u0433\u043E \u0442\u0440\u0430\u043D\u0441\u043F\u043E\u0440\u0442\u0443 \u043D\u0430 \u0441\u0430\u0439\u0442\u0456 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440'
    };
  },

  make_model_transporttype: function make_model_transporttype(data) {
    return {
      header: '\u041F\u0440\u043E\u0434\u0430\u0436\u0430 ' + data.make + ' ' + data.model,
      header_uk: '\u041F\u0440\u043E\u0434\u0430\u0436 ' + data.make + ' ' + data.model,

      title: '\u041F\u0440\u043E\u0434\u0430\u0436\u0430 ' + data.makeTranslit + ' ' + data.modelTranslit + ' \u0431\u0443 \u0438 \u043D\u043E\u0432\u044B\u0445: \u043A\u0443\u043F\u0438\u0442\u044C ' + data.make + ' ' + data.model + ' \u0432 \u0423\u043A\u0440\u0430\u0438\u043D\u0435. \u0426\u0435\u043D\u0430 \u043D\u0430 \u0433\u0440\u0443\u0437\u043E\u0432\u0438\u043A\u0438, \u0444\u043E\u0442\u043E - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',
      title_uk: '\u041F\u0440\u043E\u0434\u0430\u0436 ' + data.makeTranslit + ' ' + data.modelTranslit + ' \u0431\u0443 \u0442\u0430 \u043D\u043E\u0432\u0438\u0445: \u043A\u0443\u043F\u0438\u0442\u0438 ' + data.make + ' ' + data.model + ' \u0432 \u0423\u043A\u0440\u0430\u0457\u043D\u0456. \u0426\u0456\u043D\u0430 \u043D\u0430 \u0432\u0430\u043D\u0442\u0430\u0436\u0456\u0432\u043A\u0438, \u0444\u043E\u0442\u043E - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',

      description: '\u041A\u0443\u043F\u0438\u0442\u044C ' + data.make + ' ' + data.model + ' \u043D\u043E\u0432\u044B\u0435 \u0438 \u0441 \u043F\u0440\u043E\u0431\u0435\u0433\u043E\u043C \uD83D\uDE8C \u0432 \u0423\u043A\u0440\u0430\u0438\u043D\u0435 \u2B50 \u0423\u0434\u043E\u0431\u043D\u044B\u0439 \u043F\u043E\u0438\u0441\u043A \u043F\u043E \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u044F\u043C \u043F\u043E\u043C\u043E\u0436\u0435\u0442 \u0412\u0430\u043C \u043A\u0443\u043F\u0438\u0442\u044C \u0433\u0440\u0443\u0437\u043E\u0432\u0438\u043A\u0438 ' + data.makeTranslit + ' ' + data.modelTranslit + ' \u043F\u043E \u0432\u044B\u0433\u043E\u0434\u043D\u043E\u0439 \u0446\u0435\u043D\u0435 \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440\u0435',
      description_uk: '\u041A\u0443\u043F\u0438\u0442\u0438 ' + data.make + ' ' + data.model + ' \u043D\u043E\u0432\u0456 \u0442\u0430 \u0437 \u043F\u0440\u043E\u0431\u0456\u0433\u043E\u043C \uD83D\uDE8C \u0432 \u0423\u043A\u0440\u0430\u0457\u043D\u0456 \u2B50 \u0417\u0440\u0443\u0447\u043D\u0438\u0439 \u043F\u043E\u0448\u0443\u043A \u043F\u043E \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u043D\u044F\u0445 \u0434\u043E\u043F\u043E\u043C\u043E\u0436\u0435 \u0412\u0430\u043C \u043A\u0443\u043F\u0438\u0442\u0438 \u0432\u0430\u043D\u0442\u0430\u0436\u0456\u0432\u043A\u0438 ' + data.makeTranslit + ' ' + data.modelTranslit + ' \u0437\u0430 \u0432\u0438\u0433\u0456\u0434\u043D\u043E\u044E \u0446\u0456\u043D\u043E\u044E \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440\u0456'
    };
  }
};

/* harmony default export */ var commercial_gruzovye_templates_defaultExport = (templates_path);
// CONCATENATED MODULE: ./src/shared/helpers/seoTextFinder/seoTemplates/commercial/gruzovye/index.js


var COMMERCIAL_GRUZOVYE = {
  transporttype: commercial_gruzovye_templates_defaultExport.transporttype,
  make_transporttype: commercial_gruzovye_templates_defaultExport.make_transporttype,
  make_model_transporttype: commercial_gruzovye_templates_defaultExport.make_model_transporttype
};
// CONCATENATED MODULE: ./src/shared/helpers/seoTextFinder/seoTemplates/index.js








































/* harmony default export */ var seoTemplates_defaultExport = ({
  AVTO: AVTO,
  MOTO: MOTO,
  MOTOTSIKL: MOTOTSIKL,
  SKUTER: SKUTER,
  KVADROTSIKL: KVADROTSIKL,
  MOPED: MOPED,
  BAGGI: BAGGI,
  TRITSIKL: TRITSIKL,

  AVTOSALONY_AVTO: avto_AVTO,
  AVTOSALONY_GRUZOVYE: GRUZOVYE,
  AVTOSALONY_AVTOBUS: AVTOBUS,
  AVTOSALONY_VODNYI_TRANSPORT: VODNYI_TRANSPORT,
  AVTOSALONY_MOTOTSIKL: mototsikl_MOTOTSIKL,
  AVTOSALONY_PRITSEPY: PRITSEPY,
  AVTOSALONY_SPETSTEHNIKA: SPETSTEHNIKA,

  ZAPCHASTI_AVTO: AUTO,
  ZAPCHASTI_MOTO: moto_MOTO,
  ZAPCHASTI_AVTOBUS: avtobus_AVTOBUS,
  ZAPCHASTI_PRITSEPY: pritsepy_PRITSEPY,
  ZAPCHASTI_GRUZOVYE: gruzovye_GRUZOVYE,
  ZAPCHASTI_TRITSIKL: tritsikl_TRITSIKL,
  ZAPCHASTI_SPETSTEHNIKA: spetstehnika_SPETSTEHNIKA,
  ZAPCHASTI_VODNYI_TRANSPORT: vodnyi_transport_VODNYI_TRANSPORT,

  ZAPCHASTI_AVTO_DVIGATEL_MAHOVIK: AVTO_DVIGATEL_MAHOVIK,

  ZAPCHASTI_AVTO_DVIGATEL_PATRUBKI: AVTO_DVIGATEL_PATRUBKI,
  ZAPCHASTI_AVTO_ELEKTRIKA__I__ELEKTRONIKA_DATCHIKI: AVTO_ELEKTRIKA__I__ELEKTRONIKA_DATCHIKI,
  ZAPCHASTI_AVTO_ELEKTRIKA__I__ELEKTRONIKA_DATCHIKI__ABS: AVTO_ELEKTRIKA__I__ELEKTRONIKA_DATCHIKI__ABS,
  ZAPCHASTI_AVTO_DVIGATEL_KLAPANI__EGR: AVTO_DVIGATEL_KLAPANI__EGR,

  ZAPCHASTI_SKUTER: skuter_SKUTER,
  ZAPCHASTI_MOTOTSIKL: zapchasti_mototsikl_MOTOTSIKL,
  ZAPCHASTI_KVADROTSIKL: kvadrotsikl_KVADROTSIKL,
  ZAPCHASTI_MOPED: moped_MOPED,

  COMMERCIAL_GRUZOVYE: COMMERCIAL_GRUZOVYE
});
// CONCATENATED MODULE: ./src/shared/helpers/seoTextFinder/index.js
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return seoTextFinder_getSeoDataByParams; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_shared_modules_subjectiveText_allText__ = __webpack_require__(309);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__seoDataFinder__ = __webpack_require__(1252);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/* eslint-disable no-param-reassign */



/* import { AVTO } from './seoTemplates/search/avto';
import { AVTOSALONY } from './avtosalony'; */

var avaliableTransports = {
  легковые: 'AVTO',
  'водный транспорт': 'VODNYI_TRANSPORT',
  автобусы: 'AVTOBUS',
  грузовые: 'GRUZOVYE',
  мотоциклы: 'MOTOTSIKL',
  прицепы: 'PRITSEPY',
  спецтехника: 'SPETSTEHNIKA',

  мототранспорт: 'MOTO',
  грузовики: 'GRUZOVYE',

  // UK
  легкові: 'AVTO',
  'водний транспорт': 'VODNYI_TRANSPORT',
  автобуси: 'AVTOBUS',
  вантажні: 'GRUZOVYE',
  мотоцикли: 'MOTOTSIKL',
  причепи: 'PRITSEPY',
  спецтехніка: 'SPETSTEHNIKA',

  avto: 'AVTO',
  moto: 'MOTO',

  'vodnyi-transport': 'VODNYI_TRANSPORT',
  avtobus: 'AVTOBUS',
  gruzovye: 'GRUZOVYE',
  mototsikl: 'MOTOTSIKL',
  pritsepy: 'PRITSEPY',
  spetstehnika: 'SPETSTEHNIKA',

  kvadrotsikl: 'KVADROTSIKL',
  квадроцикл: 'KVADROTSIKL',

  moped: 'MOPED',
  мопед: 'MOPED',

  skuter: 'SKUTER',
  скутер: 'SKUTER',

  baggi: 'BAGGI',
  багги: 'BAGGI',
  баггі: 'BAGGI',

  трицикл: 'TRITSIKL',
  tritsikl: 'TRITSIKL'
};

var avaliableCategories = {
  avtosalony: 'AVTOSALONY',
  zapchasti: 'ZAPCHASTI',
  commercial: 'COMMERCIAL'
};

var avaliablePartTypes = {
  маховик: 'MAHOVIK',
  // патрубок: 'PATRUBOK',
  патрубки: 'PATRUBKI',
  датчики: 'DATCHIKI',
  'датчик abs': 'DATCHIKI__ABS',
  'клапан egr': 'KLAPANI__EGR'
};

var avaliableRubrics = {
  двигатель: 'DVIGATEL',
  Двигун: 'DVIGATEL',
  'электрика и электроника': 'ELEKTRIKA__I__ELEKTRONIKA'
};

// ZAPCHASTI_AVTO_DVIGATEL_PATRUBOK,
// ZAPCHASTI_AVTO_ELEKTRIKA__I__ELEKTRONIKA_DATCHIKI,
// ZAPCHASTI_AVTO_ELEKTRIKA__I__ELEKTRONIKA_DATCHIKI__ABS,
// ZAPCHASTI_AVTO_DVIGATEL_KLAPAN__EGR,

function getTransport(params) {
  // const key = params.transport ? params.transport.toLowerCase() : '';
  var key = params.transport ? params.transport.toLowerCase() : params.transportType ? params.transportType.toLowerCase() : '';
  if (!key || !avaliableTransports[key]) return avaliableTransports.avto;
  return avaliableTransports[key];
}

function getRubric(params) {
  var key = params.rubric ? params.rubric.toLowerCase().replace('-', '__') : '';
  if (!key || !avaliableRubrics[key]) return '';
  return avaliableRubrics[key];
}

function getPartType(params) {
  var key = params.partType ? params.partType.toLowerCase().replace('-', '__') : '';
  var keyUk = params.partTypeUk ? params.partTypeUk.toLowerCase().replace('-', '__') : '';
  if (!key || !avaliablePartTypes[key.toLowerCase()]) return '';
  return avaliablePartTypes[keyUk] || avaliablePartTypes[key];
}

function makePath(params, category) {
  var transportKey = getTransport(params);
  if (!category) return transportKey;

  var partType = getPartType(params);
  var rubric = getRubric(params);
  var path = avaliableCategories[category] + '_' + transportKey;
  return '' + path + (rubric ? '_' + rubric : '') + (partType ? '_' + partType : '');
}

/**
 * Get SEO texts by input params.
 * @param {object} params 
 * @param {object} path 
 * @param {function} t 
 * @returns {object} {header: 'h1 text', title: 'meta tag title', description: 'meta tag '}
 */
var seoTextFinder_getSeoDataByParams = function getSeoDataByParams(params, t, category) {
  var city = '';
  if (_typeof(params.city) === 'object' && params.city.is_city) {
    city = params.city.title || '';
  } else if (params.location && typeof params.location === 'string' && params.location !== (params.country && params.country.title)) {
    city = __WEBPACK_IMPORTED_MODULE_0_shared_modules_subjectiveText_allText__["g" /* sity */][params.location] ? params.location : '';
  }

  var path = makePath(params, category);
  var seoDataLinks = seoTemplates_defaultExport[path];

  if (!seoDataLinks) {
    return {};
  }

  // console.log(params);
  var paramsToSeo = _extends({}, params, { city: city });
  return __WEBPACK_IMPORTED_MODULE_2__seoDataFinder__["b" /* paramsToSeoData */](paramsToSeo, seoDataLinks, t);
};

/***/ }),

/***/ 1255:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var RegexpInput = function (_React$Component) {
  _inherits(RegexpInput, _React$Component);

  function RegexpInput() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, RegexpInput);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = RegexpInput.__proto__ || Object.getPrototypeOf(RegexpInput)).call.apply(_ref, [this].concat(args))), _this), _this.handleChange = function (e) {
      var value = e.target.value;
      var _this$props = _this.props,
          pattern = _this$props.pattern,
          onChange = _this$props.onChange;


      if (value.match(pattern) || value === '') {
        onChange(value);
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(RegexpInput, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          onChange = _props.onChange,
          inputRef = _props.inputRef,
          type = _props.type,
          props = _objectWithoutProperties(_props, ['onChange', 'inputRef', 'type']);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', _extends({ type: type, onChange: this.handleChange, ref: inputRef }, props));
    }
  }]);

  return RegexpInput;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

RegexpInput.defaultProps = {
  pattern: '',
  value: undefined,
  inputRef: undefined,
  onChange: function onChange() {},
  type: 'text'
};


/* harmony default export */ __webpack_exports__["a"] = (RegexpInput);

/***/ }),

/***/ 1256:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(1240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shared_components_Modal__ = __webpack_require__(1250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ModalContainer_css__ = __webpack_require__(1301);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ModalContainer_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__ModalContainer_css__);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();








var isClient = true;

function ModalContainer(props) {
  var children = props.children,
      onClose = props.onClose,
      isOpen = props.isOpen,
      modalCN = props.modalCN;

  if (!isClient) return null;
  return isOpen && _jsx(__WEBPACK_IMPORTED_MODULE_4_shared_components_Modal__["a" /* default */], {}, void 0, _jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_5__ModalContainer_css___default.a.root
  }, void 0, _jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_5__ModalContainer_css___default.a.background,
    onClick: onClose
  }), _jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_3_classnames___default.a(__WEBPACK_IMPORTED_MODULE_5__ModalContainer_css___default.a.content, modalCN || __WEBPACK_IMPORTED_MODULE_5__ModalContainer_css___default.a.contentParams)
  }, void 0, children)));
}

ModalContainer.defaultProps = {
  isOpen: false,
  modalCN: '',
  onClose: undefined
};


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_5__ModalContainer_css___default.a)(ModalContainer));

/***/ }),

/***/ 1257:
/***/ (function(module, exports) {

module.exports = ["dvigatel","kuzov","otoplenie-i-konditsionirovanie","pritsepnoe-oborudovanie","razborka","rulevoe-upravlenie","salon","toplivnaya-sistema","tormoznaya-sistema","hodovaya"]

/***/ }),

/***/ 1258:
/***/ (function(module, exports) {

module.exports = ["dopolnitelnoe-oborudovanie","optika-steklo-zerkala","ochistiteli-stekla-i-far","sistema-bezopasnosti","sistema-ohlazhdeniya","transmissiya","filtry","shiny-diski","elektrika-i-elektronika"]

/***/ }),

/***/ 1259:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_actions_user__ = __webpack_require__(476);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shared_helpers_common__ = __webpack_require__(184);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var withBalance = function withBalance(forceUpdate) {
  return function (WrappedComponent) {
    var _class, _temp;

    var Component = (_temp = _class = function (_React$Component) {
      _inherits(Component, _React$Component);

      function Component() {
        _classCallCheck(this, Component);

        return _possibleConstructorReturn(this, (Component.__proto__ || Object.getPrototypeOf(Component)).apply(this, arguments));
      }

      _createClass(Component, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
          if (forceUpdate || this.props.balance === null) {
            this.props.fetchBalance();
          }
        }
      }, {
        key: 'render',
        value: function render() {
          var _props = this.props,
              __ = _props.fetchBalance,
              props = _objectWithoutProperties(_props, ['fetchBalance']);

          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(WrappedComponent, props);
        }
      }]);

      return Component;
    }(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component), _class.displayName = 'withBalance(' + __WEBPACK_IMPORTED_MODULE_4_shared_helpers_common__["e" /* getDisplayName */](WrappedComponent) + ')', _class.defaultProps = {
      balance: null
    }, _temp);

    var mapStateToProps = function mapStateToProps(_ref) {
      var user = _ref.user;
      return {
        balance: user.balance.amount,
        isFetching: user.balance.isFetching
      };
    };
    var mapDispatchToProps = {
      fetchBalance: __WEBPACK_IMPORTED_MODULE_3_shared_actions_user__["g" /* fetchBalance */]
    };

    return __WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */](mapStateToProps, mapDispatchToProps)(Component);
  };
};

/* harmony default export */ __webpack_exports__["a"] = (withBalance);

/***/ }),

/***/ 1260:
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__(319);
var TAG = __webpack_require__(86)('toStringTag');
// ES3 wrong here
var ARG = cof(function () {
  return arguments;
}()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function tryGet(it, key) {
  try {
    return it[key];
  } catch (e) {/* empty */}
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
  // @@toStringTag case
  : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
  // builtinTag case
  : ARG ? cof(O)
  // ES3 arguments fallback
  : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};

/***/ }),

/***/ 1261:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  CITY: 'city',
  COUNTRY: 'country'
});

/***/ }),

/***/ 1262:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(1240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_redux__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_shared_actions_globals__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_shared_helpers_locale__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_shared_helpers_routes__ = __webpack_require__(488);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_shared_components_Link_Link__ = __webpack_require__(1241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_shared_constants_locationTypes__ = __webpack_require__(1261);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_shared_constants_json_countries_json__ = __webpack_require__(310);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_shared_constants_json_countries_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_shared_constants_json_countries_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_shared_constants_gtmEvents__ = __webpack_require__(1243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_shared_hocs_withTranslate__ = __webpack_require__(1242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__NavigationLink_css__ = __webpack_require__(1346);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__NavigationLink_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__NavigationLink_css__);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

















var NavigationLink = function (_React$Component) {
  _inherits(NavigationLink, _React$Component);

  function NavigationLink() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, NavigationLink);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = NavigationLink.__proto__ || Object.getPrototypeOf(NavigationLink)).call.apply(_ref, [this].concat(args))), _this), _this.handleClick = function (e) {
      var _this$props = _this.props,
          link = _this$props.link,
          eventPrefix = _this$props.eventPrefix,
          onClick = _this$props.onClick;

      onClick(e);
      if (!eventPrefix) return;

      var route = link.slug || link.route;
      var pattern = new RegExp('[/]{2,}', 'g');
      var slug = ('' + eventPrefix + route).replace(pattern, '/');
      var event = __WEBPACK_IMPORTED_MODULE_12_shared_constants_gtmEvents__["a" /* EVENTS */].NAVIGATION_LINK[slug];
      if (event) _this.props.setDataLayer(event);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(NavigationLink, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          location = _props.location,
          including = _props.including,
          locationType = _props.locationType,
          currentRoute = _props.currentRoute,
          link = _props.link,
          className = _props.className,
          activeClassName = _props.activeClassName,
          t = _props.t;
      var route = link.route,
          injectLocations = link.injectLocations,
          title = link.title,
          _link$count = link.count,
          count = _link$count === undefined ? '' : _link$count;


      var isActive = false;
      if (currentRoute) {
        isActive = including ? currentRoute.includes(((link.slug || link.route) + '/').replace(/\/\//g, '/')) : currentRoute === ((link.slug || link.route) + '/').replace(/\/\//g, '/');
      }

      return isActive ? _jsx('span', {
        className: __WEBPACK_IMPORTED_MODULE_3_classnames___default.a(className, activeClassName)
      }, void 0, t(title), count && _jsx('span', {
        className: __WEBPACK_IMPORTED_MODULE_14__NavigationLink_css___default.a.count
      }, void 0, ' ', count)) : _jsx(__WEBPACK_IMPORTED_MODULE_9_shared_components_Link_Link__["a" /* default */], {
        onClick: this.handleClick,
        to: location && injectLocations && injectLocations.includes(locationType) && __WEBPACK_IMPORTED_MODULE_8_shared_helpers_routes__["b" /* isValidLeasingLocationRoute */](route, location.slug) ? __WEBPACK_IMPORTED_MODULE_7_shared_helpers_locale__["d" /* injectLocationIntoHref */](route, location.slug) : route,
        className: className
      }, void 0, t(title), count && _jsx('span', {
        className: __WEBPACK_IMPORTED_MODULE_14__NavigationLink_css___default.a.count
      }, void 0, ' ', count));
    }
  }]);

  return NavigationLink;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

NavigationLink.defaultProps = {
  currentRoute: null,
  location: null,
  shouldCalculateActiveState: true,
  including: false,
  className: '',
  activeClassName: '',
  onClick: function onClick() {},
  eventPrefix: ''
};


var mapStateToProps = function mapStateToProps(_ref2) {
  var globals = _ref2.globals;
  return {
    location: globals.location,
    locationType: __WEBPACK_IMPORTED_MODULE_11_shared_constants_json_countries_json___default.a.find(function (city) {
      return city.slug === (globals.location && globals.location.slug);
    }) ? __WEBPACK_IMPORTED_MODULE_10_shared_constants_locationTypes__["a" /* default */].COUNTRY : __WEBPACK_IMPORTED_MODULE_10_shared_constants_locationTypes__["a" /* default */].CITY
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    setDataLayer: __WEBPACK_IMPORTED_MODULE_5_redux__["b" /* bindActionCreators */](__WEBPACK_IMPORTED_MODULE_6_shared_actions_globals__["j" /* setDataLayer */], dispatch)
  };
};

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_4_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_14__NavigationLink_css___default.a)(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */](mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_13_shared_hocs_withTranslate__["a" /* withTranslate */](NavigationLink))));

/***/ }),

/***/ 1263:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

var _default = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

exports.default = _default;
module.exports = exports["default"];

/***/ }),

/***/ 1264:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.nameShape = undefined;
exports.transitionTimeout = transitionTimeout;

var _react = __webpack_require__(11);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1246);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function transitionTimeout(transitionType) {
  var timeoutPropName = 'transition' + transitionType + 'Timeout';
  var enabledPropName = 'transition' + transitionType;

  return function (props) {
    // If the transition is enabled
    if (props[enabledPropName]) {
      // If no timeout duration is provided
      if (props[timeoutPropName] == null) {
        return new Error(timeoutPropName + ' wasn\'t supplied to CSSTransitionGroup: ' + 'this can cause unreliable animations and won\'t be supported in ' + 'a future version of React. See ' + 'https://fb.me/react-animation-transition-group-timeout for more ' + 'information.');

        // If the duration isn't a number
      } else if (typeof props[timeoutPropName] !== 'number') {
        return new Error(timeoutPropName + ' must be a number (in milliseconds)');
      }
    }

    return null;
  };
}

var nameShape = exports.nameShape = _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
  enter: _propTypes2.default.string,
  leave: _propTypes2.default.string,
  active: _propTypes2.default.string
}), _propTypes2.default.shape({
  enter: _propTypes2.default.string,
  enterActive: _propTypes2.default.string,
  leave: _propTypes2.default.string,
  leaveActive: _propTypes2.default.string,
  appear: _propTypes2.default.string,
  appearActive: _propTypes2.default.string
})]);

/***/ }),

/***/ 1265:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "4c77a327.svg";

/***/ }),

/***/ 1266:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1375);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./Footer.css", function() {
        content = require("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./Footer.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 1267:
/***/ (function(module, exports) {

module.exports = "\"data:image/svg+xml,%3C?xml version='1.0' encoding='iso-8859-1'?%3E %3Csvg version='1.1' id='Capa_1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' width='792.033px' height='792.033px' viewBox='0 0 792.033 792.033' style='enable-background:new 0 0 792.033 792.033;' xml:space='preserve'%3E %3Cg%3E %3Cg id='_x38_'%3E %3Cg%3E %3Cpath d='M617.858,370.896L221.513,9.705c-13.006-12.94-34.099-12.94-47.105,0c-13.006,12.939-13.006,33.934,0,46.874 l372.447,339.438L174.441,735.454c-13.006,12.94-13.006,33.935,0,46.874s34.099,12.939,47.104,0l396.346-361.191 c6.932-6.898,9.904-16.043,9.441-25.087C627.763,386.972,624.792,377.828,617.858,370.896z'/%3E %3C/g%3E %3C/g%3E %3C/g%3E %3C/svg%3E\""

/***/ }),

/***/ 1268:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// CONCATENATED MODULE: ./src/shared/components/UI/InputText/InputText.js
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__UIStyle_css__ = __webpack_require__(1245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__UIStyle_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__UIStyle_css__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }






var InputText = function InputText(_ref) {
  var changeHandler = _ref.changeHandler,
      name = _ref.name,
      inputParams = _objectWithoutProperties(_ref, ['changeHandler', 'name']);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', _extends({
    className: __WEBPACK_IMPORTED_MODULE_3__UIStyle_css__["inputGeneral"],
    onChange: function onChange(e) {
      return changeHandler(name, e.target.value);
    }
  }, inputParams));
};

/* harmony default export */ var InputText_defaultExport = (__WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_3__UIStyle_css__)(InputText));
// CONCATENATED MODULE: ./src/shared/components/UI/InputBirthday/InputBirthday.js
/* harmony import */ var InputBirthday___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var InputBirthday___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(InputBirthday___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var InputBirthday___WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var InputBirthday___WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(InputBirthday___WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var InputBirthday___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var InputBirthday___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(InputBirthday___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_input_mask__ = __webpack_require__(479);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_input_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_input_mask__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__UIStyle_css__ = __webpack_require__(1245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__UIStyle_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__UIStyle_css__);
var InputBirthday__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function InputBirthday__objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }







var InputBirthday = function InputBirthday(_ref) {
  var changeHandler = _ref.changeHandler,
      name = _ref.name,
      mask = _ref.mask,
      placeholder = _ref.placeholder,
      inputParams = InputBirthday__objectWithoutProperties(_ref, ['changeHandler', 'name', 'mask', 'placeholder']);

  return InputBirthday___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_input_mask___default.a, InputBirthday__extends({
    className: __WEBPACK_IMPORTED_MODULE_4__UIStyle_css__["inputGeneral"],
    onChange: function onChange(e) {
      return changeHandler(name, e.target.value);
    },
    placeholder: placeholder,
    mask: mask,
    maskChar: ' '
  }, inputParams));
};

InputBirthday.defaultProps = {
  value: '',
  mask: '99/99/9999',
  placeholder: '01/01/1990'
};

/* harmony default export */ var InputBirthday_defaultExport = (InputBirthday___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_4__UIStyle_css__)(InputBirthday));
// CONCATENATED MODULE: ./src/shared/components/UI/ContactButton/ContactButton.js
/* harmony import */ var ContactButton___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var ContactButton___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(ContactButton___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var ContactButton___WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var ContactButton___WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(ContactButton___WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_intl__ = __webpack_require__(474);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shared_modules__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(1240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ContactButton_css__ = __webpack_require__(1310);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ContactButton_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__ContactButton_css__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }









var isMobile = "desktop" === 'mobile';

var _ref2 = _jsx(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */], {
  id: '\u041D\u0435\u0442 \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u043E\u0432'
});

var ShowedContacts = function ShowedContacts(_ref) {
  var phones = _ref.phones;
  return _jsx('div', {
    className: isMobile ? null : __WEBPACK_IMPORTED_MODULE_6__ContactButton_css___default.a.showedContainerDesktop
  }, void 0, phones.length ? phones.map(function (phone) {
    var nPhone = __WEBPACK_IMPORTED_MODULE_4_shared_modules__["j" /* phoneNormalize */](phone);
    return _jsx('a', {
      href: 'tel:' + nPhone,
      className: isMobile ? __WEBPACK_IMPORTED_MODULE_6__ContactButton_css___default.a.showedPhoneMobile : null
    }, phone, nPhone);
  }) : _ref2);
};

var _ref4 = _jsx(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */], {
  id: '\u041F\u043E\u043A\u0430\u0437\u0430\u0442\u044C \u0442\u0435\u043B\u0435\u0444\u043E\u043D'
});

var HidedContacts = function HidedContacts(_ref3) {
  var clickHandler = _ref3.clickHandler;
  return _jsx('button', {
    className: __WEBPACK_IMPORTED_MODULE_5_classnames___default.a(__WEBPACK_IMPORTED_MODULE_6__ContactButton_css___default.a.hided, _defineProperty({}, __WEBPACK_IMPORTED_MODULE_6__ContactButton_css___default.a.hidedMobile, isMobile)),
    onClick: clickHandler
  }, void 0, _jsx('span', {
    className: __WEBPACK_IMPORTED_MODULE_6__ContactButton_css___default.a.hidedContent
  }, void 0, _ref4, _jsx('span', {
    className: __WEBPACK_IMPORTED_MODULE_6__ContactButton_css___default.a.hiddenPhone
  }, void 0, _jsx('span', {
    className: __WEBPACK_IMPORTED_MODULE_6__ContactButton_css___default.a.Plus
  }, void 0, '+'), _jsx('span', {
    className: __WEBPACK_IMPORTED_MODULE_6__ContactButton_css___default.a.Dots
  }, void 0, '\u2022\u2022\u2022 \u2022\u2022 \u2022\u2022\u2022 \u2022\u2022 \u2022\u2022'))));
};

var ContactButton = function (_React$Component) {
  _inherits(ContactButton, _React$Component);

  function ContactButton() {
    var _ref5;

    var _temp, _this, _ret;

    _classCallCheck(this, ContactButton);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref5 = ContactButton.__proto__ || Object.getPrototypeOf(ContactButton)).call.apply(_ref5, [this].concat(args))), _this), _this.state = {
      isShowed: false,
      phones: []
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ContactButton, [{
    key: 'onClick',
    value: function onClick(e) {
      var _this2 = this;

      this.props.loadPhones(function (phones) {
        _this2.setState({ isShowed: true, phones: phones });
      });
      this.props.clickHandler(e);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var phonesState = this.props.phones.length ? this.props.phones : this.state.phones;
      var phones = phonesState.map(function (phone) {
        return phone.number ? phone.number : phone;
      });
      return _jsx(ContactButton___WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment, {}, void 0, this.state.isShowed ? _jsx(ShowedContacts, {
        phones: phones
      }) : _jsx(HidedContacts, {
        clickHandler: function clickHandler(e) {
          return _this3.onClick(e);
        }
      }));
    }
  }]);

  return ContactButton;
}(ContactButton___WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

ContactButton.defaultProps = {
  phones: [],
  clickHandler: function clickHandler() {},
  loadPhones: function loadPhones(cb) {
    return cb([]);
  }
};


ShowedContacts.defaultProps = {
  phones: []
};

HidedContacts.defaultProps = {
  clickHandler: function clickHandler() {}
};

/* harmony default export */ var ContactButton_defaultExport = (__WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_6__ContactButton_css___default.a)(ContactButton));
// CONCATENATED MODULE: ./src/shared/components/UI/InputPhoneNumber/InputPhoneNumber.js
/* harmony import */ var InputPhoneNumber___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var InputPhoneNumber___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(InputPhoneNumber___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var InputPhoneNumber___WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var InputPhoneNumber___WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(InputPhoneNumber___WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var InputPhoneNumber___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var InputPhoneNumber___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(InputPhoneNumber___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var InputPhoneNumber___WEBPACK_IMPORTED_MODULE_3_react_input_mask__ = __webpack_require__(479);
/* harmony import */ var InputPhoneNumber___WEBPACK_IMPORTED_MODULE_3_react_input_mask___default = __webpack_require__.n(InputPhoneNumber___WEBPACK_IMPORTED_MODULE_3_react_input_mask__);
/* harmony import */ var InputPhoneNumber___WEBPACK_IMPORTED_MODULE_4__UIStyle_css__ = __webpack_require__(1245);
/* harmony import */ var InputPhoneNumber___WEBPACK_IMPORTED_MODULE_4__UIStyle_css___default = __webpack_require__.n(InputPhoneNumber___WEBPACK_IMPORTED_MODULE_4__UIStyle_css__);
var InputPhoneNumber__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function InputPhoneNumber__objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }







var InputPhoneNumber = function InputPhoneNumber(_ref) {
  var changeHandler = _ref.changeHandler,
      name = _ref.name,
      mask = _ref.mask,
      placeholder = _ref.placeholder,
      inputParams = InputPhoneNumber__objectWithoutProperties(_ref, ['changeHandler', 'name', 'mask', 'placeholder']);

  return InputPhoneNumber___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(InputPhoneNumber___WEBPACK_IMPORTED_MODULE_3_react_input_mask___default.a, InputPhoneNumber__extends({
    className: InputPhoneNumber___WEBPACK_IMPORTED_MODULE_4__UIStyle_css__["inputGeneral"],
    onChange: function onChange(e) {
      return changeHandler(name, e.target.value);
    }
  }, inputParams, {
    placeholder: placeholder,
    mask: mask,
    maskChar: ' ',
    type: 'tel'
  }));
};

InputPhoneNumber.defaultProps = {
  value: '',
  mask: '+3\\8 \\099 999 99 99',
  placeholder: '+38 (0**) *** ** **'
};

/* harmony default export */ var InputPhoneNumber_defaultExport = (InputPhoneNumber___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default.a(InputPhoneNumber___WEBPACK_IMPORTED_MODULE_4__UIStyle_css__)(InputPhoneNumber));
// CONCATENATED MODULE: ./src/shared/components/UI/CheckBox/CheckBox.js
/* harmony import */ var CheckBox___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var CheckBox___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(CheckBox___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var CheckBox___WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var CheckBox___WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(CheckBox___WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var CheckBox___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var CheckBox___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(CheckBox___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_intl__ = __webpack_require__(474);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__CheckBox_css__ = __webpack_require__(1312);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__CheckBox_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__CheckBox_css__);
var CheckBox__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var CheckBox__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

function CheckBox__objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }







var CheckBox = function CheckBox(_ref) {
  var changeHandler = _ref.changeHandler,
      name = _ref.name,
      text = _ref.text,
      inputParams = CheckBox__objectWithoutProperties(_ref, ['changeHandler', 'name', 'text']);

  return CheckBox__jsx('label', {
    className: __WEBPACK_IMPORTED_MODULE_4__CheckBox_css___default.a.checkbox
  }, void 0, CheckBox___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', CheckBox__extends({ type: 'checkbox', name: name, onChange: changeHandler }, inputParams)), ' ', CheckBox__jsx(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */], {
    id: text
  }));
};

CheckBox.defaultProps = {
  changeHandler: function changeHandler() {}
};

/* harmony default export */ var CheckBox_defaultExport = (CheckBox___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_4__CheckBox_css___default.a)(CheckBox));
// CONCATENATED MODULE: ./src/shared/components/UI/TagButton/TagButton.js
/* harmony import */ var TagButton___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var TagButton___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(TagButton___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var TagButton___WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var TagButton___WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(TagButton___WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var TagButton___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var TagButton___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(TagButton___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(1240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__TagButton_css__ = __webpack_require__(1314);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__TagButton_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__TagButton_css__);
var TagButton__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var TagButton__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

function TagButton__defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function TagButton__objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }







var TagButton = function TagButton(_ref) {
  var _cx;

  var title = _ref.title,
      clickHandler = _ref.clickHandler,
      Icon = _ref.Icon,
      disabled = _ref.disabled,
      className = _ref.className,
      inputParams = TagButton__objectWithoutProperties(_ref, ['title', 'clickHandler', 'Icon', 'disabled', 'className']);

  return TagButton___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    TagButton__extends({
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default.a((_cx = {}, TagButton__defineProperty(_cx, __WEBPACK_IMPORTED_MODULE_4__TagButton_css___default.a.tag, true), TagButton__defineProperty(_cx, __WEBPACK_IMPORTED_MODULE_4__TagButton_css___default.a.disabled, disabled), TagButton__defineProperty(_cx, className, !!className), _cx)),
      onClick: function onClick(e) {
        clickHandler(e, title);
      }
    }, inputParams),
    Icon ? TagButton__jsx(Icon, {}) : null,
    title
  );
};

TagButton.defaultProps = {
  disabled: false,
  className: '',
  Icon: null,
  clickHandler: function clickHandler() {}
};

/* harmony default export */ var TagButton_defaultExport = (TagButton___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_4__TagButton_css___default.a)(TagButton));
// CONCATENATED MODULE: ./src/shared/components/UI/Select/Select.js
/* harmony import */ var Select___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var Select___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(Select___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(1240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_select__ = __webpack_require__(477);
/* harmony import */ var Select___WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var Select___WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(Select___WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Select_css__ = __webpack_require__(1316);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__Select_css__);
var Select__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

function Select__defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }







var SelectWrapper = function SelectWrapper(params) {
  return Select__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_1_classnames___default.a(__WEBPACK_IMPORTED_MODULE_4__Select_css___default.a.root, Select__defineProperty({}, __WEBPACK_IMPORTED_MODULE_4__Select_css___default.a['theme-' + params.theme], params.theme && __WEBPACK_IMPORTED_MODULE_4__Select_css___default.a['theme-' + params.theme]))
  }, void 0, Select___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_select__["a" /* default */], params));
};

/* harmony default export */ var Select_defaultExport = (Select___WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_4__Select_css___default.a)(SelectWrapper));
// CONCATENATED MODULE: ./src/shared/components/UI/NumberInputWithSelect/SelectInput/SelectInput.js
/* harmony import */ var SelectInput___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var SelectInput___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(SelectInput___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var SelectInput___WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var SelectInput___WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(SelectInput___WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var SelectInput___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var SelectInput___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(SelectInput___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SelectInput_css__ = __webpack_require__(1318);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SelectInput_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__SelectInput_css__);
var SelectInput__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var SelectInput__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function SelectInput__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function SelectInput__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function SelectInput__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




 // eslint-disable-line css-modules/no-unused-class

var DEFAULT_SELECT_VALUE = 'default';
var stringOrNumberPropType = SelectInput___WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([SelectInput___WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, SelectInput___WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number]);

var SelectInput__ref2 = SelectInput__jsx('i', {
  className: 'fa fa-angle-down'
});

var SelectInput = function (_React$Component) {
  SelectInput__inherits(SelectInput, _React$Component);

  function SelectInput() {
    var _ref;

    var _temp, _this, _ret;

    SelectInput__classCallCheck(this, SelectInput);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = SelectInput__possibleConstructorReturn(this, (_ref = SelectInput.__proto__ || Object.getPrototypeOf(SelectInput)).call.apply(_ref, [this].concat(args))), _this), _this.handleSelectChange = function (e) {
      var _this$props = _this.props,
          onChange = _this$props.onChange,
          name = _this$props.name,
          options = _this$props.options;

      var selectedOption = options[e.target.selectedIndex];

      onChange(name, selectedOption);
    }, _temp), SelectInput__possibleConstructorReturn(_this, _ret);
  }

  SelectInput__createClass(SelectInput, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          options = _props.options,
          value = _props.value,
          disabled = _props.disabled,
          titleKey = _props.titleKey;

      var selected = options.find(function (option) {
        return option.val === value;
      });

      return SelectInput__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_3__SelectInput_css___default.a.root
      }, void 0, SelectInput__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_3__SelectInput_css___default.a.selectContainer
      }, void 0, SelectInput__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_3__SelectInput_css___default.a.hint
      }, void 0, selected && (selected[titleKey] || selected.title) || '', SelectInput__ref2), SelectInput__jsx('select', {
        disabled: disabled,
        className: __WEBPACK_IMPORTED_MODULE_3__SelectInput_css___default.a.select,
        onChange: this.handleSelectChange,
        value: value || DEFAULT_SELECT_VALUE
      }, void 0, options.map(function (item) {
        return SelectInput__jsx('option', {
          value: item.val || DEFAULT_SELECT_VALUE
        }, item.val + item.title, item[titleKey] || item.title);
      }))));
    }
  }]);

  return SelectInput;
}(SelectInput___WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

SelectInput.defaultProps = {
  options: [],
  onChange: function onChange() {},
  value: null,
  name: null,
  disabled: false,
  titleKey: 'title'
};


/* harmony default export */ var SelectInput_defaultExport = (SelectInput___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_3__SelectInput_css___default.a)(SelectInput));
// CONCATENATED MODULE: ./src/shared/components/UI/NumberInputWithSelect/NumberInputWithSelect.js
/* harmony import */ var NumberInputWithSelect___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var NumberInputWithSelect___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(NumberInputWithSelect___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var NumberInputWithSelect___WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var NumberInputWithSelect___WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(NumberInputWithSelect___WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(1240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var NumberInputWithSelect___WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var NumberInputWithSelect___WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(NumberInputWithSelect___WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shared_components_NumberInput_NumberInput__ = __webpack_require__(1281);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_shared_components_DecimalInput_DecimalInput__ = __webpack_require__(1283);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__NumberInputWithSelect_css__ = __webpack_require__(1320);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__NumberInputWithSelect_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__NumberInputWithSelect_css__);
var NumberInputWithSelect__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var NumberInputWithSelect__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var NumberInputWithSelect__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function NumberInputWithSelect__defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function NumberInputWithSelect__objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function NumberInputWithSelect__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function NumberInputWithSelect__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function NumberInputWithSelect__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var NumberInputWithSelect_NumberInputWithSelect = function (_React$Component) {
  NumberInputWithSelect__inherits(NumberInputWithSelect, _React$Component);

  function NumberInputWithSelect() {
    var _ref;

    var _temp, _this, _ret;

    NumberInputWithSelect__classCallCheck(this, NumberInputWithSelect);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = NumberInputWithSelect__possibleConstructorReturn(this, (_ref = NumberInputWithSelect.__proto__ || Object.getPrototypeOf(NumberInputWithSelect)).call.apply(_ref, [this].concat(args))), _this), _this.handleSelectChange = function (name, optionInfo) {
      var val = optionInfo.val,
          option = NumberInputWithSelect__objectWithoutProperties(optionInfo, ['val']);

      _this.props.onUnitsChange(option);
    }, _temp), NumberInputWithSelect__possibleConstructorReturn(_this, _ret);
  }

  NumberInputWithSelect__createClass(NumberInputWithSelect, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          title = _props.title,
          placeholder = _props.placeholder,
          unitsSwitchValue = _props.unitsSwitchValue,
          className = _props.className,
          error = _props.error,
          errorClassName = _props.errorClassName,
          onChange = _props.onChange,
          required = _props.required,
          decimal = _props.decimal,
          disabled = _props.disabled,
          Icon = _props.Icon,
          titleKey = _props.titleKey,
          theme = _props.theme,
          type = _props.type;

      var value = this.props.value || '';
      var unitsSwitchOptions = this.props.unitsSwitchOptions.filter(function (x) {
        return x;
      });

      var inputProps = {
        value: value,
        className: __WEBPACK_IMPORTED_MODULE_7__NumberInputWithSelect_css___default.a.input,
        placeholder: placeholder,
        onChange: onChange,
        disabled: disabled,
        type: type
      };

      return NumberInputWithSelect__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_2_classnames___default.a(__WEBPACK_IMPORTED_MODULE_7__NumberInputWithSelect_css___default.a.root, className, NumberInputWithSelect__defineProperty({}, __WEBPACK_IMPORTED_MODULE_7__NumberInputWithSelect_css___default.a['theme-' + theme], theme && __WEBPACK_IMPORTED_MODULE_7__NumberInputWithSelect_css___default.a['theme-' + theme]))
      }, void 0, title && NumberInputWithSelect__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_2_classnames___default.a(__WEBPACK_IMPORTED_MODULE_7__NumberInputWithSelect_css___default.a.title, NumberInputWithSelect__defineProperty({}, __WEBPACK_IMPORTED_MODULE_7__NumberInputWithSelect_css___default.a.required, required))
      }, void 0, title), NumberInputWithSelect__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_2_classnames___default.a(__WEBPACK_IMPORTED_MODULE_7__NumberInputWithSelect_css___default.a.inline, NumberInputWithSelect__defineProperty({}, __WEBPACK_IMPORTED_MODULE_7__NumberInputWithSelect_css___default.a.hasIcon, !!Icon))
      }, void 0, !!Icon && NumberInputWithSelect__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_7__NumberInputWithSelect_css___default.a.icon
      }, void 0, NumberInputWithSelect__jsx(Icon, {})), decimal ? NumberInputWithSelect___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_shared_components_DecimalInput_DecimalInput__["a" /* default */], inputProps) : NumberInputWithSelect___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_shared_components_NumberInput_NumberInput__["a" /* default */], NumberInputWithSelect__extends({ inputMode: 'numeric' }, inputProps))), unitsSwitchOptions && unitsSwitchOptions.length > 0 && NumberInputWithSelect__jsx('div', {
        className: '' + __WEBPACK_IMPORTED_MODULE_7__NumberInputWithSelect_css___default.a.switch
      }, void 0, NumberInputWithSelect__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_7__NumberInputWithSelect_css___default.a.switchDivider
      }), unitsSwitchOptions.length === 1 && NumberInputWithSelect__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_7__NumberInputWithSelect_css___default.a.singleOptionLabel
      }, void 0, unitsSwitchOptions[0][titleKey] || unitsSwitchOptions[0].title || ''), unitsSwitchOptions.length > 1 && NumberInputWithSelect__jsx(SelectInput_defaultExport, {
        options: unitsSwitchOptions.map(function (option) {
          return NumberInputWithSelect__extends({}, option, { val: option.id });
        }),
        onChange: this.handleSelectChange,
        value: unitsSwitchValue && unitsSwitchValue.id,
        titleKey: titleKey
      })), error && NumberInputWithSelect__jsx('p', {
        className: errorClassName
      }, void 0, error));
    }
  }]);

  return NumberInputWithSelect;
}(NumberInputWithSelect___WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

NumberInputWithSelect_NumberInputWithSelect.defaultProps = {
  title: null,
  className: '',
  errorClassName: '',
  placeholder: '',
  unitsSwitchOptions: [],
  onChange: function onChange() {},
  onUnitsChange: function onUnitsChange() {},
  value: null,
  unitsSwitchValue: null,
  error: null,
  required: false,
  decimal: false,
  disabled: false,
  Icon: null,
  titleKey: 'title',
  theme: '',
  type: 'text'
};


/* harmony default export */ var NumberInputWithSelect_defaultExport = (NumberInputWithSelect___WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_7__NumberInputWithSelect_css___default.a)(NumberInputWithSelect_NumberInputWithSelect));
// CONCATENATED MODULE: ./src/shared/components/UI/InputPriceWithCurrencies/InputPriceWithCurrencies.js
/* harmony import */ var InputPriceWithCurrencies___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var InputPriceWithCurrencies___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(InputPriceWithCurrencies___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var InputPriceWithCurrencies___WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var InputPriceWithCurrencies___WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(InputPriceWithCurrencies___WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_shared_actions_searchForm__ = __webpack_require__(482);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_shared_constants_json_currency_json__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_shared_constants_json_currency_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_shared_constants_json_currency_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__UIStyle_css__ = __webpack_require__(1245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__UIStyle_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__UIStyle_css__);
var InputPriceWithCurrencies__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function InputPriceWithCurrencies__objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }










// import { MoneyIcon } from 'shared/components/Icons';



var sluggifiedCurrency = __WEBPACK_IMPORTED_MODULE_7_shared_constants_json_currency_json___default.a.map(function (item) {
  return InputPriceWithCurrencies__extends({}, item, { id: item.slug });
});

var InputPriceWithCurrencies_InputPriceWithCurrencies = function InputPriceWithCurrencies(_ref) {
  var currency = _ref.currency,
      actions = _ref.actions,
      onChange = _ref.onChange,
      inputParams = InputPriceWithCurrencies__objectWithoutProperties(_ref, ['currency', 'actions', 'onChange']);

  return InputPriceWithCurrencies___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(NumberInputWithSelect_defaultExport, InputPriceWithCurrencies__extends({}, inputParams, {
    // Icon={MoneyIcon}
    unitsSwitchOptions: sluggifiedCurrency,
    unitsSwitchValue: currency,
    onUnitsChange: function onUnitsChange(e) {
      actions.set.currency(e);
      onChange(inputParams.value);
    },
    onChange: onChange,
    titleKey: 'symbol'
  }));
};

InputPriceWithCurrencies_InputPriceWithCurrencies.defaultProps = {
  currency: sluggifiedCurrency[0],
  onChange: function onChange() {}
};

var mapStateToProps = function mapStateToProps(_ref2) {
  var formState = _ref2.searchForm.selected;
  return {
    currency: formState.currency
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    actions: {
      set: __WEBPACK_IMPORTED_MODULE_3_redux__["b" /* bindActionCreators */]({
        currency: __WEBPACK_IMPORTED_MODULE_6_shared_actions_searchForm__["m" /* selectedActions */].set.currency
      }, dispatch)
    }
  };
};

/* harmony default export */ var InputPriceWithCurrencies_defaultExport = (__WEBPACK_IMPORTED_MODULE_4_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_8__UIStyle_css__)(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */](mapStateToProps, mapDispatchToProps)(InputPriceWithCurrencies_InputPriceWithCurrencies)));
// CONCATENATED MODULE: ./src/shared/components/UI/index.js
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Button_Button__ = __webpack_require__(1287);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Button_Button__["a"]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "e", function() { return InputText_defaultExport; });
/* unused concated harmony import InputBirthday */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return InputBirthday_defaultExport; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "b", function() { return ContactButton_defaultExport; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "c", function() { return InputPhoneNumber_defaultExport; });
/* unused concated harmony import CheckBox */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return CheckBox_defaultExport; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "h", function() { return TagButton_defaultExport; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "g", function() { return Select_defaultExport; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "f", function() { return NumberInputWithSelect_defaultExport; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "d", function() { return InputPriceWithCurrencies_defaultExport; });












/***/ }),

/***/ 1269:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_intl__ = __webpack_require__(474);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(1240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_shared_hocs_withBalance__ = __webpack_require__(1259);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_shared_components_Loader_Loader__ = __webpack_require__(1249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__constants_payment__ = __webpack_require__(308);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_images_credit_card_svg__ = __webpack_require__(1265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_images_credit_card_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__assets_images_credit_card_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__PaymentModal_css__ = __webpack_require__(1367);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__PaymentModal_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__PaymentModal_css__);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










// import p24Img from './payment-4.svg';
// import billImg from './receipt.svg';


var _ref2 = _jsx(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */], {
  id: '\u0433\u0440\u043D'
});

var _ref3 = _jsx(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */], {
  id: '\u0411\u0430\u043B\u0430\u043D\u0441'
});

var _ref4 = _jsx(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */], {
  id: '\u0433\u0440\u043D'
});

var _ref5 = _jsx(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */], {
  id: '\u041E\u0442\u043C\u0435\u043D\u0438\u0442\u044C'
});

var _ref6 = _jsx(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */], {
  id: '\u041F\u0440\u0438 \u043E\u043F\u043B\u0430\u0442\u0435 \u0443\u0441\u043B\u0443\u0433 \u0438\u043B\u0438 \u043F\u043E\u043F\u043E\u043B\u043D\u0435\u043D\u0438\u0438 \u043B\u0438\u0447\u043D\u043E\u0433\u043E \u043A\u043E\u0448\u0435\u043B\u044C\u043A\u0430, \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044C \u043F\u043E\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0430\u0435\u0442 \u0441\u0432\u043E\u0435 \u0441\u043E\u0433\u043B\u0430\u0441\u0438\u0435 \u0441 \u0443\u0441\u043B\u043E\u0432\u0438\u044F\u043C\u0438'
});

var _ref7 = _jsx('a', {
  href: '/public-contract/',
  target: '_blank',
  rel: 'noopener noreferrer'
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */], {
  id: '\u041F\u0443\u0431\u043B\u0438\u0447\u043D\u043E\u0433\u043E \u0434\u043E\u0433\u043E\u0432\u043E\u0440\u0430'
}));

var PaymentModal = function (_React$Component) {
  _inherits(PaymentModal, _React$Component);

  function PaymentModal() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, PaymentModal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = PaymentModal.__proto__ || Object.getPrototypeOf(PaymentModal)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      selectedItem: _this.props.items[0],
      balanceRefillMode: false,
      isChecked: true
    }, _this.handleItemChosen = function (selectedItem) {
      _this.setState({ selectedItem: selectedItem });
      _this.props.agreeHandler(selectedItem);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(PaymentModal, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      var _props = this.props,
          balance = _props.balance,
          isFetching = _props.isFetching;


      if (prevProps.isFetching && !isFetching) {
        var selectedItem = this.state.selectedItem;
        var _props2 = this.props,
            amount = _props2.amount,
            items = _props2.items,
            balanceRefillMode = _props2.balanceRefillMode;

        var isBalanceEnough = amount <= balance;
        var isPayingForService = !isBalanceEnough || balanceRefillMode;
        var newSelectedItem = isPayingForService ? items.find(function (item) {
          return item.slug !== __WEBPACK_IMPORTED_MODULE_7__constants_payment__["h" /* PAYMENT_METHODS */].BALANCE;
        }) : selectedItem;

        // eslint-disable-next-line react/no-did-update-set-state
        this.setState({
          selectedItem: newSelectedItem,
          balanceRefillMode: isPayingForService
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var intl = this.props.intl;
      var _props3 = this.props,
          amount = _props3.amount,
          closeHandler = _props3.closeHandler,
          title = _props3.title,
          isLoading = _props3.isLoading,
          items = _props3.items,
          balance = _props3.balance,
          isFetching = _props3.isFetching;
      var _state = this.state,
          balanceRefillMode = _state.balanceRefillMode,
          isChecked = _state.isChecked;

      var isMobile = "desktop" === 'mobile';

      return _jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_9__PaymentModal_css___default.a.root
      }, void 0, _jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_9__PaymentModal_css___default.a.bg,
        onClick: closeHandler
      }), _jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_9__PaymentModal_css___default.a.container
      }, void 0, _jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_9__PaymentModal_css___default.a.column
      }, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_6_shared_components_Loader_Loader__["a" /* default */], {
        isLoading: isFetching,
        className: __WEBPACK_IMPORTED_MODULE_9__PaymentModal_css___default.a.loader
      }, void 0, _jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_9__PaymentModal_css___default.a.columnWrapper
      }, void 0, _jsx('h3', {
        className: __WEBPACK_IMPORTED_MODULE_9__PaymentModal_css___default.a.h3
      }, void 0, title && _jsx('span', {}, void 0, title, ' - '), amount, ' ', _ref2), !isFetching && balance > 0 && _jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_9__PaymentModal_css___default.a.balance
      }, void 0, _ref3, ':', ' ', _jsx('b', {}, void 0, balance, ' ', _ref4)), _jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_9__PaymentModal_css___default.a.list
      }, void 0, items.map(function (item) {
        var shouldDisable = !item.isBalanceRefillOption && balanceRefillMode || item.isBalanceRefillOption && !balanceRefillMode;
        // || (item.slug === PAYMENT_METHODS.INVOICE && !this.props.balanceRefillMode);
        if (_this2.props.disableBalance) {
          shouldDisable = item.slug === __WEBPACK_IMPORTED_MODULE_7__constants_payment__["h" /* PAYMENT_METHODS */].BALANCE && _this2.props.disableBalance || item.slug === __WEBPACK_IMPORTED_MODULE_7__constants_payment__["h" /* PAYMENT_METHODS */].INVOICE && !_this2.props.balanceRefillMode;
        }
        if (item.slug === __WEBPACK_IMPORTED_MODULE_7__constants_payment__["h" /* PAYMENT_METHODS */].FONDY_P24) shouldDisable = true;
        // todo delete this functionality when privat24 will working
        return shouldDisable ? null : _jsx('button', {
          className: __WEBPACK_IMPORTED_MODULE_4_classnames___default.a(__WEBPACK_IMPORTED_MODULE_9__PaymentModal_css___default.a.payment, _defineProperty({}, __WEBPACK_IMPORTED_MODULE_9__PaymentModal_css___default.a.disabled, isLoading)),
          onClick: function onClick() {
            return _this2.handleItemChosen(item);
          },
          disabled: isLoading || !isChecked
        }, item.slug, _jsx('div', {
          className: __WEBPACK_IMPORTED_MODULE_9__PaymentModal_css___default.a.paymentContents
        }, void 0, _jsx('img', {
          src: item.imgSrc,
          width: 60,
          alt: ''
        }), _jsx('div', {
          className: __WEBPACK_IMPORTED_MODULE_9__PaymentModal_css___default.a.paymentTitle
        }, void 0, intl.formatMessage({ id: item.title }))));
      })), _jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_9__PaymentModal_css___default.a.actions
      }, void 0, _jsx('button', {
        className: __WEBPACK_IMPORTED_MODULE_9__PaymentModal_css___default.a.button,
        onClick: closeHandler
      }, void 0, _ref5)), _jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_9__PaymentModal_css___default.a.contractOffer
      }, void 0, _jsx('label', {
        className: __WEBPACK_IMPORTED_MODULE_4_classnames___default.a(__WEBPACK_IMPORTED_MODULE_9__PaymentModal_css___default.a.checkbox, _defineProperty({}, __WEBPACK_IMPORTED_MODULE_9__PaymentModal_css___default.a.disabled, isChecked), _defineProperty({}, __WEBPACK_IMPORTED_MODULE_9__PaymentModal_css___default.a.mobile, isMobile)),
        onClick: function onClick() {
          return _this2.setState({ isChecked: !isChecked });
        }
      }, void 0, _jsx('input', {
        type: 'checkbox',
        defaultChecked: isChecked
      })), _ref6, ' ', _ref7))))));
    }
  }]);

  return PaymentModal;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

PaymentModal.defaultProps = {
  balance: null,
  items: [{
    title: 'Оплатить с личного счёта',
    imgSrc: __WEBPACK_IMPORTED_MODULE_8__assets_images_credit_card_svg___default.a,
    slug: __WEBPACK_IMPORTED_MODULE_7__constants_payment__["h" /* PAYMENT_METHODS */].BALANCE,
    isBalanceRefillOption: false
  }, {
    title: 'Оплатить картой',
    imgSrc: __WEBPACK_IMPORTED_MODULE_8__assets_images_credit_card_svg___default.a,
    slug: __WEBPACK_IMPORTED_MODULE_7__constants_payment__["h" /* PAYMENT_METHODS */].MONO,
    isBalanceRefillOption: true
  }],
  isLoading: false,
  balanceRefillMode: false,
  disableBalance: false
};


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_9__PaymentModal_css___default.a)(__WEBPACK_IMPORTED_MODULE_2_react_intl__["d" /* injectIntl */](__WEBPACK_IMPORTED_MODULE_5_shared_hocs_withBalance__["a" /* default */](true)(PaymentModal))));

/***/ }),

/***/ 1270:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return DesktopButtonMark; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DesktopButton; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return DesktopRightSidebar; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BannersBuffer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_sticky__ = __webpack_require__(487);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_sticky___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_sticky__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(1240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_shared_modules__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_shared_modules_googletag_contentRollAdsense__ = __webpack_require__(1286);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_lazyload__ = __webpack_require__(481);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_lazyload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react_lazyload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__BannerAll_css__ = __webpack_require__(1299);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__BannerAll_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__BannerAll_css__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();












var MARGIN_TOP = 63;
var MARGIN_BOTTOM = 100;

var distanceFromBottom = 0;

var _ref2 = _jsx('div', {});

var DesktopButtonMark = function DesktopButtonMark() {
  return _jsx(__WEBPACK_IMPORTED_MODULE_2_react_sticky__["StickyContainer"], {}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_2_react_sticky__["Sticky"], {
    topOffset: -68,
    disableCompensation: true
  }, void 0, function (_ref) {
    var distance = _ref.distanceFromBottom;

    distanceFromBottom = Number(distance);
    return _ref2;
  }));
};

var _ref4 = _jsx(__WEBPACK_IMPORTED_MODULE_7_shared_modules_googletag_contentRollAdsense__["a" /* ContentRollAdsense */], {});

var DesktopButton = __WEBPACK_IMPORTED_MODULE_1_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_9__BannerAll_css___default.a)(function () {
  return _jsx(__WEBPACK_IMPORTED_MODULE_2_react_sticky__["StickyContainer"], {}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_2_react_sticky__["Sticky"], {
    topOffset: -68,
    disableCompensation: true
  }, void 0, function (_ref3) {
    var distance = _ref3.distanceFromBottom;

    distanceFromBottom = Number(distance);
    return _jsx('div', {
      className: __WEBPACK_IMPORTED_MODULE_9__BannerAll_css___default.a.advertContainerButoon,
      id: 'div-gpt-ad-desktop_button-all'
    }, void 0, _ref4);
  }));
}); /* data.children */

var _ref5 = _jsx(__WEBPACK_IMPORTED_MODULE_8_react_lazyload___default.a, {}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_6_shared_modules__["a" /* Googletag */], {
  id: 'div-gpt-ad-1510239331518-1'
}));

var _ref6 = _jsx(__WEBPACK_IMPORTED_MODULE_8_react_lazyload___default.a, {}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_6_shared_modules__["a" /* Googletag */], {
  id: 'div-gpt-ad-1510224251147-0'
}));

var _ref7 = _jsx(__WEBPACK_IMPORTED_MODULE_8_react_lazyload___default.a, {}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_6_shared_modules__["a" /* Googletag */], {
  id: 'div-gpt-ad-1510239331518-1'
}));

var _ref8 = _jsx('div', {
  id: 'height-div-gpt-ad-1510224251147-0'
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_8_react_lazyload___default.a, {}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_6_shared_modules__["a" /* Googletag */], {
  id: 'div-gpt-ad-1510224251147-0'
})));

var _ref10 = _jsx(__WEBPACK_IMPORTED_MODULE_8_react_lazyload___default.a, {}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_6_shared_modules__["a" /* Googletag */], {
  id: 'div-gpt-ad-1510239331518-1'
}));

var _ref11 = _jsx(__WEBPACK_IMPORTED_MODULE_8_react_lazyload___default.a, {}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_6_shared_modules__["a" /* Googletag */], {
  id: 'div-gpt-ad-1510224251147-0'
}));

var DesktopRightSidebar = __WEBPACK_IMPORTED_MODULE_1_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_9__BannerAll_css___default.a)(function (data) {
  if (data.scrollNo) {
    return _jsx('div', {
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default.a(__WEBPACK_IMPORTED_MODULE_9__BannerAll_css___default.a.flexCell, __WEBPACK_IMPORTED_MODULE_9__BannerAll_css___default.a.sideBar)
    }, void 0, _jsx('div', {
      className: __WEBPACK_IMPORTED_MODULE_9__BannerAll_css___default.a.gptPremium
    }, void 0, _ref5), data && data.children || '', _ref6);
  } else if (data.fixedSecondBanner) {
    return _jsx('div', {
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default.a(__WEBPACK_IMPORTED_MODULE_9__BannerAll_css___default.a.flexCell, __WEBPACK_IMPORTED_MODULE_9__BannerAll_css___default.a.sideBar)
    }, void 0, _jsx('div', {
      id: 'height-div-gpt-ad-1510239331518-1'
    }, void 0, _jsx('div', {
      className: __WEBPACK_IMPORTED_MODULE_9__BannerAll_css___default.a.gptPremium
    }, void 0, _ref7), data && data.children || ''), _jsx(__WEBPACK_IMPORTED_MODULE_2_react_sticky__["StickyContainer"], {
      className: __WEBPACK_IMPORTED_MODULE_9__BannerAll_css___default.a.homeSideBar
    }, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_2_react_sticky__["Sticky"], {
      topOffset: -MARGIN_TOP,
      disableCompensation: true
    }, void 0, function (props) {
      var style = props.style,
          bottomDistance = props.distanceFromBottom;

      var customStyle = _extends({}, style, { top: MARGIN_TOP + 'px' });

      if (+bottomDistance < MARGIN_BOTTOM) {
        customStyle = _extends({}, style, { top: bottomDistance - 20 });
      }
      return _jsx('div', {
        style: customStyle
      }, void 0, _ref8);
    })));
  }

  return _jsx(__WEBPACK_IMPORTED_MODULE_2_react_sticky__["StickyContainer"], {}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_2_react_sticky__["Sticky"], {
    topOffset: -MARGIN_TOP,
    disableCompensation: true
  }, void 0, function (_ref9) {
    var _ref9$style = _ref9.style,
        style = _ref9$style === undefined ? { transform: 'translateZ(0)' } : _ref9$style,
        distanceFromTop = _ref9.distanceFromTop,
        distanceFromBottomValue = _ref9.distanceFromBottom;

    var padding = 35;
    var scroll = MARGIN_TOP;
    var scrollTwo = 0;
    var bodyABIdBlockHeight = 0;
    var blockHeight = 0;
    var blockHeightAbove600 = false;
    var bodyABIdBlockHeightAbove = false;
    var doNotScroll = 0;

    var bannerBlock1 = 0;
    var bannerBlock2 = 0;

    if (true) {
      var heightDivDptAd1510239331518 = window.document.getElementById('height-div-gpt-ad-1510239331518-1') || {};
      var heightDivGptAd15102242511470 = window.document.getElementById('height-div-gpt-ad-1510224251147-0') || {};
      var bodyABIdBlock = window.document.getElementById('bodyABIdBlock') || {};
      bodyABIdBlockHeight = Number(bodyABIdBlock.clientHeight);
      blockHeight = Number(heightDivDptAd1510239331518.clientHeight);
      scroll = Number('-' + heightDivDptAd1510239331518.clientHeight) || MARGIN_TOP;
      scrollTwo = Number('-' + heightDivGptAd15102242511470.clientHeight) || 0;
      blockHeightAbove600 = blockHeight > 600;
      bodyABIdBlockHeightAbove = bodyABIdBlockHeight > Math.abs(distanceFromTop) + Math.abs(scrollTwo) + padding + 20 + 35;

      bannerBlock1 = Number(heightDivDptAd1510239331518.clientHeight) || 0;
      bannerBlock2 = Number(heightDivGptAd15102242511470.clientHeight) || 0;

      doNotScroll = bodyABIdBlockHeight - 130 < bannerBlock1 + bannerBlock2;
    }

    if (distanceFromBottomValue - padding - bannerBlock2 < 0) {
      scroll += distanceFromBottomValue - padding - bannerBlock2 + 35;
    } else if (!bodyABIdBlockHeightAbove) {
      scroll += bodyABIdBlockHeight - Math.abs(distanceFromTop) - Math.abs(scrollTwo) - padding - 20;
    } else if (blockHeightAbove600) {
      if (distanceFromBottom + scrollTwo + padding < 100) {
        if (distanceFromBottom + scrollTwo - MARGIN_TOP > scroll) {
          scroll = distanceFromBottom + scrollTwo;
        } else {
          scroll += padding;
        }
      } else {
        scroll = MARGIN_TOP;
      }
    } else {
      scroll = distanceFromTop;
    }

    var fun = function fun() {
      var obj = {};
      if (!blockHeightAbove600 && distanceFromTop < Number('-' + blockHeight)) {
        obj.position = 'fixed';
        obj.top = Math.abs(distanceFromTop - MARGIN_TOP) + 'px';
      }
      return obj;
    };

    return _jsx('div', {
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default.a(__WEBPACK_IMPORTED_MODULE_9__BannerAll_css___default.a.flexCell, __WEBPACK_IMPORTED_MODULE_9__BannerAll_css___default.a.sideBar)
    }, void 0, _jsx('div', {
      style: doNotScroll ? {} : _extends({}, style, { top: scroll + 'px' })
    }, void 0, _jsx('div', {
      id: 'height-div-gpt-ad-1510239331518-1'
    }, void 0, _jsx('div', {
      className: __WEBPACK_IMPORTED_MODULE_9__BannerAll_css___default.a.gptPremium
    }, void 0, _ref10), data && data.children || ''), _jsx('div', {
      style: fun(),
      id: 'height-div-gpt-ad-1510224251147-0'
    }, void 0, _ref11)));
  }));
});

var BannersBuffer = __WEBPACK_IMPORTED_MODULE_4_react_redux__["b" /* connect */](function (_ref12) {
  var globals = _ref12.globals;
  return {
    bannerNotErr: globals.banner && globals.banner.bannerNotErr
  };
})(function () {
  function BannersBuffer(props) {
    var bannerNotErr = props.bannerNotErr;

    return _jsx('div', {
      style: { display: 'none' }
    }, void 0, Object.keys(bannerNotErr).map(function (a) {
      return _jsx('div', {
        id: a
      }, a, '.');
    }));
  }

  BannersBuffer.defaultProps = {
    bannerNotErr: {}
  };
  return BannersBuffer;
}());

/***/ }),

/***/ 1271:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return posted; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createdDate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return shortCreatedDate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getFullDate; });
/* unused harmony export getShotDate */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_shared_helpers_locale__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_date_fns_endOfDay__ = __webpack_require__(190);



var posted = function posted(time) {
  var locale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'ru';

  if (__WEBPACK_IMPORTED_MODULE_0_shared_helpers_locale__["c" /* getFormattedDateFns */](__WEBPACK_IMPORTED_MODULE_1_date_fns_endOfDay__["default"](new Date(time)), 'yyyy-MM-dd') === __WEBPACK_IMPORTED_MODULE_0_shared_helpers_locale__["c" /* getFormattedDateFns */](__WEBPACK_IMPORTED_MODULE_1_date_fns_endOfDay__["default"](new Date()), 'yyyy-MM-dd')) {
    return __WEBPACK_IMPORTED_MODULE_0_shared_helpers_locale__["c" /* getFormattedDateFns */](time, 'H:mm');
  }
  return __WEBPACK_IMPORTED_MODULE_0_shared_helpers_locale__["c" /* getFormattedDateFns */](time, 'MMMM d, yyyy', locale);
};

var createdDate = function createdDate(time) {
  var locale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'ru';
  return __WEBPACK_IMPORTED_MODULE_0_shared_helpers_locale__["c" /* getFormattedDateFns */](time, 'MMMM d, yyyy', locale);
};

var shortCreatedDate = function shortCreatedDate(time) {
  var locale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'ru';
  return __WEBPACK_IMPORTED_MODULE_0_shared_helpers_locale__["c" /* getFormattedDateFns */](time, 'dd.MM', locale);
};

var getFullDate = function getFullDate(time) {
  var locale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'ru';
  return __WEBPACK_IMPORTED_MODULE_0_shared_helpers_locale__["c" /* getFormattedDateFns */](time, 'H:mm, MMMM d, yyyy', locale);
};

var getShotDate = function getShotDate(time) {
  var locale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'ru';
  return __WEBPACK_IMPORTED_MODULE_0_shared_helpers_locale__["c" /* getFormattedDateFns */](time, 'dd-MM-yyyy', locale);
};

/***/ }),

/***/ 1272:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getUserName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getUserThing; });
/* unused harmony export formatPhone */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return verifyYear; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getYearsOptions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getParamByKey; });
/* unused harmony export rewriteMinMaxYear */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return correctionYears; });
/* unused harmony export getActiveAdvsCount */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return isSlotAvailable; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_shared_helpers_locale__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_shared_helpers_arrays__ = __webpack_require__(104);



var getUserName = function getUserName(_ref) {
  var _ref$first_name = _ref.first_name,
      firstName = _ref$first_name === undefined ? null : _ref$first_name,
      _ref$last_name = _ref.last_name,
      lastName = _ref$last_name === undefined ? null : _ref$last_name;
  return firstName || lastName ? [firstName, lastName].filter(function (i) {
    return !!i;
  }).join(' ') : null;
};

var getUserThing = function getUserThing(_ref2) {
  var email = _ref2.email,
      _ref2$phones = _ref2.phones,
      phones = _ref2$phones === undefined ? [] : _ref2$phones,
      name = _ref2.name;

  var verifiedPhones = phones.filter(function (phone) {
    return phone.is_verified;
  });
  var emailAndPhones = verifiedPhones.length > 0 ? '' + verifiedPhones[0].number : email;
  return name || emailAndPhones;
};

var formatPhone = function formatPhone(phone) {
  var numberPhone = phone.replace(/[+\s_()]/g, '');
  return '380' + numberPhone.slice(-9);
};

var verifyYear = function verifyYear(year) {
  return year && (year < 1900 || year > +Number(__WEBPACK_IMPORTED_MODULE_0_shared_helpers_locale__["c" /* getFormattedDateFns */](new Date(), 'yyyy')));
};

var getYearsOptions = function getYearsOptions() {
  var YEAR_FROM = 1901;
  var YEAR_TO = new Date().getFullYear();
  var YEARS = __WEBPACK_IMPORTED_MODULE_1_shared_helpers_arrays__["c" /* getRange */](YEAR_FROM, YEAR_TO);

  return YEARS.map(function (year) {
    return { title: year, val: year };
  }).reverse();
};

var getParamByKey = function getParamByKey(arr, key) {
  if (arr && arr.length) return arr[0][key];
  return null;
};

var rewriteMinMaxYear = function rewriteMinMaxYear(year) {
  if (!year) return year;else if (+year < 1900) return 1900;else if (+year > +Number(__WEBPACK_IMPORTED_MODULE_0_shared_helpers_locale__["c" /* getFormattedDateFns */](new Date(), 'yyyy'))) return +Number(__WEBPACK_IMPORTED_MODULE_0_shared_helpers_locale__["c" /* getFormattedDateFns */](new Date(), 'yyyy'));
  return +year;
};

var correctionYears = function correctionYears(formState) {
  var yearTo = formState.yearTo,
      yearFrom = formState.yearFrom;


  yearTo = rewriteMinMaxYear(yearTo);
  yearFrom = rewriteMinMaxYear(yearFrom);

  if (yearTo && yearFrom && yearTo < yearFrom) return { yearTo: yearFrom, yearFrom: yearTo };
  return { yearTo: yearTo, yearFrom: yearFrom };
};

/**
 * Get count of activated adverts
 * @returns {Number}
 */
var getActiveAdvsCount = function getActiveAdvsCount(user) {
  if (!user || !user.id) return 0;
  var activeKeys = Object.keys(user.active_adverts);
  var count = activeKeys.reduce(function (acc, value) {
    return acc + user.active_adverts[value];
  }, 0);
  return count;
};

/**
 * Get count of activated adverts
 * @returns {Boolean}
 */
var isSlotAvailable = function isSlotAvailable(user) {
  if (getActiveAdvsCount(user) === 0) return true;
  return !!user.tariff && user.tariff.slots_limit > getActiveAdvsCount(user);
};

/***/ }),

/***/ 1273:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



module.exports = __webpack_require__(1285);

/***/ }),

/***/ 1274:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return getFieldFromRootOrCharacteristics; });
/* unused harmony export getNumberOrTitleFromRootOrCharacteristics */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return getCapacity; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return getMileageText; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return constructModification; });
/* unused harmony export getModification */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return carPrice; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return carPriceBySlug; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return getPriceBySlug; });
/* unused harmony export getCurrencyTitleBySlug */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return getSymbolTitleBySlug; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return getPriceValueBySlug; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return getPriceWithCurrency; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return isLocationCountry; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return convertMlToKm; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return getMileageString; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return getCapacityUnitTitleById; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return getCountryById; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getAdvertStatuses; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getAdvertOgImage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return getTransportInfoFiltered; });
/* unused harmony export getIconsByFieldName */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return getTechnicalsSpecifications; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_shared_constants_json_powerUnits_json__ = __webpack_require__(495);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_shared_constants_json_powerUnits_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_shared_constants_json_powerUnits_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_shared_constants_json_capacityUnits_json__ = __webpack_require__(494);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_shared_constants_json_capacityUnits_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_shared_constants_json_capacityUnits_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shared_constants_json_mileageUnits_json__ = __webpack_require__(320);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shared_constants_json_mileageUnits_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_shared_constants_json_mileageUnits_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_constants_json_currency_json__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_constants_json_currency_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_shared_constants_json_currency_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shared_constants_json_countries_json__ = __webpack_require__(310);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shared_constants_json_countries_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_shared_constants_json_countries_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_shared_constants_json_statuses_json__ = __webpack_require__(496);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_shared_constants_json_statuses_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_shared_constants_json_statuses_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_shared_constants_json_priceStatuses_json__ = __webpack_require__(493);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_shared_constants_json_priceStatuses_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_shared_constants_json_priceStatuses_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_shared_components_Icons__ = __webpack_require__(1397);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__common__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__arrays__ = __webpack_require__(104);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }












var getFieldFromRootOrCharacteristics = function getFieldFromRootOrCharacteristics(key, advert) {
  if (!advert || !key) {
    return null;
  }

  var characteristics = advert.characteristics || {};
  if (advert[key] && advert[key].title && advert[key].id) {
    return advert[key];
  } else if (characteristics[key] && characteristics[key].title && characteristics[key].id) {
    return characteristics[key];
  }

  return null;
};

var getNumberOrTitleFromRootOrCharacteristics = function getNumberOrTitleFromRootOrCharacteristics(key, advert) {
  var result = getFieldFromRootOrCharacteristics(key, advert);

  if (result && result.number) {
    return result.number;
  } else if (result && result.title) return result.title;

  return result;
};

var getPower = function getPower(advert, t) {
  var powerUnit = __WEBPACK_IMPORTED_MODULE_0_shared_constants_json_powerUnits_json___default.a.find(function (item) {
    return item.id === advert.power_unit;
  });
  var power = getNumberOrTitleFromRootOrCharacteristics('power', advert);

  return power ? '(' + power + ' ' + (powerUnit && t(powerUnit.title)) + ')' : '';
};

/**
 * @param advert {object}
 * @param key {string} - one of ['capacity', 'capacity_body', 'capacity_bucket']
 * @param t {function}
 * @returns {string}
 */
var getCapacity = function getCapacity(advert, t) {
  var key = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'capacity';

  var capacityUnit = __WEBPACK_IMPORTED_MODULE_1_shared_constants_json_capacityUnits_json___default.a.find(function (item) {
    return item.id === advert.capacity_unit;
  });
  var capacity = getNumberOrTitleFromRootOrCharacteristics(key, advert);

  return capacity && capacityUnit ? '' + capacity + t(capacityUnit.title) : '';
};

var getMileageText = function getMileageText(advert, t) {
  var mileage = advert.mileage,
      mileageUnitId = advert.mileage_unit,
      isNew = advert.is_new;

  var mileageUnit = __WEBPACK_IMPORTED_MODULE_2_shared_constants_json_mileageUnits_json___default.a.find(function (item) {
    return item.id === mileageUnitId;
  });

  var mileageText = mileage > 0 ? mileage + ' ' + t(__WEBPACK_IMPORTED_MODULE_8__common__["h" /* getTitleOrEmpty */](mileageUnit)) : null;
  if (isNew) {
    mileageText = t('новый');
  }

  return mileageText;
};

var constructModification = function constructModification(advert, t) {
  var gearbox = getFieldFromRootOrCharacteristics('gearbox', advert);
  var power = getPower(advert, t);
  var capacity = getCapacity(advert, t);

  return __WEBPACK_IMPORTED_MODULE_9__arrays__["a" /* cleanArray */]([capacity, __WEBPACK_IMPORTED_MODULE_8__common__["h" /* getTitleOrEmpty */](gearbox).toLowerCase(), power]).join(' ').trim();
};

var getModification = function getModification(advert, t) {
  if (advert.modification && advert.modification.id) {
    return advert.modification.title || '';
  }

  return constructModification(advert, t);
};

var carPrice = function carPrice(price, currency) {
  var priceString = __WEBPACK_IMPORTED_MODULE_8__common__["k" /* numberWithSpaces */](price);
  var currencyTitle = currency.symbol || currency.title;

  return priceString + ' ' + currencyTitle;
};

var carPriceBySlug = function carPriceBySlug(prices, currency) {
  if (!currency || !prices) {
    return '';
  }

  var price = prices.find(function (item) {
    return item.currency === currency.slug;
  });
  if (!price) {
    return '';
  }

  return carPrice(price.value, currency);
};

var getPriceBySlug = function getPriceBySlug(prices, slug) {
  var getNumber = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  if (!slug || !prices) {
    return '';
  }

  var currency = __WEBPACK_IMPORTED_MODULE_3_shared_constants_json_currency_json___default.a.find(function (c) {
    return c.slug === slug;
  });
  var price = prices.find(function (item) {
    return item.currency === currency.slug;
  });
  if (!price) {
    return '';
  }
  if (getNumber) return price.value;
  return carPrice(price.value, currency);
};

var getCurrencyTitleBySlug = function getCurrencyTitleBySlug(slug) {
  var currentCurrencyObj = __WEBPACK_IMPORTED_MODULE_3_shared_constants_json_currency_json___default.a.find(function (item) {
    return item.slug === slug;
  });

  var _ref = currentCurrencyObj || {},
      title = _ref.title;

  return title;
};

var getSymbolTitleBySlug = function getSymbolTitleBySlug(slug) {
  var currentCurrencyObj = __WEBPACK_IMPORTED_MODULE_3_shared_constants_json_currency_json___default.a.find(function (item) {
    return item.slug === slug;
  });

  var _ref2 = currentCurrencyObj || {},
      symbol = _ref2.symbol;

  return symbol;
};

var getPriceValueBySlug = function getPriceValueBySlug(prices, slug) {
  var currentPriceObj = prices.find(function (price) {
    return price.currency === slug;
  });

  return currentPriceObj ? currentPriceObj.value : null;
};

var getPriceWithCurrency = function getPriceWithCurrency(prices, slug) {
  var value = getPriceValueBySlug(prices, slug);
  var currency = getCurrencyTitleBySlug(slug);

  if (typeof value !== 'number' || !currency) {
    return null;
  }

  return slug === 'usd' ? currency + ' ' + __WEBPACK_IMPORTED_MODULE_8__common__["k" /* numberWithSpaces */](value) : __WEBPACK_IMPORTED_MODULE_8__common__["k" /* numberWithSpaces */](value) + ' ' + currency;
};

var isLocationCountry = function isLocationCountry(location) {
  if (!location || !location.id) {
    return null;
  }

  return !!__WEBPACK_IMPORTED_MODULE_4_shared_constants_json_countries_json___default.a.find(function (country) {
    return country.id === location.id;
  });
};

var convertMlToKm = function convertMlToKm(car) {
  if (car.mileage_unit === 0) {
    return car.mileage;
  } else if (car.mileage_unit === 1) {
    return car.mileage * 1.61;
  }
};

var getMileageString = function getMileageString(mileage, mileageUnitId) {
  if (!mileage || typeof mileageUnitId !== 'number') {
    return null;
  }

  var mileageUnitTitle = __WEBPACK_IMPORTED_MODULE_8__common__["h" /* getTitleOrEmpty */](__WEBPACK_IMPORTED_MODULE_2_shared_constants_json_mileageUnits_json___default.a.find(function (unit) {
    return unit.id === mileageUnitId;
  }));

  return mileage + ' ' + mileageUnitTitle.replace(/[.]/g, '');
};

var getCapacityUnitTitleById = function getCapacityUnitTitleById(unitId) {
  return __WEBPACK_IMPORTED_MODULE_8__common__["h" /* getTitleOrEmpty */](__WEBPACK_IMPORTED_MODULE_1_shared_constants_json_capacityUnits_json___default.a.find(function (unit) {
    return unit.id === unitId;
  }));
};

var getCountryById = function getCountryById(id) {
  return __WEBPACK_IMPORTED_MODULE_4_shared_constants_json_countries_json___default.a.find(function (item) {
    return item.id === id;
  });
};

var translateTitle = function translateTitle(item, intl) {
  return item.title ? _extends({}, item, { title: intl.formatMessage({ id: item.title }) }) : item;
};

var getAdvertStatuses = function getAdvertStatuses(advert, intl) {
  return [].concat(_toConsumableArray([].concat(_toConsumableArray(__WEBPACK_IMPORTED_MODULE_5_shared_constants_json_statuses_json___default.a), _toConsumableArray(__WEBPACK_IMPORTED_MODULE_6_shared_constants_json_priceStatuses_json___default.a), [{ title: 'авто не в Украине', id: 'abroad' }]).filter(function (status) {
    return advert[status.id];
  }).map(function (item) {
    return translateTitle(item, intl);
  })), _toConsumableArray(advert.is_not_cleared ? [] : [{ id: '__is_not_cleared', title: '' + intl.formatMessage({ id: 'растаможен' }) }]), _toConsumableArray(advert.driven_from && advert.driven_from.id && !!getCountryById(advert.driven_from.id) ? [{
    title: '\u0430\u0432\u0442\u043E ' + getCountryById(advert.driven_from.id).from[intl.locale],
    id: 'driven_from'
  }] : []));
};

var getAdvertOgImage = function getAdvertOgImage(advert) {
  return advert && advert.photos && advert.photos.length > 0 && advert.photos[0] && advert.photos[0].image ? advert.photos[0].image : undefined;
};

var getTechnicalsSpecification = function getTechnicalsSpecification(advert, item, t) {
  switch (item) {
    case 'engine':
      return getFieldFromRootOrCharacteristics('engine', advert);
    case 'mileage':
      return {
        slug: item,
        id: 999,
        title: getMileageText(advert, t)
      };
    case 'gearbox':
      return getFieldFromRootOrCharacteristics('gearbox', advert);
    case 'drive':
      return getFieldFromRootOrCharacteristics('drive', advert);
    case 'year':
      return {
        slug: item,
        id: 888,
        title: advert.year
      };
    case 'location':
      return {
        slug: item,
        id: 777,
        title: advert.location.title
      };
    default:
      return {
        slug: '',
        id: 0,
        title: ''
      };
  }
};

var getTransportInfoFiltered = function getTransportInfoFiltered() {
  var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'avto';

  var types = {
    avto: ['location', 'year', 'modification', 'mileage', 'body', 'color', 'engine', 'gearbox', 'drive', 'vin']
  };
  return types[type] ? types[type] : [];
};

var getIconsByFieldName = function getIconsByFieldName() {
  return {
    mileage: __WEBPACK_IMPORTED_MODULE_7_shared_components_Icons__["o" /* SpeedIcon */],
    gearbox: __WEBPACK_IMPORTED_MODULE_7_shared_components_Icons__["h" /* GearboxIcon */],
    year: __WEBPACK_IMPORTED_MODULE_7_shared_components_Icons__["b" /* CalendarIcon */],
    engine: __WEBPACK_IMPORTED_MODULE_7_shared_components_Icons__["f" /* EngineIcon */],
    drive: __WEBPACK_IMPORTED_MODULE_7_shared_components_Icons__["d" /* ChassisIcon */],
    location: __WEBPACK_IMPORTED_MODULE_7_shared_components_Icons__["l" /* LocationIcon */],
    color: __WEBPACK_IMPORTED_MODULE_7_shared_components_Icons__["e" /* ColorIcon */],
    vin: __WEBPACK_IMPORTED_MODULE_7_shared_components_Icons__["s" /* VinIcon */]
  };
};

var getTechnicalsSpecifications = function getTechnicalsSpecifications(advert, items, t) {
  var icons = getIconsByFieldName();
  return items.map(function (slug) {
    var params = getTechnicalsSpecification(advert, slug, t);
    return _extends({
      icon: icons[slug] || null
    }, params);
  }).filter(function (item) {
    return item && item.title;
  });
};

/***/ }),

/***/ 1275:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_components_ModalContainer_ModalContainer__ = __webpack_require__(1256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ModalWrapper_css__ = __webpack_require__(1303);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ModalWrapper_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__ModalWrapper_css__);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();








function ModalWrapper(props) {
  return _jsx(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment, {}, void 0, props.show && _jsx(__WEBPACK_IMPORTED_MODULE_3_shared_components_ModalContainer_ModalContainer__["a" /* default */], {
    modalCN: __WEBPACK_IMPORTED_MODULE_4__ModalWrapper_css___default.a.modal,
    onClose: props.toggleModal,
    isOpen: props.show
  }, void 0, _jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_4__ModalWrapper_css___default.a.rootModal
  }, void 0, _jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_4__ModalWrapper_css___default.a.rootModalContainer
  }, void 0, props.children, _jsx('i', {
    className: 'fa fa-times ' + __WEBPACK_IMPORTED_MODULE_4__ModalWrapper_css___default.a.closeBtnIcon,
    onClick: props.toggleModal
  })))));
}

ModalWrapper.defaultProps = {
  children: null
};


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_4__ModalWrapper_css___default.a)(ModalWrapper));

/***/ }),

/***/ 1276:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export IGNORE_CLASS_NAME */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);



function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

/**
 * Check whether some DOM node is our Component's node.
 */
function isNodeFound(current, componentNode, ignoreClass) {
  if (current === componentNode) {
    return true;
  } // SVG <use/> elements do not technically reside in the rendered DOM, so
  // they do not have classList directly, but they offer a link to their
  // corresponding element, which can have classList. This extra check is for
  // that case.
  // See: http://www.w3.org/TR/SVG11/struct.html#InterfaceSVGUseElement
  // Discussion: https://github.com/Pomax/react-onclickoutside/pull/17


  if (current.correspondingElement) {
    return current.correspondingElement.classList.contains(ignoreClass);
  }

  return current.classList.contains(ignoreClass);
}
/**
 * Try to find our node in a hierarchy of nodes, returning the document
 * node as highest node if our node is not found in the path up.
 */

function findHighest(current, componentNode, ignoreClass) {
  if (current === componentNode) {
    return true;
  } // If source=local then this event came from 'somewhere'
  // inside and should be ignored. We could handle this with
  // a layered approach, too, but that requires going back to
  // thinking in terms of Dom node nesting, running counter
  // to React's 'you shouldn't care about the DOM' philosophy.


  while (current.parentNode) {
    if (isNodeFound(current, componentNode, ignoreClass)) {
      return true;
    }

    current = current.parentNode;
  }

  return current;
}
/**
 * Check if the browser scrollbar was clicked
 */

function clickedScrollbar(evt) {
  return document.documentElement.clientWidth <= evt.clientX || document.documentElement.clientHeight <= evt.clientY;
}

// ideally will get replaced with external dep
// when rafrex/detect-passive-events#4 and rafrex/detect-passive-events#5 get merged in
var testPassiveEventSupport = function testPassiveEventSupport() {
  if (typeof window === 'undefined' || typeof window.addEventListener !== 'function') {
    return;
  }

  var passive = false;
  var options = Object.defineProperty({}, 'passive', {
    get: function get() {
      passive = true;
    }
  });

  var noop = function noop() {};

  window.addEventListener('testPassiveEventSupport', noop, options);
  window.removeEventListener('testPassiveEventSupport', noop, options);
  return passive;
};

function autoInc(seed) {
  if (seed === void 0) {
    seed = 0;
  }

  return function () {
    return ++seed;
  };
}

var uid = autoInc();

var passiveEventSupport;
var handlersMap = {};
var enabledInstances = {};
var touchEvents = ['touchstart', 'touchmove'];
var IGNORE_CLASS_NAME = 'ignore-react-onclickoutside';
/**
 * This function generates the HOC function that you'll use
 * in order to impart onOutsideClick listening to an
 * arbitrary component. It gets called at the end of the
 * bootstrapping code to yield an instance of the
 * onClickOutsideHOC function defined inside setupHOC().
 */

function onClickOutsideHOC(WrappedComponent, config) {
  var _class, _temp;

  return _temp = _class =
  /*#__PURE__*/
  function (_Component) {
    _inheritsLoose(onClickOutside, _Component);

    function onClickOutside(props) {
      var _this;

      _this = _Component.call(this, props) || this;

      _this.__outsideClickHandler = function (event) {
        if (typeof _this.__clickOutsideHandlerProp === 'function') {
          _this.__clickOutsideHandlerProp(event);

          return;
        }

        var instance = _this.getInstance();

        if (typeof instance.props.handleClickOutside === 'function') {
          instance.props.handleClickOutside(event);
          return;
        }

        if (typeof instance.handleClickOutside === 'function') {
          instance.handleClickOutside(event);
          return;
        }

        throw new Error('WrappedComponent lacks a handleClickOutside(event) function for processing outside click events.');
      };

      _this.enableOnClickOutside = function () {
        if (typeof document === 'undefined' || enabledInstances[_this._uid]) {
          return;
        }

        if (typeof passiveEventSupport === 'undefined') {
          passiveEventSupport = testPassiveEventSupport();
        }

        enabledInstances[_this._uid] = true;
        var events = _this.props.eventTypes;

        if (!events.forEach) {
          events = [events];
        }

        handlersMap[_this._uid] = function (event) {
          if (_this.props.disableOnClickOutside) return;
          if (_this.componentNode === null) return;

          if (_this.props.preventDefault) {
            event.preventDefault();
          }

          if (_this.props.stopPropagation) {
            event.stopPropagation();
          }

          if (_this.props.excludeScrollbar && clickedScrollbar(event)) return;
          var current = event.target;

          if (findHighest(current, _this.componentNode, _this.props.outsideClickIgnoreClass) !== document) {
            return;
          }

          _this.__outsideClickHandler(event);
        };

        events.forEach(function (eventName) {
          var handlerOptions = null;
          var isTouchEvent = touchEvents.indexOf(eventName) !== -1;

          if (isTouchEvent && passiveEventSupport) {
            handlerOptions = {
              passive: !_this.props.preventDefault
            };
          }

          document.addEventListener(eventName, handlersMap[_this._uid], handlerOptions);
        });
      };

      _this.disableOnClickOutside = function () {
        delete enabledInstances[_this._uid];
        var fn = handlersMap[_this._uid];

        if (fn && typeof document !== 'undefined') {
          var events = _this.props.eventTypes;

          if (!events.forEach) {
            events = [events];
          }

          events.forEach(function (eventName) {
            return document.removeEventListener(eventName, fn);
          });
          delete handlersMap[_this._uid];
        }
      };

      _this.getRef = function (ref) {
        return _this.instanceRef = ref;
      };

      _this._uid = uid();
      return _this;
    }
    /**
     * Access the WrappedComponent's instance.
     */

    var _proto = onClickOutside.prototype;

    _proto.getInstance = function getInstance() {
      if (!WrappedComponent.prototype.isReactComponent) {
        return this;
      }

      var ref = this.instanceRef;
      return ref.getInstance ? ref.getInstance() : ref;
    };

    /**
     * Add click listeners to the current document,
     * linked to this component's state.
     */
    _proto.componentDidMount = function componentDidMount() {
      // If we are in an environment without a DOM such
      // as shallow rendering or snapshots then we exit
      // early to prevent any unhandled errors being thrown.
      if (typeof document === 'undefined' || !document.createElement) {
        return;
      }

      var instance = this.getInstance();

      if (config && typeof config.handleClickOutside === 'function') {
        this.__clickOutsideHandlerProp = config.handleClickOutside(instance);

        if (typeof this.__clickOutsideHandlerProp !== 'function') {
          throw new Error('WrappedComponent lacks a function for processing outside click events specified by the handleClickOutside config option.');
        }
      }

      this.componentNode = __WEBPACK_IMPORTED_MODULE_1_react_dom__["findDOMNode"](this.getInstance());
      this.enableOnClickOutside();
    };

    _proto.componentDidUpdate = function componentDidUpdate() {
      this.componentNode = __WEBPACK_IMPORTED_MODULE_1_react_dom__["findDOMNode"](this.getInstance());
    };
    /**
     * Remove all document's event listeners for this component
     */

    _proto.componentWillUnmount = function componentWillUnmount() {
      this.disableOnClickOutside();
    };
    /**
     * Can be called to explicitly enable event listening
     * for clicks and touches outside of this element.
     */

    /**
     * Pass-through render
     */
    _proto.render = function render() {
      // eslint-disable-next-line no-unused-vars
      var _props = this.props,
          excludeScrollbar = _props.excludeScrollbar,
          props = _objectWithoutProperties(_props, ["excludeScrollbar"]);

      if (WrappedComponent.prototype.isReactComponent) {
        props.ref = this.getRef;
      } else {
        props.wrappedRef = this.getRef;
      }

      props.disableOnClickOutside = this.disableOnClickOutside;
      props.enableOnClickOutside = this.enableOnClickOutside;
      return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](WrappedComponent, props);
    };

    return onClickOutside;
  }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]), _class.displayName = "OnClickOutside(" + (WrappedComponent.displayName || WrappedComponent.name || 'Component') + ")", _class.defaultProps = {
    eventTypes: ['mousedown', 'touchstart'],
    excludeScrollbar: config && config.excludeScrollbar || false,
    outsideClickIgnoreClass: IGNORE_CLASS_NAME,
    preventDefault: false,
    stopPropagation: false
  }, _class.getClass = function () {
    return WrappedComponent.getClass ? WrappedComponent.getClass() : WrappedComponent;
  }, _temp;
}


/* harmony default export */ __webpack_exports__["a"] = (onClickOutsideHOC);

/***/ }),

/***/ 1278:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */

var REACT_STATICS = {
    childContextTypes: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};

var KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = getPrototypeOf && getPrototypeOf(Object);

function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') {
        // don't hoist over string (html) components

        if (objectPrototype) {
            var inheritedComponent = getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== objectPrototype) {
                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
            }
        }

        var keys = getOwnPropertyNames(sourceComponent);

        if (getOwnPropertySymbols) {
            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
        }

        for (var i = 0; i < keys.length; ++i) {
            var key = keys[i];
            if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }

        return targetComponent;
    }

    return targetComponent;
}

module.exports = hoistNonReactStatics;

/***/ }),

/***/ 1279:
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(1260);
var ITERATOR = __webpack_require__(86)('iterator');
var Iterators = __webpack_require__(187);
module.exports = __webpack_require__(30).getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR] || it['@@iterator'] || Iterators[classof(it)];
};

/***/ }),

/***/ 1280:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__CircleTimer_css__ = __webpack_require__(1305);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__CircleTimer_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__CircleTimer_css__);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var _ref2 = _jsx('circle', {
  fill: 'rgba(255, 217, 6, 0.2)',
  stroke: 'rgba(255, 217, 6, 0.2)',
  strokeWidth: '2',
  cx: '50%',
  cy: '50%',
  r: '50'
});

var CircleTimer = function (_React$Component) {
  _inherits(CircleTimer, _React$Component);

  function CircleTimer() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, CircleTimer);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = CircleTimer.__proto__ || Object.getPrototypeOf(CircleTimer)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      formatedTime: '0:00',
      iId: 0,
      time: 0
    }, _this.componentDidMount = function () {
      _this.setState({
        time: _this.props.time,
        formatedTime: _this.formatTime(_this.props.time)
      });
      _this.startTimer();
    }, _this.componentWillUnmount = function () {
      _this.stopTimer();
    }, _this.formatTime = function (time) {
      var minutes = Math.floor(time / 60);
      var seconds = time % 60;
      if (seconds < 10) {
        seconds = '0' + seconds;
      }
      return minutes + ':' + seconds;
    }, _this.startTimer = function () {
      var self = _this;
      var _this$props = _this.props,
          time = _this$props.time,
          repeat = _this$props.repeat,
          timeUp = _this$props.timeUp;


      var callCallback = function callCallback() {
        setTimeout(timeUp);
      };

      var iId = setInterval(function () {
        if (self.state.time < 1) {
          if (!repeat) {
            try {
              self.stopTimer();
              callCallback();
            } catch (err) {}
          } else {
            self.state.time = time;
          }
        } else {
          self.state.time -= 1;
        }

        var formatedTime = self.formatTime(self.state.time);
        self.setState({ formatedTime: formatedTime });
      }, 1000);
      self.setState({ iId: iId });
    }, _this.stopTimer = function () {
      clearInterval(_this.state.iId);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(CircleTimer, [{
    key: 'render',
    value: function render() {
      var seconds = this.props.time + 's';
      var animationFill = this.props.repeat ? 'remove' : 'freeze';
      return _jsx('svg', {
        className: 'circle-chart',
        viewBox: '0 0 110 110',
        width: '120',
        height: '120',
        xmlns: 'http://www.w3.org/2000/svg'
      }, void 0, _ref2, _jsx('circle', {
        className: __WEBPACK_IMPORTED_MODULE_3__CircleTimer_css___default.a.circleTimerProgress,
        stroke: '#FFD906',
        strokeWidth: '2',
        strokeDasharray: '0,314',
        strokeDashoffset: '314',
        strokeLinecap: 'round',
        fill: 'none',
        cx: '50%',
        cy: '50%',
        r: '50'
      }, void 0, _jsx('animate', {
        attributeName: 'stroke-dasharray',
        dur: seconds,
        begin: '0',
        values: '0,314;314,0',
        fill: animationFill
      })), _jsx('g', {}, void 0, _jsx('text', {
        className: __WEBPACK_IMPORTED_MODULE_3__CircleTimer_css___default.a.circleTimerText,
        x: '50%',
        y: '50%',
        alignmentBaseline: 'central',
        textAnchor: 'middle'
      }, void 0, this.state.formatedTime)));
    }
  }]);

  return CircleTimer;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

CircleTimer.defaultProps = {
  time: 300,
  repeat: false,
  timeUp: function timeUp() {}
};


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_3__CircleTimer_css___default.a)(CircleTimer));

/***/ }),

/***/ 1281:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shared_components_RegexpInput_RegexpInput__ = __webpack_require__(1255);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_helpers_common__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shared_constants_regexp__ = __webpack_require__(317);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var NumberInput = function (_React$Component) {
  _inherits(NumberInput, _React$Component);

  function NumberInput() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, NumberInput);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = NumberInput.__proto__ || Object.getPrototypeOf(NumberInput)).call.apply(_ref, [this].concat(args))), _this), _this.setInputRef = function (inputRef) {
      _this.inputRef = inputRef;
    }, _this.updateSelection = function () {
      var length = _this.inputRef.value.length;


      setTimeout(function () {
        if (_this.inputRef && _this.inputRef.setSelectionRange && _this.inputRef.type === 'text') {
          _this.inputRef.setSelectionRange(length, length);
        }
      }, 0);
    }, _this.handleChange = function (value) {
      return _this.props.onChange(value.replace(/\s/g, ''));
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(NumberInput, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.inputRef && this.props.autoFocus) {
        this.inputRef.focus();
        this.updateSelection();
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      if (prevProps.value !== this.props.value) {
        this.updateSelection();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          value = _props.value,
          separateThousands = _props.separateThousands,
          props = _objectWithoutProperties(_props, ['value', 'separateThousands']);

      var safeValue = value || '';

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_shared_components_RegexpInput_RegexpInput__["a" /* default */], _extends({}, props, {
        pattern: __WEBPACK_IMPORTED_MODULE_4_shared_constants_regexp__["c" /* numberWithSpacesRegexp */],
        value: separateThousands ? __WEBPACK_IMPORTED_MODULE_3_shared_helpers_common__["k" /* numberWithSpaces */](safeValue) : safeValue,
        onChange: this.handleChange,
        inputRef: this.setInputRef
      }));
    }
  }]);

  return NumberInput;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

NumberInput.defaultProps = {
  onChange: function onChange() {},
  value: '',
  autoFocus: false,
  separateThousands: true
};
/* harmony default export */ __webpack_exports__["a"] = (NumberInput);

/***/ }),

/***/ 1282:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// CONCATENATED MODULE: ./src/shared/components/ChooseLanguageDialog/ChooseLanguageDialog.js
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_js_cookie__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_js_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_intl__ = __webpack_require__(474);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_redux__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_redux__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_shared_actions_globals__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_shared_components_ModalWrapper_ModalWrapper__ = __webpack_require__(1275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_shared_components_LeasingOnlineBanner_CircleTimer_CircleTimer__ = __webpack_require__(1280);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_shared_helpers_locale__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_shared_components_UI__ = __webpack_require__(1268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__history__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__ChooseLanguageDialog_css__ = __webpack_require__(1322);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__ChooseLanguageDialog_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__ChooseLanguageDialog_css__);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





// import { FormattedMessage } from 'react-intl';














var cookieKey = 'chlc';

var ChooseLanguageDialog = function (_React$Component) {
  _inherits(ChooseLanguageDialog, _React$Component);

  function ChooseLanguageDialog() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ChooseLanguageDialog);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ChooseLanguageDialog.__proto__ || Object.getPrototypeOf(ChooseLanguageDialog)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      showModal: true
    }, _this.onChoose = function (lang) {
      __WEBPACK_IMPORTED_MODULE_3_js_cookie__["set"](cookieKey, lang);
      var redirectUrl = __WEBPACK_IMPORTED_MODULE_10_shared_helpers_locale__["h" /* toLocalized */](__WEBPACK_IMPORTED_MODULE_12__history__["a" /* default */].location.pathname, lang);
      _this.props.changeLocation(redirectUrl);
      __WEBPACK_IMPORTED_MODULE_12__history__["a" /* default */].push(redirectUrl);
      window.location.reload();
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ChooseLanguageDialog, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var locale = this.props.intl.locale;


      var pathname = __WEBPACK_IMPORTED_MODULE_12__history__["a" /* default */] && __WEBPACK_IMPORTED_MODULE_12__history__["a" /* default */].location && __WEBPACK_IMPORTED_MODULE_12__history__["a" /* default */].location.pathname;
      var lng = __WEBPACK_IMPORTED_MODULE_3_js_cookie__["get"](cookieKey);
      if (locale === 'uk' || lng || pathname !== '/') return null;

      var time = 10;

      return _jsx(__WEBPACK_IMPORTED_MODULE_8_shared_components_ModalWrapper_ModalWrapper__["a" /* default */], {
        toggleModal: function toggleModal() {},
        show: this.state.showModal
      }, void 0, _jsx('h3', {
        className: __WEBPACK_IMPORTED_MODULE_13__ChooseLanguageDialog_css___default.a.title
      }, void 0, '\u041E\u0431\u0435\u0440\u0456\u0442\u044C \u043C\u043E\u0432\u043D\u0443 \u0432\u0435\u0440\u0441\u0456\u044E \u0441\u0430\u0439\u0442\u0443'), _jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_13__ChooseLanguageDialog_css___default.a.text
      }, void 0, '\u042F\u043A\u0449\u043E \u0432\u0438 \u043D\u0435 \u0437\u0440\u043E\u0431\u0438\u0442\u0435 \u0432\u0438\u0431\u0456\u0440, \u0412\u0430\u0441 \u0431\u0443\u0434\u0435 \u0430\u0432\u0442\u043E\u043C\u0430\u0442\u0438\u0447\u043D\u043E \u043D\u0430\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u043E \u043D\u0430 \u0432\u0435\u0440\u0441\u0456\u044E \u0443\u043A\u0440\u0430\u0457\u043D\u0441\u044C\u043A\u043E\u044E \u043C\u043E\u0432\u043E\u044E \u0447\u0435\u0440\u0435\u0437 10 \u0441\u0435\u043A\u0443\u043D\u0434\u2026'), _jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_13__ChooseLanguageDialog_css___default.a.timer + ' container-center'
      }, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_9_shared_components_LeasingOnlineBanner_CircleTimer_CircleTimer__["a" /* default */], {
        time: time,
        timeUp: function timeUp() {
          _this2.onChoose('uk');
        }
      })), _jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_13__ChooseLanguageDialog_css___default.a.buttons
      }, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_11_shared_components_UI__["a" /* Button */], {
        type: 'button',
        userTranslate: false,
        text: '\u0417\u0430\u043B\u0438\u0448\u0438\u0442\u0438\u0441\u044C \u043D\u0430 \u0443\u043A\u0440\u0430\u0457\u043D\u0441\u044C\u043A\u0456\u0439',
        onClick: function onClick() {
          return _this2.onChoose('uk');
        }
      }), _jsx(__WEBPACK_IMPORTED_MODULE_11_shared_components_UI__["a" /* Button */], {
        type: 'button',
        userTranslate: false,
        text: '\u041F\u0435\u0440\u0435\u0439\u0442\u0438 \u043D\u0430 \u0440\u043E\u0441\u0456\u0439\u0441\u044C\u043A\u0443',
        theme: 'DisabledStyle',
        onClick: function onClick() {
          return _this2.onChoose('ru');
        }
      })));
    }
  }]);

  return ChooseLanguageDialog;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    changeLocation: __WEBPACK_IMPORTED_MODULE_5_redux__["b" /* bindActionCreators */](__WEBPACK_IMPORTED_MODULE_7_shared_actions_globals__["r" /* setLocation */], dispatch)
  };
};
/* harmony default export */ var ChooseLanguageDialog_defaultExport = (__WEBPACK_IMPORTED_MODULE_6_react_redux__["b" /* connect */](null, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_13__ChooseLanguageDialog_css___default.a)(__WEBPACK_IMPORTED_MODULE_4_react_intl__["d" /* injectIntl */](ChooseLanguageDialog))));
// CONCATENATED MODULE: ./src/shared/components/Logo/Logo.js
/* harmony import */ var Logo___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var Logo___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(Logo___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var Logo___WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var Logo___WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(Logo___WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var Logo___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var Logo___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(Logo___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_components_Link__ = __webpack_require__(1241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shared_hocs_withTranslate__ = __webpack_require__(1242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_shared_assets_icons_logo_svg__ = __webpack_require__(1339);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_shared_assets_icons_logo_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_shared_assets_icons_logo_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_shared_assets_icons_logo_uk_svg__ = __webpack_require__(1340);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_shared_assets_icons_logo_uk_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_shared_assets_icons_logo_uk_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Logo_css__ = __webpack_require__(1341);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Logo_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__Logo_css__);
var Logo__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();












function Logo(props) {
  var t = props.t;

  var logo = t('locale') === 'uk' ? __WEBPACK_IMPORTED_MODULE_6_shared_assets_icons_logo_uk_svg___default.a : __WEBPACK_IMPORTED_MODULE_5_shared_assets_icons_logo_svg___default.a;
  return Logo__jsx(__WEBPACK_IMPORTED_MODULE_3_shared_components_Link__["a" /* default */], {
    className: __WEBPACK_IMPORTED_MODULE_7__Logo_css___default.a.brandLogo,
    to: '/'
  }, void 0, Logo__jsx('img', {
    src: logo,
    width: '155',
    height: '36',
    style: { display: 'block' },
    title: t('Купить и продать авто в Украине на Автобазар'),
    alt: t('Покупка и продажа авто в Украине на Автобазар')
  }));
}

Logo.defaultProps = {};


/* harmony default export */ var Logo_defaultExport = (Logo___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_7__Logo_css___default.a)(__WEBPACK_IMPORTED_MODULE_4_shared_hocs_withTranslate__["a" /* withTranslate */](Logo)));
// CONCATENATED MODULE: ./src/shared/helpers/abtesting.js
// import { experimentDebugger, emitter } from '@marvelapp/react-ab-test';

var setToDataLayer = function setToDataLayer() {
  window.dataLayer.push(arguments);
};

// const implementExperiment = (experimentName, value) => {
//   console.log(`Experiment: ${experimentName}, Set value ${value}`);
//   emitter.setActiveVariant(experimentName, value);
// };

// export const initOptimizeExperiment = (
//   experimentName,
//   variants = ['0', '1'],
//   defaultVariant = '0',
// ) => {
//   if (process.env.BROWSER && window.App && window.App.optimize && !window.App.optimize.debug) {
//     const experiment = window.App.optimize.experiments.find(e => e.name === experimentName);
//     if (experiment && experiment.id) {
//       setTimeout(() => {
//         setToDataLayer('event', 'optimize.callback', {
//           name: experiment.id,
//           callback: value => {
//             implementExperiment(experimentName, value);
//           },
//         });
//       }, 1);
//     }
//   } else {
//     experimentDebugger.enable();
//   }

//   emitter.defineVariants(experimentName, variants);
//   emitter.setActiveVariant(experimentName, defaultVariant);
// };

var initOptimizeExperiment = function initOptimizeExperiment(experimentName) {
  var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};

  if (true && window.App && window.App.optimize && !window.App.optimize.debug) {
    var experiment = window.App.optimize.experiments.find(function (e) {
      return e.name === experimentName;
    });
    if (experiment && experiment.id) {
      setTimeout(function () {
        setToDataLayer('event', 'optimize.callback', {
          name: experiment.id,
          callback: callback
        });
      }, 1);
    }
  } else {
    callback('0');
  }
};
// CONCATENATED MODULE: ./src/desktop/components/Navigation/NavigationItem/NavigationItem.js
/* harmony import */ var NavigationItem___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var NavigationItem___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(NavigationItem___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var NavigationItem___WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var NavigationItem___WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(NavigationItem___WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var NavigationItem___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var NavigationItem___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(NavigationItem___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(1240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shared_components_NavigationLink_NavigationLink__ = __webpack_require__(1262);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__NavigationItem_css__ = __webpack_require__(1348);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__NavigationItem_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__NavigationItem_css__);
var NavigationItem__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }








function NavigationItem(props) {
  var isActive = props.isActive;

  var _props$item = props.item,
      childItems = _props$item.items,
      item = _objectWithoutProperties(_props$item, ['items']);

  return NavigationItem__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_3_classnames___default.a(__WEBPACK_IMPORTED_MODULE_5__NavigationItem_css___default.a.root, _defineProperty({}, __WEBPACK_IMPORTED_MODULE_5__NavigationItem_css___default.a.active, isActive))
  }, void 0, NavigationItem__jsx(__WEBPACK_IMPORTED_MODULE_4_shared_components_NavigationLink_NavigationLink__["a" /* default */], {
    className: __WEBPACK_IMPORTED_MODULE_5__NavigationItem_css___default.a.link,
    link: item,
    eventPrefix: props.eventPrefix
  }), childItems && childItems.length > 0 && NavigationItem__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_5__NavigationItem_css___default.a.dropdown
  }, void 0, childItems.map(function (child) {
    return NavigationItem__jsx(__WEBPACK_IMPORTED_MODULE_4_shared_components_NavigationLink_NavigationLink__["a" /* default */], {
      className: __WEBPACK_IMPORTED_MODULE_5__NavigationItem_css___default.a.dLink,
      link: child,
      eventPrefix: '' + props.eventPrefix + item.route
    }, child.title);
  })));
}

NavigationItem.defaultProps = {
  isActive: false,
  eventPrefix: ''
};


/* harmony default export */ var NavigationItem_defaultExport = (NavigationItem___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_5__NavigationItem_css___default.a)(NavigationItem));
// CONCATENATED MODULE: ./src/desktop/components/Navigation/ProfileButton/ProfileButton.js
/* harmony import */ var ProfileButton___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var ProfileButton___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(ProfileButton___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var ProfileButton___WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var ProfileButton___WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(ProfileButton___WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(1240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_intl__ = __webpack_require__(474);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_desktop_constants_navigation__ = __webpack_require__(1248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_shared_components_Link_Link__ = __webpack_require__(1241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_shared_helpers_users__ = __webpack_require__(1272);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ProfileButton_css__ = __webpack_require__(1350);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ProfileButton_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__ProfileButton_css__);
var ProfileButton__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();











var ProfileButton__ref = ProfileButton__jsx(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */], {
  id: '\u0412\u044B\u0439\u0442\u0438'
});

function ProfileButton(props) {
  var user = props.user;

  var buttonTitle = __WEBPACK_IMPORTED_MODULE_7_shared_helpers_users__["d" /* getUserThing */](user);
  var avatar = user.avatar;
  var avatarImg = avatar && avatar.replace('http:', 'https:');
  return ProfileButton__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_8__ProfileButton_css___default.a.root
  }, void 0, ProfileButton__jsx(__WEBPACK_IMPORTED_MODULE_6_shared_components_Link_Link__["a" /* default */], {
    className: __WEBPACK_IMPORTED_MODULE_8__ProfileButton_css___default.a.link,
    to: '/my/'
  }, void 0, avatarImg && ProfileButton__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_8__ProfileButton_css___default.a.avatarContainer
  }, void 0, ProfileButton__jsx('img', {
    alt: '',
    src: avatarImg,
    className: __WEBPACK_IMPORTED_MODULE_8__ProfileButton_css___default.a.avatar
  })), ProfileButton__jsx('div', {
    title: buttonTitle,
    className: __WEBPACK_IMPORTED_MODULE_8__ProfileButton_css___default.a.btnTitle
  }, void 0, buttonTitle)), ProfileButton__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_8__ProfileButton_css___default.a.dropdown
  }, void 0, ProfileButton__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_8__ProfileButton_css___default.a.dropdownList
  }, void 0, __WEBPACK_IMPORTED_MODULE_5_desktop_constants_navigation__["a" /* default */].PROFILE.map(function (link) {
    return ProfileButton__jsx(__WEBPACK_IMPORTED_MODULE_6_shared_components_Link_Link__["a" /* default */], {
      className: __WEBPACK_IMPORTED_MODULE_8__ProfileButton_css___default.a.dropdownLink,
      to: link.route
    }, link.route, ProfileButton__jsx(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */], {
      id: link.title
    }));
  }), ProfileButton__jsx(__WEBPACK_IMPORTED_MODULE_6_shared_components_Link_Link__["a" /* default */], {
    onClick: props.logout,
    className: __WEBPACK_IMPORTED_MODULE_2_classnames___default.a(__WEBPACK_IMPORTED_MODULE_8__ProfileButton_css___default.a.dropdownLink, __WEBPACK_IMPORTED_MODULE_8__ProfileButton_css___default.a.logout),
    to: '/login/'
  }, void 0, ProfileButton__ref))));
}

ProfileButton.defaultProps = {
  logout: function logout() {}
};


/* harmony default export */ var ProfileButton_defaultExport = (__WEBPACK_IMPORTED_MODULE_4_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_8__ProfileButton_css___default.a)(ProfileButton));
// CONCATENATED MODULE: ./src/desktop/components/Navigation/Navigation.js
/* harmony import */ var Navigation___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var Navigation___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(Navigation___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(1240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_intl__ = __webpack_require__(474);
/* harmony import */ var Navigation___WEBPACK_IMPORTED_MODULE_6_shared_components_Link_Link__ = __webpack_require__(1241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_desktop_constants_navigation__ = __webpack_require__(1248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_shared_actions_user__ = __webpack_require__(476);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_shared_constants_gtmEvents__ = __webpack_require__(1243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_shared_actions_globals__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_shared_assets_images_add_plus_button_white_svg__ = __webpack_require__(1345);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_shared_assets_images_add_plus_button_white_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_shared_assets_images_add_plus_button_white_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__Navigation_css__ = __webpack_require__(1352);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__Navigation_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__Navigation_css__);
var Navigation__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var Navigation__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function Navigation__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function Navigation__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function Navigation__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






















var _ref2 = Navigation__jsx('img', {
  src: __WEBPACK_IMPORTED_MODULE_12_shared_assets_images_add_plus_button_white_svg___default.a,
  width: '16',
  height: '16',
  alt: '\u041F\u0440\u043E\u0434\u0430\u0442\u044C'
});

var _ref3 = Navigation__jsx(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */], {
  id: '\u041F\u0440\u043E\u0434\u0430\u0442\u044C'
});

var _ref4 = Navigation__jsx(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */], {
  id: '\u0412\u043E\u0439\u0442\u0438'
});

var Navigation_Navigation = function (_React$Component) {
  Navigation__inherits(Navigation, _React$Component);

  function Navigation() {
    var _ref;

    var _temp, _this, _ret;

    Navigation__classCallCheck(this, Navigation);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = Navigation__possibleConstructorReturn(this, (_ref = Navigation.__proto__ || Object.getPrototypeOf(Navigation)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      addLink: '/add/avto/',
      addRel: ''
    }, _this.componentDidMount = function () {
      initOptimizeExperiment('AddFormAB', function (value) {
        var addLinks = {
          '0': { link: '/add/avto/', rel: '' },
          '1': { link: '/addv2/avto/', rel: 'nofollow' }
        };
        if (value && addLinks[value]) {
          _this.setState({
            addLink: addLinks[value].link,
            addRel: addLinks[value].rel
          });
        }
      });
    }, _this.handleSellClick = function () {
      _this.props.setDataLayer(__WEBPACK_IMPORTED_MODULE_9_shared_constants_gtmEvents__["a" /* EVENTS */].sellCarButtonClick);
    }, _temp), Navigation__possibleConstructorReturn(_this, _ret);
  }

  Navigation__createClass(Navigation, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          user = _props.user,
          history = _props.history,
          current = _props.current,
          shouldSetNoIndex = _props.shouldSetNoIndex;

      var token = user && user.token;

      var currentPath = history.currentPath;

      var currentRoute = current || __WEBPACK_IMPORTED_MODULE_7_desktop_constants_navigation__["a" /* default */].HEADER.filter(function (a) {
        var route = typeof a.route === 'string' && a.route || '';
        currentPath = typeof currentPath === 'string' && currentPath || '';
        return new RegExp('^' + route, 'mi').test(currentPath);
      })[0];

      return Navigation__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_16__Navigation_css___default.a.root,
        role: 'navigation'
      }, void 0, Navigation__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_16__Navigation_css___default.a.left
      }, void 0, Navigation__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_16__Navigation_css___default.a.flexRow
      }, void 0, __WEBPACK_IMPORTED_MODULE_7_desktop_constants_navigation__["a" /* default */].HEADER.map(function (item, i) {
        return Navigation__jsx('div', {
          className: __WEBPACK_IMPORTED_MODULE_1_classnames___default.a(__WEBPACK_IMPORTED_MODULE_16__Navigation_css___default.a.navItem)
        }, i, Navigation__jsx(NavigationItem_defaultExport, {
          item: item,
          isActive: item === currentRoute,
          eventPrefix: 'headerNavigation'
        }));
      }))), Navigation__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_16__Navigation_css___default.a.right
      }, void 0, Navigation__jsx(Navigation___WEBPACK_IMPORTED_MODULE_6_shared_components_Link_Link__["a" /* default */], {
        onClick: this.handleSellClick,
        className: __WEBPACK_IMPORTED_MODULE_1_classnames___default.a(__WEBPACK_IMPORTED_MODULE_16__Navigation_css___default.a.link, __WEBPACK_IMPORTED_MODULE_16__Navigation_css___default.a.sell),
        to: this.state.addLink,
        rel: this.state.addRel
      }, void 0, _ref2, '\xA0', _ref3), token && user ? Navigation__jsx(ProfileButton_defaultExport, {
        logout: this.props.userLogout,
        user: user.user
      }) : Navigation__jsx(Navigation___WEBPACK_IMPORTED_MODULE_6_shared_components_Link_Link__["a" /* default */], {
        className: __WEBPACK_IMPORTED_MODULE_1_classnames___default.a(__WEBPACK_IMPORTED_MODULE_16__Navigation_css___default.a.link, __WEBPACK_IMPORTED_MODULE_16__Navigation_css___default.a.highlight),
        shouldSetNoIndex: shouldSetNoIndex,
        to: '/login',
        rel: 'nofollow'
      }, void 0, _ref4)));
    }
  }]);

  return Navigation;
}(Navigation___WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Navigation_Navigation.defaultProps = {
  user: {},
  history: {},
  current: null,
  shouldSetNoIndex: true
};


var Navigation_mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    userLogout: function userLogout() {
      return dispatch(__WEBPACK_IMPORTED_MODULE_8_shared_actions_user__["t" /* userLogout */]());
    },
    setDataLayer: __WEBPACK_IMPORTED_MODULE_4_redux__["b" /* bindActionCreators */](__WEBPACK_IMPORTED_MODULE_10_shared_actions_globals__["j" /* setDataLayer */], dispatch)
  };
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    user: state.user,
    history: state.history
  };
};

/* harmony default export */ var Navigation_defaultExport = (__WEBPACK_IMPORTED_MODULE_13_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_16__Navigation_css___default.a)(__WEBPACK_IMPORTED_MODULE_3_react_redux__["b" /* connect */](mapStateToProps, Navigation_mapDispatchToProps)(Navigation_Navigation)));
// CONCATENATED MODULE: ./src/desktop/components/Header/Header.js
/* harmony import */ var Header___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var Header___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(Header___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var Header___WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(1240);
/* harmony import */ var Header___WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(Header___WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var Header___WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(131);
/* harmony import */ var Header___WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(Header___WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_nprogress__ = __webpack_require__(1338);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_nprogress___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_nprogress__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Header_css__ = __webpack_require__(1343);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Header_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__Header_css__);
var Header__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var Header__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function Header__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function Header__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function Header__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }













var NProgresStart = false;
var NProgresTimeoutStart = void 0;
var NProgresTimeoutDone = void 0;

var Header__ref = Header__jsx(Logo_defaultExport, {});

var Header__ref2 = Header__jsx(Navigation_defaultExport, {});

var Header = function (_React$Component) {
  Header__inherits(Header, _React$Component);

  function Header() {
    Header__classCallCheck(this, Header);

    return Header__possibleConstructorReturn(this, (Header.__proto__ || Object.getPrototypeOf(Header)).apply(this, arguments));
  }

  Header__createClass(Header, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      __WEBPACK_IMPORTED_MODULE_3_react_nprogress___default.a.configure({
        showSpinner: false
      });
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      var loading = this.props.loading;

      if (loading.start && !NProgresStart) {
        NProgresStart = true;
        NProgresTimeoutStart = setTimeout(function () {
          __WEBPACK_IMPORTED_MODULE_3_react_nprogress___default.a.start();
        }, 300);
      }

      if (!loading.start) {
        clearTimeout(NProgresTimeoutDone);
        NProgresTimeoutDone = setTimeout(function () {
          clearTimeout(NProgresTimeoutStart);
          NProgresStart = false;
          __WEBPACK_IMPORTED_MODULE_3_react_nprogress___default.a.done();
        }, 500);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return Header__jsx('div', {
        className: Header___WEBPACK_IMPORTED_MODULE_1_classnames___default.a(__WEBPACK_IMPORTED_MODULE_7__Header_css___default.a.root, __WEBPACK_IMPORTED_MODULE_7__Header_css___default.a.fixed)
      }, void 0, Header__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_7__Header_css___default.a.container
      }, void 0, Header__ref, Header__ref2));
    }
  }]);

  return Header;
}(Header___WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Header.defaultProps = {
  location: null,
  locations: null
};


var Header_mapStateToProps = function mapStateToProps(_ref3) {
  var loading = _ref3.loading;
  return {
    loading: loading
  };
};

/* harmony default export */ var Header_defaultExport = (__WEBPACK_IMPORTED_MODULE_5_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_7__Header_css___default.a)(__WEBPACK_IMPORTED_MODULE_4_react_redux__["b" /* connect */](Header_mapStateToProps)(Header)));
// CONCATENATED MODULE: ./src/desktop/components/Balance/Balance.js
/* harmony import */ var Balance___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var Balance___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(Balance___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var Balance___WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var Balance___WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(Balance___WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_onclickoutside__ = __webpack_require__(1276);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_addons_css_transition_group__ = __webpack_require__(1273);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_addons_css_transition_group___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_addons_css_transition_group__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_desktop_components_BalanceRefill_BalanceRefill__ = __webpack_require__(1288);
/* harmony import */ var Balance___WEBPACK_IMPORTED_MODULE_6_shared_components_Link_Link__ = __webpack_require__(1241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_shared_hocs_withBalance__ = __webpack_require__(1259);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_shared_assets_images_credit_card_svg__ = __webpack_require__(1265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_shared_assets_images_credit_card_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_shared_assets_images_credit_card_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Balance_css__ = __webpack_require__(1371);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Balance_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__Balance_css__);
var Balance__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var Balance__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function Balance__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function Balance__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function Balance__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }














var Balance = function (_React$Component) {
  Balance__inherits(Balance, _React$Component);

  function Balance() {
    var _ref;

    var _temp, _this, _ret;

    Balance__classCallCheck(this, Balance);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = Balance__possibleConstructorReturn(this, (_ref = Balance.__proto__ || Object.getPrototypeOf(Balance)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      isPopupOpened: false,
      shouldFreeze: false
    }, _this.togglePopup = function (e) {
      e.preventDefault();
      _this.setState(function (_ref2) {
        var isPopupOpened = _ref2.isPopupOpened;
        return { isPopupOpened: !isPopupOpened };
      });
    }, _this.handleClickOutside = function () {
      if (!_this.state.shouldFreeze) {
        _this.setState({ isPopupOpened: false });
      }
    }, _this.handleModalOpen = function () {
      _this.setState({ shouldFreeze: true });
    }, _this.handleModalClose = function () {
      _this.setState({ shouldFreeze: false });
    }, _temp), Balance__possibleConstructorReturn(_this, _ret);
  }

  Balance__createClass(Balance, [{
    key: 'render',
    value: function render() {
      var balance = this.props.balance;
      var isPopupOpened = this.state.isPopupOpened;


      if (balance === null) {
        return null;
      }

      return Balance__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_9__Balance_css___default.a.root
      }, void 0, Balance__jsx(Balance___WEBPACK_IMPORTED_MODULE_6_shared_components_Link_Link__["a" /* default */], {
        to: '/billing/',
        className: __WEBPACK_IMPORTED_MODULE_9__Balance_css___default.a.content,
        onClick: this.togglePopup
      }, void 0, Balance__jsx('img', {
        className: __WEBPACK_IMPORTED_MODULE_9__Balance_css___default.a.icon,
        src: __WEBPACK_IMPORTED_MODULE_8_shared_assets_images_credit_card_svg___default.a,
        alt: '',
        height: 22
      }), '  ', ' ', Balance__jsx('span', {
        className: __WEBPACK_IMPORTED_MODULE_9__Balance_css___default.a.title
      }, void 0, balance, ' \u0433\u0440\u043D')), Balance__jsx(__WEBPACK_IMPORTED_MODULE_4_react_addons_css_transition_group___default.a, {
        transitionName: 'fadeUp',
        transitionEnterTimeout: 100,
        transitionLeaveTimeout: 100
      }, void 0, isPopupOpened && Balance__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_9__Balance_css___default.a.popup
      }, void 0, Balance__jsx(__WEBPACK_IMPORTED_MODULE_5_desktop_components_BalanceRefill_BalanceRefill__["a" /* default */], {
        onModalOpen: this.handleModalOpen,
        onModalClose: this.handleModalClose
      }))));
    }
  }]);

  return Balance;
}(Balance___WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Balance.defaultProps = {
  balance: null
};


/* harmony default export */ var Balance_defaultExport = (__WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_9__Balance_css___default.a)(__WEBPACK_IMPORTED_MODULE_7_shared_hocs_withBalance__["a" /* default */]()(__WEBPACK_IMPORTED_MODULE_2_react_onclickoutside__["a" /* default */](Balance))));
// CONCATENATED MODULE: ./src/desktop/components/SubHeader/SubHeader.js
/* harmony import */ var SubHeader___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var SubHeader___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(SubHeader___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var SubHeader___WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var SubHeader___WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(SubHeader___WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var SubHeader___WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(1240);
/* harmony import */ var SubHeader___WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(SubHeader___WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var SubHeader___WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var SubHeader___WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(SubHeader___WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var SubHeader___WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__(307);
/* harmony import */ var SubHeader___WEBPACK_IMPORTED_MODULE_5_react_intl__ = __webpack_require__(474);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_shared_components_Link__ = __webpack_require__(1241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__InlineNav_InlineNav__ = __webpack_require__(1284);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__SubHeader_css__ = __webpack_require__(1373);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__SubHeader_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__SubHeader_css__);
var SubHeader__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var SubHeader__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function SubHeader__defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function SubHeader__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function SubHeader__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function SubHeader__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }












var SubHeader__ref2 = SubHeader__jsx(Balance_defaultExport, {});

var SubHeader = function (_React$Component) {
  SubHeader__inherits(SubHeader, _React$Component);

  function SubHeader() {
    var _ref;

    var _temp, _this, _ret;

    SubHeader__classCallCheck(this, SubHeader);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = SubHeader__possibleConstructorReturn(this, (_ref = SubHeader.__proto__ || Object.getPrototypeOf(SubHeader)).call.apply(_ref, [this].concat(args))), _this), _this.isActive = function (tariff) {
      var expireDate = tariff && tariff.expire_date && new Date(tariff.expire_date);
      var today = new Date();

      return expireDate > today;
    }, _temp), SubHeader__possibleConstructorReturn(_this, _ret);
  }

  SubHeader__createClass(SubHeader, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          navLinks = _props.navLinks,
          currentRoute = _props.currentRoute,
          personalSubheader = _props.personalSubheader,
          user = _props.user,
          including = _props.including,
          intl = _props.intl;

      var sparePartsTariff = user && user.spareparts_tariff;

      return SubHeader__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_9__SubHeader_css___default.a.root,
        role: 'navigation'
      }, void 0, SubHeader__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_9__SubHeader_css___default.a.container
      }, void 0, SubHeader__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_9__SubHeader_css___default.a.left
      }, void 0, SubHeader__jsx(__WEBPACK_IMPORTED_MODULE_7__InlineNav_InlineNav__["a" /* default */], {
        navLinks: navLinks,
        currentRoute: currentRoute,
        including: including,
        eventPrefix: 'subHeader'
      })), SubHeader__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_9__SubHeader_css___default.a.right
      }, void 0, personalSubheader && SubHeader__jsx('div', {}, void 0, sparePartsTariff && sparePartsTariff.slug && SubHeader__jsx(__WEBPACK_IMPORTED_MODULE_6_shared_components_Link__["a" /* default */], {
        to: '/profile/',
        className: SubHeader___WEBPACK_IMPORTED_MODULE_2_classnames___default.a(__WEBPACK_IMPORTED_MODULE_9__SubHeader_css___default.a.tariff, SubHeader__defineProperty({}, __WEBPACK_IMPORTED_MODULE_9__SubHeader_css___default.a.nonActiveTariff, !this.isActive(sparePartsTariff))),
        title: this.isActive(sparePartsTariff) ? undefined : intl.formatMessage({ id: 'Действие пакета закончилось' })
      }, void 0, SubHeader__jsx(SubHeader___WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */], {
        id: sparePartsTariff.title
      })), user.tariff && user.tariff.is_business && SubHeader__jsx(__WEBPACK_IMPORTED_MODULE_6_shared_components_Link__["a" /* default */], {
        to: '/profile/',
        className: SubHeader___WEBPACK_IMPORTED_MODULE_2_classnames___default.a(__WEBPACK_IMPORTED_MODULE_9__SubHeader_css___default.a.tariff, SubHeader__defineProperty({}, __WEBPACK_IMPORTED_MODULE_9__SubHeader_css___default.a.nonActiveTariff, !this.isActive(user.tariff))),
        title: this.isActive(user.tariff) ? undefined : intl.formatMessage({ id: 'Действие пакета закончилось' })
      }, void 0, SubHeader__jsx(SubHeader___WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */], {
        id: user.tariff.title
      })), SubHeader__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_9__SubHeader_css___default.a.balance
      }, void 0, SubHeader__ref2)))));
    }
  }]);

  return SubHeader;
}(SubHeader___WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

SubHeader.defaultProps = {
  currentRoute: ''
};


var SubHeader_mapStateToProps = function mapStateToProps(_ref3) {
  var user = _ref3.user;
  return {
    user: user.user
  };
};

/* harmony default export */ var SubHeader_defaultExport = (SubHeader___WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_9__SubHeader_css___default.a)(SubHeader___WEBPACK_IMPORTED_MODULE_4_react_redux__["b" /* connect */](SubHeader_mapStateToProps, {})(SubHeader___WEBPACK_IMPORTED_MODULE_5_react_intl__["d" /* injectIntl */](SubHeader))));
// CONCATENATED MODULE: ./src/shared/hocs/withFooterLocations.js
/* harmony import */ var withFooterLocations___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var withFooterLocations___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(withFooterLocations___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var withFooterLocations___WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var withFooterLocations___WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(withFooterLocations___WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_actions_globals__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shared_helpers_common__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_shared_helpers_locale__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_shared_modules__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__history__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__helpers_urls__ = __webpack_require__(312);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var withFooterLocations__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function withFooterLocations__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function withFooterLocations__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function withFooterLocations__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











var withFooterLocations = function withFooterLocations(WrappedComponent) {
  var _class, _temp2;

  return _temp2 = _class = function (_React$Component) {
    withFooterLocations__inherits(_class, _React$Component);

    function _class() {
      var _ref;

      var _temp, _this, _ret;

      withFooterLocations__classCallCheck(this, _class);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = withFooterLocations__possibleConstructorReturn(this, (_ref = _class.__proto__ || Object.getPrototypeOf(_class)).call.apply(_ref, [this].concat(args))), _this), _this.getPath = function (routeName, state, location) {
        var transport = state.transport || _this.props.seoSearchUrlResponse && _this.props.seoSearchUrlResponse.transport;
        var make = state.make && state.make.slug || _this.props.seoSearchUrlResponse && _this.props.seoSearchUrlResponse.make;

        var params = _extends({}, state, { make: make, transport: transport, location: location });

        switch (routeName) {
          case 'search':
            return __WEBPACK_IMPORTED_MODULE_8__helpers_urls__["e" /* generateSearchUrl */](params);
          case 'moto':
            return '/moto/' + (location ? location.slug : '') + '/';
          case 'commercial':
            return '/commercial/' + (location ? location.slug : '') + '/';
          case 'dealers':
            return __WEBPACK_IMPORTED_MODULE_8__helpers_urls__["a" /* generateDealersSearchUrl */](params);
          case 'firms':
            return __WEBPACK_IMPORTED_MODULE_8__helpers_urls__["b" /* generateFirmsSearchUrl */](params);
          case 'auto-parts':
            return __WEBPACK_IMPORTED_MODULE_8__helpers_urls__["f" /* generateSparesSearchUrl */](params);

          default:
            if (transport && transport.slug) {
              return '/' + transport.slug + '/' + (location ? location.slug : '') + '/';
            }

            return location ? location.slug : '';
        }
      }, _this.handleLinkClick = function (e, location) {
        var routeName = _this.props.routeName;

        e.preventDefault();
        _this.props.onLocationChange(location);

        if (routeName) {
          __WEBPACK_IMPORTED_MODULE_7__history__["a" /* default */].push(_this.updateUrl(location));
        } else {
          __WEBPACK_IMPORTED_MODULE_7__history__["a" /* default */].push();
        }
      }, _this.updateUrl = function (location, url) {
        var _this$props = _this.props,
            formState = _this$props.formState,
            locale = _this$props.locale,
            routeName = _this$props.routeName;

        var state = _extends({}, formState, { location: location });
        var pathname = _this.getPath(routeName, state, location);

        if (url) {
          return __WEBPACK_IMPORTED_MODULE_5_shared_helpers_locale__["h" /* toLocalized */](__WEBPACK_IMPORTED_MODULE_6_shared_modules__["v" /* urlReplaceSlash */](url), locale);
        }

        if (routeName === 'home' && typeof pathname === 'string' && pathname.includes('avto/')) {
          return __WEBPACK_IMPORTED_MODULE_5_shared_helpers_locale__["h" /* toLocalized */](__WEBPACK_IMPORTED_MODULE_6_shared_modules__["v" /* urlReplaceSlash */](pathname), locale);
        }

        return __WEBPACK_IMPORTED_MODULE_5_shared_helpers_locale__["h" /* toLocalized */](__WEBPACK_IMPORTED_MODULE_6_shared_modules__["v" /* urlReplaceSlash */]('/' + (routeName === 'home' ? 'avto/' : '') + pathname + '/'), locale);
      }, _temp), withFooterLocations__possibleConstructorReturn(_this, _ret);
    }

    withFooterLocations__createClass(_class, [{
      key: 'render',
      value: function render() {
        return withFooterLocations___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(WrappedComponent, _extends({}, this.props, {
          getPath: this.getPath,
          updateUrl: this.updateUrl,
          handleLinkClick: this.handleLinkClick
        }));
      }
    }]);

    return _class;
  }(withFooterLocations___WEBPACK_IMPORTED_MODULE_0_react___default.a.Component), _class.displayName = 'withFooterLocations(' + __WEBPACK_IMPORTED_MODULE_4_shared_helpers_common__["e" /* getDisplayName */](WrappedComponent) + ')', _class.defaultProps = {
    list: [],
    className: '',
    historyStore: {},
    locationLinkBuilder: null,
    routeName: null,
    resetHeader: null,
    seoSearchUrlResponse: {}
  }, _temp2;
};

var withFooterLocations_mapStateToProps = function mapStateToProps(_ref2) {
  var globals = _ref2.globals,
      historyState = _ref2.history,
      searchForm = _ref2.searchForm;
  return {
    locale: globals.locale,
    location: globals.location,
    routeName: historyState && historyState.currentRouteName,
    formState: searchForm && searchForm.selected,
    currentPath: historyState.currentPath,
    seoSearchUrlResponse: globals.seoSearchUrlResponse
  };
};
var withFooterLocations_mapDispatchToProps = {
  onLocationChange: __WEBPACK_IMPORTED_MODULE_3_shared_actions_globals__["r" /* setLocation */]
};

/* harmony default export */ var withFooterLocations_defaultExport = (function (component) {
  return __WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */](withFooterLocations_mapStateToProps, withFooterLocations_mapDispatchToProps)(withFooterLocations(component));
});
// CONCATENATED MODULE: ./src/desktop/components/Footer/ColumnList/ColumnList.js
/* harmony import */ var ColumnList___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var ColumnList___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(ColumnList___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var ColumnList___WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var ColumnList___WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(ColumnList___WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var ColumnList___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var ColumnList___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(ColumnList___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shared_components_Link_Link__ = __webpack_require__(1241);
/* harmony import */ var ColumnList___WEBPACK_IMPORTED_MODULE_5_react_intl__ = __webpack_require__(474);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames__ = __webpack_require__(1240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ColumnList_css__ = __webpack_require__(1376);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ColumnList_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__ColumnList_css__);
var ColumnList__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var ColumnList__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function ColumnList__defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function ColumnList__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function ColumnList__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function ColumnList__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var ColumnList__ref2 = ColumnList__jsx('span', {}, void 0, '> ');

var ColumnList = function (_React$Component) {
  ColumnList__inherits(ColumnList, _React$Component);

  function ColumnList() {
    var _ref;

    var _temp, _this, _ret;

    ColumnList__classCallCheck(this, ColumnList);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = ColumnList__possibleConstructorReturn(this, (_ref = ColumnList.__proto__ || Object.getPrototypeOf(ColumnList)).call.apply(_ref, [this].concat(args))), _this), _this.buildBreadCrumbs = function (selectedLocation, titleKey) {
      if (selectedLocation.is_admin_center) {
        var region = selectedLocation.parents.find(function (item) {
          return item.is_region;
        });
        return ColumnList__jsx(ColumnList___WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment, {}, void 0, ColumnList__jsx(__WEBPACK_IMPORTED_MODULE_4_shared_components_Link_Link__["a" /* default */], {
          to: _this.props.updateUrl(region),
          className: __WEBPACK_IMPORTED_MODULE_6_classnames___default.a(__WEBPACK_IMPORTED_MODULE_7__ColumnList_css___default.a.resetLocationLink, __WEBPACK_IMPORTED_MODULE_7__ColumnList_css___default.a.curentBreadCrumbs, __WEBPACK_IMPORTED_MODULE_7__ColumnList_css___default.a.cursorPointer)
        }, void 0, ColumnList__jsx('span', {
          className: __WEBPACK_IMPORTED_MODULE_7__ColumnList_css___default.a.hideHover
        }, void 0, '> '), region[titleKey]), ColumnList__jsx('span', {
          className: __WEBPACK_IMPORTED_MODULE_6_classnames___default.a(__WEBPACK_IMPORTED_MODULE_7__ColumnList_css___default.a.resetLocationLink, __WEBPACK_IMPORTED_MODULE_7__ColumnList_css___default.a.curentBreadCrumbs)
        }, void 0, ColumnList__ref2, selectedLocation[titleKey]));
      }
      return ColumnList__jsx('span', {
        className: __WEBPACK_IMPORTED_MODULE_6_classnames___default.a(__WEBPACK_IMPORTED_MODULE_7__ColumnList_css___default.a.resetLocationLink, __WEBPACK_IMPORTED_MODULE_7__ColumnList_css___default.a.curentBreadCrumbs)
      }, void 0, '> ', selectedLocation[titleKey]);
    }, _temp), ColumnList__possibleConstructorReturn(_this, _ret);
  }

  ColumnList__createClass(ColumnList, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          list = _props.list,
          className = _props.className,
          resetHeader = _props.resetHeader,
          updateUrl = _props.updateUrl,
          search = _props.search,
          selectedLocation = _props.selectedLocation,
          isRegion = _props.isRegion,
          titleKey = _props.titleKey;


      return ColumnList__jsx('div', {
        className: !isRegion ? __WEBPACK_IMPORTED_MODULE_7__ColumnList_css___default.a.root : ''
      }, void 0, ColumnList__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_7__ColumnList_css___default.a.breadCrumbsBlock
      }, void 0, search ? ColumnList__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_7__ColumnList_css___default.a.resetLocationText
      }, void 0, resetHeader) : isRegion && ColumnList__jsx(ColumnList___WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment, {}, void 0, ColumnList__jsx(__WEBPACK_IMPORTED_MODULE_4_shared_components_Link_Link__["a" /* default */], {
        to: updateUrl(null),
        className: __WEBPACK_IMPORTED_MODULE_7__ColumnList_css___default.a.resetLocationLink
      }, void 0, resetHeader), selectedLocation && this.buildBreadCrumbs(selectedLocation, titleKey))), ColumnList__jsx('div', {
        className: className
      }, void 0, list.map(function (columnItems) {
        return ColumnList__jsx('ul', {
          className: __WEBPACK_IMPORTED_MODULE_7__ColumnList_css___default.a.column
        }, columnItems[0].id, columnItems.map(function (columnItem) {
          if ((columnItem.disabled || columnItem.selectedLocation) && !search) {
            return ColumnList__jsx('p', {
              className: __WEBPACK_IMPORTED_MODULE_6_classnames___default.a(__WEBPACK_IMPORTED_MODULE_7__ColumnList_css___default.a.disabledCity, ColumnList__defineProperty({}, __WEBPACK_IMPORTED_MODULE_7__ColumnList_css___default.a.selLocation, columnItem.selectedLocation))
            }, columnItem.id, columnItem[titleKey]);
          }
          return ColumnList__jsx('li', {
            className: __WEBPACK_IMPORTED_MODULE_7__ColumnList_css___default.a.item
          }, columnItem.id + '-link', ColumnList__jsx(__WEBPACK_IMPORTED_MODULE_4_shared_components_Link_Link__["a" /* default */], {
            to: search ? updateUrl(null, columnItem.url) : updateUrl(columnItem),
            className: __WEBPACK_IMPORTED_MODULE_7__ColumnList_css___default.a.link,
            title: columnItem.hint
          }, void 0, columnItem[titleKey]));
        }));
      })));
    }
  }]);

  return ColumnList;
}(ColumnList___WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

ColumnList.defaultProps = {
  list: [],
  className: '',
  titleKey: 'title',
  locationLinkBuilder: null,
  routeName: null,
  resetHeader: null,
  search: false,
  isRegion: false,
  selectedLocation: undefined
};


/* harmony default export */ var ColumnList_defaultExport = (withFooterLocations_defaultExport(ColumnList___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_7__ColumnList_css___default.a)(ColumnList___WEBPACK_IMPORTED_MODULE_5_react_intl__["d" /* injectIntl */](ColumnList))));
// CONCATENATED MODULE: ./src/desktop/components/Footer/LocationList/LocationList.js
/* harmony import */ var LocationList___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var LocationList___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(LocationList___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var LocationList___WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var LocationList___WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(LocationList___WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_intl__ = __webpack_require__(474);
/* harmony import */ var LocationList___WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var LocationList___WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(LocationList___WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__LocationList_css__ = __webpack_require__(1378);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__LocationList_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__LocationList_css__);
var LocationList__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var LocationList__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function LocationList__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function LocationList__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function LocationList__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var isMobile = "desktop" === 'mobile';

var LocationList_LocationList = function (_Component) {
  LocationList__inherits(LocationList, _Component);

  function LocationList() {
    var _ref;

    var _temp, _this, _ret;

    LocationList__classCallCheck(this, LocationList);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = LocationList__possibleConstructorReturn(this, (_ref = LocationList.__proto__ || Object.getPrototypeOf(LocationList)).call.apply(_ref, [this].concat(args))), _this), _this.createColumns = function (arr, columnCount) {
      var maxColumnLength = Math.ceil(arr.length / columnCount);

      return arr.reduce(function (result, item, i) {
        return i % (maxColumnLength > 6 ? 6 : maxColumnLength) === 0 ? [].concat(_toConsumableArray(result), [[item]]) : [].concat(_toConsumableArray(result.slice(0, result.length - 1)), [[].concat(_toConsumableArray(result[result.length - 1]), [item])]);
      }, []);
    }, _temp), LocationList__possibleConstructorReturn(_this, _ret);
  }

  LocationList__createClass(LocationList, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          cities = _props.cities,
          columnCount = _props.columnCount,
          search = _props.search,
          selectedLocation = _props.selectedLocation,
          isRegion = _props.isRegion,
          titleKey = _props.titleKey,
          title = _props.title;

      var citiesColumns = this.createColumns(cities, columnCount);
      var rooClass = isMobile ? __WEBPACK_IMPORTED_MODULE_5__LocationList_css___default.a.rootMobile : __WEBPACK_IMPORTED_MODULE_5__LocationList_css___default.a.root;
      return LocationList__jsx('div', {
        className: rooClass
      }, void 0, title && LocationList__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_5__LocationList_css___default.a.title
      }, void 0, title), LocationList__jsx('div', {}, void 0, LocationList__jsx(ColumnList_defaultExport, {
        selectedLocation: selectedLocation,
        search: search,
        isRegion: isRegion,
        resetHeader: isRegion ? LocationList__jsx(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */], {
          id: search ? 'Популярные запросы' : 'Вся Украина'
        }) : '',
        list: citiesColumns,
        className: __WEBPACK_IMPORTED_MODULE_5__LocationList_css___default.a.citiesList,
        titleKey: titleKey
      })));
    }
  }]);

  return LocationList;
}(LocationList___WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

LocationList_LocationList.defaultProps = {
  countries: [],
  cities: [],
  columnCount: 5,
  search: false,
  isRegion: false,
  selectedLocation: undefined,
  titleKey: 'title',
  title: ''
};


/* harmony default export */ var LocationList_defaultExport = (LocationList___WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_5__LocationList_css___default.a)(LocationList_LocationList));
// CONCATENATED MODULE: ./src/desktop/components/Footer/Footer.js
/* harmony import */ var Footer___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var Footer___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(Footer___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var Footer___WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var Footer___WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(Footer___WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var Footer___WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(307);
/* harmony import */ var Footer___WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var Footer___WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(Footer___WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var Footer___WEBPACK_IMPORTED_MODULE_4_react_intl__ = __webpack_require__(474);
/* harmony import */ var Footer___WEBPACK_IMPORTED_MODULE_5_shared_helpers_locale__ = __webpack_require__(102);
/* harmony import */ var Footer___WEBPACK_IMPORTED_MODULE_6_shared_components_Link_Link__ = __webpack_require__(1241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_shared_helpers_arrays__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_shared_constants_json_countries_json__ = __webpack_require__(310);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_shared_constants_json_countries_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_shared_constants_json_countries_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Footer_css__ = __webpack_require__(1266);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Footer_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__Footer_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__constants_navigation__ = __webpack_require__(1248);
var Footer__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();
















var Footer__ref4 = Footer__jsx(Footer___WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */], {
  id: '\u041F\u043E\u043B\u0438\u0442\u0438\u043A\u0430 \u043A\u043E\u043D\u0444\u0438\u0434\u0435\u043D\u0446\u0438\u0430\u043B\u044C\u043D\u043E\u0441\u0442\u0438'
});

var _ref5 = Footer__jsx(Footer___WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */], {
  id: '\u041F\u0440\u0430\u0432\u0438\u043B\u0430 \u043F\u0443\u0431\u043B\u0438\u043A\u0430\u0446\u0438\u0438 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0439'
});

var _ref6 = Footer__jsx(Footer___WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */], {
  id: '\u041F\u0443\u0431\u043B\u0438\u0447\u043D\u044B\u0439 \u0434\u043E\u0433\u043E\u0432\u043E\u0440'
});

var _ref7 = Footer__jsx(Footer___WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */], {
  id: '\u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440\u2122'
});

var _ref8 = Footer__jsx(Footer___WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */], {
  id: '\u2013 \u041A\u0443\u043F\u0438\u0442\u044C \u043D\u043E\u0432\u043E\u0435 \u0430\u0432\u0442\u043E \u0438\u043B\u0438 \u043F\u0440\u043E\u0434\u0430\u0442\u044C \u0431\u0443 \u0441 \u043F\u0440\u043E\u0431\u0435\u0433\u043E\u043C \u0432 \u0423\u043A\u0440\u0430\u0438\u043D\u0435'
});

function Footer(props) {
  var languages = props.languages,
      currentPath = props.currentPath,
      intl = props.intl,
      locale = props.locale,
      hideLocations = props.hideLocations,
      _props$seoSearchUrlRe = props.seoSearchUrlResponse,
      make = _props$seoSearchUrlRe.make,
      trends = _props$seoSearchUrlRe.trends,
      seoLocations = _props$seoSearchUrlRe.locations,
      selectedLocation = _props$seoSearchUrlRe.location;


  var socialLinks = [{ icon: 'twitter', link: 'https://twitter.com/avtobazar' }, { icon: 'facebook', link: 'https://www.facebook.com/AvtoBazar' }, { icon: 'instagram', link: 'https://www.instagram.com/avtobazar_ua/' }, { icon: 'youtube-play', link: 'https://www.youtube.com/avtobazar' }];
  var allLocations = Footer___WEBPACK_IMPORTED_MODULE_5_shared_helpers_locale__["b" /* getAllLocations */]().map(Footer___WEBPACK_IMPORTED_MODULE_5_shared_helpers_locale__["g" /* setActiveLocations */](seoLocations, selectedLocation));
  var cities = allLocations.filter(function (item) {
    return item.is_admin_center;
  }).sort(__WEBPACK_IMPORTED_MODULE_7_shared_helpers_arrays__["b" /* compareByTitle */]);
  var regions = allLocations.filter(function (item) {
    return item.is_region;
  }).sort(__WEBPACK_IMPORTED_MODULE_7_shared_helpers_arrays__["b" /* compareByTitle */]);

  var hideRegLocValues = ['/add/', '/zhurnal/', '/service/'];
  var hideRegLocations = hideRegLocValues.some(function (item) {
    return currentPath.includes(item);
  });

  var formattedTrends = [];
  if (trends) {
    formattedTrends = trends.map(function (a, b) {
      return {
        id: b,
        slug: '',
        title: a['title_' + intl.locale],
        hint: a['text_' + intl.locale],
        url: a.url
      };
    }).filter(function (a, b) {
      return b < 30;
    });
  }
  var titleKey = locale === 'uk' ? 'uk_title' : 'title';

  return Footer__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_9__Footer_css___default.a.root
  }, void 0, Footer__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_9__Footer_css___default.a.container
  }, void 0, Footer__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_9__Footer_css___default.a.flexContainer
  }, void 0, Footer__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_9__Footer_css___default.a.left
  }, void 0, Footer__jsx('ul', {
    className: __WEBPACK_IMPORTED_MODULE_9__Footer_css___default.a.nav
  }, void 0, __WEBPACK_IMPORTED_MODULE_10__constants_navigation__["a" /* default */].FOOTER.map(function (item) {
    return Footer__jsx('li', {}, item.title, Footer__jsx(Footer___WEBPACK_IMPORTED_MODULE_6_shared_components_Link_Link__["a" /* default */], {
      className: __WEBPACK_IMPORTED_MODULE_9__Footer_css___default.a.link,
      to: item.route,
      rel: 'nofollow'
    }, void 0, Footer__jsx(Footer___WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */], {
      id: item.title
    })));
  }))), Footer__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_9__Footer_css___default.a.right
  }, void 0, Footer__jsx('span', {
    className: __WEBPACK_IMPORTED_MODULE_9__Footer_css___default.a.tel
  }, void 0, '+380 44 206-56-06'), Footer__jsx('div', {}, void 0, languages.map(function (item) {
    return Footer__jsx('span', {
      className: __WEBPACK_IMPORTED_MODULE_9__Footer_css___default.a.lang
    }, item.slug, locale === item.slug ? Footer__jsx('span', {}, void 0, item.title) : Footer__jsx('a', {
      href: Footer___WEBPACK_IMPORTED_MODULE_5_shared_helpers_locale__["h" /* toLocalized */](Footer___WEBPACK_IMPORTED_MODULE_5_shared_helpers_locale__["e" /* removeLocaleFromHref */](currentPath), item.slug),
      'data-lang-code': item.slug
    }, void 0, item.title));
  })))), trends && trends[0] ? Footer__jsx(Footer___WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment, {}, void 0, Footer__jsx('hr', {
    className: __WEBPACK_IMPORTED_MODULE_9__Footer_css___default.a.divide,
    style: { margin: '8px 0 8px 0' }
  }), Footer__jsx(LocationList_defaultExport, {
    countries: undefined,
    cities: formattedTrends,
    search: true
  })) : '', !hideLocations && Footer__jsx('hr', {
    className: __WEBPACK_IMPORTED_MODULE_9__Footer_css___default.a.divide,
    style: { margin: '8px 0 0px 0' }
  }), !hideRegLocations && !hideLocations && Footer__jsx(LocationList_defaultExport, {
    cities: regions,
    search: false,
    selectedLocation: selectedLocation,
    isRegion: true,
    titleKey: titleKey
  }), !hideLocations && Footer__jsx(LocationList_defaultExport, {
    cities: cities,
    search: false,
    selectedLocation: selectedLocation,
    titleKey: titleKey,
    isRegion: hideRegLocations
  }), Footer__jsx('hr', {
    className: __WEBPACK_IMPORTED_MODULE_9__Footer_css___default.a.divide
  }), Footer__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_9__Footer_css___default.a.flexContainer
  }, void 0, Footer__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_9__Footer_css___default.a.left
  }, void 0, Footer__jsx('ul', {
    className: __WEBPACK_IMPORTED_MODULE_9__Footer_css___default.a.nav
  }, void 0, Footer__jsx('li', {}, void 0, Footer__jsx(Footer___WEBPACK_IMPORTED_MODULE_6_shared_components_Link_Link__["a" /* default */], {
    className: __WEBPACK_IMPORTED_MODULE_9__Footer_css___default.a.smallLink,
    to: '/law/',
    rel: 'nofollow'
  }, void 0, Footer__ref4)), Footer__jsx('li', {}, void 0, Footer__jsx(Footer___WEBPACK_IMPORTED_MODULE_6_shared_components_Link_Link__["a" /* default */], {
    className: __WEBPACK_IMPORTED_MODULE_9__Footer_css___default.a.smallLink,
    to: '/advertising-conditions/',
    rel: 'nofollow'
  }, void 0, _ref5)), Footer__jsx('li', {}, void 0, Footer__jsx(Footer___WEBPACK_IMPORTED_MODULE_6_shared_components_Link_Link__["a" /* default */], {
    className: __WEBPACK_IMPORTED_MODULE_9__Footer_css___default.a.smallLink,
    to: '/public-contract/',
    rel: 'nofollow'
  }, void 0, _ref6)))), Footer__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_9__Footer_css___default.a.right
  }, void 0, Footer__jsx('a', {
    href: 'mailto:support@ab.ua',
    className: __WEBPACK_IMPORTED_MODULE_9__Footer_css___default.a.tel,
    rel: 'nofollow'
  }, void 0, 'support@ab.ua'), Footer__jsx(SocialLinks, {
    socialLinks: socialLinks
  })))), Footer__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_9__Footer_css___default.a.footerCopyRight
  }, void 0, Footer__jsx('p', {}, void 0, '\xA9 ', new Date().getFullYear(), '\xA0', Footer__jsx(Footer___WEBPACK_IMPORTED_MODULE_6_shared_components_Link_Link__["a" /* default */], {
    className: __WEBPACK_IMPORTED_MODULE_9__Footer_css___default.a.smallLink,
    to: '/'
  }, void 0, _ref7), _ref8)));
}

Footer.defaultProps = {
  languages: [{
    title: 'рус',
    slug: 'ru'
  }, {
    title: 'укр',
    slug: 'uk'
  }],
  routeName: null,
  seoSearchUrlResponse: {},
  hideLocations: false
};


function SocialLinks(_ref) {
  var socialLinks = _ref.socialLinks;

  return Footer__jsx('div', {}, void 0, socialLinks.map(function (_ref2) {
    var link = _ref2.link,
        icon = _ref2.icon;
    return Footer__jsx('a', {
      href: link,
      target: '_blank',
      rel: 'nofollow noopener noreferrer',
      className: __WEBPACK_IMPORTED_MODULE_9__Footer_css___default.a.socialLink
    }, icon, Footer__jsx('i', {
      className: 'fa fa-' + icon
    }));
  }));
}


var Footer_mapStateToProps = function mapStateToProps(_ref3) {
  var history = _ref3.history,
      searchForm = _ref3.searchForm,
      globals = _ref3.globals;
  return {
    currentPath: history.currentPath,
    routeName: history && history.currentRouteName,
    countries: __WEBPACK_IMPORTED_MODULE_8_shared_constants_json_countries_json___default.a,
    formState: searchForm && searchForm.selected,
    seoSearchUrlResponse: globals.seoSearchUrlResponse,
    locale: globals.locale
  };
};

/* harmony default export */ var Footer_defaultExport = (Footer___WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_9__Footer_css___default.a)(Footer___WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */](Footer_mapStateToProps)(Footer___WEBPACK_IMPORTED_MODULE_4_react_intl__["d" /* injectIntl */](Footer))));
// CONCATENATED MODULE: ./src/desktop/components/Footer/LanguageList/LanguageList.js
/* harmony import */ var LanguageList___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var LanguageList___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(LanguageList___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var LanguageList___WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var LanguageList___WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(LanguageList___WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var LanguageList___WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(307);
/* harmony import */ var LanguageList___WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var LanguageList___WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(LanguageList___WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shared_helpers_locale__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__LanguageList_css__ = __webpack_require__(1382);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__LanguageList_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__LanguageList_css__);
var LanguageList__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();





// / import withFooterLocations from 'shared/hocs/withFooterLocations';
// import Link from 'shared/components/Link/Link';
// import { injectIntl } from 'react-intl';



function LanguageList(props) {
  var languages = props.languages,
      locale = props.locale,
      currentPath = props.currentPath;


  return LanguageList__jsx('div', {}, void 0, languages.map(function (item) {
    return LanguageList__jsx('span', {
      className: __WEBPACK_IMPORTED_MODULE_5__LanguageList_css___default.a.lang
    }, item.slug, locale === item.slug ? LanguageList__jsx('span', {}, void 0, item.title) : LanguageList__jsx('a', {
      href: __WEBPACK_IMPORTED_MODULE_4_shared_helpers_locale__["h" /* toLocalized */](__WEBPACK_IMPORTED_MODULE_4_shared_helpers_locale__["e" /* removeLocaleFromHref */](currentPath), item.slug),
      'data-lang-code': item.slug
    }, void 0, item.title));
  }));
}

LanguageList.defaultProps = {
  languages: [{
    title: 'рус',
    slug: 'ru'
  }, {
    title: 'укр',
    slug: 'uk'
  }]
};


var LanguageList_mapStateToProps = function mapStateToProps(_ref) {
  var globals = _ref.globals,
      history = _ref.history;
  return {
    currentPath: history.currentPath,
    locale: globals.locale
  };
};

/* harmony default export */ var LanguageList_defaultExport = (LanguageList___WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_5__LanguageList_css___default.a)(LanguageList___WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */](LanguageList_mapStateToProps)(LanguageList)));
// CONCATENATED MODULE: ./src/desktop/components/Footer/FooterLeasing.js
/* harmony import */ var FooterLeasing___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var FooterLeasing___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(FooterLeasing___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var FooterLeasing___WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var FooterLeasing___WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(FooterLeasing___WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var FooterLeasing___WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(307);
/* harmony import */ var FooterLeasing___WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var FooterLeasing___WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(FooterLeasing___WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var FooterLeasing___WEBPACK_IMPORTED_MODULE_4_react_intl__ = __webpack_require__(474);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_shared_components_Link_Link__ = __webpack_require__(1241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_shared_constants_json_countries_json__ = __webpack_require__(310);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_shared_constants_json_countries_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_shared_constants_json_countries_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_shared_constants_json_leasingLinksPopular_json__ = __webpack_require__(1380);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_shared_constants_json_leasingLinksPopular_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_shared_constants_json_leasingLinksPopular_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_shared_constants_json_leasingLinksPopularBrands_json__ = __webpack_require__(1381);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_shared_constants_json_leasingLinksPopularBrands_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_shared_constants_json_leasingLinksPopularBrands_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_shared_constants_json_leasingLinksPopularCities_json__ = __webpack_require__(489);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_shared_constants_json_leasingLinksPopularCities_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_shared_constants_json_leasingLinksPopularCities_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Footer_css__ = __webpack_require__(1266);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Footer_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__Footer_css__);
var FooterLeasing__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();







// import {
//   removeLocaleFromHref,
//   toLocalized,
//   setActiveLocations,
//   getAllLocations,
// } from 'shared/helpers/locale';

// import { compareByTitle } from 'shared/helpers/arrays';







// import LINKS from '../../constants/navigation';




var FooterLeasing__ref4 = FooterLeasing__jsx(FooterLeasing___WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */], {
  id: '\u041F\u043E\u043B\u0438\u0442\u0438\u043A\u0430 \u043A\u043E\u043D\u0444\u0438\u0434\u0435\u043D\u0446\u0438\u0430\u043B\u044C\u043D\u043E\u0441\u0442\u0438'
});

var FooterLeasing__ref5 = FooterLeasing__jsx(FooterLeasing___WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */], {
  id: '\u041F\u0440\u0430\u0432\u0438\u043B\u0430 \u043F\u0443\u0431\u043B\u0438\u043A\u0430\u0446\u0438\u0438 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0439'
});

var FooterLeasing__ref6 = FooterLeasing__jsx(FooterLeasing___WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */], {
  id: '\u041F\u0443\u0431\u043B\u0438\u0447\u043D\u044B\u0439 \u0434\u043E\u0433\u043E\u0432\u043E\u0440'
});

var FooterLeasing__ref7 = FooterLeasing__jsx(FooterLeasing___WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */], {
  id: '\u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440\u2122'
});

var FooterLeasing__ref8 = FooterLeasing__jsx(FooterLeasing___WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */], {
  id: '\u2013 \u041A\u0443\u043F\u0438\u0442\u044C \u043D\u043E\u0432\u043E\u0435 \u0430\u0432\u0442\u043E \u0438\u043B\u0438 \u043F\u0440\u043E\u0434\u0430\u0442\u044C \u0431\u0443 \u0441 \u043F\u0440\u043E\u0431\u0435\u0433\u043E\u043C \u0432 \u0423\u043A\u0440\u0430\u0438\u043D\u0435'
});

function LeasingFooter(props) {
  var languages = props.languages,
      currentPath = props.currentPath,
      intl = props.intl,
      locale = props.locale,
      hideLocations = props.hideLocations,
      _props$seoSearchUrlRe = props.seoSearchUrlResponse,
      make = _props$seoSearchUrlRe.make,
      trends = _props$seoSearchUrlRe.trends,
      seoLocations = _props$seoSearchUrlRe.locations,
      selectedLocation = _props$seoSearchUrlRe.location;


  var socialLinks = [{ icon: 'twitter', link: 'https://twitter.com/avtobazar' }, { icon: 'facebook', link: 'https://www.facebook.com/AvtoBazar' }, { icon: 'instagram', link: 'https://www.instagram.com/avtobazar_ua/' }, { icon: 'youtube-play', link: 'https://www.youtube.com/avtobazar' }];
  // const allLocations = getAllLocations().map(setActiveLocations(seoLocations, selectedLocation));
  // const cities = allLocations.filter(item => item.is_admin_center).sort(compareByTitle);
  // const regions = allLocations.filter(item => item.is_region).sort(compareByTitle);

  // const hideRegLocValues = ['/add/', '/zhurnal/', '/service/'];
  // const hideRegLocations = hideRegLocValues.some(item => currentPath.includes(item));

  // let formattedTrends = [];
  // if (trends) {
  //   formattedTrends = trends
  //     .map((a, b) => ({
  //       id: b,
  //       slug: '',
  //       title: a[`title_${intl.locale}`],
  //       hint: a[`text_${intl.locale}`],
  //       url: a.url,
  //     }))
  //     .filter((a, b) => b < 30);
  // }
  var titleKey = locale === 'uk' ? 'uk_title' : 'title';
  var listBav = [{
    titleHeader: 'Информация по телефону',
    title: '+380 44 206-56-06'
  }, {
    titleHeader: 'Адрес',
    title: intl.formatMessage({ id: 'Украина, г. Киев, ул. Лейпцигская 15а' })
  }, {
    titleHeader: 'Почта',
    title: 'support@ab.ua'
  }];
  return FooterLeasing__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_12__Footer_css___default.a.root
  }, void 0, FooterLeasing__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_12__Footer_css___default.a.container
  }, void 0, FooterLeasing__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_12__Footer_css___default.a.flexContainer
  }, void 0, FooterLeasing__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_12__Footer_css___default.a.left
  }, void 0, FooterLeasing__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_12__Footer_css___default.a.navLeasing
  }, void 0, listBav.map(function (item) {
    return FooterLeasing__jsx('div', {
      className: __WEBPACK_IMPORTED_MODULE_12__Footer_css___default.a.navLeasingItem
    }, item.title, FooterLeasing__jsx('div', {
      className: __WEBPACK_IMPORTED_MODULE_12__Footer_css___default.a.navLeasingTitleHeader
    }, void 0, FooterLeasing__jsx(FooterLeasing___WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */], {
      id: item.titleHeader
    })), FooterLeasing__jsx('div', {
      className: __WEBPACK_IMPORTED_MODULE_12__Footer_css___default.a.navLeasingTitle
    }, void 0, item.title));
  }))), FooterLeasing__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_12__Footer_css___default.a.right
  }, void 0, FooterLeasing__jsx(LanguageList_defaultExport, {
    languages: languages
  }), FooterLeasing__jsx(FooterLeasing_SocialLinks, {
    socialLinks: socialLinks
  }))), FooterLeasing__jsx('hr', {
    className: __WEBPACK_IMPORTED_MODULE_12__Footer_css___default.a.divide
  }), FooterLeasing__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_12__Footer_css___default.a.leasingList
  }, void 0, FooterLeasing__jsx(LocationList_defaultExport, {
    title: __WEBPACK_IMPORTED_MODULE_7_shared_constants_json_leasingLinksPopular_json___default.a.title,
    cities: __WEBPACK_IMPORTED_MODULE_7_shared_constants_json_leasingLinksPopular_json___default.a.items,
    search: false,
    selectedLocation: selectedLocation,
    titleKey: titleKey
  }), FooterLeasing__jsx(LocationList_defaultExport, {
    title: __WEBPACK_IMPORTED_MODULE_8_shared_constants_json_leasingLinksPopularBrands_json___default.a.title,
    cities: __WEBPACK_IMPORTED_MODULE_8_shared_constants_json_leasingLinksPopularBrands_json___default.a.items,
    search: false,
    selectedLocation: selectedLocation,
    titleKey: titleKey
  }), FooterLeasing__jsx(LocationList_defaultExport, {
    title: __WEBPACK_IMPORTED_MODULE_9_shared_constants_json_leasingLinksPopularCities_json___default.a.title,
    cities: __WEBPACK_IMPORTED_MODULE_9_shared_constants_json_leasingLinksPopularCities_json___default.a.items,
    search: false,
    selectedLocation: selectedLocation,
    titleKey: titleKey
  })), FooterLeasing__jsx('hr', {
    className: __WEBPACK_IMPORTED_MODULE_12__Footer_css___default.a.divide
  }), FooterLeasing__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_12__Footer_css___default.a.flexContainer
  }, void 0, FooterLeasing__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_12__Footer_css___default.a.left
  }, void 0, FooterLeasing__jsx('ul', {
    className: __WEBPACK_IMPORTED_MODULE_12__Footer_css___default.a.nav
  }, void 0, FooterLeasing__jsx('li', {}, void 0, FooterLeasing__jsx(__WEBPACK_IMPORTED_MODULE_5_shared_components_Link_Link__["a" /* default */], {
    className: __WEBPACK_IMPORTED_MODULE_12__Footer_css___default.a.smallLink,
    to: '/law/',
    rel: 'nofollow'
  }, void 0, FooterLeasing__ref4)), FooterLeasing__jsx('li', {}, void 0, FooterLeasing__jsx(__WEBPACK_IMPORTED_MODULE_5_shared_components_Link_Link__["a" /* default */], {
    className: __WEBPACK_IMPORTED_MODULE_12__Footer_css___default.a.smallLink,
    to: '/advertising-conditions/',
    rel: 'nofollow'
  }, void 0, FooterLeasing__ref5)), FooterLeasing__jsx('li', {}, void 0, FooterLeasing__jsx(__WEBPACK_IMPORTED_MODULE_5_shared_components_Link_Link__["a" /* default */], {
    className: __WEBPACK_IMPORTED_MODULE_12__Footer_css___default.a.smallLink,
    to: '/public-contract/',
    rel: 'nofollow'
  }, void 0, FooterLeasing__ref6)))))), FooterLeasing__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_12__Footer_css___default.a.footerCopyRight
  }, void 0, FooterLeasing__jsx('p', {}, void 0, '\xA9 ', new Date().getFullYear(), '\xA0', FooterLeasing__jsx(__WEBPACK_IMPORTED_MODULE_5_shared_components_Link_Link__["a" /* default */], {
    className: __WEBPACK_IMPORTED_MODULE_12__Footer_css___default.a.smallLink,
    to: '/'
  }, void 0, FooterLeasing__ref7), FooterLeasing__ref8)));
}

LeasingFooter.defaultProps = {
  languages: [{
    title: 'рус',
    slug: 'ru'
  }, {
    title: 'укр',
    slug: 'uk'
  }],
  routeName: null,
  seoSearchUrlResponse: {},
  hideLocations: false
};


function FooterLeasing_SocialLinks(_ref) {
  var socialLinks = _ref.socialLinks;

  return FooterLeasing__jsx('div', {}, void 0, socialLinks.map(function (_ref2) {
    var link = _ref2.link,
        icon = _ref2.icon;
    return FooterLeasing__jsx('a', {
      href: link,
      target: '_blank',
      rel: 'nofollow noopener noreferrer',
      className: __WEBPACK_IMPORTED_MODULE_12__Footer_css___default.a.socialLink
    }, icon, FooterLeasing__jsx('i', {
      className: 'fa fa-' + icon
    }));
  }));
}


var FooterLeasing_mapStateToProps = function mapStateToProps(_ref3) {
  var history = _ref3.history,
      searchForm = _ref3.searchForm,
      globals = _ref3.globals;
  return {
    currentPath: history.currentPath,
    routeName: history && history.currentRouteName,
    countries: __WEBPACK_IMPORTED_MODULE_6_shared_constants_json_countries_json___default.a,
    formState: searchForm && searchForm.selected,
    seoSearchUrlResponse: globals.seoSearchUrlResponse,
    locale: globals.locale
  };
};

/* harmony default export */ var FooterLeasing_defaultExport = (FooterLeasing___WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_12__Footer_css___default.a)(FooterLeasing___WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */](FooterLeasing_mapStateToProps)(FooterLeasing___WEBPACK_IMPORTED_MODULE_4_react_intl__["d" /* injectIntl */](LeasingFooter))));
// CONCATENATED MODULE: ./src/shared/hocs/withNotifications.js
/* harmony import */ var withNotifications___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var withNotifications___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(withNotifications___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shared_actions_notifications__ = __webpack_require__(475);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_helpers_common__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
var withNotifications__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var withNotifications__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function withNotifications__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function withNotifications__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function withNotifications__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var delay = function delay(ms) {
  return new Promise(function (resolve) {
    return setTimeout(resolve, ms);
  });
};

var withNotifications_mapStateToProps = function mapStateToProps(_ref) {
  var notifications = _ref.notifications;
  return { messageQueue: notifications };
};
var withNotifications_mapDispatchToProps = { shift: __WEBPACK_IMPORTED_MODULE_2_shared_actions_notifications__["b" /* shiftNotification */] };

var withNotifications = function withNotifications(WrappedComponent) {
  var _class, _temp2;

  return __WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */](withNotifications_mapStateToProps, withNotifications_mapDispatchToProps)((_temp2 = _class = function (_React$Component) {
    withNotifications__inherits(_class, _React$Component);

    function _class() {
      var _ref2;

      var _temp, _this, _ret;

      withNotifications__classCallCheck(this, _class);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = withNotifications__possibleConstructorReturn(this, (_ref2 = _class.__proto__ || Object.getPrototypeOf(_class)).call.apply(_ref2, [this].concat(args))), _this), _this.state = {
        activeMessage: null
      }, _this.tick = function () {
        var _this$props = _this.props,
            duration = _this$props.duration,
            shift = _this$props.shift;

        var lastMessage = _this.props.messageQueue[0];

        if (lastMessage) {
          _this.setState({ activeMessage: lastMessage }, function () {
            delay(duration).then(function () {
              shift();
              _this.setState({ activeMessage: null }, function () {
                delay(duration / 4).then(function () {
                  return _this.tick();
                });
              });
            });
          });
        }
      }, _temp), withNotifications__possibleConstructorReturn(_this, _ret);
    }

    withNotifications__createClass(_class, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        if (!this.state.activeMessage) {
          this.tick();
        }
      }
    }, {
      key: 'componentDidUpdate',
      value: function componentDidUpdate(prevProps) {
        if (prevProps.messageQueue.length < this.props.messageQueue.length && !this.state.activeMessage) {
          this.tick();
        }
      }
    }, {
      key: 'render',
      value: function render() {

        return withNotifications___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(WrappedComponent, withNotifications__extends({ activeMessage: this.state.activeMessage }, this.props));
      }
    }]);

    return _class;
  }(withNotifications___WEBPACK_IMPORTED_MODULE_0_react___default.a.Component), _class.displayName = 'withNotifications(' + __WEBPACK_IMPORTED_MODULE_3_shared_helpers_common__["e" /* getDisplayName */](WrappedComponent) + ')', _class.defaultProps = {
    duration: 4000
  }, _temp2));
};

/* harmony default export */ var withNotifications_defaultExport = (withNotifications);
// CONCATENATED MODULE: ./src/desktop/components/Layout/NotificationBar/NotificationBar.js
/* harmony import */ var NotificationBar___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var NotificationBar___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(NotificationBar___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var NotificationBar___WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var NotificationBar___WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(NotificationBar___WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var NotificationBar___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var NotificationBar___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(NotificationBar___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var NotificationBar___WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(1240);
/* harmony import */ var NotificationBar___WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(NotificationBar___WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_shared_actions_notificationTypes__ = __webpack_require__(1253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__NotificationBar_css__ = __webpack_require__(1384);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__NotificationBar_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__NotificationBar_css__);
var NotificationBar__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

function NotificationBar__defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }









function NotificationBar(props) {
  var activeMessage = props.activeMessage;

  var type = activeMessage && activeMessage.type;

  return NotificationBar__jsx('div', {
    className: NotificationBar___WEBPACK_IMPORTED_MODULE_3_classnames___default.a(__WEBPACK_IMPORTED_MODULE_6__NotificationBar_css___default.a.root, NotificationBar__defineProperty({}, __WEBPACK_IMPORTED_MODULE_6__NotificationBar_css___default.a.active, activeMessage),
    //
    NotificationBar__defineProperty({}, __WEBPACK_IMPORTED_MODULE_6__NotificationBar_css___default.a.error, type === __WEBPACK_IMPORTED_MODULE_5_shared_actions_notificationTypes__["a" /* default */].ERROR), NotificationBar__defineProperty({}, __WEBPACK_IMPORTED_MODULE_6__NotificationBar_css___default.a.success, type === __WEBPACK_IMPORTED_MODULE_5_shared_actions_notificationTypes__["a" /* default */].SUCCESS), NotificationBar__defineProperty({}, __WEBPACK_IMPORTED_MODULE_6__NotificationBar_css___default.a.warning, type === __WEBPACK_IMPORTED_MODULE_5_shared_actions_notificationTypes__["a" /* default */].WARNING), NotificationBar__defineProperty({}, __WEBPACK_IMPORTED_MODULE_6__NotificationBar_css___default.a.info, type === __WEBPACK_IMPORTED_MODULE_5_shared_actions_notificationTypes__["a" /* default */].INFO))
  }, void 0, activeMessage && NotificationBar__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_6__NotificationBar_css___default.a.label
  }, void 0, activeMessage.text));
}

NotificationBar.defaultProps = {
  activeMessage: null
};


/* harmony default export */ var NotificationBar_defaultExport = (NotificationBar___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_6__NotificationBar_css___default.a)(withNotifications_defaultExport(NotificationBar)));
// CONCATENATED MODULE: ./src/desktop/components/Layout/Layout.js
/* harmony import */ var Layout___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var Layout___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(Layout___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var Layout___WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var Layout___WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(Layout___WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var Layout___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var Layout___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(Layout___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_components_BannerAll__ = __webpack_require__(1270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_lazyload__ = __webpack_require__(481);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_lazyload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_lazyload__);
/* harmony import */ var Layout___WEBPACK_IMPORTED_MODULE_6_shared_modules__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_redux__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_normalize_css_normalize_css__ = __webpack_require__(1324);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_normalize_css_normalize_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_normalize_css_normalize_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_font_awesome_css_font_awesome_min_css__ = __webpack_require__(1326);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_font_awesome_css_font_awesome_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_font_awesome_css_font_awesome_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_select_dist_react_select_css__ = __webpack_require__(1328);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_select_dist_react_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react_select_dist_react_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_datepicker_dist_react_datepicker_min_css__ = __webpack_require__(1330);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_datepicker_dist_react_datepicker_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_react_datepicker_dist_react_datepicker_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_nprogress_nprogress_css__ = __webpack_require__(1332);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_nprogress_nprogress_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_react_nprogress_nprogress_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_slick_carousel_slick_slick_css__ = __webpack_require__(1334);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_slick_carousel_slick_slick_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_slick_carousel_slick_slick_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_global_styles_desktop_css__ = __webpack_require__(1336);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_global_styles_desktop_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_global_styles_desktop_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__Layout_css__ = __webpack_require__(1386);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__Layout_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__Layout_css__);
var Layout__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var Layout__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function Layout__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function Layout__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function Layout__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




// import { updateBranding } from 'shared/helpers/adsAndMetrics';




















// eslint-disable-next-line css-modules/no-unused-class


var isClient = true;
var localCurrentPage = '';

var Layout__ref = Layout__jsx(NotificationBar_defaultExport, {});

var Layout__ref2 = Layout__jsx(Header_defaultExport, {});

var Layout__ref3 = Layout__jsx(__WEBPACK_IMPORTED_MODULE_5_react_lazyload___default.a, {}, void 0, Layout__jsx(Layout___WEBPACK_IMPORTED_MODULE_6_shared_modules__["a" /* Googletag */], {
  id: 'div-gpt-ad-1514298874616-0'
}));

var Layout__ref4 = Layout__jsx(__WEBPACK_IMPORTED_MODULE_3_shared_components_BannerAll__["a" /* BannersBuffer */], {});

var Layout__ref5 = Layout__jsx(ChooseLanguageDialog_defaultExport, {});

var Layout_Layout = function (_React$Component) {
  Layout__inherits(Layout, _React$Component);

  function Layout() {
    Layout__classCallCheck(this, Layout);

    return Layout__possibleConstructorReturn(this, (Layout.__proto__ || Object.getPrototypeOf(Layout)).apply(this, arguments));
  }

  Layout__createClass(Layout, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (!isClient) return;
      var targetNode = window.document.body;
      var bannerTopAB = window.document.getElementById('banner-top-AB');
      var changeObserver = function changeObserver() {
        if (targetNode.style.backgroundImage) {
          window.document.getElementById('bodyABIdBlock').style.margin = '68px auto 0  auto';
        } else if (bannerTopAB && Number(bannerTopAB.clientHeight) > 30) {
          // bannerTopAB.style.marginTop = '20px';
          bannerTopAB.style.display = 'flex';
        }
      };

      var observer = new MutationObserver(changeObserver);
      var observerTop = new MutationObserver(changeObserver);
      observer.observe(targetNode, { attributes: true, childList: true });
      if (bannerTopAB) {
        observerTop.observe(bannerTopAB, { attributes: true, childList: true });
      }
      // updateBranding();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      var currentPath = this.props.history.currentPath;

      if (true && '' + location.pathname + location.search !== currentPath && currentPath !== localCurrentPage) {
        // updateBranding();
        localCurrentPage = currentPath;
      }
    }
  }, {
    key: 'getFooter',
    value: function getFooter() {
      var _props = this.props,
          hideLocations = _props.hideLocations,
          footer = _props.footer;

      if (footer === 'leasing') return Layout__jsx(FooterLeasing_defaultExport, {
        hideLocations: hideLocations
      });
      return Layout__jsx(Footer_defaultExport, {
        hideLocations: hideLocations
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          navLinks = _props2.navLinks,
          currentRoute = _props2.currentRoute,
          including = _props2.including,
          personalSubheader = _props2.personalSubheader,
          currentPath = _props2.history.currentPath;


      return Layout__jsx('div', {
        id: !navLinks ? 'fakeSubHeader' : '',
        className: __WEBPACK_IMPORTED_MODULE_20__Layout_css___default.a.root
      }, void 0, Layout__ref, Layout__ref2, navLinks && !!navLinks.length && Layout__jsx(SubHeader_defaultExport, {
        including: including,
        navLinks: navLinks,
        currentRoute: currentRoute,
        personalSubheader: personalSubheader
      }), !new Set(Layout___WEBPACK_IMPORTED_MODULE_6_shared_modules__["g" /* ignoreTopBanner */]).has(currentPath) && !/\/edit\//.test(currentPath) ? Layout__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_20__Layout_css___default.a.brandingAdv,
        id: 'banner-top-AB'
      }, void 0, Layout__ref3) : '', Layout__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_20__Layout_css___default.a.layout,
        id: 'bodyABIdBlock'
      }, void 0, this.props.children), Layout__jsx('main', {
        className: __WEBPACK_IMPORTED_MODULE_20__Layout_css___default.a.mainFooter
      }, void 0, this.getFooter()), Layout__ref4, isClient && Layout__ref5);
    }
  }]);

  return Layout;
}(Layout___WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Layout_Layout.defaultProps = {
  history: {},
  currentRoute: null,
  navLinks: null,
  withBranding: false,
  personalSubheader: false,
  including: true,
  targetingArguments: {},
  shouldInitAds: true,
  hideLocations: false,
  string: '',
  footer: ''
};


/* harmony default export */ __webpack_exports__["a"] = (Layout___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_20__Layout_css___default.a)(__WEBPACK_IMPORTED_MODULE_7_react_redux__["b" /* connect */](function (_ref6) {
  var history = _ref6.history;
  return {
    history: history
  };
})(Layout_Layout)));

/***/ }),

/***/ 1283:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var DecimalInput = function (_React$Component) {
  _inherits(DecimalInput, _React$Component);

  function DecimalInput() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, DecimalInput);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = DecimalInput.__proto__ || Object.getPrototypeOf(DecimalInput)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      tempValue: _this.props.value,
      isInDotMode: false
    }, _this.handleChange = function (e) {
      var value = e.target.value;
      var _this$props = _this.props,
          onChange = _this$props.onChange,
          delimiters = _this$props.delimiters;


      value = value.replace(new RegExp('[' + delimiters + ']', 'g'), '.');

      if (value && value.startsWith('.')) {
        value = '';
      }

      if (value === '' || value.match(/^\d+(\.\d+)?$/)) {
        _this.setState({ isInDotMode: false });
        onChange(value);
      } else if (value.match(/^\d+\.$/)) {
        _this.setState({
          tempValue: value,
          isInDotMode: true
        });
      }
    }, _this.handleBlur = function () {
      if (_this.state.isInDotMode) {
        _this.setState(function (_ref2) {
          var tempValue = _ref2.tempValue;

          var newValue = '' + parseInt(tempValue, 10);
          _this.props.onChange(newValue);
          return { tempValue: newValue };
        });
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(DecimalInput, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      var value = this.props.value;
      var _state = this.state,
          isInDotMode = _state.isInDotMode,
          tempValue = _state.tempValue;


      if (!isInDotMode && '' + tempValue !== '' + value) {
        // eslint-disable-next-line react/no-did-update-set-state
        this.setState({ tempValue: value ? '' + value : value });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          inputRef = _props.inputRef,
          props = _objectWithoutProperties(_props, ['inputRef']);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', _extends({}, props, {
        type: 'tel',
        ref: inputRef,
        onChange: this.handleChange,
        onBlur: this.handleBlur,
        value: this.state.tempValue || ''
      }));
    }
  }]);

  return DecimalInput;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

DecimalInput.defaultProps = {
  value: undefined,
  inputRef: undefined,
  onChange: function onChange() {},
  delimiters: '.,'
};


/* harmony default export */ __webpack_exports__["a"] = (DecimalInput);

/***/ }),

/***/ 1284:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_components_NavigationLink_NavigationLink__ = __webpack_require__(1262);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__InlineNav_css__ = __webpack_require__(1354);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__InlineNav_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__InlineNav_css__);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();







function InlineNav(props) {
  var navLinks = props.navLinks,
      including = props.including,
      currentRoute = props.currentRoute;

  var route = (currentRoute + '/').replace('//', '/');
  return _jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_4__InlineNav_css___default.a.root,
    role: 'navigation'
  }, void 0, _jsx('ul', {
    className: __WEBPACK_IMPORTED_MODULE_4__InlineNav_css___default.a.list
  }, void 0, navLinks.map(function (item) {
    return _jsx('li', {
      className: __WEBPACK_IMPORTED_MODULE_4__InlineNav_css___default.a.item
    }, item.route, _jsx(__WEBPACK_IMPORTED_MODULE_3_shared_components_NavigationLink_NavigationLink__["a" /* default */], {
      link: item,
      currentRoute: route,
      including: including,
      className: __WEBPACK_IMPORTED_MODULE_4__InlineNav_css___default.a.link,
      activeClassName: __WEBPACK_IMPORTED_MODULE_4__InlineNav_css___default.a.active,
      eventPrefix: props.eventPrefix
    }));
  })));
}

InlineNav.defaultProps = {
  including: true,
  currentRoute: null,
  count: null,
  withCount: false,
  eventPrefix: ''
};


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_4__InlineNav_css___default.a)(InlineNav));

/***/ }),

/***/ 1285:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.__esModule = true;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

var _react = __webpack_require__(11);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1246);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _TransitionGroup = __webpack_require__(1358);

var _TransitionGroup2 = _interopRequireDefault(_TransitionGroup);

var _CSSTransitionGroupChild = __webpack_require__(1361);

var _CSSTransitionGroupChild2 = _interopRequireDefault(_CSSTransitionGroupChild);

var _PropTypes = __webpack_require__(1264);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === 'undefined' ? 'undefined' : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === 'undefined' ? 'undefined' : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var propTypes = {
  transitionName: _PropTypes.nameShape.isRequired,

  transitionAppear: _propTypes2.default.bool,
  transitionEnter: _propTypes2.default.bool,
  transitionLeave: _propTypes2.default.bool,
  transitionAppearTimeout: (0, _PropTypes.transitionTimeout)('Appear'),
  transitionEnterTimeout: (0, _PropTypes.transitionTimeout)('Enter'),
  transitionLeaveTimeout: (0, _PropTypes.transitionTimeout)('Leave')
};

var defaultProps = {
  transitionAppear: false,
  transitionEnter: true,
  transitionLeave: true
};

var CSSTransitionGroup = function (_React$Component) {
  _inherits(CSSTransitionGroup, _React$Component);

  function CSSTransitionGroup() {
    var _temp, _this, _ret;

    _classCallCheck(this, CSSTransitionGroup);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this._wrapChild = function (child) {
      return _react2.default.createElement(_CSSTransitionGroupChild2.default, {
        name: _this.props.transitionName,
        appear: _this.props.transitionAppear,
        enter: _this.props.transitionEnter,
        leave: _this.props.transitionLeave,
        appearTimeout: _this.props.transitionAppearTimeout,
        enterTimeout: _this.props.transitionEnterTimeout,
        leaveTimeout: _this.props.transitionLeaveTimeout
      }, child);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  // We need to provide this childFactory so that
  // ReactCSSTransitionGroupChild can receive updates to name, enter, and
  // leave while it is leaving.


  CSSTransitionGroup.prototype.render = function render() {
    return _react2.default.createElement(_TransitionGroup2.default, _extends({}, this.props, { childFactory: this._wrapChild }));
  };

  return CSSTransitionGroup;
}(_react2.default.Component);

CSSTransitionGroup.displayName = 'CSSTransitionGroup';

CSSTransitionGroup.propTypes =  false ? propTypes : {};
CSSTransitionGroup.defaultProps = defaultProps;

exports.default = CSSTransitionGroup;
module.exports = exports['default'];

/***/ }),

/***/ 1286:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ContentRollAdsense; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }




var isDev = false;

var _ref = _jsx('div', {}, void 0, '________________slot_________________');

var _ref2 = _jsx('div', {}, void 0, '_________ContentRollAdsense__________');

var _ref3 = _jsx('div', {}, void 0, '________________STYLE_________________');

var _ref4 = _jsx('div', {}, void 0, '________________end_block_________________');

function ContentRollAdsenseClass(props) {
  var adClient = props.adClient,
      adSlot = props.adSlot,
      other = _objectWithoutProperties(props, ['adClient', 'adSlot']);

  var devStyle = {
    width: '100%',
    minHeight: '200px',
    backgroundColor: '#ffb900',
    border: '3px solid #a73c3c'
  };
  if (isDev) {
    return _jsx('div', {
      style: devStyle
    }, void 0, _ref, _ref2, _jsx(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment, {}, void 0, adSlot), _ref3, _jsx(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment, {}, void 0, JSON.stringify(other.style)), _ref4);
  }
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ins', _extends({}, other, { className: 'adsbygoogle', 'data-ad-client': adClient, 'data-ad-slot': adSlot }));
}

ContentRollAdsenseClass.defaultProps = {
  adClient: 'ca-pub-8183181871645898',
  adSlot: '7650493142'
};


var ContentRollAdsense = ContentRollAdsenseClass;

/***/ }),

/***/ 1287:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(1240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_intl__ = __webpack_require__(474);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_shared_components_Loader_Loader__ = __webpack_require__(1249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__UIStyle_css__ = __webpack_require__(1245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__UIStyle_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__UIStyle_css__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }









var ButtonGeneral = function ButtonGeneral(_ref) {
  var _cx;

  var text = _ref.text,
      type = _ref.type,
      theme = _ref.theme,
      clickHandler = _ref.clickHandler,
      Icon = _ref.Icon,
      className = _ref.className,
      isProcessing = _ref.isProcessing,
      disabled = _ref.disabled,
      userTranslate = _ref.userTranslate,
      iconAfterText = _ref.iconAfterText,
      inputParams = _objectWithoutProperties(_ref, ['text', 'type', 'theme', 'clickHandler', 'Icon', 'className', 'isProcessing', 'disabled', 'userTranslate', 'iconAfterText']);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'button',
    _extends({
      disabled: disabled || isProcessing,
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default.a(__WEBPACK_IMPORTED_MODULE_6__UIStyle_css__["ButtonGeneral"], (_cx = {}, _defineProperty(_cx, __WEBPACK_IMPORTED_MODULE_6__UIStyle_css__["ButtonTransparent"], theme === 'Transparent'), _defineProperty(_cx, __WEBPACK_IMPORTED_MODULE_6__UIStyle_css__["ButtonTransparentYellow"], theme === 'TransparentYellow'), _defineProperty(_cx, __WEBPACK_IMPORTED_MODULE_6__UIStyle_css__["ButtonYellow"], theme === 'Yellow'), _defineProperty(_cx, __WEBPACK_IMPORTED_MODULE_6__UIStyle_css__["ButtonWhite"], theme === 'White'), _defineProperty(_cx, __WEBPACK_IMPORTED_MODULE_6__UIStyle_css__["ButtonYellowFlat"], theme === 'YellowFlat'), _defineProperty(_cx, __WEBPACK_IMPORTED_MODULE_6__UIStyle_css__["ButtonDisabledStyle"], theme === 'DisabledStyle'), _defineProperty(_cx, __WEBPACK_IMPORTED_MODULE_6__UIStyle_css__["ButtonProcessing"], isProcessing), _defineProperty(_cx, className, !!className), _defineProperty(_cx, __WEBPACK_IMPORTED_MODULE_6__UIStyle_css__["iconAfterText"], iconAfterText), _cx)),
      type: type,
      onClick: clickHandler
    }, inputParams),
    _jsx(__WEBPACK_IMPORTED_MODULE_5_shared_components_Loader_Loader__["a" /* default */], {
      isLoading: isProcessing,
      className: __WEBPACK_IMPORTED_MODULE_6__UIStyle_css__["ButtonLoader"]
    }),
    Icon && !iconAfterText ? _jsx(Icon, {}) : null,
    userTranslate ? _jsx(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */], {
      id: text
    }) : text,
    Icon && iconAfterText ? _jsx(Icon, {}) : null
  );
};

ButtonGeneral.defaultProps = {
  type: 'submit',
  theme: 'Yellow',
  className: '',
  Icon: null,
  disabled: false,
  clickHandler: function clickHandler() {},
  isProcessing: false,
  userTranslate: true,
  iconAfterText: false
};

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_6__UIStyle_css__)(ButtonGeneral));

/***/ }),

/***/ 1288:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// CONCATENATED MODULE: ./src/shared/hocs/withMonoPayment.js
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_intl__ = __webpack_require__(474);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_actions_globals__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_shared_constants_api__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_shared_actions_notificationTypes__ = __webpack_require__(1253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_shared_hocs_withFetch__ = __webpack_require__(1244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_shared_constants_gtmEvents__ = __webpack_require__(1243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__helpers_common__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__helpers_locale__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__constants_payment__ = __webpack_require__(308);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__actions_notifications__ = __webpack_require__(475);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__history__ = __webpack_require__(185);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

















var throwIfResponseNotOkay = function throwIfResponseNotOkay() {
  return function (response) {
    if (!response.ok) {
      throw new Error('Произошла ошибка');
    }

    return response;
  };
};

var getMonoOrderData = function getMonoOrderData(fetch, token, data) {
  return fetch(__WEBPACK_IMPORTED_MODULE_5_shared_constants_api__["a" /* default */].PAYMENT.MONO_ORDER_CHECKOUT, {
    method: 'POST',
    headers: {
      Authorization: 'JWT ' + token
    },
    body: JSON.stringify(data)
  });
};

var updateAdvertParams = function updateAdvertParams(advertParams, fetch, token, advertID, promoteInSocial) {
  if (advertParams.kind && advertParams.kind === __WEBPACK_IMPORTED_MODULE_11__constants_payment__["d" /* PACKAGES */].C2C_TURBO && promoteInSocial) {
    fetch(__WEBPACK_IMPORTED_MODULE_5_shared_constants_api__["a" /* default */].ADVERT.ITEM(advertID), {
      method: 'PATCH',
      headers: {
        Authorization: 'JWT ' + token,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ promote_in_social: promoteInSocial })
    });
  }
};

var withMonoPayment = function withMonoPayment(WrappedComponent) {
  var _class, _temp2;

  var Component = (_temp2 = _class = function (_React$Component) {
    _inherits(Component, _React$Component);

    function Component() {
      var _ref;

      var _temp, _this, _ret;

      _classCallCheck(this, Component);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Component.__proto__ || Object.getPrototypeOf(Component)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
        fondyFrameUrl: '',
        fondyCb: null,
        showModal: false,
        showInvoiceModal: false,
        billAmount: null,
        accountNumber: null,
        eventCounter: 1
      }, _this.setGtmEvent = function (gtmId) {
        if (!gtmId) return;

        var eventCounter = _this.state.eventCounter;

        var dataLayer = window && Array.isArray(window.dataLayer) && window.dataLayer;
        var gtmDataLayerValue = dataLayer && dataLayer.find(function (el) {
          return el.event === gtmId.event;
        });

        if (gtmDataLayerValue) {
          var newCounter = eventCounter + 1;
          _this.setState({ eventCounter: newCounter });
          _this.props.setDataLayer(_extends({}, gtmId, { event: '' + gtmId.event + newCounter + '/' }));
        } else {
          _this.props.setDataLayer(gtmId);
        }
      }, _this.getGtmEvent = function (gtmType) {
        var user = _this.props.user;

        var isBusiness = user.user.tariff && user.user.tariff.is_business;
        var isDealership = user.user.tariff && user.user.tariff.slug === 'b2c-plus';

        if (isDealership) {
          return __WEBPACK_IMPORTED_MODULE_8_shared_constants_gtmEvents__["a" /* EVENTS */].advert.dealership[gtmType];
        } else if (isBusiness) {
          return __WEBPACK_IMPORTED_MODULE_8_shared_constants_gtmEvents__["a" /* EVENTS */].advert.business[gtmType];
        }
        return __WEBPACK_IMPORTED_MODULE_8_shared_constants_gtmEvents__["a" /* EVENTS */].advert[gtmType];
      }, _this.sendGtmMetrics = function (params) {
        if (params.kind === 'subscription') _this.setGtmEvent(_this.getGtmEvent(params.details.tariff));else if (params.kind === 'c2c-free' && params.details && params.details.promos) {
          params.details.promos.map(function (item) {
            return _this.setGtmEvent(_this.getGtmEvent(item));
          });
        } else _this.setGtmEvent(_this.getGtmEvent(params.kind));
      }, _this.openMonoOrderWindow = function (token, params, redirectUrl, paymentMethod, cb) {
        var _this$props = _this.props,
            fetch = _this$props.fetch,
            intl = _this$props.intl,
            promoteInSocial = _this$props.promoteInSocial;
        var locale = intl.locale;

        var redirectUrlLocalized = __WEBPACK_IMPORTED_MODULE_10__helpers_locale__["h" /* toLocalized */](redirectUrl, locale);
        var advertId = params.details && params.details.advert_id;

        __WEBPACK_IMPORTED_MODULE_9__helpers_common__["j" /* iniRedirectToCheckout */]();
        return function () {
          return fetch(__WEBPACK_IMPORTED_MODULE_5_shared_constants_api__["a" /* default */].PAYMENT.orders(), {
            method: 'POST',
            headers: {
              Authorization: 'JWT ' + token
            },
            body: JSON.stringify(params)
          }).then(throwIfResponseNotOkay()).then(function (r) {
            return r.json();
          }).then(function (_ref2) {
            var number = _ref2.number,
                status = _ref2.status;

            if (status === __WEBPACK_IMPORTED_MODULE_11__constants_payment__["c" /* ORDER_STATUSES */].PAID || paymentMethod === __WEBPACK_IMPORTED_MODULE_11__constants_payment__["h" /* PAYMENT_METHODS */].BALANCE) {
              _this.sendGtmMetrics(params);
              _this.props.setDataLayer(__WEBPACK_IMPORTED_MODULE_8_shared_constants_gtmEvents__["a" /* EVENTS */].paidAdSent);
              _this.props.enqueueNotification({
                text: intl.formatMessage({ id: 'Оплата прошла успешно' }),
                type: __WEBPACK_IMPORTED_MODULE_6_shared_actions_notificationTypes__["a" /* default */].SUCCESS
              });
              updateAdvertParams(params, fetch, token, advertId, promoteInSocial);
              if (cb) cb({ number: number, status: status });else __WEBPACK_IMPORTED_MODULE_13__history__["a" /* default */].push(redirectUrlLocalized);
            } else {
              var handlerUrl = __WEBPACK_IMPORTED_MODULE_11__constants_payment__["j" /* URLS */].HANDLER_URL_FULL + '?redirectUrl=' + redirectUrlLocalized;
              return getMonoOrderData(fetch, token, {
                order_number: number,
                response_url: handlerUrl,
                lang: locale
              }).then(throwIfResponseNotOkay()).then(function (r) {
                return r.json();
              }).then(function (data) {
                _this.sendGtmMetrics(params);
                _this.props.setDataLayer(__WEBPACK_IMPORTED_MODULE_8_shared_constants_gtmEvents__["a" /* EVENTS */].paidAdSent);
                var url = data.checkout_url;
                updateAdvertParams(params, fetch, token, advertId, promoteInSocial);

                __WEBPACK_IMPORTED_MODULE_9__helpers_common__["d" /* doRedirectToCheckout */](url);
              });
            }

            return Promise.resolve();
          });
        }().catch(function (e) {
          _this.props.enqueueNotification(intl.formatMessage({ id: e.message ? e.message : e }));
          if (cb) cb(null, e.message ? e.message : e);
        });
      }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(Component, [{
      key: 'render',
      value: function render() {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(WrappedComponent, _extends({}, this.props, { openMonoOrderWindow: this.openMonoOrderWindow }));
      }
    }]);

    return Component;
  }(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component), _class.displayName = 'withOrders(' + __WEBPACK_IMPORTED_MODULE_9__helpers_common__["e" /* getDisplayName */](WrappedComponent) + ')', _temp2);

  var mapDispatchToProps = {
    enqueueNotification: __WEBPACK_IMPORTED_MODULE_12__actions_notifications__["a" /* enqueueNotification */],
    setDataLayer: __WEBPACK_IMPORTED_MODULE_3_shared_actions_globals__["j" /* setDataLayer */]
  };

  var mapStateToProps = function mapStateToProps(_ref3) {
    var globals = _ref3.globals,
        user = _ref3.user;
    return {
      promoteInSocial: globals.promoteInSocial,
      user: user
    };
  };

  return __WEBPACK_IMPORTED_MODULE_4_react_redux__["b" /* connect */](mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_2_react_intl__["d" /* injectIntl */](__WEBPACK_IMPORTED_MODULE_7_shared_hocs_withFetch__["a" /* withFetch */](Component)));
};

/* harmony default export */ var withMonoPayment_defaultExport = (withMonoPayment);
// CONCATENATED MODULE: ./src/desktop/components/BalanceRefill/BalanceRefill.js
/* harmony import */ var BalanceRefill___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var BalanceRefill___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(BalanceRefill___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(1240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_intl__ = __webpack_require__(474);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_shared_components_Modal__ = __webpack_require__(1250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_shared_components_PaymentModal__ = __webpack_require__(1269);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_shared_constants_payment__ = __webpack_require__(308);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__BalanceRefill_css__ = __webpack_require__(1369);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__BalanceRefill_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__BalanceRefill_css__);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var BalanceRefill__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function BalanceRefill__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function BalanceRefill__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function BalanceRefill__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }















var _ref2 = _jsx(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */], {
  id: '\u041F\u043E\u043F\u043E\u043B\u043D\u0438\u0442\u044C'
});

var BalanceRefill = function (_React$Component) {
  BalanceRefill__inherits(BalanceRefill, _React$Component);

  function BalanceRefill() {
    var _ref;

    var _temp, _this, _ret;

    BalanceRefill__classCallCheck(this, BalanceRefill);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = BalanceRefill__possibleConstructorReturn(this, (_ref = BalanceRefill.__proto__ || Object.getPrototypeOf(BalanceRefill)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      refillAmount: 99,
      showModal: false
    }, _this.handleChange = function (e) {
      var value = e.target.value;


      if (value === '') {
        _this.setState({ refillAmount: null });
      } else {
        var intValue = parseInt(value, 10);

        if (intValue) {
          _this.setState({ refillAmount: intValue });
        }
      }
    }, _this.handleShow = function () {
      // this.props.onModalOpen();
      // this.setState({ showModal: true });
      var _this$props = _this.props,
          token = _this$props.token,
          openMonoOrderWindow = _this$props.openMonoOrderWindow;
      var refillAmount = _this.state.refillAmount;


      openMonoOrderWindow(token, {
        kind: __WEBPACK_IMPORTED_MODULE_8_shared_constants_payment__["b" /* KINDS */].BALANCE_REFILL,
        details: {
          refill_amount: refillAmount
        }
      }, '' + window.location.pathname + window.location.search, // return to where we are
      'mono');
    }, _this.handleHide = function () {
      _this.props.onModalClose();
      _this.setState({ showModal: false });
    }, _this.renderModal = function () {
      return _jsx(__WEBPACK_IMPORTED_MODULE_6_shared_components_Modal__["a" /* default */], {}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_7_shared_components_PaymentModal__["a" /* default */], {
        title: _this.props.intl.formatMessage({ id: 'Пополнение баланса' }),
        description: _this.props.intl.formatMessage({
          id: 'Пополнение внутреннего баланса в аккаунте avtobazar.ua'
        }),
        closeHandler: _this.handleHide,
        amount: _this.state.refillAmount,
        balanceRefillMode: true
      }));
    }, _temp), BalanceRefill__possibleConstructorReturn(_this, _ret);
  }

  // handlePaymentMethodChosen = paymentMethodInfo => {
  //   const { token, openMonoOrderWindow } = this.props;
  //   const { refillAmount } = this.state;

  //   openMonoOrderWindow(
  //     token,
  //     {
  //       kind: KINDS.BALANCE_REFILL,
  //       details: {
  //         refill_amount: refillAmount,
  //       },
  //     },
  //     `${window.location.pathname}${window.location.search}`, // return to where we are
  //     paymentMethodInfo.slug,
  //   );
  // };

  BalanceRefill__createClass(BalanceRefill, [{
    key: 'render',
    value: function render() {
      var _state = this.state,
          refillAmount = _state.refillAmount,
          showModal = _state.showModal;


      return _jsx('div', {}, void 0, _jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_10__BalanceRefill_css___default.a.inputContainer
      }, void 0, _jsx('input', {
        type: 'text',
        className: __WEBPACK_IMPORTED_MODULE_1_classnames___default.a(__WEBPACK_IMPORTED_MODULE_10__BalanceRefill_css___default.a.input),
        value: refillAmount || '',
        onChange: this.handleChange
      }), _jsx('span', {
        className: __WEBPACK_IMPORTED_MODULE_10__BalanceRefill_css___default.a.hrn
      }, void 0, '\u0433\u0440\u043D'), _jsx('button', {
        onClick: this.handleShow,
        className: __WEBPACK_IMPORTED_MODULE_10__BalanceRefill_css___default.a.inlineButton,
        disabled: !refillAmount
      }, void 0, _ref2)), showModal && this.renderModal());
    }
  }]);

  return BalanceRefill;
}(BalanceRefill___WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

BalanceRefill.defaultProps = {
  onModalOpen: function onModalOpen() {},
  onModalClose: function onModalClose() {}
};


var mapStateToProps = function mapStateToProps(_ref3) {
  var user = _ref3.user;
  return {
    token: user.token
  };
};

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_5_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_10__BalanceRefill_css___default.a)(__WEBPACK_IMPORTED_MODULE_3_react_redux__["b" /* connect */](mapStateToProps)(withMonoPayment_defaultExport(__WEBPACK_IMPORTED_MODULE_4_react_intl__["d" /* injectIntl */](BalanceRefill)))));

/***/ }),

/***/ 1289:
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var ReactIs = require('react-is');

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(ReactIs.isElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(1290)();
}

/***/ }),

/***/ 1290:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(1291);

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

module.exports = function () {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error('Calling PropTypes validators directly is not supported by the `prop-types` package. ' + 'Use PropTypes.checkPropTypes() to call them. ' + 'Read more at http://fb.me/use-check-prop-types');
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bigint: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};

/***/ }),

/***/ 1291:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;

/***/ }),

/***/ 1292:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _isIterable2 = __webpack_require__(1293);

var _isIterable3 = _interopRequireDefault(_isIterable2);

var _getIterator2 = __webpack_require__(1296);

var _getIterator3 = _interopRequireDefault(_getIterator2);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

exports.default = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = (0, _getIterator3.default)(arr), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if ((0, _isIterable3.default)(Object(arr))) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();

/***/ }),

/***/ 1293:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1294), __esModule: true };

/***/ }),

/***/ 1294:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(480);
__webpack_require__(478);
module.exports = __webpack_require__(1295);

/***/ }),

/***/ 1295:
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(1260);
var ITERATOR = __webpack_require__(86)('iterator');
var Iterators = __webpack_require__(187);
module.exports = __webpack_require__(30).isIterable = function (it) {
  var O = Object(it);
  return O[ITERATOR] !== undefined || '@@iterator' in O
  // eslint-disable-next-line no-prototype-builtins
  || Iterators.hasOwnProperty(classof(O));
};

/***/ }),

/***/ 1296:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1297), __esModule: true };

/***/ }),

/***/ 1297:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(480);
__webpack_require__(478);
module.exports = __webpack_require__(1298);

/***/ }),

/***/ 1298:
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(105);
var get = __webpack_require__(1279);
module.exports = __webpack_require__(30).getIterator = function (it) {
  var iterFn = get(it);
  if (typeof iterFn != 'function') throw TypeError(it + ' is not iterable!');
  return anObject(iterFn.call(it));
};

/***/ }),

/***/ 1299:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1300);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./BannerAll.css", function() {
        content = require("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./BannerAll.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 1300:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, "._2I0F2{margin-bottom:20px}._3DEYy{position:relative}.K2GWo{-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;width:300px}._1VCyV,.K2GWo{display:-webkit-box;display:-ms-flexbox;display:flex}._1VCyV{-ms-flex-pack:distribute;justify-content:space-around;margin-top:20px;padding:0 45px;margin-bottom:20px}._1VCyV>div{margin-bottom:10px;margin-top:10px}._3coG7{height:100%}", ""]);

// exports
exports.locals = {
	"gptPremium": "_2I0F2",
	"flexCell": "_3DEYy",
	"sideBar": "K2GWo",
	"advertContainerButoon": "_1VCyV",
	"homeSideBar": "_3coG7"
};

/***/ }),

/***/ 1301:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1302);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./ModalContainer.css", function() {
        content = require("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./ModalContainer.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 1302:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, "._3ubq_{position:fixed;z-index:3005;background-color:rgba(50,50,50,.5);top:0;left:0;display:-webkit-box;display:-ms-flexbox;display:flex;overflow-y:auto;width:100%;height:100%;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}._8Koz-{position:absolute;top:0;left:0;right:0;bottom:0;z-index:3006;backdrop-filter:blur(4px)}.NhUO6{background-color:#fff;border:1px solid #bfbfbf;-ms-flex-item-align:center;align-self:center;z-index:3007}._2Ncf4{max-width:600px;width:90%;min-height:300px;padding:15px 20px;-webkit-box-sizing:border-box;box-sizing:border-box}", ""]);

// exports
exports.locals = {
	"root": "_3ubq_",
	"background": "_8Koz-",
	"content": "NhUO6",
	"contentParams": "_2Ncf4"
};

/***/ }),

/***/ 1303:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1304);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./ModalWrapper.css", function() {
        content = require("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./ModalWrapper.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 1304:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, "._cLKp{padding:20px 15px}._21JFC{overflow-y:auto;max-height:100vh;margin:0 auto}._2lSzg{position:relative;border-radius:10px;max-width:330px}._1BONa,._18jW-{position:absolute;cursor:pointer;top:3px;right:10px;font-size:22px;color:#c4c4c4}._18jW-:before{content:\"\\D7\"}", ""]);

// exports
exports.locals = {
	"rootModalContainer": "_cLKp",
	"rootModal": "_21JFC",
	"modal": "_2lSzg",
	"closeBtnIcon": "_1BONa",
	"closeBtn": "_18jW-"
};

/***/ }),

/***/ 1305:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1306);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./CircleTimer.css", function() {
        content = require("!!../../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./CircleTimer.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 1306:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, "._3B1TS{font-size:32px;color:#000}._1H7x_{-webkit-transform-origin:center center;transform-origin:center center;-webkit-transform:rotate(-92deg);transform:rotate(-92deg)}", ""]);

// exports
exports.locals = {
	"circleTimerText": "_3B1TS",
	"circleTimerProgress": "_1H7x_"
};

/***/ }),

/***/ 1307:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1308);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./Loader.css", function() {
        content = require("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./Loader.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 1308:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, "._23UJ_{text-align:center;padding:10px 0}", ""]);

// exports
exports.locals = {
	"root": "_23UJ_"
};

/***/ }),

/***/ 1309:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, "._1s4zB{position:relative;padding:7px 8px;border-radius:2px;height:42px;line-height:30px;border:1px solid #c4c4c4;outline:none;font-size:13px;width:100%;-webkit-box-sizing:border-box;box-sizing:border-box}._1s4zB::-webkit-input-placeholder{color:gray}._1s4zB::-moz-placeholder{color:gray}._1s4zB:-ms-input-placeholder{color:gray}._1s4zB::placeholder{color:gray}.vJnum{position:relative;margin:0 auto 10px;width:100%;padding:10px 0;font-size:14px;color:#000;font-weight:700;border-width:1px;border-style:solid;outline:none;cursor:pointer;line-height:1.1;border-radius:3px;white-space:nowrap}.vJnum:disabled,.vJnum:disabled>.hX4eV{color:rgba(0,0,0,.25);pointer-events:none}._1F-aN{color:rgba(0,0,0,.25)}._2YtbV,._3bKRW{background-color:#ffd906;border-color:#ffd906}._2YtbV,._3bKRW:hover{background-color:#ffc107;border-color:#ffc107}._2YtbV{border:none}._2YtbV:disabled{background-color:#f5f5f5}._1AWF-{background-color:#fff;border-color:#c4c4c4}._1AWF-:hover{background-color:#fffceb}._2DyKI{background-color:transparent}._2DyKI:hover,._38ptx:hover{background-color:#ffc10744}._38ptx{background-color:transparent;border:1px solid #ffc107}.vJnum.aO6AT>:not(._289M5){visibility:hidden}._15Egm{position:absolute;top:50%;left:50%;-webkit-transform:translate(-50%,-50%);transform:translate(-50%,-50%);padding:0;font-size:11px}.zoFvb>svg{margin-left:6px}.vJnum:not(.zoFvb)>svg{margin-right:6px}", ""]);

// exports
exports.locals = {
	"inputGeneral": "_1s4zB",
	"ButtonGeneral": "vJnum",
	"btnInfo": "hX4eV",
	"ButtonDisabledStyle": "_1F-aN",
	"ButtonYellowFlat": "_2YtbV",
	"ButtonYellow": "_3bKRW",
	"ButtonWhite": "_1AWF-",
	"ButtonTransparent": "_2DyKI",
	"ButtonTransparentYellow": "_38ptx",
	"buttonLoader": "aO6AT",
	"ButtonProcessing": "_289M5",
	"ButtonLoader": "_15Egm",
	"iconAfterText": "zoFvb"
};

/***/ }),

/***/ 1310:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1311);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./ContactButton.css", function() {
        content = require("!!../../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./ContactButton.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 1311:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, "._3z1Cv{min-height:60px;width:190px;background-color:#ffd906;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;margin-bottom:auto;text-align:center}._3z1Cv,._3z1Cv a{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}._3z1Cv a{padding:7px 16px 4px;font-weight:600;-webkit-box-align:center;-ms-flex-align:center;align-items:center}._1D5tw{min-height:60px;width:190px}._1D5tw,.a06XJ{font-size:14px;background-color:#ffd906;border-radius:2px;border:1px solid #ffd906;padding:7px 16px 4px;color:#000;cursor:pointer;text-align:center;line-height:1.52;outline:none;font-weight:600;-webkit-transition:all .1s ease-out;-o-transition:all .1s ease-out;transition:all .1s ease-out;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;margin-bottom:auto}._1D5tw a,._3YwyV a,._3z1Cv a,.a06XJ a{color:#000}._3z1Cv{cursor:default;background-color:#f5f5f5;border:1px solid transparent}._1D5tw:hover,._3z1Cv:hover{background-color:#ffc107;border:1px solid #ffc107}._31u6D{-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}._3T3i5,._31u6D{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}._254Zh{padding-bottom:2px;padding-left:4px}._3vtyf,._254Zh{line-height:12px;font-size:14px}._3YwyV,.a06XJ{width:100%;min-height:42px}._3YwyV>._31u6D{-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row}.a06XJ{margin-bottom:10px}", ""]);

// exports
exports.locals = {
	"showedContainerDesktop": "_3z1Cv",
	"hided": "_1D5tw",
	"showedPhoneMobile": "a06XJ",
	"hidedMobile": "_3YwyV",
	"hidedContent": "_31u6D",
	"hiddenPhone": "_3T3i5",
	"Plus": "_254Zh",
	"Dots": "_3vtyf"
};

/***/ }),

/***/ 1312:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1313);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./CheckBox.css", function() {
        content = require("!!../../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./CheckBox.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 1313:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, "._3Vsl7{position:relative;display:inline-block;cursor:pointer;font-weight:400;font-size:13px;color:#000;padding-left:20px;white-space:nowrap}._3Vsl7:hover{color:#ff5a5f}._3Vsl7 input{position:absolute;left:0;border:1px solid #aaa;border-radius:2px;cursor:pointer}._3Vsl7 input,._3Vsl7 input:checked{-webkit-appearance:none;width:15px;height:15px;outline:none}._3Vsl7 input:checked{border:1px solid #ffd906;background-color:#ffd906;border-radius:2px}._3Vsl7 input:checked:after{-webkit-appearance:none;position:absolute;font:0/0 a;z-index:2;top:1px;left:-1px;overflow:hidden;width:17px;height:9px;margin-top:-6px;content:\" \";pointer-events:none;border-width:0 0 2px 2px;border-style:solid;border-color:#222;border-radius:1px;background:0 0;-webkit-transform:rotate(315deg);transform:rotate(315deg)}", ""]);

// exports
exports.locals = {
	"checkbox": "_3Vsl7"
};

/***/ }),

/***/ 1314:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1315);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./TagButton.css", function() {
        content = require("!!../../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./TagButton.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 1315:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, "._1hjln{white-space:nowrap;display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;margin:6px 6px 6px 0;height:32px;padding:0 8px;font-size:12px;color:#333;min-width:90px;border-radius:2px;border:1px solid #ffd906;cursor:pointer}._1hjln>svg{margin-right:8px}._1hjln:hover{background-color:#ffd906;-webkit-transition:.3s;-o-transition:.3s;transition:.3s}._1hjln:last-child{margin-right:0}._1SOx4{border:1px solid #c4c4c4;border-radius:2px;pointer-events:none;color:#c4c4c4}._1SOx4 path{fill:#c4c4c4}", ""]);

// exports
exports.locals = {
	"tag": "_1hjln",
	"disabled": "_1SOx4"
};

/***/ }),

/***/ 1316:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1317);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./Select.css", function() {
        content = require("!!../../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./Select.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 1317:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, "._1pNgY .Select-control{height:42px}._1pNgY .Select-placeholder,._1pNgY .Select-value{line-height:42px;height:42px;font-weight:400}._1dne7 .Select-control{border:none}", ""]);

// exports
exports.locals = {
	"root": "_1pNgY",
	"theme-flat": "_1dne7"
};

/***/ }),

/***/ 1318:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1319);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./SelectInput.css", function() {
        content = require("!!../../../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./SelectInput.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 1319:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, "._3hl6h{min-width:65px;font-weight:400}._3hl6h,._3Y3JC{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-flex:1;-ms-flex:1 1 0%;flex:1 1 0%}._3Y3JC{position:relative}._3Y3JC:hover ._1ZTEB{background-color:#f1f1f18c}._1ZTEB{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;color:#000;font-size:16px;border-radius:4px;font-weight:400;cursor:pointer;-webkit-box-flex:1;-ms-flex:1 1 0%;flex:1 1 0%}._1ZTEB .fa{margin-left:8px}._3yfgi{width:100%;opacity:0;cursor:pointer}", ""]);

// exports
exports.locals = {
	"root": "_3hl6h",
	"selectContainer": "_3Y3JC",
	"hint": "_1ZTEB",
	"select": "_3yfgi stretched"
};

/***/ }),

/***/ 1320:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1321);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./NumberInputWithSelect.css", function() {
        content = require("!!../../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./NumberInputWithSelect.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 1321:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, "._2CTZv{width:100%;position:relative}._2CTZv,._3nhOc{display:-webkit-box;display:-ms-flexbox;display:flex}._3nhOc{margin:0;margin-right:2px;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.DRK7t{width:16px;height:16px;position:absolute;left:15px;top:8px}.jWUNC{width:100%;height:42px}._3Imj3>.jWUNC{padding-left:36px}._2byyi{-webkit-box-flex:1;-ms-flex:1 1 0%;flex:1 1 0%;height:42px;position:relative}._2byyi input[type=number]{-moz-appearance:textfield}._2byyi input[type=number]::-webkit-inner-spin-button,._2byyi input[type=number]::-webkit-outer-spin-button{-webkit-appearance:none;margin:0}._3nGhT{color:#000;font-size:16px;margin-left:5px;position:absolute;right:0;height:42px;display:-webkit-box;display:-ms-flexbox;display:flex}._-5BW7{border-right:1px solid rgba(0,0,0,.15);width:0;margin:4px 0}.J0LiY{padding-left:8px}._11n11 .input{border:none}", ""]);

// exports
exports.locals = {
	"root": "_2CTZv",
	"title": "_3nhOc questionTitle",
	"icon": "DRK7t",
	"input": "jWUNC input",
	"hasIcon": "_3Imj3",
	"inline": "_2byyi",
	"switch": "_3nGhT",
	"switchDivider": "_-5BW7",
	"singleOptionLabel": "J0LiY",
	"required": "_1_Rl_ required",
	"theme-flat": "_11n11"
};

/***/ }),

/***/ 1322:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1323);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./ChooseLanguageDialog.css", function() {
        content = require("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./ChooseLanguageDialog.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 1323:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, "._2zlxK{font-weight:700}._2zlxK,._22XDT{margin-bottom:13px}._22XDT{text-align:justify}._2rIjY{font-weight:700;margin-bottom:13px}._17hGk{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}", ""]);

// exports
exports.locals = {
	"title": "_2zlxK",
	"text": "_22XDT",
	"timer": "_2rIjY",
	"buttons": "_17hGk"
};

/***/ }),

/***/ 1324:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1325);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../extract-text-webpack-plugin/loader.js??ref--1-rules-1-0!../css-loader/index.js??ref--1-rules-1-1!../postcss-loader/lib/index.js??ref--1-rules-3!./normalize.css", function() {
        content = require("!!../extract-text-webpack-plugin/loader.js??ref--1-rules-1-0!../css-loader/index.js??ref--1-rules-1-1!../postcss-loader/lib/index.js??ref--1-rules-3!./normalize.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 1325:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1326:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1327);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../extract-text-webpack-plugin/loader.js??ref--1-rules-1-0!../../css-loader/index.js??ref--1-rules-1-1!../../postcss-loader/lib/index.js??ref--1-rules-3!./font-awesome.min.css", function() {
        content = require("!!../../extract-text-webpack-plugin/loader.js??ref--1-rules-1-0!../../css-loader/index.js??ref--1-rules-1-1!../../postcss-loader/lib/index.js??ref--1-rules-3!./font-awesome.min.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 1327:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1328:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1329);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../extract-text-webpack-plugin/loader.js??ref--1-rules-1-0!../../css-loader/index.js??ref--1-rules-1-1!../../postcss-loader/lib/index.js??ref--1-rules-3!./react-select.css", function() {
        content = require("!!../../extract-text-webpack-plugin/loader.js??ref--1-rules-1-0!../../css-loader/index.js??ref--1-rules-1-1!../../postcss-loader/lib/index.js??ref--1-rules-3!./react-select.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 1329:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1330:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1331);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../extract-text-webpack-plugin/loader.js??ref--1-rules-1-0!../../css-loader/index.js??ref--1-rules-1-1!../../postcss-loader/lib/index.js??ref--1-rules-3!./react-datepicker.min.css", function() {
        content = require("!!../../extract-text-webpack-plugin/loader.js??ref--1-rules-1-0!../../css-loader/index.js??ref--1-rules-1-1!../../postcss-loader/lib/index.js??ref--1-rules-3!./react-datepicker.min.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 1331:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1332:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1333);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../extract-text-webpack-plugin/loader.js??ref--1-rules-1-0!../css-loader/index.js??ref--1-rules-1-1!../postcss-loader/lib/index.js??ref--1-rules-3!./nprogress.css", function() {
        content = require("!!../extract-text-webpack-plugin/loader.js??ref--1-rules-1-0!../css-loader/index.js??ref--1-rules-1-1!../postcss-loader/lib/index.js??ref--1-rules-3!./nprogress.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 1333:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1334:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1335);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../extract-text-webpack-plugin/loader.js??ref--1-rules-1-0!../../css-loader/index.js??ref--1-rules-1-1!../../postcss-loader/lib/index.js??ref--1-rules-3!./slick.css", function() {
        content = require("!!../../extract-text-webpack-plugin/loader.js??ref--1-rules-1-0!../../css-loader/index.js??ref--1-rules-1-1!../../postcss-loader/lib/index.js??ref--1-rules-3!./slick.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 1335:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1336:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1337);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../node_modules/extract-text-webpack-plugin/loader.js??ref--1-rules-1-0!../../node_modules/css-loader/index.js??ref--1-rules-1-1!../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./desktop.css", function() {
        content = require("!!../../node_modules/extract-text-webpack-plugin/loader.js??ref--1-rules-1-0!../../node_modules/css-loader/index.js??ref--1-rules-1-1!../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./desktop.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 1337:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1338:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/* NProgress, (c) 2013, 2014 Rico Sta. Cruz - http://ricostacruz.com/nprogress
 * @license MIT */

;(function (root, factory) {

  if (true) {
    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if ((typeof exports === 'undefined' ? 'undefined' : _typeof(exports)) === 'object') {
    module.exports = factory();
  } else {
    root.NProgress = factory();
  }
})(this, function () {
  var NProgress = {};

  NProgress.version = '0.1.6';

  var Settings = NProgress.settings = {
    minimum: 0.08,
    easing: 'ease',
    positionUsing: '',
    speed: 200,
    trickle: true,
    trickleRate: 0.02,
    trickleSpeed: 800,
    showSpinner: true,
    barSelector: '[role="bar"]',
    spinnerSelector: '[role="spinner"]',
    parent: 'body',
    template: '<div class="bar" role="bar"><div class="peg"></div></div><div class="spinner" role="spinner"><div class="spinner-icon"></div></div>'
  };

  /**
   * Updates configuration.
   *
   *     NProgress.configure({
   *       minimum: 0.1
   *     });
   */
  NProgress.configure = function (options) {
    var key, value;
    for (key in options) {
      value = options[key];
      if (value !== undefined && options.hasOwnProperty(key)) Settings[key] = value;
    }

    return this;
  };

  /**
   * Last number.
   */

  NProgress.status = null;

  /**
   * Sets the progress bar status, where `n` is a number from `0.0` to `1.0`.
   *
   *     NProgress.set(0.4);
   *     NProgress.set(1.0);
   */

  NProgress.set = function (n) {
    var started = NProgress.isStarted();

    n = clamp(n, Settings.minimum, 1);
    NProgress.status = n === 1 ? null : n;

    var progress = NProgress.render(!started),
        bar = progress.querySelector(Settings.barSelector),
        speed = Settings.speed,
        ease = Settings.easing;

    progress.offsetWidth; /* Repaint */

    queue(function (next) {
      // Set positionUsing if it hasn't already been set
      if (Settings.positionUsing === '') Settings.positionUsing = NProgress.getPositioningCSS();

      // Add transition
      css(bar, barPositionCSS(n, speed, ease));

      if (n === 1) {
        // Fade out
        css(progress, {
          transition: 'none',
          opacity: 1
        });
        progress.offsetWidth; /* Repaint */

        setTimeout(function () {
          css(progress, {
            transition: 'all ' + speed + 'ms linear',
            opacity: 0
          });
          setTimeout(function () {
            NProgress.remove();
            next();
          }, speed);
        }, speed);
      } else {
        setTimeout(next, speed);
      }
    });

    return this;
  };

  NProgress.isStarted = function () {
    return typeof NProgress.status === 'number';
  };

  /**
   * Shows the progress bar.
   * This is the same as setting the status to 0%, except that it doesn't go backwards.
   *
   *     NProgress.start();
   *
   */
  NProgress.start = function () {
    if (!NProgress.status) NProgress.set(0);

    var work = function work() {
      setTimeout(function () {
        if (!NProgress.status) return;
        NProgress.trickle();
        work();
      }, Settings.trickleSpeed);
    };

    if (Settings.trickle) work();

    return this;
  };

  /**
   * Hides the progress bar.
   * This is the *sort of* the same as setting the status to 100%, with the
   * difference being `done()` makes some placebo effect of some realistic motion.
   *
   *     NProgress.done();
   *
   * If `true` is passed, it will show the progress bar even if its hidden.
   *
   *     NProgress.done(true);
   */

  NProgress.done = function (force) {
    if (!force && !NProgress.status) return this;

    return NProgress.inc(0.3 + 0.5 * Math.random()).set(1);
  };

  /**
   * Increments by a random amount.
   */

  NProgress.inc = function (amount) {
    var n = NProgress.status;

    if (!n) {
      return NProgress.start();
    } else {
      if (typeof amount !== 'number') {
        amount = (1 - n) * clamp(Math.random() * n, 0.1, 0.95);
      }

      n = clamp(n + amount, 0, 0.994);
      return NProgress.set(n);
    }
  };

  NProgress.trickle = function () {
    return NProgress.inc(Math.random() * Settings.trickleRate);
  };

  /**
   * Waits for all supplied jQuery promises and
   * increases the progress as the promises resolve.
   * 
   * @param $promise jQUery Promise
   */
  (function () {
    var initial = 0,
        current = 0;

    NProgress.promise = function ($promise) {
      if (!$promise || $promise.state() == "resolved") {
        return this;
      }

      if (current == 0) {
        NProgress.start();
      }

      initial++;
      current++;

      $promise.always(function () {
        current--;
        if (current == 0) {
          initial = 0;
          NProgress.done();
        } else {
          NProgress.set((initial - current) / initial);
        }
      });

      return this;
    };
  })();

  /**
   * (Internal) renders the progress bar markup based on the `template`
   * setting.
   */

  NProgress.render = function (fromStart) {
    if (NProgress.isRendered()) return document.getElementById('nprogress');

    addClass(document.documentElement, 'nprogress-busy');

    var progress = document.createElement('div');
    progress.id = 'nprogress';
    progress.innerHTML = Settings.template;

    var bar = progress.querySelector(Settings.barSelector),
        perc = fromStart ? '-100' : toBarPerc(NProgress.status || 0),
        parent = document.querySelector(Settings.parent),
        spinner;

    css(bar, {
      transition: 'all 0 linear',
      transform: 'translate3d(' + perc + '%,0,0)'
    });

    if (!Settings.showSpinner) {
      spinner = progress.querySelector(Settings.spinnerSelector);
      spinner && removeElement(spinner);
    }

    if (parent != document.body) {
      addClass(parent, 'nprogress-custom-parent');
    }

    parent.appendChild(progress);
    return progress;
  };

  /**
   * Removes the element. Opposite of render().
   */

  NProgress.remove = function () {
    removeClass(document.documentElement, 'nprogress-busy');
    removeClass(document.querySelector(Settings.parent), 'nprogress-custom-parent');
    var progress = document.getElementById('nprogress');
    progress && removeElement(progress);
  };

  /**
   * Checks if the progress bar is rendered.
   */

  NProgress.isRendered = function () {
    return !!document.getElementById('nprogress');
  };

  /**
   * Determine which positioning CSS rule to use.
   */

  NProgress.getPositioningCSS = function () {
    // Sniff on document.body.style
    var bodyStyle = document.body.style;

    // Sniff prefixes
    var vendorPrefix = 'WebkitTransform' in bodyStyle ? 'Webkit' : 'MozTransform' in bodyStyle ? 'Moz' : 'msTransform' in bodyStyle ? 'ms' : 'OTransform' in bodyStyle ? 'O' : '';

    if (vendorPrefix + 'Perspective' in bodyStyle) {
      // Modern browsers with 3D support, e.g. Webkit, IE10
      return 'translate3d';
    } else if (vendorPrefix + 'Transform' in bodyStyle) {
      // Browsers without 3D support, e.g. IE9
      return 'translate';
    } else {
      // Browsers without translate() support, e.g. IE7-8
      return 'margin';
    }
  };

  /**
   * Helpers
   */

  function clamp(n, min, max) {
    if (n < min) return min;
    if (n > max) return max;
    return n;
  }

  /**
   * (Internal) converts a percentage (`0..1`) to a bar translateX
   * percentage (`-100%..0%`).
   */

  function toBarPerc(n) {
    return (-1 + n) * 100;
  }

  /**
   * (Internal) returns the correct CSS for changing the bar's
   * position given an n percentage, and speed and ease from Settings
   */

  function barPositionCSS(n, speed, ease) {
    var barCSS;

    if (Settings.positionUsing === 'translate3d') {
      barCSS = { transform: 'translate3d(' + toBarPerc(n) + '%,0,0)' };
    } else if (Settings.positionUsing === 'translate') {
      barCSS = { transform: 'translate(' + toBarPerc(n) + '%,0)' };
    } else {
      barCSS = { 'margin-left': toBarPerc(n) + '%' };
    }

    barCSS.transition = 'all ' + speed + 'ms ' + ease;

    return barCSS;
  }

  /**
   * (Internal) Queues a function to be executed.
   */

  var queue = function () {
    var pending = [];

    function next() {
      var fn = pending.shift();
      if (fn) {
        fn(next);
      }
    }

    return function (fn) {
      pending.push(fn);
      if (pending.length == 1) next();
    };
  }();

  /**
   * (Internal) Applies css properties to an element, similar to the jQuery 
   * css method.
   *
   * While this helper does assist with vendor prefixed property names, it 
   * does not perform any manipulation of values prior to setting styles.
   */

  var css = function () {
    var cssPrefixes = ['Webkit', 'O', 'Moz', 'ms'],
        cssProps = {};

    function camelCase(string) {
      return string.replace(/^-ms-/, 'ms-').replace(/-([\da-z])/gi, function (match, letter) {
        return letter.toUpperCase();
      });
    }

    function getVendorProp(name) {
      var style = document.body.style;
      if (name in style) return name;

      var i = cssPrefixes.length,
          capName = name.charAt(0).toUpperCase() + name.slice(1),
          vendorName;
      while (i--) {
        vendorName = cssPrefixes[i] + capName;
        if (vendorName in style) return vendorName;
      }

      return name;
    }

    function getStyleProp(name) {
      name = camelCase(name);
      return cssProps[name] || (cssProps[name] = getVendorProp(name));
    }

    function applyCss(element, prop, value) {
      prop = getStyleProp(prop);
      element.style[prop] = value;
    }

    return function (element, properties) {
      var args = arguments,
          prop,
          value;

      if (args.length == 2) {
        for (prop in properties) {
          value = properties[prop];
          if (value !== undefined && properties.hasOwnProperty(prop)) applyCss(element, prop, value);
        }
      } else {
        applyCss(element, args[1], args[2]);
      }
    };
  }();

  /**
   * (Internal) Determines if an element or space separated list of class names contains a class name.
   */

  function hasClass(element, name) {
    var list = typeof element == 'string' ? element : classList(element);
    return list.indexOf(' ' + name + ' ') >= 0;
  }

  /**
   * (Internal) Adds a class to an element.
   */

  function addClass(element, name) {
    var oldList = classList(element),
        newList = oldList + name;

    if (hasClass(oldList, name)) return;

    // Trim the opening space.
    element.className = newList.substring(1);
  }

  /**
   * (Internal) Removes a class from an element.
   */

  function removeClass(element, name) {
    var oldList = classList(element),
        newList;

    if (!hasClass(element, name)) return;

    // Replace the class name.
    newList = oldList.replace(' ' + name + ' ', ' ');

    // Trim the opening and closing spaces.
    element.className = newList.substring(1, newList.length - 1);
  }

  /**
   * (Internal) Gets a space separated list of the class names on the element. 
   * The list is wrapped with a single space on each end to facilitate finding 
   * matches within the list.
   */

  function classList(element) {
    return (' ' + (element.className || '') + ' ').replace(/\s+/gi, ' ');
  }

  /**
   * (Internal) Removes an element from the DOM.
   */

  function removeElement(element) {
    element && element.parentNode && element.parentNode.removeChild(element);
  }

  return NProgress;
});

/***/ }),

/***/ 1339:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "3de37e7e.svg";

/***/ }),

/***/ 1340:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "e968b6a0.svg";

/***/ }),

/***/ 1341:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1342);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./Logo.css", function() {
        content = require("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./Logo.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 1342:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, "._2DdTy{text-decoration:none!important;font-size:10px;font-weight:600;color:#ffd906;padding-bottom:5px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;height:48px}._2DdTy:active,._2DdTy:focus,._2DdTy:hover{color:#ffd906;text-decoration:none}", ""]);

// exports
exports.locals = {
	"brandLogo": "_2DdTy"
};

/***/ }),

/***/ 1343:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1344);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./Header.css", function() {
        content = require("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./Header.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 1344:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, ".CjTMX{position:relative;background-color:#fff;color:#000;-webkit-box-shadow:0 2px 8px rgba(0,0,0,.12);box-shadow:0 2px 8px rgba(0,0,0,.12);z-index:99}._3v0wi{position:fixed;left:0;right:0;top:0;z-index:100}._1KXxC{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-flow:row nowrap;flex-flow:row nowrap;padding:0 15px;height:60px;-webkit-box-align:center;-ms-flex-align:center;align-items:center}@media print{.CjTMX{display:none}}", ""]);

// exports
exports.locals = {
	"root": "CjTMX",
	"fixed": "_3v0wi",
	"container": "_1KXxC container"
};

/***/ }),

/***/ 1345:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "f33d7fc5.svg";

/***/ }),

/***/ 1346:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1347);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./NavigationLink.css", function() {
        content = require("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./NavigationLink.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 1347:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, "._1h7t-{padding:0 4px;font-weight:400;margin-left:-2px;background-color:#ededed;border-radius:10rem}", ""]);

// exports
exports.locals = {
	"count": "_1h7t-"
};

/***/ }),

/***/ 1348:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1349);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./NavigationItem.css", function() {
        content = require("!!../../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./NavigationItem.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 1349:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, "._34VVu{position:relative;font-size:13px;border-bottom:2px solid transparent;border-top:2px solid transparent;-webkit-transition:all .15s ease-out;-o-transition:all .15s ease-out;transition:all .15s ease-out}.m5hBM{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;color:#000;font-weight:700;text-decoration:none;padding:13px 12px;height:100%}._1ojmC{display:none;position:absolute;top:100%;left:0;z-index:101;background-color:#fff;border-bottom:1px solid #ddd;border-right:1px solid #ddd;border-left:1px solid #ddd;-webkit-box-shadow:0 12px 16px rgba(0,0,0,.08);box-shadow:0 12px 16px rgba(0,0,0,.08)}._34VVu:hover{background-color:#f5f5f5;color:#e73232}._34VVu._2Rphr,._34VVu:hover{border-top:2px solid #ffd906}._34VVu:hover .m5hBM{color:#e73232}._34VVu:hover ._1ojmC,.BOSU4{display:block}.BOSU4{color:#000;font-weight:400;font-size:14px;text-decoration:none;padding:12px;white-space:nowrap}.BOSU4:hover{background-color:#f5f5f5;color:#e73232}", ""]);

// exports
exports.locals = {
	"root": "_34VVu",
	"link": "m5hBM",
	"dropdown": "_1ojmC",
	"active": "_2Rphr",
	"dLink": "BOSU4"
};

/***/ }),

/***/ 1350:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1351);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./ProfileButton.css", function() {
        content = require("!!../../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./ProfileButton.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 1351:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, ".cSaip{position:relative;font-size:13px;display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;padding:0 12px;min-width:150px}._2vqlh{color:#000;max-width:150px;font-weight:700;text-decoration:none;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1;-webkit-box-align:center;-ms-flex-align:center;align-items:center;margin:0 -12px;padding:0 11px;border-top:0 solid transparent}.cSaip:hover ._2vqlh{background-color:#f5f5f5;border-top:0 solid #ffd906;color:#e73232}.MEvex{max-width:150px;overflow:hidden;-o-text-overflow:ellipsis;text-overflow:ellipsis;white-space:nowrap}._2Esyq{display:none;position:absolute;width:100%;top:100%;left:0;z-index:101;background-color:#fff;border-bottom:1px solid #ddd;border-right:1px solid #ddd;border-left:1px solid #ddd;-webkit-box-shadow:0 12px 16px rgba(0,0,0,.08);box-shadow:0 12px 16px rgba(0,0,0,.08);-webkit-box-sizing:border-box;box-sizing:border-box}.cSaip:hover ._2Esyq{display:block}.r6XJg{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}.cdK6z>span{white-space:pre-wrap}.cdK6z{display:block;color:#000;font-weight:400;font-size:14px;text-decoration:none;padding:12px;white-space:nowrap;text-align:left}.cdK6z:hover{background-color:#f5f5f5;color:#000}._1-5lQ{border-top:1px solid #ededed;font-weight:700;padding:12px}._2ST8r{height:35px;width:35px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;border-radius:50%;overflow:hidden;margin-right:10px}._1JQVF{width:100%}", ""]);

// exports
exports.locals = {
	"root": "cSaip",
	"link": "_2vqlh",
	"btnTitle": "MEvex",
	"dropdown": "_2Esyq",
	"dropdownList": "r6XJg",
	"dropdownLink": "cdK6z",
	"logout": "_1-5lQ",
	"avatarContainer": "_2ST8r",
	"avatar": "_1JQVF"
};

/***/ }),

/***/ 1352:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1353);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./Navigation.css", function() {
        content = require("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./Navigation.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 1353:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, ".s3Ylh{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-flex:1;-ms-flex:1 1 auto;flex:1 1 auto;min-width:935px;-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end;-ms-flex-item-align:stretch;align-self:stretch}._3BN4_{margin-right:8px;margin-left:8px;border-radius:3px;color:#000}._3BN4_:hover{color:#e73232}._29C-n{-webkit-box-flex:0;-ms-flex:0 1 auto;flex:0 1 auto}.BZPWi{position:relative;height:100%}.BZPWi,.dmyLG{display:-webkit-box;display:-ms-flexbox;display:flex}.dmyLG{-webkit-box-flex:0;-ms-flex:0 1 auto;flex:0 1 auto;text-align:right;-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end;padding-left:10px}._1XlLA{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-flow:row nowrap;flex-flow:row nowrap;height:100%}._3L2yd{display:inline-block;text-decoration:none;font-weight:700;font-size:13px;padding:15px 20px 15px 18px}._3PRKw{background-color:#ffd906;color:#000;cursor:pointer;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}._3PRKw:hover{background-color:#ffc107;color:#000}._3PRKw img{margin-right:10px}", ""]);

// exports
exports.locals = {
	"root": "s3Ylh",
	"highlight": "_3BN4_",
	"left": "_29C-n",
	"navItem": "BZPWi",
	"right": "dmyLG",
	"flexRow": "_1XlLA",
	"link": "_3L2yd",
	"sell": "_3PRKw"
};

/***/ }),

/***/ 1354:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1355);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./InlineNav.css", function() {
        content = require("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./InlineNav.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 1355:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, "._3ALPP{z-index:1}._3ALPP,.mCAa6{position:relative;margin:0;padding:0}.mCAa6{list-style:none}._3PRCE{position:relative}._3PRCE,._HsNd{display:inline-block}._HsNd{text-decoration:none;font-weight:400;font-size:12px;padding:15px 10px 9px;border-bottom:4px solid transparent;cursor:pointer;-webkit-transition:all .15s ease-out;-o-transition:all .15s ease-out;transition:all .15s ease-out;text-transform:uppercase;letter-spacing:.1em}._HsNd:hover{color:#e73232}._HsNd:hover,.A7cFq{border-bottom:4px solid #ffd906}.A7cFq{position:relative;color:#000;font-weight:700}", ""]);

// exports
exports.locals = {
	"root": "_3ALPP",
	"list": "mCAa6",
	"item": "_3PRCE",
	"link": "_HsNd",
	"active": "A7cFq"
};

/***/ }),

/***/ 1356:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(1357);

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

module.exports = function () {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error('Calling PropTypes validators directly is not supported by the `prop-types` package. ' + 'Use PropTypes.checkPropTypes() to call them. ' + 'Read more at http://fb.me/use-check-prop-types');
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bigint: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};

/***/ }),

/***/ 1357:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;

/***/ }),

/***/ 1358:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.__esModule = true;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

var _chainFunction = __webpack_require__(1359);

var _chainFunction2 = _interopRequireDefault(_chainFunction);

var _react = __webpack_require__(11);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1246);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _warning = __webpack_require__(318);

var _warning2 = _interopRequireDefault(_warning);

var _ChildMapping = __webpack_require__(1360);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === 'undefined' ? 'undefined' : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === 'undefined' ? 'undefined' : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var propTypes = {
  component: _propTypes2.default.any,
  childFactory: _propTypes2.default.func,
  children: _propTypes2.default.node
};

var defaultProps = {
  component: 'span',
  childFactory: function childFactory(child) {
    return child;
  }
};

var TransitionGroup = function (_React$Component) {
  _inherits(TransitionGroup, _React$Component);

  function TransitionGroup(props, context) {
    _classCallCheck(this, TransitionGroup);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));

    _this.performAppear = function (key, component) {
      _this.currentlyTransitioningKeys[key] = true;

      if (component.componentWillAppear) {
        component.componentWillAppear(_this._handleDoneAppearing.bind(_this, key, component));
      } else {
        _this._handleDoneAppearing(key, component);
      }
    };

    _this._handleDoneAppearing = function (key, component) {
      if (component.componentDidAppear) {
        component.componentDidAppear();
      }

      delete _this.currentlyTransitioningKeys[key];

      var currentChildMapping = (0, _ChildMapping.getChildMapping)(_this.props.children);

      if (!currentChildMapping || !currentChildMapping.hasOwnProperty(key)) {
        // This was removed before it had fully appeared. Remove it.
        _this.performLeave(key, component);
      }
    };

    _this.performEnter = function (key, component) {
      _this.currentlyTransitioningKeys[key] = true;

      if (component.componentWillEnter) {
        component.componentWillEnter(_this._handleDoneEntering.bind(_this, key, component));
      } else {
        _this._handleDoneEntering(key, component);
      }
    };

    _this._handleDoneEntering = function (key, component) {
      if (component.componentDidEnter) {
        component.componentDidEnter();
      }

      delete _this.currentlyTransitioningKeys[key];

      var currentChildMapping = (0, _ChildMapping.getChildMapping)(_this.props.children);

      if (!currentChildMapping || !currentChildMapping.hasOwnProperty(key)) {
        // This was removed before it had fully entered. Remove it.
        _this.performLeave(key, component);
      }
    };

    _this.performLeave = function (key, component) {
      _this.currentlyTransitioningKeys[key] = true;

      if (component.componentWillLeave) {
        component.componentWillLeave(_this._handleDoneLeaving.bind(_this, key, component));
      } else {
        // Note that this is somewhat dangerous b/c it calls setState()
        // again, effectively mutating the component before all the work
        // is done.
        _this._handleDoneLeaving(key, component);
      }
    };

    _this._handleDoneLeaving = function (key, component) {
      if (component.componentDidLeave) {
        component.componentDidLeave();
      }

      delete _this.currentlyTransitioningKeys[key];

      var currentChildMapping = (0, _ChildMapping.getChildMapping)(_this.props.children);

      if (currentChildMapping && currentChildMapping.hasOwnProperty(key)) {
        // This entered again before it fully left. Add it again.
        _this.keysToEnter.push(key);
      } else {
        _this.setState(function (state) {
          var newChildren = _extends({}, state.children);
          delete newChildren[key];
          return { children: newChildren };
        });
      }
    };

    _this.childRefs = Object.create(null);

    _this.state = {
      children: (0, _ChildMapping.getChildMapping)(props.children)
    };
    return _this;
  }

  TransitionGroup.prototype.componentWillMount = function componentWillMount() {
    this.currentlyTransitioningKeys = {};
    this.keysToEnter = [];
    this.keysToLeave = [];
  };

  TransitionGroup.prototype.componentDidMount = function componentDidMount() {
    var initialChildMapping = this.state.children;
    for (var key in initialChildMapping) {
      if (initialChildMapping[key]) {
        this.performAppear(key, this.childRefs[key]);
      }
    }
  };

  TransitionGroup.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var nextChildMapping = (0, _ChildMapping.getChildMapping)(nextProps.children);
    var prevChildMapping = this.state.children;

    this.setState({
      children: (0, _ChildMapping.mergeChildMappings)(prevChildMapping, nextChildMapping)
    });

    for (var key in nextChildMapping) {
      var hasPrev = prevChildMapping && prevChildMapping.hasOwnProperty(key);
      if (nextChildMapping[key] && !hasPrev && !this.currentlyTransitioningKeys[key]) {
        this.keysToEnter.push(key);
      }
    }

    for (var _key in prevChildMapping) {
      var hasNext = nextChildMapping && nextChildMapping.hasOwnProperty(_key);
      if (prevChildMapping[_key] && !hasNext && !this.currentlyTransitioningKeys[_key]) {
        this.keysToLeave.push(_key);
      }
    }

    // If we want to someday check for reordering, we could do it here.
  };

  TransitionGroup.prototype.componentDidUpdate = function componentDidUpdate() {
    var _this2 = this;

    var keysToEnter = this.keysToEnter;
    this.keysToEnter = [];
    keysToEnter.forEach(function (key) {
      return _this2.performEnter(key, _this2.childRefs[key]);
    });

    var keysToLeave = this.keysToLeave;
    this.keysToLeave = [];
    keysToLeave.forEach(function (key) {
      return _this2.performLeave(key, _this2.childRefs[key]);
    });
  };

  TransitionGroup.prototype.render = function render() {
    var _this3 = this;

    // TODO: we could get rid of the need for the wrapper node
    // by cloning a single child
    var childrenToRender = [];

    var _loop = function _loop(key) {
      var child = _this3.state.children[key];
      if (child) {
        var isCallbackRef = typeof child.ref !== 'string';
        var factoryChild = _this3.props.childFactory(child);
        var ref = function ref(r) {
          _this3.childRefs[key] = r;
        };

         false ? (0, _warning2.default)(isCallbackRef, 'string refs are not supported on children of TransitionGroup and will be ignored. ' + 'Please use a callback ref instead: https://facebook.github.io/react/docs/refs-and-the-dom.html#the-ref-callback-attribute') : void 0;

        // Always chaining the refs leads to problems when the childFactory
        // wraps the child. The child ref callback gets called twice with the
        // wrapper and the child. So we only need to chain the ref if the
        // factoryChild is not different from child.
        if (factoryChild === child && isCallbackRef) {
          ref = (0, _chainFunction2.default)(child.ref, ref);
        }

        // You may need to apply reactive updates to a child as it is leaving.
        // The normal React way to do it won't work since the child will have
        // already been removed. In case you need this behavior you can provide
        // a childFactory function to wrap every child, even the ones that are
        // leaving.
        childrenToRender.push(_react2.default.cloneElement(factoryChild, {
          key: key,
          ref: ref
        }));
      }
    };

    for (var key in this.state.children) {
      _loop(key);
    }

    // Do not forward TransitionGroup props to primitive DOM nodes
    var props = _extends({}, this.props);
    delete props.transitionLeave;
    delete props.transitionName;
    delete props.transitionAppear;
    delete props.transitionEnter;
    delete props.childFactory;
    delete props.transitionLeaveTimeout;
    delete props.transitionEnterTimeout;
    delete props.transitionAppearTimeout;
    delete props.component;

    return _react2.default.createElement(this.props.component, props, childrenToRender);
  };

  return TransitionGroup;
}(_react2.default.Component);

TransitionGroup.displayName = 'TransitionGroup';

TransitionGroup.propTypes =  false ? propTypes : {};
TransitionGroup.defaultProps = defaultProps;

exports.default = TransitionGroup;
module.exports = exports['default'];

/***/ }),

/***/ 1359:
/***/ (function(module, exports) {


module.exports = function chain() {
  var len = arguments.length;
  var args = [];

  for (var i = 0; i < len; i++) {
    args[i] = arguments[i];
  }args = args.filter(function (fn) {
    return fn != null;
  });

  if (args.length === 0) return undefined;
  if (args.length === 1) return args[0];

  return args.reduce(function (current, next) {
    return function chainedFunction() {
      current.apply(this, arguments);
      next.apply(this, arguments);
    };
  });
};

/***/ }),

/***/ 1360:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.getChildMapping = getChildMapping;
exports.mergeChildMappings = mergeChildMappings;

var _react = __webpack_require__(11);

/**
 * Given `this.props.children`, return an object mapping key to child.
 *
 * @param {*} children `this.props.children`
 * @return {object} Mapping of key to child
 */
function getChildMapping(children) {
  if (!children) {
    return children;
  }
  var result = {};
  _react.Children.map(children, function (child) {
    return child;
  }).forEach(function (child) {
    result[child.key] = child;
  });
  return result;
}

/**
 * When you're adding or removing children some may be added or removed in the
 * same render pass. We want to show *both* since we want to simultaneously
 * animate elements in and out. This function takes a previous set of keys
 * and a new set of keys and merges them with its best guess of the correct
 * ordering. In the future we may expose some of the utilities in
 * ReactMultiChild to make this easy, but for now React itself does not
 * directly have this concept of the union of prevChildren and nextChildren
 * so we implement it here.
 *
 * @param {object} prev prev children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @param {object} next next children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @return {object} a key set that contains all keys in `prev` and all keys
 * in `next` in a reasonable order.
 */
function mergeChildMappings(prev, next) {
  prev = prev || {};
  next = next || {};

  function getValueForKey(key) {
    if (next.hasOwnProperty(key)) {
      return next[key];
    }

    return prev[key];
  }

  // For each key of `next`, the list of keys to insert before that key in
  // the combined list
  var nextKeysPending = {};

  var pendingKeys = [];
  for (var prevKey in prev) {
    if (next.hasOwnProperty(prevKey)) {
      if (pendingKeys.length) {
        nextKeysPending[prevKey] = pendingKeys;
        pendingKeys = [];
      }
    } else {
      pendingKeys.push(prevKey);
    }
  }

  var i = void 0;
  var childMapping = {};
  for (var nextKey in next) {
    if (nextKeysPending.hasOwnProperty(nextKey)) {
      for (i = 0; i < nextKeysPending[nextKey].length; i++) {
        var pendingNextKey = nextKeysPending[nextKey][i];
        childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
      }
    }
    childMapping[nextKey] = getValueForKey(nextKey);
  }

  // Finally, add the keys which didn't appear before any key in `next`
  for (i = 0; i < pendingKeys.length; i++) {
    childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
  }

  return childMapping;
}

/***/ }),

/***/ 1361:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.__esModule = true;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

var _addClass = __webpack_require__(1362);

var _addClass2 = _interopRequireDefault(_addClass);

var _removeClass = __webpack_require__(1364);

var _removeClass2 = _interopRequireDefault(_removeClass);

var _requestAnimationFrame = __webpack_require__(1365);

var _requestAnimationFrame2 = _interopRequireDefault(_requestAnimationFrame);

var _properties = __webpack_require__(1366);

var _react = __webpack_require__(11);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1246);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__(38);

var _PropTypes = __webpack_require__(1264);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === 'undefined' ? 'undefined' : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === 'undefined' ? 'undefined' : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var events = [];
if (_properties.transitionEnd) events.push(_properties.transitionEnd);
if (_properties.animationEnd) events.push(_properties.animationEnd);

function addEndListener(node, listener) {
  if (events.length) {
    events.forEach(function (e) {
      return node.addEventListener(e, listener, false);
    });
  } else {
    setTimeout(listener, 0);
  }

  return function () {
    if (!events.length) return;
    events.forEach(function (e) {
      return node.removeEventListener(e, listener, false);
    });
  };
}

var propTypes = {
  children: _propTypes2.default.node,
  name: _PropTypes.nameShape.isRequired,

  // Once we require timeouts to be specified, we can remove the
  // boolean flags (appear etc.) and just accept a number
  // or a bool for the timeout flags (appearTimeout etc.)
  appear: _propTypes2.default.bool,
  enter: _propTypes2.default.bool,
  leave: _propTypes2.default.bool,
  appearTimeout: _propTypes2.default.number,
  enterTimeout: _propTypes2.default.number,
  leaveTimeout: _propTypes2.default.number
};

var CSSTransitionGroupChild = function (_React$Component) {
  _inherits(CSSTransitionGroupChild, _React$Component);

  function CSSTransitionGroupChild() {
    var _temp, _this, _ret;

    _classCallCheck(this, CSSTransitionGroupChild);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.componentWillAppear = function (done) {
      if (_this.props.appear) {
        _this.transition('appear', done, _this.props.appearTimeout);
      } else {
        done();
      }
    }, _this.componentWillEnter = function (done) {
      if (_this.props.enter) {
        _this.transition('enter', done, _this.props.enterTimeout);
      } else {
        done();
      }
    }, _this.componentWillLeave = function (done) {
      if (_this.props.leave) {
        _this.transition('leave', done, _this.props.leaveTimeout);
      } else {
        done();
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  CSSTransitionGroupChild.prototype.componentWillMount = function componentWillMount() {
    this.classNameAndNodeQueue = [];
    this.transitionTimeouts = [];
  };

  CSSTransitionGroupChild.prototype.componentWillUnmount = function componentWillUnmount() {
    this.unmounted = true;

    if (this.timeout) {
      clearTimeout(this.timeout);
    }
    this.transitionTimeouts.forEach(function (timeout) {
      clearTimeout(timeout);
    });

    this.classNameAndNodeQueue.length = 0;
  };

  CSSTransitionGroupChild.prototype.transition = function transition(animationType, finishCallback, timeout) {
    var node = (0, _reactDom.findDOMNode)(this);

    if (!node) {
      if (finishCallback) {
        finishCallback();
      }
      return;
    }

    var className = this.props.name[animationType] || this.props.name + '-' + animationType;
    var activeClassName = this.props.name[animationType + 'Active'] || className + '-active';
    var timer = null;
    var removeListeners = void 0;

    (0, _addClass2.default)(node, className);

    // Need to do this to actually trigger a transition.
    this.queueClassAndNode(activeClassName, node);

    // Clean-up the animation after the specified delay
    var finish = function finish(e) {
      if (e && e.target !== node) {
        return;
      }

      clearTimeout(timer);
      if (removeListeners) removeListeners();

      (0, _removeClass2.default)(node, className);
      (0, _removeClass2.default)(node, activeClassName);

      if (removeListeners) removeListeners();

      // Usually this optional callback is used for informing an owner of
      // a leave animation and telling it to remove the child.
      if (finishCallback) {
        finishCallback();
      }
    };

    if (timeout) {
      timer = setTimeout(finish, timeout);
      this.transitionTimeouts.push(timer);
    } else if (_properties.transitionEnd) {
      removeListeners = addEndListener(node, finish);
    }
  };

  CSSTransitionGroupChild.prototype.queueClassAndNode = function queueClassAndNode(className, node) {
    var _this2 = this;

    this.classNameAndNodeQueue.push({
      className: className,
      node: node
    });

    if (!this.rafHandle) {
      this.rafHandle = (0, _requestAnimationFrame2.default)(function () {
        return _this2.flushClassNameAndNodeQueue();
      });
    }
  };

  CSSTransitionGroupChild.prototype.flushClassNameAndNodeQueue = function flushClassNameAndNodeQueue() {
    if (!this.unmounted) {
      this.classNameAndNodeQueue.forEach(function (obj) {
        // This is for to force a repaint,
        // which is necessary in order to transition styles when adding a class name.
        /* eslint-disable no-unused-expressions */
        obj.node.scrollTop;
        /* eslint-enable no-unused-expressions */
        (0, _addClass2.default)(obj.node, obj.className);
      });
    }
    this.classNameAndNodeQueue.length = 0;
    this.rafHandle = null;
  };

  CSSTransitionGroupChild.prototype.render = function render() {
    var props = _extends({}, this.props);
    delete props.name;
    delete props.appear;
    delete props.enter;
    delete props.leave;
    delete props.appearTimeout;
    delete props.enterTimeout;
    delete props.leaveTimeout;
    delete props.children;
    return _react2.default.cloneElement(_react2.default.Children.only(this.props.children), props);
  };

  return CSSTransitionGroupChild;
}(_react2.default.Component);

CSSTransitionGroupChild.displayName = 'CSSTransitionGroupChild';

CSSTransitionGroupChild.propTypes =  false ? propTypes : {};

exports.default = CSSTransitionGroupChild;
module.exports = exports['default'];

/***/ }),

/***/ 1362:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1251);

exports.__esModule = true;
exports.default = addClass;

var _hasClass = _interopRequireDefault(__webpack_require__(1363));

function addClass(element, className) {
  if (element.classList) element.classList.add(className);else if (!(0, _hasClass.default)(element, className)) if (typeof element.className === 'string') element.className = element.className + ' ' + className;else element.setAttribute('class', (element.className && element.className.baseVal || '') + ' ' + className);
}

module.exports = exports["default"];

/***/ }),

/***/ 1363:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = hasClass;

function hasClass(element, className) {
  if (element.classList) return !!className && element.classList.contains(className);else return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
}

module.exports = exports["default"];

/***/ }),

/***/ 1364:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function replaceClassName(origClass, classToRemove) {
  return origClass.replace(new RegExp('(^|\\s)' + classToRemove + '(?:\\s|$)', 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
}

module.exports = function removeClass(element, className) {
  if (element.classList) element.classList.remove(className);else if (typeof element.className === 'string') element.className = replaceClassName(element.className, className);else element.setAttribute('class', replaceClassName(element.className && element.className.baseVal || '', className));
};

/***/ }),

/***/ 1365:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1251);

exports.__esModule = true;
exports.default = void 0;

var _inDOM = _interopRequireDefault(__webpack_require__(1263));

var vendors = ['', 'webkit', 'moz', 'o', 'ms'];
var cancel = 'clearTimeout';
var raf = fallback;
var compatRaf;

var getKey = function getKey(vendor, k) {
  return vendor + (!vendor ? k : k[0].toUpperCase() + k.substr(1)) + 'AnimationFrame';
};

if (_inDOM.default) {
  vendors.some(function (vendor) {
    var rafKey = getKey(vendor, 'request');

    if (rafKey in window) {
      cancel = getKey(vendor, 'cancel');
      return raf = function raf(cb) {
        return window[rafKey](cb);
      };
    }
  });
}
/* https://github.com/component/raf */

var prev = new Date().getTime();

function fallback(fn) {
  var curr = new Date().getTime(),
      ms = Math.max(0, 16 - (curr - prev)),
      req = setTimeout(fn, ms);
  prev = curr;
  return req;
}

compatRaf = function compatRaf(cb) {
  return raf(cb);
};

compatRaf.cancel = function (id) {
  window[cancel] && typeof window[cancel] === 'function' && window[cancel](id);
};

var _default = compatRaf;
exports.default = _default;
module.exports = exports["default"];

/***/ }),

/***/ 1366:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1251);

exports.__esModule = true;
exports.default = exports.animationEnd = exports.animationDelay = exports.animationTiming = exports.animationDuration = exports.animationName = exports.transitionEnd = exports.transitionDuration = exports.transitionDelay = exports.transitionTiming = exports.transitionProperty = exports.transform = void 0;

var _inDOM = _interopRequireDefault(__webpack_require__(1263));

var transform = 'transform';
exports.transform = transform;
var prefix, transitionEnd, animationEnd;
exports.animationEnd = animationEnd;
exports.transitionEnd = transitionEnd;
var transitionProperty, transitionDuration, transitionTiming, transitionDelay;
exports.transitionDelay = transitionDelay;
exports.transitionTiming = transitionTiming;
exports.transitionDuration = transitionDuration;
exports.transitionProperty = transitionProperty;
var animationName, animationDuration, animationTiming, animationDelay;
exports.animationDelay = animationDelay;
exports.animationTiming = animationTiming;
exports.animationDuration = animationDuration;
exports.animationName = animationName;

if (_inDOM.default) {
  var _getTransitionPropert = getTransitionProperties();

  prefix = _getTransitionPropert.prefix;
  exports.transitionEnd = transitionEnd = _getTransitionPropert.transitionEnd;
  exports.animationEnd = animationEnd = _getTransitionPropert.animationEnd;
  exports.transform = transform = prefix + "-" + transform;
  exports.transitionProperty = transitionProperty = prefix + "-transition-property";
  exports.transitionDuration = transitionDuration = prefix + "-transition-duration";
  exports.transitionDelay = transitionDelay = prefix + "-transition-delay";
  exports.transitionTiming = transitionTiming = prefix + "-transition-timing-function";
  exports.animationName = animationName = prefix + "-animation-name";
  exports.animationDuration = animationDuration = prefix + "-animation-duration";
  exports.animationTiming = animationTiming = prefix + "-animation-delay";
  exports.animationDelay = animationDelay = prefix + "-animation-timing-function";
}

var _default = {
  transform: transform,
  end: transitionEnd,
  property: transitionProperty,
  timing: transitionTiming,
  delay: transitionDelay,
  duration: transitionDuration
};
exports.default = _default;

function getTransitionProperties() {
  var style = document.createElement('div').style;
  var vendorMap = {
    O: function O(e) {
      return "o" + e.toLowerCase();
    },
    Moz: function Moz(e) {
      return e.toLowerCase();
    },
    Webkit: function Webkit(e) {
      return "webkit" + e;
    },
    ms: function ms(e) {
      return "MS" + e;
    }
  };
  var vendors = Object.keys(vendorMap);
  var transitionEnd, animationEnd;
  var prefix = '';

  for (var i = 0; i < vendors.length; i++) {
    var vendor = vendors[i];

    if (vendor + "TransitionProperty" in style) {
      prefix = "-" + vendor.toLowerCase();
      transitionEnd = vendorMap[vendor]('TransitionEnd');
      animationEnd = vendorMap[vendor]('AnimationEnd');
      break;
    }
  }

  if (!transitionEnd && 'transitionProperty' in style) transitionEnd = 'transitionend';
  if (!animationEnd && 'animationName' in style) animationEnd = 'animationend';
  style = null;
  return {
    animationEnd: animationEnd,
    transitionEnd: transitionEnd,
    prefix: prefix
  };
}

/***/ }),

/***/ 1367:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1368);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./PaymentModal.css", function() {
        content = require("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./PaymentModal.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 1368:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, "._2aYHp{position:fixed;z-index:3005;background-color:rgba(50,50,50,.2);top:0;left:0;display:-webkit-box;display:-ms-flexbox;display:flex;overflow-y:auto;width:100%;height:100%;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;font-weight:400}.Qt1yN{position:absolute;top:0;left:0;right:0;bottom:0;z-index:3006}._8VETH{position:relative;background-color:#fff;width:600px;min-height:400px;padding:10px 20px 18px;margin:5px;-ms-flex-item-align:center;align-self:center;z-index:3007}._2ux5J{font-size:21px;font-weight:400;padding-bottom:15px;margin-bottom:11px;border-bottom:1px solid #eee}._1DP-n{margin-bottom:5px}.pu5sx{position:relative;-ms-flex-line-pack:stretch;align-content:stretch;margin:20px 0 35px}.pu5sx,.sMEF2{display:-webkit-box;display:-ms-flexbox;display:flex}.sMEF2{width:100%;max-width:50%;padding:20px 15px;margin:0 20px 0 auto;border:2px solid #eee;border-radius:2px;text-align:center;-webkit-transition:all .1s ease-out;-o-transition:all .1s ease-out;transition:all .1s ease-out;background:transparent;outline:none}.sMEF2:last-of-type{margin-right:auto}._2zCrj{margin:auto}._3ZjNy{padding-top:7px}._3o5Yq{height:100%;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}._3o5Yq,._3v-gG{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-flow:column wrap;flex-flow:column wrap}._3v-gG{position:relative}.sMEF2:not(._2FvZr):hover{color:#000;border-color:#ffd906;background-color:#fffbd3;cursor:pointer;outline:none}.VjrcA{text-align:right}._3gU1v,.VjrcA{position:relative}._3gU1v{margin-left:10px;border:1px solid #d0d0d0;background-color:#fff;color:#000;padding:8px 16px;overflow:hidden}._3gU1v:hover{cursor:pointer;border-color:#ffd906}._3gU1v._2FvZr>:not(._2si0B){visibility:hidden}._1EHnC{position:absolute;top:50%;left:50%;-webkit-transform:translate(-50%,-50%);transform:translate(-50%,-50%)}._1ofkJ{padding-top:21px;padding-left:18px;font-size:13px;font-weight:400;color:#aaa;margin:0 0 6px}._3_uNl{margin:5px;bottom:21px;position:absolute;left:-4px}@media screen and (max-width:380px){.pu5sx{-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;margin:0}.sMEF2{margin:10px auto}}._2FvZr{opacity:.6}._3s_hN{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;cursor:pointer;position:relative;font-weight:400;color:#000;padding-left:20px}._3s_hN:hover{color:#ff5a5f}._3s_hN input{cursor:pointer;position:absolute;left:4px;border:1px solid #aaa;border-radius:2px}._3s_hN input,._3s_hN input:checked{margin-left:-4px;top:1px;-webkit-appearance:none;width:15px;height:15px;outline:none}._3s_hN input:checked{border:1px solid #2196f3;background-color:#fff;border-radius:2px}._3s_hN input:checked:after{-webkit-appearance:none;position:absolute;font:0/0 a;z-index:15;top:1px;left:-1px;overflow:hidden;width:17px;height:9px;margin-top:-6px;content:\" \";pointer-events:none;border-width:0 0 2px 2px;border-style:solid;border-color:#222;border-radius:1px;background:0 0;-webkit-transform:rotate(315deg);transform:rotate(315deg)}._3ZsMo input,._3ZsMo input:checked{margin-top:-8px;margin-left:-4px}", ""]);

// exports
exports.locals = {
	"root": "_2aYHp",
	"bg": "Qt1yN",
	"container": "_8VETH",
	"h3": "_2ux5J",
	"balance": "_1DP-n",
	"list": "pu5sx",
	"payment": "sMEF2",
	"paymentContents": "_2zCrj",
	"paymentTitle": "_3ZjNy",
	"column": "_3o5Yq",
	"columnWrapper": "_3v-gG",
	"disabled": "_2FvZr",
	"actions": "VjrcA",
	"button": "_3gU1v",
	"buttonLoader": "_2si0B",
	"loader": "_1EHnC",
	"contractOffer": "_1ofkJ",
	"contractCheckbox": "_3_uNl",
	"checkbox": "_3s_hN",
	"mobile": "_3ZsMo"
};

/***/ }),

/***/ 1369:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1370);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./BalanceRefill.css", function() {
        content = require("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./BalanceRefill.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 1370:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, ".DmOcI{display:-webkit-box;display:-ms-flexbox;display:flex;position:relative;min-height:44px;line-height:44px;font-size:16px;font-weight:400}._3ZFf5{height:44px;background-color:#ffd906;border:1px solid #ffd906;color:#000;padding:10px 12px;border-radius:0 2px 2px 0;cursor:pointer;font-weight:600;outline:none}._3ZFf5:hover{background:#ffc107;border:1px solid #ffc107}._30C05{position:absolute;top:1px;left:110px}.LY1XA{border:1px solid #e0e0e0;font-size:16px;-webkit-transition:all .15s ease-out;-o-transition:all .15s ease-out;transition:all .15s ease-out;outline:none;width:150px;padding:12px 43px 12px 12px;text-align:right;max-height:44px}.LY1XA:active,.LY1XA:focus{outline:none;-webkit-box-shadow:none;box-shadow:none;border:1px solid #ffd906}", ""]);

// exports
exports.locals = {
	"inputContainer": "DmOcI",
	"inlineButton": "_3ZFf5",
	"hrn": "_30C05",
	"input": "LY1XA"
};

/***/ }),

/***/ 1371:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1372);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./Balance.css", function() {
        content = require("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./Balance.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 1372:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, "._1uFAv{position:relative;cursor:pointer;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;padding-right:8px}._2B6Dt{font-weight:600;color:inherit;text-decoration:none}._2O5JS{position:absolute;top:100%;right:0;padding:10px 8px 8px;background:#fff;-webkit-box-shadow:-1px 14px 28px -14px rgba(0,0,0,.75);box-shadow:-1px 14px 28px -14px rgba(0,0,0,.75)}._3iQnl{vertical-align:text-bottom}._2xW05{vertical-align:top}", ""]);

// exports
exports.locals = {
	"root": "_1uFAv",
	"content": "_2B6Dt",
	"popup": "_2O5JS",
	"icon": "_3iQnl",
	"title": "_2xW05"
};

/***/ }),

/***/ 1373:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1374);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./SubHeader.css", function() {
        content = require("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./SubHeader.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 1374:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, "._1D_Nn{position:relative;background-color:#fff;z-index:7;padding:0 15px}._1ediK{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-flow:row nowrap;flex-flow:row nowrap}._1ediK,._2cKE_,.TpfX0{-webkit-box-flex:1;-ms-flex:1 1 auto;flex:1 1 auto}.TpfX0{display:-webkit-box;display:-ms-flexbox;display:flex;text-align:right;-webkit-box-align:center;-ms-flex-align:center;align-items:center;padding-right:10px;height:44px;line-height:42px;-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end}._3YhcH{border:0;background:none}._3c7Db,._3YhcH,.vuYGG{display:inline-block}.vuYGG{font-weight:600;color:inherit;text-decoration:none}.vuYGG+.vuYGG{margin-left:30px}._3c7Db{margin-left:28px}._1dKSE{color:#e73232}", ""]);

// exports
exports.locals = {
	"root": "_1D_Nn",
	"container": "_1ediK container",
	"left": "_2cKE_",
	"right": "TpfX0",
	"locationSelect": "_3YhcH",
	"tariff": "vuYGG",
	"balance": "_3c7Db",
	"nonActiveTariff": "_1dKSE"
};

/***/ }),

/***/ 1375:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, ".zDFkx{position:relative;font-size:13px;line-height:18px;min-width:920px;padding:15px 0 30px;color:hsla(0,0%,100%,.5);background:#212121;z-index:3;min-height:200px}._3RtQ6{padding:0 20px;margin:0 auto}.fb9ID{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-flow:row nowrap;flex-flow:row nowrap}._20qxe{-webkit-box-flex:1;-ms-flex:1 1 auto;flex:1 1 auto}.NYfbf{-webkit-box-flex:0;-ms-flex:0 0 auto;flex:0 0 auto;width:265px;text-align:right;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;-webkit-box-align:center;-ms-flex-align:center;align-items:center}._35XCD{list-style:none;margin:10px 0;padding:0;min-width:790px}._35XCD li{display:inline-block;margin-right:20px}._19Cat{display:-webkit-box;display:-ms-flexbox;display:flex;padding:0}._2Rxe3{-webkit-box-flex:1;-ms-flex:1 1 0%;flex:1 1 0%;margin-bottom:8px}._3EfAE{font-weight:500;font-size:18px;line-height:120%;color:#fff}._2-_Wn{font-size:12px}._2Dlbx{font-weight:400;text-decoration:none;font-size:14px;color:hsla(0,0%,100%,.85);-webkit-transition:all .15s ease-out;-o-transition:all .15s ease-out;transition:all .15s ease-out}._2xcDA{font-weight:400}._2xcDA,.Oogak{text-decoration:none;font-size:13px;color:hsla(0,0%,100%,.5);-webkit-transition:all .15s ease-out;-o-transition:all .15s ease-out;transition:all .15s ease-out}.Oogak{position:relative;margin:10px 0;font-weight:700;display:inline-block;letter-spacing:.05em}._2Dlbx:hover,._2xcDA:hover,.Oogak:hover{color:#fff;cursor:pointer}._2-8Mr{border-top:1px solid #4e4e4e;margin:16px 0}._2rdKT{font-size:22px;color:#fff;text-decoration:none;opacity:.8;padding-left:14px}._2rdKT:hover{opacity:1}._1AipK a,span{color:inherit;text-decoration:none}._1AipK:after{content:\" | \";margin:0 10px}._1AipK:last-child:after{content:none}._3pz-l{text-align:center;margin-top:20px}@media print{.zDFkx{display:none}}._3rXoJ ul{padding:0}", ""]);

// exports
exports.locals = {
	"root": "zDFkx",
	"container": "_3RtQ6 container",
	"flexContainer": "fb9ID",
	"left": "_20qxe",
	"right": "NYfbf",
	"nav": "_35XCD",
	"navLeasing": "_19Cat",
	"navLeasingItem": "_2Rxe3",
	"navLeasingTitle": "_3EfAE",
	"navLeasingTitleHeader": "_2-_Wn",
	"link": "_2Dlbx",
	"smallLink": "_2xcDA",
	"tel": "Oogak",
	"divide": "_2-8Mr",
	"socialLink": "_2rdKT",
	"lang": "_1AipK",
	"footerCopyRight": "_3pz-l",
	"leasingList": "_3rXoJ"
};

/***/ }),

/***/ 1376:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1377);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./ColumnList.css", function() {
        content = require("!!../../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./ColumnList.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 1377:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, ".JoFQz{margin-top:20px}._3QNtp{width:200px}._2iDdE{list-style:none}._2fQe9{font-size:11px;color:inherit;text-decoration:none;margin-top:0;margin-bottom:1em;white-space:nowrap;overflow:hidden;display:block}._1LE5p{cursor:pointer;text-decoration:none}._1LE5p,._2XVd2{padding:10px;font-size:14px;font-weight:700;display:inline-block;color:hsla(0,0%,100%,.5)}.wcDf5{color:#dedede!important;font-size:12px}._3oo16{color:rgba(64,64,64,.98);font-size:12px;font-weight:700}._35FVL{display:block;padding-left:0;margin-left:-6px;font-size:12px;cursor:auto}.r4Dcm{cursor:pointer}._1gtiU{color:hsla(0,0%,100%,.5)!important}._1mQCi{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row}", ""]);

// exports
exports.locals = {
	"root": "JoFQz",
	"column": "_3QNtp",
	"item": "_2iDdE",
	"link": "_2fQe9",
	"resetLocationLink": "_1LE5p",
	"resetLocationText": "_2XVd2",
	"selLocation": "wcDf5",
	"disabledCity": "_3oo16",
	"curentBreadCrumbs": "_35FVL",
	"cursorPointer": "r4Dcm",
	"hideHover": "_1gtiU",
	"breadCrumbsBlock": "_1mQCi"
};

/***/ }),

/***/ 1378:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1379);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./LocationList.css", function() {
        content = require("!!../../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./LocationList.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 1379:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, "._1PNMZ,._3G2DH{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}._1PNMZ ._3Lg2h{-webkit-box-orient:horizontal;-ms-flex-direction:row;flex-direction:row}._1PNMZ ._3Lg2h,._3G2DH ._3Lg2h{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-direction:normal;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;list-style:none;margin:0}._3G2DH ._3Lg2h{-webkit-box-orient:vertical;-ms-flex-direction:column;flex-direction:column}._3Lg2h{font-weight:400}.f2F2C{font-size:14px;color:#c4c4c4}", ""]);

// exports
exports.locals = {
	"root": "_1PNMZ",
	"rootMobile": "_3G2DH",
	"citiesList": "_3Lg2h",
	"title": "f2F2C"
};

/***/ }),

/***/ 1380:
/***/ (function(module, exports) {

module.exports = {"title":"Популярные разделы","uk_title":"Популярні розділи","items":[{"id":1,"title":"Б/у авто в лизинг","uk_title":"Б/у авто в лізинг","slug":"/leasing/used-avto/"},{"id":2,"title":"Новые авто в лизинг","uk_title":"Нові авто в лізинг","slug":"/leasing/novyye-avto/"},{"id":3,"title":"Легковые авто в лизинг","uk_title":"Легкові авто в лізинг","slug":"/leasing/leasing-legkovykh-avto/"},{"id":4,"title":"Лизинг авто для физических лиц","uk_title":"Лізинг авто для фізичних осіб","slug":"/leasing/leasing-avto-fizicheskikh-lits/"}]}

/***/ }),

/***/ 1381:
/***/ (function(module, exports) {

module.exports = {"title":"Популярные Марки авто в лизинг","uk_title":"Популярні Марки авто в лізинг","items":[{"id":1,"title":"bmw в лизинг","uk_title":"bmw у лізинг","slug":"/leasing/bmw/"},{"id":2,"title":"peugeot в лизинг","uk_title":"peugeot у лізинг","slug":"/leasing/peugeot/"},{"id":3,"title":"volvo в лизинг","uk_title":"volvo у лізинг","slug":"/leasing/volvo/"},{"id":4,"title":"toyota в лизинг","uk_title":"toyota у лізинг","slug":"/leasing/toyota/"},{"id":5,"title":"mazda в лизинг","uk_title":"mazda у лізинг","slug":"/leasing/mazda/"},{"id":6,"title":"skoda в лизинг","uk_title":"skoda у лізинг","slug":"/leasing/skoda/"},{"id":7,"title":"газель в лизинг","uk_title":"газель у лізинг","slug":"/leasing/gaz/"},{"id":8,"title":"volkswagen в лизинг","uk_title":"volkswagen у лізинг","slug":"/leasing/volkswagen/"},{"id":9,"title":"порше в лизинг","uk_title":"порше у лізинг","slug":"/leasing/porsche/"},{"id":10,"title":"ауди в лизинг","uk_title":"ауди у лізинг","slug":"/leasing/audi/"},{"id":11,"title":"citroen в лизинг","uk_title":"citroen у лізинг","slug":"/leasing/citroen/"},{"id":12,"title":"mercedes benz в лизинг","uk_title":"mercedes benz у лізинг","slug":"/leasing/mercedes-benz/"},{"id":13,"title":"ford в лизинг","uk_title":"ford у лізинг","slug":"/leasing/ford/"},{"id":14,"title":"nissan в лизинг","uk_title":"nissan у лізинг","slug":"/leasing/nissan/"},{"id":15,"title":"hyundai в лизинг","uk_title":"hyundai у лізинг","slug":"/leasing/hyundai/"},{"id":16,"title":"renault в лизинг","uk_title":"renault у лізинг","slug":"/leasing/renault/"}]}

/***/ }),

/***/ 1382:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1383);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./LanguageList.css", function() {
        content = require("!!../../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./LanguageList.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 1383:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, "._11JjB a,span{color:inherit;text-decoration:none}._11JjB:after{content:\" | \";margin:0 10px}._11JjB:last-child:after{content:none}", ""]);

// exports
exports.locals = {
	"lang": "_11JjB"
};

/***/ }),

/***/ 1384:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1385);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./NotificationBar.css", function() {
        content = require("!!../../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./NotificationBar.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 1385:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, ".KSaKz{position:fixed;top:0;left:0;width:100%;background:rgba(0,0,0,.8);padding:13px 20px;-webkit-transform:translateY(-100%);transform:translateY(-100%);-webkit-transition:-webkit-transform .1s linear;transition:-webkit-transform .1s linear;-o-transition:transform .1s linear;transition:transform .1s linear;transition:transform .1s linear,-webkit-transform .1s linear;z-index:10000}._2sO61{background:#e73232;color:#fff}._2A3gx{background:#ffd906;color:#000}._1aLfe{background:#4caf10;color:#fff}._2pXnf{background:#2196f3;color:#fff}.bzlx8{-webkit-transform:translateY(0);transform:translateY(0)}._1WJlP{color:#fff;text-align:center;max-width:800px;margin:0 auto}@media print{.KSaKz{display:none}}", ""]);

// exports
exports.locals = {
	"root": "KSaKz",
	"error": "_2sO61",
	"warning": "_2A3gx",
	"success": "_1aLfe",
	"info": "_2pXnf",
	"active": "bzlx8",
	"label": "_1WJlP"
};

/***/ }),

/***/ 1386:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1387);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./Layout.css", function() {
        content = require("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./Layout.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 1387:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, ".-lRLO{position:relative;padding-top:10px;padding-bottom:10px;margin:0 auto;text-align:center}._35_nZ{-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-ms-flex-pack:distribute;justify-content:space-around}._3aSLj,._35_nZ{display:-webkit-box;display:-ms-flexbox;display:flex}._3aSLj{-webkit-box-align:center;-ms-flex-align:center;align-items:center}._1I3Gw{font-size:14px;font-weight:400;text-align:center;color:#000}._1I3Gw,.iXl6a{margin-bottom:20px}.iXl6a{float:right}._3w_FE{color:#2196f3;display:inline-block;cursor:pointer}._3w_FE:hover{color:#154088;border-bottom:.07em solid}._3w_FE:active{color:#497ddd;border-bottom:1px dashed}._18Fb4{display:inline-block;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;cursor:pointer;font-weight:400;font-size:15px;color:#000}._18Fb4 input{margin-left:0;position:absolute;left:0;border:1px solid #aaa;border-radius:2px}._18Fb4 input,._18Fb4 input:checked{top:3px;-webkit-appearance:none;width:15px;height:15px;outline:none}._18Fb4 input:checked{border:1px solid #2196f3;background-color:#fff;border-radius:2px}._18Fb4 input:checked:after{-webkit-appearance:none;position:absolute;font:0/0 a;z-index:15;top:0;left:-1px;overflow:hidden;width:17px;height:9px;content:\" \";pointer-events:none;border-width:0 0 2px 2px;border-style:solid;border-color:#222;border-radius:1px;background:0 0;-webkit-transform:rotate(315deg);transform:rotate(315deg)}._3IYbg input{margin-left:0;position:absolute;left:0;border:1px solid #aaa;border-radius:2px}._3IYbg input,._3IYbg input:checked{top:0;-webkit-appearance:none;width:15px;height:15px;outline:none}._3IYbg input:checked{border:1px solid #2196f3;background-color:#fff;border-radius:2px}._3IYbg input:checked:after{-webkit-appearance:none;position:absolute;font:0/0 a;z-index:15;top:-3px;left:-1px;overflow:hidden;width:17px;height:9px;content:\" \";pointer-events:none;border-width:0 0 2px 2px;border-style:solid;border-color:#222;border-radius:1px;background:0 0;-webkit-transform:rotate(315deg);transform:rotate(315deg)}body{font-family:OpenSans,sans-serif;padding:0 2px 0 0;color:#000;font-weight:400}a:focus{text-decoration:none}:after,:before{-webkit-box-sizing:border-box;box-sizing:border-box}.ant-form-item{margin:0}.ant-btn,button,input,optgroup,select,textarea{line-height:normal}._1ONYX{display:block;-webkit-box-sizing:border-box;box-sizing:border-box;padding:17px 16px;width:100%;height:60px;outline:0;border:1px solid #ccc;-webkit-appearance:none;border-radius:2px;background:#fff;color:#616161;font-size:18px;line-height:1.3333333;-webkit-transition:border-color .15s ease-in-out,-webkit-box-shadow .15s ease-in-out;transition:border-color .15s ease-in-out,-webkit-box-shadow .15s ease-in-out;-o-transition:border-color ease-in-out .15s,box-shadow ease-in-out .15s;transition:border-color .15s ease-in-out,box-shadow .15s ease-in-out;transition:border-color .15s ease-in-out,box-shadow .15s ease-in-out,-webkit-box-shadow .15s ease-in-out;margin:10px 0}._1ONYX::-webkit-input-placeholder{color:#6c6868cf;opacity:1}._1ONYX::-moz-placeholder{color:#6c6868cf;opacity:1}._1ONYX:-ms-input-placeholder{color:#6c6868cf;opacity:1}._1ONYX::placeholder{color:#6c6868cf;opacity:1}._3oObU::-webkit-input-placeholder{color:#6c6868cf;opacity:1}._3oObU::-moz-placeholder{color:#6c6868cf;opacity:1}._3oObU:-ms-input-placeholder{color:#6c6868cf;opacity:1}._3oObU::placeholder{color:#6c6868cf;opacity:1}._3oObU{padding:17px 16px;height:60px;outline:0;border:1px solid #ccc;-webkit-appearance:none;border-radius:2px;background:#fff;color:#616161;-webkit-transition:border-color .15s ease-in-out,-webkit-box-shadow .15s ease-in-out;transition:border-color .15s ease-in-out,-webkit-box-shadow .15s ease-in-out;-o-transition:border-color ease-in-out .15s,box-shadow ease-in-out .15s;transition:border-color .15s ease-in-out,box-shadow .15s ease-in-out;transition:border-color .15s ease-in-out,box-shadow .15s ease-in-out,-webkit-box-shadow .15s ease-in-out}._2RHEP,._3oObU{display:block;-webkit-box-sizing:border-box;box-sizing:border-box;width:100%;font-size:16px;line-height:1.3333333;margin-top:10px}._2RHEP{position:relative;margin-bottom:20px;height:46px;border:0;border-radius:3px;background:#ffd906;text-align:center;text-decoration:none;cursor:pointer;outline:none}._2RHEP>p{margin:0}._2RHEP:hover{background:#ffc1076b}._2RHEP:disabled,._2RHEP[disabled]{background:#ffc1077c;cursor:auto;color:rgba(0,0,0,.5)}.has-error>span>input{border-color:#f5222d}.ant-form-explain{color:#f5222d;padding:0 8px}.czsUy{text-align:center;padding:15px 0 40px}.ant-form-item{margin-bottom:5px}.eTG0E{font-size:13px;line-height:18px;margin:25px 0 20px;color:#555;letter-spacing:.34px;font-weight:400}.Nmq1p{text-decoration:none;font-size:15px;cursor:pointer}._2gUqb{cursor:pointer;float:right}._1SYqv{width:100%;text-align:right;margin:10px 0}._37Srk{font-size:14px;font-weight:400;text-align:center;color:#000;margin-top:20px;font-weight:600}._1frkA{position:relative;background-color:#fff}._1frkA,._1gBiv{margin-bottom:0;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-ms-flex-line-pack:justify;align-content:space-between;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}._1gBiv{max-width:740px}._1gBiv>div>div>iframe,._1gBiv>div>iframe,._1gBiv>iframe{max-width:100%}._1frkA>div{margin-bottom:0}._1frkA>div>div{padding-top:10px}._1frkA>div>div,._3lJEn,._31HIU{margin-bottom:20px}._3lJEn{display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-pack:distribute;justify-content:space-around;margin-top:20px;padding:0 45px}._3lJEn>div{margin-bottom:10px;margin-top:10px}#banner{display:none}._2s_Y4{position:relative;margin-top:-18px;padding-left:15px;max-width:1100px;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-ms-flex-line-pack:justify;align-content:space-between;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;padding-top:10px;-webkit-box-sizing:border-box;box-sizing:border-box;margin-bottom:20px}._2s_Y4,._30-Va>div{display:-webkit-box;display:-ms-flexbox;display:flex}._30-Va>div{width:100vw;-ms-flex-pack:distribute;justify-content:space-around}.is-focused:not(.is-open)>.Select-control{border-color:#ff5a5f;-webkit-box-shadow:none;box-shadow:none}.Select-control{border-radius:0;border:1px solid #e0e0e0}.Select-placeholder{color:#777}.d-advertSlot{margin-bottom:20px}.adunitContainer,.d-advertSlot{position:relative;text-align:center}.adunitContainer>:last-child{margin-bottom:20px}#app{position:relative;z-index:2;padding-top:63px;height:100%}.ap-script-wrapper>div{padding:20px}.F0IVy{min-width:1100px;position:relative;z-index:auto}._2azA2{margin-top:30px}html{color:#222;font-weight:100;font-size:1em;line-height:1.375}button,html{font-family:OpenSans,sans-serif}body{margin:0;background-color:#f5f5f5}a{color:#0074c2}a[class=meta-title-link-next],a[class=meta-title-link]{text-decoration:none}a[class=meta-title-link]+a[class=meta-title-link]:before,span[class=meta-title-link]+span[class=meta-title-link]:before{content:\"\";background-image:url(" + __webpack_require__(1267) + ");background-size:contain;background-repeat:no-repeat;display:inline-block;cursor:default;height:8px;width:10px}a[class=meta-title-link-next]:before,span[class=meta-title-link-next]:before{content:\"\";background-image:url(" + __webpack_require__(1267) + ");background-size:contain;background-repeat:no-repeat;display:inline-block;cursor:default;height:8px;width:10px}::-moz-selection{background:#b3d4fc;text-shadow:none}::selection{background:#b3d4fc;text-shadow:none}hr{display:block;height:1px;border:0;border-top:1px solid #ccc;margin:1em 0;padding:0}audio,canvas,iframe,img,svg,video{vertical-align:middle}fieldset{border:0;margin:0;padding:0}textarea{resize:vertical}.browserupgrade{margin:.2em 0;background:#ccc;color:#000;padding:.2em 0}@media print{*,:after,:before{background:transparent!important;color:#000!important;-webkit-box-shadow:none!important;box-shadow:none!important;text-shadow:none!important}a,a:visited{text-decoration:underline}a[href]:after{content:\" (\" attr(href) \")\"}abbr[title]:after{content:\" (\" attr(title) \")\"}a[href^=\"#\"]:after,a[href^=\"javascript:\"]:after{content:\"\"}blockquote,pre{border:1px solid #999;page-break-inside:avoid}thead{display:table-header-group}img,tr{page-break-inside:avoid}img{max-width:100%!important}h2,h3,p{orphans:3;widows:3}h2,h3{page-break-after:avoid}}._3RoS6{min-width:1070px;max-width:1100px;background:#f5f5f5;margin:8px auto 0;z-index:4;position:relative}._1agwl>div>iframe{margin-top:25px}._1HUfQ{position:relative;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-ms-flex-line-pack:justify;align-content:space-between;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-sizing:border-box;box-sizing:border-box}.imgCover{position:absolute;top:50%;left:50%;width:100%;height:auto;max-width:none;max-height:none;-webkit-transform:translate(-50%,-50%);transform:translate(-50%,-50%)}@supports ((-o-object-fit:cover) or (object-fit:cover)){.imgCover{position:static;top:auto;left:auto;width:100%;height:100%;-webkit-transform:none;transform:none;-o-object-fit:cover;object-fit:cover}}.page{padding:0;position:relative}.container{min-width:1070px;max-width:1100px;margin:0 auto}.card{background-color:#fff;z-index:1;padding:10px 20px}.flexRow{position:relative;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-webkit-box-align:stretch;-ms-flex-align:stretch;align-items:stretch}.questionTitle{font-size:21px;font-weight:700;margin-bottom:10px}.required:after{content:\"*\";display:inline-block;margin-left:2px;color:#c00}.input:active,.input:focus{outline:none;border:1px solid #ffc107}", ""]);

// exports
exports.locals = {
	"sbsGL": "-lRLO",
	"flexCenterGl": "_35_nZ",
	"flexCenterAlignGl": "_3aSLj",
	"titleNellGl": "_1I3Gw",
	"linkLeahs": "iXl6a",
	"linkLeah": "_3w_FE",
	"checkboxGl": "_18Fb4",
	"checkboxMobileGl": "_3IYbg",
	"inputFormGl": "_1ONYX",
	"inputFormMobilGl": "_3oObU",
	"buttonFormGl": "_2RHEP",
	"submitSectionGl": "czsUy",
	"agreementGl": "eTG0E",
	"urlGl": "Nmq1p",
	"linkTextGl": "_2gUqb",
	"linkBlockGl": "_1SYqv",
	"titleGl": "_37Srk",
	"advertContainerGl": "_1frkA",
	"banerAllStyleGl": "_1gBiv",
	"gptPremium": "_31HIU",
	"advertContainerButoonGl": "_3lJEn",
	"brandingAdvGl": "_2s_Y4",
	"mobileWebTop": "_30-Va",
	"root": "F0IVy",
	"mainFooter": "_2azA2",
	"layout": "_3RoS6",
	"banerTop": "_1agwl",
	"brandingAdv": "_1HUfQ"
};

/***/ }),

/***/ 1388:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// CONCATENATED MODULE: ./src/shared/helpers/seoDescription.js
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_shared_modules_subjectiveText_allText__ = __webpack_require__(309);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_shared_helpers_seoTextFinder__ = __webpack_require__(1254);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shared_constants_json_firstSeoRubricsTypes_json__ = __webpack_require__(1257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shared_constants_json_firstSeoRubricsTypes_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_shared_constants_json_firstSeoRubricsTypes_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_constants_json_secondSeoRubricsTypes_json__ = __webpack_require__(1258);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_constants_json_secondSeoRubricsTypes_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_shared_constants_json_secondSeoRubricsTypes_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shared_modules__ = __webpack_require__(103);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };







var buildFirmsSeoDescription = function buildFirmsSeoDescription(data, t) {
  var cityTitle = data.cityTitle,
      section = data.section,
      regLocation = data.regLocation,
      location = data.location;
  // if (section === 'СТО') {
  //   if (isRegion)
  //     return t(
  //       'Каталог СТО {locationAccusative}, ближайшие шиномонтажи, сервисы по диагностики и ремонту авто  ✅ адреса ☎️ телефоны на АвтоБазар™.',
  //       { locationAccusative },
  //     );
  //   else if (cityTitle)
  //     return t(
  //       'Каталог СТО в {cityTitle}, ближайшие шиномонтажи, сервисы по диагностики и ремонту авто  ✅ адреса ☎️ телефоны на АвтоБазар™.',
  //       { cityTitle },
  //     );
  //   return t(
  //     'Каталог СТО, ближайшие шиномонтажи, сервисы по диагностики и ремонту авто  ✅ адреса ☎️ телефоны на АвтоБазар™.',
  //   );
  // }
  // if (section && cityDescriptions) {
  //   return t(
  //     '{section} в {cityDescriptions}: Полный список организаций ✅ Адреса ✅ Контактные данные {section} в {cityDescriptions}',
  //     data,
  //   );
  // }
  // if (section) {
  //   return t(
  //     '{section} в Украине: Полный список организаций ✅ Адреса ✅ Контактные данные {section} в вашем городе',
  //     data,
  //   );
  // }
  // if (cityDescriptions) {
  //   return t(
  //     'Каталог СТО в {cityDescriptions}, ближайшие шиномонтажи, сервисы по диагностики и ремонту авто ✅ адреса ☎️ телефоны на АвтоБазар™.',
  //     data,
  //   );
  // }

  if (section === 'СТО' && cityTitle) {
    return t('Каталог СТО {cityTitle} с адресами компаний, телефонами и картой проезда. Связаться с автосервисом и записаться на СТО можно на Автобазаре', _extends({}, data, {
      cityTitle: t(regLocation) || t(location)
    }));
  }

  if ((section === 'Авторазборка' || section === 'Авторозборка') && cityTitle) {
    return t('Авторазборка {cityTitle}. Каталог компаний по разбору авто. Адреса, телефоны, карта проезда на сайте Автобазар', _extends({}, data, {
      cityTitle: t(regLocation) || t(location)
    }));
  }

  if ((section === 'Автовыкуп' || section === 'Автовикуп') && cityTitle) {
    return t('Автовыкуп {cityTitle}. Каталог компаний по выкупу авто с адресами, телефонами и картой проезда на Автобазаре', _extends({}, data, {
      cityTitle: t(regLocation) || t(location)
    }));
  }

  if ((section === 'Запчасти' || section === 'Запчастини') && cityTitle) {
    return t('Дилеры по продаже автозапчастей {cityTitle}. Адреса, телефоны компаний на Автобазаре', _extends({}, data, {
      cityTitle: t(regLocation) || t(location)
    }));
  }

  if ((section === 'Автотовары' || section === 'Автотовари') && cityTitle) {
    return t('Поставщики автотоваров {cityTitle}. Адреса, телефоны компаний на Автобазаре', _extends({}, data, {
      cityTitle: t(regLocation) || t(location)
    }));
  }

  if ((section === 'Сервисные центры' || section === 'Сервісні центри') && cityTitle) {
    return t('Территориальные сервисные центры {cityTitle}. Адреса, телефоны ТСЦ для регистрации авто, оформления справок, замены водительского удостоверения', _extends({}, data, {
      cityTitle: t(regLocation) || t(location)
    }));
  }

  if (cityTitle) {
    return t('Автосервисы {cityTitle} с адресами компаний, телефонами и картой проезда. Связаться с автосервисом и записаться на обслуживание можно на Автобазаре', _extends({}, data, {
      cityTitle: t(regLocation) || t(location)
    }));
  }

  return t('Автомобильные организации в Украине: СТО ✅ Авторазборки ✅ Мойки ✅ Шиномонтаж и другие фирмы для владельцев авто');
};

var buildFirmPageSeoDescription = function buildFirmPageSeoDescription(title, tab, t) {
  var car_drive_countries = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
  var tags = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
  var firm = arguments[5];

  if (tab === 'blog') {
    return t('Актуальные новости и действующие акции компании {title} смотрите на Автобазаре', {
      title: title
    });
  }

  var countries = Array.isArray(car_drive_countries) ? car_drive_countries.map(function (item) {
    return item.title;
  }).join(', ') : car_drive_countries;

  if (car_drive_countries.length > 0) {
    return t('Компания {title} по доставке авто из {countries}. Условия выкупа с аукциона и пригона авто под ключ. Стоимость услуг и преимущества сотрудничества с компанией {title}', {
      title: title,
      countries: countries
    });
  }

  if (Array.isArray(tags)) {
    for (var i = 0; i < tags.length; i++) {
      if (tags[i].slug && tags[i].slug === 'sto') {
        return t('СТО {title}. Адрес, телефон, график работы, услуги СТО, последние новости и акции. Связаться с автосервисом и записаться на СТО можно на Автобазаре', {
          title: title,
          tags: tags
        });
      }

      if (tags[i].slug && tags[i].slug === 'avtorazborka') {
        return t('Авторазборка {title}. Компания по разбору авто. Адреса, телефоны, карта проезда, график работы, услуги компании, новости и акции смотрите на сайте Автобазар', {
          title: title
        });
      }

      if (tags[i].slug && tags[i].slug === 'avtovykup') {
        return t('{title}. Услуги, новости, акции компании по выкупу авто. Адрес, телефоны, карта проезда и график работы смотрите на сайте Автобазар', {
          title: title
        });
      }

      if (tags[i].slug && tags[i].slug === 'avtotovary') {
        return t('Поставщик автотоваров {title}. Адреса, телефоны, график работы компаний на Автобазаре. Самые актуальные предложения по автотоварам от компании', {
          title: title
        });
      }

      if (tags[i].slug && tags[i].slug === 'teritorialni-servisni-centri') {
        return t('{title}. Адрес, телефон, график работы ТСЦ для регистрации авто, оформления справок, замены водительского удостоверения указаны на сайте Автобазар', {
          title: title
        });
      }
    }
  }

  return t('METATEGS_DESCRIPTION_FIRM_ZAPCHASTI', { title: title });
};

var buildSearchAvtoSeoDescription = function buildSearchAvtoSeoDescription(data, t) {
  var seoData = __WEBPACK_IMPORTED_MODULE_1_shared_helpers_seoTextFinder__["a" /* getSeoDataByParams */](data, t);
  if (seoData && seoData.description) return seoData.description;

  var _data$make = data.make,
      make = _data$make === undefined ? '' : _data$make,
      _data$model = data.model,
      model = _data$model === undefined ? '' : _data$model,
      _data$location = data.location,
      location = _data$location === undefined ? '' : _data$location,
      _data$generation = data.generation,
      generation = _data$generation === undefined ? '' : _data$generation,
      _data$gearbox = data.gearbox,
      gearbox = _data$gearbox === undefined ? '' : _data$gearbox,
      _data$engine = data.engine,
      engine = _data$engine === undefined ? '' : _data$engine,
      _data$body = data.body,
      body = _data$body === undefined ? '' : _data$body,
      _data$drive = data.drive,
      driveSelected = _data$drive === undefined ? '' : _data$drive,
      _data$isNew = data.isNew,
      isNew = _data$isNew === undefined ? false : _data$isNew,
      _data$makeTranslate = data.makeTranslate,
      makeTranslate = _data$makeTranslate === undefined ? make : _data$makeTranslate,
      _data$modelTranslate = data.modelTranslate,
      modelTranslate = _data$modelTranslate === undefined ? model : _data$modelTranslate,
      yearSelected = data.year,
      _data$country = data.country,
      country = _data$country === undefined ? null : _data$country,
      _data$city = data.city,
      city = _data$city === undefined ? null : _data$city;


  var drive = __WEBPACK_IMPORTED_MODULE_4_shared_modules__["b" /* buildDriveValue */](driveSelected, t);
  var locale = t('locale');
  var inGenitiveLocation = location && __WEBPACK_IMPORTED_MODULE_0_shared_modules_subjectiveText_allText__["g" /* sity */][location] ? __WEBPACK_IMPORTED_MODULE_4_shared_modules__["c" /* buildInGenitiveCityHeader */](__WEBPACK_IMPORTED_MODULE_0_shared_modules_subjectiveText_allText__["g" /* sity */][location][locale].genitive) : city && city.title && ' ' + __WEBPACK_IMPORTED_MODULE_4_shared_modules__["c" /* buildInGenitiveCityHeader */](city[locale + '_title'] || city.title) || '\u0432 ' + __WEBPACK_IMPORTED_MODULE_0_shared_modules_subjectiveText_allText__["g" /* sity */]['Украина'][locale].genitive;

  var yearVsSpace = yearSelected ? ' ' + yearSelected + ' ' + t('года') : '';
  var yearDotVsSpace = yearSelected ? ' ' + yearSelected + ' ' + t('г.') : '';
  var customGearboxAlt = gearbox in __WEBPACK_IMPORTED_MODULE_0_shared_modules_subjectiveText_allText__["c" /* gearboxes */] ? __WEBPACK_IMPORTED_MODULE_0_shared_modules_subjectiveText_allText__["c" /* gearboxes */][gearbox][locale].altTitle : gearbox;
  var customGearbox = gearbox in __WEBPACK_IMPORTED_MODULE_0_shared_modules_subjectiveText_allText__["c" /* gearboxes */] ? __WEBPACK_IMPORTED_MODULE_0_shared_modules_subjectiveText_allText__["c" /* gearboxes */][gearbox][locale].title : gearbox;
  var customEngineAlt = engine in __WEBPACK_IMPORTED_MODULE_0_shared_modules_subjectiveText_allText__["b" /* engines */] ? __WEBPACK_IMPORTED_MODULE_0_shared_modules_subjectiveText_allText__["b" /* engines */][engine][locale].altTitle : engine;
  var customEngine = engine in __WEBPACK_IMPORTED_MODULE_0_shared_modules_subjectiveText_allText__["b" /* engines */] ? __WEBPACK_IMPORTED_MODULE_0_shared_modules_subjectiveText_allText__["b" /* engines */][engine][locale].title : engine;
  var countryTitle = country && t(country.title);
  var countryFromTitle = country && country.from && country.from[locale];

  var params = _extends({}, data, {
    countryFromTitle: countryFromTitle,
    countryTitle: countryTitle,
    inGenitiveLocation: inGenitiveLocation,
    makeTranslate: makeTranslate,
    modelTranslate: modelTranslate,
    generation: generation ? ' ' + generation : '',
    drive: drive,
    year: yearVsSpace,
    yearDot: yearDotVsSpace
  });

  // {locale}*/avto/{country}/
  if (country && !make && !model && !generation && !gearbox && !engine && !body && !drive) {
    return t('SEO_META_DESCRIPTION_AVTO_COUNTRY', { countryFromTitle: countryFromTitle });
  }

  if (make && !model && !generation && !gearbox && !engine && !body && !drive) {
    return t(isNew ? 'Купить легковой автомобиль {make}{year} 🚗 {inGenitiveLocation}. Большой выбор новых {makeTranslate}{yearDot} без посредников по выгодной цене на АвтоБазар.' : 'Продажа легковых автомобилей {make}{year} б/у 🚗 {inGenitiveLocation}. Удобный поиск по объявлениям поможет купить {makeTranslate}{yearDot} по выгодной цене на АвтоБазар.', _extends({}, params));
  }
  if (make && model && !generation && !gearbox && !engine && !body && !drive) {
    return t(isNew ? 'Купить легковой автомобиль {make} {model}{year} 🚗 {inGenitiveLocation}. Большой выбор новых {makeTranslate}{yearDot} без посредников по выгодной цене на АвтоБазар.' : 'Продажа легковых автомобилей {make} {model}{year} б/у 🚗 {inGenitiveLocation}. Поможем купить {makeTranslate}{yearDot} по выгодной цене на АвтоБазар.', _extends({}, params));
  }
  if (make && model && body && !generation && !gearbox && !engine && !drive) {
    return t(isNew ? 'Купить {body} {make} {model}{year} 🚗 {inGenitiveLocation}. Выбрать новый {makeTranslate} {body}{yearDot} без посредников по выгодной цене на АвтоБазар.' : 'Продажа {body} {make} {model}{year} б/у 🚗 {inGenitiveLocation}. Поможем купить {makeTranslate}{yearDot} по выгодной цене на АвтоБазар.', _extends({}, params));
  }
  if (make && model && generation && !gearbox && !engine && !drive) {
    return t(isNew ? 'Купить {make} {model}{generation}{year} 🚗 {inGenitiveLocation}. Выбрать новый {makeTranslate}{yearDot} без посредников по выгодной цене на АвтоБазар.' : 'Продажа {make} {model}{generation}{year} б/у 🚗 {inGenitiveLocation}. Поможем купить {makeTranslate}{yearDot} по выгодной цене на АвтоБазар.', _extends({}, params));
  }
  if (make && model && gearbox && !engine && !drive) {
    return t(isNew ? 'Новые легковые автомобили {gearbox} {make} {model}{generation}{year} 🚗 {inGenitiveLocation}. Удобный поиск по предложениям поможет купить {makeTranslate}{yearDot} по выгодной цене на АвтоБазар.' : 'Продажа легковых автомобилей {make} {model}{generation} {gearbox}{year} 🚗 {inGenitiveLocation}. Поможем купить {makeTranslate}{yearDot} по выгодной цене на АвтоБазар.', _extends({}, params));
  }
  if (make && model && gearbox && drive && !engine) {
    return t(isNew ? 'Купить новый легковой автомобиль {make} {model}{generation} {gearbox} {drive}{year} 🚗 {inGenitiveLocation}. Удобный поиск предложений продажи {makeTranslate}{yearDot} по выгодной цене на АвтоБазар.' : 'Продажа легковых автомобилей {make} {model}{generation} {gearbox} {drive}{year} 🚗. Подбор предложений {inGenitiveLocation} поможет купить {makeTranslate}{yearDot} по выгодной цене на АвтоБазар.', _extends({}, params));
  }
  if (make && model && gearbox && drive && engine) {
    return t(isNew ? 'Купить легковой автомобиль 🚗 {make} {model} {engine} {gearbox} {drive}{generation}{year}. Предложения {inGenitiveLocation} по продаже {makeTranslate} {modelTranslate}{yearDot} по выгодной цене на АвтоБазар.' : 'Легковые автомобили 🚗б/у {make} {model}{generation} {engine} {gearbox} {drive}{year}. Предложения по продаже {makeTranslate}{yearDot} {inGenitiveLocation} по выгодной цене на АвтоБазар.', _extends({}, params));
  }
  if (!make && !model && !gearbox && !drive && engine && !body) {
    return t(isNew ? '{customEngineAlt} новые {inGenitiveLocation} 🚗 Удобный поиск по объявлениям – выгодные цены на АвтоБазар™.' : '{customEngineAlt} б/у {inGenitiveLocation} 🚗 Удобный поиск по объявлениям – выгодные цены на АвтоБазар™.', _extends({}, params, {
      customEngineAlt: customEngineAlt
    }));
  }
  if (make && !model && gearbox && !drive && !engine && !body) {
    return t(isNew ? 'Продажа новых {make} {customGearboxAlt} {inGenitiveLocation} 🚗 Удобный поиск по объявлениям – выгодные цены на АвтоБазар™.' : 'Продажа {make} {customGearboxAlt} б/у {inGenitiveLocation} 🚗 Удобный поиск по объявлениям – выгодные цены на АвтоБазар™.', _extends({}, params, {
      customGearboxAlt: customGearboxAlt
    }));
  }
  if (!make && !model && !gearbox && !drive && !engine && body) {
    return t(isNew ? 'Продажа новых автомобилей {body} {inGenitiveLocation} 🚗 Удобный поиск по объявлениям – выгодные цены на АвтоБазар™.' : 'Продажа автомобилей {body} б/у {inGenitiveLocation} 🚗 Удобный поиск по объявлениям – выгодные цены на АвтоБазар™.', _extends({}, params));
  }
  if (make && !model && !gearbox && !drive && engine && !body) {
    return t(isNew ? 'Продажа {customEngineAlt} {makeTranslate}{year} 🚗 Найти новый {customEngine} по объявлениям – выгодные цены на АвтоБазар™ {inGenitiveLocation}.' : 'Продажа {customEngineAlt} {makeTranslate}{year} 🚗 Найти б/у {customEngine} по объявлениям – выгодные цены на АвтоБазар™ {inGenitiveLocation}.', _extends({}, params, {
      customEngineAlt: customEngineAlt,
      customEngine: customEngine
    }));
  }
  if (make && model && !gearbox && !drive && engine && !body) {
    return t(isNew ? 'Продажа {customEngineAlt} {makeTranslate} {model}{year} 🚗 Найти новый {customEngine} по объявлениям – выгодные цены на АвтоБазар™ {inGenitiveLocation}.' : 'Продажа {customEngineAlt} {makeTranslate} {model}{year} 🚗 Найти б/у {customEngine} по объявлениям – выгодные цены на АвтоБазар™ {inGenitiveLocation}.', _extends({}, params, {
      customEngineAlt: customEngineAlt,
      customEngine: customEngine
    }));
  }
  if (!make && !model && gearbox && !drive && !engine && !body) {
    return t(isNew ? 'Продажа новых автомобилей {customGearbox}{year} {inGenitiveLocation} 🚗 Удобный поиск авто по объявлениям – выгодные цены на АвтоБазар™.' : 'Продажа автомобилей {customGearbox}{year} б/у {inGenitiveLocation} 🚗 Удобный поиск авто по объявлениям – выгодные цены на АвтоБазар™.', _extends({}, params, {
      customGearbox: customGearbox
    }));
  }
  if (make && !model && !gearbox && !drive && !engine && body) {
    return t(isNew ? 'Продажа новых {body} {make}{year} 🚗 Удобный поиск авто по объявлениям – выгодные цены на АвтоБазар™ {inGenitiveLocation}.' : 'Продажа {body} {make}{year} б/у 🚗 Удобный поиск авто по объявлениям – выгодные цены на АвтоБазар™ {inGenitiveLocation}.', _extends({}, params, {
      customGearbox: customGearbox
    }));
  }
  return t(isNew ? 'Купить легковой автомобиль 🚗 {inGenitiveLocation}. Большой выбор авто без посредников по выгодной цене на АвтоБазар.' : 'Продажа легковых автомобилей б/у 🚗 {inGenitiveLocation}. Удобный поиск по объявлениям поможет купить авто по выгодной цене на АвтоБазар.', {
    inGenitiveLocation: inGenitiveLocation
  });
};

var buildDealersSeoDescription = function buildDealersSeoDescription(data, slug, t) {
  var _data$make2 = data.make,
      make = _data$make2 === undefined ? '' : _data$make2,
      _data$model2 = data.model,
      model = _data$model2 === undefined ? '' : _data$model2,
      _data$makeTranslate2 = data.makeTranslate,
      makeTranslate = _data$makeTranslate2 === undefined ? make : _data$makeTranslate2,
      _data$modelTranslate2 = data.modelTranslate,
      modelTranslate = _data$modelTranslate2 === undefined ? model : _data$modelTranslate2,
      _data$location2 = data.location,
      locationRu = _data$location2 === undefined ? '' : _data$location2;

  var seoData = __WEBPACK_IMPORTED_MODULE_1_shared_helpers_seoTextFinder__["a" /* getSeoDataByParams */](_extends({}, data, { transport: data.transport || slug }), t, 'avtosalony');
  if (seoData && seoData.description) return seoData.description;

  var locale = t('locale');

  var cityHeader = locationRu && __WEBPACK_IMPORTED_MODULE_0_shared_modules_subjectiveText_allText__["g" /* sity */][locationRu] ? locationRu : 'Украина';
  var location = locationRu && t(locationRu);
  var accusativeCityHeader = __WEBPACK_IMPORTED_MODULE_0_shared_modules_subjectiveText_allText__["g" /* sity */][cityHeader][locale].accusative;
  var inGenitiveCityHeader = __WEBPACK_IMPORTED_MODULE_4_shared_modules__["c" /* buildInGenitiveCityHeader */](__WEBPACK_IMPORTED_MODULE_0_shared_modules_subjectiveText_allText__["g" /* sity */][cityHeader][locale].genitive);

  if (slug === 'avto') {
    if (location && !make && !model) {
      return t('Лучшие предложения автосалонов {inGenitiveCityHeader} – скидки автодилеров на новые автомобили. Запишитесь на тестдрайв ✅ адреса и телефоны ☎️ на сайте  АвтоБазар™.', { location: location, inGenitiveCityHeader: inGenitiveCityHeader });
    }
    if (make && !location && !model) {
      return t('Надежная ✅ покупка {makeTranslate} в автосалонах {make} – запишитесь на тестдрайв. Адреса ☎️ телефоны автодилеров на сайте АвтоБазар™.', {
        make: make,
        makeTranslate: makeTranslate
      });
    }
    if (make && location && !model) {
      return t('Предложения автосалонов {makeTranslate} {inGenitiveCityHeader}  ✅ покупка {make} в автосалонах – запишитесь на тестдрайв. Адреса ☎️ телефоны автодилеров на сайте АвтоБазар™.', {
        make: make,
        makeTranslate: makeTranslate,
        inGenitiveCityHeader: inGenitiveCityHeader
      });
    }
    if (make && model && !location) {
      return t('Предложения автосалонов {make} {model} ✅ купить {makeTranslate} {modelTranslate}  у автодилеров – запишитесь на тестдрайв. Адреса и ☎️ телефоны на сайте АвтоБазар™.', {
        make: make,
        model: model,
        makeTranslate: makeTranslate,
        modelTranslate: modelTranslate
      });
    }
    if (make && model && location) {
      return t('Предложения автосалонов {accusativeCityHeader} на {make} {model} ✅ покупка {makeTranslate} {modelTranslate} у автодилера {inGenitiveCityHeader}. Адреса и ☎️ телефоны на сайте АвтоБазар™.', {
        make: make,
        model: model,
        makeTranslate: makeTranslate,
        modelTranslate: modelTranslate,
        accusativeCityHeader: accusativeCityHeader,
        inGenitiveCityHeader: inGenitiveCityHeader
      });
    }
  }
  if (slug === 'mototsikl') {
    if (location && !make) {
      return t('Лучшие предложения на покупку мототехники в мотосалонах {inGenitiveCityHeader}. Мотоциклы, скутеры, квадроциклы, электробайки, мопеды и мотоэкипировка. Адреса и ☎️ на сайте АвтоБазар™.', { inGenitiveCityHeader: inGenitiveCityHeader });
    }
    if (make && !location) {
      return t('Лучшие цены на мототехнику {make} и акции мотосалонов. Мотоциклы, скутеры, квадроциклы, электробайки, мопеды  {makeTranslate} и мотоэкипировка. Адреса и ☎️ на сайте АвтоБазар™.', {
        make: make,
        makeTranslate: makeTranslate
      });
    }
    if (make && location) {
      return t('Лучшие цены на мототехнику {makeTranslate} и акции в мотосалонах {accusativeCityHeader}. Мотоцикли, скутери, квадроцикли, электробайки, мопеди {make} и мотоекипировка. Адреса и ☎️ на сайте АвтоБазар™.', {
        make: make,
        makeTranslate: makeTranslate,
        accusativeCityHeader: accusativeCityHeader
      });
    }
    return t('Каталог мотосалонов – лучшие цены мотомагазинов в вашем городе на мототехнику и с гарантией от салона. Сайт АвтоБазар™ ✅ адреса ☎️ телефоны.', {});
  }
  if (slug === 'avtobus') {
    if (location && !make && !model) {
      return t('Надежная ✅ покупка автобуса автосалонов {inGenitiveCityHeader} – запишитесь на тестдрайв буса. Адреса и ☎️ на АвтоБазар™', {
        inGenitiveCityHeader: inGenitiveCityHeader
      });
    }
    if (make && !location && !model) {
      return t('Надежная ✅ покупка автобуса {makeTranslate} в автосалонах {make} – запишитесь на тестдрайв буса. Адреса и ☎️ на АвтоБазар™', {
        make: make,
        makeTranslate: makeTranslate
      });
    }
    if (make && location) {
      return t('Автобусы {makeTranslate} {inGenitiveCityHeader}  ✅ покупка буса {make} в салонах {accusativeCityHeader}. Адреса и ☎️ на АвтоБазар™', {
        make: make,
        makeTranslate: makeTranslate,
        inGenitiveCityHeader: inGenitiveCityHeader,
        accusativeCityHeader: accusativeCityHeader
      });
    }
    return t('Дилеры автобусов Украины – выберите автодилера в своем городе. Бус с гарантией от салона. Сайт АвтоБазар™ ✅ адреса ☎️ телефоны', {});
  }
  if (slug === 'gruzovye') {
    if (location && !make && !model) {
      return t('Надежная ✅ покупка грузовых автомобилей в автосалонах {accusativeCityHeader} – запишитесь на тестдрайв грузовика. Адреса и ☎️ на АвтоБазар™', { accusativeCityHeader: accusativeCityHeader });
    }
    if (make && !location && !model) {
      return t('Надежная ✅ покупка грузового {makeTranslate} в официальных автосалонах {make} – кредит, лизинг. Адреса и ☎️ на АвтоБазар™', {
        make: make,
        makeTranslate: makeTranslate
      });
    }
    if (make && location) {
      return t('Грузовик {makeTranslate} {inGenitiveCityHeader} ✅ покупка грузового {make} в салонах {accusativeCityHeader}. Адреса и ☎️ на АвтоБазар™', {
        make: make,
        makeTranslate: makeTranslate,
        inGenitiveCityHeader: inGenitiveCityHeader,
        accusativeCityHeader: accusativeCityHeader
      });
    }
    return t('Автосалоны грузовиков Украины – выберите автодилера в своем городе. Грузовой автомобиль с гарантией от салона. Сайт АвтоБазар™ ✅ адреса ☎️ телефоны салонов', {});
  }
  if (slug === 'spetstehnika') {
    if (make && !location) {
      return t('Продажа спецтехники {make} и услуги от официальных и проверенных дилеров Украины. Актуальные предложения, цены и акции на технику – АвтоБазар™', {
        make: make,
        makeTranslate: makeTranslate
      });
    }
    if (location && !make) {
      return t('Продажа спецтехники и услуги от официальных и проверенных дилеров {inGenitiveCityHeader}. Актуальные предложения, цены и акции на технику – АвтоБазар™', { inGenitiveCityHeader: inGenitiveCityHeader });
    }
    return t('Продажа спецтехники и услуги от официальных и проверенных дилеров Украины. Актуальные предложения, цены и акции на технику – АвтоБазар™', {});
  }
  if (slug === 'vodnyi-transport') {
    if (make && !location) {
      return t('Продажа водного транспорта {make} и услуги от официальных и проверенных салонов Украины. Актуальные предложения, цены и акции – АвтоБазар™', {
        make: make,
        makeTranslate: makeTranslate
      });
    }
    if (location && !make) {
      return t('Продажа водного транспорта и услуги от официальных и проверенных салонов {inGenitiveCityHeader}. Актуальные предложения, цены и акции – АвтоБазар™', { inGenitiveCityHeader: inGenitiveCityHeader });
    }
    return t('Продажа водного транспорта и услуги от официальных и проверенных салонов Украины. Актуальные предложения, цены и акции – АвтоБазар™', {});
  }
  if (slug === 'pritsepy') {
    if (make && !location) {
      return t('Продажа прицепов {make} и услуги от надежных компаний Украины. Актуальные предложения, цены и акции – АвтоБазар™', {
        make: make,
        makeTranslate: makeTranslate
      });
    }
    if (location && !make) {
      return t('Продажа прицепов и услуги от надежных компаний {inGenitiveCityHeader}. Актуальные предложения, цены и акции – АвтоБазар™', { inGenitiveCityHeader: inGenitiveCityHeader });
    }
    return t('Продажа прицепов и услуги от надежных компаний Украины. Актуальные предложения, цены и акции – АвтоБазар™', {});
  }

  return t('Все автосалоны Украины – актуальные цены и скидки на новые авто ✅ адреса и телефоны дилеров ☎️ каталог АвтоБазар™.', {});
};

var buildSparePartsSeoDescription = function buildSparePartsSeoDescription(data, rubricSlug, t, isRegion) {
  var _data$location3 = data.location,
      locationRu = _data$location3 === undefined ? '' : _data$location3,
      _data$make3 = data.make,
      make = _data$make3 === undefined ? '' : _data$make3,
      _data$model3 = data.model,
      model = _data$model3 === undefined ? '' : _data$model3,
      selectedTransport = data.transport,
      rubricTitle = data.rubric,
      partTypeRu = data.partType,
      partTypeUk = data.partTypeUk;

  var seoData = __WEBPACK_IMPORTED_MODULE_1_shared_helpers_seoTextFinder__["a" /* getSeoDataByParams */](data, t, 'zapchasti');
  if (seoData && seoData.description) {
    return seoData.description;
  }
  var locale = t('locale');

  var cityHeader = locationRu && __WEBPACK_IMPORTED_MODULE_0_shared_modules_subjectiveText_allText__["g" /* sity */][locationRu] ? locationRu : 'Украина';
  var location = locationRu && t(locationRu);
  var inGenitiveCityHeader = __WEBPACK_IMPORTED_MODULE_4_shared_modules__["c" /* buildInGenitiveCityHeader */](__WEBPACK_IMPORTED_MODULE_0_shared_modules_subjectiveText_allText__["g" /* sity */][cityHeader][locale].genitive);

  var rubric = rubricTitle;
  var partType = partTypeRu;
  var transport = __WEBPACK_IMPORTED_MODULE_4_shared_modules__["o" /* replaceTransport */](selectedTransport);

  var inCityOrRegion = t('в городе') + ' ' + t(location);
  if (isRegion && locationRu) {
    inCityOrRegion = '\u0432 ' + __WEBPACK_IMPORTED_MODULE_0_shared_modules_subjectiveText_allText__["g" /* sity */][locationRu][locale].genitive;
  }

  if (locale === 'uk' && partTypeUk) partType = partTypeUk;

  if (!location && !rubric && !partType && !rubricSlug) {
    if (make && !model && !location) {
      return t('Продажа запчастей на {make} на сайте АвтоБазар™. ✅ Удобный поиск по объявлениям поможет Вам быстро и легко купить запчасти на {transport} по выгодной цене.', {
        make: make,
        transport: transport
      });
    }
    if (make && model) {
      return t('Продажа автозапчастей на {make} {model} на сайте АвтоБазар™. ✅ Удобный поиск по объявлениям поможет Вам быстро и легко купить запчасти на {transport} по выгодной цене.', {
        make: make,
        model: model,
        transport: transport
      });
    }
  }
  if (location && !rubric && !partType && !rubricSlug) {
    if (!make && !model) {
      return t('Продажа запчастей на {transport} {inGenitiveCityHeader} на сайте АвтоБазар™. ✅ Удобный поиск по объявлениям поможет Вам быстро найти автозапчасти на {transport} по лучшей цене {inCityOrRegion}.', {
        transport: transport,
        inGenitiveCityHeader: inGenitiveCityHeader,
        inCityOrRegion: inCityOrRegion
      });
    }
    if (make && !model) {
      return t('Продажа автозапчастей {make} на {transport} {inGenitiveCityHeader} на сайте АвтоБазар™. ✅ Удобный поиск по объявлениям поможет Вам быстро и легко купить запчасти для {make}.', {
        make: make,
        transport: transport,
        inGenitiveCityHeader: inGenitiveCityHeader,
        location: location
      });
    }
    if (make && model) {
      return t('Продажа автозапчастей на {make} {model} {inCityOrRegion} ✅ Сравните цены и купите запчасти на {transport} по лучшей цене на АвтоБазар™.', {
        make: make,
        model: model,
        transport: transport,
        inCityOrRegion: inCityOrRegion
      });
    }
  }

  if (__WEBPACK_IMPORTED_MODULE_2_shared_constants_json_firstSeoRubricsTypes_json___default.a.includes(rubricSlug)) {
    rubric = rubric && __WEBPACK_IMPORTED_MODULE_0_shared_modules_subjectiveText_allText__["f" /* rubrics */][rubric][locale].accusative;
  } else if (__WEBPACK_IMPORTED_MODULE_3_shared_constants_json_secondSeoRubricsTypes_json___default.a.includes(rubricSlug)) {
    rubric = rubric && __WEBPACK_IMPORTED_MODULE_0_shared_modules_subjectiveText_allText__["f" /* rubrics */][rubric][locale].nominative;
  }

  /* ______________________FIRST TYPE VS RUBRIC_______________________ */

  if (!location && rubricSlug && rubric && !partType && __WEBPACK_IMPORTED_MODULE_2_shared_constants_json_firstSeoRubricsTypes_json___default.a.includes(rubricSlug)) {
    if (make && !model) {
      return t('Продажа автозапчастей {rubric} на {transport} {make} на сайте АвтоБазар™ ✅ Большой выбор и удобный поиск по объявлениям в Украине.', {
        rubric: rubric,
        make: make,
        transport: transport
      });
    }
    if (make && model) {
      return t('Продажа автозапчастей {rubric} на {make} {model} на сайте АвтоБазар™ ✅ Большой выбор и удобный поиск по объявлениям в Украине.', {
        rubric: rubric,
        make: make,
        model: model
      });
    }

    return t('Продажа автозапчастей {rubric} на {transport} на сайте АвтоБазар™ ✅ Большой выбор и удобный поиск по объявлениям – сравните предложения в Украине.', {
      rubric: rubric,
      transport: transport
    });
  }

  if (location && rubricSlug && rubric && !partType && __WEBPACK_IMPORTED_MODULE_2_shared_constants_json_firstSeoRubricsTypes_json___default.a.includes(rubricSlug)) {
    if (make && !model) {
      return t('Продажа автозапчастей {rubric} на {transport} {make} на сайте АвтоБазар™ ✅ Большой выбор и удобный поиск по объявлениям {inGenitiveCityHeader}.', {
        rubric: rubric,
        make: make,
        transport: transport,
        inGenitiveCityHeader: inGenitiveCityHeader
      });
    }
    if (make && model) {
      return t('Продажа автозапчастей {rubric} на {transport} {make} {model} на сайте АвтоБазар™ ✅ Большой выбор и удобный поиск по объявлениям {inGenitiveCityHeader}.', {
        rubric: rubric,
        make: make,
        model: model,
        transport: transport,
        inGenitiveCityHeader: inGenitiveCityHeader
      });
    }

    return t('Продажа автозапчастей {rubric} на {transport} на сайте АвтоБазар™ ✅ Большой выбор и удобный поиск по объявлениям {inGenitiveCityHeader}.', {
      rubric: rubric,
      transport: transport,
      inGenitiveCityHeader: inGenitiveCityHeader
    });
  }

  /* ______________________FIRST TYPE VS RUBRIC && PART_TYPE_______________________ */

  if (!location && rubricSlug && rubric && partType && __WEBPACK_IMPORTED_MODULE_2_shared_constants_json_firstSeoRubricsTypes_json___default.a.includes(rubricSlug)) {
    partType = __WEBPACK_IMPORTED_MODULE_4_shared_modules__["n" /* replaceToUpperCase */](partType);
    if (make && !model) {
      return t('{partType} на {transport} {make} по выгодной цене на сайте АвтоБазар™ ✅ Большой выбор автозапчастей {rubric}.', {
        rubric: rubric,
        partType: partType,
        transport: transport,
        make: make
      });
    }
    if (make && model) {
      return t('{partType} на {transport} {make} {model} по выгодной цене на АвтоБазар™ ✅ Большой выбор автозапчастей для {rubric}.', {
        rubric: rubric,
        partType: partType,
        make: make,
        model: model,
        transport: transport
      });
    }

    return t('{partType} на {transport} по выгодной цене на сайте АвтоБазар™ ✅ Большой выбор автозапчастей {rubric}.', {
      rubric: rubric,
      partType: partType,
      transport: transport
    });
  }

  if (location && rubricSlug && rubric && partType && __WEBPACK_IMPORTED_MODULE_2_shared_constants_json_firstSeoRubricsTypes_json___default.a.includes(rubricSlug)) {
    partType = __WEBPACK_IMPORTED_MODULE_4_shared_modules__["n" /* replaceToUpperCase */](partType);

    if (make && !model) {
      return t('{partType} на {transport} {make} по выгодной цене {inGenitiveCityHeader} ✅ Большой выбор запчастей для {rubric} – АвтоБазар™.', {
        rubric: rubric,
        partType: partType,
        make: make,
        transport: transport,
        inGenitiveCityHeader: inGenitiveCityHeader
      });
    }
    if (make && model) {
      return t('{partType} на {make} {model} по выгодной цене {inGenitiveCityHeader} ✅ Большой выбор запчастей для {rubric} – АвтоБазар™.', {
        rubric: rubric,
        partType: partType,
        make: make,
        model: model,
        inGenitiveCityHeader: inGenitiveCityHeader
      });
    }

    return t('{partType} на {transport} по выгодной цене {inGenitiveCityHeader} ✅ Большой выбор автозапчастей для {rubric} – АвтоБазар™.', {
      rubric: rubric,
      partType: partType,
      transport: transport,
      inGenitiveCityHeader: inGenitiveCityHeader
    });
  }

  /* ______________________SECOND TYPE VS RUBRIC_______________________ */

  if (!location && rubricSlug && rubric && !partType && __WEBPACK_IMPORTED_MODULE_3_shared_constants_json_secondSeoRubricsTypes_json___default.a.includes(rubricSlug)) {
    if (make && !model) {
      return t('{rubric} по выгодной цене на {transport} {make} ✅ Найдите нужную деталь в Украине на АвтоБазар™.', {
        rubric: rubric,
        make: make,
        transport: transport
      });
    }
    if (make && model) {
      return t('{rubric} по лучшей цене на {transport} {make} {model} ✅ Найдите нужную деталь в Украине на АвтоБазар™.', {
        rubric: rubric,
        make: make,
        model: model,
        transport: transport
      });
    }

    return t('{rubric} по выгодной цене на {transport} ✅ Найдите нужную деталь в Украине на АвтоБазар™.', {
      rubric: rubric,
      transport: transport
    });
  }

  if (location && rubricSlug && rubric && !partType && __WEBPACK_IMPORTED_MODULE_3_shared_constants_json_secondSeoRubricsTypes_json___default.a.includes(rubricSlug)) {
    if (make && !model) {
      return t('{rubric} по выгодной цене на {transport} {make} ✅ Найдите нужную деталь {inGenitiveCityHeader} на АвтоБазар™.', {
        rubric: rubric,
        make: make,
        transport: transport,
        inGenitiveCityHeader: inGenitiveCityHeader
      });
    }
    if (make && model) {
      return t('{rubric} по выгодной цене на {transport} {make} {model} ✅ Найдите нужную деталь {inGenitiveCityHeader} на АвтоБазар™.', {
        rubric: rubric,
        make: make,
        model: model,
        transport: transport,
        inGenitiveCityHeader: inGenitiveCityHeader
      });
    }

    return t('{rubric} по выгодной цене на {transport} ✅ Найдите нужную деталь {inGenitiveCityHeader} на АвтоБазар™.', {
      rubric: rubric,
      transport: transport,
      inGenitiveCityHeader: inGenitiveCityHeader
    });
  }

  /* ______________________SECOND TYPE VS RUBRIC && PART_TYPE_______________________ */

  if (!location && rubricSlug && rubric && partType && __WEBPACK_IMPORTED_MODULE_3_shared_constants_json_secondSeoRubricsTypes_json___default.a.includes(rubricSlug)) {
    partType = __WEBPACK_IMPORTED_MODULE_4_shared_modules__["n" /* replaceToUpperCase */](partType);
    if (make && !model) {
      return t('{partType} на {transport} {make} по выгодной цене на сайте АвтоБазар™ ✅ {rubric} – большой выбор запчастей.', {
        rubric: rubric,
        partType: partType,
        transport: transport,
        make: make
      });
    }
    if (make && model) {
      return t('{partType} на {transport} {make} {model} по выгодной цене на сайте АвтоБазар™ ✅ {rubric} – большой выбор запчастей.', {
        rubric: rubric,
        partType: partType,
        make: make,
        model: model,
        transport: transport
      });
    }

    return t('{partType} на {transport} по выгодной цене на сайте АвтоБазар™ ✅ {rubric} – большой выбор запчастей.', {
      rubric: rubric,
      partType: partType,
      transport: transport
    });
  }

  if (location && rubricSlug && rubric && partType && __WEBPACK_IMPORTED_MODULE_3_shared_constants_json_secondSeoRubricsTypes_json___default.a.includes(rubricSlug)) {
    partType = __WEBPACK_IMPORTED_MODULE_4_shared_modules__["n" /* replaceToUpperCase */](partType);

    if (make && !model) {
      return t('Выбирайте {partType} на {transport} {make} по выгодной цене {inGenitiveCityHeader} ✅ {rubric} на АвтоБазар™.', {
        rubric: rubric,
        partType: partType,
        make: make,
        inGenitiveCityHeader: inGenitiveCityHeader,
        transport: transport
      });
    }
    if (make && model) {
      return t('Выбирайте {partType} на {transport} {make} {model} по выгодной цене {inGenitiveCityHeader} ✅ {rubric} на сайте АвтоБазар™.', {
        rubric: rubric,
        partType: partType,
        make: make,
        model: model,
        transport: transport,
        inGenitiveCityHeader: inGenitiveCityHeader
      });
    }

    return t('Выбирайте {partType} на {transport} по выгодной цене {inGenitiveCityHeader} ✅ {rubric} на АвтоБазар™.', {
      rubric: rubric,
      partType: partType,
      transport: transport,
      inGenitiveCityHeader: inGenitiveCityHeader
    });
  }

  return t('Продажа автозапчастей на {transport} на сайте АвтоБазар™. ✅ Удобный поиск по объявлениям поможет Вам быстро и легко купить запчасти на {transport} по выгодной цене.', {
    transport: transport
  });
};

var buildSearchMotoSeoDescription = function buildSearchMotoSeoDescription(data, t) {
  var seoData = __WEBPACK_IMPORTED_MODULE_1_shared_helpers_seoTextFinder__["a" /* getSeoDataByParams */](data, t);
  if (seoData && seoData.description) return seoData.description;

  var category = data.category,
      type = data.type,
      make = data.make,
      model = data.model,
      location = data.location,
      motoTitle = data.motoTitle,
      yearTitle = data.yearTitle;

  var condition = t('бу и новой');
  var icon = '🏍️';
  var transportWho = t('мототехники');
  var transportWhat = t('мототранспорт');
  return [t('Продажа'), condition, category || type || motoTitle ? (motoTitle || (type && type.title ? type.title.toLowerCase() : '')) + ' ' + (category && category.title ? category.title.toLowerCase() : '') : transportWho, icon, make && make.title, model && model.title, (location || t('в Украине')) + '.', t('Удобный поиск по объявлениям поможет Вам быстро и легко купить'), category || type ? (type && type.title ? type.title.toLowerCase() : '') + ' ' + (category && category.title ? category.title.toLowerCase() : '') : transportWhat || '', '' + (yearTitle || '') + t('по выгодной цене на Автобазаре™.')].filter(function (i) {
    return !!i;
  }).join(' ');
};

var buildSearchCommercialSeoDescription = function buildSearchCommercialSeoDescription(data, t) {
  var seoData = __WEBPACK_IMPORTED_MODULE_1_shared_helpers_seoTextFinder__["a" /* getSeoDataByParams */](data, t, 'commercial');
  if (seoData && seoData.description) return seoData.description;

  var isUkraine = ['Україні', 'Украине'].includes(data.cityDescriptions);

  if (!isUkraine) {
    // eslint-disable-next-line no-param-reassign
    data.cityDescriptions = t('в') + ' ' + t(data.cityDescriptions);
    // eslint-disable-next-line no-param-reassign
  } else data.cityDescriptions = '\u0432 ' + t('Украине');

  var transportDescriptions = data.transportDescriptions,
      transportNextDescriptions = data.transportNextDescriptions,
      transportCategoryTitle = data.transportCategoryTitle,
      make = data.make,
      model = data.model,
      isNew = data.isNew,
      transportType = data.transportType;


  if (transportType === 'avtobus' && transportCategoryTitle) {
    return t('Купить бу и новые {transportCategoryTitle} автобусы {cityDescriptions}. Удобный поиск объявлений - сравните предложения и покупайте автобусы по лучшей цене на АвтоБазар™.', data);
  }
  if (transportType === 'moto' && transportCategoryTitle) {
    return t('Купить бу мототехнику {cityDescriptions} 🏍️ Объявления о продаже мотоциклов, скутеров, мопедов по лучшей цене на АвтоБазар™.', data);
  }
  if (transportType === 'pritsepy' && transportCategoryTitle) {
    return t('Купить бу или новый {transportCategoryTitle} {cityDescriptions} 🏍️ Объявления о продаже прицепного оборудования по лучшей цене на АвтоБазар™.', data);
  }
  if (transportType === 'spetstehnika' && transportCategoryTitle) {
    return t('{transportCategoryTitle} по лучшей цене купить на АвтоБазар™. Все объявления о продаже бу или новой спецтехники {cityDescriptions}.', data);
  }
  if (transportType === 'vodnyi-transport' && transportCategoryTitle) {
    return t('Купить {transportHeader} по лучшей цене {cityDescriptions}. Все объявления о продаже спецтехники на АвтоБазар™.', data);
  }
  if (transportDescriptions && transportType === 'avtobus' && make) {
    return t('Купить бу или новый автобус {makeTranslit} {cityDescriptions}. Удобный поиск объявлений - сравните предложения и покупайте автобусы {make} по лучшей цене на АвтоБазар™.', data);
  }
  if (transportDescriptions && make && !model && isNew) {
    return t('Купить новые {transportDescriptions} {make} 🚌 {cityDescriptions}. Удобный поиск по объявлениям поможет купить {reductionTranslit} {makeTranslit} {yearDescriptions}по выгодной цене на Автобазаре', _extends({}, data, {
      transportDescriptions: __WEBPACK_IMPORTED_MODULE_4_shared_modules__["m" /* replaceToLowerCase */](transportDescriptions),
      transportNextDescriptions: __WEBPACK_IMPORTED_MODULE_4_shared_modules__["m" /* replaceToLowerCase */](transportNextDescriptions)
    }));
  }
  if (transportDescriptions && make && model && !isNew) {
    return t('Купить {transportDescriptions} {make} {model} бу 🚌 {cityDescriptions}. Удобный поиск по объявлениям поможет купить {reductionTranslit} {makeTranslit} {modelTranslit} {yearDescriptions}по выгодной цене на Автобазаре', _extends({}, data, {
      transportDescriptions: __WEBPACK_IMPORTED_MODULE_4_shared_modules__["m" /* replaceToLowerCase */](transportDescriptions),
      transportNextDescriptions: __WEBPACK_IMPORTED_MODULE_4_shared_modules__["m" /* replaceToLowerCase */](transportNextDescriptions)
    }));
  }
  if (transportDescriptions && make && !model && !isNew) {
    return t('Купить {transportDescriptions} {make} бу 🚌 {cityDescriptions}. Удобный поиск по объявлениям поможет купить {reductionTranslit} {makeTranslit} {yearDescriptions}по выгодной цене на Автобазаре', _extends({}, data, {
      transportDescriptions: __WEBPACK_IMPORTED_MODULE_4_shared_modules__["m" /* replaceToLowerCase */](transportDescriptions),
      transportNextDescriptions: __WEBPACK_IMPORTED_MODULE_4_shared_modules__["m" /* replaceToLowerCase */](transportNextDescriptions)
    }));
  }
  if (transportDescriptions && !make && !model && isNew) {
    return t('Купить новые {transportDescriptions} 🚌 {cityDescriptions}. Удобный поиск по объявлениям поможет купить {reductionTranslit} {yearDescriptions}по выгодной цене на Автобазаре', _extends({}, data, {
      transportDescriptions: __WEBPACK_IMPORTED_MODULE_4_shared_modules__["m" /* replaceToLowerCase */](transportDescriptions),
      transportNextDescriptions: __WEBPACK_IMPORTED_MODULE_4_shared_modules__["m" /* replaceToLowerCase */](transportNextDescriptions)
    }));
  }
  if (transportDescriptions && make && model && isNew) {
    return t('Новые {transportDescriptions} {make} {model} 🚚 {cityDescriptions}. Удобный поиск по объявлениям поможет купить {makeTranslit} {modelTranslit} {yearDescriptions}по выгодной цене на Автобазаре', _extends({}, data, {
      transportDescriptions: __WEBPACK_IMPORTED_MODULE_4_shared_modules__["m" /* replaceToLowerCase */](transportDescriptions),
      transportNextDescriptions: __WEBPACK_IMPORTED_MODULE_4_shared_modules__["m" /* replaceToLowerCase */](transportNextDescriptions)
    }));
  }
  if (transportDescriptions && make && model && !isNew) {
    return t('Купить {transportDescriptions} {make} {model} бу 🚚 {cityDescriptions}. Удобный поиск по объявлениям поможет купить {makeTranslit} {modelTranslit} {yearDescriptions}по выгодной цене на Автобазаре', _extends({}, data, {
      transportDescriptions: __WEBPACK_IMPORTED_MODULE_4_shared_modules__["m" /* replaceToLowerCase */](transportDescriptions),
      transportNextDescriptions: __WEBPACK_IMPORTED_MODULE_4_shared_modules__["m" /* replaceToLowerCase */](transportNextDescriptions)
    }));
  }
  if (transportDescriptions && make && !model && isNew) {
    return t('Купить новые {transportDescriptions} {make} 🚚 {cityDescriptions}. Удобный поиск по объявлениям поможет купить {transportNextDescriptions} {makeTranslit} {yearDescriptions}по выгодной цене на Автобазаре', _extends({}, data, {
      transportDescriptions: __WEBPACK_IMPORTED_MODULE_4_shared_modules__["m" /* replaceToLowerCase */](transportDescriptions),
      transportNextDescriptions: __WEBPACK_IMPORTED_MODULE_4_shared_modules__["m" /* replaceToLowerCase */](transportNextDescriptions)
    }));
  }
  if (transportDescriptions && !make && !model && isNew) {
    if (transportType === 'gruzovye') {
      return t('Купить новые {transportDescriptions} 🚚 {cityDescriptions}. Удобный поиск по объявлениям поможет купить {transportNextDescriptions} {yearDescriptions}по выгодной цене на Автобазаре', _extends({}, data, {
        transportDescriptions: __WEBPACK_IMPORTED_MODULE_4_shared_modules__["m" /* replaceToLowerCase */](transportDescriptions),
        transportNextDescriptions: __WEBPACK_IMPORTED_MODULE_4_shared_modules__["m" /* replaceToLowerCase */](transportNextDescriptions)
      }));
    }
    if (transportType === 'spetstehnika') {
      return t('Купить новую {transportDescriptions} 🚜 {cityDescriptions}. {transportNextDescriptions} {yearDescriptions}по выгодной цене на Автобазаре', _extends({}, data, {
        transportDescriptions: __WEBPACK_IMPORTED_MODULE_4_shared_modules__["m" /* replaceToLowerCase */](transportDescriptions),
        transportNextDescriptions: __WEBPACK_IMPORTED_MODULE_4_shared_modules__["m" /* replaceToLowerCase */](transportNextDescriptions)
      }));
    }
    return t('Продажа новых {transportDescriptions} 🚛 {cityDescriptions}. Удобный поиск по объявлениям поможет купить {transportNextDescriptions} {yearDescriptions}по выгодной цене на Автобазаре', _extends({}, data, {
      transportDescriptions: __WEBPACK_IMPORTED_MODULE_4_shared_modules__["m" /* replaceToLowerCase */](transportDescriptions),
      transportNextDescriptions: __WEBPACK_IMPORTED_MODULE_4_shared_modules__["m" /* replaceToLowerCase */](transportNextDescriptions)
    }));
  }
  if (transportDescriptions && !make && !model && !isNew) {
    if (transportType === 'gruzovye') {
      return t('Продажа {transportDescriptions} бу 🚚 {cityDescriptions}. Удобный поиск по объявлениям поможет купить {transportNextDescriptions} {yearDescriptions}по выгодной цене на Автобазаре™.', _extends({}, data, {
        transportDescriptions: __WEBPACK_IMPORTED_MODULE_4_shared_modules__["m" /* replaceToLowerCase */](transportDescriptions),
        transportNextDescriptions: __WEBPACK_IMPORTED_MODULE_4_shared_modules__["m" /* replaceToLowerCase */](transportNextDescriptions)
      }));
    }
    if (transportType === 'spetstehnika') {
      return t('Купить {transportDescriptions} бу 🚜 {cityDescriptions}. {transportNextDescriptions} {yearDescriptions}по выгодной цене на Автобазаре', _extends({}, data, {
        transportDescriptions: __WEBPACK_IMPORTED_MODULE_4_shared_modules__["m" /* replaceToLowerCase */](transportDescriptions),
        transportNextDescriptions: __WEBPACK_IMPORTED_MODULE_4_shared_modules__["m" /* replaceToLowerCase */](transportNextDescriptions)
      }));
    }
    return t('Купить {transportDescriptions} бу 🚌 {cityDescriptions}. Удобный поиск по объявлениям поможет купить {reductionTranslit} {yearDescriptions}по выгодной цене на Автобазаре', _extends({}, data, {
      transportDescriptions: __WEBPACK_IMPORTED_MODULE_4_shared_modules__["m" /* replaceToLowerCase */](transportDescriptions),
      transportNextDescriptions: __WEBPACK_IMPORTED_MODULE_4_shared_modules__["m" /* replaceToLowerCase */](transportNextDescriptions)
    }));
  }
  return t('Купить бу 🚚 в Украине. Удобный поиск по объявлениям поможет купить {yearDescriptions}по выгодной цене на Автобазаре');
};
// CONCATENATED MODULE: ./src/shared/constants/seoDescriptions.js
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_shared_helpers_moment__ = __webpack_require__(1271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shared_helpers_seoTextFinder_seoDataFinder__ = __webpack_require__(1252);




/*
my test

*/
var buildSearchDescription = function buildSearchDescription(_ref, condition, icon, transportWho, transportWhat, t) {
  var category = _ref.category,
      type = _ref.type,
      make = _ref.make,
      model = _ref.model,
      location = _ref.location,
      motoTitle = _ref.motoTitle,
      yearTitle = _ref.yearTitle;
  return [t('Продажа'), condition, category || type || motoTitle ? (motoTitle || (type && type.title ? type.title.toLowerCase() : '')) + ' ' + (category && category.title ? category.title.toLowerCase() : '') : transportWho, icon, make && make.title, model && model.title, (location || t('в Украине')) + '.', t('Удобный поиск по объявлениям поможет Вам быстро и легко купить'), category || type ? (type && type.title ? type.title.toLowerCase() : '') + ' ' + (category && category.title ? category.title.toLowerCase() : '') : transportWhat || '', '' + (yearTitle || '') + t('по выгодной цене на Автобазаре™.')].filter(function (i) {
    return !!i;
  }).join(' ');
};

var getLocationString = function getLocationString(location, t) {
  return location && location.title ? t('в ') + ' ' + location.title : t('в Украине');
};

var buildAddDescriptionByTransportSlug = function buildAddDescriptionByTransportSlug(slug, t) {
  var firstSlug = 'автомобилей';
  var secondSlug = 'свое авто';
  switch (slug) {
    case 'avto':
      {
        firstSlug = 'машину';
        secondSlug = 'авто';
        break;
      }
    case 'moto':
      {
        firstSlug = 'мотоцикл';
        secondSlug = 'мототехники';
        break;
      }
    case 'avtobus':
      {
        firstSlug = 'бус';
        secondSlug = 'автобуса';
        break;
      }
    case 'gruzovye':
      {
        firstSlug = 'грузовик_а';
        secondSlug = 'грузового авто';
        break;
      }
    case 'spetstehnika':
      {
        firstSlug = 'спецтехнику';
        secondSlug = 'спецтехники';
        break;
      }
    case 'pritsepy':
      {
        firstSlug = 'прицеп';
        secondSlug = 'прицепа';
        break;
      }
    case 'vodnyi-transport':
      {
        firstSlug = 'водный транспорт';
        secondSlug = 'водного транспорта';
        break;
      }
    case 'zapchasti':
      {
        firstSlug = 'запчасти';
        secondSlug = 'автозапчастей';
        break;
      }

    default:
      {
        break;
      }
  }

  return t('Быстро продать') + ' ' + t(firstSlug).toLowerCase() + '\n  ' + t('через интернет на сайте') + ' \u0410\u0432\u0442\u043E\u0411\u0430\u0437\u0430\u0440\u2122.\n  ' + t('Бесплатно разместите объявление о продаже') + '\n  ' + t(secondSlug).toLowerCase() + '\n  ' + t('и его увидят тысячи покупателей со всей Украины') + '.';
};

var getAdvertDate = function getAdvertDate(hotDate, dateCreated, datePublicated, t) {
  var date = hotDate || dateCreated || datePublicated;
  return date ? t('от') + ' ' + __WEBPACK_IMPORTED_MODULE_1_shared_helpers_moment__["a" /* createdDate */](date, t('от') === 'від' ? 'uk' : 'ru').slice(0, -3) : '';
};

var getBodyAltAvtoAdvert = function getBodyAltAvtoAdvert(isNew, modification, body, category, t) {
  // const result =
  //   modification && modification.series && modification.series.title
  //     ? isNew
  //       ? t(modification.series.title).charAt(0).toUpperCase() +
  //         t(modification.series.title).slice(1)
  //       : t(modification.series.title).toLowerCase()
  //     : body && body.title
  //       ? isNew
  //         ? t(body.title).charAt(0).toUpperCase() + t(body.title).slice(1)
  //         : t(body.title).toLowerCase()
  //       : isNew
  //         ? t(category.title).charAt(0).toUpperCase() + category.title.slice(1)
  //         : category && category.title && t(category.title).toLowerCase();

  var result = '';
  if (modification && modification.series && modification.series.title) {
    result = isNew ? t(modification.series.title).charAt(0).toUpperCase() + t(modification.series.title).slice(1) : t(modification.series.title).toLowerCase();
  } else if (body && body.title) {
    result = isNew ? t(body.title).charAt(0).toUpperCase() + t(body.title).slice(1) : t(body.title).toLowerCase();
  } else if (category && category.title) {
    result = isNew ? t(category.title).charAt(0).toUpperCase() + category.title.slice(1) : category && category.title && t(category.title).toLowerCase();
  }
  return result;
};

var DESCRIPTION = {
  HOME: function HOME(props, t) {
    return t('SEO_HOME_DESCRIPTION');
  },

  ADVERT: function ADVERT(_ref2) {
    var id = _ref2.id,
        make = _ref2.make,
        model = _ref2.model,
        category = _ref2.category,
        year = _ref2.year,
        mileage = _ref2.mileage,
        capacity = _ref2.capacity,
        capacityUnit = _ref2.capacityUnit,
        engine = _ref2.engine,
        gearbox = _ref2.gearbox,
        location = _ref2.location,
        color = _ref2.color,
        body = _ref2.body,
        drive = _ref2.drive,
        price = _ref2.price,
        _ref2$isNew = _ref2.isNew,
        isNew = _ref2$isNew === undefined ? false : _ref2$isNew,
        _ref2$dealer = _ref2.dealer,
        dealer = _ref2$dealer === undefined ? false : _ref2$dealer,
        date_created = _ref2.date_created,
        hot_date = _ref2.hot_date,
        date_publicated = _ref2.date_publicated,
        modification = _ref2.modification,
        capacityAlt = _ref2.capacityAlt,
        characteristics = _ref2.characteristics;
    var transportDescriptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    var t = arguments[2];

    if (transportDescriptions == 'авто') {
      var _getCustomParams = __WEBPACK_IMPORTED_MODULE_2_shared_helpers_seoTextFinder_seoDataFinder__["a" /* getCustomParams */]({ city: location && location.title }, t),
          inCity = _getCustomParams.inCity;

      var advertDate = getAdvertDate(hot_date, date_created, date_publicated, t);
      var bodyAltAdvert = getBodyAltAvtoAdvert(isNew, modification, body, category, t);
      var bodyAdvert = characteristics && characteristics.category && characteristics.category.title && t(characteristics.category.title);
      var capacityAvto = capacity || (capacityAlt && capacityAlt.title ? capacityAlt.title : '');

      return [!isNew ? 'Продам' : t('Купить'), isNew && t('новое'), t(transportDescriptions), !isNew && 'бу', make && make.title, model && model.title, modification && modification.title, year && year, mileage && t('с пробегом') + ' ' + t(mileage).slice(0, -7) + ' ' + t('тыс км'), [location && location.title && inCity, isNew && dealer && dealer.title && t('в салоне') + ' ' + dealer.title].filter(function (i) {
        return !!i;
      }).join(', ').replace(',', '').concat('.'), isNew && price && t('Цена') + ' ' + price + '.', isNew ? '' : 'Продаю', [[(!isNew ? bodyAdvert && bodyAdvert.toLowerCase() || bodyAltAdvert : bodyAdvert || bodyAltAdvert) || (isNew ? t('Легковые') : t('легковые')), color && color.title && t(color.title).toLowerCase()].filter(function (i) {
        return !!i;
      }).join(', ').replace(',', '').concat(''), [engine && engine.title && t(engine.title).toLowerCase(), capacityAvto + (capacityAvto && capacityUnit && '' + (' ' + t(capacityUnit)))].filter(function (i) {
        return !!i;
      }).join(', ').replace(/,\s*/g, ' / ').concat(''), gearbox && gearbox.title && t('коробка') + ' ' + t(gearbox.title).toLowerCase(), drive && drive.title && t(drive.title).toLowerCase() + ' ' + t('привод')].filter(function (i) {
        return !!i;
      }).join(', ').replace(/$(, )/, '').concat('.'), !isNew && price && t('Цена') + ' ' + price + '.', id && t('Объявление') + ' ' + id, [!isNew && advertDate].filter(function (i) {
        return !!i;
      }).join(', ').replace(/$(, )/, '').concat(' ')].filter(function (i) {
        return !!i;
      }).join(' ');
    } else if (transportDescriptions === 'Водный транспорт' && !isNew && dealer && dealer.title || transportDescriptions === 'Водный транспорт' && !isNew && dealer && dealer.title) {
      return [t('Купить'), t(transportDescriptions), make && make.title, model && model.title, modification && modification.title, year, '\u0432 ' + t(location.title), dealer && dealer.title && t('в автосалоне') + ' ' + dealer.title, mileage && t('с пробегом') + ' ' + t(mileage).slice(0, -7) + ' ' + (t('с пробегом') === 'с пробегом' ? 'тыс км' : 'тис км'), price && t('цена') + ' ' + price, t('на Автобазаре'), id && t('Объявление') + ' ' + id].filter(function (i) {
        return !!i;
      }).join(' ');
    }

    return [t('Продажа'), make && make.title, model && model.title, dealer && dealer.title && t('в автосалоне') + ' ' + dealer.title, '' + t('характеристики'), transportDescriptions && t(transportDescriptions) + ':', [category && category.title && t('кузов') + '- ' + t(category.title).toLowerCase(), year && t('год выпуска') + ' - ' + year, mileage && t('с пробегом') + ' ' + t(mileage).slice(0, -7) + ' ' + (t('с пробегом') === 'с пробегом' ? 'тыс км' : 'тис км'), capacity && capacityUnit && t('объем двигателя') + ' - ' + capacity + ' ' + (t(capacityUnit) || capacityUnit), engine && engine.title && t('тип топлива') + ' - ' + t(engine.title).toLowerCase(), gearbox && gearbox.title && t('КПП') + ' - ' + t(gearbox.title).toLowerCase(), color && color.title && t('цвет') + ' - ' + t(color.title).toLowerCase()].filter(function (i) {
      return !!i;
    }).join(', ').replace(/$(, )/, '').concat('.'), [id && t('Объявление') + ' ' + id].filter(function (i) {
      return !!i;
    }).join(', ').replace(/$(, )/, '').concat(' ')].filter(function (i) {
      return !!i;
    }).join(' ');

    // // old
    // [
    // t('Продажа'),
    // make && make.title,
    // model && model.title,
    // dealer && `${t('в автосалоне')} ${dealer}`,
    // `, ${t('характеристики')}`,
    // `${transportDescriptions}:`,
    // [
    //   category && category.title && `${t('кузов')}- ${category.title.toLowerCase()}`,
    //   year && `${t('год выпуска')} - ${year}`,
    //   mileage && `${t('с пробегом')} ${mileage}`,
    //   capacity &&
    //     capacityUnit &&
    //     `${t('объем двигателя')} - ${capacity} ${t(capacityUnit) || capacityUnit}`,
    //   engine && engine.title && `${t('тип топлива')} - ${engine.title.toLowerCase()}`,
    //   gearbox && gearbox.title && `${t('КПП')} - ${gearbox.title.toLowerCase()}`,
    //   color && color.title && `${t('цвет')} - ${color.title.toLowerCase()}`,

    // ]
    //   .filter(i => !!i)
    //   .join(' ')
  },

  //

  SPARE_ADVERT: function SPARE_ADVERT(_ref3, t) {
    var rubric = _ref3.rubric,
        sparetype = _ref3.sparetype,
        type = _ref3.type,
        make = _ref3.make,
        model = _ref3.model,
        location = _ref3.location,
        id = _ref3.id;
    return [t('Продажа'), rubric && rubric.title, sparetype && (sparetype.title || '').toLowerCase(), (type || make || model) && t('на'), type && (type.title || '').toLowerCase(), make && make.title, model && model.title, getLocationString(location, t), t('на Автобазаре'), [id && t('Объявление') + ' ' + id].filter(function (i) {
      return !!i;
    }).join(', ').replace(/$(, )/, '').concat(' ')].filter(function (i) {
      return !!i;
    }).join(' ');
  },
  //

  SEARCH: {
    avto: function avto(data, translate) {
      return buildSearchAvtoSeoDescription(data, translate);
    },
    moto: function moto(data, translate) {
      return buildSearchMotoSeoDescription(data, translate);
    },
    mototsikl: function mototsikl(props, t) {
      return buildSearchDescription(props, t('бу и новых'), '🏍️', t('мотоциклов'), t('мотоцикл'), t);
    },
    commercial: function commercial(data, translate) {
      return buildSearchCommercialSeoDescription(data, translate);
    }
  },
  SPARE_PARTS: function SPARE_PARTS(data, rubricSlug, t, isRegion) {
    return buildSparePartsSeoDescription(data, rubricSlug, t, isRegion);
  },
  FIRM: function FIRM(data, t) {
    return buildFirmsSeoDescription(data, t);
  },
  FIRM_PAGE: function FIRM_PAGE(title, tab, t, car_drive_countries, transportType, tags, firm) {
    return buildFirmPageSeoDescription(title, tab, t, car_drive_countries, transportType, tags, firm);
  },
  DEALERS: function DEALERS(data, slug, t) {
    return buildDealersSeoDescription(data, slug, t);
  },

  DEALER_PAGE: {
    ADVERTS: function ADVERTS(_ref4, t) {
      var dealer = _ref4.dealer,
          _ref4$isOfficial = _ref4.isOfficial,
          isOfficial = _ref4$isOfficial === undefined ? false : _ref4$isOfficial,
          _ref4$makes = _ref4.makes,
          makes = _ref4$makes === undefined ? [] : _ref4$makes;
      return [t('Купить автомобиль вы можете у'), isOfficial && t('официального'), t('дилера'), makes.map(function (_ref5, i, _ref6) {
        var make = _ref5.title;
        var count = _ref6.length;
        return '' + make + (i !== count - 1 ? ', ' : '');
      }).join(''), t('в Украине') + ' -', dealer || '', t('Все предложения автосалона на Автобазаре')].filter(function (i) {
        return !!i;
      }).join(' ');
    },

    NEWS: function NEWS() {
      var dealer = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var t = arguments[1];
      return t('Самые свежие и актуальные предложения автосалона') + ' ' + dealer + ' ' + t('читайте на АвтоБазаре') + '.';
    },

    ABOUT: function ABOUT() {
      var dealer = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var t = arguments[1];
      return t('Узнать актуальную информацию об автосалоне') + ' ' + dealer + ' ' + t('на АвтоБазаре');
    },

    CONTACT: function CONTACT() {
      var dealer = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var t = arguments[1];
      return t('Узнать контактную информацию автосалона') + ' ' + dealer + ': ' + t('адрес, месторасположения на карте, контактные номера телефонов, режим работы - все контакты на АвтоБазаре');
    }
  },

  //

  INVOICE: function INVOICE(t) {
    return t('Квитанция за оплату на АвтоБазаре');
  },

  //

  JOURNAL: {
    ALL: function ALL(t) {
      return t('Все новости и статьи на Автобазар') + '\u2122';
    },
    NEWS: function NEWS(t, rubric) {
      return t('Все') + ' ' + t(rubric || 'Новости').toLowerCase() + ' ' + t('на Автобазаре');
    }
  },

  //

  SERVICE: {
    CAR_COST_ESTIMATE: function CAR_COST_ESTIMATE(t) {
      return t('Оценка стоимости авто') + ' ' + t('на Автобазаре');
    },
    CAR_DRIVE: function CAR_DRIVE(t) {
      return t('Пригон авто') + ' ' + t('на Автобазаре');
    },
    SEARCH_SUBSCRIPTIONS: function SEARCH_SUBSCRIPTIONS(t) {
      return t('Подписка на поиск') + ' ' + t('на Автобазаре');
    }
  },

  //

  LOGIN: function LOGIN(t) {
    return t('Авторизация на Автобазар') + '\u2122';
  },

  //

  NOT_FOUND: function NOT_FOUND(t) {
    return t('Страница не найдена');
  },

  //

  ADVERT_FORM: {
    ADD: function ADD(slug, t) {
      return buildAddDescriptionByTransportSlug(slug, t);
    },
    EDIT: function EDIT(t) {
      return t('Форма редактирования объявления на Автобазар');
    }
  },

  //

  PROFILE: {
    PROFILE: function PROFILE(t) {
      return t('Профиль пользователя');
    },
    DIALOGS: function DIALOGS(t) {
      return t('Сообщения пользователя');
    },
    FAVORITES: function FAVORITES(t) {
      return t('Избранные пользователя');
    },
    BILLING: function BILLING(t) {
      return t('Баланс пользователя');
    },
    SEARCHES: function SEARCHES(t) {
      return t('Поиски пользователя');
    },
    ADVERTS: function ADVERTS(t) {
      return t('Объявления пользователя');
    },
    INSURANCE: function INSURANCE(t) {
      return t('Страховка');
    },
    SEARCH_SUBSCRIPTIONS: function SEARCH_SUBSCRIPTIONS(t) {
      return t('Подписка на поис');
    }
  },

  //

  MOBILE_FORM: {
    GEO: function GEO(t) {
      return t('Выбор местоположения');
    },
    FILTERS: function FILTERS(t) {
      return t('Выбор по параметрам');
    }
  },

  STATIC_PAGE: {
    LAW: function LAW(t) {
      return t('Политика конфиденциальности – полезная информация от Автобазар');
    },
    PUBLIC_CONTRACT: function PUBLIC_CONTRACT(t) {
      return t('Публичный договор – полезная информация от Автобазар');
    },
    INFO_ZAPCHASTI: function INFO_ZAPCHASTI(t) {
      return t('Запчасти – полезная информация от Автобазар');
    },
    HELP: function HELP(t) {
      return t('Помощь – полезная информация от Автобазар');
    },
    FOR_SERVICES: function FOR_SERVICES(t) {
      return t('Автосервисам – полезная информация от Автобазар');
    },
    FOR_PRIVATES: function FOR_PRIVATES(t) {
      return t('Размещение объявлений – полезная информация от Автобазар');
    },
    FOR_DEALERS: function FOR_DEALERS(t) {
      return t('Пакет “Бизнес Плюс” – полезная информация от Автобазар');
    },
    BIZNES_PAKET: function BIZNES_PAKET(t) {
      return t('Пакет “Бизнес” – полезная информация от Автобазар');
    },
    ADVERTISING: function ADVERTISING(t) {
      return t('Разместить рекламу – полезная информация от Автобазар');
    },
    ABOUT: function ABOUT(t) {
      return t('Что такое автобазар – полезная информация от Автобазар');
    },
    FAQ: function FAQ(t) {
      return t('Часто задаваемые вопросы – полезная информация от Автобазар');
    },
    ENTRANCE: function ENTRANCE(t) {
      return t('Регистрация на avtobazar.ua – полезная информация от Автобазар');
    },
    TRANSPORT_ADS_RULES: function TRANSPORT_ADS_RULES(t) {
      return t('Правила составления объявлений – полезная информация от Автобазар');
    }
  }
};

/* harmony default export */ __webpack_exports__["a"] = (DESCRIPTION);

/***/ }),

/***/ 1389:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// CONCATENATED MODULE: ./src/shared/helpers/seoTitles.js
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_shared_modules_subjectiveText_allText__ = __webpack_require__(309);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_shared_helpers_seoTextFinder__ = __webpack_require__(1254);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shared_constants_json_firstSeoRubricsTypes_json__ = __webpack_require__(1257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shared_constants_json_firstSeoRubricsTypes_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_shared_constants_json_firstSeoRubricsTypes_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_constants_json_secondSeoRubricsTypes_json__ = __webpack_require__(1258);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_constants_json_secondSeoRubricsTypes_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_shared_constants_json_secondSeoRubricsTypes_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shared_modules__ = __webpack_require__(103);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };








var buildSearchAvtoSeoTitle = function buildSearchAvtoSeoTitle(data, t) {
  var seoData = __WEBPACK_IMPORTED_MODULE_1_shared_helpers_seoTextFinder__["a" /* getSeoDataByParams */](data, t);
  if (seoData && seoData.title) return seoData.title;

  var _data$make = data.make,
      make = _data$make === undefined ? '' : _data$make,
      _data$model = data.model,
      model = _data$model === undefined ? '' : _data$model,
      _data$location = data.location,
      location = _data$location === undefined ? '' : _data$location,
      _data$generation = data.generation,
      generation = _data$generation === undefined ? '' : _data$generation,
      _data$gearbox = data.gearbox,
      gearbox = _data$gearbox === undefined ? '' : _data$gearbox,
      _data$engine = data.engine,
      engine = _data$engine === undefined ? '' : _data$engine,
      _data$body = data.body,
      body = _data$body === undefined ? '' : _data$body,
      _data$drive = data.drive,
      driveSelected = _data$drive === undefined ? '' : _data$drive,
      _data$isNew = data.isNew,
      isNew = _data$isNew === undefined ? false : _data$isNew,
      _data$year = data.year,
      yearSelected = _data$year === undefined ? '' : _data$year,
      _data$country = data.country,
      country = _data$country === undefined ? null : _data$country,
      _data$city = data.city,
      city = _data$city === undefined ? null : _data$city;


  var drive = __WEBPACK_IMPORTED_MODULE_4_shared_modules__["b" /* buildDriveValue */](driveSelected, t);
  var locale = t('locale');
  var inGenitiveLocation = location && __WEBPACK_IMPORTED_MODULE_0_shared_modules_subjectiveText_allText__["g" /* sity */][location] ? __WEBPACK_IMPORTED_MODULE_4_shared_modules__["c" /* buildInGenitiveCityHeader */](__WEBPACK_IMPORTED_MODULE_0_shared_modules_subjectiveText_allText__["g" /* sity */][location][locale].genitive) : city && city.title && ' ' + __WEBPACK_IMPORTED_MODULE_4_shared_modules__["c" /* buildInGenitiveCityHeader */](city[locale + '_title'] || city.title) || '\u0432 ' + __WEBPACK_IMPORTED_MODULE_0_shared_modules_subjectiveText_allText__["g" /* sity */]['Украина'][locale].genitive;

  var yearVsSpace = yearSelected ? ' ' + yearSelected + ' ' + t('года') : '';
  var customGearbox = gearbox in __WEBPACK_IMPORTED_MODULE_0_shared_modules_subjectiveText_allText__["c" /* gearboxes */] ? __WEBPACK_IMPORTED_MODULE_0_shared_modules_subjectiveText_allText__["c" /* gearboxes */][gearbox][locale].title : gearbox;
  var customEngine = engine in __WEBPACK_IMPORTED_MODULE_0_shared_modules_subjectiveText_allText__["b" /* engines */] ? __WEBPACK_IMPORTED_MODULE_0_shared_modules_subjectiveText_allText__["b" /* engines */][engine][locale].title : engine;
  var customEngineAlt = engine in __WEBPACK_IMPORTED_MODULE_0_shared_modules_subjectiveText_allText__["b" /* engines */] ? __WEBPACK_IMPORTED_MODULE_0_shared_modules_subjectiveText_allText__["b" /* engines */][engine][locale].altTitle : engine;

  var countryTitle = country && t(country.title);
  var countryFromTitle = country && country.from && country.from[locale];

  // {locale}*/avto/{country}/
  if (country && !make && !model && !generation && !gearbox && !engine && !body && !drive) {
    return t('SEO_META_TITLE_AVTO_COUNTRY', { countryTitle: countryTitle, countryFromTitle: countryFromTitle });
  }

  if (make && !model && !generation && !gearbox && !engine && !body && !drive) {
    return t(isNew ? 'Продажа {make}{year} на АвтоБазар™ {inGenitiveLocation} – купить новый автомобиль, сравнение цен в каталоге' : 'Продажа {make}{year} б/у на АвтоБазар™ {inGenitiveLocation} – купить легковой автомобиль по лучшей цене', _extends({}, data, {
      inGenitiveLocation: inGenitiveLocation,
      year: yearVsSpace
    }));
  }
  if (make && model && !generation && !gearbox && !engine && !body && !drive) {
    return t(isNew ? 'Продажа {make} {model}{year} на АвтоБазар™ {inGenitiveLocation} – купить новый автомобиль, сравнение цен в каталоге' : 'Продажа б/у {make} {model}{year} на АвтоБазар™ {inGenitiveLocation} – купить легковой автомобиль по лучшей цене', _extends({}, data, {
      inGenitiveLocation: inGenitiveLocation,
      year: yearVsSpace
    }));
  }
  if (make && model && body && !generation && !gearbox && !engine && !drive) {
    return t(isNew ? 'Продажа {make} {model} {body}{year} на АвтоБазар™ {inGenitiveLocation} – купить новый автомобиль, сравнение цен в каталоге' : 'Продажа б/у {body} {make} {model}{year} на АвтоБазар™ {inGenitiveLocation} – купить автомобиль по лучшей цене', _extends({}, data, {
      inGenitiveLocation: inGenitiveLocation,
      year: yearVsSpace
    }));
  }
  if (make && model && generation && !gearbox && !engine && !drive) {
    return t(isNew ? 'Продажа {make} {model} {generation}{year} на АвтоБазар™ {inGenitiveLocation} – купить новый автомобиль, сравнение цен в каталоге' : 'Продажа б/у {make} {model} {generation}{year} на АвтоБазар™ {inGenitiveLocation} – купить автомобиль по лучшей цене', _extends({}, data, {
      inGenitiveLocation: inGenitiveLocation,
      year: yearVsSpace
    }));
  }
  if (make && model && gearbox && !engine && !drive) {
    return t(isNew ? 'Новый {make} {model}{generation} {gearbox}{year} купить {inGenitiveLocation} на АвтоБазар™' : '{make} {model} б/у{generation} {gearbox}{year} купить {inGenitiveLocation} на АвтоБазар™', _extends({}, data, {
      generation: ' ' + generation || '',
      inGenitiveLocation: inGenitiveLocation,
      year: yearVsSpace
    }));
  }
  if (make && model && gearbox && drive && !engine) {
    return t(isNew ? 'Новый {make} {model}{generation} {gearbox} {drive}{year} купить {inGenitiveLocation} на АвтоБазар™' : 'Купить {make} {model}{generation} {gearbox} {drive}{year} {inGenitiveLocation} на АвтоБазар™', _extends({}, data, {
      generation: ' ' + generation || '',
      inGenitiveLocation: inGenitiveLocation,
      drive: drive,
      year: yearVsSpace
    }));
  }
  if (make && model && gearbox && drive && engine) {
    return t(isNew ? 'Новый {make} {model} {engine} {gearbox}{generation} {drive}{year} купить {inGenitiveLocation} на АвтоБазар™' : '{make} {model} {engine} {gearbox} {drive}{generation}{year} б/у купить {inGenitiveLocation} на АвтоБазар™', _extends({}, data, {
      generation: ' ' + generation || '',
      inGenitiveLocation: inGenitiveLocation,
      drive: drive,
      year: yearVsSpace
    }));
  }

  if (make && !model && gearbox && !engine && !drive) {
    return t(isNew ? 'АвтоБазар™ {inGenitiveLocation} – купить новое авто {makeTranslate} {customGearbox}{year} по лучшей цене' : 'АвтоБазар™ {inGenitiveLocation} – купить авто {makeTranslate} {customGearbox}{year} б/у по лучшей цене', _extends({}, data, {
      inGenitiveLocation: inGenitiveLocation,
      year: yearVsSpace,
      customGearbox: customGearbox
    }));
  }

  if (!make && !model && !gearbox && engine && !drive) {
    return t(isNew ? 'АвтоБазар™ {inGenitiveLocation} – купить новый {customEngine}{year} по лучшей цене' : 'АвтоБазар™ {inGenitiveLocation} – купить {customEngine}{year} б/у по лучшей цене', _extends({}, data, {
      inGenitiveLocation: inGenitiveLocation,
      year: yearVsSpace,
      customEngine: customEngine
    }));
  }

  if (!make && !model && !gearbox && !engine && !drive && body) {
    return t(isNew ? 'АвтоБазар™ {inGenitiveLocation} – купить новый авто {body}{year} по лучшей цене' : 'АвтоБазар™ {inGenitiveLocation} – купить авто {body}{year} б/у по лучшей цене', _extends({}, data, {
      inGenitiveLocation: inGenitiveLocation,
      year: yearVsSpace
    }));
  }

  if (make && !model && !gearbox && engine && !drive && !body) {
    return t(isNew ? 'Новые {customEngineAlt} {make}{year} купить по лучшей цене на АвтоБазар™ {inGenitiveLocation}' : '{customEngineAlt} {make}{year} б/у купить по лучшей цене на АвтоБазар™ {inGenitiveLocation}', _extends({}, data, {
      inGenitiveLocation: inGenitiveLocation,
      year: yearVsSpace,
      customEngineAlt: customEngineAlt
    }));
  }

  if (make && model && !gearbox && engine && !drive && !body) {
    return t(isNew ? 'Новые {customEngineAlt} {make} {model}{year} купить по лучшей цене на АвтоБазар™ {inGenitiveLocation}' : '{customEngineAlt} {make} {model}{year} б/у купить по лучшей цене на АвтоБазар™ {inGenitiveLocation}', _extends({}, data, {
      inGenitiveLocation: inGenitiveLocation,
      year: yearVsSpace,
      customEngineAlt: customEngineAlt
    }));
  }

  if (!make && !model && gearbox && !engine && !drive && !body) {
    return t(isNew ? 'АвтоБазар™ {inGenitiveLocation} - купить новый авто {customGearbox}{year} по лучшей цене' : 'АвтоБазар™ {inGenitiveLocation} - купить авто {customGearbox}{year} б/у по лучшей цене', _extends({}, data, {
      inGenitiveLocation: inGenitiveLocation,
      year: yearVsSpace,
      customGearbox: customGearbox
    }));
  }
  if (make && !model && !gearbox && !engine && !drive && body) {
    return t(isNew ? 'Новый {body} {make}{year} - купить по лучшей цене на АвтоБазар™ {inGenitiveLocation}' : '{body} {make}{year} б/у - купить по лучшей цене на АвтоБазар™ {inGenitiveLocation}', _extends({}, data, {
      inGenitiveLocation: inGenitiveLocation,
      year: yearVsSpace
    }));
  }

  return t(isNew ? 'АвтоБазар™ {inGenitiveLocation} – купить легковой автомобиль новый, сравнение цен в каталоге' : 'Автобазар {inGenitiveLocation}. Купить авто бу {inGenitiveLocation} с пробегом на авторынке', {
    inGenitiveLocation: inGenitiveLocation,
    location: location
  });
};

var buildDealersSeoTitle = function buildDealersSeoTitle(data, slug, t) {
  var _data$make2 = data.make,
      make = _data$make2 === undefined ? '' : _data$make2,
      _data$model2 = data.model,
      model = _data$model2 === undefined ? '' : _data$model2,
      _data$makeTranslate = data.makeTranslate,
      makeTranslate = _data$makeTranslate === undefined ? make : _data$makeTranslate,
      _data$modelTranslate = data.modelTranslate,
      modelTranslate = _data$modelTranslate === undefined ? model : _data$modelTranslate,
      _data$location2 = data.location,
      locationRu = _data$location2 === undefined ? '' : _data$location2;


  var seoData = __WEBPACK_IMPORTED_MODULE_1_shared_helpers_seoTextFinder__["a" /* getSeoDataByParams */](_extends({}, data, { transport: data.transport || slug }), t, 'avtosalony');
  if (seoData && seoData.title) return seoData.title;

  var locale = t('locale');

  var cityHeader = locationRu && __WEBPACK_IMPORTED_MODULE_0_shared_modules_subjectiveText_allText__["g" /* sity */][locationRu] ? locationRu : 'Украина';
  var location = locationRu && t(locationRu);
  var accusativeCityHeader = __WEBPACK_IMPORTED_MODULE_0_shared_modules_subjectiveText_allText__["g" /* sity */][cityHeader][locale].accusative;
  var inGenitiveCityHeader = __WEBPACK_IMPORTED_MODULE_4_shared_modules__["c" /* buildInGenitiveCityHeader */](__WEBPACK_IMPORTED_MODULE_0_shared_modules_subjectiveText_allText__["g" /* sity */][cityHeader][locale].genitive);

  if (slug === 'avto') {
    if (location && !make && !model) {
      return t('Автосалоны {location} – надежные автодилеры, цены, акции на авто из салона – АвтоБазар™', { location: location });
    }
    if (make && !location && !model) {
      return t('Автосалоны {make} – официальные дилеры {makeTranslate} на сайте АвтоБазар™', {
        make: make,
        makeTranslate: makeTranslate
      });
    }
    if (make && location && !model) {
      return t('Автосалоны {make} – цены салонов {makeTranslate} {inGenitiveCityHeader} на сайте АвтоБазар™', {
        make: make,
        makeTranslate: makeTranslate,
        inGenitiveCityHeader: inGenitiveCityHeader
      });
    }
    if (make && model && !location) {
      return t('{make} {model} купить в автосалонах – цены на {makeTranslate} {modelTranslate} – АвтоБазар™', {
        make: make,
        model: model,
        makeTranslate: makeTranslate,
        modelTranslate: modelTranslate
      });
    }
    if (make && model && location) {
      return t('Продажа {make} {model} в автосалонах {accusativeCityHeader}. Сравнение цен авто дилеров на {modelTranslate} – АвтоБазар™', {
        make: make,
        model: model,
        modelTranslate: modelTranslate,
        accusativeCityHeader: accusativeCityHeader
      });
    }
  }
  if (slug === 'mototsikl') {
    if (location && !make) {
      return t('Мотосалоны {location} – лучшие цены мото магазинов: мотоциклы, скутеры, квадроциклы – АвтоБазар™', { location: location });
    }
    if (make && !location) {
      return t('Мотосалоны {make} – все официальные мото магазины {makeTranslate} на сайте АвтоБазар™', {
        make: make,
        makeTranslate: makeTranslate
      });
    }
    if (make && location) {
      return t('Мотосалоны {make} {location} – все официальные мото магазини на сайте АвтоБазар™', {
        make: make,
        makeTranslate: makeTranslate,
        location: location
      });
    }
    return t('Мотосалоны Украины – цены мото магазинов на мотоциклы, скутеры, квадроциклы – АвтоБазар™', {});
  }
  if (slug === 'avtobus') {
    if (location && !make && !model) {
      return t('Автосалоны автобусов {location} – надежные дилеры бусов на сайте АвтоБазар™', {
        location: location
      });
    }
    if (make && !location && !model) {
      return t('Автосалоны автобусов {make} – цены дилеров на бусы {makeTranslate} – АвтоБазар™', {
        make: make,
        makeTranslate: makeTranslate
      });
    }
    if (make && location) {
      return t('Автобусы {make} в автосалонах {accusativeCityHeader} – проверенные бусы {makeTranslate} на АвтоБазар™', {
        make: make,
        makeTranslate: makeTranslate,
        accusativeCityHeader: accusativeCityHeader
      });
    }
    return t('Автосалоны автобусов Украины – все автодилеры по продаже бусов на сайте АвтоБазар™', {});
  }
  if (slug === 'gruzovye') {
    if (location && !make && !model) {
      return t('Автосалоны грузовых автомобилей {location} – надежные автодилеры грузовиков на сайте АвтоБазар™', { location: location });
    }
    if (make && !location && !model) {
      return t('Автосалоны грузовых {make} – проверенные грузовики {makeTranslate} на АвтоБазар™', {
        make: make,
        makeTranslate: makeTranslate
      });
    }
    if (make && location) {
      return t('Грузовые {make} в автосалонах {accusativeCityHeader} – проверенные грузовики {makeTranslate} на АвтоБазар™', {
        make: make,
        makeTranslate: makeTranslate,
        accusativeCityHeader: accusativeCityHeader
      });
    }
    return t('Автосалоны грузовых автомобилей Украины – все автодилеры по продаже грузовиков на АвтоБазар™', {});
  }
  if (slug === 'spetstehnika') {
    if (!make && location) {
      return t('Дилеры спецтехники {inGenitiveCityHeader} – каталог компаний АвтоБазар™', {
        inGenitiveCityHeader: inGenitiveCityHeader
      });
    }
    if (make && !location) {
      return t('Дилеры спецтехники {make} Украины в каталоге компаний АвтоБазар™', {
        make: make,
        makeTranslate: makeTranslate
      });
    }
    return t('Дилеры спецтехники Украины в каталоге компаний АвтоБазар™', {});
  }
  if (slug === 'vodnyi-transport') {
    if (!make && location) {
      return t('Дилеры водного транспорта {location} в каталоге компаний АвтоБазар™', {
        location: location
      });
    }
    if (make && !location) {
      return t('Дилеры водного транспорта {make} Украины в каталоге компаний АвтоБазар™', {
        make: make,
        makeTranslate: makeTranslate
      });
    }
    return t('Дилеры водного транспорта Украины в каталоге компаний АвтоБазар™', {});
  }
  if (slug === 'pritsepy') {
    if (!make && location) {
      return t('Производители прицепов и проверенные дилеры {inGenitiveCityHeader} – каталог компаний АвтоБазар™', {
        inGenitiveCityHeader: inGenitiveCityHeader
      });
    }
    if (make && !location) {
      return t('Проверенные дилеры прицепов {make} в Украине – каталог компаний на АвтоБазар™', {
        make: make,
        makeTranslate: makeTranslate
      });
    }
    return t('Производители прицепов и проверенные дилеры Украины в каталоге компаний АвтоБазар™', {});
  }

  return t('Автосалоны Украины – все автодилеры, цены, акции на авто из салона – АвтоБазар™', {});
};

var buildFirmsSeoTitle = function buildFirmsSeoTitle(data, t) {
  var cityTitle = data.cityTitle,
      section = data.section,
      regLocation = data.regLocation,
      location = data.location;
  // if (section === 'СТО') {
  //   if (regLocation)
  //     return t('СТО {location} - автосервис по ремонту авто на сайте Автобазар', {
  //       location: regLocation,
  //     });
  //   return t('Все СТО Украины, автосервисы и шиномонтажи на АвтоБазар™');
  // }
  // if (section && cityTitle) {
  //   return t('{section} в {cityTitle} на Автобазаре - Полный каталог фирм в вашем городе', {
  //     ...data,
  //     section: replaceToUpperCase(section),
  //   });
  // }
  // if (section) {
  //   return t('{section} в Украине на Автобазаре - Полный каталог фирм в вашем городе', {
  //     ...data,
  //     section: replaceToUpperCase(section),
  //   });
  // }
  // if (cityTitle) {
  //   return t('СТО {cityTitle} - автосервис по ремонту авто на сайте Автобазар', {
  //     ...data,
  //     cityTitle: t(location),
  //   });
  // }

  if (section === 'СТО' && cityTitle) {
    return t('СТО {cityTitle}. Адреса, телефоны, карта проезда - Автобазар', _extends({}, data, {
      cityTitle: t(regLocation) || t(location)
    }));
  }

  if ((section === 'Авторазборка' || section === 'Авторозборка') && cityTitle) {
    return t('Авторазборка {cityTitle}. Каталог компаний по разбору авто (адреса, телефоны) - Автобазар', _extends({}, data, {
      cityTitle: t(regLocation) || t(location)
    }));
  }

  if ((section === 'Автовыкуп' || section === 'Автовикуп') && cityTitle) {
    return t('Автовыкуп {cityTitle}. Каталог компаний по выкупу авто - Автобазар', _extends({}, data, {
      cityTitle: t(regLocation) || t(location)
    }));
  }

  if ((section === 'Запчасти' || section === 'Запчастини') && cityTitle) {
    return t('Дилеры по продаже автозапчастей {cityTitle}. Телефоны, адреса компаний - Автобазар', _extends({}, data, {
      cityTitle: t(regLocation) || t(location)
    }));
  }

  if ((section === 'Автотовары' || section === 'Автотовари') && cityTitle) {
    return t('Дистрибьютеры автотоваров {cityTitle}. Каталог поставщиков автотоваров - Автобазар', _extends({}, data, {
      cityTitle: t(regLocation) || t(location)
    }));
  }

  if ((section === 'Сервисные центры' || section === 'Сервісні центри') && cityTitle) {
    return t('ТСЦ {cityTitle}. Телефоны, адреса сервисных центров авто - Автобазар', _extends({}, data, {
      cityTitle: t(regLocation) || t(location)
    }));
  }

  if (cityTitle) {
    return t('Автосервисы {cityTitle}. Каталог компаний с адресами и телефонами - Автобазар', _extends({}, data, {
      cityTitle: t(regLocation) || t(location)
    }));
  }

  return t('Каталог фирм в Украине на Автобазаре - Полный каталог фирм в вашем городе');
};

var buildSparePartsSeoTitles = function buildSparePartsSeoTitles(data, rubricSlug, t) {
  var locale = t('locale');
  var _data$location3 = data.location,
      locationRu = _data$location3 === undefined ? '' : _data$location3,
      _data$make3 = data.make,
      make = _data$make3 === undefined ? '' : _data$make3,
      _data$model3 = data.model,
      model = _data$model3 === undefined ? '' : _data$model3,
      _data$makeTranslate2 = data.makeTranslate,
      makeTranslate = _data$makeTranslate2 === undefined ? make : _data$makeTranslate2,
      _data$modelTranslate2 = data.modelTranslate,
      modelTranslate = _data$modelTranslate2 === undefined ? model : _data$modelTranslate2,
      selectedTransport = data.transport,
      rubricTitle = data.rubric,
      partTypeRu = data.partType,
      partTypeUk = data.partTypeUk;

  var cityHeader = locationRu && __WEBPACK_IMPORTED_MODULE_0_shared_modules_subjectiveText_allText__["g" /* sity */][locationRu] ? locationRu : 'Украина';
  var location = locationRu && t(locationRu);

  var seoData = __WEBPACK_IMPORTED_MODULE_1_shared_helpers_seoTextFinder__["a" /* getSeoDataByParams */](data, t, 'zapchasti');
  if (seoData && seoData.title) {
    return seoData.title;
  }

  var inGenitiveCityHeader = __WEBPACK_IMPORTED_MODULE_4_shared_modules__["c" /* buildInGenitiveCityHeader */](__WEBPACK_IMPORTED_MODULE_0_shared_modules_subjectiveText_allText__["g" /* sity */][cityHeader][locale].genitive);

  var transport = __WEBPACK_IMPORTED_MODULE_4_shared_modules__["o" /* replaceTransport */](selectedTransport);

  var rubric = rubricTitle;
  var partType = partTypeRu;

  if (locale === 'uk' && partTypeUk) partType = partTypeUk;

  if (!location && !rubric && !partType && !rubricSlug) {
    if (make && !model && !location) {
      return t('Запчасти для {make} – Купить запчасти на {transport} в Украине - АвтоБазар', {
        make: make,
        transport: transport
      });
    }
    if (make && model) {
      return t('Запчасти для {make} {model} ({makeTranslate} {modelTranslate}) купить в Украине - АвтоБазар', {
        make: make,
        makeTranslate: makeTranslate,
        model: model,
        modelTranslate: modelTranslate
      });
    }
  }
  if (location && !rubric && !partType && !rubricSlug) {
    if (!make && !model) {
      return t('Запчасти на {transport} {location} – купить по лучшей цене на АвтоБазар™', {
        transport: transport,
        location: location
      });
    }
    if (make && !model) {
      return t('Запчасти на {transport} {make} ({makeTranslate}) {location} - лучшие цены на АвтоБазар™', {
        make: make,
        transport: transport,
        location: location,
        makeTranslate: makeTranslate
      });
    }
    if (make && model) {
      return t('Запчасти для {make} {model} ({makeTranslate} {modelTranslate}) купить {inGenitiveCityHeader} – АвтоБазар™', {
        make: make,
        makeTranslate: makeTranslate,
        model: model,
        modelTranslate: modelTranslate,
        inGenitiveCityHeader: inGenitiveCityHeader
      });
    }
  }

  if (__WEBPACK_IMPORTED_MODULE_2_shared_constants_json_firstSeoRubricsTypes_json___default.a.includes(rubricSlug) && rubric && __WEBPACK_IMPORTED_MODULE_0_shared_modules_subjectiveText_allText__["f" /* rubrics */][rubric]) {
    rubric = rubric && __WEBPACK_IMPORTED_MODULE_0_shared_modules_subjectiveText_allText__["f" /* rubrics */][rubric][locale].accusative;
  } else if (__WEBPACK_IMPORTED_MODULE_3_shared_constants_json_secondSeoRubricsTypes_json___default.a.includes(rubricSlug) && rubric && __WEBPACK_IMPORTED_MODULE_0_shared_modules_subjectiveText_allText__["f" /* rubrics */][rubric]) {
    rubric = rubric && __WEBPACK_IMPORTED_MODULE_0_shared_modules_subjectiveText_allText__["f" /* rubrics */][rubric][locale].nominative;
  }

  /* ______________________FIRST TYPE VS RUBRIC_______________________ */

  if (!location && rubricSlug && rubric && !partType && __WEBPACK_IMPORTED_MODULE_2_shared_constants_json_firstSeoRubricsTypes_json___default.a.includes(rubricSlug)) {
    if (make && !model) {
      return t('Запчасти {rubric} на {transport} {make} ({makeTranslate}) купить по лучшей цене - АвтоБазар™', {
        rubric: rubric,
        make: make,
        makeTranslate: makeTranslate,
        transport: transport
      });
    }
    if (make && model) {
      return t('Запчасти {rubric} {make} {model} ({makeTranslate} {modelTranslate}) купить по лучшей цене - АвтоБазар™', {
        rubric: rubric,
        make: make,
        model: model,
        makeTranslate: makeTranslate,
        modelTranslate: modelTranslate
      });
    }

    return t('Запчасти {rubric} на {transport} – купить по лучшей цене - АвтоБазар™', {
      rubric: rubric,
      transport: transport
    });
  }

  if (location && rubricSlug && rubric && !partType && __WEBPACK_IMPORTED_MODULE_2_shared_constants_json_firstSeoRubricsTypes_json___default.a.includes(rubricSlug)) {
    if (make && !model) {
      return t('Запчасти {rubric} на {transport} {make} ({makeTranslate}) купить {inGenitiveCityHeader} – АвтоБазар™', {
        rubric: rubric,
        make: make,
        makeTranslate: makeTranslate,
        transport: transport,
        inGenitiveCityHeader: inGenitiveCityHeader
      });
    }
    if (make && model) {
      return t('Запчасти {rubric} {make} {model} ({makeTranslate} {modelTranslate}) купить {inGenitiveCityHeader} – АвтоБазар™', {
        rubric: rubric,
        make: make,
        model: model,
        makeTranslate: makeTranslate,
        modelTranslate: modelTranslate,
        inGenitiveCityHeader: inGenitiveCityHeader
      });
    }

    return t('Запчасти {rubric} на {transport} {location} – купить по лучшей цене - АвтоБазар™', {
      rubric: rubric,
      transport: transport,
      location: location
    });
  }

  /* ______________________FIRST TYPE VS RUBRIC && PART_TYPE_______________________ */

  if (!location && rubricSlug && rubric && partType && __WEBPACK_IMPORTED_MODULE_2_shared_constants_json_firstSeoRubricsTypes_json___default.a.includes(rubricSlug)) {
    partType = __WEBPACK_IMPORTED_MODULE_4_shared_modules__["n" /* replaceToUpperCase */](partType);
    if (make && !model) {
      return t('{partType} на {transport} {make} ({makeTranslate}) купить в Украине – АвтоБазар™', {
        partType: partType,
        transport: transport,
        make: make,
        makeTranslate: makeTranslate
      });
    }
    if (make && model) {
      return t('{partType} на {make} {model} ({makeTranslate} {modelTranslate}) купить в Украине – АвтоБазар™', {
        partType: partType,
        make: make,
        model: model,
        makeTranslate: makeTranslate,
        modelTranslate: modelTranslate
      });
    }

    return t('{partType} на {transport} – купить в Украине – АвтоБазар™', {
      partType: partType,
      transport: transport
    });
  }

  if (location && rubricSlug && rubric && partType && __WEBPACK_IMPORTED_MODULE_2_shared_constants_json_firstSeoRubricsTypes_json___default.a.includes(rubricSlug)) {
    partType = __WEBPACK_IMPORTED_MODULE_4_shared_modules__["n" /* replaceToUpperCase */](partType);

    if (make && !model) {
      return t('{partType} на {make} ({makeTranslate}) купить {inGenitiveCityHeader} – АвтоБазар™', {
        partType: partType,
        make: make,
        makeTranslate: makeTranslate,
        inGenitiveCityHeader: inGenitiveCityHeader
      });
    }
    if (make && model) {
      return t('{partType} {make} {model} ({makeTranslate} {modelTranslate}) купить {inGenitiveCityHeader} – АвтоБазар™', {
        partType: partType,
        make: make,
        model: model,
        makeTranslate: makeTranslate,
        modelTranslate: modelTranslate,
        inGenitiveCityHeader: inGenitiveCityHeader
      });
    }

    return t('{partType} на {transport} – купить {inGenitiveCityHeader} – АвтоБазар™', {
      partType: partType,
      transport: transport,
      inGenitiveCityHeader: inGenitiveCityHeader
    });
  }

  /* ______________________SECOND TYPE VS RUBRIC_______________________ */

  if (!location && rubricSlug && rubric && !partType && __WEBPACK_IMPORTED_MODULE_3_shared_constants_json_secondSeoRubricsTypes_json___default.a.includes(rubricSlug)) {
    if (make && !model) {
      return t('{rubric} на {transport} {make} ({makeTranslate}) купить запчасти - АвтоБазар™', {
        rubric: rubric,
        make: make,
        makeTranslate: makeTranslate,
        transport: transport
      });
    }
    if (make && model) {
      return t('{rubric} на {make} {model} ({makeTranslate} {modelTranslate}) купить на АвтоБазар™', {
        rubric: rubric,
        make: make,
        model: model,
        makeTranslate: makeTranslate,
        modelTranslate: modelTranslate
      });
    }

    return t('{rubric} на {transport} – купить запчастини - АвтоБазар™', {
      rubric: rubric,
      transport: transport
    });
  }

  if (location && rubricSlug && rubric && !partType && __WEBPACK_IMPORTED_MODULE_3_shared_constants_json_secondSeoRubricsTypes_json___default.a.includes(rubricSlug)) {
    if (make && !model) {
      return t('{rubric} на {transport} {make} - купить {location} – АвтоБазар™', {
        rubric: rubric,
        make: make,
        transport: transport,
        location: location
      });
    }
    if (make && model) {
      return t('{rubric} {make} {model} – купить запчасти на {transport} {location} – АвтоБазар™', {
        rubric: rubric,
        make: make,
        model: model,
        transport: transport,
        location: location
      });
    }

    return t('{rubric} на {transport} купить {location} – АвтоБазар™', {
      rubric: rubric,
      transport: transport,
      location: location
    });
  }

  /* ______________________SECOND TYPE VS RUBRIC && PART_TYPE_______________________ */

  if (!location && rubricSlug && rubric && partType && __WEBPACK_IMPORTED_MODULE_3_shared_constants_json_secondSeoRubricsTypes_json___default.a.includes(rubricSlug)) {
    partType = __WEBPACK_IMPORTED_MODULE_4_shared_modules__["n" /* replaceToUpperCase */](partType);
    if (make && !model) {
      return t('{partType} на {transport} {make} ({makeTranslate}) купить – АвтоБазар™', {
        partType: partType,
        transport: transport,
        make: make,
        makeTranslate: makeTranslate
      });
    }
    if (make && model) {
      return t('{partType} {make} {model} ({makeTranslate} {modelTranslate}) купить в Украине – АвтоБазар™', {
        partType: partType,
        make: make,
        model: model,
        makeTranslate: makeTranslate,
        modelTranslate: modelTranslate
      });
    }

    return t('{partType} на {transport} купить в Украине – АвтоБазар™', {
      partType: partType,
      transport: transport
    });
  }

  if (location && rubricSlug && rubric && partType && __WEBPACK_IMPORTED_MODULE_3_shared_constants_json_secondSeoRubricsTypes_json___default.a.includes(rubricSlug)) {
    partType = __WEBPACK_IMPORTED_MODULE_4_shared_modules__["n" /* replaceToUpperCase */](partType);

    if (make && !model) {
      return t('{partType} на {transport} {make} ({makeTranslate}) купить {location} – АвтоБазар™', {
        partType: partType,
        make: make,
        makeTranslate: makeTranslate,
        location: location,
        transport: transport
      });
    }
    if (make && model) {
      return t('{partType} на {make} {model} ({makeTranslate} {modelTranslate}) купить {location} – АвтоБазар™', {
        partType: partType,
        make: make,
        model: model,
        makeTranslate: makeTranslate,
        modelTranslate: modelTranslate,
        location: location
      });
    }

    return t('{partType} на {transport} – купить {location} – АвтоБазар™', {
      partType: partType,
      transport: transport,
      location: location
    });
  }

  return t('Запчасти на {transport} купить в Украине – АвтоБазар™', {
    transport: transport
  });
};

var buildFirmPageSeoTitle = function buildFirmPageSeoTitle(title, tab, t) {
  var car_drive_countries = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
  var tags = arguments[4];

  if (tab === 'blog') {
    return t('{title} – Новости и акции компании на сайте Автобазар™', {
      title: title
    });
  }

  var countries = car_drive_countries.map(function (item) {
    return item.title;
  }).join(', ');

  if (car_drive_countries.length > 0) {
    return t('Компания {title} по пригону авто из {countries} - Автобазар', {
      title: title,
      countries: countries
    });
  }

  if (Array.isArray(tags)) {
    for (var i = 0; i < tags.length; i++) {
      if (tags[i].slug && tags[i].slug === 'sto') {
        return t('СТО {title}. Адрес, телефоны, график работы - Автобазар', {
          title: title
        });
      }

      if (tags[i].slug && tags[i].slug === 'avtorazborka') {
        return t('Авторазборка {title}. Адрес, телефоны, график работы - Автобазар', {
          title: title
        });
      }

      if (tags[i].slug && tags[i].slug === 'avtovykup') {
        return t('{title}. Адрес, телефон, график работы компании - Автобазар', {
          title: title
        });
      }

      if (tags[i].slug && tags[i].slug === 'avtotovary') {
        return t('Дистрибьютер автотоваров {title}. Адрес, телефон, график работы компании - Автобазар', {
          title: title
        });
      }

      if (tags[i].slug && tags[i].slug === 'teritorialni-servisni-centri') {
        return t('{title}. Адрес, телефон сервисного центра - Автобазар', {
          title: title
        });
      }
    }
  }

  return t('METATEGS_TITLE_FIRM_ZAPCHASTI', { title: title });
};

var buildSearchMotoSeoTitle = function buildSearchMotoSeoTitle(data, t) {
  var seoData = __WEBPACK_IMPORTED_MODULE_1_shared_helpers_seoTextFinder__["a" /* getSeoDataByParams */](data, t);
  if (seoData && seoData.title) {
    return seoData.title;
  }

  var _data$category = data.category,
      category = _data$category === undefined ? '' : _data$category,
      _data$type = data.type,
      type = _data$type === undefined ? '' : _data$type,
      _data$make4 = data.make,
      make = _data$make4 === undefined ? '' : _data$make4,
      _data$model4 = data.model,
      model = _data$model4 === undefined ? '' : _data$model4,
      locationWhere = data.locationWhere,
      motoTitle = data.motoTitle,
      yearTitle = data.yearTitle;

  return [t('Купить'), motoTitle || category || type ? (motoTitle || (type && type.title ? type.title.toLowerCase() : '')) + ' ' + (category && category.title ? category.title.toLowerCase() : '') + ' ' : t('мототехнику'), make && make.title, model && model.title, '' + (yearTitle || '') + (locationWhere || t('в Украине')) + ':', t('б/у и новая мототехника на АвтоБазар™')].filter(function (i) {
    return !!i;
  }).join(' ');
};

var buildSearchCommercialSeoTitle = function buildSearchCommercialSeoTitle(params, t) {
  var data = params;

  var seoData = __WEBPACK_IMPORTED_MODULE_1_shared_helpers_seoTextFinder__["a" /* getSeoDataByParams */](data, t, 'commercial');
  if (seoData && seoData.title) {
    return seoData.title;
  }

  var isUkraine = ['Україні', 'Украине'].includes(data.cityTitle);
  if (!isUkraine) {
    data.cityTitle = t('в') + ' ' + t(data.cityTitle);
  } else data.cityTitle = '\u0432 ' + t('Украине');

  var transportTitle = data.transportTitle,
      transportNextTitle = data.transportNextTitle,
      make = data.make,
      model = data.model,
      isNew = data.isNew,
      transportType = data.transportType,
      transportCategoryTitle = data.transportCategoryTitle;


  if (transportType === 'avtobus' && transportCategoryTitle) {
    return t('Автобусы {transportCategoryTitle} б/у {cityTitle} купить на АвтоБазар™', data);
  }
  if (transportType === 'moto' && transportCategoryTitle) {
    return t('Мототехника б/у {cityTitle} купить на АвтоБазар™', data);
  }
  if (transportType === 'pritsepy' && transportCategoryTitle) {
    return t('{transportCategoryTitle} б/у и новые купить {cityTitle} на АвтоБазар™', data);
  }
  if (transportType === 'spetstehnika' && transportCategoryTitle) {
    return t('{transportCategoryTitle} - купить б/у и новую спецтехнику {cityTitle} на АвтоБазар™', data);
  }
  if (transportType === 'vodnyi-transport' && transportCategoryTitle) {
    return t('{transportCategoryTitle} - купить водный транспорт б/у и новый {cityTitle} на АвтоБазар™', data);
  }
  if (transportTitle && make && model && isNew) {
    return t('Новый {make} {model} {yearTitle}купить {cityTitle}: {makeTranslit} {modelTranslit} на Автобазаре', _extends({}, data, {
      transportTitle: __WEBPACK_IMPORTED_MODULE_4_shared_modules__["m" /* replaceToLowerCase */](transportTitle),
      transportNextTitle: __WEBPACK_IMPORTED_MODULE_4_shared_modules__["m" /* replaceToLowerCase */](transportNextTitle)
    }));
  }

  if (transportTitle && make && !model && isNew) {
    if (transportType === 'gruzovye') {
      return t('Купить новую {transportTitle} {make} {yearTitle}{cityTitle}: {transportNextTitle} {makeTranslit} на Автобазаре', _extends({}, data, {
        transportTitle: __WEBPACK_IMPORTED_MODULE_4_shared_modules__["m" /* replaceToLowerCase */](transportTitle),
        transportNextTitle: __WEBPACK_IMPORTED_MODULE_4_shared_modules__["m" /* replaceToLowerCase */](transportNextTitle)
      }));
    }
    if (transportType === 'spetstehnika') {
      return t('Купить новую {transportTitle} {make} {yearTitle}{cityTitle}: {transportNextTitle} {makeTranslit} на Автобазаре', _extends({}, data, {
        transportTitle: __WEBPACK_IMPORTED_MODULE_4_shared_modules__["m" /* replaceToLowerCase */](transportTitle),
        transportNextTitle: __WEBPACK_IMPORTED_MODULE_4_shared_modules__["m" /* replaceToLowerCase */](transportNextTitle)
      }));
    }
    return t('Купить новый {transportTitle} {make} {yearTitle}{cityTitle}: {transportNextTitle} {makeTranslit} на Автобазаре', _extends({}, data, {
      transportTitle: __WEBPACK_IMPORTED_MODULE_4_shared_modules__["m" /* replaceToLowerCase */](transportTitle),
      transportNextTitle: __WEBPACK_IMPORTED_MODULE_4_shared_modules__["m" /* replaceToLowerCase */](transportNextTitle)
    }));
  }
  if (transportTitle && make && model && !isNew) {
    return t('{make} {model} {yearTitle}купить {cityTitle}: б/у и новые {makeTranslit} {modelTranslit} на Автобазаре', data);
  }
  if (transportTitle && make && !model && !isNew) {
    if (transportType === 'spetstehnika') {
      return t('Купить {transportTitle} {make} {yearTitle}{cityTitle}: б/у и новый {reductionTranslit} {makeTranslit} на Автобазаре', _extends({}, data, {
        transportTitle: __WEBPACK_IMPORTED_MODULE_4_shared_modules__["m" /* replaceToLowerCase */](transportTitle),
        transportNextTitle: __WEBPACK_IMPORTED_MODULE_4_shared_modules__["m" /* replaceToLowerCase */](transportNextTitle)
      }));
    }
    if (transportType === 'avtobus') {
      return t('Автобусы {make} {makeTranslit} б/у {yearTitle}{cityTitle} купить на АвтоБазар™',
      // 'Купить новый {transportTitle} {yearTitle}{cityTitle}: {reductionTranslit} на Автобазаре',
      _extends({}, data, {
        transportTitle: __WEBPACK_IMPORTED_MODULE_4_shared_modules__["m" /* replaceToLowerCase */](transportTitle),
        transportNextTitle: __WEBPACK_IMPORTED_MODULE_4_shared_modules__["m" /* replaceToLowerCase */](transportNextTitle)
      }));
    }
    return t('Купить {transportTitle} {make} {yearTitle}{cityTitle}: б/у и новые {transportNextTitle} {makeTranslit} на Автобазаре', _extends({}, data, {
      transportTitle: __WEBPACK_IMPORTED_MODULE_4_shared_modules__["m" /* replaceToLowerCase */](transportTitle),
      transportNextTitle: __WEBPACK_IMPORTED_MODULE_4_shared_modules__["m" /* replaceToLowerCase */](transportNextTitle)
    }));
  }
  if (transportTitle && !make && !model && isNew) {
    if (transportType === 'gruzovye') {
      return t('Купить новый {transportTitle} {yearTitle}{cityTitle}: {transportNextTitle} авто на Автобазаре', _extends({}, data, {
        transportTitle: __WEBPACK_IMPORTED_MODULE_4_shared_modules__["m" /* replaceToLowerCase */](transportTitle),
        transportNextTitle: __WEBPACK_IMPORTED_MODULE_4_shared_modules__["m" /* replaceToLowerCase */](transportNextTitle)
      }));
    }
    if (transportType === 'avtobus') {
      return t('Купить новый {transportTitle} {yearTitle}{cityTitle}: {reductionTranslit} на Автобазаре', _extends({}, data, {
        transportTitle: __WEBPACK_IMPORTED_MODULE_4_shared_modules__["m" /* replaceToLowerCase */](transportTitle),
        transportNextTitle: __WEBPACK_IMPORTED_MODULE_4_shared_modules__["m" /* replaceToLowerCase */](transportNextTitle)
      }));
    }
    if (transportType === 'spetstehnika') {
      return t('Купить новую {transportTitle} {yearTitle}{cityTitle}: {transportNextTitle} на Автобазаре', _extends({}, data, {
        transportTitle: __WEBPACK_IMPORTED_MODULE_4_shared_modules__["m" /* replaceToLowerCase */](transportTitle),
        transportNextTitle: __WEBPACK_IMPORTED_MODULE_4_shared_modules__["m" /* replaceToLowerCase */](transportNextTitle)
      }));
    }
    return t('Купить новый {transportTitle} {yearTitle}{cityTitle}: {transportNextTitle} на Автобазаре', _extends({}, data, {
      transportTitle: __WEBPACK_IMPORTED_MODULE_4_shared_modules__["m" /* replaceToLowerCase */](transportTitle),
      transportNextTitle: __WEBPACK_IMPORTED_MODULE_4_shared_modules__["m" /* replaceToLowerCase */](transportNextTitle)
    }));
  }
  if (transportTitle && !make && !model && !isNew) {
    if (transportTitle === t('коммерческий транспорт')) {
      return t('Купить {transportTitle} {yearTitle}{cityTitle}: б/у и новая техника на Автобазар™', _extends({}, data, {
        transportTitle: __WEBPACK_IMPORTED_MODULE_4_shared_modules__["m" /* replaceToLowerCase */](transportTitle)
      }));
    }
    if (transportType === 'gruzovye') {
      return t('Купить {transportTitle} {yearTitle}{cityTitle}: б/у и новые {transportNextTitle} авто на Автобазаре', _extends({}, data, {
        transportTitle: __WEBPACK_IMPORTED_MODULE_4_shared_modules__["m" /* replaceToLowerCase */](transportTitle),
        transportNextTitle: __WEBPACK_IMPORTED_MODULE_4_shared_modules__["m" /* replaceToLowerCase */](transportNextTitle)
      }));
    }
    if (transportType === 'avtobus') {
      return t('Купить {transportTitle} {yearTitle}{cityTitle}: б/у и новый {reductionTranslit} на Автобазаре', _extends({}, data, {
        transportTitle: __WEBPACK_IMPORTED_MODULE_4_shared_modules__["m" /* replaceToLowerCase */](transportTitle),
        transportNextTitle: __WEBPACK_IMPORTED_MODULE_4_shared_modules__["m" /* replaceToLowerCase */](transportNextTitle)
      }));
    }
    if (transportType === 'spetstehnika') {
      return t('Купить {transportTitle} {yearTitle}{cityTitle}: б/у и новая {transportNextTitle} на Автобазаре', _extends({}, data, {
        transportTitle: __WEBPACK_IMPORTED_MODULE_4_shared_modules__["m" /* replaceToLowerCase */](transportTitle),
        transportNextTitle: __WEBPACK_IMPORTED_MODULE_4_shared_modules__["m" /* replaceToLowerCase */](transportNextTitle)
      }));
    }
    return t('Купить {transportTitle} {yearTitle}{cityTitle}: б/у и новые {transportNextTitle} авто на Автобазаре', _extends({}, data, {
      transportTitle: __WEBPACK_IMPORTED_MODULE_4_shared_modules__["m" /* replaceToLowerCase */](transportTitle),
      transportNextTitle: __WEBPACK_IMPORTED_MODULE_4_shared_modules__["m" /* replaceToLowerCase */](transportNextTitle)
    }));
  }
  return t('Купить {cityTitle}: б/у и новые авто на Автобазаре');
};
// CONCATENATED MODULE: ./src/shared/constants/seoTitles.js
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_shared_helpers_seoTextFinder_seoDataFinder__ = __webpack_require__(1252);
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }




var getLocationString = function getLocationString(location, t) {
  return location && location.title ? t('в ') + ' ' + location.title : t('в Украине');
};

var buildAddTitleByTransportSlug = function buildAddTitleByTransportSlug(slug, t) {
  var transportTitle = 'авто';
  var transportSecondTitle = 'автомобиля';
  switch (slug) {
    case 'avto':
      {
        transportTitle = 'авто';
        transportSecondTitle = 'автомобиля';
        break;
      }
    case 'moto':
      {
        transportTitle = 'мототехнику';
        transportSecondTitle = 'мототехники';
        break;
      }
    case 'avtobus':
      {
        transportTitle = 'автобус';
        transportSecondTitle = 'автобуса';
        break;
      }
    case 'gruzovye':
      {
        transportTitle = 'грузовое авто';
        transportSecondTitle = 'грузового автомобиля';
        break;
      }
    case 'spetstehnika':
      {
        transportTitle = 'спецтехнику';
        transportSecondTitle = 'спецтехники';
        break;
      }
    case 'pritsepy':
      {
        transportTitle = 'прицеп';
        transportSecondTitle = 'прицепа';
        break;
      }
    case 'vodnyi-transport':
      {
        transportTitle = 'водный транспорт';
        transportSecondTitle = 'водного транспорта';
        break;
      }
    case 'zapchasti':
      {
        transportTitle = 'запчасти';
        transportSecondTitle = 'автозапчастей';
        break;
      }

    default:
      {
        break;
      }
  }

  return t('Продать') + ' ' + t(transportTitle).toLowerCase() + ' \u043D\u0430 \u0410\u0432\u0442\u043E\u0411\u0430\u0437\u0430\u0440\u2122 - ' + t('подать объявление о продаже') + ' ' + t(transportSecondTitle).toLowerCase() + ' \u043D\u0430 avtobazar.ua';
};

var TITLE = {
  HOME: function HOME(props, t) {
    return t('SEO_HOME_TITLE');
  },

  ADVERT: function ADVERT(_ref) {
    var id = _ref.id,
        make = _ref.make,
        model = _ref.model,
        modification = _ref.modification,
        year = _ref.year,
        price = _ref.price,
        mileage = _ref.mileage,
        location = _ref.location,
        _ref$isNew = _ref.isNew,
        isNew = _ref$isNew === undefined ? false : _ref$isNew,
        _ref$dealer = _ref.dealer,
        dealer = _ref$dealer === undefined ? false : _ref$dealer;
    var transportTitle = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    var t = arguments[2];

    var _ref2 = __WEBPACK_IMPORTED_MODULE_1_shared_helpers_seoTextFinder_seoDataFinder__["a" /* getCustomParams */]({ city: location.title }, t) || '',
        inCity = _ref2.inCity;

    var transportTitles = ['Мотоцикл', 'Скутер', 'Квадроцикл', 'Мопед', 'Баггі', 'Багги', 'Трицикл', 'Грузовые', 'Автобусы', 'Прицепы', 'Водный транспорт', 'Спецтехника'];

    if (transportTitles.includes(transportTitle)) {
      return [t('Купить'), t(transportTitle), make && make.title, model && model.title, modification && modification.title, year, '\u0432 ' + t(location.title), dealer && dealer.title && t('в автосалоне') + ' ' + dealer.title, mileage && t('с пробегом') + ' ' + t(mileage).slice(0, -7) + ' ' + (t('с пробегом') === 'с пробегом' ? 'тыс км' : 'тис км'), price && t('цена') + ' ' + price, t('на Автобазаре'), isNew && ' - ' + t('Новый').toLowerCase(), id && '(' + id + ')'].filter(function (i) {
        return !!i;
      }).join(' ');
    }

    return [t('Купить'), !isNew && transportTitle,
    /* transportNextTitle, */
    make && make.title, model && model.title, modification && modification.title, year, inCity, isNew && dealer && dealer.title && t('в автосалоне') + ' ' + dealer.title, mileage && t('с пробегом') + ' ' + t(mileage).slice(0, -7) + ' ' + t('тыс км'), price && t('цена') + ' ' + price, id && '(' + id + ')', t('- Автобазар')].filter(function (i) {
      return !!i;
    }).join(' ');
  },
  // ...

  SPARE_ADVERT: function SPARE_ADVERT(_ref3, t) {
    var id = _ref3.id,
        rubric = _ref3.rubric,
        sparetype = _ref3.sparetype,
        type = _ref3.type,
        make = _ref3.make,
        model = _ref3.model,
        price = _ref3.price,
        location = _ref3.location;
    return [t('Купить'), rubric && rubric.title, sparetype && (sparetype.title || '').toLowerCase(), (type || make || model) && t('на'), type && (type.title || '').toLowerCase(), make && make.title, model && model.title, getLocationString(location, t), price && t('цена') + ' ' + price, t('на Автобазаре'), id && '- ' + id].filter(function (i) {
      return !!i;
    }).join(' ');
  },
  //

  SEARCH: {
    avto: function avto(data, t) {
      return buildSearchAvtoSeoTitle(data, t);
    },
    moto: function moto(data, t) {
      return buildSearchMotoSeoTitle(data, t);
    },
    mototsikl: function mototsikl(_ref4, t) {
      var _ref4$make = _ref4.make,
          make = _ref4$make === undefined ? '' : _ref4$make,
          _ref4$model = _ref4.model,
          model = _ref4$model === undefined ? '' : _ref4$model,
          category = _ref4.category,
          type = _ref4.type,
          location = _ref4.location,
          motoTitle = _ref4.motoTitle,
          yearTitle = _ref4.yearTitle;
      return [t('Купить')].concat(_toConsumableArray(make ? [motoTitle || t('мотоцикл'), make && make.title, model && model.title] : ['' + (type && type.title ? type.title.toLowerCase() : '')]), [category && category.title ? category.title.toLowerCase() : '', '' + yearTitle + (location || t('в Украине')) + ':', t('б/у и новая мототехника на АвтоБазар™')]).filter(function (i) {
        return !!i;
      }).join(' ');
    },
    commercial: function commercial(params, t) {
      return buildSearchCommercialSeoTitle(params, t);
    }
  },
  //

  SPARE_PARTS: function SPARE_PARTS(data, rubricSlug, t) {
    return buildSparePartsSeoTitles(data, rubricSlug, t);
  },

  FIRM: function FIRM(data, t) {
    return buildFirmsSeoTitle(data, t);
  },

  FIRM_PAGE: function FIRM_PAGE(title, tab, t, car_drive_countries, tags) {
    return buildFirmPageSeoTitle(title, tab, t, car_drive_countries, tags);
  },

  //

  DEALERS: function DEALERS(data, slug, t) {
    return buildDealersSeoTitle(data, slug, t);
  },

  DEALER_PAGE: {
    ADVERTS: function ADVERTS() {
      var dealer = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var t = arguments[1];
      return dealer + ' - ' + t('все предложения автосалона с ценами и фото на сайте Автобазар');
    },

    NEWS: function NEWS() {
      var dealer = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var t = arguments[1];
      return t('Новости и акции автосалона') + ' ' + dealer + ' ' + t('на сайте Автобазар');
    },

    ABOUT: function ABOUT() {
      var dealer = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var t = arguments[1];
      return t('Информация об автосалоне') + ' ' + dealer + ': ' + t('все о компании на АвтоБазаре');
    },

    CONTACT: function CONTACT() {
      var dealer = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var t = arguments[1];
      return t('Контакты автосалона') + ' ' + dealer + ': ' + t('адреса, контактный номер телефона, официальный сайт');
    }
  },

  //

  INVOICE: function INVOICE(t) {
    return t('Квитанция за оплату');
  },

  //

  JOURNAL: {
    ALL: function ALL(t) {
      return t('Все новости и статьи на Автобазар');
    },
    NEWS: function NEWS(t, rubric) {
      return t('Все') + ' ' + t(rubric || 'Новости').toLowerCase() + ' ' + t('на Автобазаре');
    }
  },

  //

  SERVICE: {
    CAR_COST_ESTIMATE: function CAR_COST_ESTIMATE(t) {
      return t('Оценка стоимости авто') + ' ' + t('на Автобазаре');
    },
    CAR_DRIVE: function CAR_DRIVE(t) {
      return t('Пригон авто') + ' ' + t('на Автобазаре');
    },
    SEARCH_SUBSCRIPTIONS: function SEARCH_SUBSCRIPTIONS(t) {
      return t('Подписка на поиск') + ' ' + t('на Автобазаре');
    }
  },

  //

  LOGIN: function LOGIN(t) {
    return t('Войти в Автобазар');
  },

  //

  NOT_FOUND: function NOT_FOUND(t) {
    return t('Страница не найдена');
  },

  //

  ADVERT_FORM: {
    ADD: function ADD(slug, t) {
      return buildAddTitleByTransportSlug(slug, t);
    },
    EDIT: function EDIT(t) {
      return t('Редактировать объявление');
    }
  },

  //

  PROFILE: {
    PROFILE: function PROFILE(t) {
      return t('Мой профиль');
    },
    DIALOGS: function DIALOGS(t) {
      return t('Мои сообщения');
    },
    FAVORITES: function FAVORITES(t) {
      return t('Мои избранные');
    },
    BILLING: function BILLING(t) {
      return t('Мой баланс');
    },
    SEARCHES: function SEARCHES(t) {
      return t('Мои поиски');
    },
    ADVERTS: function ADVERTS(t) {
      return t('Мои объявления');
    },
    INSURANCE: function INSURANCE(t) {
      return t('Страховка');
    },
    SEARCH_SUBSCRIPTIONS: function SEARCH_SUBSCRIPTIONS(t) {
      return t('Подписка на поиск');
    }
  },

  //

  MOBILE_FORM: {
    GEO: function GEO(t) {
      return t('Выбор местоположения');
    },
    FILTERS: function FILTERS(t) {
      return t('Выбор по параметрам');
    }
  },

  STATIC_PAGE: {
    LAW: function LAW(t) {
      return t('Справка Автобазар:') + ' ' + t('Политика конфиденциальности');
    },
    INFO_ZAPCHASTI: function INFO_ZAPCHASTI(t) {
      return t('Справка Автобазар:') + ' ' + t('Запчасти');
    },
    HELP: function HELP(t) {
      return t('Справка Автобазар:') + ' ' + t('Помощь');
    },
    FOR_SERVICES: function FOR_SERVICES(t) {
      return t('Справка Автобазар:') + ' ' + t('Автосервисам');
    },
    FOR_PRIVATES: function FOR_PRIVATES(t) {
      return t('Справка Автобазар:') + ' ' + t('Размещение объявлений');
    },
    FOR_DEALERS: function FOR_DEALERS(t) {
      return t('Справка Автобазар:') + ' ' + t('Пакет “Бизнес Плюс”');
    },
    BIZNES_PAKET: function BIZNES_PAKET(t) {
      return t('Справка Автобазар:') + ' ' + t('Пакет “Бизнес”');
    },
    ADVERTISING: function ADVERTISING(t) {
      return t('Справка Автобазар:') + ' ' + t('Разместить рекламу');
    },
    ABOUT: function ABOUT(t) {
      return t('Справка Автобазар:') + ' ' + t('Что такое автобазар');
    },
    FAQ: function FAQ(t) {
      return t('Справка Автобазар:') + ' ' + t('Часто задаваемые вопросы');
    },
    ENTRANCE: function ENTRANCE(t) {
      return t('Справка Автобазар:') + ' ' + t('Регистрация на avtobazar.ua');
    },
    TRANSPORT_ADS_RULES: function TRANSPORT_ADS_RULES(t) {
      return t('Справка Автобазар:') + ' ' + t('Правила составления объявлений');
    },
    PUBLIC_CONTRACT: function PUBLIC_CONTRACT(t) {
      return t('Справка Автобазар:') + ' ' + t('Публичный договор');
    }
  }
};

/* harmony default export */ __webpack_exports__["a"] = (TITLE);

/***/ }),

/***/ 1391:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Buffer) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_common__ = __webpack_require__(184);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }


// import PropTypes from 'prop-types';

// import { setRatio } from 'shared/actions/globals';


var setRatioImage = function setRatioImage(image, ratio, width, height) {
  var fit = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 'cover';

  if (!image) {
    return image;
  }

  var aS3Regexp = /^(https:\/\/a[\d].s3.ua)/;
  var cndRegexp = /^(https:\/\/cdn.+(ab|s3).ua)/;
  var awsWithoutIRHRegexp = /^((https:\/\/d2wkv3iadoqiil.cloudfront.net\/)(\w*\/)?(\w*\/)?(.{32})(\..*)?)/;
  var awsWithIRHRegexp = /^((https:\/\/d1672trkrgk4ug.cloudfront.net\/)(.*))/;
  var dimensions = [width, height].map(function (x) {
    return x ? Math.round(x * ratio) : '';
  }).join('x');
  var httpsImage = image.replace('http:', 'https:');

  if (width || height) {
    if (httpsImage.match(cndRegexp)) {
      return httpsImage.replace('/image/', '/unsafe/' + dimensions + '/');
    }

    if (httpsImage.match(aS3Regexp)) {
      return httpsImage.replace(aS3Regexp, '$1/' + dimensions);
    }

    if (httpsImage.match(awsWithoutIRHRegexp)) {
      var groups = httpsImage.match(awsWithoutIRHRegexp);
      var size = 'large';
      if (width) {
        if (width * ratio <= 600) {
          size = 'small';
        } else if (width * ratio <= 900) {
          size = 'medium';
        }
      }

      var root = groups[3] && groups[3] === 'original/' ? '' : groups[3];
      return '' + (groups[2] + (root || '')) + size + '/' + (groups[5] + (groups[6] || ''));
    }

    if (httpsImage.match(awsWithIRHRegexp)) {
      var _groups = httpsImage.match(awsWithIRHRegexp);
      var imageRequest = JSON.stringify({
        key: '' + _groups[3],
        edits: {
          resize: {
            width: width ? Math.round(width * ratio) : null,
            height: height ? Math.round(height * ratio) : null,
            fit: fit
          }
        }
      });

      return '' + _groups[2] + Buffer.from(imageRequest).toString('base64');
    }
  }

  return httpsImage;
};

/*
const mapStateToProps = ({ globals }) => ({ ratio: globals.ratio });
const mapDispatchToProps = { setRatio };
*/
var mapStateToProps = function mapStateToProps() {
  return {};
};
var mapDispatchToProps = {};

// TODO: Commented code can be removed after testing, and be sure this code do not have some side effects.

var withPixelRatio = function withPixelRatio(WrappedComponent) {
  var _class, _temp2;

  return __WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */](mapStateToProps, mapDispatchToProps)((_temp2 = _class = function (_React$Component) {
    _inherits(_class, _React$Component);

    function _class() {
      var _ref;

      var _temp, _this, _ret;

      _classCallCheck(this, _class);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = _class.__proto__ || Object.getPrototypeOf(_class)).call.apply(_ref, [this].concat(args))), _this), _this.setRatioImage = function (image) {
        var width = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 240;
        var height = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
        var fit = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'cover';
        return setRatioImage(image, 1, width, height, fit);
      }, _this.setRatioAlbum = function (images, width, height) {
        return images.map(function (_ref2) {
          var image = _ref2.image,
              rest = _objectWithoutProperties(_ref2, ['image']);

          return _extends({}, rest, {
            image: _this.setRatioImage(image, width, height)
          });
        });
      }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    /*
    static propTypes = {
      // setRatio: PropTypes.func.isRequired,
      ratio: PropTypes.number,
    };
    static defaultProps = {
      ratio: null,
    }; */

    /*
    componentDidMount() {
      if (!this.props.ratio) {
        this.props.setRatio();
      }
    }
    */

    /*
    setRatioImage = (image, width = 240, height = null) =>
      setRatioImage(image, this.props.ratio, width, height);
    */


    _createClass(_class, [{
      key: 'render',
      value: function render() {
        // const { ratio, ...props } = this.props;
        var ratio = 1;

        var props = _objectWithoutProperties(this.props, []);

        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(WrappedComponent, _extends({
          setRatioAlbum: this.setRatioAlbum,
          setRatioImage: this.setRatioImage,
          ratio: ratio
        }, props));
      }
    }]);

    return _class;
  }(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component), _class.displayName = 'withPixelRatio(' + __WEBPACK_IMPORTED_MODULE_2__helpers_common__["e" /* getDisplayName */](WrappedComponent) + ')', _temp2));
};

/* harmony default export */ __webpack_exports__["a"] = (withPixelRatio);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(492).Buffer))

/***/ }),

/***/ 1393:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _assign = __webpack_require__(188);

var ReactCurrentOwner = __webpack_require__(1444);

var warning = __webpack_require__(1401);
var canDefineProperty = __webpack_require__(1443);
var hasOwnProperty = Object.prototype.hasOwnProperty;

var REACT_ELEMENT_TYPE = __webpack_require__(1445);

var RESERVED_PROPS = {
  key: true,
  ref: true,
  __self: true,
  __source: true
};

var specialPropKeyWarningShown, specialPropRefWarningShown;

function hasValidRef(config) {
  if (false) {
    if (hasOwnProperty.call(config, 'ref')) {
      var getter = Object.getOwnPropertyDescriptor(config, 'ref').get;
      if (getter && getter.isReactWarning) {
        return false;
      }
    }
  }
  return config.ref !== undefined;
}

function hasValidKey(config) {
  if (false) {
    if (hasOwnProperty.call(config, 'key')) {
      var getter = Object.getOwnPropertyDescriptor(config, 'key').get;
      if (getter && getter.isReactWarning) {
        return false;
      }
    }
  }
  return config.key !== undefined;
}

function defineKeyPropWarningGetter(props, displayName) {
  var warnAboutAccessingKey = function warnAboutAccessingKey() {
    if (!specialPropKeyWarningShown) {
      specialPropKeyWarningShown = true;
       false ? warning(false, '%s: `key` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
    }
  };
  warnAboutAccessingKey.isReactWarning = true;
  Object.defineProperty(props, 'key', {
    get: warnAboutAccessingKey,
    configurable: true
  });
}

function defineRefPropWarningGetter(props, displayName) {
  var warnAboutAccessingRef = function warnAboutAccessingRef() {
    if (!specialPropRefWarningShown) {
      specialPropRefWarningShown = true;
       false ? warning(false, '%s: `ref` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
    }
  };
  warnAboutAccessingRef.isReactWarning = true;
  Object.defineProperty(props, 'ref', {
    get: warnAboutAccessingRef,
    configurable: true
  });
}

/**
 * Factory method to create a new React element. This no longer adheres to
 * the class pattern, so do not use new to call it. Also, no instanceof check
 * will work. Instead test $$typeof field against Symbol.for('react.element') to check
 * if something is a React Element.
 *
 * @param {*} type
 * @param {*} key
 * @param {string|object} ref
 * @param {*} self A *temporary* helper to detect places where `this` is
 * different from the `owner` when React.createElement is called, so that we
 * can warn. We want to get rid of owner and replace string `ref`s with arrow
 * functions, and as long as `this` and owner are the same, there will be no
 * change in behavior.
 * @param {*} source An annotation object (added by a transpiler or otherwise)
 * indicating filename, line number, and/or other information.
 * @param {*} owner
 * @param {*} props
 * @internal
 */
var ReactElement = function ReactElement(type, key, ref, self, source, owner, props) {
  var element = {
    // This tag allow us to uniquely identify this as a React Element
    $$typeof: REACT_ELEMENT_TYPE,

    // Built-in properties that belong on the element
    type: type,
    key: key,
    ref: ref,
    props: props,

    // Record the component responsible for creating this element.
    _owner: owner
  };

  if (false) {
    // The validation flag is currently mutative. We put it on
    // an external backing store so that we can freeze the whole object.
    // This can be replaced with a WeakMap once they are implemented in
    // commonly used development environments.
    element._store = {};

    // To make comparing ReactElements easier for testing purposes, we make
    // the validation flag non-enumerable (where possible, which should
    // include every environment we run tests in), so the test framework
    // ignores it.
    if (canDefineProperty) {
      Object.defineProperty(element._store, 'validated', {
        configurable: false,
        enumerable: false,
        writable: true,
        value: false
      });
      // self and source are DEV only properties.
      Object.defineProperty(element, '_self', {
        configurable: false,
        enumerable: false,
        writable: false,
        value: self
      });
      // Two elements created in two different places should be considered
      // equal for testing purposes and therefore we hide it from enumeration.
      Object.defineProperty(element, '_source', {
        configurable: false,
        enumerable: false,
        writable: false,
        value: source
      });
    } else {
      element._store.validated = false;
      element._self = self;
      element._source = source;
    }
    if (Object.freeze) {
      Object.freeze(element.props);
      Object.freeze(element);
    }
  }

  return element;
};

/**
 * Create and return a new ReactElement of the given type.
 * See https://facebook.github.io/react/docs/top-level-api.html#react.createelement
 */
ReactElement.createElement = function (type, config, children) {
  var propName;

  // Reserved names are extracted
  var props = {};

  var key = null;
  var ref = null;
  var self = null;
  var source = null;

  if (config != null) {
    if (hasValidRef(config)) {
      ref = config.ref;
    }
    if (hasValidKey(config)) {
      key = '' + config.key;
    }

    self = config.__self === undefined ? null : config.__self;
    source = config.__source === undefined ? null : config.__source;
    // Remaining properties are added to a new props object
    for (propName in config) {
      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
        props[propName] = config[propName];
      }
    }
  }

  // Children can be more than one argument, and those are transferred onto
  // the newly allocated props object.
  var childrenLength = arguments.length - 2;
  if (childrenLength === 1) {
    props.children = children;
  } else if (childrenLength > 1) {
    var childArray = Array(childrenLength);
    for (var i = 0; i < childrenLength; i++) {
      childArray[i] = arguments[i + 2];
    }
    if (false) {
      if (Object.freeze) {
        Object.freeze(childArray);
      }
    }
    props.children = childArray;
  }

  // Resolve default props
  if (type && type.defaultProps) {
    var defaultProps = type.defaultProps;
    for (propName in defaultProps) {
      if (props[propName] === undefined) {
        props[propName] = defaultProps[propName];
      }
    }
  }
  if (false) {
    if (key || ref) {
      if (typeof props.$$typeof === 'undefined' || props.$$typeof !== REACT_ELEMENT_TYPE) {
        var displayName = typeof type === 'function' ? type.displayName || type.name || 'Unknown' : type;
        if (key) {
          defineKeyPropWarningGetter(props, displayName);
        }
        if (ref) {
          defineRefPropWarningGetter(props, displayName);
        }
      }
    }
  }
  return ReactElement(type, key, ref, self, source, ReactCurrentOwner.current, props);
};

/**
 * Return a function that produces ReactElements of a given type.
 * See https://facebook.github.io/react/docs/top-level-api.html#react.createfactory
 */
ReactElement.createFactory = function (type) {
  var factory = ReactElement.createElement.bind(null, type);
  // Expose the type on the factory and the prototype so that it can be
  // easily accessed on elements. E.g. `<Foo />.type === Foo`.
  // This should not be named `constructor` since this may not be the function
  // that created the element, and it may not even be a constructor.
  // Legacy hook TODO: Warn if this is accessed
  factory.type = type;
  return factory;
};

ReactElement.cloneAndReplaceKey = function (oldElement, newKey) {
  var newElement = ReactElement(oldElement.type, newKey, oldElement.ref, oldElement._self, oldElement._source, oldElement._owner, oldElement.props);

  return newElement;
};

/**
 * Clone and return a new ReactElement using element as the starting point.
 * See https://facebook.github.io/react/docs/top-level-api.html#react.cloneelement
 */
ReactElement.cloneElement = function (element, config, children) {
  var propName;

  // Original props are copied
  var props = _assign({}, element.props);

  // Reserved names are extracted
  var key = element.key;
  var ref = element.ref;
  // Self is preserved since the owner is preserved.
  var self = element._self;
  // Source is preserved since cloneElement is unlikely to be targeted by a
  // transpiler, and the original source is probably a better indicator of the
  // true owner.
  var source = element._source;

  // Owner will be preserved, unless ref is overridden
  var owner = element._owner;

  if (config != null) {
    if (hasValidRef(config)) {
      // Silently steal the ref from the parent.
      ref = config.ref;
      owner = ReactCurrentOwner.current;
    }
    if (hasValidKey(config)) {
      key = '' + config.key;
    }

    // Remaining properties override existing props
    var defaultProps;
    if (element.type && element.type.defaultProps) {
      defaultProps = element.type.defaultProps;
    }
    for (propName in config) {
      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
        if (config[propName] === undefined && defaultProps !== undefined) {
          // Resolve default props
          props[propName] = defaultProps[propName];
        } else {
          props[propName] = config[propName];
        }
      }
    }
  }

  // Children can be more than one argument, and those are transferred onto
  // the newly allocated props object.
  var childrenLength = arguments.length - 2;
  if (childrenLength === 1) {
    props.children = children;
  } else if (childrenLength > 1) {
    var childArray = Array(childrenLength);
    for (var i = 0; i < childrenLength; i++) {
      childArray[i] = arguments[i + 2];
    }
    props.children = childArray;
  }

  return ReactElement(element.type, key, ref, self, source, owner, props);
};

/**
 * Verifies the object is a ReactElement.
 * See https://facebook.github.io/react/docs/top-level-api.html#react.isvalidelement
 * @param {?object} object
 * @return {boolean} True if `object` is a valid component.
 * @final
 */
ReactElement.isValidElement = function (object) {
  return (typeof object === 'undefined' ? 'undefined' : _typeof(object)) === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
};

module.exports = ReactElement;

/***/ }),

/***/ 1396:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// CONCATENATED MODULE: ./src/shared/components/FondyFrame/FondyContainer.js
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_intl__ = __webpack_require__(474);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shared_hocs_withFetch__ = __webpack_require__(1244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_shared_selectors_user__ = __webpack_require__(1409);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Loader_Loader__ = __webpack_require__(1249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__FondyContainer_css__ = __webpack_require__(1432);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__FondyContainer_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__FondyContainer_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__mobile_components_Modal_cross_svg__ = __webpack_require__(1399);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__mobile_components_Modal_cross_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__mobile_components_Modal_cross_svg__);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



// import Script from 'react-load-script';










var _ref2 = _jsx('img', {
  alt: '',
  src: __WEBPACK_IMPORTED_MODULE_9__mobile_components_Modal_cross_svg___default.a,
  width: '15'
});

var _ref3 = _jsx(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */], {
  id: '\u041E\u0442\u043C\u0435\u043D\u0438\u0442\u044C'
});

var FondyContainer = function (_React$Component) {
  _inherits(FondyContainer, _React$Component);

  function FondyContainer() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, FondyContainer);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = FondyContainer.__proto__ || Object.getPrototypeOf(FondyContainer)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      isFrameLoading: true
    }, _this.handleCallback = function callback(data, type, self) {
      var form = void 0;
      if (data.error) {
        return;
      }
      if (data.action === 'redirect') {
        this.loadUrl(data.url);
        return;
      }
      if (data.send_data && data.send_data.order_status === 'delayed') {
        this.unbind('ready');
        this.hide();
      } else {
        this.unbind('ready').action('ready', function f() {
          this.show();
        });
      }
      if (data.send_data && data.url) {
        if (typeof self.props.callback === 'function') {
          self.props.fetch(data.url, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Authorization: 'JWT ' + self.props.token
            },
            body: JSON.stringify(_extends({}, data.send_data, { noredirect: 1 }))
          }).then(function (r) {
            return r.json();
          }).then(self.props.callback);
        } else {
          form = window.prepareFormData(data.url, data.send_data);
          this.find('body').appendChild(form);
          form.submit();
          form.parentNode.removeChild(form);
        }

        // action: "submit"
        // checkout_js_data: "{\"token\":\"663d9bd692d7597ce772f6c83fda4f16122336e4\",\"frame\":true}"
        // final: true
        // method: "POST"
        // send_data: {rrn: '021523241340', masked_card: '535838XXXXXX6000', sender_cell_phone: '', sender_account: '', currency: 'UAH', …}
        // target: "_top"
        // token: "663d9bd692d7597ce772f6c83fda4f16122336e4"
        // url: "http://localhost:3000/fondy/handle/?redirectUrl="
        // [[Prototype]]: Object
      }
    }, _this.handleFrameLoad = function () {
      var formUrl = _this.props.frameUrl;
      var self = _this;
      var element = document.getElementById('fondyChekout');
      var retry = 0;
      if (typeof window.$ipsp !== 'undefined' && element !== 'undefined' && element != null) {
        window.fCheckout = window.$ipsp.get('checkout').config({ wrapper: element, styles: _this.props.importantStyles }).scope(function f2() {
          var _this2 = this;

          this.setCheckoutWrapper(element);
          this.addCallback(function (data, type) {
            self.handleCallback.call(_this2, data, type, self);
          });
          this.setModal(false);
          this.action('show', function () {
            self.setState({ isFrameLoading: false });
          });
          this.loadUrl(formUrl);
        });
      } else {
        // Little feature to preevent long loading in mobile
        retry += 1;
        if (retry === 20) {
          self.setState({ isFrameLoading: false });
        }
        setTimeout(function () {
          _this.handleFrameLoad();
        }, 100);
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(FondyContainer, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.handleFrameLoad();
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          title = _props.title,
          closeHandler = _props.closeHandler;
      var isFrameLoading = this.state.isFrameLoading;

      return _jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_8__FondyContainer_css___default.a.Froot
      }, void 0, _jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_8__FondyContainer_css___default.a.Fbg,
        onClick: closeHandler
      }), _jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_8__FondyContainer_css___default.a.Fcontainer
      }, void 0, _jsx('button', {
        className: __WEBPACK_IMPORTED_MODULE_8__FondyContainer_css___default.a.Fclose,
        onClick: closeHandler
      }, void 0, _ref2), _jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_8__FondyContainer_css___default.a.Fframe,
        title: title,
        id: 'fondyChekout'
      }), _jsx(__WEBPACK_IMPORTED_MODULE_7__Loader_Loader__["a" /* default */], {
        isLoading: isFrameLoading,
        className: __WEBPACK_IMPORTED_MODULE_8__FondyContainer_css___default.a.loader
      }, void 0, _jsx('button', {
        className: __WEBPACK_IMPORTED_MODULE_8__FondyContainer_css___default.a.Fbutton,
        onClick: closeHandler
      }, void 0, _ref3))));
    }
  }]);

  return FondyContainer;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

FondyContainer.defaultProps = {
  isOpen: true,
  callback: null,
  title: 'PaymentFrame',
  importantStyles: {
    '.pages-checkout .page-section-shopinfo': {
      display: 'none'
    }
  }
};


var FondyContainer_mapStateToProps = function mapStateToProps(state) {
  return {
    token: __WEBPACK_IMPORTED_MODULE_5_shared_selectors_user__["a" /* getToken */](state)
  };
};

/* harmony default export */ var FondyContainer_defaultExport = (__WEBPACK_IMPORTED_MODULE_6_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_8__FondyContainer_css___default.a)(__WEBPACK_IMPORTED_MODULE_3_react_redux__["b" /* connect */](FondyContainer_mapStateToProps)(__WEBPACK_IMPORTED_MODULE_4_shared_hocs_withFetch__["a" /* withFetch */](FondyContainer))));
// CONCATENATED MODULE: ./src/shared/components/FondyFrame/FondyInvoiceContainer.js
/* harmony import */ var FondyInvoiceContainer___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var FondyInvoiceContainer___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(FondyInvoiceContainer___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var FondyInvoiceContainer___WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var FondyInvoiceContainer___WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(FondyInvoiceContainer___WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__FondyInvoiceContainer_css__ = __webpack_require__(1434);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__FondyInvoiceContainer_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__FondyInvoiceContainer_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mobile_components_Modal_cross_svg__ = __webpack_require__(1399);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mobile_components_Modal_cross_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__mobile_components_Modal_cross_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Invoice_Invoice__ = __webpack_require__(1414);
var FondyInvoiceContainer__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();








var FondyInvoiceContainer__ref = FondyInvoiceContainer__jsx('img', {
  alt: '',
  src: __WEBPACK_IMPORTED_MODULE_4__mobile_components_Modal_cross_svg___default.a,
  width: '15'
});

function FondyInvoiceContainer(props) {
  var billAmount = props.billAmount,
      accountNumber = props.accountNumber,
      closeHandler = props.closeHandler;

  return FondyInvoiceContainer__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_3__FondyInvoiceContainer_css___default.a.Froot
  }, void 0, FondyInvoiceContainer__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_3__FondyInvoiceContainer_css___default.a.Fbg,
    onClick: closeHandler
  }), FondyInvoiceContainer__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_3__FondyInvoiceContainer_css___default.a.Fcontainer
  }, void 0, FondyInvoiceContainer__jsx('button', {
    className: __WEBPACK_IMPORTED_MODULE_3__FondyInvoiceContainer_css___default.a.Fclose,
    onClick: closeHandler
  }, void 0, FondyInvoiceContainer__ref), FondyInvoiceContainer__jsx(__WEBPACK_IMPORTED_MODULE_5__Invoice_Invoice__["a" /* default */], {
    billAmount: billAmount,
    accountNumber: accountNumber
  })));
}

/* harmony default export */ var FondyInvoiceContainer_defaultExport = (__WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_3__FondyInvoiceContainer_css___default.a)(FondyInvoiceContainer));
// CONCATENATED MODULE: ./src/shared/hocs/withOrders.js
/* harmony import */ var withOrders___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var withOrders___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(withOrders___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var withOrders___WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var withOrders___WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(withOrders___WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var withOrders___WEBPACK_IMPORTED_MODULE_2_react_intl__ = __webpack_require__(474);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_actions_globals__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_shared_constants_api__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_shared_actions_notificationTypes__ = __webpack_require__(1253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_shared_hocs_withFetch__ = __webpack_require__(1244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_shared_constants_gtmEvents__ = __webpack_require__(1243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__helpers_common__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_Modal_Modal__ = __webpack_require__(1250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__helpers_locale__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__constants_payment__ = __webpack_require__(308);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__actions_notifications__ = __webpack_require__(475);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__history__ = __webpack_require__(185);
var withOrders__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var withOrders__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var withOrders__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function withOrders__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function withOrders__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function withOrders__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




















var throwIfResponseNotOkay = function throwIfResponseNotOkay() {
  return function (response) {
    if (!response.ok) {
      throw new Error('Произошла ошибка');
    }

    return response;
  };
};

// const doRedirectToCheckout = url => {
//   if (
//     typeof window.fondyP24Window === 'undefined' ||
//     !window.fondyP24Window ||
//     window.fondyP24Window.closed ||
//     typeof window.fondyP24Window.closed === 'undefined'
//   ) {
//     // if pop-up is blocked
//     return window.location.replace(url);
//   }
//   window.fondyP24Window.location = url;
//   return window.fondyP24Window.location;
// };

var getFondyOrderData = function getFondyOrderData(fetch, token, data) {
  return fetch(__WEBPACK_IMPORTED_MODULE_5_shared_constants_api__["a" /* default */].PAYMENT.FONDY_ORDER_CHECKOUT, {
    method: 'POST',
    headers: {
      Authorization: 'JWT ' + token
    },
    body: JSON.stringify(data)
  });
};

var getMonoOrderData = function getMonoOrderData(fetch, token, data) {
  return fetch(__WEBPACK_IMPORTED_MODULE_5_shared_constants_api__["a" /* default */].PAYMENT.MONO_ORDER_CHECKOUT, {
    method: 'POST',
    headers: {
      Authorization: 'JWT ' + token
    },
    body: JSON.stringify(data)
  });
};

var updateAdvertParams = function updateAdvertParams(advertParams, fetch, token, advertID, promoteInSocial) {
  if (advertParams.kind && advertParams.kind === __WEBPACK_IMPORTED_MODULE_14__constants_payment__["d" /* PACKAGES */].C2C_TURBO && promoteInSocial) {
    fetch(__WEBPACK_IMPORTED_MODULE_5_shared_constants_api__["a" /* default */].ADVERT.ITEM(advertID), {
      method: 'PATCH',
      headers: {
        Authorization: 'JWT ' + token,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ promote_in_social: promoteInSocial })
    });
  }
};

var withOrders_withOrders = function withOrders(WrappedComponent) {
  var _class, _temp2;

  var Component = (_temp2 = _class = function (_React$Component) {
    withOrders__inherits(Component, _React$Component);

    function Component() {
      var _ref;

      var _temp, _this, _ret;

      withOrders__classCallCheck(this, Component);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = withOrders__possibleConstructorReturn(this, (_ref = Component.__proto__ || Object.getPrototypeOf(Component)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
        fondyFrameUrl: '',
        fondyCb: null,
        showModal: false,
        showInvoiceModal: false,
        billAmount: null,
        accountNumber: null,
        eventCounter: 1
      }, _this.setGtmEvent = function (gtmId) {
        if (!gtmId) return;

        var eventCounter = _this.state.eventCounter;

        var dataLayer = window && Array.isArray(window.dataLayer) && window.dataLayer;
        var gtmDataLayerValue = dataLayer && dataLayer.find(function (el) {
          return el.event === gtmId.event;
        });

        if (gtmDataLayerValue) {
          var newCounter = eventCounter + 1;
          _this.setState({ eventCounter: newCounter });
          _this.props.setDataLayer(withOrders__extends({}, gtmId, {
            event: '' + gtmId.event + newCounter + '/'
          }));
        } else {
          _this.props.setDataLayer(gtmId);
        }
      }, _this.getGtmEvent = function (gtmType) {
        var user = _this.props.user;

        var isBusiness = user.user.tariff && user.user.tariff.is_business;
        var isDealership = user.user.tariff && user.user.tariff.slug === 'b2c-plus';

        if (isDealership) {
          return __WEBPACK_IMPORTED_MODULE_8_shared_constants_gtmEvents__["a" /* EVENTS */].advert.dealership[gtmType];
        } else if (isBusiness) {
          return __WEBPACK_IMPORTED_MODULE_8_shared_constants_gtmEvents__["a" /* EVENTS */].advert.business[gtmType];
        }
        return __WEBPACK_IMPORTED_MODULE_8_shared_constants_gtmEvents__["a" /* EVENTS */].advert[gtmType];
      }, _this.sendGtmMetrics = function (params) {
        if (params.kind === 'subscription') _this.setGtmEvent(_this.getGtmEvent(params.details.tariff));else if (params.kind === 'c2c-free' && params.details && params.details.promos) {
          params.details.promos.map(function (item) {
            _this.setGtmEvent(_this.getGtmEvent(item));
          });
        } else _this.setGtmEvent(_this.getGtmEvent(params.kind));
      }, _this.closeModal = function () {
        _this.setState({ showModal: false, showInvoiceModal: false });
      }, _this.handleChangeInvoiceData = function (amount, account) {
        _this.setState({
          billAmount: amount,
          accountNumber: account,
          showInvoiceModal: true
        });
      }, _this.handleChangeUrl = function (url, cb) {
        _this.setState({ fondyFrameUrl: url, showModal: true, fondyCb: cb });
      }, _this.postOrderAndProceedToPayment = function (token, params, redirectUrl, paymentMethod, cb) {
        var _this$props = _this.props,
            fetch = _this$props.fetch,
            intl = _this$props.intl,
            promoteInSocial = _this$props.promoteInSocial;
        var locale = intl.locale;

        var redirectUrlLocalized = __WEBPACK_IMPORTED_MODULE_13__helpers_locale__["h" /* toLocalized */](redirectUrl, locale);
        var advertId = params.details && params.details.advert_id;
        __WEBPACK_IMPORTED_MODULE_9__helpers_common__["j" /* iniRedirectToCheckout */]();
        return function () {
          return (
            // if (
            //   paymentMethod === PAYMENT_METHODS.FONDY_P24 ||
            //   paymentMethod === PAYMENT_METHODS.INVOICE
            // ) {
            //   // Create window before xhr(fecth) async request
            //   window.fondyP24Window = window.open('', '_blank');
            // }
            fetch(__WEBPACK_IMPORTED_MODULE_5_shared_constants_api__["a" /* default */].PAYMENT.orders(), {
              method: 'POST',
              headers: {
                Authorization: 'JWT ' + token
              },
              body: JSON.stringify(params)
            }).then(throwIfResponseNotOkay()).then(function (r) {
              return r.json();
            }).then(function (_ref2) {
              var number = _ref2.number,
                  status = _ref2.status;

              if (status === __WEBPACK_IMPORTED_MODULE_14__constants_payment__["c" /* ORDER_STATUSES */].PAID || paymentMethod === __WEBPACK_IMPORTED_MODULE_14__constants_payment__["h" /* PAYMENT_METHODS */].BALANCE) {
                _this.sendGtmMetrics(params);
                _this.props.setDataLayer(__WEBPACK_IMPORTED_MODULE_8_shared_constants_gtmEvents__["a" /* EVENTS */].paidAdSent);
                _this.props.enqueueNotification({
                  text: intl.formatMessage({ id: 'Оплата прошла успешно' }),
                  type: __WEBPACK_IMPORTED_MODULE_6_shared_actions_notificationTypes__["a" /* default */].SUCCESS
                });
                updateAdvertParams(params, fetch, token, advertId, promoteInSocial);
                if (cb) cb({ number: number, status: status });else __WEBPACK_IMPORTED_MODULE_16__history__["a" /* default */].push(redirectUrlLocalized);
              } else {
                var handlerUrl = __WEBPACK_IMPORTED_MODULE_14__constants_payment__["j" /* URLS */].HANDLER_URL_FULL + '?redirectUrl=' + redirectUrlLocalized;

                switch (paymentMethod) {
                  case __WEBPACK_IMPORTED_MODULE_14__constants_payment__["h" /* PAYMENT_METHODS */].INVOICE:
                    {
                      return getFondyOrderData(fetch, token, {
                        order_number: number,
                        response_url: handlerUrl,
                        lang: locale
                      }).then(throwIfResponseNotOkay()).then(function (r) {
                        return r.json();
                      }).then(function (data) {
                        _this.sendGtmMetrics(params);
                        _this.props.setDataLayer(__WEBPACK_IMPORTED_MODULE_8_shared_constants_gtmEvents__["a" /* EVENTS */].paidAdSent);
                        var url = __WEBPACK_IMPORTED_MODULE_9__helpers_common__["f" /* getFondyCheckoutUrl */](data, false, true);
                        updateAdvertParams(params, fetch, token, advertId, promoteInSocial);
                        __WEBPACK_IMPORTED_MODULE_9__helpers_common__["d" /* doRedirectToCheckout */](url);
                      });
                    }
                  case __WEBPACK_IMPORTED_MODULE_14__constants_payment__["h" /* PAYMENT_METHODS */].MONO:
                    {
                      return getMonoOrderData(fetch, token, {
                        order_number: number,
                        response_url: handlerUrl,
                        lang: locale
                      }).then(throwIfResponseNotOkay()).then(function (r) {
                        return r.json();
                      }).then(function (data) {
                        _this.sendGtmMetrics(params);
                        _this.props.setDataLayer(__WEBPACK_IMPORTED_MODULE_8_shared_constants_gtmEvents__["a" /* EVENTS */].paidAdSent);
                        var url = data.checkout_url;
                        updateAdvertParams(params, fetch, token, advertId, promoteInSocial);
                        __WEBPACK_IMPORTED_MODULE_9__helpers_common__["d" /* doRedirectToCheckout */](url);
                      });
                    }
                  default:
                    break;
                }
              }

              return Promise.resolve();
            })
          );
        }().catch(function (e) {
          _this.props.enqueueNotification(intl.formatMessage({ id: e.message ? e.message : e }));
          if (cb) cb(null, e.message ? e.message : e);
        });
      }, _this.renderPaymentModal = function () {
        return withOrders__jsx(__WEBPACK_IMPORTED_MODULE_12__components_Modal_Modal__["a" /* default */], {}, void 0, withOrders__jsx(FondyContainer_defaultExport, {
          closeHandler: _this.closeModal,
          frameUrl: _this.state.fondyFrameUrl,
          callback: _this.state.fondyCb
        }));
      }, _this.renderInvoiceModal = function (billAmount, accountNumber) {
        return withOrders__jsx(__WEBPACK_IMPORTED_MODULE_12__components_Modal_Modal__["a" /* default */], {}, void 0, withOrders__jsx(FondyInvoiceContainer_defaultExport, {
          closeHandler: _this.closeModal,
          billAmount: billAmount,
          accountNumber: accountNumber
        }));
      }, _temp), withOrders__possibleConstructorReturn(_this, _ret);
    }

    withOrders__createClass(Component, [{
      key: 'render',
      value: function render() {
        return withOrders__jsx('div', {}, void 0, withOrders___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(WrappedComponent, withOrders__extends({}, this.props, {
          postOrderAndProceedToPayment: this.postOrderAndProceedToPayment
        })), this.state.showModal && this.renderPaymentModal(), this.state.showInvoiceModal && this.renderInvoiceModal(this.state.billAmount, this.state.accountNumber));
      }
    }]);

    return Component;
  }(withOrders___WEBPACK_IMPORTED_MODULE_0_react___default.a.Component), _class.displayName = 'withOrders(' + __WEBPACK_IMPORTED_MODULE_9__helpers_common__["e" /* getDisplayName */](WrappedComponent) + ')', _temp2);

  var mapDispatchToProps = {
    enqueueNotification: __WEBPACK_IMPORTED_MODULE_15__actions_notifications__["a" /* enqueueNotification */],
    setDataLayer: __WEBPACK_IMPORTED_MODULE_3_shared_actions_globals__["j" /* setDataLayer */]
  };

  var mapStateToProps = function mapStateToProps(_ref3) {
    var globals = _ref3.globals,
        user = _ref3.user;
    return {
      promoteInSocial: globals.promoteInSocial,
      user: user
    };
  };

  return __WEBPACK_IMPORTED_MODULE_4_react_redux__["b" /* connect */](mapStateToProps, mapDispatchToProps)(withOrders___WEBPACK_IMPORTED_MODULE_2_react_intl__["d" /* injectIntl */](__WEBPACK_IMPORTED_MODULE_7_shared_hocs_withFetch__["a" /* withFetch */](Component)));
};

/* harmony default export */ __webpack_exports__["a"] = (withOrders_withOrders);

/***/ }),

/***/ 1397:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// CONCATENATED MODULE: ./src/shared/components/Icons/ExchangeIcon.js
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();



var _ref = _jsx("svg", {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, void 0, _jsx("path", {
  d: "M2.06917 13.2835C1.19201 11.1658 1.19196 8.83324 2.06917 6.71555C2.80615 4.93637 4.08826 3.48803 5.73515 2.55018V6.09019H7.15107V0.709961H1.77079V2.12587H3.8359C0.390508 4.82385 -0.993499 9.58957 0.761005 13.8253C1.42965 15.4396 2.5106 16.8534 3.88706 17.9142C5.22151 18.9426 6.80728 19.6228 8.47282 19.8812L8.68997 18.482C5.70037 18.0181 3.22535 16.0747 2.06917 13.2835Z",
  fill: "#FFC107"
}), _jsx("path", {
  d: "M19.2337 13.8257C20.2555 11.3586 20.2555 8.64115 19.2337 6.17407C18.565 4.55983 17.4841 3.14595 16.1076 2.08524C14.7731 1.05682 13.1873 0.376615 11.5218 0.118164L11.3047 1.51737C14.2942 1.98127 16.7693 3.92466 17.9254 6.71594C18.8026 8.83362 18.8026 11.1662 17.9254 13.2838C17.1885 15.063 15.9064 16.5114 14.2595 17.4492V13.9092H12.8436V19.2894H18.2238V17.8735H16.1649C17.5078 16.8249 18.5639 15.4425 19.2337 13.8257Z",
  fill: "#FFC107"
}));

var ExchangeIcon = function ExchangeIcon() {
  return _ref;
};

/* harmony default export */ var ExchangeIcon_defaultExport = (ExchangeIcon);
// CONCATENATED MODULE: ./src/shared/components/Icons/IncomminCallIcon.js
/* harmony import */ var IncomminCallIcon___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var IncomminCallIcon___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(IncomminCallIcon___WEBPACK_IMPORTED_MODULE_0_react__);
var IncomminCallIcon__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();



var IncomminCallIcon__ref = IncomminCallIcon__jsx("svg", {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, void 0, IncomminCallIcon__jsx("g", {}, void 0, IncomminCallIcon__jsx("path", {
  d: "M17.2248 15.2125C17.2247 15.2125 17.2247 15.2125 17.2248 15.2125L14.1958 13.222C13.4747 12.7482 12.5387 12.7894 11.8665 13.3242C11.2777 13.7928 10.4326 13.7449 9.90057 13.2128L6.82514 10.1374C6.29321 9.60545 6.2453 8.76026 6.71375 8.17158C7.24872 7.49927 7.28977 6.56314 6.81598 5.84215L4.82546 2.81311C4.47741 2.28347 3.93755 1.96654 3.30522 1.92061C2.67289 1.87499 2.09306 2.11059 1.67237 2.58453C-0.659189 5.20998 -0.539712 9.21223 1.94428 11.6961L8.34187 18.0938C9.6343 19.3863 11.3376 20.0384 13.0445 20.0384C14.6178 20.0384 16.1941 19.4841 17.4536 18.3657C17.9273 17.9449 18.1631 17.3649 18.1173 16.7327C18.0714 16.1006 17.7545 15.5607 17.2248 15.2125ZM16.6754 17.4896C14.513 19.4099 11.2163 19.3113 9.17027 17.2653L2.77269 10.8677C0.726622 8.82161 0.62805 5.52492 2.54838 3.36258C2.71104 3.17932 2.91352 3.0867 3.15141 3.0867C3.17399 3.0867 3.19703 3.08761 3.22053 3.08929C3.48817 3.10867 3.69875 3.23227 3.84615 3.45673L5.83667 6.48562C6.03473 6.78714 6.01901 7.1625 5.79684 7.4419C4.95699 8.49735 5.0429 10.0123 5.99658 10.9659L9.07201 14.0414C10.0257 14.9951 11.5406 15.081 12.596 14.2411C12.8754 14.0188 13.2508 14.0032 13.5522 14.2013L16.5812 16.1918C16.8055 16.3392 16.9291 16.5498 16.9485 16.8174C16.968 17.0852 16.876 17.3114 16.6754 17.4896Z",
  fill: "#FFC107"
}), IncomminCallIcon__jsx("path", {
  d: "M19.8277 0.210115C19.7134 0.0959781 19.5637 0.0390625 19.414 0.0390625C19.2639 0.0390625 19.1136 0.0964359 18.9991 0.211183L12.4618 6.76533L12.4619 4.64785C12.4619 4.32437 12.1996 4.06207 11.8761 4.06207C11.5525 4.06207 11.2902 4.32437 11.2902 4.64785L11.29 8.18242C11.29 8.33776 11.3517 8.48684 11.4617 8.5967C11.5716 8.70656 11.7205 8.76836 11.8758 8.76836H15.4105C15.7342 8.76836 15.9965 8.50606 15.9965 8.18242C15.9965 7.85893 15.7342 7.59663 15.4105 7.59663H13.2877L19.8287 1.03867C20.0573 0.809483 20.0569 0.43854 19.8277 0.210115Z",
  fill: "#FFC107"
})));

var IncomminCallIcon = function IncomminCallIcon() {
  return IncomminCallIcon__ref;
};

/* harmony default export */ var IncomminCallIcon_defaultExport = (IncomminCallIcon);
// CONCATENATED MODULE: ./src/shared/components/Icons/VerifiedIcon.js
/* harmony import */ var VerifiedIcon___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var VerifiedIcon___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(VerifiedIcon___WEBPACK_IMPORTED_MODULE_0_react__);
var VerifiedIcon__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();



var VerifiedIcon__ref = VerifiedIcon__jsx("svg", {
  width: "14",
  height: "16",
  viewBox: "0 0 14 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, void 0, VerifiedIcon__jsx("path", {
  d: "M13.5896 2.49984C10.8594 2.49984 8.76785 1.71982 6.99919 0C5.23072 1.71982 3.13924 2.49984 0.409309 2.49984C0.409309 6.9786 -0.517435 13.3944 6.99915 16C14.5163 13.3944 13.5896 6.97865 13.5896 2.49984ZM6.45326 10.3812L4.25772 8.18537L5.24075 7.20239L6.45326 8.41518L8.75787 6.11053L9.74085 7.09351L6.45326 10.3812Z",
  fill: "#6CBE00"
}));

var VerifiedIcon = function VerifiedIcon() {
  return VerifiedIcon__ref;
};

/* harmony default export */ var VerifiedIcon_defaultExport = (VerifiedIcon);
// CONCATENATED MODULE: ./src/shared/components/Icons/GuaranteedIcon.js
/* harmony import */ var GuaranteedIcon___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var GuaranteedIcon___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(GuaranteedIcon___WEBPACK_IMPORTED_MODULE_0_react__);
var GuaranteedIcon__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();



var GuaranteedIcon__ref = GuaranteedIcon__jsx("svg", {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, void 0, GuaranteedIcon__jsx("g", {}, void 0, GuaranteedIcon__jsx("path", {
  d: "M13.7933 9.95967C13.4067 10.1997 13.04 10.3863 12.7133 10.5197C12.4867 10.6197 12.24 10.6663 12 10.6663C11.76 10.6663 11.5133 10.6197 11.2867 10.5197C10.7067 10.2797 10 9.87967 9.31333 9.33301H2.94667L3.93333 7.06634C4.04 6.82634 4.28 6.66634 4.54 6.66634H7.16667C6.98 6.25301 6.83333 5.80634 6.75333 5.33301H4.54C3.74667 5.33301 3.02667 5.80634 2.70667 6.53301L1.38667 9.56634C1.38 9.57968 1.38667 9.59301 1.38 9.61301C0.566667 10.0263 0 10.8597 0 11.833V14.333C0 15.253 0.746667 15.9997 1.66667 15.9997C2.58667 15.9997 3.33333 15.253 3.33333 14.333V13.9997H11.3333V14.333C11.3333 15.253 12.08 15.9997 13 15.9997C13.92 15.9997 14.6667 15.253 14.6667 14.333V11.833C14.6667 11.0797 14.3267 10.4063 13.7933 9.95967ZM4 12.6663H2.66667C2.3 12.6663 2 12.3663 2 11.9997C2 11.633 2.3 11.333 2.66667 11.333H4C4.36667 11.333 4.66667 11.633 4.66667 11.9997C4.66667 12.3663 4.36667 12.6663 4 12.6663ZM12 12.6663H10.6667C10.3 12.6663 10 12.3663 10 11.9997C10 11.633 10.3 11.333 10.6667 11.333H12C12.3667 11.333 12.6667 11.633 12.6667 11.9997C12.6667 12.3663 12.3667 12.6663 12 12.6663Z",
  fill: "#7F46CA"
}), GuaranteedIcon__jsx("path", {
  d: "M15.6607 1.21767L12.1607 0.027C12.0567 -0.009 11.9433 -0.009 11.8393 0.027L8.33933 1.21767C8.136 1.28633 8 1.477 8 1.691V4.36967C8 7.639 11.6493 9.22833 11.8047 9.29433C11.93 9.347 12.07 9.347 12.1953 9.29433C12.3507 9.22833 16 7.639 16 4.36967V1.691C16 1.477 15.864 1.28633 15.6607 1.21767ZM14.1907 3.74567L12.3573 6.079C12.124 6.377 11.6867 6.42033 11.4 6.17367L10.2333 5.17367C9.95333 4.93433 9.92067 4.513 10.1613 4.23367C10.4007 3.95433 10.822 3.92233 11.1007 4.16167L11.7393 4.709L13.1427 2.923C13.37 2.63367 13.7887 2.58233 14.0787 2.811C14.368 3.037 14.4187 3.45633 14.1907 3.74567Z",
  fill: "#7F46CA"
})));

var GuaranteedIcon = function GuaranteedIcon() {
  return GuaranteedIcon__ref;
};

/* harmony default export */ var GuaranteedIcon_defaultExport = (GuaranteedIcon);
// CONCATENATED MODULE: ./src/shared/components/Icons/TestDriveIcon.js
/* harmony import */ var TestDriveIcon___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var TestDriveIcon___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(TestDriveIcon___WEBPACK_IMPORTED_MODULE_0_react__);
var TestDriveIcon__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();



var TestDriveIcon__ref = TestDriveIcon__jsx("svg", {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, void 0, TestDriveIcon__jsx("path", {
  d: "M10 0C4.4934 0 0 4.4941 0 10C0 15.5066 4.4941 20 10 20C15.5066 20 20 15.5059 20 10C20 4.49336 15.5059 0 10 0ZM10 18.8281C5.13215 18.8281 1.17188 14.8679 1.17188 10C1.17188 5.13215 5.13215 1.17188 10 1.17188C14.8679 1.17188 18.8281 5.13215 18.8281 10C18.8281 14.8679 14.8679 18.8281 10 18.8281Z",
  fill: "#FFC107"
}), TestDriveIcon__jsx("path", {
  d: "M10 2.34375C5.80715 2.34375 2.34375 5.78238 2.34375 10C2.34375 14.2004 5.7909 17.6562 10 17.6562C14.2051 17.6562 17.6562 14.2054 17.6562 10C17.6562 5.77773 14.1885 2.34375 10 2.34375ZM10 3.51562C12.4918 3.51562 14.6594 4.92859 15.7447 6.9952C14.2962 6.45676 12.2516 5.89844 10 5.89844C7.74836 5.89844 5.70383 6.45676 4.25531 6.9952C5.34062 4.92859 7.50824 3.51562 10 3.51562ZM3.85215 12.063L4.34699 12.1337C6.16012 12.3927 7.60734 13.8399 7.86633 15.653L7.93703 16.1479C6.01813 15.5022 4.49773 13.9818 3.85215 12.063ZM12.063 16.1479L12.1337 15.653C12.3927 13.8399 13.8399 12.3927 15.653 12.1337L16.1479 12.063C15.5023 13.9818 13.9819 15.5022 12.063 16.1479ZM15.4873 10.9736C13.1619 11.3057 11.3057 13.1619 10.9736 15.4873L10.8388 16.4302C10.5641 16.4658 10.2842 16.4844 10 16.4844C9.71578 16.4844 9.43586 16.4658 9.16117 16.4302L9.02645 15.4873C8.69426 13.1618 6.83813 11.3057 4.5127 10.9736L3.5698 10.8389C3.53418 10.5642 3.51562 10.2842 3.51562 10C3.51562 9.47914 3.57777 8.97254 3.6943 8.48691C4.99598 7.91113 7.35094 7.07031 10 7.07031C12.6491 7.07031 15.004 7.91113 16.3057 8.48691C16.4222 8.97254 16.4844 9.47914 16.4844 10C16.4844 10.2842 16.4658 10.5642 16.4302 10.8389L15.4873 10.9736Z",
  fill: "#FFC107"
}), TestDriveIcon__jsx("path", {
  d: "M10 8.24219C9.03074 8.24219 8.24219 9.03074 8.24219 10C8.24219 10.9693 9.03074 11.7578 10 11.7578C10.9693 11.7578 11.7578 10.9693 11.7578 10C11.7578 9.03074 10.9693 8.24219 10 8.24219ZM10 10.5859C9.67691 10.5859 9.41406 10.3231 9.41406 10C9.41406 9.67691 9.67691 9.41406 10 9.41406C10.3231 9.41406 10.5859 9.67691 10.5859 10C10.5859 10.3231 10.3231 10.5859 10 10.5859Z",
  fill: "#FFC107"
}));

var TestDriveIcon = function TestDriveIcon() {
  return TestDriveIcon__ref;
};
/* harmony default export */ var TestDriveIcon_defaultExport = (TestDriveIcon);
// CONCATENATED MODULE: ./src/shared/components/Icons/InfoIcon.js
/* harmony import */ var InfoIcon___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var InfoIcon___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(InfoIcon___WEBPACK_IMPORTED_MODULE_0_react__);
var InfoIcon__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();



var InfoIcon__ref = InfoIcon__jsx("svg", {
  width: "14",
  height: "14",
  viewBox: "0 0 14 14",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, void 0, InfoIcon__jsx("circle", {
  cx: "7",
  cy: "7",
  r: "6",
  stroke: "#1575C3"
}), InfoIcon__jsx("path", {
  d: "M6.32935 4.30514C6.32935 3.87954 6.55157 3.66675 6.99601 3.66675C7.44046 3.66675 7.66268 3.87954 7.66268 4.30514C7.66268 4.50794 7.60645 4.66646 7.494 4.78072C7.38423 4.89211 7.21823 4.94781 6.99601 4.94781C6.55157 4.94781 6.32935 4.73359 6.32935 4.30514ZM7.60645 10.3334H6.38155V5.54335H7.60645V10.3334Z",
  fill: "#1575C3"
}));

var InfoIcon = function InfoIcon() {
  return InfoIcon__ref;
};

/* harmony default export */ var InfoIcon_defaultExport = (InfoIcon);
// CONCATENATED MODULE: ./src/shared/components/Icons/CalendarIcon.js
/* harmony import */ var CalendarIcon___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var CalendarIcon___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(CalendarIcon___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_shared_assets_icons_sprites_carCard_svg__ = __webpack_require__(1247);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_shared_assets_icons_sprites_carCard_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_shared_assets_icons_sprites_carCard_svg__);
var CalendarIcon__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();




var CalendarIcon = function CalendarIcon() {
  return CalendarIcon__jsx('svg', {
    width: '10',
    height: '10'
  }, void 0, CalendarIcon__jsx('use', {
    xlinkHref: __WEBPACK_IMPORTED_MODULE_1_shared_assets_icons_sprites_carCard_svg___default.a + '#calendar'
  }));
};

/* harmony default export */ var CalendarIcon_defaultExport = (CalendarIcon);
// CONCATENATED MODULE: ./src/shared/components/Icons/GearboxIcon.js
/* harmony import */ var GearboxIcon___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var GearboxIcon___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(GearboxIcon___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var GearboxIcon___WEBPACK_IMPORTED_MODULE_1_shared_assets_icons_sprites_carCard_svg__ = __webpack_require__(1247);
/* harmony import */ var GearboxIcon___WEBPACK_IMPORTED_MODULE_1_shared_assets_icons_sprites_carCard_svg___default = __webpack_require__.n(GearboxIcon___WEBPACK_IMPORTED_MODULE_1_shared_assets_icons_sprites_carCard_svg__);
var GearboxIcon__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();




var GearboxIcon = function GearboxIcon() {
  return GearboxIcon__jsx('svg', {
    width: '10',
    height: '10'
  }, void 0, GearboxIcon__jsx('use', {
    xlinkHref: GearboxIcon___WEBPACK_IMPORTED_MODULE_1_shared_assets_icons_sprites_carCard_svg___default.a + '#gearbox'
  }));
};

/* harmony default export */ var GearboxIcon_defaultExport = (GearboxIcon);
// CONCATENATED MODULE: ./src/shared/components/Icons/EngineIcon.js
/* harmony import */ var EngineIcon___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var EngineIcon___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(EngineIcon___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var EngineIcon___WEBPACK_IMPORTED_MODULE_1_shared_assets_icons_sprites_carCard_svg__ = __webpack_require__(1247);
/* harmony import */ var EngineIcon___WEBPACK_IMPORTED_MODULE_1_shared_assets_icons_sprites_carCard_svg___default = __webpack_require__.n(EngineIcon___WEBPACK_IMPORTED_MODULE_1_shared_assets_icons_sprites_carCard_svg__);
var EngineIcon__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();




var EngineIcon = function EngineIcon() {
  return EngineIcon__jsx('svg', {
    width: '10',
    height: '10'
  }, void 0, EngineIcon__jsx('use', {
    xlinkHref: EngineIcon___WEBPACK_IMPORTED_MODULE_1_shared_assets_icons_sprites_carCard_svg___default.a + '#engine'
  }));
};

/* harmony default export */ var EngineIcon_defaultExport = (EngineIcon);
// CONCATENATED MODULE: ./src/shared/components/Icons/SpeedIcon.js
/* harmony import */ var SpeedIcon___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var SpeedIcon___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(SpeedIcon___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var SpeedIcon___WEBPACK_IMPORTED_MODULE_1_shared_assets_icons_sprites_carCard_svg__ = __webpack_require__(1247);
/* harmony import */ var SpeedIcon___WEBPACK_IMPORTED_MODULE_1_shared_assets_icons_sprites_carCard_svg___default = __webpack_require__.n(SpeedIcon___WEBPACK_IMPORTED_MODULE_1_shared_assets_icons_sprites_carCard_svg__);
var SpeedIcon__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();




var SpeedIcon = function SpeedIcon() {
  return SpeedIcon__jsx('svg', {
    width: '10',
    height: '10'
  }, void 0, SpeedIcon__jsx('use', {
    xlinkHref: SpeedIcon___WEBPACK_IMPORTED_MODULE_1_shared_assets_icons_sprites_carCard_svg___default.a + '#speed'
  }));
};

/* harmony default export */ var SpeedIcon_defaultExport = (SpeedIcon);
// CONCATENATED MODULE: ./src/shared/components/Icons/ChassisIcon.js
/* harmony import */ var ChassisIcon___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var ChassisIcon___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(ChassisIcon___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var ChassisIcon___WEBPACK_IMPORTED_MODULE_1_shared_assets_icons_sprites_carCard_svg__ = __webpack_require__(1247);
/* harmony import */ var ChassisIcon___WEBPACK_IMPORTED_MODULE_1_shared_assets_icons_sprites_carCard_svg___default = __webpack_require__.n(ChassisIcon___WEBPACK_IMPORTED_MODULE_1_shared_assets_icons_sprites_carCard_svg__);
var ChassisIcon__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();




var ChassisIcon = function ChassisIcon() {
  return ChassisIcon__jsx('svg', {
    width: '10',
    height: '10'
  }, void 0, ChassisIcon__jsx('use', {
    xlinkHref: ChassisIcon___WEBPACK_IMPORTED_MODULE_1_shared_assets_icons_sprites_carCard_svg___default.a + '#chassis'
  }));
};

/* harmony default export */ var ChassisIcon_defaultExport = (ChassisIcon);
// CONCATENATED MODULE: ./src/shared/components/Icons/LocationIcon.js
/* harmony import */ var LocationIcon___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var LocationIcon___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(LocationIcon___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var LocationIcon___WEBPACK_IMPORTED_MODULE_1_shared_assets_icons_sprites_carCard_svg__ = __webpack_require__(1247);
/* harmony import */ var LocationIcon___WEBPACK_IMPORTED_MODULE_1_shared_assets_icons_sprites_carCard_svg___default = __webpack_require__.n(LocationIcon___WEBPACK_IMPORTED_MODULE_1_shared_assets_icons_sprites_carCard_svg__);
var LocationIcon__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();




var LocationIcon = function LocationIcon() {
  return LocationIcon__jsx('svg', {
    width: '8',
    height: '10'
  }, void 0, LocationIcon__jsx('use', {
    xlinkHref: LocationIcon___WEBPACK_IMPORTED_MODULE_1_shared_assets_icons_sprites_carCard_svg___default.a + '#location'
  }));
};

/* harmony default export */ var LocationIcon_defaultExport = (LocationIcon);
// CONCATENATED MODULE: ./src/shared/components/Icons/CarIcon.js
/* harmony import */ var CarIcon___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var CarIcon___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(CarIcon___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var CarIcon___WEBPACK_IMPORTED_MODULE_1_shared_assets_icons_sprites_carCard_svg__ = __webpack_require__(1247);
/* harmony import */ var CarIcon___WEBPACK_IMPORTED_MODULE_1_shared_assets_icons_sprites_carCard_svg___default = __webpack_require__.n(CarIcon___WEBPACK_IMPORTED_MODULE_1_shared_assets_icons_sprites_carCard_svg__);
var CarIcon__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();




var CarIcon = function CarIcon() {
  return CarIcon__jsx('svg', {
    width: '12',
    height: '12'
  }, void 0, CarIcon__jsx('use', {
    xlinkHref: CarIcon___WEBPACK_IMPORTED_MODULE_1_shared_assets_icons_sprites_carCard_svg___default.a + '#car'
  }));
};

/* harmony default export */ var CarIcon_defaultExport = (CarIcon);
// CONCATENATED MODULE: ./src/shared/components/Icons/ColorIcon.js
/* harmony import */ var ColorIcon___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var ColorIcon___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(ColorIcon___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var ColorIcon___WEBPACK_IMPORTED_MODULE_1_shared_assets_icons_sprites_carCard_svg__ = __webpack_require__(1247);
/* harmony import */ var ColorIcon___WEBPACK_IMPORTED_MODULE_1_shared_assets_icons_sprites_carCard_svg___default = __webpack_require__.n(ColorIcon___WEBPACK_IMPORTED_MODULE_1_shared_assets_icons_sprites_carCard_svg__);
var ColorIcon__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();




var ColorIcon = function ColorIcon() {
  return ColorIcon__jsx('svg', {
    width: '12',
    height: '12'
  }, void 0, ColorIcon__jsx('use', {
    xlinkHref: ColorIcon___WEBPACK_IMPORTED_MODULE_1_shared_assets_icons_sprites_carCard_svg___default.a + '#color'
  }));
};

/* harmony default export */ var ColorIcon_defaultExport = (ColorIcon);
// CONCATENATED MODULE: ./src/shared/components/Icons/VinIcon.js
/* harmony import */ var VinIcon___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var VinIcon___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(VinIcon___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var VinIcon___WEBPACK_IMPORTED_MODULE_1_shared_assets_icons_sprites_carCard_svg__ = __webpack_require__(1247);
/* harmony import */ var VinIcon___WEBPACK_IMPORTED_MODULE_1_shared_assets_icons_sprites_carCard_svg___default = __webpack_require__.n(VinIcon___WEBPACK_IMPORTED_MODULE_1_shared_assets_icons_sprites_carCard_svg__);
var VinIcon__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();




var VinIcon = function VinIcon() {
  return VinIcon__jsx('svg', {
    width: '12',
    height: '12'
  }, void 0, VinIcon__jsx('use', {
    xlinkHref: VinIcon___WEBPACK_IMPORTED_MODULE_1_shared_assets_icons_sprites_carCard_svg___default.a + '#vin'
  }));
};

/* harmony default export */ var VinIcon_defaultExport = (VinIcon);
// CONCATENATED MODULE: ./src/shared/components/Icons/VipIcon.js
/* harmony import */ var VipIcon___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var VipIcon___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(VipIcon___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var VipIcon___WEBPACK_IMPORTED_MODULE_1_shared_assets_icons_sprites_carCard_svg__ = __webpack_require__(1247);
/* harmony import */ var VipIcon___WEBPACK_IMPORTED_MODULE_1_shared_assets_icons_sprites_carCard_svg___default = __webpack_require__.n(VipIcon___WEBPACK_IMPORTED_MODULE_1_shared_assets_icons_sprites_carCard_svg__);
var VipIcon__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();




var VipIcon = function VipIcon() {
  return VipIcon__jsx('svg', {
    width: '12',
    height: '11'
  }, void 0, VipIcon__jsx('use', {
    xlinkHref: VipIcon___WEBPACK_IMPORTED_MODULE_1_shared_assets_icons_sprites_carCard_svg___default.a + '#vip'
  }));
};

/* harmony default export */ var VipIcon_defaultExport = (VipIcon);
// CONCATENATED MODULE: ./src/shared/components/Icons/SubscribeSearch.js
/* harmony import */ var SubscribeSearch___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var SubscribeSearch___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(SubscribeSearch___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var SubscribeSearch___WEBPACK_IMPORTED_MODULE_1_shared_assets_icons_sprites_carCard_svg__ = __webpack_require__(1247);
/* harmony import */ var SubscribeSearch___WEBPACK_IMPORTED_MODULE_1_shared_assets_icons_sprites_carCard_svg___default = __webpack_require__.n(SubscribeSearch___WEBPACK_IMPORTED_MODULE_1_shared_assets_icons_sprites_carCard_svg__);
var SubscribeSearch__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();




var SubscribeSearch = function SubscribeSearch() {
  return SubscribeSearch__jsx('svg', {
    width: '18',
    height: '18'
  }, void 0, SubscribeSearch__jsx('use', {
    xlinkHref: SubscribeSearch___WEBPACK_IMPORTED_MODULE_1_shared_assets_icons_sprites_carCard_svg___default.a + '#save-search'
  }));
};

/* harmony default export */ var SubscribeSearch_defaultExport = (SubscribeSearch);
// CONCATENATED MODULE: ./src/shared/components/Icons/AvatarIcon.js
/* harmony import */ var AvatarIcon___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var AvatarIcon___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(AvatarIcon___WEBPACK_IMPORTED_MODULE_0_react__);
var AvatarIcon__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();



var AvatarIcon__ref = AvatarIcon__jsx("svg", {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, void 0, AvatarIcon__jsx("g", {
  clipPath: "url(#clip0_2232:2596)"
}, void 0, AvatarIcon__jsx("path", {
  d: "M9.99957 0C7.22547 0 4.96875 2.25672 4.96875 5.03082C4.96875 7.80492 7.22547 10.0616 9.99957 10.0616C12.7737 10.0616 15.0304 7.80492 15.0304 5.03082C15.0304 2.25672 12.7737 0 9.99957 0ZM9.99957 8.58199C8.04148 8.58199 6.4484 6.98891 6.4484 5.03082C6.4484 3.07273 8.04148 1.47965 9.99957 1.47965C11.9577 1.47965 13.5507 3.07273 13.5507 5.03082C13.5507 6.98891 11.9577 8.58199 9.99957 8.58199Z",
  fill: "#808080"
}), AvatarIcon__jsx("path", {
  d: "M9.99988 11.8398C5.57473 11.8398 2.1084 15.4253 2.1084 20.0026H3.58805C3.58805 16.1925 6.34465 13.3195 9.99988 13.3195C13.6551 13.3195 16.4117 16.1927 16.4117 20.0026H17.8914C17.8914 15.4253 14.425 11.8398 9.99988 11.8398Z",
  fill: "#808080"
})), AvatarIcon__jsx("defs", {}, void 0, AvatarIcon__jsx("clipPath", {
  id: "clip0_2232:2596"
}, void 0, AvatarIcon__jsx("rect", {
  width: "20",
  height: "20",
  fill: "white"
}))));

var AvatarIcon = function AvatarIcon() {
  return AvatarIcon__ref;
};

/* harmony default export */ var AvatarIcon_defaultExport = (AvatarIcon);
// CONCATENATED MODULE: ./src/shared/components/Icons/SettingsIcon.js
/* harmony import */ var SettingsIcon___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var SettingsIcon___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(SettingsIcon___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var SettingsIcon___WEBPACK_IMPORTED_MODULE_1_shared_assets_icons_sprites_carCard_svg__ = __webpack_require__(1247);
/* harmony import */ var SettingsIcon___WEBPACK_IMPORTED_MODULE_1_shared_assets_icons_sprites_carCard_svg___default = __webpack_require__.n(SettingsIcon___WEBPACK_IMPORTED_MODULE_1_shared_assets_icons_sprites_carCard_svg__);
var SettingsIcon__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();




var SettingsIcon = function SettingsIcon() {
  return SettingsIcon__jsx('svg', {
    width: '12',
    height: '12'
  }, void 0, SettingsIcon__jsx('use', {
    xlinkHref: SettingsIcon___WEBPACK_IMPORTED_MODULE_1_shared_assets_icons_sprites_carCard_svg___default.a + '#settings'
  }));
};

/* harmony default export */ var SettingsIcon_defaultExport = (SettingsIcon);
// CONCATENATED MODULE: ./src/shared/components/Icons/MoneyIcon.js
/* harmony import */ var MoneyIcon___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var MoneyIcon___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(MoneyIcon___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var MoneyIcon___WEBPACK_IMPORTED_MODULE_1_shared_assets_icons_sprites_carCard_svg__ = __webpack_require__(1247);
/* harmony import */ var MoneyIcon___WEBPACK_IMPORTED_MODULE_1_shared_assets_icons_sprites_carCard_svg___default = __webpack_require__.n(MoneyIcon___WEBPACK_IMPORTED_MODULE_1_shared_assets_icons_sprites_carCard_svg__);
var MoneyIcon__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();




var MoneyIcon = function MoneyIcon() {
  return MoneyIcon__jsx('svg', {
    width: '16',
    height: '16'
  }, void 0, MoneyIcon__jsx('use', {
    xlinkHref: MoneyIcon___WEBPACK_IMPORTED_MODULE_1_shared_assets_icons_sprites_carCard_svg___default.a + '#money'
  }));
};

/* harmony default export */ var MoneyIcon_defaultExport = (MoneyIcon);
// CONCATENATED MODULE: ./src/shared/components/Icons/SpriteIcon.js
/* harmony import */ var SpriteIcon___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var SpriteIcon___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(SpriteIcon___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shared_assets_icons_sprites_carCard_svg__ = __webpack_require__(1247);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shared_assets_icons_sprites_carCard_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_shared_assets_icons_sprites_carCard_svg__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var SpriteIcon__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }





var SpriteIcon = function SpriteIcon(params) {
  var width = params.width,
      height = params.height,
      className = params.className,
      id = params.id,
      otherParams = _objectWithoutProperties(params, ['width', 'height', 'className', 'id']);

  return SpriteIcon___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'svg',
    _extends({ width: width || 10, height: height || 10, className: className || '' }, otherParams),
    SpriteIcon__jsx('use', {
      xlinkHref: __WEBPACK_IMPORTED_MODULE_2_shared_assets_icons_sprites_carCard_svg___default.a + '#' + id
    })
  );
};

SpriteIcon.defaultProps = {
  width: '',
  height: '',
  className: '',
  id: ''
};

/* harmony default export */ var SpriteIcon_defaultExport = (SpriteIcon);
// CONCATENATED MODULE: ./src/shared/components/Icons/index.js
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "g", function() { return ExchangeIcon_defaultExport; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "j", function() { return IncomminCallIcon_defaultExport; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "r", function() { return VerifiedIcon_defaultExport; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "i", function() { return GuaranteedIcon_defaultExport; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "q", function() { return TestDriveIcon_defaultExport; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "k", function() { return InfoIcon_defaultExport; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "b", function() { return CalendarIcon_defaultExport; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "h", function() { return GearboxIcon_defaultExport; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "f", function() { return EngineIcon_defaultExport; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "o", function() { return SpeedIcon_defaultExport; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "d", function() { return ChassisIcon_defaultExport; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "l", function() { return LocationIcon_defaultExport; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "c", function() { return CarIcon_defaultExport; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "e", function() { return ColorIcon_defaultExport; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "s", function() { return VinIcon_defaultExport; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "t", function() { return VipIcon_defaultExport; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "p", function() { return SubscribeSearch_defaultExport; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "a", function() { return AvatarIcon_defaultExport; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "n", function() { return SettingsIcon_defaultExport; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "m", function() { return MoneyIcon_defaultExport; });
/* unused concated harmony import SpriteIcon */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return SpriteIcon_defaultExport; });



























/***/ }),

/***/ 1398:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getDefaultImageByType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getSpareDefaultImage; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_shared_assets_images_transport_car_svg__ = __webpack_require__(1447);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_shared_assets_images_transport_car_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_shared_assets_images_transport_car_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_shared_assets_images_transport_motorcycle_svg__ = __webpack_require__(1448);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_shared_assets_images_transport_motorcycle_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_shared_assets_images_transport_motorcycle_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shared_assets_images_transport_lorry_svg__ = __webpack_require__(1449);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shared_assets_images_transport_lorry_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_shared_assets_images_transport_lorry_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_assets_images_transport_bus_side_svg__ = __webpack_require__(1450);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_assets_images_transport_bus_side_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_shared_assets_images_transport_bus_side_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shared_assets_images_transport_caravan_svg__ = __webpack_require__(1451);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shared_assets_images_transport_caravan_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_shared_assets_images_transport_caravan_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_shared_assets_images_transport_loader_svg__ = __webpack_require__(1452);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_shared_assets_images_transport_loader_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_shared_assets_images_transport_loader_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_shared_assets_images_car_parts_svg__ = __webpack_require__(1453);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_shared_assets_images_car_parts_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_shared_assets_images_car_parts_svg__);








var defaultImages = {
  avto: __WEBPACK_IMPORTED_MODULE_0_shared_assets_images_transport_car_svg___default.a,
  moto: __WEBPACK_IMPORTED_MODULE_1_shared_assets_images_transport_motorcycle_svg___default.a,
  mototsikl: __WEBPACK_IMPORTED_MODULE_1_shared_assets_images_transport_motorcycle_svg___default.a,
  skuter: __WEBPACK_IMPORTED_MODULE_1_shared_assets_images_transport_motorcycle_svg___default.a,
  baggi: __WEBPACK_IMPORTED_MODULE_1_shared_assets_images_transport_motorcycle_svg___default.a,
  moped: __WEBPACK_IMPORTED_MODULE_1_shared_assets_images_transport_motorcycle_svg___default.a,
  kvadrotsikl: __WEBPACK_IMPORTED_MODULE_1_shared_assets_images_transport_motorcycle_svg___default.a,
  tritsikl: __WEBPACK_IMPORTED_MODULE_1_shared_assets_images_transport_motorcycle_svg___default.a,
  gruzovye: __WEBPACK_IMPORTED_MODULE_2_shared_assets_images_transport_lorry_svg___default.a,
  avtobus: __WEBPACK_IMPORTED_MODULE_3_shared_assets_images_transport_bus_side_svg___default.a,
  pritsepy: __WEBPACK_IMPORTED_MODULE_4_shared_assets_images_transport_caravan_svg___default.a,
  spetstehnika: __WEBPACK_IMPORTED_MODULE_5_shared_assets_images_transport_loader_svg___default.a,
  zapchasti: __WEBPACK_IMPORTED_MODULE_6_shared_assets_images_car_parts_svg___default.a
};

var getDefaultImageByType = function getDefaultImageByType(transport) {
  if (!transport) {
    return undefined;
  } else if (transport.slug && defaultImages[transport.slug]) {
    return defaultImages[transport.slug];
  } else if (transport.parents && transport.parents.length > 0 && defaultImages[transport.parents[0].slug]) {
    return defaultImages[transport.parents[0].slug];
  }

  return undefined;
};

var getSpareDefaultImage = function getSpareDefaultImage() {
  return defaultImages.zapchasti;
};

/* harmony default export */ __webpack_exports__["a"] = (defaultImages);

/***/ }),

/***/ 1399:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "b837372d.svg";

/***/ }),

/***/ 1400:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */


/**
 * WARNING: DO NOT manually require this module.
 * This is a replacement for `invariant(...)` used by the error code system
 * and will _only_ be required by the corresponding babel pass.
 * It always throws.
 */

function reactProdInvariant(code) {
  var argCount = arguments.length - 1;

  var message = 'Minified React error #' + code + '; visit ' + 'http://facebook.github.io/react/docs/error-decoder.html?invariant=' + code;

  for (var argIdx = 0; argIdx < argCount; argIdx++) {
    message += '&args[]=' + encodeURIComponent(arguments[argIdx + 1]);
  }

  message += ' for the full message or use the non-minified dev environment' + ' for full errors and additional helpful warnings.';

  var error = new Error(message);
  error.name = 'Invariant Violation';
  error.framesToPop = 1; // we don't care about reactProdInvariant's own frame

  throw error;
}

module.exports = reactProdInvariant;

/***/ }),

/***/ 1401:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var emptyFunction = __webpack_require__(490);

/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = emptyFunction;

if (false) {
  var printWarning = function printWarning(format) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    var argIndex = 0;
    var message = 'Warning: ' + format.replace(/%s/g, function () {
      return args[argIndex++];
    });
    if (typeof console !== 'undefined') {}
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };

  warning = function warning(condition, format) {
    if (format === undefined) {
      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
    }

    if (format.indexOf('Failed Composite propType: ') === 0) {
      return; // Ignore CompositeComponent proptype check.
    }

    if (!condition) {
      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
        args[_key2 - 2] = arguments[_key2];
      }

      printWarning.apply(undefined, [format].concat(args));
    }
  };
}

module.exports = warning;

/***/ }),

/***/ 1402:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export emailRegexp */
/* unused harmony export itnRegex */
/* unused harmony export vinRegex */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return isValidEmail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return isValidPhone; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return isUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return isValidITN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return isValidVIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return isValidDate; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_date_fns_isDate__ = __webpack_require__(321);


/* eslint-disable no-useless-escape */

var emailRegexp = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
var itnRegex = /^\d{10}$/;
var vinRegex = /^[\d\w]{17}$/;

var isValidEmail = function isValidEmail(email) {
  return email && !!email.match(emailRegexp);
};

var isValidPhone = function isValidPhone(phoneNumber) {
  var regexp = '^(\\+[0-9]{2}\\(([0-9]{3})\\)[0-9]{3}-[0-9]{2}-[0-9]{2}|(\\+38|38|8)?([0-9]{3})[0-9]{7})$';
  return !!phoneNumber.match(regexp);
};

var isUrl = function isUrl(str) {
  var regexp = /^(?:(?:https?|ftp):\/\/)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:\/\S*)?$/;
  return regexp.test(str);
};

// Individual Tax Number
var isValidITN = function isValidITN(itn) {
  return itn && itnRegex.test(itn);
};

// Vehicle Identification Number
var isValidVIN = function isValidVIN(vin) {
  return vin && vinRegex.test(vin);
};

var isValidDate = function isValidDate(date) {
  return __WEBPACK_IMPORTED_MODULE_0_date_fns_isDate__["default"](date);
};

/***/ }),

/***/ 1408:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(1240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* eslint-disable react/prop-types */




var AVAILABLE_JUSTIFY = ['start', 'center', 'end', 'space-between', 'space-around'];
var AVAILABLE_ALIGN = ['top', 'middle', 'bottom'];
var AVAILABLE_TYPE = ['flex'];

var Row = function (_React$Component) {
  _inherits(Row, _React$Component);

  function Row() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Row);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Row.__proto__ || Object.getPrototypeOf(Row)).call.apply(_ref, [this].concat(args))), _this), _this.makeClassesByParams = function (props) {
      var resultClasses = {};
      if (props.type && AVAILABLE_TYPE.includes(props.type)) {
        resultClasses['ant-row-' + props.type] = true;
      }
      if (props.justify && AVAILABLE_JUSTIFY.includes(props.justify)) {
        resultClasses['ant-row-flex-' + props.justify] = true;
      }
      if (props.align && AVAILABLE_ALIGN.includes(props.align)) {
        resultClasses['ant-row-flex-' + props.align] = true;
      }
      return resultClasses;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Row, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          className = _props.className,
          style = _props.style,
          otherProps = _objectWithoutProperties(_props, ['children', 'className', 'style']);

      var classes = this.makeClassesByParams(otherProps);
      return _jsx('div', {
        style: style,
        className: __WEBPACK_IMPORTED_MODULE_1_classnames___default.a('ant-row', className, classes)
      }, void 0, children);
    }
  }]);

  return Row;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Row.defaultProps = {
  data: function data() {
    return 'not text';
  },
  style: {},
  type: '',
  justify: '',
  className: ''
};


/* harmony default export */ __webpack_exports__["a"] = (Row);

/***/ }),

/***/ 1409:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getUser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getToken; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getUserProfile; });
var getUser = function getUser(state) {
  return state.user;
};
var getToken = function getToken(state) {
  return state.user.token;
};
var getUserProfile = function getUserProfile(state) {
  return state.user.user;
};

/***/ }),

/***/ 1410:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// CONCATENATED MODULE: ./src/shared/components/AntdComponents/Icon/IconClose.js
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();



var IconClose__ref = _jsx("svg", {
  viewBox: "64 64 896 896",
  className: "",
  "data-icon": "close",
  width: "1em",
  height: "1em",
  fill: "currentColor",
  "aria-hidden": "true"
}, void 0, _jsx("path", {
  d: "M563.8 512l262.5-312.9c4.4-5.2.7-13.1-6.1-13.1h-79.8c-4.7 0-9.2 2.1-12.3 5.7L511.6 449.8 295.1 191.7c-3-3.6-7.5-5.7-12.3-5.7H203c-6.8 0-10.5 7.9-6.1 13.1L459.4 512 196.9 824.9A7.95 7.95 0 0 0 203 838h79.8c4.7 0 9.2-2.1 12.3-5.7l216.5-258.1 216.5 258.1c3 3.6 7.5 5.7 12.3 5.7h79.8c6.8 0 10.5-7.9 6.1-13.1L563.8 512z"
}));

function IconClose(props) {
  return IconClose__ref;
}

/* harmony default export */ var IconClose_defaultExport = (IconClose);
// CONCATENATED MODULE: ./src/shared/components/AntdComponents/Icon/Icon.js
/* harmony import */ var Icon___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var Icon___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(Icon___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var Icon__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var _ref2 = Icon__jsx('div', {});

var Icon_Icon = function (_React$Component) {
  _inherits(Icon, _React$Component);

  function Icon() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Icon);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Icon.__proto__ || Object.getPrototypeOf(Icon)).call.apply(_ref, [this].concat(args))), _this), _this.getIcon = function (type) {
      switch (type) {
        case 'close':
          return Icon___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(IconClose_defaultExport, _this.props);
        default:
          return _ref2;
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  // type="close"
  // onClick={() => this.handleChange('clear')}
  // style={{ cursor: 'pointer' }}


  _createClass(Icon, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          type = _props.type,
          otherProps = _objectWithoutProperties(_props, ['type']);

      return Icon___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        _extends({ className: 'ant-input-suffix' }, otherProps),
        this.getIcon(type)
      );
    }
  }]);

  return Icon;
}(Icon___WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Icon_Icon.defaultProps = {
  type: ''
};


/* harmony default export */ __webpack_exports__["a"] = (Icon_Icon);

/***/ }),

/***/ 1411:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(1531);

/***/ }),

/***/ 1413:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return injectTopMakesToOptions; });
/* unused harmony export injectTopModelsToOptions */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return skipTopMakes; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_shared_constants_topMakes__ = __webpack_require__(1528);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }



var getTop = function getTop(allItems, topItemsId) {
  return allItems.filter(function (item) {
    return topItemsId.includes(item.id);
  })
  // Need a unique id in order for react-select to work properly
  .map(function (item) {
    return _extends({}, item, { uniqueId: 'top-' + item.id });
  }).sort(function (a, b) {
    return a.title < b.title ? -1 : 1;
  });
};

var getItemsWithUniqueIds = function getItemsWithUniqueIds(allItems, topItemsId) {
  return allItems.filter(function (item) {
    return !topItemsId.includes(item.id);
  }).sort(function (a, b) {
    return a.title < b.title ? -1 : 1;
  });
};

var injectTopMakesToOptions = function injectTopMakesToOptions(makes, intl) {
  var safeMakes = makes ? [].concat(_toConsumableArray(makes)) : [];
  var anyItem = [];
  var any = safeMakes.findIndex(function (item) {
    return item.id === -1;
  });
  if (any >= 0) {
    anyItem = safeMakes.splice(any, 1);
  }
  var topMakes = getTop(safeMakes, __WEBPACK_IMPORTED_MODULE_0_shared_constants_topMakes__["a" /* topMakesAvto */]);
  var makesWithUniqueIds = getItemsWithUniqueIds(safeMakes, __WEBPACK_IMPORTED_MODULE_0_shared_constants_topMakes__["a" /* topMakesAvto */]);

  return [].concat(_toConsumableArray(anyItem), _toConsumableArray(topMakes.length > 0 ? [{
    title: intl.formatMessage({ id: 'Топ марки' }),
    disabled: true
  }].concat(_toConsumableArray(topMakes), [{
    title: intl.formatMessage({ id: 'Остальные марки' }),
    disabled: true
  }]) : []), _toConsumableArray(makesWithUniqueIds));
};

var injectTopModelsToOptions = function injectTopModelsToOptions(models, intl, topModelsAvto) {
  var safeModels = models || [];
  var topModels = getTop(safeModels, topModelsAvto);
  var modelsWithUniqueIds = getItemsWithUniqueIds(safeModels, topModelsAvto);

  return [].concat(_toConsumableArray(topModels.length > 0 ? [{
    title: intl.formatMessage({ id: 'Топ модели' }),
    disabled: true
  }].concat(_toConsumableArray(topModels), [{
    title: intl.formatMessage({ id: 'Остальные модели' }),
    disabled: true
  }]) : []), _toConsumableArray(modelsWithUniqueIds));
};

var skipTopMakes = function skipTopMakes(option, filter) {
  if (!option.title) {
    return false;
  }

  return option.title.toLowerCase().startsWith(filter);
};

/***/ }),

/***/ 1414:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_intl__ = __webpack_require__(474);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Invoice_css__ = __webpack_require__(1415);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Invoice_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__Invoice_css__);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var _ref2 = _jsx(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */], {
  id: '\u041A\u0432\u0438\u0442\u0430\u043D\u0446\u0438\u044F \u0434\u043B\u044F \u043E\u043F\u043B\u0430\u0442\u044B'
});

var _ref3 = _jsx(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */], {
  id: '\u0420\u0430\u0441\u043F\u0435\u0447\u0430\u0442\u0430\u0439\u0442\u0435 \u043A\u0432\u0438\u0442\u0430\u043D\u0446\u0438\u044E \u0438 \u043E\u043F\u043B\u0430\u0442\u0438\u0442\u0435 \u0432 \u043B\u044E\u0431\u043E\u043C \u0443\u0434\u043E\u0431\u043D\u043E\u043C \u0434\u043B\u044F \u0412\u0430\u0441 \u0431\u0430\u043D\u043A\u0435'
});

var _ref4 = _jsx('p', {}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */], {
  id: '\u0422\u043E\u043B\u044C\u043A\u043E \u0434\u043B\u044F \u0447\u0430\u0441\u0442\u043D\u044B\u0445 \u043B\u0438\u0446'
}), '.', _jsx('br', {}), _jsx(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */], {
  id: '\u042E\u0440\u0438\u0434\u0438\u0447\u0435\u0441\u043A\u0438\u0435 \u043B\u0438\u0446\u0430 \u043C\u043E\u0433\u0443\u0442 \u0441\u0432\u044F\u0437\u0430\u0442\u044C\u0441\u044F \u043F\u043E email'
}), ': sales@ab.ua');

var _ref5 = _jsx(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */], {
  id: '\u0420\u0430\u0441\u043F\u0435\u0447\u0430\u0442\u0430\u0442\u044C'
});

var _ref6 = _jsx('tr', {
  className: 'st_5'
}, void 0, _jsx('td', {
  width: '1%'
}, void 0, '\xA0'), _jsx('td', {
  width: '33%',
  className: 'st_r'
}, void 0, '\xA0'), _jsx('td', {
  width: '1%'
}, void 0, '\xA0'), _jsx('td', {
  width: '43%'
}, void 0, _jsx('span', {
  className: 'f_8'
}, void 0, '\u041E\u0442\u0440\u0438\u043C\u0443\u0432\u0430\u0447 \u043F\u043B\u0430\u0442\u0435\u0436\u0443')), _jsx('td', {
  width: '10%'
}, void 0, '\xA0'), _jsx('td', {
  width: '1%'
}, void 0, '\xA0'), _jsx('td', {
  width: '10%'
}, void 0, '\xA0'), _jsx('td', {
  width: '1%'
}, void 0, '\xA0'));

var _ref7 = _jsx('td', {}, void 0, '\xA0');

var _ref8 = _jsx('td', {
  className: 'st_r'
}, void 0, _jsx('span', {
  className: 'f_12 f_b'
}, void 0, '\u041F\u041E\u0412\u0406\u0414\u041E\u041C\u041B\u0415\u041D\u041D\u042F'));

var _ref9 = _jsx('td', {}, void 0, '\xA0');

var _ref10 = _jsx('td', {}, void 0, '\xA0');

var _ref11 = _jsx('td', {}, void 0, '\xA0');

var _ref12 = _jsx('td', {}, void 0, '\xA0');

var _ref13 = _jsx('td', {}, void 0, '\xA0');

var _ref14 = _jsx('td', {}, void 0, '\xA0');

var _ref15 = _jsx('td', {
  className: 'st_r'
}, void 0, '\xA0');

var _ref16 = _jsx('td', {}, void 0, '\xA0');

var _ref17 = _jsx('td', {}, void 0, '\xA0');

var _ref18 = _jsx('td', {}, void 0, '\xA0');

var _ref19 = _jsx('tr', {}, void 0, _jsx('td', {}, void 0, '\xA0'), _jsx('td', {
  className: 'st_r'
}, void 0, '\xA0'), _jsx('td', {}, void 0, '\xA0'), _jsx('td', {}, void 0, '\xA0'), _jsx('td', {
  align: 'center',
  valign: 'top'
}, void 0, _jsx('span', {
  className: 'f_8'
}, void 0, '\u041F\u043E\u0442\u043E\u0447\u043D\u0438\u0439 \u0440\u0430\u0445\u0443\u043D\u043E\u043A')), _jsx('td', {}, void 0, '\xA0'), _jsx('td', {
  align: 'center',
  valign: 'top'
}, void 0, _jsx('span', {
  className: 'f_8'
}, void 0, '\u041A\u043E\u0434 \u0404\u0414\u0420\u041F\u041E\u0423')), _jsx('td', {}, void 0, '\xA0'));

var _ref20 = _jsx('tr', {}, void 0, _jsx('td', {}, void 0, '\xA0'), _jsx('td', {
  className: 'st_r'
}, void 0, '\xA0'), _jsx('td', {}, void 0, '\xA0'), _jsx('td', {
  colSpan: 2,
  valign: 'bottom'
}, void 0, _jsx('span', {
  className: 'f_8'
}, void 0, '\u0423\u0441\u0442\u0430\u043D\u043E\u0432\u0430 \u0431\u0430\u043D\u043A\u0443')), _jsx('td', {}, void 0, '\xA0'), _jsx('td', {}, void 0, '\xA0'), _jsx('td', {}, void 0, '\xA0'));

var _ref21 = _jsx('td', {}, void 0, '\xA0');

var _ref22 = _jsx('td', {
  className: 'st_r'
}, void 0, '\xA0');

var _ref23 = _jsx('td', {}, void 0, '\xA0');

var _ref24 = _jsx('td', {
  className: 'st_b'
}, void 0, '\xA0');

var _ref25 = _jsx('td', {}, void 0, '\xA0');

var _ref26 = _jsx('tr', {}, void 0, _jsx('td', {}, void 0, '\xA0'), _jsx('td', {
  className: 'st_r'
}, void 0, '\xA0'), _jsx('td', {}, void 0, '\xA0'), _jsx('td', {}, void 0, '\xA0'), _jsx('td', {}, void 0, '\xA0'), _jsx('td', {}, void 0, '\xA0'), _jsx('td', {
  align: 'center',
  valign: 'top'
}, void 0, _jsx('span', {
  className: 'f_8'
}, void 0, '\u041C\u0424\u041E \u0431\u0430\u043D\u043A\u0443')), _jsx('td', {}, void 0, '\xA0'));

var _ref27 = _jsx('tr', {}, void 0, _jsx('td', {}, void 0, '\xA0'), _jsx('td', {
  className: 'st_r'
}, void 0, '\xA0'), _jsx('td', {}, void 0, '\xA0'), _jsx('td', {
  colSpan: 2,
  className: 'st_b'
}, void 0, _jsx('span', {
  className: 'f_11 f_b'
}, void 0, '\xA0')), _jsx('td', {
  className: 'st_b'
}, void 0, '\xA0'), _jsx('td', {
  className: 'st_all'
}, void 0, '\xA0'), _jsx('td', {}, void 0, '\xA0'));

var _ref28 = _jsx('tr', {}, void 0, _jsx('td', {}, void 0, '\xA0'), _jsx('td', {
  className: 'st_r'
}, void 0, '\xA0'), _jsx('td', {}, void 0, '\xA0'), _jsx('td', {
  valign: 'top',
  colSpan: 2
}, void 0, _jsx('span', {
  className: 'f_8'
}, void 0, '\u041F\u0440\u0456\u0437\u0432\u0438\u0449\u0435, \u0456\u043C', "'", '\u044F \u0442\u0430 \u043F\u043E-\u0431\u0430\u0442\u044C\u043A\u043E\u0432\u0456 \u043F\u043B\u0430\u0442\u043D\u0438\u043A\u0430')), _jsx('td', {}, void 0, '\xA0'), _jsx('td', {
  align: 'center',
  valign: 'top'
}, void 0, _jsx('span', {
  className: 'f_8'
}, void 0, '\u0406\u0434\u0435\u043D\u0442\u0438\u0444\u0456\u043A\u0430\u0446\u0456\u0439\u043D\u0438\u0439 \u043D\u043E\u043C\u0435\u0440')), _jsx('td', {}, void 0, '\xA0'));

var _ref29 = _jsx('tr', {}, void 0, _jsx('td', {}, void 0, '\xA0'), _jsx('td', {
  className: 'st_r'
}, void 0, '\xA0'), _jsx('td', {}, void 0, '\xA0'), _jsx('td', {
  className: 'st_b'
}, void 0, '\xA0'), _jsx('td', {
  className: 'st_b'
}, void 0, '\xA0'), _jsx('td', {
  className: 'st_b'
}, void 0, '\xA0'), _jsx('td', {}, void 0, '\xA0'), _jsx('td', {}, void 0, '\xA0'));

var _ref30 = _jsx('tr', {}, void 0, _jsx('td', {}, void 0, '\xA0'), _jsx('td', {
  className: 'st_r'
}, void 0, '\xA0'), _jsx('td', {
  className: 'st_b2'
}, void 0, '\xA0'), _jsx('td', {
  className: 'st_b2',
  valign: 'top'
}, void 0, _jsx('span', {
  className: 'f_8'
}, void 0, '\u0430\u0434\u0440\u0435\u0441\u0430 \u043F\u043B\u0430\u0442\u043D\u0438\u043A\u0430')), _jsx('td', {
  className: 'st_b2'
}, void 0, '\xA0'), _jsx('td', {
  className: 'st_b2'
}, void 0, '\xA0'), _jsx('td', {
  className: 'st_b2'
}, void 0, '\xA0'), _jsx('td', {
  className: 'st_b2'
}, void 0, '\xA0'));

var _ref31 = _jsx('tr', {}, void 0, _jsx('td', {}, void 0, '\xA0'), _jsx('td', {
  className: 'st_r'
}, void 0, '\xA0'), _jsx('td', {}, void 0, '\xA0'), _jsx('td', {
  colSpan: 3,
  className: 'st_br'
}, void 0, _jsx('span', {
  className: 'f_8'
}, void 0, '\u0412\u0438\u0434 \u043F\u043B\u0430\u0442\u0435\u0436\u0443')), _jsx('td', {
  align: 'center',
  className: 'st_b st_r'
}, void 0, _jsx('span', {
  className: 'f_8'
}, void 0, '\u0421\u0443\u043C\u043C\u0430')), _jsx('td', {}, void 0, '\xA0'));

var _ref32 = _jsx('td', {}, void 0, '\xA0');

var _ref33 = _jsx('td', {
  className: 'st_r'
}, void 0, '\xA0');

var _ref34 = _jsx('td', {}, void 0, '\xA0');

var _ref35 = _jsx('td', {
  className: 'st_r'
}, void 0, '\xA0');

var _ref36 = _jsx('td', {}, void 0, '\xA0');

var _ref37 = _jsx('tr', {}, void 0, _jsx('td', {}, void 0, '\xA0'), _jsx('td', {
  className: 'st_r'
}, void 0, '\xA0'), _jsx('td', {}, void 0, '\xA0'), _jsx('td', {
  className: 'st_r'
}, void 0, '\xA0'), _jsx('td', {
  className: 'st_r'
}, void 0, '\xA0'), _jsx('td', {}, void 0, '\xA0'));

var _ref38 = _jsx('tr', {}, void 0, _jsx('td', {}, void 0, '\xA0'), _jsx('td', {
  className: 'st_r'
}, void 0, '\xA0'), _jsx('td', {}, void 0, '\xA0'), _jsx('td', {
  className: 'st_b st_r'
}, void 0, '\xA0'), _jsx('td', {
  className: 'st_b st_r'
}, void 0, '\xA0'), _jsx('td', {}, void 0, '\xA0'));

var _ref39 = _jsx('td', {}, void 0, '\xA0');

var _ref40 = _jsx('td', {
  className: 'st_r'
}, void 0, '\xA0');

var _ref41 = _jsx('td', {});

var _ref42 = _jsx('td', {});

var _ref43 = _jsx('td', {
  align: 'right'
}, void 0, _jsx('span', {
  className: 'f_8'
}, void 0, '\u0412\u0441\u044C\u043E\u0433\u043E'));

var _ref44 = _jsx('td', {
  className: 'st_r'
}, void 0, '\xA0');

var _ref45 = _jsx('td', {}, void 0, '\xA0');

var _ref46 = _jsx('tr', {}, void 0, _jsx('td', {}, void 0, '\xA0'), _jsx('td', {
  className: 'st_r'
}, void 0, _jsx('span', {
  className: 'f_11 f_b'
}, void 0, '\u041A\u0430\u0441\u0438\u0440')), _jsx('td', {}), _jsx('td', {}, void 0, _jsx('span', {
  className: 'f_8'
}, void 0, '\u041F\u043B\u0430\u0442\u043D\u0438\u043A')), _jsx('td', {}), _jsx('td', {}), _jsx('td', {
  className: 'st_top'
}, void 0, '\xA0'), _jsx('td', {}, void 0, '\xA0'));

var _ref47 = _jsx('tr', {
  className: 'st_5'
}, void 0, _jsx('td', {
  className: 'st_bb'
}, void 0, '\xA0'), _jsx('td', {
  className: 'st_bb st_r'
}, void 0, '\xA0'), _jsx('td', {
  className: 'st_bb'
}, void 0, '\xA0'), _jsx('td', {
  className: 'st_bb'
}, void 0, '\xA0'), _jsx('td', {
  className: 'st_bb'
}, void 0, '\xA0'), _jsx('td', {
  className: 'st_bb'
}, void 0, '\xA0'), _jsx('td', {
  className: 'st_bb'
}, void 0, '\xA0'), _jsx('td', {
  className: 'st_bb'
}, void 0, '\xA0'));

var _ref48 = _jsx('tr', {
  className: 'st_5'
}, void 0, _jsx('td', {
  width: '1%'
}, void 0, '\xA0'), _jsx('td', {
  width: '33%',
  className: 'st_r'
}, void 0, '\xA0'), _jsx('td', {
  width: '1%'
}, void 0, '\xA0'), _jsx('td', {
  width: '43%'
}, void 0, _jsx('span', {
  className: 'f_8'
}, void 0, '\u041E\u0442\u0440\u0438\u043C\u0443\u0432\u0430\u0447 \u043F\u043B\u0430\u0442\u0435\u0436\u0443')), _jsx('td', {
  width: '10%'
}, void 0, '\xA0'), _jsx('td', {
  width: '1%'
}, void 0, '\xA0'), _jsx('td', {
  width: '10%'
}, void 0, '\xA0'), _jsx('td', {
  width: '1%'
}, void 0, '\xA0'));

var _ref49 = _jsx('td', {}, void 0, '\xA0');

var _ref50 = _jsx('td', {
  className: 'st_r'
}, void 0, _jsx('span', {
  className: 'f_12 f_b'
}, void 0, '\u041A\u0412\u0418\u0422\u0410\u041D\u0426\u0406\u042F'));

var _ref51 = _jsx('td', {}, void 0, '\xA0');

var _ref52 = _jsx('td', {}, void 0, '\xA0');

var _ref53 = _jsx('td', {}, void 0, '\xA0');

var _ref54 = _jsx('td', {}, void 0, '\xA0');

var _ref55 = _jsx('td', {}, void 0, '\xA0');

var _ref56 = _jsx('td', {}, void 0, '\xA0');

var _ref57 = _jsx('td', {
  className: 'st_r'
}, void 0, '\xA0');

var _ref58 = _jsx('td', {}, void 0, '\xA0');

var _ref59 = _jsx('td', {}, void 0, '\xA0');

var _ref60 = _jsx('td', {}, void 0, '\xA0');

var _ref61 = _jsx('tr', {}, void 0, _jsx('td', {}, void 0, '\xA0'), _jsx('td', {
  className: 'st_r'
}, void 0, '\xA0'), _jsx('td', {}, void 0, '\xA0'), _jsx('td', {}, void 0, '\xA0'), _jsx('td', {
  align: 'center',
  valign: 'top'
}, void 0, _jsx('span', {
  className: 'f_8'
}, void 0, '\u041F\u043E\u0442\u043E\u0447\u043D\u0438\u0439 \u0440\u0430\u0445\u0443\u043D\u043E\u043A')), _jsx('td', {}, void 0, '\xA0'), _jsx('td', {
  align: 'center',
  valign: 'top'
}, void 0, _jsx('span', {
  className: 'f_8'
}, void 0, '\u041A\u043E\u0434 \u0404\u0414\u0420\u041F\u041E\u0423')), _jsx('td', {}, void 0, '\xA0'));

var _ref62 = _jsx('tr', {}, void 0, _jsx('td', {}, void 0, '\xA0'), _jsx('td', {
  className: 'st_r'
}, void 0, '\xA0'), _jsx('td', {}, void 0, '\xA0'), _jsx('td', {
  colSpan: 2,
  valign: 'bottom'
}, void 0, _jsx('span', {
  className: 'f_8'
}, void 0, '\u0423\u0441\u0442\u0430\u043D\u043E\u0432\u0430 \u0431\u0430\u043D\u043A\u0443')), _jsx('td', {}, void 0, '\xA0'), _jsx('td', {}, void 0, '\xA0'), _jsx('td', {}, void 0, '\xA0'));

var _ref63 = _jsx('td', {}, void 0, '\xA0');

var _ref64 = _jsx('td', {
  className: 'st_r'
}, void 0, '\xA0');

var _ref65 = _jsx('td', {}, void 0, '\xA0');

var _ref66 = _jsx('td', {
  className: 'st_b'
}, void 0, '\xA0');

var _ref67 = _jsx('td', {}, void 0, '\xA0');

var _ref68 = _jsx('tr', {}, void 0, _jsx('td', {}, void 0, '\xA0'), _jsx('td', {
  className: 'st_r'
}, void 0, '\xA0'), _jsx('td', {}, void 0, '\xA0'), _jsx('td', {}, void 0, '\xA0'), _jsx('td', {}, void 0, '\xA0'), _jsx('td', {}, void 0, '\xA0'), _jsx('td', {
  align: 'center',
  valign: 'top'
}, void 0, _jsx('span', {
  className: 'f_8'
}, void 0, '\u041C\u0424\u041E \u0431\u0430\u043D\u043A\u0443')), _jsx('td', {}, void 0, '\xA0'));

var _ref69 = _jsx('tr', {}, void 0, _jsx('td', {}, void 0, '\xA0'), _jsx('td', {
  className: 'st_r'
}, void 0, '\xA0'), _jsx('td', {}, void 0, '\xA0'), _jsx('td', {
  colSpan: 2,
  className: 'st_b'
}, void 0, _jsx('span', {
  className: 'f_11 f_b'
})), _jsx('td', {
  className: 'st_b'
}, void 0, '\xA0'), _jsx('td', {
  className: 'st_all'
}, void 0, '\xA0'), _jsx('td', {}, void 0, '\xA0'));

var _ref70 = _jsx('tr', {}, void 0, _jsx('td', {}, void 0, '\xA0'), _jsx('td', {
  className: 'st_r'
}, void 0, '\xA0'), _jsx('td', {}, void 0, '\xA0'), _jsx('td', {
  valign: 'top',
  colSpan: 2
}, void 0, _jsx('span', {
  className: 'f_8'
}, void 0, '\u041F\u0440\u0456\u0437\u0432\u0438\u0449\u0435, \u0456\u043C', "'", '\u044F \u0442\u0430 \u043F\u043E-\u0431\u0430\u0442\u044C\u043A\u043E\u0432\u0456 \u043F\u043B\u0430\u0442\u043D\u0438\u043A\u0430')), _jsx('td', {}, void 0, '\xA0'), _jsx('td', {
  align: 'center',
  valign: 'top'
}, void 0, _jsx('span', {
  className: 'f_8'
}, void 0, '\u0406\u0434\u0435\u043D\u0442\u0438\u0444\u0456\u043A\u0430\u0446\u0456\u0439\u043D\u0438\u0439 \u043D\u043E\u043C\u0435\u0440')), _jsx('td', {}, void 0, '\xA0'));

var _ref71 = _jsx('tr', {}, void 0, _jsx('td', {}, void 0, '\xA0'), _jsx('td', {
  className: 'st_r'
}, void 0, '\xA0'), _jsx('td', {}, void 0, '\xA0'), _jsx('td', {
  className: 'st_b'
}, void 0, '\xA0'), _jsx('td', {
  className: 'st_b'
}, void 0, '\xA0'), _jsx('td', {
  className: 'st_b'
}, void 0, '\xA0'), _jsx('td', {}, void 0, '\xA0'), _jsx('td', {}, void 0, '\xA0'));

var _ref72 = _jsx('tr', {}, void 0, _jsx('td', {}, void 0, '\xA0'), _jsx('td', {
  className: 'st_r'
}, void 0, '\xA0'), _jsx('td', {
  className: 'st_b2'
}, void 0, '\xA0'), _jsx('td', {
  className: 'st_b2',
  valign: 'top'
}, void 0, _jsx('span', {
  className: 'f_8'
}, void 0, '\u0430\u0434\u0440\u0435\u0441\u0430 \u043F\u043B\u0430\u0442\u043D\u0438\u043A\u0430')), _jsx('td', {
  className: 'st_b2'
}, void 0, '\xA0'), _jsx('td', {
  className: 'st_b2'
}, void 0, '\xA0'), _jsx('td', {
  className: 'st_b2'
}, void 0, '\xA0'), _jsx('td', {
  className: 'st_b2'
}, void 0, '\xA0'));

var _ref73 = _jsx('tr', {}, void 0, _jsx('td', {}, void 0, '\xA0'), _jsx('td', {
  className: 'st_r'
}, void 0, '\xA0'), _jsx('td', {}, void 0, '\xA0'), _jsx('td', {
  colSpan: 3,
  className: 'st_br'
}, void 0, _jsx('span', {
  className: 'f_8'
}, void 0, '\u0412\u0438\u0434 \u043F\u043B\u0430\u0442\u0435\u0436\u0443')), _jsx('td', {
  align: 'center',
  className: 'st_b st_r'
}, void 0, _jsx('span', {
  className: 'f_8'
}, void 0, '\u0421\u0443\u043C\u043C\u0430')), _jsx('td', {}, void 0, '\xA0'));

var _ref74 = _jsx('td', {}, void 0, '\xA0');

var _ref75 = _jsx('td', {
  className: 'st_r'
}, void 0, '\xA0');

var _ref76 = _jsx('td', {}, void 0, '\xA0');

var _ref77 = _jsx('td', {
  className: 'st_r'
}, void 0, '\xA0');

var _ref78 = _jsx('td', {}, void 0, '\xA0');

var _ref79 = _jsx('tr', {}, void 0, _jsx('td', {}, void 0, '\xA0'), _jsx('td', {
  className: 'st_r'
}, void 0, '\xA0'), _jsx('td', {}, void 0, '\xA0'), _jsx('td', {
  className: 'st_r'
}, void 0, '\xA0'), _jsx('td', {
  className: 'st_r'
}, void 0, '\xA0'), _jsx('td', {}, void 0, '\xA0'));

var _ref80 = _jsx('tr', {}, void 0, _jsx('td', {}, void 0, '\xA0'), _jsx('td', {
  className: 'st_r'
}, void 0, '\xA0'), _jsx('td', {}, void 0, '\xA0'), _jsx('td', {
  className: 'st_b st_r'
}, void 0, '\xA0'), _jsx('td', {
  className: 'st_b st_r'
}, void 0, '\xA0'), _jsx('td', {}, void 0, '\xA0'));

var _ref81 = _jsx('td', {}, void 0, '\xA0');

var _ref82 = _jsx('td', {
  className: 'st_r'
}, void 0, '\xA0');

var _ref83 = _jsx('td', {});

var _ref84 = _jsx('td', {});

var _ref85 = _jsx('td', {
  align: 'right'
}, void 0, _jsx('span', {
  className: 'f_8'
}, void 0, '\u0412\u0441\u044C\u043E\u0433\u043E'));

var _ref86 = _jsx('td', {
  className: 'st_r'
}, void 0, '\xA0');

var _ref87 = _jsx('td', {}, void 0, '\xA0');

var _ref88 = _jsx('tr', {}, void 0, _jsx('td', {}, void 0, '\xA0'), _jsx('td', {
  className: 'st_r'
}, void 0, _jsx('span', {
  className: 'f_11 f_b'
}, void 0, '\u041A\u0430\u0441\u0438\u0440')), _jsx('td', {}), _jsx('td', {}, void 0, _jsx('span', {
  className: 'f_8'
}, void 0, '\u041F\u043B\u0430\u0442\u043D\u0438\u043A')), _jsx('td', {}), _jsx('td', {}), _jsx('td', {
  className: 'st_top'
}, void 0, '\xA0'), _jsx('td', {}, void 0, '\xA0'));

var _ref89 = _jsx('tr', {
  className: 'st_5'
}, void 0, _jsx('td', {}, void 0, '\xA0'), _jsx('td', {
  className: 'st_r'
}, void 0, '\xA0'), _jsx('td', {}, void 0, '\xA0'), _jsx('td', {}, void 0, '\xA0'), _jsx('td', {}, void 0, '\xA0'), _jsx('td', {}, void 0, '\xA0'), _jsx('td', {}, void 0, '\xA0'), _jsx('td', {}, void 0, '\xA0'));

var Invoice = function (_React$Component) {
  _inherits(Invoice, _React$Component);

  function Invoice() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Invoice);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Invoice.__proto__ || Object.getPrototypeOf(Invoice)).call.apply(_ref, [this].concat(args))), _this), _this.triggerPrint = function (target) {
      setTimeout(function () {
        if (target) {
          target.contentWindow.focus();
          target.contentWindow.print();
          _this.removeWindow(target);
        }
      }, 500);
    }, _this.removeWindow = function (target) {
      setTimeout(function () {
        if (target) {
          target.parentNode.removeChild(target);
        }
      }, 500);
    }, _this.handlePrintClick = function () {
      var contentNodes = _this.componentRef;
      var printWindow = document.createElement('iframe');
      printWindow.style.position = 'absolute';
      printWindow.style.top = '-1000px';
      printWindow.style.left = '-1000px';
      var defaultPageStyle = '@page { size: auto;  margin: 0mm; } ' + '@media print { body { ' + '-webkit-print-color-adjust: exact; ' + 'padding: 10px; ' + '} }';
      var linkNodes = document.querySelectorAll('link[rel="stylesheet"]');
      _this.linkTotal = linkNodes.length || 0;
      _this.linkLoaded = 0;
      var markLoaded = function markLoaded() {
        _this.linkLoaded += 1;
        if (_this.linkLoaded === _this.linkTotal) {
          _this.triggerPrint(printWindow);
        }
      };
      printWindow.onload = function () {
        if (window.navigator && window.navigator.userAgent.indexOf('Trident/7.0') > -1) {
          printWindow.onload = null;
        }
        var domDoc = printWindow.contentDocument || printWindow.contentWindow.document;
        domDoc.open();
        domDoc.write(contentNodes.outerHTML);
        domDoc.close();
        var styleEl = domDoc.createElement('style');
        styleEl.appendChild(domDoc.createTextNode(defaultPageStyle));
        domDoc.head.appendChild(styleEl);
        var headEls = document.querySelectorAll('style, link[rel="stylesheet"]');
        [].concat(_toConsumableArray(headEls)).forEach(function (node, index) {
          var newHeadEl = domDoc.createElement(node.tagName);
          var styleCSS = '';
          if (node.tagName === 'STYLE') {
            if (node.sheet) {
              for (var i = 0; i < node.sheet.cssRules.length; i += 1) {
                styleCSS += node.sheet.cssRules[i].cssText + '\r\n';
              }
              newHeadEl.setAttribute('id', 'react-to-print-' + index);
              newHeadEl.appendChild(domDoc.createTextNode(styleCSS));
            }
          } else {
            var attributes = [].concat(_toConsumableArray(node.attributes));
            attributes.forEach(function (attr) {
              newHeadEl.setAttribute(attr.nodeName, attr.nodeValue);
            });
            newHeadEl.onload = markLoaded.bind(null, 'link');
            newHeadEl.onerror = markLoaded.bind(null, 'link');
          }
          domDoc.head.appendChild(newHeadEl);
        });
        if (_this.linkTotal === 0) {
          _this.triggerPrint(printWindow);
        }
      };
      document.body.appendChild(printWindow);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Invoice, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          recipient = _props.recipient,
          establishment = _props.establishment,
          currentAccount = _props.currentAccount,
          paymentType = _props.paymentType,
          zkpo = _props.zkpo,
          accountNumber = _props.accountNumber,
          billAmount = _props.billAmount,
          swiftCode = _props.swiftCode;


      return _jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_4__Invoice_css___default.a.root
      }, void 0, _jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_4__Invoice_css___default.a.info
      }, void 0, _jsx('h1', {
        className: __WEBPACK_IMPORTED_MODULE_4__Invoice_css___default.a.h1
      }, void 0, _ref2), _jsx('h4', {
        className: __WEBPACK_IMPORTED_MODULE_4__Invoice_css___default.a.h4
      }, void 0, _ref3, '.'), _ref4, _jsx('button', {
        onClick: this.handlePrintClick,
        className: __WEBPACK_IMPORTED_MODULE_4__Invoice_css___default.a.printButton
      }, void 0, _ref5)), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        {
          ref: function ref(el) {
            _this2.componentRef = el;
          },
          className: __WEBPACK_IMPORTED_MODULE_4__Invoice_css___default.a.tableContainer
        },
        _jsx('table', {
          cellSpacing: 0,
          cellPadding: 0,
          className: 'st_all',
          id: 'odr'
        }, void 0, _jsx('tbody', {}, void 0, _ref6, _jsx('tr', {}, void 0, _ref7, _ref8, _ref9, _jsx('td', {
          rowSpan: 2,
          className: 'st_b bottom'
        }, void 0, _jsx('span', {
          className: 'f_11 f_b'
        }, void 0, recipient)), _ref10, _ref11, _ref12, _ref13), _jsx('tr', {}, void 0, _ref14, _ref15, _ref16, _jsx('td', {
          align: 'center',
          className: 'st_all'
        }, void 0, _jsx('span', {
          className: 'f_11 f_b'
        }, void 0, currentAccount)), _ref17, _jsx('td', {
          align: 'center',
          className: 'st_all'
        }, void 0, _jsx('span', {
          className: 'f_11 f_b'
        }, void 0, zkpo)), _ref18), _ref19, _ref20, _jsx('tr', {}, void 0, _ref21, _ref22, _ref23, _jsx('td', {
          colSpan: 2,
          className: 'st_b'
        }, void 0, _jsx('span', {
          className: 'f_11 f_b'
        }, void 0, establishment)), _ref24, _jsx('td', {
          className: 'st_all',
          align: 'center'
        }, void 0, _jsx('span', {
          className: 'f_11 f_b'
        }, void 0, swiftCode)), _ref25), _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _jsx('tr', {}, void 0, _ref32, _ref33, _ref34, _jsx('td', {
          rowSpan: 3,
          className: 'st_b',
          valign: 'top',
          colSpan: 2
        }, void 0, _jsx('span', {
          className: 'f_11 f_b'
        }, void 0, paymentType, ' (\u043D\u043E\u043C\u0435\u0440 \u0440\u0430\u0445\u0443\u043D\u043A\u0443 ', accountNumber, '). \u0411\u0435\u0437 \u041F\u0414\u0412.')), _ref35, _jsx('td', {
          className: 'st_r',
          align: 'center'
        }, void 0, _jsx('span', {
          className: 'f_11 f_b'
        }, void 0, billAmount)), _ref36), _ref37, _ref38, _jsx('tr', {}, void 0, _ref39, _ref40, _ref41, _ref42, _ref43, _ref44, _jsx('td', {
          className: 'st_b st_r',
          align: 'center'
        }, void 0, _jsx('span', {
          className: 'f_11 f_b'
        }, void 0, billAmount)), _ref45), _ref46, _ref47, _ref48, _jsx('tr', {}, void 0, _ref49, _ref50, _ref51, _jsx('td', {
          rowSpan: 2,
          className: 'st_b bottom'
        }, void 0, _jsx('span', {
          className: 'f_11 f_b'
        }, void 0, recipient)), _ref52, _ref53, _ref54, _ref55), _jsx('tr', {}, void 0, _ref56, _ref57, _ref58, _jsx('td', {
          align: 'center',
          className: 'st_all'
        }, void 0, _jsx('span', {
          className: 'f_11 f_b'
        }, void 0, currentAccount)), _ref59, _jsx('td', {
          align: 'center',
          className: 'st_all'
        }, void 0, _jsx('span', {
          className: 'f_11 f_b'
        }, void 0, zkpo)), _ref60), _ref61, _ref62, _jsx('tr', {}, void 0, _ref63, _ref64, _ref65, _jsx('td', {
          colSpan: 2,
          className: 'st_b'
        }, void 0, _jsx('span', {
          className: 'f_11 f_b'
        }, void 0, establishment)), _ref66, _jsx('td', {
          className: 'st_all',
          align: 'center'
        }, void 0, _jsx('span', {
          className: 'f_11 f_b'
        }, void 0, swiftCode)), _ref67), _ref68, _ref69, _ref70, _ref71, _ref72, _ref73, _jsx('tr', {}, void 0, _ref74, _ref75, _ref76, _jsx('td', {
          rowSpan: 3,
          className: 'st_b',
          valign: 'top',
          colSpan: 2
        }, void 0, _jsx('span', {
          className: 'f_11 f_b'
        }, void 0, paymentType, ' (\u043D\u043E\u043C\u0435\u0440 \u0440\u0430\u0445\u0443\u043D\u043A\u0443 ', accountNumber, '). \u0411\u0435\u0437 \u041F\u0414\u0412.')), _ref77, _jsx('td', {
          className: 'st_r',
          align: 'center'
        }, void 0, _jsx('span', {
          className: 'f_11 f_b'
        }, void 0, billAmount)), _ref78), _ref79, _ref80, _jsx('tr', {}, void 0, _ref81, _ref82, _ref83, _ref84, _ref85, _ref86, _jsx('td', {
          className: 'st_b st_r',
          align: 'center'
        }, void 0, _jsx('span', {
          className: 'f_11 f_b'
        }, void 0, billAmount)), _ref87), _ref88, _ref89))
      ));
    }
  }]);

  return Invoice;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Invoice.defaultProps = {
  recipient: 'ФОП Швець Людмила Петрівна',
  establishment: 'Банк АТ "Райффайзен банк Аваль"',
  swiftCode: '380805',
  currentAccount: '26000147358',
  paymentType: 'Поповнення рахунку в системі avtobazar.ua',
  zkpo: '2720705249'
};


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_4__Invoice_css___default.a)(Invoice));

/***/ }),

/***/ 1415:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1416);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./Invoice.css", function() {
        content = require("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./Invoice.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 1416:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, "._3sztv{padding:0 15px 15px;max-width:1000px;margin:0 auto;font-weight:400}._3IBt_{padding-bottom:15px}._30C7L{margin-bottom:10px}._1Z-M0{margin-top:10px}._2BU88{width:800px;font-family:Times New Roman,Times,serif}._3wChw{height:44px;background-color:#ffd906;border:1px solid #ffd906;color:#000;padding:10px 12px;border-radius:0 2px 2px 0;cursor:pointer;font-weight:600;outline:none}._3wChw:hover{background:#ffc107;border:1px solid #ffc107}#centering{width:620px;margin:0 auto;position:relative;padding:0 10px;text-align:left}#odr{width:165mm;font-weight:400}#odr td{font-size:2pt;padding:0 1pt;color:#000;height:11pt}#odr .st_5 td{height:5pt}.st_all{border:1px solid #000}.st_l{border-left:1px solid #000}.st_r{border-right:1px solid #000}.st_t{border-top:1px solid #000}.st_b{border-bottom:1px solid #000}.st_tr{border-top:1px solid #000;border-right:1px solid #000}.st_br,.st_tbr{border-bottom:1px solid #000;border-right:1px solid #000}.st_tbr{border-top:1px solid #000}.st_blr{border-bottom:1px solid #000;border-right:1px solid #000;border-left:1px solid #000}.st_b2{border-bottom:2px solid #000}.st_bb{border-bottom:1px dashed #000}.bottom{vertical-align:bottom}.f_8{font-size:8pt;font-family:Verdana,Arial,Helvetica,sans-serif;line-height:1}.f_11{font-size:11pt}.f_12{font-size:12pt}.f_b{font-weight:700}#content h1{margin:0 0 5px}#content p{margin:0 0 20px;font-size:90%}@media print{._2BU88{margin-top:50px}._3wChw,title{display:none}}", ""]);

// exports
exports.locals = {
	"root": "_3sztv",
	"info": "_3IBt_",
	"h1": "_30C7L",
	"h4": "_1Z-M0",
	"tableContainer": "_2BU88",
	"printButton": "_3wChw"
};

/***/ }),

/***/ 1429:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "864d7492.svg";

/***/ }),

/***/ 1430:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _assign = __webpack_require__(188);

// -- Inlined from fbjs --

var emptyObject = {};

if (false) {
  Object.freeze(emptyObject);
}

var validateFormat = function validateFormat(format) {};

if (false) {
  validateFormat = function validateFormat(format) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  };
}

function _invariant(condition, format, a, b, c, d, e, f) {
  validateFormat(format);

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
}

var warning = function warning() {};

if (false) {
  var printWarning = function printWarning(format) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    var argIndex = 0;
    var message = 'Warning: ' + format.replace(/%s/g, function () {
      return args[argIndex++];
    });
    if (typeof console !== 'undefined') {}
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };

  warning = function warning(condition, format) {
    if (format === undefined) {
      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
    }

    if (format.indexOf('Failed Composite propType: ') === 0) {
      return; // Ignore CompositeComponent proptype check.
    }

    if (!condition) {
      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
        args[_key2 - 2] = arguments[_key2];
      }

      printWarning.apply(undefined, [format].concat(args));
    }
  };
}

// /-- Inlined from fbjs --

var MIXINS_KEY = 'mixins';

// Helper function to allow the creation of anonymous functions which do not
// have .name set to the name of the variable being assigned to.
function identity(fn) {
  return fn;
}

var ReactPropTypeLocationNames;
if (false) {
  ReactPropTypeLocationNames = {
    prop: 'prop',
    context: 'context',
    childContext: 'child context'
  };
} else {
  ReactPropTypeLocationNames = {};
}

function factory(ReactComponent, isValidElement, ReactNoopUpdateQueue) {
  /**
   * Policies that describe methods in `ReactClassInterface`.
   */

  var injectedMixins = [];

  /**
   * Composite components are higher-level components that compose other composite
   * or host components.
   *
   * To create a new type of `ReactClass`, pass a specification of
   * your new class to `React.createClass`. The only requirement of your class
   * specification is that you implement a `render` method.
   *
   *   var MyComponent = React.createClass({
   *     render: function() {
   *       return <div>Hello World</div>;
   *     }
   *   });
   *
   * The class specification supports a specific protocol of methods that have
   * special meaning (e.g. `render`). See `ReactClassInterface` for
   * more the comprehensive protocol. Any other properties and methods in the
   * class specification will be available on the prototype.
   *
   * @interface ReactClassInterface
   * @internal
   */
  var ReactClassInterface = {
    /**
     * An array of Mixin objects to include when defining your component.
     *
     * @type {array}
     * @optional
     */
    mixins: 'DEFINE_MANY',

    /**
     * An object containing properties and methods that should be defined on
     * the component's constructor instead of its prototype (static methods).
     *
     * @type {object}
     * @optional
     */
    statics: 'DEFINE_MANY',

    /**
     * Definition of prop types for this component.
     *
     * @type {object}
     * @optional
     */
    propTypes: 'DEFINE_MANY',

    /**
     * Definition of context types for this component.
     *
     * @type {object}
     * @optional
     */
    contextTypes: 'DEFINE_MANY',

    /**
     * Definition of context types this component sets for its children.
     *
     * @type {object}
     * @optional
     */
    childContextTypes: 'DEFINE_MANY',

    // ==== Definition methods ====

    /**
     * Invoked when the component is mounted. Values in the mapping will be set on
     * `this.props` if that prop is not specified (i.e. using an `in` check).
     *
     * This method is invoked before `getInitialState` and therefore cannot rely
     * on `this.state` or use `this.setState`.
     *
     * @return {object}
     * @optional
     */
    getDefaultProps: 'DEFINE_MANY_MERGED',

    /**
     * Invoked once before the component is mounted. The return value will be used
     * as the initial value of `this.state`.
     *
     *   getInitialState: function() {
     *     return {
     *       isOn: false,
     *       fooBaz: new BazFoo()
     *     }
     *   }
     *
     * @return {object}
     * @optional
     */
    getInitialState: 'DEFINE_MANY_MERGED',

    /**
     * @return {object}
     * @optional
     */
    getChildContext: 'DEFINE_MANY_MERGED',

    /**
     * Uses props from `this.props` and state from `this.state` to render the
     * structure of the component.
     *
     * No guarantees are made about when or how often this method is invoked, so
     * it must not have side effects.
     *
     *   render: function() {
     *     var name = this.props.name;
     *     return <div>Hello, {name}!</div>;
     *   }
     *
     * @return {ReactComponent}
     * @required
     */
    render: 'DEFINE_ONCE',

    // ==== Delegate methods ====

    /**
     * Invoked when the component is initially created and about to be mounted.
     * This may have side effects, but any external subscriptions or data created
     * by this method must be cleaned up in `componentWillUnmount`.
     *
     * @optional
     */
    componentWillMount: 'DEFINE_MANY',

    /**
     * Invoked when the component has been mounted and has a DOM representation.
     * However, there is no guarantee that the DOM node is in the document.
     *
     * Use this as an opportunity to operate on the DOM when the component has
     * been mounted (initialized and rendered) for the first time.
     *
     * @param {DOMElement} rootNode DOM element representing the component.
     * @optional
     */
    componentDidMount: 'DEFINE_MANY',

    /**
     * Invoked before the component receives new props.
     *
     * Use this as an opportunity to react to a prop transition by updating the
     * state using `this.setState`. Current props are accessed via `this.props`.
     *
     *   componentWillReceiveProps: function(nextProps, nextContext) {
     *     this.setState({
     *       likesIncreasing: nextProps.likeCount > this.props.likeCount
     *     });
     *   }
     *
     * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
     * transition may cause a state change, but the opposite is not true. If you
     * need it, you are probably looking for `componentWillUpdate`.
     *
     * @param {object} nextProps
     * @optional
     */
    componentWillReceiveProps: 'DEFINE_MANY',

    /**
     * Invoked while deciding if the component should be updated as a result of
     * receiving new props, state and/or context.
     *
     * Use this as an opportunity to `return false` when you're certain that the
     * transition to the new props/state/context will not require a component
     * update.
     *
     *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
     *     return !equal(nextProps, this.props) ||
     *       !equal(nextState, this.state) ||
     *       !equal(nextContext, this.context);
     *   }
     *
     * @param {object} nextProps
     * @param {?object} nextState
     * @param {?object} nextContext
     * @return {boolean} True if the component should update.
     * @optional
     */
    shouldComponentUpdate: 'DEFINE_ONCE',

    /**
     * Invoked when the component is about to update due to a transition from
     * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
     * and `nextContext`.
     *
     * Use this as an opportunity to perform preparation before an update occurs.
     *
     * NOTE: You **cannot** use `this.setState()` in this method.
     *
     * @param {object} nextProps
     * @param {?object} nextState
     * @param {?object} nextContext
     * @param {ReactReconcileTransaction} transaction
     * @optional
     */
    componentWillUpdate: 'DEFINE_MANY',

    /**
     * Invoked when the component's DOM representation has been updated.
     *
     * Use this as an opportunity to operate on the DOM when the component has
     * been updated.
     *
     * @param {object} prevProps
     * @param {?object} prevState
     * @param {?object} prevContext
     * @param {DOMElement} rootNode DOM element representing the component.
     * @optional
     */
    componentDidUpdate: 'DEFINE_MANY',

    /**
     * Invoked when the component is about to be removed from its parent and have
     * its DOM representation destroyed.
     *
     * Use this as an opportunity to deallocate any external resources.
     *
     * NOTE: There is no `componentDidUnmount` since your component will have been
     * destroyed by that point.
     *
     * @optional
     */
    componentWillUnmount: 'DEFINE_MANY',

    /**
     * Replacement for (deprecated) `componentWillMount`.
     *
     * @optional
     */
    UNSAFE_componentWillMount: 'DEFINE_MANY',

    /**
     * Replacement for (deprecated) `componentWillReceiveProps`.
     *
     * @optional
     */
    UNSAFE_componentWillReceiveProps: 'DEFINE_MANY',

    /**
     * Replacement for (deprecated) `componentWillUpdate`.
     *
     * @optional
     */
    UNSAFE_componentWillUpdate: 'DEFINE_MANY',

    // ==== Advanced methods ====

    /**
     * Updates the component's currently mounted DOM representation.
     *
     * By default, this implements React's rendering and reconciliation algorithm.
     * Sophisticated clients may wish to override this.
     *
     * @param {ReactReconcileTransaction} transaction
     * @internal
     * @overridable
     */
    updateComponent: 'OVERRIDE_BASE'
  };

  /**
   * Similar to ReactClassInterface but for static methods.
   */
  var ReactClassStaticInterface = {
    /**
     * This method is invoked after a component is instantiated and when it
     * receives new props. Return an object to update state in response to
     * prop changes. Return null to indicate no change to state.
     *
     * If an object is returned, its keys will be merged into the existing state.
     *
     * @return {object || null}
     * @optional
     */
    getDerivedStateFromProps: 'DEFINE_MANY_MERGED'
  };

  /**
   * Mapping from class specification keys to special processing functions.
   *
   * Although these are declared like instance properties in the specification
   * when defining classes using `React.createClass`, they are actually static
   * and are accessible on the constructor instead of the prototype. Despite
   * being static, they must be defined outside of the "statics" key under
   * which all other static methods are defined.
   */
  var RESERVED_SPEC_KEYS = {
    displayName: function displayName(Constructor, _displayName) {
      Constructor.displayName = _displayName;
    },
    mixins: function mixins(Constructor, _mixins) {
      if (_mixins) {
        for (var i = 0; i < _mixins.length; i++) {
          mixSpecIntoComponent(Constructor, _mixins[i]);
        }
      }
    },
    childContextTypes: function childContextTypes(Constructor, _childContextTypes) {
      if (false) {
        validateTypeDef(Constructor, _childContextTypes, 'childContext');
      }
      Constructor.childContextTypes = _assign({}, Constructor.childContextTypes, _childContextTypes);
    },
    contextTypes: function contextTypes(Constructor, _contextTypes) {
      if (false) {
        validateTypeDef(Constructor, _contextTypes, 'context');
      }
      Constructor.contextTypes = _assign({}, Constructor.contextTypes, _contextTypes);
    },
    /**
     * Special case getDefaultProps which should move into statics but requires
     * automatic merging.
     */
    getDefaultProps: function getDefaultProps(Constructor, _getDefaultProps) {
      if (Constructor.getDefaultProps) {
        Constructor.getDefaultProps = createMergedResultFunction(Constructor.getDefaultProps, _getDefaultProps);
      } else {
        Constructor.getDefaultProps = _getDefaultProps;
      }
    },
    propTypes: function propTypes(Constructor, _propTypes) {
      if (false) {
        validateTypeDef(Constructor, _propTypes, 'prop');
      }
      Constructor.propTypes = _assign({}, Constructor.propTypes, _propTypes);
    },
    statics: function statics(Constructor, _statics) {
      mixStaticSpecIntoComponent(Constructor, _statics);
    },
    autobind: function autobind() {}
  };

  function validateTypeDef(Constructor, typeDef, location) {
    for (var propName in typeDef) {
      if (typeDef.hasOwnProperty(propName)) {
        // use a warning instead of an _invariant so components
        // don't show up in prod but only in __DEV__
        if (false) {
          warning(typeof typeDef[propName] === 'function', '%s: %s type `%s` is invalid; it must be a function, usually from ' + 'React.PropTypes.', Constructor.displayName || 'ReactClass', ReactPropTypeLocationNames[location], propName);
        }
      }
    }
  }

  function validateMethodOverride(isAlreadyDefined, name) {
    var specPolicy = ReactClassInterface.hasOwnProperty(name) ? ReactClassInterface[name] : null;

    // Disallow overriding of base class methods unless explicitly allowed.
    if (ReactClassMixin.hasOwnProperty(name)) {
      _invariant(specPolicy === 'OVERRIDE_BASE', 'ReactClassInterface: You are attempting to override ' + '`%s` from your class specification. Ensure that your method names ' + 'do not overlap with React methods.', name);
    }

    // Disallow defining methods more than once unless explicitly allowed.
    if (isAlreadyDefined) {
      _invariant(specPolicy === 'DEFINE_MANY' || specPolicy === 'DEFINE_MANY_MERGED', 'ReactClassInterface: You are attempting to define ' + '`%s` on your component more than once. This conflict may be due ' + 'to a mixin.', name);
    }
  }

  /**
   * Mixin helper which handles policy validation and reserved
   * specification keys when building React classes.
   */
  function mixSpecIntoComponent(Constructor, spec) {
    if (!spec) {
      if (false) {
        var typeofSpec = typeof spec === 'undefined' ? 'undefined' : _typeof(spec);
        var isMixinValid = typeofSpec === 'object' && spec !== null;

        if (process.env.NODE_ENV !== 'production') {
          warning(isMixinValid, "%s: You're attempting to include a mixin that is either null " + 'or not an object. Check the mixins included by the component, ' + 'as well as any mixins they include themselves. ' + 'Expected object but got %s.', Constructor.displayName || 'ReactClass', spec === null ? null : typeofSpec);
        }
      }

      return;
    }

    _invariant(typeof spec !== 'function', "ReactClass: You're attempting to " + 'use a component class or function as a mixin. Instead, just use a ' + 'regular object.');
    _invariant(!isValidElement(spec), "ReactClass: You're attempting to " + 'use a component as a mixin. Instead, just use a regular object.');

    var proto = Constructor.prototype;
    var autoBindPairs = proto.__reactAutoBindPairs;

    // By handling mixins before any other properties, we ensure the same
    // chaining order is applied to methods with DEFINE_MANY policy, whether
    // mixins are listed before or after these methods in the spec.
    if (spec.hasOwnProperty(MIXINS_KEY)) {
      RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
    }

    for (var name in spec) {
      if (!spec.hasOwnProperty(name)) {
        continue;
      }

      if (name === MIXINS_KEY) {
        // We have already handled mixins in a special case above.
        continue;
      }

      var property = spec[name];
      var isAlreadyDefined = proto.hasOwnProperty(name);
      validateMethodOverride(isAlreadyDefined, name);

      if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
        RESERVED_SPEC_KEYS[name](Constructor, property);
      } else {
        // Setup methods on prototype:
        // The following member methods should not be automatically bound:
        // 1. Expected ReactClass methods (in the "interface").
        // 2. Overridden methods (that were mixed in).
        var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
        var isFunction = typeof property === 'function';
        var shouldAutoBind = isFunction && !isReactClassMethod && !isAlreadyDefined && spec.autobind !== false;

        if (shouldAutoBind) {
          autoBindPairs.push(name, property);
          proto[name] = property;
        } else {
          if (isAlreadyDefined) {
            var specPolicy = ReactClassInterface[name];

            // These cases should already be caught by validateMethodOverride.
            _invariant(isReactClassMethod && (specPolicy === 'DEFINE_MANY_MERGED' || specPolicy === 'DEFINE_MANY'), 'ReactClass: Unexpected spec policy %s for key %s ' + 'when mixing in component specs.', specPolicy, name);

            // For methods which are defined more than once, call the existing
            // methods before calling the new property, merging if appropriate.
            if (specPolicy === 'DEFINE_MANY_MERGED') {
              proto[name] = createMergedResultFunction(proto[name], property);
            } else if (specPolicy === 'DEFINE_MANY') {
              proto[name] = createChainedFunction(proto[name], property);
            }
          } else {
            proto[name] = property;
            if (false) {
              // Add verbose displayName to the function, which helps when looking
              // at profiling tools.
              if (typeof property === 'function' && spec.displayName) {
                proto[name].displayName = spec.displayName + '_' + name;
              }
            }
          }
        }
      }
    }
  }

  function mixStaticSpecIntoComponent(Constructor, statics) {
    if (!statics) {
      return;
    }

    for (var name in statics) {
      var property = statics[name];
      if (!statics.hasOwnProperty(name)) {
        continue;
      }

      var isReserved = name in RESERVED_SPEC_KEYS;
      _invariant(!isReserved, 'ReactClass: You are attempting to define a reserved ' + 'property, `%s`, that shouldn\'t be on the "statics" key. Define it ' + 'as an instance property instead; it will still be accessible on the ' + 'constructor.', name);

      var isAlreadyDefined = name in Constructor;
      if (isAlreadyDefined) {
        var specPolicy = ReactClassStaticInterface.hasOwnProperty(name) ? ReactClassStaticInterface[name] : null;

        _invariant(specPolicy === 'DEFINE_MANY_MERGED', 'ReactClass: You are attempting to define ' + '`%s` on your component more than once. This conflict may be ' + 'due to a mixin.', name);

        Constructor[name] = createMergedResultFunction(Constructor[name], property);

        return;
      }

      Constructor[name] = property;
    }
  }

  /**
   * Merge two objects, but throw if both contain the same key.
   *
   * @param {object} one The first object, which is mutated.
   * @param {object} two The second object
   * @return {object} one after it has been mutated to contain everything in two.
   */
  function mergeIntoWithNoDuplicateKeys(one, two) {
    _invariant(one && two && (typeof one === 'undefined' ? 'undefined' : _typeof(one)) === 'object' && (typeof two === 'undefined' ? 'undefined' : _typeof(two)) === 'object', 'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.');

    for (var key in two) {
      if (two.hasOwnProperty(key)) {
        _invariant(one[key] === undefined, 'mergeIntoWithNoDuplicateKeys(): ' + 'Tried to merge two objects with the same key: `%s`. This conflict ' + 'may be due to a mixin; in particular, this may be caused by two ' + 'getInitialState() or getDefaultProps() methods returning objects ' + 'with clashing keys.', key);
        one[key] = two[key];
      }
    }
    return one;
  }

  /**
   * Creates a function that invokes two functions and merges their return values.
   *
   * @param {function} one Function to invoke first.
   * @param {function} two Function to invoke second.
   * @return {function} Function that invokes the two argument functions.
   * @private
   */
  function createMergedResultFunction(one, two) {
    return function mergedResult() {
      var a = one.apply(this, arguments);
      var b = two.apply(this, arguments);
      if (a == null) {
        return b;
      } else if (b == null) {
        return a;
      }
      var c = {};
      mergeIntoWithNoDuplicateKeys(c, a);
      mergeIntoWithNoDuplicateKeys(c, b);
      return c;
    };
  }

  /**
   * Creates a function that invokes two functions and ignores their return vales.
   *
   * @param {function} one Function to invoke first.
   * @param {function} two Function to invoke second.
   * @return {function} Function that invokes the two argument functions.
   * @private
   */
  function createChainedFunction(one, two) {
    return function chainedFunction() {
      one.apply(this, arguments);
      two.apply(this, arguments);
    };
  }

  /**
   * Binds a method to the component.
   *
   * @param {object} component Component whose method is going to be bound.
   * @param {function} method Method to be bound.
   * @return {function} The bound method.
   */
  function bindAutoBindMethod(component, method) {
    var boundMethod = method.bind(component);
    if (false) {
      boundMethod.__reactBoundContext = component;
      boundMethod.__reactBoundMethod = method;
      boundMethod.__reactBoundArguments = null;
      var componentName = component.constructor.displayName;
      var _bind = boundMethod.bind;
      boundMethod.bind = function (newThis) {
        for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
          args[_key - 1] = arguments[_key];
        }

        // User is trying to bind() an autobound method; we effectively will
        // ignore the value of "this" that the user is trying to use, so
        // let's warn.
        if (newThis !== component && newThis !== null) {
          if (process.env.NODE_ENV !== 'production') {
            warning(false, 'bind(): React component methods may only be bound to the ' + 'component instance. See %s', componentName);
          }
        } else if (!args.length) {
          if (process.env.NODE_ENV !== 'production') {
            warning(false, 'bind(): You are binding a component method to the component. ' + 'React does this for you automatically in a high-performance ' + 'way, so you can safely remove this call. See %s', componentName);
          }
          return boundMethod;
        }
        var reboundMethod = _bind.apply(boundMethod, arguments);
        reboundMethod.__reactBoundContext = component;
        reboundMethod.__reactBoundMethod = method;
        reboundMethod.__reactBoundArguments = args;
        return reboundMethod;
      };
    }
    return boundMethod;
  }

  /**
   * Binds all auto-bound methods in a component.
   *
   * @param {object} component Component whose method is going to be bound.
   */
  function bindAutoBindMethods(component) {
    var pairs = component.__reactAutoBindPairs;
    for (var i = 0; i < pairs.length; i += 2) {
      var autoBindKey = pairs[i];
      var method = pairs[i + 1];
      component[autoBindKey] = bindAutoBindMethod(component, method);
    }
  }

  var IsMountedPreMixin = {
    componentDidMount: function componentDidMount() {
      this.__isMounted = true;
    }
  };

  var IsMountedPostMixin = {
    componentWillUnmount: function componentWillUnmount() {
      this.__isMounted = false;
    }
  };

  /**
   * Add more to the ReactClass base class. These are all legacy features and
   * therefore not already part of the modern ReactComponent.
   */
  var ReactClassMixin = {
    /**
     * TODO: This will be deprecated because state should always keep a consistent
     * type signature and the only use case for this, is to avoid that.
     */
    replaceState: function replaceState(newState, callback) {
      this.updater.enqueueReplaceState(this, newState, callback);
    },

    /**
     * Checks whether or not this composite component is mounted.
     * @return {boolean} True if mounted, false otherwise.
     * @protected
     * @final
     */
    isMounted: function isMounted() {
      if (false) {
        warning(this.__didWarnIsMounted, '%s: isMounted is deprecated. Instead, make sure to clean up ' + 'subscriptions and pending requests in componentWillUnmount to ' + 'prevent memory leaks.', this.constructor && this.constructor.displayName || this.name || 'Component');
        this.__didWarnIsMounted = true;
      }
      return !!this.__isMounted;
    }
  };

  var ReactClassComponent = function ReactClassComponent() {};
  _assign(ReactClassComponent.prototype, ReactComponent.prototype, ReactClassMixin);

  /**
   * Creates a composite component class given a class specification.
   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
   *
   * @param {object} spec Class specification (which must define `render`).
   * @return {function} Component constructor function.
   * @public
   */
  function createClass(spec) {
    // To keep our warnings more understandable, we'll use a little hack here to
    // ensure that Constructor.name !== 'Constructor'. This makes sure we don't
    // unnecessarily identify a class without displayName as 'Constructor'.
    var Constructor = identity(function (props, context, updater) {
      // This constructor gets overridden by mocks. The argument is used
      // by mocks to assert on what gets mounted.

      if (false) {
        warning(this instanceof Constructor, 'Something is calling a React component directly. Use a factory or ' + 'JSX instead. See: https://fb.me/react-legacyfactory');
      }

      // Wire up auto-binding
      if (this.__reactAutoBindPairs.length) {
        bindAutoBindMethods(this);
      }

      this.props = props;
      this.context = context;
      this.refs = emptyObject;
      this.updater = updater || ReactNoopUpdateQueue;

      this.state = null;

      // ReactClasses doesn't have constructors. Instead, they use the
      // getInitialState and componentWillMount methods for initialization.

      var initialState = this.getInitialState ? this.getInitialState() : null;
      if (false) {
        // We allow auto-mocks to proceed as if they're returning null.
        if (initialState === undefined && this.getInitialState._isMockFunction) {
          // This is probably bad practice. Consider warning here and
          // deprecating this convenience.
          initialState = null;
        }
      }
      _invariant((typeof initialState === 'undefined' ? 'undefined' : _typeof(initialState)) === 'object' && !Array.isArray(initialState), '%s.getInitialState(): must return an object or null', Constructor.displayName || 'ReactCompositeComponent');

      this.state = initialState;
    });
    Constructor.prototype = new ReactClassComponent();
    Constructor.prototype.constructor = Constructor;
    Constructor.prototype.__reactAutoBindPairs = [];

    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));

    mixSpecIntoComponent(Constructor, IsMountedPreMixin);
    mixSpecIntoComponent(Constructor, spec);
    mixSpecIntoComponent(Constructor, IsMountedPostMixin);

    // Initialize the defaultProps property after all mixins have been merged.
    if (Constructor.getDefaultProps) {
      Constructor.defaultProps = Constructor.getDefaultProps();
    }

    if (false) {
      // This is a tag to indicate that the use of these method names is ok,
      // since it's used with createClass. If it's not, then it's likely a
      // mistake so we'll warn you to use the static property, property
      // initializer or constructor respectively.
      if (Constructor.getDefaultProps) {
        Constructor.getDefaultProps.isReactClassApproved = {};
      }
      if (Constructor.prototype.getInitialState) {
        Constructor.prototype.getInitialState.isReactClassApproved = {};
      }
    }

    _invariant(Constructor.prototype.render, 'createClass(...): Class specification must implement a `render` method.');

    if (false) {
      warning(!Constructor.prototype.componentShouldUpdate, '%s has a method called ' + 'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' + 'The name is phrased as a question because the function is ' + 'expected to return a value.', spec.displayName || 'A component');
      warning(!Constructor.prototype.componentWillRecieveProps, '%s has a method called ' + 'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?', spec.displayName || 'A component');
      warning(!Constructor.prototype.UNSAFE_componentWillRecieveProps, '%s has a method called UNSAFE_componentWillRecieveProps(). ' + 'Did you mean UNSAFE_componentWillReceiveProps()?', spec.displayName || 'A component');
    }

    // Reduce time spent doing lookups by setting these on the prototype.
    for (var methodName in ReactClassInterface) {
      if (!Constructor.prototype[methodName]) {
        Constructor.prototype[methodName] = null;
      }
    }

    return Constructor;
  }

  return createClass;
}

module.exports = factory;

/***/ }),

/***/ 1431:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_select__ = __webpack_require__(477);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




// class UpdatedSelect extends Select {
//
// }

var _ref = _jsx('span', {
  className: 'Select-aria-only'
}, void 0, '\xA0');

function HOCUpdatedSelect(WrappedComponent) {
  return function (_WrappedComponent) {
    _inherits(Enhancer, _WrappedComponent);

    function Enhancer() {
      _classCallCheck(this, Enhancer);

      return _possibleConstructorReturn(this, (Enhancer.__proto__ || Object.getPrototypeOf(Enhancer)).apply(this, arguments));
    }

    _createClass(Enhancer, [{
      key: 'renderValue',
      value: function renderValue(valueArray, isOpen) {
        var _this2 = this;

        var renderLabel = this.props.valueRenderer || this.getOptionLabel;
        var ValueComponent = this.props.valueComponent;
        if (!valueArray.length) {
          return !this.state.inputValue ? _jsx('div', {
            className: 'Select-placeholder'
          }, void 0, this.props.placeholder) : null;
        }
        var onClick = this.props.onValueClick ? this.handleValueClick : null;
        if (this.props.multi && valueArray.length === 1) {
          return valueArray.map(function (value, i) {
            return _jsx(ValueComponent, {
              id: _this2._instancePrefix + '-value-' + i,
              instancePrefix: _this2._instancePrefix,
              disabled: _this2.props.disabled || value.clearableValue === false,
              onClick: onClick,
              onRemove: _this2.removeValue,
              value: value
            }, 'value-' + i + '-' + value[_this2.props.valueKey], renderLabel(value, i), _ref);
          });
        } else if (this.props.multi && valueArray.length > 1) {
          return !this.state.inputValue ? _jsx('div', {
            className: 'Select-placeholder'
          }, void 0, this.props.placeholder + ' (' + valueArray.length + ')') : null;
        } else if (!this.state.inputValue) {
          if (isOpen) onClick = null;
          return _jsx(ValueComponent, {
            id: this._instancePrefix + '-value-item',
            disabled: this.props.disabled,
            instancePrefix: this._instancePrefix,
            onClick: onClick,
            value: valueArray[0]
          }, void 0, renderLabel(valueArray[0]));
        }
      }
    }, {
      key: 'render',
      value: function render() {
        return _get(Enhancer.prototype.__proto__ || Object.getPrototypeOf(Enhancer.prototype), 'render', this).call(this);
      }
    }]);

    return Enhancer;
  }(WrappedComponent);
}

var UpdatedSelect = HOCUpdatedSelect(__WEBPACK_IMPORTED_MODULE_1_react_select__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (UpdatedSelect);

/***/ }),

/***/ 1432:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1433);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./FondyContainer.css", function() {
        content = require("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./FondyContainer.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 1433:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, "._2jg96{position:fixed;z-index:3008;background-color:rgba(50,50,50,.2);top:0;left:0;display:-webkit-box;display:-ms-flexbox;display:flex;overflow-y:auto;width:100%;height:100%;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;font-weight:400}._3H29P{position:absolute;top:0;left:0;right:0;bottom:0;z-index:3009}._2WF0L{position:relative;background-color:#fff;width:600px;min-height:410px;margin:5px;-ms-flex-item-align:center;align-self:center;z-index:3010;padding:20px 10px 10px;text-align:right}._2hBI9{min-height:460px;position:relative;z-index:2}._2hBI9,._2hBI9 iframe{width:100%;height:100%;border:none}._2hBI9 iframe{min-height:450px}._3eRhx{display:none}._1vKmW{position:relative;margin-right:10px;border:1px solid #d0d0d0;background-color:#fff;color:#000;padding:8px 16px;overflow:hidden;outline:none;float:left}._1vKmW:hover{cursor:pointer;border-color:#ffd906}._2yJWE{position:absolute;top:50%;left:50%;-webkit-transform:translate(-50%,-50%);transform:translate(-50%,-50%)}@media screen and (max-width:480px){._2hBI9{min-height:485px}._3eRhx{margin-left:auto;display:block;padding:7px 7px 0 0;border:0;background-color:transparent}}", ""]);

// exports
exports.locals = {
	"Froot": "_2jg96",
	"Fbg": "_3H29P",
	"Fcontainer": "_2WF0L",
	"Fframe": "_2hBI9",
	"Fclose": "_3eRhx",
	"Fbutton": "_1vKmW",
	"loader": "_2yJWE"
};

/***/ }),

/***/ 1434:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1435);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./FondyInvoiceContainer.css", function() {
        content = require("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./FondyInvoiceContainer.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 1435:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, "._1wjJu{position:fixed;z-index:3008;background-color:rgba(50,50,50,.2);top:0;left:0;display:-webkit-box;display:-ms-flexbox;display:flex;overflow-y:auto;width:100%;height:100%;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;font-weight:400}.K6bxd{position:absolute;top:0;left:0;right:0;bottom:0;z-index:3009}._2R_Vs{position:relative;background-color:#fff;width:650px;min-height:510px;margin:5px;-ms-flex-item-align:center;align-self:center;z-index:3010;padding:10px 0}._1gpZK{display:none}@media screen and (max-width:480px){._1gpZK{margin-left:auto;display:block;padding:7px 7px 0 0;border:0;background-color:transparent}}", ""]);

// exports
exports.locals = {
	"Froot": "_1wjJu",
	"Fbg": "K6bxd",
	"Fcontainer": "_2R_Vs",
	"Fclose": "_1gpZK"
};

/***/ }),

/***/ 1436:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// CONCATENATED MODULE: ./src/desktop/components/ThumbCarousel/ThumbCarousel.js
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(1240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ThumbCarousel_css__ = __webpack_require__(1464);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ThumbCarousel_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__ThumbCarousel_css__);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var ThumbCarousel = function (_React$Component) {
  _inherits(ThumbCarousel, _React$Component);

  function ThumbCarousel() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ThumbCarousel);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ThumbCarousel.__proto__ || Object.getPrototypeOf(ThumbCarousel)).call.apply(_ref, [this].concat(args))), _this), _this.handleSlideMouseOver = function (index) {
      _this.props.onMouseOver(index);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ThumbCarousel, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          album = _props.album,
          index = _props.index;


      if (!Array.isArray(album) || album.length < 2) {
        return null;
      }

      return _jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_4__ThumbCarousel_css___default.a.thumbCarousel
      }, void 0, album.map(function (imageObj, i) {
        return _jsx('span', {
          className: __WEBPACK_IMPORTED_MODULE_2_classnames___default.a(__WEBPACK_IMPORTED_MODULE_4__ThumbCarousel_css___default.a.slide, _defineProperty({}, __WEBPACK_IMPORTED_MODULE_4__ThumbCarousel_css___default.a.currentSlide, index === i)),
          onMouseOver: function onMouseOver() {
            return _this2.handleSlideMouseOver(i);
          }
        }, imageObj.id + '-' + i, _jsx('span', {
          className: __WEBPACK_IMPORTED_MODULE_4__ThumbCarousel_css___default.a.slideButton
        }));
      }));
    }
  }]);

  return ThumbCarousel;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

ThumbCarousel.defaultProps = {
  album: []
};


/* harmony default export */ var ThumbCarousel_defaultExport = (__WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_4__ThumbCarousel_css___default.a)(ThumbCarousel));
// CONCATENATED MODULE: ./src/desktop/components/Thumb/Thumb.js
/* harmony import */ var Thumb___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var Thumb___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(Thumb___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var Thumb___WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var Thumb___WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(Thumb___WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shared_components_Link__ = __webpack_require__(1241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(1240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shared_hocs_withPixelRatio__ = __webpack_require__(1391);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_shared_assets_images_car_svg__ = __webpack_require__(1429);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_shared_assets_images_car_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_shared_assets_images_car_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Thumb_css__ = __webpack_require__(1466);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Thumb_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__Thumb_css__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var Thumb__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var Thumb__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function Thumb__defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function Thumb__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function Thumb__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function Thumb__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








// import LazyLoad from 'react-lazyload';



var DEFAULT_HEIGHT = 170;

var Thumb_Thumb = function (_React$Component) {
  Thumb__inherits(Thumb, _React$Component);

  function Thumb() {
    var _ref;

    var _temp, _this, _ret;

    Thumb__classCallCheck(this, Thumb);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = Thumb__possibleConstructorReturn(this, (_ref = Thumb.__proto__ || Object.getPrototypeOf(Thumb)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      index: 0
    }, _this.getResizedImages = function () {
      var _this$props = _this.props,
          photos = _this$props.photos,
          width = _this$props.width,
          style = _this$props.style,
          setRatioAlbum = _this$props.setRatioAlbum;

      var height = parseInt(style.height, 10);

      return setRatioAlbum(photos, width, height || DEFAULT_HEIGHT);
    }, _this.handleSlideMouseOver = function (index) {
      var photos = _this.getResizedImages();
      var image = new Image();

      image.src = photos[index] && photos[index].image;
      image.onload = function () {
        _this.setState({ index: index });
      };
    }, _temp), Thumb__possibleConstructorReturn(_this, _ret);
  }

  Thumb__createClass(Thumb, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          maxCount = _props.maxCount,
          link = _props.link,
          style = _props.style,
          className = _props.className,
          defaultImg = _props.defaultImg,
          lensEvent = _props.lensEvent,
          alt = _props.alt,
          isLazy = _props.isLazy;


      var photos = this.getResizedImages();
      var index = this.state.index;

      var album = photos.length && photos.length > maxCount ? photos.slice(0, maxCount) : photos;

      var hasPhotos = photos.length > 0 && photos[index].image;
      var thumbnail = hasPhotos && photos[index].image ? photos[index].image : defaultImg || __WEBPACK_IMPORTED_MODULE_6_shared_assets_images_car_svg___default.a;

      return Thumb__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_3_classnames___default.a(__WEBPACK_IMPORTED_MODULE_8__Thumb_css___default.a.tmb, className, Thumb__defineProperty({}, __WEBPACK_IMPORTED_MODULE_8__Thumb_css___default.a.placeholderImg, !hasPhotos)),
        style: style
      }, void 0, link ? Thumb__jsx(__WEBPACK_IMPORTED_MODULE_2_shared_components_Link__["a" /* default */], {
        to: link,
        'data-lens-event': lensEvent
      }, void 0, Thumb__jsx(ThumbCarousel_defaultExport, {
        index: index,
        album: album,
        onMouseOver: this.handleSlideMouseOver
      })) : Thumb__jsx(ThumbCarousel_defaultExport, {
        index: index,
        album: album,
        onMouseOver: this.handleSlideMouseOver
      }), Thumb___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', _extends({}, isLazy ? { loading: 'lazy' } : {}, {
        className: __WEBPACK_IMPORTED_MODULE_8__Thumb_css___default.a.img,
        src: thumbnail.image || thumbnail,
        alt: alt,
        width: '230',
        height: '194'
      })));
    }
  }]);

  return Thumb;
}(Thumb___WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Thumb_Thumb.defaultProps = {
  photos: [],
  maxCount: 5,
  link: '',
  lensEvent: '',
  style: {},
  defaultImg: null,
  className: '',
  alt: '',
  width: 240,
  isLazy: true
};


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_5_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_8__Thumb_css___default.a)(__WEBPACK_IMPORTED_MODULE_4_shared_hocs_withPixelRatio__["a" /* default */](Thumb_Thumb)));

/***/ }),

/***/ 1437:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(1240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* eslint-disable react/prop-types */




var Col = function (_React$Component) {
  _inherits(Col, _React$Component);

  function Col() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Col);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Col.__proto__ || Object.getPrototypeOf(Col)).call.apply(_ref, [this].concat(args))), _this), _this.makeClassesByParams = function (props) {
      var resultClasses = {};
      if (props.span) {
        resultClasses['ant-col-' + props.span] = true;
      }
      return resultClasses;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Col, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          className = _props.className,
          style = _props.style,
          otherProps = _objectWithoutProperties(_props, ['children', 'className', 'style']);

      var classes = this.makeClassesByParams(otherProps);
      return _jsx('div', {
        style: style,
        className: __WEBPACK_IMPORTED_MODULE_1_classnames___default.a(className, classes)
      }, void 0, children);
    }
  }]);

  return Col;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Col.defaultProps = {
  data: function data() {
    return 'not text';
  },
  style: {},
  className: '',
  span: null
};


/* harmony default export */ __webpack_exports__["a"] = (Col);

/***/ }),

/***/ 1439:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shared_helpers_common__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_snakecase_keys__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_snakecase_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_snakecase_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_shared_constants_stats__ = __webpack_require__(497);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_shared_constants_api__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__withFetch__ = __webpack_require__(1244);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var dispatchEvent = function dispatchEvent(fetch, _ref) {
  var _ref$event = _ref.event,
      event = _ref$event === undefined ? __WEBPACK_IMPORTED_MODULE_5_shared_constants_stats__["b" /* EVENT_TYPES */].VIEW : _ref$event,
      _ref$objectType = _ref.objectType,
      objectType = _ref$objectType === undefined ? __WEBPACK_IMPORTED_MODULE_5_shared_constants_stats__["d" /* OBJECT_TYPES */].ADVERT : _ref$objectType,
      objectId = _ref.objectId,
      transport = _ref.transport,
      agency = _ref.agency,
      author = _ref.author,
      userId = _ref.userId,
      fingerprint = _ref.fingerprint,
      button = _ref.button;
  return fetch(__WEBPACK_IMPORTED_MODULE_6_shared_constants_api__["a" /* default */].STATS.BASE, {
    method: 'POST',
    body: JSON.stringify(__WEBPACK_IMPORTED_MODULE_4_snakecase_keys___default.a(_extends({
      event: event,
      button: button,
      objectType: objectType,
      objectId: objectId
    }, author ? { author: author } : {}, userId ? { userId: userId } : {}, transport ? { transport: transport } : {}, fingerprint ? { fingerprint: fingerprint } : {}, agency ? { agency: agency } : {})))
  });
};

var withStatsEvents = function withStatsEvents(WrappedComponent) {
  var _class, _temp2;

  var Component = (_temp2 = _class = function (_React$Component) {
    _inherits(Component, _React$Component);

    function Component() {
      var _ref2;

      var _temp, _this, _ret;

      _classCallCheck(this, Component);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref2 = Component.__proto__ || Object.getPrototypeOf(Component)).call.apply(_ref2, [this].concat(args))), _this), _this.events = {
        dispatchAdvertViewEvent: function dispatchAdvertViewEvent(id, authorID, transportId, agencyId) {
          var isSpare = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
          var _this$props = _this.props,
              userId = _this$props.userId,
              fingerprint = _this$props.fingerprint,
              isBot = _this$props.isBot;


          if (authorID !== userId && !isBot) {
            dispatchEvent(_this.props.fetch, {
              objectType: isSpare ? __WEBPACK_IMPORTED_MODULE_5_shared_constants_stats__["d" /* OBJECT_TYPES */].SPARE_PART : __WEBPACK_IMPORTED_MODULE_5_shared_constants_stats__["d" /* OBJECT_TYPES */].ADVERT,
              objectId: id,
              author: authorID,
              transport: transportId,
              agency: agencyId,
              userId: userId,
              fingerprint: fingerprint
            });
          }
        },

        dispatchPhoneViewEvent: function dispatchPhoneViewEvent(id, authorID, transportId, agencyId) {
          var isSpare = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
          var _this$props2 = _this.props,
              userId = _this$props2.userId,
              fingerprint = _this$props2.fingerprint;


          if (authorID !== userId) {
            dispatchEvent(_this.props.fetch, {
              objectType: isSpare ? __WEBPACK_IMPORTED_MODULE_5_shared_constants_stats__["d" /* OBJECT_TYPES */].SPARE_PART : __WEBPACK_IMPORTED_MODULE_5_shared_constants_stats__["d" /* OBJECT_TYPES */].ADVERT,
              event: __WEBPACK_IMPORTED_MODULE_5_shared_constants_stats__["b" /* EVENT_TYPES */].PHONE_CLICK,
              objectId: id,
              author: authorID,
              transport: transportId,
              agency: agencyId,
              userId: userId,
              fingerprint: fingerprint
            });
          }
        },

        dispatchDealerViewEvent: function dispatchDealerViewEvent(id) {
          var _this$props3 = _this.props,
              userId = _this$props3.userId,
              fingerprint = _this$props3.fingerprint,
              isBot = _this$props3.isBot;


          if (id && !isBot) {
            dispatchEvent(_this.props.fetch, {
              event: __WEBPACK_IMPORTED_MODULE_5_shared_constants_stats__["b" /* EVENT_TYPES */].VIEW,
              objectId: id,
              objectType: 'agency',
              userId: userId,
              fingerprint: fingerprint
            });
          }
        },

        dispatchDealerRedirectEvent: function dispatchDealerRedirectEvent(id) {
          var _this$props4 = _this.props,
              userId = _this$props4.userId,
              fingerprint = _this$props4.fingerprint;


          if (id) {
            dispatchEvent(_this.props.fetch, {
              event: __WEBPACK_IMPORTED_MODULE_5_shared_constants_stats__["b" /* EVENT_TYPES */].REDIRECT,
              objectId: id,
              objectType: 'agency',
              userId: userId,
              fingerprint: fingerprint
            });
          }
        },

        dispatchDealerShowPhoneEvent: function dispatchDealerShowPhoneEvent(id) {
          var _this$props5 = _this.props,
              userId = _this$props5.userId,
              fingerprint = _this$props5.fingerprint;


          if (id) {
            dispatchEvent(_this.props.fetch, {
              event: __WEBPACK_IMPORTED_MODULE_5_shared_constants_stats__["b" /* EVENT_TYPES */].PHONE_CLICK,
              objectId: id,
              objectType: 'agency',
              userId: userId,
              fingerprint: fingerprint
            });
          }
        },

        dispatchDealerSignUp: function dispatchDealerSignUp(id) {
          var _this$props6 = _this.props,
              userId = _this$props6.userId,
              fingerprint = _this$props6.fingerprint;


          if (id) {
            dispatchEvent(_this.props.fetch, {
              event: __WEBPACK_IMPORTED_MODULE_5_shared_constants_stats__["b" /* EVENT_TYPES */].VIEW,
              objectId: id,
              objectType: 'agency',
              button: 'appointment',
              userId: userId,
              fingerprint: fingerprint
            });
          }
        }
      }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(Component, [{
      key: 'render',
      value: function render() {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(WrappedComponent, _extends({ events: this.events }, this.props));
      }
    }]);

    return Component;
  }(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component), _class.displayName = 'withStatsEvents(' + __WEBPACK_IMPORTED_MODULE_2_shared_helpers_common__["e" /* getDisplayName */](WrappedComponent) + ')', _class.defaultProps = {
    userId: null,
    fingerprint: null
  }, _temp2);

  var mapStateToProps = function mapStateToProps(_ref3) {
    var user = _ref3.user,
        globals = _ref3.globals,
        searchForm = _ref3.searchForm;
    return {
      userId: user.user.id,
      fingerprint: globals.fingerprint,
      isBot: globals.isBot,
      formVocabulary: searchForm.vocabulary,
      formData: searchForm.data,
      formState: searchForm.selected,
      formResults: searchForm && searchForm.results
    };
  };

  return __WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */](mapStateToProps)(__WEBPACK_IMPORTED_MODULE_7__withFetch__["a" /* withFetch */](Component));
};

/* harmony default export */ __webpack_exports__["a"] = (withStatsEvents);

/***/ }),

/***/ 1441:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _prodInvariant = __webpack_require__(1400),
    _assign = __webpack_require__(188);

var ReactNoopUpdateQueue = __webpack_require__(1442);

var canDefineProperty = __webpack_require__(1443);
var emptyObject = __webpack_require__(504);
var invariant = __webpack_require__(483);
var lowPriorityWarning = __webpack_require__(1532);

/**
 * Base class helpers for the updating state of a component.
 */
function ReactComponent(props, context, updater) {
  this.props = props;
  this.context = context;
  this.refs = emptyObject;
  // We initialize the default updater but the real one gets injected by the
  // renderer.
  this.updater = updater || ReactNoopUpdateQueue;
}

ReactComponent.prototype.isReactComponent = {};

/**
 * Sets a subset of the state. Always use this to mutate
 * state. You should treat `this.state` as immutable.
 *
 * There is no guarantee that `this.state` will be immediately updated, so
 * accessing `this.state` after calling this method may return the old value.
 *
 * There is no guarantee that calls to `setState` will run synchronously,
 * as they may eventually be batched together.  You can provide an optional
 * callback that will be executed when the call to setState is actually
 * completed.
 *
 * When a function is provided to setState, it will be called at some point in
 * the future (not synchronously). It will be called with the up to date
 * component arguments (state, props, context). These values can be different
 * from this.* because your function may be called after receiveProps but before
 * shouldComponentUpdate, and this new state, props, and context will not yet be
 * assigned to this.
 *
 * @param {object|function} partialState Next partial state or function to
 *        produce next partial state to be merged with current state.
 * @param {?function} callback Called after state is updated.
 * @final
 * @protected
 */
ReactComponent.prototype.setState = function (partialState, callback) {
  !((typeof partialState === 'undefined' ? 'undefined' : _typeof(partialState)) === 'object' || typeof partialState === 'function' || partialState == null) ?  false ? invariant(false, 'setState(...): takes an object of state variables to update or a function which returns an object of state variables.') : _prodInvariant('85') : void 0;
  this.updater.enqueueSetState(this, partialState);
  if (callback) {
    this.updater.enqueueCallback(this, callback, 'setState');
  }
};

/**
 * Forces an update. This should only be invoked when it is known with
 * certainty that we are **not** in a DOM transaction.
 *
 * You may want to call this when you know that some deeper aspect of the
 * component's state has changed but `setState` was not called.
 *
 * This will not invoke `shouldComponentUpdate`, but it will invoke
 * `componentWillUpdate` and `componentDidUpdate`.
 *
 * @param {?function} callback Called after update is complete.
 * @final
 * @protected
 */
ReactComponent.prototype.forceUpdate = function (callback) {
  this.updater.enqueueForceUpdate(this);
  if (callback) {
    this.updater.enqueueCallback(this, callback, 'forceUpdate');
  }
};

/**
 * Deprecated APIs. These APIs used to exist on classic React classes but since
 * we would like to deprecate them, we're not going to move them over to this
 * modern base class. Instead, we define a getter that warns if it's accessed.
 */
if (false) {
  var deprecatedAPIs = {
    isMounted: ['isMounted', 'Instead, make sure to clean up subscriptions and pending requests in ' + 'componentWillUnmount to prevent memory leaks.'],
    replaceState: ['replaceState', 'Refactor your code to use setState instead (see ' + 'https://github.com/facebook/react/issues/3236).']
  };
  var defineDeprecationWarning = function defineDeprecationWarning(methodName, info) {
    if (canDefineProperty) {
      Object.defineProperty(ReactComponent.prototype, methodName, {
        get: function get() {
          lowPriorityWarning(false, '%s(...) is deprecated in plain JavaScript React classes. %s', info[0], info[1]);
          return undefined;
        }
      });
    }
  };
  for (var fnName in deprecatedAPIs) {
    if (deprecatedAPIs.hasOwnProperty(fnName)) {
      defineDeprecationWarning(fnName, deprecatedAPIs[fnName]);
    }
  }
}

/**
 * Base class helpers for the updating state of a component.
 */
function ReactPureComponent(props, context, updater) {
  // Duplicated from ReactComponent.
  this.props = props;
  this.context = context;
  this.refs = emptyObject;
  // We initialize the default updater but the real one gets injected by the
  // renderer.
  this.updater = updater || ReactNoopUpdateQueue;
}

function ComponentDummy() {}
ComponentDummy.prototype = ReactComponent.prototype;
ReactPureComponent.prototype = new ComponentDummy();
ReactPureComponent.prototype.constructor = ReactPureComponent;
// Avoid an extra prototype jump for these methods.
_assign(ReactPureComponent.prototype, ReactComponent.prototype);
ReactPureComponent.prototype.isPureReactComponent = true;

module.exports = {
  Component: ReactComponent,
  PureComponent: ReactPureComponent
};

/***/ }),

/***/ 1442:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var warning = __webpack_require__(1401);

function warnNoop(publicInstance, callerName) {
  if (false) {
    var constructor = publicInstance.constructor;
    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
  }
}

/**
 * This is the abstract API for an update queue.
 */
var ReactNoopUpdateQueue = {
  /**
   * Checks whether or not this composite component is mounted.
   * @param {ReactClass} publicInstance The instance we want to test.
   * @return {boolean} True if mounted, false otherwise.
   * @protected
   * @final
   */
  isMounted: function isMounted(publicInstance) {
    return false;
  },

  /**
   * Enqueue a callback that will be executed after all the pending updates
   * have processed.
   *
   * @param {ReactClass} publicInstance The instance to use as `this` context.
   * @param {?function} callback Called after state is updated.
   * @internal
   */
  enqueueCallback: function enqueueCallback(publicInstance, callback) {},

  /**
   * Forces an update. This should only be invoked when it is known with
   * certainty that we are **not** in a DOM transaction.
   *
   * You may want to call this when you know that some deeper aspect of the
   * component's state has changed but `setState` was not called.
   *
   * This will not invoke `shouldComponentUpdate`, but it will invoke
   * `componentWillUpdate` and `componentDidUpdate`.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @internal
   */
  enqueueForceUpdate: function enqueueForceUpdate(publicInstance) {
    warnNoop(publicInstance, 'forceUpdate');
  },

  /**
   * Replaces all of the state. Always use this or `setState` to mutate state.
   * You should treat `this.state` as immutable.
   *
   * There is no guarantee that `this.state` will be immediately updated, so
   * accessing `this.state` after calling this method may return the old value.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} completeState Next state.
   * @internal
   */
  enqueueReplaceState: function enqueueReplaceState(publicInstance, completeState) {
    warnNoop(publicInstance, 'replaceState');
  },

  /**
   * Sets a subset of the state. This only exists because _pendingState is
   * internal. This provides a merging strategy that is not available to deep
   * properties which is confusing. TODO: Expose pendingState or don't use it
   * during the merge.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} partialState Next partial state to be merged with state.
   * @internal
   */
  enqueueSetState: function enqueueSetState(publicInstance, partialState) {
    warnNoop(publicInstance, 'setState');
  }
};

module.exports = ReactNoopUpdateQueue;

/***/ }),

/***/ 1443:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var canDefineProperty = false;
if (false) {
  try {
    // $FlowFixMe https://github.com/facebook/flow/issues/285
    Object.defineProperty({}, 'x', { get: function get() {} });
    canDefineProperty = true;
  } catch (x) {
    // IE will fail on defineProperty
  }
}

module.exports = canDefineProperty;

/***/ }),

/***/ 1444:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



/**
 * Keeps track of the current owner.
 *
 * The current owner is the component who should own any components that are
 * currently being constructed.
 */

var ReactCurrentOwner = {
  /**
   * @internal
   * @type {ReactComponent}
   */
  current: null
};

module.exports = ReactCurrentOwner;

/***/ }),

/***/ 1445:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



// The Symbol used to tag the ReactElement type. If there is no native Symbol
// nor polyfill, then a plain number is used for performance.

var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 0xeac7;

module.exports = REACT_ELEMENT_TYPE;

/***/ }),

/***/ 1446:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// CONCATENATED MODULE: ./src/desktop/components/MakesSidebar/Title/Title.js
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Title_css__ = __webpack_require__(1469);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Title_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Title_css__);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var Title = function (_Component) {
  _inherits(Title, _Component);

  function Title() {
    _classCallCheck(this, Title);

    return _possibleConstructorReturn(this, (Title.__proto__ || Object.getPrototypeOf(Title)).apply(this, arguments));
  }

  _createClass(Title, [{
    key: 'render',
    value: function render() {
      var title = this.props.title;


      return _jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_3__Title_css___default.a.titleContainer
      }, void 0, _jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_3__Title_css___default.a.title
      }, void 0, title));
    }
  }]);

  return Title;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ var Title_defaultExport = (__WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_3__Title_css___default.a)(Title));
// CONCATENATED MODULE: ./src/desktop/components/MakesSidebar/MakesItem/MakesItem.js
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var MakesItem___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var MakesItem___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(MakesItem___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_hocs_withPixelRatio__ = __webpack_require__(1391);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__MakesItem_css__ = __webpack_require__(1471);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__MakesItem_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__MakesItem_css__);
var MakesItem__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var MakesItem__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function MakesItem__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function MakesItem__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function MakesItem__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }


// import LazyLoad from 'react-lazyload';







var MakesItem = function (_Component) {
  MakesItem__inherits(MakesItem, _Component);

  function MakesItem() {
    var _ref;

    var _temp, _this, _ret;

    MakesItem__classCallCheck(this, MakesItem);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = MakesItem__possibleConstructorReturn(this, (_ref = MakesItem.__proto__ || Object.getPrototypeOf(MakesItem)).call.apply(_ref, [this].concat(args))), _this), _this.handleLinkClick = function (link) {
      if (window) {
        window.open(link);
      }
    }, _temp), MakesItem__possibleConstructorReturn(_this, _ret);
  }

  MakesItem__createClass(MakesItem, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          title = _props.title,
          link = _props.link,
          models = _props.models,
          logo = _props.logo,
          className = _props.className,
          setRatioImage = _props.setRatioImage;


      return MakesItem__jsx('div', {
        className: className || __WEBPACK_IMPORTED_MODULE_4__MakesItem_css___default.a.makesItem
      }, void 0, MakesItem__jsx('span', {
        onClick: function onClick() {
          return _this2.handleLinkClick(link);
        }
      }, void 0), MakesItem__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_4__MakesItem_css___default.a.makeWithModels
      }, void 0, MakesItem__jsx('span', {
        className: __WEBPACK_IMPORTED_MODULE_4__MakesItem_css___default.a.make,
        onClick: function onClick() {
          return _this2.handleLinkClick(link);
        }
      }, void 0, title), MakesItem__jsx('p', {
        className: __WEBPACK_IMPORTED_MODULE_4__MakesItem_css___default.a.models
      }, void 0, models.map(function (model) {
        return MakesItem__jsx('span', {
          className: __WEBPACK_IMPORTED_MODULE_4__MakesItem_css___default.a.model,
          onClick: function onClick() {
            return _this2.handleLinkClick(model.link);
          }
        }, model.id, '' + model.title);
      }))));
    }
  }]);

  return MakesItem;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

MakesItem.defaultProps = {
  models: [],
  logo: '',
  className: ''
};


/* harmony default export */ var MakesItem_defaultExport = (MakesItem___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_4__MakesItem_css___default.a)(__WEBPACK_IMPORTED_MODULE_3_shared_hocs_withPixelRatio__["a" /* default */](MakesItem)));
// CONCATENATED MODULE: ./src/desktop/components/MakesSidebar/MakesList/MakesList.js
/* harmony import */ var MakesList___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var MakesList___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(MakesList___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var MakesList___WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var MakesList___WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(MakesList___WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var MakesList___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var MakesList___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(MakesList___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__MakesList_css__ = __webpack_require__(1473);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__MakesList_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__MakesList_css__);
var MakesList__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var MakesList__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function MakesList__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function MakesList__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function MakesList__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var MakesList_MakesList = function (_Component) {
  MakesList__inherits(MakesList, _Component);

  function MakesList() {
    MakesList__classCallCheck(this, MakesList);

    return MakesList__possibleConstructorReturn(this, (MakesList.__proto__ || Object.getPrototypeOf(MakesList)).apply(this, arguments));
  }

  MakesList__createClass(MakesList, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          list = _props.list,
          itemCN = _props.itemCN;


      return MakesList__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_4__MakesList_css___default.a.makesList
      }, void 0, list.map(function (make) {
        return MakesList__jsx(MakesItem_defaultExport, {
          title: make.title,
          logo: make.logo,
          models: make.models,
          link: make.link,
          className: itemCN
        }, make.id);
      }));
    }
  }]);

  return MakesList;
}(MakesList___WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

MakesList_MakesList.defaultProps = {
  list: [],
  itemCN: ''
};


/* harmony default export */ var MakesList_defaultExport = (MakesList___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_4__MakesList_css___default.a)(MakesList_MakesList));
// CONCATENATED MODULE: ./src/desktop/components/MakesSidebar/MakesSidebar.js
/* harmony import */ var MakesSidebar___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var MakesSidebar___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(MakesSidebar___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var MakesSidebar___WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var MakesSidebar___WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(MakesSidebar___WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_intl__ = __webpack_require__(474);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shared_constants_json_makes_json__ = __webpack_require__(1468);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shared_constants_json_makes_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_shared_constants_json_makes_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__MakesSidebar_css__ = __webpack_require__(1475);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__MakesSidebar_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__MakesSidebar_css__);
var MakesSidebar__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var MakesSidebar__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function MakesSidebar__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function MakesSidebar__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function MakesSidebar__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var MakesSidebar_MakesSidebar = function (_Component) {
  MakesSidebar__inherits(MakesSidebar, _Component);

  function MakesSidebar() {
    MakesSidebar__classCallCheck(this, MakesSidebar);

    return MakesSidebar__possibleConstructorReturn(this, (MakesSidebar.__proto__ || Object.getPrototypeOf(MakesSidebar)).apply(this, arguments));
  }

  MakesSidebar__createClass(MakesSidebar, [{
    key: 'render',


    // componentDidMount = () => {
    //   document.addEventListener('scroll', this.handleScrollPage);
    // };

    // handleScrollPage = () => {
    //   console.dir(this.sidebar);
    //   const a = this.sidebar.offsetTop;
    //   const parent = this.sidebar.parentNode;
    //   const { top } = parent.getBoundingClientRect();
    //   if (top < a) {
    //     this.sidebar.style.top = `${-top - a}px`;
    //   }
    // };

    value: function render() {
      var intl = this.props.intl;
      var _props = this.props,
          _props$title = _props.title,
          title = _props$title === undefined ? intl.formatMessage({ id: 'Популярные марки и модели' }) : _props$title,
          makes = _props.makes,
          itemCN = _props.itemCN;


      return MakesSidebar__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_7__MakesSidebar_css___default.a.makesSidebar
      }, void 0, MakesSidebar__jsx(Title_defaultExport, {
        title: title
      }), MakesSidebar__jsx(MakesList_defaultExport, {
        list: makes,
        itemCN: itemCN
      }));
    }
  }]);

  return MakesSidebar;
}(MakesSidebar___WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

MakesSidebar_MakesSidebar.defaultProps = {
  makes: __WEBPACK_IMPORTED_MODULE_4_shared_constants_json_makes_json___default.a,
  itemCN: '',
  title: undefined
};


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_7__MakesSidebar_css___default.a)(__WEBPACK_IMPORTED_MODULE_2_react_intl__["d" /* injectIntl */](MakesSidebar_MakesSidebar)));

/***/ }),

/***/ 1447:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "4502f606.svg";

/***/ }),

/***/ 1448:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "a7b38a8e.svg";

/***/ }),

/***/ 1449:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "b1e0c590.svg";

/***/ }),

/***/ 1450:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "a07b27d5.svg";

/***/ }),

/***/ 1451:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "9f233450.svg";

/***/ }),

/***/ 1452:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "113bf7af.svg";

/***/ }),

/***/ 1453:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "428c5185.svg";

/***/ }),

/***/ 1463:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return uppercaseFirst; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return stripMultipleSpaces; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return stripHTML; });
var uppercaseFirst = function uppercaseFirst(str) {
  var safeStr = str || '';
  return safeStr.charAt(0).toUpperCase() + safeStr.substr(1);
};
var stripMultipleSpaces = function stripMultipleSpaces(str) {
  return (str || '').replace(/\s+/g, ' ');
};
var stripHTML = function stripHTML(maybeString) {
  return (maybeString || '').replace(/<(?:.|\n)*?>/gm, '');
};

/***/ }),

/***/ 1464:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1465);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./ThumbCarousel.css", function() {
        content = require("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./ThumbCarousel.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 1465:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, "._1G-BW{width:100%;height:100%;padding:0 3px;position:absolute;top:0;left:0;display:-webkit-box;display:-ms-flexbox;display:flex;opacity:0;z-index:5;-webkit-transition:opacity .1s ease-in;-o-transition:opacity .1s ease-in;transition:opacity .1s ease-in;cursor:pointer}._1G-BW:hover{opacity:1}._2cmDv{-webkit-box-flex:1;-ms-flex:1 1 1px;flex:1 1 1px;position:relative}._2cmDv,._3rlOs{-webkit-box-sizing:border-box;box-sizing:border-box}._3rlOs{position:absolute;bottom:3px;left:0;right:0;width:98%;height:3px;background-color:#ffffffa1;margin:auto}.GK0g0 ._3rlOs{background-color:#ffd906}", ""]);

// exports
exports.locals = {
	"thumbCarousel": "_1G-BW",
	"slide": "_2cmDv",
	"slideButton": "_3rlOs",
	"currentSlide": "GK0g0"
};

/***/ }),

/***/ 1466:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1467);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./Thumb.css", function() {
        content = require("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./Thumb.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 1467:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, ".Dkcgo{position:relative;width:100%;height:170px;overflow:hidden;padding:0}._3w_xQ{background-color:#f1f1f1}._3w_xQ ._21viN{position:absolute;top:50%;left:50%;width:60%;height:auto;-webkit-transform:translate(-50%,-50%);transform:translate(-50%,-50%)}", ""]);

// exports
exports.locals = {
	"tmb": "Dkcgo",
	"img": "_21viN imgCover",
	"placeholderImg": "_3w_xQ"
};

/***/ }),

/***/ 1468:
/***/ (function(module, exports) {

module.exports = [{"id":0,"logo":"https://cdn-th1.ab.ua/image/497ad6596a134f46a96bfcc853ac289c/img/classifiers/Volkswagen-logo.png","title":"VW","link":"/avto/volkswagen/","models":[{"id":0,"title":"Passat","link":"/avto/volkswagen/passat/"},{"id":1,"title":"Golf","link":"/avto/volkswagen/golf/"},{"id":3,"title":"Jetta","link":"/avto/volkswagen/jetta/"},{"id":4,"title":"Golf","link":"/avto/volkswagen/touareg/"},{"id":5,"title":"Touareg","link":"/avto/volkswagen/touareg/"},{"id":6,"title":"Tiguan","link":"/avto/volkswagen/tiguan/"},{"id":7,"title":"Touran","link":"/avto/volkswagen/touran/"}]},{"id":1,"logo":"https://cdn-th1.ab.ua/image/dd227bda009c4b02ba53a732c9ad294c/img/classifiers/Ford-logo.png","title":"Ford","link":"/avto/ford/","models":[{"id":0,"title":"Fiesta","link":"/avto/ford/fiesta/"},{"id":1,"title":"Edge","link":"/avto/ford/edge/"},{"id":2,"title":"Kuga","link":"/avto/ford/kuga/"},{"id":3,"title":"Focus","link":"/avto/ford/focus/"},{"id":4,"title":"Focus","link":"/avto/ford/focus/"},{"id":5,"title":"Fusion","link":"/avto/ford/fusion/"},{"id":6,"title":"Escape","link":"/avto/ford/escape/"}]},{"id":2,"logo":"https://cdn-th1.ab.ua/image/b9b1373c2f3342bfaefbd0dd022595a7/img/classifiers/BMW-logo.png","title":"BMW","link":"/avto/bmw/","models":[{"id":0,"title":"X1","link":"/avto/bmw/x1/"},{"id":1,"title":"X3","link":"/avto/bmw/x3/"},{"id":2,"title":"X5","link":"/avto/bmw/x5/"},{"id":3,"title":"3 series","link":"/avto/bmw/3-seriya/"}]},{"id":3,"logo":"https://cdn-th1.ab.ua/image/ca00f6ece6bd43a19d32769a2a038bcc/img/classifiers/Mazda-logo.png","title":"Mazda","link":"/avto/mazda/","models":[{"id":0,"title":"6","link":"/avto/mazda/6/"},{"id":1,"title":"CX-9","link":"/avto/mazda/cx-9/"},{"id":2,"title":"CX-5","link":"/avto/mazda/cx-5/"}]},{"id":4,"logo":"https://cdn-th1.ab.ua/image/dcb79fe827cd4b95967d7b3c3b4fdda1/img/classifiers/Suzuki-logo.png","title":"Suzuki","link":"/avto/suzuki/","models":[{"id":0,"title":"Vitara","link":"/avto/suzuki/vitara/"},{"id":1,"title":"Sx4","link":"/avto/suzuki/sx4/"}]},{"id":5,"logo":"https://cdn-th1.ab.ua/image/ef706262283e475c84cffe15adc6066b/img/classifiers/Kia-logo.png","title":"Kia","link":"/avto/kia/","models":[{"id":0,"title":"Sportage","link":"/avto//kia/sportage"},{"id":1,"title":"Sorento","link":"https://ab.ua/avto/kia/sorento"},{"id":2,"title":"Niro","link":"/avto/kia/niro"}]},{"id":8,"logo":"https://cdn-th1.ab.ua/image/3b3b03df031c41c8b2e3a9d7026d0c1b/img/classifiers/Mitsubishi-logo.png","title":"Mitsubishi","link":"/avto/mitsubishi/","models":[{"id":0,"title":"ASX","link":"/avto/mitsubishi/asx/"},{"id":1,"title":"Outlander","link":"/avto/mitsubishi/outlander/"},{"id":2,"title":"Pajero Sport","link":"/avto/mitsubishi/pajero-sport/"}]},{"id":9,"logo":"https://cdn-th1.ab.ua/image/dedb40ba72e24e2eab443dff021efb8d/img/classifiers/Renault-logo.png","title":"Renault","link":"/avto/renault/","models":[{"id":0,"title":"Duster","link":"/avto/renault/duster/"},{"id":1,"title":"Captur","link":"/avto/renault/captur/"},{"id":2,"title":"Megane","link":"/avto/renault/megane/"},{"id":3,"title":"Sandero","link":"/avto/renault/sandero-1/"},{"id":4,"title":"Logan","link":"/avto/renault/logan/"}]},{"id":10,"logo":"https://cdn-th1.ab.ua/image/aaa7e3f5af0540239a3802b565b7c051/img/classifiers/Peugeot-logo.png","title":"Peugeot","link":"/avto/peugeot/","models":[{"id":0,"title":"208","link":"/avto/peugeot/208/"},{"id":1,"title":"308","link":"/avto/peugeot/308/"},{"id":2,"title":"3008","link":"/avto/peugeot/3008/"}]},{"id":11,"logo":"https://cdn-th1.ab.ua/image/74b998215679498ca93047b032274678/img/classifiers/Skoda-logo.png","title":"Skoda","link":"/avto/skoda/","models":[{"id":0,"title":"Rapid","link":"/avto/skoda/rapid-1/"},{"id":1,"title":"Octavia","link":"/avto/skoda/octavia/"},{"id":2,"title":"Kodiaq","link":"/avto/skoda/octavia/"},{"id":3,"title":"Karoq","link":"/avto/skoda/karoq/"}]},{"id":12,"logo":"https://cdn-th1.ab.ua/image/6cd481e3d49941819ccd6e4c29df2d95/img/classifiers/Mercedes-Benz-logo.png","title":"Mercedes-Benz","link":"/avto/mercedes-benz/","models":[{"id":0,"title":"S","link":"/avto/mercedes-benz/s-klass/"},{"id":1,"title":"GLA","link":"/avto/mercedes-benz/gla-klass/"},{"id":2,"title":"CLA","link":"/avto/mercedes-benz/cla-klass/"}]},{"id":13,"logo":"https://cdn-th1.ab.ua/image/c260d4a2e4a0476a87cd00de992f56cc/img/classifiers/Toyota-logo.png","title":"Toyota","link":"/avto/toyota/","models":[{"id":0,"title":"Corolla","link":"/avto/toyota/"},{"id":1,"title":"Camry","link":"/avto/toyota/camry/"},{"id":2,"title":"RAV 4","link":"/avto/toyota/rav4/"}]}]

/***/ }),

/***/ 1469:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1470);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./Title.css", function() {
        content = require("!!../../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./Title.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 1470:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, "._3V9RQ{-webkit-box-align:center;-ms-flex-align:center;align-items:center;background:transparent;border-bottom:3px solid #ffeb3b;padding:8px 10px}._2fhat{font-size:16px;font-weight:700;line-height:24px;margin:0;color:#000}", ""]);

// exports
exports.locals = {
	"titleContainer": "_3V9RQ",
	"title": "_2fhat"
};

/***/ }),

/***/ 1471:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1472);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./MakesItem.css", function() {
        content = require("!!../../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./MakesItem.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 1472:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, "._3Kv4F{position:relative;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-flex:1;-ms-flex:1 1 50%;flex:1 1 50%;-webkit-box-align:baseline;-ms-flex-align:baseline;align-items:baseline;padding:6px 0 8px;font-weight:400}._1QEPi{width:30px;margin-right:10px;border:none;cursor:pointer}._1weVC{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;padding-right:5px}.zJ6Ue{margin:0;font-size:16px;font-weight:700;line-height:21px;text-decoration:none;color:#000;padding-bottom:3px;cursor:pointer}._3xqxl{margin:0;font-size:12px;line-height:16px}.qT-Bi{color:#666b6f;text-decoration:none;font-size:13px;line-height:1.43;outline:none;cursor:pointer}.qT-Bi:after{content:\", \";display:inline}.qT-Bi:last-child:after{content:none}.qT-Bi:hover{color:#e73232;text-decoration:none}.qT-Bi:hover:after{color:#666b6f}", ""]);

// exports
exports.locals = {
	"makesItem": "_3Kv4F",
	"logo": "_1QEPi",
	"makeWithModels": "_1weVC",
	"make": "zJ6Ue",
	"models": "_3xqxl",
	"model": "qT-Bi"
};

/***/ }),

/***/ 1473:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1474);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./MakesList.css", function() {
        content = require("!!../../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./MakesList.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 1474:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, "._1dGx7{position:relative;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-flow:row wrap;flex-flow:row wrap;list-style:none;padding:3px 10px 10px;margin:0}", ""]);

// exports
exports.locals = {
	"makesList": "_1dGx7"
};

/***/ }),

/***/ 1475:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1476);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./MakesSidebar.css", function() {
        content = require("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./MakesSidebar.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 1476:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, "._1fc7e{position:relative;z-index:1;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;background:#fff;-webkit-box-shadow:0 2px 8px rgba(0,0,0,.04);box-shadow:0 2px 8px rgba(0,0,0,.04);border-radius:2px;margin-bottom:30px}", ""]);

// exports
exports.locals = {
	"makesSidebar": "_1fc7e"
};

/***/ }),

/***/ 1497:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// CONCATENATED MODULE: ./src/shared/hocs/withPaginate.js
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shared_helpers_common__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_query_string__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_query_string___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_query_string__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__history__ = __webpack_require__(185);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var MAX_PAGE_COUNT = 500;

var withPaginate = function withPaginate(WrappedComponent) {
  var _class, _temp2;

  return _temp2 = _class = function (_React$Component) {
    _inherits(_class, _React$Component);

    function _class() {
      var _ref;

      var _temp, _this, _ret;

      _classCallCheck(this, _class);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = _class.__proto__ || Object.getPrototypeOf(_class)).call.apply(_ref, [this].concat(args))), _this), _this.pageChanger = function (_ref2) {
        var selected = _ref2.selected;
        var _history$location = __WEBPACK_IMPORTED_MODULE_4__history__["a" /* default */].location,
            search = _history$location.search,
            pathname = _history$location.pathname;
        var anchor = _this.props.anchor;

        var query = __WEBPACK_IMPORTED_MODULE_3_query_string___default.a.parse(search);
        var searchInfo = __WEBPACK_IMPORTED_MODULE_3_query_string___default.a.stringify(_extends({}, query, { page: selected ? selected + 1 : undefined }));

        __WEBPACK_IMPORTED_MODULE_4__history__["a" /* default */].push('' + pathname + (searchInfo ? '?' + searchInfo : '') + anchor);
      }, _this.hrefBuilder = function (pageIndex) {
        var url = _this.props.url;

        var searchInfo = __WEBPACK_IMPORTED_MODULE_3_query_string___default.a.stringify(_extends({}, pageIndex && pageIndex > 1 ? { page: pageIndex || undefined } : {}));

        return '' + (url || '') + (searchInfo ? '?' + searchInfo : '');
      }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(_class, [{
      key: 'render',
      value: function render() {
        var _props = this.props,
            pageCount = _props.pageCount,
            url = _props.url,
            query = _props.query,
            props = _objectWithoutProperties(_props, ['pageCount', 'url', 'query']);

        var transformedPageCount = Math.min(parseInt(pageCount, 10), MAX_PAGE_COUNT);

        var key = (url || '') + '-' + JSON.stringify(query || {});

        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(WrappedComponent, _extends({
          key: key,
          hrefBuilder: this.hrefBuilder,
          pageChanger: this.pageChanger,
          pageCount: transformedPageCount,
          url: url,
          query: query
        }, props));
      }
    }]);

    return _class;
  }(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component), _class.displayName = 'withPaginate(' + __WEBPACK_IMPORTED_MODULE_2_shared_helpers_common__["e" /* getDisplayName */](WrappedComponent) + ')', _class.defaultProps = {
    pageCount: 1,
    url: null,
    query: null,
    anchor: ''
  }, _temp2;
};

/* harmony default export */ var withPaginate_defaultExport = (withPaginate);
// CONCATENATED MODULE: ./src/desktop/components/Paginate/Paginate.js
/* harmony import */ var Paginate___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var Paginate___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(Paginate___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_paginate__ = __webpack_require__(1529);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_paginate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_paginate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_intl__ = __webpack_require__(474);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_redux__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Paginate_css__ = __webpack_require__(1552);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Paginate_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__Paginate_css__);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();










var _ref2 = _jsx(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */], {
  id: '\u0412\u0441\u0435\u0433\u043E'
});

function Paginate(props) {
  var pageCount = props.pageCount,
      initialPage = props.initialPage,
      pageRangeDisplayed = props.pageRangeDisplayed,
      hrefBuilder = props.hrefBuilder,
      pageChanger = props.pageChanger,
      overallCount = props.overallCount,
      backgroundColor = props.backgroundColor,
      intl = props.intl;

  var prevClassName = initialPage === 1 ? __WEBPACK_IMPORTED_MODULE_7__Paginate_css___default.a.hidden : __WEBPACK_IMPORTED_MODULE_7__Paginate_css___default.a.previous;
  var nextClassName = initialPage === pageCount ? __WEBPACK_IMPORTED_MODULE_7__Paginate_css___default.a.hidden : __WEBPACK_IMPORTED_MODULE_7__Paginate_css___default.a.next;

  return _jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_7__Paginate_css___default.a.root
  }, void 0, _jsx('div', {}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_3_react_paginate___default.a, {
    pageCount: pageCount,
    pageRangeDisplayed: pageRangeDisplayed,
    initialPage: initialPage - 1,
    previousLabel: intl.formatMessage({ id: 'Предыдущая' }),
    nextLabel: intl.formatMessage({ id: 'Следующая' }),
    breakLabel: '...',
    disableInitialCallback: true,
    onPageChange: pageChanger,
    hrefBuilder: hrefBuilder,
    breakClassName: __WEBPACK_IMPORTED_MODULE_7__Paginate_css___default.a.breakMe,
    containerClassName: __WEBPACK_IMPORTED_MODULE_7__Paginate_css___default.a.pagination,
    previousClassName: prevClassName,
    nextClassName: nextClassName,
    activeClassName: backgroundColor || __WEBPACK_IMPORTED_MODULE_7__Paginate_css___default.a.activePage,
    subContainerClassName: '',
    pageClassName: __WEBPACK_IMPORTED_MODULE_7__Paginate_css___default.a.pageItem
  })), overallCount > 0 && _jsx('div', {}, void 0, _ref2, ': ', _jsx('strong', {}, void 0, overallCount)));
}

Paginate.defaultProps = {
  initialPage: 1,
  pageRangeDisplayed: 2,
  overallCount: 0,
  backgroundColor: ''
};


var mapStateToProps = function mapStateToProps(_ref) {
  var globals = _ref.globals;
  return { locale: globals.locale };
};

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_1_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_7__Paginate_css___default.a)(__WEBPACK_IMPORTED_MODULE_4_react_intl__["d" /* injectIntl */](__WEBPACK_IMPORTED_MODULE_5_react_redux__["b" /* connect */](mapStateToProps)(withPaginate_defaultExport(Paginate)))));

/***/ }),

/***/ 1498:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// CONCATENATED MODULE: ./src/shared/components/AntdComponents/Button/AntdButton.js
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(1240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Icon_Icon__ = __webpack_require__(1410);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* eslint-disable no-fallthrough */
/* eslint-disable react/prop-types */
/* eslint-disable react/sort-comp */
/* eslint-disable react/require-default-props */
/* eslint-disable no-param-reassign */
/* eslint-disable consistent-return */



// import Wave from '../_util/wave';

// import Group from './button-group';

var rxTwoCNChar = /^[\u4e00-\u9fa5]{2}$/;
var isTwoCNChar = rxTwoCNChar.test.bind(rxTwoCNChar);
function isString(str) {
  return typeof str === 'string';
}

// Insert one space between two chinese characters automatically.
function insertSpace(child, needInserted) {
  // Check the child if is undefined or null.
  if (child == null) {
    return;
  }
  var SPACE = needInserted ? ' ' : '';
  // strictNullChecks oops.
  if (typeof child !== 'string' && typeof child !== 'number' && isString(child.type) && isTwoCNChar(child.props.children)) {
    return __WEBPACK_IMPORTED_MODULE_0_react__["cloneElement"](child, {}, child.props.children.split('').join(SPACE));
  }

  if (typeof child === 'string') {
    if (isTwoCNChar(child)) {
      child = child.split('').join(SPACE);
    }
    return _jsx('span', {}, void 0, child);
  }

  return child;
}

var AntdButton = function (_React$Component) {
  _inherits(AntdButton, _React$Component);

  // : HTMLElement | null;

  // : number;
  // : typeof Group;
  function AntdButton(props) {
    _classCallCheck(this, AntdButton);

    var _this = _possibleConstructorReturn(this, (AntdButton.__proto__ || Object.getPrototypeOf(AntdButton)).call(this, props));

    _this.saveButtonRef = function (node) {
      _this.buttonNode = node;
    };

    _this.handleClick = function (e) {
      var loading = _this.state.loading;
      var onClick = _this.props.onClick;

      if (loading) {
        return;
      }
      if (onClick) {
        onClick(e);
      }
    };

    _this.state = {
      loading: props.loading,
      hasTwoCNChar: false
    };
    return _this;
  }

  _createClass(AntdButton, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.fixTwoCNChar();
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _this2 = this;

      var currentLoading = this.props.loading;
      var loading = nextProps.loading;

      if (currentLoading) {
        clearTimeout(this.delayTimeout);
      }

      if (typeof loading !== 'boolean' && loading && loading.delay) {
        this.delayTimeout = window.setTimeout(function () {
          return _this2.setState({ loading: loading });
        }, loading.delay);
      } else {
        this.setState({ loading: loading });
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      this.fixTwoCNChar();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.delayTimeout) {
        clearTimeout(this.delayTimeout);
      }
    }
  }, {
    key: 'fixTwoCNChar',
    value: function fixTwoCNChar() {
      // Fix for HOC usage like <FormatMessage />
      if (!this.buttonNode) {
        return;
      }
      var buttonText = this.buttonNode.textContent || this.buttonNode.innerText;
      if (this.isNeedInserted() && isTwoCNChar(buttonText)) {
        if (!this.state.hasTwoCNChar) {
          this.setState({
            hasTwoCNChar: true
          });
        }
      } else if (this.state.hasTwoCNChar) {
        this.setState({
          hasTwoCNChar: false
        });
      }
    }
  }, {
    key: 'isNeedInserted',
    value: function isNeedInserted() {
      var _props = this.props,
          icon = _props.icon,
          children = _props.children;

      return __WEBPACK_IMPORTED_MODULE_0_react__["Children"].count(children) === 1 && !icon;
    }
  }, {
    key: 'render',
    value: function render() {
      var _classNames,
          _this3 = this;

      var _props2 = this.props,
          type = _props2.type,
          shape = _props2.shape,
          size = _props2.size,
          className = _props2.className,
          children = _props2.children,
          icon = _props2.icon,
          prefixCls = _props2.prefixCls,
          ghost = _props2.ghost,
          _loadingProp = _props2.loading,
          block = _props2.block,
          rest = _objectWithoutProperties(_props2, ['type', 'shape', 'size', 'className', 'children', 'icon', 'prefixCls', 'ghost', 'loading', 'block']);

      var _state = this.state,
          loading = _state.loading,
          hasTwoCNChar = _state.hasTwoCNChar;

      // large => lg
      // small => sm

      var sizeCls = '';
      switch (size) {
        case 'large':
          sizeCls = 'lg';
          break;
        case 'small':
          sizeCls = 'sm';
        default:
          break;
      }

      var now = new Date();
      var isChristmas = now.getMonth() === 11 && now.getDate() === 25;
      var classes = __WEBPACK_IMPORTED_MODULE_2_classnames___default.a(prefixCls, className, (_classNames = {}, _defineProperty(_classNames, prefixCls + '-' + type, type), _defineProperty(_classNames, prefixCls + '-' + shape, shape), _defineProperty(_classNames, prefixCls + '-' + sizeCls, sizeCls), _defineProperty(_classNames, prefixCls + '-icon-only', !children && icon), _defineProperty(_classNames, prefixCls + '-loading', loading), _defineProperty(_classNames, prefixCls + '-background-ghost', ghost), _defineProperty(_classNames, prefixCls + '-two-chinese-chars', hasTwoCNChar), _defineProperty(_classNames, prefixCls + '-block', block), _defineProperty(_classNames, 'christmas', isChristmas), _classNames));

      var iconType = loading ? 'loading' : icon;
      var iconNode = iconType ? _jsx(__WEBPACK_IMPORTED_MODULE_3__Icon_Icon__["a" /* default */], {
        type: iconType
      }) : null;
      var kids = children || children === 0 ? __WEBPACK_IMPORTED_MODULE_0_react__["Children"].map(children, function (child) {
        return insertSpace(child, _this3.isNeedInserted());
      }) : null;

      var title = isChristmas ? 'Ho Ho Ho!' : rest.title;

      var linkButtonRestProps = rest;
      if (linkButtonRestProps.href !== undefined) {
        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
          'a',
          _extends({}, linkButtonRestProps, {
            className: classes,
            onClick: this.handleClick,
            title: title,
            ref: this.saveButtonRef
          }),
          iconNode,
          kids
        );
      }

      // React does not recognize the `htmlType` prop on a DOM element. Here we pick it out of `rest`.

      var htmlType = rest.htmlType,
          otherProps = _objectWithoutProperties(rest, ['htmlType']);

      return (
        // <Wave>
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
          'button',
          _extends({}, otherProps, {
            type: htmlType || 'button',
            className: classes,
            onClick: this.handleClick,
            title: title,
            ref: this.saveButtonRef
          }),
          iconNode,
          kids
        )
        // </Wave>

      );
    }
  }]);

  return AntdButton;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

AntdButton.__ANT_BUTTON = true;
AntdButton.defaultProps = {
  prefixCls: 'ant-btn',
  loading: false,
  ghost: false,
  block: false
};
/* harmony default export */ var AntdButton_defaultExport = (AntdButton);
// CONCATENATED MODULE: ./src/shared/components/AntdComponents/Button/Button.js
/* harmony import */ var Button___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var Button___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(Button___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var Button___WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var Button___WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(Button___WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Button_css__ = __webpack_require__(1508);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Button_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__Button_css__);
var Button__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function Button__objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }







function Button(props) {
  var children = props.children,
      other = Button__objectWithoutProperties(props, ['children']);

  return Button___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    AntdButton_defaultExport,
    Button__extends({ className: __WEBPACK_IMPORTED_MODULE_4__Button_css___default.a.buttonForm }, other),
    children
  );
}

Button.defaultProps = {};


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_4__Button_css___default.a)(Button));

/***/ }),

/***/ 1508:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1509);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./Button.css", function() {
        content = require("!!../../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./Button.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 1509:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, "._23ntt{margin-bottom:20px}._3w6zH{position:relative}._13plR{-webkit-box-sizing:border-box;box-sizing:border-box;height:31px;border:0;border-radius:3px;text-decoration:none;line-height:1.3333333;cursor:pointer;outline:none;padding:5px 16px;color:#fff;background-color:#1890ff}._13plR>p{margin:0}._13plR:hover{background:#1890ffb5}", ""]);

// exports
exports.locals = {
	"gptPremium": "_23ntt",
	"flexCell": "_3w6zH",
	"buttonForm": "_13plR"
};

/***/ }),

/***/ 1528:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return topMakesAvto; });
var topMakesAvto = [8, 11, 19, 20, 22, 25, 35, 37, 41, 49, 52, 62, 68, 75, 179, 81, 83, 85, 87, 93, 101, 106, 107, 113, 118, 3259, 125, 126, 130,
// commercial
4341, 4329, 4338, 4328, 4335, 4337, 4367, 4333, 4331, 4330,
// bus
4207, 4219, 4247, 4220, 4217, 4224, 4236, 4245,
// pritsepy
5064, 4940, 4928, 4930, 4933, 4935, 4944, 4923, 4962, 5217,
// spetstekhyka
4475, 4439, 4493, 4469, 4453, 4482, 11361, 4441, 4449, 4437,
// moto
3337, 3386, 3341, 3365, 3355, 3347, 3383, 3343, 3351, 3352];

/***/ }),

/***/ 1529:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _PaginationBoxView = __webpack_require__(1530);

var _PaginationBoxView2 = _interopRequireDefault(_PaginationBoxView);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

module.exports = _PaginationBoxView2.default;
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 1530:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

var _react = __webpack_require__(1411);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(1548);

var _classnames2 = _interopRequireDefault(_classnames);

var _reactAddonsCreateFragment = __webpack_require__(1549);

var _reactAddonsCreateFragment2 = _interopRequireDefault(_reactAddonsCreateFragment);

var _PageView = __webpack_require__(1550);

var _PageView2 = _interopRequireDefault(_PageView);

var _BreakView = __webpack_require__(1551);

var _BreakView2 = _interopRequireDefault(_BreakView);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }return obj;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var PaginationBoxView = function (_Component) {
  _inherits(PaginationBoxView, _Component);

  function PaginationBoxView(props) {
    _classCallCheck(this, PaginationBoxView);

    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(PaginationBoxView).call(this, props));

    _this.handlePreviousPage = function (evt) {
      evt.preventDefault ? evt.preventDefault() : evt.returnValue = false;
      if (_this.state.selected > 0) {
        _this.handlePageSelected(_this.state.selected - 1, evt);
      }
    };

    _this.handleNextPage = function (evt) {
      evt.preventDefault ? evt.preventDefault() : evt.returnValue = false;
      if (_this.state.selected < _this.props.pageCount - 1) {
        _this.handlePageSelected(_this.state.selected + 1, evt);
      }
    };

    _this.handlePageSelected = function (selected, evt) {
      evt.preventDefault ? evt.preventDefault() : evt.returnValue = false;

      if (_this.state.selected === selected) return;

      _this.setState({ selected: selected });

      // Call the callback with the new selected item:
      _this.callCallback(selected);
    };

    _this.callCallback = function (selectedItem) {
      if (typeof _this.props.onPageChange !== "undefined" && typeof _this.props.onPageChange === "function") {
        _this.props.onPageChange({ selected: selectedItem });
      }
    };

    _this.pagination = function () {
      var items = {};

      if (_this.props.pageCount <= _this.props.pageRangeDisplayed) {

        for (var index = 0; index < _this.props.pageCount; index++) {
          items['key' + index] = _this.getPageElement(index);
        }
      } else {

        var leftSide = _this.props.pageRangeDisplayed / 2;
        var rightSide = _this.props.pageRangeDisplayed - leftSide;

        if (_this.state.selected > _this.props.pageCount - _this.props.pageRangeDisplayed / 2) {
          rightSide = _this.props.pageCount - _this.state.selected;
          leftSide = _this.props.pageRangeDisplayed - rightSide;
        } else if (_this.state.selected < _this.props.pageRangeDisplayed / 2) {
          leftSide = _this.state.selected;
          rightSide = _this.props.pageRangeDisplayed - leftSide;
        }

        var _index = void 0;
        var page = void 0;
        var breakView = void 0;

        for (_index = 0; _index < _this.props.pageCount; _index++) {

          page = _index + 1;

          var pageView = _this.getPageElement(_index);

          if (page <= _this.props.marginPagesDisplayed) {
            items['key' + _index] = pageView;
            continue;
          }

          if (page > _this.props.pageCount - _this.props.marginPagesDisplayed) {
            items['key' + _index] = pageView;
            continue;
          }

          if (_index >= _this.state.selected - leftSide && _index <= _this.state.selected + rightSide) {
            items['key' + _index] = pageView;
            continue;
          }

          var keys = Object.keys(items);
          var breakLabelKey = keys[keys.length - 1];
          var breakLabelValue = items[breakLabelKey];

          if (_this.props.breakLabel && breakLabelValue !== breakView) {
            breakView = _react2.default.createElement(_BreakView2.default, {
              breakLabel: _this.props.breakLabel,
              breakClassName: _this.props.breakClassName
            });

            items['key' + _index] = breakView;
          }
        }
      }

      return items;
    };

    _this.state = {
      selected: props.initialPage ? props.initialPage : props.forcePage ? props.forcePage : 0
    };
    return _this;
  }

  _createClass(PaginationBoxView, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      // Call the callback with the initialPage item:
      if (typeof this.props.initialPage !== 'undefined' && !this.props.disableInitialCallback) {
        this.callCallback(this.props.initialPage);
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (typeof nextProps.forcePage !== 'undefined' && this.props.forcePage !== nextProps.forcePage) {
        this.setState({ selected: nextProps.forcePage });
      }
    }
  }, {
    key: 'hrefBuilder',
    value: function hrefBuilder(pageIndex) {
      if (this.props.hrefBuilder && pageIndex !== this.state.selected && pageIndex >= 0 && pageIndex < this.props.pageCount) {
        return this.props.hrefBuilder(pageIndex + 1);
      }
    }
  }, {
    key: 'getPageElement',
    value: function getPageElement(index) {
      return _react2.default.createElement(_PageView2.default, {
        onClick: this.handlePageSelected.bind(null, index),
        selected: this.state.selected === index,
        pageClassName: this.props.pageClassName,
        pageLinkClassName: this.props.pageLinkClassName,
        activeClassName: this.props.activeClassName,
        extraAriaContext: this.props.extraAriaContext,
        href: this.hrefBuilder(index),
        page: index + 1 });
    }
  }, {
    key: 'render',
    value: function render() {
      var disabled = this.props.disabledClassName;

      var previousClasses = (0, _classnames2.default)(this.props.previousClassName, _defineProperty({}, disabled, this.state.selected === 0));

      var nextClasses = (0, _classnames2.default)(this.props.nextClassName, _defineProperty({}, disabled, this.state.selected === this.props.pageCount - 1));

      return _react2.default.createElement('ul', { className: this.props.containerClassName }, _react2.default.createElement('li', { className: previousClasses }, _react2.default.createElement('a', { onClick: this.handlePreviousPage,
        className: this.props.previousLinkClassName,
        href: this.hrefBuilder(this.state.selected - 1),
        tabIndex: '0',
        onKeyPress: this.handlePreviousPage }, this.props.previousLabel)), (0, _reactAddonsCreateFragment2.default)(this.pagination()), _react2.default.createElement('li', { className: nextClasses }, _react2.default.createElement('a', { onClick: this.handleNextPage,
        className: this.props.nextLinkClassName,
        href: this.hrefBuilder(this.state.selected + 1),
        tabIndex: '0',
        onKeyPress: this.handleNextPage }, this.props.nextLabel)));
    }
  }]);

  return PaginationBoxView;
}(_react.Component);

PaginationBoxView.propTypes = {
  pageCount: _react.PropTypes.number.isRequired,
  pageRangeDisplayed: _react.PropTypes.number.isRequired,
  marginPagesDisplayed: _react.PropTypes.number.isRequired,
  previousLabel: _react.PropTypes.node,
  nextLabel: _react.PropTypes.node,
  breakLabel: _react.PropTypes.node,
  hrefBuilder: _react.PropTypes.func,
  onPageChange: _react.PropTypes.func,
  initialPage: _react.PropTypes.number,
  forcePage: _react.PropTypes.number,
  disableInitialCallback: _react.PropTypes.bool,
  containerClassName: _react.PropTypes.string,
  pageClassName: _react.PropTypes.string,
  pageLinkClassName: _react.PropTypes.string,
  activeClassName: _react.PropTypes.string,
  previousClassName: _react.PropTypes.string,
  nextClassName: _react.PropTypes.string,
  previousLinkClassName: _react.PropTypes.string,
  nextLinkClassName: _react.PropTypes.string,
  disabledClassName: _react.PropTypes.string,
  breakClassName: _react.PropTypes.string
};
PaginationBoxView.defaultProps = {
  pageCount: 10,
  pageRangeDisplayed: 2,
  marginPagesDisplayed: 3,
  activeClassName: "selected",
  previousClassName: "previous",
  nextClassName: "next",
  previousLabel: "Previous",
  nextLabel: "Next",
  breakLabel: "...",
  disabledClassName: "disabled",
  disableInitialCallback: false
};
exports.default = PaginationBoxView;
;
//# sourceMappingURL=PaginationBoxView.js.map

/***/ }),

/***/ 1531:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(188);

var ReactBaseClasses = __webpack_require__(1441);
var ReactChildren = __webpack_require__(1533);
var ReactDOMFactories = __webpack_require__(1538);
var ReactElement = __webpack_require__(1393);
var ReactPropTypes = __webpack_require__(1539);
var ReactVersion = __webpack_require__(1545);

var createReactClass = __webpack_require__(1546);
var onlyChild = __webpack_require__(1547);

var createElement = ReactElement.createElement;
var createFactory = ReactElement.createFactory;
var cloneElement = ReactElement.cloneElement;

if (false) {
  var lowPriorityWarning = require('./lowPriorityWarning');
  var canDefineProperty = require('./canDefineProperty');
  var ReactElementValidator = require('./ReactElementValidator');
  var didWarnPropTypesDeprecated = false;
  createElement = ReactElementValidator.createElement;
  createFactory = ReactElementValidator.createFactory;
  cloneElement = ReactElementValidator.cloneElement;
}

var __spread = _assign;
var createMixin = function createMixin(mixin) {
  return mixin;
};

if (false) {
  var warnedForSpread = false;
  var warnedForCreateMixin = false;
  __spread = function __spread() {
    lowPriorityWarning(warnedForSpread, 'React.__spread is deprecated and should not be used. Use ' + 'Object.assign directly or another helper function with similar ' + 'semantics. You may be seeing this warning due to your compiler. ' + 'See https://fb.me/react-spread-deprecation for more details.');
    warnedForSpread = true;
    return _assign.apply(null, arguments);
  };

  createMixin = function createMixin(mixin) {
    lowPriorityWarning(warnedForCreateMixin, 'React.createMixin is deprecated and should not be used. ' + 'In React v16.0, it will be removed. ' + 'You can use this mixin directly instead. ' + 'See https://fb.me/createmixin-was-never-implemented for more info.');
    warnedForCreateMixin = true;
    return mixin;
  };
}

var React = {
  // Modern

  Children: {
    map: ReactChildren.map,
    forEach: ReactChildren.forEach,
    count: ReactChildren.count,
    toArray: ReactChildren.toArray,
    only: onlyChild
  },

  Component: ReactBaseClasses.Component,
  PureComponent: ReactBaseClasses.PureComponent,

  createElement: createElement,
  cloneElement: cloneElement,
  isValidElement: ReactElement.isValidElement,

  // Classic

  PropTypes: ReactPropTypes,
  createClass: createReactClass,
  createFactory: createFactory,
  createMixin: createMixin,

  // This looks DOM specific but these are actually isomorphic helpers
  // since they are just generating DOM strings.
  DOM: ReactDOMFactories,

  version: ReactVersion,

  // Deprecated hook for JSX spread, don't use this for anything.
  __spread: __spread
};

if (false) {
  var warnedForCreateClass = false;
  if (canDefineProperty) {
    Object.defineProperty(React, 'PropTypes', {
      get: function get() {
        lowPriorityWarning(didWarnPropTypesDeprecated, 'Accessing PropTypes via the main React package is deprecated,' + ' and will be removed in  React v16.0.' + ' Use the latest available v15.* prop-types package from npm instead.' + ' For info on usage, compatibility, migration and more, see ' + 'https://fb.me/prop-types-docs');
        didWarnPropTypesDeprecated = true;
        return ReactPropTypes;
      }
    });

    Object.defineProperty(React, 'createClass', {
      get: function get() {
        lowPriorityWarning(warnedForCreateClass, 'Accessing createClass via the main React package is deprecated,' + ' and will be removed in React v16.0.' + " Use a plain JavaScript class instead. If you're not yet " + 'ready to migrate, create-react-class v15.* is available ' + 'on npm as a temporary, drop-in replacement. ' + 'For more info see https://fb.me/react-create-class');
        warnedForCreateClass = true;
        return createReactClass;
      }
    });
  }

  // React.DOM factories are deprecated. Wrap these methods so that
  // invocations of the React.DOM namespace and alert users to switch
  // to the `react-dom-factories` package.
  React.DOM = {};
  var warnedForFactories = false;
  Object.keys(ReactDOMFactories).forEach(function (factory) {
    React.DOM[factory] = function () {
      if (!warnedForFactories) {
        lowPriorityWarning(false, 'Accessing factories like React.DOM.%s has been deprecated ' + 'and will be removed in v16.0+. Use the ' + 'react-dom-factories package instead. ' + ' Version 1.0 provides a drop-in replacement.' + ' For more info, see https://fb.me/react-dom-factories', factory);
        warnedForFactories = true;
      }
      return ReactDOMFactories[factory].apply(ReactDOMFactories, arguments);
    };
  });
}

module.exports = React;

/***/ }),

/***/ 1532:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Forked from fbjs/warning:
 * https://github.com/facebook/fbjs/blob/e66ba20ad5be433eb54423f2b097d829324d9de6/packages/fbjs/src/__forks__/warning.js
 *
 * Only change is we use console.warn instead of console.error,
 * and do nothing when 'console' is not supported.
 * This really simplifies the code.
 * ---
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var lowPriorityWarning = function lowPriorityWarning() {};

if (false) {
  var printWarning = function printWarning(format) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    var argIndex = 0;
    var message = 'Warning: ' + format.replace(/%s/g, function () {
      return args[argIndex++];
    });
    if (typeof console !== 'undefined') {}
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };

  lowPriorityWarning = function lowPriorityWarning(condition, format) {
    if (format === undefined) {
      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
    }
    if (!condition) {
      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
        args[_key2 - 2] = arguments[_key2];
      }

      printWarning.apply(undefined, [format].concat(args));
    }
  };
}

module.exports = lowPriorityWarning;

/***/ }),

/***/ 1533:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var PooledClass = __webpack_require__(1534);
var ReactElement = __webpack_require__(1393);

var emptyFunction = __webpack_require__(490);
var traverseAllChildren = __webpack_require__(1535);

var twoArgumentPooler = PooledClass.twoArgumentPooler;
var fourArgumentPooler = PooledClass.fourArgumentPooler;

var userProvidedKeyEscapeRegex = /\/+/g;
function escapeUserProvidedKey(text) {
  return ('' + text).replace(userProvidedKeyEscapeRegex, '$&/');
}

/**
 * PooledClass representing the bookkeeping associated with performing a child
 * traversal. Allows avoiding binding callbacks.
 *
 * @constructor ForEachBookKeeping
 * @param {!function} forEachFunction Function to perform traversal with.
 * @param {?*} forEachContext Context to perform context with.
 */
function ForEachBookKeeping(forEachFunction, forEachContext) {
  this.func = forEachFunction;
  this.context = forEachContext;
  this.count = 0;
}
ForEachBookKeeping.prototype.destructor = function () {
  this.func = null;
  this.context = null;
  this.count = 0;
};
PooledClass.addPoolingTo(ForEachBookKeeping, twoArgumentPooler);

function forEachSingleChild(bookKeeping, child, name) {
  var func = bookKeeping.func,
      context = bookKeeping.context;

  func.call(context, child, bookKeeping.count++);
}

/**
 * Iterates through children that are typically specified as `props.children`.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.foreach
 *
 * The provided forEachFunc(child, index) will be called for each
 * leaf child.
 *
 * @param {?*} children Children tree container.
 * @param {function(*, int)} forEachFunc
 * @param {*} forEachContext Context for forEachContext.
 */
function forEachChildren(children, forEachFunc, forEachContext) {
  if (children == null) {
    return children;
  }
  var traverseContext = ForEachBookKeeping.getPooled(forEachFunc, forEachContext);
  traverseAllChildren(children, forEachSingleChild, traverseContext);
  ForEachBookKeeping.release(traverseContext);
}

/**
 * PooledClass representing the bookkeeping associated with performing a child
 * mapping. Allows avoiding binding callbacks.
 *
 * @constructor MapBookKeeping
 * @param {!*} mapResult Object containing the ordered map of results.
 * @param {!function} mapFunction Function to perform mapping with.
 * @param {?*} mapContext Context to perform mapping with.
 */
function MapBookKeeping(mapResult, keyPrefix, mapFunction, mapContext) {
  this.result = mapResult;
  this.keyPrefix = keyPrefix;
  this.func = mapFunction;
  this.context = mapContext;
  this.count = 0;
}
MapBookKeeping.prototype.destructor = function () {
  this.result = null;
  this.keyPrefix = null;
  this.func = null;
  this.context = null;
  this.count = 0;
};
PooledClass.addPoolingTo(MapBookKeeping, fourArgumentPooler);

function mapSingleChildIntoContext(bookKeeping, child, childKey) {
  var result = bookKeeping.result,
      keyPrefix = bookKeeping.keyPrefix,
      func = bookKeeping.func,
      context = bookKeeping.context;

  var mappedChild = func.call(context, child, bookKeeping.count++);
  if (Array.isArray(mappedChild)) {
    mapIntoWithKeyPrefixInternal(mappedChild, result, childKey, emptyFunction.thatReturnsArgument);
  } else if (mappedChild != null) {
    if (ReactElement.isValidElement(mappedChild)) {
      mappedChild = ReactElement.cloneAndReplaceKey(mappedChild,
      // Keep both the (mapped) and old keys if they differ, just as
      // traverseAllChildren used to do for objects as children
      keyPrefix + (mappedChild.key && (!child || child.key !== mappedChild.key) ? escapeUserProvidedKey(mappedChild.key) + '/' : '') + childKey);
    }
    result.push(mappedChild);
  }
}

function mapIntoWithKeyPrefixInternal(children, array, prefix, func, context) {
  var escapedPrefix = '';
  if (prefix != null) {
    escapedPrefix = escapeUserProvidedKey(prefix) + '/';
  }
  var traverseContext = MapBookKeeping.getPooled(array, escapedPrefix, func, context);
  traverseAllChildren(children, mapSingleChildIntoContext, traverseContext);
  MapBookKeeping.release(traverseContext);
}

/**
 * Maps children that are typically specified as `props.children`.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.map
 *
 * The provided mapFunction(child, key, index) will be called for each
 * leaf child.
 *
 * @param {?*} children Children tree container.
 * @param {function(*, int)} func The map function.
 * @param {*} context Context for mapFunction.
 * @return {object} Object containing the ordered map of results.
 */
function mapChildren(children, func, context) {
  if (children == null) {
    return children;
  }
  var result = [];
  mapIntoWithKeyPrefixInternal(children, result, null, func, context);
  return result;
}

function forEachSingleChildDummy(traverseContext, child, name) {
  return null;
}

/**
 * Count the number of children that are typically specified as
 * `props.children`.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.count
 *
 * @param {?*} children Children tree container.
 * @return {number} The number of children.
 */
function countChildren(children, context) {
  return traverseAllChildren(children, forEachSingleChildDummy, null);
}

/**
 * Flatten a children object (typically specified as `props.children`) and
 * return an array with appropriately re-keyed children.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.toarray
 */
function toArray(children) {
  var result = [];
  mapIntoWithKeyPrefixInternal(children, result, null, emptyFunction.thatReturnsArgument);
  return result;
}

var ReactChildren = {
  forEach: forEachChildren,
  map: mapChildren,
  mapIntoWithKeyPrefixInternal: mapIntoWithKeyPrefixInternal,
  count: countChildren,
  toArray: toArray
};

module.exports = ReactChildren;

/***/ }),

/***/ 1534:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var _prodInvariant = __webpack_require__(1400);

var invariant = __webpack_require__(483);

/**
 * Static poolers. Several custom versions for each potential number of
 * arguments. A completely generic pooler is easy to implement, but would
 * require accessing the `arguments` object. In each of these, `this` refers to
 * the Class itself, not an instance. If any others are needed, simply add them
 * here, or in their own files.
 */
var oneArgumentPooler = function oneArgumentPooler(copyFieldsFrom) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, copyFieldsFrom);
    return instance;
  } else {
    return new Klass(copyFieldsFrom);
  }
};

var twoArgumentPooler = function twoArgumentPooler(a1, a2) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2);
    return instance;
  } else {
    return new Klass(a1, a2);
  }
};

var threeArgumentPooler = function threeArgumentPooler(a1, a2, a3) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2, a3);
    return instance;
  } else {
    return new Klass(a1, a2, a3);
  }
};

var fourArgumentPooler = function fourArgumentPooler(a1, a2, a3, a4) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2, a3, a4);
    return instance;
  } else {
    return new Klass(a1, a2, a3, a4);
  }
};

var standardReleaser = function standardReleaser(instance) {
  var Klass = this;
  !(instance instanceof Klass) ?  false ? invariant(false, 'Trying to release an instance into a pool of a different type.') : _prodInvariant('25') : void 0;
  instance.destructor();
  if (Klass.instancePool.length < Klass.poolSize) {
    Klass.instancePool.push(instance);
  }
};

var DEFAULT_POOL_SIZE = 10;
var DEFAULT_POOLER = oneArgumentPooler;

/**
 * Augments `CopyConstructor` to be a poolable class, augmenting only the class
 * itself (statically) not adding any prototypical fields. Any CopyConstructor
 * you give this may have a `poolSize` property, and will look for a
 * prototypical `destructor` on instances.
 *
 * @param {Function} CopyConstructor Constructor that can be used to reset.
 * @param {Function} pooler Customizable pooler.
 */
var addPoolingTo = function addPoolingTo(CopyConstructor, pooler) {
  // Casting as any so that flow ignores the actual implementation and trusts
  // it to match the type we declared
  var NewKlass = CopyConstructor;
  NewKlass.instancePool = [];
  NewKlass.getPooled = pooler || DEFAULT_POOLER;
  if (!NewKlass.poolSize) {
    NewKlass.poolSize = DEFAULT_POOL_SIZE;
  }
  NewKlass.release = standardReleaser;
  return NewKlass;
};

var PooledClass = {
  addPoolingTo: addPoolingTo,
  oneArgumentPooler: oneArgumentPooler,
  twoArgumentPooler: twoArgumentPooler,
  threeArgumentPooler: threeArgumentPooler,
  fourArgumentPooler: fourArgumentPooler
};

module.exports = PooledClass;

/***/ }),

/***/ 1535:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _prodInvariant = __webpack_require__(1400);

var ReactCurrentOwner = __webpack_require__(1444);
var REACT_ELEMENT_TYPE = __webpack_require__(1445);

var getIteratorFn = __webpack_require__(1536);
var invariant = __webpack_require__(483);
var KeyEscapeUtils = __webpack_require__(1537);
var warning = __webpack_require__(1401);

var SEPARATOR = '.';
var SUBSEPARATOR = ':';

/**
 * This is inlined from ReactElement since this file is shared between
 * isomorphic and renderers. We could extract this to a
 *
 */

/**
 * TODO: Test that a single child and an array with one item have the same key
 * pattern.
 */

var didWarnAboutMaps = false;

/**
 * Generate a key string that identifies a component within a set.
 *
 * @param {*} component A component that could contain a manual key.
 * @param {number} index Index that is used if a manual key is not provided.
 * @return {string}
 */
function getComponentKey(component, index) {
  // Do some typechecking here since we call this blindly. We want to ensure
  // that we don't block potential future ES APIs.
  if (component && (typeof component === 'undefined' ? 'undefined' : _typeof(component)) === 'object' && component.key != null) {
    // Explicit key
    return KeyEscapeUtils.escape(component.key);
  }
  // Implicit key determined by the index in the set
  return index.toString(36);
}

/**
 * @param {?*} children Children tree container.
 * @param {!string} nameSoFar Name of the key path so far.
 * @param {!function} callback Callback to invoke with each child found.
 * @param {?*} traverseContext Used to pass information throughout the traversal
 * process.
 * @return {!number} The number of children in this subtree.
 */
function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
  var type = typeof children === 'undefined' ? 'undefined' : _typeof(children);

  if (type === 'undefined' || type === 'boolean') {
    // All of the above are perceived as null.
    children = null;
  }

  if (children === null || type === 'string' || type === 'number' ||
  // The following is inlined from ReactElement. This means we can optimize
  // some checks. React Fiber also inlines this logic for similar purposes.
  type === 'object' && children.$$typeof === REACT_ELEMENT_TYPE) {
    callback(traverseContext, children,
    // If it's the only child, treat the name as if it was wrapped in an array
    // so that it's consistent if the number of children grows.
    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
    return 1;
  }

  var child;
  var nextName;
  var subtreeCount = 0; // Count of children found in the current subtree.
  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;

  if (Array.isArray(children)) {
    for (var i = 0; i < children.length; i++) {
      child = children[i];
      nextName = nextNamePrefix + getComponentKey(child, i);
      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
    }
  } else {
    var iteratorFn = getIteratorFn(children);
    if (iteratorFn) {
      var iterator = iteratorFn.call(children);
      var step;
      if (iteratorFn !== children.entries) {
        var ii = 0;
        while (!(step = iterator.next()).done) {
          child = step.value;
          nextName = nextNamePrefix + getComponentKey(child, ii++);
          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
        }
      } else {
        if (false) {
          var mapsAsChildrenAddendum = '';
          if (ReactCurrentOwner.current) {
            var mapsAsChildrenOwnerName = ReactCurrentOwner.current.getName();
            if (mapsAsChildrenOwnerName) {
              mapsAsChildrenAddendum = ' Check the render method of `' + mapsAsChildrenOwnerName + '`.';
            }
          }
          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.%s', mapsAsChildrenAddendum) : void 0;
          didWarnAboutMaps = true;
        }
        // Iterator will provide entry [k,v] tuples rather than values.
        while (!(step = iterator.next()).done) {
          var entry = step.value;
          if (entry) {
            child = entry[1];
            nextName = nextNamePrefix + KeyEscapeUtils.escape(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
          }
        }
      }
    } else if (type === 'object') {
      var addendum = '';
      if (false) {
        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
        if (children._isReactElement) {
          addendum = " It looks like you're using an element created by a different " + 'version of React. Make sure to use only one copy of React.';
        }
        if (ReactCurrentOwner.current) {
          var name = ReactCurrentOwner.current.getName();
          if (name) {
            addendum += ' Check the render method of `' + name + '`.';
          }
        }
      }
      var childrenString = String(children);
       true ?  false ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : _prodInvariant('31', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : void 0;
    }
  }

  return subtreeCount;
}

/**
 * Traverses children that are typically specified as `props.children`, but
 * might also be specified through attributes:
 *
 * - `traverseAllChildren(this.props.children, ...)`
 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
 *
 * The `traverseContext` is an optional argument that is passed through the
 * entire traversal. It can be used to store accumulations or anything else that
 * the callback might find relevant.
 *
 * @param {?*} children Children tree object.
 * @param {!function} callback To invoke upon traversing each child.
 * @param {?*} traverseContext Context for traversal.
 * @return {!number} The number of children in this subtree.
 */
function traverseAllChildren(children, callback, traverseContext) {
  if (children == null) {
    return 0;
  }

  return traverseAllChildrenImpl(children, '', callback, traverseContext);
}

module.exports = traverseAllChildren;

/***/ }),

/***/ 1536:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



/* global Symbol */

var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

/**
 * Returns the iterator method function contained on the iterable object.
 *
 * Be sure to invoke the function with the iterable as context:
 *
 *     var iteratorFn = getIteratorFn(myIterable);
 *     if (iteratorFn) {
 *       var iterator = iteratorFn.call(myIterable);
 *       ...
 *     }
 *
 * @param {?object} maybeIterable
 * @return {?function}
 */
function getIteratorFn(maybeIterable) {
  var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
  if (typeof iteratorFn === 'function') {
    return iteratorFn;
  }
}

module.exports = getIteratorFn;

/***/ }),

/***/ 1537:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



/**
 * Escape and wrap key so it is safe to use as a reactid
 *
 * @param {string} key to be escaped.
 * @return {string} the escaped key.
 */

function escape(key) {
  var escapeRegex = /[=:]/g;
  var escaperLookup = {
    '=': '=0',
    ':': '=2'
  };
  var escapedString = ('' + key).replace(escapeRegex, function (match) {
    return escaperLookup[match];
  });

  return '$' + escapedString;
}

/**
 * Unescape and unwrap key for human-readable display
 *
 * @param {string} key to unescape.
 * @return {string} the unescaped key.
 */
function unescape(key) {
  var unescapeRegex = /(=0|=2)/g;
  var unescaperLookup = {
    '=0': '=',
    '=2': ':'
  };
  var keySubstring = key[0] === '.' && key[1] === '$' ? key.substring(2) : key.substring(1);

  return ('' + keySubstring).replace(unescapeRegex, function (match) {
    return unescaperLookup[match];
  });
}

var KeyEscapeUtils = {
  escape: escape,
  unescape: unescape
};

module.exports = KeyEscapeUtils;

/***/ }),

/***/ 1538:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ReactElement = __webpack_require__(1393);

/**
 * Create a factory that creates HTML tag elements.
 *
 * @private
 */
var createDOMFactory = ReactElement.createFactory;
if (false) {
  var ReactElementValidator = require('./ReactElementValidator');
  createDOMFactory = ReactElementValidator.createFactory;
}

/**
 * Creates a mapping from supported HTML tags to `ReactDOMComponent` classes.
 *
 * @public
 */
var ReactDOMFactories = {
  a: createDOMFactory('a'),
  abbr: createDOMFactory('abbr'),
  address: createDOMFactory('address'),
  area: createDOMFactory('area'),
  article: createDOMFactory('article'),
  aside: createDOMFactory('aside'),
  audio: createDOMFactory('audio'),
  b: createDOMFactory('b'),
  base: createDOMFactory('base'),
  bdi: createDOMFactory('bdi'),
  bdo: createDOMFactory('bdo'),
  big: createDOMFactory('big'),
  blockquote: createDOMFactory('blockquote'),
  body: createDOMFactory('body'),
  br: createDOMFactory('br'),
  button: createDOMFactory('button'),
  canvas: createDOMFactory('canvas'),
  caption: createDOMFactory('caption'),
  cite: createDOMFactory('cite'),
  code: createDOMFactory('code'),
  col: createDOMFactory('col'),
  colgroup: createDOMFactory('colgroup'),
  data: createDOMFactory('data'),
  datalist: createDOMFactory('datalist'),
  dd: createDOMFactory('dd'),
  del: createDOMFactory('del'),
  details: createDOMFactory('details'),
  dfn: createDOMFactory('dfn'),
  dialog: createDOMFactory('dialog'),
  div: createDOMFactory('div'),
  dl: createDOMFactory('dl'),
  dt: createDOMFactory('dt'),
  em: createDOMFactory('em'),
  embed: createDOMFactory('embed'),
  fieldset: createDOMFactory('fieldset'),
  figcaption: createDOMFactory('figcaption'),
  figure: createDOMFactory('figure'),
  footer: createDOMFactory('footer'),
  form: createDOMFactory('form'),
  h1: createDOMFactory('h1'),
  h2: createDOMFactory('h2'),
  h3: createDOMFactory('h3'),
  h4: createDOMFactory('h4'),
  h5: createDOMFactory('h5'),
  h6: createDOMFactory('h6'),
  head: createDOMFactory('head'),
  header: createDOMFactory('header'),
  hgroup: createDOMFactory('hgroup'),
  hr: createDOMFactory('hr'),
  html: createDOMFactory('html'),
  i: createDOMFactory('i'),
  iframe: createDOMFactory('iframe'),
  img: createDOMFactory('img'),
  input: createDOMFactory('input'),
  ins: createDOMFactory('ins'),
  kbd: createDOMFactory('kbd'),
  keygen: createDOMFactory('keygen'),
  label: createDOMFactory('label'),
  legend: createDOMFactory('legend'),
  li: createDOMFactory('li'),
  link: createDOMFactory('link'),
  main: createDOMFactory('main'),
  map: createDOMFactory('map'),
  mark: createDOMFactory('mark'),
  menu: createDOMFactory('menu'),
  menuitem: createDOMFactory('menuitem'),
  meta: createDOMFactory('meta'),
  meter: createDOMFactory('meter'),
  nav: createDOMFactory('nav'),
  noscript: createDOMFactory('noscript'),
  object: createDOMFactory('object'),
  ol: createDOMFactory('ol'),
  optgroup: createDOMFactory('optgroup'),
  option: createDOMFactory('option'),
  output: createDOMFactory('output'),
  p: createDOMFactory('p'),
  param: createDOMFactory('param'),
  picture: createDOMFactory('picture'),
  pre: createDOMFactory('pre'),
  progress: createDOMFactory('progress'),
  q: createDOMFactory('q'),
  rp: createDOMFactory('rp'),
  rt: createDOMFactory('rt'),
  ruby: createDOMFactory('ruby'),
  s: createDOMFactory('s'),
  samp: createDOMFactory('samp'),
  script: createDOMFactory('script'),
  section: createDOMFactory('section'),
  select: createDOMFactory('select'),
  small: createDOMFactory('small'),
  source: createDOMFactory('source'),
  span: createDOMFactory('span'),
  strong: createDOMFactory('strong'),
  style: createDOMFactory('style'),
  sub: createDOMFactory('sub'),
  summary: createDOMFactory('summary'),
  sup: createDOMFactory('sup'),
  table: createDOMFactory('table'),
  tbody: createDOMFactory('tbody'),
  td: createDOMFactory('td'),
  textarea: createDOMFactory('textarea'),
  tfoot: createDOMFactory('tfoot'),
  th: createDOMFactory('th'),
  thead: createDOMFactory('thead'),
  time: createDOMFactory('time'),
  title: createDOMFactory('title'),
  tr: createDOMFactory('tr'),
  track: createDOMFactory('track'),
  u: createDOMFactory('u'),
  ul: createDOMFactory('ul'),
  'var': createDOMFactory('var'),
  video: createDOMFactory('video'),
  wbr: createDOMFactory('wbr'),

  // SVG
  circle: createDOMFactory('circle'),
  clipPath: createDOMFactory('clipPath'),
  defs: createDOMFactory('defs'),
  ellipse: createDOMFactory('ellipse'),
  g: createDOMFactory('g'),
  image: createDOMFactory('image'),
  line: createDOMFactory('line'),
  linearGradient: createDOMFactory('linearGradient'),
  mask: createDOMFactory('mask'),
  path: createDOMFactory('path'),
  pattern: createDOMFactory('pattern'),
  polygon: createDOMFactory('polygon'),
  polyline: createDOMFactory('polyline'),
  radialGradient: createDOMFactory('radialGradient'),
  rect: createDOMFactory('rect'),
  stop: createDOMFactory('stop'),
  svg: createDOMFactory('svg'),
  text: createDOMFactory('text'),
  tspan: createDOMFactory('tspan')
};

module.exports = ReactDOMFactories;

/***/ }),

/***/ 1539:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _require = __webpack_require__(1393),
    isValidElement = _require.isValidElement;

var factory = __webpack_require__(1540);

module.exports = factory(isValidElement);

/***/ }),

/***/ 1540:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



// React 15.5 references this module, and assumes PropTypes are still callable in production.
// Therefore we re-export development-only version with all the PropTypes checks here.
// However if one is migrating to the `prop-types` npm library, they will go through the
// `index.js` entry point, and it will branch depending on the environment.

var factory = __webpack_require__(1541);
module.exports = function (isValidElement) {
  // It is still allowed in 15.5.
  var throwOnDirectAccess = false;
  return factory(isValidElement, throwOnDirectAccess);
};

/***/ }),

/***/ 1541:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var ReactIs = __webpack_require__(505);
var assign = __webpack_require__(188);

var ReactPropTypesSecret = __webpack_require__(1542);
var has = __webpack_require__(1543);
var checkPropTypes = __webpack_require__(1544);

var printWarning = function printWarning() {};

if (false) {
  printWarning = function printWarning(text) {
    var message = 'Warning: ' + text;
    if (typeof console !== 'undefined') {}
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };
}

function emptyFunctionThatReturnsNull() {
  return null;
}

module.exports = function (isValidElement, throwOnDirectAccess) {
  /* global Symbol */
  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

  /**
   * Returns the iterator method function contained on the iterable object.
   *
   * Be sure to invoke the function with the iterable as context:
   *
   *     var iteratorFn = getIteratorFn(myIterable);
   *     if (iteratorFn) {
   *       var iterator = iteratorFn.call(myIterable);
   *       ...
   *     }
   *
   * @param {?object} maybeIterable
   * @return {?function}
   */
  function getIteratorFn(maybeIterable) {
    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
    if (typeof iteratorFn === 'function') {
      return iteratorFn;
    }
  }

  /**
   * Collection of methods that allow declaration and validation of props that are
   * supplied to React components. Example usage:
   *
   *   var Props = require('ReactPropTypes');
   *   var MyArticle = React.createClass({
   *     propTypes: {
   *       // An optional string prop named "description".
   *       description: Props.string,
   *
   *       // A required enum prop named "category".
   *       category: Props.oneOf(['News','Photos']).isRequired,
   *
   *       // A prop named "dialog" that requires an instance of Dialog.
   *       dialog: Props.instanceOf(Dialog).isRequired
   *     },
   *     render: function() { ... }
   *   });
   *
   * A more formal specification of how these methods are used:
   *
   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
   *   decl := ReactPropTypes.{type}(.isRequired)?
   *
   * Each and every declaration produces a function with the same signature. This
   * allows the creation of custom validation functions. For example:
   *
   *  var MyLink = React.createClass({
   *    propTypes: {
   *      // An optional string or URI prop named "href".
   *      href: function(props, propName, componentName) {
   *        var propValue = props[propName];
   *        if (propValue != null && typeof propValue !== 'string' &&
   *            !(propValue instanceof URI)) {
   *          return new Error(
   *            'Expected a string or an URI for ' + propName + ' in ' +
   *            componentName
   *          );
   *        }
   *      }
   *    },
   *    render: function() {...}
   *  });
   *
   * @internal
   */

  var ANONYMOUS = '<<anonymous>>';

  // Important!
  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
  var ReactPropTypes = {
    array: createPrimitiveTypeChecker('array'),
    bigint: createPrimitiveTypeChecker('bigint'),
    bool: createPrimitiveTypeChecker('boolean'),
    func: createPrimitiveTypeChecker('function'),
    number: createPrimitiveTypeChecker('number'),
    object: createPrimitiveTypeChecker('object'),
    string: createPrimitiveTypeChecker('string'),
    symbol: createPrimitiveTypeChecker('symbol'),

    any: createAnyTypeChecker(),
    arrayOf: createArrayOfTypeChecker,
    element: createElementTypeChecker(),
    elementType: createElementTypeTypeChecker(),
    instanceOf: createInstanceTypeChecker,
    node: createNodeChecker(),
    objectOf: createObjectOfTypeChecker,
    oneOf: createEnumTypeChecker,
    oneOfType: createUnionTypeChecker,
    shape: createShapeTypeChecker,
    exact: createStrictShapeTypeChecker
  };

  /**
   * inlined Object.is polyfill to avoid requiring consumers ship their own
   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
   */
  /*eslint-disable no-self-compare*/
  function is(x, y) {
    // SameValue algorithm
    if (x === y) {
      // Steps 1-5, 7-10
      // Steps 6.b-6.e: +0 != -0
      return x !== 0 || 1 / x === 1 / y;
    } else {
      // Step 6.a: NaN == NaN
      return x !== x && y !== y;
    }
  }
  /*eslint-enable no-self-compare*/

  /**
   * We use an Error-like object for backward compatibility as people may call
   * PropTypes directly and inspect their output. However, we don't use real
   * Errors anymore. We don't inspect their stack anyway, and creating them
   * is prohibitively expensive if they are created too often, such as what
   * happens in oneOfType() for any type before the one that matched.
   */
  function PropTypeError(message, data) {
    this.message = message;
    this.data = data && (typeof data === 'undefined' ? 'undefined' : _typeof(data)) === 'object' ? data : {};
    this.stack = '';
  }
  // Make `instanceof Error` still work for returned errors.
  PropTypeError.prototype = Error.prototype;

  function createChainableTypeChecker(validate) {
    if (false) {
      var manualPropTypeCallCache = {};
      var manualPropTypeWarningCount = 0;
    }
    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
      componentName = componentName || ANONYMOUS;
      propFullName = propFullName || propName;

      if (secret !== ReactPropTypesSecret) {
        if (throwOnDirectAccess) {
          // New behavior only for users of `prop-types` package
          var err = new Error('Calling PropTypes validators directly is not supported by the `prop-types` package. ' + 'Use `PropTypes.checkPropTypes()` to call them. ' + 'Read more at http://fb.me/use-check-prop-types');
          err.name = 'Invariant Violation';
          throw err;
        } else if (false) {
          // Old behavior for people using React.PropTypes
          var cacheKey = componentName + ':' + propName;
          if (!manualPropTypeCallCache[cacheKey] &&
          // Avoid spamming the console because they are often not actionable except for lib authors
          manualPropTypeWarningCount < 3) {
            printWarning('You are manually calling a React.PropTypes validation ' + 'function for the `' + propFullName + '` prop on `' + componentName + '`. This is deprecated ' + 'and will throw in the standalone `prop-types` package. ' + 'You may be seeing this warning due to a third-party PropTypes ' + 'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.');
            manualPropTypeCallCache[cacheKey] = true;
            manualPropTypeWarningCount++;
          }
        }
      }
      if (props[propName] == null) {
        if (isRequired) {
          if (props[propName] === null) {
            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
          }
          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
        }
        return null;
      } else {
        return validate(props, propName, componentName, location, propFullName);
      }
    }

    var chainedCheckType = checkType.bind(null, false);
    chainedCheckType.isRequired = checkType.bind(null, true);

    return chainedCheckType;
  }

  function createPrimitiveTypeChecker(expectedType) {
    function validate(props, propName, componentName, location, propFullName, secret) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== expectedType) {
        // `propValue` being instance of, say, date/regexp, pass the 'object'
        // check, but we can offer a more precise error message here rather than
        // 'of type `object`'.
        var preciseType = getPreciseType(propValue);

        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'), { expectedType: expectedType });
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createAnyTypeChecker() {
    return createChainableTypeChecker(emptyFunctionThatReturnsNull);
  }

  function createArrayOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
      }
      var propValue = props[propName];
      if (!Array.isArray(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
      }
      for (var i = 0; i < propValue.length; i++) {
        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);
        if (error instanceof Error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createElementTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!isValidElement(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createElementTypeTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!ReactIs.isValidElementType(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement type.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createInstanceTypeChecker(expectedClass) {
    function validate(props, propName, componentName, location, propFullName) {
      if (!(props[propName] instanceof expectedClass)) {
        var expectedClassName = expectedClass.name || ANONYMOUS;
        var actualClassName = getClassName(props[propName]);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createEnumTypeChecker(expectedValues) {
    if (!Array.isArray(expectedValues)) {
      if (false) {
        if (arguments.length > 1) {
          printWarning('Invalid arguments supplied to oneOf, expected an array, got ' + arguments.length + ' arguments. ' + 'A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).');
        } else {
          printWarning('Invalid argument supplied to oneOf, expected an array.');
        }
      }
      return emptyFunctionThatReturnsNull;
    }

    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      for (var i = 0; i < expectedValues.length; i++) {
        if (is(propValue, expectedValues[i])) {
          return null;
        }
      }

      var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
        var type = getPreciseType(value);
        if (type === 'symbol') {
          return String(value);
        }
        return value;
      });
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + String(propValue) + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createObjectOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
      }
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
      }
      for (var key in propValue) {
        if (has(propValue, key)) {
          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
          if (error instanceof Error) {
            return error;
          }
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createUnionTypeChecker(arrayOfTypeCheckers) {
    if (!Array.isArray(arrayOfTypeCheckers)) {
       false ? printWarning('Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
      return emptyFunctionThatReturnsNull;
    }

    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
      var checker = arrayOfTypeCheckers[i];
      if (typeof checker !== 'function') {
        printWarning('Invalid argument supplied to oneOfType. Expected an array of check functions, but ' + 'received ' + getPostfixForTypeWarning(checker) + ' at index ' + i + '.');
        return emptyFunctionThatReturnsNull;
      }
    }

    function validate(props, propName, componentName, location, propFullName) {
      var expectedTypes = [];
      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
        var checker = arrayOfTypeCheckers[i];
        var checkerResult = checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret);
        if (checkerResult == null) {
          return null;
        }
        if (checkerResult.data && has(checkerResult.data, 'expectedType')) {
          expectedTypes.push(checkerResult.data.expectedType);
        }
      }
      var expectedTypesMessage = expectedTypes.length > 0 ? ', expected one of type [' + expectedTypes.join(', ') + ']' : '';
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`' + expectedTypesMessage + '.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createNodeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      if (!isNode(props[propName])) {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function invalidValidatorError(componentName, location, propFullName, key, type) {
    return new PropTypeError((componentName || 'React class') + ': ' + location + ' type `' + propFullName + '.' + key + '` is invalid; ' + 'it must be a function, usually from the `prop-types` package, but received `' + type + '`.');
  }

  function createShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      for (var key in shapeTypes) {
        var checker = shapeTypes[key];
        if (typeof checker !== 'function') {
          return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
        if (error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createStrictShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      // We need to check all keys in case some are required but missing from props.
      var allKeys = assign({}, props[propName], shapeTypes);
      for (var key in allKeys) {
        var checker = shapeTypes[key];
        if (has(shapeTypes, key) && typeof checker !== 'function') {
          return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
        }
        if (!checker) {
          return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' + '\nBad object: ' + JSON.stringify(props[propName], null, '  ') + '\nValid keys: ' + JSON.stringify(Object.keys(shapeTypes), null, '  '));
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
        if (error) {
          return error;
        }
      }
      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function isNode(propValue) {
    switch (typeof propValue === 'undefined' ? 'undefined' : _typeof(propValue)) {
      case 'number':
      case 'string':
      case 'undefined':
        return true;
      case 'boolean':
        return !propValue;
      case 'object':
        if (Array.isArray(propValue)) {
          return propValue.every(isNode);
        }
        if (propValue === null || isValidElement(propValue)) {
          return true;
        }

        var iteratorFn = getIteratorFn(propValue);
        if (iteratorFn) {
          var iterator = iteratorFn.call(propValue);
          var step;
          if (iteratorFn !== propValue.entries) {
            while (!(step = iterator.next()).done) {
              if (!isNode(step.value)) {
                return false;
              }
            }
          } else {
            // Iterator will provide entry [k,v] tuples rather than values.
            while (!(step = iterator.next()).done) {
              var entry = step.value;
              if (entry) {
                if (!isNode(entry[1])) {
                  return false;
                }
              }
            }
          }
        } else {
          return false;
        }

        return true;
      default:
        return false;
    }
  }

  function isSymbol(propType, propValue) {
    // Native Symbol.
    if (propType === 'symbol') {
      return true;
    }

    // falsy value can't be a Symbol
    if (!propValue) {
      return false;
    }

    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
    if (propValue['@@toStringTag'] === 'Symbol') {
      return true;
    }

    // Fallback for non-spec compliant Symbols which are polyfilled.
    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
      return true;
    }

    return false;
  }

  // Equivalent of `typeof` but with special handling for array and regexp.
  function getPropType(propValue) {
    var propType = typeof propValue === 'undefined' ? 'undefined' : _typeof(propValue);
    if (Array.isArray(propValue)) {
      return 'array';
    }
    if (propValue instanceof RegExp) {
      // Old webkits (at least until Android 4.0) return 'function' rather than
      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
      // passes PropTypes.object.
      return 'object';
    }
    if (isSymbol(propType, propValue)) {
      return 'symbol';
    }
    return propType;
  }

  // This handles more types than `getPropType`. Only used for error messages.
  // See `createPrimitiveTypeChecker`.
  function getPreciseType(propValue) {
    if (typeof propValue === 'undefined' || propValue === null) {
      return '' + propValue;
    }
    var propType = getPropType(propValue);
    if (propType === 'object') {
      if (propValue instanceof Date) {
        return 'date';
      } else if (propValue instanceof RegExp) {
        return 'regexp';
      }
    }
    return propType;
  }

  // Returns a string that is postfixed to a warning about an invalid type.
  // For example, "undefined" or "of type array"
  function getPostfixForTypeWarning(value) {
    var type = getPreciseType(value);
    switch (type) {
      case 'array':
      case 'object':
        return 'an ' + type;
      case 'boolean':
      case 'date':
      case 'regexp':
        return 'a ' + type;
      default:
        return type;
    }
  }

  // Returns class name of the object, if any.
  function getClassName(propValue) {
    if (!propValue.constructor || !propValue.constructor.name) {
      return ANONYMOUS;
    }
    return propValue.constructor.name;
  }

  ReactPropTypes.checkPropTypes = checkPropTypes;
  ReactPropTypes.resetWarningCache = checkPropTypes.resetWarningCache;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};

/***/ }),

/***/ 1542:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;

/***/ }),

/***/ 1543:
/***/ (function(module, exports) {

module.exports = Function.call.bind(Object.prototype.hasOwnProperty);

/***/ }),

/***/ 1544:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var printWarning = function printWarning() {};

if (false) {
  var ReactPropTypesSecret = require('./lib/ReactPropTypesSecret');
  var loggedTypeFailures = {};
  var has = require('./lib/has');

  printWarning = function printWarning(text) {
    var message = 'Warning: ' + text;
    if (typeof console !== 'undefined') {}
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {/**/}
  };
}

/**
 * Assert that the values match with the type specs.
 * Error messages are memorized and will only be shown once.
 *
 * @param {object} typeSpecs Map of name to a ReactPropType
 * @param {object} values Runtime values that need to be type-checked
 * @param {string} location e.g. "prop", "context", "child context"
 * @param {string} componentName Name of the component for error messages.
 * @param {?Function} getStack Returns the component stack.
 * @private
 */
function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
  if (false) {
    for (var typeSpecName in typeSpecs) {
      if (has(typeSpecs, typeSpecName)) {
        var error;
        // Prop type validation may throw. In case they do, we don't want to
        // fail the render phase where it didn't fail before. So we log it.
        // After these have been cleaned up, we'll let them throw.
        try {
          // This is intentionally an invariant that gets caught. It's the same
          // behavior as without this statement except with a better message.
          if (typeof typeSpecs[typeSpecName] !== 'function') {
            var err = Error((componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' + 'it must be a function, usually from the `prop-types` package, but received `' + _typeof(typeSpecs[typeSpecName]) + '`.' + 'This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.');
            err.name = 'Invariant Violation';
            throw err;
          }
          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
        } catch (ex) {
          error = ex;
        }
        if (error && !(error instanceof Error)) {
          printWarning((componentName || 'React class') + ': type specification of ' + location + ' `' + typeSpecName + '` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a ' + (typeof error === 'undefined' ? 'undefined' : _typeof(error)) + '. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).');
        }
        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
          // Only monitor this failure once because there tends to be a lot of the
          // same error.
          loggedTypeFailures[error.message] = true;

          var stack = getStack ? getStack() : '';

          printWarning('Failed ' + location + ' type: ' + error.message + (stack != null ? stack : ''));
        }
      }
    }
  }
}

/**
 * Resets warning cache when testing.
 *
 * @private
 */
checkPropTypes.resetWarningCache = function () {
  if (false) {
    loggedTypeFailures = {};
  }
};

module.exports = checkPropTypes;

/***/ }),

/***/ 1545:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



module.exports = '15.7.0';

/***/ }),

/***/ 1546:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _require = __webpack_require__(1441),
    Component = _require.Component;

var _require2 = __webpack_require__(1393),
    isValidElement = _require2.isValidElement;

var ReactNoopUpdateQueue = __webpack_require__(1442);
var factory = __webpack_require__(1430);

module.exports = factory(Component, isValidElement, ReactNoopUpdateQueue);

/***/ }),

/***/ 1547:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */


var _prodInvariant = __webpack_require__(1400);

var ReactElement = __webpack_require__(1393);

var invariant = __webpack_require__(483);

/**
 * Returns the first child in a collection of children and verifies that there
 * is only one child in the collection.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.only
 *
 * The current implementation of this function assumes that a single child gets
 * passed without a wrapper, but the purpose of this helper function is to
 * abstract away the particular structure of children.
 *
 * @param {?object} children Child collection structure.
 * @return {ReactElement} The first and only `ReactElement` contained in the
 * structure.
 */
function onlyChild(children) {
  !ReactElement.isValidElement(children) ?  false ? invariant(false, 'React.Children.only expected to receive a single React element child.') : _prodInvariant('143') : void 0;
  return children;
}

module.exports = onlyChild;

/***/ }),

/***/ 1548:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames() {
		var classes = '';

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (arg) {
				classes = appendClass(classes, parseValue(arg));
			}
		}

		return classes;
	}

	function parseValue(arg) {
		if (typeof arg === 'string' || typeof arg === 'number') {
			return arg;
		}

		if ((typeof arg === 'undefined' ? 'undefined' : _typeof(arg)) !== 'object') {
			return '';
		}

		if (Array.isArray(arg)) {
			return classNames.apply(null, arg);
		}

		if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) {
			return arg.toString();
		}

		var classes = '';

		for (var key in arg) {
			if (hasOwn.call(arg, key) && arg[key]) {
				classes = appendClass(classes, key);
			}
		}

		return classes;
	}

	function appendClass(value, newClass) {
		if (!newClass) {
			return value;
		}

		if (value) {
			return value + ' ' + newClass;
		}

		return value + newClass;
	}

	if (typeof module !== 'undefined' && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if ("function" === 'function' && _typeof(__webpack_require__(87)) === 'object' && __webpack_require__(87)) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
			return classNames;
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		window.classNames = classNames;
	}
})();

/***/ }),

/***/ 1549:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var React = __webpack_require__(11);

var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol.for && Symbol.for('react.element') || 0xeac7;

var emptyFunction = __webpack_require__(490);
var invariant = __webpack_require__(483);
var warning = __webpack_require__(1401);

var SEPARATOR = '.';
var SUBSEPARATOR = ':';

var didWarnAboutMaps = false;

var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

function getIteratorFn(maybeIterable) {
  var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
  if (typeof iteratorFn === 'function') {
    return iteratorFn;
  }
}

function escape(key) {
  var escapeRegex = /[=:]/g;
  var escaperLookup = {
    '=': '=0',
    ':': '=2'
  };
  var escapedString = ('' + key).replace(escapeRegex, function (match) {
    return escaperLookup[match];
  });

  return '$' + escapedString;
}

function getComponentKey(component, index) {
  // Do some typechecking here since we call this blindly. We want to ensure
  // that we don't block potential future ES APIs.
  if (component && (typeof component === 'undefined' ? 'undefined' : _typeof(component)) === 'object' && component.key != null) {
    // Explicit key
    return escape(component.key);
  }
  // Implicit key determined by the index in the set
  return index.toString(36);
}

function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
  var type = typeof children === 'undefined' ? 'undefined' : _typeof(children);

  if (type === 'undefined' || type === 'boolean') {
    // All of the above are perceived as null.
    children = null;
  }

  if (children === null || type === 'string' || type === 'number' ||
  // The following is inlined from ReactElement. This means we can optimize
  // some checks. React Fiber also inlines this logic for similar purposes.
  type === 'object' && children.$$typeof === REACT_ELEMENT_TYPE) {
    callback(traverseContext, children,
    // If it's the only child, treat the name as if it was wrapped in an array
    // so that it's consistent if the number of children grows.
    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
    return 1;
  }

  var child;
  var nextName;
  var subtreeCount = 0; // Count of children found in the current subtree.
  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;

  if (Array.isArray(children)) {
    for (var i = 0; i < children.length; i++) {
      child = children[i];
      nextName = nextNamePrefix + getComponentKey(child, i);
      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
    }
  } else {
    var iteratorFn = getIteratorFn(children);
    if (iteratorFn) {
      if (false) {
        // Warn about using Maps as children
        if (iteratorFn === children.entries) {
          warning(didWarnAboutMaps, 'Using Maps as children is unsupported and will likely yield ' + 'unexpected results. Convert it to a sequence/iterable of keyed ' + 'ReactElements instead.');
          didWarnAboutMaps = true;
        }
      }

      var iterator = iteratorFn.call(children);
      var step;
      var ii = 0;
      while (!(step = iterator.next()).done) {
        child = step.value;
        nextName = nextNamePrefix + getComponentKey(child, ii++);
        subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
      }
    } else if (type === 'object') {
      var addendum = '';
      if (false) {
        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
      }
      var childrenString = '' + children;
      invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum);
    }
  }

  return subtreeCount;
}

function traverseAllChildren(children, callback, traverseContext) {
  if (children == null) {
    return 0;
  }

  return traverseAllChildrenImpl(children, '', callback, traverseContext);
}

var userProvidedKeyEscapeRegex = /\/+/g;
function escapeUserProvidedKey(text) {
  return ('' + text).replace(userProvidedKeyEscapeRegex, '$&/');
}

function cloneAndReplaceKey(oldElement, newKey) {
  return React.cloneElement(oldElement, { key: newKey }, oldElement.props !== undefined ? oldElement.props.children : undefined);
}

var DEFAULT_POOL_SIZE = 10;
var DEFAULT_POOLER = oneArgumentPooler;

var oneArgumentPooler = function oneArgumentPooler(copyFieldsFrom) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, copyFieldsFrom);
    return instance;
  } else {
    return new Klass(copyFieldsFrom);
  }
};

var addPoolingTo = function addPoolingTo(CopyConstructor, pooler) {
  // Casting as any so that flow ignores the actual implementation and trusts
  // it to match the type we declared
  var NewKlass = CopyConstructor;
  NewKlass.instancePool = [];
  NewKlass.getPooled = pooler || DEFAULT_POOLER;
  if (!NewKlass.poolSize) {
    NewKlass.poolSize = DEFAULT_POOL_SIZE;
  }
  NewKlass.release = standardReleaser;
  return NewKlass;
};

var standardReleaser = function standardReleaser(instance) {
  var Klass = this;
  invariant(instance instanceof Klass, 'Trying to release an instance into a pool of a different type.');
  instance.destructor();
  if (Klass.instancePool.length < Klass.poolSize) {
    Klass.instancePool.push(instance);
  }
};

var fourArgumentPooler = function fourArgumentPooler(a1, a2, a3, a4) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2, a3, a4);
    return instance;
  } else {
    return new Klass(a1, a2, a3, a4);
  }
};

function MapBookKeeping(mapResult, keyPrefix, mapFunction, mapContext) {
  this.result = mapResult;
  this.keyPrefix = keyPrefix;
  this.func = mapFunction;
  this.context = mapContext;
  this.count = 0;
}
MapBookKeeping.prototype.destructor = function () {
  this.result = null;
  this.keyPrefix = null;
  this.func = null;
  this.context = null;
  this.count = 0;
};
addPoolingTo(MapBookKeeping, fourArgumentPooler);

function mapSingleChildIntoContext(bookKeeping, child, childKey) {
  var result = bookKeeping.result;
  var keyPrefix = bookKeeping.keyPrefix;
  var func = bookKeeping.func;
  var context = bookKeeping.context;

  var mappedChild = func.call(context, child, bookKeeping.count++);
  if (Array.isArray(mappedChild)) {
    mapIntoWithKeyPrefixInternal(mappedChild, result, childKey, emptyFunction.thatReturnsArgument);
  } else if (mappedChild != null) {
    if (React.isValidElement(mappedChild)) {
      mappedChild = cloneAndReplaceKey(mappedChild,
      // Keep both the (mapped) and old keys if they differ, just as
      // traverseAllChildren used to do for objects as children
      keyPrefix + (mappedChild.key && (!child || child.key !== mappedChild.key) ? escapeUserProvidedKey(mappedChild.key) + '/' : '') + childKey);
    }
    result.push(mappedChild);
  }
}

function mapIntoWithKeyPrefixInternal(children, array, prefix, func, context) {
  var escapedPrefix = '';
  if (prefix != null) {
    escapedPrefix = escapeUserProvidedKey(prefix) + '/';
  }
  var traverseContext = MapBookKeeping.getPooled(array, escapedPrefix, func, context);
  traverseAllChildren(children, mapSingleChildIntoContext, traverseContext);
  MapBookKeeping.release(traverseContext);
}

var numericPropertyRegex = /^\d+$/;

var warnedAboutNumeric = false;

function createReactFragment(object) {
  if ((typeof object === 'undefined' ? 'undefined' : _typeof(object)) !== 'object' || !object || Array.isArray(object)) {
    warning(false, 'React.addons.createFragment only accepts a single object. Got: %s', object);
    return object;
  }
  if (React.isValidElement(object)) {
    warning(false, 'React.addons.createFragment does not accept a ReactElement ' + 'without a wrapper object.');
    return object;
  }

  invariant(object.nodeType !== 1, 'React.addons.createFragment(...): Encountered an invalid child; DOM ' + 'elements are not valid children of React components.');

  var result = [];

  for (var key in object) {
    if (false) {
      if (!warnedAboutNumeric && numericPropertyRegex.test(key)) {
        warning(false, 'React.addons.createFragment(...): Child objects should have ' + 'non-numeric keys so ordering is preserved.');
        warnedAboutNumeric = true;
      }
    }
    mapIntoWithKeyPrefixInternal(object[key], result, key, emptyFunction.thatReturnsArgument);
  }

  return result;
}

module.exports = createReactFragment;

/***/ }),

/***/ 1550:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

var _react = __webpack_require__(1411);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var PageView = function (_React$Component) {
  _inherits(PageView, _React$Component);

  function PageView() {
    _classCallCheck(this, PageView);

    return _possibleConstructorReturn(this, Object.getPrototypeOf(PageView).apply(this, arguments));
  }

  _createClass(PageView, [{
    key: 'render',
    value: function render() {
      var cssClassName = this.props.pageClassName;
      var linkClassName = this.props.pageLinkClassName;
      var onClick = this.props.onClick;
      var href = this.props.href;
      var ariaLabel = 'Page ' + this.props.page + (this.props.extraAriaContext ? ' ' + this.props.extraAriaContext : '');
      var ariaCurrent = null;

      if (this.props.selected) {
        ariaCurrent = 'page';
        ariaLabel = 'Page ' + this.props.page + ' is your current page';
        if (typeof cssClassName !== 'undefined') {
          cssClassName = cssClassName + ' ' + this.props.activeClassName;
        } else {
          cssClassName = this.props.activeClassName;
        }
      }

      return _react2.default.createElement('li', { className: cssClassName }, _react2.default.createElement('a', { onClick: onClick,
        className: linkClassName,
        href: href,
        tabIndex: '0',
        'aria-label': ariaLabel,
        'aria-current': ariaCurrent,
        onKeyPress: onClick }, this.props.page));
    }
  }]);

  return PageView;
}(_react2.default.Component);

exports.default = PageView;
;
//# sourceMappingURL=PageView.js.map

/***/ }),

/***/ 1551:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

var _react = __webpack_require__(1411);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var BreakView = function (_React$Component) {
  _inherits(BreakView, _React$Component);

  function BreakView() {
    _classCallCheck(this, BreakView);

    return _possibleConstructorReturn(this, Object.getPrototypeOf(BreakView).apply(this, arguments));
  }

  _createClass(BreakView, [{
    key: 'render',
    value: function render() {
      var label = this.props.breakLabel;
      var className = this.props.breakClassName || 'break';

      return _react2.default.createElement('li', { className: className }, label);
    }
  }]);

  return BreakView;
}(_react2.default.Component);

exports.default = BreakView;
;
//# sourceMappingURL=BreakView.js.map

/***/ }),

/***/ 1552:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1553);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./Paginate.css", function() {
        content = require("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./Paginate.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 1553:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, ".wp2Sm{background-color:#fff;padding:10px;margin-bottom:10px;position:relative;z-index:10;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;-webkit-box-align:center;-ms-flex-align:center;align-items:center;font-weight:400}.yrL46:nth-of-type(2){border:1px solid #dedede;border-radius:2px 0 0 2px}.yrL46:nth-last-of-type(2){border-radius:0 2px 2px 0}.yrL46{cursor:pointer}._1Xm5w,.yrL46{position:relative;border:1px solid #dedede;border-left:none;display:-webkit-box;display:-ms-flexbox;display:flex}._1Xm5w{padding:0 10px}.yrL46:hover{background-color:#e4f1fb}.YGfgs{background-color:#c9e7ff}.UXnXg{padding:5px 0;margin:0;list-style:none;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;-webkit-box-flex:2;-ms-flex-positive:2;flex-grow:2;-webkit-box-align:stretch;-ms-flex-align:stretch;align-items:stretch}._2e76y,._2Lfan,.UXnXg{display:-webkit-box;display:-ms-flexbox;display:flex}._2e76y,._2Lfan{border:1px solid #dedede;margin:0 10px;border-radius:2px;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;cursor:pointer}._2e76y:hover,._2Lfan:hover{border-color:#34a7ff}.wp2Sm a{color:#000;line-height:28px;font-size:14px;outline:none;padding:0 10px;text-decoration:none;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}._1FlHS{display:none}", ""]);

// exports
exports.locals = {
	"root": "wp2Sm",
	"pageItem": "yrL46",
	"breakMe": "_1Xm5w",
	"activePage": "YGfgs",
	"pagination": "UXnXg",
	"next": "_2Lfan",
	"previous": "_2e76y",
	"hidden": "_1FlHS"
};

/***/ }),

/***/ 1561:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "97470e69.svg";

/***/ }),

/***/ 1644:
/***/ (function(module, exports) {

module.exports = [{"id":1912,"slug":"kiev","title":"Киев","uk_title":"Київ","where":{"ru":"в Киеве","uk":"в Києві"}},{"id":1943,"slug":"kievskaya-obl","title":"Киевская обл.","uk_title":"Київська область","where":{"ru":"в Киевской обл.","uk":"в Київській обл."}},{"id":29834,"slug":"ar-krym","title":"АР Крым","uk_title":"АР Крим","where":{"ru":"в АР Крым","uk":"в АР Крым"}},{"id":2028,"slug":"vinnitsa","title":"Винница","uk_title":"Вінниця","where":{"ru":"в Виннице","uk":"у Вінниці"}},{"id":2031,"slug":"dnepr-dnepropetrovsk","title":"Днепр (Днепропетровск)","uk_title":"Дніпро","where":{"ru":"в Днепре (Днепропетровск)","uk":"в Дніпрі (Дніпропетровськ)"}},{"id":2032,"slug":"donetsk","title":"Донецк","uk_title":"Донецьк","where":{"ru":"в Донецке","uk":"в Донецьку"}},{"id":29827,"slug":"mariupol","title":"Мариуполь","uk_title":"Маріуполь","where":{"ru":"в Мариуполе","uk":"в Маріуполі"}},{"id":2033,"slug":"zhitomir","title":"Житомир","uk_title":"Житомир","where":{"ru":"в Житомире","uk":"в Житомирі"}},{"id":2035,"slug":"zaporozhe","title":"Запорожье","uk_title":"Запоріжжя","where":{"ru":"в Запорожье","uk":"в Запоріжжі"}},{"id":2036,"slug":"ivano-frankovsk","title":"Ивано-Франковск","uk_title":"Івано-Франківськ","where":{"ru":"в Ивано-Франковске","uk":"в Івано-Франківську"}},{"id":29824,"slug":"krivoy-rog","title":"Кривой Рог","uk_title":"Кривий Ріг","where":{"ru":"в Кривой Роге","uk":"в Кривому Розі"}},{"id":2037,"slug":"kropivnitskiy-kirovograd","title":"Кропивницкий (Кировоград)","uk_title":"Кропивницький","where":{"ru":"в Кропивницком (Кировоград)","uk":"в Кропивницькому (Кіровоград)"}},{"id":1946,"slug":"lugansk","title":"Луганск","uk_title":"Луганськ","where":{"ru":"в Луганске","uk":"в Луганську"}},{"id":2030,"slug":"lutsk","title":"Луцк","uk_title":"Луцьк","where":{"ru":"в Луцке","uk":"в Луцьку"}},{"id":115702,"slug":"novovolynsk","title":"Нововолынск","uk_title":"Нововолинськ","where":{"ru":"в Нововолынске","uk":"у Нововолинську"}},{"id":2038,"slug":"lvov","title":"Львов","uk_title":"Львів","where":{"ru":"во Львове","uk":"у Львові"}},{"id":2039,"slug":"nikolaev","title":"Николаев","uk_title":"Миколаїв","where":{"ru":"в Николаеве","uk":"в Миколаєві"}},{"id":1944,"slug":"odessa","title":"Одесса","uk_title":"Одеса","where":{"ru":"в Одессе","uk":"в Одесі"}},{"id":1945,"slug":"poltava","title":"Полтава","uk_title":"Полтава","where":{"ru":"в Полтаве","uk":"в Полтаві"}},{"id":2040,"slug":"rovno","title":"Ровно","uk_title":"Рівне","where":{"ru":"в Ровно","uk":"в Рівному"}},{"id":2041,"slug":"sumy","title":"Сумы","uk_title":"Суми","where":{"ru":"в Сумах","uk":"в Сумах"}},{"id":2042,"slug":"ternopol","title":"Тернополь","uk_title":"Тернопіль","where":{"ru":"в Тернополе","uk":"в Тернополі"}},{"id":2034,"slug":"uzhgorod","title":"Ужгород","uk_title":"Ужгород","where":{"ru":"в Ужгороде","uk":"в Ужгороді"}},{"id":2043,"slug":"harkov","title":"Харьков","uk_title":"Харків","where":{"ru":"в Харькове","uk":"в Харкові"}},{"id":2044,"slug":"herson","title":"Херсон","uk_title":"Херсон","where":{"ru":"в Херсоне","uk":"в Херсоні"}},{"id":2045,"slug":"hmelnitskiy","title":"Хмельницкий","uk_title":"Хмельницький","where":{"ru":"в Хмельницком","uk":"в Хмельницькому"}},{"id":2046,"slug":"cherkassy","title":"Черкассы","uk_title":"Черкаси","where":{"ru":"в Черкассах","uk":"в Черкасах"}},{"id":2047,"slug":"chernigov","title":"Чернигов","uk_title":"Чернігів","where":{"ru":"в Чернигове","uk":"в Чернігові"}},{"id":2048,"slug":"chernovtsy","title":"Черновцы","uk_title":"Чернівці","where":{"ru":"в Черновцах","uk":"в Чернівцях"}},{"id":115819,"slug":"yaremche","title":"Яремче","uk_title":"Яремче","where":{"ru":"в Яремче","uk":"в Яремче"}}]

/***/ }),

/***/ 1646:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// CONCATENATED MODULE: ./src/shared/helpers/seoHeaders.js
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_shared_modules_subjectiveText_allText__ = __webpack_require__(309);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_shared_helpers_seoTextFinder__ = __webpack_require__(1254);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shared_constants_json_firstSeoRubricsTypes_json__ = __webpack_require__(1257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shared_constants_json_firstSeoRubricsTypes_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_shared_constants_json_firstSeoRubricsTypes_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_constants_json_secondSeoRubricsTypes_json__ = __webpack_require__(1258);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_constants_json_secondSeoRubricsTypes_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_shared_constants_json_secondSeoRubricsTypes_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shared_modules__ = __webpack_require__(103);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };







var defaultTranslate = function defaultTranslate(v) {
  return v;
};
var valueVsTabOrEmpty = function valueVsTabOrEmpty(val) {
  var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultTranslate;
  return val ? ' ' + t(val) : '';
};

var buildSearchAvtoSeoHeader = function buildSearchAvtoSeoHeader(data, t) {
  var seoData = __WEBPACK_IMPORTED_MODULE_1_shared_helpers_seoTextFinder__["a" /* getSeoDataByParams */](data, t);
  if (seoData && seoData.header) return seoData.header;

  var _data$make = data.make,
      make = _data$make === undefined ? '' : _data$make,
      _data$model = data.model,
      model = _data$model === undefined ? '' : _data$model,
      _data$location = data.location,
      location = _data$location === undefined ? '' : _data$location,
      _data$generation = data.generation,
      generation = _data$generation === undefined ? '' : _data$generation,
      _data$gearbox = data.gearbox,
      gearbox = _data$gearbox === undefined ? '' : _data$gearbox,
      _data$engine = data.engine,
      engine = _data$engine === undefined ? '' : _data$engine,
      _data$body = data.body,
      body = _data$body === undefined ? '' : _data$body,
      _data$drive = data.drive,
      driveSelected = _data$drive === undefined ? '' : _data$drive,
      _data$isNew = data.isNew,
      isNew = _data$isNew === undefined ? false : _data$isNew,
      _data$year = data.year,
      yearSelected = _data$year === undefined ? '' : _data$year,
      _data$makeTranslate = data.makeTranslate,
      makeTranslate = _data$makeTranslate === undefined ? '' : _data$makeTranslate,
      _data$city = data.city,
      city = _data$city === undefined ? null : _data$city;

  var locale = t('locale');

  var drive = __WEBPACK_IMPORTED_MODULE_4_shared_modules__["b" /* buildDriveValue */](t(driveSelected), t);
  var buOrUsed = body || generation || engine || gearbox ? 'б/у' : 'б у';
  var usedOrNew = !isNew ? buOrUsed : '';
  var year = yearSelected ? yearSelected + ' ' + t('года') : '';

  var makeOrAuto = make || 'авто';
  var cityHeader = location && __WEBPACK_IMPORTED_MODULE_0_shared_modules_subjectiveText_allText__["g" /* sity */][location] ? location : '';
  var customGearbox = gearbox in __WEBPACK_IMPORTED_MODULE_0_shared_modules_subjectiveText_allText__["c" /* gearboxes */] ? __WEBPACK_IMPORTED_MODULE_0_shared_modules_subjectiveText_allText__["c" /* gearboxes */][gearbox][locale].title : gearbox;
  var customEngineAlt = engine in __WEBPACK_IMPORTED_MODULE_0_shared_modules_subjectiveText_allText__["b" /* engines */] ? __WEBPACK_IMPORTED_MODULE_0_shared_modules_subjectiveText_allText__["b" /* engines */][engine][locale].altTitle : engine;
  var customEngine = engine in __WEBPACK_IMPORTED_MODULE_0_shared_modules_subjectiveText_allText__["b" /* engines */] ? __WEBPACK_IMPORTED_MODULE_0_shared_modules_subjectiveText_allText__["b" /* engines */][engine][locale].title : engine;

  var inCityHeader = cityHeader ? ' ' + __WEBPACK_IMPORTED_MODULE_4_shared_modules__["c" /* buildInGenitiveCityHeader */](__WEBPACK_IMPORTED_MODULE_0_shared_modules_subjectiveText_allText__["g" /* sity */][cityHeader][locale].genitive) : city && city.title && ' ' + __WEBPACK_IMPORTED_MODULE_4_shared_modules__["c" /* buildInGenitiveCityHeader */](city[locale + '_title'] || city.title) || '';

  if (locale === 'ru' && make && !model && !generation && !body && !engine && !drive && !gearbox) {
    return '' + t('Продажа') + valueVsTabOrEmpty(make) + valueVsTabOrEmpty(usedOrNew, t) + valueVsTabOrEmpty(year) + inCityHeader;
  }
  if (make && model && body && !generation && !engine && !drive) {
    return '' + t('Продажа') + valueVsTabOrEmpty(usedOrNew, t) + valueVsTabOrEmpty(body, t).toLowerCase() + valueVsTabOrEmpty(makeOrAuto) + valueVsTabOrEmpty(model) + valueVsTabOrEmpty(year) + inCityHeader;
  }
  if (make && model && (generation || gearbox) && !engine && !drive) {
    return '' + t('Продажа') + valueVsTabOrEmpty(usedOrNew, t) + valueVsTabOrEmpty(makeOrAuto) + valueVsTabOrEmpty(model) + valueVsTabOrEmpty(gearbox, t) + valueVsTabOrEmpty(generation) + valueVsTabOrEmpty(year) + inCityHeader;
  }
  if (make && model && (generation || gearbox) && drive && !engine) {
    return '' + t('Продажа') + valueVsTabOrEmpty(usedOrNew, t) + valueVsTabOrEmpty(makeOrAuto) + valueVsTabOrEmpty(model) + valueVsTabOrEmpty(generation) + valueVsTabOrEmpty(gearbox, t) + valueVsTabOrEmpty(drive) + valueVsTabOrEmpty(year) + inCityHeader;
  }
  if (make && model && (generation || gearbox) && drive && engine) {
    return '' + t('Продажа') + valueVsTabOrEmpty(usedOrNew, t) + valueVsTabOrEmpty(makeOrAuto) + valueVsTabOrEmpty(model) + valueVsTabOrEmpty(engine, t) + valueVsTabOrEmpty(gearbox, t) + valueVsTabOrEmpty(generation) + valueVsTabOrEmpty(drive) + valueVsTabOrEmpty(year) + inCityHeader;
  }
  if (!make && !model && !generation && !gearbox && !drive && engine) {
    return '' + customEngineAlt + valueVsTabOrEmpty(year) + valueVsTabOrEmpty(usedOrNew, t) + inCityHeader;
  }
  if (make && !model && !generation && gearbox && !drive && !engine) {
    return '' + (makeTranslate || makeOrAuto) + valueVsTabOrEmpty(customGearbox) + valueVsTabOrEmpty(year) + valueVsTabOrEmpty(usedOrNew, t) + inCityHeader;
  }
  if (!make && !model && !generation && !gearbox && !drive && !engine && body) {
    return '' + t('Авто') + valueVsTabOrEmpty(body, t) + valueVsTabOrEmpty(year) + valueVsTabOrEmpty(usedOrNew, t) + inCityHeader;
  }
  if (make && !model && !generation && !gearbox && !drive && engine && !body) {
    return '' + customEngine + valueVsTabOrEmpty(makeTranslate || makeOrAuto) + valueVsTabOrEmpty(year) + valueVsTabOrEmpty(usedOrNew, t) + inCityHeader;
  }
  if (make && model && !generation && !gearbox && !drive && engine && !body) {
    return '' + customEngine + valueVsTabOrEmpty(makeTranslate || makeOrAuto) + valueVsTabOrEmpty(model) + valueVsTabOrEmpty(year) + valueVsTabOrEmpty(usedOrNew, t) + inCityHeader;
  }
  if (!make && !model && !generation && gearbox && !drive && !engine && !body) {
    return '' + t('Авто') + valueVsTabOrEmpty(customGearbox) + valueVsTabOrEmpty(year) + valueVsTabOrEmpty(usedOrNew, t) + inCityHeader;
  }
  if (make && !model && !generation && !gearbox && !drive && !engine && body) {
    return '' + (makeTranslate || makeOrAuto) + valueVsTabOrEmpty(body, t) + valueVsTabOrEmpty(year) + valueVsTabOrEmpty(usedOrNew, t) + inCityHeader;
  }

  return '' + t('Продажа') + valueVsTabOrEmpty(usedOrNew, t) + valueVsTabOrEmpty(makeOrAuto) + valueVsTabOrEmpty(model) + valueVsTabOrEmpty(year) + inCityHeader;
};

var buildFirmsSeoHeader = function buildFirmsSeoHeader(data, t) {
  var section = data.section,
      cityTitle = data.cityTitle,
      regLocation = data.regLocation,
      location = data.location;
  // if (section === 'СТО') {
  //   if (cityHeader) return `СТО в ${cityHeader}`;
  //   return `${t('Все')} СТО ${t('Украины')}`;
  // }
  // if (section && cityHeader) {
  //   return t('Каталог компаний {section} в {cityHeader}', {
  //     section,
  //     cityHeader,
  //   });
  // }
  // if (section) {
  //   return t('Каталог компаний {section} в Украине', { section });
  // }
  // if (cityHeader) {
  //   return `СТО в ${cityHeader}`;
  // }

  if (section === 'СТО' && cityTitle) {
    return t('Каталог СТО {cityTitle}', {
      section: section,
      cityTitle: t(regLocation) || t(location)
    });
  }

  if ((section === 'Авторазборка' || section === 'Авторозборка') && cityTitle) {
    return t('Авторазборка {cityTitle}. Каталог компаний по разбору авто на запчасти', {
      section: section,
      cityTitle: t(regLocation) || t(location)
    });
  }

  if ((section === 'Автовыкуп' || section === 'Автовикуп') && cityTitle) {
    return t('Автовыкуп {cityTitle}. Каталог компаний по выкупу авто', {
      section: section,
      cityTitle: t(regLocation) || t(location)
    });
  }

  if ((section === 'Запчасти' || section === 'Запчастини') && cityTitle) {
    return t('Дилеры автозапчастей {cityTitle}', {
      section: section,
      cityTitle: t(regLocation) || t(location)
    });
  }

  if ((section === 'Автотовары' || section === 'Автотовари') && cityTitle) {
    return t('Автотовары {cityTitle}. Каталог компаний по продаже товаров для авто', {
      section: section,
      cityTitle: t(regLocation) || t(location)
    });
  }

  if ((section === 'Сервисные центры' || section === 'Сервісні центри') && cityTitle) {
    return t('ТСЦ {cityTitle}', {
      section: section,
      cityTitle: t(regLocation) || t(location)
    });
  }

  if (cityTitle) {
    return t('Автомобильные компании, автосервисы {cityTitle}', _extends({}, data, {
      // section,
      cityTitle: t(regLocation) || t(location)
    }));
  }

  return t('Каталог компаний Украины - Автомобильные организации');
};

var buildDealersSeoHeader = function buildDealersSeoHeader(data, slug, t) {
  var _data$make2 = data.make,
      make = _data$make2 === undefined ? '' : _data$make2,
      _data$model2 = data.model,
      model = _data$model2 === undefined ? '' : _data$model2,
      _data$location2 = data.location,
      location = _data$location2 === undefined ? '' : _data$location2;

  var seoData = __WEBPACK_IMPORTED_MODULE_1_shared_helpers_seoTextFinder__["a" /* getSeoDataByParams */](_extends({}, data, { transport: data.transport || slug }), t, 'avtosalony');
  if (seoData && seoData.header) return seoData.header;

  var locale = t('locale');
  var isAvto = slug === 'avto';
  var isMoto = slug === 'mototsikl';
  var isBuss = slug === 'avtobus';
  var isTrucks = slug === 'gruzovye';

  var cityHeader = location && __WEBPACK_IMPORTED_MODULE_0_shared_modules_subjectiveText_allText__["g" /* sity */][location] ? location : '';
  var cityHeaderVsSpace = location && ' ' + t(location);
  var accusativeCityHeaderVsSpace = cityHeader ? ' ' + __WEBPACK_IMPORTED_MODULE_0_shared_modules_subjectiveText_allText__["g" /* sity */][cityHeader][locale].accusative : '';
  var inGenitiveCityHeader = cityHeader ? ' ' + __WEBPACK_IMPORTED_MODULE_4_shared_modules__["c" /* buildInGenitiveCityHeader */](__WEBPACK_IMPORTED_MODULE_0_shared_modules_subjectiveText_allText__["g" /* sity */][cityHeader][locale].genitive) : '';

  if (isAvto || isMoto) {
    var dealerType = isAvto ? 'Автосалоны' : 'Мотосалоны';

    if (!make && !model && inGenitiveCityHeader) {
      return '' + t(dealerType) + inGenitiveCityHeader;
    }
    if (make && !model && cityHeader) {
      return t(dealerType) + ' ' + make + ' ' + t(cityHeader);
    }
    if (make && !model) {
      return t(dealerType) + ' ' + make + cityHeaderVsSpace;
    }
    if (make && model && isAvto) {
      return make + ' ' + model + ' \u0432 \u0430\u0432\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445' + accusativeCityHeaderVsSpace;
    }
    return t(dealerType);
  }
  if (isBuss) {
    var _dealerType = t('Автосалоны') + ' ' + t('автобусов');

    if (!make && !model && inGenitiveCityHeader) {
      return '' + _dealerType + inGenitiveCityHeader;
    }
    if (make && !model && !cityHeader) {
      return t('Автобусы') + ' ' + make + ' \u0432 \u0430\u0432\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445';
    }
    if (make && !model && accusativeCityHeaderVsSpace) {
      return t('Автобусы') + ' ' + make + ' \u0432 \u0430\u0432\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445' + accusativeCityHeaderVsSpace;
    }

    return _dealerType;
  }
  if (isTrucks) {
    var _dealerType2 = '' + t('Автосалоны грузовых автомобилей');

    if (!make && !model && inGenitiveCityHeader) {
      return '' + _dealerType2 + inGenitiveCityHeader;
    }
    if (make && !model && !cityHeader) {
      return t('Гррузовые') + ' ' + make + ' \u0432 \u0430\u0432\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445';
    }
    if (make && !model && accusativeCityHeaderVsSpace) {
      return t('Гррузовые') + ' ' + make + ' \u0432 \u0430\u0432\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445' + accusativeCityHeaderVsSpace;
    }
    return _dealerType2;
  }
  if (slug === 'spetstehnika') {
    if (make && !cityHeader) {
      return t('Дилеры') + ' ' + t('спецтехники') + ' ' + make;
    }
    if (!make && inGenitiveCityHeader) {
      return t('Дилеры') + ' ' + t('спецтехники') + inGenitiveCityHeader;
    }
    return t('Дилеры') + ' ' + t('спецтехники');
  }
  if (slug === 'vodnyi-transport') {
    if (make && !cityHeader) {
      return t('Водный транспорт') + ' ' + make + ' \u2013 ' + t('компании');
    }
    if (!make && inGenitiveCityHeader) {
      return '' + t('Водный транспорт') + inGenitiveCityHeader + ' \u2013 ' + t('компании');
    }
    return t('Водный транспорт') + ' \u2013 ' + t('компании');
  }
  if (slug === 'pritsepy') {
    if (make && !cityHeader) {
      return t('Прицепы') + ' ' + make + ' \u2013 ' + t('каталог компаний');
    }
    if (!make && inGenitiveCityHeader) {
      return t('Прицепы') + ' \u2013 ' + t('каталог компаний') + inGenitiveCityHeader;
    }
    return t('Прицепы') + ' \u2013 ' + t('каталог компаний');
  }

  return '' + t('Автосалоны') + inGenitiveCityHeader;
};

var buildSparePartsSeoHeader = function buildSparePartsSeoHeader(data, rubricSlug, t, isRegion) {
  var locale = t('locale');
  var make = data.make,
      model = data.model,
      rubricTitle = data.rubric,
      partTypeRu = data.partType,
      partTypeUk = data.partTypeUk,
      location = data.location,
      selectedTransport = data.transport;


  var seoData = __WEBPACK_IMPORTED_MODULE_1_shared_helpers_seoTextFinder__["a" /* getSeoDataByParams */](data, t, 'zapchasti');
  if (seoData && seoData.header) return seoData.header;

  var rubric = rubricTitle;
  var partType = partTypeRu;
  var transport = __WEBPACK_IMPORTED_MODULE_4_shared_modules__["o" /* replaceTransport */](selectedTransport);

  var inCityOrRegion = t('в городе') + ' ' + t(location);
  if (isRegion && location) {
    inCityOrRegion = '\u0432 ' + __WEBPACK_IMPORTED_MODULE_0_shared_modules_subjectiveText_allText__["g" /* sity */][location][locale].genitive;
  }

  if (locale === 'uk' && partTypeUk) partType = partTypeUk;

  if (!rubricSlug && !partType && !rubric) {
    if (!make && !model && !location) {
      return t('Запчасти') + ' \u043D\u0430 ' + transport + ' ' + t('в Украине');
    }
    if (make && !model && !location) {
      return t('Запчасти') + ' \u043D\u0430 ' + transport + ' ' + make + ' ' + t('в Украине');
    }
    if (make && model && !location) {
      return t('Запчасти') + ' \u043D\u0430 ' + make + ' ' + model + ' ' + t('в Украине');
    }
    if (!model && location) {
      return '' + t('Запчасти') + valueVsTabOrEmpty(make) + valueVsTabOrEmpty(model) + ' \u043D\u0430 ' + transport + ' ' + inCityOrRegion;
    }
    if (make && model && location) {
      return t('Запчасти') + ' \u043D\u0430 ' + make + ' ' + model + ' \u0432 ' + __WEBPACK_IMPORTED_MODULE_0_shared_modules_subjectiveText_allText__["g" /* sity */][location][locale].genitive;
    }
  }
  if (__WEBPACK_IMPORTED_MODULE_2_shared_constants_json_firstSeoRubricsTypes_json___default.a.includes(rubricSlug)) {
    rubric = rubric && __WEBPACK_IMPORTED_MODULE_0_shared_modules_subjectiveText_allText__["f" /* rubrics */][rubric][locale].accusative;
  } else if (__WEBPACK_IMPORTED_MODULE_3_shared_constants_json_secondSeoRubricsTypes_json___default.a.includes(rubricSlug)) {
    rubric = rubric && __WEBPACK_IMPORTED_MODULE_0_shared_modules_subjectiveText_allText__["f" /* rubrics */][rubric][locale].nominative;
  }

  /* ____________________FIRST TYPE VS RUBRIC_______________________ */

  if (rubricSlug && rubric && !partType && __WEBPACK_IMPORTED_MODULE_2_shared_constants_json_firstSeoRubricsTypes_json___default.a.includes(rubricSlug)) {
    if (!model && !location) {
      return t('Запчасти') + ' ' + rubric + ' \u043D\u0430 ' + transport + valueVsTabOrEmpty(make);
    }
    if (model && !location) {
      return t('Запчасти') + ' ' + rubric + ' \u043D\u0430' + valueVsTabOrEmpty(make) + valueVsTabOrEmpty(model);
    }
    if (model && !location && locale === 'uk') {
      return t('Запчасти') + ' ' + rubric + (locale === 'ru' ? ' на' : '') + valueVsTabOrEmpty(make) + valueVsTabOrEmpty(model);
    }

    if (!make && !model && location) {
      return t('Запчасти') + ' ' + rubric + ' \u043D\u0430 ' + transport + ' ' + t(location);
    }
    if (make && !model && location) {
      return t('Запчасти') + ' ' + rubric + ' \u043D\u0430 ' + transport + valueVsTabOrEmpty(make) + ' ' + t(location);
    }
    if (make && model && location) {
      return t('Запчасти') + ' ' + rubric + valueVsTabOrEmpty(make) + valueVsTabOrEmpty(model) + ' ' + t(location);
    }
  }

  /* ____________________FIRST TYPE VS RUBRIC && PART_TYPE_______________________ */

  if (rubricSlug && rubric && partType && __WEBPACK_IMPORTED_MODULE_2_shared_constants_json_firstSeoRubricsTypes_json___default.a.includes(rubricSlug)) {
    if (!make && !model) {
      return __WEBPACK_IMPORTED_MODULE_4_shared_modules__["n" /* replaceToUpperCase */](partType) + ' \u043D\u0430 ' + transport + valueVsTabOrEmpty(t(location));
    }
    if (make && !location) {
      return __WEBPACK_IMPORTED_MODULE_4_shared_modules__["n" /* replaceToUpperCase */](partType) + ' ' + make + valueVsTabOrEmpty(model);
    }

    if (make && location) {
      return t('Запчасти') + ' ' + rubric + ' \u043D\u0430 ' + transport + ' ' + make + valueVsTabOrEmpty(model) + ' \u2013 ' + partType + ' ' + t(location);
    }
  }

  /* ____________________SECOND TYPE VS RUBRIC_______________________ */

  if (rubricSlug && rubric && !partType && transport && __WEBPACK_IMPORTED_MODULE_3_shared_constants_json_secondSeoRubricsTypes_json___default.a.includes(rubricSlug)) {
    if (!model && !location) {
      return rubric + ' \u043D\u0430 ' + transport + valueVsTabOrEmpty(make);
    }
    if (model && !location) {
      return rubric + ' \u043D\u0430 ' + make + ' ' + model;
    }

    if (location) {
      return rubric + ' \u043D\u0430 ' + transport + valueVsTabOrEmpty(make) + valueVsTabOrEmpty(model) + ' ' + t(location);
    }
  }

  /* ____________________SECOND TYPE VS RUBRIC && PART_TYPE_______________________ */

  if (rubricSlug && rubric && partType && __WEBPACK_IMPORTED_MODULE_3_shared_constants_json_secondSeoRubricsTypes_json___default.a.includes(rubricSlug)) {
    if (!make && !model) {
      return __WEBPACK_IMPORTED_MODULE_4_shared_modules__["n" /* replaceToUpperCase */](partType) + ' \u043D\u0430 ' + transport + valueVsTabOrEmpty(t(location));
    }
    if (make && !model && !location) {
      return __WEBPACK_IMPORTED_MODULE_4_shared_modules__["n" /* replaceToUpperCase */](partType) + ' \u043D\u0430 ' + make;
    }
    if (make && model && !location) {
      return __WEBPACK_IMPORTED_MODULE_4_shared_modules__["n" /* replaceToUpperCase */](partType) + ' ' + make + ' ' + model;
    }

    if (!model && location) {
      return __WEBPACK_IMPORTED_MODULE_4_shared_modules__["n" /* replaceToUpperCase */](partType) + ' \u043D\u0430 ' + transport + valueVsTabOrEmpty(make) + ' ' + t(location);
    }

    if (make && model && location) {
      return __WEBPACK_IMPORTED_MODULE_4_shared_modules__["n" /* replaceToUpperCase */](partType) + ' \u043D\u0430 ' + model + ' ' + make + ' ' + t(location);
    }
  }

  return t('Запчасти') + ' \u043D\u0430 ' + transport + ' ' + t('в Украине');
};

var buildCommercialSeoHeader = function buildCommercialSeoHeader(params, t) {
  var data = params;

  var seoData = __WEBPACK_IMPORTED_MODULE_1_shared_helpers_seoTextFinder__["a" /* getSeoDataByParams */](data, t, 'commercial');
  if (seoData && seoData.header) return seoData.header;

  if (data.cityHeader) {
    data.cityHeader = (t(data.cityHeader) !== t('Украине') ? t('в') : 'в') + ' ' + t(data.cityHeader);
  } else data.cityHeader = '\u0432 ' + t('Украине');

  var transportHeader = data.transportHeader,
      make = data.make,
      model = data.model,
      transportType = data.transportType,
      cityHeader = data.cityHeader,
      transportCategoryTitle = data.transportCategoryTitle;


  var categoryTypes = {
    avtobus: 'Автобусы',
    moto: 'Мототехника'
  };

  if ((transportType === 'avtobus' || transportType === 'moto') && transportCategoryTitle) {
    return t(categoryTypes[transportType]) + ' ' + transportCategoryTitle + ' ' + cityHeader;
  }

  if ((transportType === 'pritsepy' || transportType === 'spetstehnika' || transportType === 'vodnyi-transport') && transportCategoryTitle) {
    return transportCategoryTitle + ' ' + cityHeader;
  }

  if (transportHeader && !make && !model) {
    return t('Продажа {transportHeader} {cityHeader}', _extends({}, data, {
      transportHeader: __WEBPACK_IMPORTED_MODULE_4_shared_modules__["m" /* replaceToLowerCase */](transportHeader)
    }));
  }
  if (transportHeader && make && model) {
    return t('Купить {transportHeader} {make} {model} {cityHeader}', _extends({}, data, {
      transportHeader: __WEBPACK_IMPORTED_MODULE_4_shared_modules__["m" /* replaceToLowerCase */](transportHeader)
    }));
  }
  if (transportHeader && make && !model) {
    if (transportType === 'avtobus') {
      return t('Автобусы') + ' ' + make + ' ' + cityHeader;
    }
    return t('Купить {transportHeader} {make} {cityHeader}', _extends({}, data, {
      transportHeader: __WEBPACK_IMPORTED_MODULE_4_shared_modules__["m" /* replaceToLowerCase */](transportHeader)
    }));
  }
  return '';
};
// CONCATENATED MODULE: ./src/shared/constants/seoHeaders.js
/* unused harmony export buildSearchHeaderByType */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shared_helpers_seoTextFinder__ = __webpack_require__(1254);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

/* eslint-disable react/prop-types */

// import { replaceToLowerCase } from 'shared/modules';




var buildPageEnding = function buildPageEnding(page, t) {
  return page > 1 ? ' - ' + t('страница') + ' ' + page : '';
};

var buildMakeSearchLink = function buildMakeSearchLink(query) {
  return query.transportHeader && query.make ? _jsx(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment, {}, void 0, query.make.title) : '';
};

var buildModelSearchLink = function buildModelSearchLink(query) {
  return query.transportHeader && query.make && query.model ? _jsx(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment, {}, void 0, query.model.title) : '';
};

var buildCategorySearchLink = function buildCategorySearchLink(query) {
  return query.transportHeader && query.category ? _jsx(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment, {}, void 0, query.category.title) : '';
};

var buildEngineSearchLink = function buildEngineSearchLink(query) {
  return query.transportHeader && query.engine ? _jsx(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment, {}, void 0, query.engine.title) : '';
};

var buildGearboxSearchLink = function buildGearboxSearchLink(query) {
  return query.transportHeader && query.gearbox ? _jsx(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment, {}, void 0, query.gearbox.title) : '';
};

var buildLocationSearchLink = function buildLocationSearchLink(query) {
  return query.transportHeader && query.location && query.locationObj ? _jsx(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment, {}, void 0, query.location) : '';
};

var buildYearSearchLink = function buildYearSearchLink(query) {
  return query.transportHeader && query.yearFrom && query.yearTo && query.yearFrom === query.yearTo ? _jsx(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment, {}, void 0, query.yearTo) : '';
};

var buildAddHeaderByTransportSlug = function buildAddHeaderByTransportSlug(slug, t) {
  var transportHeader = 'автомобиля';
  switch (slug) {
    case 'moto':
      {
        transportHeader = 'мототехники';
        break;
      }
    case 'avtobus':
      {
        transportHeader = 'автобуса';
        break;
      }
    case 'gruzovye':
      {
        transportHeader = 'грузовика';
        break;
      }
    case 'spetstehnika':
      {
        transportHeader = 'спецтехники';
        break;
      }
    case 'pritsepy':
      {
        transportHeader = 'прицепа';
        break;
      }
    case 'vodnyi-transport':
      {
        transportHeader = 'водного транспорта';
        break;
      }
    case 'zapchasti':
      {
        transportHeader = 'автозапчастей';
        break;
      }

    default:
      {
        break;
      }
  }

  return t('Разместить объявление о продаже') + ' ' + t(transportHeader);
};
var buildSearchHeaderByType = function buildSearchHeaderByType(transportSlug) {
  return function (data, t) {
    var seoData = __WEBPACK_IMPORTED_MODULE_2_shared_helpers_seoTextFinder__["a" /* getSeoDataByParams */](data, t);
    if (seoData && seoData.header) return seoData.header;
    var _data$isNew = data.isNew,
        isNew = _data$isNew === undefined ? false : _data$isNew,
        _data$category = data.category,
        category = _data$category === undefined ? '' : _data$category,
        _data$gearbox = data.gearbox,
        gearbox = _data$gearbox === undefined ? '' : _data$gearbox,
        _data$engine = data.engine,
        engine = _data$engine === undefined ? '' : _data$engine,
        _data$type = data.type,
        type = _data$type === undefined ? '' : _data$type,
        _data$make = data.make,
        make = _data$make === undefined ? '' : _data$make,
        _data$model = data.model,
        model = _data$model === undefined ? '' : _data$model,
        _data$modification = data.modification,
        modification = _data$modification === undefined ? '' : _data$modification,
        location = data.location,
        country = data.country,
        transportHeader = data.transportHeader,
        locationObj = data.locationObj,
        yearFrom = data.yearFrom,
        yearTo = data.yearTo,
        motoHeader = data.motoHeader,
        _data$page = data.page,
        page = _data$page === undefined ? 1 : _data$page,
        yearTitle = data.yearTitle;

    var categoryLink = category && category.title ? buildCategorySearchLink({ isNew: isNew, transportHeader: transportHeader, category: category }) : '';
    var engineLink = engine ? buildEngineSearchLink({ isNew: isNew, transportHeader: transportHeader, engine: engine }) : '';
    var makeLink = buildMakeSearchLink({ isNew: isNew, transportHeader: transportHeader, make: make });
    var modelLink = buildModelSearchLink({ isNew: isNew, transportHeader: transportHeader, make: make, model: model });
    var gearboxLink = gearbox ? buildGearboxSearchLink({ isNew: isNew, transportHeader: transportHeader, gearbox: gearbox }) : '';
    var yearLink = buildYearSearchLink({
      transportHeader: transportHeader,
      make: make,
      model: model,
      isNew: isNew,
      yearFrom: yearFrom,
      yearTo: yearTo
    });
    var locationLink = location ? buildLocationSearchLink({
      transportHeader: transportHeader,
      make: make,
      model: model,
      location: location,
      locationObj: locationObj,
      isNew: isNew
    }) : t('в Украине');

    var commonLinksComponent = _jsx('span', {}, void 0, makeLink, ' ', modelLink, ' ', modification && modification.title + ' ', ' ', gearboxLink, ' ', yearTitle, locationLink);
    var commonLinks = commonLinksComponent.props.children;

    switch (transportSlug) {
      case 'avto':
        {
          if (country) {
            return _jsx('span', {}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment, {}, void 0, t('Купить'), ' ', !makeLink && !modelLink && t('авто')), ' ', makeLink, ' ', modelLink, ' ', country, buildPageEnding(page, t));
          } else if (isNew) {
            return _jsx('span', {}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment, {}, void 0, t('Купить новые'), ' ', !makeLink && !modelLink && t('авто')), ' ', makeLink, ' ', modelLink, ' ', locationLink, buildPageEnding(page, t));
          }

          return _jsx('span', {}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment, {}, void 0, t('Купить'), ' ', t('авто')), ' ', categoryLink, makeLink, ' ', modelLink, ' ', engineLink, ' ', gearboxLink, ' ', yearLink, ' ', yearLink && t('года'), ' ', locationLink, buildPageEnding(page, t));
        }

      case 'mototsikl':
        {
          if (motoHeader) {
            return _jsx('span', {}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment, {}, void 0, t('Купить'), ' ', motoHeader), ' ', categoryLink, ' ', commonLinks, buildPageEnding(page, t));
          } else if (isNew) {
            return _jsx('span', {}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment, {}, void 0, t('Купить новый мотоцикл')), ' ', categoryLink, ' ', commonLinks, buildPageEnding(page, t));
          }
          return _jsx('span', {}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment, {}, void 0, t('Купить мотоцикл')), ' ', categoryLink, ' ', commonLinks, buildPageEnding(page, t));
        }
      case 'moto':
        {
          if (motoHeader) {
            return _jsx('span', {}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment, {}, void 0, t('Купить'), ' ', motoHeader), ' ', categoryLink, ' ', commonLinks, buildPageEnding(page, t));
          } else if (isNew) {
            return _jsx('span', {}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment, {}, void 0, t('Купить'), ' ', !category && !type ? t('новую') : t('новый'), ' ', !category && !type && t('мототехнику'), ' ', type ? type.title.toLowerCase() : ''), ' ', categoryLink, ' ', commonLinks, buildPageEnding(page, t));
          }
          return _jsx('span', {}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment, {}, void 0, t('Купить'), ' ', !category && !type && t('мототехнику'), ' ', type ? type.title.toLowerCase() : ''), ' ', categoryLink, ' ', commonLinks, buildPageEnding(page, t));
        }
      case 'avtobus':
        return _jsx('span', {}, void 0, t('Купить'), ' ', categoryLink, ' ', t('автобус'), ' ', commonLinks, buildPageEnding(page, t));
      case 'gruzovye':
        return _jsx('span', {}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment, {}, void 0, t('Купить'), ' ', !engine && !category && t('грузовик') + ' '), ' ', categoryLink, ' ', engineLink, commonLinks, buildPageEnding(page, t));
      case 'spetstehnika':
        return _jsx('span', {}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment, {}, void 0, t('Купить'), ' ', !categoryLink && t('спецтехнику')), ' ', categoryLink, ' ', commonLinks, buildPageEnding(page, t));
      case 'pritsepy':
        return _jsx('span', {}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment, {}, void 0, t('Купить'), ' $', !category && !type && !engineLink && t('автоприцеп')), (category || type || engineLink) && _jsx('span', {}, void 0, categoryLink, ' ', type ? type.title.toLowerCase() : '', engineLink, ' '), ' ', commonLinks, buildPageEnding(page, t));
      default:
        return '';
    }
  };
};
var META_HEADER = {
  ADVERT_FORM: {
    ADD: function ADD(slug, t) {
      return buildAddHeaderByTransportSlug(slug, t);
    }
  },
  HOME: function HOME(hull, t) {
    return [t('Автобазар') + '\u2122', '–', t('Все машины тут')].join(' ');
  },
  DEALERS: function DEALERS(data, slug, t) {
    return buildDealersSeoHeader(data, slug, t);
  },
  FIRM: function FIRM(data, t) {
    return buildFirmsSeoHeader(data, t);
  },

  MOTO: function MOTO(_ref, t) {
    var location = _ref.location,
        locationWhere = _ref.locationWhere;
    return t('Купить') + ' ' + t('мототехнику') + ' ' + (t(locationWhere) || t('в Украине'));
  },

  //

  SEARCH: {
    avto: function avto(data, translate) {
      return buildSearchAvtoSeoHeader(data, translate);
    },
    mototsikl: function mototsikl(props, translate) {
      return buildSearchHeaderByType('mototsikl')(props, translate);
    },
    moto: function moto(props, translate) {
      return buildSearchHeaderByType('moto')(props, translate);
    },
    commercial: function commercial(params, t) {
      return buildCommercialSeoHeader(params, t);
    }
  },
  SPARE_PARTS: function SPARE_PARTS(data, rubricSlug, t, isRegion) {
    return buildSparePartsSeoHeader(data, rubricSlug, t, isRegion);
  },

  SERVICE: {
    CAR_DRIVE: function CAR_DRIVE(t) {
      return t('Пригон авто') + ' ' + t('на Автобазаре');
    }
  }
};

/* harmony default export */ __webpack_exports__["a"] = (META_HEADER);

/***/ }),

/***/ 1650:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {

  GLOBAL: {
    HIDE: '__react_tooltip_hide_event',
    REBUILD: '__react_tooltip_rebuild_event',
    SHOW: '__react_tooltip_show_event'
  }
};

/***/ }),

/***/ 1652:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// CONCATENATED MODULE: ./src/shared/helpers/searchSubscriptions.js
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_shared_helpers_common__ = __webpack_require__(184);


// "lte"(less than equal) - like "to"
// "gte"(greater than equal) - like "from"
var getFromTo = function getFromTo(_ref, t) {
  var gte = _ref.gte,
      lte = _ref.lte;

  if (gte && lte) return gte + ' - ' + lte;else if (gte && !lte) return t('от') + ' ' + gte;else if (!gte && lte) return '\u0434\u043E ' + lte;
  return null;
};

var getSaveSearchParams = function getSaveSearchParams(props, t) {
  if (props) {
    var transportChild = props.transport_child,
        location = props.location,
        engine = props.engine,
        gearbox = props.gearbox,
        drive = props.drive,
        category = props.category,
        currency = props.currency,
        price = props.price,
        year = props.year,
        mileage = props.mileage;


    var infoList = [];
    infoList = [{
      title: t('Тип'),
      value: __WEBPACK_IMPORTED_MODULE_0_shared_helpers_common__["h" /* getTitleOrEmpty */](transportChild)
    }, {
      title: t('Кузов'),
      value: __WEBPACK_IMPORTED_MODULE_0_shared_helpers_common__["h" /* getTitleOrEmpty */](category)
    }, {
      title: t('двигатель'),
      value: __WEBPACK_IMPORTED_MODULE_0_shared_helpers_common__["h" /* getTitleOrEmpty */](engine)
    }, {
      title: t('Цена'),
      value: price && getFromTo(price, t),
      unitMeasurement: currency
    }, {
      title: t('Пробег'),
      value: mileage && getFromTo(mileage, t),
      unitMeasurement: 'тыс. км'
    }, {
      title: t('Год'),
      value: year && getFromTo(year, t)
    }, {
      title: t('Регион'),
      value: __WEBPACK_IMPORTED_MODULE_0_shared_helpers_common__["h" /* getTitleOrEmpty */](location)
    }, {
      title: t('Коробка'),
      value: __WEBPACK_IMPORTED_MODULE_0_shared_helpers_common__["h" /* getTitleOrEmpty */](gearbox)
    }, {
      title: t('Привод'),
      value: __WEBPACK_IMPORTED_MODULE_0_shared_helpers_common__["h" /* getTitleOrEmpty */](drive)
    }].filter(function (item) {
      return item.value;
    });

    return infoList;
  }
};
// CONCATENATED MODULE: ./src/shared/components/VerifyEmailModal/VerifyEmailModal.js
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(1240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_shared_components_Link_Link__ = __webpack_require__(1241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_shared_hocs_withTranslate__ = __webpack_require__(1242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_shared_components_AntdComponents_Button_Button__ = __webpack_require__(1498);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_shared_actions_user__ = __webpack_require__(476);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_shared_components_ModalContainer_ModalContainer__ = __webpack_require__(1256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_shared_actions_notifications__ = __webpack_require__(475);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__VerifyEmailModal_css__ = __webpack_require__(1659);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__VerifyEmailModal_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__VerifyEmailModal_css__);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }















var isMobile = "desktop" === 'mobile';

var VerifyEmailModal = function (_React$Component) {
  _inherits(VerifyEmailModal, _React$Component);

  function VerifyEmailModal() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, VerifyEmailModal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = VerifyEmailModal.__proto__ || Object.getPrototypeOf(VerifyEmailModal)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      verify: false,
      action: {},
      user: {}
    }, _this.confirmEmail = function (dat) {
      var _this$props = _this.props,
          action = _this$props.action,
          user = _this$props.user,
          switchModal = _this$props.switchModal,
          enqueueNotif = _this$props.enqueueNotif,
          t = _this$props.t;


      var phone = user.phones && user.phones.length && user.phones[0].number;

      action.userVerifyMail({ enqueueNotification: __WEBPACK_IMPORTED_MODULE_11_shared_actions_notifications__["a" /* enqueueNotification */] });
      action.logistics({
        event: 'view',
        object_id: 0,
        object_type: 'advert',
        event_id: dat,
        user_id: user.id,
        email: user.email,
        phone: phone,
        button: 'email verify'
      });
      switchModal();

      enqueueNotif(t('\u041D\u0430 {email} \u043E\u0442\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u043E \u0441\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u0435 \u0434\u043B\u044F \u043F\u043E\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0435\u043D\u0438\u044F \u043F\u043E\u0447\u0442\u044B', { email: user.email }));
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(VerifyEmailModal, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          showModal = _props.showModal,
          switchModal = _props.switchModal,
          _props$user = _props.user,
          email = _props$user.email,
          isEmailVerified = _props$user.is_email_verified,
          t = _props.t;

      var redirectUrl = (t('locale') === 'uk' ? '/uk' : '') + '/profile/';

      if (isEmailVerified || !showModal) {
        return '';
      }

      return _jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_12__VerifyEmailModal_css___default.a.root
      }, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_10_shared_components_ModalContainer_ModalContainer__["a" /* default */], {
        modalCN: __WEBPACK_IMPORTED_MODULE_1_classnames___default.a(__WEBPACK_IMPORTED_MODULE_12__VerifyEmailModal_css___default.a.modal, _defineProperty({}, __WEBPACK_IMPORTED_MODULE_12__VerifyEmailModal_css___default.a.mobileModal, isMobile)),
        onClose: switchModal,
        isOpen: showModal
      }, void 0, !email && _jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_12__VerifyEmailModal_css___default.a.mainBlock
      }, void 0, _jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_12__VerifyEmailModal_css___default.a.info
      }, void 0, t('Для оформления подписки, нужно добавить электронную почту')), _jsx(__WEBPACK_IMPORTED_MODULE_5_shared_components_Link_Link__["a" /* default */], {
        className: __WEBPACK_IMPORTED_MODULE_1_classnames___default.a(__WEBPACK_IMPORTED_MODULE_12__VerifyEmailModal_css___default.a.btn),
        to: redirectUrl
      }, void 0, t('Добавить'))), email && !isEmailVerified && _jsx('div', {
        className: isMobile ? __WEBPACK_IMPORTED_MODULE_12__VerifyEmailModal_css___default.a.mobileRoot : __WEBPACK_IMPORTED_MODULE_12__VerifyEmailModal_css___default.a.desktopRoot
      }, void 0, _jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_12__VerifyEmailModal_css___default.a.mainBlock
      }, void 0, _jsx('span', {
        className: __WEBPACK_IMPORTED_MODULE_12__VerifyEmailModal_css___default.a.info
      }, void 0, t('Для оформления подписки, нужно подтвердить электронную почту')), _jsx(__WEBPACK_IMPORTED_MODULE_7_shared_components_AntdComponents_Button_Button__["a" /* default */], {
        className: __WEBPACK_IMPORTED_MODULE_1_classnames___default.a(__WEBPACK_IMPORTED_MODULE_12__VerifyEmailModal_css___default.a.btn),
        type: 'primary',
        onClick: function onClick() {
          return _this2.confirmEmail('Q9gqm1fCNuk2LOBKQ');
        }
      }, void 0, t('Подтвердить')))), _jsx('span', {
        className: __WEBPACK_IMPORTED_MODULE_12__VerifyEmailModal_css___default.a.closeBtn,
        onClick: switchModal
      })));
    }
  }]);

  return VerifyEmailModal;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var mapStateToProps = function mapStateToProps(_ref2) {
  var user = _ref2.user;
  return {
    enqueueNotification: __WEBPACK_IMPORTED_MODULE_11_shared_actions_notifications__["a" /* enqueueNotification */],
    user: user.user
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    action: __WEBPACK_IMPORTED_MODULE_4_redux__["b" /* bindActionCreators */]({ userVerifyMail: __WEBPACK_IMPORTED_MODULE_9_shared_actions_user__["w" /* userVerifyMail */], logistics: __WEBPACK_IMPORTED_MODULE_9_shared_actions_user__["j" /* logistics */] }, dispatch),
    enqueueNotif: __WEBPACK_IMPORTED_MODULE_4_redux__["b" /* bindActionCreators */](__WEBPACK_IMPORTED_MODULE_11_shared_actions_notifications__["a" /* enqueueNotification */], dispatch),
    dispatch: dispatch
  };
};

/* harmony default export */ var VerifyEmailModal_defaultExport = (__WEBPACK_IMPORTED_MODULE_8_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_12__VerifyEmailModal_css___default.a)(__WEBPACK_IMPORTED_MODULE_3_react_redux__["b" /* connect */](mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_6_shared_hocs_withTranslate__["a" /* withTranslate */](VerifyEmailModal))));
// CONCATENATED MODULE: ./src/shared/constants/searchSubscriptions.js
var ERROR_MESSAGE = 'Извините, произошла ошибка на сервере, попробуйте повторить операцию позже';

var TO_MATCH_SUB_MESSAGE = 'Вы можете оформить 6 подписок, если Вам необходимо большее количество подписок, обращайтесь на sales@ab.ua.';

var SUB_OPTIONS = [{ key: 'every-hour', label: 'Получать письма каждый час' }, { key: 'every-four-hours', label: 'Получать письма каждые 4 часа' }, { key: 'daily', label: 'Получать письма раз в день' }, { key: 'weekly', label: 'Получать письма раз в неделю' }, { key: null, label: 'Не получать письма' }];
// CONCATENATED MODULE: ./src/shared/components/SavedSearchItem/SavedSearchItem.js
/* harmony import */ var SavedSearchItem___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var SavedSearchItem___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(SavedSearchItem___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_select__ = __webpack_require__(477);
/* harmony import */ var SavedSearchItem___WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(131);
/* harmony import */ var SavedSearchItem___WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(SavedSearchItem___WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var SavedSearchItem___WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shared_constants_api__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_shared_components_Link__ = __webpack_require__(1241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_redux__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_shared_actions_user__ = __webpack_require__(476);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_shared_hocs_withTranslate__ = __webpack_require__(1242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_shared_actions_notifications__ = __webpack_require__(475);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_shared_modules__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_shared_hocs_withFetch__ = __webpack_require__(1244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__SavedSearchItem_css__ = __webpack_require__(1661);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__SavedSearchItem_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__SavedSearchItem_css__);
var SavedSearchItem__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var SavedSearchItem__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function SavedSearchItem__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function SavedSearchItem__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function SavedSearchItem__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



















var SavedSearchItem_SavedSearchItem = function (_React$Component) {
  SavedSearchItem__inherits(SavedSearchItem, _React$Component);

  function SavedSearchItem() {
    var _ref;

    var _temp, _this, _ret;

    SavedSearchItem__classCallCheck(this, SavedSearchItem);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = SavedSearchItem__possibleConstructorReturn(this, (_ref = SavedSearchItem.__proto__ || Object.getPrototypeOf(SavedSearchItem)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      location: null,
      stateNotifPeriod: SUB_OPTIONS[4],
      showVerifyModal: false
    }, _this.updatedStoreSearches = function (updatedSearch) {
      var _this$props = _this.props,
          savedSearches = _this$props.savedSearches,
          setSearches = _this$props.setSearches;


      var newSavedSearches = savedSearches.map(function (item) {
        if (item.id === updatedSearch.id) return updatedSearch;
        return item;
      });

      setSearches(newSavedSearches);
    }, _this.deleteSearchSub = function () {
      var _this$props2 = _this.props,
          token = _this$props2.user.token,
          enqueueNotif = _this$props2.enqueueNotif,
          setSearches = _this$props2.setSearches,
          savedSearches = _this$props2.savedSearches,
          togglePopup = _this$props2.togglePopup,
          searchItem = _this$props2.searchItem,
          t = _this$props2.t;


      fetch(__WEBPACK_IMPORTED_MODULE_4_shared_constants_api__["a" /* default */].ADVERT.SEARCH_SUB_BY_ID(searchItem.id), {
        method: 'DELETE',
        headers: {
          Authorization: 'JWT ' + token
        }
      }).then(function (resp) {
        if (resp.ok) {
          // start deleting item from array
          var deletedItem = savedSearches.find(function (item) {
            return item.id === searchItem.id;
          });
          var index = savedSearches.indexOf(deletedItem);

          if (index > -1) savedSearches.splice(index, 1);
          setSearches([]);
          setSearches(savedSearches);
          togglePopup();
          enqueueNotif(t('Подписка на поиск удалена'));
          // end deleting item from array
        } else {
          enqueueNotif(t(ERROR_MESSAGE));
          togglePopup();
        }
      });
    }, _this.updatePeriod = function (period) {
      var _this$props3 = _this.props,
          fetch = _this$props3.fetch,
          updateStateItemPeriod = _this$props3.updateStateItemPeriod,
          token = _this$props3.user.token,
          enqueueNotif = _this$props3.enqueueNotif,
          searchItem = _this$props3.searchItem,
          setSearches = _this$props3.setSearches,
          savedSearches = _this$props3.savedSearches,
          t = _this$props3.t;


      var updatedSearch = _extends({}, searchItem, { update_period: period.key });
      updateStateItemPeriod(updatedSearch);
      _this.updatedStoreSearches(updatedSearch);

      fetch(__WEBPACK_IMPORTED_MODULE_4_shared_constants_api__["a" /* default */].ADVERT.SEARCH_SUB_BY_ID(searchItem.id), {
        method: 'PATCH',
        body: JSON.stringify({ update_period: period.key }),
        headers: {
          Authorization: 'JWT ' + token,
          'Content-Type': 'application/json'
        }
      }).then(function (resp) {
        if (resp.status === 402) {
          setSearches(savedSearches);
          enqueueNotif(t(TO_MATCH_SUB_MESSAGE));
        } else if (resp.status === 400) {
          updateStateItemPeriod(searchItem);
          setSearches(savedSearches);

          _this.setState({ showVerifyModal: true });
        } else if (resp.status !== 200) enqueueNotif(t(ERROR_MESSAGE));
      });
    }, _this.switchVerifyModal = function () {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if (e) e.preventDefault();
      _this.setState({ showVerifyModal: !_this.state.showVerifyModal });
    }, _temp), SavedSearchItem__possibleConstructorReturn(_this, _ret);
  }

  SavedSearchItem__createClass(SavedSearchItem, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          searchItem = _props.searchItem,
          t = _props.t;
      var _state = this.state,
          stateNotifPeriod = _state.stateNotifPeriod,
          showVerifyModal = _state.showVerifyModal;


      var notifPeriod = searchItem ? SUB_OPTIONS.find(function (item) {
        return item.key === searchItem.update_period;
      }) : stateNotifPeriod;

      var infoSearchParams = searchItem ? getSaveSearchParams(searchItem, t) : [];
      var plusCountParams = infoSearchParams.length - 3;

      return SavedSearchItem__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_16__SavedSearchItem_css___default.a.root
      }, void 0, SavedSearchItem__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_16__SavedSearchItem_css___default.a.titleBlock
      }, void 0, SavedSearchItem__jsx(__WEBPACK_IMPORTED_MODULE_5_shared_components_Link__["a" /* default */], {
        to: __WEBPACK_IMPORTED_MODULE_14_shared_modules__["d" /* camelCaseToUpperCase */](searchItem.link),
        className: __WEBPACK_IMPORTED_MODULE_16__SavedSearchItem_css___default.a.savedTitle
      }, void 0, searchItem.title), SavedSearchItem__jsx('i', {
        className: 'fa fa-trash ' + __WEBPACK_IMPORTED_MODULE_16__SavedSearchItem_css___default.a.trashIcon,
        onClick: this.deleteSearchSub
      })), SavedSearchItem__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_16__SavedSearchItem_css___default.a.infoBlock
      }, void 0, infoSearchParams.slice(0, 3).map(function (item) {
        return SavedSearchItem__jsx('div', {
          className: __WEBPACK_IMPORTED_MODULE_16__SavedSearchItem_css___default.a.infoItem
        }, item.title, SavedSearchItem__jsx('div', {
          className: __WEBPACK_IMPORTED_MODULE_16__SavedSearchItem_css___default.a.infoTitle
        }, void 0, item.title, ':'), SavedSearchItem__jsx('div', {}, void 0, item.value + ' ' + (item.unitMeasurement || '')));
      }), plusCountParams > 0 ? SavedSearchItem__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_16__SavedSearchItem_css___default.a.infoItem
      }, void 0, SavedSearchItem__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_16__SavedSearchItem_css___default.a.infoTitle
      }, void 0, '+ ' + plusCountParams + ' \u043F\u0430\u0440\u0430\u043C\u0435\u0442\u0440')) : ''), SavedSearchItem__jsx('div', {}, void 0, SavedSearchItem__jsx(__WEBPACK_IMPORTED_MODULE_1_react_select__["a" /* default */], {
        onChange: this.updatePeriod,
        labelKey: 'label',
        valueKey: 'key',
        value: notifPeriod,
        options: SUB_OPTIONS,
        clearable: false,
        searchable: false
      })), SavedSearchItem__jsx(VerifyEmailModal_defaultExport, {
        switchModal: this.switchVerifyModal,
        showModal: showVerifyModal
      }));
    }
  }]);

  return SavedSearchItem;
}(SavedSearchItem___WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

SavedSearchItem_SavedSearchItem.defaultProps = {
  user: {},
  updateStateItemPeriod: function updateStateItemPeriod() {},
  togglePopup: function togglePopup() {}
};


var SavedSearchItem_mapStateToProps = function mapStateToProps(_ref2) {
  var user = _ref2.user,
      globals = _ref2.globals;
  return {
    location: globals.location,
    savedSearches: user.savedSearches || [],
    user: user
  };
};

var SavedSearchItem_mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    enqueueNotif: __WEBPACK_IMPORTED_MODULE_6_redux__["b" /* bindActionCreators */](__WEBPACK_IMPORTED_MODULE_9_shared_actions_notifications__["a" /* enqueueNotification */], dispatch),
    setSearches: __WEBPACK_IMPORTED_MODULE_6_redux__["b" /* bindActionCreators */](__WEBPACK_IMPORTED_MODULE_7_shared_actions_user__["o" /* setSavedSearches */], dispatch)
  };
};

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_13_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_16__SavedSearchItem_css___default.a)(SavedSearchItem___WEBPACK_IMPORTED_MODULE_3_react_redux__["b" /* connect */](SavedSearchItem_mapStateToProps, SavedSearchItem_mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_15_shared_hocs_withFetch__["a" /* withFetch */](__WEBPACK_IMPORTED_MODULE_8_shared_hocs_withTranslate__["a" /* withTranslate */](SavedSearchItem_SavedSearchItem)))));

/***/ }),

/***/ 1659:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1660);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./VerifyEmailModal.css", function() {
        content = require("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./VerifyEmailModal.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 1660:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, "._1XQu9{cursor:pointer;font-size:14px;display:inline-block;border-bottom:1px solid currentColor}._1XQu9:hover{opacity:.8}._1P0tf{position:relative;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-align:center;-ms-flex-align:center;align-items:center;text-align:center;border-radius:4px;width:700px;display:-webkit-box;display:-ms-flexbox;display:flex;padding:15px 25px}._3DwT7{padding:25px 0;width:95%}._3GDqf{min-width:400px;height:auto}.E0-Zr{width:90%;max-height:350px;overflow-y:auto}.k3RCY{position:absolute;cursor:pointer;top:3px;right:10px;font-size:22px}.k3RCY:before{content:\"\\D7\"}.q8VlR{margin:0 20px 0 0}._37TSl{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;margin:5px 0;text-align:center;font-weight:400;color:#6b6b6b;font-size:16px;background-color:#fff;padding:5px 0;-webkit-box-align:center;-ms-flex-align:center;align-items:center}._149IF{text-align:center;padding:6px 12px;border-radius:3px;-webkit-box-shadow:0 4px 18px rgba(0,0,0,.14);box-shadow:0 4px 18px rgba(0,0,0,.14);font-weight:600;margin-top:10px;cursor:pointer;width:-webkit-fit-content;width:-moz-fit-content;width:fit-content}._149IF,._149IF:active,._149IF:focus,._149IF:hover{border:1px solid #ffd906;color:#000;background-color:#ffd906}._149IF:active,._149IF:focus,._149IF:hover{text-decoration:none;-webkit-box-shadow:0 4px 18px rgba(0,0,0,.24);box-shadow:0 4px 18px rgba(0,0,0,.24)}", ""]);

// exports
exports.locals = {
	"root": "_1XQu9",
	"modal": "_1P0tf",
	"mobileModal": "_3DwT7",
	"desktopRoot": "_3GDqf",
	"mobileRoot": "E0-Zr",
	"closeBtn": "k3RCY",
	"info": "q8VlR",
	"mainBlock": "_37TSl",
	"btn": "_149IF"
};

/***/ }),

/***/ 1661:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1662);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./SavedSearchItem.css", function() {
        content = require("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./SavedSearchItem.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 1662:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, "._2G9M6{height:100%;-webkit-box-orient:vertical;-ms-flex-direction:column;flex-direction:column}._2G9M6,._3Sjkb{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-direction:normal;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}._3Sjkb{-webkit-box-orient:horizontal;-ms-flex-direction:row;flex-direction:row}._1bKaV{height:20px;width:20px;color:#6d6d6d;font-size:16px;cursor:pointer}._3Y7Y8{font-size:15px;font-weight:700;line-height:18px}._3Y7Y8:first-letter{text-transform:uppercase}._3USW_{-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;font-size:13px;line-height:18px;margin:5px}._3USW_,._31s51{display:-webkit-box;display:-ms-flexbox;display:flex}._3fSjw{display:inline;padding-right:10px;text-transform:lowercase;color:grey}", ""]);

// exports
exports.locals = {
	"root": "_2G9M6",
	"titleBlock": "_3Sjkb",
	"trashIcon": "_1bKaV",
	"savedTitle": "_3Y7Y8",
	"infoBlock": "_3USW_",
	"infoItem": "_31s51",
	"infoTitle": "_3fSjw"
};

/***/ }),

/***/ 1701:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_history_js__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_snakeCase__ = __webpack_require__(1725);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_snakeCase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_snakeCase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_query_string__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_query_string___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_query_string__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_shared_constants_api__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_snakecase_keys__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_snakecase_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_snakecase_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_redux__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_shared_helpers_locale__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_shared_helpers_users__ = __webpack_require__(1272);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_shared_actions_notifications__ = __webpack_require__(475);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_shared_actions_globals__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_shared_actions_user__ = __webpack_require__(476);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_shared_helpers_urls__ = __webpack_require__(312);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__helpers_common__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__withFetch__ = __webpack_require__(1244);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



















var withSubscriptionSearch = function withSubscriptionSearch(WrappedComponent) {
  var _class, _temp2;

  var Component = (_temp2 = _class = function (_React$Component) {
    _inherits(Component, _React$Component);

    function Component() {
      var _ref;

      var _temp, _this, _ret;

      _classCallCheck(this, Component);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Component.__proto__ || Object.getPrototypeOf(Component)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
        savedSearch: null
      }, _this.componentDidMount = function () {
        var _this$props = _this.props,
            redirectUrl = _this$props.redirectUrl,
            clearRedUrl = _this$props.clearRedUrl,
            isFirstRender = _this$props.isFirstRender;


        if (redirectUrl && _this.verifySavedSearch() && isFirstRender) {
          clearRedUrl();
        } else if (redirectUrl && isFirstRender) {
          _this.saveSearch();
          clearRedUrl();
        }
      }, _this.setSavedSearchToState = function (data) {
        return _this.setState({ savedSearch: data });
      }, _this.hideSavedSearch = function () {
        var onChangeSaveSearchBtn = _this.props.onChangeSaveSearchBtn;


        onChangeSaveSearchBtn(false);
        _this.setSavedSearchToState(null);
      }, _this.verifySavedSearch = function () {
        var _this$props2 = _this.props,
            formState = _this$props2.formState,
            savedSearches = _this$props2.savedSearches,
            location = _this$props2.location;


        var editedFormState = _extends({}, formState, __WEBPACK_IMPORTED_MODULE_10_shared_helpers_users__["a" /* correctionYears */](formState));
        var rewrittenKeys = {};

        Object.keys(editedFormState).map(
        // eslint-disable-next-line no-return-assign
        function (key) {
          return rewrittenKeys[__WEBPACK_IMPORTED_MODULE_3_lodash_snakeCase___default.a(key)] = editedFormState[key];
        });

        var pathname = __WEBPACK_IMPORTED_MODULE_14_shared_helpers_urls__["e" /* generateSearchUrl */](_extends({}, rewrittenKeys, { location: location }), location && location.is_country);

        pathname = pathname.substring(0, pathname.length - 1);

        var query = __WEBPACK_IMPORTED_MODULE_14_shared_helpers_urls__["d" /* generateSearchQuery */](rewrittenKeys);
        var searchUrl = '/' + pathname + '?' + __WEBPACK_IMPORTED_MODULE_5_query_string___default.a.stringify(query);

        return savedSearches.find(function (item) {
          return item.link === searchUrl;
        }) || null;
      }, _this.saveSearch = function () {
        var _this$props3 = _this.props,
            t = _this$props3.t,
            enqueueNotif = _this$props3.enqueueNotif,
            formState = _this$props3.formState,
            user = _this$props3.user,
            fetch = _this$props3.fetch,
            location = _this$props3.location,
            setSearches = _this$props3.setSearches,
            savedSearches = _this$props3.savedSearches,
            setRedUrl = _this$props3.setRedUrl;

        var token = user && user.token;

        var editedFormState = _extends({}, formState, __WEBPACK_IMPORTED_MODULE_10_shared_helpers_users__["a" /* correctionYears */](formState));
        var query = __WEBPACK_IMPORTED_MODULE_14_shared_helpers_urls__["d" /* generateSearchQuery */](editedFormState);

        if (token) {
          fetch(__WEBPACK_IMPORTED_MODULE_6_shared_constants_api__["a" /* default */].ADVERT.SEARCH_SUB, {
            method: 'POST',
            body: JSON.stringify({ query: __WEBPACK_IMPORTED_MODULE_5_query_string___default.a.stringify(__WEBPACK_IMPORTED_MODULE_7_snakecase_keys___default.a(query)) }),
            headers: {
              Authorization: 'JWT ' + token
            }
          }).then(function (r) {
            return r.json();
          }).then(function (data) {
            if (data && data.id) {
              setSearches([].concat(_toConsumableArray(savedSearches), [_extends({}, data)]));
              enqueueNotif(t('Подписка оформлена'));
              _this.setSavedSearchToState(data);
            }
          });
        } else {
          var pathname = __WEBPACK_IMPORTED_MODULE_14_shared_helpers_urls__["e" /* generateSearchUrl */](_extends({}, editedFormState, { location: location }), location && location.is_country);
          var redirectUrl = '/' + pathname + '?' + __WEBPACK_IMPORTED_MODULE_5_query_string___default.a.stringify(query);
          var locale = t('locale') === 'uk' ? '/uk' : '';

          setRedUrl(redirectUrl);
          __WEBPACK_IMPORTED_MODULE_1_history_js__["a" /* default */].push(__WEBPACK_IMPORTED_MODULE_9_shared_helpers_locale__["h" /* toLocalized */](locale + '/my'));
        }
      }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(Component, [{
      key: 'render',
      value: function render() {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(WrappedComponent, _extends({}, this.props, {
          saveSearch: this.saveSearch,
          verifySavedSearch: this.verifySavedSearch,
          setSavedSearchToState: this.setSavedSearchToState,
          savedSearch: this.state.savedSearch,
          hideSavedSearch: this.hideSavedSearch
        }));
      }
    }]);

    return Component;
  }(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component), _class.displayName = 'withSubscriptionSearch(' + __WEBPACK_IMPORTED_MODULE_15__helpers_common__["e" /* getDisplayName */](WrappedComponent) + ')', _class.defaultProps = {
    isFirstRender: false,
    location: null,
    user: {}
  }, _temp2);

  var mapStateToProps = function mapStateToProps(_ref2) {
    var user = _ref2.user,
        searchForm = _ref2.searchForm,
        globals = _ref2.globals;
    return {
      formState: searchForm && searchForm.selected,
      location: globals.location,
      savedSearches: user.savedSearches || [],
      redirectUrl: globals.redirectUrl,
      showSaveSearchBtn: user.showSaveSearchBtn,
      user: user
    };
  };

  var mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return {
      setSearches: __WEBPACK_IMPORTED_MODULE_8_redux__["b" /* bindActionCreators */](__WEBPACK_IMPORTED_MODULE_13_shared_actions_user__["o" /* setSavedSearches */], dispatch),
      enqueueNotif: __WEBPACK_IMPORTED_MODULE_8_redux__["b" /* bindActionCreators */](__WEBPACK_IMPORTED_MODULE_11_shared_actions_notifications__["a" /* enqueueNotification */], dispatch),
      setRedUrl: __WEBPACK_IMPORTED_MODULE_8_redux__["b" /* bindActionCreators */](__WEBPACK_IMPORTED_MODULE_12_shared_actions_globals__["x" /* setRedirectUrl */], dispatch),
      clearRedUrl: __WEBPACK_IMPORTED_MODULE_8_redux__["b" /* bindActionCreators */](__WEBPACK_IMPORTED_MODULE_12_shared_actions_globals__["e" /* clearRedirectUrl */], dispatch),
      onChangeSaveSearchBtn: __WEBPACK_IMPORTED_MODULE_8_redux__["b" /* bindActionCreators */](__WEBPACK_IMPORTED_MODULE_13_shared_actions_user__["p" /* setShowSaveSearchBtn */], dispatch)
    };
  };

  return __WEBPACK_IMPORTED_MODULE_4_react_redux__["b" /* connect */](mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_16__withFetch__["a" /* withFetch */](Component));
};

/* harmony default export */ __webpack_exports__["a"] = (withSubscriptionSearch);

/***/ }),

/***/ 1702:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// CONCATENATED MODULE: ./src/desktop/components/LocationsBlock/OptionRenderer/OptionRenderer.js
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(1240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__OptionRenderer_css__ = __webpack_require__(1735);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__OptionRenderer_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__OptionRenderer_css__);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();






var optionsBlockRenderer = function optionsBlockRenderer(params) {
  return _jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_3__OptionRenderer_css___default.a.optionsBlock
  }, void 0, _jsx('span', {
    className: __WEBPACK_IMPORTED_MODULE_1_classnames___default.a(__WEBPACK_IMPORTED_MODULE_3__OptionRenderer_css___default.a.optionItem, params.disabled ? __WEBPACK_IMPORTED_MODULE_3__OptionRenderer_css___default.a.optionItemDisabled : __WEBPACK_IMPORTED_MODULE_3__OptionRenderer_css___default.a.optionItemActive)
  }, void 0, params.title));
};

/* harmony default export */ var OptionRenderer_defaultExport = (__WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_3__OptionRenderer_css___default.a)(optionsBlockRenderer));
// CONCATENATED MODULE: ./src/desktop/components/LocationsBlock/LocationsBlock.js
/* harmony import */ var LocationsBlock___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var LocationsBlock___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(LocationsBlock___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var LocationsBlock___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var LocationsBlock___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(LocationsBlock___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(1240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_pick__ = __webpack_require__(506);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_pick___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_pick__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_shared_components_Link__ = __webpack_require__(1241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_addons_css_transition_group__ = __webpack_require__(1273);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_addons_css_transition_group___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_addons_css_transition_group__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_redux__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_query_string__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_query_string___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_query_string__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_intl__ = __webpack_require__(474);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_shared_modules__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_select__ = __webpack_require__(477);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_onclickoutside__ = __webpack_require__(1276);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_shared_constants_json_regions_cities_json__ = __webpack_require__(513);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_shared_constants_json_regions_cities_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_shared_constants_json_regions_cities_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_shared_actions_globals__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_shared_actions_searchForm__ = __webpack_require__(482);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_shared_assets_images_placeholder_filled_point_svg__ = __webpack_require__(1734);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_shared_assets_images_placeholder_filled_point_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_shared_assets_images_placeholder_filled_point_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_shared_components_Loader_Loader__ = __webpack_require__(1249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_shared_helpers_locale__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_shared_actions_partsForm__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_history_js__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_shared_helpers_arrays__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_shared_helpers_urls__ = __webpack_require__(312);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__LocationsBlock_css__ = __webpack_require__(1737);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__LocationsBlock_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__LocationsBlock_css__);
var LocationsBlock__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



























var LocationsBlock_LocationsBlock = function (_React$Component) {
  _inherits(LocationsBlock, _React$Component);

  function LocationsBlock() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, LocationsBlock);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = LocationsBlock.__proto__ || Object.getPrototypeOf(LocationsBlock)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      regionSelected: null,
      showLocationPopup: false,
      shouldInjectSecondaryLocations: false
    }, _this.handleSelectInputChange = function (str) {
      _this.setState({ shouldInjectSecondaryLocations: !!str });
    }, _this.handleListLocationSelect = function (location) {
      if (!_this.state.regionSelected) _this.setState({ regionSelected: location });else _this.handleLocationChange(location);
    }, _this.handleLocationChange = function (location) {
      _this.props.dispatch(__WEBPACK_IMPORTED_MODULE_14_shared_actions_globals__["f" /* directSetLocation */](location));

      _this.handleClickOutside();
      _this.updateUrl(location);

      _this.props.dispatch(__WEBPACK_IMPORTED_MODULE_15_shared_actions_searchForm__["t" /* transportSetThunks */].count());
    }, _this.handleLocationButtonClick = function () {
      _this.setState(function (_ref2) {
        var showLocationPopup = _ref2.showLocationPopup;
        return { showLocationPopup: !showLocationPopup };
      });
    }, _this.handleClickOutside = function () {
      return _this.setState({ showLocationPopup: false });
    }, _this.stopPropagation = function (e) {
      return e.stopPropagation();
    }, _this.refreshHomePage = function (location) {
      __WEBPACK_IMPORTED_MODULE_20_history_js__["a" /* default */].push(__WEBPACK_IMPORTED_MODULE_18_shared_helpers_locale__["h" /* toLocalized */](('/' + (location ? location.slug : '') + '/').replace(/\/\//g, '/')));
    }, _this.refreshMotoPage = function (location) {
      __WEBPACK_IMPORTED_MODULE_20_history_js__["a" /* default */].push(__WEBPACK_IMPORTED_MODULE_18_shared_helpers_locale__["h" /* toLocalized */](('/moto/' + (location ? location.slug : '') + '/').replace(/\/\//g, '/')));
    }, _this.refreshCommercialPage = function (location) {
      __WEBPACK_IMPORTED_MODULE_20_history_js__["a" /* default */].push(__WEBPACK_IMPORTED_MODULE_18_shared_helpers_locale__["h" /* toLocalized */](('/commercial/' + (location ? location.slug : '') + '/').replace(/\/\//g, '/')));
    }, _this.refreshSearchPage = function (location) {
      var _this$props = _this.props,
          formState = _this$props.formState,
          locale = _this$props.locale;


      var state = _extends({}, formState, { location: location });
      var pathname = __WEBPACK_IMPORTED_MODULE_22_shared_helpers_urls__["e" /* generateSearchUrl */](state);
      var query = __WEBPACK_IMPORTED_MODULE_22_shared_helpers_urls__["d" /* generateSearchQuery */](state);

      __WEBPACK_IMPORTED_MODULE_20_history_js__["a" /* default */].push(__WEBPACK_IMPORTED_MODULE_18_shared_helpers_locale__["h" /* toLocalized */]('/' + pathname + '?' + __WEBPACK_IMPORTED_MODULE_8_query_string___default.a.stringify(query), locale));
    }, _this.refreshDealersPage = function (location) {
      var _this$props2 = _this.props,
          formState = _this$props2.formState,
          locale = _this$props2.locale;

      var state = _extends({}, formState, { location: location });
      var pathname = __WEBPACK_IMPORTED_MODULE_22_shared_helpers_urls__["a" /* generateDealersSearchUrl */](state);
      var query = __WEBPACK_IMPORTED_MODULE_22_shared_helpers_urls__["d" /* generateSearchQuery */](state);
      __WEBPACK_IMPORTED_MODULE_20_history_js__["a" /* default */].push(__WEBPACK_IMPORTED_MODULE_18_shared_helpers_locale__["h" /* toLocalized */]('/' + pathname + '?' + __WEBPACK_IMPORTED_MODULE_8_query_string___default.a.stringify(query), locale));
    }, _this.refreshFirmsPage = function () {
      var location = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var _this$props3 = _this.props,
          formState = _this$props3.formState,
          locale = _this$props3.locale,
          seoSearchUrlResponse = _this$props3.globals.seoSearchUrlResponse,
          _this$props3$partsFor = _this$props3.partsForm.vocabulary,
          query = _this$props3$partsFor.query,
          queryobj = _this$props3$partsFor.queryobj;

      var queryObj = _extends({}, queryobj);
      var queryStr = '?' + query;
      var state = _extends({}, formState);
      var pathname = __WEBPACK_IMPORTED_MODULE_22_shared_helpers_urls__["b" /* generateFirmsSearchUrl */](state);
      if (!(seoSearchUrlResponse && seoSearchUrlResponse.tag && seoSearchUrlResponse.tag.slug && seoSearchUrlResponse.kind === 'firms')) {
        return '';
      }
      if (location && location.slug) {
        _this.props.dispatch(__WEBPACK_IMPORTED_MODULE_19_shared_actions_partsForm__["a" /* hrefSet */]({
          queryObj: queryObj,
          url: __WEBPACK_IMPORTED_MODULE_18_shared_helpers_locale__["h" /* toLocalized */]('/' + pathname + '/' + seoSearchUrlResponse.tag.slug + '/' + location.slug, locale)
        }));
        return __WEBPACK_IMPORTED_MODULE_20_history_js__["a" /* default */].push(__WEBPACK_IMPORTED_MODULE_10_shared_modules__["v" /* urlReplaceSlash */](__WEBPACK_IMPORTED_MODULE_18_shared_helpers_locale__["h" /* toLocalized */]('/' + pathname + '/' + seoSearchUrlResponse.tag.slug + '/' + location.slug + (query ? queryStr : ''), locale)));
      }
      if (queryObj.location) {
        delete queryObj.location;
      }
      _this.props.dispatch(__WEBPACK_IMPORTED_MODULE_19_shared_actions_partsForm__["a" /* hrefSet */]({
        query: queryObj,
        url: __WEBPACK_IMPORTED_MODULE_18_shared_helpers_locale__["h" /* toLocalized */]('/' + pathname + '/' + seoSearchUrlResponse.tag.slug, locale)
      }));
      return __WEBPACK_IMPORTED_MODULE_20_history_js__["a" /* default */].push(__WEBPACK_IMPORTED_MODULE_10_shared_modules__["v" /* urlReplaceSlash */](__WEBPACK_IMPORTED_MODULE_18_shared_helpers_locale__["h" /* toLocalized */]('/' + pathname + '/' + seoSearchUrlResponse.tag.slug + (query ? '?' + __WEBPACK_IMPORTED_MODULE_8_query_string___default.a.stringify(queryObj) : '/'), locale)));
    }, _this.refreshSparesPage = function (location) {
      var _this$props4 = _this.props,
          formState = _this$props4.formState,
          locale = _this$props4.locale;

      var state = _extends({}, formState, { location: location });
      var pathname = __WEBPACK_IMPORTED_MODULE_22_shared_helpers_urls__["f" /* generateSparesSearchUrl */](state);
      var allParams = __WEBPACK_IMPORTED_MODULE_22_shared_helpers_urls__["d" /* generateSearchQuery */](state);
      var query = __WEBPACK_IMPORTED_MODULE_4_lodash_pick___default.a(allParams, [].concat(_toConsumableArray(Object.keys(__WEBPACK_IMPORTED_MODULE_15_shared_actions_searchForm__["r" /* sparesSetThunks */])), ['transport']));

      __WEBPACK_IMPORTED_MODULE_20_history_js__["a" /* default */].push(__WEBPACK_IMPORTED_MODULE_18_shared_helpers_locale__["h" /* toLocalized */]('/' + pathname + '?' + __WEBPACK_IMPORTED_MODULE_8_query_string___default.a.stringify(query), locale));
    }, _this.updateUrl = function (location) {
      var routeName = _this.props.routeName;


      switch (routeName) {
        case 'home':
          _this.refreshHomePage(location);
          break;
        case 'moto':
          _this.refreshMotoPage(location);
          break;
        case 'commercial':
          _this.refreshCommercialPage(location);
          break;
        case 'search':
          _this.refreshSearchPage(location);
          break;
        case 'dealers':
          _this.refreshDealersPage(location);
          break;
        case 'firms':
          _this.refreshFirmsPage(location);
          break;
        case 'auto-parts':
          _this.refreshSparesPage(location);
          break;

        default:
          break;
      }
    }, _this.handleClickRegionLink = function () {
      _this.handleLocationChange(_this.state.regionSelected);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(LocationsBlock, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          className = _props.className,
          location = _props.location,
          routeName = _props.routeName,
          intl = _props.intl,
          locations = _props.locations,
          seoSearchUrlResponse = _props.globals.seoSearchUrlResponse;
      var seoLocations = seoSearchUrlResponse.locations,
          selectedLocation = seoSearchUrlResponse.location;
      var regionSelected = this.state.regionSelected;


      var formattedListLocations = regionSelected ? regionSelected.children.sort(__WEBPACK_IMPORTED_MODULE_21_shared_helpers_arrays__["b" /* compareByTitle */]) : locations;

      formattedListLocations = formattedListLocations.map(__WEBPACK_IMPORTED_MODULE_18_shared_helpers_locale__["g" /* setActiveLocations */](seoLocations, selectedLocation)).sort(__WEBPACK_IMPORTED_MODULE_21_shared_helpers_arrays__["b" /* compareByTitle */]);

      var formattedSelectLocations = [];

      if (regionSelected) {
        formattedSelectLocations = [regionSelected].concat(_toConsumableArray(regionSelected.children)).map(__WEBPACK_IMPORTED_MODULE_18_shared_helpers_locale__["g" /* setActiveLocations */](seoLocations, selectedLocation));
      } else {
        formattedSelectLocations = __WEBPACK_IMPORTED_MODULE_18_shared_helpers_locale__["b" /* getAllLocations */]().map(__WEBPACK_IMPORTED_MODULE_18_shared_helpers_locale__["g" /* setActiveLocations */](seoLocations, selectedLocation));
      }

      var titleKey = intl.formatMessage({ id: 'locale' }) === 'uk' ? 'uk_title' : 'title';

      return LocationsBlock__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_3_classnames___default.a(__WEBPACK_IMPORTED_MODULE_24__LocationsBlock_css___default.a.root, className),
        onClick: this.handleLocationButtonClick
      }, void 0, LocationsBlock__jsx('img', {
        src: __WEBPACK_IMPORTED_MODULE_16_shared_assets_images_placeholder_filled_point_svg___default.a,
        className: __WEBPACK_IMPORTED_MODULE_24__LocationsBlock_css___default.a.locationPointImg,
        width: '14',
        alt: ''
      }), ' ', LocationsBlock__jsx('span', {
        className: __WEBPACK_IMPORTED_MODULE_24__LocationsBlock_css___default.a.label
      }, void 0, location && location.title ? intl.formatMessage({ id: location.title }) : intl.formatMessage({ id: 'Вся Украина' })), LocationsBlock__jsx(__WEBPACK_IMPORTED_MODULE_6_react_addons_css_transition_group___default.a, {
        transitionName: 'fadeUp',
        transitionEnterTimeout: 100,
        transitionLeaveTimeout: 100
      }, void 0, this.state.showLocationPopup && LocationsBlock__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_24__LocationsBlock_css___default.a.popupBlock,
        onClick: this.stopPropagation
      }, void 0, LocationsBlock__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_24__LocationsBlock_css___default.a.inputBlock
      }, void 0, LocationsBlock__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_24__LocationsBlock_css___default.a.buttonsBlock
      }, void 0, !!regionSelected && LocationsBlock__jsx(__WEBPACK_IMPORTED_MODULE_5_shared_components_Link__["a" /* default */], {
        className: __WEBPACK_IMPORTED_MODULE_3_classnames___default.a(__WEBPACK_IMPORTED_MODULE_24__LocationsBlock_css___default.a.linkItem, __WEBPACK_IMPORTED_MODULE_24__LocationsBlock_css___default.a.backLink),
        onClick: function onClick() {
          return _this2.setState({ regionSelected: null });
        }
      }, void 0, LocationsBlock__jsx('span', {
        className: __WEBPACK_IMPORTED_MODULE_3_classnames___default.a(__WEBPACK_IMPORTED_MODULE_24__LocationsBlock_css___default.a.linkItemArrow, __WEBPACK_IMPORTED_MODULE_24__LocationsBlock_css___default.a.backArrow)
      }), intl.formatMessage({ id: 'Изменить' }), ' \u043E\u0431\u043B\u0430\u0441\u0442\u044C'), LocationsBlock__jsx(__WEBPACK_IMPORTED_MODULE_5_shared_components_Link__["a" /* default */], {
        className: __WEBPACK_IMPORTED_MODULE_3_classnames___default.a(__WEBPACK_IMPORTED_MODULE_24__LocationsBlock_css___default.a.linkItem, __WEBPACK_IMPORTED_MODULE_24__LocationsBlock_css___default.a.regionLink),
        onClick: this.handleClickRegionLink
      }, void 0, intl.formatMessage({
        id: regionSelected ? 'Искать по всей области' : 'Вся Украина'
      }))), LocationsBlock__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_24__LocationsBlock_css___default.a.list
      }, '1', LocationsBlock__jsx(__WEBPACK_IMPORTED_MODULE_17_shared_components_Loader_Loader__["a" /* default */], {
        isLoading: !locations
      }, void 0, LocationsBlock__jsx(__WEBPACK_IMPORTED_MODULE_11_react_select__["a" /* default */], {
        className: __WEBPACK_IMPORTED_MODULE_24__LocationsBlock_css___default.a.select,
        options: formattedSelectLocations,
        placeholder: intl.formatMessage({ id: 'Выберите город' }) + '...',
        labelKey: titleKey,
        valueKey: 'id',
        value: location,
        onChange: this.handleLocationChange,
        onInputChange: this.handleSelectInputChange,
        optionRenderer: function optionRenderer(option) {
          return LocationsBlock___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(OptionRenderer_defaultExport, option);
        },
        isDisabled: function isDisabled(option) {
          return option.disabled;
        },
        matchPos: 'start',
        openOnFocus: true
      })))), LocationsBlock__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_24__LocationsBlock_css___default.a.locationsBlock
      }, void 0, LocationsBlock__jsx('ul', {}, void 0, formattedListLocations.map(function (item) {
        return LocationsBlock__jsx('li', {}, item.id, LocationsBlock__jsx(__WEBPACK_IMPORTED_MODULE_5_shared_components_Link__["a" /* default */], {
          disabled: item.disabled,
          className: __WEBPACK_IMPORTED_MODULE_24__LocationsBlock_css___default.a.linkItem,
          onClick: function onClick() {
            return _this2.handleListLocationSelect(item);
          }
        }, void 0, LocationsBlock__jsx('span', {}, void 0, __WEBPACK_IMPORTED_MODULE_18_shared_helpers_locale__["f" /* replaceRegion */](item[titleKey] || item.title)), !regionSelected && LocationsBlock__jsx('span', {
          className: __WEBPACK_IMPORTED_MODULE_24__LocationsBlock_css___default.a.linkItemArrow
        })));
      }))))));
    }
  }]);

  return LocationsBlock;
}(LocationsBlock___WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

LocationsBlock_LocationsBlock.defaultProps = {
  globals: {},
  partsForm: {},
  className: '',
  locations: null,
  location: null,
  routeName: null
};


var mapStateToProps = function mapStateToProps(_ref3) {
  var globals = _ref3.globals,
      historyState = _ref3.history,
      searchForm = _ref3.searchForm,
      partsForm = _ref3.partsForm;
  return {
    locations: searchForm.vocabulary.locations ? searchForm.vocabulary.locations[0].children : __WEBPACK_IMPORTED_MODULE_13_shared_constants_json_regions_cities_json___default.a,
    location: globals.location,
    locale: globals.locale,
    routeName: historyState.currentRouteName,
    formState: searchForm && searchForm.selected,
    partsForm: partsForm,
    globals: globals
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return { dispatch: dispatch };
};

/* harmony default export */ __webpack_exports__["a"] = (LocationsBlock___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_24__LocationsBlock_css___default.a)(__WEBPACK_IMPORTED_MODULE_7_react_redux__["b" /* connect */](mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_9_react_intl__["d" /* injectIntl */](__WEBPACK_IMPORTED_MODULE_12_react_onclickoutside__["a" /* default */](LocationsBlock_LocationsBlock)))));

/***/ }),

/***/ 1723:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "53bcd28e.svg";

/***/ }),

/***/ 1724:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "a228ede1.svg";

/***/ }),

/***/ 1725:
/***/ (function(module, exports, __webpack_require__) {

var createCompounder = __webpack_require__(1726);

/**
 * Converts `string` to
 * [snake case](https://en.wikipedia.org/wiki/Snake_case).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the snake cased string.
 * @example
 *
 * _.snakeCase('Foo Bar');
 * // => 'foo_bar'
 *
 * _.snakeCase('fooBar');
 * // => 'foo_bar'
 *
 * _.snakeCase('--FOO-BAR--');
 * // => 'foo_bar'
 */
var snakeCase = createCompounder(function (result, word, index) {
  return result + (index ? '_' : '') + word.toLowerCase();
});

module.exports = snakeCase;

/***/ }),

/***/ 1726:
/***/ (function(module, exports, __webpack_require__) {

var arrayReduce = __webpack_require__(328),
    deburr = __webpack_require__(1727),
    words = __webpack_require__(1730);

/** Used to compose unicode capture groups. */
var rsApos = '[\'\u2019]';

/** Used to match apostrophes. */
var reApos = RegExp(rsApos, 'g');

/**
 * Creates a function like `_.camelCase`.
 *
 * @private
 * @param {Function} callback The function to combine each word.
 * @returns {Function} Returns the new compounder function.
 */
function createCompounder(callback) {
  return function (string) {
    return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
  };
}

module.exports = createCompounder;

/***/ }),

/***/ 1727:
/***/ (function(module, exports, __webpack_require__) {

var deburrLetter = __webpack_require__(1728),
    toString = __webpack_require__(498);

/** Used to match Latin Unicode letters (excluding mathematical operators). */
var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;

/** Used to compose unicode character classes. */
var rsComboMarksRange = '\\u0300-\\u036f',
    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange = '\\u20d0-\\u20ff',
    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange;

/** Used to compose unicode capture groups. */
var rsCombo = '[' + rsComboRange + ']';

/**
 * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
 * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
 */
var reComboMark = RegExp(rsCombo, 'g');

/**
 * Deburrs `string` by converting
 * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
 * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
 * letters to basic Latin letters and removing
 * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to deburr.
 * @returns {string} Returns the deburred string.
 * @example
 *
 * _.deburr('déjà vu');
 * // => 'deja vu'
 */
function deburr(string) {
  string = toString(string);
  return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
}

module.exports = deburr;

/***/ }),

/***/ 1728:
/***/ (function(module, exports, __webpack_require__) {

var basePropertyOf = __webpack_require__(1729);

/** Used to map Latin Unicode letters to basic Latin letters. */
var deburredLetters = {
  // Latin-1 Supplement block.
  '\xc0': 'A', '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
  '\xe0': 'a', '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
  '\xc7': 'C', '\xe7': 'c',
  '\xd0': 'D', '\xf0': 'd',
  '\xc8': 'E', '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
  '\xe8': 'e', '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
  '\xcc': 'I', '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
  '\xec': 'i', '\xed': 'i', '\xee': 'i', '\xef': 'i',
  '\xd1': 'N', '\xf1': 'n',
  '\xd2': 'O', '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
  '\xf2': 'o', '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
  '\xd9': 'U', '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
  '\xf9': 'u', '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
  '\xdd': 'Y', '\xfd': 'y', '\xff': 'y',
  '\xc6': 'Ae', '\xe6': 'ae',
  '\xde': 'Th', '\xfe': 'th',
  '\xdf': 'ss',
  // Latin Extended-A block.
  '\u0100': 'A', '\u0102': 'A', '\u0104': 'A',
  '\u0101': 'a', '\u0103': 'a', '\u0105': 'a',
  '\u0106': 'C', '\u0108': 'C', '\u010A': 'C', '\u010C': 'C',
  '\u0107': 'c', '\u0109': 'c', '\u010B': 'c', '\u010D': 'c',
  '\u010E': 'D', '\u0110': 'D', '\u010F': 'd', '\u0111': 'd',
  '\u0112': 'E', '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011A': 'E',
  '\u0113': 'e', '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011B': 'e',
  '\u011C': 'G', '\u011E': 'G', '\u0120': 'G', '\u0122': 'G',
  '\u011D': 'g', '\u011F': 'g', '\u0121': 'g', '\u0123': 'g',
  '\u0124': 'H', '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
  '\u0128': 'I', '\u012A': 'I', '\u012C': 'I', '\u012E': 'I', '\u0130': 'I',
  '\u0129': 'i', '\u012B': 'i', '\u012D': 'i', '\u012F': 'i', '\u0131': 'i',
  '\u0134': 'J', '\u0135': 'j',
  '\u0136': 'K', '\u0137': 'k', '\u0138': 'k',
  '\u0139': 'L', '\u013B': 'L', '\u013D': 'L', '\u013F': 'L', '\u0141': 'L',
  '\u013A': 'l', '\u013C': 'l', '\u013E': 'l', '\u0140': 'l', '\u0142': 'l',
  '\u0143': 'N', '\u0145': 'N', '\u0147': 'N', '\u014A': 'N',
  '\u0144': 'n', '\u0146': 'n', '\u0148': 'n', '\u014B': 'n',
  '\u014C': 'O', '\u014E': 'O', '\u0150': 'O',
  '\u014D': 'o', '\u014F': 'o', '\u0151': 'o',
  '\u0154': 'R', '\u0156': 'R', '\u0158': 'R',
  '\u0155': 'r', '\u0157': 'r', '\u0159': 'r',
  '\u015A': 'S', '\u015C': 'S', '\u015E': 'S', '\u0160': 'S',
  '\u015B': 's', '\u015D': 's', '\u015F': 's', '\u0161': 's',
  '\u0162': 'T', '\u0164': 'T', '\u0166': 'T',
  '\u0163': 't', '\u0165': 't', '\u0167': 't',
  '\u0168': 'U', '\u016A': 'U', '\u016C': 'U', '\u016E': 'U', '\u0170': 'U', '\u0172': 'U',
  '\u0169': 'u', '\u016B': 'u', '\u016D': 'u', '\u016F': 'u', '\u0171': 'u', '\u0173': 'u',
  '\u0174': 'W', '\u0175': 'w',
  '\u0176': 'Y', '\u0177': 'y', '\u0178': 'Y',
  '\u0179': 'Z', '\u017B': 'Z', '\u017D': 'Z',
  '\u017A': 'z', '\u017C': 'z', '\u017E': 'z',
  '\u0132': 'IJ', '\u0133': 'ij',
  '\u0152': 'Oe', '\u0153': 'oe',
  '\u0149': "'n", '\u017F': 's'
};

/**
 * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
 * letters to basic Latin letters.
 *
 * @private
 * @param {string} letter The matched letter to deburr.
 * @returns {string} Returns the deburred letter.
 */
var deburrLetter = basePropertyOf(deburredLetters);

module.exports = deburrLetter;

/***/ }),

/***/ 1729:
/***/ (function(module, exports) {

/**
 * The base implementation of `_.propertyOf` without support for deep paths.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyOf(object) {
  return function (key) {
    return object == null ? undefined : object[key];
  };
}

module.exports = basePropertyOf;

/***/ }),

/***/ 1730:
/***/ (function(module, exports, __webpack_require__) {

var asciiWords = __webpack_require__(1731),
    hasUnicodeWord = __webpack_require__(1732),
    toString = __webpack_require__(498),
    unicodeWords = __webpack_require__(1733);

/**
 * Splits `string` into an array of its words.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to inspect.
 * @param {RegExp|string} [pattern] The pattern to match words.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Array} Returns the words of `string`.
 * @example
 *
 * _.words('fred, barney, & pebbles');
 * // => ['fred', 'barney', 'pebbles']
 *
 * _.words('fred, barney, & pebbles', /[^, ]+/g);
 * // => ['fred', 'barney', '&', 'pebbles']
 */
function words(string, pattern, guard) {
  string = toString(string);
  pattern = guard ? undefined : pattern;

  if (pattern === undefined) {
    return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
  }
  return string.match(pattern) || [];
}

module.exports = words;

/***/ }),

/***/ 1731:
/***/ (function(module, exports) {

/** Used to match words composed of alphanumeric characters. */
var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;

/**
 * Splits an ASCII `string` into an array of its words.
 *
 * @private
 * @param {string} The string to inspect.
 * @returns {Array} Returns the words of `string`.
 */
function asciiWords(string) {
  return string.match(reAsciiWord) || [];
}

module.exports = asciiWords;

/***/ }),

/***/ 1732:
/***/ (function(module, exports) {

/** Used to detect strings that need a more robust regexp to match words. */
var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2,}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;

/**
 * Checks if `string` contains a word composed of Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a word is found, else `false`.
 */
function hasUnicodeWord(string) {
  return reHasUnicodeWord.test(string);
}

module.exports = hasUnicodeWord;

/***/ }),

/***/ 1733:
/***/ (function(module, exports) {

/** Used to compose unicode character classes. */
var rsAstralRange = '\\ud800-\\udfff',
    rsComboMarksRange = '\\u0300-\\u036f',
    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange = '\\u20d0-\\u20ff',
    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
    rsDingbatRange = '\\u2700-\\u27bf',
    rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
    rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
    rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
    rsPunctuationRange = '\\u2000-\\u206f',
    rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
    rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
    rsVarRange = '\\ufe0e\\ufe0f',
    rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;

/** Used to compose unicode capture groups. */
var rsApos = '[\'\u2019]',
    rsBreak = '[' + rsBreakRange + ']',
    rsCombo = '[' + rsComboRange + ']',
    rsDigits = '\\d+',
    rsDingbat = '[' + rsDingbatRange + ']',
    rsLower = '[' + rsLowerRange + ']',
    rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
    rsFitz = '\\ud83c[\\udffb-\\udfff]',
    rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
    rsNonAstral = '[^' + rsAstralRange + ']',
    rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
    rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
    rsUpper = '[' + rsUpperRange + ']',
    rsZWJ = '\\u200d';

/** Used to compose unicode regexes. */
var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
    rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
    rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
    rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
    reOptMod = rsModifier + '?',
    rsOptVar = '[' + rsVarRange + ']?',
    rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
    rsOrdLower = '\\d*(?:(?:1st|2nd|3rd|(?![123])\\dth)\\b)',
    rsOrdUpper = '\\d*(?:(?:1ST|2ND|3RD|(?![123])\\dTH)\\b)',
    rsSeq = rsOptVar + reOptMod + rsOptJoin,
    rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq;

/** Used to match complex or compound words. */
var reUnicodeWord = RegExp([rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')', rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')', rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower, rsUpper + '+' + rsOptContrUpper, rsOrdUpper, rsOrdLower, rsDigits, rsEmoji].join('|'), 'g');

/**
 * Splits a Unicode `string` into an array of its words.
 *
 * @private
 * @param {string} The string to inspect.
 * @returns {Array} Returns the words of `string`.
 */
function unicodeWords(string) {
    return string.match(reUnicodeWord) || [];
}

module.exports = unicodeWords;

/***/ }),

/***/ 1734:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "150268ec.svg";

/***/ }),

/***/ 1735:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1736);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./OptionRenderer.css", function() {
        content = require("!!../../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./OptionRenderer.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 1736:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, ".L2me-{position:relative}._1jwst{margin-top:3px;font-size:13px;line-height:1.03;min-width:100%;width:auto;z-index:4;border-radius:2px}._3QqJe{color:#000}._3g2oa{color:#888}", ""]);

// exports
exports.locals = {
	"optionsBlock": "L2me-",
	"optionItem": "_1jwst",
	"optionItemActive": "_3QqJe",
	"optionItemDisabled": "_3g2oa"
};

/***/ }),

/***/ 1737:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1738);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./LocationsBlock.css", function() {
        content = require("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./LocationsBlock.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 1738:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, "._27ZiU{position:relative;padding-top:10px;padding-bottom:10px;margin:0 auto;text-align:center}.MimAt{-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-ms-flex-pack:distribute;justify-content:space-around}.MimAt,.U-Tfx{display:-webkit-box;display:-ms-flexbox;display:flex}.U-Tfx{-webkit-box-align:center;-ms-flex-align:center;align-items:center}.E1IrQ{font-size:14px;font-weight:400;text-align:center;color:#000}._25upW,.E1IrQ{margin-bottom:20px}._25upW{float:right}.PGD6w{color:#2196f3;display:inline-block;cursor:pointer}.PGD6w:hover{color:#154088;border-bottom:.07em solid}.PGD6w:active{color:#497ddd;border-bottom:1px dashed}._3579M{display:inline-block;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;cursor:pointer;font-weight:400;font-size:15px;color:#000}._3579M input{margin-left:0;position:absolute;left:0;border:1px solid #aaa;border-radius:2px}._3579M input,._3579M input:checked{top:3px;-webkit-appearance:none;width:15px;height:15px;outline:none}._3579M input:checked{border:1px solid #2196f3;background-color:#fff;border-radius:2px}._3579M input:checked:after{-webkit-appearance:none;position:absolute;font:0/0 a;z-index:15;top:0;left:-1px;overflow:hidden;width:17px;height:9px;content:\" \";pointer-events:none;border-width:0 0 2px 2px;border-style:solid;border-color:#222;border-radius:1px;background:0 0;-webkit-transform:rotate(315deg);transform:rotate(315deg)}._18C9e input{margin-left:0;position:absolute;left:0;border:1px solid #aaa;border-radius:2px}._18C9e input,._18C9e input:checked{top:0;-webkit-appearance:none;width:15px;height:15px;outline:none}._18C9e input:checked{border:1px solid #2196f3;background-color:#fff;border-radius:2px}._18C9e input:checked:after{-webkit-appearance:none;position:absolute;font:0/0 a;z-index:15;top:-3px;left:-1px;overflow:hidden;width:17px;height:9px;content:\" \";pointer-events:none;border-width:0 0 2px 2px;border-style:solid;border-color:#222;border-radius:1px;background:0 0;-webkit-transform:rotate(315deg);transform:rotate(315deg)}body{font-family:OpenSans,sans-serif;padding:0 2px 0 0;color:#000;font-weight:400}a:focus{text-decoration:none}:after,:before{-webkit-box-sizing:border-box;box-sizing:border-box}.ant-form-item{margin:0}.ant-btn,button,input,optgroup,select,textarea{line-height:normal}.xkmxV{display:block;-webkit-box-sizing:border-box;box-sizing:border-box;padding:17px 16px;width:100%;height:60px;outline:0;border:1px solid #ccc;-webkit-appearance:none;border-radius:2px;background:#fff;color:#616161;font-size:18px;line-height:1.3333333;-webkit-transition:border-color .15s ease-in-out,-webkit-box-shadow .15s ease-in-out;transition:border-color .15s ease-in-out,-webkit-box-shadow .15s ease-in-out;-o-transition:border-color ease-in-out .15s,box-shadow ease-in-out .15s;transition:border-color .15s ease-in-out,box-shadow .15s ease-in-out;transition:border-color .15s ease-in-out,box-shadow .15s ease-in-out,-webkit-box-shadow .15s ease-in-out;margin:10px 0}.xkmxV::-webkit-input-placeholder{color:#6c6868cf;opacity:1}.xkmxV::-moz-placeholder{color:#6c6868cf;opacity:1}.xkmxV:-ms-input-placeholder{color:#6c6868cf;opacity:1}.xkmxV::placeholder{color:#6c6868cf;opacity:1}._1c2N3::-webkit-input-placeholder{color:#6c6868cf;opacity:1}._1c2N3::-moz-placeholder{color:#6c6868cf;opacity:1}._1c2N3:-ms-input-placeholder{color:#6c6868cf;opacity:1}._1c2N3::placeholder{color:#6c6868cf;opacity:1}._1c2N3{padding:17px 16px;height:60px;outline:0;border:1px solid #ccc;-webkit-appearance:none;border-radius:2px;background:#fff;color:#616161;-webkit-transition:border-color .15s ease-in-out,-webkit-box-shadow .15s ease-in-out;transition:border-color .15s ease-in-out,-webkit-box-shadow .15s ease-in-out;-o-transition:border-color ease-in-out .15s,box-shadow ease-in-out .15s;transition:border-color .15s ease-in-out,box-shadow .15s ease-in-out;transition:border-color .15s ease-in-out,box-shadow .15s ease-in-out,-webkit-box-shadow .15s ease-in-out}._1c2N3,.TCL7Y{display:block;-webkit-box-sizing:border-box;box-sizing:border-box;width:100%;font-size:16px;line-height:1.3333333;margin-top:10px}.TCL7Y{position:relative;margin-bottom:20px;height:46px;border:0;border-radius:3px;background:#ffd906;text-align:center;text-decoration:none;cursor:pointer;outline:none}.TCL7Y>p{margin:0}.TCL7Y:hover{background:#ffc1076b}.TCL7Y:disabled,.TCL7Y[disabled]{background:#ffc1077c;cursor:auto;color:rgba(0,0,0,.5)}.has-error>span>input{border-color:#f5222d}.ant-form-explain{color:#f5222d;padding:0 8px}._-398B{text-align:center;padding:15px 0 40px}.ant-form-item{margin-bottom:5px}.Y9lWv{font-size:13px;line-height:18px;margin:25px 0 20px;color:#555;letter-spacing:.34px;font-weight:400}.DCqeM{text-decoration:none;font-size:15px;cursor:pointer}._1aA2f{cursor:pointer;float:right}._2SjvY{width:100%;text-align:right;margin:10px 0}._3NoKJ{font-size:14px;font-weight:400;text-align:center;color:#000;margin-top:20px;font-weight:600}._35yd0{position:relative;background-color:#fff}._1AHYl,._35yd0{margin-bottom:0;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-ms-flex-line-pack:justify;align-content:space-between;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}._1AHYl{max-width:740px}._1AHYl>div>div>iframe,._1AHYl>div>iframe,._1AHYl>iframe{max-width:100%}._35yd0>div{margin-bottom:0}._35yd0>div>div{padding-top:10px}._2_-yC,._35yd0>div>div,.hS3-i{margin-bottom:20px}.hS3-i{display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-pack:distribute;justify-content:space-around;margin-top:20px;padding:0 45px}.hS3-i>div{margin-bottom:10px;margin-top:10px}#banner{display:none}.jPuTC{position:relative;margin-top:-18px;padding-left:15px;max-width:1100px;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-ms-flex-line-pack:justify;align-content:space-between;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;padding-top:10px;-webkit-box-sizing:border-box;box-sizing:border-box;margin-bottom:20px}._1i4hU>div,.jPuTC{display:-webkit-box;display:-ms-flexbox;display:flex}._1i4hU>div{width:100vw;-ms-flex-pack:distribute;justify-content:space-around}.xndT6{position:relative;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;cursor:pointer;border-radius:2px;height:28px;line-height:24px}._325_6{font-size:13px;font-weight:600;-webkit-box-shadow:inset 0 -8px #ffda08;box-shadow:inset 0 -8px #ffda08;-webkit-transition:all .1s ease-out;-o-transition:all .1s ease-out;transition:all .1s ease-out}._325_6:hover{-webkit-box-shadow:inset 0 -8px #ffc107;box-shadow:inset 0 -8px #ffc107}._1A2WT{vertical-align:-2px;margin-right:-2px}.WxwjS{width:300px;-webkit-transform:translateY(0);transform:translateY(0);right:0;background:#fff;z-index:5}.WxwjS>div{border:none}._2Zari{padding:5px;text-align:left;font-size:14px;line-height:normal}._20TwN{border:1px solid #ccc;position:absolute;width:720px;right:0;top:40px;z-index:2;background:#fff;font-size:14px;line-height:18px}._1WhMc{border-bottom:1px solid #ccc}._1WhMc,._29hpy{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}._29hpy{position:relative;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;padding:10px 0;margin-left:12px;width:100%}._1FzBw li>button:hover{color:#000}._1FzBw{display:table;vertical-align:top}._1FzBw ul:first-child{border-left:none}._1FzBw ul{display:table-cell;vertical-align:top;padding:10px;-webkit-column-count:4;-moz-column-count:4;column-count:4;-webkit-column-rule:1px solid #ccc;-moz-column-rule:1px solid #ccc;column-rule:1px solid #ccc;list-style-type:none;width:25%}._1FzBw li{display:block;position:relative;list-style:none;text-align:left}.D58WJ{padding-top:5px;padding-right:10px;color:#000;display:block}.D58WJ:hover{font-size:14px;font-weight:600;color:#000;margin-left:-4px;letter-spacing:-.2px}._1W5BM,._1W5BM:hover{color:#2196f3;letter-spacing:-.3px}._1QFO3{border-color:#999 transparent transparent;border-style:solid;border-width:5px 5px 2.5px;display:inline-block;height:0;width:0;position:absolute;-webkit-transform:rotate(-90deg);transform:rotate(-90deg);right:0;top:11px}.UUahX{-webkit-transform:rotate(90deg);transform:rotate(90deg);left:0;top:20px}.D58WJ:hover>._1QFO3{border-width:6px 6px 3.5px;right:-5px}.D58WJ:hover>.UUahX{left:-5px}._2KHuB:hover{margin-left:10px}._2KHuB{margin-left:12px}._3xI9P{color:#888}.xndT6 .Select-control{border:1px solid #ccc;border-radius:2px;height:30px;font-size:13px;line-height:1em}.xndT6 .Select-control:hover{-webkit-box-shadow:none;box-shadow:none;border-color:#2196f3}.xndT6 .Select-input{height:30px;line-height:30px;font-size:13px}.xndT6 .Select-placeholder{line-height:30px;font-size:13px;font-weight:400;color:#666;font-family:sans-serif}.xndT6 .Select-menu-outer{margin-top:3px;font-size:13px;line-height:1.03;color:#000;min-width:100%;width:auto;z-index:4;border-radius:2px;border:1px solid #e0e0e0;-webkit-box-shadow:0 4px 16px rgba(0,0,0,.18);box-shadow:0 4px 16px rgba(0,0,0,.18)}.xndT6 .Select--single>.Select-control .Select-value{line-height:30px;font-weight:700;color:#000}.xndT6 .Select-option{color:#000;white-space:nowrap}.xndT6 .Select-clear{color:#666}.xndT6 .Select.is-disabled>.Select-control .Select-placeholder{color:#888}.xndT6 ::-webkit-input-placeholder{font-weight:400}.xndT6 ::-moz-placeholder{font-weight:400}.xndT6 :-ms-input-placeholder{font-weight:400}.xndT6 :-moz-placeholder{font-weight:400}", ""]);

// exports
exports.locals = {
	"sbsGL": "_27ZiU",
	"flexCenterGl": "MimAt",
	"flexCenterAlignGl": "U-Tfx",
	"titleNellGl": "E1IrQ",
	"linkLeahs": "_25upW",
	"linkLeah": "PGD6w",
	"checkboxGl": "_3579M",
	"checkboxMobileGl": "_18C9e",
	"inputFormGl": "xkmxV",
	"inputFormMobilGl": "_1c2N3",
	"buttonFormGl": "TCL7Y",
	"submitSectionGl": "_-398B",
	"agreementGl": "Y9lWv",
	"urlGl": "DCqeM",
	"linkTextGl": "_1aA2f",
	"linkBlockGl": "_2SjvY",
	"titleGl": "_3NoKJ",
	"advertContainerGl": "_35yd0",
	"banerAllStyleGl": "_1AHYl",
	"gptPremium": "_2_-yC",
	"advertContainerButoonGl": "hS3-i",
	"brandingAdvGl": "jPuTC",
	"mobileWebTop": "_1i4hU",
	"root": "xndT6",
	"label": "_325_6",
	"locationPointImg": "_1A2WT",
	"list": "WxwjS",
	"select": "_2Zari",
	"popupBlock": "_20TwN",
	"inputBlock": "_1WhMc",
	"buttonsBlock": "_29hpy",
	"locationsBlock": "_1FzBw",
	"linkItem": "D58WJ",
	"regionLink": "_1W5BM",
	"linkItemArrow": "_1QFO3",
	"backArrow": "UUahX",
	"backLink": "_2KHuB",
	"disabledItem": "_3xI9P"
};

/***/ }),

/***/ 1744:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

var _class, _class2, _temp;

/* Decoraters */

/* Utils */

/* CSS */

var _react = __webpack_require__(11);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1775);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__(38);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _classnames = __webpack_require__(1778);

var _classnames2 = _interopRequireDefault(_classnames);

var _staticMethods = __webpack_require__(1779);

var _staticMethods2 = _interopRequireDefault(_staticMethods);

var _windowListener = __webpack_require__(1780);

var _windowListener2 = _interopRequireDefault(_windowListener);

var _customEvent = __webpack_require__(1781);

var _customEvent2 = _interopRequireDefault(_customEvent);

var _isCapture = __webpack_require__(1782);

var _isCapture2 = _interopRequireDefault(_isCapture);

var _getEffect = __webpack_require__(1783);

var _getEffect2 = _interopRequireDefault(_getEffect);

var _trackRemoval = __webpack_require__(1784);

var _trackRemoval2 = _interopRequireDefault(_trackRemoval);

var _getPosition = __webpack_require__(1785);

var _getPosition2 = _interopRequireDefault(_getPosition);

var _getTipContent = __webpack_require__(1786);

var _getTipContent2 = _interopRequireDefault(_getTipContent);

var _aria = __webpack_require__(1787);

var _nodeListToArray = __webpack_require__(1788);

var _nodeListToArray2 = _interopRequireDefault(_nodeListToArray);

var _style = __webpack_require__(1789);

var _style2 = _interopRequireDefault(_style);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === 'undefined' ? 'undefined' : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === 'undefined' ? 'undefined' : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var ReactTooltip = (0, _staticMethods2.default)(_class = (0, _windowListener2.default)(_class = (0, _customEvent2.default)(_class = (0, _isCapture2.default)(_class = (0, _getEffect2.default)(_class = (0, _trackRemoval2.default)(_class = (_temp = _class2 = function (_React$Component) {
  _inherits(ReactTooltip, _React$Component);

  function ReactTooltip(props) {
    _classCallCheck(this, ReactTooltip);

    var _this = _possibleConstructorReturn(this, (ReactTooltip.__proto__ || Object.getPrototypeOf(ReactTooltip)).call(this, props));

    _this.state = {
      place: 'top', // Direction of tooltip
      type: 'dark', // Color theme of tooltip
      effect: 'float', // float or fixed
      show: false,
      border: false,
      offset: {},
      extraClass: '',
      html: false,
      delayHide: 0,
      delayShow: 0,
      event: props.event || null,
      eventOff: props.eventOff || null,
      currentEvent: null, // Current mouse event
      currentTarget: null, // Current target of mouse event
      ariaProps: (0, _aria.parseAria)(props), // aria- and role attributes
      isEmptyTip: false,
      disable: false,
      originTooltip: null,
      isMultiline: false
    };

    _this.bind(['showTooltip', 'updateTooltip', 'hideTooltip', 'getTooltipContent', 'globalRebuild', 'globalShow', 'globalHide', 'onWindowResize']);

    _this.mount = true;
    _this.delayShowLoop = null;
    _this.delayHideLoop = null;
    _this.intervalUpdateContent = null;
    return _this;
  }

  /**
   * For unify the bind and unbind listener
   */

  _createClass(ReactTooltip, [{
    key: 'bind',
    value: function bind(methodArray) {
      var _this2 = this;

      methodArray.forEach(function (method) {
        _this2[method] = _this2[method].bind(_this2);
      });
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _props = this.props,
          insecure = _props.insecure,
          resizeHide = _props.resizeHide;

      if (insecure) {
        this.setStyleHeader(); // Set the style to the <link>
      }
      this.bindListener(); // Bind listener for tooltip
      this.bindWindowEvents(resizeHide); // Bind global event for static method
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(props) {
      var ariaProps = this.state.ariaProps;

      var newAriaProps = (0, _aria.parseAria)(props);

      var isChanged = Object.keys(newAriaProps).some(function (props) {
        return newAriaProps[props] !== ariaProps[props];
      });
      if (isChanged) {
        this.setState({ ariaProps: newAriaProps });
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.mount = false;

      this.clearTimer();

      this.unbindListener();
      this.removeScrollListener();
      this.unbindWindowEvents();
    }

    /**
     * Pick out corresponded target elements
     */

  }, {
    key: 'getTargetArray',
    value: function getTargetArray(id) {
      var targetArray = void 0;
      if (!id) {
        targetArray = document.querySelectorAll('[data-tip]:not([data-for])');
      } else {
        var escaped = id.replace(/\\/g, '\\\\').replace(/"/g, '\\"');
        targetArray = document.querySelectorAll('[data-tip][data-for="' + escaped + '"]');
      }
      // targetArray is a NodeList, convert it to a real array
      return (0, _nodeListToArray2.default)(targetArray);
    }

    /**
     * Bind listener to the target elements
     * These listeners used to trigger showing or hiding the tooltip
     */

  }, {
    key: 'bindListener',
    value: function bindListener() {
      var _this3 = this;

      var _props2 = this.props,
          id = _props2.id,
          globalEventOff = _props2.globalEventOff;

      var targetArray = this.getTargetArray(id);

      targetArray.forEach(function (target) {
        var isCaptureMode = _this3.isCapture(target);
        var effect = _this3.getEffect(target);
        if (target.getAttribute('currentItem') === null) {
          target.setAttribute('currentItem', 'false');
        }
        _this3.unbindBasicListener(target);

        if (_this3.isCustomEvent(target)) {
          _this3.customBindListener(target);
          return;
        }

        target.addEventListener('mouseenter', _this3.showTooltip, isCaptureMode);
        if (effect === 'float') {
          target.addEventListener('mousemove', _this3.updateTooltip, isCaptureMode);
        }
        target.addEventListener('mouseleave', _this3.hideTooltip, isCaptureMode);
      });

      // Global event to hide tooltip
      if (globalEventOff) {
        window.removeEventListener(globalEventOff, this.hideTooltip);
        window.addEventListener(globalEventOff, this.hideTooltip, false);
      }

      // Track removal of targetArray elements from DOM
      this.bindRemovalTracker();
    }

    /**
     * Unbind listeners on target elements
     */

  }, {
    key: 'unbindListener',
    value: function unbindListener() {
      var _this4 = this;

      var _props3 = this.props,
          id = _props3.id,
          globalEventOff = _props3.globalEventOff;

      var targetArray = this.getTargetArray(id);
      targetArray.forEach(function (target) {
        _this4.unbindBasicListener(target);
        if (_this4.isCustomEvent(target)) _this4.customUnbindListener(target);
      });

      if (globalEventOff) window.removeEventListener(globalEventOff, this.hideTooltip);
      this.unbindRemovalTracker();
    }

    /**
     * Invoke this before bind listener and ummount the compont
     * it is necessary to invloke this even when binding custom event
     * so that the tooltip can switch between custom and default listener
     */

  }, {
    key: 'unbindBasicListener',
    value: function unbindBasicListener(target) {
      var isCaptureMode = this.isCapture(target);
      target.removeEventListener('mouseenter', this.showTooltip, isCaptureMode);
      target.removeEventListener('mousemove', this.updateTooltip, isCaptureMode);
      target.removeEventListener('mouseleave', this.hideTooltip, isCaptureMode);
    }
  }, {
    key: 'getTooltipContent',
    value: function getTooltipContent() {
      var _props4 = this.props,
          getContent = _props4.getContent,
          children = _props4.children;

      // Generate tooltip content

      var content = void 0;
      if (getContent) {
        if (Array.isArray(getContent)) {
          content = getContent[0] && getContent[0]();
        } else {
          content = getContent();
        }
      }

      return (0, _getTipContent2.default)(this.state.originTooltip, children, content, this.state.isMultiline);
    }
  }, {
    key: 'isEmptyTip',
    value: function isEmptyTip(placeholder) {
      return typeof placeholder === 'string' && placeholder === '' || placeholder === null;
    }

    /**
     * When mouse enter, show the tooltip
     */

  }, {
    key: 'showTooltip',
    value: function showTooltip(e, isGlobalCall) {
      var _this5 = this;

      if (isGlobalCall) {
        // Don't trigger other elements belongs to other ReactTooltip
        var targetArray = this.getTargetArray(this.props.id);
        var isMyElement = targetArray.some(function (ele) {
          return ele === e.currentTarget;
        });
        if (!isMyElement || this.state.show) return;
      }
      // Get the tooltip content
      // calculate in this phrase so that tip width height can be detected
      var _props5 = this.props,
          multiline = _props5.multiline,
          getContent = _props5.getContent;

      var originTooltip = e.currentTarget.getAttribute('data-tip');
      var isMultiline = e.currentTarget.getAttribute('data-multiline') || multiline || false;

      // If it is focus event or called by ReactTooltip.show, switch to `solid` effect
      var switchToSolid = e instanceof window.FocusEvent || isGlobalCall;

      // if it needs to skip adding hide listener to scroll
      var scrollHide = true;
      if (e.currentTarget.getAttribute('data-scroll-hide')) {
        scrollHide = e.currentTarget.getAttribute('data-scroll-hide') === 'true';
      } else if (this.props.scrollHide != null) {
        scrollHide = this.props.scrollHide;
      }

      // To prevent previously created timers from triggering
      this.clearTimer();

      this.setState({
        originTooltip: originTooltip,
        isMultiline: isMultiline,
        desiredPlace: e.currentTarget.getAttribute('data-place') || this.props.place || 'top',
        place: e.currentTarget.getAttribute('data-place') || this.props.place || 'top',
        type: e.currentTarget.getAttribute('data-type') || this.props.type || 'dark',
        effect: switchToSolid && 'solid' || this.getEffect(e.currentTarget),
        offset: e.currentTarget.getAttribute('data-offset') || this.props.offset || {},
        html: e.currentTarget.getAttribute('data-html') ? e.currentTarget.getAttribute('data-html') === 'true' : this.props.html || false,
        delayShow: e.currentTarget.getAttribute('data-delay-show') || this.props.delayShow || 0,
        delayHide: e.currentTarget.getAttribute('data-delay-hide') || this.props.delayHide || 0,
        border: e.currentTarget.getAttribute('data-border') ? e.currentTarget.getAttribute('data-border') === 'true' : this.props.border || false,
        extraClass: e.currentTarget.getAttribute('data-class') || this.props.class || this.props.className || '',
        disable: e.currentTarget.getAttribute('data-tip-disable') ? e.currentTarget.getAttribute('data-tip-disable') === 'true' : this.props.disable || false
      }, function () {
        if (scrollHide) _this5.addScrollListener(e);
        _this5.updateTooltip(e);

        if (getContent && Array.isArray(getContent)) {
          _this5.intervalUpdateContent = setInterval(function () {
            if (_this5.mount) {
              var _getContent = _this5.props.getContent;

              var placeholder = (0, _getTipContent2.default)(originTooltip, '', _getContent[0](), isMultiline);
              var isEmptyTip = _this5.isEmptyTip(placeholder);
              _this5.setState({
                isEmptyTip: isEmptyTip
              });
            }
          }, getContent[1]);
        }
      });
    }

    /**
     * When mouse hover, updatetooltip
     */

  }, {
    key: 'updateTooltip',
    value: function updateTooltip(e) {
      var _this6 = this;

      var _state = this.state,
          delayShow = _state.delayShow,
          show = _state.show,
          disable = _state.disable;
      var afterShow = this.props.afterShow;

      var placeholder = this.getTooltipContent();
      var delayTime = show ? 0 : parseInt(delayShow, 10);
      var eventTarget = e.currentTarget;

      if (this.isEmptyTip(placeholder) || disable) return; // if the tooltip is empty, disable the tooltip
      var updateState = function updateState() {
        if (Array.isArray(placeholder) && placeholder.length > 0 || placeholder) {
          var isInvisible = !_this6.state.show;
          _this6.setState({
            currentEvent: e,
            currentTarget: eventTarget,
            show: true
          }, function () {
            _this6.updatePosition();
            if (isInvisible && afterShow) afterShow();
          });
        }
      };

      clearTimeout(this.delayShowLoop);
      if (delayShow) {
        this.delayShowLoop = setTimeout(updateState, delayTime);
      } else {
        updateState();
      }
    }

    /**
     * When mouse leave, hide tooltip
     */

  }, {
    key: 'hideTooltip',
    value: function hideTooltip(e, hasTarget) {
      var _this7 = this;

      var _state2 = this.state,
          delayHide = _state2.delayHide,
          disable = _state2.disable;
      var afterHide = this.props.afterHide;

      var placeholder = this.getTooltipContent();
      if (!this.mount) return;
      if (this.isEmptyTip(placeholder) || disable) return; // if the tooltip is empty, disable the tooltip
      if (hasTarget) {
        // Don't trigger other elements belongs to other ReactTooltip
        var targetArray = this.getTargetArray(this.props.id);
        var isMyElement = targetArray.some(function (ele) {
          return ele === e.currentTarget;
        });
        if (!isMyElement || !this.state.show) return;
      }
      var resetState = function resetState() {
        var isVisible = _this7.state.show;
        _this7.setState({
          show: false
        }, function () {
          _this7.removeScrollListener();
          if (isVisible && afterHide) afterHide();
        });
      };

      this.clearTimer();
      if (delayHide) {
        this.delayHideLoop = setTimeout(resetState, parseInt(delayHide, 10));
      } else {
        resetState();
      }
    }

    /**
     * Add scroll eventlistener when tooltip show
     * automatically hide the tooltip when scrolling
     */

  }, {
    key: 'addScrollListener',
    value: function addScrollListener(e) {
      var isCaptureMode = this.isCapture(e.currentTarget);
      window.addEventListener('scroll', this.hideTooltip, isCaptureMode);
    }
  }, {
    key: 'removeScrollListener',
    value: function removeScrollListener() {
      window.removeEventListener('scroll', this.hideTooltip);
    }

    // Calculation the position

  }, {
    key: 'updatePosition',
    value: function updatePosition() {
      var _this8 = this;

      var _state3 = this.state,
          currentEvent = _state3.currentEvent,
          currentTarget = _state3.currentTarget,
          place = _state3.place,
          desiredPlace = _state3.desiredPlace,
          effect = _state3.effect,
          offset = _state3.offset;

      var node = _reactDom2.default.findDOMNode(this);
      var result = (0, _getPosition2.default)(currentEvent, currentTarget, node, place, desiredPlace, effect, offset);

      if (result.isNewState) {
        // Switch to reverse placement
        return this.setState(result.newState, function () {
          _this8.updatePosition();
        });
      }
      // Set tooltip position
      node.style.left = result.position.left + 'px';
      node.style.top = result.position.top + 'px';
    }

    /**
     * Set style tag in header
     * in this way we can insert default css
     */

  }, {
    key: 'setStyleHeader',
    value: function setStyleHeader() {
      var head = document.getElementsByTagName('head')[0];
      if (!head.querySelector('style[id="react-tooltip"]')) {
        var tag = document.createElement('style');
        tag.id = 'react-tooltip';
        tag.innerHTML = _style2.default;
        head.insertBefore(tag, head.firstChild);
      }
    }

    /**
     * CLear all kinds of timeout of interval
     */

  }, {
    key: 'clearTimer',
    value: function clearTimer() {
      clearTimeout(this.delayShowLoop);
      clearTimeout(this.delayHideLoop);
      clearInterval(this.intervalUpdateContent);
    }
  }, {
    key: 'render',
    value: function render() {
      var _state4 = this.state,
          extraClass = _state4.extraClass,
          html = _state4.html,
          ariaProps = _state4.ariaProps,
          disable = _state4.disable;

      var placeholder = this.getTooltipContent();
      var isEmptyTip = this.isEmptyTip(placeholder);
      var tooltipClass = (0, _classnames2.default)('__react_component_tooltip', { 'show': this.state.show && !disable && !isEmptyTip }, { 'border': this.state.border }, { 'place-top': this.state.place === 'top' }, { 'place-bottom': this.state.place === 'bottom' }, { 'place-left': this.state.place === 'left' }, { 'place-right': this.state.place === 'right' }, { 'type-dark': this.state.type === 'dark' }, { 'type-success': this.state.type === 'success' }, { 'type-warning': this.state.type === 'warning' }, { 'type-error': this.state.type === 'error' }, { 'type-info': this.state.type === 'info' }, { 'type-light': this.state.type === 'light' });

      var Wrapper = this.props.wrapper;
      if (ReactTooltip.supportedWrappers.indexOf(Wrapper) < 0) {
        Wrapper = ReactTooltip.defaultProps.wrapper;
      }

      if (html) {
        return _react2.default.createElement(Wrapper, _extends({ className: tooltipClass + ' ' + extraClass,
          id: this.props.id
        }, ariaProps, {
          'data-id': 'tooltip',
          dangerouslySetInnerHTML: { __html: placeholder } }));
      } else {
        return _react2.default.createElement(Wrapper, _extends({ className: tooltipClass + ' ' + extraClass,
          id: this.props.id
        }, ariaProps, {
          'data-id': 'tooltip' }), placeholder);
      }
    }
  }]);

  return ReactTooltip;
}(_react2.default.Component), _class2.propTypes = {
  children: _propTypes2.default.any,
  place: _propTypes2.default.string,
  type: _propTypes2.default.string,
  effect: _propTypes2.default.string,
  offset: _propTypes2.default.object,
  multiline: _propTypes2.default.bool,
  border: _propTypes2.default.bool,
  insecure: _propTypes2.default.bool,
  class: _propTypes2.default.string,
  className: _propTypes2.default.string,
  id: _propTypes2.default.string,
  html: _propTypes2.default.bool,
  delayHide: _propTypes2.default.number,
  delayShow: _propTypes2.default.number,
  event: _propTypes2.default.string,
  eventOff: _propTypes2.default.string,
  watchWindow: _propTypes2.default.bool,
  isCapture: _propTypes2.default.bool,
  globalEventOff: _propTypes2.default.string,
  getContent: _propTypes2.default.any,
  afterShow: _propTypes2.default.func,
  afterHide: _propTypes2.default.func,
  disable: _propTypes2.default.bool,
  scrollHide: _propTypes2.default.bool,
  resizeHide: _propTypes2.default.bool,
  wrapper: _propTypes2.default.string
}, _class2.defaultProps = {
  insecure: true,
  resizeHide: true,
  wrapper: 'div'
}, _class2.supportedWrappers = ['div', 'span'], _temp)) || _class) || _class) || _class) || _class) || _class) || _class;

/* export default not fit for standalone, it will exports {default:...} */

module.exports = ReactTooltip;

/***/ }),

/***/ 1753:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();



var JsonLdApplication = function JsonLdApplication(data) {
  return _jsx("script", {
    type: "application/ld+json",
    dangerouslySetInnerHTML: { __html: JSON.stringify(data) }
  });
};

/* harmony default export */ __webpack_exports__["a"] = (JsonLdApplication);

/***/ }),

/***/ 1754:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// CONCATENATED MODULE: ./src/desktop/components/Carousel/SlideList.js
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();




var SlideList = function SlideList(_ref) {
  var items = _ref.items,
      marginLeft = _ref.marginLeft,
      sliderCN = _ref.sliderCN,
      containerCN = _ref.containerCN,
      inputRef = _ref.inputRef;
  return _jsx('div', {
    className: containerCN
  }, void 0, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { ref: inputRef, style: { transform: 'translateX(-' + marginLeft + 'px)' }, className: sliderCN },
    items
  ));
};

SlideList.defaultProps = {
  items: [],
  marginLeft: 0,
  sliderCN: '',
  containerCN: ''
};

/* harmony default export */ var SlideList_defaultExport = (SlideList);
// CONCATENATED MODULE: ./src/desktop/components/Carousel/Carousel.js
/* harmony import */ var Carousel___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var Carousel___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(Carousel___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var Carousel___WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var Carousel___WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(Carousel___WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(1240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Carousel_css__ = __webpack_require__(1763);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Carousel_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__Carousel_css__);
var Carousel__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var Carousel_Carousel = function (_React$Component) {
  _inherits(Carousel, _React$Component);

  function Carousel() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Carousel);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Carousel.__proto__ || Object.getPrototypeOf(Carousel)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      index: 0,
      slidesInfo: []
    }, _this.getChildrenArray = function (item) {
      if (!item.children || item.children.length === 0) {
        return [];
      } else if (item.children.length === 1) {
        return _this.getChildrenArray(item.children[0]);
      }

      return [].concat(_toConsumableArray(item.children));
    }, _this.getFullWidth = function (elem) {
      var _getComputedStyle = getComputedStyle(elem),
          marginLeft = _getComputedStyle.marginLeft,
          marginRight = _getComputedStyle.marginRight;

      return [elem.offsetWidth, marginLeft, marginRight].map(function (i) {
        return parseFloat(i);
      }).reduce(function (result, current) {
        return result + current;
      }, 0);
    }, _this.getSlidesWidth = function (arr) {
      return arr.reduce(function (width, slide) {
        return width + slide.fullWidth;
      }, 0);
    }, _this.setSlidesInfo = function (slidesInfo) {
      _this.setState({ slidesInfo: slidesInfo });
    }, _this.handleNextClick = function () {
      var _this$props = _this.props,
          step = _this$props.step,
          loop = _this$props.loop,
          itemsInRow = _this$props.itemsInRow,
          slideCount = _this$props.items.length;


      _this.setState(function (_ref2) {
        var index = _ref2.index;

        var nextIndex = index + step > slideCount ? slideCount : index + step;
        return {
          index: loop && index >= slideCount - itemsInRow ? 0 : nextIndex
        };
      });
    }, _this.handlePrevClick = function () {
      var _this$props2 = _this.props,
          step = _this$props2.step,
          loop = _this$props2.loop,
          itemsInRow = _this$props2.itemsInRow,
          slideCount = _this$props2.items.length;


      _this.setState(function (_ref3) {
        var index = _ref3.index;

        var nextIndex = index - step < 0 ? 0 : index - step;
        return {
          index: loop && index === 0 ? slideCount - itemsInRow : nextIndex
        };
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Carousel, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      var slidesInfo = this.getChildrenArray(this.carousel).map(function (slide) {
        return {
          fullWidth: _this2.getFullWidth(slide)
        };
      });

      this.setSlidesInfo(slidesInfo);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this.props.items !== nextProps.items) {
        this.setState({ index: 0 });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _state = this.state,
          index = _state.index,
          slidesInfo = _state.slidesInfo;
      var _props = this.props,
          loop = _props.loop,
          items = _props.items,
          itemsInRow = _props.itemsInRow,
          itemsPosition = _props.itemsPosition,
          header = _props.header,
          _props$classNames = _props.classNames,
          _props$classNames$mai = _props$classNames.main,
          mainCN = _props$classNames$mai === undefined ? '' : _props$classNames$mai,
          _props$classNames$hea = _props$classNames.header,
          headerCN = _props$classNames$hea === undefined ? '' : _props$classNames$hea,
          bodyCN = _props$classNames.body,
          _props$classNames$sli = _props$classNames.slider,
          sliderCN = _props$classNames$sli === undefined ? '' : _props$classNames$sli;


      var maxLeft = this.carousel && this.getSlidesWidth(slidesInfo) - this.carousel.parentNode.offsetWidth;
      var left = this.getSlidesWidth(slidesInfo.slice(0, index));
      var marginLeft = Math.min(maxLeft, left);
      var roundMarginLeft = maxLeft - marginLeft < 20 ? maxLeft : marginLeft;

      return Carousel__jsx('div', {
        className: mainCN || __WEBPACK_IMPORTED_MODULE_5__Carousel_css___default.a.carousel
      }, void 0, Carousel__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_2_classnames___default.a(headerCN && headerCN, __WEBPACK_IMPORTED_MODULE_5__Carousel_css___default.a.carouselHeader)
      }, void 0, header, Carousel__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_5__Carousel_css___default.a.carouselHeaderContent
      }, void 0, itemsPosition === 'header' && Carousel__jsx(SlideList_defaultExport, {
        items: items,
        marginLeft: roundMarginLeft,
        containerCN: __WEBPACK_IMPORTED_MODULE_5__Carousel_css___default.a.carouselContainer,
        sliderCN: __WEBPACK_IMPORTED_MODULE_5__Carousel_css___default.a.carouselSlider,
        inputRef: function inputRef(item) {
          _this3.carousel = item;
        }
      })), itemsInRow < items.length && Carousel__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_5__Carousel_css___default.a.carouselNav
      }, void 0, Carousel__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_2_classnames___default.a(__WEBPACK_IMPORTED_MODULE_5__Carousel_css___default.a.carouselNavButton, _defineProperty({}, __WEBPACK_IMPORTED_MODULE_5__Carousel_css___default.a.disabled, marginLeft === 0 && !loop)),
        onClick: marginLeft > 0 || loop ? this.handlePrevClick : null
      }, void 0, Carousel__jsx('i', {
        className: 'fa fa-angle-left ' + __WEBPACK_IMPORTED_MODULE_5__Carousel_css___default.a.icon
      })), Carousel__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_2_classnames___default.a(__WEBPACK_IMPORTED_MODULE_5__Carousel_css___default.a.carouselNavButton, _defineProperty({}, __WEBPACK_IMPORTED_MODULE_5__Carousel_css___default.a.disabled, marginLeft >= maxLeft && !loop)),
        onClick: marginLeft < maxLeft || loop ? this.handleNextClick : null
      }, void 0, Carousel__jsx('i', {
        className: 'fa fa-angle-right ' + __WEBPACK_IMPORTED_MODULE_5__Carousel_css___default.a.icon
      })))), Carousel__jsx('div', {
        className: bodyCN || __WEBPACK_IMPORTED_MODULE_5__Carousel_css___default.a.carouselBody
      }, void 0, itemsPosition === 'body' && Carousel__jsx(SlideList_defaultExport, {
        items: items,
        marginLeft: marginLeft,
        containerCN: __WEBPACK_IMPORTED_MODULE_5__Carousel_css___default.a.carouselContainer,
        sliderCN: __WEBPACK_IMPORTED_MODULE_2_classnames___default.a(sliderCN && sliderCN, __WEBPACK_IMPORTED_MODULE_5__Carousel_css___default.a.carouselSlider),
        inputRef: function inputRef(item) {
          _this3.carousel = item;
        }
      })));
    }
  }]);

  return Carousel;
}(Carousel___WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Carousel_Carousel.defaultProps = {
  step: 1,
  itemsInRow: 1,
  itemsPosition: 'body',
  header: '',
  items: [],
  classNames: {},
  loop: false
};


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_5__Carousel_css___default.a)(Carousel_Carousel));

/***/ }),

/***/ 1755:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shared_actions_globals__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_intl__ = __webpack_require__(474);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_shared_hocs_stats_withStatsEvents__ = __webpack_require__(1439);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_shared_constants_gtmEvents__ = __webpack_require__(1243);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var _ref2 = _jsx(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */], {
  id: '\u0421\u0430\u0439\u0442 \u0430\u0432\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430'
});

var DealerWebsiteLink = function (_React$Component) {
  _inherits(DealerWebsiteLink, _React$Component);

  function DealerWebsiteLink() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, DealerWebsiteLink);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = DealerWebsiteLink.__proto__ || Object.getPrototypeOf(DealerWebsiteLink)).call.apply(_ref, [this].concat(args))), _this), _this.setRedirectStats = function () {
      _this.props.setDataLayer(__WEBPACK_IMPORTED_MODULE_6_shared_constants_gtmEvents__["a" /* EVENTS */].dealerSiteRedirect);
      _this.props.onClickHandle();
      var _this$props = _this.props,
          dealer = _this$props.dealer,
          events = _this$props.events;
      var id = dealer.id,
          title = dealer.title,
          gaAccount = dealer.ga_account;

      if (id) {
        events.dispatchDealerRedirectEvent(id);
      }

      var ga = window && window.ga;
      if (ga && gaAccount) {
        ga('send', 'redirect', 'AB_avtosalon', title);
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(DealerWebsiteLink, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          ClassName = _props.ClassName,
          dealer = _props.dealer,
          children = _props.children;


      if (!dealer) {
        return null;
      }

      var website = dealer && dealer.website ? dealer.website : null;

      return _jsx('a', {
        className: ClassName,
        onClick: this.setRedirectStats,
        href: '' + website,
        target: '_blank',
        rel: 'nofollow noopener noreferrer'
      }, void 0, children || _ref2);
    }
  }]);

  return DealerWebsiteLink;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

DealerWebsiteLink.defaultProps = {
  children: null,
  onClickHandle: function onClickHandle() {}
};


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_3_react_redux__["b" /* connect */](null, { setDataLayer: __WEBPACK_IMPORTED_MODULE_2_shared_actions_globals__["j" /* setDataLayer */] })(__WEBPACK_IMPORTED_MODULE_5_shared_hocs_stats_withStatsEvents__["a" /* default */](DealerWebsiteLink)));

/***/ }),

/***/ 1763:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1764);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./Carousel.css", function() {
        content = require("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./Carousel.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 1764:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, ".Tw7dU{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;position:relative;background:#fff;width:100%}._2iLsW{-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}._2iLsW,._12NOM{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}._12NOM{overflow:hidden}._20c36{padding:25px}._29nEX{display:block;width:100%;overflow:hidden}._7v6xR{display:-webkit-box;display:-ms-flexbox;display:flex;width:-webkit-fit-content;width:-moz-fit-content;width:fit-content;-webkit-transition:-webkit-transform .6s ease;transition:-webkit-transform .6s ease;-o-transition:transform .6s ease;transition:transform .6s ease;transition:transform .6s ease,-webkit-transform .6s ease}._3GXX0{padding-left:20px}._3GXX0,.TPhLD{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.TPhLD{cursor:pointer;border:1px solid #d0d0d0;width:30px;height:28px;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;font-size:25px;-webkit-transition:all .15s ease-out;-o-transition:all .15s ease-out;transition:all .15s ease-out}.TPhLD:hover{border:1px solid #999;z-index:2}.TPhLD:first-of-type{border-radius:2px 0 0 2px}.TPhLD:last-of-type{border-radius:0 2px 2px 0;margin-left:-1px}._3etcP{position:relative;top:-1px;font-size:21px}._3ylzU{opacity:.5;cursor:default}", ""]);

// exports
exports.locals = {
	"carousel": "Tw7dU",
	"carouselHeader": "_2iLsW",
	"carouselHeaderContent": "_12NOM",
	"carouselBody": "_20c36",
	"carouselContainer": "_29nEX",
	"carouselSlider": "_7v6xR",
	"carouselNav": "_3GXX0",
	"carouselNavButton": "TPhLD",
	"icon": "_3etcP",
	"disabled": "_3ylzU"
};

/***/ }),

/***/ 1775:
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var ReactIs = require('react-is');

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(ReactIs.isElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(1776)();
}

/***/ }),

/***/ 1776:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(1777);

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

module.exports = function () {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error('Calling PropTypes validators directly is not supported by the `prop-types` package. ' + 'Use PropTypes.checkPropTypes() to call them. ' + 'Read more at http://fb.me/use-check-prop-types');
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bigint: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};

/***/ }),

/***/ 1777:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;

/***/ }),

/***/ 1778:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames() {
		var classes = '';

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (arg) {
				classes = appendClass(classes, parseValue(arg));
			}
		}

		return classes;
	}

	function parseValue(arg) {
		if (typeof arg === 'string' || typeof arg === 'number') {
			return arg;
		}

		if ((typeof arg === 'undefined' ? 'undefined' : _typeof(arg)) !== 'object') {
			return '';
		}

		if (Array.isArray(arg)) {
			return classNames.apply(null, arg);
		}

		if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) {
			return arg.toString();
		}

		var classes = '';

		for (var key in arg) {
			if (hasOwn.call(arg, key) && arg[key]) {
				classes = appendClass(classes, key);
			}
		}

		return classes;
	}

	function appendClass(value, newClass) {
		if (!newClass) {
			return value;
		}

		if (value) {
			return value + ' ' + newClass;
		}

		return value + newClass;
	}

	if (typeof module !== 'undefined' && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if ("function" === 'function' && _typeof(__webpack_require__(87)) === 'object' && __webpack_require__(87)) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
			return classNames;
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		window.classNames = classNames;
	}
})();

/***/ }),

/***/ 1779:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (target) {
  /**
   * Hide all tooltip
   * @trigger ReactTooltip.hide()
   */
  target.hide = function (target) {
    dispatchGlobalEvent(_constant2.default.GLOBAL.HIDE, { target: target });
  };

  /**
   * Rebuild all tooltip
   * @trigger ReactTooltip.rebuild()
   */
  target.rebuild = function () {
    dispatchGlobalEvent(_constant2.default.GLOBAL.REBUILD);
  };

  /**
   * Show specific tooltip
   * @trigger ReactTooltip.show()
   */
  target.show = function (target) {
    dispatchGlobalEvent(_constant2.default.GLOBAL.SHOW, { target: target });
  };

  target.prototype.globalRebuild = function () {
    if (this.mount) {
      this.unbindListener();
      this.bindListener();
    }
  };

  target.prototype.globalShow = function (event) {
    if (this.mount) {
      // Create a fake event, specific show will limit the type to `solid`
      // only `float` type cares e.clientX e.clientY
      var e = { currentTarget: event.detail.target };
      this.showTooltip(e, true);
    }
  };

  target.prototype.globalHide = function (event) {
    if (this.mount) {
      var hasTarget = event && event.detail && event.detail.target && true || false;
      this.hideTooltip({ currentTarget: hasTarget && event.detail.target }, hasTarget);
    }
  };
};

var _constant = __webpack_require__(1650);

var _constant2 = _interopRequireDefault(_constant);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var dispatchGlobalEvent = function dispatchGlobalEvent(eventName, opts) {
  // Compatibale with IE
  // @see http://stackoverflow.com/questions/26596123/internet-explorer-9-10-11-event-constructor-doesnt-work
  var event = void 0;

  if (typeof window.CustomEvent === 'function') {
    event = new window.CustomEvent(eventName, { detail: opts });
  } else {
    event = document.createEvent('Event');
    event.initEvent(eventName, false, true);
    event.detail = opts;
  }

  window.dispatchEvent(event);
}; /**
    * Static methods for react-tooltip
    */

/***/ }),

/***/ 1780:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (target) {
  target.prototype.bindWindowEvents = function (resizeHide) {
    // ReactTooltip.hide
    window.removeEventListener(_constant2.default.GLOBAL.HIDE, this.globalHide);
    window.addEventListener(_constant2.default.GLOBAL.HIDE, this.globalHide, false);

    // ReactTooltip.rebuild
    window.removeEventListener(_constant2.default.GLOBAL.REBUILD, this.globalRebuild);
    window.addEventListener(_constant2.default.GLOBAL.REBUILD, this.globalRebuild, false);

    // ReactTooltip.show
    window.removeEventListener(_constant2.default.GLOBAL.SHOW, this.globalShow);
    window.addEventListener(_constant2.default.GLOBAL.SHOW, this.globalShow, false);

    // Resize
    if (resizeHide) {
      window.removeEventListener('resize', this.onWindowResize);
      window.addEventListener('resize', this.onWindowResize, false);
    }
  };

  target.prototype.unbindWindowEvents = function () {
    window.removeEventListener(_constant2.default.GLOBAL.HIDE, this.globalHide);
    window.removeEventListener(_constant2.default.GLOBAL.REBUILD, this.globalRebuild);
    window.removeEventListener(_constant2.default.GLOBAL.SHOW, this.globalShow);
    window.removeEventListener('resize', this.onWindowResize);
  };

  /**
   * invoked by resize event of window
   */
  target.prototype.onWindowResize = function () {
    if (!this.mount) return;
    this.hideTooltip();
  };
};

var _constant = __webpack_require__(1650);

var _constant2 = _interopRequireDefault(_constant);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

/***/ }),

/***/ 1781:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (target) {
  target.prototype.isCustomEvent = function (ele) {
    var event = this.state.event;

    return event || !!ele.getAttribute('data-event');
  };

  /* Bind listener for custom event */
  target.prototype.customBindListener = function (ele) {
    var _this = this;

    var _state = this.state,
        event = _state.event,
        eventOff = _state.eventOff;

    var dataEvent = ele.getAttribute('data-event') || event;
    var dataEventOff = ele.getAttribute('data-event-off') || eventOff;

    dataEvent.split(' ').forEach(function (event) {
      ele.removeEventListener(event, customListener);
      customListener = checkStatus.bind(_this, dataEventOff);
      ele.addEventListener(event, customListener, false);
    });
    if (dataEventOff) {
      dataEventOff.split(' ').forEach(function (event) {
        ele.removeEventListener(event, _this.hideTooltip);
        ele.addEventListener(event, _this.hideTooltip, false);
      });
    }
  };

  /* Unbind listener for custom event */
  target.prototype.customUnbindListener = function (ele) {
    var _state2 = this.state,
        event = _state2.event,
        eventOff = _state2.eventOff;

    var dataEvent = event || ele.getAttribute('data-event');
    var dataEventOff = eventOff || ele.getAttribute('data-event-off');

    ele.removeEventListener(dataEvent, customListener);
    if (dataEventOff) ele.removeEventListener(dataEventOff, this.hideTooltip);
  };
};

/**
 * Custom events to control showing and hiding of tooltip
 *
 * @attributes
 * - `event` {String}
 * - `eventOff` {String}
 */

var checkStatus = function checkStatus(dataEventOff, e) {
  var show = this.state.show;
  var id = this.props.id;

  var dataIsCapture = e.currentTarget.getAttribute('data-iscapture');
  var isCapture = dataIsCapture && dataIsCapture === 'true' || this.props.isCapture;
  var currentItem = e.currentTarget.getAttribute('currentItem');

  if (!isCapture) e.stopPropagation();
  if (show && currentItem === 'true') {
    if (!dataEventOff) this.hideTooltip(e);
  } else {
    e.currentTarget.setAttribute('currentItem', 'true');
    setUntargetItems(e.currentTarget, this.getTargetArray(id));
    this.showTooltip(e);
  }
};

var setUntargetItems = function setUntargetItems(currentTarget, targetArray) {
  for (var i = 0; i < targetArray.length; i++) {
    if (currentTarget !== targetArray[i]) {
      targetArray[i].setAttribute('currentItem', 'false');
    } else {
      targetArray[i].setAttribute('currentItem', 'true');
    }
  }
};

var customListener = void 0;

/***/ }),

/***/ 1782:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (target) {
  target.prototype.isCapture = function (currentTarget) {
    var dataIsCapture = currentTarget.getAttribute('data-iscapture');
    return dataIsCapture && dataIsCapture === 'true' || this.props.isCapture || false;
  };
};

/***/ }),

/***/ 1783:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (target) {
  target.prototype.getEffect = function (currentTarget) {
    var dataEffect = currentTarget.getAttribute('data-effect');
    return dataEffect || this.props.effect || 'float';
  };
};

/***/ }),

/***/ 1784:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (target) {
  target.prototype.bindRemovalTracker = function () {
    var _this = this;

    var MutationObserver = getMutationObserverClass();
    if (MutationObserver == null) return;

    var observer = new MutationObserver(function (mutations) {
      for (var m1 = 0; m1 < mutations.length; m1++) {
        var mutation = mutations[m1];
        for (var m2 = 0; m2 < mutation.removedNodes.length; m2++) {
          var element = mutation.removedNodes[m2];
          if (element === _this.state.currentTarget) {
            _this.hideTooltip();
            return;
          }
        }
      }
    });

    observer.observe(window.document, { childList: true, subtree: true });

    this.removalTracker = observer;
  };

  target.prototype.unbindRemovalTracker = function () {
    if (this.removalTracker) {
      this.removalTracker.disconnect();
      this.removalTracker = null;
    }
  };
};

/**
 * Tracking target removing from DOM.
 * It's nessesary to hide tooltip when it's target disappears.
 * Otherwise, the tooltip would be shown forever until another target
 * is triggered.
 *
 * If MutationObserver is not available, this feature just doesn't work.
 */

// https://hacks.mozilla.org/2012/05/dom-mutationobserver-reacting-to-dom-changes-without-killing-browser-performance/
var getMutationObserverClass = function getMutationObserverClass() {
  return window.MutationObserver || window.WebKitMutationObserver || window.MozMutationObserver;
};

/***/ }),

/***/ 1785:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (e, target, node, place, desiredPlace, effect, offset) {
  var tipWidth = node.clientWidth;
  var tipHeight = node.clientHeight;

  var _getCurrentOffset = getCurrentOffset(e, target, effect),
      mouseX = _getCurrentOffset.mouseX,
      mouseY = _getCurrentOffset.mouseY;

  var defaultOffset = getDefaultPosition(effect, target.clientWidth, target.clientHeight, tipWidth, tipHeight);

  var _calculateOffset = calculateOffset(offset),
      extraOffset_X = _calculateOffset.extraOffset_X,
      extraOffset_Y = _calculateOffset.extraOffset_Y;

  var windowWidth = window.innerWidth;
  var windowHeight = window.innerHeight;

  var _getParent = getParent(node),
      parentTop = _getParent.parentTop,
      parentLeft = _getParent.parentLeft;

  // Get the edge offset of the tooltip


  var getTipOffsetLeft = function getTipOffsetLeft(place) {
    var offset_X = defaultOffset[place].l;
    return mouseX + offset_X + extraOffset_X;
  };
  var getTipOffsetRight = function getTipOffsetRight(place) {
    var offset_X = defaultOffset[place].r;
    return mouseX + offset_X + extraOffset_X;
  };
  var getTipOffsetTop = function getTipOffsetTop(place) {
    var offset_Y = defaultOffset[place].t;
    return mouseY + offset_Y + extraOffset_Y;
  };
  var getTipOffsetBottom = function getTipOffsetBottom(place) {
    var offset_Y = defaultOffset[place].b;
    return mouseY + offset_Y + extraOffset_Y;
  };

  // Judge if the tooltip has over the window(screen)
  var outsideVertical = function outsideVertical() {
    var result = false;
    var newPlace = void 0;
    if (getTipOffsetTop('left') < 0 && getTipOffsetBottom('left') <= windowHeight && getTipOffsetBottom('bottom') <= windowHeight) {
      result = true;
      newPlace = 'bottom';
    } else if (getTipOffsetBottom('left') > windowHeight && getTipOffsetTop('left') >= 0 && getTipOffsetTop('top') >= 0) {
      result = true;
      newPlace = 'top';
    }
    return { result: result, newPlace: newPlace };
  };
  var outsideLeft = function outsideLeft() {
    var _outsideVertical = outsideVertical(),
        result = _outsideVertical.result,
        newPlace = _outsideVertical.newPlace; // Deal with vertical as first priority


    if (result && outsideHorizontal().result) {
      return { result: false // No need to change, if change to vertical will out of space
      };
    }
    if (!result && getTipOffsetLeft('left') < 0 && getTipOffsetRight('right') <= windowWidth) {
      result = true; // If vertical ok, but let out of side and right won't out of side
      newPlace = 'right';
    }
    return { result: result, newPlace: newPlace };
  };
  var outsideRight = function outsideRight() {
    var _outsideVertical2 = outsideVertical(),
        result = _outsideVertical2.result,
        newPlace = _outsideVertical2.newPlace;

    if (result && outsideHorizontal().result) {
      return { result: false // No need to change, if change to vertical will out of space
      };
    }
    if (!result && getTipOffsetRight('right') > windowWidth && getTipOffsetLeft('left') >= 0) {
      result = true;
      newPlace = 'left';
    }
    return { result: result, newPlace: newPlace };
  };

  var outsideHorizontal = function outsideHorizontal() {
    var result = false;
    var newPlace = void 0;
    if (getTipOffsetLeft('top') < 0 && getTipOffsetRight('top') <= windowWidth && getTipOffsetRight('right') <= windowWidth) {
      result = true;
      newPlace = 'right';
    } else if (getTipOffsetRight('top') > windowWidth && getTipOffsetLeft('top') >= 0 && getTipOffsetLeft('left') >= 0) {
      result = true;
      newPlace = 'left';
    }
    return { result: result, newPlace: newPlace };
  };
  var outsideTop = function outsideTop() {
    var _outsideHorizontal = outsideHorizontal(),
        result = _outsideHorizontal.result,
        newPlace = _outsideHorizontal.newPlace;

    if (result && outsideVertical().result) {
      return { result: false };
    }
    if (!result && getTipOffsetTop('top') < 0 && getTipOffsetBottom('bottom') <= windowHeight) {
      result = true;
      newPlace = 'bottom';
    }
    return { result: result, newPlace: newPlace };
  };
  var outsideBottom = function outsideBottom() {
    var _outsideHorizontal2 = outsideHorizontal(),
        result = _outsideHorizontal2.result,
        newPlace = _outsideHorizontal2.newPlace;

    if (result && outsideVertical().result) {
      return { result: false };
    }
    if (!result && getTipOffsetBottom('bottom') > windowHeight && getTipOffsetTop('top') >= 0) {
      result = true;
      newPlace = 'top';
    }
    return { result: result, newPlace: newPlace };
  };

  // Return new state to change the placement to the reverse if possible
  var outsideLeftResult = outsideLeft();
  var outsideRightResult = outsideRight();
  var outsideTopResult = outsideTop();
  var outsideBottomResult = outsideBottom();

  if (place === 'left' && outsideLeftResult.result) {
    return {
      isNewState: true,
      newState: { place: outsideLeftResult.newPlace }
    };
  } else if (place === 'right' && outsideRightResult.result) {
    return {
      isNewState: true,
      newState: { place: outsideRightResult.newPlace }
    };
  } else if (place === 'top' && outsideTopResult.result) {
    return {
      isNewState: true,
      newState: { place: outsideTopResult.newPlace }
    };
  } else if (place === 'bottom' && outsideBottomResult.result) {
    return {
      isNewState: true,
      newState: { place: outsideBottomResult.newPlace }
    };
  }

  // Change back to original place if possible
  if (place !== desiredPlace) {
    if (desiredPlace === 'top' && !outsideTopResult.result) {
      return {
        isNewState: true,
        newState: { place: 'top' }
      };
    } else if (desiredPlace === 'left' && !outsideLeftResult.result) {
      return {
        isNewState: true,
        newState: { place: 'left' }
      };
    } else if (desiredPlace === 'right' && !outsideRightResult.result) {
      return {
        isNewState: true,
        newState: { place: 'right' }
      };
    } else if (desiredPlace === 'bottom' && !outsideBottomResult.result) {
      return {
        isNewState: true,
        newState: { place: 'bottom' }
      };
    }
  }

  // Return tooltip offset position
  return {
    isNewState: false,
    position: {
      left: parseInt(getTipOffsetLeft(place) - parentLeft, 10),
      top: parseInt(getTipOffsetTop(place) - parentTop, 10)
    }
  };
};

// Get current mouse offset
var getCurrentOffset = function getCurrentOffset(e, currentTarget, effect) {
  var boundingClientRect = currentTarget.getBoundingClientRect();
  var targetTop = boundingClientRect.top;
  var targetLeft = boundingClientRect.left;
  var targetWidth = currentTarget.clientWidth;
  var targetHeight = currentTarget.clientHeight;

  if (effect === 'float') {
    return {
      mouseX: e.clientX,
      mouseY: e.clientY
    };
  }
  return {
    mouseX: targetLeft + targetWidth / 2,
    mouseY: targetTop + targetHeight / 2
  };
};

// List all possibility of tooltip final offset
// This is useful in judging if it is necessary for tooltip to switch position when out of window
/**
 * Calculate the position of tooltip
 *
 * @params
 * - `e` {Event} the event of current mouse
 * - `target` {Element} the currentTarget of the event
 * - `node` {DOM} the react-tooltip object
 * - `place` {String} top / right / bottom / left
 * - `effect` {String} float / solid
 * - `offset` {Object} the offset to default position
 *
 * @return {Object
 * - `isNewState` {Bool} required
 * - `newState` {Object}
 * - `position` {OBject} {left: {Number}, top: {Number}}
 */
var getDefaultPosition = function getDefaultPosition(effect, targetWidth, targetHeight, tipWidth, tipHeight) {
  var top = void 0;
  var right = void 0;
  var bottom = void 0;
  var left = void 0;
  var disToMouse = 3;
  var triangleHeight = 2;
  var cursorHeight = 12; // Optimize for float bottom only, cause the cursor will hide the tooltip

  if (effect === 'float') {
    top = {
      l: -(tipWidth / 2),
      r: tipWidth / 2,
      t: -(tipHeight + disToMouse + triangleHeight),
      b: -disToMouse
    };
    bottom = {
      l: -(tipWidth / 2),
      r: tipWidth / 2,
      t: disToMouse + cursorHeight,
      b: tipHeight + disToMouse + triangleHeight + cursorHeight
    };
    left = {
      l: -(tipWidth + disToMouse + triangleHeight),
      r: -disToMouse,
      t: -(tipHeight / 2),
      b: tipHeight / 2
    };
    right = {
      l: disToMouse,
      r: tipWidth + disToMouse + triangleHeight,
      t: -(tipHeight / 2),
      b: tipHeight / 2
    };
  } else if (effect === 'solid') {
    top = {
      l: -(tipWidth / 2),
      r: tipWidth / 2,
      t: -(targetHeight / 2 + tipHeight + triangleHeight),
      b: -(targetHeight / 2)
    };
    bottom = {
      l: -(tipWidth / 2),
      r: tipWidth / 2,
      t: targetHeight / 2,
      b: targetHeight / 2 + tipHeight + triangleHeight
    };
    left = {
      l: -(tipWidth + targetWidth / 2 + triangleHeight),
      r: -(targetWidth / 2),
      t: -(tipHeight / 2),
      b: tipHeight / 2
    };
    right = {
      l: targetWidth / 2,
      r: tipWidth + targetWidth / 2 + triangleHeight,
      t: -(tipHeight / 2),
      b: tipHeight / 2
    };
  }

  return { top: top, bottom: bottom, left: left, right: right };
};

// Consider additional offset into position calculation
var calculateOffset = function calculateOffset(offset) {
  var extraOffset_X = 0;
  var extraOffset_Y = 0;

  if (Object.prototype.toString.apply(offset) === '[object String]') {
    offset = JSON.parse(offset.toString().replace(/\'/g, '\"'));
  }
  for (var key in offset) {
    if (key === 'top') {
      extraOffset_Y -= parseInt(offset[key], 10);
    } else if (key === 'bottom') {
      extraOffset_Y += parseInt(offset[key], 10);
    } else if (key === 'left') {
      extraOffset_X -= parseInt(offset[key], 10);
    } else if (key === 'right') {
      extraOffset_X += parseInt(offset[key], 10);
    }
  }

  return { extraOffset_X: extraOffset_X, extraOffset_Y: extraOffset_Y };
};

// Get the offset of the parent elements
var getParent = function getParent(currentTarget) {
  var currentParent = currentTarget;
  while (currentParent) {
    if (window.getComputedStyle(currentParent).getPropertyValue('transform') !== 'none') break;
    currentParent = currentParent.parentElement;
  }

  var parentTop = currentParent && currentParent.getBoundingClientRect().top || 0;
  var parentLeft = currentParent && currentParent.getBoundingClientRect().left || 0;

  return { parentTop: parentTop, parentLeft: parentLeft };
};

/***/ }),

/***/ 1786:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (tip, children, getContent, multiline) {
  if (children) return children;
  if (getContent !== undefined && getContent !== null) return getContent; // getContent can be 0, '', etc.
  if (getContent === null) return null; // Tip not exist and childern is null or undefined

  var regexp = /<br\s*\/?>/;
  if (!multiline || multiline === 'false' || !regexp.test(tip)) {
    // No trim(), so that user can keep their input
    return tip;
  }

  // Multiline tooltip content
  return tip.split(regexp).map(function (d, i) {
    return _react2.default.createElement('span', { key: i, className: 'multi-line' }, d);
  });
};

var _react = __webpack_require__(11);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

/***/ }),

/***/ 1787:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.parseAria = parseAria;
/**
 * Support aria- and role in ReactTooltip
 *
 * @params props {Object}
 * @return {Object}
 */
function parseAria(props) {
  var ariaObj = {};
  Object.keys(props).filter(function (prop) {
    // aria-xxx and role is acceptable
    return (/(^aria-\w+$|^role$)/.test(prop)
    );
  }).forEach(function (prop) {
    ariaObj[prop] = props[prop];
  });

  return ariaObj;
}

/***/ }),

/***/ 1788:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (nodeList) {
  var length = nodeList.length;
  if (nodeList.hasOwnProperty) {
    return Array.prototype.slice.call(nodeList);
  }
  return new Array(length).fill().map(function (index) {
    return nodeList[index];
  });
};

/***/ }),

/***/ 1789:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = '.__react_component_tooltip{border-radius:3px;display:inline-block;font-size:13px;left:-999em;opacity:0;padding:8px 21px;position:fixed;pointer-events:none;transition:opacity 0.3s ease-out;top:-999em;visibility:hidden;z-index:999}.__react_component_tooltip:before,.__react_component_tooltip:after{content:"";width:0;height:0;position:absolute}.__react_component_tooltip.show{opacity:0.9;margin-top:0px;margin-left:0px;visibility:visible}.__react_component_tooltip.type-dark{color:#fff;background-color:#222}.__react_component_tooltip.type-dark.place-top:after{border-top-color:#222;border-top-style:solid;border-top-width:6px}.__react_component_tooltip.type-dark.place-bottom:after{border-bottom-color:#222;border-bottom-style:solid;border-bottom-width:6px}.__react_component_tooltip.type-dark.place-left:after{border-left-color:#222;border-left-style:solid;border-left-width:6px}.__react_component_tooltip.type-dark.place-right:after{border-right-color:#222;border-right-style:solid;border-right-width:6px}.__react_component_tooltip.type-dark.border{border:1px solid #fff}.__react_component_tooltip.type-dark.border.place-top:before{border-top:8px solid #fff}.__react_component_tooltip.type-dark.border.place-bottom:before{border-bottom:8px solid #fff}.__react_component_tooltip.type-dark.border.place-left:before{border-left:8px solid #fff}.__react_component_tooltip.type-dark.border.place-right:before{border-right:8px solid #fff}.__react_component_tooltip.type-success{color:#fff;background-color:#8DC572}.__react_component_tooltip.type-success.place-top:after{border-top-color:#8DC572;border-top-style:solid;border-top-width:6px}.__react_component_tooltip.type-success.place-bottom:after{border-bottom-color:#8DC572;border-bottom-style:solid;border-bottom-width:6px}.__react_component_tooltip.type-success.place-left:after{border-left-color:#8DC572;border-left-style:solid;border-left-width:6px}.__react_component_tooltip.type-success.place-right:after{border-right-color:#8DC572;border-right-style:solid;border-right-width:6px}.__react_component_tooltip.type-success.border{border:1px solid #fff}.__react_component_tooltip.type-success.border.place-top:before{border-top:8px solid #fff}.__react_component_tooltip.type-success.border.place-bottom:before{border-bottom:8px solid #fff}.__react_component_tooltip.type-success.border.place-left:before{border-left:8px solid #fff}.__react_component_tooltip.type-success.border.place-right:before{border-right:8px solid #fff}.__react_component_tooltip.type-warning{color:#fff;background-color:#F0AD4E}.__react_component_tooltip.type-warning.place-top:after{border-top-color:#F0AD4E;border-top-style:solid;border-top-width:6px}.__react_component_tooltip.type-warning.place-bottom:after{border-bottom-color:#F0AD4E;border-bottom-style:solid;border-bottom-width:6px}.__react_component_tooltip.type-warning.place-left:after{border-left-color:#F0AD4E;border-left-style:solid;border-left-width:6px}.__react_component_tooltip.type-warning.place-right:after{border-right-color:#F0AD4E;border-right-style:solid;border-right-width:6px}.__react_component_tooltip.type-warning.border{border:1px solid #fff}.__react_component_tooltip.type-warning.border.place-top:before{border-top:8px solid #fff}.__react_component_tooltip.type-warning.border.place-bottom:before{border-bottom:8px solid #fff}.__react_component_tooltip.type-warning.border.place-left:before{border-left:8px solid #fff}.__react_component_tooltip.type-warning.border.place-right:before{border-right:8px solid #fff}.__react_component_tooltip.type-error{color:#fff;background-color:#BE6464}.__react_component_tooltip.type-error.place-top:after{border-top-color:#BE6464;border-top-style:solid;border-top-width:6px}.__react_component_tooltip.type-error.place-bottom:after{border-bottom-color:#BE6464;border-bottom-style:solid;border-bottom-width:6px}.__react_component_tooltip.type-error.place-left:after{border-left-color:#BE6464;border-left-style:solid;border-left-width:6px}.__react_component_tooltip.type-error.place-right:after{border-right-color:#BE6464;border-right-style:solid;border-right-width:6px}.__react_component_tooltip.type-error.border{border:1px solid #fff}.__react_component_tooltip.type-error.border.place-top:before{border-top:8px solid #fff}.__react_component_tooltip.type-error.border.place-bottom:before{border-bottom:8px solid #fff}.__react_component_tooltip.type-error.border.place-left:before{border-left:8px solid #fff}.__react_component_tooltip.type-error.border.place-right:before{border-right:8px solid #fff}.__react_component_tooltip.type-info{color:#fff;background-color:#337AB7}.__react_component_tooltip.type-info.place-top:after{border-top-color:#337AB7;border-top-style:solid;border-top-width:6px}.__react_component_tooltip.type-info.place-bottom:after{border-bottom-color:#337AB7;border-bottom-style:solid;border-bottom-width:6px}.__react_component_tooltip.type-info.place-left:after{border-left-color:#337AB7;border-left-style:solid;border-left-width:6px}.__react_component_tooltip.type-info.place-right:after{border-right-color:#337AB7;border-right-style:solid;border-right-width:6px}.__react_component_tooltip.type-info.border{border:1px solid #fff}.__react_component_tooltip.type-info.border.place-top:before{border-top:8px solid #fff}.__react_component_tooltip.type-info.border.place-bottom:before{border-bottom:8px solid #fff}.__react_component_tooltip.type-info.border.place-left:before{border-left:8px solid #fff}.__react_component_tooltip.type-info.border.place-right:before{border-right:8px solid #fff}.__react_component_tooltip.type-light{color:#222;background-color:#fff}.__react_component_tooltip.type-light.place-top:after{border-top-color:#fff;border-top-style:solid;border-top-width:6px}.__react_component_tooltip.type-light.place-bottom:after{border-bottom-color:#fff;border-bottom-style:solid;border-bottom-width:6px}.__react_component_tooltip.type-light.place-left:after{border-left-color:#fff;border-left-style:solid;border-left-width:6px}.__react_component_tooltip.type-light.place-right:after{border-right-color:#fff;border-right-style:solid;border-right-width:6px}.__react_component_tooltip.type-light.border{border:1px solid #222}.__react_component_tooltip.type-light.border.place-top:before{border-top:8px solid #222}.__react_component_tooltip.type-light.border.place-bottom:before{border-bottom:8px solid #222}.__react_component_tooltip.type-light.border.place-left:before{border-left:8px solid #222}.__react_component_tooltip.type-light.border.place-right:before{border-right:8px solid #222}.__react_component_tooltip.place-top{margin-top:-10px}.__react_component_tooltip.place-top:before{border-left:10px solid transparent;border-right:10px solid transparent;bottom:-8px;left:50%;margin-left:-10px}.__react_component_tooltip.place-top:after{border-left:8px solid transparent;border-right:8px solid transparent;bottom:-6px;left:50%;margin-left:-8px}.__react_component_tooltip.place-bottom{margin-top:10px}.__react_component_tooltip.place-bottom:before{border-left:10px solid transparent;border-right:10px solid transparent;top:-8px;left:50%;margin-left:-10px}.__react_component_tooltip.place-bottom:after{border-left:8px solid transparent;border-right:8px solid transparent;top:-6px;left:50%;margin-left:-8px}.__react_component_tooltip.place-left{margin-left:-10px}.__react_component_tooltip.place-left:before{border-top:6px solid transparent;border-bottom:6px solid transparent;right:-8px;top:50%;margin-top:-5px}.__react_component_tooltip.place-left:after{border-top:5px solid transparent;border-bottom:5px solid transparent;right:-6px;top:50%;margin-top:-4px}.__react_component_tooltip.place-right{margin-left:10px}.__react_component_tooltip.place-right:before{border-top:6px solid transparent;border-bottom:6px solid transparent;left:-8px;top:50%;margin-top:-5px}.__react_component_tooltip.place-right:after{border-top:5px solid transparent;border-bottom:5px solid transparent;left:-6px;top:50%;margin-top:-4px}.__react_component_tooltip .multi-line{display:block;padding:2px 0px;text-align:center}';

/***/ }),

/***/ 1790:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// CONCATENATED MODULE: ./src/shared/components/SpareImg/SpareImg.js
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_hocs_withPixelRatio__ = __webpack_require__(1391);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shared_constants_defaultImages__ = __webpack_require__(1398);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__SpareImg_css__ = __webpack_require__(1791);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__SpareImg_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__SpareImg_css__);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();








var IMAGE_WIDTH = 70;

function SpareImg(props) {
  var photos = props.photos,
      defaultImg = props.defaultImg,
      setRatioAlbum = props.setRatioAlbum;

  var resizedPhotos = setRatioAlbum(photos, IMAGE_WIDTH);
  return _jsx('div', {
    style: { padding: '0 15px 0 0' }
  }, void 0, _jsx('img', {
    className: __WEBPACK_IMPORTED_MODULE_5__SpareImg_css___default.a.spareImage,
    src: resizedPhotos && resizedPhotos.length > 0 ? resizedPhotos[0].image : defaultImg,
    alt: ''
  }));
}

SpareImg.defaultProps = {
  photos: null,
  defaultImg: __WEBPACK_IMPORTED_MODULE_4_shared_constants_defaultImages__["c" /* getSpareDefaultImage */]()
};


/* harmony default export */ var SpareImg_defaultExport = (__WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_5__SpareImg_css___default.a)(__WEBPACK_IMPORTED_MODULE_3_shared_hocs_withPixelRatio__["a" /* default */](SpareImg)));
// CONCATENATED MODULE: ./src/shared/components/SpareImg/index.js


/* harmony default export */ __webpack_exports__["a"] = (SpareImg_defaultExport);

/***/ }),

/***/ 1791:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1792);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./SpareImg.css", function() {
        content = require("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./SpareImg.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 1792:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, "._2-UeN{height:auto;-webkit-box-sizing:initial;box-sizing:initial;width:70px}", ""]);

// exports
exports.locals = {
	"spareImage": "_2-UeN"
};

/***/ }),

/***/ 1850:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// CONCATENATED MODULE: ./src/desktop/components/AdvertCard/SimpleCard/SimpleCard.js
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SimpleCard_css__ = __webpack_require__(1862);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SimpleCard_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__SimpleCard_css__);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();







function SimpleCard(props) {
  var fullPrice = props.fullPrice,
      year = props.year,
      mileageText = props.mileageText,
      engineTitle = props.engineTitle,
      gearboxTitle = props.gearboxTitle,
      make = props.make,
      maker = props.maker,
      model = props.model;


  return _jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_3__SimpleCard_css___default.a.root
  }, void 0, _jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_3__SimpleCard_css___default.a.title
  }, void 0, maker && maker.title || make && make.title, ' ', model && model.title), _jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_3__SimpleCard_css___default.a.info
  }, void 0, year && _jsx('span', {}, void 0, year), mileageText && _jsx('span', {}, void 0, mileageText)), _jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_3__SimpleCard_css___default.a.info
  }, void 0, engineTitle && _jsx('span', {}, void 0, engineTitle || ''), gearboxTitle && _jsx('span', {}, void 0, gearboxTitle || '')), fullPrice && _jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_3__SimpleCard_css___default.a.price
  }, void 0, fullPrice));
}

SimpleCard.defaultProps = {
  fullPrice: null,
  engineTitle: null,
  gearboxTitle: null,
  year: null,
  maker: null,
  mileageText: null
};


/* harmony default export */ var SimpleCard_defaultExport = (__WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_3__SimpleCard_css___default.a)(SimpleCard));
// CONCATENATED MODULE: ./src/desktop/components/AdvertCard/SimilarCard/SimilarCard.js
/* harmony import */ var SimilarCard___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var SimilarCard___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(SimilarCard___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(1240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_intl__ = __webpack_require__(474);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__SimilarCard_css__ = __webpack_require__(1864);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__SimilarCard_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__SimilarCard_css__);
var SimilarCard__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }









function SimilarCard(props) {
  var fullPrice = props.fullPrice,
      year = props.year,
      make = props.make,
      maker = props.maker,
      model = props.model,
      shouldEmphasizePrice = props.shouldEmphasizePrice,
      isNegotiablePrice = props.isNegotiablePrice,
      intl = props.intl;


  return SimilarCard__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_5__SimilarCard_css___default.a.root
  }, void 0, SimilarCard__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_5__SimilarCard_css___default.a.title
  }, void 0, maker && maker.title || make && make.title, ' ', model && model.title, ' ', SimilarCard__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_5__SimilarCard_css___default.a.similarYear
  }, void 0, year)), fullPrice && !isNegotiablePrice && SimilarCard__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_1_classnames___default.a(__WEBPACK_IMPORTED_MODULE_5__SimilarCard_css___default.a.similarPrice, _defineProperty({}, __WEBPACK_IMPORTED_MODULE_5__SimilarCard_css___default.a.emphasizePrice, shouldEmphasizePrice))
  }, void 0, fullPrice), isNegotiablePrice && SimilarCard__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_1_classnames___default.a(__WEBPACK_IMPORTED_MODULE_5__SimilarCard_css___default.a.contractPrice)
  }, void 0, intl.formatMessage({ id: 'договорная' })));
}

SimilarCard.defaultProps = {
  fullPrice: null,
  year: null,
  shouldEmphasizePrice: false,
  isNegotiablePrice: false
};


/* harmony default export */ var SimilarCard_defaultExport = (__WEBPACK_IMPORTED_MODULE_4_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_5__SimilarCard_css___default.a)(SimilarCard));
// CONCATENATED MODULE: ./src/desktop/components/AdvertCard/DealerAdsCard/DealerAdsCard.js
/* harmony import */ var DealerAdsCard___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var DealerAdsCard___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(DealerAdsCard___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var DealerAdsCard___WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(1240);
/* harmony import */ var DealerAdsCard___WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(DealerAdsCard___WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var DealerAdsCard___WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(131);
/* harmony import */ var DealerAdsCard___WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(DealerAdsCard___WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__DealerAdsCard_css__ = __webpack_require__(1866);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__DealerAdsCard_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__DealerAdsCard_css__);
var DealerAdsCard__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();








function DealerAdsCard(props) {
  var fullPrice = props.fullPrice,
      year = props.year,
      make = props.make,
      maker = props.maker,
      model = props.model;


  return DealerAdsCard__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_4__DealerAdsCard_css___default.a.root
  }, void 0, DealerAdsCard__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_4__DealerAdsCard_css___default.a.title
  }, void 0, maker && maker.title || make && make.title, ' ', model && model.title, ' ', DealerAdsCard__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_4__DealerAdsCard_css___default.a.similarYear
  }, void 0, year)), fullPrice && DealerAdsCard__jsx('div', {
    className: DealerAdsCard___WEBPACK_IMPORTED_MODULE_1_classnames___default.a(__WEBPACK_IMPORTED_MODULE_4__DealerAdsCard_css___default.a.similarPrice)
  }, void 0, fullPrice));
}

DealerAdsCard.defaultProps = {
  year: null,
  fullPrice: null
};


/* harmony default export */ var DealerAdsCard_defaultExport = (__WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_4__DealerAdsCard_css___default.a)(DealerAdsCard));
// CONCATENATED MODULE: ./src/desktop/components/AdvertCard/PromoutedCard/PromoutedCard.js
/* harmony import */ var PromoutedCard___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var PromoutedCard___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(PromoutedCard___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var PromoutedCard___WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(1240);
/* harmony import */ var PromoutedCard___WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(PromoutedCard___WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var PromoutedCard___WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(131);
/* harmony import */ var PromoutedCard___WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(PromoutedCard___WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var PromoutedCard___WEBPACK_IMPORTED_MODULE_3_react_intl__ = __webpack_require__(474);
/* harmony import */ var PromoutedCard___WEBPACK_IMPORTED_MODULE_4_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var PromoutedCard___WEBPACK_IMPORTED_MODULE_4_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(PromoutedCard___WEBPACK_IMPORTED_MODULE_4_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__PromoutedCard_css__ = __webpack_require__(1868);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__PromoutedCard_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__PromoutedCard_css__);
var PromoutedCard__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

function PromoutedCard__defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }









function PromoutedCard(props) {
  var fullPrice = props.fullPrice,
      year = props.year,
      mileageText = props.mileageText,
      engineTitle = props.engineTitle,
      gearboxTitle = props.gearboxTitle,
      make = props.make,
      maker = props.maker,
      model = props.model,
      shouldEmphasizePrice = props.shouldEmphasizePrice,
      isNegotiablePrice = props.isNegotiablePrice,
      intl = props.intl;


  return PromoutedCard__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_5__PromoutedCard_css___default.a.root
  }, void 0, PromoutedCard__jsx('div', {}, void 0, PromoutedCard__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_5__PromoutedCard_css___default.a.title
  }, void 0, maker && maker.title || make && make.title, ' ', model && model.title), PromoutedCard__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_5__PromoutedCard_css___default.a.info
  }, void 0, year && PromoutedCard__jsx('span', {}, void 0, year), mileageText && PromoutedCard__jsx('span', {}, void 0, mileageText)), PromoutedCard__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_5__PromoutedCard_css___default.a.info
  }, void 0, engineTitle && PromoutedCard__jsx('span', {}, void 0, engineTitle || ''), gearboxTitle && PromoutedCard__jsx('span', {}, void 0, gearboxTitle || ''))), fullPrice && !isNegotiablePrice && PromoutedCard__jsx('div', {
    className: PromoutedCard___WEBPACK_IMPORTED_MODULE_1_classnames___default.a(__WEBPACK_IMPORTED_MODULE_5__PromoutedCard_css___default.a.price, PromoutedCard__defineProperty({}, __WEBPACK_IMPORTED_MODULE_5__PromoutedCard_css___default.a.emphasizePrice, shouldEmphasizePrice))
  }, void 0, fullPrice), isNegotiablePrice && PromoutedCard__jsx('div', {
    className: PromoutedCard___WEBPACK_IMPORTED_MODULE_1_classnames___default.a(__WEBPACK_IMPORTED_MODULE_5__PromoutedCard_css___default.a.price)
  }, void 0, intl.formatMessage({ id: 'договорная' })));
}

PromoutedCard.defaultProps = {
  fullPrice: null,
  mileageText: null,
  engineTitle: '',
  gearboxTitle: '',
  abroadTitle: '',
  drivenFromTitle: '',
  shouldEmphasizePrice: false,
  isNegotiablePrice: false
};


/* harmony default export */ var PromoutedCard_defaultExport = (PromoutedCard___WEBPACK_IMPORTED_MODULE_4_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_5__PromoutedCard_css___default.a)(PromoutedCard));
// CONCATENATED MODULE: ./src/desktop/components/AdvertCard/AdvertCard.js
/* harmony import */ var AdvertCard___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var AdvertCard___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(AdvertCard___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var AdvertCard___WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(1240);
/* harmony import */ var AdvertCard___WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(AdvertCard___WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var AdvertCard___WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(131);
/* harmony import */ var AdvertCard___WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(AdvertCard___WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var AdvertCard___WEBPACK_IMPORTED_MODULE_3_react_intl__ = __webpack_require__(474);
/* harmony import */ var AdvertCard___WEBPACK_IMPORTED_MODULE_4_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var AdvertCard___WEBPACK_IMPORTED_MODULE_4_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(AdvertCard___WEBPACK_IMPORTED_MODULE_4_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_shared_components_Link__ = __webpack_require__(1241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_shared_helpers_urls__ = __webpack_require__(312);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_shared_helpers_transportInfo__ = __webpack_require__(1274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_shared_helpers_common__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_shared_constants_json_currency_json__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_shared_constants_json_currency_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_shared_constants_json_currency_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_shared_constants_json_mileageUnits_json__ = __webpack_require__(320);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_shared_constants_json_mileageUnits_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_shared_constants_json_mileageUnits_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_shared_constants_defaultImages__ = __webpack_require__(1398);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__AdvertCard_css__ = __webpack_require__(1860);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__AdvertCard_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__AdvertCard_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Thumb_Thumb__ = __webpack_require__(1436);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var AdvertCard__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function AdvertCard__defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






















var uah = __WEBPACK_IMPORTED_MODULE_9_shared_constants_json_currency_json___default.a.find(function (item) {
  return item.slug === 'uah';
});

var AdvertCard_AdvertCard = function (_React$Component) {
  _inherits(AdvertCard, _React$Component);

  function AdvertCard() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, AdvertCard);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = AdvertCard.__proto__ || Object.getPrototypeOf(AdvertCard)).call.apply(_ref, [this].concat(args))), _this), _this.buildCarPrice = function (prices, currency) {
      if (!Array.isArray(prices)) {
        return null;
      }

      var priceObj = prices.find(function (price) {
        return price.currency === currency.slug;
      });
      return AdvertCard__jsx('span', {}, void 0, priceObj && __WEBPACK_IMPORTED_MODULE_8_shared_helpers_common__["k" /* numberWithSpaces */](priceObj.value), ' ', AdvertCard__jsx('small', {}, void 0, currency && currency.title));
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(AdvertCard, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          advertClassName = _props.advertClassName,
          advertThumbClassName = _props.advertThumbClassName,
          advertStyle = _props.advertStyle,
          imageStyle = _props.imageStyle,
          currency = _props.currency,
          item = _props.item,
          cardType = _props.cardType,
          width = _props.width,
          _props$item = _props.item,
          _props$item$maker = _props$item.maker,
          maker = _props$item$maker === undefined ? '' : _props$item$maker,
          _props$item$make = _props$item.make,
          make = _props$item$make === undefined ? '' : _props$item$make,
          _props$item$model = _props$item.model,
          model = _props$item$model === undefined ? '' : _props$item$model,
          _props$item$year = _props$item.year,
          year = _props$item$year === undefined ? '' : _props$item$year,
          _props$item$mileage = _props$item.mileage,
          mileage = _props$item$mileage === undefined ? '' : _props$item$mileage,
          _props$item$mileage_u = _props$item.mileage_units,
          mUnit = _props$item$mileage_u === undefined ? '' : _props$item$mileage_u,
          _props$item$mileage_u2 = _props$item.mileage_unit,
          mileageUnitTempId = _props$item$mileage_u2 === undefined ? 0 : _props$item$mileage_u2,
          _props$item$engine = _props$item.engine,
          engine = _props$item$engine === undefined ? '' : _props$item$engine,
          _props$item$gearbox = _props$item.gearbox,
          gearbox = _props$item$gearbox === undefined ? '' : _props$item$gearbox,
          _props$item$price = _props$item.price,
          price = _props$item$price === undefined ? '' : _props$item$price,
          _props$item$character = _props$item.characteristics,
          characteristics = _props$item$character === undefined ? '' : _props$item$character,
          transport = _props$item.transport,
          colorDate = _props$item.color_date,
          isNew = _props$item.is_new,
          clarifyPriceLink = _props$item.clarify_price_link,
          isNegotiablePrice = _props$item.is_negotiable_price,
          linkFromProps = _props.link,
          intl = _props.intl,
          lensEvent = _props.lensEvent;


      var mileageUnitId = mileageUnitTempId || 0;

      var link = linkFromProps || '/' + __WEBPACK_IMPORTED_MODULE_6_shared_helpers_urls__["g" /* generateUrl */](item);
      var fullPrice = clarifyPriceLink ? null : this.buildCarPrice(price, currency) || __WEBPACK_IMPORTED_MODULE_7_shared_helpers_transportInfo__["a" /* carPrice */](price, currency.slug);

      var engineTitle = engine ? engine.title : characteristics && characteristics.engine && characteristics.engine.title;
      var gearboxTitle = gearbox ? gearbox.title : characteristics && characteristics.gearbox && characteristics.gearbox.title;

      var mileageUnit = mUnit || intl.formatMessage({ id: __WEBPACK_IMPORTED_MODULE_10_shared_constants_json_mileageUnits_json___default.a.find(function (unit) {
          return unit.id === mileageUnitId;
        }).title });

      var defaultImage = this.props.defaultImage || __WEBPACK_IMPORTED_MODULE_11_shared_constants_defaultImages__["b" /* getDefaultImageByType */](transport);
      var shouldEmphasizePrice = colorDate ? new Date(colorDate) > new Date() : false;

      var mileageText = mileage > 0 ? mileage + ' ' + (mileageUnit || '') : null;

      if (isNew) {
        mileageText = intl.formatMessage({ id: 'Новый' });
      }

      var sharedProps = {
        maker: maker,
        make: make,
        model: model,
        year: year,
        fullPrice: fullPrice,
        shouldEmphasizePrice: shouldEmphasizePrice,
        isNegotiablePrice: isNegotiablePrice,
        intl: intl
      };

      var _ref2 = AdvertCard__jsx(SimpleCard_defaultExport, {
        make: make,
        model: model
      });

      var renderSwitchParams = function renderSwitchParams() {
        switch (cardType && cardType.toLowerCase()) {
          case 'similar':
            {
              return AdvertCard___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SimilarCard_defaultExport, sharedProps);
            }
          case 'dealerads':
            {
              return AdvertCard___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(DealerAdsCard_defaultExport, sharedProps);
            }
          case 'simple':
            {
              return AdvertCard___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SimpleCard_defaultExport, _extends({}, sharedProps, {
                mileageText: mileageText,
                engineTitle: engineTitle || '',
                gearboxTitle: gearboxTitle || ''
              }));
            }
          case 'brick':
            {
              return _ref2;
            }
          default:
            {
              return AdvertCard___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(PromoutedCard_defaultExport, _extends({}, sharedProps, {
                mileageText: mileageText,
                engineTitle: engineTitle || '',
                gearboxTitle: gearboxTitle || ''
              }));
            }
        }
      };

      return AdvertCard__jsx('div', {
        className: AdvertCard___WEBPACK_IMPORTED_MODULE_1_classnames___default.a(advertClassName, __WEBPACK_IMPORTED_MODULE_12__AdvertCard_css___default.a.advert),
        style: advertStyle
      }, JSON.stringify(item), AdvertCard__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_12__AdvertCard_css___default.a.thumb
      }, void 0, AdvertCard__jsx(__WEBPACK_IMPORTED_MODULE_13__Thumb_Thumb__["a" /* default */], {
        photos: item.photos,
        link: link,
        style: imageStyle,
        className: advertThumbClassName,
        width: width,
        defaultImg: defaultImage,
        lensEvent: lensEvent
      }, Math.random())), AdvertCard__jsx('div', {
        className: AdvertCard___WEBPACK_IMPORTED_MODULE_1_classnames___default.a(__WEBPACK_IMPORTED_MODULE_12__AdvertCard_css___default.a.subInfo, AdvertCard__defineProperty({}, __WEBPACK_IMPORTED_MODULE_12__AdvertCard_css___default.a.brick, cardType && cardType.toLowerCase() === 'brick'))
      }, void 0, renderSwitchParams()), link && AdvertCard__jsx(__WEBPACK_IMPORTED_MODULE_5_shared_components_Link__["a" /* default */], {
        to: link,
        className: __WEBPACK_IMPORTED_MODULE_12__AdvertCard_css___default.a.link,
        'data-lens-event': lensEvent
      }));
    }
  }]);

  return AdvertCard;
}(AdvertCard___WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

AdvertCard_AdvertCard.defaultProps = {
  advertStyle: {},
  imageStyle: {},
  currency: uah,
  lensEvent: '',
  advertClassName: '',
  advertThumbClassName: '',
  cardType: '',
  width: 240,
  link: null,
  defaultImage: null
};


/* harmony default export */ __webpack_exports__["a"] = (AdvertCard___WEBPACK_IMPORTED_MODULE_4_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_12__AdvertCard_css___default.a)(AdvertCard___WEBPACK_IMPORTED_MODULE_3_react_intl__["d" /* injectIntl */](AdvertCard_AdvertCard)));

/***/ }),

/***/ 1857:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(1240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_intl__ = __webpack_require__(474);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_shared_components_Link__ = __webpack_require__(1241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_shared_modules__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_shared_components_JsonLdApplication_JsonLdApplication__ = __webpack_require__(1753);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__BreadcrumbsLinks_css__ = __webpack_require__(1858);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__BreadcrumbsLinks_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__BreadcrumbsLinks_css__);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();




// import { connect } from 'react-redux';









var AB_PATH = 'https://avtobazar.ua';

var SpanLink = function SpanLink(_ref) {
  var text = _ref.text,
      index = _ref.index,
      intl = _ref.intl;
  return _jsx('span', {}, void 0, index === 0 ? __WEBPACK_IMPORTED_MODULE_6_shared_modules__["n" /* replaceToUpperCase */](intl.formatMessage({ id: text })) : intl.formatMessage({ id: text }));
};

function BreadcrumbsLinks(props) {
  var links = props.links,
      currentPath = props.history.currentPath,
      intl = props.intl;

  var hasQuery = !!currentPath.split('').find(function (item) {
    return item === '?';
  });

  var breadcrumbItemListEl = links.map(function (a, b) {
    return {
      '@type': 'ListItem',
      position: b + 1,
      item: {
        '@id': '' + AB_PATH + a[0] + '/',
        name: b === 0 ? __WEBPACK_IMPORTED_MODULE_6_shared_modules__["n" /* replaceToUpperCase */](intl.formatMessage({ id: a[1] })) : intl.formatMessage({ id: a[1] })
      }
    };
  });

  var breadcrumbListLd = {
    '@context': 'http://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: breadcrumbItemListEl
  };

  return _jsx('div', {}, void 0, _jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_1_classnames___default.a(__WEBPACK_IMPORTED_MODULE_8__BreadcrumbsLinks_css___default.a.olNavigationLink)
  }, void 0, links.map(function (a, b) {
    return _jsx('span', {
      className: __WEBPACK_IMPORTED_MODULE_8__BreadcrumbsLinks_css___default.a.itemListElement
    }, '' + b + a[2], b + 1 === links.length && !hasQuery ? _jsx('span', {
      className: 'meta-title-link-next'
    }, void 0, _jsx(SpanLink, {
      text: a[1],
      index: b,
      intl: intl
    })) : _jsx('li', {}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_5_shared_components_Link__["a" /* default */], {
      itemProp: 'url',
      to: a[0] + '/',
      className: __WEBPACK_IMPORTED_MODULE_1_classnames___default.a({
        'meta-title-link': b === 0,
        'meta-title-link-next': b !== 0
      })
    }, void 0, _jsx(SpanLink, {
      text: a[1],
      index: b,
      intl: intl
    }))));
  })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_shared_components_JsonLdApplication_JsonLdApplication__["a" /* default */], breadcrumbListLd));
}

BreadcrumbsLinks.defaultProps = {
  title: '',
  history: {
    currentPath: ''
  }
};


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_4_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_8__BreadcrumbsLinks_css___default.a)(__WEBPACK_IMPORTED_MODULE_3_react_intl__["d" /* injectIntl */](BreadcrumbsLinks)));

/***/ }),

/***/ 1858:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1859);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./BreadcrumbsLinks.css", function() {
        content = require("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./BreadcrumbsLinks.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 1859:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, "._3Iphx{float:left;margin:0 .3em .3em 0;font-size:14px;color:#888;font-weight:400}._3909O{margin:0;height:18px;list-style-type:none;padding:0}", ""]);

// exports
exports.locals = {
	"itemListElement": "_3Iphx",
	"olNavigationLink": "_3909O"
};

/***/ }),

/***/ 1860:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1861);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./AdvertCard.css", function() {
        content = require("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./AdvertCard.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 1861:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, "._2DsF1{position:relative;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}._1ZRr7{text-align:center;vertical-align:middle;overflow:hidden;-webkit-box-flex:1;-ms-flex:1 0 auto;flex:1 0 auto}.Hx99o{position:absolute;height:100%;width:100%;top:0;left:0}.aAniA{position:relative;padding:10px 0 15px;height:100%}._2_yhd{position:absolute;top:0;left:0;right:0;width:100%;height:100%;color:#fff;padding:10px;background:#0004}._1ZRr7:hover+._2_yhd{opacity:0}", ""]);

// exports
exports.locals = {
	"advert": "_2DsF1",
	"thumb": "_1ZRr7",
	"link": "Hx99o",
	"subInfo": "aAniA",
	"brick": "_2_yhd"
};

/***/ }),

/***/ 1862:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1863);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./SimpleCard.css", function() {
        content = require("!!../../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./SimpleCard.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 1863:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, "._2yk2D span{margin-right:30px}._2yk2D{position:relative;display:block;margin-bottom:4px;font-size:14px;color:#888;font-weight:400}._3JXp4{font-weight:700;margin-top:5px;display:inline-block;font-size:17px;padding:2px 0;border-radius:2px;color:#000}._3p3D5:hover ._2jmjC{color:#e73232}._2jmjC{font-size:15px;font-weight:700;margin-bottom:4px}", ""]);

// exports
exports.locals = {
	"info": "_2yk2D",
	"price": "_3JXp4",
	"root": "_3p3D5",
	"title": "_2jmjC"
};

/***/ }),

/***/ 1864:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1865);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./SimilarCard.css", function() {
        content = require("!!../../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./SimilarCard.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 1865:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, "._187jn{position:relative;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;height:100%}._1bBl2{font-size:14px;font-weight:400;margin-bottom:7px}._1bJEb{font-weight:400;padding-top:4px}._2YpXN{font-weight:700;font-size:19px}._2YpXN,._39aqy{margin-top:5px;display:inline-block;color:#000}._39aqy{font-weight:400;font-size:14px}._2YpXN small{font-size:70%;font-weight:400}._1Wpcc{background-color:#ffeb3b}", ""]);

// exports
exports.locals = {
	"root": "_187jn",
	"title": "_1bBl2",
	"similarYear": "_1bJEb",
	"similarPrice": "_2YpXN",
	"contractPrice": "_39aqy",
	"emphasizePrice": "_1Wpcc"
};

/***/ }),

/***/ 1866:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1867);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./DealerAdsCard.css", function() {
        content = require("!!../../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./DealerAdsCard.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 1867:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, "._1vxuG{position:relative;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;height:100%}._1NVWQ{font-size:14px;font-weight:700;margin-bottom:7px}._18gRJ,.FEpxH{font-weight:400}.FEpxH{display:inline-block;font-size:16px;color:#000}.FEpxH small{font-size:70%;font-weight:400}", ""]);

// exports
exports.locals = {
	"root": "_1vxuG",
	"title": "_1NVWQ",
	"similarYear": "_18gRJ",
	"similarPrice": "FEpxH"
};

/***/ }),

/***/ 1868:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1869);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./PromoutedCard.css", function() {
        content = require("!!../../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./PromoutedCard.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 1869:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, "._15MTd{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;height:100%}.ec41e span{margin-right:30px}.ec41e{position:relative;display:block;margin-bottom:4px;font-size:14px;color:#888;font-weight:400}.f_y1-{font-weight:700;margin-top:5px;display:inline-block;font-size:17px;background-color:#ffeb3b;padding:2px 5px;border-radius:2px;color:#000}._15MTd:hover ._3AaHo{color:#e73232}._3AaHo{font-size:15px;font-weight:700;margin-bottom:4px}._1tbtL{background-color:#ffeb3b}", ""]);

// exports
exports.locals = {
	"root": "_15MTd",
	"info": "ec41e",
	"price": "f_y1-",
	"title": "_3AaHo",
	"emphasizePrice": "_1tbtL"
};

/***/ }),

/***/ 1877:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// CONCATENATED MODULE: ./src/shared/components/DealerServiceForm/service.js
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_shared_constants_api__ = __webpack_require__(29);
var _this = this;

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }



var sandEmail = function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(data, fetch) {
    var service, slug, phone, name, advertId, formData, options, result;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            service = data.service, slug = data.slug, phone = data.phone, name = data.name, advertId = data.advertId;
            formData = JSON.stringify({
              service: service,
              slug: slug,
              phone: phone.replace(/\s/g, ''),
              name: name,
              advertId: advertId
            });
            options = {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                'X-Requested-With': 'XMLHttpRequest'
              },
              body: formData
            };
            _context.prev = 3;
            _context.next = 6;
            return fetch(__WEBPACK_IMPORTED_MODULE_0_shared_constants_api__["a" /* default */].DEALERS.REQUEST_SERVICE, options).then(function (r) {
              return r.json();
            });

          case 6:
            result = _context.sent;

            if (!(!result || result.err)) {
              _context.next = 9;
              break;
            }

            return _context.abrupt('return', false);

          case 9:
            _context.next = 14;
            break;

          case 11:
            _context.prev = 11;
            _context.t0 = _context['catch'](3);
            return _context.abrupt('return', false);

          case 14:
            return _context.abrupt('return', true);

          case 15:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, _this, [[3, 11]]);
  }));

  return function sandEmail(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();
// CONCATENATED MODULE: ./src/shared/components/DealerServiceForm/DealerServiceForm.js
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(1240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_shared_hocs_withTranslate__ = __webpack_require__(1242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_shared_hocs_withFetch__ = __webpack_require__(1244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_shared_components_UI__ = __webpack_require__(1268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_shared_validations_validations__ = __webpack_require__(1402);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__DealerServiceForm_css__ = __webpack_require__(1878);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__DealerServiceForm_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__DealerServiceForm_css__);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }















var DealerServiceForm = function (_React$Component) {
  _inherits(DealerServiceForm, _React$Component);

  function DealerServiceForm(props) {
    _classCallCheck(this, DealerServiceForm);

    var _this = _possibleConstructorReturn(this, (DealerServiceForm.__proto__ || Object.getPrototypeOf(DealerServiceForm)).call(this, props));

    DealerServiceForm__initialiseProps.call(_this);

    var user = _this.props.user;

    var userName = user && user.name || '';
    var phone = user && user.phones && user.phones[0].number || '';

    _this.state = {
      phone: phone,
      name: userName,
      errorMessage: '',
      successMessage: '',
      disabled: !(phone && phone.length && userName && userName.length)
    };
    return _this;
  }

  _createClass(DealerServiceForm, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _state = this.state,
          errorMessage = _state.errorMessage,
          successMessage = _state.successMessage,
          name = _state.name,
          phone = _state.phone,
          disabled = _state.disabled;
      var t = this.props.t;


      return _jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_10__DealerServiceForm_css___default.a.root
      }, void 0, _jsx('form', {
        className: __WEBPACK_IMPORTED_MODULE_10__DealerServiceForm_css___default.a.requestForm
      }, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_7_shared_components_UI__["c" /* InputPhoneNumber */], {
        name: 'phone',
        value: phone,
        changeHandler: function changeHandler(field, value) {
          return _this2.handleInput(field, value);
        }
      }), _jsx(__WEBPACK_IMPORTED_MODULE_7_shared_components_UI__["e" /* InputText */], {
        name: 'name',
        value: name,
        placeholder: name || t('Введите имя'),
        changeHandler: function changeHandler(field, value) {
          return _this2.handleInput(field, value);
        }
      }), _jsx(__WEBPACK_IMPORTED_MODULE_7_shared_components_UI__["a" /* Button */], {
        type: 'button',
        text: t('Подтвердить номер'),
        disabled: disabled,
        onClick: function onClick(e) {
          _this2.handleSubmit(e);
        }
      })), (errorMessage || successMessage) && _jsx('span', {
        className: __WEBPACK_IMPORTED_MODULE_1_classnames___default.a(_defineProperty({}, __WEBPACK_IMPORTED_MODULE_10__DealerServiceForm_css___default.a.errorMessage, errorMessage), _defineProperty({}, __WEBPACK_IMPORTED_MODULE_10__DealerServiceForm_css___default.a.successMessage, successMessage))
      }, void 0, t(errorMessage || successMessage)));
    }
  }]);

  return DealerServiceForm;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

DealerServiceForm.defaultProps = {
  onSent: function onSent() {},
  advertInfo: null,
  user: null
};

var DealerServiceForm__initialiseProps = function _initialiseProps() {
  var _this3 = this;

  this.validateForm = function () {
    var phone = _this3.state.phone;

    if (phone && !__WEBPACK_IMPORTED_MODULE_8_shared_validations_validations__["e" /* isValidPhone */](phone.replace(/\s/g, ''))) {
      _this3.setState({
        errorMessage: _this3.props.t('Некорректный номер телефона')
      });
      return false;
    }
    return !!phone;
  };

  this.handleInput = function (field, value) {
    var _this3$setState;

    _this3.setState((_this3$setState = {}, _defineProperty(_this3$setState, field, value), _defineProperty(_this3$setState, 'errorMessage', ''), _defineProperty(_this3$setState, 'disabled', !_this3.state.phone || !_this3.state.name), _this3$setState));
  };

  this.handleSubmit = function () {
    if (!_this3.validateForm()) return;
    var _props = _this3.props,
        dealerSlug = _props.dealerSlug,
        service = _props.service,
        advertInfo = _props.advertInfo;
    var _state2 = _this3.state,
        phone = _state2.phone,
        name = _state2.name;

    var dataToEmail = {
      slug: dealerSlug,
      service: service,
      phone: phone,
      name: name
    };

    if (advertInfo && advertInfo.advertId) {
      dataToEmail.advertId = advertInfo.advertId;
    }

    _this3.setState({ disabled: true });
    var errMsg = 'Извините, произошла ошибка на сервере, попробуйте повторить операцию позже';
    sandEmail(dataToEmail, _this3.props.fetch).then(function (data) {
      _this3.setState({ disabled: false });
      if (data) _this3.props.onSent();else if (!data) _this3.setState({ errorMessage: errMsg });
    }).catch(function () {
      _this3.setState({
        disabled: false,
        errorMessage: errMsg
      });
    });
  };
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    user: state.user && state.user.user
  };
};

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_4_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_10__DealerServiceForm_css___default.a)(__WEBPACK_IMPORTED_MODULE_6_shared_hocs_withFetch__["a" /* withFetch */](__WEBPACK_IMPORTED_MODULE_3_react_redux__["b" /* connect */](mapStateToProps, null)(__WEBPACK_IMPORTED_MODULE_5_shared_hocs_withTranslate__["a" /* withTranslate */](DealerServiceForm)))));

/***/ }),

/***/ 1878:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1879);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./DealerServiceForm.css", function() {
        content = require("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./DealerServiceForm.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 1879:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, ".TfW5D,.VV23o{position:relative;color:#d7433d;font-weight:400;font-size:13px;text-align:center;display:block;line-height:1.2;min-height:20px}.VV23o{color:#2c7e07;font-size:15px;font-weight:500}.wZg14>button,.wZg14>input{margin:5px 0}", ""]);

// exports
exports.locals = {
	"root": "_2fxs3",
	"errorMessage": "TfW5D",
	"successMessage": "VV23o",
	"requestForm": "wZg14"
};

/***/ }),

/***/ 1880:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_intl__ = __webpack_require__(474);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(1240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ThanksBlock_css__ = __webpack_require__(1881);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ThanksBlock_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__ThanksBlock_css__);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }








var _ref2 = _jsx('h2', {}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */], {
  id: '\u0421\u043F\u0430\u0441\u0438\u0431\u043E!'
}));

var _ref3 = _jsx('p', {}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */], {
  id: '\u0412\u0430\u0448\u0430 \u0437\u0430\u044F\u0432\u043A\u0430 \u043E\u0442\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u0430!'
}));

var _ref4 = _jsx('p', {}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */], {
  id: '\u0412 \u0431\u043B\u0438\u0436\u0430\u0439\u0448\u0435\u0435 \u0432\u0440\u0435\u043C\u044F \u0441 \u0432\u0430\u043C\u0438 \u0441\u0432\u044F\u0436\u0435\u0442\u0441\u044F \u043C\u0435\u043D\u0435\u0434\u0436\u0435\u0440 \u0430\u0432\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430'
}));

var ThanksBlock = function ThanksBlock(_ref) {
  var ClassName = _ref.ClassName;
  return _jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_4_classnames___default.a(__WEBPACK_IMPORTED_MODULE_5__ThanksBlock_css___default.a.thanksBlock, _defineProperty({}, ClassName, !!ClassName))
  }, void 0, _ref2, _ref3, _ref4);
};

ThanksBlock.defaultProps = {
  ClassName: ''
};

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_1_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_5__ThanksBlock_css___default.a)(ThanksBlock));

/***/ }),

/***/ 1881:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1882);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./ThanksBlock.css", function() {
        content = require("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./ThanksBlock.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 1882:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, "._2fRVv{text-align:center;min-height:248px;padding-top:45px}", ""]);

// exports
exports.locals = {
	"thanksBlock": "_2fRVv"
};

/***/ }),

/***/ 1883:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// CONCATENATED MODULE: ./src/shared/components/AutobookingForm/AutobookingForm.js
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_shared_components_ModalContainer_ModalContainer__ = __webpack_require__(1256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_intl__ = __webpack_require__(474);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shared_actions_advertForm__ = __webpack_require__(484);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_redux__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_shared_hocs_stats_withStatsEvents__ = __webpack_require__(1439);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_redux__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_iframe__ = __webpack_require__(1884);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_iframe___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react_iframe__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_shared_actions_notifications__ = __webpack_require__(475);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_shared_hocs_withOrders__ = __webpack_require__(1396);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }













var isMobile = "desktop" === 'mobile';

var _ref2 = _jsx(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */], {
  id: '\u0417\u0430\u043F\u0438\u0441\u0430\u0442\u044C\u0441\u044F \u043D\u0430 \u0421\u0422\u041E'
});

var AutobookingForm = function (_React$Component) {
  _inherits(AutobookingForm, _React$Component);

  function AutobookingForm() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, AutobookingForm);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = AutobookingForm.__proto__ || Object.getPrototypeOf(AutobookingForm)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      onModal: false,
      anotherReasonText: ''
    }, _this.signUpStoStats = function () {
      var _this$props = _this.props,
          events = _this$props.events,
          id = _this$props.advert.id;

      events.dispatchDealerSignUp(id);
    }, _this.handleSignUpToSto = function (e) {
      e.preventDefault();
      _this.handleChange('testAutobooking');
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(AutobookingForm, [{
    key: 'handleChange',
    value: function handleChange(key, data) {
      var _this2 = this;

      var _props = this.props,
          autobookingId = _props.advert.autobooking_id,
          intl = _props.intl;

      var fun = {
        onModal: function onModal(dat) {
          _this2.setState({ onModal: dat });
        },
        testAutobooking: function testAutobooking() {
          _this2.signUpStoStats();
          _this2.props.action.requestAutobooking({
            callback: function callback() {
              _this2.setState({ onModal: true });
            },
            autobookingId: autobookingId
          }, {
            enqueueNotification: _this2.props.enqueueNotification,
            intl: intl
          });
        }
      };
      if (fun[key]) {
        fun[key](data);
      } else {}
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _props2 = this.props,
          autobookingId = _props2.advert.autobooking_id,
          className = _props2.className,
          locale = _props2.globals.locale;

      if (!autobookingId) {
        return '';
      }
      return _jsx('div', {}, void 0, 'AutobookingForm 112', _jsx(__WEBPACK_IMPORTED_MODULE_0_shared_components_ModalContainer_ModalContainer__["a" /* default */], {
        onClose: function onClose() {
          _this3.handleChange('onModal', false);
        },
        isOpen: this.state.onModal,
        modalCN: ' '
      }, void 0, _jsx('div', {
        style: {
          height: isMobile ? '500px' : '400px',
          width: isMobile ? '420px' : '500px'
        }
      }, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_8_react_iframe___default.a, {
        height: isMobile ? '500px' : '400px',
        width: isMobile ? '420px' : '500px',
        url: 'https://autobooking.com/widgets/order?autocomplete_brand=true&autocomplete_location=true&autocomplete_service=true&height=500px&locale_country=' + (locale === 'ru' ? locale : 'ua') + '-ua&mobile_height=460px&mobile_width=400px&referer_key=DOQLoCkKnLITeqQ5a0dmog&station_id=' + autobookingId + '&view=intable&width=200px'
      }))), _jsx('div', {
        className: className,
        onClick: this.handleSignUpToSto
      }, void 0, _ref2));
    }
  }]);

  return AutobookingForm;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

AutobookingForm.defaultProps = {
  className: '',
  user: {},
  action: {},
  advert: {},
  globals: {},
  loading: false,
  minCustomReasonLength: 4,
  isUpdating: false,
  isRemoval: false
};


var mapStateToProps = function mapStateToProps(_ref3) {
  var globals = _ref3.globals,
      user = _ref3.user.user,
      loading = _ref3.loading;
  return {
    globals: globals,
    user: user,
    enqueueNotification: __WEBPACK_IMPORTED_MODULE_9_shared_actions_notifications__["a" /* enqueueNotification */],
    loading: Boolean(loading.start)
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    action: __WEBPACK_IMPORTED_MODULE_5_redux__["b" /* bindActionCreators */]({ requestAutobooking: __WEBPACK_IMPORTED_MODULE_4_shared_actions_advertForm__["e" /* requestAutobooking */] }, dispatch),
    dispatch: dispatch
  };
};

/* harmony default export */ var AutobookingForm_defaultExport = (__WEBPACK_IMPORTED_MODULE_7_react_redux__["b" /* connect */](mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_10_shared_hocs_withOrders__["a" /* default */](__WEBPACK_IMPORTED_MODULE_6_shared_hocs_stats_withStatsEvents__["a" /* default */](__WEBPACK_IMPORTED_MODULE_3_react_intl__["d" /* injectIntl */](AutobookingForm)))));
// CONCATENATED MODULE: ./src/shared/components/AutobookingForm/AutobookingAdvert.js
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_shared_constants_api__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shared_components_SpareImg__ = __webpack_require__(1790);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_intl__ = __webpack_require__(474);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_shared_components_AntdComponents_Grid_Row_Row__ = __webpack_require__(1408);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_shared_components_AntdComponents_Grid_Col_Col__ = __webpack_require__(1437);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_shared_actions_advertForm__ = __webpack_require__(484);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_redux__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_query_string__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_query_string___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_query_string__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_redux__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_shared_components_Link_Link__ = __webpack_require__(1241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_shared_hocs_withOrders__ = __webpack_require__(1396);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__AutobookingAdvert_css__ = __webpack_require__(1885);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__AutobookingAdvert_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__AutobookingAdvert_css__);
var AutobookingAdvert__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var AutobookingAdvert__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function AutobookingAdvert__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function AutobookingAdvert__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function AutobookingAdvert__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



















var AutobookingAdvert = function (_React$Component) {
  AutobookingAdvert__inherits(AutobookingAdvert, _React$Component);

  function AutobookingAdvert() {
    var _ref;

    var _temp, _this, _ret;

    AutobookingAdvert__classCallCheck(this, AutobookingAdvert);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = AutobookingAdvert__possibleConstructorReturn(this, (_ref = AutobookingAdvert.__proto__ || Object.getPrototypeOf(AutobookingAdvert)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      onModal: false,
      anotherReasonText: ''
    }, _temp), AutobookingAdvert__possibleConstructorReturn(_this, _ret);
  }

  AutobookingAdvert__createClass(AutobookingAdvert, [{
    key: 'handleChange',
    value: function handleChange(key, data) {
      var _this2 = this;

      var fun = {
        onModal: function onModal(dat) {
          _this2.setState({ onModal: dat });
        },
        testAutobooking: function testAutobooking() {}
      };
      if (fun[key]) {
        fun[key](data);
      } else {}
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          _props$advert = _props.advert,
          _props$advert$make = _props$advert.make,
          make = _props$advert$make === undefined ? { title: '' } : _props$advert$make,
          _props$advert$model = _props$advert.model,
          model = _props$advert$model === undefined ? { title: '' } : _props$advert$model,
          _props$searchForm$res = _props.searchForm.results.topFirms,
          topFirms = _props$searchForm$res === undefined ? [] : _props$searchForm$res,
          _props$partsForm$voca = _props.partsForm.vocabulary,
          url = _props$partsForm$voca.url,
          _props$partsForm$voca2 = _props$partsForm$voca.queryobj;
      _props$partsForm$voca2 = _props$partsForm$voca2 === undefined ? {} : _props$partsForm$voca2;
      var location = _props$partsForm$voca2.location,
          makes = _props$partsForm$voca2.makes,
          titleMessage = _props.title;

      if (!topFirms || !topFirms.length) return '';

      return AutobookingAdvert__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_14__AutobookingAdvert_css___default.a.root
      }, void 0, AutobookingAdvert__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_14__AutobookingAdvert_css___default.a.title
      }, void 0, AutobookingAdvert__jsx(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */], {
        id: titleMessage,
        values: { make: (make.title ? make.title : '') + ' ' + (model.title ? model.title : '') }
      })), topFirms.map(function (_ref2) {
        var _ref2$title = _ref2.title,
            title = _ref2$title === undefined ? '' : _ref2$title,
            _ref2$logo = _ref2.logo,
            logo = _ref2$logo === undefined ? '' : _ref2$logo,
            slug = _ref2.slug,
            id = _ref2.id;
        return AutobookingAdvert__jsx('div', {
          className: __WEBPACK_IMPORTED_MODULE_14__AutobookingAdvert_css___default.a.spare
        }, id, AutobookingAdvert__jsx(__WEBPACK_IMPORTED_MODULE_6_shared_components_AntdComponents_Grid_Row_Row__["a" /* default */], {
          style: { width: '100%' }
        }, void 0, AutobookingAdvert__jsx(__WEBPACK_IMPORTED_MODULE_7_shared_components_AntdComponents_Grid_Col_Col__["a" /* default */], {
          span: 8
        }, void 0, AutobookingAdvert__jsx(__WEBPACK_IMPORTED_MODULE_12_shared_components_Link_Link__["a" /* default */], {
          to: __WEBPACK_IMPORTED_MODULE_1_shared_constants_api__["a" /* default */].KATALOG_KOMPANIY(slug)
        }, void 0, AutobookingAdvert__jsx(__WEBPACK_IMPORTED_MODULE_2_shared_components_SpareImg__["a" /* default */], {
          photos: [{ image: logo }]
        }))), AutobookingAdvert__jsx(__WEBPACK_IMPORTED_MODULE_7_shared_components_AntdComponents_Grid_Col_Col__["a" /* default */], {
          span: 16
        }, void 0, AutobookingAdvert__jsx('div', {}, void 0, title && AutobookingAdvert__jsx(__WEBPACK_IMPORTED_MODULE_12_shared_components_Link_Link__["a" /* default */], {
          className: __WEBPACK_IMPORTED_MODULE_14__AutobookingAdvert_css___default.a.spareTitle,
          to: __WEBPACK_IMPORTED_MODULE_1_shared_constants_api__["a" /* default */].KATALOG_KOMPANIY(slug)
        }, void 0, title)))));
      }), AutobookingAdvert__jsx(__WEBPACK_IMPORTED_MODULE_12_shared_components_Link_Link__["a" /* default */], {
        className: __WEBPACK_IMPORTED_MODULE_14__AutobookingAdvert_css___default.a.allSpares,
        to: url + '/?' + __WEBPACK_IMPORTED_MODULE_10_query_string___default.a.stringify({ location: location, makes: makes })
      }, void 0, AutobookingAdvert__jsx(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */], {
        id: '\u0412\u0441\u0435 \u0421\u0422\u041E \u0434\u043B\u044F {make}',
        values: { make: make.title + ' ' + model.title }
      })));
    }
  }]);

  return AutobookingAdvert;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

AutobookingAdvert.defaultProps = {
  title: '',
  user: {},
  searchForm: {},
  partsForm: {},
  action: {},
  advert: {},
  globals: {},
  loading: false,
  minCustomReasonLength: 4,
  isUpdating: false,
  isRemoval: false
};


/* harmony default export */ var AutobookingAdvert_defaultExport = (__WEBPACK_IMPORTED_MODULE_11_react_redux__["b" /* connect */](function (_ref3) {
  var searchForm = _ref3.searchForm,
      partsForm = _ref3.partsForm;
  return {
    searchForm: searchForm,
    partsForm: partsForm
  };
}, function (dispatch) {
  return {
    action: __WEBPACK_IMPORTED_MODULE_9_redux__["b" /* bindActionCreators */]({ requestAutobooking: __WEBPACK_IMPORTED_MODULE_8_shared_actions_advertForm__["e" /* requestAutobooking */] }, dispatch),
    dispatch: dispatch
  };
})(__WEBPACK_IMPORTED_MODULE_13_shared_hocs_withOrders__["a" /* default */](__WEBPACK_IMPORTED_MODULE_4_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_14__AutobookingAdvert_css___default.a)(__WEBPACK_IMPORTED_MODULE_5_react_intl__["d" /* injectIntl */](AutobookingAdvert)))));
// CONCATENATED MODULE: ./src/shared/components/AutobookingForm/index.js
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return AutobookingForm_AutobookingForm; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AutobookingForm_AutobookingAdvert; });



var AutobookingForm_AutobookingForm = AutobookingForm_defaultExport;
var AutobookingForm_AutobookingAdvert = AutobookingAdvert_defaultExport;

/***/ }),

/***/ 1884:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", { value: true });var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}var React = __webpack_require__(11);var PureComponent = React.PureComponent;var PropTypes = __webpack_require__(131);var objectAssign = __webpack_require__(188);function noop() {}var Iframe = function (_PureComponent) {
  _inherits(Iframe, _PureComponent);function Iframe() {
    _classCallCheck(this, Iframe);return _possibleConstructorReturn(this, (Iframe.__proto__ || Object.getPrototypeOf(Iframe)).apply(this, arguments));
  }_createClass(Iframe, [{ key: "render", value: function render() {
      var props = { ref: "iframe", frameBorder: "0", src: this.props.url, target: "_parent", allowFullScreen: this.props.allowFullScreen || false, style: objectAssign({}, { position: this.props.position || "absolute", display: this.props.display || "block", height: this.props.height || "100%", width: this.props.width || "100%" }, this.props.styles || {}), height: this.props.height || "100%", name: this.props.name || "", width: this.props.width || "100%", onLoad: this.props.onLoad || noop, onMouseOver: this.props.onMouseOver || noop, onMouseOut: this.props.onMouseOut || noop };return React.createElement("iframe", objectAssign(props, this.props.id ? { id: this.props.id } : {}, this.props.sandbox ? { sandbox: this.props.sandbox } : {}, this.props.allow ? { allow: this.props.allow } : {}, this.props.className ? { className: this.props.className } : {}));
    } }]);return Iframe;
}(PureComponent);exports.default = Iframe;

/***/ }),

/***/ 1885:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1886);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./AutobookingAdvert.css", function() {
        content = require("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./AutobookingAdvert.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 1886:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, "._3QxWY{position:relative;font-weight:400;padding:8px 18px 10px}.yLFXk{font-size:17px;font-weight:700;margin:0 0 12px}._2jDVd{border-top:1px solid #ededed;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;min-height:55px;padding:8px 0}._2jDVd:first-of-type{border:none}._3quCg{font-size:14px;font-weight:700;padding-bottom:6px;display:block}._3quCg,.tcngL{color:#000;text-decoration:none}.tcngL{position:relative;display:inline-block;border:1px solid #ccc;border-radius:2px;font-size:12px;font-weight:400;text-align:center;padding:6px 10px;margin-top:15px;cursor:pointer}.tcngL:hover{border:1px solid #2196f3}._2jDVd:hover ._3quCg{color:#e73232}", ""]);

// exports
exports.locals = {
	"root": "_3QxWY",
	"title": "yLFXk",
	"spare": "_2jDVd",
	"spareTitle": "_3quCg",
	"allSpares": "tcngL"
};

/***/ }),

/***/ 1887:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// CONCATENATED MODULE: ./src/desktop/components/SearchPanel/SaveSearch/SaveSearch.js
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shared_components_Link__ = __webpack_require__(1241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_hocs_withTranslate__ = __webpack_require__(1242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shared_components_SavedSearchItem_SavedSearchItem__ = __webpack_require__(1652);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_shared_hocs_withSubscriptionSearch__ = __webpack_require__(1701);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_addons_css_transition_group__ = __webpack_require__(1273);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_addons_css_transition_group___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_addons_css_transition_group__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_shared_assets_images_save_search_png__ = __webpack_require__(1888);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_shared_assets_images_save_search_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_shared_assets_images_save_search_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_onclickoutside__ = __webpack_require__(1276);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_shared_hocs_withFetch__ = __webpack_require__(1244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__SaveSearch_css__ = __webpack_require__(1889);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__SaveSearch_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__SaveSearch_css__);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }














var SaveSearch = function (_React$Component) {
  _inherits(SaveSearch, _React$Component);

  function SaveSearch() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, SaveSearch);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SaveSearch.__proto__ || Object.getPrototypeOf(SaveSearch)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      isPopupOpened: false,
      editableSearch: null
    }, _this.togglePopup = function () {
      _this.setState(function (_ref2) {
        var isPopupOpened = _ref2.isPopupOpened;
        return { isPopupOpened: !isPopupOpened };
      });
    }, _this.handleClickOutside = function () {
      if (_this.props.savedSearch || _this.state.editableSearch) {
        _this.setState({ isPopupOpened: false, editableSearch: null });
      }
    }, _this.saveSearchAndToggle = function () {
      _this.togglePopup();
      _this.props.saveSearch();
    }, _this.editSearch = function () {
      var verifySavedSearch = _this.props.verifySavedSearch;

      _this.setState({ editableSearch: verifySavedSearch() });

      _this.togglePopup();
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(SaveSearch, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          verifySavedSearch = _props.verifySavedSearch,
          savedSearch = _props.savedSearch,
          setSavedSearchToState = _props.setSavedSearchToState,
          hideSavedSearch = _props.hideSavedSearch,
          t = _props.t;
      var _state = this.state,
          isPopupOpened = _state.isPopupOpened,
          editableSearch = _state.editableSearch;

      var searchItem = savedSearch || editableSearch;

      return _jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_11__SaveSearch_css___default.a.root
      }, void 0, verifySavedSearch() ? _jsx(__WEBPACK_IMPORTED_MODULE_2_shared_components_Link__["a" /* default */], {
        className: __WEBPACK_IMPORTED_MODULE_11__SaveSearch_css___default.a.content,
        onClick: this.editSearch
      }, void 0, _jsx('img', {
        className: __WEBPACK_IMPORTED_MODULE_11__SaveSearch_css___default.a.icon,
        src: __WEBPACK_IMPORTED_MODULE_7_shared_assets_images_save_search_png___default.a,
        alt: '',
        height: 22
      }), t('Подписка оформлена')) : _jsx(__WEBPACK_IMPORTED_MODULE_2_shared_components_Link__["a" /* default */], {
        className: __WEBPACK_IMPORTED_MODULE_11__SaveSearch_css___default.a.content,
        onClick: this.saveSearchAndToggle,
        'data-lens-event': 'saveSearchClick'
      }, void 0, _jsx('img', {
        className: __WEBPACK_IMPORTED_MODULE_11__SaveSearch_css___default.a.icon,
        src: __WEBPACK_IMPORTED_MODULE_7_shared_assets_images_save_search_png___default.a,
        alt: '',
        height: 22
      }), t('Подписка на поиск')), _jsx(__WEBPACK_IMPORTED_MODULE_6_react_addons_css_transition_group___default.a, {
        transitionName: 'fadeUp',
        transitionEnterTimeout: 100,
        transitionLeaveTimeout: 100
      }, void 0, isPopupOpened && searchItem && _jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_11__SaveSearch_css___default.a.popup
      }, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_4_shared_components_SavedSearchItem_SavedSearchItem__["a" /* default */], {
        togglePopup: function togglePopup() {
          hideSavedSearch();
          _this2.togglePopup();
        },
        searchItem: searchItem,
        updateStateItemPeriod: setSavedSearchToState
      }))));
    }
  }]);

  return SaveSearch;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

SaveSearch.defaultProps = {
  savedSearch: null
};


/* harmony default export */ var SaveSearch_defaultExport = (__WEBPACK_IMPORTED_MODULE_8_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_11__SaveSearch_css___default.a)(__WEBPACK_IMPORTED_MODULE_10_shared_hocs_withFetch__["a" /* withFetch */](__WEBPACK_IMPORTED_MODULE_3_shared_hocs_withTranslate__["a" /* withTranslate */](__WEBPACK_IMPORTED_MODULE_5_shared_hocs_withSubscriptionSearch__["a" /* default */](__WEBPACK_IMPORTED_MODULE_9_react_onclickoutside__["a" /* default */](SaveSearch))))));
// CONCATENATED MODULE: ./src/desktop/components/SearchPanel/SearchFormBottom/SearchFormBottom.js
/* harmony import */ var SearchFormBottom___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var SearchFormBottom___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(SearchFormBottom___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(1240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shared_components_Link_Link__ = __webpack_require__(1241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_intl__ = __webpack_require__(474);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_shared_assets_images_down_arrow_angle_svg__ = __webpack_require__(1723);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_shared_assets_images_down_arrow_angle_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_shared_assets_images_down_arrow_angle_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_shared_assets_images_up_arrow_angle_svg__ = __webpack_require__(1561);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_shared_assets_images_up_arrow_angle_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_shared_assets_images_up_arrow_angle_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_shared_assets_images_cross_black_svg__ = __webpack_require__(1724);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_shared_assets_images_cross_black_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_shared_assets_images_cross_black_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_shared_modules_googletag_googletag__ = __webpack_require__(517);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_shared_helpers_common__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__SearchFormBottom_css__ = __webpack_require__(1891);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__SearchFormBottom_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__SearchFormBottom_css__);
var SearchFormBottom__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var SearchFormBottom__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function SearchFormBottom__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function SearchFormBottom__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function SearchFormBottom__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
















var _ref2 = SearchFormBottom__jsx(SaveSearch_defaultExport, {
  isFirstRender: true
});

var _ref3 = SearchFormBottom__jsx(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */], {
  id: '\u041E\u0447\u0438\u0441\u0442\u0438\u0442\u044C'
});

var _ref4 = SearchFormBottom__jsx(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */], {
  id: '\u0412\u0441\u0435 \u043F\u0430\u0440\u0430\u043C\u0435\u0442\u0440\u044B'
});

var _ref5 = SearchFormBottom__jsx('img', {
  src: __WEBPACK_IMPORTED_MODULE_6_shared_assets_images_down_arrow_angle_svg___default.a,
  width: '10',
  alt: ''
});

var _ref6 = SearchFormBottom__jsx(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */], {
  id: '\u0421\u0432\u0435\u0440\u043D\u0443\u0442\u044C'
});

var _ref7 = SearchFormBottom__jsx('img', {
  src: __WEBPACK_IMPORTED_MODULE_8_shared_assets_images_up_arrow_angle_svg___default.a,
  width: '10',
  alt: ''
});

var _ref8 = SearchFormBottom__jsx(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */], {
  id: '\u041F\u043E\u043A\u0430\u0437\u0430\u0442\u044C'
});

var _ref9 = SearchFormBottom__jsx(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */], {
  id: '\u041D\u0435 \u043D\u0430\u0439\u0434\u0435\u043D\u043E'
});

var SearchFormBottom = function (_React$Component) {
  SearchFormBottom__inherits(SearchFormBottom, _React$Component);

  function SearchFormBottom() {
    var _ref;

    var _temp, _this, _ret;

    SearchFormBottom__classCallCheck(this, SearchFormBottom);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = SearchFormBottom__possibleConstructorReturn(this, (_ref = SearchFormBottom.__proto__ || Object.getPrototypeOf(SearchFormBottom)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      slots: [{
        dfpNetworkId: '78780000'
      }]
    }, _this.handleChange = function (key, data) {
      var fun = {
        refresh: function refresh() {
          __WEBPACK_IMPORTED_MODULE_10_shared_modules_googletag_googletag__["a" /* default */]({
            googletagRefresh: true
          });
        }
      };
      if (fun[key]) {
        fun[key](data);
      } else {}
    }, _temp), SearchFormBottom__possibleConstructorReturn(_this, _ret);
  }

  SearchFormBottom__createClass(SearchFormBottom, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          collapsed = _props.collapsed,
          handleClick = _props.handleClick,
          expandable = _props.expandable,
          searchable = _props.searchable,
          count = _props.count,
          url = _props.url,
          handleClearForm = _props.handleClearForm,
          cardTypes = _props.cardTypes,
          intl = _props.intl,
          onClickBottom = _props.onClickBottom,
          loading = _props.loading;


      return SearchFormBottom__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_13__SearchFormBottom_css___default.a.root,
        onClick: function onClick() {
          onClickBottom();
          _this2.handleChange('refresh');
        }
      }, void 0, SearchFormBottom__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_13__SearchFormBottom_css___default.a.flexRow
      }, void 0, searchable && SearchFormBottom__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_13__SearchFormBottom_css___default.a.left
      }, void 0, _ref2), SearchFormBottom__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_13__SearchFormBottom_css___default.a.innerLeft
      }, void 0, SearchFormBottom__jsx('button', {
        className: __WEBPACK_IMPORTED_MODULE_13__SearchFormBottom_css___default.a.clear,
        onClick: handleClearForm
      }, void 0, SearchFormBottom__jsx('img', {
        src: __WEBPACK_IMPORTED_MODULE_9_shared_assets_images_cross_black_svg___default.a,
        width: 12,
        className: __WEBPACK_IMPORTED_MODULE_13__SearchFormBottom_css___default.a.imgClear,
        alt: intl.formatMessage({ id: 'Сбросить фильтры' })
      }), _ref3)), collapsed && expandable && SearchFormBottom__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_13__SearchFormBottom_css___default.a.innerRight,
        onClick: handleClick
      }, void 0, _ref4, ' ', _ref5), !collapsed && expandable && SearchFormBottom__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_13__SearchFormBottom_css___default.a.innerRight,
        onClick: handleClick
      }, void 0, _ref6, ' ', _ref7), SearchFormBottom__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_13__SearchFormBottom_css___default.a.right
      }, void 0, SearchFormBottom__jsx('span', {}, void 0, count > 0 && SearchFormBottom__jsx(__WEBPACK_IMPORTED_MODULE_4_shared_components_Link_Link__["a" /* default */], {
        rel: 'nofollow',
        to: url,
        className: __WEBPACK_IMPORTED_MODULE_13__SearchFormBottom_css___default.a.searchBtn,
        'data-lens-event': 'searchClick'
      }, void 0, _ref8, ' ', __WEBPACK_IMPORTED_MODULE_11_shared_helpers_common__["k" /* numberWithSpaces */](count || 0), ' ', cardTypes), count === 0 && SearchFormBottom__jsx('span', {
        className: __WEBPACK_IMPORTED_MODULE_1_classnames___default.a(__WEBPACK_IMPORTED_MODULE_13__SearchFormBottom_css___default.a.searchBtn, __WEBPACK_IMPORTED_MODULE_13__SearchFormBottom_css___default.a.disabled)
      }, void 0, _ref9, ' ', cardTypes)))));
    }
  }]);

  return SearchFormBottom;
}(SearchFormBottom___WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

SearchFormBottom.defaultProps = {
  loading: false,
  count: 0,
  onClickBottom: function onClickBottom() {}
};


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_7_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_13__SearchFormBottom_css___default.a)(__WEBPACK_IMPORTED_MODULE_3_react_redux__["b" /* connect */](function (_ref10) {
  var _ref10$loading = _ref10.loading;
  _ref10$loading = _ref10$loading === undefined ? {} : _ref10$loading;
  var start = _ref10$loading.start;
  return { loading: Boolean(start) };
})(__WEBPACK_IMPORTED_MODULE_5_react_intl__["d" /* injectIntl */](SearchFormBottom))));

/***/ }),

/***/ 1888:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "64cc604e.png";

/***/ }),

/***/ 1889:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1890);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./SaveSearch.css", function() {
        content = require("!!../../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./SaveSearch.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 1890:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, ".mdcG2{position:relative;cursor:pointer;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;padding-right:8px}._3rBvr{color:inherit;text-decoration:none}._3rBvr :hover{color:#000;opacity:.7}._3FCtd{position:absolute;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;top:100%;width:290px;padding:10px;background:#fff;-webkit-box-shadow:-1px 14px 28px -14px rgba(0,0,0,.75);box-shadow:-1px 14px 28px -14px rgba(0,0,0,.75)}._3F8sF{vertical-align:text-bottom}._3FCtd .Select{width:100%}._3FCtd .Select-control{border:1px solid #ccc;border-radius:2px;height:30px;font-size:13px;line-height:1em}._3FCtd .Select--single>.Select-control .Select-value{line-height:30px}", ""]);

// exports
exports.locals = {
	"root": "mdcG2",
	"content": "_3rBvr",
	"popup": "_3FCtd",
	"icon": "_3F8sF"
};

/***/ }),

/***/ 1891:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1892);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./SearchFormBottom.css", function() {
        content = require("!!../../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./SearchFormBottom.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 1892:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, "._2rzug{position:relative;padding:2px 0}._1847W{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-flow:row nowrap;flex-flow:row nowrap;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}.sIQKs{-webkit-box-flex:0;-ms-flex:0 0 auto;flex:0 0 auto;width:calc(33.33333% - 10px);margin-right:10px;font-size:13px;text-align:left;line-height:28px;padding-left:2px}._25ctC{vertical-align:-6px}._1qwVx{-webkit-box-flex:1;-ms-flex:1 1 auto;flex:1 1 auto;width:calc(16.66667% - 5px);margin-right:10px;line-height:28px;font-size:13px;text-align:left;padding-left:4px}._1GjDs{position:relative;background-color:transparent;border:none;cursor:pointer;outline:none;-webkit-appearance:none;-moz-appearance:none;appearance:none;opacity:.6;margin-left:0;padding-left:0;-webkit-transition:all .1s ease-out;-o-transition:all .1s ease-out;transition:all .1s ease-out}._1GjDs:hover{opacity:1}._3hPdC{position:relative;top:-2px}._1RZ2Z,._3hPdC{margin-right:10px}._1RZ2Z{-webkit-box-flex:1;-ms-flex:1 1 auto;flex:1 1 auto;width:calc(16.66667% - 5px);line-height:28px;font-size:13px;cursor:pointer}._3kzrC{-webkit-box-flex:0;-ms-flex:0 0 auto;flex:0 0 auto;width:calc(33.33333% - 10px);margin-right:10px}._3kzrC,.tPbet{position:relative}.tPbet{background-color:#ffd906;color:#000;font-weight:600;border:0;padding:8px 7px;border-radius:2px;width:100%;font-size:14px;cursor:pointer;display:block;text-decoration:none;text-align:center;overflow:hidden;white-space:nowrap;-o-text-overflow:ellipsis;text-overflow:ellipsis;-webkit-transition:all .1s ease-out;-o-transition:all .1s ease-out;transition:all .1s ease-out;line-height:1.15}.tPbet:hover{background-color:#ffc107;color:#000}.tPbet._1UDnD{cursor:default;color:#888;background-color:#f1f1f1}.MIIfz{position:absolute;top:50%;left:50%;-webkit-transform:translate(-50%,-50%);transform:translate(-50%,-50%);padding:0}.FNZbx{border:3px solid #ffd906;border-top-color:#000;border-radius:50%;width:20px;height:20px;-webkit-animation:_3AhCp 2s linear infinite;animation:_3AhCp 2s linear infinite}@-webkit-keyframes _3AhCp{0%{-webkit-transform:rotate(0deg);transform:rotate(0deg)}to{-webkit-transform:rotate(1turn);transform:rotate(1turn)}}@keyframes _3AhCp{0%{-webkit-transform:rotate(0deg);transform:rotate(0deg)}to{-webkit-transform:rotate(1turn);transform:rotate(1turn)}}", ""]);

// exports
exports.locals = {
	"root": "_2rzug",
	"flexRow": "_1847W",
	"left": "sIQKs",
	"saveSearchIcon": "_25ctC",
	"innerLeft": "_1qwVx",
	"clear": "_1GjDs",
	"imgClear": "_3hPdC",
	"innerRight": "_1RZ2Z",
	"right": "_3kzrC",
	"searchBtn": "tPbet",
	"disabled": "_1UDnD",
	"buttonLoader": "MIIfz",
	"loader": "FNZbx",
	"spin": "_3AhCp"
};

/***/ }),

/***/ 1967:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// CONCATENATED MODULE: ./src/shared/components/Micromarking/Micromarking.js
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_intl__ = __webpack_require__(474);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_shared_modules__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_shared_components_BreadcrumbsLinks_BreadcrumbsLinks__ = __webpack_require__(1857);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_shared_helpers_strings__ = __webpack_require__(1463);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Micromarking_css__ = __webpack_require__(1968);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Micromarking_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__Micromarking_css__);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();


// import cx from 'classnames';





// import Link from 'shared/components/Link';




// import JsonLdApplication from 'shared/components/JsonLdApplication/JsonLdApplication';



// const AB_PATH = 'https://ab.ua';

// const SpanLink = ({ text, index, intl }) =>
//   <span>
//     {index === 0
//       ? replaceToUpperCase(intl.formatMessage({ id: text }))
//       : intl.formatMessage({ id: text })}
//   </span>;

// SpanLink.propTypes = {
//   text: PropTypes.string.isRequired,
//   index: PropTypes.number.isRequired,
//   intl: intlShape.isRequired,
// };

var _ref2 = _jsx('meta', {
  property: 'priceCurrency',
  content: 'USD'
});

function Micromarking(props) {
  var seoSearchUrlResponse = props.globals.seoSearchUrlResponse,
      currentPath = props.history.currentPath,
      intl = props.intl,
      title = props.title;
  var _seoSearchUrlResponse = seoSearchUrlResponse.usd_price,
      usdPrice = _seoSearchUrlResponse === undefined ? null : _seoSearchUrlResponse,
      _seoSearchUrlResponse2 = seoSearchUrlResponse.offers_count,
      offersCount = _seoSearchUrlResponse2 === undefined ? null : _seoSearchUrlResponse2,
      newCat = seoSearchUrlResponse.newness_category;


  var urlArr = currentPath.split('/').filter(Boolean).filter(function (a) {
    return !/\?/.test(a);
  });
  var obj = {
    gruzovye: 'gruzovye',
    avtobus: 'avtobus',
    pritsepy: 'pritsepy',
    spetstehnika: 'spetstehnika',

    zapchasti: 'zapchasti',
    avtosalony: 'avtosalony',
    'katalog-kompaniy': 'katalog-kompaniy'
  };
  // const hasQuery = !!currentPath.split('').find(item => item === '?');

  var urlData = [['/', 'Автобазар', 'avtobazar']];
  var locale = intl.formatMessage({ id: 'locale' });

  if (locale === 'ru') urlArr.unshift('ru');

  var avtoTitle = newCat === 'new' ? 'Новые авто' : 'БУ авто';
  var setUrls = {};
  Object.keys(seoSearchUrlResponse).map(function (a) {
    for (var a1 = 0, b1 = urlArr.length; a1 < b1; a1 += 1) {
      // eslint-disable-next-line no-continue
      if (setUrls[urlArr[a1]]) continue;
      if (seoSearchUrlResponse[a] && urlArr[a1] === seoSearchUrlResponse[a].slug) {
        if (typeof seoSearchUrlResponse[a].title === 'string' || typeof seoSearchUrlResponse[a].name === 'string') {
          var linkTitle = urlArr[a1] === 'avto' ? avtoTitle : seoSearchUrlResponse[a].title || seoSearchUrlResponse[a].name;
          var url = urlArr[a1] === 'avto' && newCat === 'new' ? urlArr[a1 + 1] : urlArr[a1];
          urlData.push([__WEBPACK_IMPORTED_MODULE_5_shared_modules__["h" /* normalizeLink */](url, { url: currentPath, defaul: '/' + urlArr[0] + '/' }), linkTitle, url]);
          setUrls[urlArr[a1]] = 1;
        }
      } else if (obj[urlArr[a1]]) {
        var titleUrl = '';
        if (urlArr[a1] === obj.zapchasti) {
          titleUrl = intl.formatMessage({ id: 'avtozapchasti' });
        } else {
          titleUrl = intl.formatMessage({ id: urlArr[a1] });
        }

        urlData.push([__WEBPACK_IMPORTED_MODULE_5_shared_modules__["h" /* normalizeLink */](urlArr[a1], { url: currentPath, defaul: '/' + urlArr[0] + '/' }), __WEBPACK_IMPORTED_MODULE_7_shared_helpers_strings__["c" /* uppercaseFirst */](titleUrl), urlArr[a1]]);
        setUrls[urlArr[a1]] = 1;
      }
    }
    return '';
  });
  // console.log('urlData >>> ', urlData);
  // const breadcrumbItemListEl = urlData.map((a, b) => ({
  //   '@type': 'ListItem',
  //   position: b + 1,
  //   item: {
  //     '@id': `${AB_PATH}${a[0]}/`,
  //     name:
  //       b === 0
  //         ? replaceToUpperCase(intl.formatMessage({ id: a[1] }))
  //         : intl.formatMessage({ id: a[1] }),
  //   },
  // }));

  // const breadcrumbListLd = {
  //   '@context': 'http://schema.org',
  //   '@type': 'BreadcrumbList',
  //   itemListElement: breadcrumbItemListEl,
  // };

  return _jsx('div', {}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_6_shared_components_BreadcrumbsLinks_BreadcrumbsLinks__["a" /* default */], {
    links: urlData
  }), usdPrice && _jsx('div', {
    vocab: 'https://schema.org/',
    'typeof': 'Product',
    className: __WEBPACK_IMPORTED_MODULE_8__Micromarking_css___default.a.displayNone
  }, void 0, _jsx('span', {
    property: 'name'
  }, void 0, title), _jsx('span', {
    property: 'offers',
    'typeof': 'AggregateOffer'
  }, void 0, _jsx('span', {
    property: 'offerCount'
  }, void 0, offersCount), '\u041E\u0442 ', _jsx('span', {
    property: 'lowPrice'
  }, void 0, usdPrice.min), '$ \u0434\u043E', ' ', _jsx('span', {
    property: 'highPrice'
  }, void 0, usdPrice.max), '$', _ref2)));
}

Micromarking.defaultProps = {
  history: {
    currentPath: ''
  },
  globals: {
    seoSearchUrlResponse: {}
  }
};


var mapStateToProps = function mapStateToProps(_ref) {
  var history = _ref.history,
      globals = _ref.globals;
  return { history: history, globals: globals };
};

/* harmony default export */ var Micromarking_defaultExport = (__WEBPACK_IMPORTED_MODULE_4_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_8__Micromarking_css___default.a)(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */](mapStateToProps)(__WEBPACK_IMPORTED_MODULE_3_react_intl__["d" /* injectIntl */](Micromarking))));
// CONCATENATED MODULE: ./src/desktop/components/PageTitle/PageTitle.js
/* harmony import */ var PageTitle___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var PageTitle___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(PageTitle___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var PageTitle___WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var PageTitle___WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(PageTitle___WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__PageTitle_css__ = __webpack_require__(1970);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__PageTitle_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__PageTitle_css__);
var PageTitle__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();









function PageTitle(props) {
  var title = props.title;


  return PageTitle__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_4__PageTitle_css___default.a.root
  }, void 0, PageTitle__jsx('h1', {
    className: __WEBPACK_IMPORTED_MODULE_4__PageTitle_css___default.a.h1
  }, void 0, title), PageTitle__jsx(Micromarking_defaultExport, {
    title: title
  }));
}

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_4__PageTitle_css___default.a)(PageTitle));

/***/ }),

/***/ 1968:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1969);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./Micromarking.css", function() {
        content = require("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./Micromarking.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 1969:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, "._1wDc5{display:none}", ""]);

// exports
exports.locals = {
	"displayNone": "_1wDc5"
};

/***/ }),

/***/ 1970:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1971);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./PageTitle.css", function() {
        content = require("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./PageTitle.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 1971:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, "._2fSwk{position:relative;background-color:#fff;border-bottom:1px solid #e0e0e0;padding:10px 15px}._2fSwk a:not([href]){color:inherit}._2ueP9{margin:0;position:relative;font-size:24px;color:#000;font-weight:400}", ""]);

// exports
exports.locals = {
	"root": "_2fSwk",
	"h1": "_2ueP9"
};

/***/ }),

/***/ 1972:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();



var _ref = _jsx("svg", {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, void 0, _jsx("g", {
  clipPath: "url(#clip0)"
}, void 0, _jsx("path", {
  d: "M19.4152 0.000610352H16.107C15.9519 0.000610352 15.8032 0.0622509 15.6935 0.171899L8.32957 7.53579C7.19485 6.78528 5.64794 6.90923 4.6495 7.9077L0.514276 12.0429C-0.171425 12.7286 -0.171425 13.8383 0.514276 14.524L5.47653 19.4863C6.16067 20.1703 7.27368 20.1702 7.95762 19.4863L12.0929 15.3511C13.1084 14.3357 13.2074 12.7861 12.4637 11.6684L13.203 10.9214C13.3114 10.8118 13.3722 10.6641 13.3722 10.51V9.43466H14.453C14.6073 9.43466 14.7554 9.37364 14.865 9.26489L15.692 8.44388C15.8026 8.33407 15.8648 8.1847 15.8648 8.02884V6.97845H16.934C17.0894 6.97845 17.2384 6.91661 17.3482 6.80661L18.1918 5.96068C18.3012 5.85103 18.3626 5.70255 18.3626 5.54771V4.4833H19.4152C19.7382 4.4833 20 4.22146 20 3.89849V0.585414C20 0.262446 19.7381 0.000610352 19.4152 0.000610352ZM11.2658 14.5241L7.13063 18.6592C6.90262 18.8873 6.53165 18.8873 6.3036 18.6592L1.34131 13.697C1.11271 13.4684 1.11275 13.0986 1.34131 12.87L5.47653 8.73473C6.16055 8.05071 7.2736 8.05067 7.95766 8.73473L11.2659 12.0429C11.9515 12.7286 11.9516 13.8383 11.2658 14.5241ZM18.8303 3.31361H17.7777C17.4547 3.31361 17.1929 3.57545 17.1929 3.89842V5.30587L16.6913 5.80876H15.28C14.957 5.80876 14.6991 6.0706 14.6991 6.39357V7.78524L14.2119 8.26493H12.7873C12.4643 8.26493 12.2025 8.52677 12.2025 8.84973V10.2695L11.6772 10.8002L9.1982 8.32118L16.3492 1.16631H18.8303V3.31361H18.8303Z",
  fill: "black"
}), _jsx("path", {
  d: "M7.95683 13.697L6.30277 12.0429C5.61871 11.3589 4.50566 11.3589 3.82164 12.0429C3.13758 12.727 3.13758 13.84 3.82164 14.524L5.47574 16.1781C6.15972 16.8621 7.27281 16.8621 7.95683 16.1781C8.64085 15.4941 8.64085 14.381 7.95683 13.697ZM7.12976 15.3511C6.90171 15.5791 6.53074 15.5791 6.30273 15.3511L4.64863 13.697C4.42062 13.469 4.42062 13.098 4.64867 12.87C4.87672 12.642 5.24769 12.642 5.4757 12.87L7.12976 14.5241C7.35773 14.7521 7.35773 15.1231 7.12976 15.3511Z",
  fill: "black"
})), _jsx("defs", {}, void 0, _jsx("clipPath", {
  id: "clip0"
}, void 0, _jsx("rect", {
  width: "20",
  height: "20",
  fill: "white"
}))));

var TradeIn = function TradeIn() {
  return _ref;
};

/* harmony default export */ __webpack_exports__["a"] = (TradeIn);

/***/ }),

/***/ 1973:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();



var _ref = _jsx("svg", {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, void 0, _jsx("path", {
  d: "M10 0C4.4934 0 0 4.4941 0 10C0 15.5066 4.4941 20 10 20C15.5066 20 20 15.5059 20 10C20 4.49336 15.5059 0 10 0ZM10 18.8281C5.13215 18.8281 1.17188 14.8679 1.17188 10C1.17188 5.13215 5.13215 1.17188 10 1.17188C14.8679 1.17188 18.8281 5.13215 18.8281 10C18.8281 14.8679 14.8679 18.8281 10 18.8281Z",
  fill: "black"
}), _jsx("path", {
  d: "M10 2.34375C5.80715 2.34375 2.34375 5.78238 2.34375 10C2.34375 14.2004 5.7909 17.6562 10 17.6562C14.2051 17.6562 17.6562 14.2054 17.6562 10C17.6562 5.77773 14.1885 2.34375 10 2.34375ZM10 3.51562C12.4918 3.51562 14.6594 4.92859 15.7447 6.9952C14.2962 6.45676 12.2516 5.89844 10 5.89844C7.74836 5.89844 5.70383 6.45676 4.25531 6.9952C5.34062 4.92859 7.50824 3.51562 10 3.51562ZM3.85215 12.063L4.34699 12.1337C6.16012 12.3927 7.60734 13.8399 7.86633 15.653L7.93703 16.1479C6.01813 15.5022 4.49773 13.9818 3.85215 12.063ZM12.063 16.1479L12.1337 15.653C12.3927 13.8399 13.8399 12.3927 15.653 12.1337L16.1479 12.063C15.5023 13.9818 13.9819 15.5022 12.063 16.1479ZM15.4873 10.9736C13.1619 11.3057 11.3057 13.1619 10.9736 15.4873L10.8388 16.4302C10.5641 16.4658 10.2842 16.4844 10 16.4844C9.71578 16.4844 9.43586 16.4658 9.16117 16.4302L9.02645 15.4873C8.69426 13.1618 6.83813 11.3057 4.5127 10.9736L3.5698 10.8389C3.53418 10.5642 3.51562 10.2842 3.51562 10C3.51562 9.47914 3.57777 8.97254 3.6943 8.48691C4.99598 7.91113 7.35094 7.07031 10 7.07031C12.6491 7.07031 15.004 7.91113 16.3057 8.48691C16.4222 8.97254 16.4844 9.47914 16.4844 10C16.4844 10.2842 16.4658 10.5642 16.4302 10.8389L15.4873 10.9736Z",
  fill: "black"
}), _jsx("path", {
  d: "M10 8.24219C9.03074 8.24219 8.24219 9.03074 8.24219 10C8.24219 10.9693 9.03074 11.7578 10 11.7578C10.9693 11.7578 11.7578 10.9693 11.7578 10C11.7578 9.03074 10.9693 8.24219 10 8.24219ZM10 10.5859C9.67691 10.5859 9.41406 10.3231 9.41406 10C9.41406 9.67691 9.67691 9.41406 10 9.41406C10.3231 9.41406 10.5859 9.67691 10.5859 10C10.5859 10.3231 10.3231 10.5859 10 10.5859Z",
  fill: "black"
}));

var TestDrive = function TestDrive() {
  return _ref;
};

/* harmony default export */ __webpack_exports__["a"] = (TestDrive);

/***/ }),

/***/ 1974:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(1240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_tooltip__ = __webpack_require__(1744);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_tooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_tooltip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shared_hocs_withTranslate__ = __webpack_require__(1242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_shared_assets_images_best_sto_png__ = __webpack_require__(1975);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_shared_assets_images_best_sto_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_shared_assets_images_best_sto_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__StoAwards_css__ = __webpack_require__(1976);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__StoAwards_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__StoAwards_css__);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var StoAwards = function (_React$Component) {
  _inherits(StoAwards, _React$Component);

  function StoAwards() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, StoAwards);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = StoAwards.__proto__ || Object.getPrototypeOf(StoAwards)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      showModal: false,
      condition: null
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(StoAwards, [{
    key: '_onClick',
    value: function _onClick() {
      this.setState({
        condition: true
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          awards = _props.awards,
          customStyle = _props.customStyle,
          customPopupStyle = _props.customPopupStyle,
          t = _props.t;

      var titleKey = t('locale') === 'uk' ? 'title_uk' : 'title';

      return _jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_1_classnames___default.a(__WEBPACK_IMPORTED_MODULE_7__StoAwards_css___default.a.root, customStyle),
        onClick: function onClick(e) {
          return e.preventDefault();
        }
      }, void 0, awards.map(function (item) {
        return _jsx('div', {
          className: __WEBPACK_IMPORTED_MODULE_7__StoAwards_css___default.a.bestStoItem
        }, item.nomination.id, _jsx('a', {
          'data-tip': '"' + item.nomination[titleKey] + ' ' + item.year + '"'
        }, void 0, _jsx('img', {
          src: __WEBPACK_IMPORTED_MODULE_5_shared_assets_images_best_sto_png___default.a,
          alt: item.nomination[titleKey]
        }), _jsx(__WEBPACK_IMPORTED_MODULE_3_react_tooltip___default.a, {
          place: 'top',
          type: 'light',
          effect: 'solid',
          condition: false,
          clickable: true,
          className: __WEBPACK_IMPORTED_MODULE_1_classnames___default.a(__WEBPACK_IMPORTED_MODULE_7__StoAwards_css___default.a.customToolTip, customPopupStyle)
        })));
      }));
    }
  }]);

  return StoAwards;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

StoAwards.defaultProps = {
  customPopupStyle: '',
  customStyle: ''
};


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_6_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_7__StoAwards_css___default.a)(__WEBPACK_IMPORTED_MODULE_4_shared_hocs_withTranslate__["a" /* withTranslate */](StoAwards)));

/***/ }),

/***/ 1975:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "73a8a0f9.png";

/***/ }),

/***/ 1976:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1977);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./StoAwards.css", function() {
        content = require("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./StoAwards.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 1977:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, "._1UXml{margin-top:-5px;margin-bottom:5px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start;font-weight:600}._3kWzM img{margin-right:5px;width:34px;height:auto}._3RFYH{max-width:260px;background-color:#ffeb3b!important}", ""]);

// exports
exports.locals = {
	"root": "_1UXml",
	"bestStoItem": "_3kWzM",
	"customToolTip": "_3RFYH"
};

/***/ }),

/***/ 1978:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// CONCATENATED MODULE: ./src/desktop/components/SearchPanel/GroupForm/GroupForm.js
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(1240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__GroupForm_css__ = __webpack_require__(1979);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__GroupForm_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__GroupForm_css__);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }







function GroupForm(props) {
  var items = props.items,
      selected = props.selected;


  return _jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_4__GroupForm_css___default.a.root
  }, void 0, items.map(function (item) {
    return _jsx('div', {
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default.a(__WEBPACK_IMPORTED_MODULE_4__GroupForm_css___default.a.item, _defineProperty({}, __WEBPACK_IMPORTED_MODULE_4__GroupForm_css___default.a.active, selected && item.id === selected.id)),
      onClick: function onClick(e) {
        return props.handleSelect(item);
      }
    }, item.id, _jsx('span', {}, void 0, item.title));
  }));
}

GroupForm.defaultProps = {
  selected: null,
  isDealerPage: false
};


/* harmony default export */ var GroupForm_defaultExport = (__WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_4__GroupForm_css___default.a)(GroupForm));
// CONCATENATED MODULE: ./src/desktop/components/SearchPanel/SearchFormHeader/SearchFormHeader.js
/* harmony import */ var SearchFormHeader___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var SearchFormHeader___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(SearchFormHeader___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var SearchFormHeader___WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var SearchFormHeader___WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(SearchFormHeader___WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var SearchFormHeader___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var SearchFormHeader___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(SearchFormHeader___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_desktop_components_LocationsBlock_LocationsBlock__ = __webpack_require__(1702);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__SearchFormHeader_css__ = __webpack_require__(1981);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__SearchFormHeader_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__SearchFormHeader_css__);
var SearchFormHeader__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();





// import urlMarker from 'shared/assets/images/location-point.svg';



function SearchFormHeader(props) {
  var isNew = props.isNew,
      setAge = props.setAge,
      age = props.age,
      withLocation = props.withLocation,
      isDealerPage = props.isDealerPage;

  var currentAge = age.find(function (item) {
    return item.id === isNew;
  });
  return SearchFormHeader__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_5__SearchFormHeader_css___default.a.root
  }, void 0, SearchFormHeader__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_5__SearchFormHeader_css___default.a.left
  }, void 0, SearchFormHeader__jsx(GroupForm_defaultExport, {
    items: age,
    selected: currentAge,
    handleSelect: setAge,
    isDealerPage: isDealerPage
  })), SearchFormHeader__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_5__SearchFormHeader_css___default.a.right
  }, void 0, SearchFormHeader__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_5__SearchFormHeader_css___default.a.location
  }, void 0, withLocation && SearchFormHeader__jsx(__WEBPACK_IMPORTED_MODULE_3_desktop_components_LocationsBlock_LocationsBlock__["a" /* default */], {
    className: __WEBPACK_IMPORTED_MODULE_5__SearchFormHeader_css___default.a.locationInput
  }))));
}

SearchFormHeader.defaultProps = {
  isNew: null,
  isDealerPage: false
};


/* harmony default export */ var SearchFormHeader_defaultExport = (SearchFormHeader___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_5__SearchFormHeader_css___default.a)(SearchFormHeader));
// CONCATENATED MODULE: ./src/desktop/components/SearchPanel/SelectTranslated/SelectTranslated.js
/* harmony import */ var SelectTranslated___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var SelectTranslated___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(SelectTranslated___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var SelectTranslated___WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var SelectTranslated___WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(SelectTranslated___WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_intl__ = __webpack_require__(474);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_select__ = __webpack_require__(477);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function SelectTranslated__defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }






function SelectTranslated(props) {
  var intl = props.intl,
      options = props.options,
      labelKey = props.labelKey;


  return SelectTranslated___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_select__["a" /* default */], _extends({
    disabled: !options || !options.length
  }, props, {
    options: options && options.length && options.map ? options.map(function (option) {
      return _extends({}, option, option[labelKey] ? SelectTranslated__defineProperty({}, labelKey, intl.formatMessage({ id: option[labelKey] })) : {});
    }) : [],
    labelKey: labelKey
  }));
}

SelectTranslated.defaultProps = {
  options: undefined,
  labelKey: undefined
};


/* harmony default export */ var SelectTranslated_defaultExport = (__WEBPACK_IMPORTED_MODULE_2_react_intl__["d" /* injectIntl */](SelectTranslated));
// CONCATENATED MODULE: ./src/desktop/components/SearchPanel/ColorItem/ColorItem.js
/* harmony import */ var ColorItem___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var ColorItem___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(ColorItem___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var ColorItem___WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var ColorItem___WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(ColorItem___WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var ColorItem___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var ColorItem___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(ColorItem___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var ColorItem___WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(1240);
/* harmony import */ var ColorItem___WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(ColorItem___WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_intl__ = __webpack_require__(474);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ColorItem_css__ = __webpack_require__(1985);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ColorItem_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__ColorItem_css__);
var ColorItem__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function ColorItem__defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var ColorItem = function (_React$Component) {
  _inherits(ColorItem, _React$Component);

  function ColorItem() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ColorItem);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ColorItem.__proto__ || Object.getPrototypeOf(ColorItem)).call.apply(_ref, [this].concat(args))), _this), _this.handleClick = function () {
      var _this$props = _this.props,
          color = _this$props.color,
          selectColor = _this$props.selectColor;

      selectColor(color.id);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ColorItem, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          color = _props.color,
          isActive = _props.isActive;


      var classname = ColorItem___WEBPACK_IMPORTED_MODULE_3_classnames___default.a(__WEBPACK_IMPORTED_MODULE_5__ColorItem_css___default.a.root, ColorItem__defineProperty({}, __WEBPACK_IMPORTED_MODULE_5__ColorItem_css___default.a.active, isActive));

      var style = {
        backgroundColor: '#' + color.slug,
        border: '1px solid #' + (color.slug === 'ffffff' ? 'ccc' : color.slug)
      };

      return ColorItem__jsx('div', {
        className: classname,
        style: style,
        onClick: this.handleClick
      }, void 0, ColorItem__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_5__ColorItem_css___default.a.popover
      }, void 0, ColorItem__jsx(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */], {
        id: color.title
      })));
    }
  }]);

  return ColorItem;
}(ColorItem___WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

ColorItem.defaultProps = {
  isActive: false,
  selectColor: function selectColor() {
    return null;
  }
};


/* harmony default export */ var ColorItem_defaultExport = (ColorItem___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_5__ColorItem_css___default.a)(ColorItem));
// CONCATENATED MODULE: ./src/desktop/components/SearchPanel/ColorsForm/ColorsForm.js
/* harmony import */ var ColorsForm___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var ColorsForm___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(ColorsForm___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var ColorsForm___WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var ColorsForm___WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(ColorsForm___WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(1240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ColorsForm_css__ = __webpack_require__(1983);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ColorsForm_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__ColorsForm_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_assets_images_up_arrow_angle_svg__ = __webpack_require__(1561);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_assets_images_up_arrow_angle_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__shared_assets_images_up_arrow_angle_svg__);
var ColorsForm__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var ColorsForm__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function ColorsForm__defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function ColorsForm__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function ColorsForm__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function ColorsForm__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








// import arrowDown from '../../../../shared/assets/images/down-arrow-angle.svg';

var _ref3 = ColorsForm__jsx('img', {
  src: __WEBPACK_IMPORTED_MODULE_6__shared_assets_images_up_arrow_angle_svg___default.a,
  width: 14,
  alt: ''
});

var ColorsForm_ColorsForm = function (_React$Component) {
  ColorsForm__inherits(ColorsForm, _React$Component);

  function ColorsForm() {
    var _ref;

    var _temp, _this, _ret;

    ColorsForm__classCallCheck(this, ColorsForm);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = ColorsForm__possibleConstructorReturn(this, (_ref = ColorsForm.__proto__ || Object.getPrototypeOf(ColorsForm)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      collapsed: true
    }, _this.toggleCollapse = function () {
      _this.setState(function (_ref2) {
        var collapsed = _ref2.collapsed;
        return { collapsed: !collapsed };
      });
    }, _temp), ColorsForm__possibleConstructorReturn(_this, _ret);
  }

  ColorsForm__createClass(ColorsForm, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          colors = _props.colors,
          selectedColors = _props.selectedColors,
          selectColor = _props.selectColor;
      var collapsed = this.state.collapsed;


      var updatedColors = selectedColors.map(function (item) {
        return parseInt(item, 10);
      }) || [];

      var classname = __WEBPACK_IMPORTED_MODULE_2_classnames___default.a(__WEBPACK_IMPORTED_MODULE_4__ColorsForm_css___default.a.root, ColorsForm__defineProperty({}, __WEBPACK_IMPORTED_MODULE_4__ColorsForm_css___default.a.collapsed, collapsed));

      return ColorsForm__jsx('div', {
        className: classname
      }, void 0, colors && colors.map(function (item) {
        return ColorsForm__jsx(ColorItem_defaultExport, {
          color: item,
          isActive: updatedColors.includes(parseInt(item.id, 10)),
          selectColor: selectColor
        }, item.id);
      }), ColorsForm__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_4__ColorsForm_css___default.a.arrow,
        onClick: this.toggleCollapse
      }, void 0, _ref3));
    }
  }]);

  return ColorsForm;
}(ColorsForm___WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

ColorsForm_ColorsForm.defaultProps = {
  selectColor: function selectColor(f) {
    return f;
  },
  selectedColors: []
};


/* harmony default export */ var ColorsForm_defaultExport = (__WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_4__ColorsForm_css___default.a)(ColorsForm_ColorsForm));
// CONCATENATED MODULE: ./src/desktop/components/SearchPanel/OptionsForm/OptionsForm.js
/* harmony import */ var OptionsForm___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var OptionsForm___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(OptionsForm___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var OptionsForm___WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var OptionsForm___WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(OptionsForm___WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var OptionsForm___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var OptionsForm___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(OptionsForm___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__OptionsForm_css__ = __webpack_require__(1987);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__OptionsForm_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__OptionsForm_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(1240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
var OptionsForm__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var OptionsForm__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function OptionsForm__defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function OptionsForm__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function OptionsForm__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function OptionsForm__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var OptionsForm_options = [];

var OptionsForm = function (_React$Component) {
  OptionsForm__inherits(OptionsForm, _React$Component);

  function OptionsForm(props) {
    OptionsForm__classCallCheck(this, OptionsForm);

    var _this = OptionsForm__possibleConstructorReturn(this, (OptionsForm.__proto__ || Object.getPrototypeOf(OptionsForm)).call(this, props));

    _this.toggleCollapse = function () {
      _this.setState(function (prevState) {
        return {
          collapsed: !prevState.collapsed
        };
      });
    };

    _this.state = {
      collapsed: true
    };
    return _this;
  }

  OptionsForm__createClass(OptionsForm, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          selectedColors = _props.selectedColors,
          selectColor = _props.selectColor;
      var collapsed = this.state.collapsed;


      var classname = __WEBPACK_IMPORTED_MODULE_4_classnames___default.a(__WEBPACK_IMPORTED_MODULE_3__OptionsForm_css___default.a.root, OptionsForm__defineProperty({}, __WEBPACK_IMPORTED_MODULE_3__OptionsForm_css___default.a.collapsed, collapsed));

      return OptionsForm__jsx('div', {
        className: classname
      });
    }
  }]);

  return OptionsForm;
}(OptionsForm___WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

OptionsForm.defaultProps = {
  selectColor: function selectColor(f) {
    return f;
  }
};

/* harmony default export */ var OptionsForm_defaultExport = (OptionsForm___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_3__OptionsForm_css___default.a)(OptionsForm));
// CONCATENATED MODULE: ./src/desktop/components/SearchPanel/CarsPanel/CarsPanel.js
/* harmony import */ var CarsPanel___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var CarsPanel___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(CarsPanel___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var CarsPanel___WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var CarsPanel___WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(CarsPanel___WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var CarsPanel___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var CarsPanel___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(CarsPanel___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_intl__ = __webpack_require__(474);
/* harmony import */ var CarsPanel___WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(1240);
/* harmony import */ var CarsPanel___WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(CarsPanel___WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_shared_helpers_arrays__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_shared_components_SearchPanel_transformOptions__ = __webpack_require__(1413);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_select__ = __webpack_require__(477);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_shared_components_RegexpInput_RegexpInput__ = __webpack_require__(1255);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__UpdatedSelect_UpdatedSelect__ = __webpack_require__(1431);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__CarsPanel_css__ = __webpack_require__(1989);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__CarsPanel_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__CarsPanel_css__);
var CarsPanel__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var CarsPanel__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var CarsPanel__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function CarsPanel__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function CarsPanel__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function CarsPanel__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

















var CarsPanel__ref3 = CarsPanel__jsx(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */], {
  id: '\u041E\u0431\u043C\u0435\u043D'
});

var _ref4 = CarsPanel__jsx(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */], {
  id: '\u041A\u0440\u0435\u0434\u0438\u0442\u043D\u044B\u0439'
});

var _ref5 = CarsPanel__jsx(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */], {
  id: '\u0422\u043E\u043B\u044C\u043A\u043E \u0441 \u0444\u043E\u0442\u043E'
});

var _ref6 = CarsPanel__jsx(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */], {
  id: '\u0421 \u0430\u0443\u043A\u0446\u0438\u043E\u043D\u0430'
});

var CarsPanel_CarsPanel = function (_React$Component) {
  CarsPanel__inherits(CarsPanel, _React$Component);

  function CarsPanel() {
    var _ref;

    var _temp, _this, _ret;

    CarsPanel__classCallCheck(this, CarsPanel);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = CarsPanel__possibleConstructorReturn(this, (_ref = CarsPanel.__proto__ || Object.getPrototypeOf(CarsPanel)).call.apply(_ref, [this].concat(args))), _this), _this.generationsRenderer = function (option) {
      return CarsPanel__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_14__CarsPanel_css___default.a.generations
      }, void 0, option.photo && CarsPanel__jsx('img', {
        src: option.photo,
        className: __WEBPACK_IMPORTED_MODULE_14__CarsPanel_css___default.a.genPhoto,
        alt: ''
      }), CarsPanel__jsx('span', {
        className: __WEBPACK_IMPORTED_MODULE_14__CarsPanel_css___default.a.genText
      }, void 0, option.title, ' (', option.year_begin, '\xA0-\xA0', option.year_end, ')'));
    }, _this.handleColorsChange = function (id) {
      _this.props.selectedActions.set.colors(id);
    }, _this.handlePhotosToggle = function () {
      var _this$props = _this.props,
          formState = _this$props.formState,
          selectedActions = _this$props.selectedActions;

      selectedActions.set.photos(!formState.photos ? 1 : null);
    }, _this.handleSwapToggle = function () {
      var _this$props2 = _this.props,
          formState = _this$props2.formState,
          selectedActions = _this$props2.selectedActions;

      selectedActions.set.isSwap(!formState.isSwap ? 1 : null);
    }, _this.handleUnderLoanToggle = function () {
      var _this$props3 = _this.props,
          formState = _this$props3.formState,
          selectedActions = _this$props3.selectedActions;

      selectedActions.set.isUnderLoan(!formState.isUnderLoan ? 1 : null);
    }, _this.handleFromAuctionToggle = function () {
      var _this$props4 = _this.props,
          formState = _this$props4.formState,
          selectedActions = _this$props4.selectedActions;

      selectedActions.set.fromAuction(!formState.fromAuction ? 1 : null);
    }, _temp), CarsPanel__possibleConstructorReturn(_this, _ret);
  }

  CarsPanel__createClass(CarsPanel, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          formVocabulary = _props.formVocabulary,
          collapsed = _props.collapsed,
          formState = _props.formState,
          formData = _props.formData,
          selectedActions = _props.selectedActions,
          intl = _props.intl;
      var makes = formVocabulary.makes,
          colors = formVocabulary.colors,
          categories = formVocabulary.categories,
          engines = formVocabulary.engines,
          drives = formVocabulary.drives,
          dealers = formVocabulary.dealers,
          gearboxes = formVocabulary.gearboxes,
          capacities = formVocabulary.capacities,
          rent = formVocabulary.rent,
          credits = formVocabulary.credits,
          customs = formVocabulary.customs,
          states = formVocabulary.states,
          options = formVocabulary.options,
          europeanCountries = formVocabulary.europeanCountries,
          abroadOptions = formVocabulary.abroadOptions;
      var models = formData.models,
          generations = formData.generations;

      var makesWithTopMakes = __WEBPACK_IMPORTED_MODULE_6_shared_components_SearchPanel_transformOptions__["a" /* injectTopMakesToOptions */](makes, intl);
      __WEBPACK_IMPORTED_MODULE_5_shared_helpers_arrays__["h" /* sortCollection */](models, 'title');
      __WEBPACK_IMPORTED_MODULE_5_shared_helpers_arrays__["h" /* sortCollection */](categories, 'title');

      var selectedSetActions = selectedActions.set;
      var pricePlaceholder = intl.formatMessage({ id: 'Цена от' }) + ', ' + (formState.currency && formState.currency.title || intl.formatMessage({ id: 'грн' }));

      var _map = [credits, states, rent, dealers, customs, europeanCountries, abroadOptions].map(function (propsArray) {
        return propsArray.map(function (_ref2) {
          var title = _ref2.title,
              props = _objectWithoutProperties(_ref2, ['title']);

          return CarsPanel__extends({}, props, {
            title: intl.formatMessage({ id: title })
          });
        });
      }),
          _map2 = _slicedToArray(_map, 7),
          formattedCredits = _map2[0],
          formattedStates = _map2[1],
          formattedRent = _map2[2],
          formattedDealers = _map2[3],
          formattedCustoms = _map2[4],
          formattedEuroCountries = _map2[5],
          formattedAbroadOptions = _map2[6];

      return CarsPanel__jsx('div', {}, void 0, CarsPanel__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_14__CarsPanel_css___default.a.mainform
      }, void 0, CarsPanel__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_14__CarsPanel_css___default.a.filterItem
      }, void 0, CarsPanel__jsx(__WEBPACK_IMPORTED_MODULE_7_react_select__["a" /* default */], {
        placeholder: intl.formatMessage({ id: 'Марка' }),
        instanceId: 'make-ff',
        name: 'make',
        options: makesWithTopMakes,
        labelKey: 'title',
        valueKey: 'id',
        disabled: !makes || !makes.length,
        onChange: selectedSetActions.make,
        value: formState.make,
        filterOption: __WEBPACK_IMPORTED_MODULE_6_shared_components_SearchPanel_transformOptions__["b" /* skipTopMakes */]
      })), CarsPanel__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_14__CarsPanel_css___default.a.filterItem
      }, void 0, CarsPanel__jsx(__WEBPACK_IMPORTED_MODULE_11__UpdatedSelect_UpdatedSelect__["a" /* default */], {
        instanceId: 'model-ff',
        name: 'model',
        placeholder: intl.formatMessage({ id: 'Модель' }),
        labelKey: 'title',
        valueKey: 'id',
        disabled: !formState.make || !models || !models.length,
        options: models && models.map ? models : [],
        onChange: selectedSetActions.model,
        value: formState.model,
        matchPos: 'start'
      })), CarsPanel__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_14__CarsPanel_css___default.a.filterItem
      }, void 0, CarsPanel__jsx(__WEBPACK_IMPORTED_MODULE_7_react_select__["a" /* default */], {
        instanceId: 'generation-ff',
        name: 'generation',
        placeholder: intl.formatMessage({ id: 'Поколение' }),
        labelKey: 'title',
        valueKey: 'id',
        optionRenderer: this.generationsRenderer,
        options: generations,
        disabled: !generations || !generations.length,
        onChange: selectedSetActions.generation,
        value: formState.generation,
        matchPos: 'start'
      })), CarsPanel__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_14__CarsPanel_css___default.a.filterItem
      }, void 0, CarsPanel__jsx(__WEBPACK_IMPORTED_MODULE_8_shared_components_RegexpInput_RegexpInput__["a" /* default */], {
        className: CarsPanel___WEBPACK_IMPORTED_MODULE_4_classnames___default.a(__WEBPACK_IMPORTED_MODULE_14__CarsPanel_css___default.a.input, __WEBPACK_IMPORTED_MODULE_14__CarsPanel_css___default.a.from),
        type: 'text',
        placeholder: pricePlaceholder,
        value: formState.priceFrom || '',
        onChange: selectedSetActions.priceFrom,
        pattern: '^[0-9]+$'
      }), CarsPanel__jsx(__WEBPACK_IMPORTED_MODULE_8_shared_components_RegexpInput_RegexpInput__["a" /* default */], {
        className: CarsPanel___WEBPACK_IMPORTED_MODULE_4_classnames___default.a(__WEBPACK_IMPORTED_MODULE_14__CarsPanel_css___default.a.input, __WEBPACK_IMPORTED_MODULE_14__CarsPanel_css___default.a.to),
        type: 'text',
        placeholder: intl.formatMessage({ id: 'до' }),
        value: formState.priceTo || '',
        onChange: selectedSetActions.priceTo,
        pattern: '^[0-9]+$'
      })), CarsPanel__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_14__CarsPanel_css___default.a.filterItem
      }, void 0, CarsPanel__jsx(__WEBPACK_IMPORTED_MODULE_8_shared_components_RegexpInput_RegexpInput__["a" /* default */], {
        className: CarsPanel___WEBPACK_IMPORTED_MODULE_4_classnames___default.a(__WEBPACK_IMPORTED_MODULE_14__CarsPanel_css___default.a.input, __WEBPACK_IMPORTED_MODULE_14__CarsPanel_css___default.a.from),
        type: 'text',
        placeholder: intl.formatMessage({ id: 'Год, от' }),
        value: formState.yearFrom || '',
        onChange: selectedSetActions.yearFrom,
        pattern: '^[0-9]+$'
      }), CarsPanel__jsx(__WEBPACK_IMPORTED_MODULE_8_shared_components_RegexpInput_RegexpInput__["a" /* default */], {
        className: CarsPanel___WEBPACK_IMPORTED_MODULE_4_classnames___default.a(__WEBPACK_IMPORTED_MODULE_14__CarsPanel_css___default.a.input, __WEBPACK_IMPORTED_MODULE_14__CarsPanel_css___default.a.to),
        type: 'text',
        placeholder: intl.formatMessage({ id: 'до' }),
        value: formState.yearTo || '',
        onChange: selectedSetActions.yearTo,
        pattern: '^[0-9]+$'
      })), CarsPanel__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_14__CarsPanel_css___default.a.filterItem
      }, void 0, CarsPanel__jsx(__WEBPACK_IMPORTED_MODULE_8_shared_components_RegexpInput_RegexpInput__["a" /* default */], {
        className: CarsPanel___WEBPACK_IMPORTED_MODULE_4_classnames___default.a(__WEBPACK_IMPORTED_MODULE_14__CarsPanel_css___default.a.input, __WEBPACK_IMPORTED_MODULE_14__CarsPanel_css___default.a.from),
        type: 'text',
        placeholder: intl.formatMessage({ id: 'Пробег от' }),
        value: formState.mileageFrom || '',
        onChange: selectedSetActions.mileageFrom,
        pattern: '^[0-9]+$'
      }), CarsPanel__jsx(__WEBPACK_IMPORTED_MODULE_8_shared_components_RegexpInput_RegexpInput__["a" /* default */], {
        className: CarsPanel___WEBPACK_IMPORTED_MODULE_4_classnames___default.a(__WEBPACK_IMPORTED_MODULE_14__CarsPanel_css___default.a.input, __WEBPACK_IMPORTED_MODULE_14__CarsPanel_css___default.a.to),
        type: 'text',
        placeholder: intl.formatMessage({ id: 'до, тыс. км' }),
        value: formState.mileageTo || '',
        onChange: selectedSetActions.mileageTo,
        pattern: '^[0-9]+$'
      })), CarsPanel__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_14__CarsPanel_css___default.a.filterItem
      }, void 0, CarsPanel__jsx(SelectTranslated_defaultExport, {
        placeholder: intl.formatMessage({ id: 'Кузов' }),
        instanceId: 'categories-ff',
        name: 'categories',
        labelKey: 'title',
        valueKey: 'id',
        options: categories,
        onChange: selectedSetActions.category,
        value: formState.category,
        matchPos: 'start'
      })), CarsPanel__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_14__CarsPanel_css___default.a.filterItem
      }, void 0, CarsPanel__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_14__CarsPanel_css___default.a.flexContainer
      }, void 0, CarsPanel__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_14__CarsPanel_css___default.a.left
      }, void 0, CarsPanel__jsx(SelectTranslated_defaultExport, {
        placeholder: intl.formatMessage({ id: 'Коробка' }),
        instanceId: 'gearbox-ff',
        name: 'gearboxes',
        labelKey: 'title',
        valueKey: 'id',
        options: gearboxes,
        onChange: selectedSetActions.gearbox,
        value: formState.gearbox,
        matchPos: 'start'
      })), CarsPanel__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_14__CarsPanel_css___default.a.right
      }, void 0, CarsPanel__jsx(SelectTranslated_defaultExport, {
        placeholder: intl.formatMessage({ id: 'Привод' }),
        instanceId: 'type-ff',
        name: 'drives',
        labelKey: 'title',
        valueKey: 'id',
        options: drives,
        onChange: selectedSetActions.drive,
        value: formState.drive,
        matchPos: 'start'
      })))), CarsPanel__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_14__CarsPanel_css___default.a.filterItem
      }, void 0, CarsPanel__jsx(SelectTranslated_defaultExport, {
        placeholder: intl.formatMessage({ id: 'двигатель' }),
        instanceId: 'engine-ff',
        name: 'engine',
        labelKey: 'title',
        valueKey: 'id',
        options: engines,
        onChange: selectedSetActions.engine,
        value: formState.engine,
        matchPos: 'start'
      })), CarsPanel__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_14__CarsPanel_css___default.a.filterItem
      }, void 0, CarsPanel__jsx(__WEBPACK_IMPORTED_MODULE_7_react_select__["a" /* default */], {
        placeholder: intl.formatMessage({ id: 'Растаможка' }),
        instanceId: 'customs-ff',
        name: 'customs',
        labelKey: 'title',
        valueKey: 'id',
        searchable: false,
        disabled: !!formState.abroad && !!formState.abroad.value,
        options: formattedCustoms,
        onChange: selectedSetActions.isNotCleared,
        value: formState.isNotCleared
      })), CarsPanel__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_14__CarsPanel_css___default.a.filterItem
      }, void 0, CarsPanel__jsx(__WEBPACK_IMPORTED_MODULE_7_react_select__["a" /* default */], {
        placeholder: intl.formatMessage({ id: 'Пригнан из' }) + '...',
        instanceId: 'drivenFrom-ff',
        name: 'drivenFrom',
        labelKey: 'title',
        valueKey: 'id',
        disabled: !!formState.abroad && !!formState.abroad.value,
        options: formattedEuroCountries,
        onChange: selectedSetActions.drivenFrom,
        value: formState.drivenFrom
      })), CarsPanel__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_14__CarsPanel_css___default.a.filterItem
      }, void 0, CarsPanel__jsx(__WEBPACK_IMPORTED_MODULE_7_react_select__["a" /* default */], {
        placeholder: intl.formatMessage({ id: 'Авто не в Украине' }),
        instanceId: 'abroad-ff',
        name: 'abroad',
        labelKey: 'title',
        valueKey: 'id',
        searchable: false,
        options: formattedAbroadOptions,
        onChange: selectedSetActions.abroad,
        value: formState.abroad
      }))), !collapsed && CarsPanel__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_14__CarsPanel_css___default.a.fullForm
      }, void 0, CarsPanel__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_14__CarsPanel_css___default.a.filterItem
      }, void 0, CarsPanel__jsx(ColorsForm_defaultExport, {
        colors: colors,
        selectedColors: formState.colors,
        selectColor: this.handleColorsChange
      })), CarsPanel__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_14__CarsPanel_css___default.a.filterItem
      }, void 0, CarsPanel__jsx(__WEBPACK_IMPORTED_MODULE_8_shared_components_RegexpInput_RegexpInput__["a" /* default */], {
        className: CarsPanel___WEBPACK_IMPORTED_MODULE_4_classnames___default.a(__WEBPACK_IMPORTED_MODULE_14__CarsPanel_css___default.a.input, __WEBPACK_IMPORTED_MODULE_14__CarsPanel_css___default.a.from),
        type: 'text',
        placeholder: intl.formatMessage({ id: 'Мощность от, ' }),
        value: formState.powerFrom || '',
        onChange: selectedSetActions.powerFrom,
        pattern: '^[0-9]+$'
      }), CarsPanel__jsx(__WEBPACK_IMPORTED_MODULE_8_shared_components_RegexpInput_RegexpInput__["a" /* default */], {
        className: CarsPanel___WEBPACK_IMPORTED_MODULE_4_classnames___default.a(__WEBPACK_IMPORTED_MODULE_14__CarsPanel_css___default.a.input, __WEBPACK_IMPORTED_MODULE_14__CarsPanel_css___default.a.to),
        type: 'text',
        placeholder: intl.formatMessage({ id: 'до, л.с.' }),
        value: formState.powerTo || '',
        onChange: selectedSetActions.powerTo,
        pattern: '^[0-9]+$'
      })), CarsPanel__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_14__CarsPanel_css___default.a.filterItem
      }, void 0, CarsPanel__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_14__CarsPanel_css___default.a.flexContainer
      }, void 0, CarsPanel__jsx(__WEBPACK_IMPORTED_MODULE_7_react_select__["a" /* default */], {
        className: __WEBPACK_IMPORTED_MODULE_14__CarsPanel_css___default.a.selectFrom,
        placeholder: intl.formatMessage({ id: 'Объем от, ' }),
        instanceId: 'capacity-from-ff',
        name: 'capacity-from',
        labelKey: 'title',
        valueKey: 'id',
        options: capacities,
        value: formState.capacityFrom,
        onChange: selectedSetActions.capacityFrom,
        searchable: false
      }), CarsPanel__jsx(__WEBPACK_IMPORTED_MODULE_7_react_select__["a" /* default */], {
        className: __WEBPACK_IMPORTED_MODULE_14__CarsPanel_css___default.a.selectTo,
        placeholder: intl.formatMessage({ id: 'до, л' }),
        instanceId: 'capacity-to-ff',
        name: 'capacity-to',
        labelKey: 'title',
        valueKey: 'id',
        options: capacities,
        value: formState.capacityTo,
        onChange: selectedSetActions.capacityTo,
        searchable: false
      }))), CarsPanel__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_14__CarsPanel_css___default.a.filterItem
      }, void 0, false && CarsPanel__jsx(GroupForm_defaultExport, {
        items: formattedDealers,
        selected: formState.dealerType,
        disabled: true,
        handleSelect: selectedSetActions.dealerType
      }), CarsPanel__jsx(__WEBPACK_IMPORTED_MODULE_7_react_select__["a" /* default */], {
        placeholder: intl.formatMessage({ id: 'Аренда' }),
        instanceId: 'rent-ff',
        name: 'rent',
        labelKey: 'title',
        valueKey: 'id',
        searchable: false,
        options: formattedRent,
        onChange: selectedSetActions.isRent,
        value: formState.isRent
      })), CarsPanel__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_14__CarsPanel_css___default.a.filterItem
      }, void 0, CarsPanel__jsx(__WEBPACK_IMPORTED_MODULE_7_react_select__["a" /* default */], {
        placeholder: intl.formatMessage({ id: 'Кредит' }),
        instanceId: 'credit-ff',
        name: 'credit',
        labelKey: 'title',
        valueKey: 'id',
        searchable: false,
        options: formattedCredits,
        onChange: selectedSetActions.isSaleOnCredit,
        value: formState.isSaleOnCredit
      })), CarsPanel__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_14__CarsPanel_css___default.a.filterItem
      }, void 0, CarsPanel__jsx(__WEBPACK_IMPORTED_MODULE_7_react_select__["a" /* default */], {
        placeholder: intl.formatMessage({ id: 'Cостояние' }),
        instanceId: 'state-ff',
        name: 'state',
        labelKey: 'title',
        valueKey: 'id',
        searchable: false,
        disabled: formState.isNew,
        options: formattedStates,
        onChange: selectedSetActions.isCrashed,
        value: formState.isCrashed
      })), CarsPanel__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_14__CarsPanel_css___default.a.filterItem
      }, void 0, CarsPanel__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_14__CarsPanel_css___default.a.flexContainer
      }, void 0, CarsPanel__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_14__CarsPanel_css___default.a.left
      }, void 0, CarsPanel__jsx('label', {
        className: __WEBPACK_IMPORTED_MODULE_14__CarsPanel_css___default.a.checkbox
      }, void 0, CarsPanel__jsx('input', {
        type: 'checkbox',
        onChange: this.handleSwapToggle,
        checked: !!formState.isSwap
      }), ' ', CarsPanel__ref3)), CarsPanel__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_14__CarsPanel_css___default.a.right
      }, void 0, CarsPanel__jsx('label', {
        className: __WEBPACK_IMPORTED_MODULE_14__CarsPanel_css___default.a.checkbox
      }, void 0, CarsPanel__jsx('input', {
        type: 'checkbox',
        onChange: this.handleUnderLoanToggle,
        checked: !!formState.isUnderLoan
      }), ' ', _ref4)))), CarsPanel__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_14__CarsPanel_css___default.a.filterItem
      }, void 0, CarsPanel__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_14__CarsPanel_css___default.a.flexContainer
      }, void 0, CarsPanel__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_14__CarsPanel_css___default.a.left
      }, void 0, CarsPanel__jsx('label', {
        className: __WEBPACK_IMPORTED_MODULE_14__CarsPanel_css___default.a.checkbox
      }, void 0, CarsPanel__jsx('input', {
        type: 'checkbox',
        onChange: this.handlePhotosToggle,
        checked: !!formState.photos
      }), ' ', _ref5)), CarsPanel__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_14__CarsPanel_css___default.a.right
      }, void 0, CarsPanel__jsx('label', {
        className: __WEBPACK_IMPORTED_MODULE_14__CarsPanel_css___default.a.checkbox
      }, void 0, CarsPanel__jsx('input', {
        type: 'checkbox',
        onChange: this.handleFromAuctionToggle,
        checked: !!formState.fromAuction
      }), ' ', _ref6)))), CarsPanel__jsx(OptionsForm_defaultExport, {
        options: options
      })));
    }
  }]);

  return CarsPanel;
}(CarsPanel___WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/* harmony default export */ var CarsPanel_defaultExport = (CarsPanel___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_14__CarsPanel_css___default.a)(__WEBPACK_IMPORTED_MODULE_3_react_intl__["d" /* injectIntl */](CarsPanel_CarsPanel)));
// CONCATENATED MODULE: ./src/desktop/components/SearchPanel/CarsPanel/index.js


/* harmony default export */ var SearchPanel_CarsPanel_defaultExport = (CarsPanel_defaultExport);
// CONCATENATED MODULE: ./src/desktop/components/SearchPanel/TransportPanelAddition/TransportPanelAddition.js
/* harmony import */ var TransportPanelAddition___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var TransportPanelAddition___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(TransportPanelAddition___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var TransportPanelAddition___WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var TransportPanelAddition___WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(TransportPanelAddition___WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var TransportPanelAddition___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var TransportPanelAddition___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(TransportPanelAddition___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_components_RegexpInput_RegexpInput__ = __webpack_require__(1255);
/* harmony import */ var TransportPanelAddition___WEBPACK_IMPORTED_MODULE_4_react_intl__ = __webpack_require__(474);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_select__ = __webpack_require__(477);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames__ = __webpack_require__(1240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__TransportPanelAddition_css__ = __webpack_require__(1991);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__TransportPanelAddition_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__TransportPanelAddition_css__);
var TransportPanelAddition__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var TransportPanelAddition__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var TransportPanelAddition__slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var TransportPanelAddition__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function TransportPanelAddition__objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function TransportPanelAddition__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function TransportPanelAddition__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function TransportPanelAddition__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }













var TransportPanelAddition__ref3 = TransportPanelAddition__jsx(TransportPanelAddition___WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */], {
  id: '\u041E\u0431\u043C\u0435\u043D'
});

var TransportPanelAddition__ref4 = TransportPanelAddition__jsx(TransportPanelAddition___WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */], {
  id: '\u041A\u0440\u0435\u0434\u0438\u0442\u043D\u044B\u0439'
});

var TransportPanelAddition__ref5 = TransportPanelAddition__jsx(TransportPanelAddition___WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */], {
  id: '\u0422\u043E\u043B\u044C\u043A\u043E \u0441 \u0444\u043E\u0442\u043E'
});

var TransportPanelAddition__ref6 = TransportPanelAddition__jsx(TransportPanelAddition___WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */], {
  id: '\u0421 \u0430\u0443\u043A\u0446\u0438\u043E\u043D\u0430'
});

var TransportPanelAddition_TransportPanelAddition = function (_React$Component) {
  TransportPanelAddition__inherits(TransportPanelAddition, _React$Component);

  function TransportPanelAddition() {
    var _ref;

    var _temp, _this, _ret;

    TransportPanelAddition__classCallCheck(this, TransportPanelAddition);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = TransportPanelAddition__possibleConstructorReturn(this, (_ref = TransportPanelAddition.__proto__ || Object.getPrototypeOf(TransportPanelAddition)).call.apply(_ref, [this].concat(args))), _this), _this.handleColorsChange = function (id) {
      _this.props.selectedActions.set.colors(id);
    }, _this.handlePhotosToggle = function () {
      var _this$props = _this.props,
          formState = _this$props.formState,
          selectedActions = _this$props.selectedActions;

      selectedActions.set.photos(!formState.photos ? 1 : null);
    }, _this.handleSwapToggle = function () {
      var _this$props2 = _this.props,
          formState = _this$props2.formState,
          selectedActions = _this$props2.selectedActions;

      selectedActions.set.isSwap(!formState.isSwap ? 1 : null);
    }, _this.handleUnderLoanToggle = function () {
      var _this$props3 = _this.props,
          formState = _this$props3.formState,
          selectedActions = _this$props3.selectedActions;

      selectedActions.set.isUnderLoan(!formState.isUnderLoan ? 1 : null);
    }, _this.handleFromAuctionToggle = function () {
      var _this$props4 = _this.props,
          formState = _this$props4.formState,
          selectedActions = _this$props4.selectedActions;

      selectedActions.set.fromAuction(!formState.fromAuction ? 1 : null);
    }, _temp), TransportPanelAddition__possibleConstructorReturn(_this, _ret);
  }

  TransportPanelAddition__createClass(TransportPanelAddition, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          formVocabulary = _props.formVocabulary,
          formState = _props.formState,
          selectedActions = _props.selectedActions,
          children = _props.children,
          intl = _props.intl;
      var colors = formVocabulary.colors,
          dealers = formVocabulary.dealers,
          capacities = formVocabulary.capacities,
          rent = formVocabulary.rent,
          credits = formVocabulary.credits,
          customs = formVocabulary.customs,
          states = formVocabulary.states,
          options = formVocabulary.options;

      var selectedSetActions = selectedActions.set;

      var _map = [credits, states, rent, dealers, customs].map(function (propsArray) {
        return propsArray.map(function (_ref2) {
          var title = _ref2.title,
              props = TransportPanelAddition__objectWithoutProperties(_ref2, ['title']);

          return TransportPanelAddition__extends({}, props, {
            title: intl.formatMessage({ id: title })
          });
        });
      }),
          _map2 = TransportPanelAddition__slicedToArray(_map, 5),
          formattedCredits = _map2[0],
          formattedStates = _map2[1],
          formattedRent = _map2[2],
          formattedDealers = _map2[3],
          formattedCustoms = _map2[4];

      var isWater = formState.transport.slug === 'vodnyi-transport';

      return TransportPanelAddition__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_10__TransportPanelAddition_css___default.a.fullForm
      }, void 0, TransportPanelAddition__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_10__TransportPanelAddition_css___default.a.filterItem
      }, void 0, TransportPanelAddition__jsx(ColorsForm_defaultExport, {
        colors: colors,
        selectedColors: formState.colors,
        selectColor: this.handleColorsChange
      })), !isWater && TransportPanelAddition__jsx(TransportPanelAddition___WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment, {}, void 0, TransportPanelAddition__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_10__TransportPanelAddition_css___default.a.filterItem
      }, void 0, TransportPanelAddition__jsx(__WEBPACK_IMPORTED_MODULE_3_shared_components_RegexpInput_RegexpInput__["a" /* default */], {
        className: __WEBPACK_IMPORTED_MODULE_6_classnames___default.a(__WEBPACK_IMPORTED_MODULE_10__TransportPanelAddition_css___default.a.input, __WEBPACK_IMPORTED_MODULE_10__TransportPanelAddition_css___default.a.from),
        type: 'text',
        placeholder: intl.formatMessage({ id: 'Мощность от, ' }),
        value: formState.powerFrom || '',
        onChange: selectedSetActions.powerFrom,
        pattern: '^[0-9]+$'
      }), TransportPanelAddition__jsx(__WEBPACK_IMPORTED_MODULE_3_shared_components_RegexpInput_RegexpInput__["a" /* default */], {
        className: __WEBPACK_IMPORTED_MODULE_6_classnames___default.a(__WEBPACK_IMPORTED_MODULE_10__TransportPanelAddition_css___default.a.input, __WEBPACK_IMPORTED_MODULE_10__TransportPanelAddition_css___default.a.to),
        type: 'text',
        placeholder: intl.formatMessage({ id: 'до, л.с.' }),
        value: formState.powerTo || '',
        onChange: selectedSetActions.powerTo,
        pattern: '^[0-9]+$'
      })), TransportPanelAddition__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_10__TransportPanelAddition_css___default.a.filterItem
      }, void 0, TransportPanelAddition__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_10__TransportPanelAddition_css___default.a.flexContainer
      }, void 0, TransportPanelAddition__jsx(__WEBPACK_IMPORTED_MODULE_5_react_select__["a" /* default */], {
        className: __WEBPACK_IMPORTED_MODULE_10__TransportPanelAddition_css___default.a.selectFrom,
        placeholder: intl.formatMessage({ id: 'Объем от, ' }),
        instanceId: 'capacity-from-ff',
        name: 'capacity-from',
        labelKey: 'title',
        valueKey: 'id',
        options: capacities,
        value: formState.capacityFrom,
        onChange: selectedSetActions.capacityFrom
      }), TransportPanelAddition__jsx(__WEBPACK_IMPORTED_MODULE_5_react_select__["a" /* default */], {
        className: __WEBPACK_IMPORTED_MODULE_10__TransportPanelAddition_css___default.a.selectTo,
        placeholder: intl.formatMessage({ id: 'до, л' }),
        instanceId: 'capacity-to-ff',
        name: 'capacity-to',
        labelKey: 'title',
        valueKey: 'id',
        options: capacities,
        value: formState.capacityTo,
        onChange: selectedSetActions.capacityTo
      })))), children, TransportPanelAddition__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_10__TransportPanelAddition_css___default.a.filterItem
      }, void 0, false && TransportPanelAddition__jsx(GroupForm_defaultExport, {
        items: formattedDealers,
        selected: formState.dealerType,
        disabled: true,
        handleSelect: selectedSetActions.dealerType
      }), TransportPanelAddition__jsx(__WEBPACK_IMPORTED_MODULE_5_react_select__["a" /* default */], {
        placeholder: intl.formatMessage({ id: 'Аренда' }),
        instanceId: 'rent-ff',
        name: 'rent',
        labelKey: 'title',
        valueKey: 'id',
        searchable: false,
        options: formattedRent,
        onChange: selectedSetActions.isRent,
        value: formState.isRent
      })), TransportPanelAddition__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_10__TransportPanelAddition_css___default.a.filterItem
      }, void 0, TransportPanelAddition__jsx(__WEBPACK_IMPORTED_MODULE_5_react_select__["a" /* default */], {
        placeholder: intl.formatMessage({ id: 'Кредит' }),
        instanceId: 'credit-ff',
        name: 'credit',
        labelKey: 'title',
        valueKey: 'id',
        searchable: false,
        options: formattedCredits,
        onChange: selectedSetActions.isSaleOnCredit,
        value: formState.isSaleOnCredit
      })), TransportPanelAddition__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_10__TransportPanelAddition_css___default.a.filterItem
      }, void 0, TransportPanelAddition__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_10__TransportPanelAddition_css___default.a.flexContainer
      }, void 0, TransportPanelAddition__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_10__TransportPanelAddition_css___default.a.left
      }, void 0, TransportPanelAddition__jsx('label', {
        className: __WEBPACK_IMPORTED_MODULE_10__TransportPanelAddition_css___default.a.checkbox
      }, void 0, TransportPanelAddition__jsx('input', {
        type: 'checkbox',
        onChange: this.handleSwapToggle,
        checked: !!formState.isSwap
      }), ' ', TransportPanelAddition__ref3)), TransportPanelAddition__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_10__TransportPanelAddition_css___default.a.right
      }, void 0, TransportPanelAddition__jsx('label', {
        className: __WEBPACK_IMPORTED_MODULE_10__TransportPanelAddition_css___default.a.checkbox
      }, void 0, TransportPanelAddition__jsx('input', {
        type: 'checkbox',
        onChange: this.handleUnderLoanToggle,
        checked: !!formState.isUnderLoan
      }), ' ', TransportPanelAddition__ref4)))), TransportPanelAddition__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_10__TransportPanelAddition_css___default.a.filterItem
      }, void 0, TransportPanelAddition__jsx(__WEBPACK_IMPORTED_MODULE_5_react_select__["a" /* default */], {
        placeholder: intl.formatMessage({ id: 'Cостояние' }),
        instanceId: 'state-ff',
        name: 'state',
        labelKey: 'title',
        valueKey: 'id',
        searchable: false,
        disabled: !!formState.isNew,
        options: formattedStates,
        onChange: selectedSetActions.isCrashed,
        value: formState.isCrashed
      })), TransportPanelAddition__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_10__TransportPanelAddition_css___default.a.filterItem
      }, void 0, TransportPanelAddition__jsx(__WEBPACK_IMPORTED_MODULE_5_react_select__["a" /* default */], {
        placeholder: intl.formatMessage({ id: 'Растаможка' }),
        instanceId: 'customs-ff',
        name: 'customs',
        labelKey: 'title',
        valueKey: 'id',
        searchable: false,
        options: formattedCustoms,
        onChange: selectedSetActions.isNotCleared,
        value: formState.isNotCleared
      })), TransportPanelAddition__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_10__TransportPanelAddition_css___default.a.filterItem
      }, void 0, TransportPanelAddition__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_10__TransportPanelAddition_css___default.a.flexContainer
      }, void 0, TransportPanelAddition__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_10__TransportPanelAddition_css___default.a.left
      }, void 0, TransportPanelAddition__jsx('label', {
        className: __WEBPACK_IMPORTED_MODULE_10__TransportPanelAddition_css___default.a.checkbox
      }, void 0, TransportPanelAddition__jsx('input', {
        type: 'checkbox',
        onChange: this.handlePhotosToggle,
        checked: !!formState.photos
      }), ' ', TransportPanelAddition__ref5)), TransportPanelAddition__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_10__TransportPanelAddition_css___default.a.right
      }, void 0, TransportPanelAddition__jsx('label', {
        className: __WEBPACK_IMPORTED_MODULE_10__TransportPanelAddition_css___default.a.checkbox
      }, void 0, TransportPanelAddition__jsx('input', {
        type: 'checkbox',
        onChange: this.handleFromAuctionToggle,
        checked: !!formState.fromAuction
      }), ' ', TransportPanelAddition__ref6)))), TransportPanelAddition__jsx(OptionsForm_defaultExport, {
        options: options
      }));
    }
  }]);

  return TransportPanelAddition;
}(TransportPanelAddition___WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

TransportPanelAddition_TransportPanelAddition.defaultProps = {
  children: null
};


/* harmony default export */ var TransportPanelAddition_defaultExport = (TransportPanelAddition___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_10__TransportPanelAddition_css___default.a)(TransportPanelAddition___WEBPACK_IMPORTED_MODULE_4_react_intl__["d" /* injectIntl */](TransportPanelAddition_TransportPanelAddition)));
// CONCATENATED MODULE: ./src/desktop/components/SearchPanel/TransportNumericOptions/TransportNumericOptions.js
/* harmony import */ var TransportNumericOptions___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var TransportNumericOptions___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(TransportNumericOptions___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var TransportNumericOptions___WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var TransportNumericOptions___WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(TransportNumericOptions___WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var TransportNumericOptions___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var TransportNumericOptions___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(TransportNumericOptions___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var TransportNumericOptions___WEBPACK_IMPORTED_MODULE_3_shared_components_RegexpInput_RegexpInput__ = __webpack_require__(1255);
/* harmony import */ var TransportNumericOptions___WEBPACK_IMPORTED_MODULE_4_react_intl__ = __webpack_require__(474);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(1240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__TransportNumericOptions_css__ = __webpack_require__(1993);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__TransportNumericOptions_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__TransportNumericOptions_css__);
var TransportNumericOptions__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();









function TransportNumericOptions(props) {
  var formState = props.formState,
      selectedActions = props.selectedActions,
      intl = props.intl;

  var selectedSetActions = selectedActions.set;

  var pricePlaceholder = intl.formatMessage({ id: 'Цена от' }) + ', ' + (formState.currency && formState.currency.title || intl.formatMessage({ id: 'грн' }));

  return TransportNumericOptions__jsx('div', {}, void 0, TransportNumericOptions__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_6__TransportNumericOptions_css___default.a.mainform
  }, void 0, TransportNumericOptions__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_6__TransportNumericOptions_css___default.a.filterItem
  }, void 0, TransportNumericOptions__jsx(TransportNumericOptions___WEBPACK_IMPORTED_MODULE_3_shared_components_RegexpInput_RegexpInput__["a" /* default */], {
    className: __WEBPACK_IMPORTED_MODULE_5_classnames___default.a(__WEBPACK_IMPORTED_MODULE_6__TransportNumericOptions_css___default.a.input, __WEBPACK_IMPORTED_MODULE_6__TransportNumericOptions_css___default.a.from),
    type: 'text',
    placeholder: pricePlaceholder,
    value: formState.priceFrom || '',
    onChange: selectedSetActions.priceFrom,
    pattern: '^[0-9]+$'
  }), TransportNumericOptions__jsx(TransportNumericOptions___WEBPACK_IMPORTED_MODULE_3_shared_components_RegexpInput_RegexpInput__["a" /* default */], {
    className: __WEBPACK_IMPORTED_MODULE_5_classnames___default.a(__WEBPACK_IMPORTED_MODULE_6__TransportNumericOptions_css___default.a.input, __WEBPACK_IMPORTED_MODULE_6__TransportNumericOptions_css___default.a.to),
    type: 'text',
    placeholder: intl.formatMessage({ id: 'до' }),
    value: formState.priceTo || '',
    onChange: selectedSetActions.priceTo,
    pattern: '^[0-9]+$'
  })), TransportNumericOptions__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_6__TransportNumericOptions_css___default.a.filterItem
  }, void 0, TransportNumericOptions__jsx(TransportNumericOptions___WEBPACK_IMPORTED_MODULE_3_shared_components_RegexpInput_RegexpInput__["a" /* default */], {
    className: __WEBPACK_IMPORTED_MODULE_5_classnames___default.a(__WEBPACK_IMPORTED_MODULE_6__TransportNumericOptions_css___default.a.input, __WEBPACK_IMPORTED_MODULE_6__TransportNumericOptions_css___default.a.from),
    type: 'text',
    placeholder: intl.formatMessage({ id: 'Год, от' }),
    value: formState.yearFrom || '',
    onChange: selectedSetActions.yearFrom,
    pattern: '^[0-9]+$'
  }), TransportNumericOptions__jsx(TransportNumericOptions___WEBPACK_IMPORTED_MODULE_3_shared_components_RegexpInput_RegexpInput__["a" /* default */], {
    className: __WEBPACK_IMPORTED_MODULE_5_classnames___default.a(__WEBPACK_IMPORTED_MODULE_6__TransportNumericOptions_css___default.a.input, __WEBPACK_IMPORTED_MODULE_6__TransportNumericOptions_css___default.a.to),
    type: 'text',
    placeholder: intl.formatMessage({ id: 'до' }),
    value: formState.yearTo || '',
    onChange: selectedSetActions.yearTo,
    pattern: '^[0-9]+$'
  })), TransportNumericOptions__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_6__TransportNumericOptions_css___default.a.filterItem
  }, void 0, TransportNumericOptions__jsx(TransportNumericOptions___WEBPACK_IMPORTED_MODULE_3_shared_components_RegexpInput_RegexpInput__["a" /* default */], {
    className: __WEBPACK_IMPORTED_MODULE_5_classnames___default.a(__WEBPACK_IMPORTED_MODULE_6__TransportNumericOptions_css___default.a.input, __WEBPACK_IMPORTED_MODULE_6__TransportNumericOptions_css___default.a.from),
    type: 'text',
    placeholder: intl.formatMessage({ id: 'Пробег от' }),
    value: formState.mileageFrom || '',
    onChange: selectedSetActions.mileageFrom,
    pattern: '^[0-9]+$'
  }), TransportNumericOptions__jsx(TransportNumericOptions___WEBPACK_IMPORTED_MODULE_3_shared_components_RegexpInput_RegexpInput__["a" /* default */], {
    className: __WEBPACK_IMPORTED_MODULE_5_classnames___default.a(__WEBPACK_IMPORTED_MODULE_6__TransportNumericOptions_css___default.a.input, __WEBPACK_IMPORTED_MODULE_6__TransportNumericOptions_css___default.a.to),
    type: 'text',
    placeholder: intl.formatMessage({ id: 'до, тыс. км' }),
    value: formState.mileageTo || '',
    onChange: selectedSetActions.mileageTo,
    pattern: '^[0-9]+$'
  }))));
}

/* harmony default export */ var TransportNumericOptions_defaultExport = (TransportNumericOptions___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_6__TransportNumericOptions_css___default.a)(TransportNumericOptions___WEBPACK_IMPORTED_MODULE_4_react_intl__["d" /* injectIntl */](TransportNumericOptions)));
// CONCATENATED MODULE: ./src/desktop/components/SearchPanel/MotoPanel/MotoPanel.js
/* harmony import */ var MotoPanel___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var MotoPanel___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(MotoPanel___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var MotoPanel___WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var MotoPanel___WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(MotoPanel___WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var MotoPanel___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var MotoPanel___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(MotoPanel___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var MotoPanel___WEBPACK_IMPORTED_MODULE_3_react_intl__ = __webpack_require__(474);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_select__ = __webpack_require__(477);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_shared_components_SearchPanel_transformOptions__ = __webpack_require__(1413);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_shared_helpers_arrays__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__UpdatedSelect_UpdatedSelect__ = __webpack_require__(1431);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__MotoPanel_css__ = __webpack_require__(1995);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__MotoPanel_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__MotoPanel_css__);
var MotoPanel__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();














function MotoPanel(props) {
  var formVocabulary = props.formVocabulary,
      collapsed = props.collapsed,
      formState = props.formState,
      formData = props.formData,
      selectedActions = props.selectedActions,
      intl = props.intl;
  var makes = formVocabulary.makes,
      categories = formVocabulary.categories,
      engines = formVocabulary.engines,
      drives = formVocabulary.drives,
      gearboxes = formVocabulary.gearboxes,
      types = formVocabulary.types,
      engineOrders = formVocabulary.engineOrders,
      tacts = formVocabulary.tacts;
  var models = formData.models;

  var toSort = __WEBPACK_IMPORTED_MODULE_5_shared_components_SearchPanel_transformOptions__["a" /* injectTopMakesToOptions */](makes, intl);
  __WEBPACK_IMPORTED_MODULE_6_shared_helpers_arrays__["h" /* sortCollection */](models, 'title');
  __WEBPACK_IMPORTED_MODULE_6_shared_helpers_arrays__["h" /* sortCollection */](categories, 'title');
  var selectedSetActions = selectedActions.set;

  return MotoPanel__jsx('div', {}, void 0, MotoPanel__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_11__MotoPanel_css___default.a.mainform
  }, void 0, MotoPanel__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_11__MotoPanel_css___default.a.filterItem
  }, void 0, MotoPanel__jsx(__WEBPACK_IMPORTED_MODULE_4_react_select__["a" /* default */], {
    placeholder: intl.formatMessage({ id: 'Марка' }),
    instanceId: 'make-ff',
    name: 'make',
    options: toSort,
    labelKey: 'title',
    valueKey: 'id',
    disabled: !makes || !makes.length,
    onChange: selectedSetActions.make,
    value: formState.make,
    matchPos: 'start'
  })), MotoPanel__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_11__MotoPanel_css___default.a.filterItem
  }, void 0, MotoPanel__jsx(__WEBPACK_IMPORTED_MODULE_10__UpdatedSelect_UpdatedSelect__["a" /* default */], {
    instanceId: 'model-ff',
    name: 'model',
    placeholder: intl.formatMessage({ id: 'Модель' }),
    labelKey: 'title',
    valueKey: 'id',
    disabled: !models || !models.length,
    options: models && models.map ? models : [],
    onChange: selectedSetActions.model,
    value: formState.model,
    matchPos: 'start'
  })), MotoPanel__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_11__MotoPanel_css___default.a.filterItem
  }, void 0, MotoPanel__jsx(SelectTranslated_defaultExport, {
    instanceId: 'transportChild-ff',
    name: 'transportChild',
    placeholder: intl.formatMessage({ id: 'Тип' }),
    labelKey: 'title',
    valueKey: 'id',
    options: types && types.map ? types : [],
    disabled: !types || !types.length,
    onChange: selectedSetActions.transportChild,
    value: formState.transportChild,
    matchPos: 'start'
  })), MotoPanel__jsx(TransportNumericOptions_defaultExport, {
    selectedActions: selectedActions,
    formState: formState
  }), MotoPanel__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_11__MotoPanel_css___default.a.filterItem
  }, void 0, MotoPanel__jsx(SelectTranslated_defaultExport, {
    placeholder: intl.formatMessage({ id: 'Расположение цилиндров' }),
    instanceId: 'engineOrder-ff',
    name: 'engineOrder',
    labelKey: 'title',
    valueKey: 'id',
    options: engineOrders && engineOrders.map ? engineOrders : [],
    disabled: !engineOrders || !engineOrders.length,
    onChange: selectedSetActions.engineOrder,
    value: formState.engineOrder,
    matchPos: 'start'
  })), MotoPanel__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_11__MotoPanel_css___default.a.filterItem
  }, void 0, MotoPanel__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_11__MotoPanel_css___default.a.flexContainer
  }, void 0, MotoPanel__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_11__MotoPanel_css___default.a.left
  }, void 0, MotoPanel__jsx(SelectTranslated_defaultExport, {
    placeholder: intl.formatMessage({ id: 'Коробка' }),
    instanceId: 'gearbox-ff',
    name: 'gearboxes',
    labelKey: 'title',
    valueKey: 'id',
    options: gearboxes && gearboxes.map ? gearboxes : [],
    onChange: selectedSetActions.gearbox,
    value: formState.gearbox,
    matchPos: 'start'
  })), MotoPanel__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_11__MotoPanel_css___default.a.right
  }, void 0, MotoPanel__jsx(SelectTranslated_defaultExport, {
    placeholder: intl.formatMessage({ id: 'Привод' }),
    instanceId: 'type-ff',
    name: 'drives',
    labelKey: 'title',
    valueKey: 'id',
    options: drives && drives.map ? drives : [],
    onChange: selectedSetActions.drive,
    value: formState.drive,
    matchPos: 'start'
  })))), MotoPanel__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_11__MotoPanel_css___default.a.filterItem
  }, void 0, MotoPanel__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_11__MotoPanel_css___default.a.flexContainer
  }, void 0, MotoPanel__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_11__MotoPanel_css___default.a.left
  }, void 0, MotoPanel__jsx(__WEBPACK_IMPORTED_MODULE_4_react_select__["a" /* default */], {
    placeholder: intl.formatMessage({ id: 'К-во тактов' }),
    instanceId: 'tacts-ff',
    name: 'tacts',
    labelKey: 'title',
    valueKey: 'id',
    options: tacts && tacts.map ? tacts : [],
    disabled: !tacts || !tacts.length,
    onChange: selectedSetActions.tacts,
    value: formState.tacts,
    matchPos: 'start'
  })), MotoPanel__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_11__MotoPanel_css___default.a.right
  }, void 0, MotoPanel__jsx(SelectTranslated_defaultExport, {
    placeholder: intl.formatMessage({ id: 'двигатель' }),
    instanceId: 'engine-ff',
    name: 'engine',
    labelKey: 'title',
    valueKey: 'id',
    options: engines && engines.map ? engines : [],
    disabled: !engines || !engines.length,
    onChange: selectedSetActions.engine,
    value: formState.engine,
    matchPos: 'start'
  }))))), !collapsed && MotoPanel__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_11__MotoPanel_css___default.a.fullForm
  }, void 0, MotoPanel__jsx(TransportPanelAddition_defaultExport, {
    formVocabulary: formVocabulary,
    selectedActions: selectedActions,
    formState: formState
  })));
}

/* harmony default export */ var MotoPanel_defaultExport = (MotoPanel___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_11__MotoPanel_css___default.a)(MotoPanel___WEBPACK_IMPORTED_MODULE_3_react_intl__["d" /* injectIntl */](MotoPanel)));
// CONCATENATED MODULE: ./src/desktop/components/SearchPanel/MotoPanel/index.js


/* harmony default export */ var SearchPanel_MotoPanel_defaultExport = (MotoPanel_defaultExport);
// CONCATENATED MODULE: ./src/desktop/components/SearchPanel/CommercialPanel/SpecialPanel/SpecialPanel.js
/* harmony import */ var SpecialPanel___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var SpecialPanel___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(SpecialPanel___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var SpecialPanel___WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var SpecialPanel___WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(SpecialPanel___WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var SpecialPanel___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var SpecialPanel___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(SpecialPanel___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var SpecialPanel___WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(1240);
/* harmony import */ var SpecialPanel___WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(SpecialPanel___WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var SpecialPanel___WEBPACK_IMPORTED_MODULE_4_react_intl__ = __webpack_require__(474);
/* harmony import */ var SpecialPanel___WEBPACK_IMPORTED_MODULE_5_react_select__ = __webpack_require__(477);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_shared_components_RegexpInput_RegexpInput__ = __webpack_require__(1255);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__SpecialPanel_css__ = __webpack_require__(1997);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__SpecialPanel_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__SpecialPanel_css__);
var SpecialPanel__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();











var TYPES = {
  avtobus: 'avtobus',
  pritsepy: 'pritsepy',
  gruzovye: 'gruzovye',
  spetstehnika: 'spetstehnika',
  vodnyiTransport: 'vodnyi-transport'
};

function SpecialPanel(props) {
  var formVocabulary = props.formVocabulary,
      formState = props.formState,
      selectedActions = props.selectedActions,
      type = props.type,
      intl = props.intl;
  var unloadings = formVocabulary.unloadings,
      ecotypes = formVocabulary.ecotypes,
      engines = formVocabulary.engines,
      drives = formVocabulary.drives,
      gearboxes = formVocabulary.gearboxes;

  var selectedSetActions = selectedActions.set;

  if (!type) {
    return null;
  }

  return SpecialPanel__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_8__SpecialPanel_css___default.a.root
  }, void 0, function () {
    switch (type) {
      case TYPES.avtobus:
        {
          return SpecialPanel__jsx('div', {
            className: __WEBPACK_IMPORTED_MODULE_8__SpecialPanel_css___default.a.mainform
          }, void 0, SpecialPanel__jsx('div', {
            className: __WEBPACK_IMPORTED_MODULE_8__SpecialPanel_css___default.a.filterItem
          }, void 0, SpecialPanel__jsx(SpecialPanel___WEBPACK_IMPORTED_MODULE_5_react_select__["a" /* default */], {
            placeholder: intl.formatMessage({ id: 'Колесная формула' }),
            instanceId: 'drive-ff',
            name: 'drive',
            labelKey: 'title',
            valueKey: 'id',
            options: drives,
            disabled: !(drives && drives.length > 0),
            onChange: selectedSetActions.drive,
            value: formState.drive
          })), SpecialPanel__jsx('div', {
            className: __WEBPACK_IMPORTED_MODULE_8__SpecialPanel_css___default.a.filterItem
          }, void 0, SpecialPanel__jsx(SelectTranslated_defaultExport, {
            placeholder: intl.formatMessage({ id: 'Коробка' }),
            instanceId: 'gearbox-ff',
            name: 'gearboxes',
            labelKey: 'title',
            valueKey: 'id',
            options: gearboxes,
            disabled: !(gearboxes && gearboxes.length > 0),
            onChange: selectedSetActions.gearbox,
            value: formState.gearbox
          })), SpecialPanel__jsx('div', {
            className: __WEBPACK_IMPORTED_MODULE_8__SpecialPanel_css___default.a.filterItem
          }, void 0, SpecialPanel__jsx('div', {
            className: __WEBPACK_IMPORTED_MODULE_8__SpecialPanel_css___default.a.flexContainer
          }, void 0, SpecialPanel__jsx('div', {
            className: __WEBPACK_IMPORTED_MODULE_8__SpecialPanel_css___default.a.left
          }, void 0, SpecialPanel__jsx(SelectTranslated_defaultExport, {
            placeholder: intl.formatMessage({ id: 'двигатель' }),
            instanceId: 'engine-ff',
            name: 'engine',
            labelKey: 'title',
            valueKey: 'id',
            options: engines,
            disabled: !(engines && engines.length > 0),
            onChange: selectedSetActions.engine,
            value: formState.engine
          })), SpecialPanel__jsx('div', {
            className: __WEBPACK_IMPORTED_MODULE_8__SpecialPanel_css___default.a.right
          }, void 0, SpecialPanel__jsx(SelectTranslated_defaultExport, {
            placeholder: intl.formatMessage({ id: 'Эконормы' }),
            instanceId: 'type-ff',
            name: 'drives',
            labelKey: 'title',
            valueKey: 'id',
            options: ecotypes,
            disabled: !(ecotypes && ecotypes.length > 0),
            onChange: selectedSetActions.ecotype,
            value: formState.ecotype
          })))));
        }
      case TYPES.gruzovye:
        {
          return SpecialPanel__jsx('div', {
            className: __WEBPACK_IMPORTED_MODULE_8__SpecialPanel_css___default.a.mainform
          }, void 0, SpecialPanel__jsx('div', {
            className: __WEBPACK_IMPORTED_MODULE_8__SpecialPanel_css___default.a.filterItem
          }, void 0, SpecialPanel__jsx(SpecialPanel___WEBPACK_IMPORTED_MODULE_5_react_select__["a" /* default */], {
            placeholder: intl.formatMessage({ id: 'Колесная формула' }),
            instanceId: 'drive-ff',
            name: 'drive',
            labelKey: 'title',
            valueKey: 'id',
            options: drives,
            disabled: !(drives && drives.length > 0),
            onChange: selectedSetActions.drive,
            value: formState.drive
          })), SpecialPanel__jsx('div', {
            className: __WEBPACK_IMPORTED_MODULE_8__SpecialPanel_css___default.a.filterItem
          }, void 0, SpecialPanel__jsx(SelectTranslated_defaultExport, {
            placeholder: intl.formatMessage({ id: 'Коробка' }),
            instanceId: 'gearbox-ff',
            name: 'gearboxes',
            labelKey: 'title',
            valueKey: 'id',
            options: gearboxes,
            disabled: !(gearboxes && gearboxes.length > 0),
            onChange: selectedSetActions.gearbox,
            value: formState.gearbox
          })), SpecialPanel__jsx('div', {
            className: __WEBPACK_IMPORTED_MODULE_8__SpecialPanel_css___default.a.filterItem
          }, void 0, SpecialPanel__jsx('div', {
            className: __WEBPACK_IMPORTED_MODULE_8__SpecialPanel_css___default.a.flexContainer
          }, void 0, SpecialPanel__jsx('div', {
            className: __WEBPACK_IMPORTED_MODULE_8__SpecialPanel_css___default.a.left
          }, void 0, SpecialPanel__jsx(SelectTranslated_defaultExport, {
            placeholder: intl.formatMessage({ id: 'двигатель' }),
            instanceId: 'engine-ff',
            name: 'engine',
            labelKey: 'title',
            valueKey: 'id',
            options: engines,
            disabled: !(engines && engines.length > 0),
            onChange: selectedSetActions.engine,
            value: formState.engine
          })), SpecialPanel__jsx('div', {
            className: __WEBPACK_IMPORTED_MODULE_8__SpecialPanel_css___default.a.right
          }, void 0, SpecialPanel__jsx(SelectTranslated_defaultExport, {
            placeholder: intl.formatMessage({ id: 'Эконормы' }),
            instanceId: 'type-ff',
            name: 'drives',
            labelKey: 'title',
            valueKey: 'id',
            options: ecotypes,
            disabled: !(ecotypes && ecotypes.length > 0),
            onChange: selectedSetActions.ecotype,
            value: formState.ecotype
          })))));
        }
      case TYPES.pritsepy:
        {
          return SpecialPanel__jsx('div', {
            className: __WEBPACK_IMPORTED_MODULE_8__SpecialPanel_css___default.a.mainform
          }, void 0, SpecialPanel__jsx('div', {
            className: __WEBPACK_IMPORTED_MODULE_8__SpecialPanel_css___default.a.filterItem
          }, void 0, SpecialPanel__jsx(SpecialPanel___WEBPACK_IMPORTED_MODULE_5_react_select__["a" /* default */], {
            placeholder: intl.formatMessage({ id: 'Колесная формула' }),
            instanceId: 'drive-ff',
            name: 'drive',
            labelKey: 'title',
            valueKey: 'id',
            options: drives,
            disabled: !(drives && drives.length > 0),
            onChange: selectedSetActions.drive,
            value: formState.drive
          })), SpecialPanel__jsx('div', {
            className: __WEBPACK_IMPORTED_MODULE_8__SpecialPanel_css___default.a.filterItem
          }, void 0, SpecialPanel__jsx(SelectTranslated_defaultExport, {
            placeholder: intl.formatMessage({ id: 'Выгрузка' }),
            instanceId: 'unloading-ff',
            name: 'unloadings',
            labelKey: 'title',
            valueKey: 'id',
            options: unloadings,
            disabled: !(unloadings && unloadings.length > 0),
            onChange: selectedSetActions.unloading,
            value: formState.unloading
          })), SpecialPanel__jsx('div', {
            className: __WEBPACK_IMPORTED_MODULE_8__SpecialPanel_css___default.a.filterItem
          }, void 0, SpecialPanel__jsx(__WEBPACK_IMPORTED_MODULE_6_shared_components_RegexpInput_RegexpInput__["a" /* default */], {
            className: SpecialPanel___WEBPACK_IMPORTED_MODULE_3_classnames___default.a(__WEBPACK_IMPORTED_MODULE_8__SpecialPanel_css___default.a.input, __WEBPACK_IMPORTED_MODULE_8__SpecialPanel_css___default.a.from),
            type: 'text',
            placeholder: intl.formatMessage({ id: 'Гр-сть, от' }),
            value: formState.tonnageFrom || '',
            onChange: selectedSetActions.tonnageFrom,
            pattern: '^[0-9]+$'
          }), SpecialPanel__jsx(__WEBPACK_IMPORTED_MODULE_6_shared_components_RegexpInput_RegexpInput__["a" /* default */], {
            className: SpecialPanel___WEBPACK_IMPORTED_MODULE_3_classnames___default.a(__WEBPACK_IMPORTED_MODULE_8__SpecialPanel_css___default.a.input, __WEBPACK_IMPORTED_MODULE_8__SpecialPanel_css___default.a.to),
            type: 'text',
            placeholder: intl.formatMessage({ id: 'до' }),
            value: formState.tonnageTo || '',
            onChange: selectedSetActions.tonnageTo,
            pattern: '^[0-9]+$'
          })));
        }
      case TYPES.spetstehnika:
        {
          return SpecialPanel__jsx('div', {
            className: __WEBPACK_IMPORTED_MODULE_8__SpecialPanel_css___default.a.mainform
          }, void 0, SpecialPanel__jsx('div', {
            className: __WEBPACK_IMPORTED_MODULE_8__SpecialPanel_css___default.a.filterItem
          }, void 0, SpecialPanel__jsx(__WEBPACK_IMPORTED_MODULE_6_shared_components_RegexpInput_RegexpInput__["a" /* default */], {
            className: SpecialPanel___WEBPACK_IMPORTED_MODULE_3_classnames___default.a(__WEBPACK_IMPORTED_MODULE_8__SpecialPanel_css___default.a.input, __WEBPACK_IMPORTED_MODULE_8__SpecialPanel_css___default.a.from),
            type: 'text',
            placeholder: intl.formatMessage({ id: 'Гр-сть, от' }),
            value: formState.tonnageFrom || '',
            onChange: selectedSetActions.tonnageFrom,
            pattern: '^[0-9]+$'
          }), SpecialPanel__jsx(__WEBPACK_IMPORTED_MODULE_6_shared_components_RegexpInput_RegexpInput__["a" /* default */], {
            className: SpecialPanel___WEBPACK_IMPORTED_MODULE_3_classnames___default.a(__WEBPACK_IMPORTED_MODULE_8__SpecialPanel_css___default.a.input, __WEBPACK_IMPORTED_MODULE_8__SpecialPanel_css___default.a.to),
            type: 'text',
            placeholder: intl.formatMessage({ id: 'до' }),
            value: formState.tonnageTo || '',
            onChange: selectedSetActions.tonnageTo,
            pattern: '^[0-9]+$'
          })), SpecialPanel__jsx('div', {
            className: __WEBPACK_IMPORTED_MODULE_8__SpecialPanel_css___default.a.filterItem
          }, void 0, SpecialPanel__jsx('div', {
            className: __WEBPACK_IMPORTED_MODULE_8__SpecialPanel_css___default.a.flexContainer
          }, void 0, SpecialPanel__jsx('div', {
            className: __WEBPACK_IMPORTED_MODULE_8__SpecialPanel_css___default.a.left
          }, void 0, SpecialPanel__jsx(SelectTranslated_defaultExport, {
            placeholder: intl.formatMessage({ id: 'Коробка' }),
            instanceId: 'gearbox-ff',
            name: 'gearboxes',
            labelKey: 'title',
            valueKey: 'id',
            options: gearboxes,
            disabled: !(gearboxes && gearboxes.length > 0),
            onChange: selectedSetActions.gearbox,
            value: formState.gearbox
          })), SpecialPanel__jsx('div', {
            className: __WEBPACK_IMPORTED_MODULE_8__SpecialPanel_css___default.a.right
          }, void 0, SpecialPanel__jsx(SelectTranslated_defaultExport, {
            placeholder: intl.formatMessage({ id: 'Выгрузка' }),
            instanceId: 'unloading-ff',
            name: 'unloadings',
            labelKey: 'title',
            valueKey: 'id',
            options: unloadings,
            disabled: !(unloadings && unloadings.length > 0),
            onChange: selectedSetActions.unloading,
            value: formState.unloading
          })))), SpecialPanel__jsx('div', {
            className: __WEBPACK_IMPORTED_MODULE_8__SpecialPanel_css___default.a.filterItem
          }, void 0, SpecialPanel__jsx('div', {
            className: __WEBPACK_IMPORTED_MODULE_8__SpecialPanel_css___default.a.flexContainer
          }, void 0, SpecialPanel__jsx('div', {
            className: __WEBPACK_IMPORTED_MODULE_8__SpecialPanel_css___default.a.left
          }, void 0, SpecialPanel__jsx(SelectTranslated_defaultExport, {
            placeholder: intl.formatMessage({ id: 'двигатель' }),
            instanceId: 'engine-ff',
            name: 'engine',
            labelKey: 'title',
            valueKey: 'id',
            options: engines,
            disabled: !(engines && engines.length > 0),
            onChange: selectedSetActions.engine,
            value: formState.engine
          })), SpecialPanel__jsx('div', {
            className: __WEBPACK_IMPORTED_MODULE_8__SpecialPanel_css___default.a.right
          }, void 0, SpecialPanel__jsx(SelectTranslated_defaultExport, {
            placeholder: intl.formatMessage({ id: 'Эконормы' }),
            instanceId: 'type-ff',
            name: 'drives',
            labelKey: 'title',
            valueKey: 'id',
            options: ecotypes,
            disabled: !(ecotypes && ecotypes.length > 0),
            onChange: selectedSetActions.ecotype,
            value: formState.ecotype
          })))));
        }
      case TYPES.vodnyiTransport:
        {
          return SpecialPanel__jsx('div', {
            className: __WEBPACK_IMPORTED_MODULE_8__SpecialPanel_css___default.a.filterItem
          }, void 0, SpecialPanel__jsx(SelectTranslated_defaultExport, {
            placeholder: intl.formatMessage({ id: 'двигатель' }),
            instanceId: 'engine-ff',
            name: 'engine',
            labelKey: 'title',
            valueKey: 'id',
            options: engines,
            disabled: !(engines && engines.length > 0),
            onChange: selectedSetActions.engine,
            value: formState.engine
          }));
        }
      default:
        {
          return null;
        }
    }
  }());
}

SpecialPanel.defaultProps = {
  type: null
};


/* harmony default export */ var SpecialPanel_defaultExport = (SpecialPanel___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_8__SpecialPanel_css___default.a)(SpecialPanel___WEBPACK_IMPORTED_MODULE_4_react_intl__["d" /* injectIntl */](SpecialPanel)));
// CONCATENATED MODULE: ./src/desktop/components/SearchPanel/CommercialPanel/CommercialPanel.js
/* harmony import */ var CommercialPanel___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var CommercialPanel___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(CommercialPanel___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var CommercialPanel___WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var CommercialPanel___WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(CommercialPanel___WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var CommercialPanel___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var CommercialPanel___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(CommercialPanel___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var CommercialPanel___WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(1240);
/* harmony import */ var CommercialPanel___WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(CommercialPanel___WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var CommercialPanel___WEBPACK_IMPORTED_MODULE_4_react_intl__ = __webpack_require__(474);
/* harmony import */ var CommercialPanel___WEBPACK_IMPORTED_MODULE_5_react_select__ = __webpack_require__(477);
/* harmony import */ var CommercialPanel___WEBPACK_IMPORTED_MODULE_6_shared_components_SearchPanel_transformOptions__ = __webpack_require__(1413);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_shared_components_RegexpInput_RegexpInput__ = __webpack_require__(1255);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_shared_helpers_arrays__ = __webpack_require__(104);
/* harmony import */ var CommercialPanel___WEBPACK_IMPORTED_MODULE_10__UpdatedSelect_UpdatedSelect__ = __webpack_require__(1431);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__CommercialPanel_css__ = __webpack_require__(1999);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__CommercialPanel_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__CommercialPanel_css__);
var CommercialPanel__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var CommercialPanel__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function CommercialPanel__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function CommercialPanel__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function CommercialPanel__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

















var CommercialPanel_CommercialPanel = function (_React$Component) {
  CommercialPanel__inherits(CommercialPanel, _React$Component);

  function CommercialPanel() {
    var _ref;

    var _temp, _this, _ret;

    CommercialPanel__classCallCheck(this, CommercialPanel);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = CommercialPanel__possibleConstructorReturn(this, (_ref = CommercialPanel.__proto__ || Object.getPrototypeOf(CommercialPanel)).call.apply(_ref, [this].concat(args))), _this), _this.setChildTransportType = function (type) {
      var _this$props = _this.props,
          set = _this$props.selectedActions.set,
          _this$props$formState = _this$props.formState,
          transportChild = _this$props$formState.transportChild,
          transport = _this$props$formState.transport,
          childrenTransportTypes = _this$props.formVocabulary.childrenTransportTypes;


      if (type) {
        set.transportChild(type);
      } else if (transport) {
        set.transportChild(_this.findSelectedRootType(transportChild, childrenTransportTypes[transport.slug]));
      }
    }, _this.findSelectedRootType = function (selected, arr) {
      if (!selected || !selected.id || !arr) {
        return null;
      }

      var selectedType = arr.find(function (type) {
        return type.id === selected.id;
      });
      if (!selectedType) {
        return null;
      }

      if (selectedType.parent) {
        return arr.find(function (type) {
          return type.id === parseFloat(selectedType.parent);
        });
      }

      return selectedType;
    }, _temp), CommercialPanel__possibleConstructorReturn(_this, _ret);
  }

  CommercialPanel__createClass(CommercialPanel, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          formVocabulary = _props.formVocabulary,
          collapsed = _props.collapsed,
          formState = _props.formState,
          formData = _props.formData,
          selectedActions = _props.selectedActions,
          transportType = _props.transportType,
          intl = _props.intl;


      var transportSlug = transportType ? transportType.slug : null;

      var makes = formVocabulary.makes,
          childrenTransportTypes = formVocabulary.childrenTransportTypes;
      var models = formData.models;

      var selectedSetActions = selectedActions.set;
      var toSort = CommercialPanel___WEBPACK_IMPORTED_MODULE_6_shared_components_SearchPanel_transformOptions__["a" /* injectTopMakesToOptions */](makes, intl);

      __WEBPACK_IMPORTED_MODULE_8_shared_helpers_arrays__["h" /* sortCollection */](models, 'title');

      var transportTypes = formState.transport ? childrenTransportTypes[formState.transport.slug] : [];
      var rootTypes = transportTypes ? transportTypes.filter(function (type) {
        return !type.parent;
      }) : [];
      var selectedRootType = this.findSelectedRootType(formState.transportChild, transportTypes);

      var isSubtypesExist = transportTypes && !!transportTypes.filter(function (type) {
        return type.parent;
      }).length;
      var childTypes = isSubtypesExist && selectedRootType && transportTypes ? transportTypes.filter(function (type) {
        return parseFloat(type.parent) === selectedRootType.id;
      }) : [];
      var selectedChildType = formState.transportChild && selectedRootType && formState.transportChild.id !== selectedRootType.id ? formState.transportChild : null;

      return CommercialPanel__jsx('div', {}, void 0, CommercialPanel__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_14__CommercialPanel_css___default.a.mainform
      }, void 0, CommercialPanel__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_14__CommercialPanel_css___default.a.filterItem
      }, void 0, CommercialPanel__jsx(CommercialPanel___WEBPACK_IMPORTED_MODULE_5_react_select__["a" /* default */], {
        placeholder: intl.formatMessage({ id: 'Марка' }),
        instanceId: 'make-ff',
        name: 'make',
        options: toSort,
        labelKey: 'title',
        valueKey: 'id',
        disabled: !makes || !makes.length,
        onChange: selectedSetActions.make,
        value: formState.make,
        filterOption: CommercialPanel___WEBPACK_IMPORTED_MODULE_6_shared_components_SearchPanel_transformOptions__["b" /* skipTopMakes */],
        matchPos: 'start'
      })), CommercialPanel__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_14__CommercialPanel_css___default.a.filterItem
      }, void 0, CommercialPanel__jsx(CommercialPanel___WEBPACK_IMPORTED_MODULE_10__UpdatedSelect_UpdatedSelect__["a" /* default */], {
        instanceId: 'model-ff',
        name: 'model',
        placeholder: intl.formatMessage({ id: 'Модель' }),
        labelKey: 'title',
        valueKey: 'id',
        disabled: !models || !models.length,
        options: models && models.map ? models : [],
        onChange: selectedSetActions.model,
        value: formState.model,
        matchPos: 'start'
      })), isSubtypesExist ? CommercialPanel__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_14__CommercialPanel_css___default.a.filterItem
      }, void 0, CommercialPanel__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_14__CommercialPanel_css___default.a.flexContainer
      }, void 0, CommercialPanel__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_14__CommercialPanel_css___default.a.left
      }, void 0, CommercialPanel__jsx(SelectTranslated_defaultExport, {
        placeholder: intl.formatMessage({ id: 'Тип' }),
        instanceId: 'gearbox-ff',
        name: 'gearboxes',
        labelKey: 'title',
        valueKey: 'id',
        options: rootTypes,
        onChange: selectedSetActions.transportChild,
        value: selectedRootType,
        matchPos: 'start'
      })), CommercialPanel__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_14__CommercialPanel_css___default.a.right
      }, void 0, CommercialPanel__jsx(SelectTranslated_defaultExport, {
        placeholder: intl.formatMessage({ id: 'Подтип' }),
        instanceId: 'type-ff',
        name: 'drives',
        labelKey: 'title',
        valueKey: 'id',
        disabled: !selectedRootType || !childTypes.length,
        options: childTypes,
        onChange: this.setChildTransportType,
        value: selectedChildType,
        matchPos: 'start'
      })))) : CommercialPanel__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_14__CommercialPanel_css___default.a.filterItem
      }, void 0, CommercialPanel__jsx(SelectTranslated_defaultExport, {
        placeholder: intl.formatMessage({ id: 'Тип' }),
        instanceId: 'gearbox-ff',
        name: 'gearboxes',
        labelKey: 'title',
        valueKey: 'id',
        options: rootTypes,
        onChange: selectedSetActions.transportChild,
        value: selectedRootType,
        matchPos: 'start'
      })), CommercialPanel__jsx(TransportNumericOptions_defaultExport, {
        selectedActions: selectedActions,
        formState: formState
      }), CommercialPanel__jsx(SpecialPanel_defaultExport, {
        formVocabulary: formVocabulary,
        formState: formState,
        selectedActions: selectedActions,
        type: transportSlug
      })), !collapsed && CommercialPanel__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_14__CommercialPanel_css___default.a.fullForm
      }, void 0, CommercialPanel__jsx(TransportPanelAddition_defaultExport, {
        formVocabulary: formVocabulary,
        selectedActions: selectedActions,
        formState: formState
      }, void 0, transportType.slug === 'spetstehnika' && CommercialPanel__jsx('div', {
        className: CommercialPanel___WEBPACK_IMPORTED_MODULE_3_classnames___default.a(__WEBPACK_IMPORTED_MODULE_14__CommercialPanel_css___default.a.mainform, __WEBPACK_IMPORTED_MODULE_14__CommercialPanel_css___default.a.fullWidth)
      }, void 0, CommercialPanel__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_14__CommercialPanel_css___default.a.filterItem
      }, void 0, CommercialPanel__jsx(__WEBPACK_IMPORTED_MODULE_7_shared_components_RegexpInput_RegexpInput__["a" /* default */], {
        className: CommercialPanel___WEBPACK_IMPORTED_MODULE_3_classnames___default.a(__WEBPACK_IMPORTED_MODULE_14__CommercialPanel_css___default.a.input, __WEBPACK_IMPORTED_MODULE_14__CommercialPanel_css___default.a.from),
        type: 'text',
        placeholder: intl.formatMessage({ id: 'Об-м кузова от,' }),
        value: formState.capacityBodyFrom || '',
        onChange: selectedSetActions.capacityBodyFrom,
        pattern: '^[0-9]+$'
      }), CommercialPanel__jsx(__WEBPACK_IMPORTED_MODULE_7_shared_components_RegexpInput_RegexpInput__["a" /* default */], {
        className: CommercialPanel___WEBPACK_IMPORTED_MODULE_3_classnames___default.a(__WEBPACK_IMPORTED_MODULE_14__CommercialPanel_css___default.a.input, __WEBPACK_IMPORTED_MODULE_14__CommercialPanel_css___default.a.to),
        type: 'text',
        placeholder: intl.formatMessage({ id: 'до, куб. м' }),
        value: formState.capacityBodyTo || '',
        onChange: selectedSetActions.capacityBodyTo,
        pattern: '^[0-9]+$'
      })), CommercialPanel__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_14__CommercialPanel_css___default.a.filterItem
      }, void 0, CommercialPanel__jsx(__WEBPACK_IMPORTED_MODULE_7_shared_components_RegexpInput_RegexpInput__["a" /* default */], {
        className: CommercialPanel___WEBPACK_IMPORTED_MODULE_3_classnames___default.a(__WEBPACK_IMPORTED_MODULE_14__CommercialPanel_css___default.a.input, __WEBPACK_IMPORTED_MODULE_14__CommercialPanel_css___default.a.from),
        type: 'text',
        placeholder: intl.formatMessage({ id: 'Об-м ковша от,' }),
        value: formState.capacityBucketFrom || '',
        onChange: selectedSetActions.capacityBucketFrom,
        pattern: '^[0-9]+$'
      }), CommercialPanel__jsx(__WEBPACK_IMPORTED_MODULE_7_shared_components_RegexpInput_RegexpInput__["a" /* default */], {
        className: CommercialPanel___WEBPACK_IMPORTED_MODULE_3_classnames___default.a(__WEBPACK_IMPORTED_MODULE_14__CommercialPanel_css___default.a.input, __WEBPACK_IMPORTED_MODULE_14__CommercialPanel_css___default.a.to),
        type: 'text',
        placeholder: intl.formatMessage({ id: 'до, куб. м' }),
        value: formState.capacityBucketTo || '',
        onChange: selectedSetActions.capacityBucketTo,
        pattern: '^[0-9]+$'
      })), CommercialPanel__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_14__CommercialPanel_css___default.a.filterItem
      }, void 0, CommercialPanel__jsx(__WEBPACK_IMPORTED_MODULE_7_shared_components_RegexpInput_RegexpInput__["a" /* default */], {
        className: CommercialPanel___WEBPACK_IMPORTED_MODULE_3_classnames___default.a(__WEBPACK_IMPORTED_MODULE_14__CommercialPanel_css___default.a.input, __WEBPACK_IMPORTED_MODULE_14__CommercialPanel_css___default.a.from),
        type: 'text',
        placeholder: intl.formatMessage({ id: 'Ш-на укладки от,' }),
        value: formState.layingWidthFrom || '',
        onChange: selectedSetActions.layingWidthFrom,
        pattern: '^[0-9]+$'
      }), CommercialPanel__jsx(__WEBPACK_IMPORTED_MODULE_7_shared_components_RegexpInput_RegexpInput__["a" /* default */], {
        className: CommercialPanel___WEBPACK_IMPORTED_MODULE_3_classnames___default.a(__WEBPACK_IMPORTED_MODULE_14__CommercialPanel_css___default.a.input, __WEBPACK_IMPORTED_MODULE_14__CommercialPanel_css___default.a.to),
        type: 'text',
        placeholder: intl.formatMessage({ id: 'до, м' }),
        value: formState.layingWidthTo || '',
        onChange: selectedSetActions.layingWidthTo,
        pattern: '^[0-9]+$'
      })), CommercialPanel__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_14__CommercialPanel_css___default.a.filterItem
      }, void 0, CommercialPanel__jsx(__WEBPACK_IMPORTED_MODULE_7_shared_components_RegexpInput_RegexpInput__["a" /* default */], {
        className: CommercialPanel___WEBPACK_IMPORTED_MODULE_3_classnames___default.a(__WEBPACK_IMPORTED_MODULE_14__CommercialPanel_css___default.a.input, __WEBPACK_IMPORTED_MODULE_14__CommercialPanel_css___default.a.from),
        type: 'text',
        placeholder: intl.formatMessage({ id: 'В-та подъема от,' }),
        value: formState.liftHeightFrom || '',
        onChange: selectedSetActions.liftHeightFrom,
        pattern: '^[0-9]+$'
      }), CommercialPanel__jsx(__WEBPACK_IMPORTED_MODULE_7_shared_components_RegexpInput_RegexpInput__["a" /* default */], {
        className: CommercialPanel___WEBPACK_IMPORTED_MODULE_3_classnames___default.a(__WEBPACK_IMPORTED_MODULE_14__CommercialPanel_css___default.a.input, __WEBPACK_IMPORTED_MODULE_14__CommercialPanel_css___default.a.to),
        type: 'text',
        placeholder: intl.formatMessage({ id: 'до, м' }),
        value: formState.liftHeightTo || '',
        onChange: selectedSetActions.liftHeightTo,
        pattern: '^[0-9]+$'
      })), CommercialPanel__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_14__CommercialPanel_css___default.a.filterItem
      }, void 0, CommercialPanel__jsx(__WEBPACK_IMPORTED_MODULE_7_shared_components_RegexpInput_RegexpInput__["a" /* default */], {
        className: CommercialPanel___WEBPACK_IMPORTED_MODULE_3_classnames___default.a(__WEBPACK_IMPORTED_MODULE_14__CommercialPanel_css___default.a.input, __WEBPACK_IMPORTED_MODULE_14__CommercialPanel_css___default.a.from),
        type: 'text',
        placeholder: intl.formatMessage({ id: 'В-та подачи от,' }),
        value: formState.admissionHeightFrom || '',
        onChange: selectedSetActions.admissionHeightFrom,
        pattern: '^[0-9]+$'
      }), CommercialPanel__jsx(__WEBPACK_IMPORTED_MODULE_7_shared_components_RegexpInput_RegexpInput__["a" /* default */], {
        className: CommercialPanel___WEBPACK_IMPORTED_MODULE_3_classnames___default.a(__WEBPACK_IMPORTED_MODULE_14__CommercialPanel_css___default.a.input, __WEBPACK_IMPORTED_MODULE_14__CommercialPanel_css___default.a.to),
        type: 'text',
        placeholder: intl.formatMessage({ id: 'до, м' }),
        value: formState.admissionHeightTo || '',
        onChange: selectedSetActions.admissionHeightTo,
        pattern: '^[0-9]+$'
      })), CommercialPanel__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_14__CommercialPanel_css___default.a.filterItem
      }, void 0, CommercialPanel__jsx(__WEBPACK_IMPORTED_MODULE_7_shared_components_RegexpInput_RegexpInput__["a" /* default */], {
        className: CommercialPanel___WEBPACK_IMPORTED_MODULE_3_classnames___default.a(__WEBPACK_IMPORTED_MODULE_14__CommercialPanel_css___default.a.input, __WEBPACK_IMPORTED_MODULE_14__CommercialPanel_css___default.a.from),
        type: 'text',
        placeholder: intl.formatMessage({ id: 'Вылет стр. от,' }),
        value: formState.armBoomFrom || '',
        onChange: selectedSetActions.armBoomFrom,
        pattern: '^[0-9]+$'
      }), CommercialPanel__jsx(__WEBPACK_IMPORTED_MODULE_7_shared_components_RegexpInput_RegexpInput__["a" /* default */], {
        className: CommercialPanel___WEBPACK_IMPORTED_MODULE_3_classnames___default.a(__WEBPACK_IMPORTED_MODULE_14__CommercialPanel_css___default.a.input, __WEBPACK_IMPORTED_MODULE_14__CommercialPanel_css___default.a.to),
        type: 'text',
        placeholder: intl.formatMessage({ id: 'до, м' }),
        value: formState.armBoomTo || '',
        onChange: selectedSetActions.armBoomTo,
        pattern: '^[0-9]+$'
      })), CommercialPanel__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_14__CommercialPanel_css___default.a.filterItem
      }, void 0, CommercialPanel__jsx(__WEBPACK_IMPORTED_MODULE_7_shared_components_RegexpInput_RegexpInput__["a" /* default */], {
        className: CommercialPanel___WEBPACK_IMPORTED_MODULE_3_classnames___default.a(__WEBPACK_IMPORTED_MODULE_14__CommercialPanel_css___default.a.input, __WEBPACK_IMPORTED_MODULE_14__CommercialPanel_css___default.a.from),
        type: 'text',
        placeholder: intl.formatMessage({ id: 'Г-на копания от,' }),
        value: formState.depBigFrom || '',
        onChange: selectedSetActions.depBigFrom,
        pattern: '^[0-9]+$'
      }), CommercialPanel__jsx(__WEBPACK_IMPORTED_MODULE_7_shared_components_RegexpInput_RegexpInput__["a" /* default */], {
        className: CommercialPanel___WEBPACK_IMPORTED_MODULE_3_classnames___default.a(__WEBPACK_IMPORTED_MODULE_14__CommercialPanel_css___default.a.input, __WEBPACK_IMPORTED_MODULE_14__CommercialPanel_css___default.a.to),
        type: 'text',
        placeholder: intl.formatMessage({ id: 'до, м' }),
        value: formState.depBigTo || '',
        onChange: selectedSetActions.depBigTo,
        pattern: '^[0-9]+$'
      })), CommercialPanel__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_14__CommercialPanel_css___default.a.filterItem
      }, void 0, CommercialPanel__jsx(__WEBPACK_IMPORTED_MODULE_7_shared_components_RegexpInput_RegexpInput__["a" /* default */], {
        className: CommercialPanel___WEBPACK_IMPORTED_MODULE_3_classnames___default.a(__WEBPACK_IMPORTED_MODULE_14__CommercialPanel_css___default.a.input, __WEBPACK_IMPORTED_MODULE_14__CommercialPanel_css___default.a.from),
        type: 'text',
        placeholder: intl.formatMessage({ id: 'Нараб. от,' }),
        value: formState.productivityFrom || '',
        onChange: selectedSetActions.productivityFrom,
        pattern: '^[0-9]+$'
      }), CommercialPanel__jsx(__WEBPACK_IMPORTED_MODULE_7_shared_components_RegexpInput_RegexpInput__["a" /* default */], {
        className: CommercialPanel___WEBPACK_IMPORTED_MODULE_3_classnames___default.a(__WEBPACK_IMPORTED_MODULE_14__CommercialPanel_css___default.a.input, __WEBPACK_IMPORTED_MODULE_14__CommercialPanel_css___default.a.to),
        type: 'text',
        placeholder: intl.formatMessage({ id: 'до, м/ч.' }),
        value: formState.productivityTo || '',
        onChange: selectedSetActions.productivityTo,
        pattern: '^[0-9]+$'
      }))))));
    }
  }]);

  return CommercialPanel;
}(CommercialPanel___WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/* harmony default export */ var CommercialPanel_defaultExport = (CommercialPanel___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_14__CommercialPanel_css___default.a)(CommercialPanel___WEBPACK_IMPORTED_MODULE_4_react_intl__["d" /* injectIntl */](CommercialPanel_CommercialPanel)));
// CONCATENATED MODULE: ./src/desktop/components/SearchPanel/CommercialPanel/index.js


/* harmony default export */ var SearchPanel_CommercialPanel_defaultExport = (CommercialPanel_defaultExport);
// CONCATENATED MODULE: ./src/desktop/components/SearchPanel/DealersPanel/DealersPanel.js
/* harmony import */ var DealersPanel___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var DealersPanel___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(DealersPanel___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var DealersPanel___WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var DealersPanel___WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(DealersPanel___WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var DealersPanel___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var DealersPanel___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(DealersPanel___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_components_SearchPanel_transformOptions__ = __webpack_require__(1413);
/* harmony import */ var DealersPanel___WEBPACK_IMPORTED_MODULE_4_react_select__ = __webpack_require__(477);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_intl__ = __webpack_require__(474);
/* harmony import */ var DealersPanel___WEBPACK_IMPORTED_MODULE_6_shared_components_RegexpInput_RegexpInput__ = __webpack_require__(1255);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_shared_helpers_arrays__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__UpdatedSelect_UpdatedSelect__ = __webpack_require__(1431);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__DealersPanel_css__ = __webpack_require__(2001);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__DealersPanel_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__DealersPanel_css__);
var DealersPanel__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var DealersPanel__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function DealersPanel__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function DealersPanel__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function DealersPanel__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }












var _ref2 = DealersPanel__jsx(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */], {
  id: '\u0422\u043E\u043B\u044C\u043A\u043E \u043E\u0444\u0438\u0446\u0438\u0430\u043B\u044C\u043D\u044B\u0435'
});

var DealersPanel__ref3 = DealersPanel__jsx(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */], {
  id: '\u041E\u0431\u043C\u0435\u043D \u0441\u0442\u0430\u0440\u043E\u0433\u043E \u043D\u0430 \u043D\u043E\u0432\u044B\u0439'
});

var DealersPanel__ref4 = DealersPanel__jsx(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */], {
  id: '\u0422\u0435\u0441\u0442-\u0434\u0440\u0430\u0439\u0432'
});

var DealersPanel = function (_React$Component) {
  DealersPanel__inherits(DealersPanel, _React$Component);

  function DealersPanel() {
    var _ref;

    var _temp, _this, _ret;

    DealersPanel__classCallCheck(this, DealersPanel);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = DealersPanel__possibleConstructorReturn(this, (_ref = DealersPanel.__proto__ || Object.getPrototypeOf(DealersPanel)).call.apply(_ref, [this].concat(args))), _this), _this.handleTradeInToggle = function () {
      var _this$props = _this.props,
          formState = _this$props.formState,
          selectedActions = _this$props.selectedActions;

      selectedActions.set.tradeIn(!formState.tradeIn ? 1 : null);
    }, _this.handleCreditToggle = function () {
      var _this$props2 = _this.props,
          formState = _this$props2.formState,
          selectedActions = _this$props2.selectedActions;

      selectedActions.set.credit(!formState.credit ? 1 : null);
    }, _this.handleOfficialToggle = function () {
      var _this$props3 = _this.props,
          formState = _this$props3.formState,
          selectedActions = _this$props3.selectedActions;

      selectedActions.set.isOfficial(!formState.isOfficial ? 1 : null);
    }, _this.handleTestDriveToggle = function () {
      var _this$props4 = _this.props,
          formState = _this$props4.formState,
          selectedActions = _this$props4.selectedActions;

      selectedActions.set.testDrive(!formState.testDrive ? 1 : null);
    }, _temp), DealersPanel__possibleConstructorReturn(_this, _ret);
  }

  DealersPanel__createClass(DealersPanel, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          formVocabulary = _props.formVocabulary,
          formState = _props.formState,
          formData = _props.formData,
          selectedActions = _props.selectedActions,
          intl = _props.intl;
      var makes = formVocabulary.makes,
          categories = formVocabulary.categories;
      var models = formData.models;

      var makesWithTopMakes = __WEBPACK_IMPORTED_MODULE_3_shared_components_SearchPanel_transformOptions__["a" /* injectTopMakesToOptions */](makes, intl);

      __WEBPACK_IMPORTED_MODULE_7_shared_helpers_arrays__["h" /* sortCollection */](models, 'title');
      __WEBPACK_IMPORTED_MODULE_7_shared_helpers_arrays__["h" /* sortCollection */](categories, 'title');

      var selectedSetActions = selectedActions.set;

      return DealersPanel__jsx('div', {}, void 0, DealersPanel__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_9__DealersPanel_css___default.a.mainform
      }, void 0, DealersPanel__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_9__DealersPanel_css___default.a.filterItem
      }, void 0, DealersPanel__jsx(DealersPanel___WEBPACK_IMPORTED_MODULE_4_react_select__["a" /* default */], {
        placeholder: intl.formatMessage({ id: 'Марка' }),
        instanceId: 'make-ff',
        name: 'make',
        options: makesWithTopMakes,
        labelKey: 'title',
        valueKey: 'id',
        disabled: !makes || !makes.length,
        onChange: selectedSetActions.make,
        value: formState.make,
        filterOption: __WEBPACK_IMPORTED_MODULE_3_shared_components_SearchPanel_transformOptions__["b" /* skipTopMakes */]
      })), DealersPanel__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_9__DealersPanel_css___default.a.filterItem
      }, void 0, DealersPanel__jsx(__WEBPACK_IMPORTED_MODULE_8__UpdatedSelect_UpdatedSelect__["a" /* default */], {
        instanceId: 'model-ff',
        name: 'model',
        placeholder: intl.formatMessage({ id: 'Модель' }),
        labelKey: 'title',
        valueKey: 'id',
        disabled: !models || !models.length,
        options: models && models.length > 0 ? models : [],
        onChange: selectedSetActions.model,
        value: formState.model,
        matchPos: 'start'
      })), DealersPanel__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_9__DealersPanel_css___default.a.filterItem
      }, void 0, DealersPanel__jsx(DealersPanel___WEBPACK_IMPORTED_MODULE_6_shared_components_RegexpInput_RegexpInput__["a" /* default */], {
        className: __WEBPACK_IMPORTED_MODULE_9__DealersPanel_css___default.a.input,
        type: 'text',
        placeholder: intl.formatMessage({ id: 'Название дилера' }),
        value: formState.q || '',
        onChange: selectedSetActions.q
      })), DealersPanel__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_9__DealersPanel_css___default.a.filterItem
      }, void 0, DealersPanel__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_9__DealersPanel_css___default.a.checkboxContainer
      }, void 0, DealersPanel__jsx('label', {
        className: __WEBPACK_IMPORTED_MODULE_9__DealersPanel_css___default.a.checkbox
      }, void 0, DealersPanel__jsx('input', {
        type: 'checkbox',
        onChange: this.handleOfficialToggle,
        checked: !!formState.isOfficial
      }), ' ', _ref2))), DealersPanel__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_9__DealersPanel_css___default.a.filterItem
      }, void 0, DealersPanel__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_9__DealersPanel_css___default.a.checkboxContainer
      }, void 0, DealersPanel__jsx('label', {
        className: __WEBPACK_IMPORTED_MODULE_9__DealersPanel_css___default.a.checkbox
      }, void 0, DealersPanel__jsx('input', {
        type: 'checkbox',
        onChange: this.handleTradeInToggle,
        checked: !!formState.tradeIn
      }), ' ', 'Trade In (', DealersPanel__ref3, ')'))), DealersPanel__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_9__DealersPanel_css___default.a.filterItem
      }, void 0, DealersPanel__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_9__DealersPanel_css___default.a.flexContainer
      }, void 0, DealersPanel__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_9__DealersPanel_css___default.a.left
      }, void 0, DealersPanel__jsx('label', {
        className: __WEBPACK_IMPORTED_MODULE_9__DealersPanel_css___default.a.checkbox
      }, void 0, DealersPanel__jsx('input', {
        type: 'checkbox',
        onChange: this.handleTestDriveToggle,
        checked: !!formState.testDrive
      }), ' ', DealersPanel__ref4))))));
    }
  }]);

  return DealersPanel;
}(DealersPanel___WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/* harmony default export */ var DealersPanel_defaultExport = (DealersPanel___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_9__DealersPanel_css___default.a)(__WEBPACK_IMPORTED_MODULE_5_react_intl__["d" /* injectIntl */](DealersPanel)));
// CONCATENATED MODULE: ./src/desktop/components/SearchPanel/DealersPanel/index.js


/* harmony default export */ var SearchPanel_DealersPanel_defaultExport = (DealersPanel_defaultExport);
// CONCATENATED MODULE: ./src/desktop/components/SearchPanel/SparesPanel/SparesPanel.js
/* harmony import */ var SparesPanel___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var SparesPanel___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(SparesPanel___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var SparesPanel___WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var SparesPanel___WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(SparesPanel___WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var SparesPanel___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var SparesPanel___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(SparesPanel___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var SparesPanel___WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(1240);
/* harmony import */ var SparesPanel___WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(SparesPanel___WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var SparesPanel___WEBPACK_IMPORTED_MODULE_4_react_intl__ = __webpack_require__(474);
/* harmony import */ var SparesPanel___WEBPACK_IMPORTED_MODULE_5_react_select__ = __webpack_require__(477);
/* harmony import */ var SparesPanel___WEBPACK_IMPORTED_MODULE_6_shared_components_SearchPanel_transformOptions__ = __webpack_require__(1413);
/* harmony import */ var SparesPanel___WEBPACK_IMPORTED_MODULE_7_shared_components_RegexpInput_RegexpInput__ = __webpack_require__(1255);
/* harmony import */ var SparesPanel___WEBPACK_IMPORTED_MODULE_8__UpdatedSelect_UpdatedSelect__ = __webpack_require__(1431);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__SparesPanel_css__ = __webpack_require__(2003);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__SparesPanel_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__SparesPanel_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__shared_helpers_arrays__ = __webpack_require__(104);
var SparesPanel__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var SparesPanel__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function SparesPanel__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function SparesPanel__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function SparesPanel__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }













var SparesPanel = function (_React$Component) {
  SparesPanel__inherits(SparesPanel, _React$Component);

  function SparesPanel() {
    var _ref;

    var _temp, _this, _ret;

    SparesPanel__classCallCheck(this, SparesPanel);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = SparesPanel__possibleConstructorReturn(this, (_ref = SparesPanel.__proto__ || Object.getPrototypeOf(SparesPanel)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      producer: null,
      stockStatus: null
    }, _this.handleProducerChange = function (producer) {
      var value = producer && producer.value;
      var set = _this.props.selectedActions.set;


      _this.setState({ producer: producer });

      if (value === 1) {
        set.isOriginal(1);
        set.isAnalogue(null);
      } else if (value === 0) {
        set.isOriginal(null);
        set.isAnalogue(1);
      } else {
        set.isOriginal(null);
        set.isAnalogue(null);
      }
    }, _this.handleStockStatusChange = function (status) {
      var value = status && status.value;
      var set = _this.props.selectedActions.set;


      _this.setState({ stockStatus: status });

      if (value === 1) {
        set.inStock(1);
        set.isUnderTheOrder(null);
      } else if (value === 0) {
        set.inStock(null);
        set.isUnderTheOrder(1);
      } else {
        set.inStock(null);
        set.isUnderTheOrder(null);
      }
    }, _temp), SparesPanel__possibleConstructorReturn(_this, _ret);
  }

  SparesPanel__createClass(SparesPanel, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          formVocabulary = _props.formVocabulary,
          formState = _props.formState,
          formData = _props.formData,
          selectedActions = _props.selectedActions,
          intl = _props.intl;

      var selectedSetActions = selectedActions.set;
      var makes = formVocabulary.makes,
          rubrics = formVocabulary.rubrics;
      var models = formData.models,
          sparetypes = formData.sparetypes;

      var makesWithTopMakes = SparesPanel___WEBPACK_IMPORTED_MODULE_6_shared_components_SearchPanel_transformOptions__["a" /* injectTopMakesToOptions */](makes, intl);

      __WEBPACK_IMPORTED_MODULE_10__shared_helpers_arrays__["h" /* sortCollection */](models, 'title');
      __WEBPACK_IMPORTED_MODULE_10__shared_helpers_arrays__["h" /* sortCollection */](rubrics, 'title');
      __WEBPACK_IMPORTED_MODULE_10__shared_helpers_arrays__["h" /* sortCollection */](sparetypes, 'title');

      var _state = this.state,
          producer = _state.producer,
          stockStatus = _state.stockStatus;


      var producers = [{
        title: intl.formatMessage({ id: 'Оригинальный' }),
        value: 1
      }, {
        title: intl.formatMessage({ id: 'Не оригинальный' }),
        value: 0
      }, {
        title: intl.formatMessage({ id: 'Все' }),
        value: null
      }];

      var selectedProducer = producer || formState.isOriginal && producers[0] || formState.isAnalogue && producers[1] || null;

      var stockStatuses = [{
        title: intl.formatMessage({ id: 'В наличии' }),
        value: 1
      }, {
        title: intl.formatMessage({ id: 'Под заказ' }),
        value: 0
      }, {
        title: intl.formatMessage({ id: 'Все' }),
        value: null
      }];

      var selectedStockStatus = stockStatus || formState.inStock && stockStatuses[0] || formState.isUnderTheOrder && stockStatuses[1] || null;

      return SparesPanel__jsx('div', {}, void 0, SparesPanel__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_9__SparesPanel_css___default.a.mainform
      }, void 0, SparesPanel__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_9__SparesPanel_css___default.a.filterItem
      }, void 0, SparesPanel__jsx(SparesPanel___WEBPACK_IMPORTED_MODULE_5_react_select__["a" /* default */], {
        placeholder: intl.formatMessage({ id: 'Марка' }),
        instanceId: 'make-ff',
        name: 'make',
        options: makesWithTopMakes,
        labelKey: 'title',
        valueKey: 'uniqueId',
        disabled: !makes || !makes.length,
        onChange: selectedSetActions.make,
        value: formState.make,
        filterOption: SparesPanel___WEBPACK_IMPORTED_MODULE_6_shared_components_SearchPanel_transformOptions__["b" /* skipTopMakes */]
      })), SparesPanel__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_9__SparesPanel_css___default.a.filterItem
      }, void 0, SparesPanel__jsx(SparesPanel___WEBPACK_IMPORTED_MODULE_8__UpdatedSelect_UpdatedSelect__["a" /* default */], {
        instanceId: 'model-ff',
        name: 'model',
        placeholder: intl.formatMessage({ id: 'Модель' }),
        labelKey: 'title',
        valueKey: 'id',
        disabled: !models || !models.length,
        options: models && models.length > 0 ? models : [],
        onChange: selectedSetActions.model,
        value: formState.model,
        matchPos: 'start'
      })), SparesPanel__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_9__SparesPanel_css___default.a.filterItem
      }, void 0, SparesPanel__jsx(SparesPanel___WEBPACK_IMPORTED_MODULE_7_shared_components_RegexpInput_RegexpInput__["a" /* default */], {
        className: SparesPanel___WEBPACK_IMPORTED_MODULE_3_classnames___default.a(__WEBPACK_IMPORTED_MODULE_9__SparesPanel_css___default.a.input, __WEBPACK_IMPORTED_MODULE_9__SparesPanel_css___default.a.from),
        type: 'text',
        placeholder: intl.formatMessage({ id: 'Год, от' }),
        value: formState.yearFrom || '',
        onChange: selectedSetActions.yearFrom,
        pattern: '^[0-9]+$'
      }), SparesPanel__jsx(SparesPanel___WEBPACK_IMPORTED_MODULE_7_shared_components_RegexpInput_RegexpInput__["a" /* default */], {
        className: SparesPanel___WEBPACK_IMPORTED_MODULE_3_classnames___default.a(__WEBPACK_IMPORTED_MODULE_9__SparesPanel_css___default.a.input, __WEBPACK_IMPORTED_MODULE_9__SparesPanel_css___default.a.to),
        type: 'text',
        placeholder: intl.formatMessage({ id: 'до' }),
        value: formState.yearTo || '',
        onChange: selectedSetActions.yearTo,
        pattern: '^[0-9]+$'
      })), SparesPanel__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_9__SparesPanel_css___default.a.filterItem
      }, void 0, SparesPanel__jsx(SparesPanel___WEBPACK_IMPORTED_MODULE_5_react_select__["a" /* default */], {
        placeholder: intl.formatMessage({ id: 'Тип' }),
        instanceId: 'rubrics-ff',
        name: 'rubrics',
        options: rubrics && rubrics.length > 0 ? rubrics : [],
        labelKey: intl.formatMessage({ id: 'locale' }) === 'uk' ? 'uk_title' : 'title',
        valueKey: 'id',
        onChange: selectedSetActions.rubric,
        value: formState.rubric
      })), SparesPanel__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_9__SparesPanel_css___default.a.filterItem
      }, void 0, SparesPanel__jsx(SparesPanel___WEBPACK_IMPORTED_MODULE_8__UpdatedSelect_UpdatedSelect__["a" /* default */], {
        instanceId: 'sparetypes-ff',
        name: 'sparetypes',
        placeholder: intl.formatMessage({ id: 'Подтип' }),
        labelKey: intl.formatMessage({ id: 'locale' }) === 'uk' ? 'uk_title' : 'title',
        valueKey: 'id',
        disabled: !sparetypes || !sparetypes.length,
        options: sparetypes && sparetypes.length > 0 && sparetypes.map ? sparetypes : [],
        onChange: selectedSetActions.sparetype,
        value: formState.sparetype,
        matchPos: 'start'
      })), SparesPanel__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_9__SparesPanel_css___default.a.filterItem
      }, void 0, SparesPanel__jsx(SparesPanel___WEBPACK_IMPORTED_MODULE_5_react_select__["a" /* default */], {
        placeholder: intl.formatMessage({ id: 'Тип производителя' }),
        instanceId: 'producer-ff',
        name: 'producer',
        options: producers,
        labelKey: 'title',
        valueKey: 'id',
        onChange: this.handleProducerChange,
        value: selectedProducer,
        matchPos: 'start'
      })), SparesPanel__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_9__SparesPanel_css___default.a.filterItem
      }, void 0, SparesPanel__jsx(SparesPanel___WEBPACK_IMPORTED_MODULE_5_react_select__["a" /* default */], {
        placeholder: intl.formatMessage({ id: 'Наличие запчастей' }),
        instanceId: 'stockStatus-ff',
        name: 'stockStatus',
        options: stockStatuses,
        labelKey: 'title',
        valueKey: 'id',
        onChange: this.handleStockStatusChange,
        value: selectedStockStatus
      }))));
    }
  }]);

  return SparesPanel;
}(SparesPanel___WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/* harmony default export */ var SparesPanel_defaultExport = (SparesPanel___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_9__SparesPanel_css___default.a)(SparesPanel___WEBPACK_IMPORTED_MODULE_4_react_intl__["d" /* injectIntl */](SparesPanel)));
// CONCATENATED MODULE: ./src/desktop/components/SearchPanel/SparesPanel/index.js


/* harmony default export */ var SearchPanel_SparesPanel_defaultExport = (SparesPanel_defaultExport);
// CONCATENATED MODULE: ./src/desktop/components/SearchPanel/SearchPanel.js
/* harmony import */ var SearchPanel___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var SearchPanel___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(SearchPanel___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var SearchPanel___WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var SearchPanel___WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(SearchPanel___WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var SearchPanel___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var SearchPanel___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(SearchPanel___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(307);
/* harmony import */ var SearchPanel___WEBPACK_IMPORTED_MODULE_4_react_intl__ = __webpack_require__(474);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__SearchFormBottom_SearchFormBottom__ = __webpack_require__(1887);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__history__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__SearchPanel_css__ = __webpack_require__(2005);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__SearchPanel_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__SearchPanel_css__);
var SearchPanel__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var SearchPanel__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var SearchPanel__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function SearchPanel__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function SearchPanel__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function SearchPanel__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
















var SearchPanel_SearchPanel = function (_React$Component) {
  SearchPanel__inherits(SearchPanel, _React$Component);

  function SearchPanel() {
    var _ref;

    var _temp, _this, _ret;

    SearchPanel__classCallCheck(this, SearchPanel);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = SearchPanel__possibleConstructorReturn(this, (_ref = SearchPanel.__proto__ || Object.getPrototypeOf(SearchPanel)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      collapsed: true,
      type: 'all',
      region: 'all'
    }, _this.setAge = function (age) {
      _this.props.selectedActions.set.isNew(age.id);
      _this.props.formState.isNew = age.id;
      __WEBPACK_IMPORTED_MODULE_12__history__["a" /* default */].push(_this.props.getSearchUrl(_this.props.formState));
    }, _this.toggleCollapse = function () {
      _this.setState(function (prevState) {
        return {
          collapsed: !prevState.collapsed
        };
      });
    }, _temp), SearchPanel__possibleConstructorReturn(_this, _ret);
  }

  SearchPanel__createClass(SearchPanel, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          formState = _props.formState,
          handleClearForm = _props.handleClearForm,
          getSearchUrl = _props.getSearchUrl,
          page = _props.page,
          _props$formData = _props.formData,
          formData = _props$formData === undefined ? {} : _props$formData,
          _props$formResults = _props.formResults,
          formResults = _props$formResults === undefined ? {} : _props$formResults,
          formVocabulary = _props.formVocabulary,
          cardTypes = _props.cardTypes,
          expandable = _props.expandable,
          age = _props.age,
          searchable = _props.searchable,
          withLocation = _props.withLocation,
          isLoading = _props.isLoading,
          count = _props.count,
          intl = _props.intl;


      var newCount = formResults['dealers-AJAX'] && formResults['dealers-AJAX'].count;
      var _state = this.state,
          collapsed = _state.collapsed,
          region = _state.region,
          type = _state.type;

      var url = getSearchUrl(formState);
      var defaultCardType = intl.formatMessage({
        id: 'объявления'
      }, {
        count: count % 100 > 19 ? count % 10 : count % 100
      });

      return SearchPanel__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_13__SearchPanel_css___default.a.root
      }, void 0, SearchPanel__jsx(SearchFormHeader_defaultExport, {
        isNew: page.toLowerCase() === 'dealers' ? formState.hasNew : formState.isNew,
        withLocation: withLocation,
        locations: formVocabulary.locations,
        regionId: region,
        setAge: this.props.setAge || this.setAge,
        age: age
      }), function () {
        switch (page.toLowerCase()) {
          case 'dealers':
            {
              return SearchPanel___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SearchPanel_DealersPanel_defaultExport, SearchPanel__extends({}, _this2.props, { collapsed: collapsed }));
            }
          case 'spares':
            {
              return SearchPanel___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SearchPanel_SparesPanel_defaultExport, SearchPanel__extends({}, _this2.props, { collapsed: collapsed }));
            }
          case 'moto-search':
            {
              return SearchPanel___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SearchPanel_MotoPanel_defaultExport, SearchPanel__extends({}, _this2.props, { collapsed: collapsed }));
            }
          case 'commercial':
            {
              return SearchPanel___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SearchPanel_CommercialPanel_defaultExport, SearchPanel__extends({}, _this2.props, { collapsed: collapsed }));
            }
          case 'search':
            {
              return SearchPanel___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SearchPanel_CarsPanel_defaultExport, SearchPanel__extends({}, _this2.props, { collapsed: collapsed }));
            }
          default:
            {
              return SearchPanel___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SearchPanel_CarsPanel_defaultExport, SearchPanel__extends({}, _this2.props, { collapsed: collapsed }));
            }
        }
      }(), SearchPanel__jsx(__WEBPACK_IMPORTED_MODULE_5__SearchFormBottom_SearchFormBottom__["a" /* default */], {
        count: count,
        collapsed: collapsed,
        type: type,
        url: url,
        expandable: expandable,
        searchable: searchable,
        handleClick: this.toggleCollapse,
        handleClearForm: handleClearForm,
        cardTypes: cardTypes || defaultCardType,
        isLoading: isLoading
      }));
    }
  }]);

  return SearchPanel;
}(SearchPanel___WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

SearchPanel_SearchPanel.defaultProps = {
  expandable: true,
  searchable: true,
  withLocation: true,
  isLoading: false,
  count: 0,
  cardTypes: undefined,
  setAge: null
};

var mapStateToProps = function mapStateToProps(_ref2) {
  var _ref2$searchForm = _ref2.searchForm,
      searchForm = _ref2$searchForm === undefined ? {} : _ref2$searchForm;
  return {
    formResults: searchForm.results,
    count: searchForm.data.count
  };
};
/* harmony default export */ __webpack_exports__["a"] = (SearchPanel___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_13__SearchPanel_css___default.a)(__WEBPACK_IMPORTED_MODULE_3_react_redux__["b" /* connect */](mapStateToProps)(SearchPanel___WEBPACK_IMPORTED_MODULE_4_react_intl__["d" /* injectIntl */](SearchPanel_SearchPanel))));

/***/ }),

/***/ 1979:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1980);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./GroupForm.css", function() {
        content = require("!!../../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./GroupForm.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 1980:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, "._38bjl{display:-webkit-box;display:-ms-flexbox;display:flex;font-size:14px;background-color:#ccc;height:32px;border-radius:2px}._38bjl,.TkETo{position:relative}.TkETo{padding:0 8px;line-height:32px;font-size:13px;-webkit-box-flex:1;-ms-flex:1 0 auto;flex:1 0 auto;text-align:center;white-space:nowrap;-o-text-overflow:ellipsis;text-overflow:ellipsis;overflow:hidden;cursor:pointer}.TkETo:before{position:absolute;left:1px;top:1px;right:1px;bottom:1px;background-color:#fff;content:\" \"}.TkETo:first-child:before{border-radius:2px 0 0 2px}.TkETo:last-child:before{border-radius:0 2px 2px 0}.TkETo+.TkETo:before{left:0}.TkETo:hover:before{background-color:#e4f1fb}.TkETo span{position:relative;vertical-align:top}.TkETo._3rn21:before{background-color:#c9e7ff}", ""]);

// exports
exports.locals = {
	"root": "_38bjl",
	"item": "TkETo",
	"active": "_3rn21"
};

/***/ }),

/***/ 1981:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1982);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./SearchFormHeader.css", function() {
        content = require("!!../../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./SearchFormHeader.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 1982:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, "._2aGtP{position:relative;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-flow:row nowrap;flex-flow:row nowrap;display:-webkit-box;display:-ms-flexbox;display:flex;padding-bottom:10px}._1WHLF{-webkit-box-flex:0;-ms-flex:0 0 auto;flex:0 0 auto;width:calc(33.33333% - 10px)}._1_k26{-webkit-box-flex:1;-ms-flex:1 1 auto;flex:1 1 auto;text-align:right;padding-right:10px}._3ME3Q{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end}._30G9V{width:-webkit-fit-content;width:-moz-fit-content;width:fit-content}", ""]);

// exports
exports.locals = {
	"root": "_2aGtP",
	"left": "_1WHLF",
	"right": "_1_k26",
	"location": "_3ME3Q",
	"locationInput": "_30G9V"
};

/***/ }),

/***/ 1983:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1984);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./ColorsForm.css", function() {
        content = require("!!../../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./ColorsForm.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 1984:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, "._2dqiP{position:relative;display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;padding-right:12px;padding-top:10px;margin-top:-10px;-webkit-transition:all ease-auto .1s;-o-transition:all .1s ease-auto;transition:all ease-auto .1s}._2zkrB{height:40px;overflow:hidden}._17D3k{display:block;position:absolute;right:-4px;top:10px;width:24px;height:24px;margin:3px 0 0;text-align:center}._17D3k img{-webkit-transition:all .15s ease-out;-o-transition:all .15s ease-out;transition:all .15s ease-out}._2zkrB ._17D3k img{-webkit-transform:rotate(180deg);transform:rotate(180deg)}", ""]);

// exports
exports.locals = {
	"root": "_2dqiP",
	"collapsed": "_2zkrB",
	"arrow": "_17D3k"
};

/***/ }),

/***/ 1985:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1986);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./ColorItem.css", function() {
        content = require("!!../../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./ColorItem.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 1986:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, "._2B_D-{display:block;width:24px;height:24px;margin-right:10px;margin-bottom:10px;border-radius:12px;margin-top:3px;position:relative;cursor:pointer}._3ARa9{position:absolute;display:none;top:-30px;-webkit-transition:all .1s ease-out;-o-transition:all .1s ease-out;transition:all .1s ease-out;background-color:rgba(0,0,0,.85);font-size:11px;color:#fff;padding:1px 3px 2px;z-index:82}._2B_D-:hover ._3ARa9{-webkit-transition-delay:.5s;-o-transition-delay:.5s;transition-delay:.5s;display:block;top:-10px}._2i5Ea{border:3px solid #fff}._2i5Ea:before{left:0;top:0;bottom:0;border-radius:12px;right:0;z-index:2;background-color:hsla(0,0%,100%,.8)}._2i5Ea:after,._2i5Ea:before{content:\" \";position:absolute}._2i5Ea:after{left:5px;top:5px;z-index:3;width:10px;height:6px;border-bottom:2px solid #000;border-left:2px solid #000;-webkit-transform:rotate(-45deg);transform:rotate(-45deg)}", ""]);

// exports
exports.locals = {
	"root": "_2B_D-",
	"popover": "_3ARa9",
	"active": "_2i5Ea"
};

/***/ }),

/***/ 1987:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1988);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./OptionsForm.css", function() {
        content = require("!!../../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./OptionsForm.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 1988:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, "._2OYH2{position:relative;display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;padding-right:12px;padding-top:10px;margin-top:-10px;-webkit-transition:all ease-auto .1s;-o-transition:all .1s ease-auto;transition:all ease-auto .1s}", ""]);

// exports
exports.locals = {
	"root": "_2OYH2"
};

/***/ }),

/***/ 1989:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1990);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./CarsPanel.css", function() {
        content = require("!!../../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./CarsPanel.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 1990:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, "._2Mpju,._3T2wH{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-flow:row wrap;flex-flow:row wrap}._2Mpju{margin-top:8px}._3vdR0{position:relative;width:calc(33.33333% - 10px);margin-right:10px;margin-bottom:10px}._1-UsM{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row}._3J3yK{position:relative;margin-left:-1px}._3J3yK,._10ler{-webkit-box-flex:0;-ms-flex:0 0 50%;flex:0 0 50%}._3-5O5{-webkit-box-flex:1;-ms-flex:1 0 auto;flex:1 0 auto;font-size:13px;padding-right:5px;width:50%}._3-5O5 label{line-height:30px}.qfiJX{-webkit-box-flex:1;-ms-flex:1 0 auto;flex:1 0 auto;font-size:13px;padding-left:5px;width:50%}._1YU7d,.qfiJX label{line-height:30px}._1YU7d{position:relative;padding:7px 8px;border-radius:2px;height:32px;border:1px solid #ccc;outline:none;font-size:13px;font-weight:700}._1YU7d:active,._1YU7d:focus{outline:none;border:1px solid #2196f3;z-index:2}._1o3OM{width:50%;border-radius:2px 0 0 2px}._2WaJq{width:50%;margin-left:-1px;border-radius:0 2px 2px 0}._1p2wk,._2WaJq{display:inline-block}._1p2wk{position:relative;cursor:pointer;font-weight:400;font-size:13px;color:#000;padding-left:20px;white-space:nowrap}._1p2wk:hover{color:#ff5a5f}._1p2wk input{position:absolute;left:0;border:1px solid #aaa;border-radius:2px}._1p2wk input,._1p2wk input:checked{top:7px;-webkit-appearance:none;width:15px;height:15px;outline:none}._1p2wk input:checked{border:1px solid #ffd906;background-color:#ffd906;border-radius:2px}._1p2wk input:checked:after{-webkit-appearance:none;position:absolute;font:0/0 a;z-index:2;top:1px;left:-1px;overflow:hidden;width:17px;height:9px;margin-top:-6px;content:\" \";pointer-events:none;border-width:0 0 2px 2px;border-style:solid;border-color:#222;border-radius:1px;background:0 0;-webkit-transform:rotate(315deg);transform:rotate(315deg)}.cicZT{position:relative}._28Ncm{width:195px;margin-bottom:5px}._1vWha,._28Ncm{position:relative;display:block}._1vWha{font-weight:700;padding:3px 0 6px}.cicZT:hover ._1vWha{color:#e73232}", ""]);

// exports
exports.locals = {
	"mainform": "_3T2wH",
	"fullForm": "_2Mpju",
	"filterItem": "_3vdR0",
	"flexContainer": "_1-UsM",
	"selectTo": "_3J3yK",
	"selectFrom": "_10ler",
	"left": "_3-5O5",
	"right": "qfiJX",
	"input": "_1YU7d",
	"from": "_1o3OM",
	"to": "_2WaJq",
	"checkbox": "_1p2wk",
	"generations": "cicZT",
	"genPhoto": "_28Ncm",
	"genText": "_1vWha"
};

/***/ }),

/***/ 1991:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1992);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./TransportPanelAddition.css", function() {
        content = require("!!../../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./TransportPanelAddition.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 1992:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, ".-bKsj{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-flow:row wrap;flex-flow:row wrap;margin-top:8px}._40snq{position:relative;width:calc(33.33333% - 10px);margin-right:10px;margin-bottom:10px}._1KiKM{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row}._2p3AJ{position:relative;margin-left:-1px}._2p3AJ,._19DTd{-webkit-box-flex:0;-ms-flex:0 0 50%;flex:0 0 50%}.qf35t{-webkit-box-flex:1;-ms-flex:1 0 auto;flex:1 0 auto;font-size:13px;padding-right:5px;width:50%}.qf35t label{line-height:30px}._1Bn0F{-webkit-box-flex:1;-ms-flex:1 0 auto;flex:1 0 auto;font-size:13px;padding-left:5px;width:50%}._1Bn0F label,.FAy5E{line-height:30px}.FAy5E{position:relative;padding:7px 8px;border-radius:2px;height:32px;border:1px solid #ccc;outline:none;font-size:13px;font-weight:700}.FAy5E:active,.FAy5E:focus{outline:none;border:1px solid #2196f3;z-index:2}._1rW63{width:50%;border-radius:2px 0 0 2px}._3pGJs{width:50%;margin-left:-1px;border-radius:0 2px 2px 0}._1gxm5,._3pGJs{display:inline-block}._1gxm5{position:relative;cursor:pointer;font-weight:400;font-size:13px;color:#000;padding-left:20px;white-space:nowrap}._1gxm5:hover{color:#ff5a5f}._1gxm5 input{position:absolute;left:0;border:1px solid #aaa;border-radius:2px}._1gxm5 input,._1gxm5 input:checked{top:7px;-webkit-appearance:none;width:15px;height:15px;outline:none}._1gxm5 input:checked{border:1px solid #ffd906;background-color:#ffd906;border-radius:2px}._1gxm5 input:checked:after{-webkit-appearance:none;position:absolute;font:0/0 a;z-index:2;top:1px;left:-1px;overflow:hidden;width:17px;height:9px;margin-top:-6px;content:\" \";pointer-events:none;border-width:0 0 2px 2px;border-style:solid;border-color:#222;border-radius:1px;background:0 0;-webkit-transform:rotate(315deg);transform:rotate(315deg)}", ""]);

// exports
exports.locals = {
	"fullForm": "-bKsj",
	"filterItem": "_40snq",
	"flexContainer": "_1KiKM",
	"selectTo": "_2p3AJ",
	"selectFrom": "_19DTd",
	"left": "qf35t",
	"right": "_1Bn0F",
	"input": "FAy5E",
	"from": "_1rW63",
	"to": "_3pGJs",
	"checkbox": "_1gxm5"
};

/***/ }),

/***/ 1993:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1994);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./TransportNumericOptions.css", function() {
        content = require("!!../../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./TransportNumericOptions.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 1994:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, "._3Wbm_{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-flow:row wrap;flex-flow:row wrap}.ZnNu6{width:calc(33.33333% - 10px);margin-right:10px;margin-bottom:10px}._22Axv,.ZnNu6{position:relative}._22Axv{padding:7px 8px;border-radius:2px;height:32px;line-height:30px;border:1px solid #ccc;outline:none;font-size:13px;font-weight:700}._22Axv:active,._22Axv:focus{outline:none;border:1px solid #2196f3;z-index:2}._3ammL{width:50%;border-radius:2px 0 0 2px}._2Fw59{width:50%;display:inline-block;margin-left:-1px;border-radius:0 2px 2px 0}", ""]);

// exports
exports.locals = {
	"mainform": "_3Wbm_",
	"filterItem": "ZnNu6",
	"input": "_22Axv",
	"from": "_3ammL",
	"to": "_2Fw59"
};

/***/ }),

/***/ 1995:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1996);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./MotoPanel.css", function() {
        content = require("!!../../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./MotoPanel.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 1996:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, ".am3P3,.bHmI_{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-flow:row wrap;flex-flow:row wrap}.am3P3{margin-top:8px}._2uIsL{position:relative;width:calc(33.33333% - 10px);margin-right:10px;margin-bottom:10px}._2QDsN{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row}._1Qi_J{-webkit-box-flex:1;-ms-flex:1 0 auto;flex:1 0 auto;font-size:13px;padding-right:5px;width:50%}._1Qi_J label{line-height:30px}._2j-Fv{-webkit-box-flex:1;-ms-flex:1 0 auto;flex:1 0 auto;font-size:13px;padding-left:5px;width:50%}._2j-Fv label{line-height:30px}", ""]);

// exports
exports.locals = {
	"mainform": "bHmI_",
	"fullForm": "am3P3",
	"filterItem": "_2uIsL",
	"flexContainer": "_2QDsN",
	"left": "_1Qi_J",
	"right": "_2j-Fv"
};

/***/ }),

/***/ 1997:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1998);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./SpecialPanel.css", function() {
        content = require("!!../../../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./SpecialPanel.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 1998:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, "._3qxtC,.BVSoG{width:100%}._3qxtC{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-flow:row wrap;flex-flow:row wrap}._3V-t3{position:relative;width:calc(33.33333% - 10px);margin-right:10px;margin-bottom:10px}._15ogt{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row}._3kREB{-webkit-box-flex:1;-ms-flex:1 0 auto;flex:1 0 auto;font-size:13px;padding-right:5px;width:50%}._3kREB label{line-height:30px}._3HHPw{-webkit-box-flex:1;-ms-flex:1 0 auto;flex:1 0 auto;font-size:13px;padding-left:5px;width:50%}._3HHPw label{line-height:30px}.RX_ck{width:50%;border-radius:2px 0 0 2px}.Vyqyn{width:50%;display:inline-block;margin-left:-1px;border-radius:0 2px 2px 0}._1rJJy{position:relative;padding:7px 8px;border-radius:2px;height:32px;line-height:30px;border:1px solid #ccc;outline:none;font-size:13px;font-weight:700}._1rJJy:active,._1rJJy:focus{outline:none;border:1px solid #2196f3;z-index:2}", ""]);

// exports
exports.locals = {
	"root": "BVSoG",
	"mainform": "_3qxtC",
	"filterItem": "_3V-t3",
	"flexContainer": "_15ogt",
	"left": "_3kREB",
	"right": "_3HHPw",
	"from": "RX_ck",
	"to": "Vyqyn",
	"input": "_1rJJy"
};

/***/ }),

/***/ 1999:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(2000);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./CommercialPanel.css", function() {
        content = require("!!../../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./CommercialPanel.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 2000:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, "._3U0PD{width:100%}._1so4s,._3WUck{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-flow:row wrap;flex-flow:row wrap}._1so4s{margin-top:8px}._1nsEG{position:relative;width:calc(33.33333% - 10px);margin-right:10px;margin-bottom:10px}._1tP4C{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row}._3tZ94{-webkit-box-flex:1;-ms-flex:1 0 auto;flex:1 0 auto;font-size:13px;padding-right:5px;width:50%}._3tZ94 label{line-height:30px}._2Q-I1{-webkit-box-flex:1;-ms-flex:1 0 auto;flex:1 0 auto;font-size:13px;padding-left:5px;width:50%}._2GGsg,._2Q-I1 label{line-height:30px}._2GGsg{position:relative;padding:7px 8px;border-radius:2px;height:32px;border:1px solid #ccc;outline:none;font-size:13px;font-weight:700}._2GGsg:active,._2GGsg:focus{outline:none;border:1px solid #2196f3;z-index:2}.qGRM9{width:50%;border-radius:2px 0 0 2px}.Mmp2-{width:50%;display:inline-block;margin-left:-1px;border-radius:0 2px 2px 0}", ""]);

// exports
exports.locals = {
	"fullWidth": "_3U0PD",
	"mainform": "_3WUck",
	"fullForm": "_1so4s",
	"filterItem": "_1nsEG",
	"flexContainer": "_1tP4C",
	"left": "_3tZ94",
	"right": "_2Q-I1",
	"input": "_2GGsg",
	"from": "qGRM9",
	"to": "Mmp2-"
};

/***/ }),

/***/ 2001:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(2002);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./DealersPanel.css", function() {
        content = require("!!../../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./DealersPanel.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 2002:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, "._1bwAA{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-flow:row wrap;flex-flow:row wrap}._34LCh{position:relative;width:calc(33.33333% - 10px);margin-right:10px;margin-bottom:10px}._29Wjh{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row}.QFZ95{-webkit-box-flex:1;-ms-flex:1 0 auto;flex:1 0 auto;font-size:13px;padding-right:5px;width:50%}.QFZ95 label{line-height:30px}._6UEoo{-webkit-box-flex:1;-ms-flex:1 0 auto;flex:1 0 auto;font-size:13px;padding-left:5px;width:50%}._6UEoo label,.DhEP7{line-height:30px}.DhEP7{position:relative;padding:7px 8px;border-radius:2px;height:32px;border:1px solid #ccc;outline:none;font-size:13px;width:100%;font-weight:700}.DhEP7:active,.DhEP7:focus{outline:none;border:1px solid #2196f3;z-index:2}.EfnXo{line-height:30px}._2Imbp,.EfnXo{position:relative}._2Imbp{display:inline-block;cursor:pointer;font-weight:400;font-size:12px;color:#000;padding-left:20px;white-space:nowrap}._2Imbp:hover{color:#ff5a5f}._2Imbp input{position:absolute;left:0;border:1px solid #aaa;border-radius:2px}._2Imbp input,._2Imbp input:checked{top:7px;-webkit-appearance:none;width:15px;height:15px;outline:none}._2Imbp input:checked{border:1px solid #ffd906;background-color:#ffd906;border-radius:2px}._2Imbp input:checked:after{-webkit-appearance:none;position:absolute;font:0/0 a;z-index:2;top:1px;left:-1px;overflow:hidden;width:17px;height:9px;margin-top:-6px;content:\" \";pointer-events:none;border-width:0 0 2px 2px;border-style:solid;border-color:#222;border-radius:1px;background:0 0;-webkit-transform:rotate(315deg);transform:rotate(315deg)}", ""]);

// exports
exports.locals = {
	"mainform": "_1bwAA",
	"filterItem": "_34LCh",
	"flexContainer": "_29Wjh",
	"left": "QFZ95",
	"right": "_6UEoo",
	"input": "DhEP7",
	"checkboxContainer": "EfnXo",
	"checkbox": "_2Imbp"
};

/***/ }),

/***/ 2003:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(2004);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./SparesPanel.css", function() {
        content = require("!!../../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./SparesPanel.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 2004:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, ".rXOMr{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-flow:row wrap;flex-flow:row wrap}._2Fvpz{width:calc(33.33333% - 10px);margin-right:10px;margin-bottom:10px}._2Fvpz,._3_biK{position:relative}._3_biK{padding:7px 8px;border-radius:2px;height:32px;line-height:30px;border:1px solid #ccc;outline:none;font-size:13px;width:100%;font-weight:700}._3_biK:active,._3_biK:focus{outline:none;border:1px solid #2196f3;z-index:2}._13Uwy{width:50%;border-radius:2px 0 0 2px}._3xVmX{width:50%;display:inline-block;margin-left:-1px;border-radius:0 2px 2px 0}", ""]);

// exports
exports.locals = {
	"mainform": "rXOMr",
	"filterItem": "_2Fvpz",
	"input": "_3_biK",
	"from": "_13Uwy",
	"to": "_3xVmX"
};

/***/ }),

/***/ 2005:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(2006);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./SearchPanel.css", function() {
        content = require("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./SearchPanel.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 2006:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, "._10Y7_{position:relative;padding:15px 4px 12px 15px;background-color:#fff;margin-bottom:20px;font-weight:400}._10Y7_ .Select-control{border:1px solid #ccc;border-radius:2px;height:30px;font-size:13px;line-height:1em;font-weight:400}._10Y7_ .Select-control:hover{-webkit-box-shadow:none;box-shadow:none;border-color:#2196f3}._10Y7_ .Select-input{height:30px;line-height:30px;font-size:13px}._10Y7_ .Select-placeholder{line-height:30px;font-size:13px;font-weight:400;color:#666;font-family:sans-serif}._10Y7_ .Select-menu-outer{margin-top:3px;font-size:13px;line-height:1.03;color:#000;min-width:100%;width:auto;z-index:4;border-radius:2px;border:1px solid #e0e0e0;-webkit-box-shadow:0 4px 16px rgba(0,0,0,.18);box-shadow:0 4px 16px rgba(0,0,0,.18)}._10Y7_ .Select--single>.Select-control .Select-value{line-height:30px;font-weight:700;color:#000}._10Y7_ .Select-option:not(.is-disabled){color:#000;white-space:nowrap}._10Y7_ .Select-clear{color:#666}._10Y7_ .Select.is-disabled>.Select-control .Select-placeholder{color:#888}._10Y7_ ::-webkit-input-placeholder{font-weight:400}._10Y7_ ::-moz-placeholder{font-weight:400}._10Y7_ :-ms-input-placeholder{font-weight:400}._10Y7_ :-moz-placeholder{font-weight:400}", ""]);

// exports
exports.locals = {
	"root": "_10Y7_"
};

/***/ }),

/***/ 2426:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();




function ListAds(props) {
  var index = props.index,
      rootClassName = props.rootClassName;


  return _jsx('div', {
    className: rootClassName || undefined
  }, void 0, (index === 7 || index === 17) && _jsx('ins', {
    className: 'adsbygoogle',
    style: { display: 'block' },
    'data-ad-format': 'fluid',
    'data-ad-layout-key': '-et+5k+6r-el+2s',
    'data-ad-client': 'ca-pub-8183181871645898',
    'data-ad-slot': '3991950634'
  }));
}

ListAds.defaultProps = {
  rootClassName: null
};


/* harmony default export */ __webpack_exports__["a"] = (ListAds);

/***/ }),

/***/ 2436:
/***/ (function(module, exports) {

module.exports = [{"id":1943,"slug":"kievskaya-obl","is_country":false,"title":"Киевская область","uk_title":"Київська область","is_region":true,"is_city":false,"is_admin_center":false},{"id":29834,"slug":"ar-krym","is_country":false,"title":"АР Крым","uk_title":"АР Крим","is_region":true,"is_city":false,"is_admin_center":false},{"id":116051,"slug":"vinnytska-oblast","is_country":false,"title":"Винницкая область","uk_title":"Вінницька область","is_region":true,"is_city":false,"is_admin_center":false},{"id":116053,"slug":"volynska-oblast","is_country":false,"title":"Волынская область","uk_title":"Волинська область","is_region":true,"is_city":false,"is_admin_center":false},{"id":116054,"slug":"dnipropetrovska-oblast","is_country":false,"title":"Днепропетровская область","uk_title":"Дніпропетровська область","is_region":true,"is_city":false,"is_admin_center":false},{"id":116056,"slug":"donetska-oblast","is_country":false,"title":"Донецкая область","uk_title":"Донецька область","is_region":true,"is_city":false,"is_admin_center":false},{"id":116063,"slug":"zhytomyrska-oblast","is_country":false,"title":"Житомирская область","uk_title":"Житомирська область","is_region":true,"is_city":false,"is_admin_center":false},{"id":116064,"slug":"zakarpatska-oblast","is_country":false,"title":"Закарпатская область","uk_title":"Закарпатська область","is_region":true,"is_city":false,"is_admin_center":false},{"id":116065,"slug":"zaporizka-oblast","is_country":false,"title":"Запорожская область","uk_title":"Запорізька область","is_region":true,"is_city":false,"is_admin_center":false},{"id":116066,"slug":"ivano-frankivska-oblast","is_country":false,"title":"Ивано-Франковская область","uk_title":"Івано-Франківська область","is_region":true,"is_city":false,"is_admin_center":false},{"id":116067,"slug":"kirovohradska-oblast","is_country":false,"title":"Кировоградская область","uk_title":"Кіровоградська область","is_region":true,"is_city":false,"is_admin_center":false},{"id":116068,"slug":"luhanska-oblast","is_country":false,"title":"Луганская область","uk_title":"Луганська область","is_region":true,"is_city":false,"is_admin_center":false},{"id":116077,"slug":"lvivska-oblast","is_country":false,"title":"Львовская область","uk_title":"Львівська область","is_region":true,"is_city":false,"is_admin_center":false},{"id":116078,"slug":"mykolaivska-oblast","is_country":false,"title":"Николаевская область","uk_title":"Миколаївська область","is_region":true,"is_city":false,"is_admin_center":false},{"id":116081,"slug":"odeska-oblast","is_country":false,"title":"Одесская область","uk_title":"Одеська область","is_region":true,"is_city":false,"is_admin_center":false},{"id":116082,"slug":"poltavska-oblast","is_country":false,"title":"Полтавская область","uk_title":"Полтавська область","is_region":true,"is_city":false,"is_admin_center":false},{"id":116083,"slug":"rivnenska-oblast","is_country":false,"title":"Ровенская область","uk_title":"Рівненська область","is_region":true,"is_city":false,"is_admin_center":false},{"id":116084,"slug":"sumska-oblast","is_country":false,"title":"Сумская область","uk_title":"Сумська область","is_region":true,"is_city":false,"is_admin_center":false},{"id":116085,"slug":"ternopilska-oblast","is_country":false,"title":"Тернопольская область","uk_title":"Тернопільська область","is_region":true,"is_city":false,"is_admin_center":false},{"id":116086,"slug":"kharkivska-oblast","is_country":false,"title":"Харьковская область","uk_title":"Харківська область","is_region":true,"is_city":false,"is_admin_center":false},{"id":116089,"slug":"khersonska-oblast","is_country":false,"title":"Херсонская область","uk_title":"Херсонська область","is_region":true,"is_city":false,"is_admin_center":false},{"id":116090,"slug":"khmelnytska-oblast","is_country":false,"title":"Хмельницкая область","uk_title":"Хмельницька область","is_region":true,"is_city":false,"is_admin_center":false},{"id":116091,"slug":"cherkaska-oblast","is_country":false,"title":"Черкасская область","uk_title":"Черкаська область","is_region":true,"is_city":false,"is_admin_center":false},{"id":116093,"slug":"chernivetska-oblast","is_country":false,"title":"Черновицкая область","uk_title":"Чернівецька область","is_region":true,"is_city":false,"is_admin_center":false},{"id":116096,"slug":"chernihivska-oblast","is_country":false,"title":"Черниговская область","uk_title":"Чернігівська область","is_region":true,"is_city":false,"is_admin_center":false}]

/***/ }),

/***/ 2437:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_query_string__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_query_string___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_query_string__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_snakecase_keys__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_snakecase_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_snakecase_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_constants_api__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_intl__ = __webpack_require__(474);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_shared_components_Link__ = __webpack_require__(1241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_shared_constants_json_currency_json__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_shared_constants_json_currency_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_shared_constants_json_currency_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Carousel_Carousel__ = __webpack_require__(1754);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__AdvertCard_AdvertCard__ = __webpack_require__(1850);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__shared_hocs_withFetch__ = __webpack_require__(1244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__TopAvtosalon_css__ = __webpack_require__(2438);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__TopAvtosalon_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__TopAvtosalon_css__);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _this = this;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }














var uah = __WEBPACK_IMPORTED_MODULE_7_shared_constants_json_currency_json___default.a.find(function (item) {
  return item.slug === 'uah';
});
var PER_PAGE = 20;
var IMAGE_WIDTH = 240;

var fetchTopDealer = function fetchTopDealer(fetch, params) {
  return fetch(__WEBPACK_IMPORTED_MODULE_3_shared_constants_api__["a" /* default */].DEALERS.ALL('?' + __WEBPACK_IMPORTED_MODULE_1_query_string___default.a.stringify(__WEBPACK_IMPORTED_MODULE_2_snakecase_keys___default.a(_extends({
    isTop: 1,
    perPage: 1
  }, params))))).then(function (r) {
    return r.json();
  });
};

var fetchTopDealerCars = function fetchTopDealerCars(fetch, dealer, params) {
  if (!dealer) {
    return Promise.resolve();
  }

  return fetch(__WEBPACK_IMPORTED_MODULE_3_shared_constants_api__["a" /* default */].ADVERT.ALL('?' + __WEBPACK_IMPORTED_MODULE_1_query_string___default.a.stringify(__WEBPACK_IMPORTED_MODULE_2_snakecase_keys___default.a(_extends({
    dealer: dealer.id,
    perPage: PER_PAGE
  }, params && params.transport ? { transport: params.transport } : {}))))).then(function (r) {
    return r.json();
  });
};
// eslint-disable-next-line no-unused-vars
var fetchDealer = function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(data) {
    var _data$props, additionParams, fetch;

    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _data$props = data.props, additionParams = _data$props.additionParams, fetch = _data$props.fetch;


            data.setState({ dealer: null, cars: null, isFetching: true });

            return _context.abrupt('return', Promise.all([fetchTopDealer(fetch, additionParams)]).then(function (_ref2) {
              var _ref3 = _slicedToArray(_ref2, 1),
                  dealers = _ref3[0];

              var dealer = dealers && dealers[0] || null;
              data.setState({ dealer: dealer, isFetching: false });
            }));

          case 3:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, _this);
  }));

  return function fetchDealer(_x) {
    return _ref.apply(this, arguments);
  };
}();

// eslint-disable-next-line no-unused-vars
var fetchDealerCars = function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(data) {
    var dealer, _data$props2, _data$props2$addition, additionParams, fetch;

    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            dealer = data.state.dealer;
            _data$props2 = data.props, _data$props2$addition = _data$props2.additionParams, additionParams = _data$props2$addition === undefined ? {} : _data$props2$addition, fetch = _data$props2.fetch;

            if (dealer) {
              _context2.next = 4;
              break;
            }

            return _context2.abrupt('return', Promise.resolve());

          case 4:

            data.setState({ cars: null, isFetching: true });

            return _context2.abrupt('return', Promise.all([fetchTopDealerCars(fetch, dealer, additionParams)]).then(function (_ref5) {
              var _ref6 = _slicedToArray(_ref5, 1),
                  cars = _ref6[0];

              return data.setState({ cars: cars.results, isFetching: false });
            }));

          case 6:
          case 'end':
            return _context2.stop();
        }
      }
    }, _callee2, _this);
  }));

  return function fetchDealerCars(_x2) {
    return _ref4.apply(this, arguments);
  };
}();

var _ref8 = _jsx(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */], {
  id: '\u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0439'
});

var TopAvtosalon = function (_React$Component) {
  _inherits(TopAvtosalon, _React$Component);

  function TopAvtosalon() {
    var _ref7;

    var _temp, _this2, _ret;

    _classCallCheck(this, TopAvtosalon);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this2 = _possibleConstructorReturn(this, (_ref7 = TopAvtosalon.__proto__ || Object.getPrototypeOf(TopAvtosalon)).call.apply(_ref7, [this].concat(args))), _this2), _this2.state = {
      dealer: null,
      cars: null,
      isFetching: false
    }, _temp), _possibleConstructorReturn(_this2, _ret);
  }

  _createClass(TopAvtosalon, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      /** temporary solution * */
      // fetchDealer(this);
      // fetchDealerCars(this);
    }
  }, {
    key: 'render',
    value: function render() {
      var _state = this.state,
          dealer = _state.dealer,
          fetchedCars = _state.cars;

      if (!dealer) {
        return null;
      }

      var cars = fetchedCars && fetchedCars.length > 0 ? fetchedCars.slice(0, 20) : null;

      var advertsCount = dealer.adverts_count;

      var imageStyles = { height: '200px' };
      var avtosalonUrl = '/avtosalony/' + dealer.slug + '/';

      return _jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_11__TopAvtosalon_css___default.a.root
      }, void 0, _jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_11__TopAvtosalon_css___default.a.head
      }, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_6_shared_components_Link__["a" /* default */], {
        to: avtosalonUrl,
        className: __WEBPACK_IMPORTED_MODULE_11__TopAvtosalon_css___default.a.title
      }, void 0, dealer.title), _jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_11__TopAvtosalon_css___default.a.adr
      }, void 0, dealer.address), dealer.logo && _jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_11__TopAvtosalon_css___default.a.logo
      }, void 0, _jsx('img', {
        src: dealer.logo,
        width: '60',
        alt: ''
      }))), cars && _jsx(__WEBPACK_IMPORTED_MODULE_8__Carousel_Carousel__["a" /* default */], {
        step: 1,
        itemsInRow: 1,
        loop: true,
        classNames: {
          body: __WEBPACK_IMPORTED_MODULE_11__TopAvtosalon_css___default.a.carouselBody
        },
        header: _jsx('div', {
          className: __WEBPACK_IMPORTED_MODULE_11__TopAvtosalon_css___default.a.count
        }, void 0, advertsCount, ' ', _ref8),
        items: cars.map(function (car) {
          return _jsx(__WEBPACK_IMPORTED_MODULE_9__AdvertCard_AdvertCard__["a" /* default */], {
            item: car,
            currency: uah,
            cardType: 'simple',
            imageStyle: imageStyles,
            advertClassName: __WEBPACK_IMPORTED_MODULE_11__TopAvtosalon_css___default.a.advertItem,
            advertThumbClassName: __WEBPACK_IMPORTED_MODULE_11__TopAvtosalon_css___default.a.advertThumbItem,
            width: IMAGE_WIDTH
          }, car.id);
        })
      }));
    }
  }]);

  return TopAvtosalon;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_4_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_11__TopAvtosalon_css___default.a)(__WEBPACK_IMPORTED_MODULE_10__shared_hocs_withFetch__["a" /* withFetch */](TopAvtosalon)));

/***/ }),

/***/ 2438:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(2439);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./TopAvtosalon.css", function() {
        content = require("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./TopAvtosalon.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 2439:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, ".xcAO8{position:relative;background-color:#fff;padding:2px 10px 0;min-height:240px;z-index:1;-webkit-box-shadow:0 2px 8px rgba(0,0,0,.04);box-shadow:0 2px 8px rgba(0,0,0,.04);border-radius:2px;-webkit-transition:all .1s ease-out;-o-transition:all .1s ease-out;transition:all .1s ease-out;font-weight:400;margin-bottom:20px}._1d9bv{padding:0!important}._2tFfJ{width:290px;padding:0 5px}._3_M_0{padding-bottom:0}._1prcS{position:relative;margin-bottom:3px;padding-top:7px;padding-bottom:10px;border-bottom:1px solid #e0e0e0;padding-right:90px}.jUsJd{position:absolute;right:0;top:10px}._27vpz{position:relative;font-size:15px;text-decoration:none;font-weight:700;color:#000;margin-bottom:3px;display:inline-block}.jSZTh{padding-bottom:2px;font-size:13px}._1W4CN{position:relative;font-size:13px;line-height:44px;color:#000}", ""]);

// exports
exports.locals = {
	"root": "xcAO8",
	"advertThumbItem": "_1d9bv",
	"advertItem": "_2tFfJ",
	"carouselBody": "_3_M_0",
	"head": "_1prcS",
	"logo": "jUsJd",
	"title": "_27vpz",
	"adr": "jSZTh",
	"count": "_1W4CN"
};

/***/ }),

/***/ 2440:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// CONCATENATED MODULE: ./src/shared/components/DealerItem/DealerItem.js
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(1240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_intl__ = __webpack_require__(474);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_shared_components_Link__ = __webpack_require__(1241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_shared_constants_gtmEvents__ = __webpack_require__(1243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_shared_actions_globals__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_shared_hocs_withPixelRatio__ = __webpack_require__(1391);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_shared_components_UI__ = __webpack_require__(1268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_shared_hocs_stats_withStatsEvents__ = __webpack_require__(1439);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_shared_components_ModalContainer_ModalContainer__ = __webpack_require__(1256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_shared_components_DealerServiceForm_DealerServiceForm__ = __webpack_require__(1877);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_shared_components_DealerServiceForm_ThanksBlock__ = __webpack_require__(1880);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_shared_hocs_withTranslate__ = __webpack_require__(1242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_shared_assets_icons_dealer_isChecked_svg__ = __webpack_require__(2441);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_shared_assets_icons_dealer_isChecked_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_shared_assets_icons_dealer_isChecked_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_shared_components_DealerItem_Icons_TradeIn__ = __webpack_require__(1972);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_shared_components_DealerItem_Icons_TestDrive__ = __webpack_require__(1973);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_shared_assets_icons_dealer_guarantee_svg__ = __webpack_require__(2442);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_shared_assets_icons_dealer_guarantee_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_shared_assets_icons_dealer_guarantee_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_shared_helpers_rtbHouse__ = __webpack_require__(491);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__DealerItem_css__ = __webpack_require__(2443);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__DealerItem_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__DealerItem_css__);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// TODO: tech debt, refactor it, priority: medium. Also move to shared folder and create common css























// import { IsVerifiedElement } from 'shared/components/Elements';



var _ref2 = _jsx(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */], {
  id: '\u041F\u0440\u043E\u0432\u0435\u0440\u0435\u043D\u043D\u044B\u0439 \u043F\u0430\u0440\u0442\u043D\u0451\u0440'
});

var _ref3 = _jsx(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */], {
  id: '\u0410\u0441\u0441\u043E\u0446\u0438\u0430\u0446\u0438\u044F \u0433\u0430\u0440\u0430\u043D\u0442\u0438\u0440\u0443\u0435\u0442'
});

var _ref4 = _jsx(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */], {
  id: '\u041E\u0444\u0438\u0446\u0438\u0430\u043B\u044C\u043D\u044B\u0439 \u0434\u0438\u043B\u0435\u0440'
});

var _ref5 = _jsx(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */], {
  id: '\u043F\u0440\u0435\u0434\u043B\u043E\u0436\u0435\u043D\u0438\u0439'
});

var _ref6 = _jsx(__WEBPACK_IMPORTED_MODULE_14_shared_components_DealerServiceForm_ThanksBlock__["a" /* default */], {});

var _ref7 = _jsx(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */], {
  id: '\u0417\u0430\u044F\u0432\u043A\u0430 \u043D\u0430'
});

var _ref8 = _jsx(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */], {
  id: 'USER_AGREEMENT_DLG_TITLE_1'
});

var _ref9 = _jsx('br', {});

var _ref10 = _jsx(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */], {
  id: 'USER_AGREEMENT_DLG_TITLE_2'
});

var DealerItem = function (_React$Component) {
  _inherits(DealerItem, _React$Component);

  function DealerItem() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, DealerItem);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = DealerItem.__proto__ || Object.getPrototypeOf(DealerItem)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      emailSent: false,
      showDealerServiceModal: false,
      currentService: ''
    }, _this.onEmailSent = function (serviceType) {
      _this.setState({ emailSent: true });
      setTimeout(function () {
        _this.closeServiceModal();
      }, 5000);

      var eventName = { 'Trade-in': 'formTradeIn', 'Тест-драйв': 'formTestDrive' };
      var gtmEvent = __WEBPACK_IMPORTED_MODULE_7_shared_constants_gtmEvents__["a" /* EVENTS */].DEALERS[eventName[serviceType]];
      if (gtmEvent) _this.props.setDataLayer(gtmEvent);

      __WEBPACK_IMPORTED_MODULE_20_shared_helpers_rtbHouse__["a" /* fireRTBEvent */](eventName[serviceType], {
        ids: [_this.props.dealer.slug]
      });
    }, _this.handleShowPhonesClick = function () {
      var _this$props = _this.props,
          id = _this$props.dealer.id,
          events = _this$props.events;

      events.dispatchDealerShowPhoneEvent(id);
      _this.props.setDataLayer(__WEBPACK_IMPORTED_MODULE_7_shared_constants_gtmEvents__["a" /* EVENTS */].DEALERS.showNubmer);
      __WEBPACK_IMPORTED_MODULE_20_shared_helpers_rtbHouse__["a" /* fireRTBEvent */]('showNubmer', {
        ids: [_this.props.dealer.slug]
      });
    }, _this.handleAllAdvertsClick = function () {
      _this.props.setDataLayer(__WEBPACK_IMPORTED_MODULE_7_shared_constants_gtmEvents__["a" /* EVENTS */].showAllDealerAdverts);
    }, _this.handleRemovalModalClose = function () {
      _this.setState({ isDeactivateModalOpen: false, isRemovalModalOpened: false });
    }, _this.openServiceModal = function (event, serviceType) {
      _this.setState({
        showDealerServiceModal: true,
        currentService: serviceType
      });
      var eventName = { 'Trade-in': 'tradeIn', 'Тест-драйв': 'testDrive' };
      var gtmEvent = __WEBPACK_IMPORTED_MODULE_7_shared_constants_gtmEvents__["a" /* EVENTS */].DEALERS[eventName[serviceType]];
      if (gtmEvent) _this.props.setDataLayer(gtmEvent);
    }, _this.closeServiceModal = function () {
      _this.setState({
        showDealerServiceModal: false,
        emailSent: false
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(DealerItem, [{
    key: 'render',
    value: function render() {
      var _cx,
          _this2 = this;

      var _props = this.props,
          dealer = _props.dealer,
          urlPrefix = _props.url,
          setRatioImage = _props.setRatioImage,
          t = _props.t;

      var url = urlPrefix ? '' + urlPrefix + dealer.slug + '/' : '/avtosalony/' + dealer.slug + '/';
      var title = dealer.title,
          logo = dealer.logo,
          address = dealer.address,
          phones = dealer.phones,
          _dealer$adverts_count = dealer.adverts_count,
          advertsCount = _dealer$adverts_count === undefined ? t('Нет') : _dealer$adverts_count,
          _dealer$is_official = dealer.is_official,
          isOfficial = _dealer$is_official === undefined ? false : _dealer$is_official,
          isVerified = dealer.is_verified,
          isGuarantee = dealer.association_guarantees,
          isVip = dealer.tariff_vip,
          isStandart = dealer.tariff_standart,
          isStart = dealer.tariff_start,
          testDrive = dealer.test_drive,
          tradeIn = dealer.trade_in;


      var tags = [{
        title: t('Тест-драйв'),
        icon: __WEBPACK_IMPORTED_MODULE_18_shared_components_DealerItem_Icons_TestDrive__["a" /* default */],
        available: testDrive
      }, {
        title: 'Trade-in',
        icon: __WEBPACK_IMPORTED_MODULE_17_shared_components_DealerItem_Icons_TradeIn__["a" /* default */],
        available: tradeIn
      }];

      var IMAGE_WIDTH = 100;

      var logoImg = logo && setRatioImage(logo.replace('http:', 'https:'), IMAGE_WIDTH);

      /* const locale = t('locale') === 'ru' ? '' : `${t('locale')}_`;
      const agreementLink = `/pdf/${locale}terms-of-use.pdf`; */

      return _jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_1_classnames___default.a(__WEBPACK_IMPORTED_MODULE_21__DealerItem_css___default.a.root, (_cx = {}, _defineProperty(_cx, __WEBPACK_IMPORTED_MODULE_21__DealerItem_css___default.a.isVip, isVip), _defineProperty(_cx, __WEBPACK_IMPORTED_MODULE_21__DealerItem_css___default.a.isStandart, isStandart), _cx))
      }, void 0, isVip && _jsx('span', {
        className: __WEBPACK_IMPORTED_MODULE_21__DealerItem_css___default.a.vipBadge
      }, void 0, '\u0422\u041E\u041F'), _jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_21__DealerItem_css___default.a.left
      }, void 0, _jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_21__DealerItem_css___default.a.logo
      }, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_6_shared_components_Link__["a" /* default */], {
        to: url
      }, void 0, _jsx('img', {
        className: __WEBPACK_IMPORTED_MODULE_21__DealerItem_css___default.a.img,
        src: logoImg,
        width: IMAGE_WIDTH,
        alt: ''
      })))), _jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_21__DealerItem_css___default.a.right
      }, void 0, _jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_21__DealerItem_css___default.a.titleWithButton
      }, void 0, _jsx('div', {}, void 0, isVerified && _jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_21__DealerItem_css___default.a.isVerified
      }, void 0, _jsx('img', {
        src: __WEBPACK_IMPORTED_MODULE_16_shared_assets_icons_dealer_isChecked_svg___default.a,
        className: __WEBPACK_IMPORTED_MODULE_21__DealerItem_css___default.a.isVerifiedIcon,
        alt: '\u041F\u0440\u043E\u0432\u0435\u0440\u0435\u043D\u043D\u044B\u0439 \u043F\u0430\u0440\u0442\u043D\u0451\u0440'
      }), _ref2), isGuarantee && _jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_21__DealerItem_css___default.a.isGuarantee
      }, void 0, _jsx('img', {
        src: __WEBPACK_IMPORTED_MODULE_19_shared_assets_icons_dealer_guarantee_svg___default.a,
        className: __WEBPACK_IMPORTED_MODULE_21__DealerItem_css___default.a.isGuaranteeIcon,
        alt: '\u0410\u0441\u0441\u043E\u0446\u0438\u0430\u0446\u0438\u044F \u0433\u0430\u0440\u0430\u043D\u0442\u0438\u0440\u0443\u0435\u0442'
      }), _ref3), _jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_21__DealerItem_css___default.a.title
      }, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_6_shared_components_Link__["a" /* default */], {
        className: __WEBPACK_IMPORTED_MODULE_21__DealerItem_css___default.a.link,
        to: url
      }, void 0, title)), isOfficial && _jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_21__DealerItem_css___default.a.isOfficial
      }, void 0, _ref4), _jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_21__DealerItem_css___default.a.adr
      }, void 0, address)), _jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_21__DealerItem_css___default.a.contactPhoneButton
      }, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_10_shared_components_UI__["b" /* ContactPhoneButton */], {
        clickHandler: this.handleShowPhonesClick,
        phones: phones
      }))), _jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_21__DealerItem_css___default.a.tags
      }, void 0, tags.map(function (item) {
        return _jsx(__WEBPACK_IMPORTED_MODULE_10_shared_components_UI__["h" /* TagButton */], {
          title: item.title,
          clickHandler: _this2.openServiceModal,
          Icon: item.icon,
          disabled: !item.available
        }, item.title);
      })), _jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_21__DealerItem_css___default.a.adverts
      }, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_6_shared_components_Link__["a" /* default */], {
        onClick: this.handleAllAdvertsClick,
        to: url,
        className: __WEBPACK_IMPORTED_MODULE_21__DealerItem_css___default.a.allAdvertsLink
      }, void 0, advertsCount, ' ', _ref5)), this.state.showDealerServiceModal && _jsx('div', {}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_12_shared_components_ModalContainer_ModalContainer__["a" /* default */], {
        modalCN: __WEBPACK_IMPORTED_MODULE_21__DealerItem_css___default.a.modal,
        onClose: this.closeServiceModal,
        isOpen: this.state.showDealerServiceModal
      }, void 0, _jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_21__DealerItem_css___default.a.rootModal
      }, void 0, _jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_21__DealerItem_css___default.a.rootModalBody
      }, void 0, this.state.emailSent ? _ref6 : _jsx(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment, {}, void 0, _jsx('h3', {
        className: __WEBPACK_IMPORTED_MODULE_21__DealerItem_css___default.a.rootModalTitle
      }, void 0, _ref7, ' ', this.state.currentService), _jsx(__WEBPACK_IMPORTED_MODULE_13_shared_components_DealerServiceForm_DealerServiceForm__["a" /* default */], {
        dealerSlug: dealer.slug,
        service: this.state.currentService,
        onSent: function onSent() {
          return _this2.onEmailSent(_this2.state.currentService);
        }
      }), _jsx('p', {
        className: __WEBPACK_IMPORTED_MODULE_21__DealerItem_css___default.a.modalText + ' ' + __WEBPACK_IMPORTED_MODULE_21__DealerItem_css___default.a.rootModalPolicy
      }, void 0, _ref8, _ref9, _jsx(__WEBPACK_IMPORTED_MODULE_6_shared_components_Link__["a" /* default */], {
        className: __WEBPACK_IMPORTED_MODULE_21__DealerItem_css___default.a.modalTextLink
      }, void 0, '', _ref10))), _jsx('i', {
        className: __WEBPACK_IMPORTED_MODULE_1_classnames___default.a(_defineProperty({
          'fa fa-times': true
        }, __WEBPACK_IMPORTED_MODULE_21__DealerItem_css___default.a.closeBtnIcon, true)),
        onClick: this.closeServiceModal
      })))))));
    }
  }]);

  return DealerItem;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

DealerItem.defaultProps = {
  type: 'dealer',
  url: null
};


/* harmony default export */ var DealerItem_defaultExport = (__WEBPACK_IMPORTED_MODULE_5_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_21__DealerItem_css___default.a)(__WEBPACK_IMPORTED_MODULE_3_react_redux__["b" /* connect */](null, { setDataLayer: __WEBPACK_IMPORTED_MODULE_8_shared_actions_globals__["j" /* setDataLayer */] })(__WEBPACK_IMPORTED_MODULE_15_shared_hocs_withTranslate__["a" /* withTranslate */](__WEBPACK_IMPORTED_MODULE_11_shared_hocs_stats_withStatsEvents__["a" /* default */](__WEBPACK_IMPORTED_MODULE_9_shared_hocs_withPixelRatio__["a" /* default */](DealerItem))))));
// CONCATENATED MODULE: ./src/desktop/components/DealerItem/LegacyDealerItem.js
/* harmony import */ var LegacyDealerItem___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var LegacyDealerItem___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(LegacyDealerItem___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(1240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var LegacyDealerItem___WEBPACK_IMPORTED_MODULE_4_react_intl__ = __webpack_require__(474);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_shared_components_Link__ = __webpack_require__(1241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_shared_constants_gtmEvents__ = __webpack_require__(1243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_shared_actions_globals__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_shared_hocs_withPixelRatio__ = __webpack_require__(1391);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_shared_components_StoAwards_StoAwards__ = __webpack_require__(1974);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var LegacyDealerItem___WEBPACK_IMPORTED_MODULE_11_shared_hocs_stats_withStatsEvents__ = __webpack_require__(1439);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_shared_components_AutobookingForm__ = __webpack_require__(1883);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_shared_components_DealerWebsiteLink_DealerWebsiteLink__ = __webpack_require__(1755);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__LegacyDealerItem_css__ = __webpack_require__(2445);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__LegacyDealerItem_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__LegacyDealerItem_css__);
var LegacyDealerItem__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var LegacyDealerItem__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function LegacyDealerItem__defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function LegacyDealerItem__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function LegacyDealerItem__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function LegacyDealerItem__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




















var isMobile = "desktop" === 'mobile';

// TODO: Need refactrotoring to use with firms only, no Dealers.
// For Dealers should be DealerItems only.

var LegacyDealerItem__ref2 = LegacyDealerItem__jsx(LegacyDealerItem___WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */], {
  id: '\u041E\u0444\u0438\u0446\u0438\u0430\u043B\u044C\u043D\u044B\u0439 \u0434\u0438\u043B\u0435\u0440'
});

var LegacyDealerItem__ref3 = LegacyDealerItem__jsx(LegacyDealerItem___WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */], {
  id: '\u043F\u0440\u0435\u0434\u043B\u043E\u0436\u0435\u043D\u0438\u0439'
});

var LegacyDealerItem__ref5 = LegacyDealerItem__jsx(LegacyDealerItem___WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */], {
  id: '\u041D\u0435\u0442 \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u043E\u0432'
});

var LegacyDealerItem__ref6 = LegacyDealerItem__jsx(LegacyDealerItem___WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */], {
  id: '\u041F\u043E\u043A\u0430\u0437\u0430\u0442\u044C \u0442\u0435\u043B\u0435\u0444\u043E\u043D'
});

var LegacyDealerItem__ref7 = LegacyDealerItem__jsx(LegacyDealerItem___WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */], {
  id: '\u041F\u0435\u0440\u0435\u0439\u0442\u0438 \u043D\u0430 \u0441\u0430\u0439\u0442'
});

var LegacyDealerItem = function (_React$Component) {
  LegacyDealerItem__inherits(LegacyDealerItem, _React$Component);

  function LegacyDealerItem() {
    var _ref;

    var _temp, _this, _ret;

    LegacyDealerItem__classCallCheck(this, LegacyDealerItem);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = LegacyDealerItem__possibleConstructorReturn(this, (_ref = LegacyDealerItem.__proto__ || Object.getPrototypeOf(LegacyDealerItem)).call.apply(_ref, [this].concat(args))), _this), _this.state = { isShowedPhones: false }, _this.handleShowPhonesClick = function () {
      var _this$props = _this.props,
          id = _this$props.dealer.id,
          events = _this$props.events;

      events.dispatchDealerShowPhoneEvent(id);
      _this.setState({ isShowedPhones: true });
    }, _this.handleAllAdvertsClick = function () {
      _this.props.setDataLayer(__WEBPACK_IMPORTED_MODULE_6_shared_constants_gtmEvents__["a" /* EVENTS */].showAllDealerAdverts);
    }, _temp), LegacyDealerItem__possibleConstructorReturn(_this, _ret);
  }

  LegacyDealerItem__createClass(LegacyDealerItem, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          dealer = _props.dealer,
          type = _props.type,
          urlPrefix = _props.url,
          setRatioImage = _props.setRatioImage,
          intl = _props.intl;

      var url = urlPrefix ? '' + urlPrefix + dealer.slug + '/' : '/avtosalony/' + dealer.slug + '/';
      var title = dealer.title,
          dealerTags = dealer.tags,
          logo = dealer.logo,
          address = dealer.address,
          website = dealer.website,
          phones = dealer.phones,
          _dealer$adverts_count = dealer.adverts_count,
          advertsCount = _dealer$adverts_count === undefined ? intl.formatMessage({ id: 'Нет' }) : _dealer$adverts_count,
          _dealer$is_official = dealer.is_official,
          isOfficial = _dealer$is_official === undefined ? false : _dealer$is_official,
          _dealer$test_drive = dealer.test_drive,
          testDrive = _dealer$test_drive === undefined ? false : _dealer$test_drive,
          _dealer$trade_in = dealer.trade_in,
          tradeIn = _dealer$trade_in === undefined ? false : _dealer$trade_in,
          _dealer$accessories = dealer.accessories,
          accessories = _dealer$accessories === undefined ? false : _dealer$accessories,
          _dealer$insurance = dealer.insurance,
          insurance = _dealer$insurance === undefined ? false : _dealer$insurance,
          _dealer$credit = dealer.credit,
          credit = _dealer$credit === undefined ? false : _dealer$credit,
          awards = dealer.awards;
      var isShowedPhones = this.state.isShowedPhones;


      var tags = [testDrive && {
        title: intl.formatMessage({ id: 'Тест-драйв' })
      }, tradeIn && {
        title: 'Trade-in'
      }].filter(function (i) {
        return !!i;
      });

      var IMAGE_WIDTH = 100;

      var logoImg = logo && setRatioImage(logo.replace('http:', 'https:'), IMAGE_WIDTH);
      var isFirm = type === 'firm';
      var elemStyles = isFirm ? {
        minHeight: '120px'
      } : null;
      var shouldShowOffers = !isFirm || dealerTags.find(function (item) {
        return item.slug === 'zapchasti' || item.slug === 'avtorazborka';
      });

      return LegacyDealerItem__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_3_classnames___default.a(__WEBPACK_IMPORTED_MODULE_14__LegacyDealerItem_css___default.a.root, LegacyDealerItem__defineProperty({}, __WEBPACK_IMPORTED_MODULE_14__LegacyDealerItem_css___default.a.isMobile, isMobile)),
        style: elemStyles
      }, void 0, LegacyDealerItem__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_14__LegacyDealerItem_css___default.a.left
      }, void 0, LegacyDealerItem__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_14__LegacyDealerItem_css___default.a.logo
      }, void 0, LegacyDealerItem__jsx(__WEBPACK_IMPORTED_MODULE_5_shared_components_Link__["a" /* default */], {
        to: url
      }, void 0, LegacyDealerItem__jsx('img', {
        className: __WEBPACK_IMPORTED_MODULE_14__LegacyDealerItem_css___default.a.img,
        src: logoImg,
        width: IMAGE_WIDTH,
        alt: ''
      })))), LegacyDealerItem__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_14__LegacyDealerItem_css___default.a.right
      }, void 0, LegacyDealerItem__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_14__LegacyDealerItem_css___default.a.title
      }, void 0, LegacyDealerItem__jsx(__WEBPACK_IMPORTED_MODULE_5_shared_components_Link__["a" /* default */], {
        className: __WEBPACK_IMPORTED_MODULE_14__LegacyDealerItem_css___default.a.link,
        to: url
      }, void 0, title), awards && !!awards.length && LegacyDealerItem__jsx(__WEBPACK_IMPORTED_MODULE_9_shared_components_StoAwards_StoAwards__["a" /* default */], {
        awards: awards,
        customStyle: __WEBPACK_IMPORTED_MODULE_14__LegacyDealerItem_css___default.a.awardsSection
      })), isOfficial && LegacyDealerItem__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_14__LegacyDealerItem_css___default.a.isOfficial
      }, void 0, LegacyDealerItem__ref2), tags && !isFirm && LegacyDealerItem__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_14__LegacyDealerItem_css___default.a.tags
      }, void 0, tags.map(function (item) {
        return LegacyDealerItem__jsx('div', {
          className: __WEBPACK_IMPORTED_MODULE_14__LegacyDealerItem_css___default.a.tag
        }, item.title, item.title);
      })), LegacyDealerItem__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_14__LegacyDealerItem_css___default.a.adr
      }, void 0, address), LegacyDealerItem__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_14__LegacyDealerItem_css___default.a.photos
      }, void 0, dealer.photos && dealer.photos.slice(0, 5).map(function (item) {
        return LegacyDealerItem__jsx('img', {
          src: item.image && setRatioImage(item.image.replace('http:', 'https:'), 60),
          width: '60',
          alt: ''
        }, item.id);
      })), shouldShowOffers && LegacyDealerItem__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_14__LegacyDealerItem_css___default.a.adverts
      }, void 0, LegacyDealerItem__jsx(__WEBPACK_IMPORTED_MODULE_5_shared_components_Link__["a" /* default */], {
        onClick: this.handleAllAdvertsClick,
        to: url,
        className: __WEBPACK_IMPORTED_MODULE_14__LegacyDealerItem_css___default.a.allAdvertsLink
      }, void 0, advertsCount, ' ', LegacyDealerItem__ref3))), LegacyDealerItem__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_14__LegacyDealerItem_css___default.a.actions
      }, void 0, isShowedPhones ? LegacyDealerItem__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_14__LegacyDealerItem_css___default.a.phones
      }, void 0, phones.map(function (_ref4) {
        var id = _ref4.id,
            number = _ref4.number;
        return LegacyDealerItem__jsx('div', {}, id, number);
      }), !phones.length > 0 && LegacyDealerItem__ref5) : LegacyDealerItem__jsx('button', {
        className: __WEBPACK_IMPORTED_MODULE_14__LegacyDealerItem_css___default.a.btn,
        onClick: this.handleShowPhonesClick
      }, void 0, LegacyDealerItem__ref6), LegacyDealerItem__jsx(__WEBPACK_IMPORTED_MODULE_12_shared_components_AutobookingForm__["b" /* AutobookingForm */], {
        className: __WEBPACK_IMPORTED_MODULE_14__LegacyDealerItem_css___default.a.btn,
        advert: dealer
      }), website && LegacyDealerItem__jsx(__WEBPACK_IMPORTED_MODULE_13_shared_components_DealerWebsiteLink_DealerWebsiteLink__["a" /* default */], {
        dealer: dealer,
        ClassName: __WEBPACK_IMPORTED_MODULE_14__LegacyDealerItem_css___default.a.btn
      }, void 0, LegacyDealerItem__ref7)));
    }
  }]);

  return LegacyDealerItem;
}(LegacyDealerItem___WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

LegacyDealerItem.defaultProps = {
  type: 'dealer',
  url: null
};


/* harmony default export */ var LegacyDealerItem_defaultExport = (__WEBPACK_IMPORTED_MODULE_10_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_14__LegacyDealerItem_css___default.a)(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */](null, { setDataLayer: __WEBPACK_IMPORTED_MODULE_7_shared_actions_globals__["j" /* setDataLayer */] })(LegacyDealerItem___WEBPACK_IMPORTED_MODULE_4_react_intl__["d" /* injectIntl */](LegacyDealerItem___WEBPACK_IMPORTED_MODULE_11_shared_hocs_stats_withStatsEvents__["a" /* default */](__WEBPACK_IMPORTED_MODULE_8_shared_hocs_withPixelRatio__["a" /* default */](LegacyDealerItem))))));
// CONCATENATED MODULE: ./src/desktop/components/DealerItem/index.js
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "a", function() { return LegacyDealerItem_defaultExport; });




/* harmony default export */ __webpack_exports__["b"] = (DealerItem_defaultExport);

/***/ }),

/***/ 2441:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "2041175b.svg";

/***/ }),

/***/ 2442:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "92c62def.svg";

/***/ }),

/***/ 2443:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(2444);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./DealerItem.css", function() {
        content = require("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./DealerItem.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 2444:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, "._1h-4m{overflow-y:auto;max-height:100vh;margin:0 auto}.vF-DD{position:relative;border-radius:10px;max-width:330px}._3gd3k,._3zZW1{position:absolute;cursor:pointer;top:3px;right:10px;font-size:22px;color:#c4c4c4}._3gd3k:before{content:\"\\D7\"}._1TWak{padding:20px 15px}._2n-yx{position:relative;padding:20px;background-color:#fff;border-bottom:1px solid #e0e0e0;font-weight:400;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-flow:row nowrap;flex-flow:row nowrap;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;text-decoration:none;min-height:180px}._1hicz,._2n-yx{display:-webkit-box;display:-ms-flexbox;display:flex}._1hicz{position:absolute;background:#ffd906;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;width:60px;height:20px;top:-2px;left:-2px;border-radius:0 0 2px 0;font-size:12px;font-weight:600;line-height:16px}._1wohf{-webkit-box-flex:0;-ms-flex:0 0 125px;flex:0 0 125px;width:125px;padding-right:25px}._2v4e1{max-height:100px}._2EIMA{width:100%;max-height:100%;margin:auto}._3L8vR{-webkit-box-flex:1;-ms-flex:1 1 auto;flex:1 1 auto;text-align:left;padding-right:7px}._3BLoq{margin-bottom:5px;max-width:360px}._1u5la,._3BLoq{position:relative}._1u5la{font-size:13px;margin-bottom:7px}.RQggw{display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap}._2dPcp{font-size:17px;font-weight:700;text-decoration:none;color:#000;margin-bottom:10px}._2dPcp:hover{color:#e73232}._2fHkZ{color:#969696;font-size:13px;font-weight:400;margin-bottom:5px}._1UGYp{color:#2196f3;font-size:13px}._32ifB{position:relative;display:inline-block;padding:0 12px;line-height:32px;text-align:center;border-radius:3px;font-size:13px;color:#000;-webkit-appearance:none;-moz-appearance:none;appearance:none;border:1px solid #0003;width:160px;margin-bottom:12px;-webkit-transition:all .1s ease-out;-o-transition:all .1s ease-out;transition:all .1s ease-out;cursor:pointer;outline:none!important;background-color:#fff;text-decoration:none}._32ifB:hover{background-color:#ffe922;border-color:#ffe922;color:#000}._3lLDu{text-decoration:none}._1MFRf{margin-top:0!important}._1MFRf img{width:27px!important}._3aa-2{max-width:100px}.tcY6p{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}._2jBl7 span{margin-top:2px}._2jBl7{color:#6cbe00;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start;margin-bottom:2px}._2noTu{margin-right:6px;font-size:14px;font-weight:600;line-height:20px}._3CO2e span{margin-top:2px}._3CO2e{color:#7f46ca;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start;margin-bottom:2px}.dyr_B{margin-right:6px;font-size:14px;font-weight:600;line-height:20px}._3Xoqf{border:1px solid #ffd906}._1bRCe,._3Xoqf{background:#fffceb}._2D7KI{text-align:center;min-height:248px;padding-top:45px}._1-1co{font-weight:700;font-size:18px}._1N6Ym{line-height:140%;color:gray}._1N6Ym,._2XQRT{font-size:12px;text-align:center}._2XQRT{display:block}._2XQRT,.WjCjX{line-height:16px}.WjCjX{text-decoration:none;color:#1575c3;font-size:12px;display:inline-block}.WjCjX:hover{color:#2196f3}.tFtiU{min-width:190px}", ""]);

// exports
exports.locals = {
	"rootModal": "_1h-4m",
	"modal": "vF-DD",
	"closeBtnIcon": "_3zZW1",
	"closeBtn": "_3gd3k",
	"rootModalBody": "_1TWak",
	"root": "_2n-yx",
	"vipBadge": "_1hicz",
	"left": "_1wohf",
	"logo": "_2v4e1",
	"img": "_2EIMA",
	"right": "_3L8vR",
	"title": "_3BLoq",
	"isOfficial": "_1u5la",
	"tags": "RQggw",
	"link": "_2dPcp",
	"adr": "_2fHkZ",
	"adverts": "_1UGYp",
	"btn": "_32ifB",
	"allAdvertsLink": "_3lLDu",
	"awardsSection": "_1MFRf",
	"reactTooltip": "_3aa-2",
	"titleWithButton": "tcY6p",
	"isVerified": "_2jBl7",
	"isVerifiedIcon": "_2noTu",
	"isGuarantee": "_3CO2e",
	"isGuaranteeIcon": "dyr_B",
	"isVip": "_3Xoqf",
	"isStandart": "_1bRCe",
	"thanksDialog": "_2D7KI",
	"rootModalTitle": "_1-1co",
	"rootModalPolicy": "_1N6Ym",
	"modalText": "_2XQRT",
	"modalTextLink": "WjCjX",
	"contactPhoneButton": "tFtiU"
};

/***/ }),

/***/ 2445:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(2446);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./LegacyDealerItem.css", function() {
        content = require("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./LegacyDealerItem.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 2446:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, "._26mLG{position:relative;padding:20px;background-color:#fff;border-bottom:1px solid #e0e0e0;font-weight:400;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-ms-flex-flow:row nowrap;flex-flow:row nowrap;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;text-decoration:none;min-height:180px;padding-right:20px}._26mLG,._26mLG._92U7x{-webkit-box-direction:normal}._26mLG._92U7x{-webkit-box-orient:vertical;-ms-flex-direction:column;flex-direction:column}.eqErh{-webkit-box-flex:0;-ms-flex:0 0 125px;flex:0 0 125px;width:125px;padding-right:25px}._3ecou{max-height:100px}._376PF{width:100%;max-height:100%;margin:auto}._1-yJf{-webkit-box-flex:1;-ms-flex:1 1 auto;flex:1 1 auto;text-align:left;padding-right:7px}._3kgMs{margin-bottom:5px}._2_UVZ,._3kgMs{position:relative}._2_UVZ{font-size:13px;margin-bottom:7px}._1Av7S{max-width:420px;display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap}._1pD2A{white-space:nowrap;display:inline-block;margin:6px 4px 6px 0;padding:3px 12px 4px;font-size:11px;color:#333;border-radius:2px;border:1px solid #e0e0e0}._2rOY7{font-size:17px;font-weight:700;text-decoration:none;color:#000;margin-bottom:10px}._2rOY7:hover{color:#e73232}._18jT_{color:#969696;font-size:13px;font-weight:400;margin-bottom:5px}._2P4XG{color:#2196f3;font-size:13px}._31x1p{-webkit-box-flex:0;-ms-flex:0 0 160px;flex:0 0 160px}._31x1p,._209dn{position:relative}._209dn{display:inline-block;padding:0 12px;line-height:32px;text-align:center;border-radius:3px;font-size:13px;color:#000;-webkit-appearance:none;-moz-appearance:none;appearance:none;border:1px solid #0003;width:160px;margin-bottom:12px;-webkit-transition:all .1s ease-out;-o-transition:all .1s ease-out;transition:all .1s ease-out;cursor:pointer;outline:none!important;background-color:#fff;text-decoration:none}._209dn:hover{background-color:#ffe922;border-color:#ffe922;color:#000}.iJ0f5{display:inline-block;padding:5px 12px;line-height:22px;text-align:center;border-radius:3px;font-size:13px;color:#000;-webkit-appearance:none;-moz-appearance:none;appearance:none;border:1px solid #0003;width:160px}._3C-p1,.iJ0f5{position:relative;margin-bottom:12px}._3C-p1{margin-top:10px}._3C-p1 img{position:relative;margin-right:5px}._3cB_V{text-decoration:none}._1R14V{margin-top:0!important}._1R14V img{width:27px!important}._3WaIC{max-width:100px}", ""]);

// exports
exports.locals = {
	"root": "_26mLG",
	"isMobile": "_92U7x",
	"left": "eqErh",
	"logo": "_3ecou",
	"img": "_376PF",
	"right": "_1-yJf",
	"title": "_3kgMs",
	"isOfficial": "_2_UVZ",
	"tags": "_1Av7S",
	"tag": "_1pD2A",
	"link": "_2rOY7",
	"adr": "_18jT_",
	"adverts": "_2P4XG",
	"actions": "_31x1p",
	"btn": "_209dn",
	"phones": "iJ0f5",
	"photos": "_3C-p1",
	"allAdvertsLink": "_3cB_V",
	"awardsSection": "_1R14V",
	"reactTooltip": "_3WaIC"
};

/***/ }),

/***/ 2880:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(2881);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./DealersList.css", function() {
        content = require("!!../../../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./DealersList.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 2881:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, ".UPJ0_{position:relative;z-index:1;margin-bottom:20px}._3QRIx{margin:20px 0;padding:20px 0;background:#fff;text-align:center}", ""]);

// exports
exports.locals = {
	"root": "UPJ0_",
	"defaultText": "_3QRIx"
};

/***/ }),

/***/ 2882:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(2883);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./SearchBar.css", function() {
        content = require("!!../../../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./SearchBar.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 2883:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),

/***/ 2884:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(2885);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./Dealers.css", function() {
        content = require("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./Dealers.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 2885:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, "._38qdU{padding:17px 0 0}._1PPJ3{margin-bottom:20px}.TZavS{margin:0 auto}._12GLi{-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}._333GJ{position:relative}._1w_sS{width:calc(100% - 300px);padding-right:20px;padding-bottom:20px}._3sP9K{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;width:300px}.vKFEP{-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1}._2L_WJ{background-color:#fff;border-bottom:1px solid #e0e0e0;border-radius:2px 2px 0 0}._1aF5N{margin-bottom:15px}", ""]);

// exports
exports.locals = {
	"page": "_38qdU page",
	"Juan": "_1PPJ3",
	"container": "TZavS container",
	"flexRow": "_12GLi flexRow",
	"flexCell": "_333GJ",
	"mainCell": "_1w_sS",
	"sideBar": "_3sP9K",
	"flexGrow1": "vKFEP",
	"navWrapper": "_2L_WJ",
	"advertContainerGl": "_1aF5N"
};

/***/ }),

/***/ 3318:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// CONCATENATED MODULE: ./src/shared/routes/dealers/index.js
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_shared_constants_api__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_snakecase_keys__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_snakecase_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_snakecase_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_query_string__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_query_string___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_query_string__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_pick__ = __webpack_require__(506);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_pick___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_pick__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_isEmpty__ = __webpack_require__(515);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_isEmpty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_isEmpty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_shared_actions_searchForm__ = __webpack_require__(482);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_shared_constants_json_cities_json__ = __webpack_require__(1644);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_shared_constants_json_cities_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_shared_constants_json_cities_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_shared_constants_json_countries_json__ = __webpack_require__(310);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_shared_constants_json_countries_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_shared_constants_json_countries_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_shared_constants_json_regions_json__ = __webpack_require__(2436);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_shared_constants_json_regions_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_shared_constants_json_regions_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_shared_helpers_arrays__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_shared_modules__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_shared_actions_globals__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_shared_helpers_common__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_shared_constants_json_transportTypes_json__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_shared_constants_json_transportTypes_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_shared_constants_json_transportTypes_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_shared_constants_seoDescriptions__ = __webpack_require__(1388);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_shared_constants_seoTitles__ = __webpack_require__(1389);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_shared_constants_seoHeaders__ = __webpack_require__(1646);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_desktop_constants_navigation__ = __webpack_require__(1248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_shared_helpers_adsAndMetrics__ = __webpack_require__(510);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_shared_helpers_locale__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_shared_modules_subjectiveText__ = __webpack_require__(566);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_shared_helpers_transportTypes__ = __webpack_require__(194);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
























/* harmony default export */ var dealers_defaultExport = ((function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(_ref2) {
    var fetch = _ref2.fetch,
        store = _ref2.store,
        baseUrl = _ref2.baseUrl,
        path = _ref2.path,
        query = _ref2.query,
        translate = _ref2.translate;
    var device = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'desktop';

    var missingVocabularyFields, url, state, _state$globals, locale, storeLocation, vocabulary, currentPage, seoQuery, seoTags, kind, meta, seoResponse, seoAPITitle, seoAPIDescription, seoAPIH1, transportType, fetchedVocabulary, mergedVocabulary, _store$getState, categories, body, a, buf, transportID, prevSelectedTransport, storeParams, q, location, LangPrefix, seoTagsData, hasNew, formQueryState, makes, queryParams, transportLinks, year, seoLocation, seoParams, description, title, metaHeader, result, isLastPage, isAuto, lang, country, _seoQuery$make, make, _seoQuery$model, model, transportTypeTitle, transportCategoryTitle, defaultCategoryDescriptions, defaultCategoryTitleHeader, drive, seo, metaParams, commonArguments, rootTransportType, type, allMetaParams, targetingArguments, topDealerRequestObj;

    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            missingVocabularyFields = [];
            url = __WEBPACK_IMPORTED_MODULE_19_shared_helpers_locale__["e" /* removeLocaleFromHref */](('' + baseUrl + path).replace('//', '/'));
            state = store.getState();
            _state$globals = state.globals, locale = _state$globals.locale, storeLocation = _state$globals.location, vocabulary = state.searchForm.vocabulary;
            currentPage = query.page ? parseInt(query.page, 10) : 1;


            if (storeLocation && storeLocation.is_country) {
              store.dispatch(__WEBPACK_IMPORTED_MODULE_11_shared_actions_globals__["r" /* setLocation */](null));
            }

            _context.next = 8;
            return store.dispatch(__WEBPACK_IMPORTED_MODULE_11_shared_actions_globals__["i" /* seoRequest */](url));

          case 8:
            seoQuery = _context.sent;

            if (!__WEBPACK_IMPORTED_MODULE_4_lodash_isEmpty___default.a(seoQuery)) {
              _context.next = 11;
              break;
            }

            return _context.abrupt('return', null);

          case 11:
            if (!(seoQuery.location && seoQuery.location.is_country)) {
              _context.next = 13;
              break;
            }

            return _context.abrupt('return', null);

          case 13:
            seoTags = seoQuery.seo, kind = seoQuery.kind, meta = seoQuery.meta, seoResponse = _objectWithoutProperties(seoQuery, ['seo', 'kind', 'meta']);
            seoAPITitle = '';
            seoAPIDescription = '';
            seoAPIH1 = '';


            store.dispatch(__WEBPACK_IMPORTED_MODULE_5_shared_actions_searchForm__["m" /* selectedActions */].set.powerUnit(null));
            // store.dispatch(selectedActions.set.currency(null));
            store.dispatch(__WEBPACK_IMPORTED_MODULE_5_shared_actions_searchForm__["m" /* selectedActions */].set.dealer(null));
            store.dispatch(__WEBPACK_IMPORTED_MODULE_5_shared_actions_searchForm__["m" /* selectedActions */].set.capacityUnit(null));

            transportType = seoQuery.transport || __WEBPACK_IMPORTED_MODULE_13_shared_constants_json_transportTypes_json___default.a.find(function (item) {
              return item.slug === 'avto';
            });

            if (!vocabulary.categories) {
              missingVocabularyFields.push('categories');
            }
            _context.next = 24;
            return Promise.all(missingVocabularyFields.map(function (field) {
              return __WEBPACK_IMPORTED_MODULE_0_shared_constants_api__["a" /* default */].VOCABULARY[field] ? fetch(__WEBPACK_IMPORTED_MODULE_0_shared_constants_api__["a" /* default */].VOCABULARY[field](transportType.id)).then(function (r) {
                return r.json();
              }).then(function (response) {
                return _defineProperty({}, field, response);
              }) : Promise.resolve({});
            }));

          case 24:
            fetchedVocabulary = _context.sent;
            mergedVocabulary = fetchedVocabulary.reduce(function (results, pair) {
              return _extends({}, results, pair);
            }, {});

            store.dispatch(__WEBPACK_IMPORTED_MODULE_5_shared_actions_searchForm__["o" /* setFormVocabulary */](_extends({}, mergedVocabulary)));
            _store$getState = store.getState(), categories = _store$getState.searchForm.vocabulary.categories;
            body = void 0;
            a = 0;

          case 30:
            if (!(a < categories.length)) {
              _context.next = 38;
              break;
            }

            buf = categories[a] && categories[a].title && categories[a].id;

            if (!(buf && query.category && String(buf) === query.category)) {
              _context.next = 35;
              break;
            }

            body = categories[a];
            return _context.abrupt('break', 38);

          case 35:
            a += 1;
            _context.next = 30;
            break;

          case 38:
            transportID = transportType.id;
            prevSelectedTransport = state.searchForm.selected && state.searchForm.selected.transport;

            if (prevSelectedTransport && prevSelectedTransport.id !== transportID) {
              store.dispatch(__WEBPACK_IMPORTED_MODULE_5_shared_actions_searchForm__["k" /* resetAll */]());
            }
            store.dispatch(__WEBPACK_IMPORTED_MODULE_5_shared_actions_searchForm__["m" /* selectedActions */].set.transport(transportType));

            storeParams = Object.entries(store.getState().searchForm.selected).map(function (_ref4) {
              var _ref5 = _slicedToArray(_ref4, 2),
                  key = _ref5[0],
                  value = _ref5[1];

              return value && value.id ? [key, value.id] : [key, value];
            }).filter(function (_ref6) {
              var _ref7 = _slicedToArray(_ref6, 2),
                  value = _ref7[1];

              return !!value && (typeof value === 'string' || typeof value === 'number');
            }).reduce(function (result, item) {
              return _extends({}, result, _defineProperty({}, item[0], item[1]));
            }, {});


            if (transportType.slug === 'avto') {
              delete storeParams.tags;
            }

            q = _extends({}, storeParams, query);
            location = store.getState() && store.getState().globals.location;

            if (!(q.model && !seoQuery.model)) {
              _context.next = 50;
              break;
            }

            _context.next = 49;
            return fetch(__WEBPACK_IMPORTED_MODULE_0_shared_constants_api__["a" /* default */].SEO.SEARCH_MODEL(q.model)).then(function (r) {
              return r.ok ? r.json() : {};
            });

          case 49:
            seoQuery.model = _context.sent;

          case 50:
            if (seoQuery.make) {
              q.make = seoQuery.make.id;
            }
            /* if (seoQuery.model) {
              q.model = seoQuery.model.id;
            } */
            if (seoQuery.location) {
              location = seoQuery.location;
              store.dispatch(__WEBPACK_IMPORTED_MODULE_11_shared_actions_globals__["r" /* setLocation */](seoQuery.location));
            }

            if ((typeof seoTags === 'undefined' ? 'undefined' : _typeof(seoTags)) === 'object') {
              LangPrefix = locale === 'ru' ? '' : locale + '_';

              seoAPIDescription = seoTags[LangPrefix + 'description'] || '';
              seoAPITitle = seoTags[LangPrefix + 'title'] || '';
              seoTagsData = seoTags[LangPrefix + 'data'] || null;

              seoAPIH1 = seoTagsData && (seoTagsData.H1 || seoTagsData.h1);
            }

            hasNew = query.hasNew || store.getState().searchForm.selected.hasNew || null;


            q.location = location && location.id || undefined;
            q.transport = transportID;
            if (!isNaN(hasNew) && hasNew !== null) {
              q.hasNew = hasNew;
            }

            formQueryState = __WEBPACK_IMPORTED_MODULE_3_lodash_pick___default.a(q, Object.keys(state.searchForm.selected));

            store.dispatch(__WEBPACK_IMPORTED_MODULE_5_shared_actions_searchForm__["h" /* dealersSetThunks */].count(formQueryState));

            _context.next = 61;
            return fetch(__WEBPACK_IMPORTED_MODULE_0_shared_constants_api__["a" /* default */].VOCABULARY.makes(transportID)).then(function (r) {
              return r.json();
            });

          case 61:
            makes = _context.sent;


            store.dispatch(__WEBPACK_IMPORTED_MODULE_5_shared_actions_searchForm__["o" /* setFormVocabulary */]({
              makes: makes
            }));

            queryParams = __WEBPACK_IMPORTED_MODULE_2_query_string___default.a.stringify(__WEBPACK_IMPORTED_MODULE_1_snakecase_keys___default.a(q));
            _context.next = 66;
            return store.dispatch(__WEBPACK_IMPORTED_MODULE_5_shared_actions_searchForm__["l" /* resultsThunks */].searchDealersResults(queryParams));

          case 66:

            Object.keys(q).forEach(function (key) {
              var item = q[key];
              if (__WEBPACK_IMPORTED_MODULE_5_shared_actions_searchForm__["g" /* dealersFormFillThunks */][key]) {
                store.dispatch(__WEBPACK_IMPORTED_MODULE_5_shared_actions_searchForm__["g" /* dealersFormFillThunks */][key](item));
              }
            });

            transportLinks = device !== 'mobile' && __WEBPACK_IMPORTED_MODULE_17_desktop_constants_navigation__["a" /* default */].AVTOSALONS_LINKS.map(function (_ref8) {
              var route = _ref8.route,
                  rest = _objectWithoutProperties(_ref8, ['route']);

              return _extends({}, rest, {
                route: location ? (route + '/' + location.slug + '/').replace(/\/\//g, '/') : route
              });
            });
            year = seoQuery.year;

            if (!year && query.yearFrom === query.yearTo) year = query.yearFrom;

            seoLocation = [].concat(_toConsumableArray(__WEBPACK_IMPORTED_MODULE_6_shared_constants_json_cities_json___default.a), _toConsumableArray(__WEBPACK_IMPORTED_MODULE_8_shared_constants_json_regions_json___default.a), _toConsumableArray(__WEBPACK_IMPORTED_MODULE_7_shared_constants_json_countries_json___default.a)).find(function (item) {
              return item.id === (location && location.id);
            });
            seoParams = __WEBPACK_IMPORTED_MODULE_9_shared_helpers_arrays__["d" /* getSeoParamsTitles */](_extends({}, seoQuery, { location: location, country: seoLocation }), translate);
            description = __WEBPACK_IMPORTED_MODULE_10_shared_modules__["l" /* replaceSpace */](__WEBPACK_IMPORTED_MODULE_14_shared_constants_seoDescriptions__["a" /* default */].DEALERS(seoParams, transportType.slug, translate));
            title = __WEBPACK_IMPORTED_MODULE_10_shared_modules__["l" /* replaceSpace */](__WEBPACK_IMPORTED_MODULE_15_shared_constants_seoTitles__["a" /* default */].DEALERS(seoParams, transportType.slug, translate));
            metaHeader = __WEBPACK_IMPORTED_MODULE_10_shared_modules__["l" /* replaceSpace */](__WEBPACK_IMPORTED_MODULE_16_shared_constants_seoHeaders__["a" /* default */].DEALERS(seoParams, transportType.slug, translate));
            result = __WEBPACK_IMPORTED_MODULE_12_shared_helpers_common__["g" /* getResultFromStoreByKey */](store, 'dealers-' + queryParams);
            isLastPage = !(result && result.next);
            isAuto = transportType.slug === 'avto';
            lang = state.globals.locale;
            country = seoLocation && seoLocation.is_country ? seoLocation.from[locale] : undefined;
            _seoQuery$make = seoQuery.make, make = _seoQuery$make === undefined ? {} : _seoQuery$make, _seoQuery$model = seoQuery.model, model = _seoQuery$model === undefined ? {} : _seoQuery$model;
            transportTypeTitle = transportType && transportType.title || '';
            transportCategoryTitle = seoQuery.transport_category && seoQuery.transport_category.title || '';
            defaultCategoryDescriptions = model.title && !seoQuery.category ? translate('авто') : translate('легковой автомобиль');
            defaultCategoryTitleHeader = model.title;
            drive = void 0;
            seo = _extends({}, seoQuery, {
              location: seoLocation
            });
            metaParams = {
              transport: transportType,
              type: transportType,
              make: seoQuery.make,
              model: seoQuery.model,
              modification: seoQuery.modification,
              category: seoQuery.category,
              gearbox: seoQuery.gearbox,
              engine: seoQuery.engine,
              location: location && '\u0432 ' + location.title,
              yearTo: q.yearTo,
              yearFrom: q.yearFrom,
              isNew: q.isNew,
              country: country,
              year: seoQuery.year,
              body: q.body
            };
            commonArguments = __WEBPACK_IMPORTED_MODULE_20_shared_modules_subjectiveText__["a" /* default */]({
              make: make && make.title || '',
              makeTranslit: make[lang + '_title'] || make.title || '',
              model: model.title || '',
              modelTranslit: model[lang + '_title'] || model.title || '',
              transportTitle: isAuto && transportCategoryTitle || transportTypeTitle,
              transportNextTitle: transportTypeTitle,
              transportDescriptions: isAuto && transportCategoryTitle || transportTypeTitle,
              transportNextDescriptions: transportTypeTitle,
              transportHeader: transportCategoryTitle || transportTypeTitle,
              transportNextHeader: transportCategoryTitle || transportTypeTitle,
              categoryHeader: !model && !model.title && body && body.title ? body.title : defaultCategoryTitleHeader,
              categoryTitle: body && body.title || defaultCategoryTitleHeader,
              categoryDescriptions: body && body.title || defaultCategoryDescriptions,
              reductionTranslit: transportType.slug === 'avtobus' ? 'бус' : '',
              cityTitle: location && location.title || 'Украина',
              cityDescriptions: location && location.title || 'Украина',
              cityHeader: location && location.title || 'Украина',
              transportCategoryTitle: transportCategoryTitle,
              generation: query.generation && seoQuery.generation && seoQuery.generation.title || query.generation && ' ' || '',
              driveUnit: drive || '',
              engine: seo.engine && seo.engine.title || '',
              transmission: metaParams.gearbox && metaParams.gearbox.title || '',
              body: body && body.title || '',
              subsection: seoQuery && seoQuery.part_type && seoQuery.part_type.title || '',
              isNew: q.isNew,
              transportType: transportType && transportType.slug || '',
              allData: {
                url: url,
                baseUrl: baseUrl,
                locale: locale,
                translate: translate
              },
              yearTitle: year ? year + ' ' + translate('года') + ' ' : '',
              yearDescriptions: year ? year + ' ' + translate('г.') + ' ' : '',
              motoHeader: transportCategoryTitle,
              motoTitle: transportCategoryTitle
            });
            rootTransportType = __WEBPACK_IMPORTED_MODULE_21_shared_helpers_transportTypes__["d" /* getRootTransportType */](transportType);
            type = rootTransportType.slug;
            allMetaParams = _extends({}, commonArguments, metaParams);


            if (rootTransportType.slug === 'moto') {
              title = seoAPITitle || __WEBPACK_IMPORTED_MODULE_15_shared_constants_seoTitles__["a" /* default */].DEALERS({
                allMetaParams: allMetaParams,
                make: make && make.title ? make.title : '',
                model: model && model.title ? model.title : '',
                location: location && location.title ? location.title : ''
              }, 'mototsikl', translate);
              description = seoAPIDescription || __WEBPACK_IMPORTED_MODULE_14_shared_constants_seoDescriptions__["a" /* default */].DEALERS({
                allMetaParams: allMetaParams,
                make: make && make.title ? make.title : '',
                model: model && model.title ? model.title : '',
                location: location && location.title ? location.title : ''
              }, 'mototsikl', translate);
              metaHeader = seoAPIH1 || __WEBPACK_IMPORTED_MODULE_16_shared_constants_seoHeaders__["a" /* default */].DEALERS({
                allMetaParams: allMetaParams,
                make: make && make.title ? make.title : '',
                model: model && model.title ? model.title : '',
                location: location && location.title ? location.title : ''
              }, 'mototsikl', translate);
            } else {
              title = seoAPITitle || __WEBPACK_IMPORTED_MODULE_15_shared_constants_seoTitles__["a" /* default */].DEALERS({
                allMetaParams: allMetaParams,
                make: make && make.title ? make.title : '',
                model: model && model.title ? model.title : '',
                location: location && location.title ? location.title : ''
              }, type, translate);
              description = seoAPIDescription || __WEBPACK_IMPORTED_MODULE_14_shared_constants_seoDescriptions__["a" /* default */].DEALERS({
                allMetaParams: allMetaParams,
                make: make && make.title ? make.title : '',
                model: model && model.title ? model.title : '',
                location: location && location.title ? location.title : ''
              }, type, translate);
              metaHeader = seoAPIH1 || __WEBPACK_IMPORTED_MODULE_16_shared_constants_seoHeaders__["a" /* default */].DEALERS({
                allMetaParams: allMetaParams,
                make: make && make.title ? make.title : '',
                model: model && model.title ? model.title : '',
                location: location && location.title ? location.title : ''
              }, type, translate);
            }

            targetingArguments = __WEBPACK_IMPORTED_MODULE_18_shared_helpers_adsAndMetrics__["a" /* getAdsContext */]({
              make: seo.make,
              model: seo.model,
              isMain: seo.isMain,
              isNew: seo.isNew,
              rubric: seo.rubric,
              isCustomCleared: seo.isCustomCleared,
              location: seo.location,
              isCountry: seo.isCountry,
              transport: transportType,
              category: body,
              engine: seo.engine,
              dealer: seo.rubric,
              price: __WEBPACK_IMPORTED_MODULE_18_shared_helpers_adsAndMetrics__["b" /* getPriceValuation */]({ from: q.priceFrom, to: q.priceTo }, q.currency),
              page: baseUrl.replace(/\//g, ''),
              id: seo.slug
            });
            topDealerRequestObj = _extends({
              transport: transportType ? transportType.id : 1
            }, q.make ? { make: q.make } : {});

            store.dispatch(__WEBPACK_IMPORTED_MODULE_11_shared_actions_globals__["A" /* setSeoSearchUrl */](_extends({}, seoQuery, { url: url })));

            return _context.abrupt('return', {
              url: url,
              currentPage: currentPage,
              targetingArguments: targetingArguments,
              description: description,
              title: title,
              queryParams: queryParams,
              metaHeader: metaHeader,
              topDealerRequestObj: topDealerRequestObj,
              isLastPage: isLastPage,
              transportLinks: transportLinks,
              location: location,
              transportType: transportType,
              seoQuery: seoQuery,
              q: q
            });

          case 97:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, this);
  }));

  return function (_x) {
    return _ref.apply(this, arguments);
  };
})());
// CONCATENATED MODULE: ./src/desktop/routes/dealers/components/DealersList/DealersList.js
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_intl__ = __webpack_require__(474);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shared_components_ListAds_ListAds__ = __webpack_require__(2426);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_shared_components_BannerAll__ = __webpack_require__(1270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__DealersList_css__ = __webpack_require__(2880);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__DealersList_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__DealersList_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_DealerItem__ = __webpack_require__(2440);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();










var DealersList__ref = _jsx(__WEBPACK_IMPORTED_MODULE_5_shared_components_BannerAll__["c" /* DesktopButtonMark */], {});

var _ref2 = _jsx(__WEBPACK_IMPORTED_MODULE_5_shared_components_BannerAll__["b" /* DesktopButton */], {});

var _ref3 = _jsx(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */], {
  id: 'По Вашему запросу ничего не найдено'
});

function DealersList(props) {
  var dealers = props.dealers;

  var showBottomMark = dealers.length && dealers.length < 6;
  return _jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_6__DealersList_css___default.a.root
  }, void 0, showBottomMark && DealersList__ref, dealers && dealers.length > 0 ? dealers.map(function (item, idx) {
    return _jsx('div', {}, item.id + '-' + item.slug, idx === 6 && _ref2, _jsx(__WEBPACK_IMPORTED_MODULE_4_shared_components_ListAds_ListAds__["a" /* default */], {
      index: idx
    }), _jsx(__WEBPACK_IMPORTED_MODULE_7__components_DealerItem__["b" /* default */], {
      dealer: item
    }));
  }) : _jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_6__DealersList_css___default.a.defaultText
  }, void 0, _ref3));
}

/* harmony default export */ var DealersList_defaultExport = (__WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_6__DealersList_css___default.a)(DealersList));
// CONCATENATED MODULE: ./src/desktop/routes/dealers/components/DealersList/index.js


/* harmony default export */ var components_DealersList_defaultExport = (DealersList_defaultExport);
// CONCATENATED MODULE: ./src/desktop/routes/dealers/components/SearchBar/SearchBar.js
/* harmony import */ var SearchBar___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var SearchBar___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(SearchBar___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var SearchBar___WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var SearchBar___WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(SearchBar___WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_intl__ = __webpack_require__(474);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_query_string__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_query_string___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_query_string__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_redux__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_shared_helpers_locale__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_desktop_components_SearchPanel_SearchPanel__ = __webpack_require__(1978);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_shared_helpers_urls__ = __webpack_require__(312);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_history_js__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__SearchBar_css__ = __webpack_require__(2882);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__SearchBar_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__SearchBar_css__);
var SearchBar__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var SearchBar__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function SearchBar__objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }













var SearchBar = function (_React$Component) {
  _inherits(SearchBar, _React$Component);

  function SearchBar() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, SearchBar);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SearchBar.__proto__ || Object.getPrototypeOf(SearchBar)).call.apply(_ref, [this].concat(args))), _this), _this.getSearchUrl = function (state) {
      var location = _this.props.location;

      var pathname = __WEBPACK_IMPORTED_MODULE_8_shared_helpers_urls__["a" /* generateDealersSearchUrl */](SearchBar__extends({}, state, { location: location }));

      var isNew = state.isNew,
          validDealersSate = SearchBar__objectWithoutProperties(state, ['isNew']);

      var query = __WEBPACK_IMPORTED_MODULE_8_shared_helpers_urls__["d" /* generateSearchQuery */](validDealersSate);

      return __WEBPACK_IMPORTED_MODULE_6_shared_helpers_locale__["h" /* toLocalized */]('/' + pathname + '?' + __WEBPACK_IMPORTED_MODULE_4_query_string___default.a.stringify(query), _this.props.locale);
    }, _this.handleClearForm = function () {
      var pathname = __WEBPACK_IMPORTED_MODULE_8_shared_helpers_urls__["a" /* generateDealersSearchUrl */]({
        transport: _this.props.formState.transport,
        hasNew: _this.props.formState.hasNew
      });
      _this.props.selectedActions.clearForm();
      __WEBPACK_IMPORTED_MODULE_9_history_js__["a" /* default */].push(__WEBPACK_IMPORTED_MODULE_6_shared_helpers_locale__["h" /* toLocalized */]('/' + pathname, _this.props.locale));
    }, _this.handleSetAge = function (age) {
      if (!isNaN(age.id) && age.id !== null) {
        _this.props.selectedActions.set.hasNew(age.id);
        __WEBPACK_IMPORTED_MODULE_9_history_js__["a" /* default */].push(_this.getSearchUrl(SearchBar__extends({}, _this.props.formState, { hasNew: age.id })));
      } else {
        _this.props.selectedActions.set.hasNew(null);
        __WEBPACK_IMPORTED_MODULE_9_history_js__["a" /* default */].push(_this.getSearchUrl(SearchBar__extends({}, _this.props.formState, { hasNew: null })));
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(SearchBar, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          transportType = _props.transportType,
          formData = _props.formData,
          formVocabulary = _props.formVocabulary,
          selectedActions = _props.selectedActions,
          formState = _props.formState,
          intl = _props.intl,
          count = _props.count;


      var age = [{
        id: null,
        title: intl.formatMessage({ id: 'Все' })
      }, {
        id: 1,
        title: intl.formatMessage({ id: 'Новые' })
      }, {
        id: 0,
        title: intl.formatMessage({ id: 'С пробегом' })
      }];

      return SearchBar__jsx(__WEBPACK_IMPORTED_MODULE_7_desktop_components_SearchPanel_SearchPanel__["a" /* default */], {
        setAge: this.handleSetAge,
        transportType: transportType,
        formVocabulary: formVocabulary,
        formData: formData,
        formState: formState,
        selectedActions: selectedActions,
        getSearchUrl: this.getSearchUrl,
        handleClearForm: this.handleClearForm,
        expandable: false,
        searchable: false,
        page: 'dealers',
        cardTypes: intl.formatMessage({ id: 'aвтосалонов' }, { count: count || 0 }),
        age: age
      });
    }
  }]);

  return SearchBar;
}(SearchBar___WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

SearchBar.defaultProps = {
  count: 0,
  location: null
};


var mapStateToProps = function mapStateToProps(_ref2) {
  var globals = _ref2.globals,
      searchForm = _ref2.searchForm;
  return {
    locale: globals.locale,
    location: globals.location,
    count: searchForm.data.count
  };
};

/* harmony default export */ var SearchBar_defaultExport = (__WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_10__SearchBar_css___default.a)(__WEBPACK_IMPORTED_MODULE_5_react_redux__["b" /* connect */](mapStateToProps)(__WEBPACK_IMPORTED_MODULE_2_react_intl__["d" /* injectIntl */](SearchBar))));
// CONCATENATED MODULE: ./src/desktop/routes/dealers/components/SearchBar/index.js


/* harmony default export */ var components_SearchBar_defaultExport = (SearchBar_defaultExport);
// CONCATENATED MODULE: ./src/desktop/routes/dealers/Dealers.js
/* harmony import */ var Dealers___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var Dealers___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(Dealers___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var Dealers___WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var Dealers___WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(Dealers___WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var Dealers___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var Dealers___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(Dealers___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(1240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_shared_modules__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_shared_components_BannerAll__ = __webpack_require__(1270);
/* harmony import */ var Dealers___WEBPACK_IMPORTED_MODULE_8_shared_helpers_urls__ = __webpack_require__(312);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_shared_actions_searchForm__ = __webpack_require__(482);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_desktop_components_InlineNav_InlineNav__ = __webpack_require__(1284);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_desktop_components_PageTitle_PageTitle__ = __webpack_require__(1967);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_desktop_components_MakesSidebar_MakesSidebar__ = __webpack_require__(1446);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_desktop_components_TopAvtosalon_TopAvtosalon__ = __webpack_require__(2437);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_desktop_components_Paginate_Paginate__ = __webpack_require__(1497);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__Dealers_css__ = __webpack_require__(2884);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__Dealers_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__Dealers_css__);
var Dealers__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var Dealers__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




















var Dealers__ref2 = Dealers__jsx(__WEBPACK_IMPORTED_MODULE_6_shared_modules__["a" /* Googletag */], {
  id: 'div-gpt-ad-1510239331518-2'
});

var Dealers__ref3 = Dealers__jsx(__WEBPACK_IMPORTED_MODULE_12_desktop_components_MakesSidebar_MakesSidebar__["a" /* default */], {});

function Dealers(props) {
  var url = props.url,
      queryParams = props.queryParams,
      currentPage = props.currentPage,
      transportType = props.transportType,
      formData = props.formData,
      formState = props.formState,
      formResults = props.formResults,
      formVocabulary = props.formVocabulary,
      selectedActions = props.selectedActions,
      query = props.query,
      count = props.count,
      transportLinks = props.transportLinks,
      title = props.title,
      location = props.location,
      topDealerRequestObj = props.topDealerRequestObj;


  var result = url === '/avtosalony/' && queryParams !== 'currency=uah&transport=1' && formResults && formResults['dealers-currency=uah&transport=1'] ? formResults['dealers-currency=uah&transport=1'] : formResults['dealers-AJAX'] || {};

  var pageCount = Math.ceil(count / 20);

  var linkPrefix = Dealers___WEBPACK_IMPORTED_MODULE_8_shared_helpers_urls__["a" /* generateDealersSearchUrl */]({ transport: transportType });

  // /avtosalony/ === /avtosalony/avto/
  var currentUrl = transportType.id === 1 ? ('/' + Dealers___WEBPACK_IMPORTED_MODULE_8_shared_helpers_urls__["a" /* generateDealersSearchUrl */]({}) + '/avto/').replace(/\/\//g, '/') : url;
  return Dealers__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_17__Dealers_css___default.a.page
  }, void 0, Dealers__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_17__Dealers_css___default.a.container
  }, void 0, Dealers__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_17__Dealers_css___default.a.flexRow
  }, void 0, Dealers__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_5_classnames___default.a(__WEBPACK_IMPORTED_MODULE_17__Dealers_css___default.a.flexCell, __WEBPACK_IMPORTED_MODULE_17__Dealers_css___default.a.mainCell)
  }, void 0, Dealers__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_17__Dealers_css___default.a.navWrapper
  }, void 0, Dealers__jsx(__WEBPACK_IMPORTED_MODULE_10_desktop_components_InlineNav_InlineNav__["a" /* default */], {
    currentRoute: currentUrl,
    navLinks: transportLinks,
    including: true
  })), Dealers__jsx(components_SearchBar_defaultExport, {
    transportType: transportType,
    selectedActions: selectedActions,
    formState: formState,
    formData: formData,
    formVocabulary: formVocabulary
  }), Dealers__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_17__Dealers_css___default.a.advertContainerGl
  }, void 0, Dealers__ref2), Dealers__jsx(__WEBPACK_IMPORTED_MODULE_11_desktop_components_PageTitle_PageTitle__["a" /* default */], {
    title: title
  }), Dealers__jsx(components_DealersList_defaultExport, {
    dealers: result.results
  }), pageCount > 1 && Dealers__jsx(__WEBPACK_IMPORTED_MODULE_14_desktop_components_Paginate_Paginate__["a" /* default */], {
    query: query,
    url: url,
    pageCount: pageCount,
    initialPage: currentPage
  })), Dealers__jsx(__WEBPACK_IMPORTED_MODULE_7_shared_components_BannerAll__["d" /* DesktopRightSidebar */], {}, void 0, Dealers__jsx(Dealers___WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment, {}, void 0, Dealers__jsx(__WEBPACK_IMPORTED_MODULE_13_desktop_components_TopAvtosalon_TopAvtosalon__["a" /* default */], {
    additionParams: topDealerRequestObj
  }, JSON.stringify(topDealerRequestObj)), Dealers__ref3)))));
}

Dealers.defaultProps = {
  topDealer: null,
  count: 0,
  location: null,
  topDealerRequestObj: {},
  seoQuery: {}
};


var Dealers_mapStateToProps = function mapStateToProps(_ref) {
  var searchForm = _ref.searchForm,
      globals = _ref.globals;
  return {
    formState: searchForm && searchForm.selected,
    formResults: searchForm && searchForm.results,
    formData: searchForm && searchForm.data,
    formVocabulary: searchForm && searchForm.vocabulary,
    location: globals && globals.location,
    count: searchForm.data.count
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    selectedActions: {
      set: __WEBPACK_IMPORTED_MODULE_3_redux__["b" /* bindActionCreators */](Dealers__extends({}, __WEBPACK_IMPORTED_MODULE_9_shared_actions_searchForm__["m" /* selectedActions */].set, __WEBPACK_IMPORTED_MODULE_9_shared_actions_searchForm__["h" /* dealersSetThunks */]), dispatch),
      toggle: __WEBPACK_IMPORTED_MODULE_3_redux__["b" /* bindActionCreators */](__WEBPACK_IMPORTED_MODULE_9_shared_actions_searchForm__["m" /* selectedActions */].toggle, dispatch),
      clear: __WEBPACK_IMPORTED_MODULE_3_redux__["b" /* bindActionCreators */](__WEBPACK_IMPORTED_MODULE_9_shared_actions_searchForm__["m" /* selectedActions */].clear),
      clearForm: __WEBPACK_IMPORTED_MODULE_3_redux__["b" /* bindActionCreators */](__WEBPACK_IMPORTED_MODULE_9_shared_actions_searchForm__["h" /* dealersSetThunks */].clearSelected, dispatch)
    }
  };
};

/* harmony default export */ var Dealers_defaultExport = (Dealers___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_17__Dealers_css___default.a)(__WEBPACK_IMPORTED_MODULE_4_react_redux__["b" /* connect */](Dealers_mapStateToProps, mapDispatchToProps)(Dealers)));
// CONCATENATED MODULE: ./src/desktop/routes/dealers/index.js
/* harmony import */ var dealers___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var dealers___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(dealers___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_desktop_constants_navigation__ = __webpack_require__(1248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_actions_globals__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Layout__ = __webpack_require__(1282);
var dealers__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var action = function () {
  var _ref = dealers__asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(params) {
    var store, data, url, currentPage, targetingArguments, title, description, metaHeader, queryParams, isLastPage, topDealerRequestObj, transportLinks, location, transportType;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            store = params.store;
            _context.next = 3;
            return dealers_defaultExport(params);

          case 3:
            data = _context.sent;

            if (data) {
              _context.next = 6;
              break;
            }

            return _context.abrupt('return', null);

          case 6:
            url = data.url, currentPage = data.currentPage, targetingArguments = data.targetingArguments, title = data.title, description = data.description, metaHeader = data.metaHeader, queryParams = data.queryParams, isLastPage = data.isLastPage, topDealerRequestObj = data.topDealerRequestObj, transportLinks = data.transportLinks, location = data.location, transportType = data.transportType;

            store.dispatch(__WEBPACK_IMPORTED_MODULE_3_shared_actions_globals__["C" /* setTargetingArguments */](targetingArguments));
            return _context.abrupt('return', {
              chunks: ['dealers'],
              title: title,
              description: description,
              page: currentPage,
              isLastPage: isLastPage,
              routeName: 'dealers',
              shouldSetNoIndex: false,
              shouldSetIndex: true,
              component: dealers__jsx(__WEBPACK_IMPORTED_MODULE_5__components_Layout__["a" /* default */], {
                withBranding: true,
                navLinks: __WEBPACK_IMPORTED_MODULE_2_desktop_constants_navigation__["a" /* default */].SEARCH.avto,
                currentRoute: url.replace('/avto/', '/')
              }, void 0, dealers__jsx(Dealers_defaultExport, {
                queryParams: queryParams,
                topDealerRequestObj: topDealerRequestObj,
                currentPage: currentPage,
                transportType: transportType,
                url: url,
                query: params.query,
                location: location,
                transportLinks: transportLinks,
                title: metaHeader
              }))
            });

          case 9:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, this);
  }));

  return function action(_x) {
    return _ref.apply(this, arguments);
  };
}();

function dealers__asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }








/* harmony default export */ __webpack_exports__["default"] = (action);

/***/ })

});


// WEBPACK FOOTER //
// 0-dealers-b8e2a23f.chunk.js